
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6cf1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6cf1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("2ujND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sanitizeUrl = void 0;
var $1cfdbde1ae470967$var$invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
var $1cfdbde1ae470967$var$htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
var $1cfdbde1ae470967$var$htmlCtrlEntityRegex = /&(newline|tab);/gi;
var $1cfdbde1ae470967$var$ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var $1cfdbde1ae470967$var$urlSchemeRegex = /^.+(:|&colon;)/gim;
var $1cfdbde1ae470967$var$relativeFirstCharacters = [
    ".",
    "/"
];
function $1cfdbde1ae470967$var$isRelativeUrlWithoutProtocol(url) {
    return $1cfdbde1ae470967$var$relativeFirstCharacters.indexOf(url[0]) > -1;
}
// adapted from https://stackoverflow.com/a/29824550/2601552
function $1cfdbde1ae470967$var$decodeHtmlCharacters(str) {
    return str.replace($1cfdbde1ae470967$var$htmlEntitiesRegex, function(match, dec) {
        return String.fromCharCode(dec);
    });
}
function $1cfdbde1ae470967$var$sanitizeUrl(url) {
    var sanitizedUrl = $1cfdbde1ae470967$var$decodeHtmlCharacters(url || "").replace($1cfdbde1ae470967$var$htmlCtrlEntityRegex, "").replace($1cfdbde1ae470967$var$ctrlCharactersRegex, "").trim();
    if (!sanitizedUrl) return "about:blank";
    if ($1cfdbde1ae470967$var$isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
    var urlSchemeParseResults = sanitizedUrl.match($1cfdbde1ae470967$var$urlSchemeRegex);
    if (!urlSchemeParseResults) return sanitizedUrl;
    var urlScheme = urlSchemeParseResults[0];
    if ($1cfdbde1ae470967$var$invalidProtocolRegex.test(urlScheme)) return "about:blank";
    return sanitizedUrl;
}
module.exports.sanitizeUrl = $1cfdbde1ae470967$var$sanitizeUrl;

});

parcelRegister("jwLj3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9de54").then(()=>parcelRequire("lM5a5"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("7A0V7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("abv7J").then(()=>parcelRequire("3OoHe"));

});

parcelRegister("1BpsR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2rDZ8").then(()=>parcelRequire("hoFJa"));

});

parcelRegister("fPR7J", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6noeo").then(()=>parcelRequire("iWAvx"));

});

parcelRegister("6eVtL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6nA5D").then(()=>parcelRequire("kNyAU"));

});

parcelRegister("lxYyM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("TPGFR").then(()=>parcelRequire("6dfek"));

});

parcelRegister("LluiH", function(module, exports) {
module.exports = $08e50eea0403ba2c$var$encode;
function $08e50eea0403ba2c$var$encode(keyword, content) {
    keyword = String(keyword);
    content = String(content);
    if (!/^[\x00-\xFF]+$/.test(keyword) || !/^[\x00-\xFF]+$/.test(content)) throw new Error("Only Latin-1 characters are permitted in PNG tEXt chunks. You might want to consider base64 encoding and/or zEXt compression");
    if (keyword.length >= 80) throw new Error('Keyword "' + keyword + '" is longer than the 79-character limit imposed by the PNG specification');
    var totalSize = keyword.length + content.length + 1;
    var output = new Uint8Array(totalSize);
    var idx = 0;
    var code;
    for(var i = 0; i < keyword.length; i++){
        if (!(code = keyword.charCodeAt(i))) throw new Error("0x00 character is not permitted in tEXt keywords");
        output[idx++] = code;
    }
    output[idx++] = 0;
    for(var j = 0; j < content.length; j++){
        if (!(code = content.charCodeAt(j))) throw new Error("0x00 character is not permitted in tEXt content");
        output[idx++] = code;
    }
    return {
        name: "tEXt",
        data: output
    };
}

});

parcelRegister("akGah", function(module, exports) {
module.exports = $785c7ab2a8c61011$var$decode;
function $785c7ab2a8c61011$var$decode(data) {
    if (data.data && data.name) data = data.data;
    var naming = true;
    var text = "";
    var name = "";
    for(var i = 0; i < data.length; i++){
        var code = data[i];
        if (naming) {
            if (code) name += String.fromCharCode(code);
            else naming = false;
        } else {
            if (code) text += String.fromCharCode(code);
            else throw new Error("Invalid NULL character found. 0x00 character is not permitted in tEXt content");
        }
    }
    return {
        keyword: name,
        text: text
    };
}

});

parcelRegister("dA3hl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4tRyo").then(()=>parcelRequire("5FcLv"));

});

parcelRegister("44DGG", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3LgTg").then(()=>parcelRequire("9N4wv"));

});

parcelRegister("2BVx3", function(module, exports) {
module.exports = JSON.parse('{"labels":{"paste":"Paste","pasteAsPlaintext":"Paste as plaintext","pasteCharts":"Paste charts","selectAll":"Select all","multiSelect":"Add element to selection","moveCanvas":"Move canvas","cut":"Cut","copy":"Copy","copyAsPng":"Copy to clipboard as PNG","copyAsSvg":"Copy to clipboard as SVG","copyText":"Copy to clipboard as text","copySource":"Copy source to clipboard","convertToCode":"Convert to code","bringForward":"Bring forward","sendToBack":"Send to back","bringToFront":"Bring to front","sendBackward":"Send backward","delete":"Delete","copyStyles":"Copy styles","pasteStyles":"Paste styles","stroke":"Stroke","changeStroke":"Change stroke color","background":"Background","changeBackground":"Change background color","fill":"Fill","strokeWidth":"Stroke width","strokeStyle":"Stroke style","strokeStyle_solid":"Solid","strokeStyle_dashed":"Dashed","strokeStyle_dotted":"Dotted","sloppiness":"Sloppiness","opacity":"Opacity","textAlign":"Text align","edges":"Edges","sharp":"Sharp","round":"Round","arrowheads":"Arrowheads","arrowhead_none":"None","arrowhead_arrow":"Arrow","arrowhead_bar":"Bar","arrowhead_circle":"Circle","arrowhead_circle_outline":"Circle (outline)","arrowhead_triangle":"Triangle","arrowhead_triangle_outline":"Triangle (outline)","arrowhead_diamond":"Diamond","arrowhead_diamond_outline":"Diamond (outline)","arrowtypes":"Arrow type","arrowtype_sharp":"Sharp arrow","arrowtype_round":"Curved arrow","arrowtype_elbowed":"Elbow arrow","fontSize":"Font size","fontFamily":"Font family","addWatermark":"Add \\"Made with Excalidraw\\"","handDrawn":"Hand-drawn","normal":"Normal","code":"Code","small":"Small","medium":"Medium","large":"Large","veryLarge":"Very large","solid":"Solid","hachure":"Hachure","zigzag":"Zigzag","crossHatch":"Cross-hatch","thin":"Thin","bold":"Bold","left":"Left","center":"Center","right":"Right","extraBold":"Extra bold","architect":"Architect","artist":"Artist","cartoonist":"Cartoonist","fileTitle":"File name","colorPicker":"Color picker","canvasColors":"Used on canvas","canvasBackground":"Canvas background","drawingCanvas":"Drawing canvas","clearCanvas":"Clear canvas","layers":"Layers","actions":"Actions","language":"Language","liveCollaboration":"Live collaboration...","duplicateSelection":"Duplicate","untitled":"Untitled","name":"Name","yourName":"Your name","madeWithExcalidraw":"Made with Excalidraw","group":"Group selection","ungroup":"Ungroup selection","collaborators":"Collaborators","toggleGrid":"Toggle grid","addToLibrary":"Add to library","removeFromLibrary":"Remove from library","libraryLoadingMessage":"Loading library\u2026","libraries":"Browse libraries","loadingScene":"Loading scene\u2026","loadScene":"Load scene from file","align":"Align","alignTop":"Align top","alignBottom":"Align bottom","alignLeft":"Align left","alignRight":"Align right","centerVertically":"Center vertically","centerHorizontally":"Center horizontally","distributeHorizontally":"Distribute horizontally","distributeVertically":"Distribute vertically","flipHorizontal":"Flip horizontal","flipVertical":"Flip vertical","viewMode":"View mode","share":"Share","showStroke":"Show stroke color picker","showBackground":"Show background color picker","showFonts":"Show font picker","toggleTheme":"Toggle light/dark theme","theme":"Theme","personalLib":"Personal Library","excalidrawLib":"Excalidraw Library","decreaseFontSize":"Decrease font size","increaseFontSize":"Increase font size","unbindText":"Unbind text","bindText":"Bind text to the container","createContainerFromText":"Wrap text in a container","link":{"edit":"Edit link","editEmbed":"Edit link & embed","create":"Create link","createEmbed":"Create link & embed","label":"Link","labelEmbed":"Link & embed","empty":"No link is set"},"lineEditor":{"edit":"Edit line","editArrow":"Edit arrow"},"elementLock":{"lock":"Lock","unlock":"Unlock","lockAll":"Lock all","unlockAll":"Unlock all"},"statusPublished":"Published","sidebarLock":"Keep sidebar open","selectAllElementsInFrame":"Select all elements in frame","removeAllElementsFromFrame":"Remove all elements from frame","eyeDropper":"Pick color from canvas","textToDiagram":"Text to diagram","prompt":"Prompt","followUs":"Follow us","discordChat":"Discord chat","zoomToFitViewport":"Zoom to fit in viewport","zoomToFitSelection":"Zoom to fit selection","zoomToFit":"Zoom to fit all elements","installPWA":"Install Excalidraw locally (PWA)","autoResize":"Enable text auto-resizing"},"library":{"noItems":"No items added yet...","hint_emptyLibrary":"Select an item on canvas to add it here, or install a library from the public repository, below.","hint_emptyPrivateLibrary":"Select an item on canvas to add it here."},"buttons":{"clearReset":"Reset the canvas","exportJSON":"Export to file","exportImage":"Export image...","export":"Save to...","copyToClipboard":"Copy to clipboard","copyLink":"Copy link","save":"Save to current file","saveAs":"Save as","load":"Open","getShareableLink":"Get shareable link","close":"Close","selectLanguage":"Select language","scrollBackToContent":"Scroll back to content","zoomIn":"Zoom in","zoomOut":"Zoom out","resetZoom":"Reset zoom","menu":"Menu","done":"Done","edit":"Edit","undo":"Undo","redo":"Redo","resetLibrary":"Reset library","createNewRoom":"Create new room","fullScreen":"Full screen","darkMode":"Dark mode","lightMode":"Light mode","systemMode":"System mode","zenMode":"Zen mode","objectsSnapMode":"Snap to objects","exitZenMode":"Exit zen mode","cancel":"Cancel","clear":"Clear","remove":"Remove","embed":"Toggle embedding","publishLibrary":"Publish","submit":"Submit","confirm":"Confirm","embeddableInteractionButton":"Click to interact"},"alerts":{"clearReset":"This will clear the whole canvas. Are you sure?","couldNotCreateShareableLink":"Couldn\'t create shareable link.","couldNotCreateShareableLinkTooBig":"Couldn\'t create shareable link: the scene is too big","couldNotLoadInvalidFile":"Couldn\'t load invalid file","importBackendFailed":"Importing from backend failed.","cannotExportEmptyCanvas":"Cannot export empty canvas.","couldNotCopyToClipboard":"Couldn\'t copy to clipboard.","decryptFailed":"Couldn\'t decrypt data.","uploadedSecurly":"The upload has been secured with end-to-end encryption, which means that Excalidraw server and third parties can\'t read the content.","loadSceneOverridePrompt":"Loading external drawing will replace your existing content. Do you wish to continue?","collabStopOverridePrompt":"Stopping the session will overwrite your previous, locally stored drawing. Are you sure?\\n\\n(If you want to keep your local drawing, simply close the browser tab instead.)","errorAddingToLibrary":"Couldn\'t add item to the library","errorRemovingFromLibrary":"Couldn\'t remove item from the library","confirmAddLibrary":"This will add {{numShapes}} shape(s) to your library. Are you sure?","imageDoesNotContainScene":"This image does not seem to contain any scene data. Have you enabled scene embedding during export?","cannotRestoreFromImage":"Scene couldn\'t be restored from this image file","invalidSceneUrl":"Couldn\'t import scene from the supplied URL. It\'s either malformed, or doesn\'t contain valid Excalidraw JSON data.","resetLibrary":"This will clear your library. Are you sure?","removeItemsFromsLibrary":"Delete {{count}} item(s) from library?","invalidEncryptionKey":"Encryption key must be of 22 characters. Live collaboration is disabled.","collabOfflineWarning":"No internet connection available.\\nYour changes will not be saved!"},"errors":{"unsupportedFileType":"Unsupported file type.","imageInsertError":"Couldn\'t insert image. Try again later...","fileTooBig":"File is too big. Maximum allowed size is {{maxSize}}.","svgImageInsertError":"Couldn\'t insert SVG image. The SVG markup looks invalid.","failedToFetchImage":"Failed to fetch image.","cannotResolveCollabServer":"Couldn\'t connect to the collab server. Please reload the page and try again.","importLibraryError":"Couldn\'t load library","saveLibraryError":"Couldn\'t save library to storage. Please save your library to a file locally to make sure you don\'t lose changes.","collabSaveFailed":"Couldn\'t save to the backend database. If problems persist, you should save your file locally to ensure you don\'t lose your work.","collabSaveFailed_sizeExceeded":"Couldn\'t save to the backend database, the canvas seems to be too big. You should save the file locally to ensure you don\'t lose your work.","imageToolNotSupported":"Images are disabled.","brave_measure_text_error":{"line1":"Looks like you are using Brave browser with the <bold>Aggressively Block Fingerprinting</bold> setting enabled.","line2":"This could result in breaking the <bold>Text Elements</bold> in your drawings.","line3":"We strongly recommend disabling this setting. You can follow <link>these steps</link> on how to do so.","line4":"If disabling this setting doesn\'t fix the display of text elements, please open an <issueLink>issue</issueLink> on our GitHub, or write us on <discordLink>Discord</discordLink>"},"libraryElementTypeError":{"embeddable":"Embeddable elements cannot be added to the library.","iframe":"IFrame elements cannot be added to the library.","image":"Support for adding images to the library coming soon!"},"asyncPasteFailedOnRead":"Couldn\'t paste (couldn\'t read from system clipboard).","asyncPasteFailedOnParse":"Couldn\'t paste.","copyToSystemClipboardFailed":"Couldn\'t copy to clipboard."},"toolBar":{"selection":"Selection","image":"Insert image","rectangle":"Rectangle","diamond":"Diamond","ellipse":"Ellipse","arrow":"Arrow","line":"Line","freedraw":"Draw","text":"Text","library":"Library","lock":"Keep selected tool active after drawing","penMode":"Pen mode - prevent touch","link":"Add / Update link for a selected shape","eraser":"Eraser","frame":"Frame tool","magicframe":"Wireframe to code","embeddable":"Web Embed","laser":"Laser pointer","hand":"Hand (panning tool)","extraTools":"More tools","mermaidToExcalidraw":"Mermaid to Excalidraw"},"element":{"rectangle":"Rectangle","diamond":"Diamond","ellipse":"Ellipse","arrow":"Arrow","line":"Line","freedraw":"Freedraw","text":"Text","image":"Image","group":"Group","frame":"Frame","magicframe":"Wireframe to code","embeddable":"Web Embed","selection":"Selection","iframe":"IFrame"},"headings":{"canvasActions":"Canvas actions","selectedShapeActions":"Selected shape actions","shapes":"Shapes"},"hints":{"canvasPanning":"To move canvas, hold mouse wheel or spacebar while dragging, or use the hand tool","linearElement":"Click to start multiple points, drag for single line","arrowTool":"Click to start multiple points, drag for single line. Press {{arrowShortcut}} again to change arrow type.","freeDraw":"Click and drag, release when you\'re finished","text":"Tip: you can also add text by double-clicking anywhere with the selection tool","embeddable":"Click-drag to create a website embed","text_selected":"Double-click or press ENTER to edit text","text_editing":"Press Escape or CtrlOrCmd+ENTER to finish editing","linearElementMulti":"Click on last point or press Escape or Enter to finish","lockAngle":"You can constrain angle by holding SHIFT","resize":"You can constrain proportions by holding SHIFT while resizing,\\nhold ALT to resize from the center","resizeImage":"You can resize freely by holding SHIFT,\\nhold ALT to resize from the center","rotate":"You can constrain angles by holding SHIFT while rotating","lineEditor_info":"Hold CtrlOrCmd and Double-click or press CtrlOrCmd + Enter to edit points","lineEditor_pointSelected":"Press Delete to remove point(s),\\nCtrlOrCmd+D to duplicate, or drag to move","lineEditor_nothingSelected":"Select a point to edit (hold SHIFT to select multiple),\\nor hold Alt and click to add new points","placeImage":"Click to place the image, or click and drag to set its size manually","publishLibrary":"Publish your own library","bindTextToElement":"Press enter to add text","createFlowchart":"Hold CtrlOrCmd and Arrow key to create a flowchart","deepBoxSelect":"Hold CtrlOrCmd to deep select, and to prevent dragging","eraserRevert":"Hold Alt to revert the elements marked for deletion","firefox_clipboard_write":"This feature can likely be enabled by setting the \\"dom.events.asyncClipboard.clipboardItem\\" flag to \\"true\\". To change the browser flags in Firefox, visit the \\"about:config\\" page.","disableSnapping":"Hold CtrlOrCmd to disable snapping"},"canvasError":{"cannotShowPreview":"Cannot show preview","canvasTooBig":"The canvas may be too big.","canvasTooBigTip":"Tip: try moving the farthest elements a bit closer together."},"errorSplash":{"headingMain":"Encountered an error. Try <button>reloading the page</button>.","clearCanvasMessage":"If reloading doesn\'t work, try <button>clearing the canvas</button>.","clearCanvasCaveat":" This will result in loss of work ","trackedToSentry":"The error with identifier {{eventId}} was tracked on our system.","openIssueMessage":"We were very cautious not to include your scene information on the error. If your scene is not private, please consider following up on our <button>bug tracker</button>. Please include information below by copying and pasting into the GitHub issue.","sceneContent":"Scene content:"},"shareDialog":{"or":"Or"},"roomDialog":{"desc_intro":"Invite people to collaborate on your drawing.","desc_privacy":"Don\'t worry, the session is end-to-end encrypted, and fully private. Not even our server can see what you draw.","button_startSession":"Start session","button_stopSession":"Stop session","desc_inProgressIntro":"Live-collaboration session is now in progress.","desc_shareLink":"Share this link with anyone you want to collaborate with:","desc_exitSession":"Stopping the session will disconnect you from the room, but you\'ll be able to continue working with the scene, locally. Note that this won\'t affect other people, and they\'ll still be able to collaborate on their version.","shareTitle":"Join a live collaboration session on Excalidraw"},"errorDialog":{"title":"Error"},"exportDialog":{"disk_title":"Save to disk","disk_details":"Export the scene data to a file from which you can import later.","disk_button":"Save to file","link_title":"Shareable link","link_details":"Export as a read-only link.","link_button":"Export to Link","excalidrawplus_description":"Save the scene to your Excalidraw+ workspace.","excalidrawplus_button":"Export","excalidrawplus_exportError":"Couldn\'t export to Excalidraw+ at this moment..."},"helpDialog":{"blog":"Read our blog","click":"click","deepSelect":"Deep select","deepBoxSelect":"Deep select within box, and prevent dragging","createFlowchart":"Create a flowchart from a generic element","navigateFlowchart":"Navigate a flowchart","curvedArrow":"Curved arrow","curvedLine":"Curved line","documentation":"Documentation","doubleClick":"double-click","drag":"drag","editor":"Editor","editLineArrowPoints":"Edit line/arrow points","editText":"Edit text / add label","github":"Found an issue? Submit","howto":"Follow our guides","or":"or","preventBinding":"Prevent arrow binding","tools":"Tools","shortcuts":"Keyboard shortcuts","textFinish":"Finish editing (text editor)","textNewLine":"Add new line (text editor)","title":"Help","view":"View","zoomToFit":"Zoom to fit all elements","zoomToSelection":"Zoom to selection","toggleElementLock":"Lock/unlock selection","movePageUpDown":"Move page up/down","movePageLeftRight":"Move page left/right"},"clearCanvasDialog":{"title":"Clear canvas"},"publishDialog":{"title":"Publish library","itemName":"Item name","authorName":"Author name","githubUsername":"GitHub username","twitterUsername":"Twitter username","libraryName":"Library name","libraryDesc":"Library description","website":"Website","placeholder":{"authorName":"Your name or username","libraryName":"Name of your library","libraryDesc":"Description of your library to help people understand its usage","githubHandle":"GitHub handle (optional), so you can edit the library once submitted for review","twitterHandle":"Twitter username (optional), so we know who to credit when promoting over Twitter","website":"Link to your personal website or elsewhere (optional)"},"errors":{"required":"Required","website":"Enter a valid URL"},"noteDescription":"Submit your library to be included in the <link>public library repository</link> for other people to use in their drawings.","noteGuidelines":"The library needs to be manually approved first. Please read the <link>guidelines</link> before submitting. You will need a GitHub account to communicate and make changes if requested, but it is not strictly required.","noteLicense":"By submitting, you agree the library will be published under the <link>MIT License</link>, which in short means anyone can use them without restrictions.","noteItems":"Each library item must have its own name so it\'s filterable. The following library items will be included:","atleastOneLibItem":"Please select at least one library item to get started","republishWarning":"Note: some of the selected items are marked as already published/submitted. You should only resubmit items when updating an existing library or submission."},"publishSuccessDialog":{"title":"Library submitted","content":"Thank you {{authorName}}. Your library has been submitted for review. You can track the status <link>here</link>"},"confirmDialog":{"resetLibrary":"Reset library","removeItemsFromLib":"Remove selected items from library"},"imageExportDialog":{"header":"Export image","label":{"withBackground":"Background","onlySelected":"Only selected","darkMode":"Dark mode","embedScene":"Embed scene","scale":"Scale","padding":"Padding"},"tooltip":{"embedScene":"Scene data will be saved into the exported PNG/SVG file so that the scene can be restored from it.\\nWill increase exported file size."},"title":{"exportToPng":"Export to PNG","exportToSvg":"Export to SVG","copyPngToClipboard":"Copy PNG to clipboard"},"button":{"exportToPng":"PNG","exportToSvg":"SVG","copyPngToClipboard":"Copy to clipboard"}},"encrypted":{"tooltip":"Your drawings are end-to-end encrypted so Excalidraw\'s servers will never see them.","link":"Blog post on end-to-end encryption in Excalidraw"},"stats":{"angle":"Angle","shapes":"Shapes","height":"Height","scene":"Scene","selected":"Selected","storage":"Storage","fullTitle":"Canvas & Shape properties","title":"Properties","generalStats":"General","elementProperties":"Shape properties","total":"Total","version":"Version","versionCopy":"Click to copy","versionNotAvailable":"Version not available","width":"Width"},"toast":{"addedToLibrary":"Added to library","copyStyles":"Copied styles.","copyToClipboard":"Copied to clipboard.","copyToClipboardAsPng":"Copied {{exportSelection}} to clipboard as PNG\\n({{exportColorScheme}})","fileSaved":"File saved.","fileSavedToFilename":"Saved to {filename}","canvas":"canvas","selection":"selection","pasteAsSingleElement":"Use {{shortcut}} to paste as a single element,\\nor paste into an existing text editor","unableToEmbed":"Embedding this url is currently not allowed. Raise an issue on GitHub to request the url whitelisted","unrecognizedLinkFormat":"The link you embedded does not match the expected format. Please try to paste the \'embed\' string provided by the source site"},"colors":{"transparent":"Transparent","black":"Black","white":"White","red":"Red","pink":"Pink","grape":"Grape","violet":"Violet","gray":"Gray","blue":"Blue","cyan":"Cyan","teal":"Teal","green":"Green","yellow":"Yellow","orange":"Orange","bronze":"Bronze"},"welcomeScreen":{"app":{"center_heading":"All your data is saved locally in your browser.","center_heading_plus":"Did you want to go to the Excalidraw+ instead?","menuHint":"Export, preferences, languages, ..."},"defaults":{"menuHint":"Export, preferences, and more...","center_heading":"Diagrams. Made. Simple.","toolbarHint":"Pick a tool & Start drawing!","helpHint":"Shortcuts & help"}},"colorPicker":{"mostUsedCustomColors":"Most used custom colors","colors":"Colors","shades":"Shades","hexCode":"Hex code","noShades":"No shades available for this color"},"overwriteConfirm":{"action":{"exportToImage":{"title":"Export as image","button":"Export as image","description":"Export the scene data as an image from which you can import later."},"saveToDisk":{"title":"Save to disk","button":"Save to disk","description":"Export the scene data to a file from which you can import later."},"excalidrawPlus":{"title":"Excalidraw+","button":"Export to Excalidraw+","description":"Save the scene to your Excalidraw+ workspace."}},"modal":{"loadFromFile":{"title":"Load from file","button":"Load from file","description":"Loading from a file will <bold>replace your existing content</bold>.<br></br>You can back up your drawing first using one of the options below."},"shareableLink":{"title":"Load from link","button":"Replace my content","description":"Loading external drawing will <bold>replace your existing content</bold>.<br></br>You can back up your drawing first by using one of the options below."}}},"mermaid":{"title":"Mermaid to Excalidraw","button":"Insert","description":"Currently only <flowchartLink>Flowchart</flowchartLink>,<sequenceLink> Sequence, </sequenceLink> and <classLink>Class </classLink>Diagrams are supported. The other types will be rendered as image in Excalidraw.","syntax":"Mermaid Syntax","preview":"Preview"},"quickSearch":{"placeholder":"Quick search"},"fontList":{"badge":{"old":"old"},"sceneFonts":"In this scene","availableFonts":"Available fonts","empty":"No fonts found"},"userList":{"empty":"No users found","hint":{"text":"Click on user to follow","followStatus":"You\'re currently following this user","inCall":"User is in a voice call","micMuted":"User\'s microphone is muted","isSpeaking":"User is speaking"}},"commandPalette":{"title":"Command palette","shortcuts":{"select":"Select","confirm":"Confirm","close":"Close"},"recents":"Recently used","search":{"placeholder":"Search menus, commands, and discover hidden gems","noMatch":"No matching commands..."},"itemNotAvailable":"Command is not available...","shortcutHint":"For Command palette, use {{shortcut}}"}}');

});

parcelRegister("3V2Z3", function(module, exports) {
module.exports = JSON.parse('{"ar-SA":94,"az-AZ":17,"bg-BG":71,"bn-BD":52,"ca-ES":83,"cs-CZ":86,"da-DK":61,"de-DE":100,"el-GR":80,"en":100,"es-ES":96,"eu-ES":97,"fa-IR":84,"fi-FI":76,"fr-FR":99,"gl-ES":86,"he-IL":77,"hi-IN":76,"hu-HU":76,"id-ID":91,"it-IT":98,"ja-JP":90,"kaa":36,"kab-KAB":76,"kk-KZ":18,"km-KH":83,"ko-KR":100,"ku-TR":87,"lt-LT":48,"lv-LV":77,"mr-IN":98,"my-MM":35,"nb-NO":93,"nl-NL":75,"nn-NO":67,"oc-FR":92,"pa-IN":78,"pl-PL":99,"pt-BR":91,"pt-PT":83,"ro-RO":99,"ru-RU":92,"si-LK":7,"sk-SK":100,"sl-SI":100,"sv-SE":100,"ta-IN":81,"th-TH":44,"tr-TR":87,"uk-UA":93,"vi-VN":49,"zh-CN":100,"zh-HK":22,"zh-TW":100}');

});

parcelRegister("wrIgO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3PEi6").then(()=>parcelRequire("9orsv"));

});

parcelRegister("8lIq9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gZM2p").then(()=>parcelRequire("3lgbH"));

});

parcelRegister("57K7R", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6jWZ7").then(()=>parcelRequire("6hvjH"));

});

parcelRegister("kfBeg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("iQzb6").then(()=>parcelRequire("9s5og"));

});

parcelRegister("44kIP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("50CEm").then(()=>parcelRequire("jzazD"));

});

parcelRegister("3m0Tx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dtM3d").then(()=>parcelRequire("i4xJh"));

});

parcelRegister("8rYzt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kPNkR").then(()=>parcelRequire("6loTX"));

});

parcelRegister("8iCCj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kupiY").then(()=>parcelRequire("g2UDl"));

});

parcelRegister("4ilWR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dbiD9").then(()=>parcelRequire("5IIm1"));

});

parcelRegister("fsgwp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hjCdI").then(()=>parcelRequire("9fZYH"));

});

parcelRegister("15R1L", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7xM0C").then(()=>parcelRequire("3kfG0"));

});

parcelRegister("7o3SH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5X01s").then(()=>parcelRequire("aWoDV"));

});

parcelRegister("k4qN1", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9pXyV").then(()=>parcelRequire("et2Zc"));

});

parcelRegister("dlVEY", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fNhxp").then(()=>parcelRequire("6rwOb"));

});

parcelRegister("7IdwF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("63mDA").then(()=>parcelRequire("3IgQ4"));

});

parcelRegister("iG5Bq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2f1KO").then(()=>parcelRequire("koVGK"));

});

parcelRegister("c2ybi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("d1Kkv").then(()=>parcelRequire("187y8"));

});

parcelRegister("b5nR4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1nQCV").then(()=>parcelRequire("aOayC"));

});

parcelRegister("6P2RI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1aqYQ").then(()=>parcelRequire("4gdCu"));

});

parcelRegister("a1KRe", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e74nS").then(()=>parcelRequire("4AbkW"));

});

parcelRegister("hGQ09", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gmc65").then(()=>parcelRequire("fXjv9"));

});

parcelRegister("ghkPC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("58gUL").then(()=>parcelRequire("aeZtV"));

});

parcelRegister("eM4BI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("HkYC4").then(()=>parcelRequire("jlbbW"));

});

parcelRegister("95UFN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ej1Ki").then(()=>parcelRequire("g1zUy"));

});

parcelRegister("gNgTQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2LIsB").then(()=>parcelRequire("03TKt"));

});

parcelRegister("k76pO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7K8Iv").then(()=>parcelRequire("3W6fo"));

});

parcelRegister("fohp3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gMekr").then(()=>parcelRequire("iJ6gt"));

});

parcelRegister("7h0V3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lX0oh").then(()=>parcelRequire("3fScm"));

});

parcelRegister("bVMzX", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dHsrz").then(()=>parcelRequire("2Wtoc"));

});

parcelRegister("6Zs38", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gabOW").then(()=>parcelRequire("lHe4X"));

});

parcelRegister("j458G", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("63JFW").then(()=>parcelRequire("8gvXe"));

});

parcelRegister("ecTVv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4oDFf").then(()=>parcelRequire("k1B9f"));

});

parcelRegister("7bmgS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hez1n").then(()=>parcelRequire("jgyea"));

});

parcelRegister("jsO5K", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c62kr").then(()=>parcelRequire("iWXYF"));

});

parcelRegister("fPHNf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ijvxV").then(()=>parcelRequire("cvLCY"));

});

parcelRegister("lRcpC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("nfoLC").then(()=>parcelRequire("1dqjz"));

});

parcelRegister("g7AEJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5cPHb").then(()=>parcelRequire("bdSiI"));

});

parcelRegister("6HCdb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7DFRb").then(()=>parcelRequire("bV09i"));

});

parcelRegister("hSORx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9KJOK").then(()=>parcelRequire("3lJVP"));

});

parcelRegister("8yN6k", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1KQuA").then(()=>parcelRequire("c2voC"));

});

parcelRegister("7KoIq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b8qDY").then(()=>parcelRequire("9RmfD"));

});

parcelRegister("wOfp0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7Wcbr").then(()=>parcelRequire("5Z0sz"));

});

parcelRegister("6sNyb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eGeIv").then(()=>parcelRequire("ldDSf"));

});

parcelRegister("jkTe4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2w4e1").then(()=>parcelRequire("iAKWm"));

});

parcelRegister("8eHj9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lbcFP").then(()=>parcelRequire("7eNMD"));

});

parcelRegister("74729", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4sNbc").then(()=>parcelRequire("49p7V"));

});

parcelRegister("87mTV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6QV53").then(()=>parcelRequire("ioirK"));

});

parcelRegister("j7RCH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2CO1S").then(()=>parcelRequire("6PeCx"));

});

parcelRegister("qnPd3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e83S2").then(()=>parcelRequire("181Nv"));

});

parcelRegister("bVo2w", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fhSKp").then(()=>parcelRequire("5GAMp"));

});

parcelRegister("kfL8w", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1Lu4t").then(()=>parcelRequire("gsSnz"));

});

parcelRegister("aOo5T", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hpwQ9").then(()=>parcelRequire("13KCB"));

});

parcelRegister("7NDzr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2OikP").then(()=>parcelRequire("4fT1g"));

});

parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});
parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});



parcelRegister("f3nFz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dCQFS").then(()=>parcelRequire("aOJAZ"));

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("891Eb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7u3ox").then(()=>parcelRequire("hdD2r"));

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
$parcel$export(module.exports, "prefixer", () => $298fb931ed4fbf8b$export$e08c7d021b829b7a);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $e1b69108328f9d49$exports = {};
$e1b69108328f9d49$exports = JSON.parse('{"white":"#ffffff","black":"#000000","gray":["#f8f9fa","#f1f3f5","#e9ecef","#dee2e6","#ced4da","#adb5bd","#868e96","#495057","#343a40","#212529"],"red":["#fff5f5","#ffe3e3","#ffc9c9","#ffa8a8","#ff8787","#ff6b6b","#fa5252","#f03e3e","#e03131","#c92a2a"],"pink":["#fff0f6","#ffdeeb","#fcc2d7","#faa2c1","#f783ac","#f06595","#e64980","#d6336c","#c2255c","#a61e4d"],"grape":["#f8f0fc","#f3d9fa","#eebefa","#e599f7","#da77f2","#cc5de8","#be4bdb","#ae3ec9","#9c36b5","#862e9c"],"violet":["#f3f0ff","#e5dbff","#d0bfff","#b197fc","#9775fa","#845ef7","#7950f2","#7048e8","#6741d9","#5f3dc4"],"indigo":["#edf2ff","#dbe4ff","#bac8ff","#91a7ff","#748ffc","#5c7cfa","#4c6ef5","#4263eb","#3b5bdb","#364fc7"],"blue":["#e7f5ff","#d0ebff","#a5d8ff","#74c0fc","#4dabf7","#339af0","#228be6","#1c7ed6","#1971c2","#1864ab"],"cyan":["#e3fafc","#c5f6fa","#99e9f2","#66d9e8","#3bc9db","#22b8cf","#15aabf","#1098ad","#0c8599","#0b7285"],"teal":["#e6fcf5","#c3fae8","#96f2d7","#63e6be","#38d9a9","#20c997","#12b886","#0ca678","#099268","#087f5b"],"green":["#ebfbee","#d3f9d8","#b2f2bb","#8ce99a","#69db7c","#51cf66","#40c057","#37b24d","#2f9e44","#2b8a3e"],"lime":["#f4fce3","#e9fac8","#d8f5a2","#c0eb75","#a9e34b","#94d82d","#82c91e","#74b816","#66a80f","#5c940d"],"yellow":["#fff9db","#fff3bf","#ffec99","#ffe066","#ffd43b","#fcc419","#fab005","#f59f00","#f08c00","#e67700"],"orange":["#fff4e6","#ffe8cc","#ffd8a8","#ffc078","#ffa94d","#ff922b","#fd7e14","#f76707","#e8590c","#d9480f"]}');


function $6783b31e8a74aa35$export$7c185c3757807f6c() {
    return Math.floor(Math.random() * 2 ** 31);
}
class $6783b31e8a74aa35$export$a92776769f460054 {
    constructor(seed){
        this.seed = seed;
    }
    next() {
        if (this.seed) return (2 ** 31 - 1 & (this.seed = Math.imul(48271, this.seed))) / 2 ** 31;
        else return Math.random();
    }
}


let $13a61ad500a8c5bb$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";


let $363a23d82a2fc856$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $363a23d82a2fc856$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $363a23d82a2fc856$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$363a23d82a2fc856$export$a5cee9e955a615e5(alphabet, size, $363a23d82a2fc856$export$4385e60b38654f68);
let $363a23d82a2fc856$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");



var $2ujND = parcelRequire("2ujND");
function $536751070c6e3eab$var$rotatePoints(points, center, degrees) {
    if (points && points.length) {
        const [cx, cy] = center;
        const angle = Math.PI / 180 * degrees;
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        for (const p of points){
            const [x, y] = p;
            p[0] = (x - cx) * cos - (y - cy) * sin + cx;
            p[1] = (x - cx) * sin + (y - cy) * cos + cy;
        }
    }
}
function $536751070c6e3eab$var$rotateLines(lines, center, degrees) {
    const points = [];
    lines.forEach((line)=>points.push(...line));
    $536751070c6e3eab$var$rotatePoints(points, center, degrees);
}
function $536751070c6e3eab$var$areSamePoints(p1, p2) {
    return p1[0] === p2[0] && p1[1] === p2[1];
}
function $536751070c6e3eab$export$5ccb715ed57d028b(polygons, hachureGap, hachureAngle, hachureStepOffset = 1) {
    const angle = hachureAngle;
    const gap = Math.max(hachureGap, 0.1);
    const polygonList = polygons[0] && polygons[0][0] && typeof polygons[0][0] === "number" ? [
        polygons
    ] : polygons;
    const rotationCenter = [
        0,
        0
    ];
    if (angle) for (const polygon of polygonList)$536751070c6e3eab$var$rotatePoints(polygon, rotationCenter, angle);
    const lines = $536751070c6e3eab$var$straightHachureLines(polygonList, gap, hachureStepOffset);
    if (angle) {
        for (const polygon of polygonList)$536751070c6e3eab$var$rotatePoints(polygon, rotationCenter, -angle);
        $536751070c6e3eab$var$rotateLines(lines, rotationCenter, -angle);
    }
    return lines;
}
function $536751070c6e3eab$var$straightHachureLines(polygons, gap, hachureStepOffset) {
    const vertexArray = [];
    for (const polygon of polygons){
        const vertices = [
            ...polygon
        ];
        if (!$536751070c6e3eab$var$areSamePoints(vertices[0], vertices[vertices.length - 1])) vertices.push([
            vertices[0][0],
            vertices[0][1]
        ]);
        if (vertices.length > 2) vertexArray.push(vertices);
    }
    const lines = [];
    gap = Math.max(gap, 0.1);
    // Create sorted edges table
    const edges = [];
    for (const vertices of vertexArray)for(let i = 0; i < vertices.length - 1; i++){
        const p1 = vertices[i];
        const p2 = vertices[i + 1];
        if (p1[1] !== p2[1]) {
            const ymin = Math.min(p1[1], p2[1]);
            edges.push({
                ymin: ymin,
                ymax: Math.max(p1[1], p2[1]),
                x: ymin === p1[1] ? p1[0] : p2[0],
                islope: (p2[0] - p1[0]) / (p2[1] - p1[1])
            });
        }
    }
    edges.sort((e1, e2)=>{
        if (e1.ymin < e2.ymin) return -1;
        if (e1.ymin > e2.ymin) return 1;
        if (e1.x < e2.x) return -1;
        if (e1.x > e2.x) return 1;
        if (e1.ymax === e2.ymax) return 0;
        return (e1.ymax - e2.ymax) / Math.abs(e1.ymax - e2.ymax);
    });
    if (!edges.length) return lines;
    // Start scanning
    let activeEdges = [];
    let y = edges[0].ymin;
    let iteration = 0;
    while(activeEdges.length || edges.length){
        if (edges.length) {
            let ix = -1;
            for(let i = 0; i < edges.length; i++){
                if (edges[i].ymin > y) break;
                ix = i;
            }
            const removed = edges.splice(0, ix + 1);
            removed.forEach((edge)=>{
                activeEdges.push({
                    s: y,
                    edge: edge
                });
            });
        }
        activeEdges = activeEdges.filter((ae)=>{
            if (ae.edge.ymax <= y) return false;
            return true;
        });
        activeEdges.sort((ae1, ae2)=>{
            if (ae1.edge.x === ae2.edge.x) return 0;
            return (ae1.edge.x - ae2.edge.x) / Math.abs(ae1.edge.x - ae2.edge.x);
        });
        // fill between the edges
        if (hachureStepOffset !== 1 || iteration % gap === 0) {
            if (activeEdges.length > 1) for(let i = 0; i < activeEdges.length; i = i + 2){
                const nexti = i + 1;
                if (nexti >= activeEdges.length) break;
                const ce = activeEdges[i].edge;
                const ne = activeEdges[nexti].edge;
                lines.push([
                    [
                        Math.round(ce.x),
                        y
                    ],
                    [
                        Math.round(ne.x),
                        y
                    ]
                ]);
            }
        }
        y += hachureStepOffset;
        activeEdges.forEach((ae)=>{
            ae.edge.x = ae.edge.x + hachureStepOffset * ae.edge.islope;
        });
        iteration++;
    }
    return lines;
}


function $424f7d863733a9eb$export$7664e190bc97040e(polygonList, o) {
    var _a;
    const angle = o.hachureAngle + 90;
    let gap = o.hachureGap;
    if (gap < 0) gap = o.strokeWidth * 4;
    gap = Math.max(gap, 0.1);
    let skipOffset = 1;
    if (o.roughness >= 1) {
        if ((((_a = o.randomizer) === null || _a === void 0 ? void 0 : _a.next()) || Math.random()) > 0.7) skipOffset = gap;
    }
    return (0, $536751070c6e3eab$export$5ccb715ed57d028b)(polygonList, gap, angle, skipOffset || 1);
}


class $463cde7bf7c30a75$export$8077f6acb8ac3b3 {
    constructor(helper){
        this.helper = helper;
    }
    fillPolygons(polygonList, o) {
        return this._fillPolygons(polygonList, o);
    }
    _fillPolygons(polygonList, o) {
        const lines = (0, $424f7d863733a9eb$export$7664e190bc97040e)(polygonList, o);
        const ops = this.renderLines(lines, o);
        return {
            type: "fillSketch",
            ops: ops
        };
    }
    renderLines(lines, o) {
        const ops = [];
        for (const line of lines)ops.push(...this.helper.doubleLineOps(line[0][0], line[0][1], line[1][0], line[1][1], o));
        return ops;
    }
}




function $eb4666c8fbe8f9de$export$28022775658f8740(line) {
    const p1 = line[0];
    const p2 = line[1];
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2));
}


class $310e660f709dc89b$export$dbab8ffea9cbe320 extends (0, $463cde7bf7c30a75$export$8077f6acb8ac3b3) {
    fillPolygons(polygonList, o) {
        let gap = o.hachureGap;
        if (gap < 0) gap = o.strokeWidth * 4;
        gap = Math.max(gap, 0.1);
        const o2 = Object.assign({}, o, {
            hachureGap: gap
        });
        const lines = (0, $424f7d863733a9eb$export$7664e190bc97040e)(polygonList, o2);
        const zigZagAngle = Math.PI / 180 * o.hachureAngle;
        const zigzagLines = [];
        const dgx = gap * 0.5 * Math.cos(zigZagAngle);
        const dgy = gap * 0.5 * Math.sin(zigZagAngle);
        for (const [p1, p2] of lines)if ((0, $eb4666c8fbe8f9de$export$28022775658f8740)([
            p1,
            p2
        ])) zigzagLines.push([
            [
                p1[0] - dgx,
                p1[1] + dgy
            ],
            [
                ...p2
            ]
        ], [
            [
                p1[0] + dgx,
                p1[1] - dgy
            ],
            [
                ...p2
            ]
        ]);
        const ops = this.renderLines(zigzagLines, o);
        return {
            type: "fillSketch",
            ops: ops
        };
    }
}



class $4218b9d21eb7cee0$export$1f7afac05e8c20da extends (0, $463cde7bf7c30a75$export$8077f6acb8ac3b3) {
    fillPolygons(polygonList, o) {
        const set = this._fillPolygons(polygonList, o);
        const o2 = Object.assign({}, o, {
            hachureAngle: o.hachureAngle + 90
        });
        const set2 = this._fillPolygons(polygonList, o2);
        set.ops = set.ops.concat(set2.ops);
        return set;
    }
}




class $48019f3343ac93df$export$c4d4e67b11bcd3cf {
    constructor(helper){
        this.helper = helper;
    }
    fillPolygons(polygonList, o) {
        o = Object.assign({}, o, {
            hachureAngle: 0
        });
        const lines = (0, $424f7d863733a9eb$export$7664e190bc97040e)(polygonList, o);
        return this.dotsOnLines(lines, o);
    }
    dotsOnLines(lines, o) {
        const ops = [];
        let gap = o.hachureGap;
        if (gap < 0) gap = o.strokeWidth * 4;
        gap = Math.max(gap, 0.1);
        let fweight = o.fillWeight;
        if (fweight < 0) fweight = o.strokeWidth / 2;
        const ro = gap / 4;
        for (const line of lines){
            const length = (0, $eb4666c8fbe8f9de$export$28022775658f8740)(line);
            const dl = length / gap;
            const count = Math.ceil(dl) - 1;
            const offset = length - count * gap;
            const x = (line[0][0] + line[1][0]) / 2 - gap / 4;
            const minY = Math.min(line[0][1], line[1][1]);
            for(let i = 0; i < count; i++){
                const y = minY + offset + i * gap;
                const cx = x - ro + Math.random() * 2 * ro;
                const cy = y - ro + Math.random() * 2 * ro;
                const el = this.helper.ellipse(cx, cy, fweight, fweight, o);
                ops.push(...el.ops);
            }
        }
        return {
            type: "fillSketch",
            ops: ops
        };
    }
}




class $260d10c25b6091fe$export$2ce278f2d3c6a9ab {
    constructor(helper){
        this.helper = helper;
    }
    fillPolygons(polygonList, o) {
        const lines = (0, $424f7d863733a9eb$export$7664e190bc97040e)(polygonList, o);
        return {
            type: "fillSketch",
            ops: this.dashedLine(lines, o)
        };
    }
    dashedLine(lines, o) {
        const offset = o.dashOffset < 0 ? o.hachureGap < 0 ? o.strokeWidth * 4 : o.hachureGap : o.dashOffset;
        const gap = o.dashGap < 0 ? o.hachureGap < 0 ? o.strokeWidth * 4 : o.hachureGap : o.dashGap;
        const ops = [];
        lines.forEach((line)=>{
            const length = (0, $eb4666c8fbe8f9de$export$28022775658f8740)(line);
            const count = Math.floor(length / (offset + gap));
            const startOffset = (length + gap - count * (offset + gap)) / 2;
            let p1 = line[0];
            let p2 = line[1];
            if (p1[0] > p2[0]) {
                p1 = line[1];
                p2 = line[0];
            }
            const alpha = Math.atan((p2[1] - p1[1]) / (p2[0] - p1[0]));
            for(let i = 0; i < count; i++){
                const lstart = i * (offset + gap);
                const lend = lstart + offset;
                const start = [
                    p1[0] + lstart * Math.cos(alpha) + startOffset * Math.cos(alpha),
                    p1[1] + lstart * Math.sin(alpha) + startOffset * Math.sin(alpha)
                ];
                const end = [
                    p1[0] + lend * Math.cos(alpha) + startOffset * Math.cos(alpha),
                    p1[1] + lend * Math.sin(alpha) + startOffset * Math.sin(alpha)
                ];
                ops.push(...this.helper.doubleLineOps(start[0], start[1], end[0], end[1], o));
            }
        });
        return ops;
    }
}




class $4976faa496cf4ce5$export$2d8f0f089ecf3b74 {
    constructor(helper){
        this.helper = helper;
    }
    fillPolygons(polygonList, o) {
        const gap = o.hachureGap < 0 ? o.strokeWidth * 4 : o.hachureGap;
        const zo = o.zigzagOffset < 0 ? gap : o.zigzagOffset;
        o = Object.assign({}, o, {
            hachureGap: gap + zo
        });
        const lines = (0, $424f7d863733a9eb$export$7664e190bc97040e)(polygonList, o);
        return {
            type: "fillSketch",
            ops: this.zigzagLines(lines, zo, o)
        };
    }
    zigzagLines(lines, zo, o) {
        const ops = [];
        lines.forEach((line)=>{
            const length = (0, $eb4666c8fbe8f9de$export$28022775658f8740)(line);
            const count = Math.round(length / (2 * zo));
            let p1 = line[0];
            let p2 = line[1];
            if (p1[0] > p2[0]) {
                p1 = line[1];
                p2 = line[0];
            }
            const alpha = Math.atan((p2[1] - p1[1]) / (p2[0] - p1[0]));
            for(let i = 0; i < count; i++){
                const lstart = i * 2 * zo;
                const lend = (i + 1) * 2 * zo;
                const dz = Math.sqrt(2 * Math.pow(zo, 2));
                const start = [
                    p1[0] + lstart * Math.cos(alpha),
                    p1[1] + lstart * Math.sin(alpha)
                ];
                const end = [
                    p1[0] + lend * Math.cos(alpha),
                    p1[1] + lend * Math.sin(alpha)
                ];
                const middle = [
                    start[0] + dz * Math.cos(alpha + Math.PI / 4),
                    start[1] + dz * Math.sin(alpha + Math.PI / 4)
                ];
                ops.push(...this.helper.doubleLineOps(start[0], start[1], middle[0], middle[1], o), ...this.helper.doubleLineOps(middle[0], middle[1], end[0], end[1], o));
            }
        });
        return ops;
    }
}


const $227b354485fe3585$var$fillers = {};
function $227b354485fe3585$export$6de2f8d51867ea9d(o, helper) {
    let fillerName = o.fillStyle || "hachure";
    if (!$227b354485fe3585$var$fillers[fillerName]) switch(fillerName){
        case "zigzag":
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $310e660f709dc89b$export$dbab8ffea9cbe320)(helper);
            break;
        case "cross-hatch":
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $4218b9d21eb7cee0$export$1f7afac05e8c20da)(helper);
            break;
        case "dots":
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $48019f3343ac93df$export$c4d4e67b11bcd3cf)(helper);
            break;
        case "dashed":
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $260d10c25b6091fe$export$2ce278f2d3c6a9ab)(helper);
            break;
        case "zigzag-line":
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $4976faa496cf4ce5$export$2d8f0f089ecf3b74)(helper);
            break;
        case "hachure":
        default:
            fillerName = "hachure";
            if (!$227b354485fe3585$var$fillers[fillerName]) $227b354485fe3585$var$fillers[fillerName] = new (0, $463cde7bf7c30a75$export$8077f6acb8ac3b3)(helper);
            break;
    }
    return $227b354485fe3585$var$fillers[fillerName];
}



const $1a3f93f8daa5daea$var$COMMAND = 0;
const $1a3f93f8daa5daea$var$NUMBER = 1;
const $1a3f93f8daa5daea$var$EOD = 2;
const $1a3f93f8daa5daea$var$PARAMS = {
    A: 7,
    a: 7,
    C: 6,
    c: 6,
    H: 1,
    h: 1,
    L: 2,
    l: 2,
    M: 2,
    m: 2,
    Q: 4,
    q: 4,
    S: 4,
    s: 4,
    T: 2,
    t: 2,
    V: 1,
    v: 1,
    Z: 0,
    z: 0
};
function $1a3f93f8daa5daea$var$tokenize(d) {
    const tokens = new Array();
    while(d !== ""){
        if (d.match(/^([ \t\r\n,]+)/)) d = d.substr(RegExp.$1.length);
        else if (d.match(/^([aAcChHlLmMqQsStTvVzZ])/)) {
            tokens[tokens.length] = {
                type: $1a3f93f8daa5daea$var$COMMAND,
                text: RegExp.$1
            };
            d = d.substr(RegExp.$1.length);
        } else if (d.match(/^(([-+]?[0-9]+(\.[0-9]*)?|[-+]?\.[0-9]+)([eE][-+]?[0-9]+)?)/)) {
            tokens[tokens.length] = {
                type: $1a3f93f8daa5daea$var$NUMBER,
                text: `${parseFloat(RegExp.$1)}`
            };
            d = d.substr(RegExp.$1.length);
        } else return [];
    }
    tokens[tokens.length] = {
        type: $1a3f93f8daa5daea$var$EOD,
        text: ""
    };
    return tokens;
}
function $1a3f93f8daa5daea$var$isType(token, type) {
    return token.type === type;
}
function $1a3f93f8daa5daea$export$8ccf933b0513f8d0(d) {
    const segments = [];
    const tokens = $1a3f93f8daa5daea$var$tokenize(d);
    let mode = "BOD";
    let index = 0;
    let token = tokens[index];
    while(!$1a3f93f8daa5daea$var$isType(token, $1a3f93f8daa5daea$var$EOD)){
        let paramsCount = 0;
        const params = [];
        if (mode === "BOD") {
            if (token.text === "M" || token.text === "m") {
                index++;
                paramsCount = $1a3f93f8daa5daea$var$PARAMS[token.text];
                mode = token.text;
            } else return $1a3f93f8daa5daea$export$8ccf933b0513f8d0("M0,0" + d);
        } else if ($1a3f93f8daa5daea$var$isType(token, $1a3f93f8daa5daea$var$NUMBER)) paramsCount = $1a3f93f8daa5daea$var$PARAMS[mode];
        else {
            index++;
            paramsCount = $1a3f93f8daa5daea$var$PARAMS[token.text];
            mode = token.text;
        }
        if (index + paramsCount < tokens.length) {
            for(let i = index; i < index + paramsCount; i++){
                const numbeToken = tokens[i];
                if ($1a3f93f8daa5daea$var$isType(numbeToken, $1a3f93f8daa5daea$var$NUMBER)) params[params.length] = +numbeToken.text;
                else throw new Error("Param not a number: " + mode + "," + numbeToken.text);
            }
            if (typeof $1a3f93f8daa5daea$var$PARAMS[mode] === "number") {
                const segment = {
                    key: mode,
                    data: params
                };
                segments.push(segment);
                index += paramsCount;
                token = tokens[index];
                if (mode === "M") mode = "L";
                if (mode === "m") mode = "l";
            } else throw new Error("Bad segment: " + mode);
        } else throw new Error("Path data ended short");
    }
    return segments;
}
function $1a3f93f8daa5daea$export$dfdc1655ccc5b9cb(segments) {
    const tokens = [];
    for (const { key: key, data: data } of segments){
        tokens.push(key);
        switch(key){
            case "C":
            case "c":
                tokens.push(data[0], `${data[1]},`, data[2], `${data[3]},`, data[4], data[5]);
                break;
            case "S":
            case "s":
            case "Q":
            case "q":
                tokens.push(data[0], `${data[1]},`, data[2], data[3]);
                break;
            default:
                tokens.push(...data);
                break;
        }
    }
    return tokens.join(" ");
}


// Translate relative commands to absolute commands
function $d190fbece6b82c7d$export$6445f6b54d7a4f43(segments) {
    let cx = 0, cy = 0;
    let subx = 0, suby = 0;
    const out = [];
    for (const { key: key, data: data } of segments)switch(key){
        case "M":
            out.push({
                key: "M",
                data: [
                    ...data
                ]
            });
            [cx, cy] = data;
            [subx, suby] = data;
            break;
        case "m":
            cx += data[0];
            cy += data[1];
            out.push({
                key: "M",
                data: [
                    cx,
                    cy
                ]
            });
            subx = cx;
            suby = cy;
            break;
        case "L":
            out.push({
                key: "L",
                data: [
                    ...data
                ]
            });
            [cx, cy] = data;
            break;
        case "l":
            cx += data[0];
            cy += data[1];
            out.push({
                key: "L",
                data: [
                    cx,
                    cy
                ]
            });
            break;
        case "C":
            out.push({
                key: "C",
                data: [
                    ...data
                ]
            });
            cx = data[4];
            cy = data[5];
            break;
        case "c":
            {
                const newdata = data.map((d, i)=>i % 2 ? d + cy : d + cx);
                out.push({
                    key: "C",
                    data: newdata
                });
                cx = newdata[4];
                cy = newdata[5];
                break;
            }
        case "Q":
            out.push({
                key: "Q",
                data: [
                    ...data
                ]
            });
            cx = data[2];
            cy = data[3];
            break;
        case "q":
            {
                const newdata = data.map((d, i)=>i % 2 ? d + cy : d + cx);
                out.push({
                    key: "Q",
                    data: newdata
                });
                cx = newdata[2];
                cy = newdata[3];
                break;
            }
        case "A":
            out.push({
                key: "A",
                data: [
                    ...data
                ]
            });
            cx = data[5];
            cy = data[6];
            break;
        case "a":
            cx += data[5];
            cy += data[6];
            out.push({
                key: "A",
                data: [
                    data[0],
                    data[1],
                    data[2],
                    data[3],
                    data[4],
                    cx,
                    cy
                ]
            });
            break;
        case "H":
            out.push({
                key: "H",
                data: [
                    ...data
                ]
            });
            cx = data[0];
            break;
        case "h":
            cx += data[0];
            out.push({
                key: "H",
                data: [
                    cx
                ]
            });
            break;
        case "V":
            out.push({
                key: "V",
                data: [
                    ...data
                ]
            });
            cy = data[0];
            break;
        case "v":
            cy += data[0];
            out.push({
                key: "V",
                data: [
                    cy
                ]
            });
            break;
        case "S":
            out.push({
                key: "S",
                data: [
                    ...data
                ]
            });
            cx = data[2];
            cy = data[3];
            break;
        case "s":
            {
                const newdata = data.map((d, i)=>i % 2 ? d + cy : d + cx);
                out.push({
                    key: "S",
                    data: newdata
                });
                cx = newdata[2];
                cy = newdata[3];
                break;
            }
        case "T":
            out.push({
                key: "T",
                data: [
                    ...data
                ]
            });
            cx = data[0];
            cy = data[1];
            break;
        case "t":
            cx += data[0];
            cy += data[1];
            out.push({
                key: "T",
                data: [
                    cx,
                    cy
                ]
            });
            break;
        case "Z":
        case "z":
            out.push({
                key: "Z",
                data: []
            });
            cx = subx;
            cy = suby;
            break;
    }
    return out;
}


// Normalize path to include only M, L, C, and Z commands
function $e66d010f3d556b31$export$a3295358bff77e(segments) {
    const out = [];
    let lastType = "";
    let cx = 0, cy = 0;
    let subx = 0, suby = 0;
    let lcx = 0, lcy = 0;
    for (const { key: key, data: data } of segments){
        switch(key){
            case "M":
                out.push({
                    key: "M",
                    data: [
                        ...data
                    ]
                });
                [cx, cy] = data;
                [subx, suby] = data;
                break;
            case "C":
                out.push({
                    key: "C",
                    data: [
                        ...data
                    ]
                });
                cx = data[4];
                cy = data[5];
                lcx = data[2];
                lcy = data[3];
                break;
            case "L":
                out.push({
                    key: "L",
                    data: [
                        ...data
                    ]
                });
                [cx, cy] = data;
                break;
            case "H":
                cx = data[0];
                out.push({
                    key: "L",
                    data: [
                        cx,
                        cy
                    ]
                });
                break;
            case "V":
                cy = data[0];
                out.push({
                    key: "L",
                    data: [
                        cx,
                        cy
                    ]
                });
                break;
            case "S":
                {
                    let cx1 = 0, cy1 = 0;
                    if (lastType === "C" || lastType === "S") {
                        cx1 = cx + (cx - lcx);
                        cy1 = cy + (cy - lcy);
                    } else {
                        cx1 = cx;
                        cy1 = cy;
                    }
                    out.push({
                        key: "C",
                        data: [
                            cx1,
                            cy1,
                            ...data
                        ]
                    });
                    lcx = data[0];
                    lcy = data[1];
                    cx = data[2];
                    cy = data[3];
                    break;
                }
            case "T":
                {
                    const [x, y] = data;
                    let x1 = 0, y1 = 0;
                    if (lastType === "Q" || lastType === "T") {
                        x1 = cx + (cx - lcx);
                        y1 = cy + (cy - lcy);
                    } else {
                        x1 = cx;
                        y1 = cy;
                    }
                    const cx1 = cx + 2 * (x1 - cx) / 3;
                    const cy1 = cy + 2 * (y1 - cy) / 3;
                    const cx2 = x + 2 * (x1 - x) / 3;
                    const cy2 = y + 2 * (y1 - y) / 3;
                    out.push({
                        key: "C",
                        data: [
                            cx1,
                            cy1,
                            cx2,
                            cy2,
                            x,
                            y
                        ]
                    });
                    lcx = x1;
                    lcy = y1;
                    cx = x;
                    cy = y;
                    break;
                }
            case "Q":
                {
                    const [x1, y1, x, y] = data;
                    const cx1 = cx + 2 * (x1 - cx) / 3;
                    const cy1 = cy + 2 * (y1 - cy) / 3;
                    const cx2 = x + 2 * (x1 - x) / 3;
                    const cy2 = y + 2 * (y1 - y) / 3;
                    out.push({
                        key: "C",
                        data: [
                            cx1,
                            cy1,
                            cx2,
                            cy2,
                            x,
                            y
                        ]
                    });
                    lcx = x1;
                    lcy = y1;
                    cx = x;
                    cy = y;
                    break;
                }
            case "A":
                {
                    const r1 = Math.abs(data[0]);
                    const r2 = Math.abs(data[1]);
                    const angle = data[2];
                    const largeArcFlag = data[3];
                    const sweepFlag = data[4];
                    const x = data[5];
                    const y = data[6];
                    if (r1 === 0 || r2 === 0) {
                        out.push({
                            key: "C",
                            data: [
                                cx,
                                cy,
                                x,
                                y,
                                x,
                                y
                            ]
                        });
                        cx = x;
                        cy = y;
                    } else if (cx !== x || cy !== y) {
                        const curves = $e66d010f3d556b31$var$arcToCubicCurves(cx, cy, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
                        curves.forEach(function(curve) {
                            out.push({
                                key: "C",
                                data: curve
                            });
                        });
                        cx = x;
                        cy = y;
                    }
                    break;
                }
            case "Z":
                out.push({
                    key: "Z",
                    data: []
                });
                cx = subx;
                cy = suby;
                break;
        }
        lastType = key;
    }
    return out;
}
function $e66d010f3d556b31$var$degToRad(degrees) {
    return Math.PI * degrees / 180;
}
function $e66d010f3d556b31$var$rotate(x, y, angleRad) {
    const X = x * Math.cos(angleRad) - y * Math.sin(angleRad);
    const Y = x * Math.sin(angleRad) + y * Math.cos(angleRad);
    return [
        X,
        Y
    ];
}
function $e66d010f3d556b31$var$arcToCubicCurves(x1, y1, x2, y2, r1, r2, angle, largeArcFlag, sweepFlag, recursive) {
    const angleRad = $e66d010f3d556b31$var$degToRad(angle);
    let params = [];
    let f1 = 0, f2 = 0, cx = 0, cy = 0;
    if (recursive) [f1, f2, cx, cy] = recursive;
    else {
        [x1, y1] = $e66d010f3d556b31$var$rotate(x1, y1, -angleRad);
        [x2, y2] = $e66d010f3d556b31$var$rotate(x2, y2, -angleRad);
        const x = (x1 - x2) / 2;
        const y = (y1 - y2) / 2;
        let h = x * x / (r1 * r1) + y * y / (r2 * r2);
        if (h > 1) {
            h = Math.sqrt(h);
            r1 = h * r1;
            r2 = h * r2;
        }
        const sign = largeArcFlag === sweepFlag ? -1 : 1;
        const r1Pow = r1 * r1;
        const r2Pow = r2 * r2;
        const left = r1Pow * r2Pow - r1Pow * y * y - r2Pow * x * x;
        const right = r1Pow * y * y + r2Pow * x * x;
        const k = sign * Math.sqrt(Math.abs(left / right));
        cx = k * r1 * y / r2 + (x1 + x2) / 2;
        cy = k * -r2 * x / r1 + (y1 + y2) / 2;
        f1 = Math.asin(parseFloat(((y1 - cy) / r2).toFixed(9)));
        f2 = Math.asin(parseFloat(((y2 - cy) / r2).toFixed(9)));
        if (x1 < cx) f1 = Math.PI - f1;
        if (x2 < cx) f2 = Math.PI - f2;
        if (f1 < 0) f1 = Math.PI * 2 + f1;
        if (f2 < 0) f2 = Math.PI * 2 + f2;
        if (sweepFlag && f1 > f2) f1 = f1 - Math.PI * 2;
        if (!sweepFlag && f2 > f1) f2 = f2 - Math.PI * 2;
    }
    let df = f2 - f1;
    if (Math.abs(df) > Math.PI * 120 / 180) {
        const f2old = f2;
        const x2old = x2;
        const y2old = y2;
        if (sweepFlag && f2 > f1) f2 = f1 + Math.PI * 120 / 180 * 1;
        else f2 = f1 + Math.PI * 120 / 180 * -1;
        x2 = cx + r1 * Math.cos(f2);
        y2 = cy + r2 * Math.sin(f2);
        params = $e66d010f3d556b31$var$arcToCubicCurves(x2, y2, x2old, y2old, r1, r2, angle, 0, sweepFlag, [
            f2,
            f2old,
            cx,
            cy
        ]);
    }
    df = f2 - f1;
    const c1 = Math.cos(f1);
    const s1 = Math.sin(f1);
    const c2 = Math.cos(f2);
    const s2 = Math.sin(f2);
    const t = Math.tan(df / 4);
    const hx = 4 / 3 * r1 * t;
    const hy = 4 / 3 * r2 * t;
    const m1 = [
        x1,
        y1
    ];
    const m2 = [
        x1 + hx * s1,
        y1 - hy * c1
    ];
    const m3 = [
        x2 + hx * s2,
        y2 - hy * c2
    ];
    const m4 = [
        x2,
        y2
    ];
    m2[0] = 2 * m1[0] - m2[0];
    m2[1] = 2 * m1[1] - m2[1];
    if (recursive) return [
        m2,
        m3,
        m4
    ].concat(params);
    else {
        params = [
            m2,
            m3,
            m4
        ].concat(params);
        const curves = [];
        for(let i = 0; i < params.length; i += 3){
            const r1 = $e66d010f3d556b31$var$rotate(params[i][0], params[i][1], angleRad);
            const r2 = $e66d010f3d556b31$var$rotate(params[i + 1][0], params[i + 1][1], angleRad);
            const r3 = $e66d010f3d556b31$var$rotate(params[i + 2][0], params[i + 2][1], angleRad);
            curves.push([
                r1[0],
                r1[1],
                r2[0],
                r2[1],
                r3[0],
                r3[1]
            ]);
        }
        return curves;
    }
}




const $5ca4fc04df070a71$var$helper = {
    randOffset: $5ca4fc04df070a71$export$fa98ee57e7e2a1d3,
    randOffsetWithRange: $5ca4fc04df070a71$export$84f7f536b6d805f9,
    ellipse: $5ca4fc04df070a71$export$35eec893e28a8a34,
    doubleLineOps: $5ca4fc04df070a71$export$3284bb4bf9c65675
};
function $5ca4fc04df070a71$export$53f1d5ea8de3d7c(x1, y1, x2, y2, o) {
    return {
        type: "path",
        ops: $5ca4fc04df070a71$var$_doubleLine(x1, y1, x2, y2, o)
    };
}
function $5ca4fc04df070a71$export$926d3b8505d404a6(points, close, o) {
    const len = (points || []).length;
    if (len > 2) {
        const ops = [];
        for(let i = 0; i < len - 1; i++)ops.push(...$5ca4fc04df070a71$var$_doubleLine(points[i][0], points[i][1], points[i + 1][0], points[i + 1][1], o));
        if (close) ops.push(...$5ca4fc04df070a71$var$_doubleLine(points[len - 1][0], points[len - 1][1], points[0][0], points[0][1], o));
        return {
            type: "path",
            ops: ops
        };
    } else if (len === 2) return $5ca4fc04df070a71$export$53f1d5ea8de3d7c(points[0][0], points[0][1], points[1][0], points[1][1], o);
    return {
        type: "path",
        ops: []
    };
}
function $5ca4fc04df070a71$export$b7b19aa0ee06c73(points, o) {
    return $5ca4fc04df070a71$export$926d3b8505d404a6(points, true, o);
}
function $5ca4fc04df070a71$export$405b065079b7caf2(x, y, width, height, o) {
    const points = [
        [
            x,
            y
        ],
        [
            x + width,
            y
        ],
        [
            x + width,
            y + height
        ],
        [
            x,
            y + height
        ]
    ];
    return $5ca4fc04df070a71$export$b7b19aa0ee06c73(points, o);
}
function $5ca4fc04df070a71$export$c05cc7140eecf824(points, o) {
    let o1 = $5ca4fc04df070a71$var$_curveWithOffset(points, 1 * (1 + o.roughness * 0.2), o);
    if (!o.disableMultiStroke) {
        const o2 = $5ca4fc04df070a71$var$_curveWithOffset(points, 1.5 * (1 + o.roughness * 0.22), $5ca4fc04df070a71$var$cloneOptionsAlterSeed(o));
        o1 = o1.concat(o2);
    }
    return {
        type: "path",
        ops: o1
    };
}
function $5ca4fc04df070a71$export$35eec893e28a8a34(x, y, width, height, o) {
    const params = $5ca4fc04df070a71$export$5739d30efb9e449d(width, height, o);
    return $5ca4fc04df070a71$export$b087d802a72d43db(x, y, o, params).opset;
}
function $5ca4fc04df070a71$export$5739d30efb9e449d(width, height, o) {
    const psq = Math.sqrt(Math.PI * 2 * Math.sqrt((Math.pow(width / 2, 2) + Math.pow(height / 2, 2)) / 2));
    const stepCount = Math.ceil(Math.max(o.curveStepCount, o.curveStepCount / Math.sqrt(200) * psq));
    const increment = Math.PI * 2 / stepCount;
    let rx = Math.abs(width / 2);
    let ry = Math.abs(height / 2);
    const curveFitRandomness = 1 - o.curveFitting;
    rx += $5ca4fc04df070a71$var$_offsetOpt(rx * curveFitRandomness, o);
    ry += $5ca4fc04df070a71$var$_offsetOpt(ry * curveFitRandomness, o);
    return {
        increment: increment,
        rx: rx,
        ry: ry
    };
}
function $5ca4fc04df070a71$export$b087d802a72d43db(x, y, o, ellipseParams) {
    const [ap1, cp1] = $5ca4fc04df070a71$var$_computeEllipsePoints(ellipseParams.increment, x, y, ellipseParams.rx, ellipseParams.ry, 1, ellipseParams.increment * $5ca4fc04df070a71$var$_offset(0.1, $5ca4fc04df070a71$var$_offset(0.4, 1, o), o), o);
    let o1 = $5ca4fc04df070a71$var$_curve(ap1, null, o);
    if (!o.disableMultiStroke && o.roughness !== 0) {
        const [ap2] = $5ca4fc04df070a71$var$_computeEllipsePoints(ellipseParams.increment, x, y, ellipseParams.rx, ellipseParams.ry, 1.5, 0, o);
        const o2 = $5ca4fc04df070a71$var$_curve(ap2, null, o);
        o1 = o1.concat(o2);
    }
    return {
        estimatedPoints: cp1,
        opset: {
            type: "path",
            ops: o1
        }
    };
}
function $5ca4fc04df070a71$export$ff1ef9a5c671f043(x, y, width, height, start, stop, closed, roughClosure, o) {
    const cx = x;
    const cy = y;
    let rx = Math.abs(width / 2);
    let ry = Math.abs(height / 2);
    rx += $5ca4fc04df070a71$var$_offsetOpt(rx * 0.01, o);
    ry += $5ca4fc04df070a71$var$_offsetOpt(ry * 0.01, o);
    let strt = start;
    let stp = stop;
    while(strt < 0){
        strt += Math.PI * 2;
        stp += Math.PI * 2;
    }
    if (stp - strt > Math.PI * 2) {
        strt = 0;
        stp = Math.PI * 2;
    }
    const ellipseInc = Math.PI * 2 / o.curveStepCount;
    const arcInc = Math.min(ellipseInc / 2, (stp - strt) / 2);
    const ops = $5ca4fc04df070a71$var$_arc(arcInc, cx, cy, rx, ry, strt, stp, 1, o);
    if (!o.disableMultiStroke) {
        const o2 = $5ca4fc04df070a71$var$_arc(arcInc, cx, cy, rx, ry, strt, stp, 1.5, o);
        ops.push(...o2);
    }
    if (closed) {
        if (roughClosure) ops.push(...$5ca4fc04df070a71$var$_doubleLine(cx, cy, cx + rx * Math.cos(strt), cy + ry * Math.sin(strt), o), ...$5ca4fc04df070a71$var$_doubleLine(cx, cy, cx + rx * Math.cos(stp), cy + ry * Math.sin(stp), o));
        else ops.push({
            op: "lineTo",
            data: [
                cx,
                cy
            ]
        }, {
            op: "lineTo",
            data: [
                cx + rx * Math.cos(strt),
                cy + ry * Math.sin(strt)
            ]
        });
    }
    return {
        type: "path",
        ops: ops
    };
}
function $5ca4fc04df070a71$export$b1d97a68920756b7(path, o) {
    const segments = (0, $e66d010f3d556b31$export$a3295358bff77e)((0, $d190fbece6b82c7d$export$6445f6b54d7a4f43)((0, $1a3f93f8daa5daea$export$8ccf933b0513f8d0)(path)));
    const ops = [];
    let first = [
        0,
        0
    ];
    let current = [
        0,
        0
    ];
    for (const { key: key, data: data } of segments)switch(key){
        case "M":
            current = [
                data[0],
                data[1]
            ];
            first = [
                data[0],
                data[1]
            ];
            break;
        case "L":
            ops.push(...$5ca4fc04df070a71$var$_doubleLine(current[0], current[1], data[0], data[1], o));
            current = [
                data[0],
                data[1]
            ];
            break;
        case "C":
            {
                const [x1, y1, x2, y2, x, y] = data;
                ops.push(...$5ca4fc04df070a71$var$_bezierTo(x1, y1, x2, y2, x, y, current, o));
                current = [
                    x,
                    y
                ];
                break;
            }
        case "Z":
            ops.push(...$5ca4fc04df070a71$var$_doubleLine(current[0], current[1], first[0], first[1], o));
            current = [
                first[0],
                first[1]
            ];
            break;
    }
    return {
        type: "path",
        ops: ops
    };
}
function $5ca4fc04df070a71$export$f0dce869e486cb8c(polygonList, o) {
    const ops = [];
    for (const points of polygonList)if (points.length) {
        const offset = o.maxRandomnessOffset || 0;
        const len = points.length;
        if (len > 2) {
            ops.push({
                op: "move",
                data: [
                    points[0][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
                    points[0][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
                ]
            });
            for(let i = 1; i < len; i++)ops.push({
                op: "lineTo",
                data: [
                    points[i][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
                    points[i][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
                ]
            });
        }
    }
    return {
        type: "fillPath",
        ops: ops
    };
}
function $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8(polygonList, o) {
    return (0, $227b354485fe3585$export$6de2f8d51867ea9d)(o, $5ca4fc04df070a71$var$helper).fillPolygons(polygonList, o);
}
function $5ca4fc04df070a71$export$8bd3cd7cb88674f6(x, y, width, height, start, stop, o) {
    const cx = x;
    const cy = y;
    let rx = Math.abs(width / 2);
    let ry = Math.abs(height / 2);
    rx += $5ca4fc04df070a71$var$_offsetOpt(rx * 0.01, o);
    ry += $5ca4fc04df070a71$var$_offsetOpt(ry * 0.01, o);
    let strt = start;
    let stp = stop;
    while(strt < 0){
        strt += Math.PI * 2;
        stp += Math.PI * 2;
    }
    if (stp - strt > Math.PI * 2) {
        strt = 0;
        stp = Math.PI * 2;
    }
    const increment = (stp - strt) / o.curveStepCount;
    const points = [];
    for(let angle = strt; angle <= stp; angle = angle + increment)points.push([
        cx + rx * Math.cos(angle),
        cy + ry * Math.sin(angle)
    ]);
    points.push([
        cx + rx * Math.cos(stp),
        cy + ry * Math.sin(stp)
    ]);
    points.push([
        cx,
        cy
    ]);
    return $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8([
        points
    ], o);
}
function $5ca4fc04df070a71$export$fa98ee57e7e2a1d3(x, o) {
    return $5ca4fc04df070a71$var$_offsetOpt(x, o);
}
function $5ca4fc04df070a71$export$84f7f536b6d805f9(min, max, o) {
    return $5ca4fc04df070a71$var$_offset(min, max, o);
}
function $5ca4fc04df070a71$export$3284bb4bf9c65675(x1, y1, x2, y2, o) {
    return $5ca4fc04df070a71$var$_doubleLine(x1, y1, x2, y2, o, true);
}
// Private helpers
function $5ca4fc04df070a71$var$cloneOptionsAlterSeed(ops) {
    const result = Object.assign({}, ops);
    result.randomizer = undefined;
    if (ops.seed) result.seed = ops.seed + 1;
    return result;
}
function $5ca4fc04df070a71$var$random(ops) {
    if (!ops.randomizer) ops.randomizer = new (0, $6783b31e8a74aa35$export$a92776769f460054)(ops.seed || 0);
    return ops.randomizer.next();
}
function $5ca4fc04df070a71$var$_offset(min, max, ops, roughnessGain = 1) {
    return ops.roughness * roughnessGain * ($5ca4fc04df070a71$var$random(ops) * (max - min) + min);
}
function $5ca4fc04df070a71$var$_offsetOpt(x, ops, roughnessGain = 1) {
    return $5ca4fc04df070a71$var$_offset(-x, x, ops, roughnessGain);
}
function $5ca4fc04df070a71$var$_doubleLine(x1, y1, x2, y2, o, filling = false) {
    const singleStroke = filling ? o.disableMultiStrokeFill : o.disableMultiStroke;
    const o1 = $5ca4fc04df070a71$var$_line(x1, y1, x2, y2, o, true, false);
    if (singleStroke) return o1;
    const o2 = $5ca4fc04df070a71$var$_line(x1, y1, x2, y2, o, true, true);
    return o1.concat(o2);
}
function $5ca4fc04df070a71$var$_line(x1, y1, x2, y2, o, move, overlay) {
    const lengthSq = Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
    const length = Math.sqrt(lengthSq);
    let roughnessGain = 1;
    if (length < 200) roughnessGain = 1;
    else if (length > 500) roughnessGain = 0.4;
    else roughnessGain = -0.0016668 * length + 1.233334;
    let offset = o.maxRandomnessOffset || 0;
    if (offset * offset * 100 > lengthSq) offset = length / 10;
    const halfOffset = offset / 2;
    const divergePoint = 0.2 + $5ca4fc04df070a71$var$random(o) * 0.2;
    let midDispX = o.bowing * o.maxRandomnessOffset * (y2 - y1) / 200;
    let midDispY = o.bowing * o.maxRandomnessOffset * (x1 - x2) / 200;
    midDispX = $5ca4fc04df070a71$var$_offsetOpt(midDispX, o, roughnessGain);
    midDispY = $5ca4fc04df070a71$var$_offsetOpt(midDispY, o, roughnessGain);
    const ops = [];
    const randomHalf = ()=>$5ca4fc04df070a71$var$_offsetOpt(halfOffset, o, roughnessGain);
    const randomFull = ()=>$5ca4fc04df070a71$var$_offsetOpt(offset, o, roughnessGain);
    const preserveVertices = o.preserveVertices;
    if (move) {
        if (overlay) ops.push({
            op: "move",
            data: [
                x1 + (preserveVertices ? 0 : randomHalf()),
                y1 + (preserveVertices ? 0 : randomHalf())
            ]
        });
        else ops.push({
            op: "move",
            data: [
                x1 + (preserveVertices ? 0 : $5ca4fc04df070a71$var$_offsetOpt(offset, o, roughnessGain)),
                y1 + (preserveVertices ? 0 : $5ca4fc04df070a71$var$_offsetOpt(offset, o, roughnessGain))
            ]
        });
    }
    if (overlay) ops.push({
        op: "bcurveTo",
        data: [
            midDispX + x1 + (x2 - x1) * divergePoint + randomHalf(),
            midDispY + y1 + (y2 - y1) * divergePoint + randomHalf(),
            midDispX + x1 + 2 * (x2 - x1) * divergePoint + randomHalf(),
            midDispY + y1 + 2 * (y2 - y1) * divergePoint + randomHalf(),
            x2 + (preserveVertices ? 0 : randomHalf()),
            y2 + (preserveVertices ? 0 : randomHalf())
        ]
    });
    else ops.push({
        op: "bcurveTo",
        data: [
            midDispX + x1 + (x2 - x1) * divergePoint + randomFull(),
            midDispY + y1 + (y2 - y1) * divergePoint + randomFull(),
            midDispX + x1 + 2 * (x2 - x1) * divergePoint + randomFull(),
            midDispY + y1 + 2 * (y2 - y1) * divergePoint + randomFull(),
            x2 + (preserveVertices ? 0 : randomFull()),
            y2 + (preserveVertices ? 0 : randomFull())
        ]
    });
    return ops;
}
function $5ca4fc04df070a71$var$_curveWithOffset(points, offset, o) {
    const ps = [];
    ps.push([
        points[0][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
        points[0][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
    ]);
    ps.push([
        points[0][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
        points[0][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
    ]);
    for(let i = 1; i < points.length; i++){
        ps.push([
            points[i][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
            points[i][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
        ]);
        if (i === points.length - 1) ps.push([
            points[i][0] + $5ca4fc04df070a71$var$_offsetOpt(offset, o),
            points[i][1] + $5ca4fc04df070a71$var$_offsetOpt(offset, o)
        ]);
    }
    return $5ca4fc04df070a71$var$_curve(ps, null, o);
}
function $5ca4fc04df070a71$var$_curve(points, closePoint, o) {
    const len = points.length;
    const ops = [];
    if (len > 3) {
        const b = [];
        const s = 1 - o.curveTightness;
        ops.push({
            op: "move",
            data: [
                points[1][0],
                points[1][1]
            ]
        });
        for(let i = 1; i + 2 < len; i++){
            const cachedVertArray = points[i];
            b[0] = [
                cachedVertArray[0],
                cachedVertArray[1]
            ];
            b[1] = [
                cachedVertArray[0] + (s * points[i + 1][0] - s * points[i - 1][0]) / 6,
                cachedVertArray[1] + (s * points[i + 1][1] - s * points[i - 1][1]) / 6
            ];
            b[2] = [
                points[i + 1][0] + (s * points[i][0] - s * points[i + 2][0]) / 6,
                points[i + 1][1] + (s * points[i][1] - s * points[i + 2][1]) / 6
            ];
            b[3] = [
                points[i + 1][0],
                points[i + 1][1]
            ];
            ops.push({
                op: "bcurveTo",
                data: [
                    b[1][0],
                    b[1][1],
                    b[2][0],
                    b[2][1],
                    b[3][0],
                    b[3][1]
                ]
            });
        }
        if (closePoint && closePoint.length === 2) {
            const ro = o.maxRandomnessOffset;
            ops.push({
                op: "lineTo",
                data: [
                    closePoint[0] + $5ca4fc04df070a71$var$_offsetOpt(ro, o),
                    closePoint[1] + $5ca4fc04df070a71$var$_offsetOpt(ro, o)
                ]
            });
        }
    } else if (len === 3) {
        ops.push({
            op: "move",
            data: [
                points[1][0],
                points[1][1]
            ]
        });
        ops.push({
            op: "bcurveTo",
            data: [
                points[1][0],
                points[1][1],
                points[2][0],
                points[2][1],
                points[2][0],
                points[2][1]
            ]
        });
    } else if (len === 2) ops.push(...$5ca4fc04df070a71$var$_doubleLine(points[0][0], points[0][1], points[1][0], points[1][1], o));
    return ops;
}
function $5ca4fc04df070a71$var$_computeEllipsePoints(increment, cx, cy, rx, ry, offset, overlap, o) {
    const coreOnly = o.roughness === 0;
    const corePoints = [];
    const allPoints = [];
    if (coreOnly) {
        increment = increment / 4;
        allPoints.push([
            cx + rx * Math.cos(-increment),
            cy + ry * Math.sin(-increment)
        ]);
        for(let angle = 0; angle <= Math.PI * 2; angle = angle + increment){
            const p = [
                cx + rx * Math.cos(angle),
                cy + ry * Math.sin(angle)
            ];
            corePoints.push(p);
            allPoints.push(p);
        }
        allPoints.push([
            cx + rx * Math.cos(0),
            cy + ry * Math.sin(0)
        ]);
        allPoints.push([
            cx + rx * Math.cos(increment),
            cy + ry * Math.sin(increment)
        ]);
    } else {
        const radOffset = $5ca4fc04df070a71$var$_offsetOpt(0.5, o) - Math.PI / 2;
        allPoints.push([
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + 0.9 * rx * Math.cos(radOffset - increment),
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + 0.9 * ry * Math.sin(radOffset - increment)
        ]);
        const endAngle = Math.PI * 2 + radOffset - 0.01;
        for(let angle = radOffset; angle < endAngle; angle = angle + increment){
            const p = [
                $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + rx * Math.cos(angle),
                $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + ry * Math.sin(angle)
            ];
            corePoints.push(p);
            allPoints.push(p);
        }
        allPoints.push([
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + rx * Math.cos(radOffset + Math.PI * 2 + overlap * 0.5),
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + ry * Math.sin(radOffset + Math.PI * 2 + overlap * 0.5)
        ]);
        allPoints.push([
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + 0.98 * rx * Math.cos(radOffset + overlap),
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + 0.98 * ry * Math.sin(radOffset + overlap)
        ]);
        allPoints.push([
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + 0.9 * rx * Math.cos(radOffset + overlap * 0.5),
            $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + 0.9 * ry * Math.sin(radOffset + overlap * 0.5)
        ]);
    }
    return [
        allPoints,
        corePoints
    ];
}
function $5ca4fc04df070a71$var$_arc(increment, cx, cy, rx, ry, strt, stp, offset, o) {
    const radOffset = strt + $5ca4fc04df070a71$var$_offsetOpt(0.1, o);
    const points = [];
    points.push([
        $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + 0.9 * rx * Math.cos(radOffset - increment),
        $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + 0.9 * ry * Math.sin(radOffset - increment)
    ]);
    for(let angle = radOffset; angle <= stp; angle = angle + increment)points.push([
        $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cx + rx * Math.cos(angle),
        $5ca4fc04df070a71$var$_offsetOpt(offset, o) + cy + ry * Math.sin(angle)
    ]);
    points.push([
        cx + rx * Math.cos(stp),
        cy + ry * Math.sin(stp)
    ]);
    points.push([
        cx + rx * Math.cos(stp),
        cy + ry * Math.sin(stp)
    ]);
    return $5ca4fc04df070a71$var$_curve(points, null, o);
}
function $5ca4fc04df070a71$var$_bezierTo(x1, y1, x2, y2, x, y, current, o) {
    const ops = [];
    const ros = [
        o.maxRandomnessOffset || 1,
        (o.maxRandomnessOffset || 1) + 0.3
    ];
    let f = [
        0,
        0
    ];
    const iterations = o.disableMultiStroke ? 1 : 2;
    const preserveVertices = o.preserveVertices;
    for(let i = 0; i < iterations; i++){
        if (i === 0) ops.push({
            op: "move",
            data: [
                current[0],
                current[1]
            ]
        });
        else ops.push({
            op: "move",
            data: [
                current[0] + (preserveVertices ? 0 : $5ca4fc04df070a71$var$_offsetOpt(ros[0], o)),
                current[1] + (preserveVertices ? 0 : $5ca4fc04df070a71$var$_offsetOpt(ros[0], o))
            ]
        });
        f = preserveVertices ? [
            x,
            y
        ] : [
            x + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o),
            y + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o)
        ];
        ops.push({
            op: "bcurveTo",
            data: [
                x1 + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o),
                y1 + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o),
                x2 + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o),
                y2 + $5ca4fc04df070a71$var$_offsetOpt(ros[i], o),
                f[0],
                f[1]
            ]
        });
    }
    return ops;
}



function $d371309317c8cefd$var$clone(p) {
    return [
        ...p
    ];
}
function $d371309317c8cefd$export$2aa70a4801d10c8e(pointsIn, curveTightness = 0) {
    const len = pointsIn.length;
    if (len < 3) throw new Error("A curve must have at least three points.");
    const out = [];
    if (len === 3) out.push($d371309317c8cefd$var$clone(pointsIn[0]), $d371309317c8cefd$var$clone(pointsIn[1]), $d371309317c8cefd$var$clone(pointsIn[2]), $d371309317c8cefd$var$clone(pointsIn[2]));
    else {
        const points = [];
        points.push(pointsIn[0], pointsIn[0]);
        for(let i = 1; i < pointsIn.length; i++){
            points.push(pointsIn[i]);
            if (i === pointsIn.length - 1) points.push(pointsIn[i]);
        }
        const b = [];
        const s = 1 - curveTightness;
        out.push($d371309317c8cefd$var$clone(points[0]));
        for(let i = 1; i + 2 < points.length; i++){
            const cachedVertArray = points[i];
            b[0] = [
                cachedVertArray[0],
                cachedVertArray[1]
            ];
            b[1] = [
                cachedVertArray[0] + (s * points[i + 1][0] - s * points[i - 1][0]) / 6,
                cachedVertArray[1] + (s * points[i + 1][1] - s * points[i - 1][1]) / 6
            ];
            b[2] = [
                points[i + 1][0] + (s * points[i][0] - s * points[i + 2][0]) / 6,
                points[i + 1][1] + (s * points[i][1] - s * points[i + 2][1]) / 6
            ];
            b[3] = [
                points[i + 1][0],
                points[i + 1][1]
            ];
            out.push(b[1], b[2], b[3]);
        }
    }
    return out;
}


// distance between 2 points
function $8f7bd78ead6c7947$var$distance(p1, p2) {
    return Math.sqrt($8f7bd78ead6c7947$var$distanceSq(p1, p2));
}
// distance between 2 points squared
function $8f7bd78ead6c7947$var$distanceSq(p1, p2) {
    return Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2);
}
// Sistance squared from a point p to the line segment vw
function $8f7bd78ead6c7947$var$distanceToSegmentSq(p, v, w) {
    const l2 = $8f7bd78ead6c7947$var$distanceSq(v, w);
    if (l2 === 0) return $8f7bd78ead6c7947$var$distanceSq(p, v);
    let t = ((p[0] - v[0]) * (w[0] - v[0]) + (p[1] - v[1]) * (w[1] - v[1])) / l2;
    t = Math.max(0, Math.min(1, t));
    return $8f7bd78ead6c7947$var$distanceSq(p, $8f7bd78ead6c7947$var$lerp(v, w, t));
}
function $8f7bd78ead6c7947$var$lerp(a, b, t) {
    return [
        a[0] + (b[0] - a[0]) * t,
        a[1] + (b[1] - a[1]) * t
    ];
}
// Adapted from https://seant23.wordpress.com/2010/11/12/offset-bezier-curves/
function $8f7bd78ead6c7947$var$flatness(points, offset) {
    const p1 = points[offset + 0];
    const p2 = points[offset + 1];
    const p3 = points[offset + 2];
    const p4 = points[offset + 3];
    let ux = 3 * p2[0] - 2 * p1[0] - p4[0];
    ux *= ux;
    let uy = 3 * p2[1] - 2 * p1[1] - p4[1];
    uy *= uy;
    let vx = 3 * p3[0] - 2 * p4[0] - p1[0];
    vx *= vx;
    let vy = 3 * p3[1] - 2 * p4[1] - p1[1];
    vy *= vy;
    if (ux < vx) ux = vx;
    if (uy < vy) uy = vy;
    return ux + uy;
}
function $8f7bd78ead6c7947$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints) {
    const outPoints = newPoints || [];
    if ($8f7bd78ead6c7947$var$flatness(points, offset) < tolerance) {
        const p0 = points[offset + 0];
        if (outPoints.length) {
            const d = $8f7bd78ead6c7947$var$distance(outPoints[outPoints.length - 1], p0);
            if (d > 1) outPoints.push(p0);
        } else outPoints.push(p0);
        outPoints.push(points[offset + 3]);
    } else {
        // subdivide
        const t = .5;
        const p1 = points[offset + 0];
        const p2 = points[offset + 1];
        const p3 = points[offset + 2];
        const p4 = points[offset + 3];
        const q1 = $8f7bd78ead6c7947$var$lerp(p1, p2, t);
        const q2 = $8f7bd78ead6c7947$var$lerp(p2, p3, t);
        const q3 = $8f7bd78ead6c7947$var$lerp(p3, p4, t);
        const r1 = $8f7bd78ead6c7947$var$lerp(q1, q2, t);
        const r2 = $8f7bd78ead6c7947$var$lerp(q2, q3, t);
        const red = $8f7bd78ead6c7947$var$lerp(r1, r2, t);
        $8f7bd78ead6c7947$var$getPointsOnBezierCurveWithSplitting([
            p1,
            q1,
            r1,
            red
        ], 0, tolerance, outPoints);
        $8f7bd78ead6c7947$var$getPointsOnBezierCurveWithSplitting([
            red,
            r2,
            q3,
            p4
        ], 0, tolerance, outPoints);
    }
    return outPoints;
}
function $8f7bd78ead6c7947$export$798b53621063651(points, distance) {
    return $8f7bd78ead6c7947$var$simplifyPoints(points, 0, points.length, distance);
}
// Ramer–Douglas–Peucker algorithm
// https://en.wikipedia.org/wiki/Ramer%E2%80%93Douglas%E2%80%93Peucker_algorithm
function $8f7bd78ead6c7947$var$simplifyPoints(points, start, end, epsilon, newPoints) {
    const outPoints = newPoints || [];
    // find the most distance point from the endpoints
    const s = points[start];
    const e = points[end - 1];
    let maxDistSq = 0;
    let maxNdx = 1;
    for(let i = start + 1; i < end - 1; ++i){
        const distSq = $8f7bd78ead6c7947$var$distanceToSegmentSq(points[i], s, e);
        if (distSq > maxDistSq) {
            maxDistSq = distSq;
            maxNdx = i;
        }
    }
    // if that point is too far, split
    if (Math.sqrt(maxDistSq) > epsilon) {
        $8f7bd78ead6c7947$var$simplifyPoints(points, start, maxNdx + 1, epsilon, outPoints);
        $8f7bd78ead6c7947$var$simplifyPoints(points, maxNdx, end, epsilon, outPoints);
    } else {
        if (!outPoints.length) outPoints.push(s);
        outPoints.push(e);
    }
    return outPoints;
}
function $8f7bd78ead6c7947$export$b28976ce5879d0d(points, tolerance = 0.15, distance) {
    const newPoints = [];
    const numSegments = (points.length - 1) / 3;
    for(let i = 0; i < numSegments; i++){
        const offset = i * 3;
        $8f7bd78ead6c7947$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints);
    }
    if (distance && distance > 0) return $8f7bd78ead6c7947$var$simplifyPoints(newPoints, 0, newPoints.length, distance);
    return newPoints;
}


// distance between 2 points
function $dec76eabbba7aaa3$var$distance(p1, p2) {
    return Math.sqrt($dec76eabbba7aaa3$var$distanceSq(p1, p2));
}
// distance between 2 points squared
function $dec76eabbba7aaa3$var$distanceSq(p1, p2) {
    return Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2);
}
// Sistance squared from a point p to the line segment vw
function $dec76eabbba7aaa3$var$distanceToSegmentSq(p, v, w) {
    const l2 = $dec76eabbba7aaa3$var$distanceSq(v, w);
    if (l2 === 0) return $dec76eabbba7aaa3$var$distanceSq(p, v);
    let t = ((p[0] - v[0]) * (w[0] - v[0]) + (p[1] - v[1]) * (w[1] - v[1])) / l2;
    t = Math.max(0, Math.min(1, t));
    return $dec76eabbba7aaa3$var$distanceSq(p, $dec76eabbba7aaa3$var$lerp(v, w, t));
}
function $dec76eabbba7aaa3$var$lerp(a, b, t) {
    return [
        a[0] + (b[0] - a[0]) * t,
        a[1] + (b[1] - a[1]) * t
    ];
}
// Adapted from https://seant23.wordpress.com/2010/11/12/offset-bezier-curves/
function $dec76eabbba7aaa3$var$flatness(points, offset) {
    const p1 = points[offset + 0];
    const p2 = points[offset + 1];
    const p3 = points[offset + 2];
    const p4 = points[offset + 3];
    let ux = 3 * p2[0] - 2 * p1[0] - p4[0];
    ux *= ux;
    let uy = 3 * p2[1] - 2 * p1[1] - p4[1];
    uy *= uy;
    let vx = 3 * p3[0] - 2 * p4[0] - p1[0];
    vx *= vx;
    let vy = 3 * p3[1] - 2 * p4[1] - p1[1];
    vy *= vy;
    if (ux < vx) ux = vx;
    if (uy < vy) uy = vy;
    return ux + uy;
}
function $dec76eabbba7aaa3$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints) {
    const outPoints = newPoints || [];
    if ($dec76eabbba7aaa3$var$flatness(points, offset) < tolerance) {
        const p0 = points[offset + 0];
        if (outPoints.length) {
            const d = $dec76eabbba7aaa3$var$distance(outPoints[outPoints.length - 1], p0);
            if (d > 1) outPoints.push(p0);
        } else outPoints.push(p0);
        outPoints.push(points[offset + 3]);
    } else {
        // subdivide
        const t = .5;
        const p1 = points[offset + 0];
        const p2 = points[offset + 1];
        const p3 = points[offset + 2];
        const p4 = points[offset + 3];
        const q1 = $dec76eabbba7aaa3$var$lerp(p1, p2, t);
        const q2 = $dec76eabbba7aaa3$var$lerp(p2, p3, t);
        const q3 = $dec76eabbba7aaa3$var$lerp(p3, p4, t);
        const r1 = $dec76eabbba7aaa3$var$lerp(q1, q2, t);
        const r2 = $dec76eabbba7aaa3$var$lerp(q2, q3, t);
        const red = $dec76eabbba7aaa3$var$lerp(r1, r2, t);
        $dec76eabbba7aaa3$var$getPointsOnBezierCurveWithSplitting([
            p1,
            q1,
            r1,
            red
        ], 0, tolerance, outPoints);
        $dec76eabbba7aaa3$var$getPointsOnBezierCurveWithSplitting([
            red,
            r2,
            q3,
            p4
        ], 0, tolerance, outPoints);
    }
    return outPoints;
}
function $dec76eabbba7aaa3$export$798b53621063651(points, distance) {
    return $dec76eabbba7aaa3$var$simplifyPoints(points, 0, points.length, distance);
}
// Ramer–Douglas–Peucker algorithm
// https://en.wikipedia.org/wiki/Ramer%E2%80%93Douglas%E2%80%93Peucker_algorithm
function $dec76eabbba7aaa3$var$simplifyPoints(points, start, end, epsilon, newPoints) {
    const outPoints = newPoints || [];
    // find the most distance point from the endpoints
    const s = points[start];
    const e = points[end - 1];
    let maxDistSq = 0;
    let maxNdx = 1;
    for(let i = start + 1; i < end - 1; ++i){
        const distSq = $dec76eabbba7aaa3$var$distanceToSegmentSq(points[i], s, e);
        if (distSq > maxDistSq) {
            maxDistSq = distSq;
            maxNdx = i;
        }
    }
    // if that point is too far, split
    if (Math.sqrt(maxDistSq) > epsilon) {
        $dec76eabbba7aaa3$var$simplifyPoints(points, start, maxNdx + 1, epsilon, outPoints);
        $dec76eabbba7aaa3$var$simplifyPoints(points, maxNdx, end, epsilon, outPoints);
    } else {
        if (!outPoints.length) outPoints.push(s);
        outPoints.push(e);
    }
    return outPoints;
}
function $dec76eabbba7aaa3$export$b28976ce5879d0d(points, tolerance = 0.15, distance) {
    const newPoints = [];
    const numSegments = (points.length - 1) / 3;
    for(let i = 0; i < numSegments; i++){
        const offset = i * 3;
        $dec76eabbba7aaa3$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints);
    }
    if (distance && distance > 0) return $dec76eabbba7aaa3$var$simplifyPoints(newPoints, 0, newPoints.length, distance);
    return newPoints;
}



function $c2f74820facd9c3c$export$60f9af320dd8c0b8(path, tolerance, distance) {
    const segments = (0, $1a3f93f8daa5daea$export$8ccf933b0513f8d0)(path);
    const normalized = (0, $e66d010f3d556b31$export$a3295358bff77e)((0, $d190fbece6b82c7d$export$6445f6b54d7a4f43)(segments));
    const sets = [];
    let currentPoints = [];
    let start = [
        0,
        0
    ];
    let pendingCurve = [];
    const appendPendingCurve = ()=>{
        if (pendingCurve.length >= 4) currentPoints.push(...(0, $dec76eabbba7aaa3$export$b28976ce5879d0d)(pendingCurve, tolerance));
        pendingCurve = [];
    };
    const appendPendingPoints = ()=>{
        appendPendingCurve();
        if (currentPoints.length) {
            sets.push(currentPoints);
            currentPoints = [];
        }
    };
    for (const { key: key, data: data } of normalized)switch(key){
        case "M":
            appendPendingPoints();
            start = [
                data[0],
                data[1]
            ];
            currentPoints.push(start);
            break;
        case "L":
            appendPendingCurve();
            currentPoints.push([
                data[0],
                data[1]
            ]);
            break;
        case "C":
            if (!pendingCurve.length) {
                const lastPoint = currentPoints.length ? currentPoints[currentPoints.length - 1] : start;
                pendingCurve.push([
                    lastPoint[0],
                    lastPoint[1]
                ]);
            }
            pendingCurve.push([
                data[0],
                data[1]
            ]);
            pendingCurve.push([
                data[2],
                data[3]
            ]);
            pendingCurve.push([
                data[4],
                data[5]
            ]);
            break;
        case "Z":
            appendPendingCurve();
            currentPoints.push([
                start[0],
                start[1]
            ]);
            break;
    }
    appendPendingPoints();
    if (!distance) return sets;
    const out = [];
    for (const set of sets){
        const simplifiedSet = (0, $dec76eabbba7aaa3$export$798b53621063651)(set, distance);
        if (simplifiedSet.length) out.push(simplifiedSet);
    }
    return out;
}


const $31af7cd5eabf8e2d$var$NOS = "none";
class $31af7cd5eabf8e2d$export$e52ef8e5145b365e {
    constructor(config){
        this.defaultOptions = {
            maxRandomnessOffset: 2,
            roughness: 1,
            bowing: 1,
            stroke: "#000",
            strokeWidth: 1,
            curveTightness: 0,
            curveFitting: 0.95,
            curveStepCount: 9,
            fillStyle: "hachure",
            fillWeight: -1,
            hachureAngle: -41,
            hachureGap: -1,
            dashOffset: -1,
            dashGap: -1,
            zigzagOffset: -1,
            seed: 0,
            disableMultiStroke: false,
            disableMultiStrokeFill: false,
            preserveVertices: false,
            fillShapeRoughnessGain: 0.8
        };
        this.config = config || {};
        if (this.config.options) this.defaultOptions = this._o(this.config.options);
    }
    static newSeed() {
        return (0, $6783b31e8a74aa35$export$7c185c3757807f6c)();
    }
    _o(options) {
        return options ? Object.assign({}, this.defaultOptions, options) : this.defaultOptions;
    }
    _d(shape, sets, options) {
        return {
            shape: shape,
            sets: sets || [],
            options: options || this.defaultOptions
        };
    }
    line(x1, y1, x2, y2, options) {
        const o = this._o(options);
        return this._d("line", [
            (0, $5ca4fc04df070a71$export$53f1d5ea8de3d7c)(x1, y1, x2, y2, o)
        ], o);
    }
    rectangle(x, y, width, height, options) {
        const o = this._o(options);
        const paths = [];
        const outline = (0, $5ca4fc04df070a71$export$405b065079b7caf2)(x, y, width, height, o);
        if (o.fill) {
            const points = [
                [
                    x,
                    y
                ],
                [
                    x + width,
                    y
                ],
                [
                    x + width,
                    y + height
                ],
                [
                    x,
                    y + height
                ]
            ];
            if (o.fillStyle === "solid") paths.push((0, $5ca4fc04df070a71$export$f0dce869e486cb8c)([
                points
            ], o));
            else paths.push((0, $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8)([
                points
            ], o));
        }
        if (o.stroke !== $31af7cd5eabf8e2d$var$NOS) paths.push(outline);
        return this._d("rectangle", paths, o);
    }
    ellipse(x, y, width, height, options) {
        const o = this._o(options);
        const paths = [];
        const ellipseParams = (0, $5ca4fc04df070a71$export$5739d30efb9e449d)(width, height, o);
        const ellipseResponse = (0, $5ca4fc04df070a71$export$b087d802a72d43db)(x, y, o, ellipseParams);
        if (o.fill) {
            if (o.fillStyle === "solid") {
                const shape = (0, $5ca4fc04df070a71$export$b087d802a72d43db)(x, y, o, ellipseParams).opset;
                shape.type = "fillPath";
                paths.push(shape);
            } else paths.push((0, $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8)([
                ellipseResponse.estimatedPoints
            ], o));
        }
        if (o.stroke !== $31af7cd5eabf8e2d$var$NOS) paths.push(ellipseResponse.opset);
        return this._d("ellipse", paths, o);
    }
    circle(x, y, diameter, options) {
        const ret = this.ellipse(x, y, diameter, diameter, options);
        ret.shape = "circle";
        return ret;
    }
    linearPath(points, options) {
        const o = this._o(options);
        return this._d("linearPath", [
            (0, $5ca4fc04df070a71$export$926d3b8505d404a6)(points, false, o)
        ], o);
    }
    arc(x, y, width, height, start, stop, closed = false, options) {
        const o = this._o(options);
        const paths = [];
        const outline = (0, $5ca4fc04df070a71$export$ff1ef9a5c671f043)(x, y, width, height, start, stop, closed, true, o);
        if (closed && o.fill) {
            if (o.fillStyle === "solid") {
                const fillOptions = Object.assign({}, o);
                fillOptions.disableMultiStroke = true;
                const shape = (0, $5ca4fc04df070a71$export$ff1ef9a5c671f043)(x, y, width, height, start, stop, true, false, fillOptions);
                shape.type = "fillPath";
                paths.push(shape);
            } else paths.push((0, $5ca4fc04df070a71$export$8bd3cd7cb88674f6)(x, y, width, height, start, stop, o));
        }
        if (o.stroke !== $31af7cd5eabf8e2d$var$NOS) paths.push(outline);
        return this._d("arc", paths, o);
    }
    curve(points, options) {
        const o = this._o(options);
        const paths = [];
        const outline = (0, $5ca4fc04df070a71$export$c05cc7140eecf824)(points, o);
        if (o.fill && o.fill !== $31af7cd5eabf8e2d$var$NOS && points.length >= 3) {
            if (o.fillStyle === "solid") {
                const fillShape = (0, $5ca4fc04df070a71$export$c05cc7140eecf824)(points, Object.assign(Object.assign({}, o), {
                    disableMultiStroke: true,
                    roughness: o.roughness ? o.roughness + o.fillShapeRoughnessGain : 0
                }));
                paths.push({
                    type: "fillPath",
                    ops: this._mergedShape(fillShape.ops)
                });
            } else {
                const bcurve = (0, $d371309317c8cefd$export$2aa70a4801d10c8e)(points);
                const polyPoints = (0, $8f7bd78ead6c7947$export$b28976ce5879d0d)(bcurve, 10, (1 + o.roughness) / 2);
                paths.push((0, $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8)([
                    polyPoints
                ], o));
            }
        }
        if (o.stroke !== $31af7cd5eabf8e2d$var$NOS) paths.push(outline);
        return this._d("curve", paths, o);
    }
    polygon(points, options) {
        const o = this._o(options);
        const paths = [];
        const outline = (0, $5ca4fc04df070a71$export$926d3b8505d404a6)(points, true, o);
        if (o.fill) {
            if (o.fillStyle === "solid") paths.push((0, $5ca4fc04df070a71$export$f0dce869e486cb8c)([
                points
            ], o));
            else paths.push((0, $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8)([
                points
            ], o));
        }
        if (o.stroke !== $31af7cd5eabf8e2d$var$NOS) paths.push(outline);
        return this._d("polygon", paths, o);
    }
    path(d, options) {
        const o = this._o(options);
        const paths = [];
        if (!d) return this._d("path", paths, o);
        d = (d || "").replace(/\n/g, " ").replace(/(-\s)/g, "-").replace("/(ss)/g", " ");
        const hasFill = o.fill && o.fill !== "transparent" && o.fill !== $31af7cd5eabf8e2d$var$NOS;
        const hasStroke = o.stroke !== $31af7cd5eabf8e2d$var$NOS;
        const simplified = !!(o.simplification && o.simplification < 1);
        const distance = simplified ? 4 - 4 * (o.simplification || 1) : (1 + o.roughness) / 2;
        const sets = (0, $c2f74820facd9c3c$export$60f9af320dd8c0b8)(d, 1, distance);
        const shape = (0, $5ca4fc04df070a71$export$b1d97a68920756b7)(d, o);
        if (hasFill) {
            if (o.fillStyle === "solid") {
                if (sets.length === 1) {
                    const fillShape = (0, $5ca4fc04df070a71$export$b1d97a68920756b7)(d, Object.assign(Object.assign({}, o), {
                        disableMultiStroke: true,
                        roughness: o.roughness ? o.roughness + o.fillShapeRoughnessGain : 0
                    }));
                    paths.push({
                        type: "fillPath",
                        ops: this._mergedShape(fillShape.ops)
                    });
                } else paths.push((0, $5ca4fc04df070a71$export$f0dce869e486cb8c)(sets, o));
            } else paths.push((0, $5ca4fc04df070a71$export$a2c2a1c18c0cf9f8)(sets, o));
        }
        if (hasStroke) {
            if (simplified) sets.forEach((set)=>{
                paths.push((0, $5ca4fc04df070a71$export$926d3b8505d404a6)(set, false, o));
            });
            else paths.push(shape);
        }
        return this._d("path", paths, o);
    }
    opsToPath(drawing, fixedDecimals) {
        let path = "";
        for (const item of drawing.ops){
            const data = typeof fixedDecimals === "number" && fixedDecimals >= 0 ? item.data.map((d)=>+d.toFixed(fixedDecimals)) : item.data;
            switch(item.op){
                case "move":
                    path += `M${data[0]} ${data[1]} `;
                    break;
                case "bcurveTo":
                    path += `C${data[0]} ${data[1]}, ${data[2]} ${data[3]}, ${data[4]} ${data[5]} `;
                    break;
                case "lineTo":
                    path += `L${data[0]} ${data[1]} `;
                    break;
            }
        }
        return path.trim();
    }
    toPaths(drawable) {
        const sets = drawable.sets || [];
        const o = drawable.options || this.defaultOptions;
        const paths = [];
        for (const drawing of sets){
            let path = null;
            switch(drawing.type){
                case "path":
                    path = {
                        d: this.opsToPath(drawing),
                        stroke: o.stroke,
                        strokeWidth: o.strokeWidth,
                        fill: $31af7cd5eabf8e2d$var$NOS
                    };
                    break;
                case "fillPath":
                    path = {
                        d: this.opsToPath(drawing),
                        stroke: $31af7cd5eabf8e2d$var$NOS,
                        strokeWidth: 0,
                        fill: o.fill || $31af7cd5eabf8e2d$var$NOS
                    };
                    break;
                case "fillSketch":
                    path = this.fillSketch(drawing, o);
                    break;
            }
            if (path) paths.push(path);
        }
        return paths;
    }
    fillSketch(drawing, o) {
        let fweight = o.fillWeight;
        if (fweight < 0) fweight = o.strokeWidth / 2;
        return {
            d: this.opsToPath(drawing),
            stroke: o.fill || $31af7cd5eabf8e2d$var$NOS,
            strokeWidth: fweight,
            fill: $31af7cd5eabf8e2d$var$NOS
        };
    }
    _mergedShape(input) {
        return input.filter((d, i)=>{
            if (i === 0) return true;
            if (d.op === "move") return false;
            return true;
        });
    }
}



var $acw62 = parcelRequire("acw62");
function $15e6d94060e5d8b6$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $15e6d94060e5d8b6$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $15e6d94060e5d8b6$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $15e6d94060e5d8b6$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}



const $11b096c57ac70a88$export$5f747a46dc0eb6ee = (()=>{
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top;
    } catch (e) {
        return !1;
    }
    else if ("showOpenFilePicker" in self) return "showOpenFilePicker";
    return !1;
})();


const $11b096c57ac70a88$var$t = $11b096c57ac70a88$export$5f747a46dc0eb6ee ? (parcelRequire("jwLj3")) : (parcelRequire("7A0V7"));
async function $11b096c57ac70a88$export$c1bd535e520dbbc3(...e) {
    return (await $11b096c57ac70a88$var$t).default(...e);
}


const $11b096c57ac70a88$var$i = $11b096c57ac70a88$export$5f747a46dc0eb6ee ? (parcelRequire("1BpsR")) : (parcelRequire("fPR7J"));
async function $11b096c57ac70a88$export$270aed3754275094(...e) {
    return (await $11b096c57ac70a88$var$i).default(...e);
}


const $11b096c57ac70a88$var$o = $11b096c57ac70a88$export$5f747a46dc0eb6ee ? (parcelRequire("6eVtL")) : (parcelRequire("lxYyM"));
async function $11b096c57ac70a88$export$cf414c79194c40b9(...e) {
    return (await $11b096c57ac70a88$var$o).default(...e);
}


// distance between 2 points
function $989397d018ece9d6$var$distance(p1, p2) {
    return Math.sqrt($989397d018ece9d6$var$distanceSq(p1, p2));
}
// distance between 2 points squared
function $989397d018ece9d6$var$distanceSq(p1, p2) {
    return Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2);
}
// Sistance squared from a point p to the line segment vw
function $989397d018ece9d6$var$distanceToSegmentSq(p, v, w) {
    const l2 = $989397d018ece9d6$var$distanceSq(v, w);
    if (l2 === 0) return $989397d018ece9d6$var$distanceSq(p, v);
    let t = ((p[0] - v[0]) * (w[0] - v[0]) + (p[1] - v[1]) * (w[1] - v[1])) / l2;
    t = Math.max(0, Math.min(1, t));
    return $989397d018ece9d6$var$distanceSq(p, $989397d018ece9d6$var$lerp(v, w, t));
}
function $989397d018ece9d6$var$lerp(a, b, t) {
    return [
        a[0] + (b[0] - a[0]) * t,
        a[1] + (b[1] - a[1]) * t
    ];
}
// Adapted from https://seant23.wordpress.com/2010/11/12/offset-bezier-curves/
function $989397d018ece9d6$var$flatness(points, offset) {
    const p1 = points[offset + 0];
    const p2 = points[offset + 1];
    const p3 = points[offset + 2];
    const p4 = points[offset + 3];
    let ux = 3 * p2[0] - 2 * p1[0] - p4[0];
    ux *= ux;
    let uy = 3 * p2[1] - 2 * p1[1] - p4[1];
    uy *= uy;
    let vx = 3 * p3[0] - 2 * p4[0] - p1[0];
    vx *= vx;
    let vy = 3 * p3[1] - 2 * p4[1] - p1[1];
    vy *= vy;
    if (ux < vx) ux = vx;
    if (uy < vy) uy = vy;
    return ux + uy;
}
function $989397d018ece9d6$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints) {
    const outPoints = newPoints || [];
    if ($989397d018ece9d6$var$flatness(points, offset) < tolerance) {
        const p0 = points[offset + 0];
        if (outPoints.length) {
            const d = $989397d018ece9d6$var$distance(outPoints[outPoints.length - 1], p0);
            if (d > 1) outPoints.push(p0);
        } else outPoints.push(p0);
        outPoints.push(points[offset + 3]);
    } else {
        // subdivide
        const t = .5;
        const p1 = points[offset + 0];
        const p2 = points[offset + 1];
        const p3 = points[offset + 2];
        const p4 = points[offset + 3];
        const q1 = $989397d018ece9d6$var$lerp(p1, p2, t);
        const q2 = $989397d018ece9d6$var$lerp(p2, p3, t);
        const q3 = $989397d018ece9d6$var$lerp(p3, p4, t);
        const r1 = $989397d018ece9d6$var$lerp(q1, q2, t);
        const r2 = $989397d018ece9d6$var$lerp(q2, q3, t);
        const red = $989397d018ece9d6$var$lerp(r1, r2, t);
        $989397d018ece9d6$var$getPointsOnBezierCurveWithSplitting([
            p1,
            q1,
            r1,
            red
        ], 0, tolerance, outPoints);
        $989397d018ece9d6$var$getPointsOnBezierCurveWithSplitting([
            red,
            r2,
            q3,
            p4
        ], 0, tolerance, outPoints);
    }
    return outPoints;
}
function $989397d018ece9d6$export$798b53621063651(points, distance) {
    return $989397d018ece9d6$export$59627e036caae5e0(points, 0, points.length, distance);
}
function $989397d018ece9d6$export$59627e036caae5e0(points, start, end, epsilon, newPoints) {
    const outPoints = newPoints || [];
    // find the most distance point from the endpoints
    const s = points[start];
    const e = points[end - 1];
    let maxDistSq = 0;
    let maxNdx = 1;
    for(let i = start + 1; i < end - 1; ++i){
        const distSq = $989397d018ece9d6$var$distanceToSegmentSq(points[i], s, e);
        if (distSq > maxDistSq) {
            maxDistSq = distSq;
            maxNdx = i;
        }
    }
    // if that point is too far, split
    if (Math.sqrt(maxDistSq) > epsilon) {
        $989397d018ece9d6$export$59627e036caae5e0(points, start, maxNdx + 1, epsilon, outPoints);
        $989397d018ece9d6$export$59627e036caae5e0(points, maxNdx, end, epsilon, outPoints);
    } else {
        if (!outPoints.length) outPoints.push(s);
        outPoints.push(e);
    }
    return outPoints;
}
function $989397d018ece9d6$export$b28976ce5879d0d(points, tolerance = 0.15, distance) {
    const newPoints = [];
    const numSegments = (points.length - 1) / 3;
    for(let i = 0; i < numSegments; i++){
        const offset = i * 3;
        $989397d018ece9d6$var$getPointsOnBezierCurveWithSplitting(points, offset, tolerance, newPoints);
    }
    if (distance && distance > 0) return $989397d018ece9d6$export$59627e036caae5e0(newPoints, 0, newPoints.length, distance);
    return newPoints;
}


var $cbacbc9d0ce6177f$exports = {};
var $40b0ed8255973f00$exports = {};
/* crc32.js (C) 2014-2015 SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $40b0ed8255973f00$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $40b0ed8255973f00$var$CRC32;
(function(factory) {
    if (typeof DO_NOT_EXPORT_CRC === "undefined") factory($40b0ed8255973f00$exports);
    else factory($40b0ed8255973f00$var$CRC32 = {});
})(function(CRC32) {
    CRC32.version = "0.3.0";
    /* see perf/crc32table.js */ function signed_crc_table() {
        var c = 0, table = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var table = signed_crc_table();
    /* charCodeAt is the best approach for binary strings */ var use_buffer = typeof $40b0ed8255973f00$require$Buffer !== "undefined";
    function crc32_bstr(bstr) {
        if (bstr.length > 32768) {
            if (use_buffer) return crc32_buf_8(new $40b0ed8255973f00$require$Buffer(bstr));
        }
        var crc = -1, L = bstr.length - 1;
        for(var i = 0; i < L;){
            crc = table[(crc ^ bstr.charCodeAt(i++)) & 0xFF] ^ crc >>> 8;
            crc = table[(crc ^ bstr.charCodeAt(i++)) & 0xFF] ^ crc >>> 8;
        }
        if (i === L) crc = crc >>> 8 ^ table[(crc ^ bstr.charCodeAt(i)) & 0xFF];
        return crc ^ -1;
    }
    function crc32_buf(buf) {
        if (buf.length > 10000) return crc32_buf_8(buf);
        for(var crc = -1, i = 0, L = buf.length - 3; i < L;){
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        }
        while(i < L + 3)crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        return crc ^ -1;
    }
    function crc32_buf_8(buf) {
        for(var crc = -1, i = 0, L = buf.length - 7; i < L;){
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        }
        while(i < L + 7)crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        return crc ^ -1;
    }
    /* much much faster to intertwine utf8 and crc */ function crc32_str(str) {
        for(var crc = -1, i = 0, L = str.length, c, d; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) crc = crc >>> 8 ^ table[(crc ^ c) & 0xFF];
            else if (c < 0x800) {
                crc = crc >>> 8 ^ table[(crc ^ (192 | c >> 6 & 31)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                crc = crc >>> 8 ^ table[(crc ^ (240 | c >> 8 & 7)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c >> 2 & 63)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | d >> 6 & 15 | c & 3)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | d & 63)) & 0xFF];
            } else {
                crc = crc >>> 8 ^ table[(crc ^ (224 | c >> 12 & 15)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c >> 6 & 63)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c & 63)) & 0xFF];
            }
        }
        return crc ^ -1;
    }
    CRC32.table = table;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
});


$cbacbc9d0ce6177f$exports = $cbacbc9d0ce6177f$var$extractChunks;
// Used for fast-ish conversion between uint8s and uint32s/int32s.
// Also required in order to remain agnostic for both Node Buffers and
// Uint8Arrays.
var $cbacbc9d0ce6177f$var$uint8 = new Uint8Array(4);
var $cbacbc9d0ce6177f$var$int32 = new Int32Array($cbacbc9d0ce6177f$var$uint8.buffer);
var $cbacbc9d0ce6177f$var$uint32 = new Uint32Array($cbacbc9d0ce6177f$var$uint8.buffer);
function $cbacbc9d0ce6177f$var$extractChunks(data) {
    if (data[0] !== 0x89) throw new Error("Invalid .png file header");
    if (data[1] !== 0x50) throw new Error("Invalid .png file header");
    if (data[2] !== 0x4E) throw new Error("Invalid .png file header");
    if (data[3] !== 0x47) throw new Error("Invalid .png file header");
    if (data[4] !== 0x0D) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (data[5] !== 0x0A) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (data[6] !== 0x1A) throw new Error("Invalid .png file header");
    if (data[7] !== 0x0A) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    var ended = false;
    var chunks = [];
    var idx = 8;
    while(idx < data.length){
        // Read the length of the current chunk,
        // which is stored as a Uint32.
        $cbacbc9d0ce6177f$var$uint8[3] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[2] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[1] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[0] = data[idx++];
        // Chunk includes name/type for CRC check (see below).
        var length = $cbacbc9d0ce6177f$var$uint32[0] + 4;
        var chunk = new Uint8Array(length);
        chunk[0] = data[idx++];
        chunk[1] = data[idx++];
        chunk[2] = data[idx++];
        chunk[3] = data[idx++];
        // Get the name in ASCII for identification.
        var name = String.fromCharCode(chunk[0]) + String.fromCharCode(chunk[1]) + String.fromCharCode(chunk[2]) + String.fromCharCode(chunk[3]);
        // The IHDR header MUST come first.
        if (!chunks.length && name !== "IHDR") throw new Error("IHDR header missing");
        // The IEND header marks the end of the file,
        // so on discovering it break out of the loop.
        if (name === "IEND") {
            ended = true;
            chunks.push({
                name: name,
                data: new Uint8Array(0)
            });
            break;
        }
        // Read the contents of the chunk out of the main buffer.
        for(var i = 4; i < length; i++)chunk[i] = data[idx++];
        // Read out the CRC value for comparison.
        // It's stored as an Int32.
        $cbacbc9d0ce6177f$var$uint8[3] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[2] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[1] = data[idx++];
        $cbacbc9d0ce6177f$var$uint8[0] = data[idx++];
        var crcActual = $cbacbc9d0ce6177f$var$int32[0];
        var crcExpect = $40b0ed8255973f00$exports.buf(chunk);
        if (crcExpect !== crcActual) throw new Error("CRC values for " + name + " header do not match, PNG file is likely corrupted");
        // The chunk data is now copied to remove the 4 preceding
        // bytes used for the chunk name/type.
        var chunkData = new Uint8Array(chunk.buffer.slice(4));
        chunks.push({
            name: name,
            data: chunkData
        });
    }
    if (!ended) throw new Error(".png file ended prematurely: no IEND header was found");
    return chunks;
}


var $178790578e00e627$exports = {};

$parcel$export($178790578e00e627$exports, "encode", () => $178790578e00e627$export$c564cdbbe6da493, (v) => $178790578e00e627$export$c564cdbbe6da493 = v);
$parcel$export($178790578e00e627$exports, "decode", () => $178790578e00e627$export$2f872c0f2117be69, (v) => $178790578e00e627$export$2f872c0f2117be69 = v);
var $178790578e00e627$export$c564cdbbe6da493;
var $178790578e00e627$export$2f872c0f2117be69;

$178790578e00e627$export$c564cdbbe6da493 = (parcelRequire("LluiH"));

$178790578e00e627$export$2f872c0f2117be69 = (parcelRequire("akGah"));


var $22b609628ac539ce$exports = {};
var $d131e0b1966efd3e$exports = {};
/**
 * An Array.prototype.slice.call(arguments) alternative
 *
 * @param {Object} args something with a length
 * @param {Number} slice
 * @param {Number} sliceEnd
 * @api public
 */ $d131e0b1966efd3e$exports = function(args, slice, sliceEnd) {
    var ret = [];
    var len = args.length;
    if (0 === len) return ret;
    var start = slice < 0 ? Math.max(0, slice + len) : slice || 0;
    if (sliceEnd !== undefined) len = sliceEnd < 0 ? sliceEnd + len : sliceEnd;
    while(len-- > start)ret[len - start] = args[len];
    return ret;
};



$22b609628ac539ce$exports = $22b609628ac539ce$var$encodeChunks;
// Used for fast-ish conversion between uint8s and uint32s/int32s.
// Also required in order to remain agnostic for both Node Buffers and
// Uint8Arrays.
var $22b609628ac539ce$var$uint8 = new Uint8Array(4);
var $22b609628ac539ce$var$int32 = new Int32Array($22b609628ac539ce$var$uint8.buffer);
var $22b609628ac539ce$var$uint32 = new Uint32Array($22b609628ac539ce$var$uint8.buffer);
function $22b609628ac539ce$var$encodeChunks(chunks) {
    var totalSize = 8;
    var idx = totalSize;
    var i;
    for(i = 0; i < chunks.length; i++){
        totalSize += chunks[i].data.length;
        totalSize += 12;
    }
    var output = new Uint8Array(totalSize);
    output[0] = 0x89;
    output[1] = 0x50;
    output[2] = 0x4E;
    output[3] = 0x47;
    output[4] = 0x0D;
    output[5] = 0x0A;
    output[6] = 0x1A;
    output[7] = 0x0A;
    for(i = 0; i < chunks.length; i++){
        var chunk = chunks[i];
        var name = chunk.name;
        var data = chunk.data;
        var size = data.length;
        var nameChars = [
            name.charCodeAt(0),
            name.charCodeAt(1),
            name.charCodeAt(2),
            name.charCodeAt(3)
        ];
        $22b609628ac539ce$var$uint32[0] = size;
        output[idx++] = $22b609628ac539ce$var$uint8[3];
        output[idx++] = $22b609628ac539ce$var$uint8[2];
        output[idx++] = $22b609628ac539ce$var$uint8[1];
        output[idx++] = $22b609628ac539ce$var$uint8[0];
        output[idx++] = nameChars[0];
        output[idx++] = nameChars[1];
        output[idx++] = nameChars[2];
        output[idx++] = nameChars[3];
        for(var j = 0; j < size;)output[idx++] = data[j++];
        var crcCheck = nameChars.concat($d131e0b1966efd3e$exports(data));
        var crc = $40b0ed8255973f00$exports.buf(crcCheck);
        $22b609628ac539ce$var$int32[0] = crc;
        output[idx++] = $22b609628ac539ce$var$uint8[3];
        output[idx++] = $22b609628ac539ce$var$uint8[2];
        output[idx++] = $22b609628ac539ce$var$uint8[1];
        output[idx++] = $22b609628ac539ce$var$uint8[0];
    }
    return output;
}


var $8fa5292818130bae$exports = {};
// Top level file is just a mixin of submodules & constants
"use strict";
var $701cc75d47025217$exports = {};
"use strict";
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$701cc75d47025217$exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
$701cc75d47025217$exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
$701cc75d47025217$exports.setTyped = function(on) {
    if (on) {
        $701cc75d47025217$exports.Buf8 = Uint8Array;
        $701cc75d47025217$exports.Buf16 = Uint16Array;
        $701cc75d47025217$exports.Buf32 = Int32Array;
        $701cc75d47025217$exports.assign($701cc75d47025217$exports, $701cc75d47025217$var$fnTyped);
    } else {
        $701cc75d47025217$exports.Buf8 = Array;
        $701cc75d47025217$exports.Buf16 = Array;
        $701cc75d47025217$exports.Buf32 = Array;
        $701cc75d47025217$exports.assign($701cc75d47025217$exports, $701cc75d47025217$var$fnUntyped);
    }
};
$701cc75d47025217$exports.setTyped($701cc75d47025217$var$TYPED_OK);


var $8fa5292818130bae$require$assign = $701cc75d47025217$exports.assign;
var $1d57b756249bc6d3$exports = {};

$parcel$export($1d57b756249bc6d3$exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export($1d57b756249bc6d3$exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export($1d57b756249bc6d3$exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export($1d57b756249bc6d3$exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
"use strict";
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
"use strict";

var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
"use strict";

/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $701cc75d47025217$exports.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;


var $c2fc869ba2d0859c$exports = {};
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
$c2fc869ba2d0859c$exports = $c2fc869ba2d0859c$var$adler32;


var $44e7d98dd6723a9a$exports = {};
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
$44e7d98dd6723a9a$exports = $44e7d98dd6723a9a$var$crc32;


var $54a63c0c56b6e112$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$54a63c0c56b6e112$exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};


/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $54a63c0c56b6e112$exports[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $701cc75d47025217$exports.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $cc3a58b664fcb155$export$44f15b52eef0cf41(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $701cc75d47025217$exports.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $c2fc869ba2d0859c$exports(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $701cc75d47025217$exports.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $701cc75d47025217$exports.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $701cc75d47025217$exports.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $701cc75d47025217$exports.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $701cc75d47025217$exports.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $701cc75d47025217$exports.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $701cc75d47025217$exports.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $cc3a58b664fcb155$export$4e4fc0157c3cd14d(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $701cc75d47025217$exports.Buf8(s.w_size * 2);
    s.head = new $701cc75d47025217$exports.Buf16(s.hash_size);
    s.prev = new $701cc75d47025217$exports.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $701cc75d47025217$exports.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $cc3a58b664fcb155$export$bfb360e02ee9b403(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $cc3a58b664fcb155$export$8959e34c5e020172(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $c2fc869ba2d0859c$exports(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $701cc75d47025217$exports.Buf8(s.w_size);
        $701cc75d47025217$exports.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 



// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
"use strict";

// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $701cc75d47025217$exports.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $701cc75d47025217$exports.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $701cc75d47025217$exports.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $701cc75d47025217$exports.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};



var $73d8265e2c50d00b$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
$73d8265e2c50d00b$exports = $73d8265e2c50d00b$var$ZStream;


var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $701cc75d47025217$exports.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $73d8265e2c50d00b$exports();
    this.strm.avail_out = 0;
    var status = $fc8941aa2060205a$export$a65c7b2bde87cb70(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
    if (opt.header) $fc8941aa2060205a$export$1cd50f7b2515ba19(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $fc8941aa2060205a$export$f55e0b3ab66b5d46(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $701cc75d47025217$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fc8941aa2060205a$export$2316623ecd1285ab(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($d8cddf31faab2448$export$a751fe64af8a9a51($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $fc8941aa2060205a$export$599854fa319a815f(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $701cc75d47025217$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $54a63c0c56b6e112$exports[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;


var $2c8537a6b47169be$exports = {};

$parcel$export($2c8537a6b47169be$exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export($2c8537a6b47169be$exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export($2c8537a6b47169be$exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export($2c8537a6b47169be$exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
"use strict";
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
"use strict";



var $4f67bc996330e695$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ $4f67bc996330e695$exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};


var $86622ca50c32b2ec$exports = {};
"use strict";

var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
$86622ca50c32b2ec$exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $701cc75d47025217$exports.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $701cc75d47025217$exports.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};


var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $701cc75d47025217$exports.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $701cc75d47025217$exports.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $701cc75d47025217$exports.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $701cc75d47025217$exports.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $701cc75d47025217$exports.Buf32(512);
        $b562a383a327bea1$var$distfix = new $701cc75d47025217$exports.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $86622ca50c32b2ec$exports($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $86622ca50c32b2ec$exports($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $701cc75d47025217$exports.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $701cc75d47025217$exports.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $701cc75d47025217$exports.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $701cc75d47025217$exports.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $701cc75d47025217$exports.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $701cc75d47025217$exports.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $701cc75d47025217$exports.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $4f67bc996330e695$exports(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $44e7d98dd6723a9a$exports(state.check, output, _out, put - _out) : $c2fc869ba2d0859c$exports(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $44e7d98dd6723a9a$exports(state.check, output, _out, strm.next_out - _out) : $c2fc869ba2d0859c$exports(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $c2fc869ba2d0859c$exports(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 




var $c8d7af08a93a7841$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$c8d7af08a93a7841$exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};




var $6e4bef2851e6b301$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
$6e4bef2851e6b301$exports = $6e4bef2851e6b301$var$GZheader;


var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $701cc75d47025217$exports.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $73d8265e2c50d00b$exports();
    this.strm.avail_out = 0;
    var status = $b562a383a327bea1$export$6792d92addc5c8a0(this.strm, opt.windowBits);
    if (status !== $c8d7af08a93a7841$exports.Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
    this.header = new $6e4bef2851e6b301$exports();
    $b562a383a327bea1$export$6d4647cb9e1c75fc(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $b562a383a327bea1$export$60da749bed98ccf8(this.strm, opt.dictionary);
            if (status !== $c8d7af08a93a7841$exports.Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $c8d7af08a93a7841$exports.Z_FINISH : $c8d7af08a93a7841$exports.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $d8cddf31faab2448$export$1d1a7119601ff18c(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $701cc75d47025217$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $b562a383a327bea1$export$cae1ce83fe4a1782(strm, $c8d7af08a93a7841$exports.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $c8d7af08a93a7841$exports.Z_NEED_DICT && dictionary) status = $b562a383a327bea1$export$60da749bed98ccf8(this.strm, dictionary);
        if (status === $c8d7af08a93a7841$exports.Z_BUF_ERROR && allowBufError === true) {
            status = $c8d7af08a93a7841$exports.Z_OK;
            allowBufError = false;
        }
        if (status !== $c8d7af08a93a7841$exports.Z_STREAM_END && status !== $c8d7af08a93a7841$exports.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $c8d7af08a93a7841$exports.Z_STREAM_END || strm.avail_in === 0 && (_mode === $c8d7af08a93a7841$exports.Z_FINISH || _mode === $c8d7af08a93a7841$exports.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $d8cddf31faab2448$export$53dee3f58a714214(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $d8cddf31faab2448$export$49a50563f377746(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $701cc75d47025217$exports.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $c8d7af08a93a7841$exports.Z_STREAM_END);
    if (status === $c8d7af08a93a7841$exports.Z_STREAM_END) _mode = $c8d7af08a93a7841$exports.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $c8d7af08a93a7841$exports.Z_FINISH) {
        status = $b562a383a327bea1$export$224e1a443c3fba76(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $c8d7af08a93a7841$exports.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $c8d7af08a93a7841$exports.Z_SYNC_FLUSH) {
        this.onEnd($c8d7af08a93a7841$exports.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $c8d7af08a93a7841$exports.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $701cc75d47025217$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $54a63c0c56b6e112$exports[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;



var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $1d57b756249bc6d3$exports, $2c8537a6b47169be$exports, $c8d7af08a93a7841$exports);
$8fa5292818130bae$exports = $8fa5292818130bae$var$pako;



class $064a46608f33c2ee$export$91cc94ee2dfd1f5d {
    constructor(canvas, config){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext("2d");
        this.gen = new (0, $31af7cd5eabf8e2d$export$e52ef8e5145b365e)(config);
    }
    draw(drawable) {
        const sets = drawable.sets || [];
        const o = drawable.options || this.getDefaultOptions();
        const ctx = this.ctx;
        const precision = drawable.options.fixedDecimalPlaceDigits;
        for (const drawing of sets)switch(drawing.type){
            case "path":
                ctx.save();
                ctx.strokeStyle = o.stroke === "none" ? "transparent" : o.stroke;
                ctx.lineWidth = o.strokeWidth;
                if (o.strokeLineDash) ctx.setLineDash(o.strokeLineDash);
                if (o.strokeLineDashOffset) ctx.lineDashOffset = o.strokeLineDashOffset;
                this._drawToContext(ctx, drawing, precision);
                ctx.restore();
                break;
            case "fillPath":
                {
                    ctx.save();
                    ctx.fillStyle = o.fill || "";
                    const fillRule = drawable.shape === "curve" || drawable.shape === "polygon" || drawable.shape === "path" ? "evenodd" : "nonzero";
                    this._drawToContext(ctx, drawing, precision, fillRule);
                    ctx.restore();
                    break;
                }
            case "fillSketch":
                this.fillSketch(ctx, drawing, o);
                break;
        }
    }
    fillSketch(ctx, drawing, o) {
        let fweight = o.fillWeight;
        if (fweight < 0) fweight = o.strokeWidth / 2;
        ctx.save();
        if (o.fillLineDash) ctx.setLineDash(o.fillLineDash);
        if (o.fillLineDashOffset) ctx.lineDashOffset = o.fillLineDashOffset;
        ctx.strokeStyle = o.fill || "";
        ctx.lineWidth = fweight;
        this._drawToContext(ctx, drawing, o.fixedDecimalPlaceDigits);
        ctx.restore();
    }
    _drawToContext(ctx, drawing, fixedDecimals, rule = "nonzero") {
        ctx.beginPath();
        for (const item of drawing.ops){
            const data = typeof fixedDecimals === "number" && fixedDecimals >= 0 ? item.data.map((d)=>+d.toFixed(fixedDecimals)) : item.data;
            switch(item.op){
                case "move":
                    ctx.moveTo(data[0], data[1]);
                    break;
                case "bcurveTo":
                    ctx.bezierCurveTo(data[0], data[1], data[2], data[3], data[4], data[5]);
                    break;
                case "lineTo":
                    ctx.lineTo(data[0], data[1]);
                    break;
            }
        }
        if (drawing.type === "fillPath") ctx.fill(rule);
        else ctx.stroke();
    }
    get generator() {
        return this.gen;
    }
    getDefaultOptions() {
        return this.gen.defaultOptions;
    }
    line(x1, y1, x2, y2, options) {
        const d = this.gen.line(x1, y1, x2, y2, options);
        this.draw(d);
        return d;
    }
    rectangle(x, y, width, height, options) {
        const d = this.gen.rectangle(x, y, width, height, options);
        this.draw(d);
        return d;
    }
    ellipse(x, y, width, height, options) {
        const d = this.gen.ellipse(x, y, width, height, options);
        this.draw(d);
        return d;
    }
    circle(x, y, diameter, options) {
        const d = this.gen.circle(x, y, diameter, options);
        this.draw(d);
        return d;
    }
    linearPath(points, options) {
        const d = this.gen.linearPath(points, options);
        this.draw(d);
        return d;
    }
    polygon(points, options) {
        const d = this.gen.polygon(points, options);
        this.draw(d);
        return d;
    }
    arc(x, y, width, height, start, stop, closed = false, options) {
        const d = this.gen.arc(x, y, width, height, start, stop, closed, options);
        this.draw(d);
        return d;
    }
    curve(points, options) {
        const d = this.gen.curve(points, options);
        this.draw(d);
        return d;
    }
    path(d, options) {
        const drawing = this.gen.path(d, options);
        this.draw(drawing);
        return drawing;
    }
}



const $3b9f452fcea3a517$export$a690ad4c9a38f86e = "http://www.w3.org/2000/svg";



class $b6fa6a21b39f0569$export$1c87db17f9f2f314 {
    constructor(svg, config){
        this.svg = svg;
        this.gen = new (0, $31af7cd5eabf8e2d$export$e52ef8e5145b365e)(config);
    }
    draw(drawable) {
        const sets = drawable.sets || [];
        const o = drawable.options || this.getDefaultOptions();
        const doc = this.svg.ownerDocument || window.document;
        const g = doc.createElementNS((0, $3b9f452fcea3a517$export$a690ad4c9a38f86e), "g");
        const precision = drawable.options.fixedDecimalPlaceDigits;
        for (const drawing of sets){
            let path = null;
            switch(drawing.type){
                case "path":
                    path = doc.createElementNS((0, $3b9f452fcea3a517$export$a690ad4c9a38f86e), "path");
                    path.setAttribute("d", this.opsToPath(drawing, precision));
                    path.setAttribute("stroke", o.stroke);
                    path.setAttribute("stroke-width", o.strokeWidth + "");
                    path.setAttribute("fill", "none");
                    if (o.strokeLineDash) path.setAttribute("stroke-dasharray", o.strokeLineDash.join(" ").trim());
                    if (o.strokeLineDashOffset) path.setAttribute("stroke-dashoffset", `${o.strokeLineDashOffset}`);
                    break;
                case "fillPath":
                    path = doc.createElementNS((0, $3b9f452fcea3a517$export$a690ad4c9a38f86e), "path");
                    path.setAttribute("d", this.opsToPath(drawing, precision));
                    path.setAttribute("stroke", "none");
                    path.setAttribute("stroke-width", "0");
                    path.setAttribute("fill", o.fill || "");
                    if (drawable.shape === "curve" || drawable.shape === "polygon") path.setAttribute("fill-rule", "evenodd");
                    break;
                case "fillSketch":
                    path = this.fillSketch(doc, drawing, o);
                    break;
            }
            if (path) g.appendChild(path);
        }
        return g;
    }
    fillSketch(doc, drawing, o) {
        let fweight = o.fillWeight;
        if (fweight < 0) fweight = o.strokeWidth / 2;
        const path = doc.createElementNS((0, $3b9f452fcea3a517$export$a690ad4c9a38f86e), "path");
        path.setAttribute("d", this.opsToPath(drawing, o.fixedDecimalPlaceDigits));
        path.setAttribute("stroke", o.fill || "");
        path.setAttribute("stroke-width", fweight + "");
        path.setAttribute("fill", "none");
        if (o.fillLineDash) path.setAttribute("stroke-dasharray", o.fillLineDash.join(" ").trim());
        if (o.fillLineDashOffset) path.setAttribute("stroke-dashoffset", `${o.fillLineDashOffset}`);
        return path;
    }
    get generator() {
        return this.gen;
    }
    getDefaultOptions() {
        return this.gen.defaultOptions;
    }
    opsToPath(drawing, fixedDecimalPlaceDigits) {
        return this.gen.opsToPath(drawing, fixedDecimalPlaceDigits);
    }
    line(x1, y1, x2, y2, options) {
        const d = this.gen.line(x1, y1, x2, y2, options);
        return this.draw(d);
    }
    rectangle(x, y, width, height, options) {
        const d = this.gen.rectangle(x, y, width, height, options);
        return this.draw(d);
    }
    ellipse(x, y, width, height, options) {
        const d = this.gen.ellipse(x, y, width, height, options);
        return this.draw(d);
    }
    circle(x, y, diameter, options) {
        const d = this.gen.circle(x, y, diameter, options);
        return this.draw(d);
    }
    linearPath(points, options) {
        const d = this.gen.linearPath(points, options);
        return this.draw(d);
    }
    polygon(points, options) {
        const d = this.gen.polygon(points, options);
        return this.draw(d);
    }
    arc(x, y, width, height, start, stop, closed = false, options) {
        const d = this.gen.arc(x, y, width, height, start, stop, closed, options);
        return this.draw(d);
    }
    curve(points, options) {
        const d = this.gen.curve(points, options);
        return this.draw(d);
    }
    path(d, options) {
        const drawing = this.gen.path(d, options);
        return this.draw(drawing);
    }
}


var $c82ad6b659cbfd26$export$2e2bcd8739ae039 = {
    canvas (canvas, config) {
        return new (0, $064a46608f33c2ee$export$91cc94ee2dfd1f5d)(canvas, config);
    },
    svg (svg, config) {
        return new (0, $b6fa6a21b39f0569$export$1c87db17f9f2f314)(svg, config);
    },
    generator (config) {
        return new (0, $31af7cd5eabf8e2d$export$e52ef8e5145b365e)(config);
    },
    newSeed () {
        return (0, $31af7cd5eabf8e2d$export$e52ef8e5145b365e).newSeed();
    }
};


function $cdfd1866a6cf81a8$var$$(e, t, u, x = (h)=>h) {
    return e * x(.5 - t * (.5 - u));
}
function $cdfd1866a6cf81a8$var$se(e) {
    return [
        -e[0],
        -e[1]
    ];
}
function $cdfd1866a6cf81a8$var$l(e, t) {
    return [
        e[0] + t[0],
        e[1] + t[1]
    ];
}
function $cdfd1866a6cf81a8$var$a(e, t) {
    return [
        e[0] - t[0],
        e[1] - t[1]
    ];
}
function $cdfd1866a6cf81a8$var$b(e, t) {
    return [
        e[0] * t,
        e[1] * t
    ];
}
function $cdfd1866a6cf81a8$var$he(e, t) {
    return [
        e[0] / t,
        e[1] / t
    ];
}
function $cdfd1866a6cf81a8$var$R(e) {
    return [
        e[1],
        -e[0]
    ];
}
function $cdfd1866a6cf81a8$var$B(e, t) {
    return e[0] * t[0] + e[1] * t[1];
}
function $cdfd1866a6cf81a8$var$ue(e, t) {
    return e[0] === t[0] && e[1] === t[1];
}
function $cdfd1866a6cf81a8$var$ge(e) {
    return Math.hypot(e[0], e[1]);
}
function $cdfd1866a6cf81a8$var$de(e) {
    return e[0] * e[0] + e[1] * e[1];
}
function $cdfd1866a6cf81a8$var$A(e, t) {
    return $cdfd1866a6cf81a8$var$de($cdfd1866a6cf81a8$var$a(e, t));
}
function $cdfd1866a6cf81a8$var$G(e) {
    return $cdfd1866a6cf81a8$var$he(e, $cdfd1866a6cf81a8$var$ge(e));
}
function $cdfd1866a6cf81a8$var$ie(e, t) {
    return Math.hypot(e[1] - t[1], e[0] - t[0]);
}
function $cdfd1866a6cf81a8$var$L(e, t, u) {
    let x = Math.sin(u), h = Math.cos(u), y = e[0] - t[0], n = e[1] - t[1], f = y * h - n * x, d = y * x + n * h;
    return [
        f + t[0],
        d + t[1]
    ];
}
function $cdfd1866a6cf81a8$var$K(e, t, u) {
    return $cdfd1866a6cf81a8$var$l(e, $cdfd1866a6cf81a8$var$b($cdfd1866a6cf81a8$var$a(t, e), u));
}
function $cdfd1866a6cf81a8$var$ee(e, t, u) {
    return $cdfd1866a6cf81a8$var$l(e, $cdfd1866a6cf81a8$var$b(t, u));
}
var { min: $cdfd1866a6cf81a8$var$C, PI: $cdfd1866a6cf81a8$var$xe } = Math, $cdfd1866a6cf81a8$var$pe = .275, $cdfd1866a6cf81a8$var$V = $cdfd1866a6cf81a8$var$xe + 1e-4;
function $cdfd1866a6cf81a8$export$276a2b1ff2e4b78c(e, t = {}) {
    let { size: u = 16, smoothing: x = .5, thinning: h = .5, simulatePressure: y = !0, easing: n = (r)=>r, start: f = {}, end: d = {}, last: D = !1 } = t, { cap: S = !0, easing: j = (r)=>r * (2 - r) } = f, { cap: q = !0, easing: c = (r)=>--r * r * r + 1 } = d;
    if (e.length === 0 || u <= 0) return [];
    let p = e[e.length - 1].runningLength, g = f.taper === !1 ? 0 : f.taper === !0 ? Math.max(u, p) : f.taper, T = d.taper === !1 ? 0 : d.taper === !0 ? Math.max(u, p) : d.taper, te = Math.pow(u * x, 2), _ = [], M = [], H = e.slice(0, 10).reduce((r, i)=>{
        let o = i.pressure;
        if (y) {
            let s = $cdfd1866a6cf81a8$var$C(1, i.distance / u), W = $cdfd1866a6cf81a8$var$C(1, 1 - s);
            o = $cdfd1866a6cf81a8$var$C(1, r + (W - r) * (s * $cdfd1866a6cf81a8$var$pe));
        }
        return (r + o) / 2;
    }, e[0].pressure), m = $cdfd1866a6cf81a8$var$$(u, h, e[e.length - 1].pressure, n), U, X = e[0].vector, z = e[0].point, F = z, O = z, E = F, J = !1;
    for(let r = 0; r < e.length; r++){
        let { pressure: i } = e[r], { point: o, vector: s, distance: W, runningLength: I } = e[r];
        if (r < e.length - 1 && p - I < 3) continue;
        if (h) {
            if (y) {
                let v = $cdfd1866a6cf81a8$var$C(1, W / u), Z = $cdfd1866a6cf81a8$var$C(1, 1 - v);
                i = $cdfd1866a6cf81a8$var$C(1, H + (Z - H) * (v * $cdfd1866a6cf81a8$var$pe));
            }
            m = $cdfd1866a6cf81a8$var$$(u, h, i, n);
        } else m = u / 2;
        U === void 0 && (U = m);
        let le = I < g ? j(I / g) : 1, fe = p - I < T ? c((p - I) / T) : 1;
        m = Math.max(.01, m * Math.min(le, fe));
        let re = (r < e.length - 1 ? e[r + 1] : e[r]).vector, Y = r < e.length - 1 ? $cdfd1866a6cf81a8$var$B(s, re) : 1, be = $cdfd1866a6cf81a8$var$B(s, X) < 0 && !J, ne = Y !== null && Y < 0;
        if (be || ne) {
            let v = $cdfd1866a6cf81a8$var$b($cdfd1866a6cf81a8$var$R(X), m);
            for(let Z = 1 / 13, w = 0; w <= 1; w += Z)O = $cdfd1866a6cf81a8$var$L($cdfd1866a6cf81a8$var$a(o, v), o, $cdfd1866a6cf81a8$var$V * w), _.push(O), E = $cdfd1866a6cf81a8$var$L($cdfd1866a6cf81a8$var$l(o, v), o, $cdfd1866a6cf81a8$var$V * -w), M.push(E);
            z = O, F = E, ne && (J = !0);
            continue;
        }
        if (J = !1, r === e.length - 1) {
            let v = $cdfd1866a6cf81a8$var$b($cdfd1866a6cf81a8$var$R(s), m);
            _.push($cdfd1866a6cf81a8$var$a(o, v)), M.push($cdfd1866a6cf81a8$var$l(o, v));
            continue;
        }
        let oe = $cdfd1866a6cf81a8$var$b($cdfd1866a6cf81a8$var$R($cdfd1866a6cf81a8$var$K(re, s, Y)), m);
        O = $cdfd1866a6cf81a8$var$a(o, oe), (r <= 1 || $cdfd1866a6cf81a8$var$A(z, O) > te) && (_.push(O), z = O), E = $cdfd1866a6cf81a8$var$l(o, oe), (r <= 1 || $cdfd1866a6cf81a8$var$A(F, E) > te) && (M.push(E), F = E), H = i, X = s;
    }
    let P = e[0].point.slice(0, 2), k = e.length > 1 ? e[e.length - 1].point.slice(0, 2) : $cdfd1866a6cf81a8$var$l(e[0].point, [
        1,
        1
    ]), Q = [], N = [];
    if (e.length === 1) {
        if (!(g || T) || D) {
            let r = $cdfd1866a6cf81a8$var$ee(P, $cdfd1866a6cf81a8$var$G($cdfd1866a6cf81a8$var$R($cdfd1866a6cf81a8$var$a(P, k))), -(U || m)), i = [];
            for(let o = 1 / 13, s = o; s <= 1; s += o)i.push($cdfd1866a6cf81a8$var$L(r, P, $cdfd1866a6cf81a8$var$V * 2 * s));
            return i;
        }
    } else {
        if (!(g || T && e.length === 1)) {
            if (S) for(let i = 1 / 13, o = i; o <= 1; o += i){
                let s = $cdfd1866a6cf81a8$var$L(M[0], P, $cdfd1866a6cf81a8$var$V * o);
                Q.push(s);
            }
            else {
                let i = $cdfd1866a6cf81a8$var$a(_[0], M[0]), o = $cdfd1866a6cf81a8$var$b(i, .5), s = $cdfd1866a6cf81a8$var$b(i, .51);
                Q.push($cdfd1866a6cf81a8$var$a(P, o), $cdfd1866a6cf81a8$var$a(P, s), $cdfd1866a6cf81a8$var$l(P, s), $cdfd1866a6cf81a8$var$l(P, o));
            }
        }
        let r = $cdfd1866a6cf81a8$var$R($cdfd1866a6cf81a8$var$se(e[e.length - 1].vector));
        if (T || g && e.length === 1) N.push(k);
        else if (q) {
            let i = $cdfd1866a6cf81a8$var$ee(k, r, m);
            for(let o = 1 / 29, s = o; s < 1; s += o)N.push($cdfd1866a6cf81a8$var$L(i, k, $cdfd1866a6cf81a8$var$V * 3 * s));
        } else N.push($cdfd1866a6cf81a8$var$l(k, $cdfd1866a6cf81a8$var$b(r, m)), $cdfd1866a6cf81a8$var$l(k, $cdfd1866a6cf81a8$var$b(r, m * .99)), $cdfd1866a6cf81a8$var$a(k, $cdfd1866a6cf81a8$var$b(r, m * .99)), $cdfd1866a6cf81a8$var$a(k, $cdfd1866a6cf81a8$var$b(r, m)));
    }
    return _.concat(N, M.reverse(), Q);
}
function $cdfd1866a6cf81a8$export$a3df61851b8bff6e(e, t = {}) {
    var q;
    let { streamline: u = .5, size: x = 16, last: h = !1 } = t;
    if (e.length === 0) return [];
    let y = .15 + (1 - u) * .85, n = Array.isArray(e[0]) ? e : e.map(({ x: c, y: p, pressure: g = .5 })=>[
            c,
            p,
            g
        ]);
    if (n.length === 2) {
        let c = n[1];
        n = n.slice(0, -1);
        for(let p = 1; p < 5; p++)n.push($cdfd1866a6cf81a8$var$K(n[0], c, p / 4));
    }
    n.length === 1 && (n = [
        ...n,
        [
            ...$cdfd1866a6cf81a8$var$l(n[0], [
                1,
                1
            ]),
            ...n[0].slice(2)
        ]
    ]);
    let f = [
        {
            point: [
                n[0][0],
                n[0][1]
            ],
            pressure: n[0][2] >= 0 ? n[0][2] : .25,
            vector: [
                1,
                1
            ],
            distance: 0,
            runningLength: 0
        }
    ], d = !1, D = 0, S = f[0], j = n.length - 1;
    for(let c = 1; c < n.length; c++){
        let p = h && c === j ? n[c].slice(0, 2) : $cdfd1866a6cf81a8$var$K(S.point, n[c], y);
        if ($cdfd1866a6cf81a8$var$ue(S.point, p)) continue;
        let g = $cdfd1866a6cf81a8$var$ie(p, S.point);
        if (D += g, c < j && !d) {
            if (D < x) continue;
            d = !0;
        }
        S = {
            point: p,
            pressure: n[c][2] >= 0 ? n[c][2] : .5,
            vector: $cdfd1866a6cf81a8$var$G($cdfd1866a6cf81a8$var$a(S.point, p)),
            distance: g,
            runningLength: D
        }, f.push(S);
    }
    return f[0].vector = ((q = f[1]) == null ? void 0 : q.vector) || [
        0,
        0
    ], f;
}
function $cdfd1866a6cf81a8$export$d5e7b8855b0b151b(e, t = {}) {
    return $cdfd1866a6cf81a8$export$276a2b1ff2e4b78c($cdfd1866a6cf81a8$export$a3df61851b8bff6e(e, t), t);
}
var $cdfd1866a6cf81a8$export$2e2bcd8739ae039 = $cdfd1866a6cf81a8$export$d5e7b8855b0b151b;


// License: CC0 (no rights reserved).
// This is based on https://observablehq.com/@dgreensp/implementing-fractional-indexing
const $84454c8a8f31dddd$export$c28d00e24a5c5949 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
// `a` may be empty string, `b` is null or non-empty string.
// `a < b` lexicographically if `b` is non-null.
// no trailing zeros allowed.
// digits is a string such as '0123456789' for base 10.  Digits must be in
// ascending character code order!
/**
 * @param {string} a
 * @param {string | null | undefined} b
 * @param {string} digits
 * @returns {string}
 */ function $84454c8a8f31dddd$var$midpoint(a, b, digits) {
    const zero = digits[0];
    if (b != null && a >= b) throw new Error(a + " >= " + b);
    if (a.slice(-1) === zero || b && b.slice(-1) === zero) throw new Error("trailing zero");
    if (b) {
        // remove longest common prefix.  pad `a` with 0s as we
        // go.  note that we don't need to pad `b`, because it can't
        // end before `a` while traversing the common prefix.
        let n = 0;
        while((a[n] || zero) === b[n])n++;
        if (n > 0) return b.slice(0, n) + $84454c8a8f31dddd$var$midpoint(a.slice(n), b.slice(n), digits);
    }
    // first digits (or lack of digit) are different
    const digitA = a ? digits.indexOf(a[0]) : 0;
    const digitB = b != null ? digits.indexOf(b[0]) : digits.length;
    if (digitB - digitA > 1) {
        const midDigit = Math.round(0.5 * (digitA + digitB));
        return digits[midDigit];
    } else {
        // first digits are consecutive
        if (b && b.length > 1) return b.slice(0, 1);
        else // `b` is null or has length 1 (a single digit).
        // the first digit of `a` is the previous digit to `b`,
        // or 9 if `b` is null.
        // given, for example, midpoint('49', '5'), return
        // '4' + midpoint('9', null), which will become
        // '4' + '9' + midpoint('', null), which is '495'
        return digits[digitA] + $84454c8a8f31dddd$var$midpoint(a.slice(1), null, digits);
    }
}
/**
 * @param {string} int
 * @return {void}
 */ function $84454c8a8f31dddd$var$validateInteger(int) {
    if (int.length !== $84454c8a8f31dddd$var$getIntegerLength(int[0])) throw new Error("invalid integer part of order key: " + int);
}
/**
 * @param {string} head
 * @return {number}
 */ function $84454c8a8f31dddd$var$getIntegerLength(head) {
    if (head >= "a" && head <= "z") return head.charCodeAt(0) - "a".charCodeAt(0) + 2;
    else if (head >= "A" && head <= "Z") return "Z".charCodeAt(0) - head.charCodeAt(0) + 2;
    else throw new Error("invalid order key head: " + head);
}
/**
 * @param {string} key
 * @return {string}
 */ function $84454c8a8f31dddd$var$getIntegerPart(key) {
    const integerPartLength = $84454c8a8f31dddd$var$getIntegerLength(key[0]);
    if (integerPartLength > key.length) throw new Error("invalid order key: " + key);
    return key.slice(0, integerPartLength);
}
/**
 * @param {string} key
 * @param {string} digits
 * @return {void}
 */ function $84454c8a8f31dddd$var$validateOrderKey(key, digits) {
    if (key === "A" + digits[0].repeat(26)) throw new Error("invalid order key: " + key);
    // getIntegerPart will throw if the first character is bad,
    // or the key is too short.  we'd call it to check these things
    // even if we didn't need the result
    const i = $84454c8a8f31dddd$var$getIntegerPart(key);
    const f = key.slice(i.length);
    if (f.slice(-1) === digits[0]) throw new Error("invalid order key: " + key);
}
// note that this may return null, as there is a largest integer
/**
 * @param {string} x
 * @param {string} digits
 * @return {string | null}
 */ function $84454c8a8f31dddd$var$incrementInteger(x, digits) {
    $84454c8a8f31dddd$var$validateInteger(x);
    const [head, ...digs] = x.split("");
    let carry = true;
    for(let i = digs.length - 1; carry && i >= 0; i--){
        const d = digits.indexOf(digs[i]) + 1;
        if (d === digits.length) digs[i] = digits[0];
        else {
            digs[i] = digits[d];
            carry = false;
        }
    }
    if (carry) {
        if (head === "Z") return "a" + digits[0];
        if (head === "z") return null;
        const h = String.fromCharCode(head.charCodeAt(0) + 1);
        if (h > "a") digs.push(digits[0]);
        else digs.pop();
        return h + digs.join("");
    } else return head + digs.join("");
}
// note that this may return null, as there is a smallest integer
/**
 * @param {string} x
 * @param {string} digits
 * @return {string | null}
 */ function $84454c8a8f31dddd$var$decrementInteger(x, digits) {
    $84454c8a8f31dddd$var$validateInteger(x);
    const [head, ...digs] = x.split("");
    let borrow = true;
    for(let i = digs.length - 1; borrow && i >= 0; i--){
        const d = digits.indexOf(digs[i]) - 1;
        if (d === -1) digs[i] = digits.slice(-1);
        else {
            digs[i] = digits[d];
            borrow = false;
        }
    }
    if (borrow) {
        if (head === "a") return "Z" + digits.slice(-1);
        if (head === "A") return null;
        const h = String.fromCharCode(head.charCodeAt(0) - 1);
        if (h < "Z") digs.push(digits.slice(-1));
        else digs.pop();
        return h + digs.join("");
    } else return head + digs.join("");
}
function $84454c8a8f31dddd$export$f922196f163d5217(a, b, digits = $84454c8a8f31dddd$export$c28d00e24a5c5949) {
    if (a != null) $84454c8a8f31dddd$var$validateOrderKey(a, digits);
    if (b != null) $84454c8a8f31dddd$var$validateOrderKey(b, digits);
    if (a != null && b != null && a >= b) throw new Error(a + " >= " + b);
    if (a == null) {
        if (b == null) return "a" + digits[0];
        const ib = $84454c8a8f31dddd$var$getIntegerPart(b);
        const fb = b.slice(ib.length);
        if (ib === "A" + digits[0].repeat(26)) return ib + $84454c8a8f31dddd$var$midpoint("", fb, digits);
        if (ib < b) return ib;
        const res = $84454c8a8f31dddd$var$decrementInteger(ib, digits);
        if (res == null) throw new Error("cannot decrement any more");
        return res;
    }
    if (b == null) {
        const ia = $84454c8a8f31dddd$var$getIntegerPart(a);
        const fa = a.slice(ia.length);
        const i = $84454c8a8f31dddd$var$incrementInteger(ia, digits);
        return i == null ? ia + $84454c8a8f31dddd$var$midpoint(fa, null, digits) : i;
    }
    const ia = $84454c8a8f31dddd$var$getIntegerPart(a);
    const fa = a.slice(ia.length);
    const ib = $84454c8a8f31dddd$var$getIntegerPart(b);
    const fb = b.slice(ib.length);
    if (ia === ib) return ia + $84454c8a8f31dddd$var$midpoint(fa, fb, digits);
    const i = $84454c8a8f31dddd$var$incrementInteger(ia, digits);
    if (i == null) throw new Error("cannot increment any more");
    if (i < b) return i;
    return ia + $84454c8a8f31dddd$var$midpoint(fa, null, digits);
}
function $84454c8a8f31dddd$export$b76def7bbb7952e0(a, b, n, digits = $84454c8a8f31dddd$export$c28d00e24a5c5949) {
    if (n === 0) return [];
    if (n === 1) return [
        $84454c8a8f31dddd$export$f922196f163d5217(a, b, digits)
    ];
    if (b == null) {
        let c = $84454c8a8f31dddd$export$f922196f163d5217(a, b, digits);
        const result = [
            c
        ];
        for(let i = 0; i < n - 1; i++){
            c = $84454c8a8f31dddd$export$f922196f163d5217(c, b, digits);
            result.push(c);
        }
        return result;
    }
    if (a == null) {
        let c = $84454c8a8f31dddd$export$f922196f163d5217(a, b, digits);
        const result = [
            c
        ];
        for(let i = 0; i < n - 1; i++){
            c = $84454c8a8f31dddd$export$f922196f163d5217(a, c, digits);
            result.push(c);
        }
        result.reverse();
        return result;
    }
    const mid = Math.floor(n / 2);
    const c = $84454c8a8f31dddd$export$f922196f163d5217(a, b, digits);
    return [
        ...$84454c8a8f31dddd$export$b76def7bbb7952e0(a, c, mid, digits),
        c,
        ...$84454c8a8f31dddd$export$b76def7bbb7952e0(c, b, n - mid - 1, digits)
    ];
}


var $ac43bb23aa0a60e2$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $ac43bb23aa0a60e2$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac43bb23aa0a60e2$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $ac43bb23aa0a60e2$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac43bb23aa0a60e2$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac43bb23aa0a60e2$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac43bb23aa0a60e2$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac43bb23aa0a60e2$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac43bb23aa0a60e2$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac43bb23aa0a60e2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac43bb23aa0a60e2$var$root = $ac43bb23aa0a60e2$var$freeGlobal || $ac43bb23aa0a60e2$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $ac43bb23aa0a60e2$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac43bb23aa0a60e2$var$objectToString = $ac43bb23aa0a60e2$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac43bb23aa0a60e2$var$nativeMax = Math.max, $ac43bb23aa0a60e2$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac43bb23aa0a60e2$var$now = function() {
    return $ac43bb23aa0a60e2$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac43bb23aa0a60e2$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    wait = $ac43bb23aa0a60e2$var$toNumber(wait) || 0;
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ac43bb23aa0a60e2$var$nativeMax($ac43bb23aa0a60e2$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac43bb23aa0a60e2$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac43bb23aa0a60e2$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac43bb23aa0a60e2$var$now());
    }
    function debounced() {
        var time = $ac43bb23aa0a60e2$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac43bb23aa0a60e2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $ac43bb23aa0a60e2$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac43bb23aa0a60e2$var$isSymbol(value) {
    return typeof value == "symbol" || $ac43bb23aa0a60e2$var$isObjectLike(value) && $ac43bb23aa0a60e2$var$objectToString.call(value) == $ac43bb23aa0a60e2$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac43bb23aa0a60e2$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ac43bb23aa0a60e2$var$isSymbol(value)) return $ac43bb23aa0a60e2$var$NAN;
    if ($ac43bb23aa0a60e2$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ac43bb23aa0a60e2$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($ac43bb23aa0a60e2$var$reTrim, "");
    var isBinary = $ac43bb23aa0a60e2$var$reIsBinary.test(value);
    return isBinary || $ac43bb23aa0a60e2$var$reIsOctal.test(value) ? $ac43bb23aa0a60e2$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac43bb23aa0a60e2$var$reIsBadHex.test(value) ? $ac43bb23aa0a60e2$var$NAN : +value;
}
$ac43bb23aa0a60e2$exports = $ac43bb23aa0a60e2$var$throttle;



var $2BVx3 = parcelRequire("2BVx3");

var $3V2Z3 = parcelRequire("3V2Z3");
var $051474e5c5a9c9ad$export$2881499e37b75b9a;
var $051474e5c5a9c9ad$export$e1d2347eb3f70fd3;
var $051474e5c5a9c9ad$export$a8d36bcf35bd31bd;
var $051474e5c5a9c9ad$export$5fb5cc0d078610b;
var $051474e5c5a9c9ad$export$239265d4179d81b3;
var $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed;
var $051474e5c5a9c9ad$export$89a40582f8c436cc;
var $051474e5c5a9c9ad$export$a247c952d39ea7ea;
"use strict";

var $acw62 = parcelRequire("acw62");
var $5fc7457900d13db1$export$5fb5cc0d078610b;
var $5fc7457900d13db1$export$f51a9068ac82ea43;
var $5fc7457900d13db1$export$39b2e4393dfcb8aa;
"use strict";
var $5fc7457900d13db1$var$keyCount = 0;
function $5fc7457900d13db1$var$atom(read, write) {
    var key = "atom" + ++$5fc7457900d13db1$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = function(get) {
            return get(config);
        };
        config.write = function(get, set, arg) {
            return set(config, typeof arg === "function" ? arg(get(config)) : arg);
        };
    }
    if (write) config.write = write;
    return config;
}
function $5fc7457900d13db1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5fc7457900d13db1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5fc7457900d13db1$var$_arrayLikeToArray(o, minLen);
}
function $5fc7457900d13db1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5fc7457900d13db1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5fc7457900d13db1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $5fc7457900d13db1$var$hasInitialValue = function hasInitialValue(atom) {
    return "init" in atom;
};
var $5fc7457900d13db1$var$isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
    return !!atom.write;
};
var $5fc7457900d13db1$var$cancelPromiseMap = new WeakMap();
var $5fc7457900d13db1$var$registerCancelPromise = function registerCancelPromise(promise, cancel) {
    $5fc7457900d13db1$var$cancelPromiseMap.set(promise, cancel);
    promise.catch(function() {}).finally(function() {
        return $5fc7457900d13db1$var$cancelPromiseMap.delete(promise);
    });
};
var $5fc7457900d13db1$var$cancelPromise = function cancelPromise(promise, next) {
    var cancel = $5fc7457900d13db1$var$cancelPromiseMap.get(promise);
    if (cancel) {
        $5fc7457900d13db1$var$cancelPromiseMap.delete(promise);
        cancel(next);
    }
};
var $5fc7457900d13db1$var$resolvePromise = function resolvePromise(promise, value) {
    promise.status = "fulfilled";
    promise.value = value;
};
var $5fc7457900d13db1$var$rejectPromise = function rejectPromise(promise, e) {
    promise.status = "rejected";
    promise.reason = e;
};
var $5fc7457900d13db1$var$isEqualAtomValue = function isEqualAtomValue(a, b) {
    return "v" in a && "v" in b && Object.is(a.v, b.v);
};
var $5fc7457900d13db1$var$isEqualAtomError = function isEqualAtomError(a, b) {
    return "e" in a && "e" in b && Object.is(a.e, b.e);
};
var $5fc7457900d13db1$var$hasPromiseAtomValue = function hasPromiseAtomValue(a) {
    return "v" in a && a.v instanceof Promise;
};
var $5fc7457900d13db1$var$returnAtomValue = function returnAtomValue(atomState) {
    if ("e" in atomState) throw atomState.e;
    return atomState.v;
};
var $5fc7457900d13db1$var$createStore = function createStore() {
    var atomStateMap = new WeakMap();
    var mountedMap = new WeakMap();
    var pendingMap = new Map();
    var stateListeners;
    var mountedAtoms;
    var getAtomState = function getAtomState(atom) {
        return atomStateMap.get(atom);
    };
    var setAtomState = function setAtomState(atom, atomState) {
        var prevAtomState = atomStateMap.get(atom);
        atomStateMap.set(atom, atomState);
        if (!pendingMap.has(atom)) pendingMap.set(atom, prevAtomState);
        if (prevAtomState && $5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState)) {
            var _next = "v" in atomState ? atomState.v instanceof Promise ? atomState.v : Promise.resolve(atomState.v) : Promise.reject(atomState.e);
            $5fc7457900d13db1$var$cancelPromise(prevAtomState.v, _next);
        }
    };
    var updateDependencies = function updateDependencies(atom, nextAtomState, depSet) {
        var dependencies = new Map();
        var changed = false;
        depSet.forEach(function(a) {
            var aState = a === atom ? nextAtomState : getAtomState(a);
            if (aState) {
                dependencies.set(a, aState);
                if (nextAtomState.d.get(a) !== aState) changed = true;
            }
        });
        if (changed || nextAtomState.d.size !== dependencies.size) nextAtomState.d = dependencies;
    };
    var setAtomValue = function setAtomValue(atom, value, depSet) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            v: value
        };
        if (depSet) updateDependencies(atom, nextAtomState, depSet);
        if (prevAtomState && $5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomError = function setAtomError(atom, error, depSet) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            e: error
        };
        if (depSet) updateDependencies(atom, nextAtomState, depSet);
        if (prevAtomState && $5fc7457900d13db1$var$isEqualAtomError(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var readAtomState = function readAtomState(atom) {
        var atomState = getAtomState(atom);
        if (atomState) {
            atomState.d.forEach(function(_, a) {
                if (a !== atom && !mountedMap.has(a)) readAtomState(a);
            });
            if (Array.from(atomState.d).every(function(_ref) {
                var a = _ref[0], s = _ref[1];
                return a === atom || getAtomState(a) === s;
            })) return atomState;
        }
        var depSet = new Set();
        var isSync = true;
        var getter = function getter(a) {
            depSet.add(a);
            if (a === atom) {
                var _aState = getAtomState(a);
                if (_aState) return $5fc7457900d13db1$var$returnAtomValue(_aState);
                if ($5fc7457900d13db1$var$hasInitialValue(a)) return a.init;
                throw new Error("no atom init");
            }
            var aState = readAtomState(a);
            return $5fc7457900d13db1$var$returnAtomValue(aState);
        };
        var controller;
        var setSelf;
        var options = {
            get signal () {
                if (!controller) controller = new AbortController();
                return controller.signal;
            },
            get setSelf () {
                if (!setSelf && $5fc7457900d13db1$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                    if (!isSync) {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return writeAtom.apply(void 0, [
                            atom
                        ].concat(args));
                    }
                };
                return setSelf;
            }
        };
        try {
            var value = atom.read(getter, options);
            if (value instanceof Promise) {
                var continuePromise;
                var promise = new Promise(function(resolve, reject) {
                    var settled = false;
                    value.then(function(v) {
                        if (!settled) {
                            $5fc7457900d13db1$var$resolvePromise(promise, v);
                            resolve(v);
                        }
                    }, function(e) {
                        if (!settled) {
                            $5fc7457900d13db1$var$rejectPromise(promise, e);
                            reject(e);
                        }
                    }).finally(function() {
                        if (!settled) {
                            settled = true;
                            setAtomValue(atom, promise, depSet);
                        }
                    });
                    continuePromise = function continuePromise(next) {
                        if (!settled) {
                            settled = true;
                            next.then(function(v) {
                                return $5fc7457900d13db1$var$resolvePromise(promise, v);
                            }, function(e) {
                                return $5fc7457900d13db1$var$rejectPromise(promise, e);
                            });
                            resolve(next);
                        }
                    };
                });
                promise.status = "pending";
                $5fc7457900d13db1$var$registerCancelPromise(promise, function(next) {
                    var _controller;
                    if (next) continuePromise(next);
                    (_controller = controller) == null || _controller.abort();
                });
                return setAtomValue(atom, promise, depSet);
            }
            return setAtomValue(atom, value, depSet);
        } catch (error) {
            return setAtomError(atom, error, depSet);
        } finally{
            isSync = false;
        }
    };
    var readAtom = function readAtom(atom) {
        return $5fc7457900d13db1$var$returnAtomValue(readAtomState(atom));
    };
    var addAtom = function addAtom(atom) {
        var mounted = mountedMap.get(atom);
        if (!mounted) mounted = mountAtom(atom);
        return mounted;
    };
    var canUnmountAtom = function canUnmountAtom(atom, mounted) {
        return !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
    };
    var delAtom = function delAtom(atom) {
        var mounted = mountedMap.get(atom);
        if (mounted && canUnmountAtom(atom, mounted)) unmountAtom(atom);
    };
    var recomputeDependents = function recomputeDependents(atom) {
        var mounted = mountedMap.get(atom);
        mounted == null || mounted.t.forEach(function(dependent) {
            if (dependent !== atom) {
                var prevAtomState = getAtomState(dependent);
                var nextAtomState = readAtomState(dependent);
                if (!prevAtomState || !$5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, nextAtomState)) recomputeDependents(dependent);
            }
        });
    };
    var writeAtomState = function writeAtomState(atom) {
        var isSync = true;
        var getter = function getter(a) {
            return $5fc7457900d13db1$var$returnAtomValue(readAtomState(a));
        };
        var setter = function setter(a) {
            var r;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            if (a === atom) {
                if (!$5fc7457900d13db1$var$hasInitialValue(a)) throw new Error("atom not writable");
                var prevAtomState = getAtomState(a);
                var nextAtomState = setAtomValue(a, args[0]);
                if (!prevAtomState || !$5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, nextAtomState)) recomputeDependents(a);
            } else r = writeAtomState.apply(void 0, [
                a
            ].concat(args));
            if (!isSync) flushPending();
            return r;
        };
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var result = atom.write.apply(atom, [
            getter,
            setter
        ].concat(args));
        isSync = false;
        return result;
    };
    var writeAtom = function writeAtom(atom) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        var result = writeAtomState.apply(void 0, [
            atom
        ].concat(args));
        flushPending();
        return result;
    };
    var mountAtom = function mountAtom(atom, initialDependent) {
        var mounted = {
            t: new Set(initialDependent && [
                initialDependent
            ]),
            l: new Set()
        };
        mountedMap.set(atom, mounted);
        readAtomState(atom).d.forEach(function(_, a) {
            var aMounted = mountedMap.get(a);
            if (aMounted) aMounted.t.add(atom);
            else if (a !== atom) mountAtom(a, atom);
        });
        readAtomState(atom);
        if ($5fc7457900d13db1$var$isActuallyWritableAtom(atom) && atom.onMount) {
            var onUnmount = atom.onMount(function() {
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                return writeAtom.apply(void 0, [
                    atom
                ].concat(args));
            });
            if (onUnmount) mounted.u = onUnmount;
        }
        return mounted;
    };
    var unmountAtom = function unmountAtom(atom) {
        var _mountedMap$get;
        var onUnmount = (_mountedMap$get = mountedMap.get(atom)) == null ? void 0 : _mountedMap$get.u;
        if (onUnmount) onUnmount();
        mountedMap.delete(atom);
        var atomState = getAtomState(atom);
        if (atomState) {
            if ($5fc7457900d13db1$var$hasPromiseAtomValue(atomState)) $5fc7457900d13db1$var$cancelPromise(atomState.v);
            atomState.d.forEach(function(_, a) {
                if (a !== atom) {
                    var mounted = mountedMap.get(a);
                    if (mounted) {
                        mounted.t.delete(atom);
                        if (canUnmountAtom(a, mounted)) unmountAtom(a);
                    }
                }
            });
        }
    };
    var mountDependencies = function mountDependencies(atom, atomState, prevDependencies) {
        var depSet = new Set(atomState.d.keys());
        prevDependencies == null || prevDependencies.forEach(function(_, a) {
            if (depSet.has(a)) {
                depSet.delete(a);
                return;
            }
            var mounted = mountedMap.get(a);
            if (mounted) {
                mounted.t.delete(atom);
                if (canUnmountAtom(a, mounted)) unmountAtom(a);
            }
        });
        depSet.forEach(function(a) {
            var mounted = mountedMap.get(a);
            if (mounted) mounted.t.add(atom);
            else if (mountedMap.has(atom)) mountAtom(a, atom);
        });
    };
    var flushPending = function flushPending() {
        while(pendingMap.size){
            var pending = Array.from(pendingMap);
            pendingMap.clear();
            pending.forEach(function(_ref2) {
                var atom = _ref2[0], prevAtomState = _ref2[1];
                var atomState = getAtomState(atom);
                if (atomState) {
                    if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
                    var mounted = mountedMap.get(atom);
                    if (mounted && !(prevAtomState && !$5fc7457900d13db1$var$hasPromiseAtomValue(prevAtomState) && ($5fc7457900d13db1$var$isEqualAtomValue(prevAtomState, atomState) || $5fc7457900d13db1$var$isEqualAtomError(prevAtomState, atomState)))) mounted.l.forEach(function(listener) {
                        return listener();
                    });
                }
            });
        }
    };
    var subscribeAtom = function subscribeAtom(atom, listener) {
        var mounted = addAtom(atom);
        flushPending();
        var listeners = mounted.l;
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            delAtom(atom);
        };
    };
    return {
        get: readAtom,
        set: writeAtom,
        sub: subscribeAtom
    };
};
var $5fc7457900d13db1$var$defaultStore;
var $5fc7457900d13db1$var$getDefaultStore = function getDefaultStore() {
    if (!$5fc7457900d13db1$var$defaultStore) $5fc7457900d13db1$var$defaultStore = $5fc7457900d13db1$var$createStore();
    return $5fc7457900d13db1$var$defaultStore;
};
$5fc7457900d13db1$export$5fb5cc0d078610b = $5fc7457900d13db1$var$atom;
$5fc7457900d13db1$export$f51a9068ac82ea43 = $5fc7457900d13db1$var$createStore;
$5fc7457900d13db1$export$39b2e4393dfcb8aa = $5fc7457900d13db1$var$getDefaultStore;


function $051474e5c5a9c9ad$var$_extends() {
    $051474e5c5a9c9ad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $051474e5c5a9c9ad$var$_extends.apply(this, arguments);
}
function $051474e5c5a9c9ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $051474e5c5a9c9ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $051474e5c5a9c9ad$var$_arrayLikeToArray(o, minLen);
}
function $051474e5c5a9c9ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $051474e5c5a9c9ad$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $051474e5c5a9c9ad$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $051474e5c5a9c9ad$var$SUSPENSE_PROMISE = Symbol();
var $051474e5c5a9c9ad$var$isSuspensePromise = function isSuspensePromise(promise) {
    return !!promise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE];
};
var $051474e5c5a9c9ad$var$isSuspensePromiseAlreadyCancelled = function isSuspensePromiseAlreadyCancelled(suspensePromise) {
    return !suspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE].c;
};
var $051474e5c5a9c9ad$var$cancelSuspensePromise = function cancelSuspensePromise(suspensePromise) {
    var _suspensePromise$SUSP = suspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE], basePromise = _suspensePromise$SUSP.b, cancelPromise = _suspensePromise$SUSP.c;
    if (cancelPromise) {
        var _promiseAbortMap$get;
        cancelPromise();
        (_promiseAbortMap$get = $051474e5c5a9c9ad$var$promiseAbortMap.get(basePromise)) == null || _promiseAbortMap$get();
    }
};
var $051474e5c5a9c9ad$var$isEqualSuspensePromise = function isEqualSuspensePromise(oldSuspensePromise, newSuspensePromise) {
    var oldOriginalPromise = oldSuspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE].o;
    var newOriginalPromise = newSuspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE].o;
    return oldOriginalPromise === newOriginalPromise || oldSuspensePromise === newOriginalPromise || $051474e5c5a9c9ad$var$isSuspensePromise(oldOriginalPromise) && isEqualSuspensePromise(oldOriginalPromise, newSuspensePromise);
};
var $051474e5c5a9c9ad$var$createSuspensePromise = function createSuspensePromise(basePromise, promise) {
    var suspensePromiseExtra = {
        b: basePromise,
        o: promise,
        c: null
    };
    var suspensePromise = new Promise(function(resolve) {
        suspensePromiseExtra.c = function() {
            suspensePromiseExtra.c = null;
            resolve();
        };
        promise.finally(suspensePromiseExtra.c);
    });
    suspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE] = suspensePromiseExtra;
    return suspensePromise;
};
var $051474e5c5a9c9ad$var$copySuspensePromise = function copySuspensePromise(suspensePromise) {
    return $051474e5c5a9c9ad$var$createSuspensePromise(suspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE].b, suspensePromise[$051474e5c5a9c9ad$var$SUSPENSE_PROMISE].o);
};
var $051474e5c5a9c9ad$var$promiseAbortMap = new WeakMap();
var $051474e5c5a9c9ad$var$registerPromiseAbort = function registerPromiseAbort(basePromise, abort) {
    $051474e5c5a9c9ad$var$promiseAbortMap.set(basePromise, abort);
};
var $051474e5c5a9c9ad$var$hasInitialValue = function hasInitialValue(atom) {
    return "init" in atom;
};
var $051474e5c5a9c9ad$var$READ_ATOM = "r";
var $051474e5c5a9c9ad$var$WRITE_ATOM = "w";
var $051474e5c5a9c9ad$var$COMMIT_ATOM = "c";
var $051474e5c5a9c9ad$var$SUBSCRIBE_ATOM = "s";
var $051474e5c5a9c9ad$var$RESTORE_ATOMS = "h";
var $051474e5c5a9c9ad$var$DEV_SUBSCRIBE_STATE = "n";
var $051474e5c5a9c9ad$var$DEV_GET_MOUNTED_ATOMS = "l";
var $051474e5c5a9c9ad$var$DEV_GET_ATOM_STATE = "a";
var $051474e5c5a9c9ad$var$DEV_GET_MOUNTED = "m";
var $051474e5c5a9c9ad$var$createStore = function createStore(initialValues) {
    var _ref4;
    var committedAtomStateMap = new WeakMap();
    var mountedMap = new WeakMap();
    var pendingMap = new Map();
    var stateListeners;
    var mountedAtoms;
    if (initialValues) for(var _iterator = $051474e5c5a9c9ad$var$_createForOfIteratorHelperLoose(initialValues), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, atom = _step$value[0], value = _step$value[1];
        var atomState = {
            v: value,
            r: 0,
            y: true,
            d: new Map()
        };
        committedAtomStateMap.set(atom, atomState);
    }
    var suspensePromiseCacheMap = new WeakMap();
    var addSuspensePromiseToCache = function addSuspensePromiseToCache(version, atom, suspensePromise) {
        var cache = suspensePromiseCacheMap.get(atom);
        if (!cache) {
            cache = new Map();
            suspensePromiseCacheMap.set(atom, cache);
        }
        suspensePromise.then(function() {
            if (cache.get(version) === suspensePromise) {
                cache.delete(version);
                if (!cache.size) suspensePromiseCacheMap.delete(atom);
            }
        });
        cache.set(version, suspensePromise);
    };
    var cancelAllSuspensePromiseInCache = function cancelAllSuspensePromiseInCache(atom) {
        var versionSet = new Set();
        var cache = suspensePromiseCacheMap.get(atom);
        if (cache) {
            suspensePromiseCacheMap.delete(atom);
            cache.forEach(function(suspensePromise, version) {
                $051474e5c5a9c9ad$var$cancelSuspensePromise(suspensePromise);
                versionSet.add(version);
            });
        }
        return versionSet;
    };
    var versionedAtomStateMapMap = new WeakMap();
    var getVersionedAtomStateMap = function getVersionedAtomStateMap(version) {
        var versionedAtomStateMap = versionedAtomStateMapMap.get(version);
        if (!versionedAtomStateMap) {
            versionedAtomStateMap = new Map();
            versionedAtomStateMapMap.set(version, versionedAtomStateMap);
        }
        return versionedAtomStateMap;
    };
    var getAtomState = function getAtomState(version, atom) {
        if (version) {
            var versionedAtomStateMap = getVersionedAtomStateMap(version);
            var _atomState = versionedAtomStateMap.get(atom);
            if (!_atomState) {
                _atomState = getAtomState(version.p, atom);
                if (_atomState && "p" in _atomState && $051474e5c5a9c9ad$var$isSuspensePromiseAlreadyCancelled(_atomState.p)) _atomState = undefined;
                if (_atomState) versionedAtomStateMap.set(atom, _atomState);
            }
            return _atomState;
        }
        return committedAtomStateMap.get(atom);
    };
    var setAtomState = function setAtomState(version, atom, atomState) {
        if (version) {
            var versionedAtomStateMap = getVersionedAtomStateMap(version);
            versionedAtomStateMap.set(atom, atomState);
        } else {
            var prevAtomState = committedAtomStateMap.get(atom);
            committedAtomStateMap.set(atom, atomState);
            if (!pendingMap.has(atom)) pendingMap.set(atom, prevAtomState);
        }
    };
    var createReadDependencies = function createReadDependencies(version, prevReadDependencies, dependencies) {
        if (prevReadDependencies === void 0) prevReadDependencies = new Map();
        if (!dependencies) return prevReadDependencies;
        var readDependencies = new Map();
        var changed = false;
        dependencies.forEach(function(atom) {
            var _getAtomState;
            var revision = ((_getAtomState = getAtomState(version, atom)) == null ? void 0 : _getAtomState.r) || 0;
            readDependencies.set(atom, revision);
            if (prevReadDependencies.get(atom) !== revision) changed = true;
        });
        if (prevReadDependencies.size === readDependencies.size && !changed) return prevReadDependencies;
        return readDependencies;
    };
    var setAtomValue = function setAtomValue(version, atom, value, dependencies, suspensePromise) {
        var atomState = getAtomState(version, atom);
        if (atomState) {
            if (suspensePromise && (!("p" in atomState) || !$051474e5c5a9c9ad$var$isEqualSuspensePromise(atomState.p, suspensePromise))) return atomState;
            if ("p" in atomState) $051474e5c5a9c9ad$var$cancelSuspensePromise(atomState.p);
        }
        var nextAtomState = {
            v: value,
            r: (atomState == null ? void 0 : atomState.r) || 0,
            y: true,
            d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
        };
        var changed = !(atomState != null && atomState.y);
        if (!atomState || !("v" in atomState) || !Object.is(atomState.v, value)) {
            changed = true;
            ++nextAtomState.r;
            if (nextAtomState.d.has(atom)) nextAtomState.d = new Map(nextAtomState.d).set(atom, nextAtomState.r);
        } else if (nextAtomState.d !== atomState.d && (nextAtomState.d.size !== atomState.d.size || !Array.from(nextAtomState.d.keys()).every(function(a) {
            return atomState.d.has(a);
        }))) {
            changed = true;
            Promise.resolve().then(function() {
                flushPending(version);
            });
        }
        if (atomState && !changed) return atomState;
        setAtomState(version, atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomReadError = function setAtomReadError(version, atom, error, dependencies, suspensePromise) {
        var atomState = getAtomState(version, atom);
        if (atomState) {
            if (suspensePromise && (!("p" in atomState) || !$051474e5c5a9c9ad$var$isEqualSuspensePromise(atomState.p, suspensePromise))) return atomState;
            if ("p" in atomState) $051474e5c5a9c9ad$var$cancelSuspensePromise(atomState.p);
        }
        var nextAtomState = {
            e: error,
            r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
            y: true,
            d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
        };
        setAtomState(version, atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomSuspensePromise = function setAtomSuspensePromise(version, atom, suspensePromise, dependencies) {
        var atomState = getAtomState(version, atom);
        if (atomState && "p" in atomState) {
            if ($051474e5c5a9c9ad$var$isEqualSuspensePromise(atomState.p, suspensePromise) && !$051474e5c5a9c9ad$var$isSuspensePromiseAlreadyCancelled(atomState.p)) {
                if (!atomState.y) return $051474e5c5a9c9ad$var$_extends({}, atomState, {
                    y: true
                });
                return atomState;
            }
            $051474e5c5a9c9ad$var$cancelSuspensePromise(atomState.p);
        }
        addSuspensePromiseToCache(version, atom, suspensePromise);
        var nextAtomState = {
            p: suspensePromise,
            r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
            y: true,
            d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
        };
        setAtomState(version, atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomPromiseOrValue = function setAtomPromiseOrValue(version, atom, promiseOrValue, dependencies) {
        if (promiseOrValue instanceof Promise) {
            var suspensePromise = $051474e5c5a9c9ad$var$createSuspensePromise(promiseOrValue, promiseOrValue.then(function(value) {
                setAtomValue(version, atom, value, dependencies, suspensePromise);
            }).catch(function(e) {
                if (e instanceof Promise) {
                    if ($051474e5c5a9c9ad$var$isSuspensePromise(e)) return e.then(function() {
                        readAtomState(version, atom, true);
                    });
                    return e;
                }
                setAtomReadError(version, atom, e, dependencies, suspensePromise);
            }));
            return setAtomSuspensePromise(version, atom, suspensePromise, dependencies);
        }
        return setAtomValue(version, atom, promiseOrValue, dependencies);
    };
    var setAtomInvalidated = function setAtomInvalidated(version, atom) {
        var atomState = getAtomState(version, atom);
        if (atomState) {
            var nextAtomState = $051474e5c5a9c9ad$var$_extends({}, atomState, {
                y: false
            });
            setAtomState(version, atom, nextAtomState);
        }
    };
    var readAtomState = function readAtomState(version, atom, force) {
        if (!force) {
            var _atomState2 = getAtomState(version, atom);
            if (_atomState2) {
                if (_atomState2.y && "p" in _atomState2 && !$051474e5c5a9c9ad$var$isSuspensePromiseAlreadyCancelled(_atomState2.p)) return _atomState2;
                _atomState2.d.forEach(function(_, a) {
                    if (a !== atom) {
                        if (!mountedMap.has(a)) readAtomState(version, a);
                        else {
                            var aState = getAtomState(version, a);
                            if (aState && !aState.y) readAtomState(version, a);
                        }
                    }
                });
                if (Array.from(_atomState2.d).every(function(_ref) {
                    var a = _ref[0], r = _ref[1];
                    var aState = getAtomState(version, a);
                    return aState && !("p" in aState) && aState.r === r;
                })) {
                    if (!_atomState2.y) return $051474e5c5a9c9ad$var$_extends({}, _atomState2, {
                        y: true
                    });
                    return _atomState2;
                }
            }
        }
        var dependencies = new Set();
        try {
            var promiseOrValue = atom.read(function(a) {
                dependencies.add(a);
                var aState = a === atom ? getAtomState(version, a) : readAtomState(version, a);
                if (aState) {
                    if ("e" in aState) throw aState.e;
                    if ("p" in aState) throw aState.p;
                    return aState.v;
                }
                if ($051474e5c5a9c9ad$var$hasInitialValue(a)) return a.init;
                throw new Error("no atom init");
            });
            return setAtomPromiseOrValue(version, atom, promiseOrValue, dependencies);
        } catch (errorOrPromise) {
            if (errorOrPromise instanceof Promise) {
                var suspensePromise = $051474e5c5a9c9ad$var$isSuspensePromise(errorOrPromise) && $051474e5c5a9c9ad$var$isSuspensePromiseAlreadyCancelled(errorOrPromise) ? $051474e5c5a9c9ad$var$copySuspensePromise(errorOrPromise) : $051474e5c5a9c9ad$var$createSuspensePromise(errorOrPromise, errorOrPromise);
                return setAtomSuspensePromise(version, atom, suspensePromise, dependencies);
            }
            return setAtomReadError(version, atom, errorOrPromise, dependencies);
        }
    };
    var readAtom = function readAtom(readingAtom, version) {
        var atomState = readAtomState(version, readingAtom);
        return atomState;
    };
    var addAtom = function addAtom(version, addingAtom) {
        var mounted = mountedMap.get(addingAtom);
        if (!mounted) mounted = mountAtom(version, addingAtom);
        return mounted;
    };
    var canUnmountAtom = function canUnmountAtom(atom, mounted) {
        return !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
    };
    var delAtom = function delAtom(version, deletingAtom) {
        var mounted = mountedMap.get(deletingAtom);
        if (mounted && canUnmountAtom(deletingAtom, mounted)) unmountAtom(version, deletingAtom);
    };
    var invalidateDependents = function invalidateDependents(version, atom) {
        var mounted = mountedMap.get(atom);
        mounted == null || mounted.t.forEach(function(dependent) {
            if (dependent !== atom) {
                setAtomInvalidated(version, dependent);
                invalidateDependents(version, dependent);
            }
        });
    };
    var writeAtomState = function writeAtomState(version, atom, update) {
        var isSync = true;
        var writeGetter = function writeGetter(a, options) {
            var aState = readAtomState(version, a);
            if ("e" in aState) throw aState.e;
            if ("p" in aState) {
                if (options != null && options.unstable_promise) return aState.p.then(function() {
                    var s = getAtomState(version, a);
                    if (s && "p" in s && s.p === aState.p) return new Promise(function(resolve) {
                        return setTimeout(resolve);
                    }).then(function() {
                        return writeGetter(a, options);
                    });
                    return writeGetter(a, options);
                });
                throw aState.p;
            }
            if ("v" in aState) return aState.v;
            throw new Error("no value found");
        };
        var setter = function setter(a, v) {
            var promiseOrVoid;
            if (a === atom) {
                if (!$051474e5c5a9c9ad$var$hasInitialValue(a)) throw new Error("atom not writable");
                var versionSet = cancelAllSuspensePromiseInCache(a);
                versionSet.forEach(function(cancelledVersion) {
                    if (cancelledVersion !== version) setAtomPromiseOrValue(cancelledVersion, a, v);
                });
                var prevAtomState = getAtomState(version, a);
                var nextAtomState = setAtomPromiseOrValue(version, a, v);
                if (prevAtomState !== nextAtomState) invalidateDependents(version, a);
            } else promiseOrVoid = writeAtomState(version, a, v);
            if (!isSync) flushPending(version);
            return promiseOrVoid;
        };
        var promiseOrVoid = atom.write(writeGetter, setter, update);
        isSync = false;
        return promiseOrVoid;
    };
    var writeAtom = function writeAtom(writingAtom, update, version) {
        var promiseOrVoid = writeAtomState(version, writingAtom, update);
        flushPending(version);
        return promiseOrVoid;
    };
    var isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
        return !!atom.write;
    };
    var mountAtom = function mountAtom(version, atom, initialDependent) {
        var mounted = {
            t: new Set(initialDependent && [
                initialDependent
            ]),
            l: new Set()
        };
        mountedMap.set(atom, mounted);
        var atomState = readAtomState(undefined, atom);
        atomState.d.forEach(function(_, a) {
            var aMounted = mountedMap.get(a);
            if (aMounted) aMounted.t.add(atom);
            else if (a !== atom) mountAtom(version, a, atom);
        });
        if (isActuallyWritableAtom(atom) && atom.onMount) {
            var setAtom = function setAtom(update) {
                return writeAtom(atom, update, version);
            };
            var onUnmount = atom.onMount(setAtom);
            version = undefined;
            if (onUnmount) mounted.u = onUnmount;
        }
        return mounted;
    };
    var unmountAtom = function unmountAtom(version, atom) {
        var _mountedMap$get;
        var onUnmount = (_mountedMap$get = mountedMap.get(atom)) == null ? void 0 : _mountedMap$get.u;
        if (onUnmount) onUnmount();
        mountedMap.delete(atom);
        var atomState = getAtomState(version, atom);
        if (atomState) {
            if ("p" in atomState) $051474e5c5a9c9ad$var$cancelSuspensePromise(atomState.p);
            atomState.d.forEach(function(_, a) {
                if (a !== atom) {
                    var mounted = mountedMap.get(a);
                    if (mounted) {
                        mounted.t.delete(atom);
                        if (canUnmountAtom(a, mounted)) unmountAtom(version, a);
                    }
                }
            });
        }
    };
    var mountDependencies = function mountDependencies(version, atom, atomState, prevReadDependencies) {
        var dependencies = new Set(atomState.d.keys());
        prevReadDependencies == null || prevReadDependencies.forEach(function(_, a) {
            if (dependencies.has(a)) {
                dependencies.delete(a);
                return;
            }
            var mounted = mountedMap.get(a);
            if (mounted) {
                mounted.t.delete(atom);
                if (canUnmountAtom(a, mounted)) unmountAtom(version, a);
            }
        });
        dependencies.forEach(function(a) {
            var mounted = mountedMap.get(a);
            if (mounted) mounted.t.add(atom);
            else if (mountedMap.has(atom)) mountAtom(version, a, atom);
        });
    };
    var flushPending = function flushPending(version) {
        if (version) {
            var versionedAtomStateMap = getVersionedAtomStateMap(version);
            versionedAtomStateMap.forEach(function(atomState, atom) {
                var committedAtomState = committedAtomStateMap.get(atom);
                if (atomState !== committedAtomState) {
                    var mounted = mountedMap.get(atom);
                    mounted == null || mounted.l.forEach(function(listener) {
                        return listener(version);
                    });
                }
            });
            return;
        }
        while(pendingMap.size){
            var pending = Array.from(pendingMap);
            pendingMap.clear();
            pending.forEach(function(_ref2) {
                var atom = _ref2[0], prevAtomState = _ref2[1];
                var atomState = getAtomState(undefined, atom);
                if (atomState && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) mountDependencies(undefined, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
                if (prevAtomState && !prevAtomState.y && atomState != null && atomState.y) return;
                var mounted = mountedMap.get(atom);
                mounted == null || mounted.l.forEach(function(listener) {
                    return listener();
                });
            });
        }
    };
    var commitVersionedAtomStateMap = function commitVersionedAtomStateMap(version) {
        var versionedAtomStateMap = getVersionedAtomStateMap(version);
        versionedAtomStateMap.forEach(function(atomState, atom) {
            var prevAtomState = committedAtomStateMap.get(atom);
            if (!prevAtomState || atomState.r > prevAtomState.r || atomState.y !== prevAtomState.y || atomState.r === prevAtomState.r && atomState.d !== prevAtomState.d) {
                committedAtomStateMap.set(atom, atomState);
                if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) mountDependencies(version, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
            }
        });
    };
    var commitAtom = function commitAtom(_atom, version) {
        if (version) commitVersionedAtomStateMap(version);
        flushPending(undefined);
    };
    var subscribeAtom = function subscribeAtom(atom, callback, version) {
        var mounted = addAtom(version, atom);
        var listeners = mounted.l;
        listeners.add(callback);
        return function() {
            listeners.delete(callback);
            delAtom(version, atom);
        };
    };
    var restoreAtoms = function restoreAtoms(values, version) {
        for(var _iterator2 = $051474e5c5a9c9ad$var$_createForOfIteratorHelperLoose(values), _step2; !(_step2 = _iterator2()).done;){
            var _step2$value = _step2.value, _atom2 = _step2$value[0], _value = _step2$value[1];
            if ($051474e5c5a9c9ad$var$hasInitialValue(_atom2)) {
                setAtomPromiseOrValue(version, _atom2, _value);
                invalidateDependents(version, _atom2);
            }
        }
        flushPending(version);
    };
    var _ref3;
    return _ref4 = {}, _ref4[$051474e5c5a9c9ad$var$READ_ATOM] = readAtom, _ref4[$051474e5c5a9c9ad$var$WRITE_ATOM] = writeAtom, _ref4[$051474e5c5a9c9ad$var$COMMIT_ATOM] = commitAtom, _ref4[$051474e5c5a9c9ad$var$SUBSCRIBE_ATOM] = subscribeAtom, _ref4[$051474e5c5a9c9ad$var$RESTORE_ATOMS] = restoreAtoms, _ref4;
};
var $051474e5c5a9c9ad$var$createStoreForExport = function createStoreForExport(initialValues) {
    var store = $051474e5c5a9c9ad$var$createStore(initialValues);
    var get = function get(atom) {
        var atomState = store[$051474e5c5a9c9ad$var$READ_ATOM](atom);
        if ("e" in atomState) throw atomState.e;
        if ("p" in atomState) return undefined;
        return atomState.v;
    };
    var asyncGet = function asyncGet(atom) {
        return new Promise(function(resolve, reject) {
            var atomState = store[$051474e5c5a9c9ad$var$READ_ATOM](atom);
            if ("e" in atomState) reject(atomState.e);
            else if ("p" in atomState) resolve(atomState.p.then(function() {
                return asyncGet(atom);
            }));
            else resolve(atomState.v);
        });
    };
    var set = function set(atom, update) {
        return store[$051474e5c5a9c9ad$var$WRITE_ATOM](atom, update);
    };
    var sub = function sub(atom, callback) {
        return store[$051474e5c5a9c9ad$var$SUBSCRIBE_ATOM](atom, callback);
    };
    return {
        get: get,
        asyncGet: asyncGet,
        set: set,
        sub: sub,
        SECRET_INTERNAL_store: store
    };
};
var $051474e5c5a9c9ad$var$createScopeContainer = function createScopeContainer(initialValues, unstable_createStore) {
    var store = unstable_createStore ? unstable_createStore(initialValues).SECRET_INTERNAL_store : $051474e5c5a9c9ad$var$createStore(initialValues);
    return {
        s: store
    };
};
var $051474e5c5a9c9ad$var$ScopeContextMap = new Map();
var $051474e5c5a9c9ad$var$getScopeContext = function getScopeContext(scope) {
    if (!$051474e5c5a9c9ad$var$ScopeContextMap.has(scope)) $051474e5c5a9c9ad$var$ScopeContextMap.set(scope, $acw62.createContext($051474e5c5a9c9ad$var$createScopeContainer()));
    return $051474e5c5a9c9ad$var$ScopeContextMap.get(scope);
};
var $051474e5c5a9c9ad$var$Provider = function Provider(_ref) {
    var children = _ref.children, initialValues = _ref.initialValues, scope = _ref.scope, unstable_createStore = _ref.unstable_createStore, unstable_enableVersionedWrite = _ref.unstable_enableVersionedWrite;
    var _useState = $acw62.useState({}), version = _useState[0], setVersion = _useState[1];
    $acw62.useEffect(function() {
        var scopeContainer = scopeContainerRef.current;
        if (scopeContainer.w) {
            scopeContainer.s[$051474e5c5a9c9ad$var$COMMIT_ATOM](null, version);
            delete version.p;
            scopeContainer.v = version;
        }
    }, [
        version
    ]);
    var scopeContainerRef = $acw62.useRef();
    if (!scopeContainerRef.current) {
        var scopeContainer = $051474e5c5a9c9ad$var$createScopeContainer(initialValues, unstable_createStore);
        if (unstable_enableVersionedWrite) {
            var retrying = 0;
            scopeContainer.w = function(write) {
                setVersion(function(parentVersion) {
                    var nextVersion = retrying ? parentVersion : {
                        p: parentVersion
                    };
                    write(nextVersion);
                    return nextVersion;
                });
            };
            scopeContainer.v = version;
            scopeContainer.r = function(fn) {
                ++retrying;
                fn();
                --retrying;
            };
        }
        scopeContainerRef.current = scopeContainer;
    }
    var ScopeContainerContext = $051474e5c5a9c9ad$var$getScopeContext(scope);
    return $acw62.createElement(ScopeContainerContext.Provider, {
        value: scopeContainerRef.current
    }, children);
};
function $051474e5c5a9c9ad$var$atom(read, write) {
    return $5fc7457900d13db1$export$5fb5cc0d078610b(read, write);
}
function $051474e5c5a9c9ad$var$useAtomValue(atom, scope) {
    var ScopeContext = $051474e5c5a9c9ad$var$getScopeContext(scope);
    var scopeContainer = $acw62.useContext(ScopeContext);
    var store = scopeContainer.s, versionFromProvider = scopeContainer.v;
    var getAtomValue = function getAtomValue(version) {
        var atomState = store[$051474e5c5a9c9ad$var$READ_ATOM](atom, version);
        if ("e" in atomState) throw atomState.e;
        if ("p" in atomState) throw atomState.p;
        if ("v" in atomState) return atomState.v;
        throw new Error("no atom value");
    };
    var _useReducer = $acw62.useReducer(function(prev, nextVersion) {
        var nextValue = getAtomValue(nextVersion);
        if (Object.is(prev[1], nextValue) && prev[2] === atom) return prev;
        return [
            nextVersion,
            nextValue,
            atom
        ];
    }, versionFromProvider, function(initialVersion) {
        var initialValue = getAtomValue(initialVersion);
        return [
            initialVersion,
            initialValue,
            atom
        ];
    }), _useReducer$ = _useReducer[0], version = _useReducer$[0], valueFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerenderIfChanged = _useReducer[1];
    var value = valueFromReducer;
    if (atomFromReducer !== atom) {
        rerenderIfChanged(version);
        value = getAtomValue(version);
    }
    $acw62.useEffect(function() {
        var versionFromProvider = scopeContainer.v;
        if (versionFromProvider) store[$051474e5c5a9c9ad$var$COMMIT_ATOM](atom, versionFromProvider);
        var unsubscribe = store[$051474e5c5a9c9ad$var$SUBSCRIBE_ATOM](atom, rerenderIfChanged, versionFromProvider);
        rerenderIfChanged(versionFromProvider);
        return unsubscribe;
    }, [
        store,
        atom,
        scopeContainer
    ]);
    $acw62.useEffect(function() {
        store[$051474e5c5a9c9ad$var$COMMIT_ATOM](atom, version);
    });
    $acw62.useDebugValue(value);
    return value;
}
function $051474e5c5a9c9ad$var$useSetAtom(atom, scope) {
    var ScopeContext = $051474e5c5a9c9ad$var$getScopeContext(scope);
    var _useContext = $acw62.useContext(ScopeContext), store = _useContext.s, versionedWrite = _useContext.w;
    var setAtom = $acw62.useCallback(function(update) {
        var write = function write(version) {
            return store[$051474e5c5a9c9ad$var$WRITE_ATOM](atom, update, version);
        };
        return versionedWrite ? versionedWrite(write) : write();
    }, [
        store,
        versionedWrite,
        atom
    ]);
    return setAtom;
}
function $051474e5c5a9c9ad$var$useAtom(atom, scope) {
    if ("scope" in atom) {
        console.warn("atom.scope is deprecated. Please do useAtom(atom, scope) instead.");
        scope = atom.scope;
    }
    return [
        $051474e5c5a9c9ad$var$useAtomValue(atom, scope),
        $051474e5c5a9c9ad$var$useSetAtom(atom, scope)
    ];
}
$051474e5c5a9c9ad$export$2881499e37b75b9a = $051474e5c5a9c9ad$var$Provider;
$051474e5c5a9c9ad$export$e1d2347eb3f70fd3 = $051474e5c5a9c9ad$var$getScopeContext;
$051474e5c5a9c9ad$export$a8d36bcf35bd31bd = $051474e5c5a9c9ad$var$registerPromiseAbort;
$051474e5c5a9c9ad$export$5fb5cc0d078610b = $051474e5c5a9c9ad$var$atom;
$051474e5c5a9c9ad$export$239265d4179d81b3 = $051474e5c5a9c9ad$var$createStoreForExport;
$051474e5c5a9c9ad$export$83cf7ae8bb57e7ed = $051474e5c5a9c9ad$var$useAtom;
$051474e5c5a9c9ad$export$89a40582f8c436cc = $051474e5c5a9c9ad$var$useAtomValue;
$051474e5c5a9c9ad$export$a247c952d39ea7ea = $051474e5c5a9c9ad$var$useSetAtom;



function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $acw62 = parcelRequire("acw62");
function $e0f75533c8da79e2$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($06dbdeafb212d82f$export$43e446d32b3d21af(...refs), refs);
}



var $acw62 = parcelRequire("acw62");
function $a27e3b74a1e4b413$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$2fad294522b5ed20$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $06dbdeafb212d82f$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $2fad294522b5ed20$export$d9f1ccf0bdb05d45;
}
function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $2fad294522b5ed20$export$be92b6f5f03c0fe9 = $2fad294522b5ed20$export$8c6ed5c666ac1360;


const $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$250ffa63cdc0d034 = $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $2fad294522b5ed20$export$8c6ed5c666ac1360) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $ffa305e20fe06c82$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $11492dca620dcaa5$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$be92b6f5f03c0fe9 = $ffa305e20fe06c82$export$250ffa63cdc0d034;




var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $6421c5b6e6501f6d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $acw62 = parcelRequire("acw62");

/**
 * Listens for when the escape key is down
 */ function $c502a0c80a589ede$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $934b33b1070542f6$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $934b33b1070542f6$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $934b33b1070542f6$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $934b33b1070542f6$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $acw62.useContext)($934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $acw62.useState)({});
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $934b33b1070542f6$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $934b33b1070542f6$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $c502a0c80a589ede$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $acw62.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $934b33b1070542f6$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($934b33b1070542f6$export$177fb62ff3ec1f22, {
    displayName: $934b33b1070542f6$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $934b33b1070542f6$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $934b33b1070542f6$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = (0, $acw62.useContext)($934b33b1070542f6$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($934b33b1070542f6$export$4d5eb2109db14228, {
    displayName: $934b33b1070542f6$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $934b33b1070542f6$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $acw62.useRef)(false);
    const handleClickRef = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $934b33b1070542f6$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $934b33b1070542f6$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($934b33b1070542f6$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $934b33b1070542f6$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $ffa305e20fe06c82$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $934b33b1070542f6$export$be92b6f5f03c0fe9 = $934b33b1070542f6$export$177fb62ff3ec1f22;
const $934b33b1070542f6$export$aecb2ddcb55c95be = $934b33b1070542f6$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");
/** Number of components which have requested interest to have focus guards */ let $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$count = 0;
function $8fdc5d26108cccc8$export$ac5b58043b79449b(props) {
    $8fdc5d26108cccc8$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $8fdc5d26108cccc8$export$b7ece24a22aeda8c() {
    (0, $acw62.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $8fdc5d26108cccc8$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $8fdc5d26108cccc8$export$be92b6f5f03c0fe9 = $8fdc5d26108cccc8$export$ac5b58043b79449b;




var $acw62 = parcelRequire("acw62");



const $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $d52e479a4b6ab6b0$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $acw62.useState)(null);
    const onMountAutoFocus = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $acw62.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $acw62.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $acw62.useEffect)(()=>{
        if (container1) {
            $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focusFirst($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$removeLinks($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($d52e479a4b6ab6b0$export$20e40289641fbbb6, {
    displayName: $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$focusScopesStack = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $d52e479a4b6ab6b0$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $d52e479a4b6ab6b0$export$be92b6f5f03c0fe9 = $d52e479a4b6ab6b0$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b37fe3d39d956993$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};


const $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId = $acw62["useId".toString()] || (()=>undefined);
let $f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count = 0;
function $f3afa084f31a11ef$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($f3afa084f31a11ef$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $acw62 = parcelRequire("acw62");
function $99d14ddb65d238cd$var$getSide(placement) {
    return placement.split("-")[0];
}
function $99d14ddb65d238cd$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($99d14ddb65d238cd$var$getSide(placement)) ? "x" : "y";
}
function $99d14ddb65d238cd$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $99d14ddb65d238cd$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement);
    const length = $99d14ddb65d238cd$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $99d14ddb65d238cd$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($99d14ddb65d238cd$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $99d14ddb65d238cd$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    var _ref;
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $99d14ddb65d238cd$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < middleware.length; i++){
        const { name: name, fn: fn } = middleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $99d14ddb65d238cd$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $99d14ddb65d238cd$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $99d14ddb65d238cd$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $99d14ddb65d238cd$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $99d14ddb65d238cd$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = middlewareArguments;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = options;
    const paddingObject = $99d14ddb65d238cd$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $99d14ddb65d238cd$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const elementClientRect = $99d14ddb65d238cd$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: elementContext === "floating" ? {
            ...rects.floating,
            x: x,
            y: y
        } : rects.reference,
        offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
        strategy: strategy
    }) : rects[elementContext]);
    return {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
}
const $99d14ddb65d238cd$var$min = Math.min;
const $99d14ddb65d238cd$var$max = Math.max;
function $99d14ddb65d238cd$var$within(min$1, value, max$1) {
    return $99d14ddb65d238cd$var$max(min$1, $99d14ddb65d238cd$var$min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $99d14ddb65d238cd$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (middlewareArguments) {
            // Since `element` is required, we don't Partial<> the type
            const { element: element, padding: padding = 0 } = options != null ? options : {};
            const { x: x, y: y, placement: placement, rects: rects, platform: platform } = middlewareArguments;
            if (element == null) return {};
            const paddingObject = $99d14ddb65d238cd$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement);
            const alignment = $99d14ddb65d238cd$var$getAlignment(placement);
            const length = $99d14ddb65d238cd$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const minProp = axis === "y" ? "top" : "left";
            const maxProp = axis === "y" ? "bottom" : "right";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
            if (clientSize === 0) clientSize = rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $99d14ddb65d238cd$var$within(min, center, max); // Make sure that arrow points at the reference
            const alignmentPadding = alignment === "start" ? paddingObject[minProp] : paddingObject[maxProp];
            const shouldAddOffset = alignmentPadding > 0 && center !== offset && rects.reference[length] <= rects.floating[length];
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $99d14ddb65d238cd$var$hash$1 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $99d14ddb65d238cd$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (matched)=>$99d14ddb65d238cd$var$hash$1[matched]);
}
function $99d14ddb65d238cd$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $99d14ddb65d238cd$var$getAlignment(placement);
    const mainAxis = $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement);
    const length = $99d14ddb65d238cd$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $99d14ddb65d238cd$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $99d14ddb65d238cd$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $99d14ddb65d238cd$var$hash = {
    start: "end",
    end: "start"
};
function $99d14ddb65d238cd$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (matched)=>$99d14ddb65d238cd$var$hash[matched]);
}
const $99d14ddb65d238cd$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $99d14ddb65d238cd$var$allPlacements = /*#__PURE__*/ $99d14ddb65d238cd$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
function $99d14ddb65d238cd$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$99d14ddb65d238cd$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$99d14ddb65d238cd$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$99d14ddb65d238cd$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $99d14ddb65d238cd$var$getAlignment(placement) === alignment || (autoAlignment ? $99d14ddb65d238cd$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $99d14ddb65d238cd$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$autoP, _middlewareData$autoP2, _middlewareData$autoP3, _middlewareData$autoP4, _placementsSortedByLe;
            const { x: x, y: y, rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = middlewareArguments;
            const { alignment: alignment = null, allowedPlacements: allowedPlacements = $99d14ddb65d238cd$var$allPlacements, autoAlignment: autoAlignment = true, ...detectOverflowOptions } = options;
            const placements = $99d14ddb65d238cd$var$getPlacementList(alignment, autoAlignment, allowedPlacements);
            const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const currentIndex = (_middlewareData$autoP = (_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.index) != null ? _middlewareData$autoP : 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main, cross: cross } = $99d14ddb65d238cd$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))); // Make `computeCoords` start from the right place
            if (placement !== currentPlacement) return {
                x: x,
                y: y,
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$99d14ddb65d238cd$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...(_middlewareData$autoP3 = (_middlewareData$autoP4 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP4.overflows) != null ? _middlewareData$autoP3 : [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1]; // There are more placements to check
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b)=>a.overflows[0] - b.overflows[0]);
            const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find((_ref)=>{
                let { overflows: overflows } = _ref;
                return overflows.every((overflow)=>overflow <= 0);
            })) == null ? void 0 : _placementsSortedByLe.placement;
            const resetPlacement = placementThatFitsOnAllSides != null ? placementThatFitsOnAllSides : placementsSortedByLeastOverflow[0].placement;
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $99d14ddb65d238cd$var$getExpandedPlacements(placement) {
    const oppositePlacement = $99d14ddb65d238cd$var$getOppositePlacement(placement);
    return [
        $99d14ddb65d238cd$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $99d14ddb65d238cd$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */ const $99d14ddb65d238cd$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = options;
            const side = $99d14ddb65d238cd$var$getSide(placement);
            const isBasePlacement = side === initialPlacement;
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $99d14ddb65d238cd$var$getOppositePlacement(initialPlacement)
            ] : $99d14ddb65d238cd$var$getExpandedPlacements(initialPlacement));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main, cross: cross } = $99d14ddb65d238cd$var$getAlignmentSides(placement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ]; // One or more sides is overflowing
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip$, _middlewareData$flip2;
                const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = "bottom";
                switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $99d14ddb65d238cd$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $99d14ddb65d238cd$var$isAnySideFullyClipped(overflow) {
    return $99d14ddb65d238cd$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $99d14ddb65d238cd$export$fe8985bb6374093c = function(_temp) {
    let { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = _temp === void 0 ? {} : _temp;
    return {
        name: "hide",
        async fn (middlewareArguments) {
            const { rects: rects } = middlewareArguments;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $99d14ddb65d238cd$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $99d14ddb65d238cd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $99d14ddb65d238cd$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $99d14ddb65d238cd$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
async function $99d14ddb65d238cd$var$convertValueToCoords(middlewareArguments, value) {
    const { placement: placement, platform: platform, elements: elements } = middlewareArguments;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $99d14ddb65d238cd$var$getSide(placement);
    const alignment = $99d14ddb65d238cd$var$getAlignment(placement);
    const isVertical = $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(middlewareArguments) : value; // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */ const $99d14ddb65d238cd$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (middlewareArguments) {
            const { x: x, y: y } = middlewareArguments;
            const diffCoords = await $99d14ddb65d238cd$var$convertValueToCoords(middlewareArguments, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $99d14ddb65d238cd$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $99d14ddb65d238cd$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (middlewareArguments) {
            const { x: x, y: y, placement: placement } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const mainAxis = $99d14ddb65d238cd$var$getMainAxisFromPlacement($99d14ddb65d238cd$var$getSide(placement));
            const crossAxis = $99d14ddb65d238cd$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $99d14ddb65d238cd$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $99d14ddb65d238cd$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...middlewareArguments,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $99d14ddb65d238cd$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (middlewareArguments) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = middlewareArguments;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $99d14ddb65d238cd$var$getMainAxisFromPlacement(placement);
            const crossAxis = $99d14ddb65d238cd$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset({
                ...rects,
                placement: placement
            }) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($99d14ddb65d238cd$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */ const $99d14ddb65d238cd$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = middlewareArguments;
            const { apply: apply, ...detectOverflowOptions } = options;
            const overflow = await $99d14ddb65d238cd$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const side = $99d14ddb65d238cd$var$getSide(placement);
            const alignment = $99d14ddb65d238cd$var$getAlignment(placement);
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const xMin = $99d14ddb65d238cd$var$max(overflow.left, 0);
            const xMax = $99d14ddb65d238cd$var$max(overflow.right, 0);
            const yMin = $99d14ddb65d238cd$var$max(overflow.top, 0);
            const yMax = $99d14ddb65d238cd$var$max(overflow.bottom, 0);
            const dimensions = {
                availableHeight: rects.floating.height - ([
                    "left",
                    "right"
                ].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $99d14ddb65d238cd$var$max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                availableWidth: rects.floating.width - ([
                    "top",
                    "bottom"
                ].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $99d14ddb65d238cd$var$max(overflow.left, overflow.right)) : overflow[widthSide])
            };
            const prevDimensions = await platform.getDimensions(elements.floating);
            apply == null || apply({
                ...middlewareArguments,
                ...dimensions
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (prevDimensions.width !== nextDimensions.width || prevDimensions.height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $99d14ddb65d238cd$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (middlewareArguments) {
            var _await$platform$getCl;
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = middlewareArguments; // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = options;
            const fallback = $99d14ddb65d238cd$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                rect: rects.reference,
                offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
                strategy: strategy
            }) : rects.reference);
            const clientRects = (_await$platform$getCl = await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) != null ? _await$platform$getCl : [];
            const paddingObject = $99d14ddb65d238cd$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
                    var _clientRects$find;
                    // Find the first rect in which the point is fully inside
                    return (_clientRects$find = clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom)) != null ? _clientRects$find : fallback;
                } // There are 2 or more connected rects
                if (clientRects.length >= 2) {
                    if ($99d14ddb65d238cd$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $99d14ddb65d238cd$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $99d14ddb65d238cd$var$getSide(placement) === "left";
                    const maxRight = $99d14ddb65d238cd$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $99d14ddb65d238cd$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};


function $36155bd4f6d209d1$var$isWindow(value) {
    return value && value.document && value.location && value.alert && value.setInterval;
}
function $36155bd4f6d209d1$var$getWindow(node) {
    if (node == null) return window;
    if (!$36155bd4f6d209d1$var$isWindow(node)) {
        const ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function $36155bd4f6d209d1$var$getComputedStyle$1(element) {
    return $36155bd4f6d209d1$var$getWindow(element).getComputedStyle(element);
}
function $36155bd4f6d209d1$var$getNodeName(node) {
    return $36155bd4f6d209d1$var$isWindow(node) ? "" : node ? (node.nodeName || "").toLowerCase() : "";
}
function $36155bd4f6d209d1$var$getUAString() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map((item)=>item.brand + "/" + item.version).join(" ");
    return navigator.userAgent;
}
function $36155bd4f6d209d1$var$isHTMLElement(value) {
    return value instanceof $36155bd4f6d209d1$var$getWindow(value).HTMLElement;
}
function $36155bd4f6d209d1$var$isElement(value) {
    return value instanceof $36155bd4f6d209d1$var$getWindow(value).Element;
}
function $36155bd4f6d209d1$var$isNode(value) {
    return value instanceof $36155bd4f6d209d1$var$getWindow(value).Node;
}
function $36155bd4f6d209d1$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $36155bd4f6d209d1$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $36155bd4f6d209d1$var$isOverflowElement(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = $36155bd4f6d209d1$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $36155bd4f6d209d1$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($36155bd4f6d209d1$var$getNodeName(element));
}
function $36155bd4f6d209d1$var$isContainingBlock(element) {
    // TODO: Try and use feature detection here instead
    const isFirefox = /firefox/i.test($36155bd4f6d209d1$var$getUAString());
    const css = $36155bd4f6d209d1$var$getComputedStyle$1(element); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || // @ts-ignore (TS 4.1 compat)
    css.contain === "paint" || [
        "transform",
        "perspective"
    ].includes(css.willChange) || isFirefox && css.willChange === "filter" || isFirefox && (css.filter ? css.filter !== "none" : false);
}
function $36155bd4f6d209d1$var$isLayoutViewport() {
    // Not Safari
    return !/^((?!chrome|android).)*safari/i.test($36155bd4f6d209d1$var$getUAString()); // Feature detection for this fails in various ways
// • Always-visible scrollbar or not
// • Width of <html>, etc.
// const vV = win.visualViewport;
// return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}
const $36155bd4f6d209d1$var$min = Math.min;
const $36155bd4f6d209d1$var$max = Math.max;
const $36155bd4f6d209d1$var$round = Math.round;
function $36155bd4f6d209d1$var$getBoundingClientRect(element, includeScale, isFixedStrategy) {
    var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    let scaleX = 1;
    let scaleY = 1;
    if (includeScale && $36155bd4f6d209d1$var$isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? $36155bd4f6d209d1$var$round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? $36155bd4f6d209d1$var$round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    const win = $36155bd4f6d209d1$var$isElement(element) ? $36155bd4f6d209d1$var$getWindow(element) : window;
    const addVisualOffsets = !$36155bd4f6d209d1$var$isLayoutViewport() && isFixedStrategy;
    const x = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
    const y = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
    const width = clientRect.width / scaleX;
    const height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $36155bd4f6d209d1$var$getDocumentElement(node) {
    return (($36155bd4f6d209d1$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $36155bd4f6d209d1$var$getNodeScroll(element) {
    if ($36155bd4f6d209d1$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $36155bd4f6d209d1$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $36155bd4f6d209d1$var$getBoundingClientRect($36155bd4f6d209d1$var$getDocumentElement(element)).left + $36155bd4f6d209d1$var$getNodeScroll(element).scrollLeft;
}
function $36155bd4f6d209d1$var$isScaled(element) {
    const rect = $36155bd4f6d209d1$var$getBoundingClientRect(element);
    return $36155bd4f6d209d1$var$round(rect.width) !== element.offsetWidth || $36155bd4f6d209d1$var$round(rect.height) !== element.offsetHeight;
}
function $36155bd4f6d209d1$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $36155bd4f6d209d1$var$isHTMLElement(offsetParent);
    const documentElement = $36155bd4f6d209d1$var$getDocumentElement(offsetParent);
    const rect = $36155bd4f6d209d1$var$getBoundingClientRect(element, isOffsetParentAnElement && $36155bd4f6d209d1$var$isScaled(offsetParent), strategy === "fixed");
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($36155bd4f6d209d1$var$getNodeName(offsetParent) !== "body" || $36155bd4f6d209d1$var$isOverflowElement(documentElement)) scroll = $36155bd4f6d209d1$var$getNodeScroll(offsetParent);
        if ($36155bd4f6d209d1$var$isHTMLElement(offsetParent)) {
            const offsetRect = $36155bd4f6d209d1$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $36155bd4f6d209d1$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $36155bd4f6d209d1$var$getParentNode(node) {
    if ($36155bd4f6d209d1$var$getNodeName(node) === "html") return node;
    return(// @ts-ignore
    node.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    node.parentNode || ($36155bd4f6d209d1$var$isShadowRoot(node) ? node.host : null) || // ShadowRoot detected
    $36155bd4f6d209d1$var$getDocumentElement(node) // fallback
    );
}
function $36155bd4f6d209d1$var$getTrueOffsetParent(element) {
    if (!$36155bd4f6d209d1$var$isHTMLElement(element) || getComputedStyle(element).position === "fixed") return null;
    return element.offsetParent;
}
function $36155bd4f6d209d1$var$getContainingBlock(element) {
    let currentNode = $36155bd4f6d209d1$var$getParentNode(element);
    if ($36155bd4f6d209d1$var$isShadowRoot(currentNode)) currentNode = currentNode.host;
    while($36155bd4f6d209d1$var$isHTMLElement(currentNode) && ![
        "html",
        "body"
    ].includes($36155bd4f6d209d1$var$getNodeName(currentNode))){
        if ($36155bd4f6d209d1$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $36155bd4f6d209d1$var$getOffsetParent(element) {
    const window1 = $36155bd4f6d209d1$var$getWindow(element);
    let offsetParent = $36155bd4f6d209d1$var$getTrueOffsetParent(element);
    while(offsetParent && $36155bd4f6d209d1$var$isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static")offsetParent = $36155bd4f6d209d1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($36155bd4f6d209d1$var$getNodeName(offsetParent) === "html" || $36155bd4f6d209d1$var$getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static" && !$36155bd4f6d209d1$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $36155bd4f6d209d1$var$getContainingBlock(element) || window1;
}
function $36155bd4f6d209d1$var$getDimensions(element) {
    if ($36155bd4f6d209d1$var$isHTMLElement(element)) return {
        width: element.offsetWidth,
        height: element.offsetHeight
    };
    const rect = $36155bd4f6d209d1$var$getBoundingClientRect(element);
    return {
        width: rect.width,
        height: rect.height
    };
}
function $36155bd4f6d209d1$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $36155bd4f6d209d1$var$isHTMLElement(offsetParent);
    const documentElement = $36155bd4f6d209d1$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($36155bd4f6d209d1$var$getNodeName(offsetParent) !== "body" || $36155bd4f6d209d1$var$isOverflowElement(documentElement)) scroll = $36155bd4f6d209d1$var$getNodeScroll(offsetParent);
        if ($36155bd4f6d209d1$var$isHTMLElement(offsetParent)) {
            const offsetRect = $36155bd4f6d209d1$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } // This doesn't appear to be need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }
    }
    return {
        ...rect,
        x: rect.x - scroll.scrollLeft + offsets.x,
        y: rect.y - scroll.scrollTop + offsets.y
    };
}
function $36155bd4f6d209d1$var$getViewportRect(element, strategy) {
    const win = $36155bd4f6d209d1$var$getWindow(element);
    const html = $36155bd4f6d209d1$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const layoutViewport = $36155bd4f6d209d1$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $36155bd4f6d209d1$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    const html = $36155bd4f6d209d1$var$getDocumentElement(element);
    const scroll = $36155bd4f6d209d1$var$getNodeScroll(element);
    const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    const width = $36155bd4f6d209d1$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    const height = $36155bd4f6d209d1$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    let x = -scroll.scrollLeft + $36155bd4f6d209d1$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($36155bd4f6d209d1$var$getComputedStyle$1(body || html).direction === "rtl") x += $36155bd4f6d209d1$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $36155bd4f6d209d1$var$getNearestOverflowAncestor(node) {
    const parentNode = $36155bd4f6d209d1$var$getParentNode(node);
    if ([
        "html",
        "body",
        "#document"
    ].includes($36155bd4f6d209d1$var$getNodeName(parentNode))) // @ts-ignore assume body is always available
    return node.ownerDocument.body;
    if ($36155bd4f6d209d1$var$isHTMLElement(parentNode) && $36155bd4f6d209d1$var$isOverflowElement(parentNode)) return parentNode;
    return $36155bd4f6d209d1$var$getNearestOverflowAncestor(parentNode);
}
function $36155bd4f6d209d1$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $36155bd4f6d209d1$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $36155bd4f6d209d1$var$getWindow(scrollableAncestor);
    const target = isBody ? [
        win
    ].concat(win.visualViewport || [], $36155bd4f6d209d1$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
    const updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($36155bd4f6d209d1$export$3b57c1601291186b(target));
}
function $36155bd4f6d209d1$var$contains(parent, child) {
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && $36155bd4f6d209d1$var$isShadowRoot(rootNode)) {
        let next = child;
        do {
            // use `===` replace node.isSameNode()
            if (next && parent === next) return true;
             // @ts-ignore: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    }
    return false;
}
function $36155bd4f6d209d1$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $36155bd4f6d209d1$var$getBoundingClientRect(element, false, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    return {
        top: top,
        left: left,
        x: left,
        y: top,
        right: left + element.clientWidth,
        bottom: top + element.clientHeight,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $36155bd4f6d209d1$var$getClientRectFromClippingAncestor(element, clippingParent, strategy) {
    if (clippingParent === "viewport") return (0, $99d14ddb65d238cd$export$ee05aea0aeecbad4)($36155bd4f6d209d1$var$getViewportRect(element, strategy));
    if ($36155bd4f6d209d1$var$isElement(clippingParent)) return $36155bd4f6d209d1$var$getInnerBoundingClientRect(clippingParent, strategy);
    return (0, $99d14ddb65d238cd$export$ee05aea0aeecbad4)($36155bd4f6d209d1$var$getDocumentRect($36155bd4f6d209d1$var$getDocumentElement(element)));
} // A "clipping ancestor" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $36155bd4f6d209d1$var$getClippingAncestors(element) {
    const clippingAncestors = $36155bd4f6d209d1$export$3b57c1601291186b(element);
    const canEscapeClipping = [
        "absolute",
        "fixed"
    ].includes($36155bd4f6d209d1$var$getComputedStyle$1(element).position);
    const clipperElement = canEscapeClipping && $36155bd4f6d209d1$var$isHTMLElement(element) ? $36155bd4f6d209d1$var$getOffsetParent(element) : element;
    if (!$36155bd4f6d209d1$var$isElement(clipperElement)) return [];
     // @ts-ignore isElement check ensures we return Array<Element>
    return clippingAncestors.filter((clippingAncestors)=>$36155bd4f6d209d1$var$isElement(clippingAncestors) && $36155bd4f6d209d1$var$contains(clippingAncestors, clipperElement) && $36155bd4f6d209d1$var$getNodeName(clippingAncestors) !== "body");
} // Gets the maximum area that the element is visible in due to any number of
// clipping ancestors
function $36155bd4f6d209d1$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const mainClippingAncestors = boundary === "clippingAncestors" ? $36155bd4f6d209d1$var$getClippingAncestors(element) : [].concat(boundary);
    const clippingAncestors = [
        ...mainClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $36155bd4f6d209d1$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $36155bd4f6d209d1$var$max(rect.top, accRect.top);
        accRect.right = $36155bd4f6d209d1$var$min(rect.right, accRect.right);
        accRect.bottom = $36155bd4f6d209d1$var$min(rect.bottom, accRect.bottom);
        accRect.left = $36155bd4f6d209d1$var$max(rect.left, accRect.left);
        return accRect;
    }, $36155bd4f6d209d1$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
const $36155bd4f6d209d1$var$platform = {
    getClippingRect: $36155bd4f6d209d1$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $36155bd4f6d209d1$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $36155bd4f6d209d1$var$isElement,
    getDimensions: $36155bd4f6d209d1$var$getDimensions,
    getOffsetParent: $36155bd4f6d209d1$var$getOffsetParent,
    getDocumentElement: $36155bd4f6d209d1$var$getDocumentElement,
    getElementRects: (_ref)=>{
        let { reference: reference, floating: floating, strategy: strategy } = _ref;
        return {
            reference: $36155bd4f6d209d1$var$getRectRelativeToOffsetParent(reference, $36155bd4f6d209d1$var$getOffsetParent(floating), strategy),
            floating: {
                ...$36155bd4f6d209d1$var$getDimensions(floating),
                x: 0,
                y: 0
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$36155bd4f6d209d1$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $36155bd4f6d209d1$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: _ancestorScroll = true, ancestorResize: _ancestorResize = true, elementResize: elementResize = true, animationFrame: animationFrame = false } = options;
    const ancestorScroll = _ancestorScroll && !animationFrame;
    const ancestorResize = _ancestorResize && !animationFrame;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$36155bd4f6d209d1$var$isElement(reference) ? $36155bd4f6d209d1$export$3b57c1601291186b(reference) : [],
        ...$36155bd4f6d209d1$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        let initialUpdate = true;
        observer = new ResizeObserver(()=>{
            if (!initialUpdate) update();
            initialUpdate = false;
        });
        $36155bd4f6d209d1$var$isElement(reference) && !animationFrame && observer.observe(reference);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $36155bd4f6d209d1$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $36155bd4f6d209d1$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $36155bd4f6d209d1$export$48a53dcb22e581d0 = (reference, floating, options)=>(0, $99d14ddb65d238cd$export$48a53dcb22e581d0)(reference, floating, {
        platform: $36155bd4f6d209d1$var$platform,
        ...options
    });



var $acw62 = parcelRequire("acw62");

var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(_temp) {
    let { middleware: middleware, placement: placement = "bottom", strategy: strategy = "absolute", whileElementsMounted: whileElementsMounted } = _temp === void 0 ? {} : _temp;
    const reference = $acw62.useRef(null);
    const floating = $acw62.useRef(null);
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const cleanupRef = $acw62.useRef(null);
    const [data, setData] = $acw62.useState({
        // Setting these to `null` will allow the consumer to determine if
        // `computePosition()` has run yet
        x: null,
        y: null,
        strategy: strategy,
        placement: placement,
        middlewareData: {}
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref)=>{
        let { options: options } = _ref;
        return options;
    }), middleware == null ? void 0 : middleware.map((_ref2)=>{
        let { options: options } = _ref2;
        return options;
    }))) setLatestMiddleware(middleware);
    const update = $acw62.useCallback(()=>{
        if (!reference.current || !floating.current) return;
        (0, $36155bd4f6d209d1$export$48a53dcb22e581d0)(reference.current, floating.current, {
            middleware: latestMiddleware,
            placement: placement,
            strategy: strategy
        }).then((data)=>{
            if (isMountedRef.current) $11492dca620dcaa5$exports.flushSync(()=>{
                setData(data);
            });
        });
    }, [
        latestMiddleware,
        placement,
        strategy
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        // Skip first update
        if (isMountedRef.current) update();
    }, [
        update
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const runElementMountCallback = $acw62.useCallback(()=>{
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (reference.current && floating.current) {
            if (whileElementsMountedRef.current) {
                const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
                cleanupRef.current = cleanupFn;
            } else update();
        }
    }, [
        update,
        whileElementsMountedRef
    ]);
    const setReference = $acw62.useCallback((node)=>{
        reference.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const setFloating = $acw62.useCallback((node)=>{
        floating.current = node;
        runElementMountCallback();
    }, [
        runElementMountCallback
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: reference,
            floating: floating
        }), []);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            reference: setReference,
            floating: setFloating
        }), [
        data,
        update,
        refs,
        setReference,
        setFloating
    ]);
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    const { element: element, padding: padding } = options;
    function isRef(value) {
        return Object.prototype.hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (args) {
            if (isRef(element)) {
                if (element.current != null) return (0, $99d14ddb65d238cd$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(args);
                return {};
            } else if (element) return (0, $99d14ddb65d238cd$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(args);
            return {};
        }
    };
};




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $8f56a07a0f827cef$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $8f56a07a0f827cef$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $acw62.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($8f56a07a0f827cef$export$21b07c8f274aebd5, {
    displayName: $8f56a07a0f827cef$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8f56a07a0f827cef$export$be92b6f5f03c0fe9 = $8f56a07a0f827cef$export$21b07c8f274aebd5;








var $acw62 = parcelRequire("acw62");

function $cb5e472331db9c97$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $acw62.useState)(undefined);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $b44af8157e52e192$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $b44af8157e52e192$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext, $b44af8157e52e192$export$722aac194ae923] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $b44af8157e52e192$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$badac9ada3a0bdf9, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $b44af8157e52e192$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$ecd4e1ccab6ed6d, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$useContentContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePositionContext] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$createPopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, {
    hasParent: false,
    positionUpdateFns: new Set()
});
const $b44af8157e52e192$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, avoidCollisions: avoidCollisions = true, onPlaced: onPlaced, ...contentProps } = props;
    const context = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePopperContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $acw62.useState)(null);
    const arrowSize = (0, $cb5e472331db9c97$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { reference: reference, floating: floating, strategy: strategy, x: x, y: y, placement: placement, middlewareData: middlewareData, update: update } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (0, $36155bd4f6d209d1$export$deee3a793edee05f),
        middleware: [
            $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$anchorCssProperties(),
            (0, $99d14ddb65d238cd$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions ? (0, $99d14ddb65d238cd$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $99d14ddb65d238cd$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }) : undefined,
            arrow ? (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }) : undefined,
            avoidCollisions ? (0, $99d14ddb65d238cd$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }) : undefined,
            (0, $99d14ddb65d238cd$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, availableWidth: width, availableHeight: height })=>{
                    elements.floating.style.setProperty("--radix-popper-available-width", `${width}px`);
                    elements.floating.style.setProperty("--radix-popper-available-height", `${height}px`);
                }
            }),
            $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached ? (0, $99d14ddb65d238cd$export$fe8985bb6374093c)({
                strategy: "referenceHidden"
            }) : undefined
        ].filter($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isDefined)
    }); // assign the reference dynamically once `Content` has mounted so we can collocate the logic
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        reference(context.anchor);
    }, [
        reference,
        context.anchor
    ]);
    const isPlaced = x !== null && y !== null;
    const [placedSide, placedAlign] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (isPlaced) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPlaced,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const { hasParent: hasParent, positionUpdateFns: positionUpdateFns } = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$usePositionContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const isRoot = !hasParent;
    (0, $acw62.useLayoutEffect)(()=>{
        if (!isRoot) {
            positionUpdateFns.add(update);
            return ()=>{
                positionUpdateFns.delete(update);
            };
        }
    }, [
        isRoot,
        positionUpdateFns,
        update
    ]); // when nested contents are rendered in portals, they are appended out of order causing
    // children to be positioned incorrectly if initially open.
    // we need to re-compute the positioning once the parent has finally been placed.
    // https://github.com/floating-ui/floating-ui/issues/1531
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach((fn)=>requestAnimationFrame(fn));
    }, [
        isRoot,
        isPlaced,
        positionUpdateFns
    ]);
    const commonProps = {
        "data-side": placedSide,
        "data-align": placedAlign,
        ...contentProps,
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    };
    return /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: floating,
        "data-radix-popper-content-wrapper": "",
        style: {
            position: strategy,
            left: 0,
            top: 0,
            transform: isPlaced ? `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)` : "translate3d(0, -200%, 0)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, isRoot ? /*#__PURE__*/ (0, $acw62.createElement)($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$PositionContextProvider, {
        scope: __scopePopper,
        hasParent: true,
        positionUpdateFns: positionUpdateFns
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, commonProps)) : /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, commonProps)));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$bc4ae5855d3c4fc, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $b44af8157e52e192$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$useContentContext($b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $acw62.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $8f56a07a0f827cef$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($b44af8157e52e192$export$79d62cd4e10a3fd0, {
    displayName: $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isDefined(value) {
    return value !== undefined;
}
function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$anchorCssProperties = ()=>({
        name: "anchorCssProperties",
        fn (data) {
            const { rects: rects, elements: elements } = data;
            const { width: width, height: height } = rects.reference;
            elements.floating.style.setProperty("--radix-popper-anchor-width", `${width}px`);
            elements.floating.style.setProperty("--radix-popper-anchor-height", `${height}px`);
            return {};
        }
    });
const $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $b44af8157e52e192$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $b44af8157e52e192$export$be92b6f5f03c0fe9 = $b44af8157e52e192$export$badac9ada3a0bdf9;
const $b44af8157e52e192$export$b688253958b8dfe7 = $b44af8157e52e192$export$ecd4e1ccab6ed6d;
const $b44af8157e52e192$export$7c6e2c02157bb7d2 = $b44af8157e52e192$export$bc4ae5855d3c4fc;
const $b44af8157e52e192$export$21b07c8f274aebd5 = $b44af8157e52e192$export$79d62cd4e10a3fd0;




var $acw62 = parcelRequire("acw62");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $7e4e93e12e9bb800$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $7e4e93e12e9bb800$export$602eac185826482c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($7e4e93e12e9bb800$export$602eac185826482c, {
    displayName: $7e4e93e12e9bb800$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $7e4e93e12e9bb800$export$be92b6f5f03c0fe9 = $7e4e93e12e9bb800$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");



function $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $33a5aa769cc85be3$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$33a5aa769cc85be3$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b37fe3d39d956993$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $11492dca620dcaa5$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $acw62 = parcelRequire("acw62");

function $206b7034d5d190d4$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $206b7034d5d190d4$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState(function() {
        return (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


/* -------------------------------------------------------------------------------------------------
 * Popover
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$createPopoverContext, $8a88ecc38cbd867b$export$c8393c9e73286932] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$POPOVER_NAME, [
    (0, $b44af8157e52e192$export$722aac194ae923)
]);
const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope = (0, $b44af8157e52e192$export$722aac194ae923)();
const [$8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverProvider, $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext] = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$createPopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$POPOVER_NAME);
const $8a88ecc38cbd867b$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const triggerRef = (0, $acw62.useRef)(null);
    const [hasCustomAnchor, setHasCustomAnchor] = (0, $acw62.useState)(false);
    const [open = false, setOpen] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverProvider, {
        scope: __scopePopover,
        contentId: (0, $f3afa084f31a11ef$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        hasCustomAnchor: hasCustomAnchor,
        onCustomAnchorAdd: (0, $acw62.useCallback)(()=>setHasCustomAnchor(true), []),
        onCustomAnchorRemove: (0, $acw62.useCallback)(()=>setHasCustomAnchor(false), []),
        modal: modal
    }, children));
};
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$5b6b19405a83ff9d, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$POPOVER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverAnchor
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $8a88ecc38cbd867b$export$96e5381f42521a79 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    (0, $acw62.useEffect)(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$96e5381f42521a79, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverTrigger
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $8a88ecc38cbd867b$export$7dacb05d26466c3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), trigger);
});
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$7dacb05d26466c3, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverPortal
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PortalProvider, $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePortalContext] = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$createPopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, {
    forceMount: undefined
});
const $8a88ecc38cbd867b$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $7e4e93e12e9bb800$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$dd679ffb4362d2d4, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverContent
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $8a88ecc38cbd867b$export$d7e1f420b25549ff = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePortalContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$d7e1f420b25549ff, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = (0, $acw62.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $acw62.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: (0, $2fad294522b5ed20$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
        }, {
            checkForDefaultPrevented: false
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        })
    })));
});
const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$PopoverContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
    const popperScope = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover); // Make sure the whole tree has focus guards as our `Popover` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $8fdc5d26108cccc8$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $d52e479a4b6ab6b0$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $934b33b1070542f6$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-state": $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$getState(context.open),
        role: "dialog",
        id: context.contentId
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            // re-namespace exposed content custom property
            ["--radix-popover-content-transform-origin"]: "var(--radix-popper-transform-origin)"
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * PopoverClose
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $8a88ecc38cbd867b$export$d6ac43ebaa40d53e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopoverContext($8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$d6ac43ebaa40d53e, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$CLOSE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopoverArrow
 * -----------------------------------------------------------------------------------------------*/ const $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$ARROW_NAME = "PopoverArrow";
const $8a88ecc38cbd867b$export$3152841115e061b2 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $b44af8157e52e192$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($8a88ecc38cbd867b$export$3152841115e061b2, {
    displayName: $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $8a88ecc38cbd867b$var$$cb5cc270b50c6fcd$var$getState(open) {
    return open ? "open" : "closed";
}
const $8a88ecc38cbd867b$export$be92b6f5f03c0fe9 = $8a88ecc38cbd867b$export$5b6b19405a83ff9d;
const $8a88ecc38cbd867b$export$b688253958b8dfe7 = $8a88ecc38cbd867b$export$96e5381f42521a79;
const $8a88ecc38cbd867b$export$41fb9f06171c75f4 = $8a88ecc38cbd867b$export$7dacb05d26466c3;
const $8a88ecc38cbd867b$export$602eac185826482c = $8a88ecc38cbd867b$export$dd679ffb4362d2d4;
const $8a88ecc38cbd867b$export$7c6e2c02157bb7d2 = $8a88ecc38cbd867b$export$d7e1f420b25549ff;
const $8a88ecc38cbd867b$export$f39c2d165cd861fe = $8a88ecc38cbd867b$export$d6ac43ebaa40d53e;
const $8a88ecc38cbd867b$export$21b07c8f274aebd5 = $8a88ecc38cbd867b$export$3152841115e061b2;


var $ca0b4b54599ec457$exports = {};
/*
 * Fuzzy
 * https://github.com/myork/fuzzy
 *
 * Copyright (c) 2012 Matt York
 * Licensed under the MIT license.
 */ (function() {
    var root = this;
    var fuzzy = {};
    $ca0b4b54599ec457$exports = fuzzy;
    // Return all elements of `array` that have a fuzzy
    // match against `pattern`.
    fuzzy.simpleFilter = function(pattern, array) {
        return array.filter(function(str) {
            return fuzzy.test(pattern, str);
        });
    };
    // Does `pattern` fuzzy match `str`?
    fuzzy.test = function(pattern, str) {
        return fuzzy.match(pattern, str) !== null;
    };
    // If `pattern` matches `str`, wrap each matching character
    // in `opts.pre` and `opts.post`. If no match, return null
    fuzzy.match = function(pattern, str, opts) {
        opts = opts || {};
        var patternIdx = 0, result = [], len = str.length, totalScore = 0, currScore = 0, pre = opts.pre || "", post = opts.post || "", compareString = opts.caseSensitive && str || str.toLowerCase(), ch;
        pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
        // For each character in the string, either add it to the result
        // or wrap in template if it's the next string in the pattern
        for(var idx = 0; idx < len; idx++){
            ch = str[idx];
            if (compareString[idx] === pattern[patternIdx]) {
                ch = pre + ch + post;
                patternIdx += 1;
                // consecutive characters should increase the score more than linearly
                currScore += 1 + currScore;
            } else currScore = 0;
            totalScore += currScore;
            result[result.length] = ch;
        }
        // return rendered string if we have a match for every char
        if (patternIdx === pattern.length) {
            // if the string is an exact match with pattern, totalScore should be maxed
            totalScore = compareString === pattern ? Infinity : totalScore;
            return {
                rendered: result.join(""),
                score: totalScore
            };
        }
        return null;
    };
    // The normal entry point. Filters `arr` for matches against `pattern`.
    // It returns an array with matching values of the type:
    //
    //     [{
    //         string:   '<b>lah' // The rendered string
    //       , index:    2        // The index of the element in `arr`
    //       , original: 'blah'   // The original element in `arr`
    //     }]
    //
    // `opts` is an optional argument bag. Details:
    //
    //    opts = {
    //        // string to put before a matching character
    //        pre:     '<b>'
    //
    //        // string to put after matching character
    //      , post:    '</b>'
    //
    //        // Optional function. Input is an entry in the given arr`,
    //        // output should be the string to test `pattern` against.
    //        // In this example, if `arr = [{crying: 'koala'}]` we would return
    //        // 'koala'.
    //      , extract: function(arg) { return arg.crying; }
    //    }
    fuzzy.filter = function(pattern, arr, opts) {
        if (!arr || arr.length === 0) return [];
        if (typeof pattern !== "string") return arr;
        opts = opts || {};
        return arr.reduce(function(prev, element, idx, arr) {
            var str = element;
            if (opts.extract) str = opts.extract(element);
            var rendered = fuzzy.match(pattern, str, opts);
            if (rendered != null) prev[prev.length] = {
                string: rendered.rendered,
                score: rendered.score,
                index: idx,
                original: element
            };
            return prev;
        }, [])// Sort by score. Browsers are inconsistent wrt stable/unstable
        // sorting, so force stable by using the index in the case of tie.
        // See http://ofb.net/~sethml/is-sort-stable.html
        .sort(function(a, b) {
            var compare = b.score - a.score;
            if (compare) return compare;
            return a.index - b.index;
        });
    };
})();



var $acw62 = parcelRequire("acw62");
var $af9e91ea6e32034a$exports = {};
"use strict";
var $daecaa38e3584fd1$exports = {};
"use strict";
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports = $daecaa38e3584fd1$var$vanilla;
$daecaa38e3584fd1$exports.createStore = $daecaa38e3584fd1$var$createStore;
$daecaa38e3584fd1$exports.default = $daecaa38e3584fd1$exports;



var $acw62 = parcelRequire("acw62");
var $6ae5e5baff12bbf7$exports = {};
"use strict";

$6ae5e5baff12bbf7$exports = (parcelRequire("6VZtt"));


var $af9e91ea6e32034a$var$useDebugValue = $acw62.useDebugValue;
var $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector = $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector;
var $af9e91ea6e32034a$var$didWarnAboutEqualityFn = false;
var $af9e91ea6e32034a$var$identity = function identity(arg) {
    return arg;
};
function $af9e91ea6e32034a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $af9e91ea6e32034a$var$identity;
    var slice = $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $af9e91ea6e32034a$var$useDebugValue(slice);
    return slice;
}
var $af9e91ea6e32034a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $daecaa38e3584fd1$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $af9e91ea6e32034a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $af9e91ea6e32034a$var$create = function create(createState) {
    return createState ? $af9e91ea6e32034a$var$createImpl(createState) : $af9e91ea6e32034a$var$createImpl;
};
var $af9e91ea6e32034a$var$react = function(createState) {
    return $af9e91ea6e32034a$var$create(createState);
};
$af9e91ea6e32034a$exports.create = $af9e91ea6e32034a$var$create;
$af9e91ea6e32034a$exports.default = $af9e91ea6e32034a$var$react;
$af9e91ea6e32034a$exports.useStore = $af9e91ea6e32034a$var$useStore;
Object.keys($daecaa38e3584fd1$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($af9e91ea6e32034a$exports, k)) Object.defineProperty($af9e91ea6e32034a$exports, k, {
        enumerable: true,
        get: function() {
            return $daecaa38e3584fd1$exports[k];
        }
    });
});
$af9e91ea6e32034a$exports = $af9e91ea6e32034a$var$react;
$af9e91ea6e32034a$exports.create = $af9e91ea6e32034a$var$create;
$af9e91ea6e32034a$exports.useStore = $af9e91ea6e32034a$var$useStore;
$af9e91ea6e32034a$exports.createStore = $daecaa38e3584fd1$exports.createStore;
$af9e91ea6e32034a$exports.default = $af9e91ea6e32034a$exports;


var $6d4d33fbf8eac225$var$_window$document, $6d4d33fbf8eac225$var$_window$navigator;
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $6d4d33fbf8eac225$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && (($6d4d33fbf8eac225$var$_window$document = window.document) != null && $6d4d33fbf8eac225$var$_window$document.createElement || (($6d4d33fbf8eac225$var$_window$navigator = window.navigator) == null ? void 0 : $6d4d33fbf8eac225$var$_window$navigator.product) === "ReactNative") ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
function $6d4d33fbf8eac225$export$2e2bcd8739ae039() {
    const useStore = (0, $af9e91ea6e32034a$exports.create)((set)=>({
            current: new Array(),
            version: 0,
            set: set
        }));
    return {
        In: ({ children: children })=>{
            const set = useStore((state)=>state.set);
            const version = useStore((state)=>state.version);
            /* When this component mounts, we increase the store's version number.
      This will cause all existing rats to re-render (just like if the Out component
      were mapping items to a list.) The re-rendering will cause the final 
      order of rendered components to match what the user is expecting. */ $6d4d33fbf8eac225$var$useIsomorphicLayoutEffect(()=>{
                set((state)=>({
                        version: state.version + 1
                    }));
            }, []);
            /* Any time the children _or_ the store's version number change, insert
      the specified React children into the list of rats. */ $6d4d33fbf8eac225$var$useIsomorphicLayoutEffect(()=>{
                set(({ current: current })=>({
                        current: [
                            ...current,
                            children
                        ]
                    }));
                return ()=>set(({ current: current })=>({
                            current: current.filter((c)=>c !== children)
                        }));
            }, [
                children,
                version
            ]);
            return null;
        },
        Out: ()=>{
            const current = useStore((state)=>state.current);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, current);
        }
    };
}




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $435c9fb8798de9ba$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2fad294522b5ed20$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}









var $acw62 = parcelRequire("acw62");
const $a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $a0d8f34db6c98cd1$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $a0d8f34db6c98cd1$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $a0d8f34db6c98cd1$export$2881499e37b75b9a = $a0d8f34db6c98cd1$export$c760c09fdd558351;


const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $435c9fb8798de9ba$export$c74125a8e3af6bb2)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $31e40192e19ff522$export$c7109489551a4f4] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $31e40192e19ff522$export$8699f7c8af148338 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($31e40192e19ff522$export$8699f7c8af148338, {
    displayName: $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $06dbdeafb212d82f$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $a0d8f34db6c98cd1$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $acw62.useState)(false);
    const handleEntryFocus = (0, $6421c5b6e6501f6d$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $acw62.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $acw62.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $acw62.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $31e40192e19ff522$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $f3afa084f31a11ef$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $acw62.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($31e40192e19ff522$export$ab9df7c53fe8454, {
    displayName: $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $31e40192e19ff522$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $31e40192e19ff522$export$be92b6f5f03c0fe9 = $31e40192e19ff522$export$8699f7c8af148338;
const $31e40192e19ff522$export$6d08773d2e66f8f2 = $31e40192e19ff522$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$1e222a1434bedc9c$var$$69cb30bb0017df05$var$createTabsContext, $1e222a1434bedc9c$export$355f5bd209d7b13a] = (0, $a27e3b74a1e4b413$export$50c7b4e9d9f19c1)($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME, [
    (0, $31e40192e19ff522$export$c7109489551a4f4)
]);
const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope = (0, $31e40192e19ff522$export$c7109489551a4f4)();
const [$1e222a1434bedc9c$var$$69cb30bb0017df05$var$TabsProvider, $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext] = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$createTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME);
const $1e222a1434bedc9c$export$b2539bed5023c21c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $a0d8f34db6c98cd1$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $206b7034d5d190d4$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $f3afa084f31a11ef$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$b2539bed5023c21c, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $1e222a1434bedc9c$export$9712d22edc0d78c1 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $31e40192e19ff522$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$9712d22edc0d78c1, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $1e222a1434bedc9c$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $31e40192e19ff522$export$6d08773d2e66f8f2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? "active" : "inactive",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else event.preventDefault();
        }),
        onKeyDown: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if ([
                " ",
                "Enter"
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0, $e0f75533c8da79e2$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== "manual";
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$8114b9fdfdf9f3ba, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $1e222a1434bedc9c$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$useTabsContext($1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0, $acw62.useRef)(isSelected);
    (0, $acw62.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $33a5aa769cc85be3$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected
    }, ({ present: present })=>/*#__PURE__*/ (0, $acw62.createElement)((0, $ffa305e20fe06c82$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            "data-state": isSelected ? "active" : "inactive",
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? "0s" : undefined
            }
        }), present && children));
});
/*#__PURE__*/ Object.assign($1e222a1434bedc9c$export$bd905d70e8fd2ebb, {
    displayName: $1e222a1434bedc9c$var$$69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $1e222a1434bedc9c$var$$69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $1e222a1434bedc9c$export$be92b6f5f03c0fe9 = $1e222a1434bedc9c$export$b2539bed5023c21c;
const $1e222a1434bedc9c$export$54c2e3dc7acea9f5 = $1e222a1434bedc9c$export$9712d22edc0d78c1;
const $1e222a1434bedc9c$export$41fb9f06171c75f4 = $1e222a1434bedc9c$export$8114b9fdfdf9f3ba;
const $1e222a1434bedc9c$export$7c6e2c02157bb7d2 = $1e222a1434bedc9c$export$bd905d70e8fd2ebb;



var $f1q41 = parcelRequire("f1q41");
function $30b0e781a03fc496$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $30b0e781a03fc496$var$$94cfa2cfccc8cc22$exports = {};
$30b0e781a03fc496$var$$parcel$export($30b0e781a03fc496$var$$94cfa2cfccc8cc22$exports, "LaserPointer", ()=>$30b0e781a03fc496$export$6531021b3bf36eae);
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096([ax, ay, ar], [bx, by, br]) {
    return [
        ax + bx,
        ay + by,
        ar + br
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca([ax, ay, ar], [bx, by, br]) {
    return [
        ax - bx,
        ay - by,
        ar - br
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443([x, y, r], s) {
    return [
        x * s,
        y * s,
        r * s
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b([x, y, r]) {
    return [
        x / Math.sqrt(x ** 2 + y ** 2),
        y / Math.sqrt(x ** 2 + y ** 2),
        r
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b([x, y, r], rad) {
    return [
        Math.cos(rad) * x - Math.sin(rad) * y,
        Math.sin(rad) * x + Math.cos(rad) * y,
        r
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$92d8e23769117a5e(a, b, t) {
    return $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(a, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca(b, a), t));
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$3a89f8d6f6bf6c9f(a, b, t) {
    return a + (b - a) * t;
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$944b09d2ad10b378(p, p1, p2) {
    return Math.atan2(p2[1] - p[1], p2[0] - p[0]) - Math.atan2(p1[1] - p[1], p1[0] - p[0]);
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$3c05aaf71f141f73(a) {
    return Math.atan2(Math.sin(a), Math.cos(a));
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$1b9bab504faa9305([x, y]) {
    return Math.sqrt(x ** 2 + y ** 2);
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764([ax, ay], [bx, by]) {
    return Math.sqrt((bx - ax) ** 2 + (by - ay) ** 2);
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$46f6d3e1b4bd7c8b(point, direction, radius) {
    return [
        $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(point, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(direction, Math.PI / 2)), radius)),
        $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(point, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(direction, -Math.PI / 2)), radius))
    ];
}
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$ccb1b4dfbd3f36a7(ps) {
    if (ps.length < 2) return 0;
    let len = 0;
    for(let i = 1; i <= ps.length - 1; i++)len += $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(ps[i - 1], ps[i]);
    len += $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(ps[ps.length - 2], ps[ps.length - 1]);
    return len;
}
const $30b0e781a03fc496$var$$8cd7efb5af385306$export$7d15b64cf5a3a4c4 = (v, min, max)=>Math.max(min, Math.min(max, v));
function $30b0e781a03fc496$var$$8cd7efb5af385306$export$548cc43590159af6(p3, p1, p2) {
    const sMag = $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(p1, p2);
    if (sMag === 0) return $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(p3, p1);
    const u = $30b0e781a03fc496$var$$8cd7efb5af385306$export$7d15b64cf5a3a4c4(((p3[0] - p1[0]) * (p2[0] - p1[0]) + (p3[1] - p1[1]) * (p2[1] - p1[1])) / sMag ** 2, 0, 1);
    const pi = [
        p1[0] + u * (p2[0] - p1[0]),
        p1[1] + u * (p2[1] - p1[1]),
        p3[2]
    ];
    return $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(pi, p3);
}
function $30b0e781a03fc496$var$$34bab0059f842ce6$export$ef693d1572e64fb8(points, epsilon) {
    if (epsilon === 0) return points;
    if (points.length <= 2) return points;
    const first = points[0];
    const last = points[points.length - 1];
    const [maxDistance, maxIndex] = points.reduce(([maxDistance, maxIndex], point, index)=>{
        const distance = $30b0e781a03fc496$var$$8cd7efb5af385306$export$548cc43590159af6(point, first, last);
        return distance > maxDistance ? [
            distance,
            index
        ] : [
            maxDistance,
            maxIndex
        ];
    }, [
        0,
        -1
    ]);
    if (maxDistance >= epsilon) {
        const maxIndexPoint = points[maxIndex];
        return [
            ...$30b0e781a03fc496$var$$34bab0059f842ce6$export$ef693d1572e64fb8([
                first,
                ...points.slice(1, maxIndex),
                maxIndexPoint
            ], epsilon).slice(0, -1),
            maxIndexPoint,
            ...$30b0e781a03fc496$var$$34bab0059f842ce6$export$ef693d1572e64fb8([
                maxIndexPoint,
                ...points.slice(maxIndex, -1),
                last
            ], epsilon).slice(1)
        ];
    } else return [
        first,
        last
    ];
}
class $30b0e781a03fc496$export$6531021b3bf36eae {
    static #_ = this.defaults = {
        size: 2,
        streamline: 0.45,
        simplify: 0.1,
        simplifyPhase: "output",
        keepHead: false,
        sizeMapping: ()=>1
    };
    static #_1 = this.constants = {
        cornerDetectionMaxAngle: 75,
        cornerDetectionVariance: (s)=>s > 35 ? 0.5 : 1,
        maxTailLength: 50
    };
    constructor(options){
        this.originalPoints = [];
        this.stablePoints = [];
        this.tailPoints = [];
        this.isFresh = true;
        this.options = Object.assign({}, $30b0e781a03fc496$export$6531021b3bf36eae.defaults, options);
    }
    get lastPoint() {
        return this.tailPoints[this.tailPoints.length - 1] ?? this.stablePoints[this.stablePoints.length - 1];
    }
    addPoint(point) {
        const lastPoint = this.originalPoints[this.originalPoints.length - 1];
        if (lastPoint && lastPoint[0] === point[0] && lastPoint[1] === point[1]) return;
        this.originalPoints.push(point);
        if (this.isFresh) {
            this.isFresh = false;
            this.stablePoints.push(point);
            return;
        }
        if (this.options.streamline > 0) point = $30b0e781a03fc496$var$$8cd7efb5af385306$export$92d8e23769117a5e(this.lastPoint, point, 1 - this.options.streamline);
        this.tailPoints.push(point);
        if ($30b0e781a03fc496$var$$8cd7efb5af385306$export$ccb1b4dfbd3f36a7(this.tailPoints) > $30b0e781a03fc496$export$6531021b3bf36eae.constants.maxTailLength) this.stabilizeTail();
    }
    close() {
        this.stabilizeTail();
    }
    stabilizeTail() {
        if (this.options.simplify > 0 && this.options.simplifyPhase == "tail") throw new Error("Not implemented yet");
        else {
            this.stablePoints.push(...this.tailPoints);
            this.tailPoints = [];
        }
    }
    getSize(sizeOverride, pressure, index, totalLength, runningLength) {
        return (sizeOverride ?? this.options.size) * this.options.sizeMapping({
            pressure: pressure,
            runningLength: runningLength,
            currentIndex: index,
            totalLength: totalLength
        });
    }
    getStrokeOutline(sizeOverride) {
        if (this.isFresh) return [];
        let points = [
            ...this.stablePoints,
            ...this.tailPoints
        ];
        if (this.options.simplify > 0 && this.options.simplifyPhase === "input") points = $30b0e781a03fc496$var$$34bab0059f842ce6$export$ef693d1572e64fb8(points, this.options.simplify);
        const len = points.length;
        if (len === 0) return [];
        if (len === 1) {
            const c = points[0];
            const size = this.getSize(sizeOverride, c[2], 0, len, 0);
            if (size < 0.5) return [];
            const ps = [];
            for(let theta = 0; theta <= Math.PI * 2; theta += Math.PI / 16)ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b([
                1,
                0,
                0
            ], theta), size)));
            ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443([
                1,
                0,
                0
            ], this.getSize(sizeOverride, c[2], 0, len, 0))));
            return ps;
        }
        if (len === 2) {
            const c = points[0];
            const n = points[1];
            const cSize = this.getSize(sizeOverride, c[2], 0, len, 0);
            const nSize = this.getSize(sizeOverride, n[2], 0, len, 0);
            if (cSize < 0.5 || nSize < 0.5) return [];
            const ps = [];
            const pAngle = $30b0e781a03fc496$var$$8cd7efb5af385306$export$944b09d2ad10b378(c, [
                c[0],
                c[1] - 100,
                c[2]
            ], n);
            for(let theta = pAngle; theta <= Math.PI + pAngle; theta += Math.PI / 16)ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b([
                1,
                0,
                0
            ], theta), cSize)));
            for(let theta = Math.PI + pAngle; theta <= Math.PI * 2 + pAngle; theta += Math.PI / 16)ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(n, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b([
                1,
                0,
                0
            ], theta), nSize)));
            ps.push(ps[0]);
            return ps;
        }
        const forwardPoints = [];
        const backwardPoints = [];
        let speed = 0;
        let prevSpeed = 0;
        let visibleStartIndex = 0;
        let runningLength = 0;
        for(let i = 1; i < len - 1; i++){
            const p = points[i - 1], c = points[i], n = points[i + 1];
            let pressure = c[2];
            const d = $30b0e781a03fc496$var$$8cd7efb5af385306$export$6c4a311cc157c764(p, c);
            runningLength += d;
            speed = prevSpeed + (d - prevSpeed) * 0.2;
            const cSize = this.getSize(sizeOverride, pressure, i, len, runningLength);
            if (cSize === 0) {
                visibleStartIndex = i + 1;
                continue;
            }
            const dirPC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca(p, c));
            const dirNC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca(n, c));
            const p1dirPC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirPC, Math.PI / 2);
            const p2dirPC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirPC, -Math.PI / 2);
            const p1dirNC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirNC, Math.PI / 2);
            const p2dirNC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirNC, -Math.PI / 2);
            const p1PC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirPC, cSize));
            const p2PC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p2dirPC, cSize));
            const p1NC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirNC, cSize));
            const p2NC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p2dirNC, cSize));
            const ftdir = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(p1dirPC, p2dirNC);
            const btdir = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(p2dirPC, p1dirNC);
            const paPC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$1b9bab504faa9305(ftdir) === 0 ? dirPC : $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b(ftdir), cSize));
            const paNC = $30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$1b9bab504faa9305(btdir) === 0 ? dirNC : $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b(btdir), cSize));
            const cAngle = $30b0e781a03fc496$var$$8cd7efb5af385306$export$3c05aaf71f141f73($30b0e781a03fc496$var$$8cd7efb5af385306$export$944b09d2ad10b378(c, p, n));
            const D_ANGLE = $30b0e781a03fc496$export$6531021b3bf36eae.constants.cornerDetectionMaxAngle / 180 * Math.PI * $30b0e781a03fc496$export$6531021b3bf36eae.constants.cornerDetectionVariance(speed);
            if (Math.abs(cAngle) < D_ANGLE) {
                const tAngle = Math.abs($30b0e781a03fc496$var$$8cd7efb5af385306$export$3c05aaf71f141f73(Math.PI - cAngle)) // turn angle
                ;
                if (tAngle === 0) continue;
                if (cAngle < 0) {
                    backwardPoints.push(p2PC, paNC);
                    for(let theta = 0; theta <= tAngle; theta += tAngle / 4)forwardPoints.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirPC, cSize), theta)));
                    for(let theta = tAngle; theta >= 0; theta -= tAngle / 4)backwardPoints.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirPC, cSize), theta)));
                    backwardPoints.push(paNC, p1NC);
                } else {
                    forwardPoints.push(p1PC, paPC);
                    for(let theta = 0; theta <= tAngle; theta += tAngle / 4)backwardPoints.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirPC, -cSize), -theta)));
                    for(let theta = tAngle; theta >= 0; theta -= tAngle / 4)forwardPoints.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(p1dirPC, -cSize), -theta)));
                    forwardPoints.push(paPC, p2NC);
                }
            } else {
                forwardPoints.push(paPC);
                backwardPoints.push(paNC);
            }
            prevSpeed = speed;
        }
        if (visibleStartIndex >= len - 2) {
            if (this.options.keepHead) {
                const c = points[len - 1];
                const ps = [];
                for(let theta = 0; theta <= Math.PI * 2; theta += Math.PI / 16)ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443($30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b([
                    1,
                    0,
                    0
                ], theta), this.options.size)));
                ps.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(c, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443([
                    1,
                    0,
                    0
                ], this.options.size)));
                return ps;
            } else return [];
        }
        const first = points[visibleStartIndex];
        const second = points[visibleStartIndex + 1];
        const penultimate = points[len - 2];
        const ultimate = points[len - 1];
        const dirFS = $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca(second, first));
        const dirPU = $30b0e781a03fc496$var$$8cd7efb5af385306$export$1991ecd29cc92c6b($30b0e781a03fc496$var$$8cd7efb5af385306$export$f93b5905241a7cca(penultimate, ultimate));
        const ppdirFS = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirFS, -Math.PI / 2);
        const ppdirPU = $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b(dirPU, Math.PI / 2);
        const startCapSize = this.getSize(sizeOverride, first[2], 0, len, 0);
        const startCap = [];
        const endCapSize = this.options.keepHead ? this.options.size : this.getSize(sizeOverride, penultimate[2], len - 2, len, runningLength);
        const endCap = [];
        if (startCapSize > 1) {
            for(let theta = 0; theta <= Math.PI; theta += Math.PI / 16)startCap.unshift($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(first, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(ppdirFS, startCapSize), -theta)));
            startCap.unshift($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(first, $30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(ppdirFS, -startCapSize)));
        } else startCap.push(first);
        for(let theta = 0; theta <= Math.PI * 3; theta += Math.PI / 16)endCap.push($30b0e781a03fc496$var$$8cd7efb5af385306$export$e16d8520af44a096(ultimate, $30b0e781a03fc496$var$$8cd7efb5af385306$export$855df823ceb9b81b($30b0e781a03fc496$var$$8cd7efb5af385306$export$1c8884ee32bdf443(ppdirPU, -endCapSize), -theta)));
        const strokeOutline = [
            ...startCap,
            ...forwardPoints,
            ...endCap.reverse(),
            ...backwardPoints.reverse()
        ];
        if (startCap.length > 0) strokeOutline.push(startCap[0]);
        if (this.options.simplify > 0 && this.options.simplifyPhase === "output") return $30b0e781a03fc496$var$$34bab0059f842ce6$export$ef693d1572e64fb8(strokeOutline, this.options.simplify);
        return strokeOutline;
    }
}


var $e68ba20b3d2d159d$var$w6 = Object.defineProperty;
var $e68ba20b3d2d159d$var$e0 = (e)=>(t)=>{
        var r = e[t];
        if (r) return r();
        throw new Error("Module not found in bundle: " + t);
    };
var $e68ba20b3d2d159d$var$K = (e, t)=>()=>(e && (t = e(e = 0)), t);
var $e68ba20b3d2d159d$var$Zg = (e, t)=>{
    for(var r in t)$e68ba20b3d2d159d$var$w6(e, r, {
        get: t[r],
        enumerable: !0
    });
};
var $e68ba20b3d2d159d$var$T, $e68ba20b3d2d159d$var$f = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$T = {
        PROD: !0
    };
});
var $e68ba20b3d2d159d$var$qg, $e68ba20b3d2d159d$var$n0 = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$qg = {};
});
var $e68ba20b3d2d159d$var$_6, $e68ba20b3d2d159d$var$i0, $e68ba20b3d2d159d$var$_a, $e68ba20b3d2d159d$var$a0, $e68ba20b3d2d159d$var$Us, $e68ba20b3d2d159d$var$Gs, $e68ba20b3d2d159d$var$Xo, $e68ba20b3d2d159d$var$Ko, $e68ba20b3d2d159d$var$fe, $e68ba20b3d2d159d$var$s0, $e68ba20b3d2d159d$var$Am, $e68ba20b3d2d159d$var$Mm, $e68ba20b3d2d159d$var$km, $e68ba20b3d2d159d$var$l0, $e68ba20b3d2d159d$var$c0, $e68ba20b3d2d159d$var$d0, $e68ba20b3d2d159d$var$m0, $e68ba20b3d2d159d$var$yr = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$_6 = (e, t)=>t.reduce((r, o)=>(o in e && (r[o] = e[o]), r), {}), $e68ba20b3d2d159d$var$i0 = 5, $e68ba20b3d2d159d$var$_a = 5, $e68ba20b3d2d159d$var$a0 = 4, $e68ba20b3d2d159d$var$Us = 4, $e68ba20b3d2d159d$var$Gs = 1, $e68ba20b3d2d159d$var$Xo = [
        0,
        2,
        4,
        6,
        8
    ], $e68ba20b3d2d159d$var$Ko = (e, t)=>t.map((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports)))[e][r]), $e68ba20b3d2d159d$var$fe = {
        transparent: "transparent",
        black: "#1e1e1e",
        white: "#ffffff",
        gray: $e68ba20b3d2d159d$var$Ko("gray", $e68ba20b3d2d159d$var$Xo),
        red: $e68ba20b3d2d159d$var$Ko("red", $e68ba20b3d2d159d$var$Xo),
        pink: $e68ba20b3d2d159d$var$Ko("pink", $e68ba20b3d2d159d$var$Xo),
        grape: $e68ba20b3d2d159d$var$Ko("grape", $e68ba20b3d2d159d$var$Xo),
        violet: $e68ba20b3d2d159d$var$Ko("violet", $e68ba20b3d2d159d$var$Xo),
        blue: $e68ba20b3d2d159d$var$Ko("blue", $e68ba20b3d2d159d$var$Xo),
        cyan: $e68ba20b3d2d159d$var$Ko("cyan", $e68ba20b3d2d159d$var$Xo),
        teal: $e68ba20b3d2d159d$var$Ko("teal", $e68ba20b3d2d159d$var$Xo),
        green: $e68ba20b3d2d159d$var$Ko("green", $e68ba20b3d2d159d$var$Xo),
        yellow: $e68ba20b3d2d159d$var$Ko("yellow", $e68ba20b3d2d159d$var$Xo),
        orange: $e68ba20b3d2d159d$var$Ko("orange", $e68ba20b3d2d159d$var$Xo),
        bronze: [
            "#f8f1ee",
            "#eaddd7",
            "#d2bab0",
            "#a18072",
            "#846358"
        ]
    }, $e68ba20b3d2d159d$var$s0 = $e68ba20b3d2d159d$var$_6($e68ba20b3d2d159d$var$fe, [
        "cyan",
        "blue",
        "violet",
        "grape",
        "pink",
        "green",
        "teal",
        "yellow",
        "orange",
        "red"
    ]), $e68ba20b3d2d159d$var$Am = [
        $e68ba20b3d2d159d$var$fe.black,
        $e68ba20b3d2d159d$var$fe.red[$e68ba20b3d2d159d$var$Us],
        $e68ba20b3d2d159d$var$fe.green[$e68ba20b3d2d159d$var$Us],
        $e68ba20b3d2d159d$var$fe.blue[$e68ba20b3d2d159d$var$Us],
        $e68ba20b3d2d159d$var$fe.yellow[$e68ba20b3d2d159d$var$Us]
    ], $e68ba20b3d2d159d$var$Mm = [
        $e68ba20b3d2d159d$var$fe.transparent,
        $e68ba20b3d2d159d$var$fe.red[$e68ba20b3d2d159d$var$Gs],
        $e68ba20b3d2d159d$var$fe.green[$e68ba20b3d2d159d$var$Gs],
        $e68ba20b3d2d159d$var$fe.blue[$e68ba20b3d2d159d$var$Gs],
        $e68ba20b3d2d159d$var$fe.yellow[$e68ba20b3d2d159d$var$Gs]
    ], $e68ba20b3d2d159d$var$km = [
        $e68ba20b3d2d159d$var$fe.white,
        "#f8f9fa",
        "#f5faff",
        "#fffce8",
        "#fdf8f6"
    ], $e68ba20b3d2d159d$var$l0 = {
        transparent: $e68ba20b3d2d159d$var$fe.transparent,
        white: $e68ba20b3d2d159d$var$fe.white,
        gray: $e68ba20b3d2d159d$var$fe.gray,
        black: $e68ba20b3d2d159d$var$fe.black,
        bronze: $e68ba20b3d2d159d$var$fe.bronze,
        ...$e68ba20b3d2d159d$var$s0
    }, $e68ba20b3d2d159d$var$c0 = {
        transparent: $e68ba20b3d2d159d$var$fe.transparent,
        white: $e68ba20b3d2d159d$var$fe.white,
        gray: $e68ba20b3d2d159d$var$fe.gray,
        black: $e68ba20b3d2d159d$var$fe.black,
        bronze: $e68ba20b3d2d159d$var$fe.bronze,
        ...$e68ba20b3d2d159d$var$s0
    }, $e68ba20b3d2d159d$var$d0 = (e)=>[
            $e68ba20b3d2d159d$var$fe.cyan[e],
            $e68ba20b3d2d159d$var$fe.blue[e],
            $e68ba20b3d2d159d$var$fe.violet[e],
            $e68ba20b3d2d159d$var$fe.grape[e],
            $e68ba20b3d2d159d$var$fe.pink[e],
            $e68ba20b3d2d159d$var$fe.green[e],
            $e68ba20b3d2d159d$var$fe.teal[e],
            $e68ba20b3d2d159d$var$fe.yellow[e],
            $e68ba20b3d2d159d$var$fe.orange[e],
            $e68ba20b3d2d159d$var$fe.red[e]
        ], $e68ba20b3d2d159d$var$m0 = (e, t, r)=>`#${(16777216 + (e << 16) + (t << 8) + r).toString(16).slice(1)}`;
});
var $e68ba20b3d2d159d$var$_r, $e68ba20b3d2d159d$var$Pm, $e68ba20b3d2d159d$var$p0, $e68ba20b3d2d159d$var$ni, $e68ba20b3d2d159d$var$R6, $e68ba20b3d2d159d$var$u0, $e68ba20b3d2d159d$var$Lm, $e68ba20b3d2d159d$var$h0, $e68ba20b3d2d159d$var$vc, $e68ba20b3d2d159d$var$Tc, $e68ba20b3d2d159d$var$g0, $e68ba20b3d2d159d$var$ii, $e68ba20b3d2d159d$var$Ws, $e68ba20b3d2d159d$var$f0, $e68ba20b3d2d159d$var$Jg, $e68ba20b3d2d159d$var$E0, $e68ba20b3d2d159d$var$In, $e68ba20b3d2d159d$export$b42ada940915b9f1, $e68ba20b3d2d159d$var$Ue, $e68ba20b3d2d159d$var$Cn, $e68ba20b3d2d159d$var$Ra, $e68ba20b3d2d159d$var$Sc, $e68ba20b3d2d159d$var$Zt, $e68ba20b3d2d159d$var$Na, $e68ba20b3d2d159d$export$530097e879f93363, $e68ba20b3d2d159d$export$5714e40777c1bcc2, $e68ba20b3d2d159d$var$ot, $e68ba20b3d2d159d$var$ef, $e68ba20b3d2d159d$var$Dm, $e68ba20b3d2d159d$var$wr, $e68ba20b3d2d159d$var$vr, $e68ba20b3d2d159d$var$An, $e68ba20b3d2d159d$var$Oa, $e68ba20b3d2d159d$var$ai, $e68ba20b3d2d159d$var$_m, $e68ba20b3d2d159d$var$N6, $e68ba20b3d2d159d$var$x0, $e68ba20b3d2d159d$var$Ic, $e68ba20b3d2d159d$var$b0, $e68ba20b3d2d159d$var$y0, $e68ba20b3d2d159d$var$Fa, $e68ba20b3d2d159d$var$Rm, $e68ba20b3d2d159d$var$Cc, $e68ba20b3d2d159d$var$w0, $e68ba20b3d2d159d$export$edfb5d7e4280f611, $e68ba20b3d2d159d$var$Nm, $e68ba20b3d2d159d$var$Tr, $e68ba20b3d2d159d$var$Ac, $e68ba20b3d2d159d$var$v0, $e68ba20b3d2d159d$var$T0, $e68ba20b3d2d159d$var$S0, $e68ba20b3d2d159d$var$I0, $e68ba20b3d2d159d$var$Ba, $e68ba20b3d2d159d$var$Om, $e68ba20b3d2d159d$var$Fm, $e68ba20b3d2d159d$var$C0, $e68ba20b3d2d159d$var$Vs, $e68ba20b3d2d159d$var$Bm, $e68ba20b3d2d159d$var$zm, $e68ba20b3d2d159d$var$tf, $e68ba20b3d2d159d$var$A0, $e68ba20b3d2d159d$var$M0, $e68ba20b3d2d159d$var$k0, $e68ba20b3d2d159d$var$P0, $e68ba20b3d2d159d$var$L0, $e68ba20b3d2d159d$var$Ys, $e68ba20b3d2d159d$var$Xs, $e68ba20b3d2d159d$var$$o, $e68ba20b3d2d159d$var$D0, $e68ba20b3d2d159d$var$rf, $e68ba20b3d2d159d$var$Ze, $e68ba20b3d2d159d$var$za, $e68ba20b3d2d159d$var$wt, $e68ba20b3d2d159d$var$_0, $e68ba20b3d2d159d$var$R0, $e68ba20b3d2d159d$var$Pt, $e68ba20b3d2d159d$var$Oi, $e68ba20b3d2d159d$var$N0, $e68ba20b3d2d159d$var$Hm, $e68ba20b3d2d159d$var$O0, $e68ba20b3d2d159d$export$93eaedb7efc8b9fa, $e68ba20b3d2d159d$var$of, $e68ba20b3d2d159d$var$Um, $e68ba20b3d2d159d$var$mt, $e68ba20b3d2d159d$var$Mc, $e68ba20b3d2d159d$var$mo, $e68ba20b3d2d159d$var$Gm, $e68ba20b3d2d159d$var$St, $e68ba20b3d2d159d$var$Fi, $e68ba20b3d2d159d$var$Wm, $e68ba20b3d2d159d$var$Bi, $e68ba20b3d2d159d$var$$r, $e68ba20b3d2d159d$var$_t, $e68ba20b3d2d159d$var$Y = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$n0();
    $e68ba20b3d2d159d$var$yr();
    $e68ba20b3d2d159d$var$_r = /Mac|iPod|iPhone|iPad/.test(navigator.platform), $e68ba20b3d2d159d$var$Pm = /^Win/.test(navigator.platform), $e68ba20b3d2d159d$var$p0 = /\b(android)\b/i.test(navigator.userAgent), $e68ba20b3d2d159d$var$ni = "netscape" in window && navigator.userAgent.indexOf("rv:") > 1 && navigator.userAgent.indexOf("Gecko") > 1, $e68ba20b3d2d159d$var$R6 = navigator.userAgent.indexOf("Chrome") !== -1, $e68ba20b3d2d159d$var$u0 = !$e68ba20b3d2d159d$var$R6 && navigator.userAgent.indexOf("Safari") !== -1, $e68ba20b3d2d159d$var$Lm = /iPad|iPhone/.test(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document, $e68ba20b3d2d159d$var$h0 = ()=>navigator.brave?.isBrave?.name === "isBrave", $e68ba20b3d2d159d$var$vc = typeof window < "u" && "ResizeObserver" in window, $e68ba20b3d2d159d$var$Tc = "Excalidraw", $e68ba20b3d2d159d$var$g0 = 36, $e68ba20b3d2d159d$var$ii = 10, $e68ba20b3d2d159d$var$Ws = 8, $e68ba20b3d2d159d$var$f0 = 5, $e68ba20b3d2d159d$var$Jg = 1, $e68ba20b3d2d159d$var$E0 = 30, $e68ba20b3d2d159d$var$In = Math.PI / 12, $e68ba20b3d2d159d$export$b42ada940915b9f1 = "red", $e68ba20b3d2d159d$var$Ue = {
        TEXT: "text",
        CROSSHAIR: "crosshair",
        GRABBING: "grabbing",
        GRAB: "grab",
        POINTER: "pointer",
        MOVE: "move",
        AUTO: ""
    }, $e68ba20b3d2d159d$var$Cn = {
        MAIN: 0,
        WHEEL: 1,
        SECONDARY: 2,
        TOUCH: -1,
        ERASER: 5
    }, $e68ba20b3d2d159d$var$Ra = {
        enabled: "all",
        disabled: "none",
        inheritFromUI: "var(--ui-pointerEvents)"
    }, $e68ba20b3d2d159d$var$Sc = {
        UNSTARTED: -1,
        ENDED: 0,
        PLAYING: 1,
        PAUSED: 2,
        BUFFERING: 3,
        CUED: 5
    }, $e68ba20b3d2d159d$var$Zt = {
        TEST: "test",
        DEVELOPMENT: "development"
    }, $e68ba20b3d2d159d$var$Na = {
        SHAPE_ACTIONS_MENU: "App-menu__left",
        ZOOM_ACTIONS: "zoom-actions"
    }, $e68ba20b3d2d159d$export$530097e879f93363 = {
        Virgil: 1,
        Helvetica: 2,
        Cascadia: 3,
        Excalifont: 5,
        Nunito: 6,
        "Lilita One": 7,
        "Comic Shanns": 8,
        "Liberation Sans": 9
    }, $e68ba20b3d2d159d$export$5714e40777c1bcc2 = {
        LIGHT: "light",
        DARK: "dark"
    }, $e68ba20b3d2d159d$var$ot = {
        strokeColor: "#bbb",
        strokeWidth: 2,
        strokeStyle: "solid",
        fillStyle: "solid",
        roughness: 0,
        roundness: null,
        backgroundColor: "transparent",
        radius: 8,
        nameOffsetY: 3,
        nameColorLightTheme: "#999999",
        nameColorDarkTheme: "#7a7a7a",
        nameFontSize: 14,
        nameLineHeight: 1.25
    }, $e68ba20b3d2d159d$var$ef = "Segoe UI Emoji", $e68ba20b3d2d159d$var$Dm = 1, $e68ba20b3d2d159d$var$wr = 20, $e68ba20b3d2d159d$var$vr = $e68ba20b3d2d159d$export$530097e879f93363.Excalifont, $e68ba20b3d2d159d$var$An = "left", $e68ba20b3d2d159d$var$Oa = "top", $e68ba20b3d2d159d$var$ai = 2, $e68ba20b3d2d159d$var$_m = 2 * $e68ba20b3d2d159d$var$ai, $e68ba20b3d2d159d$var$N6 = 1e-5, $e68ba20b3d2d159d$var$x0 = 2 * $e68ba20b3d2d159d$var$_m - $e68ba20b3d2d159d$var$N6, $e68ba20b3d2d159d$var$Ic = "#ffffff", $e68ba20b3d2d159d$var$b0 = "#1e1e1e", $e68ba20b3d2d159d$var$y0 = "#a2f1a6", $e68ba20b3d2d159d$var$Fa = 20, $e68ba20b3d2d159d$var$Rm = 5, $e68ba20b3d2d159d$var$Cc = {
        svg: "image/svg+xml",
        png: "image/png",
        jpg: "image/jpeg",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        ico: "image/x-icon",
        avif: "image/avif",
        jfif: "image/jfif"
    }, $e68ba20b3d2d159d$var$w0 = [
        "text/plain",
        "text/html"
    ], $e68ba20b3d2d159d$export$edfb5d7e4280f611 = {
        json: "application/json",
        excalidraw: "application/vnd.excalidraw+json",
        excalidrawlib: "application/vnd.excalidrawlib+json",
        "excalidraw.svg": "image/svg+xml",
        "excalidraw.png": "image/png",
        binary: "application/octet-stream",
        ...$e68ba20b3d2d159d$var$Cc
    }, $e68ba20b3d2d159d$var$Nm = {
        png: "png",
        svg: "svg",
        clipboard: "clipboard"
    }, $e68ba20b3d2d159d$var$Tr = {
        excalidraw: "excalidraw",
        excalidrawClipboard: "excalidraw/clipboard",
        excalidrawLibrary: "excalidrawlib",
        excalidrawClipboardWithAPI: "excalidraw-api/clipboard"
    }, $e68ba20b3d2d159d$var$Ac = window.EXCALIDRAW_EXPORT_SOURCE || window.location.origin, $e68ba20b3d2d159d$var$v0 = 500, $e68ba20b3d2d159d$var$T0 = 300, $e68ba20b3d2d159d$var$S0 = 500, $e68ba20b3d2d159d$var$I0 = 100, $e68ba20b3d2d159d$var$Ba = .1, $e68ba20b3d2d159d$var$Om = .1, $e68ba20b3d2d159d$var$Fm = 30, $e68ba20b3d2d159d$var$C0 = 300, $e68ba20b3d2d159d$var$Vs = $e68ba20b3d2d159d$var$qg.themeFilter, $e68ba20b3d2d159d$var$Bm = {
        addLibrary: "addLibrary"
    }, $e68ba20b3d2d159d$var$zm = {
        addLibrary: "addLibrary"
    }, $e68ba20b3d2d159d$var$tf = {
        canvasActions: {
            changeViewBackgroundColor: !0,
            clearCanvas: !0,
            export: {
                saveFileToDisk: !0
            },
            loadScene: !0,
            saveToActiveFile: !0,
            toggleTheme: null,
            saveAsImage: !0
        },
        tools: {
            image: !0
        }
    }, $e68ba20b3d2d159d$var$A0 = 730, $e68ba20b3d2d159d$var$M0 = 1e3, $e68ba20b3d2d159d$var$k0 = 500, $e68ba20b3d2d159d$var$P0 = 1229, $e68ba20b3d2d159d$var$L0 = parseInt($e68ba20b3d2d159d$var$qg.rightSidebarWidth), $e68ba20b3d2d159d$var$Ys = 2, $e68ba20b3d2d159d$var$Xs = [
        1,
        2,
        3
    ], $e68ba20b3d2d159d$var$$o = 10, $e68ba20b3d2d159d$var$D0 = 1440, $e68ba20b3d2d159d$var$rf = 4194304, $e68ba20b3d2d159d$var$Ze = "http://www.w3.org/2000/svg", $e68ba20b3d2d159d$var$za = {
        excalidraw: 2,
        excalidrawLibrary: 2
    }, $e68ba20b3d2d159d$var$wt = 5, $e68ba20b3d2d159d$var$_0 = .7, $e68ba20b3d2d159d$var$R0 = 11, $e68ba20b3d2d159d$var$Pt = {
        TOP: "top",
        MIDDLE: "middle",
        BOTTOM: "bottom"
    }, $e68ba20b3d2d159d$var$Oi = {
        LEFT: "left",
        CENTER: "center",
        RIGHT: "right"
    }, $e68ba20b3d2d159d$var$N0 = 20, $e68ba20b3d2d159d$var$Hm = .25, $e68ba20b3d2d159d$var$O0 = 32, $e68ba20b3d2d159d$export$93eaedb7efc8b9fa = {
        LEGACY: 1,
        PROPORTIONAL_RADIUS: 2,
        ADAPTIVE_RADIUS: 3
    }, $e68ba20b3d2d159d$var$of = {
        architect: 0,
        artist: 1,
        cartoonist: 2
    }, $e68ba20b3d2d159d$var$Um = {
        thin: 1,
        bold: 2,
        extraBold: 4
    }, $e68ba20b3d2d159d$var$mt = {
        strokeColor: $e68ba20b3d2d159d$var$fe.black,
        backgroundColor: $e68ba20b3d2d159d$var$fe.transparent,
        fillStyle: "solid",
        strokeWidth: 2,
        strokeStyle: "solid",
        roughness: $e68ba20b3d2d159d$var$of.artist,
        opacity: 100,
        locked: !1
    }, $e68ba20b3d2d159d$var$Mc = "library", $e68ba20b3d2d159d$var$mo = {
        name: "default",
        defaultTab: $e68ba20b3d2d159d$var$Mc
    }, $e68ba20b3d2d159d$var$Gm = new Set([
        "iframe",
        "embeddable",
        "image"
    ]), $e68ba20b3d2d159d$var$St = {
        selection: "selection",
        rectangle: "rectangle",
        diamond: "diamond",
        ellipse: "ellipse",
        arrow: "arrow",
        line: "line",
        freedraw: "freedraw",
        text: "text",
        image: "image",
        eraser: "eraser",
        hand: "hand",
        frame: "frame",
        magicframe: "magicframe",
        embeddable: "embeddable",
        laser: "laser"
    }, $e68ba20b3d2d159d$var$Fi = {
        OAI_API_KEY: "excalidraw-oai-api-key",
        MERMAID_TO_EXCALIDRAW: "mermaid-to-excalidraw",
        PUBLISH_LIBRARY: "publish-library-data"
    }, $e68ba20b3d2d159d$var$Wm = "Untitled", $e68ba20b3d2d159d$var$Bi = {
        generalStats: 1,
        elementProperties: 2
    }, $e68ba20b3d2d159d$var$$r = 1, $e68ba20b3d2d159d$var$_t = {
        sharp: "sharp",
        round: "round",
        elbow: "elbow"
    };
});
function $e68ba20b3d2d159d$var$Lc(e, t) {
    if (!e) throw new Error(t);
}
function $e68ba20b3d2d159d$var$xt(e, t, r, o) {
    return e ? (e?.addEventListener?.(t, r, o), ()=>{
        e?.removeEventListener?.(t, r, o);
    }) : ()=>{};
}
function $e68ba20b3d2d159d$var$ey(e, t = !0) {
    let r = e.length;
    if (r < 4) return "";
    let o = e[0], n = e[1], i = e[2], a = `M${o[0].toFixed(2)},${o[1].toFixed(2)} Q${n[0].toFixed(2)},${n[1].toFixed(2)} ${$e68ba20b3d2d159d$var$Ym(n[0], i[0]).toFixed(2)},${$e68ba20b3d2d159d$var$Ym(n[1], i[1]).toFixed(2)} T`;
    for(let s = 2, l = r - 1; s < l; s++)o = e[s], n = e[s + 1], a += `${$e68ba20b3d2d159d$var$Ym(o[0], n[0]).toFixed(2)},${$e68ba20b3d2d159d$var$Ym(o[1], n[1]).toFixed(2)} `;
    return t && (a += "Z"), a;
}
var $e68ba20b3d2d159d$var$B0, $e68ba20b3d2d159d$var$af, $e68ba20b3d2d159d$var$zi, $e68ba20b3d2d159d$var$U0, $e68ba20b3d2d159d$var$Xm, $e68ba20b3d2d159d$var$G0, $e68ba20b3d2d159d$var$Mn, $e68ba20b3d2d159d$var$kn, $e68ba20b3d2d159d$var$ke, $e68ba20b3d2d159d$var$si, $e68ba20b3d2d159d$var$Hi, $e68ba20b3d2d159d$var$li, $e68ba20b3d2d159d$var$z0, $e68ba20b3d2d159d$var$W0, $e68ba20b3d2d159d$var$V0, $e68ba20b3d2d159d$var$Wt, $e68ba20b3d2d159d$var$it, $e68ba20b3d2d159d$var$O, $e68ba20b3d2d159d$export$ae5c444d4333ce2d, $e68ba20b3d2d159d$export$a4a3582487786f33, $e68ba20b3d2d159d$var$kc, $e68ba20b3d2d159d$var$W6, $e68ba20b3d2d159d$var$V6, $e68ba20b3d2d159d$var$Y6, $e68ba20b3d2d159d$var$Km, $e68ba20b3d2d159d$var$sr, $e68ba20b3d2d159d$var$$m, $e68ba20b3d2d159d$var$sf, $e68ba20b3d2d159d$var$lf, $e68ba20b3d2d159d$var$Rr, $e68ba20b3d2d159d$var$Zm, $e68ba20b3d2d159d$var$Y0, $e68ba20b3d2d159d$var$X0, $e68ba20b3d2d159d$var$K0, $e68ba20b3d2d159d$var$$0, $e68ba20b3d2d159d$var$ci, $e68ba20b3d2d159d$var$j, $e68ba20b3d2d159d$var$Z0, $e68ba20b3d2d159d$var$Pn, $e68ba20b3d2d159d$var$j0, $e68ba20b3d2d159d$var$Zr, $e68ba20b3d2d159d$var$q0, $e68ba20b3d2d159d$var$jm, $e68ba20b3d2d159d$var$Ks, $e68ba20b3d2d159d$var$J0, $e68ba20b3d2d159d$var$Ln, $e68ba20b3d2d159d$var$Pc, $e68ba20b3d2d159d$var$H0, $e68ba20b3d2d159d$var$at, $e68ba20b3d2d159d$var$Ui, $e68ba20b3d2d159d$var$Zo, $e68ba20b3d2d159d$var$Q0, $e68ba20b3d2d159d$var$qm, $e68ba20b3d2d159d$var$jr, $e68ba20b3d2d159d$var$Ha, $e68ba20b3d2d159d$var$Jm, $e68ba20b3d2d159d$var$Ym, $e68ba20b3d2d159d$var$Qm, $e68ba20b3d2d159d$var$lr, $e68ba20b3d2d159d$var$Dc, $e68ba20b3d2d159d$var$ty, $e68ba20b3d2d159d$var$W = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$yr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$B0 = null, $e68ba20b3d2d159d$var$af = ()=>{
        if ($e68ba20b3d2d159d$var$B0) return $e68ba20b3d2d159d$var$B0;
        let e = new Date, t = e.getFullYear(), r = `${e.getMonth() + 1}`.padStart(2, "0"), o = `${e.getDate()}`.padStart(2, "0"), n = `${e.getHours()}`.padStart(2, "0"), i = `${e.getMinutes()}`.padStart(2, "0");
        return `${t}-${r}-${o}-${n}${i}`;
    }, $e68ba20b3d2d159d$var$zi = (e)=>e.charAt(0).toUpperCase() + e.slice(1), $e68ba20b3d2d159d$var$U0 = (e)=>e instanceof HTMLElement && e.className.includes("ToolIcon"), $e68ba20b3d2d159d$var$Xm = (e)=>e instanceof HTMLElement && e.dataset.type === "wysiwyg" || e instanceof HTMLBRElement || e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement || e instanceof HTMLSelectElement, $e68ba20b3d2d159d$var$G0 = (e)=>$e68ba20b3d2d159d$var$Xm(e) || e instanceof Element && !!e.closest("label, button"), $e68ba20b3d2d159d$var$Mn = (e)=>e instanceof HTMLElement && e.dataset.type === "wysiwyg" || e instanceof HTMLBRElement || e instanceof HTMLTextAreaElement || e instanceof HTMLInputElement && (e.type === "text" || e.type === "number" || e.type === "password"), $e68ba20b3d2d159d$var$kn = ({ fontFamily: e })=>{
        for (let [t, r] of Object.entries($e68ba20b3d2d159d$export$530097e879f93363))if (r === e) return `${t}, ${$e68ba20b3d2d159d$var$ef}`;
        return $e68ba20b3d2d159d$var$ef;
    }, $e68ba20b3d2d159d$var$ke = ({ fontSize: e, fontFamily: t })=>`${e}px ${$e68ba20b3d2d159d$var$kn({
            fontFamily: t
        })}`, $e68ba20b3d2d159d$var$si = (e, t)=>{
        let r = 0, o = null, n = (...i)=>{
            o = i, clearTimeout(r), r = window.setTimeout(()=>{
                o = null, e(...i);
            }, t);
        };
        return n.flush = ()=>{
            if (clearTimeout(r), o) {
                let i = o;
                o = null, e(...i);
            }
        }, n.cancel = ()=>{
            o = null, clearTimeout(r);
        }, n;
    }, $e68ba20b3d2d159d$var$Hi = (e, t)=>{
        let r = null, o = null, n = null, i = (s)=>{
            r = window.requestAnimationFrame(()=>{
                r = null, e(...s), o = null, n && (o = n, n = null, i(o));
            });
        }, a = (...s)=>{
            if ($e68ba20b3d2d159d$var$T.MODE === "test") {
                e(...s);
                return;
            }
            o = s, r === null ? i(o) : t?.trailing && (n = s);
        };
        return a.flush = ()=>{
            r !== null && (cancelAnimationFrame(r), r = null), o && (e(...n || o), o = n = null);
        }, a.cancel = ()=>{
            o = n = null, r !== null && (cancelAnimationFrame(r), r = null);
        }, a;
    }, $e68ba20b3d2d159d$var$li = (e)=>1 - Math.pow(1 - e, 4), $e68ba20b3d2d159d$var$z0 = (e, t, r)=>(t - e) * $e68ba20b3d2d159d$var$li(r) + e, $e68ba20b3d2d159d$var$W0 = ({ fromValues: e, toValues: t, onStep: r, duration: o = 250, interpolateValue: n, onStart: i, onEnd: a, onCancel: s })=>{
        let l = !1, c = 0, d;
        function m(p) {
            if (l) return;
            d === void 0 && (d = p, i?.());
            let u = Math.min(p - d, o), h = $e68ba20b3d2d159d$var$li(u / o), g = {};
            if (Object.keys(e).forEach((b)=>{
                let v = b, y = (t[v] - e[v]) * h + e[v];
                g[v] = y;
            }), r(g), u < o) {
                let b = u / o, v = {};
                Object.keys(e).forEach((y)=>{
                    let w = y, I = e[w], M = t[w], C;
                    C = n ? n(I, M, b, w) : $e68ba20b3d2d159d$var$z0(I, M, b), C == null && (C = $e68ba20b3d2d159d$var$z0(I, M, b)), v[w] = C;
                }), r(v), c = window.requestAnimationFrame(m);
            } else r(t), a?.();
        }
        return c = window.requestAnimationFrame(m), ()=>{
            s?.(), l = !0, window.cancelAnimationFrame(c);
        };
    }, $e68ba20b3d2d159d$var$V0 = (e, t)=>{
        if (!e.length || t < 1) return [];
        let r = 0, o = 0, n = Array(Math.ceil(e.length / t));
        for(; r < e.length;)n[o++] = e.slice(r, r += t);
        return n;
    }, $e68ba20b3d2d159d$var$Wt = (e, t)=>Math.abs(e - t), $e68ba20b3d2d159d$var$it = (e, t)=>t.type === "custom" ? {
            ...e.activeTool,
            type: "custom",
            customType: t.customType,
            locked: t.locked ?? e.activeTool.locked
        } : {
            ...e.activeTool,
            lastActiveTool: t.lastActiveToolBeforeEraser === void 0 ? e.activeTool.lastActiveTool : t.lastActiveToolBeforeEraser,
            type: t.type,
            customType: null,
            locked: t.locked ?? e.activeTool.locked
        }, $e68ba20b3d2d159d$var$O = (e)=>(e = e.replace(/\bAlt\b/i, "Alt").replace(/\bShift\b/i, "Shift").replace(/\b(Enter|Return)\b/i, "Enter"), $e68ba20b3d2d159d$var$_r ? e.replace(/\bCtrlOrCmd\b/gi, "Cmd").replace(/\bAlt\b/i, "Option") : e.replace(/\bCtrlOrCmd\b/gi, "Ctrl")), $e68ba20b3d2d159d$export$ae5c444d4333ce2d = ({ clientX: e, clientY: t }, { zoom: r, offsetLeft: o, offsetTop: n, scrollX: i, scrollY: a })=>{
        let s = (e - o) / r.value - i, l = (t - n) / r.value - a;
        return {
            x: s,
            y: l
        };
    }, $e68ba20b3d2d159d$export$a4a3582487786f33 = ({ sceneX: e, sceneY: t }, { zoom: r, offsetLeft: o, offsetTop: n, scrollX: i, scrollY: a })=>{
        let s = (e + i) * r.value + o, l = (t + a) * r.value + n;
        return {
            x: s,
            y: l
        };
    }, $e68ba20b3d2d159d$var$kc = (e)=>getComputedStyle(document.documentElement).getPropertyValue(`--${e}`), $e68ba20b3d2d159d$var$W6 = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0800-\u1FFF\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF", $e68ba20b3d2d159d$var$V6 = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC", $e68ba20b3d2d159d$var$Y6 = new RegExp(`^[^${$e68ba20b3d2d159d$var$W6}]*[${$e68ba20b3d2d159d$var$V6}]`), $e68ba20b3d2d159d$var$Km = (e)=>$e68ba20b3d2d159d$var$Y6.test(e), $e68ba20b3d2d159d$var$sr = (e)=>{
        let [t, r] = e;
        return {
            x: t,
            y: r
        };
    }, $e68ba20b3d2d159d$var$$m = (e)=>{
        if (e?.name === "AbortError") {
            console.warn(e);
            return;
        }
        throw e;
    }, $e68ba20b3d2d159d$var$sf = (e, t, r = 0)=>{
        r < 0 && (r = e.length + r), r = Math.min(e.length, Math.max(r, 0));
        let o = r - 1;
        for(; ++o < e.length;)if (t(e[o], o, e)) return o;
        return -1;
    }, $e68ba20b3d2d159d$var$lf = (e, t, r = e.length - 1)=>{
        r < 0 && (r = e.length + r), r = Math.min(e.length - 1, Math.max(r, 0));
        let o = r + 1;
        for(; --o > -1;)if (t(e[o], o, e)) return o;
        return -1;
    }, $e68ba20b3d2d159d$var$Rr = (e)=>{
        let t = e.length === 5 && e.substr(4, 1) === "0", r = e.length === 9 && e.substr(7, 2) === "00";
        return t || r || e === $e68ba20b3d2d159d$var$fe.transparent;
    }, $e68ba20b3d2d159d$var$Zm = ()=>{
        let e, t, r = new Promise((o, n)=>{
            e = o, t = n;
        });
        return r.resolve = e, r.reject = t, r;
    }, $e68ba20b3d2d159d$var$Y0 = (e)=>{
        let t = e.parentElement;
        for(; t;){
            if (t === document.body) return document;
            let { overflowY: r } = window.getComputedStyle(t);
            if (t.scrollHeight > t.clientHeight && (r === "auto" || r === "scroll" || r === "overlay")) return t;
            t = t.parentElement;
        }
        return document;
    }, $e68ba20b3d2d159d$var$X0 = (e)=>{
        let t = e.parentElement;
        for(; t;){
            if (t.tabIndex > -1) {
                t.focus();
                return;
            }
            t = t.parentElement;
        }
    }, $e68ba20b3d2d159d$var$K0 = (e)=>{
        e.preventDefault(), e.returnValue = "";
    }, $e68ba20b3d2d159d$var$$0 = (e)=>Array.from(e).map((t)=>`0${t.toString(16)}`.slice(-2)).join(""), $e68ba20b3d2d159d$var$ci = ()=>$e68ba20b3d2d159d$var$Zr() ? 1 : Date.now(), $e68ba20b3d2d159d$var$j = (e)=>e instanceof Map ? e : e.reduce((t, r)=>(t.set(typeof r == "string" ? r : r.id, r), t), new Map), $e68ba20b3d2d159d$var$Z0 = (e)=>e.reduce((t, r, o)=>(t.set(r.id, [
                r,
                o
            ]), t), new Map), $e68ba20b3d2d159d$var$Pn = (e, t)=>e.reduce((r, o)=>(r[t ? t(o) : String(o)] = o, r), {}), $e68ba20b3d2d159d$var$j0 = (e)=>e.reduce((t, r, o)=>{
            let n = {
                ...r,
                prev: null,
                next: null
            };
            if (o !== 0) {
                let i = t[o - 1];
                if (n.prev = i, i.next = n, o === e.length - 1) {
                    let a = t[0];
                    n.next = a, a.prev = n;
                }
            }
            return t.push(n), t;
        }, []), $e68ba20b3d2d159d$var$Zr = ()=>$e68ba20b3d2d159d$var$T.MODE === "test", $e68ba20b3d2d159d$var$q0 = ()=>$e68ba20b3d2d159d$var$T.MODE === "development", $e68ba20b3d2d159d$var$jm = (e, t)=>new CustomEvent(e, {
            detail: {
                nativeEvent: t
            },
            cancelable: !0
        }), $e68ba20b3d2d159d$var$Ks = (e, t)=>{
        let r = !1;
        for(let o in t){
            let n = t[o];
            if (typeof n < "u") {
                if (e[o] === n && (typeof n != "object" || n === null)) continue;
                r = !0;
            }
        }
        return r ? {
            ...e,
            ...t
        } : e;
    }, $e68ba20b3d2d159d$var$J0 = ()=>{
        try {
            return window.self === window.top ? "top" : "iframe";
        } catch  {
            return "iframe";
        }
    }, $e68ba20b3d2d159d$var$Ln = (e)=>!!e && typeof e == "object" && "then" in e && "catch" in e && "finally" in e, $e68ba20b3d2d159d$var$Pc = (e)=>{
        let t = e?.querySelectorAll("button, a, input, select, textarea, div[tabindex], label[tabindex]");
        return t ? Array.from(t).filter((r)=>r.tabIndex > -1 && !r.disabled) : [];
    }, $e68ba20b3d2d159d$var$H0 = (e, t)=>Array.isArray(e) && Array.isArray(t) && e.length === 0 && t.length === 0 ? !0 : e === t, $e68ba20b3d2d159d$var$at = (e, t, r, o = !1)=>{
        let n = Object.keys(e), i = Object.keys(t);
        if (n.length !== i.length) return o && console.warn("%cisShallowEqual: objects don't have same properties ->", "color: #8B4000", e, t), !1;
        if (r && Array.isArray(r)) {
            for (let a of r)if (!(e[a] === t[a] || $e68ba20b3d2d159d$var$H0(e[a], t[a]))) return o && console.warn(`%cisShallowEqual: ${a} not equal ->`, "color: #8B4000", e[a], t[a]), !1;
            return !0;
        }
        return n.every((a)=>{
            let s = r?.[a], l = s ? s(e[a], t[a]) : e[a] === t[a] || $e68ba20b3d2d159d$var$H0(e[a], t[a]);
            return !l && o && console.warn(`%cisShallowEqual: ${a} not equal ->`, "color: #8B4000", e[a], t[a]), l;
        });
    }, $e68ba20b3d2d159d$var$Ui = (e, t, { checkForDefaultPrevented: r = !0 } = {})=>function(n) {
            if (e?.(n), !r || !n?.defaultPrevented) return t?.(n);
        }, $e68ba20b3d2d159d$var$Zo = (e, t, r)=>{
        if (!t) return e;
        if (r) return console.error(t), e;
        throw new Error(t);
    };
    $e68ba20b3d2d159d$var$Q0 = (e)=>{
        let t, r, o = function(n) {
            let i = Object.entries(n);
            if (t) {
                let s = !0;
                for (let [l, c] of i)if (t.get(l) !== c) {
                    s = !1;
                    break;
                }
                if (s) return r;
            }
            let a = e(n);
            return t = new Map(i), r = a, a;
        };
        return o.clear = ()=>{
            t = void 0, r = void 0;
        }, o;
    }, $e68ba20b3d2d159d$var$qm = (e, t)=>e instanceof Set || e instanceof Map ? e.has(t) : "includes" in e ? e.includes(t) : e.hasOwnProperty(t), $e68ba20b3d2d159d$var$jr = (e)=>JSON.parse(JSON.stringify(e)), $e68ba20b3d2d159d$var$Ha = (e)=>typeof e == "number" && Number.isFinite(e), $e68ba20b3d2d159d$var$Jm = (e, t)=>$e68ba20b3d2d159d$var$at(e, t) ? e : t;
    $e68ba20b3d2d159d$var$Ym = (e, t)=>(e + t) / 2;
    $e68ba20b3d2d159d$var$Qm = (e)=>e.replace(/\r?\n|\r/g, `
`), $e68ba20b3d2d159d$var$lr = (e)=>e, $e68ba20b3d2d159d$var$Dc = async (e, ...t)=>new Promise((r)=>{
            r(e(...t));
        }), $e68ba20b3d2d159d$var$ty = (...e)=>Math.max(...e.map((t)=>t ? 1 : 0)) > 0;
});
var $e68ba20b3d2d159d$var$Nr, $e68ba20b3d2d159d$var$Ao, $e68ba20b3d2d159d$var$Rt, $e68ba20b3d2d159d$var$Mo, $e68ba20b3d2d159d$var$cr, $e68ba20b3d2d159d$var$G, $e68ba20b3d2d159d$var$ep, $e68ba20b3d2d159d$var$$s, $e68ba20b3d2d159d$var$re, $e68ba20b3d2d159d$var$qt, $e68ba20b3d2d159d$var$X6, $e68ba20b3d2d159d$export$5df2ebb939539835, $e68ba20b3d2d159d$var$ie, $e68ba20b3d2d159d$var$ce, $e68ba20b3d2d159d$var$_c, $e68ba20b3d2d159d$var$qr, $e68ba20b3d2d159d$var$cf, $e68ba20b3d2d159d$var$po, $e68ba20b3d2d159d$var$ry, $e68ba20b3d2d159d$var$oy, $e68ba20b3d2d159d$var$Dn, $e68ba20b3d2d159d$var$Rc, $e68ba20b3d2d159d$var$Ua, $e68ba20b3d2d159d$var$It, $e68ba20b3d2d159d$var$Ge, $e68ba20b3d2d159d$var$_n, $e68ba20b3d2d159d$var$ny, $e68ba20b3d2d159d$var$iy, $e68ba20b3d2d159d$var$ay, $e68ba20b3d2d159d$var$df, $e68ba20b3d2d159d$var$de = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Nr = (e)=>!!e && e.type === "image" && !!e.fileId, $e68ba20b3d2d159d$var$Ao = (e)=>!!e && e.type === "image", $e68ba20b3d2d159d$var$Rt = (e)=>!!e && e.type === "embeddable", $e68ba20b3d2d159d$var$Mo = (e)=>!!e && e.type === "iframe", $e68ba20b3d2d159d$var$cr = (e)=>!!e && (e.type === "iframe" || e.type === "embeddable"), $e68ba20b3d2d159d$var$G = (e)=>e != null && e.type === "text", $e68ba20b3d2d159d$var$ep = (e)=>e != null && e.type === "frame", $e68ba20b3d2d159d$var$$s = (e)=>e != null && e.type === "magicframe", $e68ba20b3d2d159d$var$re = (e)=>e != null && (e.type === "frame" || e.type === "magicframe"), $e68ba20b3d2d159d$var$qt = (e)=>e != null && $e68ba20b3d2d159d$var$X6(e.type), $e68ba20b3d2d159d$var$X6 = (e)=>e === "freedraw", $e68ba20b3d2d159d$export$5df2ebb939539835 = (e)=>e != null && $e68ba20b3d2d159d$var$_c(e.type), $e68ba20b3d2d159d$var$ie = (e)=>e != null && e.type === "arrow", $e68ba20b3d2d159d$var$ce = (e)=>$e68ba20b3d2d159d$var$ie(e) && e.elbowed, $e68ba20b3d2d159d$var$_c = (e)=>e === "arrow" || e === "line", $e68ba20b3d2d159d$var$qr = (e, t = !0)=>e != null && (!e.locked || t === !0) && $e68ba20b3d2d159d$var$cf(e.type), $e68ba20b3d2d159d$var$cf = (e)=>e === "arrow", $e68ba20b3d2d159d$var$po = (e, t = !0)=>e != null && (!e.locked || t === !0) && (e.type === "rectangle" || e.type === "diamond" || e.type === "ellipse" || e.type === "image" || e.type === "iframe" || e.type === "embeddable" || e.type === "frame" || e.type === "magicframe" || e.type === "text" && !e.containerId), $e68ba20b3d2d159d$var$ry = (e)=>e != null && (e.type === "rectangle" || e.type === "diamond" || e.type === "image" || e.type === "iframe" || e.type === "embeddable" || e.type === "frame" || e.type === "magicframe" || e.type === "text" && !e.containerId), $e68ba20b3d2d159d$var$oy = (e)=>e != null && (e.type === "rectangle" || e.type === "image" || e.type === "text" || e.type === "iframe" || e.type === "embeddable" || e.type === "frame" || e.type === "magicframe"), $e68ba20b3d2d159d$var$Dn = (e, t = !0)=>e != null && (!e.locked || t === !0) && (e.type === "rectangle" || e.type === "diamond" || e.type === "ellipse" || $e68ba20b3d2d159d$var$ie(e)), $e68ba20b3d2d159d$var$Rc = (e)=>{
        let t = e?.type;
        if (!t) return !1;
        switch(t){
            case "text":
            case "diamond":
            case "rectangle":
            case "iframe":
            case "embeddable":
            case "ellipse":
            case "arrow":
            case "freedraw":
            case "line":
            case "frame":
            case "magicframe":
            case "image":
            case "selection":
                return !0;
            default:
                return $e68ba20b3d2d159d$var$Zo(t, null), !1;
        }
    }, $e68ba20b3d2d159d$var$Ua = (e)=>e.type === "rectangle" || e.type === "ellipse" || e.type === "diamond", $e68ba20b3d2d159d$var$It = (e)=>$e68ba20b3d2d159d$var$Dn(e) && !!e.boundElements?.some(({ type: t })=>t === "text"), $e68ba20b3d2d159d$var$Ge = (e)=>e !== null && "containerId" in e && e.containerId !== null && $e68ba20b3d2d159d$var$G(e), $e68ba20b3d2d159d$var$_n = (e)=>e === "rectangle" || e === "embeddable" || e === "iframe" || e === "image", $e68ba20b3d2d159d$var$ny = (e)=>e === "line" || e === "arrow" || e === "diamond", $e68ba20b3d2d159d$var$iy = (e, t)=>!!((e === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS || e === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.LEGACY) && $e68ba20b3d2d159d$var$_n(t.type) || e === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS && $e68ba20b3d2d159d$var$ny(t.type)), $e68ba20b3d2d159d$var$ay = (e)=>$e68ba20b3d2d159d$var$ny(e.type) ? {
            type: $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
        } : $e68ba20b3d2d159d$var$_n(e.type) ? {
            type: $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS
        } : null, $e68ba20b3d2d159d$var$df = (e)=>e.fixedPoint != null;
});
var $e68ba20b3d2d159d$var$Z6, $e68ba20b3d2d159d$var$j6, $e68ba20b3d2d159d$var$ko, $e68ba20b3d2d159d$var$Vt, $e68ba20b3d2d159d$var$jo = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Z6 = new (0, $6783b31e8a74aa35$export$a92776769f460054)(Date.now()), $e68ba20b3d2d159d$var$j6 = 0, $e68ba20b3d2d159d$var$ko = ()=>Math.floor($e68ba20b3d2d159d$var$Z6.next() * 2 ** 31), $e68ba20b3d2d159d$var$Vt = ()=>$e68ba20b3d2d159d$var$Zr() ? `id${$e68ba20b3d2d159d$var$j6++}` : (0, $363a23d82a2fc856$export$ac4959f4f1338dfc)();
});
var $e68ba20b3d2d159d$var$tp, $e68ba20b3d2d159d$var$Rn, $e68ba20b3d2d159d$var$qo, $e68ba20b3d2d159d$var$rp, $e68ba20b3d2d159d$var$Gi = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$tp = class extends Error {
        constructor(t = "Couldn't export canvas.", r = "CANVAS_ERROR"){
            super(), this.name = r, this.message = t;
        }
    }, $e68ba20b3d2d159d$var$Rn = class extends DOMException {
        constructor(t = "Request Aborted"){
            super(t, "AbortError");
        }
    }, $e68ba20b3d2d159d$var$qo = class extends Error {
        code;
        constructor(t = "Image Scene Data Error", r = "IMAGE_SCENE_DATA_ERROR"){
            super(t), this.name = "EncodingError", this.code = r;
        }
    }, $e68ba20b3d2d159d$var$rp = class extends Error {
        code = "ELEMENT_HAS_INVALID_INDEX";
    };
});
var $e68ba20b3d2d159d$var$q6, $e68ba20b3d2d159d$var$dr, $e68ba20b3d2d159d$var$J6, $e68ba20b3d2d159d$var$sy, $e68ba20b3d2d159d$var$op, $e68ba20b3d2d159d$var$ly, $e68ba20b3d2d159d$var$Jr, $e68ba20b3d2d159d$var$Jo, $e68ba20b3d2d159d$var$Qr = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$yr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$q6 = $e68ba20b3d2d159d$var$Xs.includes(devicePixelRatio) ? devicePixelRatio : 1, $e68ba20b3d2d159d$var$dr = ()=>({
            showWelcomeScreen: !1,
            theme: $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT,
            collaborators: new Map,
            currentChartType: "bar",
            currentItemBackgroundColor: $e68ba20b3d2d159d$var$mt.backgroundColor,
            currentItemEndArrowhead: "arrow",
            currentItemFillStyle: $e68ba20b3d2d159d$var$mt.fillStyle,
            currentItemFontFamily: $e68ba20b3d2d159d$var$vr,
            currentItemFontSize: $e68ba20b3d2d159d$var$wr,
            currentItemOpacity: $e68ba20b3d2d159d$var$mt.opacity,
            currentItemRoughness: $e68ba20b3d2d159d$var$mt.roughness,
            currentItemStartArrowhead: null,
            currentItemStrokeColor: $e68ba20b3d2d159d$var$mt.strokeColor,
            currentItemRoundness: "round",
            currentItemArrowType: $e68ba20b3d2d159d$var$_t.round,
            currentItemStrokeStyle: $e68ba20b3d2d159d$var$mt.strokeStyle,
            currentItemStrokeWidth: $e68ba20b3d2d159d$var$mt.strokeWidth,
            currentItemTextAlign: $e68ba20b3d2d159d$var$An,
            currentHoveredFontFamily: null,
            cursorButton: "up",
            activeEmbeddable: null,
            newElement: null,
            editingTextElement: null,
            editingGroupId: null,
            editingLinearElement: null,
            activeTool: {
                type: "selection",
                customType: null,
                locked: $e68ba20b3d2d159d$var$mt.locked,
                lastActiveTool: null
            },
            penMode: !1,
            penDetected: !1,
            errorMessage: null,
            exportBackground: !0,
            exportScale: $e68ba20b3d2d159d$var$q6,
            exportEmbedScene: !1,
            exportWithDarkMode: !1,
            fileHandle: null,
            gridSize: $e68ba20b3d2d159d$var$Fa,
            gridStep: $e68ba20b3d2d159d$var$Rm,
            gridModeEnabled: !1,
            isBindingEnabled: !0,
            defaultSidebarDockedPreference: !1,
            isLoading: !1,
            isResizing: !1,
            isRotating: !1,
            lastPointerDownWith: "mouse",
            multiElement: null,
            name: null,
            contextMenu: null,
            openMenu: null,
            openPopup: null,
            openSidebar: null,
            openDialog: null,
            pasteDialog: {
                shown: !1,
                data: null
            },
            previousSelectedElementIds: {},
            resizingElement: null,
            scrolledOutside: !1,
            scrollX: 0,
            scrollY: 0,
            selectedElementIds: {},
            selectedGroupIds: {},
            selectedElementsAreBeingDragged: !1,
            selectionElement: null,
            shouldCacheIgnoreZoom: !1,
            stats: {
                open: !1,
                panels: $e68ba20b3d2d159d$var$Bi.generalStats | $e68ba20b3d2d159d$var$Bi.elementProperties
            },
            startBoundElement: null,
            suggestedBindings: [],
            frameRendering: {
                enabled: !0,
                clip: !0,
                name: !0,
                outline: !0
            },
            frameToHighlight: null,
            editingFrame: null,
            elementsToHighlight: null,
            toast: null,
            viewBackgroundColor: $e68ba20b3d2d159d$var$fe.white,
            zenModeEnabled: !1,
            zoom: {
                value: 1
            },
            viewModeEnabled: !1,
            pendingImageElementId: null,
            showHyperlinkPopup: !1,
            selectedLinearElement: null,
            snapLines: [],
            originSnapOffset: {
                x: 0,
                y: 0
            },
            objectsSnapModeEnabled: !1,
            userToFollow: null,
            followedBy: new Set
        }), $e68ba20b3d2d159d$var$J6 = ((e)=>e)({
        showWelcomeScreen: {
            browser: !0,
            export: !1,
            server: !1
        },
        theme: {
            browser: !0,
            export: !1,
            server: !1
        },
        collaborators: {
            browser: !1,
            export: !1,
            server: !1
        },
        currentChartType: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemBackgroundColor: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemEndArrowhead: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemFillStyle: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemFontFamily: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemFontSize: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemRoundness: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemArrowType: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemOpacity: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemRoughness: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemStartArrowhead: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemStrokeColor: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemStrokeStyle: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemStrokeWidth: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentItemTextAlign: {
            browser: !0,
            export: !1,
            server: !1
        },
        currentHoveredFontFamily: {
            browser: !1,
            export: !1,
            server: !1
        },
        cursorButton: {
            browser: !0,
            export: !1,
            server: !1
        },
        activeEmbeddable: {
            browser: !1,
            export: !1,
            server: !1
        },
        newElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        editingTextElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        editingGroupId: {
            browser: !0,
            export: !1,
            server: !1
        },
        editingLinearElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        activeTool: {
            browser: !0,
            export: !1,
            server: !1
        },
        penMode: {
            browser: !0,
            export: !1,
            server: !1
        },
        penDetected: {
            browser: !0,
            export: !1,
            server: !1
        },
        errorMessage: {
            browser: !1,
            export: !1,
            server: !1
        },
        exportBackground: {
            browser: !0,
            export: !1,
            server: !1
        },
        exportEmbedScene: {
            browser: !0,
            export: !1,
            server: !1
        },
        exportScale: {
            browser: !0,
            export: !1,
            server: !1
        },
        exportWithDarkMode: {
            browser: !0,
            export: !1,
            server: !1
        },
        fileHandle: {
            browser: !1,
            export: !1,
            server: !1
        },
        gridSize: {
            browser: !0,
            export: !0,
            server: !0
        },
        gridStep: {
            browser: !0,
            export: !0,
            server: !0
        },
        gridModeEnabled: {
            browser: !0,
            export: !0,
            server: !0
        },
        height: {
            browser: !1,
            export: !1,
            server: !1
        },
        isBindingEnabled: {
            browser: !1,
            export: !1,
            server: !1
        },
        defaultSidebarDockedPreference: {
            browser: !0,
            export: !1,
            server: !1
        },
        isLoading: {
            browser: !1,
            export: !1,
            server: !1
        },
        isResizing: {
            browser: !1,
            export: !1,
            server: !1
        },
        isRotating: {
            browser: !1,
            export: !1,
            server: !1
        },
        lastPointerDownWith: {
            browser: !0,
            export: !1,
            server: !1
        },
        multiElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        name: {
            browser: !0,
            export: !1,
            server: !1
        },
        offsetLeft: {
            browser: !1,
            export: !1,
            server: !1
        },
        offsetTop: {
            browser: !1,
            export: !1,
            server: !1
        },
        contextMenu: {
            browser: !1,
            export: !1,
            server: !1
        },
        openMenu: {
            browser: !0,
            export: !1,
            server: !1
        },
        openPopup: {
            browser: !1,
            export: !1,
            server: !1
        },
        openSidebar: {
            browser: !0,
            export: !1,
            server: !1
        },
        openDialog: {
            browser: !1,
            export: !1,
            server: !1
        },
        pasteDialog: {
            browser: !1,
            export: !1,
            server: !1
        },
        previousSelectedElementIds: {
            browser: !0,
            export: !1,
            server: !1
        },
        resizingElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        scrolledOutside: {
            browser: !0,
            export: !1,
            server: !1
        },
        scrollX: {
            browser: !0,
            export: !1,
            server: !1
        },
        scrollY: {
            browser: !0,
            export: !1,
            server: !1
        },
        selectedElementIds: {
            browser: !0,
            export: !1,
            server: !1
        },
        selectedGroupIds: {
            browser: !0,
            export: !1,
            server: !1
        },
        selectedElementsAreBeingDragged: {
            browser: !1,
            export: !1,
            server: !1
        },
        selectionElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        shouldCacheIgnoreZoom: {
            browser: !0,
            export: !1,
            server: !1
        },
        stats: {
            browser: !0,
            export: !1,
            server: !1
        },
        startBoundElement: {
            browser: !1,
            export: !1,
            server: !1
        },
        suggestedBindings: {
            browser: !1,
            export: !1,
            server: !1
        },
        frameRendering: {
            browser: !1,
            export: !1,
            server: !1
        },
        frameToHighlight: {
            browser: !1,
            export: !1,
            server: !1
        },
        editingFrame: {
            browser: !1,
            export: !1,
            server: !1
        },
        elementsToHighlight: {
            browser: !1,
            export: !1,
            server: !1
        },
        toast: {
            browser: !1,
            export: !1,
            server: !1
        },
        viewBackgroundColor: {
            browser: !0,
            export: !0,
            server: !0
        },
        width: {
            browser: !1,
            export: !1,
            server: !1
        },
        zenModeEnabled: {
            browser: !0,
            export: !1,
            server: !1
        },
        zoom: {
            browser: !0,
            export: !1,
            server: !1
        },
        viewModeEnabled: {
            browser: !1,
            export: !1,
            server: !1
        },
        pendingImageElementId: {
            browser: !1,
            export: !1,
            server: !1
        },
        showHyperlinkPopup: {
            browser: !1,
            export: !1,
            server: !1
        },
        selectedLinearElement: {
            browser: !0,
            export: !1,
            server: !1
        },
        snapLines: {
            browser: !1,
            export: !1,
            server: !1
        },
        originSnapOffset: {
            browser: !1,
            export: !1,
            server: !1
        },
        objectsSnapModeEnabled: {
            browser: !0,
            export: !1,
            server: !1
        },
        userToFollow: {
            browser: !1,
            export: !1,
            server: !1
        },
        followedBy: {
            browser: !1,
            export: !1,
            server: !1
        }
    }), $e68ba20b3d2d159d$var$sy = (e, t)=>{
        let r = {};
        for (let o of Object.keys(e))if ($e68ba20b3d2d159d$var$J6[o]?.[t]) {
            let i = e[o];
            r[o] = i;
        }
        return r;
    }, $e68ba20b3d2d159d$var$op = (e)=>$e68ba20b3d2d159d$var$sy(e, "export"), $e68ba20b3d2d159d$var$ly = (e)=>$e68ba20b3d2d159d$var$sy(e, "server"), $e68ba20b3d2d159d$var$Jr = ({ activeTool: e })=>e.type === "eraser", $e68ba20b3d2d159d$var$Jo = ({ activeTool: e })=>e.type === "hand";
});
var $e68ba20b3d2d159d$var$mf, $e68ba20b3d2d159d$var$mr, $e68ba20b3d2d159d$var$np, $e68ba20b3d2d159d$var$pf, $e68ba20b3d2d159d$var$Qo, $e68ba20b3d2d159d$var$ip, $e68ba20b3d2d159d$var$cy, $e68ba20b3d2d159d$var$Ga, $e68ba20b3d2d159d$var$nt, $e68ba20b3d2d159d$var$dy, $e68ba20b3d2d159d$var$my, $e68ba20b3d2d159d$var$py, $e68ba20b3d2d159d$var$uy, $e68ba20b3d2d159d$var$Wa, $e68ba20b3d2d159d$var$hy, $e68ba20b3d2d159d$var$gy, $e68ba20b3d2d159d$var$Nn, $e68ba20b3d2d159d$var$Yt = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Wi();
    $e68ba20b3d2d159d$var$mf = (e, t, r)=>{
        let o = r.reduce((n, i)=>(i.groupIds.includes(e) && (n[i.id] = !0), n), {});
        return Object.keys(o).length < 2 ? t.selectedGroupIds[e] || t.editingGroupId === e ? {
            selectedElementIds: t.selectedElementIds,
            selectedGroupIds: {
                ...t.selectedGroupIds,
                [e]: !1
            },
            editingGroupId: null
        } : t : {
            editingGroupId: t.editingGroupId,
            selectedGroupIds: {
                ...t.selectedGroupIds,
                [e]: !0
            },
            selectedElementIds: {
                ...t.selectedElementIds,
                ...o
            }
        };
    }, $e68ba20b3d2d159d$var$mr = function() {
        let e = null, t = null, r = null, o = (i, a, s, l)=>{
            if (r !== void 0 && a === t && i === e && s.editingGroupId === r?.editingGroupId) return r;
            let c = {};
            for (let p of i){
                let u = p.groupIds;
                if (s.editingGroupId) {
                    let h = u.indexOf(s.editingGroupId);
                    h > -1 && (u = u.slice(0, h));
                }
                if (u.length > 0) {
                    let h = u[u.length - 1];
                    c[h] = !0;
                }
            }
            let d = {}, m = a.reduce((p, u)=>{
                let h = u.groupIds.find((g)=>c[g]);
                return h && (p[u.id] = !0, Array.isArray(d[h]) ? d[h].push(u.id) : d[h] = [
                    u.id
                ]), p;
            }, {});
            for (let p of Object.keys(d))d[p].length < 2 && c[p] && (c[p] = !1);
            return t = a, e = i, r = {
                editingGroupId: s.editingGroupId,
                selectedGroupIds: c,
                selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                    ...s.selectedElementIds,
                    ...m
                }, l)
            }, r;
        }, n = (i, a, s, l)=>{
            let c = l ? l.scene.getSelectedElements({
                selectedElementIds: i.selectedElementIds,
                elements: a
            }) : $e68ba20b3d2d159d$var$pe(a, i);
            return c.length ? o(c, a, i, s) : {
                selectedGroupIds: {},
                editingGroupId: null,
                selectedElementIds: $e68ba20b3d2d159d$var$Fe(i.selectedElementIds, s)
            };
        };
        return n.clearCache = ()=>{
            t = null, e = null, r = null;
        }, n;
    }(), $e68ba20b3d2d159d$var$np = (e, t)=>$e68ba20b3d2d159d$var$pf(e, t) != null, $e68ba20b3d2d159d$var$pf = (e, t)=>t.groupIds.filter((r)=>r !== e.editingGroupId).find((r)=>e.selectedGroupIds[r]), $e68ba20b3d2d159d$var$Qo = (e)=>Object.entries(e.selectedGroupIds).filter(([t, r])=>r).map(([t, r])=>t), $e68ba20b3d2d159d$var$ip = (e, t)=>{
        let r = {
            ...t,
            selectedGroupIds: {}
        };
        for (let o of e){
            let n = o.groupIds;
            if (t.editingGroupId) {
                let i = n.indexOf(t.editingGroupId);
                i > -1 && (n = n.slice(0, i));
            }
            if (n.length > 0) {
                let i = n[n.length - 1];
                r = {
                    ...r,
                    ...$e68ba20b3d2d159d$var$mf(i, r, e)
                };
            }
        }
        return r.selectedGroupIds;
    }, $e68ba20b3d2d159d$var$cy = (e, t)=>({
            ...e,
            editingGroupId: t.groupIds.length ? t.groupIds[0] : null,
            selectedGroupIds: {},
            selectedElementIds: {
                [t.id]: !0
            }
        }), $e68ba20b3d2d159d$var$Ga = (e, t)=>e.groupIds.includes(t), $e68ba20b3d2d159d$var$nt = (e, t)=>{
        let r = [];
        for (let o of e.values())$e68ba20b3d2d159d$var$Ga(o, t) && r.push(o);
        return r;
    }, $e68ba20b3d2d159d$var$dy = (e, t)=>e.groupIds.find((r)=>t[r]), $e68ba20b3d2d159d$var$my = (e, t, r)=>{
        let o = [
            ...e
        ], n = t ? e.indexOf(t) : -1, i = n > -1 ? n : e.length;
        for(let a = 0; a < i; a++)o[a] = r(o[a]);
        return o;
    }, $e68ba20b3d2d159d$var$py = (e, t, r)=>{
        let o = [
            ...e
        ], n = r ? o.indexOf(r) : -1, i = n > -1 ? n : o.length;
        return o.splice(i, 0, t), o;
    }, $e68ba20b3d2d159d$var$uy = (e, t)=>e.filter((r)=>!t[r]), $e68ba20b3d2d159d$var$Wa = (e, t)=>{
        let r = new Map;
        return e.forEach((o)=>{
            let n = o.groupIds.length === 0 ? o.id : o.groupIds[o.groupIds.length - 1], i = r.get(n) || [], a = $e68ba20b3d2d159d$var$te(o, t);
            a && i.push(a), r.set(n, [
                ...i,
                o
            ]);
        }), Array.from(r.values());
    }, $e68ba20b3d2d159d$var$hy = (e)=>{
        let t = new Set;
        for (let [, r] of e)if (!r.isDeleted) for (let o of r.groupIds ?? [])t.add(o);
        return t;
    }, $e68ba20b3d2d159d$var$gy = (e)=>{
        let t = e.flatMap((n)=>n.groupIds), r = new Map, o = 0;
        for (let n of t)r.set(n, (r.get(n) ?? 0) + 1), r.get(n) > o && (o = r.get(n));
        return o === e.length;
    }, $e68ba20b3d2d159d$var$Nn = (e)=>e.groupIds.length > 0;
});
var $e68ba20b3d2d159d$var$ap, $e68ba20b3d2d159d$export$fc49cccc588ff0d4, $e68ba20b3d2d159d$var$sp, $e68ba20b3d2d159d$var$lp, $e68ba20b3d2d159d$var$Va = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ap = (e)=>e.replace(/"/g, "&quot;"), $e68ba20b3d2d159d$export$fc49cccc588ff0d4 = (e)=>(e = e.trim(), e && (0, $2ujND.sanitizeUrl)($e68ba20b3d2d159d$var$ap(e))), $e68ba20b3d2d159d$var$sp = (e)=>!!(e?.includes(location.origin) || e?.startsWith("/")), $e68ba20b3d2d159d$var$lp = (e)=>{
        if (e = $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e), e.startsWith("/")) return `${location.origin}${e}`;
        try {
            new URL(e);
        } catch  {
            return "about:blank";
        }
        return e;
    };
});
var $e68ba20b3d2d159d$var$cp, $e68ba20b3d2d159d$var$U, $e68ba20b3d2d159d$var$je = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$cp = [], $e68ba20b3d2d159d$var$U = (e)=>($e68ba20b3d2d159d$var$cp = $e68ba20b3d2d159d$var$cp.concat(e), e);
});
var $e68ba20b3d2d159d$var$Ey, $e68ba20b3d2d159d$var$eM, $e68ba20b3d2d159d$var$xy, $e68ba20b3d2d159d$var$tM, $e68ba20b3d2d159d$var$rM, $e68ba20b3d2d159d$var$uo, $e68ba20b3d2d159d$var$qe, $e68ba20b3d2d159d$var$On, $e68ba20b3d2d159d$var$fy, $e68ba20b3d2d159d$var$uf, $e68ba20b3d2d159d$var$ho, $e68ba20b3d2d159d$var$Zs = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$Ey = '<svg viewBox="0 0 24 24" stroke-width="1" width="28" height="28" xmlns="http://www.w3.org/2000/svg">', $e68ba20b3d2d159d$var$eM = '<path d="M6.164 11.755a5.314 5.314 0 0 1-4.932-5.298 5.314 5.314 0 0 1 5.311-5.311 5.314 5.314 0 0 1 5.307 5.113l8.773 8.773a3.322 3.322 0 0 1 0 4.696l-.895.895a3.322 3.322 0 0 1-4.696 0l-8.868-8.868Z" style="fill:#fff"/>', $e68ba20b3d2d159d$var$xy = '<path stroke="#1b1b1f" fill="#fff" d="m7.868 11.113 7.773 7.774a2.359 2.359 0 0 0 1.667.691 2.368 2.368 0 0 0 2.357-2.358c0-.625-.248-1.225-.69-1.667L11.201 7.78 9.558 9.469l-1.69 1.643v.001Zm10.273 3.606-3.333 3.333m-3.25-6.583 2 2m-7-7 3 3M3.664 3.625l1 1M2.529 6.922l1.407-.144m5.735-2.932-1.118.866M4.285 9.823l.758-1.194m1.863-6.207-.13 1.408"/>', $e68ba20b3d2d159d$var$tM = `data:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.svg},${encodeURIComponent(`${$e68ba20b3d2d159d$var$Ey}${$e68ba20b3d2d159d$var$xy}</svg>`)}`, $e68ba20b3d2d159d$var$rM = `data:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.svg},${encodeURIComponent(`${$e68ba20b3d2d159d$var$Ey}${$e68ba20b3d2d159d$var$eM}${$e68ba20b3d2d159d$var$xy}</svg>`)}`, $e68ba20b3d2d159d$var$uo = (e)=>{
        e && (e.style.cursor = "");
    }, $e68ba20b3d2d159d$var$qe = (e, t)=>{
        e && (e.style.cursor = t);
    }, $e68ba20b3d2d159d$var$uf = (e, t)=>{
        let o = ()=>{
            let n = t === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK;
            $e68ba20b3d2d159d$var$On = document.createElement("canvas"), $e68ba20b3d2d159d$var$On.theme = t, $e68ba20b3d2d159d$var$On.height = 20, $e68ba20b3d2d159d$var$On.width = 20;
            let i = $e68ba20b3d2d159d$var$On.getContext("2d");
            i.lineWidth = 1, i.beginPath(), i.arc($e68ba20b3d2d159d$var$On.width / 2, $e68ba20b3d2d159d$var$On.height / 2, 5, 0, 2 * Math.PI), i.fillStyle = n ? (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).black : (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white, i.fill(), i.strokeStyle = n ? (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white : (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).black, i.stroke(), $e68ba20b3d2d159d$var$fy = $e68ba20b3d2d159d$var$On.toDataURL($e68ba20b3d2d159d$export$edfb5d7e4280f611.svg);
        };
        (!$e68ba20b3d2d159d$var$On || $e68ba20b3d2d159d$var$On.theme !== t) && o(), $e68ba20b3d2d159d$var$qe(e, `url(${$e68ba20b3d2d159d$var$fy}) ${10} ${10}, auto`);
    }, $e68ba20b3d2d159d$var$ho = (e, t)=>{
        if (e) {
            if (t.activeTool.type === "selection") $e68ba20b3d2d159d$var$uo(e);
            else if ($e68ba20b3d2d159d$var$Jo(t)) e.style.cursor = $e68ba20b3d2d159d$var$Ue.GRAB;
            else if ($e68ba20b3d2d159d$var$Jr(t)) $e68ba20b3d2d159d$var$uf(e, t.theme);
            else if (t.activeTool.type === "laser") {
                let r = t.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? $e68ba20b3d2d159d$var$tM : $e68ba20b3d2d159d$var$rM;
                e.style.cursor = `url(${r}), auto`;
            } else [
                "image",
                "custom"
            ].includes(t.activeTool.type) ? t.activeTool.type !== "image" && (e.style.cursor = $e68ba20b3d2d159d$var$Ue.AUTO) : e.style.cursor = $e68ba20b3d2d159d$var$Ue.CROSSHAIR;
        }
    };
});
var $e68ba20b3d2d159d$var$Oe, $e68ba20b3d2d159d$var$en = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Fn();
    $e68ba20b3d2d159d$var$hf();
    $e68ba20b3d2d159d$var$yr();
    $e68ba20b3d2d159d$var$Oe = class e {
        static rg = new (0, $31af7cd5eabf8e2d$export$e52ef8e5145b365e);
        static cache = new WeakMap;
        static get = (t)=>e.cache.get(t);
        static set = (t, r)=>e.cache.set(t, r);
        static delete = (t)=>e.cache.delete(t);
        static destroy = ()=>{
            e.cache = new WeakMap;
        };
        static generateElementShape = (t, r)=>{
            let o = r?.isExporting ? void 0 : e.get(t);
            if (o !== void 0) return o;
            $e68ba20b3d2d159d$var$mp.delete(t);
            let n = $e68ba20b3d2d159d$var$by(t, e.rg, r || {
                isExporting: !1,
                canvasBackgroundColor: $e68ba20b3d2d159d$var$fe.white,
                embedsValidationStatus: null
            });
            return e.cache.set(t, n), n;
        };
    };
});
var $e68ba20b3d2d159d$var$tn, $e68ba20b3d2d159d$var$yy, $e68ba20b3d2d159d$var$L, $e68ba20b3d2d159d$var$q, $e68ba20b3d2d159d$var$Se, $e68ba20b3d2d159d$var$fB, $e68ba20b3d2d159d$var$pp, $e68ba20b3d2d159d$var$wy, $e68ba20b3d2d159d$var$vy, $e68ba20b3d2d159d$var$Ty, $e68ba20b3d2d159d$var$Ya, $e68ba20b3d2d159d$var$js, $e68ba20b3d2d159d$var$Sy, $e68ba20b3d2d159d$var$Iy, $e68ba20b3d2d159d$var$Cy, $e68ba20b3d2d159d$var$EB, $e68ba20b3d2d159d$var$Ay, $e68ba20b3d2d159d$var$My, $e68ba20b3d2d159d$var$ky, $e68ba20b3d2d159d$var$Py, $e68ba20b3d2d159d$var$Ly, $e68ba20b3d2d159d$var$Dy, $e68ba20b3d2d159d$var$_y, $e68ba20b3d2d159d$var$di, $e68ba20b3d2d159d$var$up, $e68ba20b3d2d159d$var$Ry, $e68ba20b3d2d159d$var$Ny, $e68ba20b3d2d159d$var$gf, $e68ba20b3d2d159d$var$ff, $e68ba20b3d2d159d$var$Oy, $e68ba20b3d2d159d$var$rn, $e68ba20b3d2d159d$var$Fy, $e68ba20b3d2d159d$var$Nc, $e68ba20b3d2d159d$var$Oc, $e68ba20b3d2d159d$var$Fc, $e68ba20b3d2d159d$var$hp, $e68ba20b3d2d159d$var$Xa, $e68ba20b3d2d159d$var$qs, $e68ba20b3d2d159d$var$By, $e68ba20b3d2d159d$var$Ef, $e68ba20b3d2d159d$var$gp, $e68ba20b3d2d159d$var$zy, $e68ba20b3d2d159d$var$Hy, $e68ba20b3d2d159d$var$Uy, $e68ba20b3d2d159d$var$Bc, $e68ba20b3d2d159d$var$Gy, $e68ba20b3d2d159d$var$Wy, $e68ba20b3d2d159d$var$Js, $e68ba20b3d2d159d$var$xB, $e68ba20b3d2d159d$var$Vy, $e68ba20b3d2d159d$var$fp, $e68ba20b3d2d159d$var$Ep, $e68ba20b3d2d159d$var$Yy, $e68ba20b3d2d159d$var$bB, $e68ba20b3d2d159d$var$yB, $e68ba20b3d2d159d$var$Xy, $e68ba20b3d2d159d$var$wB, $e68ba20b3d2d159d$var$xf, $e68ba20b3d2d159d$var$bf, $e68ba20b3d2d159d$var$Ky, $e68ba20b3d2d159d$var$$y, $e68ba20b3d2d159d$var$vB, $e68ba20b3d2d159d$var$TB, $e68ba20b3d2d159d$var$SB, $e68ba20b3d2d159d$var$IB, $e68ba20b3d2d159d$var$CB, $e68ba20b3d2d159d$var$Zy, $e68ba20b3d2d159d$var$jy, $e68ba20b3d2d159d$var$yf, $e68ba20b3d2d159d$var$wf, $e68ba20b3d2d159d$var$vf, $e68ba20b3d2d159d$var$Tf, $e68ba20b3d2d159d$var$Sf, $e68ba20b3d2d159d$var$If, $e68ba20b3d2d159d$var$Cf, $e68ba20b3d2d159d$var$Af, $e68ba20b3d2d159d$var$qy, $e68ba20b3d2d159d$var$Jy, $e68ba20b3d2d159d$var$Mf, $e68ba20b3d2d159d$var$kf, $e68ba20b3d2d159d$var$xp, $e68ba20b3d2d159d$var$AB, $e68ba20b3d2d159d$var$MB, $e68ba20b3d2d159d$var$Po, $e68ba20b3d2d159d$var$kB, $e68ba20b3d2d159d$var$PB, $e68ba20b3d2d159d$var$LB, $e68ba20b3d2d159d$var$Pf, $e68ba20b3d2d159d$var$Lf, $e68ba20b3d2d159d$var$Qy, $e68ba20b3d2d159d$var$ew, $e68ba20b3d2d159d$var$tw, $e68ba20b3d2d159d$var$rw, $e68ba20b3d2d159d$var$Df, $e68ba20b3d2d159d$var$ow, $e68ba20b3d2d159d$var$nw, $e68ba20b3d2d159d$var$DB, $e68ba20b3d2d159d$var$iw, $e68ba20b3d2d159d$var$aw, $e68ba20b3d2d159d$var$sw, $e68ba20b3d2d159d$var$lw, $e68ba20b3d2d159d$var$cw, $e68ba20b3d2d159d$var$dw, $e68ba20b3d2d159d$var$mw, $e68ba20b3d2d159d$var$pw, $e68ba20b3d2d159d$var$uw, $e68ba20b3d2d159d$var$_f, $e68ba20b3d2d159d$var$hw, $e68ba20b3d2d159d$var$gw, $e68ba20b3d2d159d$var$fw, $e68ba20b3d2d159d$var$Ew, $e68ba20b3d2d159d$var$xw, $e68ba20b3d2d159d$var$bw, $e68ba20b3d2d159d$var$yw, $e68ba20b3d2d159d$var$ww, $e68ba20b3d2d159d$var$vw, $e68ba20b3d2d159d$var$Tw, $e68ba20b3d2d159d$var$Ka, $e68ba20b3d2d159d$var$Sw, $e68ba20b3d2d159d$var$Qs, $e68ba20b3d2d159d$var$zc, $e68ba20b3d2d159d$var$Iw, $e68ba20b3d2d159d$var$Cw, $e68ba20b3d2d159d$var$Aw, $e68ba20b3d2d159d$var$Mw, $e68ba20b3d2d159d$var$kw, $e68ba20b3d2d159d$var$Pw, $e68ba20b3d2d159d$var$bp, $e68ba20b3d2d159d$var$Lw, $e68ba20b3d2d159d$var$_B, $e68ba20b3d2d159d$var$yp, $e68ba20b3d2d159d$var$Rf, $e68ba20b3d2d159d$var$wp, $e68ba20b3d2d159d$var$Dw, $e68ba20b3d2d159d$var$_w, $e68ba20b3d2d159d$var$RB, $e68ba20b3d2d159d$var$NB, $e68ba20b3d2d159d$var$Rw, $e68ba20b3d2d159d$var$Nw, $e68ba20b3d2d159d$var$Ow, $e68ba20b3d2d159d$var$Fw, $e68ba20b3d2d159d$var$vp, $e68ba20b3d2d159d$var$Tp, $e68ba20b3d2d159d$var$el, $e68ba20b3d2d159d$var$Sp, $e68ba20b3d2d159d$var$Ip, $e68ba20b3d2d159d$var$OB, $e68ba20b3d2d159d$var$FB, $e68ba20b3d2d159d$var$Bw, $e68ba20b3d2d159d$var$tl, $e68ba20b3d2d159d$var$zw, $e68ba20b3d2d159d$var$Hw, $e68ba20b3d2d159d$var$Uw, $e68ba20b3d2d159d$var$Cp, $e68ba20b3d2d159d$var$Gw, $e68ba20b3d2d159d$var$Ww, $e68ba20b3d2d159d$var$Vw, $e68ba20b3d2d159d$var$Ap, $e68ba20b3d2d159d$var$Yw, $e68ba20b3d2d159d$var$Xw, $e68ba20b3d2d159d$var$Kw, $e68ba20b3d2d159d$var$$w, $e68ba20b3d2d159d$var$Nf, $e68ba20b3d2d159d$var$Mp, $e68ba20b3d2d159d$var$Zw, $e68ba20b3d2d159d$var$jw, $e68ba20b3d2d159d$var$qw, $e68ba20b3d2d159d$var$Jw, $e68ba20b3d2d159d$var$Qw, $e68ba20b3d2d159d$var$BB, $e68ba20b3d2d159d$var$e2, $e68ba20b3d2d159d$var$t2, $e68ba20b3d2d159d$var$r2, $e68ba20b3d2d159d$var$o2, $e68ba20b3d2d159d$var$n2, $e68ba20b3d2d159d$var$i2, $e68ba20b3d2d159d$var$a2, $e68ba20b3d2d159d$var$s2, $e68ba20b3d2d159d$var$oe = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$tn = (e)=>"var(--icon-fill-color)", $e68ba20b3d2d159d$var$yy = (e)=>e === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white : "#1e1e1e", $e68ba20b3d2d159d$var$L = (e, t = 512)=>{
        let { width: r = 512, height: o = r, mirror: n, style: i, ...a } = typeof t == "number" ? {
            width: t
        } : t;
        return (0, $7b02d682eb115277$exports.jsx)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            role: "img",
            viewBox: `0 0 ${r} ${o}`,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                "rtl-mirror": n
            }),
            style: i,
            ...a,
            children: typeof e == "string" ? (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: e
            }) : e
        });
    }, $e68ba20b3d2d159d$var$q = {
        width: 24,
        height: 24,
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, $e68ba20b3d2d159d$var$Se = {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, $e68ba20b3d2d159d$var$fB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: 3,
                y: 8,
                width: 18,
                height: 4,
                rx: 1
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: 12,
                y1: 8,
                x2: 12,
                y2: 21
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$pp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "3",
                y1: "6",
                x2: "3",
                y2: "19"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "6",
                x2: "12",
                y2: "19"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "21",
                y1: "6",
                x2: "21",
                y2: "19"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$wy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("svg", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$vy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "19",
                r: "1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ty = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("svg", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "16",
                x2: "12",
                y2: "21"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "8",
                y1: "4",
                x2: "16",
                y2: "4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ya = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.542 8.542H6.458a2.5 2.5 0 0 0-2.5 2.5v3.75a2.5 2.5 0 0 0 2.5 2.5h7.084a2.5 2.5 0 0 0 2.5-2.5v-3.75a2.5 2.5 0 0 0-2.5-2.5Z",
                stroke: "currentColor",
                strokeWidth: "1.25"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 13.958a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Z",
                stroke: "currentColor",
                strokeWidth: "1.25"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "UnlockedIcon",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 6,
                y: 1,
                width: 9,
                height: 9,
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M6.399 9.561V5.175c0-.93.401-1.823 1.116-2.48a3.981 3.981 0 0 1 2.693-1.028c1.01 0 1.98.37 2.694 1.027.715.658 1.116 1.55 1.116 2.481",
                    fill: "#fff"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#UnlockedIcon)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M5.149 9.561v1.25h2.5v-1.25h-2.5Zm5.06-7.894V.417v1.25Zm2.559 3.508v1.25h2.5v-1.25h-2.5ZM7.648 8.51V5.175h-2.5V8.51h2.5Zm0-3.334c0-.564.243-1.128.713-1.561L6.668 1.775c-.959.883-1.52 2.104-1.52 3.4h2.5Zm.713-1.561a2.732 2.732 0 0 1 1.847-.697v-2.5c-1.31 0-2.585.478-3.54 1.358L8.36 3.614Zm1.847-.697c.71 0 1.374.26 1.847.697l1.694-1.839a5.231 5.231 0 0 0-3.54-1.358v2.5Zm1.847.697c.47.433.713.997.713 1.561h2.5c0-1.296-.56-2.517-1.52-3.4l-1.693 1.839Z",
                    fill: "currentColor"
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$js = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.542 8.542H6.458a2.5 2.5 0 0 0-2.5 2.5v3.75a2.5 2.5 0 0 0 2.5 2.5h7.084a2.5 2.5 0 0 0 2.5-2.5v-3.75a2.5 2.5 0 0 0-2.5-2.5Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 13.958a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.667 8.333V5.417C6.667 3.806 8.159 2.5 10 2.5c1.841 0 3.333 1.306 3.333 2.917v2.916"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Sy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M38.5 83.5c-14-2-17.833-10.473-21-22.5C14.333 48.984 12 22 12 12.5",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m12.005 10.478 7.905 14.423L6 25.75l6.005-15.273Z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.005 10.478c1.92 3.495 3.838 7 7.905 14.423m-7.905-14.423c3.11 5.683 6.23 11.368 7.905 14.423m0 0c-3.68.226-7.35.455-13.91.85m13.91-.85c-5.279.33-10.566.647-13.91.85m0 0c1.936-4.931 3.882-9.86 6.005-15.273M6 25.75c2.069-5.257 4.135-10.505 6.005-15.272",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            })
        ]
    }), {
        width: 41,
        height: 94,
        fill: "none"
    }), $e68ba20b3d2d159d$var$Iy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.026 1.232c-5.268 13.125-5.548 33.555 3.285 42.311 8.823 8.75 33.31 12.304 42.422 13.523",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m72.181 59.247-13.058-10-2.948 13.62 16.006-3.62Z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M72.181 59.247c-3.163-2.429-6.337-4.856-13.058-10m13.058 10c-5.145-3.936-10.292-7.882-13.058-10m0 0c-.78 3.603-1.563 7.196-2.948 13.62m2.948-13.62c-1.126 5.168-2.24 10.346-2.948 13.62m0 0c5.168-1.166 10.334-2.343 16.006-3.62m-16.006 3.62c5.51-1.248 11.01-2.495 16.006-3.62",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            })
        ]
    }), {
        width: 85,
        height: 71,
        fill: "none"
    }), $e68ba20b3d2d159d$var$Cy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1 77c14-2 31.833-11.973 35-24 3.167-12.016-6-35-9.5-43.5",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m24.165 1.093-2.132 16.309 13.27-4.258-11.138-12.05Z",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M24.165 1.093c-.522 3.953-1.037 7.916-2.132 16.309m2.131-16.309c-.835 6.424-1.68 12.854-2.13 16.308m0 0c3.51-1.125 7.013-2.243 13.27-4.257m-13.27 4.257c5.038-1.608 10.08-3.232 13.27-4.257m0 0c-3.595-3.892-7.197-7.777-11.14-12.05m11.14 12.05c-3.837-4.148-7.667-8.287-11.14-12.05",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round"
            })
        ]
    }), {
        width: 38,
        height: 78,
        fill: "none"
    }), $e68ba20b3d2d159d$var$EB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("g", {
        fill: "currentColor",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M39.9 32.889a.326.326 0 0 0-.279-.056c-2.094-3.083-4.774-6-7.343-8.833l-.419-.472a.212.212 0 0 0-.056-.139.586.586 0 0 0-.167-.111l-.084-.083-.056-.056c-.084-.167-.28-.278-.475-.167-.782.39-1.507.973-2.206 1.528-.92.722-1.842 1.445-2.708 2.25a8.405 8.405 0 0 0-.977 1.028c-.14.194-.028.361.14.444-.615.611-1.23 1.223-1.843 1.861a.315.315 0 0 0-.084.223c0 .083.056.166.111.194l1.09.833v.028c1.535 1.528 4.244 3.611 7.12 5.861.418.334.865.667 1.284 1 .195.223.39.473.558.695.084.11.28.139.391.055.056.056.14.111.196.167a.398.398 0 0 0 .167.056.255.255 0 0 0 .224-.111.394.394 0 0 0 .055-.167c.029 0 .028.028.056.028a.318.318 0 0 0 .224-.084l5.082-5.528a.309.309 0 0 0 0-.444Zm-14.63-1.917a.485.485 0 0 0 .111.14c.586.5 1.2 1 1.843 1.555l-2.569-1.945-.251-.166c-.056-.028-.112-.084-.168-.111l-.195-.167.056-.056.055-.055.112-.111c.866-.861 2.346-2.306 3.1-3.028-.81.805-2.43 3.167-2.095 3.944Zm8.767 6.89-2.122-1.612a44.713 44.713 0 0 0-2.625-2.5c1.145.861 2.122 1.611 2.262 1.75 1.117.972 1.06.806 1.815 1.445l.921.666a1.06 1.06 0 0 1-.251.25Zm.558.416-.056-.028c.084-.055.168-.111.252-.194l-.196.222ZM1.089 5.75c.055.361.14.722.195 1.056.335 1.833.67 3.5 1.284 4.75l.252.944c.084.361.223.806.363.917 1.424 1.25 3.602 3.11 5.947 4.889a.295.295 0 0 0 .363 0s0 .027.028.027a.254.254 0 0 0 .196.084.318.318 0 0 0 .223-.084c2.988-3.305 5.221-6.027 6.813-8.305.112-.111.14-.278.14-.417.111-.111.195-.25.307-.333.111-.111.111-.306 0-.39l-.028-.027c0-.055-.028-.139-.084-.167-.698-.666-1.2-1.138-1.731-1.638-.922-.862-1.871-1.75-3.881-3.75l-.028-.028c-.028-.028-.056-.056-.112-.056-.558-.194-1.703-.389-3.127-.639C6.087 2.223 3.21 1.723.614.944c0 0-.168 0-.196.028l-.083.084c-.028.027-.056.055-.224.11h.056-.056c.028.167.028.278.084.473 0 .055.112.5.112.555l.782 3.556Zm15.496 3.278-.335-.334c.084.112.196.195.335.334Zm-3.546 4.666-.056.056c0-.028.028-.056.056-.056Zm-2.038-10c.168.167.866.834 1.033.973-.726-.334-2.54-1.167-3.379-1.445.838.167 1.983.334 2.346.472ZM1.424 2.306c.419.722.754 3.222 1.089 5.666-.196-.778-.335-1.555-.503-2.278-.251-1.277-.503-2.416-.838-3.416.056 0 .14 0 .252.028Zm-.168-.584c-.112 0-.223-.028-.307-.028 0-.027 0-.055-.028-.055.14 0 .223.028.335.083Zm-1.089.222c0-.027 0-.027 0 0ZM39.453 1.333c.028-.11-.558-.61-.363-.639.42-.027.42-.666 0-.666-.558.028-1.144.166-1.675.25-.977.194-1.982.389-2.96.61-2.205.473-4.383.973-6.561 1.557-.67.194-1.424.333-2.066.666-.224.111-.196.333-.084.472-.056.028-.084.028-.14.056-.195.028-.363.056-.558.083-.168.028-.252.167-.224.334 0 .027.028.083.028.11-1.173 1.556-2.485 3.195-3.909 4.945-1.396 1.611-2.876 3.306-4.356 5.056-4.719 5.5-10.052 11.75-15.943 17.25a.268.268 0 0 0 0 .389c.028.027.056.055.084.055-.084.084-.168.14-.252.222-.056.056-.084.111-.084.167a.605.605 0 0 0-.111.139c-.112.111-.112.305.028.389.111.11.307.11.39-.028.029-.028.029-.056.056-.056a.44.44 0 0 1 .615 0c.335.362.67.723.977 1.028l-.698-.583c-.112-.111-.307-.083-.39.028-.113.11-.085.305.027.389l7.427 6.194c.056.056.112.056.196.056s.14-.028.195-.084l.168-.166c.028.027.083.027.111.027.084 0 .14-.027.196-.083 10.052-10.055 18.15-17.639 27.42-24.417.083-.055.111-.166.111-.25.112 0 .196-.083.251-.194 1.704-5.194 2.039-9.806 2.15-12.083v-.028c0-.028.028-.056.028-.083.028-.056.028-.084.028-.084a1.626 1.626 0 0 0-.111-1.028ZM21.472 9.5c.446-.5.893-1.028 1.34-1.5-2.876 3.778-7.65 9.583-14.408 16.5 4.607-5.083 9.242-10.333 13.068-15ZM5.193 35.778h.084-.084Zm3.462 3.194c-.027-.028-.027-.028 0-.028v.028Zm4.16-3.583c.224-.25.448-.472.699-.722 0 0 0 .027.028.027-.252.223-.475.445-.726.695Zm1.146-1.111c.14-.14.279-.334.446-.5l.028-.028c1.648-1.694 3.351-3.389 5.082-5.111l.028-.028c.419-.333.921-.694 1.368-1.028a379.003 379.003 0 0 0-6.952 6.695ZM24.794 6.472c-.921 1.195-1.954 2.778-2.82 4.028-2.736 3.944-11.532 13.583-11.727 13.75a1976.983 1976.983 0 0 1-8.042 7.639l-.167.167c-.14-.167-.14-.417.028-.556C14.49 19.861 22.03 10.167 25.074 5.917c-.084.194-.14.36-.28.555Zm4.83 5.695c-1.116-.64-1.646-1.64-1.34-2.611l.084-.334c.028-.083.084-.194.14-.277.307-.5.754-.917 1.257-1.167.027 0 .055 0 .083-.028-.028-.056-.028-.139-.028-.222.028-.167.14-.278.335-.278.335 0 1.369.306 1.76.639.111.083.223.194.335.305.14.167.363.445.474.667.056.028.112.306.196.445.056.222.111.472.084.694-.028.028 0 .194-.028.194a2.668 2.668 0 0 1-.363 1.028c-.028.028-.028.056-.056.084l-.028.027c-.14.223-.335.417-.53.556-.643.444-1.369.583-2.095.389 0 0-.195-.084-.28-.111Zm8.154-.834a39.098 39.098 0 0 1-.893 3.167c0 .028-.028.083 0 .111-.056 0-.084.028-.14.056-2.206 1.61-4.356 3.305-6.506 5.028 1.843-1.64 3.686-3.306 5.613-4.945.558-.5.949-1.139 1.06-1.861l.28-1.667v-.055c.14-.334.67-.195.586.166Z",
            fill: "currentColor"
        })
    }), {
        width: 40,
        height: 40,
        fill: "none"
    }), $e68ba20b3d2d159d$var$Ay = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 6l4.153 11.793a0.365 .365 0 0 0 .331 .207a0.366 .366 0 0 0 .332 -.207l2.184 -4.793l4.787 -1.994a0.355 .355 0 0 0 .213 -.323a0.355 .355 0 0 0 -.213 -.323l-11.787 -4.36z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.5 13.5l4.5 4.5"
            })
        ]
    }), {
        fill: "none",
        width: 22,
        height: 22,
        strokeWidth: 1.25
    }), $e68ba20b3d2d159d$var$My = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "4",
                width: "16",
                height: "16",
                rx: "2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$ky = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Py = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ly = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "15",
                y1: "16",
                x2: "19",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "15",
                y1: "8",
                x2: "19",
                y2: "12"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Dy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M4.167 10h11.666",
        strokeWidth: "1.5"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$_y = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 7h4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$di = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "m7.643 15.69 7.774-7.773a2.357 2.357 0 1 0-3.334-3.334L4.31 12.357a3.333 3.333 0 0 0-.977 2.357v1.953h1.953c.884 0 1.732-.352 2.357-.977Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m11.25 5.417 3.333 3.333"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$up = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "20",
                x2: "7",
                y2: "20"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "14",
                y1: "20",
                x2: "21",
                y2: "20"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "6.9",
                y1: "15",
                x2: "13.8",
                y2: "15"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "10.2",
                y1: "6.3",
                x2: "16",
                y2: "20"
            }),
            (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "5 20 11 4 13 4 20 20"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ry = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.5 6.667h.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.91 2.625h10.18a2.284 2.284 0 0 1 2.285 2.284v10.182a2.284 2.284 0 0 1-2.284 2.284H4.909a2.284 2.284 0 0 1-2.284-2.284V4.909a2.284 2.284 0 0 1 2.284-2.284Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m3.333 12.5 3.334-3.333c.773-.745 1.726-.745 2.5 0l4.166 4.166"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m11.667 11.667.833-.834c.774-.744 1.726-.744 2.5 0l1.667 1.667"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Ny = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 13.3l-6.3 -6.3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$gf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        strokeWidth: "1.25",
        d: "M10 4.167v11.666M4.167 10h11.666"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$ff = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M5 10h10",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Oy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 21l-6 -6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.268 12.043a7.017 7.017 0 0 0 6.634 4.957a7.012 7.012 0 0 0 7.043 -6.131a7 7 0 0 0 -5.314 -7.672a7.021 7.021 0 0 0 -8.241 4.403"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 4v4h4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$rn = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        strokeWidth: "1.25",
        d: "M3.333 5.833h13.334M8.333 9.167v5M11.667 9.167v5M4.167 5.833l.833 10c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.746 1.667-1.667l.833-10M7.5 5.833v-2.5c0-.46.373-.833.833-.833h3.334c.46 0 .833.373.833.833v2.5"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Fy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "12 16 18 10 12 4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("polyline", {
                points: "8 4 2 10 8 16"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Nc = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.375 6.458H8.958a2.5 2.5 0 0 0-2.5 2.5v5.417a2.5 2.5 0 0 0 2.5 2.5h5.417a2.5 2.5 0 0 0 2.5-2.5V8.958a2.5 2.5 0 0 0-2.5-2.5Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M11.667 3.125c.517 0 .986.21 1.325.55.34.338.55.807.55 1.325v1.458H8.333c-.485 0-.927.185-1.26.487-.343.312-.57.75-.609 1.24l-.005 5.357H5a1.87 1.87 0 0 1-1.326-.55 1.87 1.87 0 0 1-.549-1.325V5c0-.518.21-.987.55-1.326.338-.34.807-.549 1.325-.549h6.667Z"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Oc = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        clipRule: "evenodd",
        d: "M10 2.5h.328a6.25 6.25 0 0 0 6.6 10.372A7.5 7.5 0 1 1 10 2.493V2.5Z",
        stroke: "currentColor"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Fc = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("g", {
        stroke: "currentColor",
        strokeLinejoin: "round",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM10 4.167V2.5M14.167 5.833l1.166-1.166M15.833 10H17.5M14.167 14.167l1.166 1.166M10 15.833V17.5M5.833 14.167l-1.166 1.166M5 10H3.333M5.833 5.833 4.667 4.667"
        })
    }), {
        ...$e68ba20b3d2d159d$var$Se,
        strokeWidth: 1.5
    }), $e68ba20b3d2d159d$var$hp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "6",
                x2: "20",
                y2: "6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "12",
                x2: "20",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "18",
                x2: "20",
                y2: "18"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Xa = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        strokeWidth: "1.25",
        d: "M3.333 14.167v1.666c0 .92.747 1.667 1.667 1.667h10c.92 0 1.667-.746 1.667-1.667v-1.666M5.833 9.167 10 13.333l4.167-4.166M10 3.333v10"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$qs = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "17",
                x2: "12",
                y2: "17.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$By = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "9"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "17",
                x2: "12",
                y2: "17.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ef = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        strokeWidth: "1.25",
        d: "M9.167 5.833H5.833c-1.254 0-2.5 1.282-2.5 2.5v5.834c0 1.283 1.252 2.5 2.5 2.5h5.834c1.251 0 2.5-1.25 2.5-2.5v-3.334M8.333 11.667l8.334-8.334M12.5 3.333h4.167V7.5"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$gp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M7.5 15.833c-3.583 1.167-3.583-2.083-5-2.5m10 4.167v-2.917c0-.833.083-1.166-.417-1.666 2.334-.25 4.584-1.167 4.584-5a3.833 3.833 0 0 0-1.084-2.667 3.5 3.5 0 0 0-.083-2.667s-.917-.25-2.917 1.084a10.25 10.25 0 0 0-5.166 0C5.417 2.333 4.5 2.583 4.5 2.583a3.5 3.5 0 0 0-.083 2.667 3.833 3.833 0 0 0-1.084 2.667c0 3.833 2.25 4.75 4.584 5-.5.5-.5 1-.417 1.666V17.5",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$zy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.5 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM12.5 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM6.25 6.25c2.917-.833 4.583-.833 7.5 0M5.833 13.75c2.917.833 5.417.833 8.334 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.917 14.167c0 .833 1.25 2.5 1.666 2.5 1.25 0 2.361-1.39 2.917-2.5.556-1.39.417-4.861-1.25-9.584-1.214-.846-2.5-1.116-3.75-1.25l-.833 2.084M7.083 14.167c0 .833-1.13 2.5-1.526 2.5-1.191 0-2.249-1.39-2.778-2.5-.529-1.39-.397-4.861 1.19-9.584 1.157-.846 2.318-1.116 3.531-1.25l.833 2.084"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Hy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4l11.733 16h4.267l-11.733 -16z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Uy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("polyline", {
        fill: "none",
        stroke: "currentColor",
        points: "20 6 9 17 4 12"
    }), {
        width: 24,
        height: 24
    }), $e68ba20b3d2d159d$var$Bc = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.333 11.667a2.917 2.917 0 0 0 4.167 0l3.333-3.334a2.946 2.946 0 1 0-4.166-4.166l-.417.416"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.667 8.333a2.917 2.917 0 0 0-4.167 0l-3.333 3.334a2.946 2.946 0 0 0 4.166 4.166l.417-.416"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Gy = $e68ba20b3d2d159d$var$L("M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z", {
        width: 448,
        height: 512
    }), $e68ba20b3d2d159d$var$Wy = $e68ba20b3d2d159d$var$L("M252 54L203 8a28 27 0 00-20-8H28C12 0 0 12 0 27v195c0 15 12 26 28 26h204c15 0 28-11 28-26V73a28 27 0 00-8-19zM130 213c-21 0-37-16-37-36 0-19 16-35 37-35 20 0 37 16 37 35 0 20-17 36-37 36zm56-169v56c0 4-4 6-7 6H44c-4 0-7-2-7-6V42c0-4 3-7 7-7h133l4 2 3 2a7 7 0 012 5z M296 201l87 95-188 205-78 9c-10 1-19-8-18-20l9-84zm141-14l-41-44a31 31 0 00-46 0l-38 41 87 95 38-42c13-14 13-36 0-50z", {
        width: 448,
        height: 512
    }), $e68ba20b3d2d159d$var$Js = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "m9.257 6.351.183.183H15.819c.34 0 .727.182 1.051.506.323.323.505.708.505 1.05v5.819c0 .316-.183.7-.52 1.035-.337.338-.723.522-1.037.522H4.182c-.352 0-.74-.181-1.058-.5-.318-.318-.499-.705-.499-1.057V5.182c0-.351.181-.736.5-1.054.32-.321.71-.503 1.057-.503H6.53l2.726 2.726Z",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$xB = $e68ba20b3d2d159d$var$L("M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z", {
        width: 384,
        height: 512
    }), $e68ba20b3d2d159d$var$Vy = $e68ba20b3d2d159d$var$L("M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"), $e68ba20b3d2d159d$var$fp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 16l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.737 9.737c2.299 -2.3 3.23 -5.095 2.081 -6.245c-1.15 -1.15 -3.945 -.217 -6.244 2.082c-2.3 2.299 -3.231 5.095 -2.082 6.244c1.15 1.15 3.946 .218 6.245 -2.081z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.492 11.818c.362 .362 .768 .676 1.208 .934l6.895 4.047c1.078 .557 2.255 -.075 3.692 -1.512c1.437 -1.437 2.07 -2.614 1.512 -3.692c-.372 -.718 -1.72 -3.017 -4.047 -6.895a6.015 6.015 0 0 0 -.934 -1.208"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ep = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 8h.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 20h-5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 14l1 -1c.617 -.593 1.328 -.793 2.009 -.598"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 16v6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 19l-3 3l-3 -3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Yy = $e68ba20b3d2d159d$var$L("M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z", {
        width: 512,
        height: 512
    }), $e68ba20b3d2d159d$var$bB = $e68ba20b3d2d159d$var$L("M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z", {
        width: 448,
        height: 512
    }), $e68ba20b3d2d159d$var$yB = $e68ba20b3d2d159d$var$L("M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z", {
        width: 448,
        height: 512
    }), $e68ba20b3d2d159d$var$Xy = $e68ba20b3d2d159d$var$L("M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"), $e68ba20b3d2d159d$var$wB = $e68ba20b3d2d159d$var$L("M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"), $e68ba20b3d2d159d$var$xf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M7.5 10.833 4.167 7.5 7.5 4.167M4.167 7.5h9.166a3.333 3.333 0 0 1 0 6.667H12.5",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$bf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M12.5 10.833 15.833 7.5 12.5 4.167M15.833 7.5H6.667a3.333 3.333 0 1 0 0 6.667H7.5",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Ky = $e68ba20b3d2d159d$var$L("M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z", {
        mirror: !0
    }), $e68ba20b3d2d159d$var$$y = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M5 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM15 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM15 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7.25 8.917l5.5-2.834M7.25 11.083l5.5 2.834",
        strokeWidth: "1.5"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$vB = $e68ba20b3d2d159d$var$L("M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"), $e68ba20b3d2d159d$var$TB = $e68ba20b3d2d159d$var$L("M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z", {
        width: 24,
        height: 24
    }), $e68ba20b3d2d159d$var$SB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 9h-1a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2h-1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 14v-11"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 6l3 -3l3 3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$IB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M40 5.6v6.1l-4.1.7c-8.9 1.4-16.5 6.9-20.6 15C13 32 10.9 43 12.4 43c.4 0 2.4-1.3 4.4-3 5-3.9 12.1-7 18.2-7.7l5-.6v12.8l11.2-11.3L62.5 22 51.2 10.8 40-.5v6.1zm10.2 22.6L44 34.5v-6.8l-6.9.6c-3.9.3-9.8 1.7-13.2 3.1-3.5 1.4-6.5 2.4-6.7 2.2-.9-1 3-7.5 6.4-10.8C28 18.6 34.4 16 40.1 16c3.7 0 3.9-.1 3.9-3.2V9.5l6.2 6.3 6.3 6.2-6.3 6.2z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "currentColor",
                fill: "currentColor",
                d: "M0 36v20h48v-6.2c0-6 0-6.1-2-4.3-1.1 1-2 2.9-2 4.2V52H4V34c0-17.3-.1-18-2-18s-2 .7-2 20z"
            })
        ]
    }), {
        width: 64,
        height: 64
    }), $e68ba20b3d2d159d$var$CB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        stroke: "currentColor",
        strokeWidth: "40",
        fill: "currentColor",
        d: "M148 560a318 318 0 0 0 522 110 316 316 0 0 0 0-450 316 316 0 0 0-450 0c-11 11-21 22-30 34v4h47c25 0 46 21 46 46s-21 45-46 45H90c-13 0-25-6-33-14-9-9-14-20-14-33V156c0-25 20-45 45-45s45 20 45 45v32l1 1a401 401 0 0 1 623 509l212 212a42 42 0 0 1-59 59L698 757A401 401 0 0 1 65 570a42 42 0 0 1 83-10z"
    }), {
        width: 1024
    }), $e68ba20b3d2d159d$var$Zy = (0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10l0 10"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10l4 4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10l-4 4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4l16 0"
            })
        ]
    }), $e68ba20b3d2d159d$var$jy = (0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 5l0 14"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 9l-4 -4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 9l4 -4"
            })
        ]
    }), $e68ba20b3d2d159d$var$yf = $e68ba20b3d2d159d$var$L($e68ba20b3d2d159d$var$jy, $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$wf = $e68ba20b3d2d159d$var$L($e68ba20b3d2d159d$var$jy, {
        ...$e68ba20b3d2d159d$var$q,
        style: {
            transform: "rotate(180deg)"
        }
    }), $e68ba20b3d2d159d$var$vf = $e68ba20b3d2d159d$var$L($e68ba20b3d2d159d$var$Zy, $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Tf = $e68ba20b3d2d159d$var$L($e68ba20b3d2d159d$var$Zy, {
        ...$e68ba20b3d2d159d$var$q,
        style: {
            transform: "rotate(180deg)"
        }
    }), $e68ba20b3d2d159d$var$Sf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M3.333 3.333h13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.542 6.458h-.417c-.92 0-1.667.747-1.667 1.667v7.083c0 .92.746 1.667 1.667 1.667h.417c.92 0 1.666-.746 1.666-1.667V8.125c0-.92-.746-1.667-1.666-1.667ZM6.875 6.458h-.417c-.92 0-1.666.747-1.666 1.667v3.75c0 .92.746 1.667 1.666 1.667h.417c.92 0 1.667-.746 1.667-1.667v-3.75c0-.92-.747-1.667-1.667-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$If = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M3.333 16.667h13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.875 3.125h-.417c-.92 0-1.666.746-1.666 1.667v7.083c0 .92.746 1.667 1.666 1.667h.417c.92 0 1.667-.746 1.667-1.667V4.792c0-.92-.747-1.667-1.667-1.667ZM13.542 5.817h-.417c-.92 0-1.667.747-1.667 1.667v4.391c0 .92.746 1.667 1.667 1.667h.417c.92 0 1.666-.746 1.666-1.667V7.484c0-.92-.746-1.667-1.666-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Cf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M3.333 3.333v13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.208 4.792H8.125c-.92 0-1.667.746-1.667 1.666v.417c0 .92.747 1.667 1.667 1.667h7.083c.92 0 1.667-.747 1.667-1.667v-.417c0-.92-.746-1.666-1.667-1.666ZM12.516 11.458H8.125c-.92 0-1.667.746-1.667 1.667v.417c0 .92.747 1.666 1.667 1.666h4.391c.92 0 1.667-.746 1.667-1.666v-.417c0-.92-.746-1.667-1.667-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Af = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.667 3.333v13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.875 4.792H4.792c-.92 0-1.667.746-1.667 1.666v.417c0 .92.746 1.667 1.667 1.667h7.083c.92 0 1.667-.747 1.667-1.667v-.417c0-.92-.746-1.666-1.667-1.666ZM11.683 11.458H7.292c-.92 0-1.667.746-1.667 1.667v.417c0 .92.746 1.666 1.667 1.666h4.39c.921 0 1.667-.746 1.667-1.666v-.417c0-.92-.746-1.667-1.666-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$qy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.667 3.333v13.334M3.333 3.333v13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.375 10.208v-.416c0-.92-.746-1.667-1.667-1.667H7.292c-.92 0-1.667.746-1.667 1.667v.416c0 .92.746 1.667 1.667 1.667h5.416c.92 0 1.667-.746 1.667-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Jy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M3.333 3.333h13.334M3.333 16.667h13.334",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.208 5.625h-.416c-.92 0-1.667.746-1.667 1.667v5.416c0 .92.746 1.667 1.667 1.667h.416c.92 0 1.667-.746 1.667-1.667V7.292c0-.92-.746-1.667-1.667-1.667Z"
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Mf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1.667 10h2.916",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.333 10h3.334",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.417 10h2.916",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.875 4.792h-.417c-.92 0-1.666.746-1.666 1.666v7.084c0 .92.746 1.666 1.666 1.666h.417c.92 0 1.667-.746 1.667-1.666V6.458c0-.92-.747-1.666-1.667-1.666ZM13.542 6.458h-.417c-.92 0-1.667.747-1.667 1.667v3.75c0 .92.746 1.667 1.667 1.667h.417c.92 0 1.666-.746 1.666-1.667v-3.75c0-.92-.746-1.667-1.666-1.667Z"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$kf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 18.333v-2.916",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 11.667V8.333",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 4.583V1.667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.792 13.125v.417c0 .92.746 1.666 1.666 1.666h7.084c.92 0 1.666-.746 1.666-1.666v-.417c0-.92-.746-1.667-1.666-1.667H6.458c-.92 0-1.666.746-1.666 1.667ZM6.458 6.458v.417c0 .92.747 1.667 1.667 1.667h3.75c.92 0 1.667-.747 1.667-1.667v-.417c0-.92-.746-1.666-1.667-1.666h-3.75c-.92 0-1.667.746-1.667 1.666Z"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$xp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 3.13a4 4 0 0 1 0 7.75"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$AB = $e68ba20b3d2d159d$var$L("M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"), $e68ba20b3d2d159d$var$MB = $e68ba20b3d2d159d$var$L("M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"), $e68ba20b3d2d159d$var$Po = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M15 5 5 15M5 5l10 10"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$kB = $e68ba20b3d2d159d$var$L("M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z", {
        mirror: !0
    }), $e68ba20b3d2d159d$var$PB = $e68ba20b3d2d159d$var$L("M11.553 22.894a.998.998 0 00.894 0s3.037-1.516 5.465-4.097C19.616 16.987 21 14.663 21 12V5a1 1 0 00-.649-.936l-8-3a.998.998 0 00-.702 0l-8 3A1 1 0 003 5v7c0 2.663 1.384 4.987 3.088 6.797 2.428 2.581 5.465 4.097 5.465 4.097zm-1.303-8.481l6.644-6.644a.856.856 0 111.212 1.212l-7.25 7.25a.856.856 0 01-1.212 0l-3.75-3.75a.856.856 0 111.212-1.212l3.144 3.144z", {
        width: 24
    }), $e68ba20b3d2d159d$var$LB = $e68ba20b3d2d159d$var$L("M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z", {
        width: 384,
        height: 512
    }), $e68ba20b3d2d159d$var$Pf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M25 26H111V111H25",
                    fill: $e68ba20b3d2d159d$var$tn(e)
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M25 111C25 80.2068 25 49.4135 25 26M25 26C48.6174 26 72.2348 26 111 26H25ZM25 26C53.3671 26 81.7343 26 111 26H25ZM111 26C111 52.303 111 78.606 111 111V26ZM111 26C111 51.2947 111 76.5893 111 111V26ZM111 111C87.0792 111 63.1585 111 25 111H111ZM111 111C87.4646 111 63.9293 111 25 111H111ZM25 111C25 81.1514 25 51.3028 25 26V111Z",
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "2"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M100 100H160V160H100",
                    fill: $e68ba20b3d2d159d$var$tn(e)
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M100 160C100 144.106 100 128.211 100 100M100 100C117.706 100 135.412 100 160 100H100ZM100 100C114.214 100 128.428 100 160 100H100ZM160 100C160 120.184 160 140.369 160 160V100ZM160 100C160 113.219 160 126.437 160 160V100ZM160 160C145.534 160 131.068 160 100 160H160ZM160 160C143.467 160 126.934 160 100 160H160ZM100 160C100 143.661 100 127.321 100 100V160Z",
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "2"
                }),
                (0, $7b02d682eb115277$exports.jsxs)("g", {
                    fill: $e68ba20b3d2d159d$var$yy(e),
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "2.5",
                            y: "2.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "2.5",
                            y: "149.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "147.5",
                            y: "149.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "147.5",
                            y: "2.5",
                            width: "30",
                            height: "30"
                        })
                    ]
                })
            ]
        }), {
            width: 182,
            height: 182,
            mirror: !0
        })), $e68ba20b3d2d159d$var$Lf = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M25 26H111V111H25",
                    fill: $e68ba20b3d2d159d$var$tn(e)
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M25 111C25 80.2068 25 49.4135 25 26M25 26C48.6174 26 72.2348 26 111 26H25ZM25 26C53.3671 26 81.7343 26 111 26H25ZM111 26C111 52.303 111 78.606 111 111V26ZM111 26C111 51.2947 111 76.5893 111 111V26ZM111 111C87.0792 111 63.1585 111 25 111H111ZM111 111C87.4646 111 63.9293 111 25 111H111ZM25 111C25 81.1514 25 51.3028 25 26V111Z",
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "2"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M100 100H160V160H100",
                    fill: $e68ba20b3d2d159d$var$tn(e)
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M100 160C100 144.106 100 128.211 100 100M100 100C117.706 100 135.412 100 160 100H100ZM100 100C114.214 100 128.428 100 160 100H100ZM160 100C160 120.184 160 140.369 160 160V100ZM160 100C160 113.219 160 126.437 160 160V100ZM160 160C145.534 160 131.068 160 100 160H160ZM160 160C143.467 160 126.934 160 100 160H160ZM100 160C100 143.661 100 127.321 100 100V160Z",
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "2"
                }),
                (0, $7b02d682eb115277$exports.jsxs)("g", {
                    fill: $e68ba20b3d2d159d$var$yy(e),
                    stroke: $e68ba20b3d2d159d$var$tn(e),
                    strokeWidth: "6",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "2.5",
                            y: "2.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "78.5",
                            y: "149.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "147.5",
                            y: "149.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "147.5",
                            y: "78.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "105.5",
                            y: "2.5",
                            width: "30",
                            height: "30"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: "2.5",
                            y: "102.5",
                            width: "30",
                            height: "30"
                        })
                    ]
                })
            ]
        }), {
            width: 182,
            height: 182,
            mirror: !0
        })), $e68ba20b3d2d159d$var$Qy = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("g", {
        strokeWidth: 1.25,
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5.879 2.625h8.242a3.27 3.27 0 0 1 3.254 3.254v8.242a3.27 3.27 0 0 1-3.254 3.254H5.88a3.27 3.27 0 0 1-3.254-3.254V5.88A3.27 3.27 0 0 1 5.88 2.626l-.001-.001ZM4.518 16.118l7.608-12.83m.198 13.934 5.051-9.897M2.778 9.675l9.348-6.387m-7.608 12.83 12.857-8.793"
        })
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$ew = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.879 2.625h8.242a3.254 3.254 0 0 1 3.254 3.254v8.242a3.254 3.254 0 0 1-3.254 3.254H5.88a3.254 3.254 0 0 1-3.254-3.254V5.88a3.254 3.254 0 0 1 3.254-3.254Z",
                stroke: "currentColor",
                strokeWidth: "1.25"
            }),
            (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "FillHachureIcon",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.879 2.625h8.242a3.254 3.254 0 0 1 3.254 3.254v8.242a3.254 3.254 0 0 1-3.254 3.254H5.88a3.254 3.254 0 0 1-3.254-3.254V5.88a3.254 3.254 0 0 1 3.254-3.254Z",
                    fill: "currentColor",
                    stroke: "currentColor",
                    strokeWidth: "1.25"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#FillHachureIcon)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M2.258 15.156 15.156 2.258M7.324 20.222 20.222 7.325m-20.444 5.35L12.675-.222m-8.157 18.34L17.416 5.22",
                    stroke: "currentColor",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$tw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.879 2.625h8.242a3.254 3.254 0 0 1 3.254 3.254v8.242a3.254 3.254 0 0 1-3.254 3.254H5.88a3.254 3.254 0 0 1-3.254-3.254V5.88a3.254 3.254 0 0 1 3.254-3.254Z",
                        stroke: "currentColor",
                        strokeWidth: "1.25"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("mask", {
                        id: "FillCrossHatchIcon",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: -1,
                        y: -1,
                        width: 22,
                        height: 22,
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M2.426 15.044 15.044 2.426M7.383 20 20 7.383M0 12.617 12.617 0m-7.98 17.941L17.256 5.324m-2.211 12.25L2.426 4.956M20 12.617 7.383 0m5.234 20L0 7.383m17.941 7.98L5.324 2.745",
                            stroke: "currentColor",
                            strokeWidth: "1.25",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("g", {
                        mask: "url(#FillCrossHatchIcon)",
                        children: (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M14.121 2H5.88A3.879 3.879 0 0 0 2 5.879v8.242A3.879 3.879 0 0 0 5.879 18h8.242A3.879 3.879 0 0 0 18 14.121V5.88A3.879 3.879 0 0 0 14.121 2Z",
                            fill: "currentColor"
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$rw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M4.91 2.625h10.18a2.284 2.284 0 0 1 2.285 2.284v10.182a2.284 2.284 0 0 1-2.284 2.284H4.909a2.284 2.284 0 0 1-2.284-2.284V4.909a2.284 2.284 0 0 1 2.284-2.284Z",
                    stroke: "currentColor",
                    strokeWidth: "1.25"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), {
        ...$e68ba20b3d2d159d$var$Se,
        fill: "currentColor"
    }), $e68ba20b3d2d159d$var$Df = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4.167 10h11.666",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$ow = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M5 10h10",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$nw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M5 10h10",
        stroke: "currentColor",
        strokeWidth: "3.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$DB = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 10H34",
            stroke: $e68ba20b3d2d159d$var$tn(e),
            strokeWidth: 2,
            fill: "none",
            strokeLinecap: "round"
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$iw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "2",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 12h2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 12h2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 12h2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$aw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "2",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 12v.01"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$sw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M2.5 12.038c1.655-.885 5.9-3.292 8.568-4.354 2.668-1.063.101 2.821 1.32 3.104 1.218.283 5.112-1.814 5.112-1.814",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$lw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M2.5 12.563c1.655-.886 5.9-3.293 8.568-4.355 2.668-1.062.101 2.822 1.32 3.105 1.218.283 5.112-1.814 5.112-1.814m-13.469 2.23c2.963-1.586 6.13-5.62 7.468-4.998 1.338.623-1.153 4.11-.132 5.595 1.02 1.487 6.133-1.43 6.133-1.43",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$cw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M2.5 11.936c1.737-.879 8.627-5.346 10.42-5.268 1.795.078-.418 5.138.345 5.736.763.598 3.53-1.789 4.235-2.147M2.929 9.788c1.164-.519 5.47-3.28 6.987-3.114 1.519.165 1 3.827 2.121 4.109 1.122.281 3.839-2.016 4.606-2.42",
        strokeWidth: "1.25"
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$dw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("svg", {
        strokeWidth: "1.5",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.33334 9.99998V6.66665C3.33334 6.04326 3.33403 4.9332 3.33539 3.33646C4.95233 3.33436 6.06276 3.33331 6.66668 3.33331H10"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.3333 3.33331V3.34331"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6667 3.33331V3.34331"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6667 6.66669V6.67669"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6667 10V10.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.33334 13.3333V13.3433"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6667 13.3333V13.3433"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.33334 16.6667V16.6767"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.66666 16.6667V16.6767"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 16.6667V16.6767"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13.3333 16.6667V16.6767"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6667 16.6667V16.6767"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$mw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.5",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 12v-4a4 4 0 0 1 4 -4h4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "16",
                y1: "4",
                x2: "16",
                y2: "4.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "4",
                x2: "20",
                y2: "4.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "8",
                x2: "20",
                y2: "8.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "12",
                x2: "20",
                y2: "12.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "16",
                x2: "4",
                y2: "16.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "16",
                x2: "20",
                y2: "16.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "20",
                x2: "4",
                y2: "20.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "8",
                y1: "20",
                x2: "8",
                y2: "20.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "12",
                y1: "20",
                x2: "12",
                y2: "20.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "16",
                y1: "20",
                x2: "16",
                y2: "20.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "20",
                y1: "20",
                x2: "20",
                y2: "20.01"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$pw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M6 10H34",
        stroke: "currentColor",
        strokeWidth: 2,
        fill: "none"
    }), {
        width: 40,
        height: 20
    }), $e68ba20b3d2d159d$var$uw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            stroke: "currentColor",
            strokeWidth: 2,
            fill: "none",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M34 10H6M34 10L27 5M34 10L27 15"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M27.5 5L34.5 10L27.5 15"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$_f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "currentColor",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M32 10L6 10",
                    strokeWidth: 2
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    r: "4",
                    transform: "matrix(-1 0 0 1 30 10)"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$hw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "none",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            strokeWidth: 2,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M26 10L6 10"
                }),
                (0, $7b02d682eb115277$exports.jsx)("circle", {
                    r: "4",
                    transform: "matrix(-1 0 0 1 30 10)"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$gw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("g", {
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M34 10H5.99996M34 10L34 5M34 10L34 15",
                stroke: "currentColor",
                strokeWidth: 2,
                fill: "none"
            })
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$fw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "currentColor",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M32 10L6 10",
                    strokeWidth: 2
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M27.5 5.5L34.5 10L27.5 14.5L27.5 5.5"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$Ew = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "none",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            strokeWidth: 2,
            strokeLinejoin: "round",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6,9.5H27"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M27,5L34,10L27,14Z",
                    fill: "none"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$xw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "currentColor",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            strokeLinejoin: "round",
            strokeWidth: 2,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6,9.5H20"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M27,5L34,10L27,14L20,9.5Z"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$bw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ flip: e = !1 })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            fill: "none",
            transform: e ? "translate(40, 0) scale(-1, 1)" : "",
            strokeLinejoin: "round",
            strokeWidth: 2,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6,9.5H20"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M27,5L34,10L27,14L20,9.5Z"
                })
            ]
        }), {
            width: 40,
            height: 20
        })), $e68ba20b3d2d159d$var$yw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M14.167 6.667a3.333 3.333 0 0 0-3.334-3.334H9.167a3.333 3.333 0 0 0 0 6.667h1.666a3.333 3.333 0 0 1 0 6.667H9.167a3.333 3.333 0 0 1-3.334-3.334",
                    stroke: "currentColor",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$ww = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5 16.667V3.333L10 15l5-11.667v13.334",
                    stroke: "currentColor",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$vw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.833 3.333v13.334h8.334",
                    stroke: "currentColor",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Tw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m1.667 3.333 6.666 13.334M8.333 3.333 1.667 16.667M11.667 3.333v13.334h6.666",
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Ka = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 7v-2h13v2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 5v14"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 19h-4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 13v-1h6v1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 12v7"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 19h2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Sw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $7b02d682eb115277$exports.jsxs)("g", {
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7 12h10"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7 5v14"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M17 5v14"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M15 19h4"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M15 5h4"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5 19h4"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5 5h4"
                })
            ]
        })
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Qs = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $7b02d682eb115277$exports.jsx)("g", {
            stroke: "currentColor",
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.833 16.667v-10a3.333 3.333 0 0 1 3.334-3.334h1.666a3.333 3.333 0 0 1 3.334 3.334v10M5.833 10.833h8.334"
            })
        })
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$zc = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#a)",
                stroke: "currentColor",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.833 6.667 2.5 10l3.333 3.333M14.167 6.667 17.5 10l-3.333 3.333M11.667 3.333 8.333 16.667"
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "a",
                    children: (0, $7b02d682eb115277$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Iw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "8",
                x2: "20",
                y2: "8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "12",
                x2: "12",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "16",
                x2: "16",
                y2: "16"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Cw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "8",
                x2: "20",
                y2: "8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "8",
                y1: "12",
                x2: "16",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "6",
                y1: "16",
                x2: "18",
                y2: "16"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Aw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "4",
                y1: "8",
                x2: "20",
                y2: "8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "10",
                y1: "12",
                x2: "20",
                y2: "12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "8",
                y1: "16",
                x2: "20",
                y2: "16"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Mw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            strokeWidth: "1.5",
            stroke: "currentColor",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    x1: "4",
                    y1: "4",
                    x2: "20",
                    y2: "4"
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "9",
                    y: "8",
                    width: "6",
                    height: "12",
                    rx: "2"
                })
            ]
        }), $e68ba20b3d2d159d$var$q)), $e68ba20b3d2d159d$var$kw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            strokeWidth: "2",
            stroke: "currentColor",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    x1: "4",
                    y1: "20",
                    x2: "20",
                    y2: "20"
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "9",
                    y: "4",
                    width: "6",
                    height: "12",
                    rx: "2"
                })
            ]
        }), $e68ba20b3d2d159d$var$q)), $e68ba20b3d2d159d$var$Pw = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ theme: e })=>$e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
            strokeWidth: "1.5",
            stroke: "currentColor",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    x1: "4",
                    y1: "12",
                    x2: "9",
                    y2: "12"
                }),
                (0, $7b02d682eb115277$exports.jsx)("line", {
                    x1: "15",
                    y1: "12",
                    x2: "20",
                    y2: "12"
                }),
                (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "9",
                    y: "6",
                    width: "6",
                    height: "12",
                    rx: "2"
                })
            ]
        }), $e68ba20b3d2d159d$var$q)), $e68ba20b3d2d159d$var$bp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 19h-18l9 -15"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.615 15.171h.015"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.515 11.771h.015"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.715 8.671h.015"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.415 5.971h.015"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Lw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z",
        fill: "currentColor"
    }), {
        width: 640,
        height: 512
    }), $e68ba20b3d2d159d$var$_B = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M480 416C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H150.6C133.7 480 117.4 473.3 105.4 461.3L25.37 381.3C.3786 356.3 .3786 315.7 25.37 290.7L258.7 57.37C283.7 32.38 324.3 32.38 349.3 57.37L486.6 194.7C511.6 219.7 511.6 260.3 486.6 285.3L355.9 416H480zM265.4 416L332.7 348.7L195.3 211.3L70.63 336L150.6 416L265.4 416z"
    })), $e68ba20b3d2d159d$var$yp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Rf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 11l5 5l5 -5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 4l0 12"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$wp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Dw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.15 14.85l8.85 -10.85"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 4l8.85 10.85"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$_w = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17l0 .01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$RB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 4v16l13 -8z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$NB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 4h-10a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
                strokeWidth: "0",
                fill: "currentColor"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Rw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 12l5 5l10 -10"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Nw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 9v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17h.01"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ow = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 7l6 6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Fw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3l-4 7h8z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$vp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 7l16 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 17l16 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 4l0 16"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 4l0 16"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Tp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsx)("path", {
        fill: "currentColor",
        d: "M407.48,111.18C335.587,108.103 269.573,152.338 245.08,220C220.587,152.338 154.573,108.103 82.68,111.18C80.285,168.229 107.577,222.632 154.74,254.82C178.908,271.419 193.35,298.951 193.27,328.27L193.27,379.13L296.9,379.13L296.9,328.27C296.816,298.953 311.255,271.42 335.42,254.82C382.596,222.644 409.892,168.233 407.48,111.18Z"
    })), $e68ba20b3d2d159d$var$el = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: "1.25",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.16602 10H15.8327"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.5 13.3333L15.8333 10"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.5 6.66666L15.8333 9.99999"
            })
        ]
    }), $e68ba20b3d2d159d$var$Se), $e68ba20b3d2d159d$var$Sp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.25",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        transform: "rotate(90 10 10)",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "m9.644 13.69 7.774-7.773a2.357 2.357 0 0 0-3.334-3.334l-7.773 7.774L8 12l1.643 1.69Z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m13.25 3.417 3.333 3.333M10 10l2-2M5 15l3-3M2.156 17.894l1-1M5.453 19.029l-.144-1.407M2.377 11.887l.866 1.118M8.354 17.273l-1.194-.758M.953 14.652l1.408.13"
            })
        ]
    }), 20), $e68ba20b3d2d159d$var$Ip = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 21l15 -15l-3 -3l-15 15l3 3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 6l3 3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$OB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 21l15 -15l-3 -3l-15 15l3 3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 6l3 3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$FB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.217 19.384a3.501 3.501 0 0 0 6.783 -1.217v-5.167l-6 -3.35"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.214 15.014a3.501 3.501 0 0 0 4.446 5.266l4.34 -2.534v-6.946"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 7.63c-1.391 -.236 -2.787 .395 -3.534 1.689a3.474 3.474 0 0 0 1.271 4.745l4.263 2.514l6 -3.348"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.783 4.616a3.501 3.501 0 0 0 -6.783 1.217v5.067l6 3.45"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.786 8.986a3.501 3.501 0 0 0 -4.446 -5.266l-4.34 2.534v6.946"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 16.302c1.391 .236 2.787 -.395 3.534 -1.689a3.474 3.474 0 0 0 -1.271 -4.745l-4.308 -2.514l-5.955 3.42"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Bw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 8v-2a2 2 0 0 1 2 -2h2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 16v2a2 2 0 0 0 2 2h2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 20h2a2 2 0 0 0 2 -2v-2"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$tl = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$zw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.585 10.587a2 2 0 0 0 2.829 2.828"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 3l18 18"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Hw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        fill: "none",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Uw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Cp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 21l-6 -6"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Gw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.984 12.53a9 9 0 1 0 -7.552 8.355"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 7v5l3 3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 16l-2 3h4l-2 3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ww = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 2m0 3a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 10a7 7 0 0 0 14 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 21l8 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17l0 4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Vw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 3l18 18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 10a7 7 0 0 0 10.846 5.85m2 -2a6.967 6.967 0 0 0 1.152 -3.85"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 21l8 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 17l0 4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Ap = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Yw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 20v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 20v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 20v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 20v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 16v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 8v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 4v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 4v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 4v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 4v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 4v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 8v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 12v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 16v.01"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 20v.01"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Xw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 3v18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 21v-18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 7h14"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 15h14"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 13v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 13v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 13v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 5v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 5v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 5v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 21h18"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Kw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 12l18 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 16l10 0l-10 5l0 -5"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 8l10 0l-10 -5l0 5"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$$w = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3l0 18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 7l0 10l5 0l-5 -10"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 7l0 10l-5 0l5 -10"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Nf = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Mp = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 22l-3 -3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 18h-1a2 2 0 0 1 -2 -2v-1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 11v-1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 6v-1a2 2 0 0 1 2 -2h1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 3h1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 3h1a2 2 0 0 1 2 2v1"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Zw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 3v4a1 1 0 0 0 1 1h4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 15l2 6l2 -6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$jw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 3v4a1 1 0 0 0 1 1h4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 21v-6l3 6v-6"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$qw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 8l5 0"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 8l4 0"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Jw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.25,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.746 16.726a3 3 0 1 0 .252 -5.555"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$Qw = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-10zM7 20h10M9 16v4M15 16v4"
            })
        ]
    }), {
        ...$e68ba20b3d2d159d$var$q,
        strokeWidth: 1.5
    }), $e68ba20b3d2d159d$var$BB = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 12h-13l3 -3"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 15l-3 -3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$e2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 9l5 3l-5 3z"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$t2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 6h18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 12h18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 18h18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 3v18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3v18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 3v18"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$r2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        strokeWidth: 1.5,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17 5c-6.627 0 -12 5.373 -12 12"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$o2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 18l12 -12"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 10v-4h-4"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$n2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4,19L10,19C11.097,19 12,18.097 12,17L12,9C12,7.903 12.903,7 14,7L21,7"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 4l3 3l-3 3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$i2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16,12L20,9L16,6"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 20c0 -6.075 4.925 -11 11 -11h3"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$a2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 9l6 6l6 -6"
            })
        ]
    }), $e68ba20b3d2d159d$var$q), $e68ba20b3d2d159d$var$s2 = $e68ba20b3d2d159d$var$L((0, $7b02d682eb115277$exports.jsxs)("g", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 15l6 -6l6 6"
            })
        ]
    }), $e68ba20b3d2d159d$var$q);
});
var $e68ba20b3d2d159d$var$on, $e68ba20b3d2d159d$var$Vi, $e68ba20b3d2d159d$var$kp, $e68ba20b3d2d159d$var$Of = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$oe();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$on = {
        [$e68ba20b3d2d159d$export$530097e879f93363.Excalifont]: {
            metrics: {
                unitsPerEm: 1e3,
                ascender: 886,
                descender: -374,
                lineHeight: 1.25
            },
            icon: $e68ba20b3d2d159d$var$di
        },
        [$e68ba20b3d2d159d$export$530097e879f93363.Nunito]: {
            metrics: {
                unitsPerEm: 1e3,
                ascender: 1011,
                descender: -353,
                lineHeight: 1.35
            },
            icon: $e68ba20b3d2d159d$var$Qs
        },
        [$e68ba20b3d2d159d$export$530097e879f93363["Lilita One"]]: {
            metrics: {
                unitsPerEm: 1e3,
                ascender: 923,
                descender: -220,
                lineHeight: 1.15
            },
            icon: $e68ba20b3d2d159d$var$Sw
        },
        [$e68ba20b3d2d159d$export$530097e879f93363["Comic Shanns"]]: {
            metrics: {
                unitsPerEm: 1e3,
                ascender: 750,
                descender: -250,
                lineHeight: 1.25
            },
            icon: $e68ba20b3d2d159d$var$zc
        },
        [$e68ba20b3d2d159d$export$530097e879f93363.Virgil]: {
            metrics: {
                unitsPerEm: 1e3,
                ascender: 886,
                descender: -374,
                lineHeight: 1.25
            },
            icon: $e68ba20b3d2d159d$var$di,
            deprecated: !0
        },
        [$e68ba20b3d2d159d$export$530097e879f93363.Helvetica]: {
            metrics: {
                unitsPerEm: 2048,
                ascender: 1577,
                descender: -471,
                lineHeight: 1.15
            },
            icon: $e68ba20b3d2d159d$var$Qs,
            deprecated: !0,
            local: !0
        },
        [$e68ba20b3d2d159d$export$530097e879f93363.Cascadia]: {
            metrics: {
                unitsPerEm: 2048,
                ascender: 1900,
                descender: -480,
                lineHeight: 1.2
            },
            icon: $e68ba20b3d2d159d$var$zc,
            deprecated: !0
        },
        [$e68ba20b3d2d159d$export$530097e879f93363["Liberation Sans"]]: {
            metrics: {
                unitsPerEm: 2048,
                ascender: 1854,
                descender: -434,
                lineHeight: 1.15
            },
            icon: $e68ba20b3d2d159d$var$Qs,
            serverSide: !0
        }
    }, $e68ba20b3d2d159d$var$Vi = {
        LATIN: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
        LATIN_EXT: "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF",
        CYRILIC_EXT: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
        CYRILIC: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
        VIETNAMESE: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB"
    }, $e68ba20b3d2d159d$var$kp = "local:";
});
var $e68ba20b3d2d159d$var$l2, $e68ba20b3d2d159d$var$rl, $e68ba20b3d2d159d$var$ol, $e68ba20b3d2d159d$var$mi = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Gi();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$l2 = 500, $e68ba20b3d2d159d$var$rl = (e)=>{
        let t = e.extensions?.reduce((o, n)=>(o.push($e68ba20b3d2d159d$export$edfb5d7e4280f611[n]), o), []), r = e.extensions?.reduce((o, n)=>n === "jpg" ? o.concat(".jpg", ".jpeg") : o.concat(`.${n}`), []);
        return (0, $11b096c57ac70a88$export$c1bd535e520dbbc3)({
            description: e.description,
            extensions: r,
            mimeTypes: t,
            multiple: e.multiple ?? !1,
            legacySetup: (o, n, i)=>{
                let a = $e68ba20b3d2d159d$var$si(n, $e68ba20b3d2d159d$var$l2), s = ()=>{
                    l(), document.addEventListener("keyup", a), document.addEventListener("pointerup", a), a();
                }, l = ()=>{
                    if (i.files?.length) {
                        let d = e.multiple ? [
                            ...i.files
                        ] : i.files[0];
                        o(d);
                    }
                };
                requestAnimationFrame(()=>{
                    window.addEventListener("focus", s);
                });
                let c = window.setInterval(()=>{
                    l();
                }, $e68ba20b3d2d159d$var$l2);
                return (d)=>{
                    clearInterval(c), a.cancel(), window.removeEventListener("focus", s), document.removeEventListener("keyup", a), document.removeEventListener("pointerup", a), d && (console.warn("Opening the file was canceled (legacy-fs)."), d(new $e68ba20b3d2d159d$var$Rn));
                };
            }
        });
    }, $e68ba20b3d2d159d$var$ol = (e, t)=>(0, $11b096c57ac70a88$export$cf414c79194c40b9)(e, {
            fileName: `${t.name}.${t.extension}`,
            description: t.description,
            extensions: [
                `.${t.extension}`
            ]
        }, t.fileHandle);
});
var $e68ba20b3d2d159d$var$lM, $e68ba20b3d2d159d$export$b502122c5be20fdd, $e68ba20b3d2d159d$var$Pp, $e68ba20b3d2d159d$var$Ff, $e68ba20b3d2d159d$var$c2, $e68ba20b3d2d159d$var$Bf, $e68ba20b3d2d159d$export$dd44df3f856016a2, $e68ba20b3d2d159d$var$d2, $e68ba20b3d2d159d$var$pi = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$mi();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$Fr();
    $e68ba20b3d2d159d$var$lM = (e, t)=>{
        let r = {};
        for (let o of e)!o.isDeleted && "fileId" in o && o.fileId && t[o.fileId] && (r[o.fileId] = t[o.fileId]);
        return r;
    }, $e68ba20b3d2d159d$export$b502122c5be20fdd = (e, t, r, o)=>{
        let n = {
            type: $e68ba20b3d2d159d$var$Tr.excalidraw,
            version: $e68ba20b3d2d159d$var$za.excalidraw,
            source: $e68ba20b3d2d159d$var$Ac,
            elements: o === "local" ? $e68ba20b3d2d159d$var$Dp(e) : $e68ba20b3d2d159d$var$m2(e),
            appState: o === "local" ? $e68ba20b3d2d159d$var$op(t) : $e68ba20b3d2d159d$var$ly(t),
            files: o === "local" ? $e68ba20b3d2d159d$var$lM(e, r) : void 0
        };
        return JSON.stringify(n, null, 2);
    }, $e68ba20b3d2d159d$var$Pp = async (e, t, r, o = t.name || $e68ba20b3d2d159d$var$Wm)=>{
        let n = $e68ba20b3d2d159d$export$b502122c5be20fdd(e, t, r, "local"), i = new Blob([
            n
        ], {
            type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw
        });
        return {
            fileHandle: await $e68ba20b3d2d159d$var$ol(i, {
                name: o,
                extension: "excalidraw",
                description: "Excalidraw file",
                fileHandle: $e68ba20b3d2d159d$var$nl(t.fileHandle) ? null : t.fileHandle
            })
        };
    }, $e68ba20b3d2d159d$var$Ff = async (e, t)=>{
        let r = await $e68ba20b3d2d159d$var$rl({
            description: "Excalidraw files"
        });
        return $e68ba20b3d2d159d$export$d8a4a83cfacbdff0(await $e68ba20b3d2d159d$var$Hc(r), e, t, r.handle);
    }, $e68ba20b3d2d159d$var$c2 = (e)=>e?.type === $e68ba20b3d2d159d$var$Tr.excalidraw && (!e.elements || Array.isArray(e.elements) && (!e.appState || typeof e.appState == "object")), $e68ba20b3d2d159d$var$Bf = (e)=>typeof e == "object" && e && e.type === $e68ba20b3d2d159d$var$Tr.excalidrawLibrary && (e.version === 1 || e.version === 2), $e68ba20b3d2d159d$export$dd44df3f856016a2 = (e)=>{
        let t = {
            type: $e68ba20b3d2d159d$var$Tr.excalidrawLibrary,
            version: $e68ba20b3d2d159d$var$za.excalidrawLibrary,
            source: $e68ba20b3d2d159d$var$Ac,
            libraryItems: e
        };
        return JSON.stringify(t, null, 2);
    }, $e68ba20b3d2d159d$var$d2 = async (e)=>{
        let t = $e68ba20b3d2d159d$export$dd44df3f856016a2(e);
        await $e68ba20b3d2d159d$var$ol(new Blob([
            t
        ], {
            type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib
        }), {
            name: "library",
            extension: "excalidrawlib",
            description: "Excalidraw library file"
        });
    };
});
var $e68ba20b3d2d159d$var$ui, $e68ba20b3d2d159d$var$Ki, $e68ba20b3d2d159d$var$$a = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ui = (e)=>{
        let t = e.map((o)=>o[0]), r = e.map((o)=>o[1]);
        return {
            width: Math.max(...t) - Math.min(...t),
            height: Math.max(...r) - Math.min(...r)
        };
    }, $e68ba20b3d2d159d$var$Ki = (e, t, r, o)=>{
        let n = r.map((u)=>u[e]), i = Math.max(...n), a = Math.min(...n), s = i - a, l = s === 0 ? 1 : t / s, c = 1 / 0, d = r.map((u)=>{
            let h = u[e] * l, g = [
                ...u
            ];
            return g[e] = h, h < c && (c = h), g;
        });
        if (!o || d.length === 2) return d;
        let m = a - c;
        return d.map((u)=>u.map((h, g)=>g === e ? h + m : h));
    };
});
var $e68ba20b3d2d159d$var$Sr, $e68ba20b3d2d159d$var$p2, $e68ba20b3d2d159d$var$Za, $e68ba20b3d2d159d$var$al, $e68ba20b3d2d159d$var$u2, $e68ba20b3d2d159d$var$zf, $e68ba20b3d2d159d$var$$i, $e68ba20b3d2d159d$var$cM, $e68ba20b3d2d159d$var$Hf, $e68ba20b3d2d159d$var$_p, $e68ba20b3d2d159d$var$Uf, $e68ba20b3d2d159d$var$h2, $e68ba20b3d2d159d$var$Gf, $e68ba20b3d2d159d$var$g2, $e68ba20b3d2d159d$var$ja, $e68ba20b3d2d159d$var$f2, $e68ba20b3d2d159d$var$Wf, $e68ba20b3d2d159d$var$sz, $e68ba20b3d2d159d$var$lz, $e68ba20b3d2d159d$var$cz, $e68ba20b3d2d159d$var$dz, $e68ba20b3d2d159d$var$mz, $e68ba20b3d2d159d$var$pz, $e68ba20b3d2d159d$var$uz, $e68ba20b3d2d159d$var$qa = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Sr = (e, t)=>[
            0,
            0,
            0,
            0,
            t,
            e,
            1,
            0
        ], $e68ba20b3d2d159d$var$p2 = (e, t)=>[
            0,
            0,
            0,
            0,
            t,
            e,
            0,
            0
        ], $e68ba20b3d2d159d$var$Za = (e = 0, t = 0)=>{
        let r = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (t < 0 || t > 7) throw new Error(`Expected \`index\` between 0 and 7, got \`${t}\``);
        return e !== 0 && (r[t] = e), r;
    }, $e68ba20b3d2d159d$var$al = (e)=>[
            e[0],
            e[1],
            e[2],
            e[3],
            -e[4],
            -e[5],
            -e[6],
            -e[7]
        ], $e68ba20b3d2d159d$var$u2 = (e, t)=>$e68ba20b3d2d159d$var$Wf(t) ? [
            e[0] + t,
            e[1],
            e[2],
            e[3],
            e[4],
            e[5],
            e[6],
            e[7]
        ] : [
            e[0] + t[0],
            e[1] + t[1],
            e[2] + t[2],
            e[3] + t[3],
            e[4] + t[4],
            e[5] + t[5],
            e[6] + t[6],
            e[7] + t[7]
        ], $e68ba20b3d2d159d$var$zf = (e, t)=>$e68ba20b3d2d159d$var$Wf(t) ? [
            e[0] - t,
            e[1],
            e[2],
            e[3],
            e[4],
            e[5],
            e[6],
            e[7]
        ] : [
            e[0] - t[0],
            e[1] - t[1],
            e[2] - t[2],
            e[3] - t[3],
            e[4] - t[4],
            e[5] - t[5],
            e[6] - t[6],
            e[7] - t[7]
        ], $e68ba20b3d2d159d$var$$i = (e, t)=>$e68ba20b3d2d159d$var$Wf(t) ? [
            e[0] * t,
            e[1] * t,
            e[2] * t,
            e[3] * t,
            e[4] * t,
            e[5] * t,
            e[6] * t,
            e[7] * t
        ] : [
            $e68ba20b3d2d159d$var$cM(e, t),
            t[1] * e[0] + t[0] * e[1] - t[4] * e[2] + t[5] * e[3] + t[2] * e[4] - t[3] * e[5] - t[7] * e[6] - t[6] * e[7],
            t[2] * e[0] + t[0] * e[2] - t[6] * e[3] + t[3] * e[6],
            t[3] * e[0] + t[6] * e[2] + t[0] * e[3] - t[2] * e[6],
            t[4] * e[0] + t[2] * e[1] - t[1] * e[2] + t[7] * e[3] + t[0] * e[4] + t[6] * e[5] - t[5] * e[6] + t[3] * e[7],
            t[5] * e[0] - t[3] * e[1] + t[7] * e[2] + t[1] * e[3] - t[6] * e[4] + t[0] * e[5] + t[4] * e[6] + t[2] * e[7],
            t[6] * e[0] + t[3] * e[2] - t[2] * e[3] + t[0] * e[6],
            t[7] * e[0] + t[6] * e[1] + t[5] * e[2] + t[4] * e[3] + t[3] * e[4] + t[2] * e[5] + t[1] * e[6] + t[0] * e[7]
        ], $e68ba20b3d2d159d$var$cM = (e, t)=>t[0] * e[0] + t[2] * e[2] + t[3] * e[3] - t[6] * e[6], $e68ba20b3d2d159d$var$Hf = (e, t)=>[
            t[0] * e[0],
            t[1] * e[0] + t[0] * e[1],
            t[2] * e[0] + t[0] * e[2],
            t[3] * e[0] + t[0] * e[3],
            t[4] * e[0] + t[2] * e[1] - t[1] * e[2] + t[0] * e[4],
            t[5] * e[0] - t[3] * e[1] + t[1] * e[3] + t[0] * e[5],
            t[6] * e[0] + t[3] * e[2] - t[2] * e[3] + t[0] * e[6],
            t[7] * e[0] + t[6] * e[1] + t[5] * e[2] + t[4] * e[3] + t[3] * e[4] + t[2] * e[5] + t[1] * e[6]
        ], $e68ba20b3d2d159d$var$_p = (e, t)=>[
            $e68ba20b3d2d159d$var$Uf(e, t),
            e[1] * t[7] + e[4] * t[5] - e[5] * t[4] + e[7] * t[1],
            e[2] * t[7] - e[4] * t[6] + e[6] * t[4] + e[7] * t[2],
            e[3] * t[7] + e[5] * t[6] - e[6] * t[5] + e[7] * t[3],
            e[4] * t[7] + e[7] * t[4],
            e[5] * t[7] + e[7] * t[5],
            e[6] * t[7] + e[7] * t[6],
            e[7] * t[7]
        ], $e68ba20b3d2d159d$var$Uf = (e, t)=>e[0] * t[7] + e[1] * t[6] + e[2] * t[5] + e[3] * t[4] + e[4] * t[3] + e[5] * t[2] + e[6] * t[1] + e[7] * t[0], $e68ba20b3d2d159d$var$h2 = (e, t)=>[
            t[0] * e[0] + t[2] * e[2] + t[3] * e[3] - t[6] * e[6],
            t[1] * e[0] + t[0] * e[1] - t[4] * e[2] + t[5] * e[3] + t[2] * e[4] - t[3] * e[5] - t[7] * e[6] - t[6] * e[7],
            t[2] * e[0] + t[0] * e[2] - t[6] * e[3] + t[3] * e[6],
            t[3] * e[0] + t[6] * e[2] + t[0] * e[3] - t[2] * e[6],
            t[4] * e[0] + t[7] * e[3] + t[0] * e[4] + t[3] * e[7],
            t[5] * e[0] + t[7] * e[2] + t[0] * e[5] + t[2] * e[7],
            t[6] * e[0] + t[0] * e[6],
            t[7] * e[0] + t[0] * e[7]
        ], $e68ba20b3d2d159d$var$Gf = (e)=>Math.sqrt(Math.abs(e[0] * e[0] - e[2] * e[2] - e[3] * e[3] + e[6] * e[6])), $e68ba20b3d2d159d$var$g2 = (e)=>Math.sqrt(Math.abs(e[7] * e[7] - e[5] * e[5] - e[4] * e[4] + e[1] * e[1])), $e68ba20b3d2d159d$var$ja = (e)=>{
        let t = $e68ba20b3d2d159d$var$Gf(e);
        if (t === 0 || t === 1) return e;
        let r = e[6] < 0 ? -1 : 1;
        return $e68ba20b3d2d159d$var$$i(e, r / t);
    }, $e68ba20b3d2d159d$var$f2 = (e)=>{
        let t = $e68ba20b3d2d159d$var$g2(e);
        return t === 0 || t === 1 ? e : $e68ba20b3d2d159d$var$$i(e, 1 / t);
    }, $e68ba20b3d2d159d$var$Wf = (e)=>typeof e == "number", $e68ba20b3d2d159d$var$sz = $e68ba20b3d2d159d$var$Za(1, 1), $e68ba20b3d2d159d$var$lz = $e68ba20b3d2d159d$var$Za(1, 2), $e68ba20b3d2d159d$var$cz = $e68ba20b3d2d159d$var$Za(1, 3), $e68ba20b3d2d159d$var$dz = $e68ba20b3d2d159d$var$Za(1, 4), $e68ba20b3d2d159d$var$mz = $e68ba20b3d2d159d$var$Za(1, 5), $e68ba20b3d2d159d$var$pz = $e68ba20b3d2d159d$var$Za(1, 6), $e68ba20b3d2d159d$var$uz = $e68ba20b3d2d159d$var$Za(1, 7);
});
var $e68ba20b3d2d159d$var$Rp, $e68ba20b3d2d159d$var$sl, $e68ba20b3d2d159d$var$E2, $e68ba20b3d2d159d$var$x2, $e68ba20b3d2d159d$var$b2, $e68ba20b3d2d159d$var$Vf = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$Rp = (e, t, r)=>$e68ba20b3d2d159d$var$ja([
            0,
            r,
            e,
            t,
            0,
            0,
            0,
            0
        ]), $e68ba20b3d2d159d$var$sl = (e, t)=>$e68ba20b3d2d159d$var$ja($e68ba20b3d2d159d$var$_p(t, e)), $e68ba20b3d2d159d$var$E2 = (e, t)=>$e68ba20b3d2d159d$var$h2(e, t), $e68ba20b3d2d159d$var$x2 = (e, t)=>$e68ba20b3d2d159d$var$E2($e68ba20b3d2d159d$var$sl(e, t), t), $e68ba20b3d2d159d$var$b2 = (e)=>Math.sign(e[1]);
});
var $e68ba20b3d2d159d$var$Ja, $e68ba20b3d2d159d$var$Qa, $e68ba20b3d2d159d$var$w2, $e68ba20b3d2d159d$var$v2, $e68ba20b3d2d159d$var$Yf, $e68ba20b3d2d159d$var$Zi, $e68ba20b3d2d159d$var$T2 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$Vf();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$Ja = ([e, t])=>[
            0,
            0,
            0,
            0,
            t,
            e,
            1,
            0
        ], $e68ba20b3d2d159d$var$Qa = (e)=>[
            e[5],
            e[4]
        ], $e68ba20b3d2d159d$var$w2 = (e)=>[
            0,
            0,
            0,
            0,
            Math.abs(e[4]),
            Math.abs(e[5]),
            1,
            0
        ], $e68ba20b3d2d159d$var$v2 = (e, t)=>$e68ba20b3d2d159d$var$ja($e68ba20b3d2d159d$var$Hf(e, t)), $e68ba20b3d2d159d$var$Yf = (e, t)=>$e68ba20b3d2d159d$var$Gf($e68ba20b3d2d159d$var$_p(e, t)), $e68ba20b3d2d159d$var$Zi = (e, t)=>$e68ba20b3d2d159d$var$Uf(e, t);
});
var $e68ba20b3d2d159d$var$Xf, $e68ba20b3d2d159d$var$S2, $e68ba20b3d2d159d$var$Kf = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$Xf = (e)=>[
            0,
            0,
            0,
            0,
            e[4],
            e[5],
            0,
            0
        ], $e68ba20b3d2d159d$var$S2 = (e, t)=>$e68ba20b3d2d159d$var$f2([
            0,
            0,
            0,
            0,
            t[4] - e[4],
            t[5] - e[5],
            0,
            0
        ]);
});
var $e68ba20b3d2d159d$var$$f, $e68ba20b3d2d159d$var$C2, $e68ba20b3d2d159d$var$A2, $e68ba20b3d2d159d$var$M2, $e68ba20b3d2d159d$var$nn, $e68ba20b3d2d159d$var$k2 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$Kf();
    $e68ba20b3d2d159d$var$$f = (e, t)=>$e68ba20b3d2d159d$var$u2($e68ba20b3d2d159d$var$$i(e, Math.sin(t / 2)), Math.cos(t / 2)), $e68ba20b3d2d159d$var$C2 = (e)=>[
            1,
            0,
            0,
            0,
            -(.5 * e[5]),
            .5 * e[4],
            0,
            0
        ], $e68ba20b3d2d159d$var$A2 = (e, t)=>{
        let r = .5 * t;
        return [
            1,
            0,
            0,
            0,
            r * e[4],
            r * e[5],
            0,
            0
        ];
    }, $e68ba20b3d2d159d$var$M2 = (e, t)=>$e68ba20b3d2d159d$var$$i(t, e), $e68ba20b3d2d159d$var$nn = (e, t)=>$e68ba20b3d2d159d$var$ja($e68ba20b3d2d159d$var$$i($e68ba20b3d2d159d$var$$i(e, t), $e68ba20b3d2d159d$var$al(e)));
});
function $e68ba20b3d2d159d$var$P2(e) {
    return [
        Math.min(e[0][0], e[1][0]),
        Math.min(e[0][1], e[1][1]),
        Math.max(e[0][0], e[1][0]),
        Math.max(e[0][1], e[1][1])
    ];
}
function $e68ba20b3d2d159d$var$ll(e, t) {
    return e[0] * t[1] - t[0] * e[1];
}
function $e68ba20b3d2d159d$var$pM(e, t) {
    return e[0] <= t[2] && e[2] >= t[0] && e[1] <= t[3] && e[3] >= t[1];
}
function $e68ba20b3d2d159d$var$Np(e, t) {
    return [
        e[0] - t[0],
        e[1] - t[1]
    ];
}
function $e68ba20b3d2d159d$var$L2(e, t) {
    let r = $e68ba20b3d2d159d$var$Np(e[1], e[0]), o = $e68ba20b3d2d159d$var$Np(t, e[0]), n = $e68ba20b3d2d159d$var$ll(r, o);
    return Math.abs(n) < $e68ba20b3d2d159d$var$uM;
}
function $e68ba20b3d2d159d$var$Zf(e, t) {
    let r = $e68ba20b3d2d159d$var$Np(e[1], e[0]), o = $e68ba20b3d2d159d$var$Np(t, e[0]);
    return $e68ba20b3d2d159d$var$ll(r, o) < 0;
}
function $e68ba20b3d2d159d$var$D2(e, t) {
    return $e68ba20b3d2d159d$var$L2(e, t[0]) || $e68ba20b3d2d159d$var$L2(e, t[1]) || ($e68ba20b3d2d159d$var$Zf(e, t[0]) ? !$e68ba20b3d2d159d$var$Zf(e, t[1]) : $e68ba20b3d2d159d$var$Zf(e, t[1]));
}
function $e68ba20b3d2d159d$var$_2(e, t) {
    return $e68ba20b3d2d159d$var$pM($e68ba20b3d2d159d$var$P2(e), $e68ba20b3d2d159d$var$P2(t)) && $e68ba20b3d2d159d$var$D2(e, t) && $e68ba20b3d2d159d$var$D2(t, e);
}
var $e68ba20b3d2d159d$var$uM, $e68ba20b3d2d159d$var$jf = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$uM = 1e-6;
});
var $e68ba20b3d2d159d$var$cl, $e68ba20b3d2d159d$var$Gc, $e68ba20b3d2d159d$var$hM, $e68ba20b3d2d159d$var$dl, $e68ba20b3d2d159d$var$an, $e68ba20b3d2d159d$var$gM, $e68ba20b3d2d159d$var$R2, $e68ba20b3d2d159d$var$fM, $e68ba20b3d2d159d$var$Ct, $e68ba20b3d2d159d$var$EM, $e68ba20b3d2d159d$var$qf, $e68ba20b3d2d159d$var$xM, $e68ba20b3d2d159d$var$N2, $e68ba20b3d2d159d$var$O2, $e68ba20b3d2d159d$var$bM, $e68ba20b3d2d159d$var$es, $e68ba20b3d2d159d$var$Jf, $e68ba20b3d2d159d$var$yM, $e68ba20b3d2d159d$var$wM, $e68ba20b3d2d159d$var$Qf, $e68ba20b3d2d159d$var$F2, $e68ba20b3d2d159d$var$eE, $e68ba20b3d2d159d$var$B2, $e68ba20b3d2d159d$var$vM, $e68ba20b3d2d159d$var$z2, $e68ba20b3d2d159d$var$H2, $e68ba20b3d2d159d$var$TM, $e68ba20b3d2d159d$var$U2, $e68ba20b3d2d159d$var$ts = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$jf();
    $e68ba20b3d2d159d$var$cl = 1e-4, $e68ba20b3d2d159d$var$Gc = (e, t, r)=>(e[0] - r[0]) * (t[1] - r[1]) - (e[1] - r[1]) * (t[0] - r[0]), $e68ba20b3d2d159d$var$hM = (e)=>{
        let t = e[0], r = e[e.length - 1];
        return t[0] === r[0] && t[1] === r[1];
    }, $e68ba20b3d2d159d$var$dl = (e)=>$e68ba20b3d2d159d$var$hM(e) ? e : [
            ...e,
            e[0]
        ], $e68ba20b3d2d159d$var$an = (e)=>{
        let t = e * 180 / Math.PI;
        return t < 0 ? 360 + t : t;
    }, $e68ba20b3d2d159d$var$gM = (e)=>e / 180 * Math.PI, $e68ba20b3d2d159d$var$R2 = (e, t)=>[
            e[0] * Math.cos(t) - e[1] * Math.sin(t),
            e[0] * Math.sin(t) + e[1] * Math.cos(t)
        ], $e68ba20b3d2d159d$var$fM = (e)=>e[0] === 0 && e[1] === 0, $e68ba20b3d2d159d$var$Ct = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$gM(t);
        return !r || $e68ba20b3d2d159d$var$fM(r) ? $e68ba20b3d2d159d$var$R2(e, o) : $e68ba20b3d2d159d$var$R2(e.map((n, i)=>n - r[i]), o).map((n, i)=>n + r[i]);
    }, $e68ba20b3d2d159d$var$EM = (e)=>[
            -e[0],
            -e[1]
        ], $e68ba20b3d2d159d$var$qf = (e, t)=>[
            e[0] + t[0],
            e[1] + t[1]
        ], $e68ba20b3d2d159d$var$xM = (e, t)=>$e68ba20b3d2d159d$var$Lt(...e, ...t), $e68ba20b3d2d159d$var$N2 = (e)=>$e68ba20b3d2d159d$var$an(Math.atan2(e[1][1] - e[0][1], e[1][0] - e[0][0])), $e68ba20b3d2d159d$var$O2 = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$qf(e, $e68ba20b3d2d159d$var$EM(t));
        return $e68ba20b3d2d159d$var$Ct(o, -$e68ba20b3d2d159d$var$an(r));
    }, $e68ba20b3d2d159d$var$bM = (e, t)=>{
        let [r, o] = e, [[n, i], [a, s]] = t, l = r - n, c = o - i, d = a - n, m = s - i, p = l * d + c * m, u = d * d + m * m, h = -1;
        u !== 0 && (h = p / u);
        let g, b;
        h < 0 ? (g = n, b = i) : h > 1 ? (g = a, b = s) : (g = n + h * d, b = i + h * m);
        let v = r - g, y = o - b;
        return Math.sqrt(v * v + y * y);
    }, $e68ba20b3d2d159d$var$es = (e, t, r = $e68ba20b3d2d159d$var$cl)=>{
        let o = $e68ba20b3d2d159d$var$bM(e, t);
        return o === 0 ? !0 : o < r;
    }, $e68ba20b3d2d159d$var$Jf = (e, t, r = $e68ba20b3d2d159d$var$cl)=>t.some((o)=>$e68ba20b3d2d159d$var$es(e, o, r)), $e68ba20b3d2d159d$var$yM = (e)=>{
        let [t, r, o, n] = e;
        return (i, a)=>Math.pow(1 - i, 3) * n[a] + 3 * i * Math.pow(1 - i, 2) * o[a] + 3 * Math.pow(i, 2) * (1 - i) * r[a] + t[a] * Math.pow(i, 3);
    }, $e68ba20b3d2d159d$var$wM = (e, t = 10)=>{
        let r = $e68ba20b3d2d159d$var$yM(e), o = [
            r(0, 0),
            r(0, 1)
        ], n = [], i = 0, a = 1 / t;
        for(let s = 0; s < t; s++)if (i += a, i <= 1) {
            let l = [
                r(i, 0),
                r(i, 1)
            ];
            n.push([
                o,
                l
            ]), o = l;
        }
        return n;
    }, $e68ba20b3d2d159d$var$Qf = (e, t, r = $e68ba20b3d2d159d$var$cl)=>$e68ba20b3d2d159d$var$Jf(e, $e68ba20b3d2d159d$var$wM(t), r), $e68ba20b3d2d159d$var$F2 = (e, t, r = $e68ba20b3d2d159d$var$cl)=>t.some((o)=>$e68ba20b3d2d159d$var$Qf(e, o, r)), $e68ba20b3d2d159d$var$eE = (e, t)=>{
        let r = e[0], o = e[1], n = !1;
        for(let i = 0, a = t.length - 1; i < t.length; a = i++){
            let s = t[i][0], l = t[i][1], c = t[a][0], d = t[a][1];
            (l > o && d <= o || l <= o && d > o) && r < (c - s) * (o - l) / (d - l) + s && (n = !n);
        }
        return n;
    }, $e68ba20b3d2d159d$var$B2 = (e, t, r = $e68ba20b3d2d159d$var$cl)=>{
        let o = !1, n = $e68ba20b3d2d159d$var$dl(t);
        for(let i = 0, a = n.length - 1; i < a; i++)if ($e68ba20b3d2d159d$var$es(e, [
            n[i],
            n[i + 1]
        ], r)) {
            o = !0;
            break;
        }
        return o;
    }, $e68ba20b3d2d159d$var$vM = (e, t)=>{
        let { angle: r, halfWidth: o, halfHeight: n, center: i } = t, a = o, s = n, [l, c] = $e68ba20b3d2d159d$var$O2(e, i, r), d = Math.abs(l), m = Math.abs(c), p = .707, u = .707;
        for(let b = 0; b < 3; b++){
            let v = a * p, y = s * u, w = (a * a - s * s) * p ** 3 / a, I = (s * s - a * a) * u ** 3 / s, M = v - w, C = y - I, P = d - w, k = m - I, _ = Math.hypot(C, M), A = Math.hypot(k, P);
            p = Math.min(1, Math.max(0, (P * _ / A + w) / a)), u = Math.min(1, Math.max(0, (k * _ / A + I) / s));
            let R = Math.hypot(u, p);
            p /= R, u /= R;
        }
        let [h, g] = [
            a * p * Math.sign(l),
            s * u * Math.sign(c)
        ];
        return $e68ba20b3d2d159d$var$xM([
            l,
            c
        ], [
            h,
            g
        ]);
    }, $e68ba20b3d2d159d$var$z2 = (e, t, r = $e68ba20b3d2d159d$var$cl)=>$e68ba20b3d2d159d$var$vM(e, t) <= r, $e68ba20b3d2d159d$var$H2 = (e, t)=>{
        let { center: r, angle: o, halfWidth: n, halfHeight: i } = t, [a, s] = $e68ba20b3d2d159d$var$O2(e, r, o);
        return a / n * (a / n) + s / i * (s / i) <= 1;
    }, $e68ba20b3d2d159d$var$TM = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$Op(e[1], e[0]), o = $e68ba20b3d2d159d$var$Op(t[1], t[0]), n = $e68ba20b3d2d159d$var$ll(r, o);
        if (n === 0) return null;
        let i = $e68ba20b3d2d159d$var$Op(t[0], e[0]), a = $e68ba20b3d2d159d$var$ll(i, r) / n, s = $e68ba20b3d2d159d$var$ll(i, o) / n;
        if (a === 0) return null;
        let l = $e68ba20b3d2d159d$var$G2(e[0], $e68ba20b3d2d159d$var$Wc(r, s));
        return s >= 0 && s < 1 && a >= 0 && a < 1 ? l : null;
    }, $e68ba20b3d2d159d$var$U2 = (e, t, r = 0)=>{
        let o = [
            e.x - r,
            e.y - r,
            e.x + e.width + r,
            e.y + e.height + r
        ], n = [
            (o[0] + o[2]) / 2,
            (o[1] + o[3]) / 2
        ];
        return [
            [
                $e68ba20b3d2d159d$var$J([
                    o[0],
                    o[1]
                ], n, e.angle),
                $e68ba20b3d2d159d$var$J([
                    o[2],
                    o[1]
                ], n, e.angle)
            ],
            [
                $e68ba20b3d2d159d$var$J([
                    o[2],
                    o[1]
                ], n, e.angle),
                $e68ba20b3d2d159d$var$J([
                    o[2],
                    o[3]
                ], n, e.angle)
            ],
            [
                $e68ba20b3d2d159d$var$J([
                    o[2],
                    o[3]
                ], n, e.angle),
                $e68ba20b3d2d159d$var$J([
                    o[0],
                    o[3]
                ], n, e.angle)
            ],
            [
                $e68ba20b3d2d159d$var$J([
                    o[0],
                    o[3]
                ], n, e.angle),
                $e68ba20b3d2d159d$var$J([
                    o[0],
                    o[1]
                ], n, e.angle)
            ]
        ].map((i)=>$e68ba20b3d2d159d$var$TM(t, i)).filter((i)=>!!i);
    };
});
var $e68ba20b3d2d159d$var$Vc, $e68ba20b3d2d159d$var$ml, $e68ba20b3d2d159d$var$Fp = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$Vc = (e, t, r = 0)=>{
        switch(t.type){
            case "polygon":
                return $e68ba20b3d2d159d$var$B2(e, t.data, r);
            case "ellipse":
                return $e68ba20b3d2d159d$var$z2(e, t.data, r);
            case "line":
                return $e68ba20b3d2d159d$var$es(e, t.data, r);
            case "polyline":
                return $e68ba20b3d2d159d$var$Jf(e, t.data, r);
            case "curve":
                return $e68ba20b3d2d159d$var$Qf(e, t.data, r);
            case "polycurve":
                return $e68ba20b3d2d159d$var$F2(e, t.data, r);
            default:
                throw Error(`shape ${t} is not implemented`);
        }
    }, $e68ba20b3d2d159d$var$ml = (e, t)=>{
        switch(t.type){
            case "polygon":
                return $e68ba20b3d2d159d$var$eE(e, t.data);
            case "line":
                return !1;
            case "curve":
                return !1;
            case "ellipse":
                return $e68ba20b3d2d159d$var$H2(e, t.data);
            case "polyline":
                {
                    let r = $e68ba20b3d2d159d$var$dl(t.data.flat());
                    return $e68ba20b3d2d159d$var$eE(e, r);
                }
            case "polycurve":
                return !1;
            default:
                throw Error(`shape ${t} is not implemented`);
        }
    };
});
var $e68ba20b3d2d159d$var$Ae, $e68ba20b3d2d159d$var$S, $e68ba20b3d2d159d$var$rs, $e68ba20b3d2d159d$var$Bp, $e68ba20b3d2d159d$var$pl, $e68ba20b3d2d159d$var$os, $e68ba20b3d2d159d$var$be = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Ae = {
        EQUAL: "Equal",
        MINUS: "Minus",
        NUM_ADD: "NumpadAdd",
        NUM_SUBTRACT: "NumpadSubtract",
        NUM_ZERO: "Numpad0",
        BRACKET_RIGHT: "BracketRight",
        BRACKET_LEFT: "BracketLeft",
        ONE: "Digit1",
        TWO: "Digit2",
        THREE: "Digit3",
        NINE: "Digit9",
        QUOTE: "Quote",
        ZERO: "Digit0",
        SLASH: "Slash",
        C: "KeyC",
        D: "KeyD",
        H: "KeyH",
        V: "KeyV",
        Z: "KeyZ",
        R: "KeyR",
        S: "KeyS"
    }, $e68ba20b3d2d159d$var$S = {
        ARROW_DOWN: "ArrowDown",
        ARROW_LEFT: "ArrowLeft",
        ARROW_RIGHT: "ArrowRight",
        ARROW_UP: "ArrowUp",
        PAGE_UP: "PageUp",
        PAGE_DOWN: "PageDown",
        BACKSPACE: "Backspace",
        ALT: "Alt",
        CTRL_OR_CMD: $e68ba20b3d2d159d$var$_r ? "metaKey" : "ctrlKey",
        DELETE: "Delete",
        ENTER: "Enter",
        ESCAPE: "Escape",
        QUESTION_MARK: "?",
        SPACE: " ",
        TAB: "Tab",
        CHEVRON_LEFT: "<",
        CHEVRON_RIGHT: ">",
        PERIOD: ".",
        COMMA: ",",
        SUBTRACT: "-",
        SLASH: "/",
        A: "a",
        C: "c",
        D: "d",
        E: "e",
        F: "f",
        G: "g",
        H: "h",
        I: "i",
        L: "l",
        O: "o",
        P: "p",
        Q: "q",
        R: "r",
        S: "s",
        T: "t",
        V: "v",
        X: "x",
        Y: "y",
        Z: "z",
        K: "k",
        W: "w",
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9"
    }, $e68ba20b3d2d159d$var$rs = (e)=>e === $e68ba20b3d2d159d$var$S.ARROW_LEFT || e === $e68ba20b3d2d159d$var$S.ARROW_RIGHT || e === $e68ba20b3d2d159d$var$S.ARROW_DOWN || e === $e68ba20b3d2d159d$var$S.ARROW_UP, $e68ba20b3d2d159d$var$Bp = (e)=>e.altKey, $e68ba20b3d2d159d$var$pl = (e)=>e.shiftKey, $e68ba20b3d2d159d$var$os = (e)=>e.shiftKey;
});
var $e68ba20b3d2d159d$var$zp, $e68ba20b3d2d159d$var$W2, $e68ba20b3d2d159d$var$V2, $e68ba20b3d2d159d$var$Y2, $e68ba20b3d2d159d$var$X2, $e68ba20b3d2d159d$var$IM, $e68ba20b3d2d159d$var$K2, $e68ba20b3d2d159d$var$$2, $e68ba20b3d2d159d$var$Hp = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$zp = (e)=>{
        let { angle: t, width: r, height: o, x: n, y: i } = e, a = $e68ba20b3d2d159d$var$an(t), s = n + r / 2, l = i + o / 2, c = [
            s,
            l
        ], d = [];
        return e.type === "diamond" ? d = [
            $e68ba20b3d2d159d$var$Ct([
                s,
                i
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                n + r,
                l
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                s,
                i + o
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                n,
                l
            ], a, c)
        ] : d = [
            $e68ba20b3d2d159d$var$Ct([
                n,
                i
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                n + r,
                i
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                n + r,
                i + o
            ], a, c),
            $e68ba20b3d2d159d$var$Ct([
                n,
                i + o
            ], a, c)
        ], {
            type: "polygon",
            data: d
        };
    }, $e68ba20b3d2d159d$var$W2 = (e, t, r = 10)=>{
        let [o, n, i, a, s, l] = $e68ba20b3d2d159d$var$ae(e, t, !0);
        o -= r, i += r, n -= r, a += r;
        let c = $e68ba20b3d2d159d$var$an(e.angle), d = [
            s,
            l
        ], m = $e68ba20b3d2d159d$var$Ct([
            o,
            n
        ], c, d), p = $e68ba20b3d2d159d$var$Ct([
            i,
            n
        ], c, d), u = $e68ba20b3d2d159d$var$Ct([
            o,
            a
        ], c, d), h = $e68ba20b3d2d159d$var$Ct([
            i,
            a
        ], c, d);
        return {
            type: "polygon",
            data: [
                m,
                p,
                h,
                u
            ]
        };
    }, $e68ba20b3d2d159d$var$V2 = (e)=>{
        let { width: t, height: r, angle: o, x: n, y: i } = e;
        return {
            type: "ellipse",
            data: {
                center: [
                    n + t / 2,
                    i + r / 2
                ],
                angle: o,
                halfWidth: t / 2,
                halfHeight: r / 2
            }
        };
    }, $e68ba20b3d2d159d$var$Y2 = (e)=>{
        for (let t of e.sets)if (t.type === "path") return t.ops;
        return e.sets[0].ops;
    }, $e68ba20b3d2d159d$var$X2 = (e, t = [
        0,
        0
    ], r, o)=>{
        let n = (l)=>$e68ba20b3d2d159d$var$Ct([
                l[0] + t[0],
                l[1] + t[1]
            ], $e68ba20b3d2d159d$var$an(r), o), i = $e68ba20b3d2d159d$var$Y2(e), a = [], s = [
            0,
            0
        ];
        for (let l of i)if (l.op === "move" && (s = n(l.data)), l.op === "bcurveTo") {
            let c = n([
                l.data[0],
                l.data[1]
            ]), d = n([
                l.data[2],
                l.data[3]
            ]), m = n([
                l.data[4],
                l.data[5]
            ]);
            a.push([
                s,
                c,
                d,
                m
            ]), s = m;
        }
        return {
            type: "polycurve",
            data: a
        };
    }, $e68ba20b3d2d159d$var$IM = (e)=>{
        let t = e[0], r = [];
        for(let o = 1; o < e.length; o++){
            let n = e[o];
            r.push([
                t,
                n
            ]), t = n;
        }
        return r;
    }, $e68ba20b3d2d159d$var$K2 = (e, t, r = !1)=>{
        let o = $e68ba20b3d2d159d$var$an(e.angle), n = (a)=>$e68ba20b3d2d159d$var$Ct($e68ba20b3d2d159d$var$qf(a, [
                e.x,
                e.y
            ]), o, t), i = $e68ba20b3d2d159d$var$IM(e.points.map((a)=>n(a)));
        return r ? {
            type: "polygon",
            data: $e68ba20b3d2d159d$var$dl(i.flat())
        } : {
            type: "polyline",
            data: i
        };
    }, $e68ba20b3d2d159d$var$$2 = (e, t, r = [
        0,
        0
    ], o, n)=>{
        let i = (d)=>$e68ba20b3d2d159d$var$Ct([
                d[0] + r[0],
                d[1] + r[1]
            ], $e68ba20b3d2d159d$var$an(o), n);
        if (e.roundness === null) return {
            type: "polygon",
            data: $e68ba20b3d2d159d$var$dl(e.points.map((d)=>i(d)))
        };
        let a = $e68ba20b3d2d159d$var$Y2(t), s = [], l = !1;
        for (let d of a)d.op === "move" ? (l = !l, l && s.push([
            d.data[0],
            d.data[1]
        ])) : d.op === "bcurveTo" ? l && (s.push([
            d.data[0],
            d.data[1]
        ]), s.push([
            d.data[2],
            d.data[3]
        ]), s.push([
            d.data[4],
            d.data[5]
        ])) : d.op === "lineTo" && l && s.push([
            d.data[0],
            d.data[1]
        ]);
        return {
            type: "polygon",
            data: (0, $989397d018ece9d6$export$b28976ce5879d0d)(s, 10, 5).map((d)=>i(d))
        };
    };
});
var $e68ba20b3d2d159d$var$Up, $e68ba20b3d2d159d$var$ns, $e68ba20b3d2d159d$var$Yc, $e68ba20b3d2d159d$var$Z2, $e68ba20b3d2d159d$var$tE, $e68ba20b3d2d159d$var$Xc = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Hp();
    $e68ba20b3d2d159d$var$Fp();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$ul();
    $e68ba20b3d2d159d$var$Up = (e)=>{
        if (e.type === "arrow") return !1;
        let t = !$e68ba20b3d2d159d$var$Rr(e.backgroundColor) || $e68ba20b3d2d159d$var$It(e) || $e68ba20b3d2d159d$var$cr(e) || $e68ba20b3d2d159d$var$G(e);
        return e.type === "line" ? t && $e68ba20b3d2d159d$var$Br(e.points) : e.type === "freedraw" ? t && $e68ba20b3d2d159d$var$Br(e.points) : t || $e68ba20b3d2d159d$var$Ao(e);
    }, $e68ba20b3d2d159d$var$ns = ({ x: e, y: t, element: r, shape: o, threshold: n = 10, frameNameBound: i = null })=>{
        let a = $e68ba20b3d2d159d$var$Up(r) ? $e68ba20b3d2d159d$var$ml([
            e,
            t
        ], o) || $e68ba20b3d2d159d$var$Vc([
            e,
            t
        ], o, n) : $e68ba20b3d2d159d$var$Vc([
            e,
            t
        ], o, n);
        return !a && i && (a = $e68ba20b3d2d159d$var$ml([
            e,
            t
        ], {
            type: "polygon",
            data: $e68ba20b3d2d159d$var$zp(i).data
        })), a;
    }, $e68ba20b3d2d159d$var$Yc = (e, t, r, o, n = 0)=>{
        let [i, a, s, l] = $e68ba20b3d2d159d$var$go(r, o);
        return i -= n, a -= n, s += n, l += n, $e68ba20b3d2d159d$var$Wp([
            i,
            a
        ], [
            e,
            t
        ], [
            s,
            l
        ]);
    }, $e68ba20b3d2d159d$var$Z2 = (e, t)=>!$e68ba20b3d2d159d$var$ns(e) && !$e68ba20b3d2d159d$var$tE(e.x, e.y, $e68ba20b3d2d159d$var$Gp(e.element, t)) && $e68ba20b3d2d159d$var$Yc(e.x, e.y, e.element, t), $e68ba20b3d2d159d$var$tE = (e, t, r)=>!!r && $e68ba20b3d2d159d$var$ml([
            e,
            t
        ], r);
});
var $e68ba20b3d2d159d$var$Kc, $e68ba20b3d2d159d$var$j2, $e68ba20b3d2d159d$var$sn, $e68ba20b3d2d159d$var$Gp, $e68ba20b3d2d159d$var$ul = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Hp();
    $e68ba20b3d2d159d$var$oe();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$Xc();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$be();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$Kc = [
        {
            icon: $e68ba20b3d2d159d$var$Ay,
            value: "selection",
            key: $e68ba20b3d2d159d$var$S.V,
            numericKey: $e68ba20b3d2d159d$var$S[1],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$My,
            value: "rectangle",
            key: $e68ba20b3d2d159d$var$S.R,
            numericKey: $e68ba20b3d2d159d$var$S[2],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$ky,
            value: "diamond",
            key: $e68ba20b3d2d159d$var$S.D,
            numericKey: $e68ba20b3d2d159d$var$S[3],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$Py,
            value: "ellipse",
            key: $e68ba20b3d2d159d$var$S.O,
            numericKey: $e68ba20b3d2d159d$var$S[4],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$Ly,
            value: "arrow",
            key: $e68ba20b3d2d159d$var$S.A,
            numericKey: $e68ba20b3d2d159d$var$S[5],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$Dy,
            value: "line",
            key: $e68ba20b3d2d159d$var$S.L,
            numericKey: $e68ba20b3d2d159d$var$S[6],
            fillable: !0
        },
        {
            icon: $e68ba20b3d2d159d$var$di,
            value: "freedraw",
            key: [
                $e68ba20b3d2d159d$var$S.P,
                $e68ba20b3d2d159d$var$S.X
            ],
            numericKey: $e68ba20b3d2d159d$var$S[7],
            fillable: !1
        },
        {
            icon: $e68ba20b3d2d159d$var$up,
            value: "text",
            key: $e68ba20b3d2d159d$var$S.T,
            numericKey: $e68ba20b3d2d159d$var$S[8],
            fillable: !1
        },
        {
            icon: $e68ba20b3d2d159d$var$Ry,
            value: "image",
            key: null,
            numericKey: $e68ba20b3d2d159d$var$S[9],
            fillable: !1
        },
        {
            icon: $e68ba20b3d2d159d$var$Ny,
            value: "eraser",
            key: $e68ba20b3d2d159d$var$S.E,
            numericKey: $e68ba20b3d2d159d$var$S[0],
            fillable: !1
        }
    ], $e68ba20b3d2d159d$var$j2 = (e)=>$e68ba20b3d2d159d$var$Kc.find((r, o)=>r.numericKey != null && e === r.numericKey.toString() || r.key && (typeof r.key == "string" ? r.key === e : r.key.includes(e)))?.value || null, $e68ba20b3d2d159d$var$sn = (e, t)=>{
        switch(e.type){
            case "rectangle":
            case "diamond":
            case "frame":
            case "magicframe":
            case "embeddable":
            case "image":
            case "iframe":
            case "text":
            case "selection":
                return $e68ba20b3d2d159d$var$zp(e);
            case "arrow":
            case "line":
                {
                    let r = $e68ba20b3d2d159d$var$Oe.get(e)?.[0] ?? $e68ba20b3d2d159d$var$Oe.generateElementShape(e, null)[0], [, , , , o, n] = $e68ba20b3d2d159d$var$ae(e, t);
                    return $e68ba20b3d2d159d$var$Up(e) ? $e68ba20b3d2d159d$var$$2(e, r, [
                        e.x,
                        e.y
                    ], e.angle, [
                        o,
                        n
                    ]) : $e68ba20b3d2d159d$var$X2(r, [
                        e.x,
                        e.y
                    ], e.angle, [
                        o,
                        n
                    ]);
                }
            case "ellipse":
                return $e68ba20b3d2d159d$var$V2(e);
            case "freedraw":
                {
                    let [, , , , r, o] = $e68ba20b3d2d159d$var$ae(e, t);
                    return $e68ba20b3d2d159d$var$K2(e, [
                        r,
                        o
                    ], $e68ba20b3d2d159d$var$Up(e));
                }
        }
    }, $e68ba20b3d2d159d$var$Gp = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$te(e, t);
        return r ? e.type === "arrow" ? $e68ba20b3d2d159d$var$sn({
            ...r,
            ...$e68ba20b3d2d159d$var$$.getBoundTextElementPosition(e, r, t)
        }, t) : $e68ba20b3d2d159d$var$sn(r, t) : null;
    };
});
var $e68ba20b3d2d159d$var$At, $e68ba20b3d2d159d$var$pr, $e68ba20b3d2d159d$var$ur, $e68ba20b3d2d159d$var$hr, $e68ba20b3d2d159d$var$Vp, $e68ba20b3d2d159d$var$ji, $e68ba20b3d2d159d$var$cn, $e68ba20b3d2d159d$var$$c, $e68ba20b3d2d159d$var$Yp = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$At = [
        1,
        0
    ], $e68ba20b3d2d159d$var$pr = [
        0,
        1
    ], $e68ba20b3d2d159d$var$ur = [
        -1,
        0
    ], $e68ba20b3d2d159d$var$hr = [
        0,
        -1
    ], $e68ba20b3d2d159d$var$Vp = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$N2([
            e,
            t
        ]);
        return r >= 315 || r < 45 ? $e68ba20b3d2d159d$var$hr : r >= 45 && r < 135 ? $e68ba20b3d2d159d$var$At : r >= 135 && r < 225 ? $e68ba20b3d2d159d$var$pr : $e68ba20b3d2d159d$var$ur;
    }, $e68ba20b3d2d159d$var$ji = (e)=>{
        let [t, r] = e, o = Math.abs(t), n = Math.abs(r);
        return t > n ? $e68ba20b3d2d159d$var$At : t <= -n ? $e68ba20b3d2d159d$var$ur : r > o ? $e68ba20b3d2d159d$var$pr : $e68ba20b3d2d159d$var$hr;
    }, $e68ba20b3d2d159d$var$cn = (e, t)=>e[0] === t[0] && e[1] === t[1], $e68ba20b3d2d159d$var$$c = (e, t, r)=>{
        let n = $e68ba20b3d2d159d$var$Xp(t);
        if (e.type === "diamond") {
            if (r[0] < e.x) return $e68ba20b3d2d159d$var$ur;
            if (r[1] < e.y) return $e68ba20b3d2d159d$var$hr;
            if (r[0] > e.x + e.width) return $e68ba20b3d2d159d$var$At;
            if (r[1] > e.y + e.height) return $e68ba20b3d2d159d$var$pr;
            let c = $e68ba20b3d2d159d$var$J($e68ba20b3d2d159d$var$ln([
                e.x + e.width / 2,
                e.y
            ], n, 2), n, e.angle), d = $e68ba20b3d2d159d$var$J($e68ba20b3d2d159d$var$ln([
                e.x + e.width,
                e.y + e.height / 2
            ], n, 2), n, e.angle), m = $e68ba20b3d2d159d$var$J($e68ba20b3d2d159d$var$ln([
                e.x + e.width / 2,
                e.y + e.height
            ], n, 2), n, e.angle), p = $e68ba20b3d2d159d$var$J($e68ba20b3d2d159d$var$ln([
                e.x,
                e.y + e.height / 2
            ], n, 2), n, e.angle);
            return $e68ba20b3d2d159d$var$is(r, c, d, n) ? $e68ba20b3d2d159d$var$Vp(c, d) : $e68ba20b3d2d159d$var$is(r, d, m, n) ? $e68ba20b3d2d159d$var$Vp(d, m) : $e68ba20b3d2d159d$var$is(r, m, p, n) ? $e68ba20b3d2d159d$var$Vp(m, p) : $e68ba20b3d2d159d$var$Vp(p, c);
        }
        let i = $e68ba20b3d2d159d$var$ln([
            t[0],
            t[1]
        ], n, 2), a = $e68ba20b3d2d159d$var$ln([
            t[2],
            t[1]
        ], n, 2), s = $e68ba20b3d2d159d$var$ln([
            t[0],
            t[3]
        ], n, 2), l = $e68ba20b3d2d159d$var$ln([
            t[2],
            t[3]
        ], n, 2);
        return $e68ba20b3d2d159d$var$is(r, i, a, n) ? $e68ba20b3d2d159d$var$hr : $e68ba20b3d2d159d$var$is(r, a, l, n) ? $e68ba20b3d2d159d$var$At : $e68ba20b3d2d159d$var$is(r, l, s, n) ? $e68ba20b3d2d159d$var$pr : $e68ba20b3d2d159d$var$ur;
    };
});
var $e68ba20b3d2d159d$var$ev, $e68ba20b3d2d159d$var$zn, $e68ba20b3d2d159d$var$st, $e68ba20b3d2d159d$var$CM, $e68ba20b3d2d159d$var$as, $e68ba20b3d2d159d$var$q2, $e68ba20b3d2d159d$var$AM, $e68ba20b3d2d159d$var$tv, $e68ba20b3d2d159d$var$MM, $e68ba20b3d2d159d$var$kM, $e68ba20b3d2d159d$var$ss, $e68ba20b3d2d159d$var$jp, $e68ba20b3d2d159d$var$jc, $e68ba20b3d2d159d$var$fo, $e68ba20b3d2d159d$var$rv, $e68ba20b3d2d159d$var$oE, $e68ba20b3d2d159d$var$ov, $e68ba20b3d2d159d$var$PM, $e68ba20b3d2d159d$var$Ir, $e68ba20b3d2d159d$var$LM, $e68ba20b3d2d159d$var$Jt, $e68ba20b3d2d159d$var$DM, $e68ba20b3d2d159d$var$_M, $e68ba20b3d2d159d$var$nv, $e68ba20b3d2d159d$var$RM, $e68ba20b3d2d159d$var$fl, $e68ba20b3d2d159d$var$NM, $e68ba20b3d2d159d$var$iv, $e68ba20b3d2d159d$var$av, $e68ba20b3d2d159d$var$OM, $e68ba20b3d2d159d$var$qc, $e68ba20b3d2d159d$var$J2, $e68ba20b3d2d159d$var$hl, $e68ba20b3d2d159d$var$sv, $e68ba20b3d2d159d$var$qp, $e68ba20b3d2d159d$var$Q2, $e68ba20b3d2d159d$var$Jp, $e68ba20b3d2d159d$var$Zc, $e68ba20b3d2d159d$var$lv, $e68ba20b3d2d159d$var$Jc, $e68ba20b3d2d159d$var$El, $e68ba20b3d2d159d$var$FM, $e68ba20b3d2d159d$var$BM, $e68ba20b3d2d159d$var$zM, $e68ba20b3d2d159d$var$HM, $e68ba20b3d2d159d$var$nE, $e68ba20b3d2d159d$var$iE, $e68ba20b3d2d159d$var$aE, $e68ba20b3d2d159d$var$UM, $e68ba20b3d2d159d$var$GM, $e68ba20b3d2d159d$var$rE, $e68ba20b3d2d159d$var$WM, $e68ba20b3d2d159d$var$cv, $e68ba20b3d2d159d$var$VM, $e68ba20b3d2d159d$var$YM, $e68ba20b3d2d159d$var$XM, $e68ba20b3d2d159d$var$KM, $e68ba20b3d2d159d$var$$M, $e68ba20b3d2d159d$var$ZM, $e68ba20b3d2d159d$var$dv, $e68ba20b3d2d159d$var$Kp, $e68ba20b3d2d159d$var$$p, $e68ba20b3d2d159d$var$qi, $e68ba20b3d2d159d$var$Ji, $e68ba20b3d2d159d$var$Zp, $e68ba20b3d2d159d$var$jM, $e68ba20b3d2d159d$var$mv, $e68ba20b3d2d159d$var$Qc, $e68ba20b3d2d159d$var$Qt = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$qa();
    $e68ba20b3d2d159d$var$T2();
    $e68ba20b3d2d159d$var$Kf();
    $e68ba20b3d2d159d$var$Vf();
    $e68ba20b3d2d159d$var$k2();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Fp();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$be();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$ul();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$Yp();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$ev = (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD], $e68ba20b3d2d159d$var$zn = (e)=>e.isBindingEnabled, $e68ba20b3d2d159d$var$st = 5, $e68ba20b3d2d159d$var$CM = (e, t)=>{
        let r = [];
        return t.forEach((o)=>{
            let n = e.getNonDeletedElement(o);
            n != null && r.push(n);
        }), r;
    }, $e68ba20b3d2d159d$var$as = (e, t, r, o, n)=>{
        let i = new Set, a = new Set;
        $e68ba20b3d2d159d$var$q2(e, t, r, "start", i, a, o), $e68ba20b3d2d159d$var$q2(e, r, t, "end", i, a, o);
        let s = Array.from(a).filter((l)=>!i.has(l));
        $e68ba20b3d2d159d$var$CM(n, s).forEach((l)=>{
            $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                boundElements: l.boundElements?.filter((c)=>c.type !== "arrow" || c.id !== e.id)
            });
        });
    }, $e68ba20b3d2d159d$var$q2 = (e, t, r, o, n, i, a)=>{
        if (t !== "keep") {
            if (t === null) {
                let s = $e68ba20b3d2d159d$var$PM(e, o);
                s != null && i.add(s);
                return;
            }
            $e68ba20b3d2d159d$var$ov(e) ? (r == null || (r === "keep" ? !$e68ba20b3d2d159d$var$rv(e, t, o) : o === "start" || r.id !== t.id)) && ($e68ba20b3d2d159d$var$fo(e, t, o, a), n.add(t.id)) : ($e68ba20b3d2d159d$var$fo(e, t, o, a), n.add(t.id));
        }
    }, $e68ba20b3d2d159d$var$AM = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$sv(e, t, r), n = t === "start" ? e.startBinding?.elementId : e.endBinding?.elementId;
        if (n) {
            let i = r.get(n);
            if ($e68ba20b3d2d159d$var$po(i) && $e68ba20b3d2d159d$var$lv(i, o, r)) return i;
        }
        return null;
    }, $e68ba20b3d2d159d$var$tv = (e, t)=>[
            "start",
            "end"
        ].map((r)=>$e68ba20b3d2d159d$var$AM(e, r, t)), $e68ba20b3d2d159d$var$MM = (e, t, r, o, n)=>{
        let a = e.points.length - 1, s = r.findIndex((m)=>m === 0) > -1, l = r.findIndex((m)=>m === a) > -1, c = s ? t ? $e68ba20b3d2d159d$var$hl(e, "start", o, n) : null : $e68ba20b3d2d159d$var$hl(e, "start", o, n), d = l ? t ? $e68ba20b3d2d159d$var$hl(e, "end", o, n) : null : $e68ba20b3d2d159d$var$hl(e, "end", o, n);
        return [
            c,
            d
        ];
    }, $e68ba20b3d2d159d$var$kM = (e, t, r, o)=>{
        let [n, i] = $e68ba20b3d2d159d$var$tv(e, t), a = n && o ? $e68ba20b3d2d159d$var$hl(e, "start", t, r) : null, s = i && o ? $e68ba20b3d2d159d$var$hl(e, "end", t, r) : null;
        return [
            a,
            s
        ];
    }, $e68ba20b3d2d159d$var$ss = (e, t, r, o, n, i)=>{
        e.forEach((a)=>{
            let [s, l] = i?.length ? $e68ba20b3d2d159d$var$MM(a, n, i ?? [], t, r) : $e68ba20b3d2d159d$var$kM(a, t, r, n);
            $e68ba20b3d2d159d$var$as(a, s, l, t, o);
        });
    }, $e68ba20b3d2d159d$var$jp = (e, t)=>e.length > 50 ? [] : e.filter($e68ba20b3d2d159d$export$5df2ebb939539835).flatMap((r)=>$e68ba20b3d2d159d$var$tv(r, t)).filter((r)=>r !== null).filter((r)=>e.filter((o)=>o.id === r?.id).length === 0), $e68ba20b3d2d159d$var$jc = (e, t, r, o, n)=>{
        t.startBoundElement != null && $e68ba20b3d2d159d$var$fo(e, t.startBoundElement, "start", o);
        let i = $e68ba20b3d2d159d$var$Ir(r, n, o, $e68ba20b3d2d159d$var$ce(e) && $e68ba20b3d2d159d$var$ce(e));
        i !== null && ($e68ba20b3d2d159d$var$rv(e, i, "end") || $e68ba20b3d2d159d$var$fo(e, i, "end", o));
    }, $e68ba20b3d2d159d$var$fo = (e, t, r, o)=>{
        if (!$e68ba20b3d2d159d$var$ie(e)) return;
        let n = {
            elementId: t.id,
            ...$e68ba20b3d2d159d$var$LM(e, t, r, o),
            ...$e68ba20b3d2d159d$var$ce(e) ? $e68ba20b3d2d159d$var$qc(e, t, r, o) : {
                fixedPoint: null
            }
        };
        $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            [r === "start" ? "startBinding" : "endBinding"]: n
        }), $e68ba20b3d2d159d$var$j(t.boundElements || []).has(e.id) || $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
            boundElements: (t.boundElements || []).concat({
                id: e.id,
                type: "arrow"
            })
        });
    }, $e68ba20b3d2d159d$var$rv = (e, t, r)=>{
        let o = e[r === "start" ? "endBinding" : "startBinding"];
        return $e68ba20b3d2d159d$var$oE(e, o?.elementId, t);
    }, $e68ba20b3d2d159d$var$oE = (e, t, r)=>t === r.id && $e68ba20b3d2d159d$var$ov(e), $e68ba20b3d2d159d$var$ov = (e)=>e.points.length < 3, $e68ba20b3d2d159d$var$PM = (e, t)=>{
        let r = t === "start" ? "startBinding" : "endBinding", o = e[r];
        return o == null ? null : ($e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            [r]: null
        }), o.elementId);
    }, $e68ba20b3d2d159d$var$Ir = (e, t, r, o)=>$e68ba20b3d2d159d$var$sE(t, (i)=>$e68ba20b3d2d159d$var$po(i, !1) && $e68ba20b3d2d159d$var$lv(i, e, r, o && !$e68ba20b3d2d159d$var$re(i))), $e68ba20b3d2d159d$var$LM = (e, t, r, o)=>{
        let n = r === "start" ? -1 : 1, i = n === -1 ? 0 : e.points.length - 1, a = i - n, s = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, i, o), l = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, a, o);
        return {
            focus: $e68ba20b3d2d159d$var$UM(t, l, s, o),
            gap: Math.max(1, $e68ba20b3d2d159d$var$El(t, s, o))
        };
    }, $e68ba20b3d2d159d$var$Jt = (e, t, r)=>{
        let { oldSize: o, simultaneouslyUpdated: n, changedElements: i } = r ?? {}, a = $e68ba20b3d2d159d$var$_M(n);
        $e68ba20b3d2d159d$var$po(e) && $e68ba20b3d2d159d$var$Kp(t, e, (s)=>{
            if (!$e68ba20b3d2d159d$export$5df2ebb939539835(s) || s.isDeleted || !$e68ba20b3d2d159d$var$DM(s, e)) return;
            let l = {
                startBinding: $e68ba20b3d2d159d$var$J2(e, s.startBinding, o),
                endBinding: $e68ba20b3d2d159d$var$J2(e, s.endBinding, o)
            };
            if (a.has(s.id)) {
                $e68ba20b3d2d159d$export$55655e96a21bba2e(s, l);
                return;
            }
            let c = $e68ba20b3d2d159d$var$$p(t, s, (m, p)=>{
                if (m && $e68ba20b3d2d159d$var$po(m) && (p === "startBinding" || p === "endBinding") && e.id === s[p]?.elementId) {
                    let u = $e68ba20b3d2d159d$var$OM(s, p, l[p], m, t);
                    if (u) return {
                        index: p === "startBinding" ? 0 : s.points.length - 1,
                        point: u
                    };
                }
                return null;
            }).filter((m)=>m !== null);
            $e68ba20b3d2d159d$var$$.movePoints(s, c, t, {
                ...e.id === s.startBinding?.elementId ? {
                    startBinding: l.startBinding
                } : {},
                ...e.id === s.endBinding?.elementId ? {
                    endBinding: l.endBinding
                } : {}
            }, {
                changedElements: i
            });
            let d = $e68ba20b3d2d159d$var$te(s, t);
            d && !d.isDeleted && $e68ba20b3d2d159d$var$mn(s, t, !1);
        });
    }, $e68ba20b3d2d159d$var$DM = (e, t)=>e.startBinding?.elementId === t.id || e.endBinding?.elementId === t.id, $e68ba20b3d2d159d$var$_M = (e)=>new Set((e || []).map((t)=>t.id)), $e68ba20b3d2d159d$var$nv = (e, t, r, o, n, i)=>{
        let a = $e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(t, e));
        return !r || !o ? a : $e68ba20b3d2d159d$var$RM(i, r, n) ? $e68ba20b3d2d159d$var$$c(r, o, e) : $e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(e, $e68ba20b3d2d159d$var$Qp(r)));
    }, $e68ba20b3d2d159d$var$RM = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$El(t, e, r), n = $e68ba20b3d2d159d$var$Jc(t, t.width, t.height);
        return o > n ? null : o;
    }, $e68ba20b3d2d159d$var$fl = (e, t, r, o)=>{
        let n = r && $e68ba20b3d2d159d$var$dn(r);
        if (r && n) {
            let i = $e68ba20b3d2d159d$var$$c(r, n, e), a = [
                ...$e68ba20b3d2d159d$var$rE(r, [
                    e[0],
                    e[1] - 2 * r.height
                ], [
                    e[0],
                    e[1] + 2 * r.height
                ], $e68ba20b3d2d159d$var$st, o),
                ...$e68ba20b3d2d159d$var$rE(r, [
                    e[0] - 2 * r.width,
                    e[1]
                ], [
                    e[0] + 2 * r.width,
                    e[1]
                ], $e68ba20b3d2d159d$var$st, o)
            ], s = $e68ba20b3d2d159d$var$cn(i, $e68ba20b3d2d159d$var$ur) || $e68ba20b3d2d159d$var$cn(i, $e68ba20b3d2d159d$var$At), l = Math.abs($e68ba20b3d2d159d$var$El(r, e, o)), c = s ? l < r.width * -0.1 : l < r.height * -0.1;
            return a.sort((d, m)=>$e68ba20b3d2d159d$var$gl(d, e) - $e68ba20b3d2d159d$var$gl(m, e)), c ? $e68ba20b3d2d159d$var$NM(t, r, n) : a.filter((d)=>s ? Math.abs(e[1] - d[1]) < .1 : Math.abs(e[0] - d[0]) < .1)[0] ?? e;
        }
        return e;
    }, $e68ba20b3d2d159d$var$NM = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$Xp(r), n = $e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(e, o));
        switch(!0){
            case $e68ba20b3d2d159d$var$cn(n, $e68ba20b3d2d159d$var$hr):
                return $e68ba20b3d2d159d$var$J([
                    (r[0] + r[2]) / 2 + .1,
                    r[1]
                ], o, t.angle);
            case $e68ba20b3d2d159d$var$cn(n, $e68ba20b3d2d159d$var$At):
                return $e68ba20b3d2d159d$var$J([
                    r[2],
                    (r[1] + r[3]) / 2 + .1
                ], o, t.angle);
            case $e68ba20b3d2d159d$var$cn(n, $e68ba20b3d2d159d$var$pr):
                return $e68ba20b3d2d159d$var$J([
                    (r[0] + r[2]) / 2 - .1,
                    r[3]
                ], o, t.angle);
            default:
                return $e68ba20b3d2d159d$var$J([
                    r[0],
                    (r[1] + r[3]) / 2 - .1
                ], o, t.angle);
        }
    }, $e68ba20b3d2d159d$var$iv = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$Qp(e), o = $e68ba20b3d2d159d$var$J(t, r, -e.angle);
        return o[0] < e.x && o[1] < e.y ? o[1] - e.y > -$e68ba20b3d2d159d$var$st ? $e68ba20b3d2d159d$var$J([
            e.x - $e68ba20b3d2d159d$var$st,
            e.y
        ], r, e.angle) : $e68ba20b3d2d159d$var$J([
            e.x,
            e.y - $e68ba20b3d2d159d$var$st
        ], r, e.angle) : o[0] < e.x && o[1] > e.y + e.height ? o[0] - e.x > -$e68ba20b3d2d159d$var$st ? $e68ba20b3d2d159d$var$J([
            e.x,
            e.y + e.height + $e68ba20b3d2d159d$var$st
        ], r, e.angle) : $e68ba20b3d2d159d$var$J([
            e.x - $e68ba20b3d2d159d$var$st,
            e.y + e.height
        ], r, e.angle) : o[0] > e.x + e.width && o[1] > e.y + e.height ? o[0] - e.x < e.width + $e68ba20b3d2d159d$var$st ? $e68ba20b3d2d159d$var$J([
            e.x + e.width,
            e.y + e.height + $e68ba20b3d2d159d$var$st
        ], r, e.angle) : $e68ba20b3d2d159d$var$J([
            e.x + e.width + $e68ba20b3d2d159d$var$st,
            e.y + e.height
        ], r, e.angle) : o[0] > e.x + e.width && o[1] < e.y ? o[0] - e.x < e.width + $e68ba20b3d2d159d$var$st ? $e68ba20b3d2d159d$var$J([
            e.x + e.width,
            e.y - $e68ba20b3d2d159d$var$st
        ], r, e.angle) : $e68ba20b3d2d159d$var$J([
            e.x + e.width + $e68ba20b3d2d159d$var$st,
            e.y
        ], r, e.angle) : t;
    }, $e68ba20b3d2d159d$var$av = (e, t, r = .05)=>{
        let { x: o, y: n, width: i, height: a, angle: s } = e, l = [
            o + i / 2 - .1,
            n + a / 2 - .1
        ], c = $e68ba20b3d2d159d$var$J(t, l, -s), d = $e68ba20b3d2d159d$var$Bn(r * a, 5, 80), m = $e68ba20b3d2d159d$var$Bn(r * i, 5, 80);
        return c[0] <= o + i / 2 && c[1] > l[1] - d && c[1] < l[1] + d ? $e68ba20b3d2d159d$var$J([
            o - $e68ba20b3d2d159d$var$st,
            l[1]
        ], l, s) : c[1] <= n + a / 2 && c[0] > l[0] - m && c[0] < l[0] + m ? $e68ba20b3d2d159d$var$J([
            l[0],
            n - $e68ba20b3d2d159d$var$st
        ], l, s) : c[0] >= o + i / 2 && c[1] > l[1] - d && c[1] < l[1] + d ? $e68ba20b3d2d159d$var$J([
            o + i + $e68ba20b3d2d159d$var$st,
            l[1]
        ], l, s) : c[1] >= n + a / 2 && c[0] > l[0] - m && c[0] < l[0] + m ? $e68ba20b3d2d159d$var$J([
            l[0],
            n + a + $e68ba20b3d2d159d$var$st
        ], l, s) : t;
    }, $e68ba20b3d2d159d$var$OM = (e, t, r, o, n)=>{
        if (r == null || r.elementId !== o.id && e.points.length > 2) return null;
        let i = t === "startBinding" ? -1 : 1, a = i === -1 ? 0 : e.points.length - 1;
        if ($e68ba20b3d2d159d$var$ce(e)) {
            let m = $e68ba20b3d2d159d$var$Qc(r.fixedPoint) ?? $e68ba20b3d2d159d$var$qc(e, o, t === "startBinding" ? "start" : "end", n).fixedPoint, p = [
                o.x + o.width / 2,
                o.y + o.height / 2
            ], u = [
                o.x + m[0] * o.width,
                o.y + m[1] * o.height
            ], h = $e68ba20b3d2d159d$var$J(u, p, o.angle);
            return $e68ba20b3d2d159d$var$$.pointFromAbsoluteCoords(e, h, n);
        }
        let s = a - i, l = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, s, n), c = $e68ba20b3d2d159d$var$GM(o, r.focus, l, n), d;
        if (r.gap === 0) d = c;
        else {
            let m = $e68ba20b3d2d159d$var$rE(o, l, c, r.gap, n);
            m.length === 0 ? d = c : d = m[0];
        }
        return $e68ba20b3d2d159d$var$$.pointFromAbsoluteCoords(e, d, n);
    }, $e68ba20b3d2d159d$var$qc = (e, t, r, o)=>{
        let n = [
            t.x,
            t.y,
            t.x + t.width,
            t.y + t.height
        ], i = r === "start" ? 0 : e.points.length - 1, a = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, i, o), s = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, i, o), l = $e68ba20b3d2d159d$var$fl(a, s, t, o), c = [
            n[0] + (n[2] - n[0]) / 2,
            n[1] + (n[3] - n[1]) / 2
        ], d = $e68ba20b3d2d159d$var$J(l, c, -t.angle);
        return {
            fixedPoint: $e68ba20b3d2d159d$var$Qc([
                (d[0] - t.x) / t.width,
                (d[1] - t.y) / t.height
            ])
        };
    }, $e68ba20b3d2d159d$var$J2 = (e, t, r)=>{
        if (t == null || r == null) return t;
        let { width: o, height: n } = r, { width: i, height: a } = e, s = Math.max(1, Math.min($e68ba20b3d2d159d$var$Jc(e, o, n), t.gap * (o < n ? o / i : n / a)));
        return {
            ...t,
            gap: s
        };
    }, $e68ba20b3d2d159d$var$hl = (e, t, r, o)=>$e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sv(e, t, r), o, r), $e68ba20b3d2d159d$var$sv = (e, t, r)=>{
        let o = t === "start" ? 0 : -1;
        return $e68ba20b3d2d159d$var$sr($e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(e, o, r));
    }, $e68ba20b3d2d159d$var$qp = (e, t, r, o)=>{
        let n = new Set, i = new Set, a = o === "duplicatesServeAsOld", s = new Map([
            ...r
        ].map(([l, c])=>[
                c,
                l
            ]));
        t.forEach((l)=>{
            let { boundElements: c } = l;
            if (c != null && c.length > 0 && (c.forEach((d)=>{
                a && !r.has(d.id) && n.add(d.id);
            }), i.add(r.get(l.id))), $e68ba20b3d2d159d$var$qr(l)) {
                if (l.startBinding != null) {
                    let { elementId: d } = l.startBinding;
                    a && !r.has(d) && i.add(d);
                }
                if (l.endBinding != null) {
                    let { elementId: d } = l.endBinding;
                    a && !r.has(d) && i.add(d);
                }
                (l.startBinding != null || l.endBinding != null) && n.add(r.get(l.id));
            }
        }), e.filter(({ id: l })=>n.has(l)).forEach((l)=>{
            let { startBinding: c, endBinding: d } = l;
            $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                startBinding: $e68ba20b3d2d159d$var$Q2(c, r),
                endBinding: $e68ba20b3d2d159d$var$Q2(d, r)
            });
        }), e.filter(({ id: l })=>i.has(l)).forEach((l)=>{
            let c = s.get(l.id), d = e.find(({ id: m })=>m === c)?.boundElements;
            d && d.length > 0 && $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                boundElements: d.map((m)=>r.has(m.id) ? {
                        id: r.get(m.id),
                        type: m.type
                    } : m)
            });
        });
    }, $e68ba20b3d2d159d$var$Q2 = (e, t)=>e == null ? null : {
            ...e,
            elementId: t.get(e.elementId) ?? e.elementId
        }, $e68ba20b3d2d159d$var$Jp = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$j(e);
        for (let o of t)$e68ba20b3d2d159d$var$qi.unbindAffected(r, o, $e68ba20b3d2d159d$export$55655e96a21bba2e), $e68ba20b3d2d159d$var$Ji.unbindAffected(r, o, $e68ba20b3d2d159d$export$55655e96a21bba2e);
    }, $e68ba20b3d2d159d$var$Zc = (e, t, r = [])=>{
        if (!e) return null;
        let o = e.filter((n)=>!t.has(n.id));
        return o.push(...r.map((n)=>({
                id: n.id,
                type: n.type
            }))), o;
    }, $e68ba20b3d2d159d$var$lv = (e, { x: t, y: r }, o, n)=>{
        let i = $e68ba20b3d2d159d$var$Jc(e, e.width, e.height), a = $e68ba20b3d2d159d$var$sn(e, o);
        return $e68ba20b3d2d159d$var$Vc([
            t,
            r
        ], a, i) || n === !0 && $e68ba20b3d2d159d$var$Qi([
            t,
            r
        ], $e68ba20b3d2d159d$var$dn(e));
    }, $e68ba20b3d2d159d$var$Jc = (e, t, r)=>{
        let n = (e.type === "diamond" ? 1 / Math.sqrt(2) : 1) * Math.min(t, r);
        return Math.max(16, Math.min(.25 * n, 32));
    }, $e68ba20b3d2d159d$var$El = (e, t, r)=>{
        switch(e.type){
            case "rectangle":
            case "image":
            case "text":
            case "iframe":
            case "embeddable":
            case "frame":
            case "magicframe":
                return $e68ba20b3d2d159d$var$FM(e, t, r);
            case "diamond":
                return $e68ba20b3d2d159d$var$BM(e, t, r);
            case "ellipse":
                return $e68ba20b3d2d159d$var$zM(e, t, r);
        }
    }, $e68ba20b3d2d159d$var$FM = (e, t, r)=>{
        let [, o, n, i] = $e68ba20b3d2d159d$var$nE(e, t, r);
        return Math.max($e68ba20b3d2d159d$var$Zi(o, $e68ba20b3d2d159d$var$Rp(0, 1, -i)), $e68ba20b3d2d159d$var$Zi(o, $e68ba20b3d2d159d$var$Rp(1, 0, -n)));
    }, $e68ba20b3d2d159d$var$BM = (e, t, r)=>{
        let [, o, n, i] = $e68ba20b3d2d159d$var$nE(e, t, r), a = $e68ba20b3d2d159d$var$Rp(i, n, -i * n);
        return $e68ba20b3d2d159d$var$Zi(o, a);
    }, $e68ba20b3d2d159d$var$zM = (e, t, r)=>{
        let [o, n] = $e68ba20b3d2d159d$var$HM(e, t, r);
        return -$e68ba20b3d2d159d$var$b2(n) * $e68ba20b3d2d159d$var$Zi(o, n);
    }, $e68ba20b3d2d159d$var$HM = (e, t, r)=>{
        let [, o, n, i] = $e68ba20b3d2d159d$var$nE(e, t, r), [a, s] = $e68ba20b3d2d159d$var$Qa(o), l = .707, c = .707, d = n, m = i;
        [
            0,
            1,
            2,
            3
        ].forEach((h)=>{
            let g = d * l, b = m * c, v = (d * d - m * m) * l ** 3 / d, y = (m * m - d * d) * c ** 3 / m, w = g - v, I = b - y, M = a - v, C = s - y, P = Math.hypot(I, w), k = Math.hypot(C, M);
            l = Math.min(1, Math.max(0, (M * P / k + v) / d)), c = Math.min(1, Math.max(0, (C * P / k + y) / m));
            let _ = Math.hypot(c, l);
            l /= _, c /= _;
        });
        let p = $e68ba20b3d2d159d$var$Sr(d * l, m * c), u = $e68ba20b3d2d159d$var$x2(o, p);
        return [
            o,
            u
        ];
    }, $e68ba20b3d2d159d$var$nE = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$Ja(t), [n, i, a, s] = $e68ba20b3d2d159d$var$ae(e, r), l = $e68ba20b3d2d159d$var$aE(n, i, a, s), c = $e68ba20b3d2d159d$var$$f(l, e.angle), d = $e68ba20b3d2d159d$var$nn(c, o), m = $e68ba20b3d2d159d$var$zf(d, $e68ba20b3d2d159d$var$Xf(l)), p = $e68ba20b3d2d159d$var$w2(m), u = $e68ba20b3d2d159d$var$p2(e.x, e.y), h = $e68ba20b3d2d159d$var$zf(d, u), g = (a - n) / 2, b = (s - i) / 2;
        return [
            h,
            p,
            g,
            b
        ];
    }, $e68ba20b3d2d159d$var$iE = (e, t)=>{
        let [r, o, n, i] = $e68ba20b3d2d159d$var$ae(e, t), a = $e68ba20b3d2d159d$var$aE(r, o, n, i), s = $e68ba20b3d2d159d$var$$f(a, e.angle), l = $e68ba20b3d2d159d$var$al($e68ba20b3d2d159d$var$C2($e68ba20b3d2d159d$var$Xf(a)));
        return $e68ba20b3d2d159d$var$M2(s, l);
    }, $e68ba20b3d2d159d$var$aE = (e, t, r, o)=>$e68ba20b3d2d159d$var$Sr((e + r) / 2, (t + o) / 2), $e68ba20b3d2d159d$var$UM = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$iE(e, o), i = $e68ba20b3d2d159d$var$nn(n, $e68ba20b3d2d159d$var$Ja(t)), a = $e68ba20b3d2d159d$var$nn(n, $e68ba20b3d2d159d$var$Ja(r)), s = $e68ba20b3d2d159d$var$sl(i, a), l = e.height / e.width, c = e.width / 2, d = e.height / 2, m = s[2], p = s[3], u = s[1], h = Math.abs(p), g = Math.abs(m), b;
        switch(e.type){
            case "rectangle":
            case "image":
            case "text":
            case "iframe":
            case "embeddable":
            case "frame":
            case "magicframe":
                b = u / (c * (g + l * h));
                break;
            case "diamond":
                b = h < g ? u / (g * c) : u / (h * d);
                break;
            case "ellipse":
                b = u / (c * Math.sqrt(m ** 2 + l ** 2 * p ** 2));
                break;
        }
        return b || 0;
    }, $e68ba20b3d2d159d$var$GM = (e, t, r, o)=>{
        if (t === 0) {
            let [l, c, d, m] = $e68ba20b3d2d159d$var$ae(e, o), p = $e68ba20b3d2d159d$var$aE(l, c, d, m);
            return $e68ba20b3d2d159d$var$Qa(p);
        }
        let n = $e68ba20b3d2d159d$var$iE(e, o), i = $e68ba20b3d2d159d$var$nn(n, $e68ba20b3d2d159d$var$Ja(r)), a = $e68ba20b3d2d159d$var$al(n), s;
        switch(e.type){
            case "rectangle":
            case "image":
            case "text":
            case "diamond":
            case "iframe":
            case "embeddable":
            case "frame":
            case "magicframe":
                s = $e68ba20b3d2d159d$var$ZM(e, t, i);
                break;
            case "ellipse":
                s = $e68ba20b3d2d159d$var$$M(e, t, i);
                break;
        }
        return $e68ba20b3d2d159d$var$Qa($e68ba20b3d2d159d$var$nn(a, s));
    }, $e68ba20b3d2d159d$var$rE = (e, t, r, o = 0, n)=>{
        if ($e68ba20b3d2d159d$var$oy(e)) return $e68ba20b3d2d159d$var$U2(e, [
            t,
            r
        ], o);
        let i = $e68ba20b3d2d159d$var$iE(e, n), a = $e68ba20b3d2d159d$var$nn(i, $e68ba20b3d2d159d$var$Ja(t)), s = $e68ba20b3d2d159d$var$nn(i, $e68ba20b3d2d159d$var$Ja(r)), l = $e68ba20b3d2d159d$var$sl(a, s), c = $e68ba20b3d2d159d$var$al(i);
        return $e68ba20b3d2d159d$var$WM(e, l, a, o).map((m)=>$e68ba20b3d2d159d$var$Qa($e68ba20b3d2d159d$var$nn(c, m)));
    }, $e68ba20b3d2d159d$var$WM = (e, t, r, o = 0)=>{
        let n;
        switch(e.type){
            case "rectangle":
            case "image":
            case "text":
            case "diamond":
            case "iframe":
            case "embeddable":
            case "frame":
            case "magicframe":
                let a = $e68ba20b3d2d159d$var$cv(e);
                n = a.flatMap((s, l)=>{
                    let c = [
                        s,
                        a[(l + 1) % 4]
                    ];
                    return $e68ba20b3d2d159d$var$VM(t, $e68ba20b3d2d159d$var$YM(c, o));
                }).concat(a.flatMap((s)=>$e68ba20b3d2d159d$var$KM(s, o, t)));
                break;
            case "ellipse":
                n = $e68ba20b3d2d159d$var$XM(e, o, t);
                break;
        }
        if (n.length < 2) return [];
        let i = n.sort((a, s)=>$e68ba20b3d2d159d$var$Yf(a, r) - $e68ba20b3d2d159d$var$Yf(s, r));
        return [
            i[0],
            i[i.length - 1]
        ];
    }, $e68ba20b3d2d159d$var$cv = (e, t = 1)=>{
        let r = t * e.width / 2, o = t * e.height / 2;
        switch(e.type){
            case "rectangle":
            case "image":
            case "text":
            case "iframe":
            case "embeddable":
            case "frame":
            case "magicframe":
                return [
                    $e68ba20b3d2d159d$var$Sr(r, o),
                    $e68ba20b3d2d159d$var$Sr(r, -o),
                    $e68ba20b3d2d159d$var$Sr(-r, -o),
                    $e68ba20b3d2d159d$var$Sr(-r, o)
                ];
            case "diamond":
                return [
                    $e68ba20b3d2d159d$var$Sr(0, o),
                    $e68ba20b3d2d159d$var$Sr(r, 0),
                    $e68ba20b3d2d159d$var$Sr(0, -o),
                    $e68ba20b3d2d159d$var$Sr(-r, 0)
                ];
        }
    }, $e68ba20b3d2d159d$var$VM = (e, t)=>{
        let [r, o] = t, n = $e68ba20b3d2d159d$var$Zi(r, e), i = $e68ba20b3d2d159d$var$Zi(o, e);
        return n * i >= 0 ? [] : [
            $e68ba20b3d2d159d$var$v2(e, $e68ba20b3d2d159d$var$sl(r, o))
        ];
    }, $e68ba20b3d2d159d$var$YM = (e, t)=>{
        let [r, o] = e, n = $e68ba20b3d2d159d$var$A2($e68ba20b3d2d159d$var$S2(r, o), t);
        return [
            $e68ba20b3d2d159d$var$nn(n, r),
            $e68ba20b3d2d159d$var$nn(n, o)
        ];
    }, $e68ba20b3d2d159d$var$XM = (e, t, r)=>{
        let o = e.width / 2 + t, n = e.height / 2 + t, i = r[2], a = r[3], s = r[1], l = o * o * i * i + n * n * a * a, c = l - s * s;
        if (l === 0 || c <= 0) return [];
        let d = Math.sqrt(c), m = -o * o * i * s, p = -n * n * a * s;
        return [
            $e68ba20b3d2d159d$var$Sr((m + o * n * a * d) / l, (p - o * n * i * d) / l),
            $e68ba20b3d2d159d$var$Sr((m - o * n * a * d) / l, (p + o * n * i * d) / l)
        ];
    }, $e68ba20b3d2d159d$var$KM = (e, t, r)=>{
        if (t === 0) return $e68ba20b3d2d159d$var$Zi(r, e) === 0 ? [
            e
        ] : [];
        let o = r[2], n = r[3], i = r[1], [a, s] = $e68ba20b3d2d159d$var$Qa(e), l = t, c = o * o + n * n, d = l * l * c - (o * a + n * s + i) ** 2;
        if (c === 0 || d <= 0) return [];
        let m = Math.sqrt(d), p = a * n * n - s * o * n - o * i, u = s * o * o - a * o * n - n * i;
        return [
            $e68ba20b3d2d159d$var$Sr((p + n * m) / c, (u - o * m) / c),
            $e68ba20b3d2d159d$var$Sr((p - n * m) / c, (u + o * m) / c)
        ];
    }, $e68ba20b3d2d159d$var$$M = (e, t, r)=>{
        let o = Math.abs(t), n = e.width * o / 2, i = e.height * o / 2, a = Math.sign(t), [s, l] = $e68ba20b3d2d159d$var$Qa(r), c = l === 0 ? 1e-4 : l, d = s ** 2 * i ** 2 + c ** 2 * n ** 2, m = (-s * i ** 2 + a * c * Math.sqrt(Math.max(0, d - n ** 2 * i ** 2))) / d, p = (-m * s - 1) / c;
        p === 0 && (p = (Object.is(p, -0) ? -1 : 1) * .01);
        let u = -(n ** 2 * m) / (p ** 2 * i ** 2 + m ** 2 * n ** 2);
        return $e68ba20b3d2d159d$var$Sr(u, (-m * u - 1) / p);
    }, $e68ba20b3d2d159d$var$ZM = (e, t, r)=>{
        let o = Math.abs(t), n = Math.sign(t), i = $e68ba20b3d2d159d$var$cv(e, o), a = 0, s = null;
        return i.forEach((l)=>{
            let c = n * $e68ba20b3d2d159d$var$sl(r, l)[1];
            c > a && (a = c, s = l);
        }), s;
    }, $e68ba20b3d2d159d$var$dv = new Set([
        "boundElements",
        "frameId",
        "containerId",
        "startBinding",
        "endBinding"
    ]), $e68ba20b3d2d159d$var$Kp = (e, t, r)=>{
        $e68ba20b3d2d159d$var$po(t) && (t.boundElements?.slice() ?? []).forEach(({ id: n })=>{
            r(e.get(n), "boundElements", n);
        });
    }, $e68ba20b3d2d159d$var$$p = (e, t, r)=>{
        let o = [];
        if (t.frameId) {
            let n = t.frameId;
            o.push(r(e.get(n), "frameId", n));
        }
        if ($e68ba20b3d2d159d$var$Ge(t)) {
            let n = t.containerId;
            o.push(r(e.get(n), "containerId", n));
        }
        if ($e68ba20b3d2d159d$var$ie(t)) {
            if (t.startBinding) {
                let n = t.startBinding.elementId;
                o.push(r(e.get(n), "startBinding", n));
            }
            if (t.endBinding) {
                let n = t.endBinding.elementId;
                o.push(r(e.get(n), "endBinding", n));
            }
        }
        return o;
    }, $e68ba20b3d2d159d$var$qi = class {
        static unbindAffected(t, r, o) {
            r && $e68ba20b3d2d159d$var$$p(t, r, (n)=>{
                !n || n.isDeleted || $e68ba20b3d2d159d$var$Kp(t, n, (i, a, s)=>{
                    s === r.id && o(n, {
                        boundElements: $e68ba20b3d2d159d$var$Zc(n.boundElements, new Set([
                            s
                        ]))
                    });
                });
            });
        }
        static rebindAffected = (t, r, o)=>{
            !r || r.isDeleted || $e68ba20b3d2d159d$var$$p(t, r, (n, i)=>{
                if (!n || n.isDeleted) {
                    o(r, {
                        [i]: null
                    });
                    return;
                }
                i !== "frameId" && (n.boundElements?.find((a)=>a.id === r.id) || ($e68ba20b3d2d159d$var$ie(r) && o(n, {
                    boundElements: $e68ba20b3d2d159d$var$Zc(n.boundElements, new Set, new Array(r))
                }), $e68ba20b3d2d159d$var$G(r) && (n.boundElements?.find((a)=>a.type === "text") ? o(r, {
                    [i]: null
                }) : o(n, {
                    boundElements: $e68ba20b3d2d159d$var$Zc(n.boundElements, new Set, new Array(r))
                }))));
            });
        };
    }, $e68ba20b3d2d159d$var$Ji = class {
        static unbindAffected(t, r, o) {
            r && $e68ba20b3d2d159d$var$Kp(t, r, (n)=>{
                !n || n.isDeleted || $e68ba20b3d2d159d$var$$p(t, n, (i, a, s)=>{
                    s === r.id && o(n, {
                        [a]: null
                    });
                });
            });
        }
        static rebindAffected = (t, r, o)=>{
            !r || r.isDeleted || $e68ba20b3d2d159d$var$Kp(t, r, (n, i, a)=>{
                if (!n || n.isDeleted) {
                    o(r, {
                        boundElements: $e68ba20b3d2d159d$var$Zc(r.boundElements, new Set([
                            a
                        ]))
                    });
                    return;
                }
                $e68ba20b3d2d159d$var$G(n) && ((r.boundElements?.slice() ?? []).reverse().find((l)=>l.type === "text")?.id === n.id ? n.containerId !== r.id && o(n, {
                    containerId: r.id
                }) : (n.containerId !== null && o(n, {
                    containerId: null
                }), o(r, {
                    boundElements: $e68ba20b3d2d159d$var$Zc(r.boundElements, new Set([
                        n.id
                    ]))
                })));
            });
        };
    }, $e68ba20b3d2d159d$var$Zp = (e, t)=>{
        let [r, o] = $e68ba20b3d2d159d$var$Qc(e);
        return $e68ba20b3d2d159d$var$J([
            t.x + t.width * r,
            t.y + t.height * o
        ], $e68ba20b3d2d159d$var$Qp(t), t.angle);
    }, $e68ba20b3d2d159d$var$jM = (e, t)=>{
        let r = e.startBinding && t.get(e.startBinding.elementId), o = e.endBinding && t.get(e.endBinding.elementId), n = r && e.startBinding ? $e68ba20b3d2d159d$var$Zp(e.startBinding.fixedPoint, r) : [
            e.x + e.points[0][0],
            e.y + e.points[0][1]
        ], i = o && e.endBinding ? $e68ba20b3d2d159d$var$Zp(e.endBinding.fixedPoint, o) : [
            e.x + e.points[e.points.length - 1][0],
            e.y + e.points[e.points.length - 1][1]
        ];
        return [
            n,
            i
        ];
    }, $e68ba20b3d2d159d$var$mv = (e, t)=>{
        let [r, o] = $e68ba20b3d2d159d$var$jM(e, t);
        return [
            $e68ba20b3d2d159d$var$$.pointFromAbsoluteCoords(e, r, t),
            $e68ba20b3d2d159d$var$$.pointFromAbsoluteCoords(e, o, t)
        ];
    }, $e68ba20b3d2d159d$var$Qc = (e)=>e && (e[0] === .5 || e[1] === .5) ? e.map((t)=>t === .5 ? .5001 : t) : e;
});
var $e68ba20b3d2d159d$var$qM, $e68ba20b3d2d159d$var$JM, $e68ba20b3d2d159d$var$eu, $e68ba20b3d2d159d$var$ls, $e68ba20b3d2d159d$var$QM, $e68ba20b3d2d159d$var$e4, $e68ba20b3d2d159d$var$t4, $e68ba20b3d2d159d$var$r4, $e68ba20b3d2d159d$export$bf29272de9e9a11, $e68ba20b3d2d159d$var$o4, $e68ba20b3d2d159d$var$pv, $e68ba20b3d2d159d$export$32e2ba60a07f30a6, $e68ba20b3d2d159d$export$db239ef39aadc7fe, $e68ba20b3d2d159d$var$uv, $e68ba20b3d2d159d$export$f65496d0049b5d9e, $e68ba20b3d2d159d$var$xl = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$jo();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Va();
    $e68ba20b3d2d159d$var$Do();
    $e68ba20b3d2d159d$var$$a();
    $e68ba20b3d2d159d$var$pn();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$qM = {
        selection: !0,
        text: !0,
        rectangle: !0,
        diamond: !0,
        ellipse: !0,
        line: !0,
        image: !0,
        arrow: !0,
        freedraw: !0,
        eraser: !1,
        custom: !0,
        frame: !0,
        embeddable: !0,
        hand: !0,
        laser: !1,
        magicframe: !1
    }, $e68ba20b3d2d159d$var$JM = (e)=>Object.keys($e68ba20b3d2d159d$export$530097e879f93363).includes(e) ? $e68ba20b3d2d159d$export$530097e879f93363[e] : $e68ba20b3d2d159d$var$vr, $e68ba20b3d2d159d$var$eu = (e, t)=>t ? {
            ...t,
            focus: t.focus || 0,
            fixedPoint: $e68ba20b3d2d159d$var$ce(e) ? $e68ba20b3d2d159d$var$Qc(t.fixedPoint ?? [
                0,
                0
            ]) : null
        } : null, $e68ba20b3d2d159d$var$ls = (e, t)=>{
        let r = {
            type: t.type || e.type,
            version: e.version || 1,
            versionNonce: e.versionNonce ?? 0,
            index: e.index ?? null,
            isDeleted: e.isDeleted ?? !1,
            id: e.id || $e68ba20b3d2d159d$var$Vt(),
            fillStyle: e.fillStyle || $e68ba20b3d2d159d$var$mt.fillStyle,
            strokeWidth: e.strokeWidth || $e68ba20b3d2d159d$var$mt.strokeWidth,
            strokeStyle: e.strokeStyle ?? $e68ba20b3d2d159d$var$mt.strokeStyle,
            roughness: e.roughness ?? $e68ba20b3d2d159d$var$mt.roughness,
            opacity: e.opacity == null ? $e68ba20b3d2d159d$var$mt.opacity : e.opacity,
            angle: e.angle || 0,
            x: t.x ?? e.x ?? 0,
            y: t.y ?? e.y ?? 0,
            strokeColor: e.strokeColor || $e68ba20b3d2d159d$var$mt.strokeColor,
            backgroundColor: e.backgroundColor || $e68ba20b3d2d159d$var$mt.backgroundColor,
            width: e.width || 0,
            height: e.height || 0,
            seed: e.seed ?? 1,
            groupIds: e.groupIds ?? [],
            frameId: e.frameId ?? null,
            roundness: e.roundness ? e.roundness : e.strokeSharpness === "round" ? {
                type: $e68ba20b3d2d159d$var$_n(e.type) ? $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.LEGACY : $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
            } : null,
            boundElements: e.boundElementIds ? e.boundElementIds.map((o)=>({
                    type: "arrow",
                    id: o
                })) : e.boundElements ?? [],
            updated: e.updated ?? $e68ba20b3d2d159d$var$ci(),
            link: e.link ? $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e.link) : null,
            locked: e.locked ?? !1
        };
        return ("customData" in e || "customData" in t) && (r.customData = "customData" in t ? t.customData : e.customData), {
            ...r,
            ...$e68ba20b3d2d159d$var$rd(r),
            ...t
        };
    }, $e68ba20b3d2d159d$var$QM = (e)=>{
        switch(e.type){
            case "text":
                let t = e.fontSize, r = e.fontFamily;
                if ("font" in e) {
                    let [d, m] = e.font.split(" ");
                    t = parseFloat(d), r = $e68ba20b3d2d159d$var$JM(m);
                }
                let o = typeof e.text == "string" && e.text || "", n = e.lineHeight || (e.height ? $e68ba20b3d2d159d$var$gv(e) : $e68ba20b3d2d159d$var$Eo(e.fontFamily));
                return e = $e68ba20b3d2d159d$var$ls(e, {
                    fontSize: t,
                    fontFamily: r,
                    text: o,
                    textAlign: e.textAlign || $e68ba20b3d2d159d$var$An,
                    verticalAlign: e.verticalAlign || $e68ba20b3d2d159d$var$Oa,
                    containerId: e.containerId ?? null,
                    originalText: e.originalText || o,
                    autoResize: e.autoResize ?? !0,
                    lineHeight: n
                }), !o && !e.isDeleted && (e = {
                    ...e,
                    originalText: o,
                    isDeleted: !0
                }, e = $e68ba20b3d2d159d$export$52f84dc7de3cd4b8(e)), e;
            case "freedraw":
                return $e68ba20b3d2d159d$var$ls(e, {
                    points: e.points,
                    lastCommittedPoint: null,
                    simulatePressure: e.simulatePressure,
                    pressures: e.pressures
                });
            case "image":
                return $e68ba20b3d2d159d$var$ls(e, {
                    status: e.status || "pending",
                    fileId: e.fileId,
                    scale: e.scale || [
                        1,
                        1
                    ]
                });
            case "line":
            case "draw":
                let { startArrowhead: i = null, endArrowhead: a = null } = e, s = e.x, l = e.y, c = !Array.isArray(e.points) || e.points.length < 2 ? [
                    [
                        0,
                        0
                    ],
                    [
                        e.width,
                        e.height
                    ]
                ] : e.points;
                return (c[0][0] !== 0 || c[0][1] !== 0) && ({ points: c, x: s, y: l } = $e68ba20b3d2d159d$var$$.getNormalizedPoints(e)), $e68ba20b3d2d159d$var$ls(e, {
                    type: e.type === "draw" ? "line" : e.type,
                    startBinding: $e68ba20b3d2d159d$var$eu(e, e.startBinding),
                    endBinding: $e68ba20b3d2d159d$var$eu(e, e.endBinding),
                    lastCommittedPoint: null,
                    startArrowhead: i,
                    endArrowhead: a,
                    points: c,
                    x: s,
                    y: l,
                    ...$e68ba20b3d2d159d$var$ui(c)
                });
            case "arrow":
                {
                    let { startArrowhead: d = null, endArrowhead: m = "arrow" } = e, p = e.x, u = e.y, h = !Array.isArray(e.points) || e.points.length < 2 ? [
                        [
                            0,
                            0
                        ],
                        [
                            e.width,
                            e.height
                        ]
                    ] : e.points;
                    return (h[0][0] !== 0 || h[0][1] !== 0) && ({ points: h, x: p, y: u } = $e68ba20b3d2d159d$var$$.getNormalizedPoints(e)), $e68ba20b3d2d159d$var$ls(e, {
                        type: e.type,
                        startBinding: $e68ba20b3d2d159d$var$eu(e, e.startBinding),
                        endBinding: $e68ba20b3d2d159d$var$eu(e, e.endBinding),
                        lastCommittedPoint: null,
                        startArrowhead: d,
                        endArrowhead: m,
                        points: h,
                        x: p,
                        y: u,
                        elbowed: e.elbowed,
                        ...$e68ba20b3d2d159d$var$ui(h)
                    });
                }
            case "ellipse":
            case "rectangle":
            case "diamond":
            case "iframe":
            case "embeddable":
                return $e68ba20b3d2d159d$var$ls(e, {});
            case "magicframe":
            case "frame":
                return $e68ba20b3d2d159d$var$ls(e, {
                    name: e.name ?? null
                });
        }
        return null;
    }, $e68ba20b3d2d159d$var$e4 = (e, t)=>{
        if (e.boundElements) {
            let r = e.boundElements.slice(), o = new Set;
            e.boundElements = r.reduce((n, i)=>{
                let a = t.get(i.id);
                if (a && !o.has(i.id)) {
                    if (o.add(i.id), a.isDeleted) return n;
                    n.push(i), $e68ba20b3d2d159d$var$G(a) && !a.containerId && (a.containerId = e.id);
                }
                return n;
            }, []);
        }
    }, $e68ba20b3d2d159d$var$t4 = (e, t)=>{
        let r = e.containerId ? t.get(e.containerId) : null;
        if (!r) {
            e.containerId = null;
            return;
        }
        if (!e.isDeleted && r.boundElements && !r.boundElements.find((o)=>o.id === e.id)) {
            let o = (r.boundElements || (r.boundElements = [])).slice();
            o.push({
                type: "text",
                id: e.id
            }), r.boundElements = o;
        }
    }, $e68ba20b3d2d159d$var$r4 = (e, t)=>{
        e.frameId && (t.get(e.frameId) || (e.frameId = null));
    }, $e68ba20b3d2d159d$export$bf29272de9e9a11 = (e, t, r)=>{
        let o = new Set, n = t ? $e68ba20b3d2d159d$var$j(t) : null, i = $e68ba20b3d2d159d$var$Cr((e || []).reduce((s, l)=>{
            if (l.type !== "selection" && !$e68ba20b3d2d159d$export$2cab0e754c9472e0(l)) {
                let c = $e68ba20b3d2d159d$var$QM(l);
                if (c) {
                    let d = n?.get(l.id);
                    d && d.version > c.version && (c = $e68ba20b3d2d159d$export$52f84dc7de3cd4b8(c, d.version)), o.has(c.id) && (c = {
                        ...c,
                        id: $e68ba20b3d2d159d$var$Vt()
                    }), o.add(c.id), s.push(c);
                }
            }
            return s;
        }, []));
        if (!r?.repairBindings) return i;
        let a = $e68ba20b3d2d159d$var$j(i);
        for (let s of i)s.frameId && $e68ba20b3d2d159d$var$r4(s, a), $e68ba20b3d2d159d$var$G(s) && s.containerId ? $e68ba20b3d2d159d$var$t4(s, a) : s.boundElements && $e68ba20b3d2d159d$var$e4(s, a), r.refreshDimensions && $e68ba20b3d2d159d$var$G(s) && Object.assign(s, $e68ba20b3d2d159d$var$td(s, $e68ba20b3d2d159d$var$bt(s, a), a)), $e68ba20b3d2d159d$export$5df2ebb939539835(s) && (s.startBinding && (!a.has(s.startBinding.elementId) || !$e68ba20b3d2d159d$var$ie(s)) && (s.startBinding = null), s.endBinding && (!a.has(s.endBinding.elementId) || !$e68ba20b3d2d159d$var$ie(s)) && (s.endBinding = null));
        return i;
    }, $e68ba20b3d2d159d$var$o4 = (e, t, r)=>{
        let o = t[e];
        return o !== void 0 ? o : r[e];
    }, $e68ba20b3d2d159d$var$pv = {
        isSidebarDocked: (e, t)=>[
                "defaultSidebarDockedPreference",
                e.isSidebarDocked ?? $e68ba20b3d2d159d$var$o4("defaultSidebarDockedPreference", e, t)
            ]
    }, $e68ba20b3d2d159d$export$32e2ba60a07f30a6 = (e, t)=>{
        e = e || {};
        let r = $e68ba20b3d2d159d$var$dr(), o = {};
        for (let n of Object.keys($e68ba20b3d2d159d$var$pv))if (n in e) {
            let [i, a] = $e68ba20b3d2d159d$var$pv[n](e, r);
            o[i] = a;
        }
        for (let [n, i] of Object.entries(r)){
            let a = e[n], s = t ? t[n] : void 0;
            o[n] = a !== void 0 ? a : s !== void 0 ? s : i;
        }
        return {
            ...o,
            cursorButton: t?.cursorButton || "up",
            penDetected: t?.penDetected ?? (e.penMode ? e.penDetected ?? !1 : !1),
            activeTool: {
                ...$e68ba20b3d2d159d$var$it(r, o.activeTool.type && $e68ba20b3d2d159d$var$qM[o.activeTool.type] ? o.activeTool : {
                    type: "selection"
                }),
                lastActiveTool: null,
                locked: o.activeTool.locked ?? !1
            },
            zoom: {
                value: $e68ba20b3d2d159d$var$to($e68ba20b3d2d159d$var$Ha(e.zoom) ? e.zoom : e.zoom?.value ?? r.zoom.value)
            },
            openSidebar: typeof e.openSidebar == "string" ? {
                name: $e68ba20b3d2d159d$var$mo.name
            } : o.openSidebar,
            gridSize: $e68ba20b3d2d159d$var$lE($e68ba20b3d2d159d$var$Ha(e.gridSize) ? e.gridSize : $e68ba20b3d2d159d$var$Fa),
            gridStep: $e68ba20b3d2d159d$var$od($e68ba20b3d2d159d$var$Ha(e.gridStep) ? e.gridStep : $e68ba20b3d2d159d$var$Rm)
        };
    }, $e68ba20b3d2d159d$export$db239ef39aadc7fe = (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$export$bf29272de9e9a11(e?.elements, r, o),
            appState: $e68ba20b3d2d159d$export$32e2ba60a07f30a6(e?.appState, t || null),
            files: e?.files || {}
        }), $e68ba20b3d2d159d$var$uv = (e)=>{
        let t = $e68ba20b3d2d159d$export$bf29272de9e9a11($e68ba20b3d2d159d$export$a9f9e75229944f66(e.elements), null);
        return t.length ? {
            ...e,
            elements: t
        } : null;
    }, $e68ba20b3d2d159d$export$f65496d0049b5d9e = (e = [], t)=>{
        let r = [];
        for (let o of e)if (Array.isArray(o)) {
            let n = $e68ba20b3d2d159d$var$uv({
                status: t,
                elements: o,
                id: $e68ba20b3d2d159d$var$Vt(),
                created: Date.now()
            });
            n && r.push(n);
        } else {
            let n = o, i = $e68ba20b3d2d159d$var$uv({
                ...n,
                id: n.id || $e68ba20b3d2d159d$var$Vt(),
                status: n.status || t,
                created: n.created || Date.now()
            });
            i && r.push(i);
        }
        return r;
    };
});
var $e68ba20b3d2d159d$var$nd = {};
$e68ba20b3d2d159d$var$Zg($e68ba20b3d2d159d$var$nd, {
    decodePngMetadata: ()=>$e68ba20b3d2d159d$var$i4,
    decodeSvgMetadata: ()=>$e68ba20b3d2d159d$var$s4,
    encodePngMetadata: ()=>$e68ba20b3d2d159d$var$cE,
    encodeSvgMetadata: ()=>$e68ba20b3d2d159d$var$a4,
    getTEXtChunk: ()=>$e68ba20b3d2d159d$var$xv
});
var $e68ba20b3d2d159d$var$xv, $e68ba20b3d2d159d$var$cE, $e68ba20b3d2d159d$var$i4, $e68ba20b3d2d159d$var$a4, $e68ba20b3d2d159d$var$s4, $e68ba20b3d2d159d$var$bl = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$pE();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Fr();
    $e68ba20b3d2d159d$var$xv = async (e)=>{
        let r = (0, (/*@__PURE__*/$parcel$interopDefault($cbacbc9d0ce6177f$exports)))(new Uint8Array(await $e68ba20b3d2d159d$var$gi(e))).find((o)=>o.name === "tEXt");
        return r ? (0, (/*@__PURE__*/$parcel$interopDefault($178790578e00e627$exports))).decode(r.data) : null;
    }, $e68ba20b3d2d159d$var$cE = async ({ blob: e, metadata: t })=>{
        let r = (0, (/*@__PURE__*/$parcel$interopDefault($cbacbc9d0ce6177f$exports)))(new Uint8Array(await $e68ba20b3d2d159d$var$gi(e))), o = (0, (/*@__PURE__*/$parcel$interopDefault($178790578e00e627$exports))).encode($e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw, JSON.stringify(await $e68ba20b3d2d159d$var$dE({
            text: t,
            compress: !0
        })));
        return r.splice(-1, 0, o), new Blob([
            (0, (/*@__PURE__*/$parcel$interopDefault($22b609628ac539ce$exports)))(r)
        ], {
            type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.png
        });
    }, $e68ba20b3d2d159d$var$i4 = async (e)=>{
        let t = await $e68ba20b3d2d159d$var$xv(e);
        if (t?.keyword === $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw) try {
            let r = JSON.parse(t.text);
            if (!("encoded" in r)) {
                if ("type" in r && r.type === $e68ba20b3d2d159d$var$Tr.excalidraw) return t.text;
                throw new Error("FAILED");
            }
            return await $e68ba20b3d2d159d$var$mE(r);
        } catch (r) {
            throw console.error(r), new Error("FAILED");
        }
        throw new Error("INVALID");
    }, $e68ba20b3d2d159d$var$a4 = async ({ text: e })=>{
        let t = await $e68ba20b3d2d159d$var$tu(JSON.stringify(await $e68ba20b3d2d159d$var$dE({
            text: e
        })), !0), r = "";
        return r += `<!-- payload-type:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw} -->`, r += "<!-- payload-version:2 -->", r += "<!-- payload-start -->", r += t, r += "<!-- payload-end -->", r;
    }, $e68ba20b3d2d159d$var$s4 = async ({ svg: e })=>{
        if (e.includes(`payload-type:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw}`)) {
            let t = e.match(/<!-- payload-start -->\s*(.+?)\s*<!-- payload-end -->/);
            if (!t) throw new Error("INVALID");
            let n = (e.match(/<!-- payload-version:(\d+) -->/)?.[1] || "1") !== "1";
            try {
                let i = await $e68ba20b3d2d159d$var$bv(t[1], n), a = JSON.parse(i);
                if (!("encoded" in a)) {
                    if ("type" in a && a.type === $e68ba20b3d2d159d$var$Tr.excalidraw) return i;
                    throw new Error("FAILED");
                }
                return await $e68ba20b3d2d159d$var$mE(a);
            } catch (i) {
                throw console.error(i), new Error("FAILED");
            }
        }
        throw new Error("INVALID");
    };
});
var $e68ba20b3d2d159d$var$wv, $e68ba20b3d2d159d$var$uE, $e68ba20b3d2d159d$var$vv, $e68ba20b3d2d159d$var$nl, $e68ba20b3d2d159d$var$ra, $e68ba20b3d2d159d$export$d9e5f6de300e0e24, $e68ba20b3d2d159d$export$d8a4a83cfacbdff0, $e68ba20b3d2d159d$var$hE, $e68ba20b3d2d159d$export$2f1669626eca00b4, $e68ba20b3d2d159d$var$fi, $e68ba20b3d2d159d$var$Tv, $e68ba20b3d2d159d$export$7a55ad1e8bd07594, $e68ba20b3d2d159d$var$Sv, $e68ba20b3d2d159d$var$id, $e68ba20b3d2d159d$var$fE, $e68ba20b3d2d159d$var$Iv, $e68ba20b3d2d159d$var$Cv, $e68ba20b3d2d159d$var$c4, $e68ba20b3d2d159d$var$yv, $e68ba20b3d2d159d$var$ru, $e68ba20b3d2d159d$var$Hc, $e68ba20b3d2d159d$var$gi;


var $e68ba20b3d2d159d$var$Fr = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$Gi();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$mi();
    $e68ba20b3d2d159d$var$pi();
    $e68ba20b3d2d159d$var$xl();
    $e68ba20b3d2d159d$var$wv = async (e)=>{
        let t;
        if (e.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.png) try {
            return await (await Promise.resolve().then(()=>($e68ba20b3d2d159d$var$bl(), $e68ba20b3d2d159d$var$nd))).decodePngMetadata(e);
        } catch (r) {
            throw r.message === "INVALID" ? new $e68ba20b3d2d159d$var$qo("Image doesn't contain scene", "IMAGE_NOT_CONTAINS_SCENE_DATA") : new $e68ba20b3d2d159d$var$qo("Error: cannot restore image");
        }
        else if ("text" in Blob ? t = await e.text() : t = await new Promise((r)=>{
            let o = new FileReader;
            o.readAsText(e, "utf8"), o.onloadend = ()=>{
                o.readyState === FileReader.DONE && r(o.result);
            };
        }), e.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg) try {
            return await (await Promise.resolve().then(()=>($e68ba20b3d2d159d$var$bl(), $e68ba20b3d2d159d$var$nd))).decodeSvgMetadata({
                svg: t
            });
        } catch (r) {
            throw r.message === "INVALID" ? new $e68ba20b3d2d159d$var$qo("Image doesn't contain scene", "IMAGE_NOT_CONTAINS_SCENE_DATA") : new $e68ba20b3d2d159d$var$qo("Error: cannot restore image");
        }
        return t;
    }, $e68ba20b3d2d159d$var$uE = (e)=>e && e.name.match(/\.(json|excalidraw|png|svg)$/)?.[1] || null, $e68ba20b3d2d159d$var$vv = (e)=>e === "png" || e === "svg", $e68ba20b3d2d159d$var$nl = (e)=>{
        let t = $e68ba20b3d2d159d$var$uE(e);
        return t === "png" || t === "svg";
    }, $e68ba20b3d2d159d$var$ra = (e)=>{
        let { type: t } = e || {};
        return !!t && Object.values($e68ba20b3d2d159d$var$Cc).includes(t);
    }, $e68ba20b3d2d159d$export$d9e5f6de300e0e24 = async (e, t, r, o)=>{
        let n = await $e68ba20b3d2d159d$var$wv(e), i;
        try {
            try {
                i = JSON.parse(n);
            } catch (a) {
                throw $e68ba20b3d2d159d$var$ra(e) ? new $e68ba20b3d2d159d$var$qo("Image doesn't contain scene", "IMAGE_NOT_CONTAINS_SCENE_DATA") : a;
            }
            if ($e68ba20b3d2d159d$var$c2(i)) return {
                type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw,
                data: $e68ba20b3d2d159d$export$db239ef39aadc7fe({
                    elements: $e68ba20b3d2d159d$var$Dp(i.elements || []),
                    appState: {
                        theme: t?.theme,
                        fileHandle: o || e.handle || null,
                        ...$e68ba20b3d2d159d$var$op(i.appState || {}),
                        ...t ? $e68ba20b3d2d159d$var$Hn(i.elements || [], t) : {}
                    },
                    files: i.files
                }, t, r, {
                    repairBindings: !0,
                    refreshDimensions: !1
                })
            };
            if ($e68ba20b3d2d159d$var$Bf(i)) return {
                type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib,
                data: i
            };
            throw new Error("Error: invalid file");
        } catch (a) {
            throw a instanceof $e68ba20b3d2d159d$var$qo ? a : new Error("Error: invalid file");
        }
    }, $e68ba20b3d2d159d$export$d8a4a83cfacbdff0 = async (e, t, r, o)=>{
        let n = await $e68ba20b3d2d159d$export$d9e5f6de300e0e24(e, t, r, o);
        if (n.type !== $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw) throw new Error("Error: invalid file");
        return n.data;
    }, $e68ba20b3d2d159d$var$hE = (e, t = "unpublished")=>{
        let r = JSON.parse(e);
        if (!$e68ba20b3d2d159d$var$Bf(r)) throw new Error("Invalid library");
        let o = r.libraryItems || r.library;
        return $e68ba20b3d2d159d$export$f65496d0049b5d9e(o, t);
    }, $e68ba20b3d2d159d$export$2f1669626eca00b4 = async (e, t = "unpublished")=>$e68ba20b3d2d159d$var$hE(await $e68ba20b3d2d159d$var$wv(e), t), $e68ba20b3d2d159d$var$fi = async (e)=>new Promise(async (t, r)=>{
            try {
                $e68ba20b3d2d159d$var$Ln(e) && (e = await e), e.toBlob((o)=>{
                    if (!o) return r(new $e68ba20b3d2d159d$var$tp("Error: Canvas too big", "CANVAS_POSSIBLY_TOO_BIG"));
                    t(o);
                });
            } catch (o) {
                r(o);
            }
        }), $e68ba20b3d2d159d$var$Tv = async (e)=>{
        try {
            let t = await window.crypto.subtle.digest("SHA-1", await $e68ba20b3d2d159d$var$gi(e));
            return $e68ba20b3d2d159d$var$$0(new Uint8Array(t));
        } catch (t) {
            return console.error(t), (0, $363a23d82a2fc856$export$ac4959f4f1338dfc)(40);
        }
    }, $e68ba20b3d2d159d$export$7a55ad1e8bd07594 = async (e)=>new Promise((t, r)=>{
            let o = new FileReader;
            o.onload = ()=>{
                let n = o.result;
                t(n);
            }, o.onerror = (n)=>r(n), o.readAsDataURL(e);
        }), $e68ba20b3d2d159d$var$Sv = (e, t = "")=>{
        let r = e.indexOf(","), o = atob(e.slice(r + 1)), n = e.slice(0, r).split(":")[1].split(";")[0], i = new ArrayBuffer(o.length), a = new Uint8Array(i);
        for(let s = 0; s < o.length; s++)a[s] = o.charCodeAt(s);
        return new File([
            i
        ], t, {
            type: n
        });
    }, $e68ba20b3d2d159d$var$id = async (e, t)=>{
        if (e.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg) return e;
        let [r, o] = await Promise.all([
            (parcelRequire("dA3hl")).then((i)=>i.default),
            (parcelRequire("44DGG")).then((i)=>i.default)
        ]), n = o({
            pica: r({
                features: [
                    "js",
                    "wasm"
                ]
            })
        });
        if (t.outputType) {
            let { outputType: i } = t;
            n._create_blob = function(a) {
                return this.pica.toBlob(a.out_canvas, i, .8).then((s)=>(a.out_blob = s, a));
            };
        }
        if (!$e68ba20b3d2d159d$var$ra(e)) throw new Error("Error: unsupported file type", {
            cause: "UNSUPPORTED"
        });
        return new File([
            await n.toBlob(e, {
                max: t.maxWidthOrHeight
            })
        ], e.name, {
            type: t.outputType || e.type
        });
    }, $e68ba20b3d2d159d$var$fE = (e, t = "")=>new File([
            new TextEncoder().encode(e)
        ], t, {
            type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg
        }), $e68ba20b3d2d159d$var$Iv = async (e, t = "")=>{
        let r;
        try {
            r = await fetch(e);
        } catch  {
            throw new Error("Error: failed to fetch image", {
                cause: "FETCH_ERROR"
            });
        }
        if (!r.ok) throw new Error("Error: failed to fetch image", {
            cause: "FETCH_ERROR"
        });
        let o = await r.blob();
        if (o.type && $e68ba20b3d2d159d$var$ra(o)) {
            let n = t || o.name || "";
            return new File([
                o
            ], n, {
                type: o.type
            });
        }
        throw new Error("Error: unsupported file type", {
            cause: "UNSUPPORTED"
        });
    }, $e68ba20b3d2d159d$var$Cv = async (e)=>{
        let t = e.dataTransfer.files.item(0), r = await $e68ba20b3d2d159d$var$c4(e);
        return {
            file: t ? await $e68ba20b3d2d159d$var$Hc(t) : null,
            fileHandle: r
        };
    }, $e68ba20b3d2d159d$var$c4 = async (e)=>{
        if (0, $11b096c57ac70a88$export$5f747a46dc0eb6ee) try {
            return await e.dataTransfer.items[0].getAsFileSystemHandle() || null;
        } catch (t) {
            return console.warn(t.name, t.message), null;
        }
        return null;
    }, $e68ba20b3d2d159d$var$yv = (e)=>{
        let t = null, r = `${[
            ...new Uint8Array(e).slice(0, 8)
        ].join(" ")} `, o = {
            png: "137 80 78 71 13 10 26 10 ",
            jpg: "255 216 255 ",
            gif: "71 73 70 56 57 97 "
        };
        return r === o.png ? t = $e68ba20b3d2d159d$export$edfb5d7e4280f611.png : r.startsWith(o.jpg) ? t = $e68ba20b3d2d159d$export$edfb5d7e4280f611.jpg : r.startsWith(o.gif) && (t = $e68ba20b3d2d159d$export$edfb5d7e4280f611.gif), t;
    }, $e68ba20b3d2d159d$var$ru = (e, t, r)=>new File([
            e
        ], r || "", {
            type: t
        }), $e68ba20b3d2d159d$var$Hc = async (e)=>{
        if (e.type) {
            if ($e68ba20b3d2d159d$var$ra(e)) {
                let t = await $e68ba20b3d2d159d$var$gi(e), r = $e68ba20b3d2d159d$var$yv(t);
                r && r !== e.type && (e = $e68ba20b3d2d159d$var$ru(t, r, e.name));
            }
        } else if (e?.name?.endsWith(".excalidrawlib")) e = $e68ba20b3d2d159d$var$ru(await $e68ba20b3d2d159d$var$gi(e), $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib, e.name);
        else if (e?.name?.endsWith(".excalidraw")) e = $e68ba20b3d2d159d$var$ru(await $e68ba20b3d2d159d$var$gi(e), $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw, e.name);
        else {
            let t = await $e68ba20b3d2d159d$var$gi(e), r = $e68ba20b3d2d159d$var$yv(t);
            r && (e = $e68ba20b3d2d159d$var$ru(t, r, e.name));
        }
        return e;
    }, $e68ba20b3d2d159d$var$gi = (e)=>"arrayBuffer" in e ? e.arrayBuffer() : new Promise((t, r)=>{
            let o = new FileReader;
            o.onload = (n)=>{
                if (!n.target?.result) return r(new Error("Couldn't convert blob to ArrayBuffer"));
                t(n.target.result);
            }, o.readAsArrayBuffer(e);
        });
});
var $e68ba20b3d2d159d$var$Av = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Fr();
});
var $e68ba20b3d2d159d$var$ad, $e68ba20b3d2d159d$var$Mv, $e68ba20b3d2d159d$var$kv, $e68ba20b3d2d159d$var$tu, $e68ba20b3d2d159d$var$bv, $e68ba20b3d2d159d$var$dE, $e68ba20b3d2d159d$var$mE, $e68ba20b3d2d159d$var$pE = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Av();
    $e68ba20b3d2d159d$var$ad = (e)=>new Promise((t, r)=>{
            let o = typeof e == "string" ? new Blob([
                new TextEncoder().encode(e)
            ]) : new Blob([
                e instanceof Uint8Array ? e : new Uint8Array(e)
            ]), n = new FileReader;
            n.onload = (i)=>{
                if (!i.target || typeof i.target.result != "string") return r(new Error("couldn't convert to byte string"));
                t(i.target.result);
            }, n.readAsBinaryString(o);
        }), $e68ba20b3d2d159d$var$Mv = (e)=>{
        let t = new ArrayBuffer(e.length), r = new Uint8Array(t);
        for(let o = 0, n = e.length; o < n; o++)r[o] = e.charCodeAt(o);
        return t;
    }, $e68ba20b3d2d159d$var$kv = (e)=>new TextDecoder("utf-8").decode($e68ba20b3d2d159d$var$Mv(e)), $e68ba20b3d2d159d$var$tu = async (e, t = !1)=>t ? window.btoa(e) : window.btoa(await $e68ba20b3d2d159d$var$ad(e)), $e68ba20b3d2d159d$var$bv = async (e, t = !1)=>t ? window.atob(e) : $e68ba20b3d2d159d$var$kv(window.atob(e)), $e68ba20b3d2d159d$var$dE = async ({ text: e, compress: t })=>{
        let r;
        if (t !== !1) try {
            r = await $e68ba20b3d2d159d$var$ad((0, $8fa5292818130bae$exports.deflate)(e));
        } catch (o) {
            console.error("encode: cannot deflate", o);
        }
        return {
            version: "1",
            encoding: "bstring",
            compressed: !!r,
            encoded: r || await $e68ba20b3d2d159d$var$ad(e)
        };
    }, $e68ba20b3d2d159d$var$mE = async (e)=>{
        let t;
        switch(e.encoding){
            case "bstring":
                t = e.compressed ? e.encoded : await $e68ba20b3d2d159d$var$kv(e.encoded);
                break;
            default:
                throw new Error(`decode: unknown encoding "${e.encoding}"`);
        }
        return e.compressed ? (0, $8fa5292818130bae$exports.inflate)(new Uint8Array($e68ba20b3d2d159d$var$Mv(t)), {
            to: "string"
        }) : t;
    };
});
var $e68ba20b3d2d159d$var$p4, $e68ba20b3d2d159d$var$iu, $e68ba20b3d2d159d$var$Pv = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$pE();
    $e68ba20b3d2d159d$var$Of();
    $e68ba20b3d2d159d$var$p4 = `https://unpkg.com/${$e68ba20b3d2d159d$var$T.VITE_PKG_NAME ? `${$e68ba20b3d2d159d$var$T.VITE_PKG_NAME}@${$e68ba20b3d2d159d$var$T.PKG_VERSION}` : "@excalidraw/excalidraw"}/dist/prod/`, $e68ba20b3d2d159d$var$iu = class e {
        urls;
        fontFace;
        constructor(t, r, o){
            this.urls = e.createUrls(r);
            let n = this.urls.map((i)=>`url(${i}) ${e.getFormat(i)}`).join(", ");
            this.fontFace = new FontFace(t, n, {
                display: "swap",
                style: "normal",
                weight: "400",
                ...o
            });
        }
        async getContent() {
            let t = 0, r = [];
            for(; t < this.urls.length;){
                let o = this.urls[t];
                if (o.protocol === "data:") return o.toString();
                try {
                    let n = await fetch(o, {
                        headers: {
                            Accept: "font/woff2"
                        }
                    });
                    if (n.ok) {
                        let i = await n.headers.get("Content-Type"), a = await n.arrayBuffer();
                        return `data:${i};base64,${await $e68ba20b3d2d159d$var$tu(await $e68ba20b3d2d159d$var$ad(a), !0)}`;
                    }
                    r.push(`"${o.toString()}" returned status "${n.status}"`);
                } catch (n) {
                    r.push(`"${o.toString()}" returned error "${n}"`);
                }
                t++;
            }
            return console.error(`Failed to fetch font "${this.fontFace.family}" from urls "${this.urls.toString()}`, JSON.stringify(r, void 0, 2)), this.urls.length ? this.urls[this.urls.length - 1].toString() : "";
        }
        static createUrls(t) {
            if (t.startsWith($e68ba20b3d2d159d$var$kp)) return [];
            if (t.startsWith("http") || t.startsWith("data")) return [
                new URL(t)
            ];
            let r = t.replace(/^\/+/, ""), o = [];
            if (typeof window.EXCALIDRAW_ASSET_PATH == "string") {
                let n = this.normalizeBaseUrl(window.EXCALIDRAW_ASSET_PATH);
                o.push(new URL(r, n));
            } else Array.isArray(window.EXCALIDRAW_ASSET_PATH) && window.EXCALIDRAW_ASSET_PATH.forEach((n)=>{
                let i = this.normalizeBaseUrl(n);
                o.push(new URL(r, i));
            });
            return o.push(new URL(r, $e68ba20b3d2d159d$var$p4)), o;
        }
        static getFormat(t) {
            try {
                let o = new URL(t).pathname.split(".");
                return o.length === 1 ? "" : `format('${o.pop()}')`;
            } catch  {
                return "";
            }
        }
        static normalizeBaseUrl(t) {
            let r = t;
            return /^\.?\//.test(r) && (r = new URL(r.replace(/^\.?\/+/, ""), window?.location?.origin).toString()), r = `${r.replace(/\/+$/, "")}/`, r;
        }
    };
});
var $e68ba20b3d2d159d$var$Dv, $e68ba20b3d2d159d$var$Lv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Dv = "./Virgil-Regular-YHAB2VGJ.woff2";
});
var $e68ba20b3d2d159d$var$Rv, $e68ba20b3d2d159d$var$_v = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Rv = "./Excalifont-Regular-CPKEUDVM.woff2";
});
var $e68ba20b3d2d159d$var$Ov, $e68ba20b3d2d159d$var$Nv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Ov = "./CascadiaCode-Regular-TMZI7IJ5.woff2";
});
var $e68ba20b3d2d159d$var$Bv, $e68ba20b3d2d159d$var$Fv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Bv = "./ComicShanns-Regular-6TOETDFT.woff2";
});
var $e68ba20b3d2d159d$var$Hv, $e68ba20b3d2d159d$var$zv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Hv = "./LiberationSans-Regular-ZQD73GJM.woff2";
});
var $e68ba20b3d2d159d$var$Gv, $e68ba20b3d2d159d$var$Uv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Gv = "https://fonts.gstatic.com/s/lilitaone/v15/i7dPIFZ9Zz-WBtRtedDbYEF8RXi4EwQ.woff2";
});
var $e68ba20b3d2d159d$var$Vv, $e68ba20b3d2d159d$var$Wv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Vv = "https://fonts.gstatic.com/s/lilitaone/v15/i7dPIFZ9Zz-WBtRtedDbYE98RXi4EwSsbg.woff2";
});
var $e68ba20b3d2d159d$var$Xv, $e68ba20b3d2d159d$var$Yv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Xv = "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhdTQ3j6zbXWjgeg.woff2";
});
var $e68ba20b3d2d159d$var$$v, $e68ba20b3d2d159d$var$Kv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$$v = "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhdTo3j6zbXWjgevT5.woff2";
});
var $e68ba20b3d2d159d$var$jv, $e68ba20b3d2d159d$var$Zv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$jv = "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhdTA3j6zbXWjgevT5.woff2";
});
var $e68ba20b3d2d159d$var$Jv, $e68ba20b3d2d159d$var$qv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$Jv = "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhdTk3j6zbXWjgevT5.woff2";
});
var $e68ba20b3d2d159d$var$eT, $e68ba20b3d2d159d$var$Qv = $e68ba20b3d2d159d$var$K(()=>{
    $e68ba20b3d2d159d$var$eT = "https://fonts.gstatic.com/s/nunito/v26/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhdTs3j6zbXWjgevT5.woff2";
});
function $e68ba20b3d2d159d$var$I4(e, t, ...r) {
    let o = $e68ba20b3d2d159d$export$530097e879f93363[e];
    return this.registered.get(o) || this.registered.set(o, {
        metadata: t,
        fonts: r.map(({ uri: i, descriptors: a })=>new $e68ba20b3d2d159d$var$iu(e, i, a))
    }), this.registered;
}
var $e68ba20b3d2d159d$var$zr, $e68ba20b3d2d159d$var$au, $e68ba20b3d2d159d$var$Eo, $e68ba20b3d2d159d$var$pn = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Of();
    $e68ba20b3d2d159d$var$Pv();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Lv();
    $e68ba20b3d2d159d$var$_v();
    $e68ba20b3d2d159d$var$Nv();
    $e68ba20b3d2d159d$var$Fv();
    $e68ba20b3d2d159d$var$zv();
    $e68ba20b3d2d159d$var$Uv();
    $e68ba20b3d2d159d$var$Wv();
    $e68ba20b3d2d159d$var$Yv();
    $e68ba20b3d2d159d$var$Kv();
    $e68ba20b3d2d159d$var$Zv();
    $e68ba20b3d2d159d$var$qv();
    $e68ba20b3d2d159d$var$Qv();
    $e68ba20b3d2d159d$var$zr = class e {
        static loadedFontsCache = new Set;
        static _registered;
        static _initialized = !1;
        static get registered() {
            return e._registered ? e._initialized || (e._registered = new Map([
                ...e.init().entries(),
                ...e._registered.entries()
            ])) : e._registered = e.init(), e._registered;
        }
        get registered() {
            return e.registered;
        }
        scene;
        constructor({ scene: t }){
            this.scene = t;
        }
        onLoaded = (t)=>{
            if (t.every((n)=>{
                let i = `${n.family}-${n.style}-${n.weight}-${n.unicodeRange}`;
                return e.loadedFontsCache.has(i) ? !0 : (e.loadedFontsCache.add(i), !1);
            })) return !1;
            let r = !1, o = this.scene.getNonDeletedElementsMap();
            for (let n of this.scene.getNonDeletedElements())if ($e68ba20b3d2d159d$var$G(n)) {
                r = !0, $e68ba20b3d2d159d$var$Oe.delete(n);
                let i = $e68ba20b3d2d159d$var$bt(n, o);
                i && $e68ba20b3d2d159d$var$Oe.delete(i);
            }
            r && this.scene.triggerUpdate();
        };
        loadSceneFonts = async ()=>{
            let t = this.getSceneFontFamilies(), r = await e.loadFontFaces(t);
            return this.onLoaded(r), r;
        };
        getSceneFontFamilies = ()=>e.getFontFamilies(this.scene.getNonDeletedElements());
        static loadFontsForElements = async (t)=>{
            let r = e.getFontFamilies(t);
            return await e.loadFontFaces(r);
        };
        static async loadFontFaces(t) {
            for (let { fonts: o, metadata: n } of e.registered.values())if (!n.local) for (let { fontFace: i } of o)window.document.fonts.has(i) || window.document.fonts.add(i);
            return (await Promise.all(t.map(async (o)=>{
                let n = $e68ba20b3d2d159d$var$ke({
                    fontFamily: o,
                    fontSize: 16
                });
                if (!window.document.fonts.check(n)) try {
                    return await window.document.fonts.load(n);
                } catch (i) {
                    console.error(`Failed to load font "${n}" from urls "${e.registered.get(o)?.fonts.map((a)=>a.urls)}"`, i);
                }
                return Promise.resolve();
            }))).flat().filter(Boolean);
        }
        static init() {
            let t = {
                registered: new Map
            }, r = $e68ba20b3d2d159d$var$I4.bind(t);
            return r("Virgil", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Virgil], {
                uri: $e68ba20b3d2d159d$var$Dv
            }), r("Excalifont", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Excalifont], {
                uri: $e68ba20b3d2d159d$var$Rv
            }), r("Helvetica", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Helvetica], {
                uri: $e68ba20b3d2d159d$var$kp
            }), r("Liberation Sans", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363["Liberation Sans"]], {
                uri: $e68ba20b3d2d159d$var$Hv
            }), r("Cascadia", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Cascadia], {
                uri: $e68ba20b3d2d159d$var$Ov
            }), r("Comic Shanns", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363["Comic Shanns"]], {
                uri: $e68ba20b3d2d159d$var$Bv
            }), r("Lilita One", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363["Lilita One"]], {
                uri: $e68ba20b3d2d159d$var$Vv,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.LATIN_EXT
                }
            }, {
                uri: $e68ba20b3d2d159d$var$Gv,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.LATIN
                }
            }), r("Nunito", $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Nunito], {
                uri: $e68ba20b3d2d159d$var$Jv,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.CYRILIC_EXT,
                    weight: "500"
                }
            }, {
                uri: $e68ba20b3d2d159d$var$jv,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.CYRILIC,
                    weight: "500"
                }
            }, {
                uri: $e68ba20b3d2d159d$var$eT,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.VIETNAMESE,
                    weight: "500"
                }
            }, {
                uri: $e68ba20b3d2d159d$var$$v,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.LATIN_EXT,
                    weight: "500"
                }
            }, {
                uri: $e68ba20b3d2d159d$var$Xv,
                descriptors: {
                    unicodeRange: $e68ba20b3d2d159d$var$Vi.LATIN,
                    weight: "500"
                }
            }), e._initialized = !0, t.registered;
        }
        static getFontFamilies(t) {
            return Array.from(t.reduce((r, o)=>($e68ba20b3d2d159d$var$G(o) && r.add(o.fontFamily), r), new Set));
        }
    };
    $e68ba20b3d2d159d$var$au = (e, t, r)=>{
        let { unitsPerEm: o, ascender: n, descender: i } = $e68ba20b3d2d159d$var$zr.registered.get(e)?.metadata.metrics || $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Virgil].metrics, a = t / o, s = (r - a * n + a * i) / 2;
        return a * n + s;
    }, $e68ba20b3d2d159d$var$Eo = (e)=>{
        let { lineHeight: t } = $e68ba20b3d2d159d$var$zr.registered.get(e)?.metadata.metrics || $e68ba20b3d2d159d$var$on[$e68ba20b3d2d159d$export$530097e879f93363.Excalifont].metrics;
        return t;
    };
});
var $e68ba20b3d2d159d$var$Un, $e68ba20b3d2d159d$var$Ar, $e68ba20b3d2d159d$var$EE, $e68ba20b3d2d159d$var$tT, $e68ba20b3d2d159d$var$cu, $e68ba20b3d2d159d$var$sd, $e68ba20b3d2d159d$var$rT, $e68ba20b3d2d159d$var$er, $e68ba20b3d2d159d$var$C4, $e68ba20b3d2d159d$var$td, $e68ba20b3d2d159d$var$oT, $e68ba20b3d2d159d$var$un, $e68ba20b3d2d159d$var$ds, $e68ba20b3d2d159d$var$ld, $e68ba20b3d2d159d$var$su, $e68ba20b3d2d159d$var$hn, $e68ba20b3d2d159d$var$lu, $e68ba20b3d2d159d$var$cd, $e68ba20b3d2d159d$var$du, $e68ba20b3d2d159d$var$gn = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$jo();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Yt();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$pn();
    $e68ba20b3d2d159d$var$Un = (e, { x: t, y: r, strokeColor: o = $e68ba20b3d2d159d$var$mt.strokeColor, backgroundColor: n = $e68ba20b3d2d159d$var$mt.backgroundColor, fillStyle: i = $e68ba20b3d2d159d$var$mt.fillStyle, strokeWidth: a = $e68ba20b3d2d159d$var$mt.strokeWidth, strokeStyle: s = $e68ba20b3d2d159d$var$mt.strokeStyle, roughness: l = $e68ba20b3d2d159d$var$mt.roughness, opacity: c = $e68ba20b3d2d159d$var$mt.opacity, width: d = 0, height: m = 0, angle: p = 0, groupIds: u = [], frameId: h = null, index: g = null, roundness: b = null, boundElements: v = null, link: y = null, locked: w = $e68ba20b3d2d159d$var$mt.locked, ...I })=>({
            id: I.id || $e68ba20b3d2d159d$var$Vt(),
            type: e,
            x: t,
            y: r,
            width: d,
            height: m,
            angle: p,
            strokeColor: o,
            backgroundColor: n,
            fillStyle: i,
            strokeWidth: a,
            strokeStyle: s,
            roughness: l,
            opacity: c,
            groupIds: u,
            frameId: h,
            index: g,
            roundness: b,
            seed: I.seed ?? $e68ba20b3d2d159d$var$ko(),
            version: I.version || 1,
            versionNonce: I.versionNonce ?? 0,
            isDeleted: !1,
            boundElements: v,
            updated: $e68ba20b3d2d159d$var$ci(),
            link: y,
            locked: w,
            customData: I.customData
        }), $e68ba20b3d2d159d$var$Ar = (e)=>$e68ba20b3d2d159d$var$Un(e.type, e), $e68ba20b3d2d159d$var$EE = (e)=>$e68ba20b3d2d159d$var$Un("embeddable", e), $e68ba20b3d2d159d$var$tT = (e)=>({
            ...$e68ba20b3d2d159d$var$Un("iframe", e)
        }), $e68ba20b3d2d159d$var$cu = (e)=>$e68ba20b3d2d159d$export$5390fab1c98104d7({
            ...$e68ba20b3d2d159d$var$Un("frame", e),
            type: "frame",
            name: e?.name || null
        }, {}), $e68ba20b3d2d159d$var$sd = (e)=>$e68ba20b3d2d159d$export$5390fab1c98104d7({
            ...$e68ba20b3d2d159d$var$Un("magicframe", e),
            type: "magicframe",
            name: e?.name || null
        }, {}), $e68ba20b3d2d159d$var$rT = (e, t)=>({
            x: e.textAlign === "center" ? t.width / 2 : e.textAlign === "right" ? t.width : 0,
            y: e.verticalAlign === "middle" ? t.height / 2 : 0
        }), $e68ba20b3d2d159d$var$er = (e)=>{
        let t = e.fontFamily || $e68ba20b3d2d159d$var$vr, r = e.fontSize || $e68ba20b3d2d159d$var$wr, o = e.lineHeight || $e68ba20b3d2d159d$var$Eo(t), n = $e68ba20b3d2d159d$var$Gn(e.text), i = $e68ba20b3d2d159d$var$Xt(n, $e68ba20b3d2d159d$var$ke({
            fontFamily: t,
            fontSize: r
        }), o), a = e.textAlign || $e68ba20b3d2d159d$var$An, s = e.verticalAlign || $e68ba20b3d2d159d$var$Oa, l = $e68ba20b3d2d159d$var$rT({
            textAlign: a,
            verticalAlign: s
        }, i), c = {
            ...$e68ba20b3d2d159d$var$Un("text", e),
            text: n,
            fontSize: r,
            fontFamily: t,
            textAlign: a,
            verticalAlign: s,
            x: e.x - l.x,
            y: e.y - l.y,
            width: i.width,
            height: i.height,
            containerId: e.containerId || null,
            originalText: e.originalText ?? n,
            autoResize: e.autoResize ?? !0,
            lineHeight: o
        };
        return $e68ba20b3d2d159d$export$5390fab1c98104d7(c, {});
    }, $e68ba20b3d2d159d$var$C4 = (e, t, r)=>{
        let { width: o, height: n } = $e68ba20b3d2d159d$var$Xt(r, $e68ba20b3d2d159d$var$ke(e), e.lineHeight);
        e.autoResize || (o = e.width);
        let { textAlign: i, verticalAlign: a } = e, s, l;
        if (i === "center" && a === $e68ba20b3d2d159d$var$Pt.MIDDLE && !e.containerId && e.autoResize) {
            let c = $e68ba20b3d2d159d$var$Xt(e.text, $e68ba20b3d2d159d$var$ke(e), e.lineHeight), d = $e68ba20b3d2d159d$var$rT(e, {
                width: o - c.width,
                height: n - c.height
            });
            s = e.x - d.x, l = e.y - d.y;
        } else {
            let [c, d, m, p] = $e68ba20b3d2d159d$var$ae(e, t), [u, h, g, b] = $e68ba20b3d2d159d$var$Ei(e, o, n, !1), v = (c - u) / 2, y = (d - h) / 2, w = (m - g) / 2, I = (p - b) / 2;
            [s, l] = $e68ba20b3d2d159d$var$nT({
                s: !0,
                e: i === "center" || i === "left",
                w: i === "center" || i === "right"
            }, e.x, e.y, e.angle, v, y, w, I);
        }
        return {
            width: o,
            height: n,
            x: Number.isFinite(s) ? s : e.x,
            y: Number.isFinite(l) ? l : e.y
        };
    }, $e68ba20b3d2d159d$var$td = (e, t, r, o = e.text)=>{
        if (e.isDeleted) return;
        (t || !e.autoResize) && (o = $e68ba20b3d2d159d$var$Ro(o, $e68ba20b3d2d159d$var$ke(e), t ? $e68ba20b3d2d159d$var$Mr(t, e) : e.width));
        let n = $e68ba20b3d2d159d$var$C4(e, r, o);
        return {
            text: o,
            ...n
        };
    }, $e68ba20b3d2d159d$var$oT = (e)=>({
            ...$e68ba20b3d2d159d$var$Un(e.type, e),
            points: e.points || [],
            pressures: e.pressures || [],
            simulatePressure: e.simulatePressure,
            lastCommittedPoint: null
        }), $e68ba20b3d2d159d$var$un = (e)=>({
            ...$e68ba20b3d2d159d$var$Un(e.type, e),
            points: e.points || [],
            lastCommittedPoint: null,
            startBinding: null,
            endBinding: null,
            startArrowhead: null,
            endArrowhead: null
        }), $e68ba20b3d2d159d$var$ds = (e)=>({
            ...$e68ba20b3d2d159d$var$Un(e.type, e),
            points: e.points || [],
            lastCommittedPoint: null,
            startBinding: null,
            endBinding: null,
            startArrowhead: e.startArrowhead || null,
            endArrowhead: e.endArrowhead || null,
            elbowed: e.elbowed || !1
        }), $e68ba20b3d2d159d$var$ld = (e)=>({
            ...$e68ba20b3d2d159d$var$Un("image", e),
            strokeColor: "transparent",
            status: e.status ?? "pending",
            fileId: e.fileId ?? null,
            scale: e.scale ?? [
                1,
                1
            ]
        }), $e68ba20b3d2d159d$var$su = (e, t = 0)=>{
        if (e == null || typeof e != "object") return e;
        let r = Object.prototype.toString.call(e);
        if (r === "[object Object]") {
            let o = typeof e.constructor == "function" ? Object.create(Object.getPrototypeOf(e)) : {};
            for(let n in e)if (e.hasOwnProperty(n)) {
                if (t === 0 && (n === "shape" || n === "canvas")) continue;
                o[n] = $e68ba20b3d2d159d$var$su(e[n], t + 1);
            }
            return o;
        }
        if (Array.isArray(e)) {
            let o = e.length, n = new Array(o);
            for(; o--;)n[o] = $e68ba20b3d2d159d$var$su(e[o], t + 1);
            return n;
        }
        return $e68ba20b3d2d159d$var$T.DEV && r !== "[object Object]" && r !== "[object Array]" && r.startsWith("[object ") && console.warn(`_deepCloneElement: unexpected object type ${r}. This value will not be cloned!`), e;
    }, $e68ba20b3d2d159d$var$hn = (e)=>$e68ba20b3d2d159d$var$su(e), $e68ba20b3d2d159d$var$lu = (e)=>{
        if ($e68ba20b3d2d159d$var$Zr() && e) {
            let t = `${e}_copy`;
            return window.h?.app?.getSceneElementsIncludingDeleted().find((r)=>r.id === t) && (t += "_copy"), t;
        }
        return $e68ba20b3d2d159d$var$Vt();
    }, $e68ba20b3d2d159d$var$cd = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$hn(r);
        return n.id = $e68ba20b3d2d159d$var$lu(n.id), n.boundElements = null, n.updated = $e68ba20b3d2d159d$var$ci(), n.seed = $e68ba20b3d2d159d$var$ko(), n.groupIds = $e68ba20b3d2d159d$var$my(n.groupIds, e, (i)=>(t.has(i) || t.set(i, $e68ba20b3d2d159d$var$lu(i)), t.get(i))), o && (n = Object.assign(n, o)), n;
    }, $e68ba20b3d2d159d$var$du = (e, t)=>{
        let r = [], o = $e68ba20b3d2d159d$var$j(e), n = new Map, i = (s)=>{
            if (n.has(s)) return n.get(s);
            if (o.has(s)) {
                let l = $e68ba20b3d2d159d$var$lu(s);
                return n.set(s, l), l;
            }
            return null;
        }, a = new Map;
        for (let s of e){
            let l = $e68ba20b3d2d159d$var$su(s);
            if (l.id = i(s.id), t?.randomizeSeed && (l.seed = $e68ba20b3d2d159d$var$ko(), $e68ba20b3d2d159d$export$52f84dc7de3cd4b8(l)), l.groupIds && (l.groupIds = l.groupIds.map((c)=>(a.has(c) || a.set(c, $e68ba20b3d2d159d$var$lu(c)), a.get(c)))), "containerId" in l && l.containerId) {
                let c = i(l.containerId);
                l.containerId = c;
            }
            if ("boundElements" in l && l.boundElements && (l.boundElements = l.boundElements.reduce((c, d)=>{
                let m = i(d.id);
                return m && c.push({
                    ...d,
                    id: m
                }), c;
            }, [])), "endBinding" in l && l.endBinding) {
                let c = i(l.endBinding.elementId);
                l.endBinding = c ? {
                    ...l.endBinding,
                    elementId: c
                } : null;
            }
            if ("startBinding" in l && l.startBinding) {
                let c = i(l.startBinding.elementId);
                l.startBinding = c ? {
                    ...l.startBinding,
                    elementId: c
                } : null;
            }
            l.frameId && (l.frameId = i(l.frameId)), r.push(l);
        }
        return r;
    };
});
var $e68ba20b3d2d159d$var$vt, $e68ba20b3d2d159d$var$dd, $e68ba20b3d2d159d$var$md, $e68ba20b3d2d159d$var$iT = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Do();
    $e68ba20b3d2d159d$var$Yt();
    $e68ba20b3d2d159d$var$Be();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$vt = class e {
        constructor(t, r){
            this.deleted = t;
            this.inserted = r;
        }
        static create(t, r, o, n) {
            let i = o && n !== "inserted" ? o(t) : t, a = o && n !== "deleted" ? o(r) : r;
            return new e(i, a);
        }
        static calculate(t, r, o, n) {
            if (t === r) return e.empty();
            let i = {}, a = {};
            for (let c of this.distinctKeysIterator("full", t, r))i[c] = t[c], a[c] = r[c];
            let [s, l] = n ? n(i, a) : [
                i,
                a
            ];
            return e.create(s, l, o);
        }
        static empty() {
            return new e({}, {});
        }
        static isEmpty(t) {
            return !Object.keys(t.deleted).length && !Object.keys(t.inserted).length;
        }
        static mergeObjects(t, r, o) {
            let n = {
                ...t
            };
            for (let i of Object.keys(o))delete n[i];
            return {
                ...n,
                ...r
            };
        }
        static mergeArrays(t, r, o, n) {
            return Object.values(e.mergeObjects($e68ba20b3d2d159d$var$Pn(t ?? [], n), $e68ba20b3d2d159d$var$Pn(r ?? [], n), $e68ba20b3d2d159d$var$Pn(o ?? [], n)));
        }
        static diffObjects(t, r, o, n) {
            if (!(!t[o] && !r[o]) && (typeof t[o] == "object" || typeof r[o] == "object")) {
                let i = t[o] ?? {}, a = r[o] ?? {}, s = e.getLeftDifferences(i, a).reduce((c, d)=>(c[d] = n(i[d]), c), {}), l = e.getRightDifferences(i, a).reduce((c, d)=>(c[d] = n(a[d]), c), {});
                Object.keys(s).length || Object.keys(l).length ? (Reflect.set(t, o, s), Reflect.set(r, o, l)) : (Reflect.deleteProperty(t, o), Reflect.deleteProperty(r, o));
            }
        }
        static diffArrays(t, r, o, n) {
            if (!(!t[o] && !r[o]) && (Array.isArray(t[o]) || Array.isArray(r[o]))) {
                let i = Array.isArray(t[o]) ? t[o] : [], a = Array.isArray(r[o]) ? r[o] : [], s = $e68ba20b3d2d159d$var$Pn(e.getLeftDifferences($e68ba20b3d2d159d$var$Pn(i, n), $e68ba20b3d2d159d$var$Pn(a, n))), l = $e68ba20b3d2d159d$var$Pn(e.getRightDifferences($e68ba20b3d2d159d$var$Pn(i, n), $e68ba20b3d2d159d$var$Pn(a, n)));
                if (Object.keys(s).length || Object.keys(l).length) {
                    let c = i.filter((m)=>s[n ? n(m) : String(m)]), d = a.filter((m)=>l[n ? n(m) : String(m)]);
                    Reflect.set(t, o, c), Reflect.set(r, o, d);
                } else Reflect.deleteProperty(t, o), Reflect.deleteProperty(r, o);
            }
        }
        static isLeftDifferent(t, r, o = !1) {
            return !!this.distinctKeysIterator("left", t, r, o).next().value;
        }
        static isRightDifferent(t, r, o = !1) {
            return !!this.distinctKeysIterator("right", t, r, o).next().value;
        }
        static getLeftDifferences(t, r, o = !1) {
            return Array.from(this.distinctKeysIterator("left", t, r, o));
        }
        static getRightDifferences(t, r, o = !1) {
            return Array.from(this.distinctKeysIterator("right", t, r, o));
        }
        static *distinctKeysIterator(t, r, o, n = !1) {
            if (r === o) return;
            let i = [];
            t === "left" ? i = Object.keys(r) : t === "right" ? i = Object.keys(o) : t === "full" ? i = Array.from(new Set([
                ...Object.keys(r),
                ...Object.keys(o)
            ])) : $e68ba20b3d2d159d$var$Zo(t, `Unknown distinctKeysIterator's join param "${t}"`, !0);
            for (let a of i){
                let s = r[a], l = o[a];
                if (s !== l) {
                    if (!n && typeof s == "object" && typeof l == "object" && s !== null && l !== null && $e68ba20b3d2d159d$var$at(s, l)) continue;
                    yield a;
                }
            }
        }
    }, $e68ba20b3d2d159d$var$dd = class e {
        constructor(t){
            this.delta = t;
        }
        static calculate(t, r) {
            let o = $e68ba20b3d2d159d$var$vt.calculate(t, r, void 0, e.postProcess);
            return new e(o);
        }
        static empty() {
            return new e($e68ba20b3d2d159d$var$vt.create({}, {}));
        }
        inverse() {
            let t = $e68ba20b3d2d159d$var$vt.create(this.delta.inserted, this.delta.deleted);
            return new e(t);
        }
        applyTo(t, r) {
            try {
                let { selectedElementIds: o = {}, selectedGroupIds: n = {} } = this.delta.deleted, { selectedElementIds: i = {}, selectedGroupIds: a = {}, selectedLinearElementId: s, editingLinearElementId: l, ...c } = this.delta.inserted, d = $e68ba20b3d2d159d$var$vt.mergeObjects(t.selectedElementIds, i, o), m = $e68ba20b3d2d159d$var$vt.mergeObjects(t.selectedGroupIds, a, n), p = s && r.has(s) ? new $e68ba20b3d2d159d$var$$(r.get(s)) : null, u = l && r.has(l) ? new $e68ba20b3d2d159d$var$$(r.get(l)) : null, h = {
                    ...t,
                    ...c,
                    selectedElementIds: d,
                    selectedGroupIds: m,
                    selectedLinearElement: typeof s < "u" ? p : t.selectedLinearElement,
                    editingLinearElement: typeof l < "u" ? u : t.editingLinearElement
                }, g = this.filterInvisibleChanges(t, h, r);
                return [
                    h,
                    g
                ];
            } catch (o) {
                if (console.error("Couldn't apply appstate change", o), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw o;
                return [
                    t,
                    !1
                ];
            }
        }
        isEmpty() {
            return $e68ba20b3d2d159d$var$vt.isEmpty(this.delta);
        }
        static postProcess(t, r) {
            try {
                $e68ba20b3d2d159d$var$vt.diffObjects(t, r, "selectedElementIds", (o)=>!0), $e68ba20b3d2d159d$var$vt.diffObjects(t, r, "selectedGroupIds", (o)=>o ?? !1);
            } catch (o) {
                if (console.error("Couldn't postprocess appstate change deltas."), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw o;
            } finally{
                return [
                    t,
                    r
                ];
            }
        }
        filterInvisibleChanges(t, r, o) {
            let n = $e68ba20b3d2d159d$var$pd(t), i = $e68ba20b3d2d159d$var$pd(r), a = $e68ba20b3d2d159d$var$vt.isRightDifferent(e.stripElementsProps(n), e.stripElementsProps(i)), s = $e68ba20b3d2d159d$var$vt.isRightDifferent(e.stripStandaloneProps(n), e.stripStandaloneProps(i));
            if (!a && !s) return !1;
            let l = {
                value: a
            };
            if (s) {
                let c = $e68ba20b3d2d159d$var$vt.getRightDifferences(e.stripStandaloneProps(n), e.stripStandaloneProps(i)), d = new Set;
                (c.includes("editingGroupId") || c.includes("selectedGroupIds")) && (d = $e68ba20b3d2d159d$var$hy(o));
                for (let m of c)switch(m){
                    case "selectedElementIds":
                        r[m] = e.filterSelectedElements(r[m], o, l);
                        break;
                    case "selectedGroupIds":
                        r[m] = e.filterSelectedGroups(r[m], d, l);
                        break;
                    case "editingGroupId":
                        let p = r[m];
                        p ? d.has(p) ? l.value = !0 : r[m] = null : l.value = !0;
                        break;
                    case "selectedLinearElementId":
                    case "editingLinearElementId":
                        let u = e.convertToAppStateKey(m), h = r[u];
                        if (!h) l.value = !0;
                        else {
                            let g = o.get(h.elementId);
                            g && !g.isDeleted ? l.value = !0 : r[u] = null;
                        }
                        break;
                    default:
                        $e68ba20b3d2d159d$var$Zo(m, `Unknown ObservedElementsAppState's key "${m}"`, !0);
                }
            }
            return l.value;
        }
        static convertToAppStateKey(t) {
            switch(t){
                case "selectedLinearElementId":
                    return "selectedLinearElement";
                case "editingLinearElementId":
                    return "editingLinearElement";
            }
        }
        static filterSelectedElements(t, r, o) {
            let n = Object.keys(t);
            if (!n.length) return o.value = !0, t;
            let i = {
                ...t
            };
            for (let a of n){
                let s = r.get(a);
                s && !s.isDeleted ? o.value = !0 : delete i[a];
            }
            return i;
        }
        static filterSelectedGroups(t, r, o) {
            if (!Object.keys(t).length) return o.value = !0, t;
            let i = {
                ...t
            };
            for (let a of Object.keys(i))r.has(a) ? o.value = !0 : delete i[a];
            return i;
        }
        static stripElementsProps(t) {
            let { editingGroupId: r, selectedGroupIds: o, selectedElementIds: n, editingLinearElementId: i, selectedLinearElementId: a, ...s } = t;
            return s;
        }
        static stripStandaloneProps(t) {
            let { name: r, viewBackgroundColor: o, ...n } = t;
            return n;
        }
    }, $e68ba20b3d2d159d$var$md = class e {
        constructor(t, r, o){
            this.added = t;
            this.removed = r;
            this.updated = o;
        }
        static create(t, r, o, n = {
            shouldRedistribute: !1
        }) {
            let i;
            if (n.shouldRedistribute) {
                let a = new Map, s = new Map, l = new Map, c = [
                    ...t,
                    ...r,
                    ...o
                ];
                for (let [d, m] of c)this.satisfiesAddition(m) ? a.set(d, m) : this.satisfiesRemoval(m) ? s.set(d, m) : l.set(d, m);
                i = new e(a, s, l);
            } else i = new e(t, r, o);
            return ($e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) && (e.validate(i, "added", this.satisfiesAddition), e.validate(i, "removed", this.satisfiesRemoval), e.validate(i, "updated", this.satisfiesUpdate)), i;
        }
        static satisfiesAddition = ({ deleted: t, inserted: r })=>t.isDeleted === !0 && !r.isDeleted;
        static satisfiesRemoval = ({ deleted: t, inserted: r })=>!t.isDeleted && r.isDeleted === !0;
        static satisfiesUpdate = ({ deleted: t, inserted: r })=>!!t.isDeleted == !!r.isDeleted;
        static validate(t, r, o) {
            for (let [n, i] of t[r].entries())if (!o(i)) throw console.error(`Broken invariant for "${r}" delta, element "${n}", delta:`, i), new Error(`ElementsChange invariant broken for element "${n}".`);
        }
        static calculate(t, r) {
            if (t === r) return e.empty();
            let o = new Map, n = new Map, i = new Map;
            for (let a of t.values())if (!r.get(a.id)) {
                let l = {
                    ...a,
                    isDeleted: !1
                }, c = {
                    isDeleted: !0
                }, d = $e68ba20b3d2d159d$var$vt.create(l, c, e.stripIrrelevantProps);
                n.set(a.id, d);
            }
            for (let a of r.values()){
                let s = t.get(a.id);
                if (!s) {
                    let l = {
                        isDeleted: !0
                    }, c = {
                        ...a,
                        isDeleted: !1
                    }, d = $e68ba20b3d2d159d$var$vt.create(l, c, e.stripIrrelevantProps);
                    o.set(a.id, d);
                    continue;
                }
                if (s.versionNonce !== a.versionNonce) {
                    let l = $e68ba20b3d2d159d$var$vt.calculate(s, a, e.stripIrrelevantProps, e.postProcess);
                    if (typeof s.isDeleted == "boolean" && typeof a.isDeleted == "boolean" && s.isDeleted !== a.isDeleted) {
                        s.isDeleted && !a.isDeleted ? o.set(a.id, l) : n.set(a.id, l);
                        continue;
                    }
                    $e68ba20b3d2d159d$var$vt.isEmpty(l) || i.set(a.id, l);
                }
            }
            return e.create(o, n, i);
        }
        static empty() {
            return e.create(new Map, new Map, new Map);
        }
        inverse() {
            let t = (i)=>{
                let a = new Map;
                for (let [s, l] of i.entries())a.set(s, $e68ba20b3d2d159d$var$vt.create(l.inserted, l.deleted));
                return a;
            }, r = t(this.added), o = t(this.removed), n = t(this.updated);
            return e.create(o, r, n);
        }
        isEmpty() {
            return this.added.size === 0 && this.removed.size === 0 && this.updated.size === 0;
        }
        applyLatestChanges(t) {
            let r = (s)=>(l)=>{
                    let c = {};
                    for (let d of Object.keys(l))switch(d){
                        case "boundElements":
                            c[d] = l[d];
                            break;
                        default:
                            c[d] = s[d];
                    }
                    return c;
                }, o = (s)=>{
                let l = new Map;
                for (let [c, d] of s.entries()){
                    let m = t.get(c);
                    if (m) {
                        let p = $e68ba20b3d2d159d$var$vt.create(d.deleted, d.inserted, r(m), "inserted");
                        l.set(c, p);
                    } else l.set(c, d);
                }
                return l;
            }, n = o(this.added), i = o(this.removed), a = o(this.updated);
            return e.create(n, i, a, {
                shouldRedistribute: !0
            });
        }
        applyTo(t, r) {
            let o = $e68ba20b3d2d159d$var$lr(new Map(t)), n, i = {
                containsVisibleDifference: !1,
                containsZindexDifference: !1
            };
            try {
                let a = e.createApplier(o, r, i), s = a(this.added), l = a(this.removed), c = a(this.updated), d = this.resolveConflicts(t, o);
                n = new Map([
                    ...s,
                    ...l,
                    ...c,
                    ...d
                ]);
            } catch (a) {
                if (console.error("Couldn't apply elements change", a), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw a;
                return [
                    t,
                    !0
                ];
            }
            try {
                e.redrawTextBoundingBoxes(o, n), o = e.reorderElements(o, n, i), e.redrawBoundArrows(o, n);
            } catch (a) {
                if (console.error("Couldn't mutate elements after applying elements change", a), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw a;
            } finally{
                return [
                    o,
                    i.containsVisibleDifference
                ];
            }
        }
        static createApplier = (t, r, o)=>{
            let n = e.createGetter(t, r, o);
            return (i)=>Array.from(i.entries()).reduce((a, [s, l])=>{
                    let c = n(s, l.inserted);
                    if (c) {
                        let d = e.applyDelta(c, l, o);
                        t.set(d.id, d), a.set(d.id, d);
                    }
                    return a;
                }, new Map);
        };
        static createGetter = (t, r, o)=>(n, i)=>{
                let a = t.get(n);
                return a || (a = r.get(n), a && (o.containsZindexDifference = !0, (i.isDeleted === !1 || i.isDeleted !== !0 && a.isDeleted === !1) && (o.containsVisibleDifference = !0))), a;
            };
        static applyDelta(t, r, o = {
            containsVisibleDifference: !0,
            containsZindexDifference: !0
        }) {
            let { boundElements: n, ...i } = r.inserted;
            if (r.deleted.boundElements?.length || r.inserted.boundElements?.length) {
                let a = $e68ba20b3d2d159d$var$vt.mergeArrays(t.boundElements, r.inserted.boundElements, r.deleted.boundElements, (s)=>s.id);
                Object.assign(i, {
                    boundElements: a
                });
            }
            if (!o.containsVisibleDifference) {
                let { index: a, ...s } = i, l = e.checkForVisibleDifference(t, s);
                o.containsVisibleDifference = l;
            }
            return o.containsZindexDifference || (o.containsZindexDifference = r.deleted.index !== r.inserted.index), $e68ba20b3d2d159d$export$5390fab1c98104d7(t, i);
        }
        static checkForVisibleDifference(t, r) {
            return t.isDeleted && r.isDeleted !== !1 ? !1 : t.isDeleted && r.isDeleted === !1 || t.isDeleted === !1 && r.isDeleted ? !0 : $e68ba20b3d2d159d$var$vt.isRightDifferent(t, r);
        }
        resolveConflicts(t, r) {
            let o = new Map, n = (c, d)=>{
                let m = r.get(c.id);
                if (!m) return;
                let p;
                t.get(c.id) === m ? p = $e68ba20b3d2d159d$export$5390fab1c98104d7(m, d) : p = $e68ba20b3d2d159d$export$55655e96a21bba2e(m, d), o.set(p.id, p), r.set(p.id, p);
            };
            for (let [c] of this.removed)e.unbindAffected(t, r, c, n);
            for (let [c] of this.added)e.rebindAffected(t, r, c, n);
            for (let [c] of Array.from(this.updated).filter(([d, m])=>Object.keys({
                    ...m.deleted,
                    ...m.inserted
                }).find((p)=>$e68ba20b3d2d159d$var$dv.has(p)))){
                let d = r.get(c);
                !d || d.isDeleted || e.rebindAffected(t, r, c, n);
            }
            let i = new Map(Array.from(t).filter(([c])=>o.has(c))), { added: a, removed: s, updated: l } = e.calculate(i, o);
            for (let [c, d] of a)this.added.set(c, d);
            for (let [c, d] of s)this.removed.set(c, d);
            for (let [c, d] of l)this.updated.set(c, d);
            return o;
        }
        static unbindAffected(t, r, o, n) {
            let i = ()=>t.get(o), a = ()=>r.get(o);
            $e68ba20b3d2d159d$var$qi.unbindAffected(r, i(), n), $e68ba20b3d2d159d$var$qi.unbindAffected(r, a(), n), $e68ba20b3d2d159d$var$Ji.unbindAffected(r, i(), n), $e68ba20b3d2d159d$var$Ji.unbindAffected(r, a(), n);
        }
        static rebindAffected(t, r, o, n) {
            let i = ()=>t.get(o), a = ()=>r.get(o);
            $e68ba20b3d2d159d$var$qi.unbindAffected(r, i(), n), $e68ba20b3d2d159d$var$qi.rebindAffected(r, a(), n), $e68ba20b3d2d159d$var$Ji.unbindAffected(r, i(), (s, l)=>{
                $e68ba20b3d2d159d$var$G(s) && n(s, l);
            }), $e68ba20b3d2d159d$var$Ji.rebindAffected(r, a(), n);
        }
        static redrawTextBoundingBoxes(t, r) {
            let o = new Map;
            for (let n of r.values()){
                if ($e68ba20b3d2d159d$var$Ge(n)) {
                    let { containerId: i } = n, a = i ? t.get(i) : void 0;
                    a && o.set(a.id, {
                        container: a,
                        boundText: n
                    });
                }
                if ($e68ba20b3d2d159d$var$It(n)) {
                    let i = $e68ba20b3d2d159d$var$fn(n), a = i ? t.get(i) : void 0;
                    a && o.set(n.id, {
                        container: n,
                        boundText: a
                    });
                }
            }
            for (let { container: n, boundText: i } of o.values())n.isDeleted || i.isDeleted || $e68ba20b3d2d159d$var$gt(i, n, t, !1);
        }
        static redrawBoundArrows(t, r) {
            for (let o of r.values())!o.isDeleted && $e68ba20b3d2d159d$var$po(o) && $e68ba20b3d2d159d$var$Jt(o, t, {
                changedElements: r
            });
        }
        static reorderElements(t, r, o) {
            if (!o.containsZindexDifference) return t;
            let n = Array.from(t.values()), i = $e68ba20b3d2d159d$var$mu([
                ...n
            ]), a = $e68ba20b3d2d159d$var$vt.getRightDifferences(n, i, !0).reduce((s, l)=>{
                let c = n[Number(l)];
                return c && r.has(c.id) && s.set(c.id, c), s;
            }, new Map);
            return !o.containsVisibleDifference && a.size && (o.containsVisibleDifference = !0), $e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$tr(i, a));
        }
        static postProcess(t, r) {
            try {
                $e68ba20b3d2d159d$var$vt.diffArrays(t, r, "boundElements", (o)=>o.id);
            } catch (o) {
                if (console.error("Couldn't postprocess elements change deltas."), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw o;
            } finally{
                return [
                    t,
                    r
                ];
            }
        }
        static stripIrrelevantProps(t) {
            let { id: r, updated: o, version: n, versionNonce: i, seed: a, ...s } = t;
            return s;
        }
    };
});
var $e68ba20b3d2d159d$var$kr, $e68ba20b3d2d159d$var$ud = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$kr = class {
        subscribers = [];
        on(...t) {
            let r = t.flat().filter((o)=>typeof o == "function");
            return this.subscribers.push(...r), ()=>this.off(r);
        }
        once(...t) {
            let r = t.flat().filter((n)=>typeof n == "function");
            r.push(()=>o());
            let o = this.on(...r);
            return o;
        }
        off(...t) {
            let r = t.flat();
            this.subscribers = this.subscribers.filter((o)=>!r.includes(o));
        }
        trigger(...t) {
            for (let r of this.subscribers)r(...t);
            return this;
        }
        clear() {
            this.subscribers = [];
        }
    };
});
var $e68ba20b3d2d159d$var$aT, $e68ba20b3d2d159d$var$pd, $e68ba20b3d2d159d$var$A4, $e68ba20b3d2d159d$export$85f9bb8d5701581c, $e68ba20b3d2d159d$var$xE, $e68ba20b3d2d159d$var$pu, $e68ba20b3d2d159d$var$uu, $e68ba20b3d2d159d$var$Be = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$iT();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$gn();
    $e68ba20b3d2d159d$var$ud();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$aT = "__observedAppState", $e68ba20b3d2d159d$var$pd = (e)=>{
        let t = {
            name: e.name,
            editingGroupId: e.editingGroupId,
            viewBackgroundColor: e.viewBackgroundColor,
            selectedElementIds: e.selectedElementIds,
            selectedGroupIds: e.selectedGroupIds,
            editingLinearElementId: e.editingLinearElement?.elementId || null,
            selectedLinearElementId: e.selectedLinearElement?.elementId || null
        };
        return Reflect.defineProperty(t, $e68ba20b3d2d159d$var$aT, {
            value: !0,
            enumerable: !1
        }), t;
    }, $e68ba20b3d2d159d$var$A4 = (e)=>!!Reflect.get(e, $e68ba20b3d2d159d$var$aT), $e68ba20b3d2d159d$export$85f9bb8d5701581c = {
        CAPTURE: "capture",
        UPDATE: "update",
        NONE: "none"
    }, $e68ba20b3d2d159d$var$xE = class {
        constructor(t, r){
            this.elementsChange = t;
            this.appStateChange = r;
        }
    }, $e68ba20b3d2d159d$var$pu = class {
        onStoreIncrementEmitter = new $e68ba20b3d2d159d$var$kr;
        scheduledActions = new Set;
        _snapshot = $e68ba20b3d2d159d$var$uu.empty();
        get snapshot() {
            return this._snapshot;
        }
        set snapshot(t) {
            this._snapshot = t;
        }
        shouldCaptureIncrement = ()=>{
            this.scheduleAction($e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE);
        };
        shouldUpdateSnapshot = ()=>{
            this.scheduleAction($e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE);
        };
        scheduleAction = (t)=>{
            this.scheduledActions.add(t), this.satisfiesScheduledActionsInvariant();
        };
        commit = (t, r)=>{
            try {
                this.scheduledActions.has($e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE) ? this.captureIncrement(t, r) : this.scheduledActions.has($e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE) && this.updateSnapshot(t, r);
            } finally{
                this.satisfiesScheduledActionsInvariant(), this.scheduledActions = new Set;
            }
        };
        captureIncrement = (t, r)=>{
            let o = this.snapshot, n = this.snapshot.maybeClone(t, r);
            if (o !== n) {
                let i = n.meta.didElementsChange ? $e68ba20b3d2d159d$var$md.calculate(o.elements, n.elements) : $e68ba20b3d2d159d$var$md.empty(), a = n.meta.didAppStateChange ? $e68ba20b3d2d159d$var$dd.calculate(o.appState, n.appState) : $e68ba20b3d2d159d$var$dd.empty();
                (!i.isEmpty() || !a.isEmpty()) && this.onStoreIncrementEmitter.trigger(new $e68ba20b3d2d159d$var$xE(i, a)), this.snapshot = n;
            }
        };
        updateSnapshot = (t, r)=>{
            let o = this.snapshot.maybeClone(t, r);
            this.snapshot !== o && (this.snapshot = o);
        };
        filterUncomittedElements = (t, r)=>{
            for (let [o, n] of t.entries()){
                if (!r.get(o)) continue;
                let a = this.snapshot.elements.get(o);
                a ? a.version < n.version && r.set(o, a) : r.delete(o);
            }
            return r;
        };
        clear = ()=>{
            this.snapshot = $e68ba20b3d2d159d$var$uu.empty(), this.scheduledActions = new Set;
        };
        satisfiesScheduledActionsInvariant = ()=>{
            if (!(this.scheduledActions.size >= 0 && this.scheduledActions.size <= 3)) {
                let t = `There can be at most three store actions scheduled at the same time, but there are "${this.scheduledActions.size}".`;
                if (console.error(t, this.scheduledActions.values()), $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST) throw new Error(t);
            }
        };
    }, $e68ba20b3d2d159d$var$uu = class e {
        constructor(t, r, o = {
            didElementsChange: !1,
            didAppStateChange: !1,
            isEmpty: !1
        }){
            this.elements = t;
            this.appState = r;
            this.meta = o;
        }
        static empty() {
            return new e(new Map, $e68ba20b3d2d159d$var$pd($e68ba20b3d2d159d$var$dr()), {
                didElementsChange: !1,
                didAppStateChange: !1,
                isEmpty: !0
            });
        }
        isEmpty() {
            return this.meta.isEmpty;
        }
        maybeClone(t, r) {
            let o = this.maybeCreateElementsSnapshot(t), n = this.maybeCreateAppStateSnapshot(r), i = !1, a = !1;
            return this.elements !== o && (i = !0), this.appState !== n && (a = !0), !i && !a ? this : new e(o, n, {
                didElementsChange: i,
                didAppStateChange: a
            });
        }
        maybeCreateAppStateSnapshot(t) {
            if (!t) return this.appState;
            let r = $e68ba20b3d2d159d$var$A4(t) ? t : $e68ba20b3d2d159d$var$pd(t);
            return this.detectChangedAppState(r) ? r : this.appState;
        }
        detectChangedAppState(t) {
            return !$e68ba20b3d2d159d$var$at(this.appState, t, {
                selectedElementIds: $e68ba20b3d2d159d$var$at,
                selectedGroupIds: $e68ba20b3d2d159d$var$at
            });
        }
        maybeCreateElementsSnapshot(t) {
            return t ? this.detectChangedElements(t) ? this.createElementsSnapshot(t) : this.elements : this.elements;
        }
        detectChangedElements(t) {
            if (this.elements === t) return !1;
            if (this.elements.size !== t.size) return !0;
            let r = Array.from(t.keys());
            for(let o = r.length - 1; o >= 0; o--){
                let n = this.elements.get(r[o]), i = t.get(r[o]);
                if (!n || !i || n.id !== i.id || n.versionNonce !== i.versionNonce) return !0;
            }
            return !1;
        }
        createElementsSnapshot(t) {
            let r = new Map;
            for (let [o, n] of this.elements.entries())t.get(o) ? r.set(o, n) : r.set(o, $e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                isDeleted: !0
            }));
            for (let [o, n] of t.entries()){
                let i = r.get(o);
                (!i || i && i.versionNonce !== n.versionNonce) && r.set(o, $e68ba20b3d2d159d$var$hn(n));
            }
            return r;
        }
    };
});
var $e68ba20b3d2d159d$var$xi, $e68ba20b3d2d159d$var$M4, $e68ba20b3d2d159d$var$k4, $e68ba20b3d2d159d$var$P4, $e68ba20b3d2d159d$var$sT, $e68ba20b3d2d159d$var$L4, $e68ba20b3d2d159d$var$lT, $e68ba20b3d2d159d$var$D4, $e68ba20b3d2d159d$var$_4, $e68ba20b3d2d159d$var$R4, $e68ba20b3d2d159d$var$cT, $e68ba20b3d2d159d$var$bE, $e68ba20b3d2d159d$var$dT, $e68ba20b3d2d159d$var$hd, $e68ba20b3d2d159d$var$bi, $e68ba20b3d2d159d$var$hu, $e68ba20b3d2d159d$var$VG, $e68ba20b3d2d159d$var$yE, $e68ba20b3d2d159d$var$mT, $e68ba20b3d2d159d$var$yl, $e68ba20b3d2d159d$var$gd = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$je();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Zs();
    $e68ba20b3d2d159d$var$gn();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Va();
    $e68ba20b3d2d159d$var$Be();
    $e68ba20b3d2d159d$var$xi = new Map, $e68ba20b3d2d159d$var$M4 = /^(?:http(?:s)?:\/\/)?(?:www\.)?youtu(?:be\.com|\.be)\/(embed\/|watch\?v=|shorts\/|playlist\?list=|embed\/videoseries\?list=)?([a-zA-Z0-9_-]+)(?:\?t=|&t=|\?start=|&start=)?([a-zA-Z0-9_-]+)?[^\s]*$/, $e68ba20b3d2d159d$var$k4 = /^(?:http(?:s)?:\/\/)?(?:(?:w){3}\.)?(?:player\.)?vimeo\.com\/(?:video\/)?([^?\s]+)(?:\?.*)?$/, $e68ba20b3d2d159d$var$P4 = /^https:\/\/(?:www\.)?figma\.com/, $e68ba20b3d2d159d$var$sT = /^https:\/\/gist\.github\.com\/([\w_-]+)\/([\w_-]+)/, $e68ba20b3d2d159d$var$L4 = /^<script[\s\S]*?\ssrc=["'](https:\/\/gist\.github\.com\/.*?)\.js["']/i, $e68ba20b3d2d159d$var$lT = /(?:https?:\/\/)?(?:(?:w){3}\.)?(?:twitter|x)\.com\/[^/]+\/status\/(\d+)/, $e68ba20b3d2d159d$var$D4 = /^<blockquote[\s\S]*?\shref=["'](https?:\/\/(?:twitter|x)\.com\/[^"']*)/i, $e68ba20b3d2d159d$var$_4 = /^https:\/\/(?:www\.)?val\.town\/(v|embed)\/[a-zA-Z_$][0-9a-zA-Z_$]+\.[a-zA-Z_$][0-9a-zA-Z_$]+/, $e68ba20b3d2d159d$var$R4 = /^<(?:iframe|blockquote)[\s\S]*?\s(?:src|href)=["']([^"']*)["'][\s\S]*?>$/i, $e68ba20b3d2d159d$var$cT = /giphy.com\/(?:clips|embed|gifs)\/[a-zA-Z0-9]*?-?([a-zA-Z0-9]+)(?:[^a-zA-Z0-9]|$)/, $e68ba20b3d2d159d$var$bE = new Set([
        "youtube.com",
        "youtu.be",
        "vimeo.com",
        "player.vimeo.com",
        "figma.com",
        "link.excalidraw.com",
        "gist.github.com",
        "twitter.com",
        "x.com",
        "*.simplepdf.eu",
        "stackblitz.com",
        "val.town",
        "giphy.com"
    ]), $e68ba20b3d2d159d$var$dT = new Set([
        "youtube.com",
        "youtu.be",
        "vimeo.com",
        "player.vimeo.com",
        "figma.com",
        "twitter.com",
        "x.com",
        "*.simplepdf.eu",
        "stackblitz.com"
    ]), $e68ba20b3d2d159d$var$hd = (e)=>`<html><body>${e}</body></html>`, $e68ba20b3d2d159d$var$bi = (e)=>{
        if (!e) return null;
        if ($e68ba20b3d2d159d$var$xi.has(e)) return $e68ba20b3d2d159d$var$xi.get(e);
        let t = e, r = $e68ba20b3d2d159d$var$dT.has($e68ba20b3d2d159d$var$yE(e, $e68ba20b3d2d159d$var$dT) || ""), o = "generic", n = {
            w: 560,
            h: 840
        }, i = e.match($e68ba20b3d2d159d$var$M4);
        if (i?.[2]) {
            let c = i[3] ? `&start=${i[3]}` : "", d = e.includes("shorts");
            switch(o = "video", i[1]){
                case "embed/":
                case "watch?v=":
                case "shorts/":
                    e = `https://www.youtube.com/embed/${i[2]}?enablejsapi=1${c}`;
                    break;
                case "playlist?list=":
                case "embed/videoseries?list=":
                    e = `https://www.youtube.com/embed/videoseries?list=${i[2]}&enablejsapi=1${c}`;
                    break;
                default:
                    e = `https://www.youtube.com/embed/${i[2]}?enablejsapi=1${c}`;
                    break;
            }
            return n = d ? {
                w: 315,
                h: 560
            } : {
                w: 560,
                h: 315
            }, $e68ba20b3d2d159d$var$xi.set(t, {
                link: e,
                intrinsicSize: n,
                type: o,
                sandbox: {
                    allowSameOrigin: r
                }
            }), {
                link: e,
                intrinsicSize: n,
                type: o,
                sandbox: {
                    allowSameOrigin: r
                }
            };
        }
        let a = e.match($e68ba20b3d2d159d$var$k4);
        if (a?.[1]) {
            let c = a?.[1], d = /^\d+$/.test(c) ? void 0 : new URIError("Invalid embed link format");
            return o = "video", e = `https://player.vimeo.com/video/${c}?api=1`, n = {
                w: 560,
                h: 315
            }, $e68ba20b3d2d159d$var$xi.set(t, {
                link: e,
                intrinsicSize: n,
                type: o,
                sandbox: {
                    allowSameOrigin: r
                }
            }), {
                link: e,
                intrinsicSize: n,
                type: o,
                error: d,
                sandbox: {
                    allowSameOrigin: r
                }
            };
        }
        if (e.match($e68ba20b3d2d159d$var$P4)) return o = "generic", e = `https://www.figma.com/embed?embed_host=share&url=${encodeURIComponent(e)}`, n = {
            w: 550,
            h: 550
        }, $e68ba20b3d2d159d$var$xi.set(t, {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        }), {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        };
        let l = e.match($e68ba20b3d2d159d$var$_4);
        if (l) return e = l[1] === "embed" ? l[0] : l[0].replace("/v", "/embed"), $e68ba20b3d2d159d$var$xi.set(t, {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        }), {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        };
        if ($e68ba20b3d2d159d$var$lT.test(e)) {
            let c = e.match($e68ba20b3d2d159d$var$lT)[1], d = $e68ba20b3d2d159d$var$ap(`https://twitter.com/x/status/${c}`), m = {
                type: "document",
                srcdoc: (p)=>$e68ba20b3d2d159d$var$hd(`<blockquote class="twitter-tweet" data-dnt="true" data-theme="${p}"><a href="${d}"></a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"><\/script>`),
                intrinsicSize: {
                    w: 480,
                    h: 480
                },
                sandbox: {
                    allowSameOrigin: r
                }
            };
            return $e68ba20b3d2d159d$var$xi.set(t, m), m;
        }
        if ($e68ba20b3d2d159d$var$sT.test(e)) {
            let [, c, d] = e.match($e68ba20b3d2d159d$var$sT), m = $e68ba20b3d2d159d$var$ap(`https://gist.github.com/${c}/${d}`), p = {
                type: "document",
                srcdoc: ()=>$e68ba20b3d2d159d$var$hd(`
          <script src="${m}.js"><\/script>
          <style type="text/css">
            * { margin: 0px; }
            table, .gist { height: 100%; }
            .gist .gist-file { height: calc(100vh - 2px); padding: 0px; display: grid; grid-template-rows: 1fr auto; }
          </style>
        `),
                intrinsicSize: {
                    w: 550,
                    h: 720
                },
                sandbox: {
                    allowSameOrigin: r
                }
            };
            return $e68ba20b3d2d159d$var$xi.set(e, p), p;
        }
        return $e68ba20b3d2d159d$var$xi.set(e, {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        }), {
            link: e,
            intrinsicSize: n,
            type: o,
            sandbox: {
                allowSameOrigin: r
            }
        };
    }, $e68ba20b3d2d159d$var$hu = (e)=>{
        let t;
        $e68ba20b3d2d159d$var$Mo(e) ? t = "IFrame element" : t = !e.link || e?.link === "" ? "Empty Web-Embed" : e.link;
        let r = Math.max(Math.min(e.width / 2, e.width / t.length), e.width / 30), o = $e68ba20b3d2d159d$export$530097e879f93363.Helvetica, n = $e68ba20b3d2d159d$var$ke({
            fontSize: r,
            fontFamily: o
        });
        return $e68ba20b3d2d159d$var$er({
            x: e.x + e.width / 2,
            y: e.y + e.height / 2,
            strokeColor: e.strokeColor !== "transparent" ? e.strokeColor : "black",
            backgroundColor: "transparent",
            fontFamily: o,
            fontSize: r,
            text: $e68ba20b3d2d159d$var$Ro(t, n, e.width - 20),
            textAlign: "center",
            verticalAlign: $e68ba20b3d2d159d$var$Pt.MIDDLE,
            angle: e.angle ?? 0
        });
    }, $e68ba20b3d2d159d$var$VG = $e68ba20b3d2d159d$var$U({
        name: "setEmbeddableAsActiveTool",
        trackEvent: {
            category: "toolbar"
        },
        target: "Tool",
        label: "toolBar.embeddable",
        perform: (e, t, r, o)=>{
            let n = $e68ba20b3d2d159d$var$it(t, {
                type: "embeddable"
            });
            return $e68ba20b3d2d159d$var$ho(o.canvas, {
                ...t,
                activeTool: n
            }), {
                elements: e,
                appState: {
                    ...t,
                    activeTool: $e68ba20b3d2d159d$var$it(t, {
                        type: "embeddable"
                    })
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    }), $e68ba20b3d2d159d$var$yE = (e, t)=>{
        try {
            let { hostname: r } = new URL(e), o = r.replace(/^www\./, "");
            if (t instanceof Set) {
                if ($e68ba20b3d2d159d$var$bE.has(o)) return o;
                let i = o.replace(/^([^.]+)/, "*");
                return $e68ba20b3d2d159d$var$bE.has(i) ? i : null;
            }
            let n = t.replace(/^www\./, "");
            if (o === n) return n;
        } catch  {}
        return null;
    }, $e68ba20b3d2d159d$var$mT = (e)=>{
        let t = e.match($e68ba20b3d2d159d$var$D4);
        if (t && t.length === 2) return t[1];
        let r = e.match($e68ba20b3d2d159d$var$L4);
        if (r && r.length === 2) return r[1];
        if ($e68ba20b3d2d159d$var$cT.test(e)) return `https://giphy.com/embed/${$e68ba20b3d2d159d$var$cT.exec(e)[1]}`;
        let o = e.match($e68ba20b3d2d159d$var$R4);
        return o && o.length === 2 ? o[1] : e;
    }, $e68ba20b3d2d159d$var$yl = (e, t)=>{
        if (!e) return !1;
        if (t != null) {
            if (typeof t == "function") {
                let r = t(e);
                if (typeof r == "boolean") return r;
            } else {
                if (typeof t == "boolean") return t;
                if (t instanceof RegExp) return t.test(e);
                if (Array.isArray(t)) {
                    for (let r of t)if (r instanceof RegExp) {
                        if (e.match(r)) return !0;
                    } else if ($e68ba20b3d2d159d$var$yE(e, r)) return !0;
                    return !1;
                }
            }
        }
        return !!$e68ba20b3d2d159d$var$yE(e, $e68ba20b3d2d159d$var$bE);
    };
});
var $e68ba20b3d2d159d$var$fd, $e68ba20b3d2d159d$var$Ed, $e68ba20b3d2d159d$var$gu, $e68ba20b3d2d159d$var$pT, $e68ba20b3d2d159d$var$uT = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Va();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$gd();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Fn();
    $e68ba20b3d2d159d$var$pn();
    $e68ba20b3d2d159d$var$fd = (e, t, r)=>{
        if (typeof r > "u") return e.draw(t);
        let o = {
            sets: t.sets,
            shape: t.shape,
            options: {
                ...t.options,
                fixedDecimalPlaceDigits: r
            }
        };
        return e.draw(o);
    }, $e68ba20b3d2d159d$var$Ed = (e, t, r, o, n)=>{
        if (!o.enabled || !o.clip) return null;
        let i = $e68ba20b3d2d159d$var$rr(e, n);
        if (i) {
            let a = t.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "g");
            return a.setAttributeNS($e68ba20b3d2d159d$var$Ze, "clip-path", `url(#${i.id})`), r.forEach((s)=>a.appendChild(s)), a;
        }
        return null;
    }, $e68ba20b3d2d159d$var$gu = (e, t, r, o, n, i, a, s)=>{
        let l = {
            x: i,
            y: a
        }, [c, d, m, p] = $e68ba20b3d2d159d$var$ae(e, t), u = (m - c) / 2 - (e.x - c), h = (p - d) / 2 - (e.y - d);
        if ($e68ba20b3d2d159d$var$G(e)) {
            let w = $e68ba20b3d2d159d$var$bt(e, t);
            if ($e68ba20b3d2d159d$var$ie(w)) {
                let [I, M, C, P] = $e68ba20b3d2d159d$var$ae(w, t), k = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(w, e, t);
                u = (C - I) / 2 - (k.x - I), h = (P - M) / 2 - (k.y - M), i = i + k.x - e.x, a = a + k.y - e.y;
            }
        }
        let g = 180 * e.angle / Math.PI, b = o;
        if (e.link) {
            let w = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "a");
            w.setAttribute("href", $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e.link)), b.appendChild(w), b = w;
        }
        let v = (w, I)=>{
            $e68ba20b3d2d159d$var$Zr() && w.setAttribute("data-id", I.id), b.appendChild(w);
        }, y = ($e68ba20b3d2d159d$var$rr(e, t)?.opacity ?? 100) * e.opacity / 1e4;
        switch(e.type){
            case "selection":
                throw new Error("Selection rendering is not supported for SVG");
            case "rectangle":
            case "diamond":
            case "ellipse":
                {
                    let w = $e68ba20b3d2d159d$var$Oe.generateElementShape(e, null), I = $e68ba20b3d2d159d$var$fd(r, w, $e68ba20b3d2d159d$var$Ys);
                    y !== 1 && (I.setAttribute("stroke-opacity", `${y}`), I.setAttribute("fill-opacity", `${y}`)), I.setAttribute("stroke-linecap", "round"), I.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`);
                    let M = $e68ba20b3d2d159d$var$Ed(e, b, [
                        I
                    ], s.frameRendering, t);
                    v(M || I, e);
                    break;
                }
            case "iframe":
            case "embeddable":
                {
                    let w = $e68ba20b3d2d159d$var$Oe.generateElementShape(e, s), I = $e68ba20b3d2d159d$var$fd(r, w, $e68ba20b3d2d159d$var$Ys), M = e.opacity / 100;
                    M !== 1 && (I.setAttribute("stroke-opacity", `${M}`), I.setAttribute("fill-opacity", `${M}`)), I.setAttribute("stroke-linecap", "round"), I.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`), v(I, e);
                    let C = $e68ba20b3d2d159d$var$hu(e);
                    $e68ba20b3d2d159d$var$gu(C, t, r, b, n, C.x + l.x - e.x, C.y + l.y - e.y, s);
                    let P = $e68ba20b3d2d159d$var$fd(r, w, $e68ba20b3d2d159d$var$Ys);
                    for(P.setAttribute("stroke-linecap", "round"), P.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`); P.firstChild;)P.removeChild(P.firstChild);
                    let k = $e68ba20b3d2d159d$var$xo(Math.min(e.width, e.height), e), _ = $e68ba20b3d2d159d$var$bi($e68ba20b3d2d159d$var$lp(e.link || ""));
                    if (s.renderEmbeddables === !1 || _?.type === "document") {
                        let A = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "a");
                        A.setAttribute("href", $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e.link || "")), A.setAttribute("target", "_blank"), A.setAttribute("rel", "noopener noreferrer"), A.style.borderRadius = `${k}px`, P.appendChild(A);
                    } else {
                        let A = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "foreignObject");
                        A.style.width = `${e.width}px`, A.style.height = `${e.height}px`, A.style.border = "none";
                        let R = A.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "div");
                        R.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), R.style.width = "100%", R.style.height = "100%";
                        let B = R.ownerDocument.createElement("iframe");
                        B.src = _?.link ?? "", B.style.width = "100%", B.style.height = "100%", B.style.border = "none", B.style.borderRadius = `${k}px`, B.style.top = "0", B.style.left = "0", B.allowFullscreen = !0, R.appendChild(B), A.appendChild(R), P.appendChild(A);
                    }
                    v(P, e);
                    break;
                }
            case "line":
            case "arrow":
                {
                    let w = $e68ba20b3d2d159d$var$te(e, t), I = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "mask");
                    if (w) {
                        I.setAttribute("id", `mask-${e.id}`);
                        let k = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "rect");
                        i = i || 0, a = a || 0, k.setAttribute("x", "0"), k.setAttribute("y", "0"), k.setAttribute("fill", "#fff"), k.setAttribute("width", `${e.width + 100 + i}`), k.setAttribute("height", `${e.height + 100 + a}`), I.appendChild(k);
                        let _ = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "rect"), A = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(e, w, t), R = i + A.x - e.x, B = a + A.y - e.y;
                        _.setAttribute("x", R.toString()), _.setAttribute("y", B.toString()), _.setAttribute("fill", "#000"), _.setAttribute("width", `${w.width}`), _.setAttribute("height", `${w.height}`), _.setAttribute("opacity", "1"), I.appendChild(_);
                    }
                    let M = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "g");
                    w && M.setAttribute("mask", `url(#mask-${e.id})`), M.setAttribute("stroke-linecap", "round"), $e68ba20b3d2d159d$var$Oe.generateElementShape(e, s).forEach((k)=>{
                        let _ = $e68ba20b3d2d159d$var$fd(r, k, $e68ba20b3d2d159d$var$Ys);
                        y !== 1 && (_.setAttribute("stroke-opacity", `${y}`), _.setAttribute("fill-opacity", `${y}`)), _.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`), e.type === "line" && $e68ba20b3d2d159d$var$Br(e.points) && e.backgroundColor !== "transparent" && _.setAttribute("fill-rule", "evenodd"), M.appendChild(_);
                    });
                    let P = $e68ba20b3d2d159d$var$Ed(e, b, [
                        M,
                        I
                    ], s.frameRendering, t);
                    P ? (v(P, e), b.appendChild(P)) : (v(M, e), b.append(I));
                    break;
                }
            case "freedraw":
                {
                    let w = $e68ba20b3d2d159d$var$Oe.generateElementShape(e, s), I = w ? $e68ba20b3d2d159d$var$fd(r, w, $e68ba20b3d2d159d$var$Ys) : o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "g");
                    y !== 1 && (I.setAttribute("stroke-opacity", `${y}`), I.setAttribute("fill-opacity", `${y}`)), I.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`), I.setAttribute("stroke", "none");
                    let M = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "path");
                    M.setAttribute("fill", e.strokeColor), M.setAttribute("d", $e68ba20b3d2d159d$export$4391385250dacbf7(e)), I.appendChild(M);
                    let C = $e68ba20b3d2d159d$var$Ed(e, b, [
                        I
                    ], s.frameRendering, t);
                    v(C || I, e);
                    break;
                }
            case "image":
                {
                    let w = Math.round(e.width), I = Math.round(e.height), M = $e68ba20b3d2d159d$var$Nr(e) && n[e.fileId];
                    if (M) {
                        let C = `image-${M.id}`, P = o.querySelector(`#${C}`);
                        if (!P) {
                            P = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "symbol"), P.id = C;
                            let R = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "image");
                            R.setAttribute("width", "100%"), R.setAttribute("height", "100%"), R.setAttribute("href", M.dataURL), P.appendChild(R), b.prepend(P);
                        }
                        let k = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "use");
                        if (k.setAttribute("href", `#${C}`), s.exportWithDarkMode && M.mimeType !== $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg && k.setAttribute("filter", $e68ba20b3d2d159d$var$wE), k.setAttribute("width", `${w}`), k.setAttribute("height", `${I}`), k.setAttribute("opacity", `${y}`), e.scale[0] !== 1 || e.scale[1] !== 1) {
                            let R = e.scale[0] !== 1 ? -w : 0, B = e.scale[1] !== 1 ? -I : 0;
                            k.setAttribute("transform", `scale(${e.scale[0]}, ${e.scale[1]}) translate(${R} ${B})`);
                        }
                        let _ = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "g");
                        if (_.appendChild(k), _.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`), e.roundness) {
                            let R = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "clipPath");
                            R.id = `image-clipPath-${e.id}`;
                            let B = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "rect"), V = $e68ba20b3d2d159d$var$xo(Math.min(e.width, e.height), e);
                            B.setAttribute("width", `${e.width}`), B.setAttribute("height", `${e.height}`), B.setAttribute("rx", `${V}`), B.setAttribute("ry", `${V}`), R.appendChild(B), v(R, e), _.setAttributeNS($e68ba20b3d2d159d$var$Ze, "clip-path", `url(#${R.id})`);
                        }
                        let A = $e68ba20b3d2d159d$var$Ed(e, b, [
                            _
                        ], s.frameRendering, t);
                        v(A || _, e);
                    }
                    break;
                }
            case "frame":
            case "magicframe":
                if (s.frameRendering.enabled && s.frameRendering.outline) {
                    let w = document.createElementNS($e68ba20b3d2d159d$var$Ze, "rect");
                    w.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`), w.setAttribute("width", `${e.width}px`), w.setAttribute("height", `${e.height}px`), w.setAttribute("rx", $e68ba20b3d2d159d$var$ot.radius.toString()), w.setAttribute("ry", $e68ba20b3d2d159d$var$ot.radius.toString()), w.setAttribute("fill", "none"), w.setAttribute("stroke", $e68ba20b3d2d159d$var$ot.strokeColor), w.setAttribute("stroke-width", $e68ba20b3d2d159d$var$ot.strokeWidth.toString()), v(w, e);
                }
                break;
            default:
                if ($e68ba20b3d2d159d$var$G(e)) {
                    let w = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "g");
                    y !== 1 && (w.setAttribute("stroke-opacity", `${y}`), w.setAttribute("fill-opacity", `${y}`)), w.setAttribute("transform", `translate(${i || 0} ${a || 0}) rotate(${g} ${u} ${h})`);
                    let I = e.text.replace(/\r\n?/g, `
`).split(`
`), M = $e68ba20b3d2d159d$var$oa(e.fontSize, e.lineHeight), C = e.textAlign === "center" ? e.width / 2 : e.textAlign === "right" ? e.width : 0, P = $e68ba20b3d2d159d$var$au(e.fontFamily, e.fontSize, M), k = $e68ba20b3d2d159d$var$Km(e.text) ? "rtl" : "ltr", _ = e.textAlign === "center" ? "middle" : e.textAlign === "right" || k === "rtl" ? "end" : "start";
                    for(let R = 0; R < I.length; R++){
                        let B = o.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "text");
                        B.textContent = I[R], B.setAttribute("x", `${C}`), B.setAttribute("y", `${R * M + P}`), B.setAttribute("font-family", $e68ba20b3d2d159d$var$kn(e)), B.setAttribute("font-size", `${e.fontSize}px`), B.setAttribute("fill", e.strokeColor), B.setAttribute("text-anchor", _), B.setAttribute("style", "white-space: pre;"), B.setAttribute("direction", k), B.setAttribute("dominant-baseline", "alphabetic"), w.appendChild(B);
                    }
                    let A = $e68ba20b3d2d159d$var$Ed(e, b, [
                        w
                    ], s.frameRendering, t);
                    v(A || w, e);
                } else throw new Error(`Unimplemented type ${e.type}`);
        }
    }, $e68ba20b3d2d159d$var$pT = (e, t, r, o, n, i)=>{
        o && (e.filter((a)=>!$e68ba20b3d2d159d$var$cr(a)).forEach((a)=>{
            if (!a.isDeleted) {
                if ($e68ba20b3d2d159d$var$G(a) && a.containerId && t.has(a.containerId)) return;
                try {
                    $e68ba20b3d2d159d$var$gu(a, t, r, o, n, a.x + i.offsetX, a.y + i.offsetY, i);
                    let s = $e68ba20b3d2d159d$var$te(a, t);
                    s && $e68ba20b3d2d159d$var$gu(s, t, r, o, n, s.x + i.offsetX, s.y + i.offsetY, i);
                } catch (s) {
                    console.error(s);
                }
            }
        }), e.filter((a)=>$e68ba20b3d2d159d$var$cr(a)).forEach((a)=>{
            if (!a.isDeleted) try {
                $e68ba20b3d2d159d$var$gu(a, t, r, o, n, a.x + i.offsetX, a.y + i.offsetY, i);
            } catch (s) {
                console.error(s);
            }
        }));
    };
});
var $e68ba20b3d2d159d$var$vE, $e68ba20b3d2d159d$var$Eu, $e68ba20b3d2d159d$var$xu, $e68ba20b3d2d159d$var$N4, $e68ba20b3d2d159d$var$hT, $e68ba20b3d2d159d$var$TE = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$vE = (e)=>new Promise((t, r)=>{
            let o = new Image;
            o.onload = ()=>{
                t(o);
            }, o.onerror = (n)=>{
                r(n);
            }, o.src = e;
        }), $e68ba20b3d2d159d$var$Eu = async ({ fileIds: e, files: t, imageCache: r })=>{
        let o = new Map, n = new Map;
        return await Promise.all(e.reduce((i, a)=>{
            let s = t[a];
            return s && !o.has(a) ? (o.set(a, !0), i.concat((async ()=>{
                try {
                    if (s.mimeType === $e68ba20b3d2d159d$export$edfb5d7e4280f611.binary) throw new Error("Only images can be added to ImageCache");
                    let l = $e68ba20b3d2d159d$var$vE(s.dataURL), c = {
                        image: l,
                        mimeType: s.mimeType
                    };
                    r.set(a, c);
                    let d = await l;
                    r.set(a, {
                        ...c,
                        image: d
                    });
                } catch  {
                    n.set(a, !0);
                }
            })())) : i;
        }, [])), {
            imageCache: r,
            updatedFiles: o,
            erroredFiles: n
        };
    }, $e68ba20b3d2d159d$var$xu = (e)=>e.filter((t)=>$e68ba20b3d2d159d$var$Nr(t)), $e68ba20b3d2d159d$var$N4 = (e)=>e?.nodeName.toLowerCase() === "svg", $e68ba20b3d2d159d$var$hT = async (e)=>{
        let t = new DOMParser().parseFromString(e, $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg), r = t.querySelector("svg");
        if (t.querySelector("parsererror") || !$e68ba20b3d2d159d$var$N4(r)) throw new Error("Invalid SVG");
        if (r.hasAttribute("xmlns") || r.setAttribute("xmlns", $e68ba20b3d2d159d$var$Ze), !r.hasAttribute("width") || !r.hasAttribute("height")) {
            let n = r.getAttribute("viewBox"), i = r.getAttribute("width") || "50", a = r.getAttribute("height") || "50";
            if (n) {
                let s = n.match(/\d+ +\d+ +(\d+) +(\d+)/);
                s && ([, i, a] = s);
            }
            r.setAttribute("width", i), r.setAttribute("height", a);
        }
        return r.outerHTML;
    };
});
var $e68ba20b3d2d159d$var$SE, $e68ba20b3d2d159d$var$xd, $e68ba20b3d2d159d$var$IE, $e68ba20b3d2d159d$var$bu, $e68ba20b3d2d159d$var$yu = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Xc();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$Fn();
    $e68ba20b3d2d159d$var$SE = document.createElement("img");
    $e68ba20b3d2d159d$var$SE.src = `data:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.svg}, ${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1971c2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>')}`;
    $e68ba20b3d2d159d$var$xd = ([e, t, r, o], n, i)=>{
        let a = $e68ba20b3d2d159d$var$gT, s = a / i.zoom.value, l = a / i.zoom.value, c = a / i.zoom.value, d = (e + r) / 2, m = (t + o) / 2, p = (a - 8) / (2 * i.zoom.value), u = 4 / i.zoom.value, h = r + u - p, g = t - u - c + p, [b, v] = $e68ba20b3d2d159d$var$Ee(h + s / 2, g + l / 2, d, m, n);
        return [
            b - s / 2,
            v - l / 2,
            s,
            l
        ];
    }, $e68ba20b3d2d159d$var$IE = (e, t, r, [o, n])=>{
        let i = 4 / r.zoom.value, [a, s, l, c] = $e68ba20b3d2d159d$var$ae(e, t), [d, m, p, u] = $e68ba20b3d2d159d$var$xd([
            a,
            s,
            l,
            c
        ], e.angle, r);
        return o > d - i && o < d + i + p && n > m - i && n < m + u + i;
    }, $e68ba20b3d2d159d$var$bu = (e, t, r, [o, n], i)=>!e.link || r.selectedElementIds[e.id] ? !1 : !i && r.viewModeEnabled && $e68ba20b3d2d159d$var$Yc(o, n, e, t) ? !0 : $e68ba20b3d2d159d$var$IE(e, t, r, [
            o,
            n
        ]);
});
var $e68ba20b3d2d159d$var$bd, $e68ba20b3d2d159d$var$wl, $e68ba20b3d2d159d$var$vl, $e68ba20b3d2d159d$var$wu = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$bd = (e, t, r, o, n = !0)=>{
        e.beginPath(), e.arc(t, r, o, 0, Math.PI * 2), e.fill(), n && e.stroke();
    }, $e68ba20b3d2d159d$var$wl = (e, t)=>[
            e.width / t,
            e.height / t
        ], $e68ba20b3d2d159d$var$vl = ({ canvas: e, scale: t, normalizedWidth: r, normalizedHeight: o, theme: n, isExporting: i, viewBackgroundColor: a })=>{
        let s = e.getContext("2d");
        return s.setTransform(1, 0, 0, 1, 0, 0), s.scale(t, t), i && n === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK && (s.filter = $e68ba20b3d2d159d$var$Vs), typeof a == "string" ? ((a === "transparent" || a.length === 5 || a.length === 9 || /(hsla|rgba)\(/.test(a)) && s.clearRect(0, 0, r, o), s.save(), s.fillStyle = a, s.fillRect(0, 0, r, o), s.restore()) : s.clearRect(0, 0, r, o), s;
    };
});
var $e68ba20b3d2d159d$var$vu, $e68ba20b3d2d159d$var$O4, $e68ba20b3d2d159d$var$fT, $e68ba20b3d2d159d$var$yi, $e68ba20b3d2d159d$var$ET, $e68ba20b3d2d159d$var$xT, $e68ba20b3d2d159d$var$CE, $e68ba20b3d2d159d$var$Su, $e68ba20b3d2d159d$var$Iu = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Fn();
    $e68ba20b3d2d159d$var$gd();
    $e68ba20b3d2d159d$var$yu();
    $e68ba20b3d2d159d$var$wu();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$vu = {
        Bold: "#dddddd",
        Regular: "#e5e5e5"
    }, $e68ba20b3d2d159d$var$O4 = (e, t, r, o, n, i, a, s)=>{
        let l = o % t - t, c = n % t - t, d = t * i.value, m = 1 / i.value;
        e.save(), i.value === 1 && e.translate(l % 1 ? 0 : .5, c % 1 ? 0 : .5);
        for(let p = l; p < l + a + t * 2; p += t){
            let u = r > 1 && Math.round(p - o) % (r * t) === 0;
            if (!u && d < 10) continue;
            let h = Math.min(1 / i.value, u ? 4 : 1);
            e.lineWidth = h;
            let g = [
                h * 3,
                m + (h + m)
            ];
            e.beginPath(), e.setLineDash(u ? [] : g), e.strokeStyle = u ? $e68ba20b3d2d159d$var$vu.Bold : $e68ba20b3d2d159d$var$vu.Regular, e.moveTo(p, c - t), e.lineTo(p, Math.ceil(c + s + t * 2)), e.stroke();
        }
        for(let p = c; p < c + s + t * 2; p += t){
            let u = r > 1 && Math.round(p - n) % (r * t) === 0;
            if (!u && d < 10) continue;
            let h = Math.min(1 / i.value, u ? 4 : 1);
            e.lineWidth = h;
            let g = [
                h * 3,
                m + (h + m)
            ];
            e.beginPath(), e.setLineDash(u ? [] : g), e.strokeStyle = u ? $e68ba20b3d2d159d$var$vu.Bold : $e68ba20b3d2d159d$var$vu.Regular, e.moveTo(l - t, p), e.lineTo(Math.ceil(l + a + t * 2), p), e.stroke();
        }
        e.restore();
    }, $e68ba20b3d2d159d$var$fT = (e, t, r, o)=>{
        t.translate(e.x + o.scrollX, e.y + o.scrollY), t.beginPath(), t.roundRect ? t.roundRect(0, 0, e.width, e.height, $e68ba20b3d2d159d$var$ot.radius / o.zoom.value) : t.rect(0, 0, e.width, e.height), t.clip(), t.translate(-(e.x + o.scrollX), -(e.y + o.scrollY));
    }, $e68ba20b3d2d159d$var$ET = (e, t, r, o)=>{
        if (e.link && !r.selectedElementIds[e.id]) {
            let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(e, o), [l, c, d, m] = $e68ba20b3d2d159d$var$xd([
                n,
                i,
                a,
                s
            ], e.angle, r), p = l + d / 2, u = c + m / 2;
            if (t.save(), t.translate(r.scrollX + p, r.scrollY + u), t.rotate(e.angle), !$e68ba20b3d2d159d$var$yi || $e68ba20b3d2d159d$var$yi.zoom !== r.zoom.value) {
                $e68ba20b3d2d159d$var$yi = document.createElement("canvas"), $e68ba20b3d2d159d$var$yi.zoom = r.zoom.value, $e68ba20b3d2d159d$var$yi.width = d * window.devicePixelRatio * r.zoom.value, $e68ba20b3d2d159d$var$yi.height = m * window.devicePixelRatio * r.zoom.value;
                let h = $e68ba20b3d2d159d$var$yi.getContext("2d");
                h.scale(window.devicePixelRatio * r.zoom.value, window.devicePixelRatio * r.zoom.value), h.fillStyle = "#fff", h.fillRect(0, 0, d, m), h.drawImage($e68ba20b3d2d159d$var$SE, 0, 0, d, m), h.restore(), t.drawImage($e68ba20b3d2d159d$var$yi, l - p, c - u, d, m);
            } else t.drawImage($e68ba20b3d2d159d$var$yi, l - p, c - u, d, m);
            t.restore();
        }
    }, $e68ba20b3d2d159d$var$xT = ({ canvas: e, rc: t, elementsMap: r, allElementsMap: o, visibleElements: n, scale: i, appState: a, renderConfig: s })=>{
        if (e === null) return;
        let { renderGrid: l = !0, isExporting: c } = s, [d, m] = $e68ba20b3d2d159d$var$wl(e, i), p = $e68ba20b3d2d159d$var$vl({
            canvas: e,
            scale: i,
            normalizedWidth: d,
            normalizedHeight: m,
            theme: a.theme,
            isExporting: c,
            viewBackgroundColor: a.viewBackgroundColor
        });
        p.scale(a.zoom.value, a.zoom.value), l && $e68ba20b3d2d159d$var$O4(p, a.gridSize, a.gridStep, a.scrollX, a.scrollY, a.zoom, d / a.zoom.value, m / a.zoom.value);
        let u = new Set;
        n.forEach((h)=>{
            h.groupIds.length > 0 && a.frameToHighlight && a.selectedElementIds[h.id] && ($e68ba20b3d2d159d$var$No(h, a.frameToHighlight, r) || h.groupIds.find((g)=>u.has(g))) && h.groupIds.forEach((g)=>u.add(g));
        }), n.filter((h)=>!$e68ba20b3d2d159d$var$cr(h)).forEach((h)=>{
            try {
                let g = h.frameId || a.frameToHighlight?.id;
                if ($e68ba20b3d2d159d$var$G(h) && h.containerId && r.has(h.containerId)) return;
                if (p.save(), g && a.frameRendering.enabled && a.frameRendering.clip) {
                    let v = $e68ba20b3d2d159d$var$Tu(h, r, a);
                    v && $e68ba20b3d2d159d$var$ms(h, r, a) && $e68ba20b3d2d159d$var$fT(v, p, s, a), $e68ba20b3d2d159d$var$wi(h, r, o, t, p, s, a);
                } else $e68ba20b3d2d159d$var$wi(h, r, o, t, p, s, a);
                let b = $e68ba20b3d2d159d$var$te(h, r);
                b && $e68ba20b3d2d159d$var$wi(b, r, o, t, p, s, a), p.restore(), c || $e68ba20b3d2d159d$var$ET(h, p, a, r);
            } catch (g) {
                console.error(g);
            }
        }), n.filter((h)=>$e68ba20b3d2d159d$var$cr(h)).forEach((h)=>{
            try {
                let g = ()=>{
                    if ($e68ba20b3d2d159d$var$wi(h, r, o, t, p, s, a), $e68ba20b3d2d159d$var$cr(h) && (c || $e68ba20b3d2d159d$var$Rt(h) && s.embedsValidationStatus.get(h.id) !== !0) && h.width && h.height) {
                        let v = $e68ba20b3d2d159d$var$hu(h);
                        $e68ba20b3d2d159d$var$wi(v, r, o, t, p, s, a);
                    }
                    c || $e68ba20b3d2d159d$var$ET(h, p, a, r);
                };
                if ((h.frameId || a.frameToHighlight?.id) && a.frameRendering.enabled && a.frameRendering.clip) {
                    p.save();
                    let v = $e68ba20b3d2d159d$var$Tu(h, r, a);
                    v && $e68ba20b3d2d159d$var$ms(h, r, a) && $e68ba20b3d2d159d$var$fT(v, p, s, a), g(), p.restore();
                } else g();
            } catch (g) {
                console.error(g);
            }
        }), s.pendingFlowchartNodes?.forEach((h)=>{
            try {
                $e68ba20b3d2d159d$var$wi(h, r, o, t, p, s, a);
            } catch (g) {
                console.error(g);
            }
        });
    }, $e68ba20b3d2d159d$var$CE = $e68ba20b3d2d159d$var$Hi((e)=>{
        $e68ba20b3d2d159d$var$xT(e);
    }, {
        trailing: !0
    }), $e68ba20b3d2d159d$var$Su = (e, t)=>{
        if (t) {
            $e68ba20b3d2d159d$var$CE(e);
            return;
        }
        $e68ba20b3d2d159d$var$xT(e);
    };
});
var $e68ba20b3d2d159d$var$F4, $e68ba20b3d2d159d$var$B4, $e68ba20b3d2d159d$var$z4, $e68ba20b3d2d159d$var$yT, $e68ba20b3d2d159d$var$wT, $e68ba20b3d2d159d$var$Cu, $e68ba20b3d2d159d$var$Tl, $e68ba20b3d2d159d$var$AE, $e68ba20b3d2d159d$var$vT;

var $e68ba20b3d2d159d$var$yd = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$uT();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$pi();
    $e68ba20b3d2d159d$var$TE();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Do();
    $e68ba20b3d2d159d$var$Iu();
    $e68ba20b3d2d159d$var$pn();
    $e68ba20b3d2d159d$var$F4 = "<!-- svg-source:excalidraw -->", $e68ba20b3d2d159d$var$B4 = (e, t)=>{
        if (e.width <= t) return e;
        let o = document.createElement("canvas").getContext("2d");
        o.font = $e68ba20b3d2d159d$var$ke({
            fontFamily: e.fontFamily,
            fontSize: e.fontSize
        });
        let n = e.text;
        if (o.measureText(n).width > t) for(let a = n.length; a > 0; a--){
            let s = `${n.slice(0, a)}...`;
            if (o.measureText(s).width <= t) {
                n = s;
                break;
            }
        }
        return $e68ba20b3d2d159d$export$5390fab1c98104d7(e, {
            text: n,
            width: t
        });
    }, $e68ba20b3d2d159d$var$z4 = (e, t)=>{
        let r = [];
        for (let o of e){
            if ($e68ba20b3d2d159d$var$re(o)) {
                let n = $e68ba20b3d2d159d$var$er({
                    x: o.x,
                    y: o.y - $e68ba20b3d2d159d$var$ot.nameOffsetY,
                    fontFamily: $e68ba20b3d2d159d$export$530097e879f93363.Helvetica,
                    fontSize: $e68ba20b3d2d159d$var$ot.nameFontSize,
                    lineHeight: $e68ba20b3d2d159d$var$ot.nameLineHeight,
                    strokeColor: t.exportWithDarkMode ? $e68ba20b3d2d159d$var$ot.nameColorDarkTheme : $e68ba20b3d2d159d$var$ot.nameColorLightTheme,
                    text: $e68ba20b3d2d159d$var$Au(o)
                });
                n.y -= n.height, n = $e68ba20b3d2d159d$var$B4(n, o.width), r.push(n);
            }
            r.push(o);
        }
        return r;
    }, $e68ba20b3d2d159d$var$yT = (e, t)=>(t = t || $e68ba20b3d2d159d$var$dr().frameRendering, {
            enabled: e ? !0 : t.enabled,
            outline: e ? !1 : t.outline,
            name: e ? !1 : t.name,
            clip: e ? !0 : t.clip
        }), $e68ba20b3d2d159d$var$wT = ({ elements: e, exportingFrame: t, frameRendering: r, exportWithDarkMode: o })=>{
        let n;
        return t ? n = $e68ba20b3d2d159d$var$Sl(e, t) : r.enabled && r.name ? n = $e68ba20b3d2d159d$var$z4(e, {
            exportWithDarkMode: o
        }) : n = e, n;
    }, $e68ba20b3d2d159d$var$Cu = async (e, t, r, { exportBackground: o, exportPadding: n = $e68ba20b3d2d159d$var$$o, viewBackgroundColor: i, exportingFrame: a }, s = (c, d)=>{
        let m = document.createElement("canvas");
        return m.width = c * t.exportScale, m.height = d * t.exportScale, {
            canvas: m,
            scale: t.exportScale
        };
    }, l = async ()=>{
        await $e68ba20b3d2d159d$var$zr.loadFontsForElements(e);
    })=>{
        await l();
        let c = $e68ba20b3d2d159d$var$yT(a ?? null, t.frameRendering ?? null), d = $e68ba20b3d2d159d$var$wT({
            elements: e,
            exportingFrame: a,
            exportWithDarkMode: t.exportWithDarkMode,
            frameRendering: c
        });
        a && (n = 0);
        let [m, p, u, h] = $e68ba20b3d2d159d$var$AE(a ? [
            a
        ] : $e68ba20b3d2d159d$var$ME(d), n), { canvas: g, scale: b = 1 } = s(u, h), v = $e68ba20b3d2d159d$var$dr(), { imageCache: y } = await $e68ba20b3d2d159d$var$Eu({
            imageCache: new Map,
            fileIds: $e68ba20b3d2d159d$var$xu(d).map((w)=>w.fileId),
            files: r
        });
        return $e68ba20b3d2d159d$var$Su({
            canvas: g,
            rc: (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).canvas(g),
            elementsMap: $e68ba20b3d2d159d$var$lr($e68ba20b3d2d159d$var$j(d)),
            allElementsMap: $e68ba20b3d2d159d$var$lr($e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$Cr(e))),
            visibleElements: d,
            scale: b,
            appState: {
                ...t,
                frameRendering: c,
                viewBackgroundColor: o ? i : null,
                scrollX: -m + n,
                scrollY: -p + n,
                zoom: v.zoom,
                shouldCacheIgnoreZoom: !1,
                theme: t.exportWithDarkMode ? $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK : $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT
            },
            renderConfig: {
                canvasBackgroundColor: i,
                imageCache: y,
                renderGrid: !1,
                isExporting: !0,
                embedsValidationStatus: new Map,
                elementsPendingErasure: new Set,
                pendingFlowchartNodes: null
            }
        }), g;
    }, $e68ba20b3d2d159d$var$Tl = async (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$yT(o?.exportingFrame ?? null, t.frameRendering ?? null), { exportPadding: i = $e68ba20b3d2d159d$var$$o, exportWithDarkMode: a = !1, viewBackgroundColor: s, exportScale: l = 1, exportEmbedScene: c } = t, { exportingFrame: d = null } = o || {}, m = $e68ba20b3d2d159d$var$wT({
            elements: e,
            exportingFrame: d,
            exportWithDarkMode: a,
            frameRendering: n
        });
        d && (i = 0);
        let p = "";
        if (c) try {
            p = await (await Promise.resolve().then(function() {
                return (parcelRequire("44DGG"));
            }).then((res)=>($e68ba20b3d2d159d$var$bl(), $e68ba20b3d2d159d$var$nd))).encodeSvgMetadata({
                text: $e68ba20b3d2d159d$export$b502122c5be20fdd(e, t, r || {}, "local")
            });
        } catch (R) {
            console.error(R);
        }
        let [u, h, g, b] = $e68ba20b3d2d159d$var$AE(d ? [
            d
        ] : $e68ba20b3d2d159d$var$ME(m), i), v = document.createElementNS($e68ba20b3d2d159d$var$Ze, "svg");
        v.setAttribute("version", "1.1"), v.setAttribute("xmlns", $e68ba20b3d2d159d$var$Ze), v.setAttribute("viewBox", `0 0 ${g} ${b}`), v.setAttribute("width", `${g * l}`), v.setAttribute("height", `${b * l}`), a && v.setAttribute("filter", $e68ba20b3d2d159d$var$Vs);
        let y = -u + i, w = -h + i, I = $e68ba20b3d2d159d$var$wd(e), M = "", C = $e68ba20b3d2d159d$var$j(e);
        for (let R of I){
            let [B, V, ee, N] = $e68ba20b3d2d159d$var$ae(R, C), H = (ee - B) / 2 - (R.x - B), xe = (N - V) / 2 - (R.y - V);
            M += `<clipPath id=${R.id}>
            <rect transform="translate(${R.x + y} ${R.y + w}) rotate(${R.angle} ${H} ${xe})"
          width="${R.width}"
          height="${R.height}"
          >
          </rect>
        </clipPath>`;
        }
        let P = e.reduce((R, B)=>($e68ba20b3d2d159d$var$G(B) && R.add(B.fontFamily), R), new Set), k = o?.skipInliningFonts ? [] : await Promise.all(Array.from(P).map(async (R)=>{
            let { fonts: B, metadata: V } = $e68ba20b3d2d159d$var$zr.registered.get(R) ?? {};
            if (!Array.isArray(B)) {
                console.error(`Couldn't find registered fonts for font-family "${R}"`, $e68ba20b3d2d159d$var$zr.registered);
                return;
            }
            if (!V?.local) return Promise.all(B.map(async (ee)=>`@font-face {
        font-family: ${ee.fontFace.family};
        src: url(${await ee.getContent()});
          }`));
        }));
        if (v.innerHTML = `
  ${$e68ba20b3d2d159d$var$F4}
  ${p}
  <defs>
    <style class="style-fonts">
      ${k.flat().filter(Boolean).join(`
`)}
    </style>
    ${M}
  </defs>
  `, t.exportBackground && s) {
            let R = v.ownerDocument.createElementNS($e68ba20b3d2d159d$var$Ze, "rect");
            R.setAttribute("x", "0"), R.setAttribute("y", "0"), R.setAttribute("width", `${g}`), R.setAttribute("height", `${b}`), R.setAttribute("fill", s), v.appendChild(R);
        }
        let _ = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).svg(v), A = o?.renderEmbeddables ?? !1;
        return $e68ba20b3d2d159d$var$pT(m, $e68ba20b3d2d159d$var$lr($e68ba20b3d2d159d$var$j(m)), _, v, r || {}, {
            offsetX: y,
            offsetY: w,
            isExporting: !0,
            exportWithDarkMode: a,
            renderEmbeddables: A,
            frameRendering: n,
            canvasBackgroundColor: s,
            embedsValidationStatus: A ? new Map(m.filter((R)=>$e68ba20b3d2d159d$var$re(R)).map((R)=>[
                    R.id,
                    !0
                ])) : new Map
        }), v;
    }, $e68ba20b3d2d159d$var$AE = (e, t)=>{
        let [r, o, n, i] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e), a = $e68ba20b3d2d159d$var$Wt(r, n) + t * 2, s = $e68ba20b3d2d159d$var$Wt(o, i) + t * 2;
        return [
            r,
            o,
            a,
            s
        ];
    }, $e68ba20b3d2d159d$var$vT = (e, t, r)=>{
        let [, , o, n] = $e68ba20b3d2d159d$var$AE(e, t).map((i)=>Math.trunc(i * r));
        return [
            o,
            n
        ];
    };
});
var $e68ba20b3d2d159d$var$En, $e68ba20b3d2d159d$var$lt, $e68ba20b3d2d159d$var$na, $e68ba20b3d2d159d$var$ST, $e68ba20b3d2d159d$var$ps, $e68ba20b3d2d159d$var$Il, $e68ba20b3d2d159d$var$vd, $e68ba20b3d2d159d$var$kE, $e68ba20b3d2d159d$var$TT, $e68ba20b3d2d159d$var$H4, $e68ba20b3d2d159d$var$IT, $e68ba20b3d2d159d$var$Mu, $e68ba20b3d2d159d$var$Oo, $e68ba20b3d2d159d$var$CT, $e68ba20b3d2d159d$var$U4, $e68ba20b3d2d159d$var$G4, $e68ba20b3d2d159d$var$W4, $e68ba20b3d2d159d$var$AT, $e68ba20b3d2d159d$var$V4, $e68ba20b3d2d159d$var$Y4, $e68ba20b3d2d159d$var$MT, $e68ba20b3d2d159d$var$PE = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$yr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$jo();
    $e68ba20b3d2d159d$var$En = 32, $e68ba20b3d2d159d$var$lt = 12, $e68ba20b3d2d159d$var$na = 256, $e68ba20b3d2d159d$var$ST = 50, $e68ba20b3d2d159d$var$ps = "NOT_SPREADSHEET", $e68ba20b3d2d159d$var$Il = "VALID_SPREADSHEET", $e68ba20b3d2d159d$var$vd = (e)=>{
        let t = /^([-+]?)[$€£¥₩]?([-+]?)([\d.,]+)[%]?$/.exec(e);
        return t ? parseFloat(`${(t[1] || t[2]) + t[3]}`.replace(/,/g, "")) : null;
    }, $e68ba20b3d2d159d$var$kE = (e, t)=>e.slice(1).every((r)=>$e68ba20b3d2d159d$var$vd(r[t]) !== null), $e68ba20b3d2d159d$var$TT = (e)=>{
        let t = e[0].length;
        if (t > 2) return {
            type: $e68ba20b3d2d159d$var$ps,
            reason: "More than 2 columns"
        };
        if (t === 1) {
            if (!$e68ba20b3d2d159d$var$kE(e, 0)) return {
                type: $e68ba20b3d2d159d$var$ps,
                reason: "Value is not numeric"
            };
            let l = $e68ba20b3d2d159d$var$vd(e[0][0]) === null, c = (l ? e.slice(1) : e).map((d)=>$e68ba20b3d2d159d$var$vd(d[0]));
            return c.length < 2 ? {
                type: $e68ba20b3d2d159d$var$ps,
                reason: "Less than two rows"
            } : {
                type: $e68ba20b3d2d159d$var$Il,
                spreadsheet: {
                    title: l ? e[0][0] : null,
                    labels: null,
                    values: c
                }
            };
        }
        let r = $e68ba20b3d2d159d$var$kE(e, 0), o = $e68ba20b3d2d159d$var$kE(e, 1);
        if (!r && !o) return {
            type: $e68ba20b3d2d159d$var$ps,
            reason: "Value is not numeric"
        };
        let [n, i] = o ? [
            0,
            1
        ] : [
            1,
            0
        ], a = $e68ba20b3d2d159d$var$vd(e[0][i]) === null, s = a ? e.slice(1) : e;
        return s.length < 2 ? {
            type: $e68ba20b3d2d159d$var$ps,
            reason: "Less than 2 rows"
        } : {
            type: $e68ba20b3d2d159d$var$Il,
            spreadsheet: {
                title: a ? e[0][i] : null,
                labels: s.map((l)=>l[n]),
                values: s.map((l)=>$e68ba20b3d2d159d$var$vd(l[i]))
            }
        };
    }, $e68ba20b3d2d159d$var$H4 = (e)=>{
        let t = [];
        for(let r = 0; r < e[0].length; r++){
            let o = [];
            for(let n = 0; n < e.length; n++)o.push(e[n][r]);
            t.push(o);
        }
        return t;
    }, $e68ba20b3d2d159d$var$IT = (e)=>{
        let t = e.trim().split(`
`).map((i)=>i.trim().split("	"));
        if (t.length && t[0].length !== 2 && (t = e.trim().split(`
`).map((i)=>i.trim().split(","))), t.length === 0) return {
            type: $e68ba20b3d2d159d$var$ps,
            reason: "No values"
        };
        let r = t[0].length;
        if (!t.every((i)=>i.length === r)) return {
            type: $e68ba20b3d2d159d$var$ps,
            reason: "All rows don't have same number of columns"
        };
        let n = $e68ba20b3d2d159d$var$TT(t);
        if (n.type !== $e68ba20b3d2d159d$var$Il) {
            let i = $e68ba20b3d2d159d$var$TT($e68ba20b3d2d159d$var$H4(t));
            if (i.type === $e68ba20b3d2d159d$var$Il) return i;
        }
        return n;
    }, $e68ba20b3d2d159d$var$Mu = $e68ba20b3d2d159d$var$d0($e68ba20b3d2d159d$var$a0), $e68ba20b3d2d159d$var$Oo = {
        fillStyle: "hachure",
        fontFamily: $e68ba20b3d2d159d$var$vr,
        fontSize: $e68ba20b3d2d159d$var$wr,
        opacity: 100,
        roughness: 1,
        strokeColor: $e68ba20b3d2d159d$var$fe.black,
        roundness: null,
        strokeStyle: "solid",
        strokeWidth: 1,
        verticalAlign: $e68ba20b3d2d159d$var$Pt.MIDDLE,
        locked: !1
    }, $e68ba20b3d2d159d$var$CT = (e)=>{
        let t = ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt) * e.values.length + $e68ba20b3d2d159d$var$lt, r = $e68ba20b3d2d159d$var$na + $e68ba20b3d2d159d$var$lt * 2;
        return {
            chartWidth: t,
            chartHeight: r
        };
    }, $e68ba20b3d2d159d$var$U4 = (e, t, r, o, n)=>e.labels?.map((i, a)=>$e68ba20b3d2d159d$var$er({
                groupIds: [
                    o
                ],
                backgroundColor: n,
                ...$e68ba20b3d2d159d$var$Oo,
                text: i.length > 8 ? `${i.slice(0, 5)}...` : i,
                x: t + a * ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt) + $e68ba20b3d2d159d$var$lt * 2,
                y: r + $e68ba20b3d2d159d$var$lt / 2,
                width: $e68ba20b3d2d159d$var$En,
                angle: 5.87,
                fontSize: 16,
                textAlign: "center",
                verticalAlign: "top"
            })) || [], $e68ba20b3d2d159d$var$G4 = (e, t, r, o, n)=>{
        let i = $e68ba20b3d2d159d$var$er({
            groupIds: [
                o
            ],
            backgroundColor: n,
            ...$e68ba20b3d2d159d$var$Oo,
            x: t - $e68ba20b3d2d159d$var$lt,
            y: r - $e68ba20b3d2d159d$var$lt,
            text: "0",
            textAlign: "right"
        }), a = $e68ba20b3d2d159d$var$er({
            groupIds: [
                o
            ],
            backgroundColor: n,
            ...$e68ba20b3d2d159d$var$Oo,
            x: t - $e68ba20b3d2d159d$var$lt,
            y: r - $e68ba20b3d2d159d$var$na - i.height / 2,
            text: Math.max(...e.values).toLocaleString(),
            textAlign: "right"
        });
        return [
            i,
            a
        ];
    }, $e68ba20b3d2d159d$var$W4 = (e, t, r, o, n)=>{
        let { chartWidth: i, chartHeight: a } = $e68ba20b3d2d159d$var$CT(e), s = $e68ba20b3d2d159d$var$un({
            backgroundColor: n,
            groupIds: [
                o
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            type: "line",
            x: t,
            y: r,
            width: i,
            points: [
                [
                    0,
                    0
                ],
                [
                    i,
                    0
                ]
            ]
        }), l = $e68ba20b3d2d159d$var$un({
            backgroundColor: n,
            groupIds: [
                o
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            type: "line",
            x: t,
            y: r,
            height: a,
            points: [
                [
                    0,
                    0
                ],
                [
                    0,
                    -a
                ]
            ]
        }), c = $e68ba20b3d2d159d$var$un({
            backgroundColor: n,
            groupIds: [
                o
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            type: "line",
            x: t,
            y: r - $e68ba20b3d2d159d$var$na - $e68ba20b3d2d159d$var$lt,
            strokeStyle: "dotted",
            width: i,
            opacity: $e68ba20b3d2d159d$var$ST,
            points: [
                [
                    0,
                    0
                ],
                [
                    i,
                    0
                ]
            ]
        });
        return [
            s,
            l,
            c
        ];
    }, $e68ba20b3d2d159d$var$AT = (e, t, r, o, n, i)=>{
        let { chartWidth: a, chartHeight: s } = $e68ba20b3d2d159d$var$CT(e), l = e.title ? $e68ba20b3d2d159d$var$er({
            backgroundColor: n,
            groupIds: [
                o
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            text: e.title,
            x: t + a / 2,
            y: r - $e68ba20b3d2d159d$var$na - $e68ba20b3d2d159d$var$lt * 2 - $e68ba20b3d2d159d$var$wr,
            roundness: null,
            textAlign: "center"
        }) : null, c = i ? $e68ba20b3d2d159d$var$Ar({
            backgroundColor: n,
            groupIds: [
                o
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            type: "rectangle",
            x: t,
            y: r - s,
            width: a,
            height: s,
            strokeColor: $e68ba20b3d2d159d$var$fe.black,
            fillStyle: "solid",
            opacity: 6
        }) : null;
        return [
            ...c ? [
                c
            ] : [],
            ...l ? [
                l
            ] : [],
            ...$e68ba20b3d2d159d$var$U4(e, t, r, o, n),
            ...$e68ba20b3d2d159d$var$G4(e, t, r, o, n),
            ...$e68ba20b3d2d159d$var$W4(e, t, r, o, n)
        ];
    }, $e68ba20b3d2d159d$var$V4 = (e, t, r)=>{
        let o = Math.max(...e.values), n = $e68ba20b3d2d159d$var$Vt(), i = $e68ba20b3d2d159d$var$Mu[Math.floor(Math.random() * $e68ba20b3d2d159d$var$Mu.length)];
        return [
            ...e.values.map((s, l)=>{
                let c = s / o * $e68ba20b3d2d159d$var$na;
                return $e68ba20b3d2d159d$var$Ar({
                    backgroundColor: i,
                    groupIds: [
                        n
                    ],
                    ...$e68ba20b3d2d159d$var$Oo,
                    type: "rectangle",
                    x: t + l * ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt) + $e68ba20b3d2d159d$var$lt,
                    y: r - c - $e68ba20b3d2d159d$var$lt,
                    width: $e68ba20b3d2d159d$var$En,
                    height: c
                });
            }),
            ...$e68ba20b3d2d159d$var$AT(e, t, r, n, i, $e68ba20b3d2d159d$var$T.DEV)
        ];
    }, $e68ba20b3d2d159d$var$Y4 = (e, t, r)=>{
        let o = Math.max(...e.values), n = $e68ba20b3d2d159d$var$Vt(), i = $e68ba20b3d2d159d$var$Mu[Math.floor(Math.random() * $e68ba20b3d2d159d$var$Mu.length)], a = 0, s = [];
        for (let g of e.values){
            let b = a * ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt), v = -(g / o) * $e68ba20b3d2d159d$var$na;
            s.push([
                b,
                v
            ]), a++;
        }
        let l = Math.max(...s.map((g)=>g[0])), c = Math.max(...s.map((g)=>g[1])), d = Math.min(...s.map((g)=>g[0])), m = Math.min(...s.map((g)=>g[1])), p = $e68ba20b3d2d159d$var$un({
            backgroundColor: i,
            groupIds: [
                n
            ],
            ...$e68ba20b3d2d159d$var$Oo,
            type: "line",
            x: t + $e68ba20b3d2d159d$var$lt + $e68ba20b3d2d159d$var$En / 2,
            y: r - $e68ba20b3d2d159d$var$lt,
            height: c - m,
            width: l - d,
            strokeWidth: 2,
            points: s
        }), u = e.values.map((g, b)=>{
            let v = b * ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt) + $e68ba20b3d2d159d$var$lt / 2, y = -(g / o) * $e68ba20b3d2d159d$var$na + $e68ba20b3d2d159d$var$lt / 2;
            return $e68ba20b3d2d159d$var$Ar({
                backgroundColor: i,
                groupIds: [
                    n
                ],
                ...$e68ba20b3d2d159d$var$Oo,
                fillStyle: "solid",
                strokeWidth: 2,
                type: "ellipse",
                x: t + v + $e68ba20b3d2d159d$var$En / 2,
                y: r + y - $e68ba20b3d2d159d$var$lt * 2,
                width: $e68ba20b3d2d159d$var$lt,
                height: $e68ba20b3d2d159d$var$lt
            });
        }), h = e.values.map((g, b)=>{
            let v = b * ($e68ba20b3d2d159d$var$En + $e68ba20b3d2d159d$var$lt) + $e68ba20b3d2d159d$var$lt / 2, y = g / o * $e68ba20b3d2d159d$var$na + $e68ba20b3d2d159d$var$lt / 2 + $e68ba20b3d2d159d$var$lt;
            return $e68ba20b3d2d159d$var$un({
                backgroundColor: i,
                groupIds: [
                    n
                ],
                ...$e68ba20b3d2d159d$var$Oo,
                type: "line",
                x: t + v + $e68ba20b3d2d159d$var$En / 2 + $e68ba20b3d2d159d$var$lt / 2,
                y: r - y,
                height: y,
                strokeStyle: "dotted",
                opacity: $e68ba20b3d2d159d$var$ST,
                points: [
                    [
                        0,
                        0
                    ],
                    [
                        0,
                        y
                    ]
                ]
            });
        });
        return [
            ...$e68ba20b3d2d159d$var$AT(e, t, r, n, i, $e68ba20b3d2d159d$var$T.DEV),
            p,
            ...h,
            ...u
        ];
    }, $e68ba20b3d2d159d$var$MT = (e, t, r, o)=>e === "line" ? $e68ba20b3d2d159d$var$Y4(t, r, o) : $e68ba20b3d2d159d$var$V4(t, r, o);
});
function $e68ba20b3d2d159d$var$PT(e) {
    let t = [];
    for (let r of e.childNodes)if (r.nodeType === 3) {
        let o = r.textContent?.trim();
        o && t.push({
            type: "text",
            value: o
        });
    } else if (r instanceof HTMLImageElement) {
        let o = r.getAttribute("src");
        o && o.startsWith("http") && t.push({
            type: "imageUrl",
            value: o
        });
    } else t = t.concat($e68ba20b3d2d159d$var$PT(r));
    return t;
}
var $e68ba20b3d2d159d$var$dV, $e68ba20b3d2d159d$var$ku, $e68ba20b3d2d159d$var$Cl, $e68ba20b3d2d159d$var$X4, $e68ba20b3d2d159d$var$kT, $e68ba20b3d2d159d$var$K4, $e68ba20b3d2d159d$var$Pu, $e68ba20b3d2d159d$var$$4, $e68ba20b3d2d159d$var$Z4, $e68ba20b3d2d159d$var$LT, $e68ba20b3d2d159d$var$j4, $e68ba20b3d2d159d$var$Lu, $e68ba20b3d2d159d$var$Du, $e68ba20b3d2d159d$var$vi, $e68ba20b3d2d159d$var$q4, $e68ba20b3d2d159d$var$ia = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$PE();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$gn();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$dV = "clipboard" in navigator && "readText" in navigator.clipboard, $e68ba20b3d2d159d$var$ku = "clipboard" in navigator && "writeText" in navigator.clipboard, $e68ba20b3d2d159d$var$Cl = "clipboard" in navigator && "write" in navigator.clipboard && "ClipboardItem" in window && "toBlob" in HTMLCanvasElement.prototype, $e68ba20b3d2d159d$var$X4 = (e)=>!!([
            $e68ba20b3d2d159d$var$Tr.excalidraw,
            $e68ba20b3d2d159d$var$Tr.excalidrawClipboard,
            $e68ba20b3d2d159d$var$Tr.excalidrawClipboardWithAPI
        ].includes(e?.type) && Array.isArray(e.elements)), $e68ba20b3d2d159d$var$kT = ({ types: e, files: t })=>{
        !e && !t && console.warn("createPasteEvent: no types or files provided");
        let r = new ClipboardEvent("paste", {
            clipboardData: new DataTransfer
        });
        if (e) for (let [o, n] of Object.entries(e))try {
            if (r.clipboardData?.setData(o, n), r.clipboardData?.getData(o) !== n) throw new Error(`Failed to set "${o}" as clipboardData item`);
        } catch (i) {
            throw new Error(i.message);
        }
        if (t) {
            let o = -1;
            for (let n of t){
                o++;
                try {
                    if (r.clipboardData?.items.add(n), r.clipboardData?.files[o] !== n) throw new Error(`Failed to set file "${n.name}" as clipboardData item`);
                } catch (i) {
                    throw new Error(i.message);
                }
            }
        }
        return r;
    }, $e68ba20b3d2d159d$var$K4 = ({ elements: e, files: t })=>{
        let r = $e68ba20b3d2d159d$var$j(e), o = new Set(e.filter((s)=>$e68ba20b3d2d159d$var$re(s))), n = !1, i = e.reduce((s, l)=>($e68ba20b3d2d159d$var$Nr(l) && (n = !0, t && t[l.fileId] && (s[l.fileId] = t[l.fileId])), s), {});
        n && !t && console.warn("copyToClipboard: attempting to file element(s) without providing associated `files` object.");
        let a = {
            type: $e68ba20b3d2d159d$var$Tr.excalidrawClipboard,
            elements: e.map((s)=>{
                if ($e68ba20b3d2d159d$var$rr(s, r) && !o.has($e68ba20b3d2d159d$var$rr(s, r))) {
                    let l = $e68ba20b3d2d159d$var$hn(s);
                    return $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                        frameId: null
                    }), l;
                }
                return s;
            }),
            files: t ? i : void 0
        };
        return JSON.stringify(a);
    }, $e68ba20b3d2d159d$var$Pu = async (e, t, r)=>{
        await $e68ba20b3d2d159d$var$vi($e68ba20b3d2d159d$var$K4({
            elements: e,
            files: t
        }), r);
    }, $e68ba20b3d2d159d$var$$4 = (e)=>{
        let t = $e68ba20b3d2d159d$var$IT(e);
        return t.type === $e68ba20b3d2d159d$var$Il ? {
            spreadsheet: t.spreadsheet
        } : null;
    };
    $e68ba20b3d2d159d$var$Z4 = (e)=>{
        let t = e.clipboardData?.getData("text/html");
        if (!t) return null;
        try {
            let r = new DOMParser().parseFromString(t, "text/html"), o = $e68ba20b3d2d159d$var$PT(r.body);
            if (o.length) return {
                type: "mixedContent",
                value: o
            };
        } catch (r) {
            console.error(`error in parseHTMLFromPaste: ${r.message}`);
        }
        return null;
    }, $e68ba20b3d2d159d$var$LT = async ()=>{
        let e = {};
        try {
            if (navigator.clipboard?.readText) return {
                "text/plain": await navigator.clipboard?.readText()
            };
        } catch (r) {
            if (navigator.clipboard?.read) console.warn(`navigator.clipboard.readText() failed (${r.message}). Failling back to navigator.clipboard.read()`);
            else throw r;
        }
        let t;
        try {
            t = await navigator.clipboard?.read();
        } catch (r) {
            if (r.name === "DataError") return console.warn(`navigator.clipboard.read() error, clipboard is probably empty: ${r.message}`), e;
            throw r;
        }
        for (let r of t)for (let o of r.types)if ($e68ba20b3d2d159d$var$qm($e68ba20b3d2d159d$var$w0, o)) try {
            e[o] = await (await r.getType(o)).text();
        } catch (n) {
            console.warn(`Cannot retrieve ${o} from clipboardItem: ${n.message}`);
        }
        return Object.keys(e).length === 0 && console.warn("No clipboard data found from clipboard.read()."), e;
    }, $e68ba20b3d2d159d$var$j4 = async (e, t = !1)=>{
        try {
            let r = !t && e && $e68ba20b3d2d159d$var$Z4(e);
            return r ? r.value.every((n)=>n.type === "text") ? {
                type: "text",
                value: e.clipboardData?.getData("text/plain") || r.value.map((n)=>n.value).join(`
`).trim()
            } : r : {
                type: "text",
                value: (e.clipboardData?.getData("text/plain") || "").trim()
            };
        } catch  {
            return {
                type: "text",
                value: ""
            };
        }
    }, $e68ba20b3d2d159d$var$Lu = async (e, t = !1)=>{
        let r = await $e68ba20b3d2d159d$var$j4(e, t);
        if (r.type === "mixedContent") return {
            mixedContent: r.value
        };
        try {
            let o = !t && $e68ba20b3d2d159d$var$$4(r.value);
            if (o) return o;
        } catch (o) {
            console.error(o);
        }
        try {
            let o = JSON.parse(r.value), n = o.type === $e68ba20b3d2d159d$var$Tr.excalidrawClipboardWithAPI;
            if ($e68ba20b3d2d159d$var$X4(o)) return {
                elements: o.elements,
                files: o.files,
                text: t ? JSON.stringify(o.elements, null, 2) : void 0,
                programmaticAPI: n
            };
        } catch  {}
        return {
            text: r.value
        };
    }, $e68ba20b3d2d159d$var$Du = async (e)=>{
        try {
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    [$e68ba20b3d2d159d$export$edfb5d7e4280f611.png]: e
                })
            ]);
        } catch (t) {
            if ($e68ba20b3d2d159d$var$Ln(e)) await navigator.clipboard.write([
                new window.ClipboardItem({
                    [$e68ba20b3d2d159d$export$edfb5d7e4280f611.png]: await e
                })
            ]);
            else throw t;
        }
    }, $e68ba20b3d2d159d$var$vi = async (e, t)=>{
        if ($e68ba20b3d2d159d$var$ku) try {
            await navigator.clipboard.writeText(e || "");
            return;
        } catch (r) {
            console.error(r);
        }
        try {
            if (t) {
                if (t.clipboardData?.setData("text/plain", e || ""), t.clipboardData?.getData("text/plain") !== e) throw new Error("Failed to setData on clipboardEvent");
                return;
            }
        } catch (r) {
            console.error(r);
        }
        if (!$e68ba20b3d2d159d$var$q4(e)) throw new Error("Error copying to clipboard.");
    }, $e68ba20b3d2d159d$var$q4 = (e)=>{
        e || (e = " ");
        let t = document.documentElement.getAttribute("dir") === "rtl", r = document.createElement("textarea");
        r.style.border = "0", r.style.padding = "0", r.style.margin = "0", r.style.position = "absolute", r.style[t ? "right" : "left"] = "-9999px";
        let o = window.pageYOffset || document.documentElement.scrollTop;
        r.style.top = `${o}px`, r.style.fontSize = "12pt", r.setAttribute("readonly", ""), r.value = e, document.body.appendChild(r);
        let n = !1;
        try {
            r.select(), r.setSelectionRange(0, r.value.length), n = document.execCommand("copy");
        } catch (i) {
            console.error(i);
        }
        return r.remove(), n;
    };
});
var $e68ba20b3d2d159d$export$7e83d8bd8a3024f4, $e68ba20b3d2d159d$export$64d5110a38cde8, $e68ba20b3d2d159d$export$369dce80fa4b3d47, $e68ba20b3d2d159d$export$6c182b874ed7cf6b, $e68ba20b3d2d159d$var$Ml = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$yd();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$xl();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$bl();
    $e68ba20b3d2d159d$var$pi();
    $e68ba20b3d2d159d$var$ia();
    $e68ba20b3d2d159d$export$7e83d8bd8a3024f4 = ({ elements: e, appState: t, files: r, maxWidthOrHeight: o, getDimensions: n, exportPadding: i, exportingFrame: a })=>{
        let { elements: s, appState: l } = $e68ba20b3d2d159d$export$db239ef39aadc7fe({
            elements: e,
            appState: t
        }, null, null), { exportBackground: c, viewBackgroundColor: d } = l;
        return $e68ba20b3d2d159d$var$Cu(s, {
            ...l,
            offsetTop: 0,
            offsetLeft: 0,
            width: 0,
            height: 0
        }, r || {}, {
            exportBackground: c,
            exportPadding: i,
            viewBackgroundColor: d,
            exportingFrame: a
        }, (m, p)=>{
            let u = document.createElement("canvas");
            if (o) {
                typeof n == "function" && console.warn("`getDimensions()` is ignored when `maxWidthOrHeight` is supplied.");
                let g = Math.max(m, p), b = o < g ? o / g : t?.exportScale ?? 1;
                return u.width = m * b, u.height = p * b, {
                    canvas: u,
                    scale: b
                };
            }
            let h = n?.(m, p) || {
                width: m,
                height: p
            };
            return u.width = h.width, u.height = h.height, {
                canvas: u,
                scale: h.scale ?? 1
            };
        });
    }, $e68ba20b3d2d159d$export$64d5110a38cde8 = async (e)=>{
        let { mimeType: t = $e68ba20b3d2d159d$export$edfb5d7e4280f611.png, quality: r } = e;
        t === $e68ba20b3d2d159d$export$edfb5d7e4280f611.png && typeof r == "number" && console.warn(`"quality" will be ignored for "${$e68ba20b3d2d159d$export$edfb5d7e4280f611.png}" mimeType`), t === "image/jpg" && (t = $e68ba20b3d2d159d$export$edfb5d7e4280f611.jpg), t === $e68ba20b3d2d159d$export$edfb5d7e4280f611.jpg && !e.appState?.exportBackground && (console.warn(`Defaulting "exportBackground" to "true" for "${$e68ba20b3d2d159d$export$edfb5d7e4280f611.jpg}" mimeType`), e = {
            ...e,
            appState: {
                ...e.appState,
                exportBackground: !0
            }
        });
        let o = await $e68ba20b3d2d159d$export$7e83d8bd8a3024f4(e);
        return r = r || (/image\/jpe?g/.test(t) ? .92 : .8), new Promise((n, i)=>{
            o.toBlob(async (a)=>{
                if (!a) return i(new Error("couldn't export to blob"));
                a && t === $e68ba20b3d2d159d$export$edfb5d7e4280f611.png && e.appState?.exportEmbedScene && (a = await $e68ba20b3d2d159d$var$cE({
                    blob: a,
                    metadata: $e68ba20b3d2d159d$export$b502122c5be20fdd(e.elements, e.appState, e.files || {}, "local")
                })), n(a);
            }, t, r);
        });
    }, $e68ba20b3d2d159d$export$369dce80fa4b3d47 = async ({ elements: e, appState: t = $e68ba20b3d2d159d$var$dr(), files: r = {}, exportPadding: o, renderEmbeddables: n, exportingFrame: i, skipInliningFonts: a })=>{
        let { elements: s, appState: l } = $e68ba20b3d2d159d$export$db239ef39aadc7fe({
            elements: e,
            appState: t
        }, null, null), c = {
            ...l,
            exportPadding: o
        };
        return $e68ba20b3d2d159d$var$Tl(s, c, r, {
            exportingFrame: i,
            renderEmbeddables: n,
            skipInliningFonts: a
        });
    }, $e68ba20b3d2d159d$export$6c182b874ed7cf6b = async (e)=>{
        if (e.type === "svg") {
            let t = await $e68ba20b3d2d159d$export$369dce80fa4b3d47(e);
            await $e68ba20b3d2d159d$var$vi(t.outerHTML);
        } else if (e.type === "png") await $e68ba20b3d2d159d$var$Du($e68ba20b3d2d159d$export$64d5110a38cde8(e));
        else if (e.type === "json") await $e68ba20b3d2d159d$var$Pu(e.elements, e.files);
        else throw new Error("Invalid export type");
    };
});
var $e68ba20b3d2d159d$var$Q4, $e68ba20b3d2d159d$var$ek, $e68ba20b3d2d159d$var$_T, $e68ba20b3d2d159d$var$RT, $e68ba20b3d2d159d$export$9d2fbf0ff04c6d18, $e68ba20b3d2d159d$export$84a44e4716e6bf66, $e68ba20b3d2d159d$export$7e344a8703988f2e, $e68ba20b3d2d159d$var$_E = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Q4 = (e)=>e.type === "diamond" ? [
            [
                e.width / 2,
                0
            ],
            [
                e.width,
                e.height / 2
            ],
            [
                e.width / 2,
                e.height
            ],
            [
                0,
                e.height / 2
            ]
        ] : [
            [
                0,
                0
            ],
            [
                0 + e.width,
                0
            ],
            [
                0 + e.width,
                e.height
            ],
            [
                0,
                e.height
            ]
        ], $e68ba20b3d2d159d$var$ek = (e)=>$e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e) ? e.points : $e68ba20b3d2d159d$var$Q4(e), $e68ba20b3d2d159d$var$_T = (e)=>{
        let t = e.reduce((r, [o, n])=>(r.minY = Math.min(r.minY, n), r.minX = Math.min(r.minX, o), r.maxX = Math.max(r.maxX, o), r.maxY = Math.max(r.maxY, n), r), {
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0,
            cx: 0,
            cy: 0
        });
        return t.cx = (t.maxX + t.minX) / 2, t.cy = (t.maxY + t.minY) / 2, t;
    }, $e68ba20b3d2d159d$var$RT = (e)=>{
        let t = $e68ba20b3d2d159d$var$ek(e), { cx: r, cy: o } = $e68ba20b3d2d159d$var$_T(t), n = [
            r,
            o
        ], i = t.map((d)=>$e68ba20b3d2d159d$var$J([
                d[0],
                d[1]
            ], n, e.angle)), { minX: a, minY: s, maxX: l, maxY: c } = $e68ba20b3d2d159d$var$_T(i);
        return [
            a + e.x,
            s + e.y,
            l + e.x,
            c + e.y
        ];
    }, $e68ba20b3d2d159d$export$9d2fbf0ff04c6d18 = (e, t, r = !1)=>{
        let o = $e68ba20b3d2d159d$var$RT(e), n = t[0] <= o[0] && t[2] >= o[2] && t[1] <= o[1] && t[3] >= o[3];
        return r ? n ? !0 : o[0] <= t[0] && o[2] >= t[2] && o[1] <= t[1] && o[3] >= t[3] : n;
    }, $e68ba20b3d2d159d$export$84a44e4716e6bf66 = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$RT(e);
        return ($e68ba20b3d2d159d$var$Td(r[0], t[0], t[2]) || $e68ba20b3d2d159d$var$Td(t[0], r[0], r[2])) && ($e68ba20b3d2d159d$var$Td(r[1], t[1], t[3]) || $e68ba20b3d2d159d$var$Td(t[1], r[1], r[3]));
    }, $e68ba20b3d2d159d$export$7e344a8703988f2e = ({ elements: e, bounds: t, type: r, errorMargin: o = 0 })=>{
        $e68ba20b3d2d159d$var$Rc(t) && (t = $e68ba20b3d2d159d$var$go(t, $e68ba20b3d2d159d$var$j(e)));
        let n = [
            t[0] - o,
            t[1] - o,
            t[2] + o,
            t[3] + o
        ], i = new Set;
        for (let a of e){
            if (i.has(a.id)) continue;
            if (r === "overlap" ? $e68ba20b3d2d159d$export$84a44e4716e6bf66(a, n) : r === "inside" ? $e68ba20b3d2d159d$export$9d2fbf0ff04c6d18(a, n) : $e68ba20b3d2d159d$export$9d2fbf0ff04c6d18(a, n, !0)) {
                if (i.add(a.id), a.boundElements) for (let l of a.boundElements)i.add(l.id);
                $e68ba20b3d2d159d$var$G(a) && a.containerId && i.add(a.containerId), $e68ba20b3d2d159d$var$ie(a) && (a.startBinding && i.add(a.startBinding.elementId), a.endBinding && i.add(a.endBinding?.elementId));
            }
        }
        return e.filter((a)=>i.has(a.id));
    };
});
var $e68ba20b3d2d159d$var$OT = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Ml();
    $e68ba20b3d2d159d$var$_E();
    $e68ba20b3d2d159d$var$jf();
    $e68ba20b3d2d159d$var$dt();
});
function $e68ba20b3d2d159d$var$FT(e, t, r) {
    let o = $e68ba20b3d2d159d$var$RE(t, r), n = $e68ba20b3d2d159d$var$RE(e, r);
    return o.some((a)=>n.some((s)=>$e68ba20b3d2d159d$var$_2(a, s)));
}
var $e68ba20b3d2d159d$var$_u, $e68ba20b3d2d159d$var$BT, $e68ba20b3d2d159d$var$zT, $e68ba20b3d2d159d$var$Ru, $e68ba20b3d2d159d$var$No, $e68ba20b3d2d159d$var$NE, $e68ba20b3d2d159d$var$HT, $e68ba20b3d2d159d$var$bo, $e68ba20b3d2d159d$var$wd, $e68ba20b3d2d159d$var$ME, $e68ba20b3d2d159d$var$kl, $e68ba20b3d2d159d$var$UT, $e68ba20b3d2d159d$var$rr, $e68ba20b3d2d159d$var$GT, $e68ba20b3d2d159d$var$Sd, $e68ba20b3d2d159d$var$Pl, $e68ba20b3d2d159d$var$OE, $e68ba20b3d2d159d$var$Nu, $e68ba20b3d2d159d$var$Wn, $e68ba20b3d2d159d$var$Ou, $e68ba20b3d2d159d$var$Tu, $e68ba20b3d2d159d$var$ms, $e68ba20b3d2d159d$var$Au, $e68ba20b3d2d159d$var$Sl, $e68ba20b3d2d159d$var$gr = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$Yt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$OT();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$_u = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$j(e);
        for (let n of t)if (n.frameId) {
            let i = r.get(n.id), a = r.get(n.frameId);
            if (i) {
                let s = o.get(i);
                s && $e68ba20b3d2d159d$export$55655e96a21bba2e(s, {
                    frameId: a ?? n.frameId
                }, !1);
            }
        }
    };
    $e68ba20b3d2d159d$var$BT = (e, t, r)=>$e68ba20b3d2d159d$var$Ou($e68ba20b3d2d159d$var$Ll(e, t, r, !1)).filter((o)=>!$e68ba20b3d2d159d$var$re(o) && !o.frameId || o.frameId === t.id), $e68ba20b3d2d159d$var$zT = (e, t, r, o)=>$e68ba20b3d2d159d$var$Ll(e, t, o).some((n)=>n.id === r.id), $e68ba20b3d2d159d$var$Ru = (e, t, r)=>{
        let [o, n, i, a] = $e68ba20b3d2d159d$var$ae(t, r), [s, l, c, d] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e);
        return o <= s && n <= l && i >= c && a >= d;
    }, $e68ba20b3d2d159d$var$No = (e, t, r)=>$e68ba20b3d2d159d$var$Ru([
            e
        ], t, r) || $e68ba20b3d2d159d$var$FT(e, t, r) || $e68ba20b3d2d159d$var$zT([
            t
        ], e, t, r), $e68ba20b3d2d159d$var$NE = (e, t, r)=>{
        let [o, n, i, a] = $e68ba20b3d2d159d$var$ae(t, r);
        return $e68ba20b3d2d159d$var$Wp([
            o,
            n
        ], [
            e.x,
            e.y
        ], [
            i,
            a
        ]);
    }, $e68ba20b3d2d159d$var$HT = (e)=>{
        let t = new Map;
        for (let r of e){
            let o = $e68ba20b3d2d159d$var$re(r) ? r.id : r.frameId;
            o && !t.has(o) && t.set(o, $e68ba20b3d2d159d$var$bo(e, o));
        }
        return t;
    }, $e68ba20b3d2d159d$var$bo = (e, t)=>{
        let r = [];
        for (let o of e.values())o.frameId === t && r.push(o);
        return r;
    }, $e68ba20b3d2d159d$var$wd = (e)=>e.filter((t)=>$e68ba20b3d2d159d$var$re(t)), $e68ba20b3d2d159d$var$ME = (e)=>{
        let t = $e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$wd(e));
        return e.filter((r)=>t.has(r.id) || !r.frameId || !t.has(r.frameId));
    }, $e68ba20b3d2d159d$var$kl = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$bo(e, t.id), i = new Set(n), a = new Set([
            ...$e68ba20b3d2d159d$var$BT(e, t, o),
            ...n.filter((p)=>$e68ba20b3d2d159d$var$zT(e, p, t, o))
        ]), s = n.filter((p)=>!a.has(p)), l = new Set(Array.from(a).flatMap((p)=>p.groupIds));
        for (let p of s)if (!$e68ba20b3d2d159d$var$FT(p, t, o)) p.groupIds.length === 0 && i.delete(p);
        else if (p.groupIds.length > 0) for (let u of p.groupIds)l.add(u);
        for (let p of s)if (p.groupIds.length > 0) {
            let u = !0;
            for (let h of p.groupIds)l.has(h) && (u = !1);
            u && i.delete(p);
        }
        let c = Array.from(a).filter((p)=>p.groupIds.length === 0);
        for (let p of c)i.add(p);
        let d = Array.from(a).filter((p)=>p.groupIds.length > 0), m = $e68ba20b3d2d159d$var$ip(d, r);
        for (let [p, u] of Object.entries(m))if (u) {
            let h = $e68ba20b3d2d159d$var$nt(e, p);
            if ($e68ba20b3d2d159d$var$Ru(h, t, o)) for (let g of h)i.add(g);
        }
        return [
            ...i
        ].filter((p)=>!($e68ba20b3d2d159d$var$G(p) && p.containerId));
    }, $e68ba20b3d2d159d$var$UT = (e, t, r)=>$e68ba20b3d2d159d$var$Ou(e, $e68ba20b3d2d159d$var$BT(e, t, r)), $e68ba20b3d2d159d$var$rr = (e, t)=>e.frameId && t.get(e.frameId) || null, $e68ba20b3d2d159d$var$GT = (e, t)=>{
        let r = new Set, o = $e68ba20b3d2d159d$var$j(e);
        e = $e68ba20b3d2d159d$var$Ou(e);
        for (let a of e)$e68ba20b3d2d159d$var$re(a) && a.id !== t.id && r.add(a.id);
        let n = new Set, i = [];
        for (let a of e)if (!($e68ba20b3d2d159d$var$re(a) || a.frameId && r.has(a.frameId))) {
            if (a.groupIds.length) {
                let s = a.groupIds.at(-1);
                if (!n.has(s)) {
                    n.add(s);
                    let l = $e68ba20b3d2d159d$var$nt(e, s);
                    if (l.some((c)=>$e68ba20b3d2d159d$var$No(c, t, o))) for (let c of l)i.push(c);
                }
            } else $e68ba20b3d2d159d$var$No(a, t, o) && i.push(a);
        }
        return i;
    }, $e68ba20b3d2d159d$var$Sd = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$j(e), n = new Map;
        for (let l of e.values())l.frameId === r.id && n.set(l.id, !0);
        let i = new Set(t.map((l)=>l.id)), a = [], s = new Set;
        for (let l of t)$e68ba20b3d2d159d$var$re(l) && l.id !== r.id && s.add(l.id);
        for (let l of $e68ba20b3d2d159d$var$Ou(e, t)){
            if ($e68ba20b3d2d159d$var$re(l) || l.frameId && s.has(l.frameId)) continue;
            n.has(l.id) || a.push(l);
            let c = $e68ba20b3d2d159d$var$te(l, o);
            c && !i.has(c.id) && !n.has(c.id) && a.push(c);
        }
        for (let l of a)$e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
            frameId: r.id
        }, !1);
        return e;
    }, $e68ba20b3d2d159d$var$Pl = (e, t)=>{
        let r = new Map, o = new Map;
        for (let n of e)if (n.frameId) {
            r.set(n.id, n);
            let i = o.get(n.frameId) || [];
            i.push(n);
            let a = $e68ba20b3d2d159d$var$te(n, t);
            a && (r.set(a.id, a), i.push(a)), o.set(n.frameId, i);
        }
        for (let [, n] of r)$e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
            frameId: null
        }, !1);
    }, $e68ba20b3d2d159d$var$OE = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$bo(e, t.id);
        return $e68ba20b3d2d159d$var$Pl(r, $e68ba20b3d2d159d$var$j(e)), e;
    }, $e68ba20b3d2d159d$var$Nu = (e, t, r, o)=>$e68ba20b3d2d159d$var$Sd($e68ba20b3d2d159d$var$OE(e, r), t, r).slice(), $e68ba20b3d2d159d$var$Wn = (e, t, r)=>{
        let o = r.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            elements: e
        }), n = new Set(o);
        if (t.editingGroupId) for (let s of o)s.groupIds.length === 0 ? n.add(s) : s.groupIds.flatMap((l)=>$e68ba20b3d2d159d$var$nt(e, l)).forEach((l)=>n.add(l));
        let i = new Set, a = $e68ba20b3d2d159d$var$j(e);
        return n.forEach((s)=>{
            s.frameId && !$e68ba20b3d2d159d$var$re(s) && !$e68ba20b3d2d159d$var$ms(s, a, t) && i.add(s);
        }), i.size > 0 && $e68ba20b3d2d159d$var$Pl(i, a), e;
    }, $e68ba20b3d2d159d$var$Ou = (e, t)=>{
        let r = new Set, o = t || e;
        for (let a of o.values()){
            let s = a.groupIds[a.groupIds.length - 1];
            s && r.add(s);
        }
        let n = new Set;
        for (let a of r)$e68ba20b3d2d159d$var$nt(e, a).some((s)=>$e68ba20b3d2d159d$var$re(s)) && n.add(a);
        let i = [];
        for (let a of o.values())n.has(a.groupIds[a.groupIds.length - 1]) || i.push(a);
        return i;
    }, $e68ba20b3d2d159d$var$Tu = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$G(e) && $e68ba20b3d2d159d$var$bt(e, t) || e;
        return r.selectedElementIds[o.id] && r.selectedElementsAreBeingDragged ? r.frameToHighlight : $e68ba20b3d2d159d$var$rr(o, t);
    }, $e68ba20b3d2d159d$var$ms = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$Tu(e, t, r), n = $e68ba20b3d2d159d$var$G(e) && $e68ba20b3d2d159d$var$bt(e, t) || e;
        if (o) {
            if (!r.selectedElementIds[e.id] || !r.selectedElementsAreBeingDragged) return !0;
            if (n.groupIds.length === 0) return $e68ba20b3d2d159d$var$No(n, o, t);
            let i = new Set(n.groupIds.flatMap((a)=>$e68ba20b3d2d159d$var$nt(t, a)));
            if (r.editingGroupId && r.selectedElementsAreBeingDragged) {
                let a = new Set($e68ba20b3d2d159d$var$pe(t, r));
                if (r.frameToHighlight !== null) return !0;
                a.forEach((l)=>{
                    i.delete(l);
                });
            }
            for (let a of i)if ($e68ba20b3d2d159d$var$re(a)) return !1;
            for (let a of i)if ($e68ba20b3d2d159d$var$No(a, o, t)) return !0;
        }
        return !1;
    }, $e68ba20b3d2d159d$var$Au = (e)=>e.name === null ? $e68ba20b3d2d159d$var$ep(e) ? "Frame" : "AI Frame" : e.name, $e68ba20b3d2d159d$var$Sl = (e, t)=>$e68ba20b3d2d159d$export$7e344a8703988f2e({
            elements: e,
            bounds: t,
            type: "overlap"
        }).filter((r)=>!r.frameId || r.frameId === t.id);
});
function $e68ba20b3d2d159d$var$QT(e) {
    let t = $e68ba20b3d2d159d$export$4391385250dacbf7(e), r = new Path2D(t);
    return $e68ba20b3d2d159d$var$JT.set(e, r), r;
}
function $e68ba20b3d2d159d$var$ak(e) {
    return $e68ba20b3d2d159d$var$JT.get(e);
}
function $e68ba20b3d2d159d$export$4391385250dacbf7(e) {
    let t = e.simulatePressure ? e.points : e.points.length ? e.points.map(([o, n], i)=>[
            o,
            n,
            e.pressures[i]
        ]) : [
        [
            0,
            0,
            .5
        ]
    ], r = {
        simulatePressure: e.simulatePressure,
        size: e.strokeWidth * 4.25,
        thinning: .6,
        smoothing: .5,
        streamline: .5,
        easing: (o)=>Math.sin(o * Math.PI / 2),
        last: !!e.lastCommittedPoint
    };
    return $e68ba20b3d2d159d$var$lk((0, $cdfd1866a6cf81a8$export$d5e7b8855b0b151b)(t, r));
}
function $e68ba20b3d2d159d$var$YT(e, t) {
    return [
        (e[0] + t[0]) / 2,
        (e[1] + t[1]) / 2
    ];
}
function $e68ba20b3d2d159d$var$lk(e) {
    if (!e.length) return "";
    let t = e.length - 1;
    return e.reduce((r, o, n, i)=>(n === t ? r.push(o, $e68ba20b3d2d159d$var$YT(o, i[0]), "L", i[0], "Z") : r.push(o, $e68ba20b3d2d159d$var$YT(o, i[n + 1])), r), [
        "M",
        e[0],
        "Q"
    ]).join(" ").replace($e68ba20b3d2d159d$var$sk, "$1");
}
var $e68ba20b3d2d159d$var$wE, $e68ba20b3d2d159d$var$rk, $e68ba20b3d2d159d$var$KT, $e68ba20b3d2d159d$var$$T, $e68ba20b3d2d159d$var$Bu, $e68ba20b3d2d159d$var$FE, $e68ba20b3d2d159d$var$ok, $e68ba20b3d2d159d$var$nk, $e68ba20b3d2d159d$var$gT, $e68ba20b3d2d159d$var$ZT, $e68ba20b3d2d159d$var$jT, $e68ba20b3d2d159d$var$ik, $e68ba20b3d2d159d$var$Fu, $e68ba20b3d2d159d$var$mp, $e68ba20b3d2d159d$var$WT, $e68ba20b3d2d159d$var$VT, $e68ba20b3d2d159d$var$qT, $e68ba20b3d2d159d$var$wi, $e68ba20b3d2d159d$var$JT, $e68ba20b3d2d159d$var$sk, $e68ba20b3d2d159d$var$Fn = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$Qr();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$pn();
    $e68ba20b3d2d159d$var$wE = "invert(100%) hue-rotate(180deg) saturate(1.25)", $e68ba20b3d2d159d$var$rk = $e68ba20b3d2d159d$var$dr(), $e68ba20b3d2d159d$var$KT = (e, t)=>$e68ba20b3d2d159d$var$Nr(e) && !t.imageCache.has(e.fileId), $e68ba20b3d2d159d$var$$T = (e, t, r)=>r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK && $e68ba20b3d2d159d$var$Nr(e) && !$e68ba20b3d2d159d$var$KT(e, t) && t.imageCache.get(e.fileId)?.mimeType !== $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg, $e68ba20b3d2d159d$var$Bu = (e)=>{
        switch(e.type){
            case "freedraw":
                return e.strokeWidth * 12;
            case "text":
                return e.fontSize / 2;
            default:
                return 20;
        }
    }, $e68ba20b3d2d159d$var$FE = (e, t, r, o)=>{
        let n = (t?.opacity ?? 100) * e.opacity / 1e4;
        return (r.has(e.id) || o && o.some((i)=>i.id === e.id) || t && r.has(t.id)) && (n *= $e68ba20b3d2d159d$var$N0 / 100), n;
    }, $e68ba20b3d2d159d$var$ok = (e, t, r)=>{
        let i = $e68ba20b3d2d159d$var$Bu(e), [a, s, l, c] = $e68ba20b3d2d159d$var$ae(e, t), d = $e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e) ? $e68ba20b3d2d159d$var$Wt(a, l) : e.width, m = $e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e) ? $e68ba20b3d2d159d$var$Wt(s, c) : e.height, p = d * window.devicePixelRatio + i * 2, u = m * window.devicePixelRatio + i * 2, h = r.value;
        return (p * h > 32767 || u * h > 32767) && (h = Math.min(32767 / p, 32767 / u)), p * u * h * h > 16777216 && (h = Math.sqrt(16777216 / (p * u))), p = Math.floor(p * h), u = Math.floor(u * h), {
            width: p,
            height: u,
            scale: h
        };
    }, $e68ba20b3d2d159d$var$nk = (e, t, r, o, n)=>{
        let i = document.createElement("canvas"), a = i.getContext("2d"), s = $e68ba20b3d2d159d$var$Bu(e), { width: l, height: c, scale: d } = $e68ba20b3d2d159d$var$ok(e, t, r);
        if (!l || !c) return null;
        i.width = l, i.height = c;
        let m = -100, p = 0;
        if ($e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e)) {
            let [v, y] = $e68ba20b3d2d159d$var$ae(e, t);
            m = e.x > v ? $e68ba20b3d2d159d$var$Wt(e.x, v) * window.devicePixelRatio * d : 0, p = e.y > y ? $e68ba20b3d2d159d$var$Wt(e.y, y) * window.devicePixelRatio * d : 0, a.translate(m, p);
        }
        a.save(), a.translate(s * d, s * d), a.scale(window.devicePixelRatio * d, window.devicePixelRatio * d);
        let u = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).canvas(i);
        $e68ba20b3d2d159d$var$$T(e, o, n) && (a.filter = $e68ba20b3d2d159d$var$wE), $e68ba20b3d2d159d$var$Fu(e, u, a, o, n), a.restore();
        let h = $e68ba20b3d2d159d$var$te(e, t), g = document.createElement("canvas"), b = g.getContext("2d");
        if ($e68ba20b3d2d159d$var$ie(e) && h) {
            let [v, y, w, I] = $e68ba20b3d2d159d$var$ae(e, t), M = Math.max($e68ba20b3d2d159d$var$Wt(v, w), $e68ba20b3d2d159d$var$Wt(y, I));
            g.width = M * window.devicePixelRatio * d + s * d * 10, g.height = M * window.devicePixelRatio * d + s * d * 10, b.translate(g.width / 2, g.height / 2), b.rotate(e.angle), b.drawImage(i, -i.width / 2, -i.height / 2, i.width, i.height);
            let [, , , , C, P] = $e68ba20b3d2d159d$var$ae(h, t);
            b.rotate(-e.angle);
            let k = (g.width - i.width) / 2, _ = (g.height - i.height) / 2, A = g.width / 2 - (C - v) * window.devicePixelRatio * d - k - s * d, R = g.height / 2 - (P - y) * window.devicePixelRatio * d - _ - s * d;
            b.translate(-A, -R), b.clearRect(-(h.width / 2 + $e68ba20b3d2d159d$var$wt) * window.devicePixelRatio * d, -(h.height / 2 + $e68ba20b3d2d159d$var$wt) * window.devicePixelRatio * d, (h.width + $e68ba20b3d2d159d$var$wt * 2) * window.devicePixelRatio * d, (h.height + $e68ba20b3d2d159d$var$wt * 2) * window.devicePixelRatio * d);
        }
        return {
            element: e,
            canvas: i,
            theme: n.theme,
            scale: d,
            zoomValue: r.value,
            canvasOffsetX: m,
            canvasOffsetY: p,
            boundTextElementVersion: $e68ba20b3d2d159d$var$te(e, t)?.version || null,
            containingFrameOpacity: $e68ba20b3d2d159d$var$rr(e, t)?.opacity || 100,
            boundTextCanvas: g,
            angle: e.angle
        };
    }, $e68ba20b3d2d159d$var$gT = 14, $e68ba20b3d2d159d$var$ZT = document.createElement("img");
    $e68ba20b3d2d159d$var$ZT.src = `data:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.svg},${encodeURIComponent('<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="image" class="svg-inline--fa fa-image fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#888" d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>')}`;
    $e68ba20b3d2d159d$var$jT = document.createElement("img");
    $e68ba20b3d2d159d$var$jT.src = `data:${$e68ba20b3d2d159d$export$edfb5d7e4280f611.svg},${encodeURIComponent('<svg viewBox="0 0 668 668" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48ZM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56ZM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48Z" style="fill:#888;fill-rule:nonzero" transform="matrix(.81709 0 0 .81709 124.825 145.825)"/><path d="M256 8C119.034 8 8 119.033 8 256c0 136.967 111.034 248 248 248s248-111.034 248-248S392.967 8 256 8Zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676ZM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676Z" style="fill:#888;fill-rule:nonzero" transform="matrix(.30366 0 0 .30366 506.822 60.065)"/></svg>')}`;
    $e68ba20b3d2d159d$var$ik = (e, t)=>{
        t.fillStyle = "#E7E7E7", t.fillRect(0, 0, e.width, e.height);
        let r = Math.min(e.width, e.height), o = Math.min(r, Math.min(r * .4, 100));
        t.drawImage(e.status === "error" ? $e68ba20b3d2d159d$var$jT : $e68ba20b3d2d159d$var$ZT, e.width / 2 - o / 2, e.height / 2 - o / 2, o, o);
    }, $e68ba20b3d2d159d$var$Fu = (e, t, r, o, n)=>{
        switch(e.type){
            case "rectangle":
            case "iframe":
            case "embeddable":
            case "diamond":
            case "ellipse":
                r.lineJoin = "round", r.lineCap = "round", t.draw($e68ba20b3d2d159d$var$Oe.get(e));
                break;
            case "arrow":
            case "line":
                r.lineJoin = "round", r.lineCap = "round", $e68ba20b3d2d159d$var$Oe.get(e).forEach((i)=>{
                    t.draw(i);
                });
                break;
            case "freedraw":
                {
                    r.save(), r.fillStyle = e.strokeColor;
                    let i = $e68ba20b3d2d159d$var$ak(e), a = $e68ba20b3d2d159d$var$Oe.get(e);
                    a && t.draw(a), r.fillStyle = e.strokeColor, r.fill(i), r.restore();
                    break;
                }
            case "image":
                {
                    let i = $e68ba20b3d2d159d$var$Nr(e) ? o.imageCache.get(e.fileId)?.image : void 0;
                    i != null && !(i instanceof Promise) ? (e.roundness && r.roundRect && (r.beginPath(), r.roundRect(0, 0, e.width, e.height, $e68ba20b3d2d159d$var$xo(Math.min(e.width, e.height), e)), r.clip()), r.drawImage(i, 0, 0, e.width, e.height)) : $e68ba20b3d2d159d$var$ik(e, r);
                    break;
                }
            default:
                if ($e68ba20b3d2d159d$var$G(e)) {
                    let i = $e68ba20b3d2d159d$var$Km(e.text), a = i && !r.canvas.isConnected;
                    a && document.body.appendChild(r.canvas), r.canvas.setAttribute("dir", i ? "rtl" : "ltr"), r.save(), r.font = $e68ba20b3d2d159d$var$ke(e), r.fillStyle = e.strokeColor, r.textAlign = e.textAlign;
                    let s = e.text.replace(/\r\n?/g, `
`).split(`
`), l = e.textAlign === "center" ? e.width / 2 : e.textAlign === "right" ? e.width : 0, c = $e68ba20b3d2d159d$var$oa(e.fontSize, e.lineHeight), d = $e68ba20b3d2d159d$var$au(e.fontFamily, e.fontSize, c);
                    for(let m = 0; m < s.length; m++)r.fillText(s[m], l, m * c + d);
                    r.restore(), a && r.canvas.remove();
                } else throw new Error(`Unimplemented type ${e.type}`);
        }
    }, $e68ba20b3d2d159d$var$mp = new WeakMap, $e68ba20b3d2d159d$var$WT = (e, t, r, o)=>{
        let n = r ? o.zoom : $e68ba20b3d2d159d$var$rk.zoom, i = $e68ba20b3d2d159d$var$mp.get(e), a = i && i.zoomValue !== n.value && !o?.shouldCacheIgnoreZoom, s = $e68ba20b3d2d159d$var$te(e, t), l = s?.version || null, c = $e68ba20b3d2d159d$var$rr(e, t)?.opacity || 100;
        if (!i || a || i.theme !== o.theme || i.boundTextElementVersion !== l || i.containingFrameOpacity !== c || $e68ba20b3d2d159d$var$ie(e) && s && e.angle !== i.angle) {
            let d = $e68ba20b3d2d159d$var$nk(e, t, n, r, o);
            return d ? ($e68ba20b3d2d159d$var$mp.set(e, d), d) : null;
        }
        return i;
    }, $e68ba20b3d2d159d$var$VT = (e, t, r, o, n)=>{
        let i = e.element, a = $e68ba20b3d2d159d$var$Bu(i), s = e.scale, [l, c, d, m] = $e68ba20b3d2d159d$var$ae(i, n), p = ((l + d) / 2 + o.scrollX) * window.devicePixelRatio, u = ((c + m) / 2 + o.scrollY) * window.devicePixelRatio;
        t.save(), t.scale(1 / window.devicePixelRatio, 1 / window.devicePixelRatio);
        let h = $e68ba20b3d2d159d$var$te(i, n);
        if ($e68ba20b3d2d159d$var$ie(i) && h) {
            let g = (e.boundTextCanvas.width - e.canvas.width) / 2, b = (e.boundTextCanvas.height - e.canvas.height) / 2;
            t.translate(p, u), t.drawImage(e.boundTextCanvas, -(d - l) / 2 * window.devicePixelRatio - g / s - a, -(m - c) / 2 * window.devicePixelRatio - b / s - a, e.boundTextCanvas.width / s, e.boundTextCanvas.height / s);
        } else if (t.translate(p, u), t.rotate(i.angle), "scale" in e.element && !$e68ba20b3d2d159d$var$KT(i, r) && t.scale(e.element.scale[0], e.element.scale[1]), t.translate(-p, -u), t.drawImage(e.canvas, (l + o.scrollX) * window.devicePixelRatio - a * e.scale / e.scale, (c + o.scrollY) * window.devicePixelRatio - a * e.scale / e.scale, e.canvas.width / e.scale, e.canvas.height / e.scale), $e68ba20b3d2d159d$var$T.VITE_APP_DEBUG_ENABLE_TEXT_CONTAINER_BOUNDING_BOX === "true" && $e68ba20b3d2d159d$var$It(i)) {
            let g = $e68ba20b3d2d159d$var$te(i, n), b = $e68ba20b3d2d159d$var$BE(i);
            t.strokeStyle = "#c92a2a", t.lineWidth = 3, t.strokeRect((b.x + o.scrollX) * window.devicePixelRatio, (b.y + o.scrollY) * window.devicePixelRatio, $e68ba20b3d2d159d$var$Mr(i, g) * window.devicePixelRatio, $e68ba20b3d2d159d$var$us(i, g) * window.devicePixelRatio);
        }
        t.restore();
    }, $e68ba20b3d2d159d$var$qT = (e, t, r, o)=>{
        t.save(), t.translate(e.x + r.scrollX, e.y + r.scrollY), t.fillStyle = "rgba(0, 0, 200, 0.04)";
        let n = .5 / r.zoom.value;
        t.fillRect(n, n, e.width, e.height), t.lineWidth = 1 / r.zoom.value, t.strokeStyle = o, t.strokeRect(n, n, e.width, e.height), t.restore();
    }, $e68ba20b3d2d159d$var$wi = (e, t, r, o, n, i, a)=>{
        switch(n.globalAlpha = $e68ba20b3d2d159d$var$FE(e, $e68ba20b3d2d159d$var$rr(e, t), i.elementsPendingErasure, i.pendingFlowchartNodes), e.type){
            case "magicframe":
            case "frame":
                a.frameRendering.enabled && a.frameRendering.outline && (n.save(), n.translate(e.x + a.scrollX, e.y + a.scrollY), n.fillStyle = "rgba(0, 0, 200, 0.04)", n.lineWidth = $e68ba20b3d2d159d$var$ot.strokeWidth / a.zoom.value, n.strokeStyle = $e68ba20b3d2d159d$var$ot.strokeColor, $e68ba20b3d2d159d$var$$s(e) && (n.strokeStyle = a.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? "#7affd7" : "#1d8264"), $e68ba20b3d2d159d$var$ot.radius && n.roundRect ? (n.beginPath(), n.roundRect(0, 0, e.width, e.height, $e68ba20b3d2d159d$var$ot.radius / a.zoom.value), n.stroke(), n.closePath()) : n.strokeRect(0, 0, e.width, e.height), n.restore());
                break;
            case "freedraw":
                if ($e68ba20b3d2d159d$var$Oe.generateElementShape(e, null), i.isExporting) {
                    let [s, l, c, d] = $e68ba20b3d2d159d$var$ae(e, t), m = (s + c) / 2 + a.scrollX, p = (l + d) / 2 + a.scrollY, u = (c - s) / 2 - (e.x - s), h = (d - l) / 2 - (e.y - l);
                    n.save(), n.translate(m, p), n.rotate(e.angle), n.translate(-u, -h), $e68ba20b3d2d159d$var$Fu(e, o, n, i, a), n.restore();
                } else {
                    let s = $e68ba20b3d2d159d$var$WT(e, r, i, a);
                    if (!s) return;
                    $e68ba20b3d2d159d$var$VT(s, n, i, a, r);
                }
                break;
            case "rectangle":
            case "diamond":
            case "ellipse":
            case "line":
            case "arrow":
            case "image":
            case "text":
            case "iframe":
            case "embeddable":
                if ($e68ba20b3d2d159d$var$Oe.generateElementShape(e, i), i.isExporting) {
                    let [s, l, c, d] = $e68ba20b3d2d159d$var$ae(e, t), m = (s + c) / 2 + a.scrollX, p = (l + d) / 2 + a.scrollY, u = (c - s) / 2 - (e.x - s), h = (d - l) / 2 - (e.y - l);
                    if ($e68ba20b3d2d159d$var$G(e)) {
                        let b = $e68ba20b3d2d159d$var$bt(e, t);
                        if ($e68ba20b3d2d159d$var$ie(b)) {
                            let v = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(b, e, t);
                            u = (c - s) / 2 - (v.x - s), h = (d - l) / 2 - (v.y - l);
                        }
                    }
                    n.save(), n.translate(m, p), $e68ba20b3d2d159d$var$$T(e, i, a) && (n.filter = "none");
                    let g = $e68ba20b3d2d159d$var$te(e, t);
                    if ($e68ba20b3d2d159d$var$ie(e) && g) {
                        let b = document.createElement("canvas"), v = b.getContext("2d"), y = Math.max($e68ba20b3d2d159d$var$Wt(s, c), $e68ba20b3d2d159d$var$Wt(l, d)), w = $e68ba20b3d2d159d$var$Bu(e);
                        b.width = y * a.exportScale + w * 10 * a.exportScale, b.height = y * a.exportScale + w * 10 * a.exportScale, v.translate(b.width / 2, b.height / 2), v.scale(a.exportScale, a.exportScale), u = e.width / 2 - (e.x - s), h = e.height / 2 - (e.y - l), v.rotate(e.angle);
                        let I = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).canvas(b);
                        v.translate(-u, -h), $e68ba20b3d2d159d$var$Fu(e, I, v, i, a), v.translate(u, h), v.rotate(-e.angle);
                        let [, , , , M, C] = $e68ba20b3d2d159d$var$ae(g, t), P = (s + c) / 2 - M, k = (l + d) / 2 - C;
                        v.translate(-P, -k), v.clearRect(-g.width / 2, -g.height / 2, g.width, g.height), n.scale(1 / a.exportScale, 1 / a.exportScale), n.drawImage(b, -b.width / 2, -b.height / 2, b.width, b.height);
                    } else n.rotate(e.angle), e.type === "image" && n.scale(e.scale[0], e.scale[1]), n.translate(-u, -h), $e68ba20b3d2d159d$var$Fu(e, o, n, i, a);
                    n.restore();
                } else {
                    let s = $e68ba20b3d2d159d$var$WT(e, r, i, a);
                    if (!s) return;
                    let l = n.imageSmoothingEnabled;
                    !a?.shouldCacheIgnoreZoom && (!e.angle || $e68ba20b3d2d159d$var$e3(e.angle)) && (n.imageSmoothingEnabled = !1), $e68ba20b3d2d159d$var$VT(s, n, i, a, r), n.imageSmoothingEnabled = l;
                }
                break;
            default:
                throw new Error(`Unimplemented type ${e.type}`);
        }
        n.globalAlpha = 1;
    }, $e68ba20b3d2d159d$var$JT = new WeakMap([]);
    $e68ba20b3d2d159d$var$sk = /(\s?[A-Z]?,?-?[0-9]*\.[0-9]{0,2})(([0-9]|e|-)*)/g;
});
var $e68ba20b3d2d159d$var$Ti, $e68ba20b3d2d159d$var$Id, $e68ba20b3d2d159d$var$zu, $e68ba20b3d2d159d$var$Hu, $e68ba20b3d2d159d$var$Dl, $e68ba20b3d2d159d$var$zE, $e68ba20b3d2d159d$var$hs, $e68ba20b3d2d159d$var$sE, $e68ba20b3d2d159d$var$Cd = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Ti = (e)=>e === "rectangle" || e === "iframe" || e === "embeddable" || e === "ellipse" || e === "diamond" || e === "line" || e === "freedraw", $e68ba20b3d2d159d$var$Id = (e)=>e !== "image" && e !== "frame" && e !== "magicframe", $e68ba20b3d2d159d$var$zu = (e)=>e === "rectangle" || e === "iframe" || e === "embeddable" || e === "ellipse" || e === "diamond" || e === "freedraw" || e === "arrow" || e === "line", $e68ba20b3d2d159d$var$Hu = (e)=>e === "rectangle" || e === "iframe" || e === "embeddable" || e === "ellipse" || e === "diamond" || e === "arrow" || e === "line", $e68ba20b3d2d159d$var$Dl = (e)=>e === "rectangle" || e === "iframe" || e === "embeddable" || e === "line" || e === "diamond" || e === "image", $e68ba20b3d2d159d$var$zE = (e)=>e === "arrow", $e68ba20b3d2d159d$var$hs = (e)=>e === "arrow", $e68ba20b3d2d159d$var$sE = (e, t)=>{
        let r = null;
        for(let o = e.length - 1; o >= 0; --o){
            let n = e[o];
            if (!n.isDeleted && t(n)) {
                r = n;
                break;
            }
        }
        return r;
    };
});
function $e68ba20b3d2d159d$var$mk(e) {
    let t = e.roughness, r = Math.max(e.width, e.height), o = Math.min(e.width, e.height);
    return o >= 20 && r >= 50 || o >= 15 && e.roundness && $e68ba20b3d2d159d$var$Dl(e.type) || $e68ba20b3d2d159d$export$5df2ebb939539835(e) && r >= 50 ? t : Math.min(t / (r < 10 ? 3 : 2), 2.5);
}
var $e68ba20b3d2d159d$var$dk, $e68ba20b3d2d159d$var$o3, $e68ba20b3d2d159d$var$ro, $e68ba20b3d2d159d$var$t3, $e68ba20b3d2d159d$var$r3, $e68ba20b3d2d159d$var$by, $e68ba20b3d2d159d$var$pk, $e68ba20b3d2d159d$var$hf = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$Fn();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Cd();
    $e68ba20b3d2d159d$var$dk = (e)=>[
            8,
            8 + e
        ], $e68ba20b3d2d159d$var$o3 = (e)=>[
            1.5,
            6 + e
        ];
    $e68ba20b3d2d159d$var$ro = (e, t = !1)=>{
        let r = {
            seed: e.seed,
            strokeLineDash: e.strokeStyle === "dashed" ? $e68ba20b3d2d159d$var$dk(e.strokeWidth) : e.strokeStyle === "dotted" ? $e68ba20b3d2d159d$var$o3(e.strokeWidth) : void 0,
            disableMultiStroke: e.strokeStyle !== "solid",
            strokeWidth: e.strokeStyle !== "solid" ? e.strokeWidth + .5 : e.strokeWidth,
            fillWeight: e.strokeWidth / 2,
            hachureGap: e.strokeWidth * 4,
            roughness: $e68ba20b3d2d159d$var$mk(e),
            stroke: e.strokeColor,
            preserveVertices: t || e.roughness < $e68ba20b3d2d159d$var$of.cartoonist
        };
        switch(e.type){
            case "rectangle":
            case "iframe":
            case "embeddable":
            case "diamond":
            case "ellipse":
                return r.fillStyle = e.fillStyle, r.fill = $e68ba20b3d2d159d$var$Rr(e.backgroundColor) ? void 0 : e.backgroundColor, e.type === "ellipse" && (r.curveFitting = 1), r;
            case "line":
            case "freedraw":
                return $e68ba20b3d2d159d$var$Br(e.points) && (r.fillStyle = e.fillStyle, r.fill = e.backgroundColor === "transparent" ? void 0 : e.backgroundColor), r;
            case "arrow":
                return r;
            default:
                throw new Error(`Unimplemented type ${e.type}`);
        }
    }, $e68ba20b3d2d159d$var$t3 = (e, t, r)=>$e68ba20b3d2d159d$var$cr(e) && (t || $e68ba20b3d2d159d$var$Rt(e) && r?.get(e.id) !== !0) && $e68ba20b3d2d159d$var$Rr(e.backgroundColor) && $e68ba20b3d2d159d$var$Rr(e.strokeColor) ? {
            ...e,
            roughness: 0,
            backgroundColor: "#d3d3d3",
            fillStyle: "solid"
        } : $e68ba20b3d2d159d$var$Mo(e) ? {
            ...e,
            strokeColor: $e68ba20b3d2d159d$var$Rr(e.strokeColor) ? "#000000" : e.strokeColor,
            backgroundColor: $e68ba20b3d2d159d$var$Rr(e.backgroundColor) ? "#f4f4f6" : e.backgroundColor
        } : e, $e68ba20b3d2d159d$var$r3 = (e, t, r, o, n, i, a)=>{
        let s = $e68ba20b3d2d159d$var$UE(e, t, r, o);
        if (s === null) return [];
        switch(o){
            case "dot":
            case "circle":
            case "circle_outline":
                {
                    let [l, c, d] = s;
                    return delete i.strokeLineDash, [
                        n.circle(l, c, d, {
                            ...i,
                            fill: o === "circle_outline" ? a : e.strokeColor,
                            fillStyle: "solid",
                            stroke: e.strokeColor,
                            roughness: Math.min(.5, i.roughness || 0)
                        })
                    ];
                }
            case "triangle":
            case "triangle_outline":
                {
                    let [l, c, d, m, p, u] = s;
                    return delete i.strokeLineDash, [
                        n.polygon([
                            [
                                l,
                                c
                            ],
                            [
                                d,
                                m
                            ],
                            [
                                p,
                                u
                            ],
                            [
                                l,
                                c
                            ]
                        ], {
                            ...i,
                            fill: o === "triangle_outline" ? a : e.strokeColor,
                            fillStyle: "solid",
                            roughness: Math.min(1, i.roughness || 0)
                        })
                    ];
                }
            case "diamond":
            case "diamond_outline":
                {
                    let [l, c, d, m, p, u, h, g] = s;
                    return delete i.strokeLineDash, [
                        n.polygon([
                            [
                                l,
                                c
                            ],
                            [
                                d,
                                m
                            ],
                            [
                                p,
                                u
                            ],
                            [
                                h,
                                g
                            ],
                            [
                                l,
                                c
                            ]
                        ], {
                            ...i,
                            fill: o === "diamond_outline" ? a : e.strokeColor,
                            fillStyle: "solid",
                            roughness: Math.min(1, i.roughness || 0)
                        })
                    ];
                }
            case "bar":
            case "arrow":
            default:
                {
                    let [l, c, d, m, p, u] = s;
                    if (e.strokeStyle === "dotted") {
                        let h = $e68ba20b3d2d159d$var$o3(e.strokeWidth - 1);
                        i.strokeLineDash = [
                            h[0],
                            h[1] - 1
                        ];
                    } else delete i.strokeLineDash;
                    return i.roughness = Math.min(1, i.roughness || 0), [
                        n.line(d, m, l, c, i),
                        n.line(p, u, l, c, i)
                    ];
                }
        }
    }, $e68ba20b3d2d159d$var$by = (e, t, { isExporting: r, canvasBackgroundColor: o, embedsValidationStatus: n })=>{
        switch(e.type){
            case "rectangle":
            case "iframe":
            case "embeddable":
                {
                    let i;
                    if (e.roundness) {
                        let a = e.width, s = e.height, l = $e68ba20b3d2d159d$var$xo(Math.min(a, s), e);
                        i = t.path(`M ${l} 0 L ${a - l} 0 Q ${a} 0, ${a} ${l} L ${a} ${s - l} Q ${a} ${s}, ${a - l} ${s} L ${l} ${s} Q 0 ${s}, 0 ${s - l} L 0 ${l} Q 0 0, ${l} 0`, $e68ba20b3d2d159d$var$ro($e68ba20b3d2d159d$var$t3(e, r, n), !0));
                    } else i = t.rectangle(0, 0, e.width, e.height, $e68ba20b3d2d159d$var$ro($e68ba20b3d2d159d$var$t3(e, r, n), !1));
                    return i;
                }
            case "diamond":
                {
                    let i, [a, s, l, c, d, m, p, u] = $e68ba20b3d2d159d$var$HE(e);
                    if (e.roundness) {
                        let h = $e68ba20b3d2d159d$var$xo(Math.abs(a - p), e), g = $e68ba20b3d2d159d$var$xo(Math.abs(c - s), e);
                        i = t.path(`M ${a + h} ${s + g} L ${l - h} ${c - g}
            C ${l} ${c}, ${l} ${c}, ${l - h} ${c + g}
            L ${d + h} ${m - g}
            C ${d} ${m}, ${d} ${m}, ${d - h} ${m - g}
            L ${p + h} ${u + g}
            C ${p} ${u}, ${p} ${u}, ${p + h} ${u - g}
            L ${a - h} ${s + g}
            C ${a} ${s}, ${a} ${s}, ${a + h} ${s + g}`, $e68ba20b3d2d159d$var$ro(e, !0));
                    } else i = t.polygon([
                        [
                            a,
                            s
                        ],
                        [
                            l,
                            c
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            p,
                            u
                        ]
                    ], $e68ba20b3d2d159d$var$ro(e));
                    return i;
                }
            case "ellipse":
                return t.ellipse(e.width / 2, e.height / 2, e.width, e.height, $e68ba20b3d2d159d$var$ro(e));
            case "line":
            case "arrow":
                {
                    let i, a = $e68ba20b3d2d159d$var$ro(e), s = e.points.length ? e.points : [
                        [
                            0,
                            0
                        ]
                    ];
                    if ($e68ba20b3d2d159d$var$ce(e) ? i = [
                        t.path($e68ba20b3d2d159d$var$pk(s, 16), $e68ba20b3d2d159d$var$ro(e, !0))
                    ] : e.roundness ? i = [
                        t.curve(s, a)
                    ] : a.fill ? i = [
                        t.polygon(s, a)
                    ] : i = [
                        t.linearPath(s, a)
                    ], e.type === "arrow") {
                        let { startArrowhead: l = null, endArrowhead: c = "arrow" } = e;
                        if (l !== null) {
                            let d = $e68ba20b3d2d159d$var$r3(e, i, "start", l, t, a, o);
                            i.push(...d);
                        }
                        if (c !== null) {
                            let d = $e68ba20b3d2d159d$var$r3(e, i, "end", c, t, a, o);
                            i.push(...d);
                        }
                    }
                    return i;
                }
            case "freedraw":
                {
                    let i;
                    if ($e68ba20b3d2d159d$var$QT(e), $e68ba20b3d2d159d$var$Br(e.points)) {
                        let a = (0, $989397d018ece9d6$export$798b53621063651)(e.points, .75);
                        i = t.curve(a, {
                            ...$e68ba20b3d2d159d$var$ro(e),
                            stroke: "none"
                        });
                    } else i = null;
                    return i;
                }
            case "frame":
            case "magicframe":
            case "text":
            case "image":
                return null;
            default:
                return $e68ba20b3d2d159d$var$Zo(e, `generateElementShape(): Unimplemented type ${e?.type}`), null;
        }
    }, $e68ba20b3d2d159d$var$pk = (e, t)=>{
        let r = [];
        for(let n = 1; n < e.length - 1; n += 1){
            let i = e[n - 1], a = e[n + 1], s = Math.min(t, Math.sqrt($e68ba20b3d2d159d$var$gl(e[n], a)) / 2, Math.sqrt($e68ba20b3d2d159d$var$gl(e[n], i)) / 2);
            i[0] < e[n][0] && i[1] === e[n][1] ? r.push([
                e[n][0] - s,
                e[n][1]
            ]) : i[0] === e[n][0] && i[1] < e[n][1] ? r.push([
                e[n][0],
                e[n][1] - s
            ]) : i[0] > e[n][0] && i[1] === e[n][1] ? r.push([
                e[n][0] + s,
                e[n][1]
            ]) : r.push([
                e[n][0],
                e[n][1] + s
            ]), r.push(e[n]), a[0] < e[n][0] && a[1] === e[n][1] ? r.push([
                e[n][0] - s,
                e[n][1]
            ]) : a[0] === e[n][0] && a[1] < e[n][1] ? r.push([
                e[n][0],
                e[n][1] - s
            ]) : a[0] > e[n][0] && a[1] === e[n][1] ? r.push([
                e[n][0] + s,
                e[n][1]
            ]) : r.push([
                e[n][0],
                e[n][1] + s
            ]);
        }
        let o = [
            `M ${e[0][0]} ${e[0][1]}`
        ];
        for(let n = 0; n < r.length; n += 3)o.push(`L ${r[n][0]} ${r[n][1]}`), o.push(`Q ${r[n + 1][0]} ${r[n + 1][1]}, ${r[n + 2][0]} ${r[n + 2][1]}`);
        return o.push(`L ${e[e.length - 1][0]} ${e[e.length - 1][1]}`), o.join(" ");
    };
});
var $e68ba20b3d2d159d$var$GE, $e68ba20b3d2d159d$var$ae, $e68ba20b3d2d159d$var$RE, $e68ba20b3d2d159d$var$HE, $e68ba20b3d2d159d$var$sa, $e68ba20b3d2d159d$var$n3, $e68ba20b3d2d159d$var$i3, $e68ba20b3d2d159d$var$uk, $e68ba20b3d2d159d$var$Ad, $e68ba20b3d2d159d$var$VE, $e68ba20b3d2d159d$var$hk, $e68ba20b3d2d159d$var$gk, $e68ba20b3d2d159d$var$fk, $e68ba20b3d2d159d$var$UE, $e68ba20b3d2d159d$var$Ek, $e68ba20b3d2d159d$var$xk, $e68ba20b3d2d159d$var$go, $e68ba20b3d2d159d$export$3e54c0515ef60d1d, $e68ba20b3d2d159d$var$Uu, $e68ba20b3d2d159d$var$Ei, $e68ba20b3d2d159d$var$YE, $e68ba20b3d2d159d$var$XE, $e68ba20b3d2d159d$var$oo, $e68ba20b3d2d159d$export$88b92c9ed786194d, $e68ba20b3d2d159d$var$dt = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$hf();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$$a();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$GE = class e {
        static boundsCache = new WeakMap;
        static getBounds(t, r) {
            let o = e.boundsCache.get(t);
            if (o?.version && o.version === t.version && !$e68ba20b3d2d159d$var$Ge(t)) return o.bounds;
            let n = e.calculateBounds(t, r);
            return e.boundsCache.set(t, {
                version: t.version,
                bounds: n
            }), n;
        }
        static calculateBounds(t, r) {
            let o, [n, i, a, s, l, c] = $e68ba20b3d2d159d$var$ae(t, r);
            if ($e68ba20b3d2d159d$var$qt(t)) {
                let [d, m, p, u] = $e68ba20b3d2d159d$var$VE(t.points.map(([h, g])=>$e68ba20b3d2d159d$var$Ee(h, g, l - t.x, c - t.y, t.angle)));
                return [
                    d + t.x,
                    m + t.y,
                    p + t.x,
                    u + t.y
                ];
            } else if ($e68ba20b3d2d159d$export$5df2ebb939539835(t)) o = $e68ba20b3d2d159d$var$xk(t, l, c, r);
            else if (t.type === "diamond") {
                let [d, m] = $e68ba20b3d2d159d$var$Ee(l, i, l, c, t.angle), [p, u] = $e68ba20b3d2d159d$var$Ee(l, s, l, c, t.angle), [h, g] = $e68ba20b3d2d159d$var$Ee(n, c, l, c, t.angle), [b, v] = $e68ba20b3d2d159d$var$Ee(a, c, l, c, t.angle), y = Math.min(d, p, h, b), w = Math.min(m, u, g, v), I = Math.max(d, p, h, b), M = Math.max(m, u, g, v);
                o = [
                    y,
                    w,
                    I,
                    M
                ];
            } else if (t.type === "ellipse") {
                let d = (a - n) / 2, m = (s - i) / 2, p = Math.cos(t.angle), u = Math.sin(t.angle), h = Math.hypot(d * p, m * u), g = Math.hypot(m * p, d * u);
                o = [
                    l - h,
                    c - g,
                    l + h,
                    c + g
                ];
            } else {
                let [d, m] = $e68ba20b3d2d159d$var$Ee(n, i, l, c, t.angle), [p, u] = $e68ba20b3d2d159d$var$Ee(n, s, l, c, t.angle), [h, g] = $e68ba20b3d2d159d$var$Ee(a, s, l, c, t.angle), [b, v] = $e68ba20b3d2d159d$var$Ee(a, i, l, c, t.angle), y = Math.min(d, p, h, b), w = Math.min(m, u, g, v), I = Math.max(d, p, h, b), M = Math.max(m, u, g, v);
                o = [
                    y,
                    w,
                    I,
                    M
                ];
            }
            return o;
        }
    }, $e68ba20b3d2d159d$var$ae = (e, t, r = !1)=>{
        if ($e68ba20b3d2d159d$var$qt(e)) return $e68ba20b3d2d159d$var$hk(e);
        if ($e68ba20b3d2d159d$export$5df2ebb939539835(e)) return $e68ba20b3d2d159d$var$$.getElementAbsoluteCoords(e, t, r);
        if ($e68ba20b3d2d159d$var$G(e)) {
            let o = t ? $e68ba20b3d2d159d$var$bt(e, t) : null;
            if ($e68ba20b3d2d159d$var$ie(o)) {
                let n = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(o, e, t);
                return [
                    n.x,
                    n.y,
                    n.x + e.width,
                    n.y + e.height,
                    n.x + e.width / 2,
                    n.y + e.height / 2
                ];
            }
        }
        return [
            e.x,
            e.y,
            e.x + e.width,
            e.y + e.height,
            e.x + e.width / 2,
            e.y + e.height / 2
        ];
    }, $e68ba20b3d2d159d$var$RE = (e, t)=>{
        let [r, o, n, i, a, s] = $e68ba20b3d2d159d$var$ae(e, t), l = [
            a,
            s
        ];
        if ($e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e)) {
            let v = [], y = 0;
            for(; y < e.points.length - 1;)v.push([
                $e68ba20b3d2d159d$var$J([
                    e.points[y][0] + e.x,
                    e.points[y][1] + e.y
                ], l, e.angle),
                $e68ba20b3d2d159d$var$J([
                    e.points[y + 1][0] + e.x,
                    e.points[y + 1][1] + e.y
                ], l, e.angle)
            ]), y++;
            return v;
        }
        let [c, d, m, p, u, h, g, b] = [
            [
                r,
                o
            ],
            [
                n,
                o
            ],
            [
                r,
                i
            ],
            [
                n,
                i
            ],
            [
                a,
                o
            ],
            [
                a,
                i
            ],
            [
                r,
                s
            ],
            [
                n,
                s
            ]
        ].map((v)=>$e68ba20b3d2d159d$var$J(v, l, e.angle));
        return e.type === "diamond" ? [
            [
                u,
                g
            ],
            [
                u,
                b
            ],
            [
                h,
                g
            ],
            [
                h,
                b
            ]
        ] : e.type === "ellipse" ? [
            [
                u,
                g
            ],
            [
                u,
                b
            ],
            [
                h,
                g
            ],
            [
                h,
                b
            ],
            [
                u,
                g
            ],
            [
                u,
                b
            ],
            [
                h,
                g
            ],
            [
                h,
                b
            ]
        ] : [
            [
                c,
                d
            ],
            [
                m,
                p
            ],
            [
                c,
                m
            ],
            [
                d,
                p
            ],
            [
                c,
                b
            ],
            [
                m,
                b
            ],
            [
                d,
                g
            ],
            [
                p,
                g
            ]
        ];
    }, $e68ba20b3d2d159d$var$HE = (e)=>{
        let t = Math.floor(e.width / 2) + 1, r = 0, o = e.width, n = Math.floor(e.height / 2) + 1, i = t, a = e.height;
        return [
            t,
            r,
            o,
            n,
            i,
            a,
            0,
            n
        ];
    }, $e68ba20b3d2d159d$var$sa = (e)=>{
        for (let t of e.sets)if (t.type === "path") return t.ops;
        return e.sets[0].ops;
    }, $e68ba20b3d2d159d$var$n3 = (e, t, r, o, n)=>{
        let i = 1 - e;
        return Math.pow(i, 3) * t + 3 * Math.pow(i, 2) * e * r + 3 * i * Math.pow(e, 2) * o + Math.pow(e, 3) * n;
    }, $e68ba20b3d2d159d$var$i3 = (e, t, r, o)=>{
        let n = t - e, i = r - t, a = o - r, s = 3 * n - 6 * i + 3 * a, l = 6 * i - 6 * n, c = 3 * n, d = l * l - 4 * s * c;
        if (!(d >= 0)) return !1;
        let p = null, u = null, h = 1 / 0, g = 1 / 0;
        return s === 0 ? h = g = -c / l : (h = (-l + Math.sqrt(d)) / (2 * s), g = (-l - Math.sqrt(d)) / (2 * s)), h >= 0 && h <= 1 && (p = $e68ba20b3d2d159d$var$n3(h, e, t, r, o)), g >= 0 && g <= 1 && (u = $e68ba20b3d2d159d$var$n3(g, e, t, r, o)), [
            p,
            u
        ];
    }, $e68ba20b3d2d159d$var$uk = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$i3(e[0], t[0], r[0], o[0]), i = $e68ba20b3d2d159d$var$i3(e[1], t[1], r[1], o[1]), a = Math.min(e[0], o[0]), s = Math.max(e[0], o[0]);
        if (n) {
            let d = n.filter((m)=>m !== null);
            a = Math.min(a, ...d), s = Math.max(s, ...d);
        }
        let l = Math.min(e[1], o[1]), c = Math.max(e[1], o[1]);
        if (i) {
            let d = i.filter((m)=>m !== null);
            l = Math.min(l, ...d), c = Math.max(c, ...d);
        }
        return [
            a,
            l,
            s,
            c
        ];
    }, $e68ba20b3d2d159d$var$Ad = (e, t)=>{
        let r = [
            0,
            0
        ], { minX: o, minY: n, maxX: i, maxY: a } = e.reduce((s, { op: l, data: c })=>{
            if (l === "move") r = c;
            else if (l === "bcurveTo") {
                let d = [
                    c[0],
                    c[1]
                ], m = [
                    c[2],
                    c[3]
                ], p = [
                    c[4],
                    c[5]
                ], u = t ? t(...d) : d, h = t ? t(...m) : m, g = t ? t(...p) : p, b = t ? t(...r) : r;
                r = p;
                let [v, y, w, I] = $e68ba20b3d2d159d$var$uk(b, u, h, g);
                s.minX = Math.min(s.minX, v), s.minY = Math.min(s.minY, y), s.maxX = Math.max(s.maxX, w), s.maxY = Math.max(s.maxY, I);
            }
            return s;
        }, {
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        });
        return [
            o,
            n,
            i,
            a
        ];
    }, $e68ba20b3d2d159d$var$VE = (e)=>{
        let t = 1 / 0, r = 1 / 0, o = -1 / 0, n = -1 / 0;
        for (let [i, a] of e)t = Math.min(t, i), r = Math.min(r, a), o = Math.max(o, i), n = Math.max(n, a);
        return [
            t,
            r,
            o,
            n
        ];
    }, $e68ba20b3d2d159d$var$hk = (e)=>{
        let [t, r, o, n] = $e68ba20b3d2d159d$var$VE(e.points), i = t + e.x, a = r + e.y, s = o + e.x, l = n + e.y;
        return [
            i,
            a,
            s,
            l,
            (i + s) / 2,
            (a + l) / 2
        ];
    }, $e68ba20b3d2d159d$var$gk = (e)=>{
        switch(e){
            case "arrow":
                return 25;
            case "diamond":
            case "diamond_outline":
                return 12;
            default:
                return 15;
        }
    }, $e68ba20b3d2d159d$var$fk = (e)=>{
        switch(e){
            case "bar":
                return 90;
            case "arrow":
                return 20;
            default:
                return 25;
        }
    }, $e68ba20b3d2d159d$var$UE = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$sa(t[0]);
        if (n.length < 1) return null;
        let i = r === "start" ? 1 : n.length - 1, a = n[i].data, s = [
            a[4],
            a[5]
        ], l = [
            a[2],
            a[3]
        ], c = [
            a[0],
            a[1]
        ], d = n[i - 1], m = [
            0,
            0
        ];
        d.op === "move" ? m = d.data : d.op === "bcurveTo" && (m = [
            d.data[4],
            d.data[5]
        ]);
        let p = (N, H)=>Math.pow(1 - N, 3) * s[H] + 3 * N * Math.pow(1 - N, 2) * l[H] + 3 * Math.pow(N, 2) * (1 - N) * c[H] + m[H] * Math.pow(N, 3), [u, h] = r === "start" ? m : s, [g, b] = [
            p(.3, 0),
            p(.3, 1)
        ], v = Math.hypot(u - g, h - b), y = (u - g) / v, w = (h - b) / v, I = $e68ba20b3d2d159d$var$gk(o), M = 0;
        {
            let [N, H] = r === "end" ? e.points[e.points.length - 1] : e.points[0], [xe, X] = e.points.length > 1 ? r === "end" ? e.points[e.points.length - 2] : e.points[1] : [
                0,
                0
            ];
            M = Math.hypot(N - xe, H - X);
        }
        let P = Math.min(I, M * (o === "diamond" || o === "diamond_outline" ? .25 : .5)), k = u - y * P, _ = h - w * P;
        if (o === "dot" || o === "circle" || o === "circle_outline") {
            let N = Math.hypot(_ - h, k - u) + e.strokeWidth - 2;
            return [
                u,
                h,
                N
            ];
        }
        let A = $e68ba20b3d2d159d$var$fk(o), [R, B] = $e68ba20b3d2d159d$var$Ee(k, _, u, h, -A * Math.PI / 180), [V, ee] = $e68ba20b3d2d159d$var$Ee(k, _, u, h, A * Math.PI / 180);
        if (o === "diamond" || o === "diamond_outline") {
            let N, H;
            if (r === "start") {
                let [xe, X] = e.points.length > 1 ? e.points[1] : [
                    0,
                    0
                ];
                [N, H] = $e68ba20b3d2d159d$var$Ee(u + P * 2, h, u, h, Math.atan2(X - h, xe - u));
            } else {
                let [xe, X] = e.points.length > 1 ? e.points[e.points.length - 2] : [
                    0,
                    0
                ];
                [N, H] = $e68ba20b3d2d159d$var$Ee(u - P * 2, h, u, h, Math.atan2(h - X, u - xe));
            }
            return [
                u,
                h,
                R,
                B,
                N,
                H,
                V,
                ee
            ];
        }
        return [
            u,
            h,
            R,
            B,
            V,
            ee
        ];
    }, $e68ba20b3d2d159d$var$Ek = (e)=>{
        let t = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).generator(), r = $e68ba20b3d2d159d$var$ro(e), o = e.roundness ? "curve" : r.fill ? "polygon" : "linearPath";
        return t[o](e.points, r);
    }, $e68ba20b3d2d159d$var$xk = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$te(e, o);
        if (e.points.length < 2) {
            let [m, p] = e.points[0], [u, h] = $e68ba20b3d2d159d$var$Ee(e.x + m, e.y + p, t, r, e.angle), g = [
                u,
                h,
                u,
                h
            ];
            if (n) {
                let b = $e68ba20b3d2d159d$var$$.getMinMaxXYWithBoundText(e, o, [
                    u,
                    h,
                    u,
                    h
                ], n);
                g = [
                    b[0],
                    b[1],
                    b[2],
                    b[3]
                ];
            }
            return g;
        }
        let a = $e68ba20b3d2d159d$var$Oe.get(e)?.[0] ?? $e68ba20b3d2d159d$var$Ek(e), s = $e68ba20b3d2d159d$var$sa(a), c = $e68ba20b3d2d159d$var$Ad(s, (m, p)=>$e68ba20b3d2d159d$var$Ee(e.x + m, e.y + p, t, r, e.angle)), d = [
            c[0],
            c[1],
            c[2],
            c[3]
        ];
        if (n) {
            let m = $e68ba20b3d2d159d$var$$.getMinMaxXYWithBoundText(e, o, d, n);
            d = [
                m[0],
                m[1],
                m[2],
                m[3]
            ];
        }
        return d;
    }, $e68ba20b3d2d159d$var$go = (e, t)=>$e68ba20b3d2d159d$var$GE.getBounds(e, t), $e68ba20b3d2d159d$export$3e54c0515ef60d1d = (e, t)=>{
        if (!e.length) return [
            0,
            0,
            0,
            0
        ];
        let r = 1 / 0, o = -1 / 0, n = 1 / 0, i = -1 / 0, a = t || $e68ba20b3d2d159d$var$j(e);
        return e.forEach((s)=>{
            let [l, c, d, m] = $e68ba20b3d2d159d$var$go(s, a);
            r = Math.min(r, l), n = Math.min(n, c), o = Math.max(o, d), i = Math.max(i, m);
        }), [
            r,
            n,
            o,
            i
        ];
    }, $e68ba20b3d2d159d$var$Uu = (e, t)=>{
        let [r, o, n, i] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e);
        return [
            r + t.x,
            o + t.y,
            n + t.x,
            i + t.y
        ];
    }, $e68ba20b3d2d159d$var$Ei = (e, t, r, o)=>{
        if (!($e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e))) return [
            e.x,
            e.y,
            e.x + t,
            e.y + r
        ];
        let n = $e68ba20b3d2d159d$var$Ki(0, t, $e68ba20b3d2d159d$var$Ki(1, r, e.points, o), o), i;
        if ($e68ba20b3d2d159d$var$qt(e)) i = $e68ba20b3d2d159d$var$VE(n);
        else {
            let d = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).generator(), m = e.roundness ? d.curve(n, $e68ba20b3d2d159d$var$ro(e)) : d.linearPath(n, $e68ba20b3d2d159d$var$ro(e)), p = $e68ba20b3d2d159d$var$sa(m);
            i = $e68ba20b3d2d159d$var$Ad(p);
        }
        let [a, s, l, c] = i;
        return [
            a + e.x,
            s + e.y,
            l + e.x,
            c + e.y
        ];
    }, $e68ba20b3d2d159d$var$YE = (e, t)=>{
        let r = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).generator(), o = e.roundness == null ? r.linearPath(t, $e68ba20b3d2d159d$var$ro(e)) : r.curve(t, $e68ba20b3d2d159d$var$ro(e)), n = $e68ba20b3d2d159d$var$sa(o), [i, a, s, l] = $e68ba20b3d2d159d$var$Ad(n);
        return [
            i + e.x,
            a + e.y,
            s + e.x,
            l + e.y
        ];
    }, $e68ba20b3d2d159d$var$XE = (e, t)=>{
        if (!e.length) return [
            0,
            0,
            0,
            0
        ];
        let r = 1 / 0, o = e[0], n = $e68ba20b3d2d159d$var$j(e);
        return e.forEach((i)=>{
            let [a, s, l, c] = $e68ba20b3d2d159d$var$go(i, n), d = $e68ba20b3d2d159d$var$Lt((a + l) / 2, (s + c) / 2, t.x, t.y);
            d < r && (r = d, o = i);
        }), $e68ba20b3d2d159d$var$go(o, n);
    }, $e68ba20b3d2d159d$var$oo = (e)=>{
        let [t, r, o, n] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e);
        return {
            minX: t,
            minY: r,
            maxX: o,
            maxY: n,
            width: o - t,
            height: n - r,
            midX: (t + o) / 2,
            midY: (r + n) / 2
        };
    }, $e68ba20b3d2d159d$export$88b92c9ed786194d = ({ scrollX: e, scrollY: t, width: r, height: o, zoom: n })=>[
            -e,
            -t,
            -e + r / n.value,
            -t + o / n.value
        ];
});
var $e68ba20b3d2d159d$var$Ee, $e68ba20b3d2d159d$var$J, $e68ba20b3d2d159d$var$nT, $e68ba20b3d2d159d$var$Lt, $e68ba20b3d2d159d$var$gl, $e68ba20b3d2d159d$var$_l, $e68ba20b3d2d159d$var$Br, $e68ba20b3d2d159d$var$Wp, $e68ba20b3d2d159d$var$Ot, $e68ba20b3d2d159d$var$xo, $e68ba20b3d2d159d$var$ZE, $e68ba20b3d2d159d$var$jE, $e68ba20b3d2d159d$var$bk, $e68ba20b3d2d159d$var$a3, $e68ba20b3d2d159d$var$s3, $e68ba20b3d2d159d$var$l3, $e68ba20b3d2d159d$var$xn, $e68ba20b3d2d159d$var$e3, $e68ba20b3d2d159d$var$Rl, $e68ba20b3d2d159d$var$Nl, $e68ba20b3d2d159d$var$Md, $e68ba20b3d2d159d$var$kd, $e68ba20b3d2d159d$var$Td, $e68ba20b3d2d159d$var$Gu, $e68ba20b3d2d159d$var$Wc, $e68ba20b3d2d159d$var$hi, $e68ba20b3d2d159d$var$ln, $e68ba20b3d2d159d$var$$E, $e68ba20b3d2d159d$var$is, $e68ba20b3d2d159d$var$G2, $e68ba20b3d2d159d$var$Op, $e68ba20b3d2d159d$var$Qi, $e68ba20b3d2d159d$var$dn, $e68ba20b3d2d159d$var$Xp, $e68ba20b3d2d159d$var$Qp, $e68ba20b3d2d159d$var$Bn, $e68ba20b3d2d159d$var$c3, $e68ba20b3d2d159d$var$rt = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$Ee = (e, t, r, o, n)=>[
            (e - r) * Math.cos(n) - (t - o) * Math.sin(n) + r,
            (e - r) * Math.sin(n) + (t - o) * Math.cos(n) + o
        ], $e68ba20b3d2d159d$var$J = (e, t, r)=>$e68ba20b3d2d159d$var$Ee(e[0], e[1], t[0], t[1], r), $e68ba20b3d2d159d$var$nT = (e, t, r, o, n, i, a, s)=>{
        let l = Math.cos(o), c = Math.sin(o);
        return e.e && e.w ? t += n + a : e.e ? (t += n * (1 + l), r += n * c, t += a * (1 - l), r += a * -c) : e.w && (t += n * (1 - l), r += n * -c, t += a * (1 + l), r += a * c), e.n && e.s ? r += i + s : e.n ? (t += i * c, r += i * (1 - l), t += s * -c, r += s * (1 + l)) : e.s && (t += i * -c, r += i * (1 + l), t += s * c, r += s * (1 - l)), [
            t,
            r
        ];
    }, $e68ba20b3d2d159d$var$Lt = (e, t, r, o)=>{
        let n = r - e, i = o - t;
        return Math.hypot(n, i);
    }, $e68ba20b3d2d159d$var$gl = (e, t)=>{
        let r = t[0] - e[0], o = t[1] - e[1];
        return r * r + o * o;
    }, $e68ba20b3d2d159d$var$_l = (e, t)=>[
            (e[0] + t[0]) / 2,
            (e[1] + t[1]) / 2
        ], $e68ba20b3d2d159d$var$Br = (e, t = 1)=>{
        if (e.length >= 3) {
            let [r, o] = [
                e[0],
                e[e.length - 1]
            ];
            return $e68ba20b3d2d159d$var$Lt(r[0], r[1], o[0], o[1]) <= $e68ba20b3d2d159d$var$Ws / t;
        }
        return !1;
    }, $e68ba20b3d2d159d$var$Wp = (e, t, r)=>t[0] <= Math.max(e[0], r[0]) && t[0] >= Math.min(e[0], r[0]) && t[1] <= Math.max(e[1], r[1]) && t[1] >= Math.min(e[1], r[1]), $e68ba20b3d2d159d$var$Ot = (e, t, r)=>r ? [
            Math.round(e / r) * r,
            Math.round(t / r) * r
        ] : [
            e,
            t
        ], $e68ba20b3d2d159d$var$xo = (e, t)=>{
        if (t.roundness?.type === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS || t.roundness?.type === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.LEGACY) return e * $e68ba20b3d2d159d$var$Hm;
        if (t.roundness?.type === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS) {
            let r = t.roundness?.value ?? $e68ba20b3d2d159d$var$O0, o = r / $e68ba20b3d2d159d$var$Hm;
            return e <= o ? e * $e68ba20b3d2d159d$var$Hm : r;
        }
        return 0;
    }, $e68ba20b3d2d159d$var$ZE = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$Oe.generateElementShape(e, null);
        if (!r) return null;
        let o = $e68ba20b3d2d159d$var$sa(r[0]), n = [
            0,
            0
        ], i = 0, a = 1 / 0, s = null;
        for(; i < o.length;){
            let { op: l, data: c } = o[i];
            if (l === "move" && (n = c), l === "bcurveTo") {
                let d = n, m = [
                    c[0],
                    c[1]
                ], p = [
                    c[2],
                    c[3]
                ], u = [
                    c[4],
                    c[5]
                ], h = $e68ba20b3d2d159d$var$Lt(u[0], u[1], t[0], t[1]);
                h < a && (a = h, s = [
                    d,
                    m,
                    p,
                    u
                ]), n = u;
            }
            i++;
        }
        return s;
    }, $e68ba20b3d2d159d$var$jE = (e, t, r, o, n)=>{
        let i = (l, c)=>Math.pow(1 - l, 3) * o[c] + 3 * l * Math.pow(1 - l, 2) * r[c] + 3 * Math.pow(l, 2) * (1 - l) * t[c] + e[c] * Math.pow(l, 3), a = i(n, 0), s = i(n, 1);
        return [
            a,
            s
        ];
    }, $e68ba20b3d2d159d$var$bk = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$ZE(e, t);
        if (!r) return [];
        let o = [], n = 1;
        for(; n > 0;){
            let i = $e68ba20b3d2d159d$var$jE(r[0], r[1], r[2], r[3], n);
            o.push([
                i[0],
                i[1]
            ]), n -= .05;
        }
        return o.length && $e68ba20b3d2d159d$var$xn(o.at(-1), t) && o.push([
            t[0],
            t[1]
        ]), o;
    }, $e68ba20b3d2d159d$var$a3 = (e, t)=>{
        let r = [];
        r[0] = 0;
        let o = $e68ba20b3d2d159d$var$bk(e, t), n = 0, i = 0;
        for(; n < o.length - 1;){
            let a = $e68ba20b3d2d159d$var$Lt(o[n][0], o[n][1], o[n + 1][0], o[n + 1][1]);
            i += a, r.push(i), n++;
        }
        return r;
    }, $e68ba20b3d2d159d$var$s3 = (e, t)=>$e68ba20b3d2d159d$var$a3(e, t).at(-1), $e68ba20b3d2d159d$var$l3 = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$a3(e, t), n = o.length - 1, i = o.at(-1), a = r * i, s = 0, l = n, c = 0;
        for(; s < l;)c = Math.floor(s + (l - s) / 2), o[c] < a ? s = c + 1 : l = c;
        return o[c] > a && c--, o[c] === a ? c / n : 1 - (c + (a - o[c]) / (o[c + 1] - o[c])) / n;
    }, $e68ba20b3d2d159d$var$xn = (e, t)=>e[0] === t[0] && e[1] === t[1], $e68ba20b3d2d159d$var$e3 = (e)=>Math.round(e / Math.PI * 1e4) % 5e3 === 0, $e68ba20b3d2d159d$var$Rl = (e)=>e * 180 / Math.PI, $e68ba20b3d2d159d$var$Nl = (e)=>e / 180 * Math.PI, $e68ba20b3d2d159d$var$Md = ([e, t], [r, o])=>e <= r ? t >= r : e >= r ? o >= e : !1, $e68ba20b3d2d159d$var$kd = (e, t)=>{
        let r = Math.max(e[0], t[0]), o = Math.min(e[1], t[1]);
        return r <= o ? [
            r,
            o
        ] : null;
    }, $e68ba20b3d2d159d$var$Td = (e, t, r)=>e >= t && e <= r, $e68ba20b3d2d159d$var$Gu = (e, t)=>[
            e[0] + t[0],
            e[1] + t[1]
        ], $e68ba20b3d2d159d$var$Wc = (e, t)=>[
            e[0] * t,
            e[1] * t
        ], $e68ba20b3d2d159d$var$hi = (e, t = [
        0,
        0
    ])=>[
            e[0] - t[0],
            e[1] - t[1]
        ], $e68ba20b3d2d159d$var$ln = (e, t, r)=>$e68ba20b3d2d159d$var$Gu(t, $e68ba20b3d2d159d$var$Wc($e68ba20b3d2d159d$var$hi(e, t), r)), $e68ba20b3d2d159d$var$$E = (e, t, r)=>(e[0] - r[0]) * (t[1] - r[1]) - (t[0] - r[0]) * (e[1] - r[1]), $e68ba20b3d2d159d$var$is = (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$$E(e, t, r), i = $e68ba20b3d2d159d$var$$E(e, r, o), a = $e68ba20b3d2d159d$var$$E(e, o, t), s = n < 0 || i < 0 || a < 0, l = n > 0 || i > 0 || a > 0;
        return !(s && l);
    }, $e68ba20b3d2d159d$var$G2 = (e, t)=>[
            e[0] + t[0],
            e[1] + t[1]
        ], $e68ba20b3d2d159d$var$Op = (e, t)=>[
            e[0] - t[0],
            e[1] - t[1]
        ], $e68ba20b3d2d159d$var$Qi = (e, t)=>e[0] > t[0] && e[0] < t[2] && e[1] > t[1] && e[1] < t[3], $e68ba20b3d2d159d$var$dn = (e, t)=>{
        let r = {
            minX: e.x,
            minY: e.y,
            maxX: e.x + e.width,
            maxY: e.y + e.height,
            midX: e.x + e.width / 2,
            midY: e.y + e.height / 2
        }, o = [
            r.midX,
            r.midY
        ], [n, i] = $e68ba20b3d2d159d$var$J([
            r.minX,
            r.minY
        ], o, e.angle), [a, s] = $e68ba20b3d2d159d$var$J([
            r.maxX,
            r.minY
        ], o, e.angle), [l, c] = $e68ba20b3d2d159d$var$J([
            r.maxX,
            r.maxY
        ], o, e.angle), [d, m] = $e68ba20b3d2d159d$var$J([
            r.minX,
            r.maxY
        ], o, e.angle), p = [
            Math.min(n, a, l, d),
            Math.min(i, s, c, m),
            Math.max(n, a, l, d),
            Math.max(i, s, c, m)
        ];
        if (t) {
            let [u, h, g, b] = t;
            return [
                p[0] - b,
                p[1] - u,
                p[2] + h,
                p[3] + g
            ];
        }
        return p;
    }, $e68ba20b3d2d159d$var$Xp = (e)=>[
            e[0] + (e[2] - e[0]) / 2,
            e[1] + (e[3] - e[1]) / 2
        ], $e68ba20b3d2d159d$var$Qp = (e)=>[
            e.x + e.width / 2,
            e.y + e.height / 2
        ], $e68ba20b3d2d159d$var$Bn = (e, t, r)=>Math.min(Math.max(e, t), r), $e68ba20b3d2d159d$var$c3 = (e, t)=>{
        let r = Math.pow(10, t);
        return Math.round((e + Number.EPSILON) * r) / r;
    };
});
var $e68ba20b3d2d159d$var$Pd, $e68ba20b3d2d159d$var$d3 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Pd = class {
        constructor(t){
            this.scoreFunction = t;
        }
        content = [];
        sinkDown(t) {
            let r = this.content[t];
            for(; t > 0;){
                let o = (t + 1 >> 1) - 1, n = this.content[o];
                if (this.scoreFunction(r) < this.scoreFunction(n)) this.content[o] = r, this.content[t] = n, t = o;
                else break;
            }
        }
        bubbleUp(t) {
            let r = this.content.length, o = this.content[t], n = this.scoreFunction(o);
            for(;;){
                let i = t + 1 << 1, a = i - 1, s = null, l = 0;
                if (a < r) {
                    let c = this.content[a];
                    l = this.scoreFunction(c), l < n && (s = a);
                }
                if (i < r) {
                    let c = this.content[i];
                    this.scoreFunction(c) < (s === null ? n : l) && (s = i);
                }
                if (s !== null) this.content[t] = this.content[s], this.content[s] = o, t = s;
                else break;
            }
        }
        push(t) {
            this.content.push(t), this.sinkDown(this.content.length - 1);
        }
        pop() {
            if (this.content.length === 0) return null;
            let t = this.content[0], r = this.content.pop();
            return this.content.length > 0 && (this.content[0] = r, this.bubbleUp(0)), t;
        }
        remove(t) {
            if (this.content.length === 0) return;
            let r = this.content.indexOf(t), o = this.content.pop();
            r < this.content.length && (this.content[r] = o, this.scoreFunction(o) < this.scoreFunction(t) ? this.sinkDown(r) : this.bubbleUp(r));
        }
        size() {
            return this.content.length;
        }
        rescoreElement(t) {
            this.sinkDown(this.content.indexOf(t));
        }
    };
});
var $e68ba20b3d2d159d$var$Vn, $e68ba20b3d2d159d$var$Fo, $e68ba20b3d2d159d$var$la, $e68ba20b3d2d159d$var$yk, $e68ba20b3d2d159d$var$wk, $e68ba20b3d2d159d$var$qE, $e68ba20b3d2d159d$var$vk, $e68ba20b3d2d159d$var$Tk, $e68ba20b3d2d159d$var$m3, $e68ba20b3d2d159d$var$Sk, $e68ba20b3d2d159d$var$Ik, $e68ba20b3d2d159d$var$Ld, $e68ba20b3d2d159d$var$Wu, $e68ba20b3d2d159d$var$f3, $e68ba20b3d2d159d$var$p3, $e68ba20b3d2d159d$var$Ck, $e68ba20b3d2d159d$var$Ak, $e68ba20b3d2d159d$var$Mk, $e68ba20b3d2d159d$var$u3, $e68ba20b3d2d159d$var$h3, $e68ba20b3d2d159d$var$g3, $e68ba20b3d2d159d$var$kk, $e68ba20b3d2d159d$var$Ol = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$d3();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$$a();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$Yp();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Vn = 40, $e68ba20b3d2d159d$var$Fo = (e, t, r, o, n, i)=>{
        let a = $e68ba20b3d2d159d$var$Gu(r[0], [
            e.x + (o ? o[0] : 0),
            e.y + (o ? o[1] : 0)
        ]), s = $e68ba20b3d2d159d$var$Gu(r[r.length - 1], [
            e.x + (o ? o[0] : 0),
            e.y + (o ? o[1] : 0)
        ]), l = e.startBinding && $e68ba20b3d2d159d$var$p3(e.startBinding.elementId, t), c = e.endBinding && $e68ba20b3d2d159d$var$p3(e.endBinding.elementId, t), [d, m] = i?.isDragging ? $e68ba20b3d2d159d$var$kk(a, s, t) : [
            l,
            c
        ], p = $e68ba20b3d2d159d$var$u3(e.startBinding?.fixedPoint, a, s, t, l, d, i?.isDragging), u = $e68ba20b3d2d159d$var$u3(e.endBinding?.fixedPoint, s, a, t, c, m, i?.isDragging), h = $e68ba20b3d2d159d$var$g3(p, u, t, d, a), g = $e68ba20b3d2d159d$var$g3(u, p, t, m, s), b = [
            p[0] - 2,
            p[1] - 2,
            p[0] + 2,
            p[1] + 2
        ], v = [
            u[0] - 2,
            u[1] - 2,
            u[0] + 2,
            u[1] + 2
        ], y = d ? $e68ba20b3d2d159d$var$dn(d, $e68ba20b3d2d159d$var$la(h, e.startArrowhead ? $e68ba20b3d2d159d$var$st * 6 : $e68ba20b3d2d159d$var$st * 2, 1)) : b, w = m ? $e68ba20b3d2d159d$var$dn(m, $e68ba20b3d2d159d$var$la(g, e.endArrowhead ? $e68ba20b3d2d159d$var$st * 6 : $e68ba20b3d2d159d$var$st * 2, 1)) : v, I = $e68ba20b3d2d159d$var$Qi(p, m ? $e68ba20b3d2d159d$var$dn(m, $e68ba20b3d2d159d$var$la(g, $e68ba20b3d2d159d$var$Vn, $e68ba20b3d2d159d$var$Vn)) : v) || $e68ba20b3d2d159d$var$Qi(u, d ? $e68ba20b3d2d159d$var$dn(d, $e68ba20b3d2d159d$var$la(h, $e68ba20b3d2d159d$var$Vn, $e68ba20b3d2d159d$var$Vn)) : b), M = $e68ba20b3d2d159d$var$f3(I ? [
            b,
            v
        ] : [
            y,
            w
        ]), C = $e68ba20b3d2d159d$var$vk(I ? b : y, I ? v : w, M, I ? $e68ba20b3d2d159d$var$la(h, !d && !m ? 0 : $e68ba20b3d2d159d$var$Vn, 0) : $e68ba20b3d2d159d$var$la(h, !d && !m ? 0 : $e68ba20b3d2d159d$var$Vn - (e.startArrowhead ? $e68ba20b3d2d159d$var$st * 6 : $e68ba20b3d2d159d$var$st * 2), $e68ba20b3d2d159d$var$Vn), I ? $e68ba20b3d2d159d$var$la(g, !d && !m ? 0 : $e68ba20b3d2d159d$var$Vn, 0) : $e68ba20b3d2d159d$var$la(g, !d && !m ? 0 : $e68ba20b3d2d159d$var$Vn - (e.endArrowhead ? $e68ba20b3d2d159d$var$st * 6 : $e68ba20b3d2d159d$var$st * 2), $e68ba20b3d2d159d$var$Vn), I), P = $e68ba20b3d2d159d$var$m3(C[0], h, p), k = $e68ba20b3d2d159d$var$m3(C[1], g, u), _ = $e68ba20b3d2d159d$var$Tk(C, P || p, h, k || u, g, M), A = P && $e68ba20b3d2d159d$var$Wu(P, _), R = k && $e68ba20b3d2d159d$var$Wu(k, _), B = $e68ba20b3d2d159d$var$Wu(u, _);
        B && m && (B.closed = !0);
        let V = $e68ba20b3d2d159d$var$Wu(p, _);
        V && e.startBinding && (V.closed = !0);
        let ee = A && R && ($e68ba20b3d2d159d$var$Qi(A.pos, C[1]) || $e68ba20b3d2d159d$var$Qi(R.pos, C[0])), N = $e68ba20b3d2d159d$var$yk(A || V, R || B, _, h || $e68ba20b3d2d159d$var$At, g || $e68ba20b3d2d159d$var$At, ee ? [] : C);
        if (N) {
            let H = N.map((xe)=>[
                    xe.pos[0],
                    xe.pos[1]
                ]);
            A && H.unshift(p), R && H.push(u), $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
                ...n,
                ...$e68ba20b3d2d159d$var$Ck($e68ba20b3d2d159d$var$Ak(H), 0, 0),
                angle: 0
            }, i?.informMutation);
        } else console.error("Elbow arrow cannot find a route");
    }, $e68ba20b3d2d159d$var$la = (e, t, r)=>{
        switch(e){
            case $e68ba20b3d2d159d$var$hr:
                return [
                    t,
                    r,
                    r,
                    r
                ];
            case $e68ba20b3d2d159d$var$At:
                return [
                    r,
                    t,
                    r,
                    r
                ];
            case $e68ba20b3d2d159d$var$pr:
                return [
                    r,
                    r,
                    t,
                    r
                ];
        }
        return [
            r,
            r,
            r,
            t
        ];
    }, $e68ba20b3d2d159d$var$yk = (e, t, r, o, n, i)=>{
        let a = $e68ba20b3d2d159d$var$qE(e.pos, t.pos), s = new $e68ba20b3d2d159d$var$Pd((l)=>l.f);
        for(s.push(e); s.size() > 0;){
            let l = s.pop();
            if (!l || l.closed) continue;
            if (l === t) return $e68ba20b3d2d159d$var$wk(e, l);
            l.closed = !0;
            let c = $e68ba20b3d2d159d$var$Ik(l.addr, r);
            for(let d = 0; d < 4; d++){
                let m = c[d];
                if (!m || m.closed) continue;
                let p = $e68ba20b3d2d159d$var$ln(m.pos, l.pos, .5);
                if ($e68ba20b3d2d159d$var$ty(...i.map((I)=>$e68ba20b3d2d159d$var$Qi(p, I)))) continue;
                let u = $e68ba20b3d2d159d$var$Mk(d), h = l.parent ? $e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(l.pos, l.parent.pos)) : o, g = $e68ba20b3d2d159d$var$Wc(h, -1);
                if ($e68ba20b3d2d159d$var$xn(g, u) || $e68ba20b3d2d159d$var$xn(e.addr, m.addr) && $e68ba20b3d2d159d$var$xn(u, o) || $e68ba20b3d2d159d$var$xn(t.addr, m.addr) && $e68ba20b3d2d159d$var$xn(u, n)) continue;
                let v = h !== u, y = l.g + $e68ba20b3d2d159d$var$qE(m.pos, l.pos) + (v ? Math.pow(a, 3) : 0), w = m.visited;
                if (!w || y < m.g) {
                    let I = $e68ba20b3d2d159d$var$Sk(m, t, u, n);
                    m.visited = !0, m.parent = l, m.h = $e68ba20b3d2d159d$var$qE(t.pos, m.pos) + I * Math.pow(a, 2), m.g = y, m.f = m.g + m.h, w ? s.rescoreElement(m) : s.push(m);
                }
            }
        }
        return null;
    }, $e68ba20b3d2d159d$var$wk = (e, t)=>{
        let r = t, o = [];
        for(; r.parent;)o.unshift(r), r = r.parent;
        return o.unshift(e), o;
    }, $e68ba20b3d2d159d$var$qE = (e, t)=>Math.abs(e[0] - t[0]) + Math.abs(e[1] - t[1]), $e68ba20b3d2d159d$var$vk = (e, t, r, o, n, i)=>{
        let [a, s, l, c] = o ?? [
            0,
            0,
            0,
            0
        ], [d, m, p, u] = n ?? [
            0,
            0,
            0,
            0
        ], h = [
            e[0] > t[2] ? e[1] > t[3] || e[3] < t[1] ? Math.min((e[0] + t[2]) / 2, e[0] - c) : (e[0] + t[2]) / 2 : e[0] > t[0] ? e[0] - c : r[0] - c,
            e[1] > t[3] ? e[0] > t[2] || e[2] < t[0] ? Math.min((e[1] + t[3]) / 2, e[1] - a) : (e[1] + t[3]) / 2 : e[1] > t[1] ? e[1] - a : r[1] - a,
            e[2] < t[0] ? e[1] > t[3] || e[3] < t[1] ? Math.max((e[2] + t[0]) / 2, e[2] + s) : (e[2] + t[0]) / 2 : e[2] < t[2] ? e[2] + s : r[2] + s,
            e[3] < t[1] ? e[0] > t[2] || e[2] < t[0] ? Math.max((e[3] + t[1]) / 2, e[3] + l) : (e[3] + t[1]) / 2 : e[3] < t[3] ? e[3] + l : r[3] + l
        ], g = [
            t[0] > e[2] ? t[1] > e[3] || t[3] < e[1] ? Math.min((t[0] + e[2]) / 2, t[0] - u) : (t[0] + e[2]) / 2 : t[0] > e[0] ? t[0] - u : r[0] - u,
            t[1] > e[3] ? t[0] > e[2] || t[2] < e[0] ? Math.min((t[1] + e[3]) / 2, t[1] - d) : (t[1] + e[3]) / 2 : t[1] > e[1] ? t[1] - d : r[1] - d,
            t[2] < e[0] ? t[1] > e[3] || t[3] < e[1] ? Math.max((t[2] + e[0]) / 2, t[2] + m) : (t[2] + e[0]) / 2 : t[2] < e[2] ? t[2] + m : r[2] + m,
            t[3] < e[1] ? t[0] > e[2] || t[2] < e[0] ? Math.max((t[3] + e[1]) / 2, t[3] + p) : (t[3] + e[1]) / 2 : t[3] < e[3] ? t[3] + p : r[3] + p
        ], b = $e68ba20b3d2d159d$var$f3([
            h,
            g
        ]);
        if (!i && h[2] - h[0] + g[2] - g[0] > b[2] - b[0] + 1e-11 && h[3] - h[1] + g[3] - g[1] > b[3] - b[1] + 1e-11) {
            let [v, y] = [
                (g[0] + g[2]) / 2,
                (g[1] + g[3]) / 2
            ];
            if (t[0] > e[2] && e[1] > t[3]) {
                let w = h[2] + (g[0] - h[2]) / 2, I = g[3] + (h[1] - g[3]) / 2;
                return $e68ba20b3d2d159d$var$Gc([
                    e[2],
                    e[1]
                ], [
                    e[0],
                    e[3]
                ], [
                    v,
                    y
                ]) > 0 ? [
                    [
                        h[0],
                        h[1],
                        w,
                        h[3]
                    ],
                    [
                        w,
                        g[1],
                        g[2],
                        g[3]
                    ]
                ] : [
                    [
                        h[0],
                        I,
                        h[2],
                        h[3]
                    ],
                    [
                        g[0],
                        g[1],
                        g[2],
                        I
                    ]
                ];
            } else if (e[2] < t[0] && e[3] < t[1]) {
                let w = h[2] + (g[0] - h[2]) / 2, I = h[3] + (g[1] - h[3]) / 2;
                return $e68ba20b3d2d159d$var$Gc([
                    e[0],
                    e[1]
                ], [
                    e[2],
                    e[3]
                ], [
                    v,
                    y
                ]) > 0 ? [
                    [
                        h[0],
                        h[1],
                        h[2],
                        I
                    ],
                    [
                        g[0],
                        I,
                        g[2],
                        g[3]
                    ]
                ] : [
                    [
                        h[0],
                        h[1],
                        w,
                        h[3]
                    ],
                    [
                        w,
                        g[1],
                        g[2],
                        g[3]
                    ]
                ];
            } else if (e[0] > t[2] && e[3] < t[1]) {
                let w = g[2] + (h[0] - g[2]) / 2, I = h[3] + (g[1] - h[3]) / 2;
                return $e68ba20b3d2d159d$var$Gc([
                    e[2],
                    e[1]
                ], [
                    e[0],
                    e[3]
                ], [
                    v,
                    y
                ]) > 0 ? [
                    [
                        w,
                        h[1],
                        h[2],
                        h[3]
                    ],
                    [
                        g[0],
                        g[1],
                        w,
                        g[3]
                    ]
                ] : [
                    [
                        h[0],
                        h[1],
                        h[2],
                        I
                    ],
                    [
                        g[0],
                        I,
                        g[2],
                        g[3]
                    ]
                ];
            } else if (e[0] > t[2] && e[1] > t[3]) {
                let w = g[2] + (h[0] - g[2]) / 2, I = g[3] + (h[1] - g[3]) / 2;
                return $e68ba20b3d2d159d$var$Gc([
                    e[0],
                    e[1]
                ], [
                    e[2],
                    e[3]
                ], [
                    v,
                    y
                ]) > 0 ? [
                    [
                        w,
                        h[1],
                        h[2],
                        h[3]
                    ],
                    [
                        g[0],
                        g[1],
                        w,
                        g[3]
                    ]
                ] : [
                    [
                        h[0],
                        I,
                        h[2],
                        h[3]
                    ],
                    [
                        g[0],
                        g[1],
                        g[2],
                        I
                    ]
                ];
            }
        }
        return [
            h,
            g
        ];
    }, $e68ba20b3d2d159d$var$Tk = (e, t, r, o, n, i)=>{
        let a = new Set, s = new Set;
        r === $e68ba20b3d2d159d$var$ur || r === $e68ba20b3d2d159d$var$At ? s.add(t[1]) : a.add(t[0]), n === $e68ba20b3d2d159d$var$ur || n === $e68ba20b3d2d159d$var$At ? s.add(o[1]) : a.add(o[0]), e.forEach((d)=>{
            a.add(d[0]), a.add(d[2]), s.add(d[1]), s.add(d[3]);
        }), a.add(i[0]), a.add(i[2]), s.add(i[1]), s.add(i[3]);
        let l = Array.from(s).sort((d, m)=>d - m), c = Array.from(a).sort((d, m)=>d - m);
        return {
            row: l.length,
            col: c.length,
            data: l.flatMap((d, m)=>c.map((p, u)=>({
                        f: 0,
                        g: 0,
                        h: 0,
                        closed: !1,
                        visited: !1,
                        parent: null,
                        addr: [
                            u,
                            m
                        ],
                        pos: [
                            p,
                            d
                        ]
                    })))
        };
    }, $e68ba20b3d2d159d$var$m3 = (e, t, r)=>{
        switch(t){
            case $e68ba20b3d2d159d$var$hr:
                return [
                    r[0],
                    e[1]
                ];
            case $e68ba20b3d2d159d$var$At:
                return [
                    e[2],
                    r[1]
                ];
            case $e68ba20b3d2d159d$var$pr:
                return [
                    r[0],
                    e[3]
                ];
        }
        return [
            e[0],
            r[1]
        ];
    }, $e68ba20b3d2d159d$var$Sk = (e, t, r, o)=>{
        if (o === $e68ba20b3d2d159d$var$At) switch(r){
            case $e68ba20b3d2d159d$var$At:
                return e.pos[0] >= t.pos[0] ? 4 : e.pos[1] === t.pos[1] ? 0 : 2;
            case $e68ba20b3d2d159d$var$hr:
                return e.pos[1] > t.pos[1] && e.pos[0] < t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$pr:
                return e.pos[1] < t.pos[1] && e.pos[0] < t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$ur:
                return e.pos[1] === t.pos[1] ? 4 : 2;
        }
        else if (o === $e68ba20b3d2d159d$var$ur) switch(r){
            case $e68ba20b3d2d159d$var$At:
                return e.pos[1] === t.pos[1] ? 4 : 2;
            case $e68ba20b3d2d159d$var$hr:
                return e.pos[1] > t.pos[1] && e.pos[0] > t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$pr:
                return e.pos[1] < t.pos[1] && e.pos[0] > t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$ur:
                return e.pos[0] <= t.pos[0] ? 4 : e.pos[1] === t.pos[1] ? 0 : 2;
        }
        else if (o === $e68ba20b3d2d159d$var$hr) switch(r){
            case $e68ba20b3d2d159d$var$At:
                return e.pos[1] > t.pos[1] && e.pos[0] < t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$hr:
                return e.pos[1] >= t.pos[1] ? 4 : e.pos[0] === t.pos[0] ? 0 : 2;
            case $e68ba20b3d2d159d$var$pr:
                return e.pos[0] === t.pos[0] ? 4 : 2;
            case $e68ba20b3d2d159d$var$ur:
                return e.pos[1] > t.pos[1] && e.pos[0] > t.pos[0] ? 1 : 3;
        }
        else if (o === $e68ba20b3d2d159d$var$pr) switch(r){
            case $e68ba20b3d2d159d$var$At:
                return e.pos[1] < t.pos[1] && e.pos[0] < t.pos[0] ? 1 : 3;
            case $e68ba20b3d2d159d$var$hr:
                return e.pos[0] === t.pos[0] ? 4 : 2;
            case $e68ba20b3d2d159d$var$pr:
                return e.pos[1] <= t.pos[1] ? 4 : e.pos[0] === t.pos[0] ? 0 : 2;
            case $e68ba20b3d2d159d$var$ur:
                return e.pos[1] < t.pos[1] && e.pos[0] > t.pos[0] ? 1 : 3;
        }
        return 0;
    }, $e68ba20b3d2d159d$var$Ik = ([e, t], r)=>[
            $e68ba20b3d2d159d$var$Ld([
                e,
                t - 1
            ], r),
            $e68ba20b3d2d159d$var$Ld([
                e + 1,
                t
            ], r),
            $e68ba20b3d2d159d$var$Ld([
                e,
                t + 1
            ], r),
            $e68ba20b3d2d159d$var$Ld([
                e - 1,
                t
            ], r)
        ], $e68ba20b3d2d159d$var$Ld = ([e, t], r)=>e < 0 || e >= r.col || t < 0 || t >= r.row ? null : r.data[t * r.col + e] ?? null, $e68ba20b3d2d159d$var$Wu = (e, t)=>{
        for(let r = 0; r < t.col; r++)for(let o = 0; o < t.row; o++){
            let n = $e68ba20b3d2d159d$var$Ld([
                r,
                o
            ], t);
            if (n && e[0] === n.pos[0] && e[1] === n.pos[1]) return n;
        }
        return null;
    }, $e68ba20b3d2d159d$var$f3 = (e)=>[
            Math.min(...e.map((t)=>t[0])),
            Math.min(...e.map((t)=>t[1])),
            Math.max(...e.map((t)=>t[2])),
            Math.max(...e.map((t)=>t[3]))
        ], $e68ba20b3d2d159d$var$p3 = (e, t)=>{
        let r = t.get(e);
        return r && $e68ba20b3d2d159d$var$po(r) ? r : null;
    }, $e68ba20b3d2d159d$var$Ck = (e, t, r)=>{
        let o = e[0][0], n = e[0][1], i = e.map((a)=>[
                a[0] - o,
                a[1] - n
            ]);
        return {
            points: i,
            x: o + (t ?? 0),
            y: n + (r ?? 0),
            ...$e68ba20b3d2d159d$var$ui(i)
        };
    }, $e68ba20b3d2d159d$var$Ak = (e)=>e.slice(2).reduce((t, r)=>$e68ba20b3d2d159d$var$xn($e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(t[t.length - 1], t[t.length - 2])), $e68ba20b3d2d159d$var$ji($e68ba20b3d2d159d$var$hi(r, t[t.length - 1]))) ? [
                ...t.slice(0, -1),
                r
            ] : [
                ...t,
                r
            ], [
            e[0] ?? [
                0,
                0
            ],
            e[1] ?? [
                1,
                0
            ]
        ]), $e68ba20b3d2d159d$var$Mk = (e)=>{
        switch(e){
            case 0:
                return $e68ba20b3d2d159d$var$hr;
            case 1:
                return $e68ba20b3d2d159d$var$At;
            case 2:
                return $e68ba20b3d2d159d$var$pr;
        }
        return $e68ba20b3d2d159d$var$ur;
    }, $e68ba20b3d2d159d$var$u3 = (e, t, r, o, n, i, a)=>{
        if (a) {
            if (i) {
                let s = $e68ba20b3d2d159d$var$h3(t, r, i, o);
                return $e68ba20b3d2d159d$var$av(i, s);
            }
            return t;
        }
        if (n) {
            let s = $e68ba20b3d2d159d$var$Zp(e || [
                0,
                0
            ], n);
            return Math.abs($e68ba20b3d2d159d$var$El(n, s, o) - $e68ba20b3d2d159d$var$st) > .01 ? $e68ba20b3d2d159d$var$h3(t, r, n, o) : s;
        }
        return t;
    }, $e68ba20b3d2d159d$var$h3 = (e, t, r, o)=>$e68ba20b3d2d159d$var$fl($e68ba20b3d2d159d$var$ry(r) ? $e68ba20b3d2d159d$var$iv(r, e) : e, t, r, o), $e68ba20b3d2d159d$var$g3 = (e, t, r, o, n)=>$e68ba20b3d2d159d$var$nv(e, t, o, o && $e68ba20b3d2d159d$var$dn(o, Array(4).fill($e68ba20b3d2d159d$var$El(o, e, r))), r, n), $e68ba20b3d2d159d$var$kk = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$lr(new Map([
            ...r
        ].filter((i)=>!i[1].isDeleted))), n = Array.from(r.values());
        return [
            $e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sr(e), n, o, !0),
            $e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sr(t), n, o, !0)
        ];
    };
});
var $e68ba20b3d2d159d$var$Si, $e68ba20b3d2d159d$var$$, $e68ba20b3d2d159d$var$Pk, $e68ba20b3d2d159d$var$Nt = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$be();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$var$Ol();
    $e68ba20b3d2d159d$var$Si = {
        version: null,
        points: [],
        zoom: null
    }, $e68ba20b3d2d159d$var$$ = class e {
        elementId;
        selectedPointsIndices;
        pointerDownState;
        isDragging;
        lastUncommittedPoint;
        pointerOffset;
        startBindingElement;
        endBindingElement;
        hoverPointIndex;
        segmentMidPointHoveredCoords;
        constructor(t){
            this.elementId = t.id, $e68ba20b3d2d159d$var$xn(t.points[0], [
                0,
                0
            ]) || console.error("Linear element is not normalized", Error().stack), this.selectedPointsIndices = null, this.lastUncommittedPoint = null, this.isDragging = !1, this.pointerOffset = {
                x: 0,
                y: 0
            }, this.startBindingElement = "keep", this.endBindingElement = "keep", this.pointerDownState = {
                prevSelectedPointsIndices: null,
                lastClickedPoint: -1,
                lastClickedIsEndPoint: !1,
                origin: null,
                segmentMidpoint: {
                    value: null,
                    index: null,
                    added: !1
                }
            }, this.hoverPointIndex = -1, this.segmentMidPointHoveredCoords = null;
        }
        static POINT_HANDLE_SIZE = 10;
        static getElement(t, r) {
            let o = r.get(t);
            return o || null;
        }
        static handleBoxSelection(t, r, o, n) {
            if (!r.editingLinearElement || !r.selectionElement) return !1;
            let { editingLinearElement: i } = r, { selectedPointsIndices: a, elementId: s } = i, l = e.getElement(s, n);
            if (!l) return !1;
            let [c, d, m, p] = $e68ba20b3d2d159d$var$ae(r.selectionElement, n), h = e.getPointsGlobalCoordinates(l, n).reduce((g, b, v)=>((b[0] >= c && b[0] <= m && b[1] >= d && b[1] <= p || t.shiftKey && a?.includes(v)) && g.push(v), g), []).filter((g)=>!($e68ba20b3d2d159d$var$ce(l) && g !== 0 && g !== l.points.length - 1));
            o({
                editingLinearElement: {
                    ...i,
                    selectedPointsIndices: h.length ? h : null
                }
            });
        }
        static handlePointDragging(t, r, o, n, i, a, s) {
            if (!a) return !1;
            let { elementId: l } = a, c = s.getNonDeletedElementsMap(), d = e.getElement(l, c);
            if (!d || $e68ba20b3d2d159d$var$ce(d) && !a.pointerDownState.lastClickedIsEndPoint && a.pointerDownState.lastClickedPoint !== 0) return !1;
            let m = $e68ba20b3d2d159d$var$ce(d) ? a.selectedPointsIndices?.reduce((h, g)=>g === 0 ? [
                    0,
                    h[1]
                ] : [
                    h[0],
                    d.points.length - 1
                ], [
                !1,
                !1
            ]).filter((h)=>typeof h == "number") : a.selectedPointsIndices, p = $e68ba20b3d2d159d$var$ce(d) ? a.pointerDownState.lastClickedPoint > 0 ? d.points.length - 1 : 0 : a.pointerDownState.lastClickedPoint, u = d.points[p];
            if (m && u) {
                if ($e68ba20b3d2d159d$var$os(t) && m.length === 1 && d.points.length > 1) {
                    let g = m[0], b = d.points[g === 0 ? 1 : g - 1], [v, y] = e._getShiftLockedDelta(d, c, b, [
                        o,
                        n
                    ], t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : r.getEffectiveGridSize());
                    e.movePoints(d, [
                        {
                            index: g,
                            point: [
                                v + b[0],
                                y + b[1]
                            ],
                            isDragging: g === p
                        }
                    ], c);
                } else {
                    let g = e.createPointAt(d, c, o - a.pointerOffset.x, n - a.pointerOffset.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : r.getEffectiveGridSize()), b = g[0] - u[0], v = g[1] - u[1];
                    e.movePoints(d, m.map((y)=>{
                        let w = y === p ? e.createPointAt(d, c, o - a.pointerOffset.x, n - a.pointerOffset.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : r.getEffectiveGridSize()) : [
                            d.points[y][0] + b,
                            d.points[y][1] + v
                        ];
                        return {
                            index: y,
                            point: w,
                            isDragging: y === p
                        };
                    }), c);
                }
                if ($e68ba20b3d2d159d$var$te(d, c) && $e68ba20b3d2d159d$var$mn(d, c, !1), $e68ba20b3d2d159d$var$qr(d, !1)) {
                    let g = [];
                    m[0] === 0 && g.push($e68ba20b3d2d159d$var$sr(e.getPointGlobalCoordinates(d, d.points[0], c)));
                    let v = m[m.length - 1];
                    v === d.points.length - 1 && g.push($e68ba20b3d2d159d$var$sr(e.getPointGlobalCoordinates(d, d.points[v], c))), g.length && i(d, g);
                }
                return !0;
            }
            return !1;
        }
        static handlePointerUp(t, r, o, n) {
            let i = n.getNonDeletedElementsMap(), a = n.getNonDeletedElements(), { elementId: s, selectedPointsIndices: l, isDragging: c, pointerDownState: d } = r, m = e.getElement(s, i);
            if (!m) return r;
            let p = {};
            if (c && l) {
                for (let u of l)if (u === 0 || u === m.points.length - 1) {
                    $e68ba20b3d2d159d$var$Br(m.points, o.zoom.value) && e.movePoints(m, [
                        {
                            index: u,
                            point: u === 0 ? m.points[m.points.length - 1] : m.points[0]
                        }
                    ], i);
                    let h = $e68ba20b3d2d159d$var$zn(o) ? $e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sr(e.getPointAtIndexGlobalCoordinates(m, u, i)), a, i) : null;
                    p[u === 0 ? "startBindingElement" : "endBindingElement"] = h;
                }
            }
            return {
                ...r,
                ...p,
                selectedPointsIndices: c || t.shiftKey ? !c && t.shiftKey && d.prevSelectedPointsIndices?.includes(d.lastClickedPoint) ? l && l.filter((u)=>u !== d.lastClickedPoint) : l : l?.includes(d.lastClickedPoint) ? [
                    d.lastClickedPoint
                ] : l,
                isDragging: !1,
                pointerOffset: {
                    x: 0,
                    y: 0
                }
            };
        }
        static getEditorMidPoints = (t, r, o)=>{
            let n = $e68ba20b3d2d159d$var$te(t, r);
            return !o.editingLinearElement && t.points.length > 2 && !n ? [] : ($e68ba20b3d2d159d$var$Si.version === t.version && $e68ba20b3d2d159d$var$Si.zoom === o.zoom.value || e.updateEditorMidPointsCache(t, r, o), $e68ba20b3d2d159d$var$Si.points);
        };
        static updateEditorMidPointsCache = (t, r, o)=>{
            let n = e.getPointsGlobalCoordinates(t, r), i = 0, a = [];
            for(; i < n.length - 1;){
                if (e.isSegmentTooShort(t, t.points[i], t.points[i + 1], o.zoom)) {
                    a.push(null), i++;
                    continue;
                }
                let s = e.getSegmentMidPoint(t, n[i], n[i + 1], i + 1, r);
                a.push(s), i++;
            }
            $e68ba20b3d2d159d$var$Si.points = a, $e68ba20b3d2d159d$var$Si.version = t.version, $e68ba20b3d2d159d$var$Si.zoom = o.zoom.value;
        };
        static getSegmentMidpointHitCoords = (t, r, o, n)=>{
            let { elementId: i } = t, a = e.getElement(i, n);
            if (!a || e.getPointIndexUnderCursor(a, n, o.zoom, r.x, r.y) >= 0 || e.getPointsGlobalCoordinates(a, n).length >= 3 && !o.editingLinearElement) return null;
            let c = e.POINT_HANDLE_SIZE / o.zoom.value, d = t.segmentMidPointHoveredCoords;
            if (d && $e68ba20b3d2d159d$var$Lt(d[0], d[1], r.x, r.y) <= c) return d;
            let m = 0, p = e.getEditorMidPoints(a, n, o);
            for(; m < p.length;){
                if (p[m] !== null && $e68ba20b3d2d159d$var$Lt(p[m][0], p[m][1], r.x, r.y) <= c) return p[m];
                m++;
            }
            return null;
        };
        static isSegmentTooShort(t, r, o, n) {
            let i = $e68ba20b3d2d159d$var$Lt(r[0], r[1], o[0], o[1]);
            return t.points.length > 2 && t.roundness && (i = $e68ba20b3d2d159d$var$s3(t, o)), i * n.value < e.POINT_HANDLE_SIZE * 4;
        }
        static getSegmentMidPoint(t, r, o, n, i) {
            let a = $e68ba20b3d2d159d$var$_l(r, o);
            if (t.points.length > 2 && t.roundness) {
                let s = $e68ba20b3d2d159d$var$ZE(t, t.points[n]);
                if (s) {
                    let l = $e68ba20b3d2d159d$var$l3(t, t.points[n], .5), [c, d] = $e68ba20b3d2d159d$var$jE(s[0], s[1], s[2], s[3], l);
                    a = e.getPointGlobalCoordinates(t, [
                        c,
                        d
                    ], i);
                }
            }
            return a;
        }
        static getSegmentMidPointIndex(t, r, o, n) {
            let i = e.getElement(t.elementId, n);
            if (!i) return -1;
            let a = e.getEditorMidPoints(i, n, r), s = 0;
            for(; s < a.length;){
                if (e.arePointsEqual(o, a[s])) return s + 1;
                s++;
            }
            return -1;
        }
        static handlePointerDown(t, r, o, n, i, a) {
            let s = r.state, l = a.getNonDeletedElementsMap(), c = a.getNonDeletedElements(), d = {
                didAddPoint: !1,
                hitElement: null,
                linearElementEditor: null
            };
            if (!i) return d;
            let { elementId: m } = i, p = e.getElement(m, l);
            if (!p) return d;
            let u = e.getSegmentMidpointHitCoords(i, n, s, l), h = null;
            if (u && (h = e.getSegmentMidPointIndex(i, s, u, l)), t.altKey && s.editingLinearElement) return i.lastUncommittedPoint == null && !$e68ba20b3d2d159d$var$ce(p) && ($e68ba20b3d2d159d$export$55655e96a21bba2e(p, {
                points: [
                    ...p.points,
                    e.createPointAt(p, l, n.x, n.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : r.getEffectiveGridSize())
                ]
            }), d.didAddPoint = !0), o.shouldCaptureIncrement(), d.linearElementEditor = {
                ...i,
                pointerDownState: {
                    prevSelectedPointsIndices: i.selectedPointsIndices,
                    lastClickedPoint: -1,
                    lastClickedIsEndPoint: !1,
                    origin: {
                        x: n.x,
                        y: n.y
                    },
                    segmentMidpoint: {
                        value: u,
                        index: h,
                        added: !1
                    }
                },
                selectedPointsIndices: [
                    p.points.length - 1
                ],
                lastUncommittedPoint: null,
                endBindingElement: $e68ba20b3d2d159d$var$Ir(n, c, l)
            }, d.didAddPoint = !0, d;
            let g = e.getPointIndexUnderCursor(p, l, s.zoom, n.x, n.y);
            if (g >= 0 || u) d.hitElement = p;
            else {
                let { startBindingElement: k, endBindingElement: _ } = i;
                $e68ba20b3d2d159d$var$zn(s) && $e68ba20b3d2d159d$var$qr(p) && $e68ba20b3d2d159d$var$as(p, k, _, l, a);
            }
            let [b, v, y, w] = $e68ba20b3d2d159d$var$ae(p, l), I = (b + y) / 2, M = (v + w) / 2, C = g > -1 && $e68ba20b3d2d159d$var$Ee(p.x + p.points[g][0], p.y + p.points[g][1], I, M, p.angle), P = g > -1 || t.shiftKey ? t.shiftKey || i.selectedPointsIndices?.includes(g) ? $e68ba20b3d2d159d$var$Pk([
                ...i.selectedPointsIndices || [],
                g
            ]) : [
                g
            ] : null;
            return d.linearElementEditor = {
                ...i,
                pointerDownState: {
                    prevSelectedPointsIndices: i.selectedPointsIndices,
                    lastClickedPoint: g,
                    lastClickedIsEndPoint: g === p.points.length - 1,
                    origin: {
                        x: n.x,
                        y: n.y
                    },
                    segmentMidpoint: {
                        value: u,
                        index: h,
                        added: !1
                    }
                },
                selectedPointsIndices: P,
                pointerOffset: C ? {
                    x: n.x - C[0],
                    y: n.y - C[1]
                } : {
                    x: 0,
                    y: 0
                }
            }, d;
        }
        static arePointsEqual(t, r) {
            return !t && !r ? !0 : !t || !r ? !1 : $e68ba20b3d2d159d$var$xn(t, r);
        }
        static handlePointerMove(t, r, o, n, i) {
            let a = n.state;
            if (!a.editingLinearElement) return null;
            let { elementId: s, lastUncommittedPoint: l } = a.editingLinearElement, c = e.getElement(s, i);
            if (!c) return a.editingLinearElement;
            let { points: d } = c, m = d[d.length - 1];
            if (!t.altKey) return m === l && e.deletePoints(c, [
                d.length - 1
            ], i), {
                ...a.editingLinearElement,
                lastUncommittedPoint: null
            };
            let p;
            if ($e68ba20b3d2d159d$var$os(t) && d.length >= 2) {
                let u = d[d.length - 2], [h, g] = e._getShiftLockedDelta(c, i, u, [
                    r,
                    o
                ], t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : n.getEffectiveGridSize());
                p = [
                    h + u[0],
                    g + u[1]
                ];
            } else p = e.createPointAt(c, i, r - a.editingLinearElement.pointerOffset.x, o - a.editingLinearElement.pointerOffset.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || $e68ba20b3d2d159d$var$ce(c) ? null : n.getEffectiveGridSize());
            return m === l ? e.movePoints(c, [
                {
                    index: c.points.length - 1,
                    point: p
                }
            ], i) : e.addPoints(c, [
                {
                    point: p
                }
            ], i), {
                ...a.editingLinearElement,
                lastUncommittedPoint: c.points[c.points.length - 1]
            };
        }
        static getPointGlobalCoordinates(t, r, o) {
            let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(t, o), l = (n + a) / 2, c = (i + s) / 2, { x: d, y: m } = t;
            return [d, m] = $e68ba20b3d2d159d$var$Ee(d + r[0], m + r[1], l, c, t.angle), [
                d,
                m
            ];
        }
        static getPointsGlobalCoordinates(t, r) {
            let [o, n, i, a] = $e68ba20b3d2d159d$var$ae(t, r), s = (o + i) / 2, l = (n + a) / 2;
            return t.points.map((c)=>{
                let { x: d, y: m } = t;
                return [d, m] = $e68ba20b3d2d159d$var$Ee(d + c[0], m + c[1], s, l, t.angle), [
                    d,
                    m
                ];
            });
        }
        static getPointAtIndexGlobalCoordinates(t, r, o) {
            let n = r < 0 ? t.points.length + r : r, [i, a, s, l] = $e68ba20b3d2d159d$var$ae(t, o), c = (i + s) / 2, d = (a + l) / 2, m = t.points[n], { x: p, y: u } = t;
            return m ? $e68ba20b3d2d159d$var$Ee(p + m[0], u + m[1], c, d, t.angle) : $e68ba20b3d2d159d$var$Ee(p, u, c, d, t.angle);
        }
        static pointFromAbsoluteCoords(t, r, o) {
            if ($e68ba20b3d2d159d$var$ce(t)) return [
                r[0] - t.x,
                r[1] - t.y
            ];
            let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(t, o), l = (n + a) / 2, c = (i + s) / 2, [d, m] = $e68ba20b3d2d159d$var$Ee(r[0], r[1], l, c, -t.angle);
            return [
                d - t.x,
                m - t.y
            ];
        }
        static getPointIndexUnderCursor(t, r, o, n, i) {
            let a = e.getPointsGlobalCoordinates(t, r), s = a.length;
            for(; --s > -1;){
                let l = a[s];
                if ($e68ba20b3d2d159d$var$Lt(n, i, l[0], l[1]) * o.value < e.POINT_HANDLE_SIZE + 1) return s;
            }
            return -1;
        }
        static createPointAt(t, r, o, n, i) {
            let a = $e68ba20b3d2d159d$var$Ot(o, n, i), [s, l, c, d] = $e68ba20b3d2d159d$var$ae(t, r), m = (s + c) / 2, p = (l + d) / 2, [u, h] = $e68ba20b3d2d159d$var$Ee(a[0], a[1], m, p, -t.angle);
            return [
                u - t.x,
                h - t.y
            ];
        }
        static getNormalizedPoints(t) {
            let { points: r } = t, o = r[0][0], n = r[0][1];
            return {
                points: r.map((i)=>[
                        i[0] - o,
                        i[1] - n
                    ]),
                x: t.x + o,
                y: t.y + n
            };
        }
        static normalizePoints(t) {
            $e68ba20b3d2d159d$export$55655e96a21bba2e(t, e.getNormalizedPoints(t));
        }
        static duplicateSelectedPoints(t, r) {
            if (!t.editingLinearElement) return !1;
            let { selectedPointsIndices: o, elementId: n } = t.editingLinearElement, i = e.getElement(n, r);
            if (!i || o === null) return !1;
            let { points: a } = i, s = [], l = !1, c = -1, d = a.reduce((m, p, u)=>{
                if (++c, m.push(p), o.includes(u)) {
                    let g = a[u + 1];
                    g || (l = !0), m.push(g ? [
                        (p[0] + g[0]) / 2,
                        (p[1] + g[1]) / 2
                    ] : [
                        p[0],
                        p[1]
                    ]), s.push(c + 1), ++c;
                }
                return m;
            }, []);
            if ($e68ba20b3d2d159d$export$55655e96a21bba2e(i, {
                points: d
            }), l) {
                let m = i.points[i.points.length - 1];
                e.movePoints(i, [
                    {
                        index: i.points.length - 1,
                        point: [
                            m[0] + 30,
                            m[1] + 30
                        ]
                    }
                ], r);
            }
            return {
                appState: {
                    ...t,
                    editingLinearElement: {
                        ...t.editingLinearElement,
                        selectedPointsIndices: s
                    }
                }
            };
        }
        static deletePoints(t, r, o) {
            let n = 0, i = 0;
            if (r.includes(0)) {
                let l = t.points.find((c, d)=>!r.includes(d));
                l && (n = l[0], i = l[1]);
            }
            let s = t.points.reduce((l, c, d)=>(r.includes(d) || l.push(l.length ? [
                    c[0] - n,
                    c[1] - i
                ] : [
                    0,
                    0
                ]), l), []);
            e._updatePoints(t, s, n, i, o);
        }
        static addPoints(t, r, o) {
            let a = [
                ...t.points,
                ...r.map((s)=>s.point)
            ];
            e._updatePoints(t, a, 0, 0, o);
        }
        static movePoints(t, r, o, n, i) {
            let { points: a } = t, s = 0, l = 0, c = r.find(({ index: m })=>m === 0);
            c && (s = c.point[0] + a[c.index][0], l = c.point[1] + a[c.index][1]);
            let d = a.map((m, p)=>{
                let u = r.find((h)=>h.index === p);
                if (u) {
                    if (u.index === 0) return m;
                    let h = u.point[0] - a[u.index][0], g = u.point[1] - a[u.index][1];
                    return [
                        m[0] + h - s,
                        m[1] + g - l
                    ];
                }
                return s || l ? [
                    m[0] - s,
                    m[1] - l
                ] : m;
            });
            e._updatePoints(t, d, s, l, o, n, {
                isDragging: r.reduce((m, p)=>m || p.isDragging === !0, !1),
                changedElements: i?.changedElements
            });
        }
        static shouldAddMidpoint(t, r, o, n) {
            let i = e.getElement(t.elementId, n);
            if (i && $e68ba20b3d2d159d$var$ce(i) || !i) return !1;
            let { segmentMidpoint: a } = t.pointerDownState;
            if (a.added || a.value === null || a.index === null || t.pointerDownState.origin === null) return !1;
            let s = t.pointerDownState.origin, l = $e68ba20b3d2d159d$var$Lt(s.x, s.y, r.x, r.y);
            return !(!o.editingLinearElement && l < $e68ba20b3d2d159d$var$ii / o.zoom.value);
        }
        static addMidpoint(t, r, o, n, i) {
            let a = e.getElement(t.elementId, i);
            if (!a) return;
            let { segmentMidpoint: s } = t.pointerDownState, l = {
                pointerDownState: t.pointerDownState,
                selectedPointsIndices: t.selectedPointsIndices
            }, c = e.createPointAt(a, i, r.x, r.y, n && !$e68ba20b3d2d159d$var$ce(a) ? o.getEffectiveGridSize() : null), d = [
                ...a.points.slice(0, s.index),
                c,
                ...a.points.slice(s.index)
            ];
            return $e68ba20b3d2d159d$export$55655e96a21bba2e(a, {
                points: d
            }), l.pointerDownState = {
                ...t.pointerDownState,
                segmentMidpoint: {
                    ...t.pointerDownState.segmentMidpoint,
                    added: !0
                },
                lastClickedPoint: s.index
            }, l.selectedPointsIndices = [
                s.index
            ], l;
        }
        static _updatePoints(t, r, o, n, i, a, s) {
            if ($e68ba20b3d2d159d$var$ce(t)) {
                let l = {};
                a?.startBinding !== void 0 && (l.startBinding = a.startBinding !== null && $e68ba20b3d2d159d$var$df(a.startBinding) ? a.startBinding : null), a?.endBinding !== void 0 && (l.endBinding = a.endBinding !== null && $e68ba20b3d2d159d$var$df(a.endBinding) ? a.endBinding : null);
                let c = s?.changedElements ? $e68ba20b3d2d159d$var$lr(new Map([
                    ...i,
                    ...s.changedElements
                ])) : i;
                $e68ba20b3d2d159d$var$Fo(t, c, r, [
                    o,
                    n
                ], l, s);
            } else {
                let l = $e68ba20b3d2d159d$var$YE(t, r), c = $e68ba20b3d2d159d$var$YE(t, t.points), d = (l[0] + l[2]) / 2, m = (l[1] + l[3]) / 2, p = (c[0] + c[2]) / 2, u = (c[1] + c[3]) / 2, h = p - d, g = u - m, b = $e68ba20b3d2d159d$var$Ee(o, n, h, g, t.angle);
                $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                    ...a,
                    points: r,
                    x: t.x + b[0],
                    y: t.y + b[1]
                });
            }
        }
        static _getShiftLockedDelta(t, r, o, n, i) {
            let a = e.getPointGlobalCoordinates(t, o, r);
            if ($e68ba20b3d2d159d$var$ce(t)) return [
                n[0] - a[0],
                n[1] - a[1]
            ];
            let [s, l] = $e68ba20b3d2d159d$var$Ot(n[0], n[1], i), { width: c, height: d } = $e68ba20b3d2d159d$var$Fl(a[0], a[1], s, l);
            return $e68ba20b3d2d159d$var$J([
                c,
                d
            ], [
                0,
                0
            ], -t.angle);
        }
        static getBoundTextElementPosition = (t, r, o)=>{
            let n = e.getPointsGlobalCoordinates(t, o);
            n.length < 2 && $e68ba20b3d2d159d$export$55655e96a21bba2e(r, {
                isDeleted: !0
            });
            let i = 0, a = 0;
            if (t.points.length % 2 === 1) {
                let s = Math.floor(t.points.length / 2), l = e.getPointGlobalCoordinates(t, t.points[s], o);
                i = l[0] - r.width / 2, a = l[1] - r.height / 2;
            } else {
                let s = t.points.length / 2 - 1, l = $e68ba20b3d2d159d$var$Si.points[s];
                t.points.length === 2 && (l = $e68ba20b3d2d159d$var$_l(n[0], n[1])), (!l || $e68ba20b3d2d159d$var$Si.version !== t.version) && (l = e.getSegmentMidPoint(t, n[s], n[s + 1], s + 1, o)), i = l[0] - r.width / 2, a = l[1] - r.height / 2;
            }
            return {
                x: i,
                y: a
            };
        };
        static getMinMaxXYWithBoundText = (t, r, o, n)=>{
            let [i, a, s, l] = o, c = (i + s) / 2, d = (a + l) / 2, { x: m, y: p } = e.getBoundTextElementPosition(t, n, r), u = m + n.width, h = p + n.height, g = $e68ba20b3d2d159d$var$J([
                i,
                a
            ], [
                c,
                d
            ], t.angle), b = $e68ba20b3d2d159d$var$J([
                s,
                a
            ], [
                c,
                d
            ], t.angle), v = $e68ba20b3d2d159d$var$J([
                m,
                p
            ], [
                c,
                d
            ], -t.angle), y = $e68ba20b3d2d159d$var$J([
                u,
                p
            ], [
                c,
                d
            ], -t.angle), w = $e68ba20b3d2d159d$var$J([
                m,
                h
            ], [
                c,
                d
            ], -t.angle), I = $e68ba20b3d2d159d$var$J([
                u,
                h
            ], [
                c,
                d
            ], -t.angle);
            return g[0] < b[0] && g[1] >= b[1] ? (i = Math.min(i, w[0]), s = Math.max(s, Math.max(y[0], I[0])), a = Math.min(a, v[1]), l = Math.max(l, I[1])) : g[0] >= b[0] && g[1] > b[1] ? (i = Math.min(i, I[0]), s = Math.max(s, Math.max(v[0], y[0])), a = Math.min(a, w[1]), l = Math.max(l, y[1])) : g[0] >= b[0] ? (i = Math.min(i, y[0]), s = Math.max(s, w[0]), a = Math.min(a, I[1]), l = Math.max(l, v[1])) : g[1] <= b[1] && (i = Math.min(i, Math.min(y[0], v[0])), s = Math.max(s, I[0]), a = Math.min(a, y[1]), l = Math.max(l, w[1])), [
                i,
                a,
                s,
                l,
                c,
                d
            ];
        };
        static getElementAbsoluteCoords = (t, r, o = !1)=>{
            let n, i, a, s, l;
            if (t.points.length < 2 || !$e68ba20b3d2d159d$var$Oe.get(t)) {
                let { minX: p, minY: u, maxX: h, maxY: g } = t.points.reduce((b, [v, y])=>(b.minY = Math.min(b.minY, y), b.minX = Math.min(b.minX, v), b.maxX = Math.max(b.maxX, v), b.maxY = Math.max(b.maxY, y), b), {
                    minX: 1 / 0,
                    minY: 1 / 0,
                    maxX: -1 / 0,
                    maxY: -1 / 0
                });
                i = p + t.x, a = u + t.y, s = h + t.x, l = g + t.y;
            } else {
                let p = $e68ba20b3d2d159d$var$Oe.generateElementShape(t, null), u = $e68ba20b3d2d159d$var$sa(p[0]), [h, g, b, v] = $e68ba20b3d2d159d$var$Ad(u);
                i = h + t.x, a = g + t.y, s = b + t.x, l = v + t.y;
            }
            let c = (i + s) / 2, d = (a + l) / 2;
            if (n = [
                i,
                a,
                s,
                l,
                c,
                d
            ], !o) return n;
            let m = $e68ba20b3d2d159d$var$te(t, r);
            return m && (n = e.getMinMaxXYWithBoundText(t, r, [
                i,
                a,
                s,
                l
            ], m)), n;
        };
    }, $e68ba20b3d2d159d$var$Pk = (e)=>{
        let t = [
            ...new Set(e.filter((r)=>r !== null && r !== -1))
        ];
        return t = t.sort((r, o)=>r - o), t.length ? t : null;
    };
});
var $e68ba20b3d2d159d$var$gs, $e68ba20b3d2d159d$var$fs, $e68ba20b3d2d159d$var$Vu, $e68ba20b3d2d159d$var$E3, $e68ba20b3d2d159d$var$Yu = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$gs = {}, $e68ba20b3d2d159d$var$fs = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$gs[e] || ($e68ba20b3d2d159d$var$gs[e] = {
            height: t
        });
        return r.height = t, r;
    }, $e68ba20b3d2d159d$var$Vu = (e)=>{
        $e68ba20b3d2d159d$var$gs[e] && delete $e68ba20b3d2d159d$var$gs[e];
    }, $e68ba20b3d2d159d$var$E3 = (e)=>$e68ba20b3d2d159d$var$gs[e]?.height ?? null;
});
var $e68ba20b3d2d159d$var$Gn, $e68ba20b3d2d159d$var$QE, $e68ba20b3d2d159d$var$gt, $e68ba20b3d2d159d$var$Xu, $e68ba20b3d2d159d$var$mn, $e68ba20b3d2d159d$var$Bl, $e68ba20b3d2d159d$var$Xt, $e68ba20b3d2d159d$var$gv, $e68ba20b3d2d159d$var$oa, $e68ba20b3d2d159d$var$zl, $e68ba20b3d2d159d$var$JE, $e68ba20b3d2d159d$var$Es, $e68ba20b3d2d159d$var$Ku, $e68ba20b3d2d159d$var$Lk, $e68ba20b3d2d159d$var$Dk, $e68ba20b3d2d159d$var$Ro, $e68ba20b3d2d159d$var$x3, $e68ba20b3d2d159d$var$b3, $e68ba20b3d2d159d$var$Hl, $e68ba20b3d2d159d$var$_k, $e68ba20b3d2d159d$var$fn, $e68ba20b3d2d159d$var$te, $e68ba20b3d2d159d$var$bt, $e68ba20b3d2d159d$var$$u, $e68ba20b3d2d159d$var$BE, $e68ba20b3d2d159d$var$y3, $e68ba20b3d2d159d$var$w3, $e68ba20b3d2d159d$var$v3, $e68ba20b3d2d159d$var$Rk, $e68ba20b3d2d159d$var$T3, $e68ba20b3d2d159d$var$Ii, $e68ba20b3d2d159d$var$Mr, $e68ba20b3d2d159d$var$us, $e68ba20b3d2d159d$var$S3, $e68ba20b3d2d159d$var$Ul, $e68ba20b3d2d159d$export$490cca97d34091f8, $e68ba20b3d2d159d$var$We = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$Yu();
    $e68ba20b3d2d159d$var$Gn = (e)=>$e68ba20b3d2d159d$var$Qm(e).replace(/\t/g, "        "), $e68ba20b3d2d159d$var$QE = (e)=>$e68ba20b3d2d159d$var$Gn(e).split(`
`), $e68ba20b3d2d159d$var$gt = (e, t, r, o = !0)=>{
        let n, i = {
            x: e.x,
            y: e.y,
            text: e.text,
            width: e.width,
            height: e.height,
            angle: t?.angle ?? e.angle
        };
        i.text = e.text, (t || !e.autoResize) && (n = t ? $e68ba20b3d2d159d$var$Mr(t, e) : e.width, i.text = $e68ba20b3d2d159d$var$Ro(e.originalText, $e68ba20b3d2d159d$var$ke(e), n));
        let a = $e68ba20b3d2d159d$var$Xt(i.text, $e68ba20b3d2d159d$var$ke(e), e.lineHeight);
        if (e.autoResize && (i.width = a.width), i.height = a.height, t) {
            let s = $e68ba20b3d2d159d$var$us(t, e), l = $e68ba20b3d2d159d$var$Mr(t, e);
            if (!$e68ba20b3d2d159d$var$ie(t) && a.height > s) {
                let p = $e68ba20b3d2d159d$var$Ii(a.height, t.type);
                $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                    height: p
                }, o), $e68ba20b3d2d159d$var$fs(t.id, p);
            }
            if (a.width > l) {
                let p = $e68ba20b3d2d159d$var$Ii(a.width, t.type);
                $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                    width: p
                }, o);
            }
            let c = {
                ...e,
                ...i
            }, { x: d, y: m } = $e68ba20b3d2d159d$var$Bl(t, c, r);
            i.x = d, i.y = m;
        }
        $e68ba20b3d2d159d$export$55655e96a21bba2e(e, i, o);
    }, $e68ba20b3d2d159d$var$Xu = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$j(e);
        t.forEach((n)=>{
            let i = r.get(n.id), a = $e68ba20b3d2d159d$var$fn(n);
            if (a) {
                let s = r.get(a);
                if (s) {
                    let l = o.get(i);
                    l && $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                        boundElements: (n.boundElements || []).filter((d)=>d.id !== s && d.id !== a).concat({
                            type: "text",
                            id: s
                        })
                    });
                    let c = o.get(s);
                    c && $e68ba20b3d2d159d$var$G(c) && $e68ba20b3d2d159d$export$55655e96a21bba2e(c, {
                        containerId: l ? i : null
                    });
                }
            }
        });
    }, $e68ba20b3d2d159d$var$mn = (e, t, r, o = !1)=>{
        if (!$e68ba20b3d2d159d$var$fn(e)) return;
        $e68ba20b3d2d159d$var$Vu(e.id);
        let i = $e68ba20b3d2d159d$var$te(e, t);
        if (i && i.text) {
            if (!e) return;
            let a = i.text, s = i.height, l = i.width, c = $e68ba20b3d2d159d$var$Mr(e, i), d = $e68ba20b3d2d159d$var$us(e, i), m = e.height;
            if (o || r !== "n" && r !== "s") {
                a && (a = $e68ba20b3d2d159d$var$Ro(i.originalText, $e68ba20b3d2d159d$var$ke(i), c));
                let p = $e68ba20b3d2d159d$var$Xt(a, $e68ba20b3d2d159d$var$ke(i), i.lineHeight);
                s = p.height, l = p.width;
            }
            if (s > d) {
                m = $e68ba20b3d2d159d$var$Ii(s, e.type);
                let p = m - e.height, u = !$e68ba20b3d2d159d$var$ie(e) && (r === "ne" || r === "nw" || r === "n") ? e.y - p : e.y;
                $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
                    height: m,
                    y: u
                });
            }
            $e68ba20b3d2d159d$export$55655e96a21bba2e(i, {
                text: a,
                width: l,
                height: s
            }), $e68ba20b3d2d159d$var$ie(e) || $e68ba20b3d2d159d$export$55655e96a21bba2e(i, $e68ba20b3d2d159d$var$Bl(e, i, t));
        }
    }, $e68ba20b3d2d159d$var$Bl = (e, t, r)=>{
        if ($e68ba20b3d2d159d$var$ie(e)) return $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(e, t, r);
        let o = $e68ba20b3d2d159d$var$BE(e), n = $e68ba20b3d2d159d$var$us(e, t), i = $e68ba20b3d2d159d$var$Mr(e, t), a, s;
        return t.verticalAlign === $e68ba20b3d2d159d$var$Pt.TOP ? s = o.y : t.verticalAlign === $e68ba20b3d2d159d$var$Pt.BOTTOM ? s = o.y + (n - t.height) : s = o.y + (n / 2 - t.height / 2), t.textAlign === $e68ba20b3d2d159d$var$Oi.LEFT ? a = o.x : t.textAlign === $e68ba20b3d2d159d$var$Oi.RIGHT ? a = o.x + (i - t.width) : a = o.x + (i / 2 - t.width / 2), {
            x: a,
            y: s
        };
    }, $e68ba20b3d2d159d$var$Xt = (e, t, r)=>{
        e = e.split(`
`).map((a)=>a || " ").join(`
`);
        let o = parseFloat(t), n = $e68ba20b3d2d159d$var$Lk(e, o, r);
        return {
            width: $e68ba20b3d2d159d$var$Ku(e, t),
            height: n
        };
    }, $e68ba20b3d2d159d$var$gv = (e)=>{
        let t = $e68ba20b3d2d159d$var$QE(e.text).length;
        return e.height / t / e.fontSize;
    }, $e68ba20b3d2d159d$var$oa = (e, t)=>e * t, $e68ba20b3d2d159d$var$zl = (e, t)=>$e68ba20b3d2d159d$var$oa(e, t) + $e68ba20b3d2d159d$var$wt * 2, $e68ba20b3d2d159d$var$Es = (e, t, r)=>{
        $e68ba20b3d2d159d$var$JE || ($e68ba20b3d2d159d$var$JE = document.createElement("canvas"));
        let o = $e68ba20b3d2d159d$var$JE.getContext("2d");
        o.font = t;
        let n = o.measureText(e), i = n.width;
        if (!r && window.TextMetrics && "actualBoundingBoxLeft" in window.TextMetrics.prototype && "actualBoundingBoxRight" in window.TextMetrics.prototype) {
            let a = Math.abs(n.actualBoundingBoxLeft) + Math.abs(n.actualBoundingBoxRight);
            return Math.max(a, i);
        }
        return $e68ba20b3d2d159d$var$Zr() ? i * 10 : i;
    }, $e68ba20b3d2d159d$var$Ku = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$QE(e), n = 0;
        return o.forEach((i)=>{
            n = Math.max(n, $e68ba20b3d2d159d$var$Es(i, t, r));
        }), n;
    }, $e68ba20b3d2d159d$var$Lk = (e, t, r)=>{
        let o = $e68ba20b3d2d159d$var$QE(e).length;
        return $e68ba20b3d2d159d$var$oa(t, r) * o;
    }, $e68ba20b3d2d159d$var$Dk = (e)=>{
        let t = e.split("-");
        return t.length > 1 && t.forEach((r, o)=>{
            o !== t.length - 1 && (t[o] = r += "-");
        }), t.join(" ").split(" ");
    }, $e68ba20b3d2d159d$var$Ro = (e, t, r)=>{
        if (!Number.isFinite(r) || r < 0) return e;
        let o = [], n = e.split(`
`), i = $e68ba20b3d2d159d$var$Es(" ", t, !0), a = "", s = 0, l = (d)=>{
            d.trim() && o.push(d);
        }, c = ()=>{
            a = "", s = 0;
        };
        for (let d of n){
            if ($e68ba20b3d2d159d$var$Es(d, t, !0) <= r) {
                o.push(d);
                continue;
            }
            let p = $e68ba20b3d2d159d$var$Dk(d);
            c();
            let u = 0;
            for(; u < p.length;){
                let h = $e68ba20b3d2d159d$var$Es(p[u], t, !0);
                if (h === r) l(p[u]), u++;
                else if (h > r) {
                    for(l(a), c(); p[u].length > 0;){
                        let g = String.fromCodePoint(p[u].codePointAt(0)), b = a + g, v = $e68ba20b3d2d159d$var$Es(b, t, !0), y = $e68ba20b3d2d159d$var$x3.calculate(g, t);
                        s = v, p[u] = p[u].slice(g.length), s >= r ? (l(a), a = g, s = y) : a = b;
                    }
                    s + i >= r ? (l(a), c()) : a.endsWith("-") || (a += " ", s += i), u++;
                } else for(; s < r && u < p.length;){
                    let g = p[u];
                    if (s = $e68ba20b3d2d159d$var$Es(a + g, t, !0), s > r) {
                        l(a), c();
                        break;
                    }
                    u++;
                    let b = !g.endsWith("-");
                    if (a += g, b && (a += " "), s + i >= r) {
                        b ? o.push(a.slice(0, -1)) : o.push(a), c();
                        break;
                    }
                }
            }
            a.slice(-1) === " " && (a = a.slice(0, -1), l(a));
        }
        return o.join(`
`);
    }, $e68ba20b3d2d159d$var$x3 = (()=>{
        let e = {};
        return {
            calculate: (o, n)=>{
                let i = o.charCodeAt(0);
                if (e[n] || (e[n] = []), !e[n][i]) {
                    let a = $e68ba20b3d2d159d$var$Es(o, n, !0);
                    e[n][i] = a;
                }
                return e[n][i];
            },
            getCache: (o)=>e[o]
        };
    })(), $e68ba20b3d2d159d$var$b3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".toLocaleUpperCase(), $e68ba20b3d2d159d$var$Hl = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$_k(e);
        return r === 0 ? $e68ba20b3d2d159d$var$Xt($e68ba20b3d2d159d$var$b3.split("").join(`
`), e, t).width + $e68ba20b3d2d159d$var$wt * 2 : r + $e68ba20b3d2d159d$var$wt * 2;
    }, $e68ba20b3d2d159d$var$_k = (e)=>{
        let t = $e68ba20b3d2d159d$var$x3.getCache(e);
        if (!t) return 0;
        let r = t.filter((o)=>o !== void 0);
        return Math.max(...r);
    }, $e68ba20b3d2d159d$var$fn = (e)=>e?.boundElements?.length && e?.boundElements?.find((t)=>t.type === "text")?.id || null, $e68ba20b3d2d159d$var$te = (e, t)=>{
        if (!e) return null;
        let r = $e68ba20b3d2d159d$var$fn(e);
        return r && t.get(r) || null;
    }, $e68ba20b3d2d159d$var$bt = (e, t)=>e && e.containerId && t.get(e.containerId) || null, $e68ba20b3d2d159d$var$$u = (e, t, r)=>{
        if (!$e68ba20b3d2d159d$var$ie(e)) return {
            x: e.x + e.width / 2,
            y: e.y + e.height / 2
        };
        let o = $e68ba20b3d2d159d$var$$.getPointsGlobalCoordinates(e, r);
        if (o.length % 2 === 1) {
            let a = Math.floor(e.points.length / 2), s = $e68ba20b3d2d159d$var$$.getPointGlobalCoordinates(e, e.points[a], r);
            return {
                x: s[0],
                y: s[1]
            };
        }
        let n = e.points.length / 2 - 1, i = $e68ba20b3d2d159d$var$$.getEditorMidPoints(e, r, t)[n];
        return i || (i = $e68ba20b3d2d159d$var$$.getSegmentMidPoint(e, o[n], o[n + 1], n + 1, r)), {
            x: i[0],
            y: i[1]
        };
    }, $e68ba20b3d2d159d$var$BE = (e)=>{
        let t = $e68ba20b3d2d159d$var$wt, r = $e68ba20b3d2d159d$var$wt;
        return e.type === "ellipse" && (t += e.width / 2 * (1 - Math.sqrt(2) / 2), r += e.height / 2 * (1 - Math.sqrt(2) / 2)), e.type === "diamond" && (t += e.width / 4, r += e.height / 4), {
            x: e.x + t,
            y: e.y + r
        };
    }, $e68ba20b3d2d159d$var$y3 = (e, t)=>!t || $e68ba20b3d2d159d$var$ie(t) ? e.angle : t.angle, $e68ba20b3d2d159d$var$w3 = (e, t)=>e.some((r)=>{
            if ($e68ba20b3d2d159d$var$Ge(r)) {
                let o = $e68ba20b3d2d159d$var$bt(r, t);
                return !$e68ba20b3d2d159d$var$ie(o);
            }
            return !1;
        }), $e68ba20b3d2d159d$var$v3 = (e, t)=>e.some((r)=>{
            if ($e68ba20b3d2d159d$var$Ge(r)) {
                let o = $e68ba20b3d2d159d$var$bt(r, t);
                return !$e68ba20b3d2d159d$var$ie(o);
            }
            return $e68ba20b3d2d159d$var$G(r);
        }), $e68ba20b3d2d159d$var$Rk = new Set([
        "rectangle",
        "ellipse",
        "diamond",
        "arrow"
    ]), $e68ba20b3d2d159d$var$T3 = (e)=>$e68ba20b3d2d159d$var$Rk.has(e.type), $e68ba20b3d2d159d$var$Ii = (e, t)=>{
        e = Math.ceil(e);
        let r = $e68ba20b3d2d159d$var$wt * 2;
        return t === "ellipse" ? Math.round((e + r) / Math.sqrt(2) * 2) : t === "arrow" ? e + r * 8 : t === "diamond" ? 2 * (e + r) : e + r;
    }, $e68ba20b3d2d159d$var$Mr = (e, t)=>{
        let { width: r } = e;
        if ($e68ba20b3d2d159d$var$ie(e)) {
            let o = (t?.fontSize ?? $e68ba20b3d2d159d$var$wr) * $e68ba20b3d2d159d$var$R0;
            return Math.max($e68ba20b3d2d159d$var$_0 * r, o);
        }
        return e.type === "ellipse" ? Math.round(r / 2 * Math.sqrt(2)) - $e68ba20b3d2d159d$var$wt * 2 : e.type === "diamond" ? Math.round(r / 2) - $e68ba20b3d2d159d$var$wt * 2 : r - $e68ba20b3d2d159d$var$wt * 2;
    }, $e68ba20b3d2d159d$var$us = (e, t)=>{
        let { height: r } = e;
        return $e68ba20b3d2d159d$var$ie(e) ? r - $e68ba20b3d2d159d$var$wt * 16 <= 0 ? t.height : r : e.type === "ellipse" ? Math.round(r / 2 * Math.sqrt(2)) - $e68ba20b3d2d159d$var$wt * 2 : e.type === "diamond" ? Math.round(r / 2) - $e68ba20b3d2d159d$var$wt * 2 : r - $e68ba20b3d2d159d$var$wt * 2;
    }, $e68ba20b3d2d159d$var$S3 = ()=>$e68ba20b3d2d159d$var$Ku($e68ba20b3d2d159d$var$b3, $e68ba20b3d2d159d$var$ke({
            fontSize: $e68ba20b3d2d159d$var$wr,
            fontFamily: $e68ba20b3d2d159d$var$vr
        })) > 0, $e68ba20b3d2d159d$var$Ul = (e, t)=>$e68ba20b3d2d159d$var$Xt("", e, t).width + $e68ba20b3d2d159d$var$wt * 2, $e68ba20b3d2d159d$export$490cca97d34091f8 = (e, t = `

`)=>e.reduce((o, n)=>($e68ba20b3d2d159d$var$G(n) && o.push(n.text), o), []).join(t);
});
var $e68ba20b3d2d159d$var$Dd, $e68ba20b3d2d159d$var$mu, $e68ba20b3d2d159d$var$tr, $e68ba20b3d2d159d$var$Cr, $e68ba20b3d2d159d$var$Ok, $e68ba20b3d2d159d$var$Fk, $e68ba20b3d2d159d$var$ex, $e68ba20b3d2d159d$var$C3, $e68ba20b3d2d159d$var$I3, $e68ba20b3d2d159d$var$Do = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$Gi();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Dd = (e, { shouldThrow: t = !1, includeBoundTextValidation: r = !1, ignoreLogs: o, reconciliationContext: n })=>{
        let i = [], a = (l)=>`${l?.index}:${l?.id}:${l?.type}:${l?.isDeleted}:${l?.version}:${l?.versionNonce}`, s = e.map((l)=>l.index);
        for (let [l, c] of s.entries()){
            let d = s[l - 1], m = s[l + 1];
            if ($e68ba20b3d2d159d$var$ex(c, d, m) || i.push(`Fractional indices invariant has been compromised: "${a(e[l - 1])}", "${a(e[l])}", "${a(e[l + 1])}"`), r && $e68ba20b3d2d159d$var$It(e[l])) {
                let p = e[l], u = $e68ba20b3d2d159d$var$te(p, $e68ba20b3d2d159d$var$j(e));
                u && u.index <= p.index && i.push(`Fractional indices invariant for bound elements has been compromised: "${a(u)}", "${a(p)}"`);
            }
        }
        if (i.length) {
            let l = new $e68ba20b3d2d159d$var$rp, c = [];
            if (n && (c.push("Additional reconciliation context:"), c.push(n.localElements.map((d)=>a(d))), c.push(n.remoteElements.map((d)=>a(d)))), o || console.error(i.join(`

`), l.stack, e.map((d)=>a(d)), ...c), t) throw l;
        }
    }, $e68ba20b3d2d159d$var$mu = (e)=>e.sort((t, r)=>$e68ba20b3d2d159d$var$I3(t) && $e68ba20b3d2d159d$var$I3(r) ? t.index < r.index ? -1 : t.index > r.index ? 1 : t.id < r.id ? -1 : 1 : 1), $e68ba20b3d2d159d$var$tr = (e, t)=>{
        try {
            let r = $e68ba20b3d2d159d$var$Ok(e, t), o = $e68ba20b3d2d159d$var$C3(e, r), n = e.map((i)=>o.has(i) ? {
                    ...i,
                    ...o.get(i)
                } : i);
            $e68ba20b3d2d159d$var$Dd(n, {
                includeBoundTextValidation: !1,
                shouldThrow: !0,
                ignoreLogs: !0
            });
            for (let [i, a] of o)$e68ba20b3d2d159d$export$55655e96a21bba2e(i, a, !1);
        } catch  {
            $e68ba20b3d2d159d$var$Cr(e);
        }
        return e;
    }, $e68ba20b3d2d159d$var$Cr = (e)=>{
        let t = $e68ba20b3d2d159d$var$Fk(e), r = $e68ba20b3d2d159d$var$C3(e, t);
        for (let [o, n] of r)$e68ba20b3d2d159d$export$55655e96a21bba2e(o, n, !1);
        return e;
    }, $e68ba20b3d2d159d$var$Ok = (e, t)=>{
        let r = [], o = 0;
        for(; o < e.length;)if (t.has(e[o].id)) {
            let n = [
                o - 1,
                o
            ];
            for(; ++o < e.length && t.has(e[o].id);)n.push(o);
            n.push(o), r.push(n);
        } else o++;
        return r;
    }, $e68ba20b3d2d159d$var$Fk = (e)=>{
        let t = [], r, o, n = -1, i = 0, a = (c)=>{
            let d = e[n] ? e[n].index : void 0, m = e[c - 1]?.index;
            return !d && m || d && m && m > d ? [
                m,
                c - 1
            ] : [
                d,
                n
            ];
        }, s = (c)=>{
            let d = e[i] ? e[i].index : void 0;
            if (d && c < i) return [
                d,
                i
            ];
            let m = i;
            for(; ++m < e.length;){
                let p = e[m]?.index;
                if (!d && p || d && p && p > d) return [
                    p,
                    m
                ];
            }
            return [
                void 0,
                m
            ];
        }, l = 0;
        for(; l < e.length;){
            let c = e[l].index;
            if ([r, n] = a(l), [o, i] = s(l), $e68ba20b3d2d159d$var$ex(c, r, o)) l++;
            else {
                let d = [
                    n,
                    l
                ];
                for(; ++l < e.length;){
                    let m = e[l].index, [p, u] = a(l), [h, g] = s(l);
                    if ($e68ba20b3d2d159d$var$ex(m, p, h)) break;
                    [r, n] = [
                        p,
                        u
                    ], [o, i] = [
                        h,
                        g
                    ], d.push(l);
                }
                d.push(i), t.push(d);
            }
        }
        return t;
    }, $e68ba20b3d2d159d$var$ex = (e, t, r)=>e ? t && r ? t < e && e < r : !t && r ? e < r : t && !r ? t < e : !!e : !1, $e68ba20b3d2d159d$var$C3 = (e, t)=>{
        let r = new Map;
        for (let o of t){
            let n = o.shift(), i = o.pop(), a = (0, $84454c8a8f31dddd$export$b76def7bbb7952e0)(e[n]?.index, e[i]?.index, o.length);
            for(let s = 0; s < o.length; s++){
                let l = e[o[s]];
                r.set(l, {
                    index: a[s]
                });
            }
        }
        return r;
    }, $e68ba20b3d2d159d$var$I3 = (e)=>!!e.index;
});
var $e68ba20b3d2d159d$var$A3, $e68ba20b3d2d159d$var$zk, $e68ba20b3d2d159d$var$Hk, $e68ba20b3d2d159d$var$M3, $e68ba20b3d2d159d$var$tx, $e68ba20b3d2d159d$var$fr, $e68ba20b3d2d159d$var$xs = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Wi();
    $e68ba20b3d2d159d$var$jo();
    $e68ba20b3d2d159d$var$Do();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$A3 = (e)=>{
        let t = new Map, r = [];
        for (let o of e)o.isDeleted || (r.push(o), t.set(o.id, o));
        return {
            elementsMap: t,
            elements: r
        };
    }, $e68ba20b3d2d159d$var$zk = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))((e)=>{
        ($e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST || window?.DEBUG_FRACTIONAL_INDICES) && $e68ba20b3d2d159d$var$Dd(e, {
            shouldThrow: $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST,
            includeBoundTextValidation: !0
        });
    }, 60000, {
        leading: !0,
        trailing: !1
    }), $e68ba20b3d2d159d$var$Hk = (e)=>{
        let t = [
            "includeBoundTextElement",
            "includeElementsInFrames"
        ], r = "";
        for (let o of t)r += `${o}:${e[o] ? "1" : "0"}`;
        return r;
    }, $e68ba20b3d2d159d$var$M3 = (e)=>typeof e == "string", $e68ba20b3d2d159d$var$tx = class e {
        static sceneMapByElement = new WeakMap;
        static sceneMapById = new Map;
        static mapElementToScene(t, r) {
            $e68ba20b3d2d159d$var$M3(t) ? this.sceneMapById.set(t, r) : (this.sceneMapByElement.set(t, r), this.sceneMapById.set(t.id, r));
        }
        static getScene(t) {
            return $e68ba20b3d2d159d$var$M3(t) ? this.sceneMapById.get(t) || null : this.sceneMapByElement.get(t) || null;
        }
        callbacks = new Set;
        nonDeletedElements = [];
        nonDeletedElementsMap = $e68ba20b3d2d159d$var$lr(new Map);
        elements = [];
        nonDeletedFramesLikes = [];
        frames = [];
        elementsMap = $e68ba20b3d2d159d$var$lr(new Map);
        selectedElementsCache = {
            selectedElementIds: null,
            elements: null,
            cache: new Map
        };
        sceneNonce;
        getSceneNonce() {
            return this.sceneNonce;
        }
        getNonDeletedElementsMap() {
            return this.nonDeletedElementsMap;
        }
        getElementsIncludingDeleted() {
            return this.elements;
        }
        getElementsMapIncludingDeleted() {
            return this.elementsMap;
        }
        getNonDeletedElements() {
            return this.nonDeletedElements;
        }
        getFramesIncludingDeleted() {
            return this.frames;
        }
        getSelectedElements(t) {
            let r = $e68ba20b3d2d159d$var$Hk(t), o = t?.elements || this.nonDeletedElements;
            if (this.selectedElementsCache.elements === o && this.selectedElementsCache.selectedElementIds === t.selectedElementIds) {
                let i = this.selectedElementsCache.cache.get(r);
                if (i) return i;
            } else t?.elements == null && this.selectedElementsCache.cache.clear();
            let n = $e68ba20b3d2d159d$var$pe(o, {
                selectedElementIds: t.selectedElementIds
            }, t);
            return t?.elements == null && (this.selectedElementsCache.selectedElementIds = t.selectedElementIds, this.selectedElementsCache.elements = this.nonDeletedElements, this.selectedElementsCache.cache.set(r, n)), n;
        }
        getNonDeletedFramesLikes() {
            return this.nonDeletedFramesLikes;
        }
        getElement(t) {
            return this.elementsMap.get(t) || null;
        }
        getNonDeletedElement(t) {
            let r = this.getElement(t);
            return r && $e68ba20b3d2d159d$var$_d(r) ? r : null;
        }
        mapElements(t) {
            let r = !1, o = this.elements.map((n)=>{
                let i = t(n);
                return i !== n && (r = !0), i;
            });
            return r && this.replaceAllElements(o), r;
        }
        replaceAllElements(t) {
            let r = t instanceof Array ? t : Array.from(t.values()), o = [];
            $e68ba20b3d2d159d$var$zk(r), this.elements = $e68ba20b3d2d159d$var$Cr(r), this.elementsMap.clear(), this.elements.forEach((i)=>{
                $e68ba20b3d2d159d$var$re(i) && o.push(i), this.elementsMap.set(i.id, i), e.mapElementToScene(i, this);
            });
            let n = $e68ba20b3d2d159d$var$A3(this.elements);
            this.nonDeletedElements = n.elements, this.nonDeletedElementsMap = n.elementsMap, this.frames = o, this.nonDeletedFramesLikes = $e68ba20b3d2d159d$var$A3(this.frames).elements, this.triggerUpdate();
        }
        triggerUpdate() {
            this.sceneNonce = $e68ba20b3d2d159d$var$ko();
            for (let t of Array.from(this.callbacks))t();
        }
        onUpdate(t) {
            if (this.callbacks.has(t)) throw new Error;
            return this.callbacks.add(t), ()=>{
                if (!this.callbacks.has(t)) throw new Error;
                this.callbacks.delete(t);
            };
        }
        destroy() {
            this.elements = [], this.nonDeletedElements = [], this.nonDeletedFramesLikes = [], this.frames = [], this.elementsMap.clear(), this.selectedElementsCache.selectedElementIds = null, this.selectedElementsCache.elements = null, this.selectedElementsCache.cache.clear(), e.sceneMapById.forEach((t, r)=>{
                t === this && e.sceneMapById.delete(r);
            }), this.callbacks.clear();
        }
        insertElementAtIndex(t, r) {
            if (!Number.isFinite(r) || r < 0) throw new Error("insertElementAtIndex can only be called with index >= 0");
            let o = [
                ...this.elements.slice(0, r),
                t,
                ...this.elements.slice(r)
            ];
            $e68ba20b3d2d159d$var$tr(o, $e68ba20b3d2d159d$var$j([
                t
            ])), this.replaceAllElements(o);
        }
        insertElementsAtIndex(t, r) {
            if (!t.length) return;
            if (!Number.isFinite(r) || r < 0) throw new Error("insertElementAtIndex can only be called with index >= 0");
            let o = [
                ...this.elements.slice(0, r),
                ...t,
                ...this.elements.slice(r)
            ];
            $e68ba20b3d2d159d$var$tr(o, $e68ba20b3d2d159d$var$j(t)), this.replaceAllElements(o);
        }
        insertElement = (t)=>{
            let r = t.frameId ? this.getElementIndex(t.frameId) : this.elements.length;
            this.insertElementAtIndex(t, r);
        };
        insertElements = (t)=>{
            if (!t.length) return;
            let r = t[0]?.frameId ? this.getElementIndex(t[0].frameId) : this.elements.length;
            this.insertElementsAtIndex(t, r);
        };
        getElementIndex(t) {
            return this.elements.findIndex((r)=>r.id === t);
        }
        getContainerElement = (t)=>t && t.containerId && this.getElement(t.containerId) || null;
    }, $e68ba20b3d2d159d$var$fr = $e68ba20b3d2d159d$var$tx;
});
var $e68ba20b3d2d159d$export$55655e96a21bba2e, $e68ba20b3d2d159d$export$5390fab1c98104d7, $e68ba20b3d2d159d$export$52f84dc7de3cd4b8, $e68ba20b3d2d159d$var$Re = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$xs();
    $e68ba20b3d2d159d$var$$a();
    $e68ba20b3d2d159d$var$jo();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$en();
    $e68ba20b3d2d159d$export$55655e96a21bba2e = (e, t, r = !0)=>{
        let o = !1, { points: n, fileId: i } = t;
        typeof n < "u" && (t = {
            ...$e68ba20b3d2d159d$var$ui(n),
            ...t
        });
        for(let a in t){
            let s = t[a];
            if (typeof s < "u") {
                if (e[a] === s && (typeof s != "object" || s === null || a === "groupIds" || a === "scale")) continue;
                if (a === "scale") {
                    let l = e[a], c = s;
                    if (l[0] === c[0] && l[1] === c[1]) continue;
                } else if (a === "points") {
                    let l = e[a], c = s;
                    if (l.length === c.length) {
                        let d = !1, m = l.length;
                        for(; --m;){
                            let p = l[m], u = c[m];
                            if (p[0] !== u[0] || p[1] !== u[1]) {
                                d = !0;
                                break;
                            }
                        }
                        if (!d) continue;
                    }
                }
                e[a] = s, o = !0;
            }
        }
        return o && ((typeof t.height < "u" || typeof t.width < "u" || typeof i < "u" || typeof n < "u") && $e68ba20b3d2d159d$var$Oe.delete(e), e.version++, e.versionNonce = $e68ba20b3d2d159d$var$ko(), e.updated = $e68ba20b3d2d159d$var$ci(), r && $e68ba20b3d2d159d$var$fr.getScene(e)?.triggerUpdate()), e;
    }, $e68ba20b3d2d159d$export$5390fab1c98104d7 = (e, t, r = !1)=>{
        let o = !1;
        for(let n in t){
            let i = t[n];
            if (typeof i < "u") {
                if (e[n] === i && (typeof i != "object" || i === null)) continue;
                o = !0;
            }
        }
        return !o && !r ? e : {
            ...e,
            ...t,
            updated: $e68ba20b3d2d159d$var$ci(),
            version: e.version + 1,
            versionNonce: $e68ba20b3d2d159d$var$ko()
        };
    }, $e68ba20b3d2d159d$export$52f84dc7de3cd4b8 = (e, t)=>(e.version = (t ?? e.version) + 1, e.versionNonce = $e68ba20b3d2d159d$var$ko(), e.updated = $e68ba20b3d2d159d$var$ci(), e);
});
var $e68ba20b3d2d159d$export$2cab0e754c9472e0, $e68ba20b3d2d159d$var$bs, $e68ba20b3d2d159d$var$ju, $e68ba20b3d2d159d$var$qu, $e68ba20b3d2d159d$var$Fl, $e68ba20b3d2d159d$var$rd, $e68ba20b3d2d159d$var$ys = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$export$2cab0e754c9472e0 = (e)=>$e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e) ? e.points.length < 2 : e.width === 0 && e.height === 0, $e68ba20b3d2d159d$var$bs = (e, t, r, o, n)=>{
        let [i, a, s, l] = $e68ba20b3d2d159d$var$go(e, n), c = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: o.offsetLeft,
            clientY: o.offsetTop
        }, o), d = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: o.offsetLeft + t,
            clientY: o.offsetTop + r
        }, o);
        return c.x <= s && c.y <= l && d.x >= i && d.y >= a;
    }, $e68ba20b3d2d159d$var$ju = (e, t, r, o, n, i)=>{
        let [a, s, l, c] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e, n), d = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: o.offsetLeft + (i?.left || 0),
            clientY: o.offsetTop + (i?.top || 0)
        }, o), m = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: o.offsetLeft + t - (i?.right || 0),
            clientY: o.offsetTop + r - (i?.bottom || 0)
        }, o);
        return a >= d.x && s >= d.y && l <= m.x && c <= m.y;
    }, $e68ba20b3d2d159d$var$qu = (e, t, r)=>{
        let o = Math.abs(t), n = Math.abs(r);
        if (e === "line" || e === "arrow" || e === "freedraw") {
            let i = Math.round(Math.atan(n / o) / $e68ba20b3d2d159d$var$In) * $e68ba20b3d2d159d$var$In;
            i === 0 ? r = 0 : i === Math.PI / 2 ? t = 0 : r = o * Math.tan(i) * Math.sign(r) || r;
        } else e !== "selection" && (r = o * Math.sign(r));
        return {
            width: t,
            height: r
        };
    }, $e68ba20b3d2d159d$var$Fl = (e, t, r, o)=>{
        let n = r - e, i = o - t, a = Math.round(Math.atan(i / n) / $e68ba20b3d2d159d$var$In) * $e68ba20b3d2d159d$var$In;
        if (a === 0) i = 0;
        else if (a === Math.PI / 2) n = 0;
        else {
            let s = Math.tan(a), l = -1, c = t - s * e, d = -1 / s, m = -1, p = o - d * r, u = (l * p - m * c) / (s * m - d * l), h = (c * d - p * s) / (s * m - d * l);
            n = u - e, i = h - t;
        }
        return {
            width: n,
            height: i
        };
    }, $e68ba20b3d2d159d$var$rd = (e)=>{
        let t = {
            width: e.width,
            height: e.height,
            x: e.x,
            y: e.y
        };
        if (e.width < 0) {
            let r = Math.abs(e.width);
            t.width = r, t.x = e.x - r;
        }
        if (e.height < 0) {
            let r = Math.abs(e.height);
            t.height = r, t.y = e.y - r;
        }
        return t;
    };
});
var $e68ba20b3d2d159d$var$k3, $e68ba20b3d2d159d$var$Uk, $e68ba20b3d2d159d$var$L3, $e68ba20b3d2d159d$var$P3, $e68ba20b3d2d159d$var$rx, $e68ba20b3d2d159d$var$Ci, $e68ba20b3d2d159d$var$Ju, $e68ba20b3d2d159d$var$ws, $e68ba20b3d2d159d$var$Gl, $e68ba20b3d2d159d$var$Rd, $e68ba20b3d2d159d$var$Qu, $e68ba20b3d2d159d$var$Nd = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$k3 = {
        mouse: 8,
        pen: 16,
        touch: 28
    }, $e68ba20b3d2d159d$var$Uk = 16, $e68ba20b3d2d159d$var$L3 = {
        e: !0,
        s: !0,
        n: !0,
        w: !0
    }, $e68ba20b3d2d159d$var$P3 = {
        e: !0,
        s: !0,
        n: !0,
        w: !0,
        nw: !0,
        se: !0
    }, $e68ba20b3d2d159d$var$rx = {
        e: !0,
        s: !0,
        n: !0,
        w: !0
    }, $e68ba20b3d2d159d$var$Ci = (e, t, r, o, n, i, a)=>{
        let [s, l] = $e68ba20b3d2d159d$var$Ee(e + r / 2, t + o / 2, n, i, a);
        return [
            s - r / 2,
            l - o / 2,
            r,
            o
        ];
    }, $e68ba20b3d2d159d$var$Ju = (e)=>!(e.viewport.isMobile || e.isTouchScreen && ($e68ba20b3d2d159d$var$p0 || $e68ba20b3d2d159d$var$Lm)), $e68ba20b3d2d159d$var$ws = (e)=>$e68ba20b3d2d159d$var$Ju(e) ? $e68ba20b3d2d159d$var$L3 : {}, $e68ba20b3d2d159d$var$Gl = ([e, t, r, o, n, i], a, s, l, c = {}, d = 4)=>{
        let m = $e68ba20b3d2d159d$var$k3[l], p = m / s.value, u = m / s.value, h = m / s.value, g = m / s.value, b = r - e, v = o - t, y = d / s.value, w = (m - $e68ba20b3d2d159d$var$ai * 2) / (2 * s.value), I = {
            nw: c.nw ? void 0 : $e68ba20b3d2d159d$var$Ci(e - y - h + w, t - y - g + w, p, u, n, i, a),
            ne: c.ne ? void 0 : $e68ba20b3d2d159d$var$Ci(r + y - w, t - y - g + w, p, u, n, i, a),
            sw: c.sw ? void 0 : $e68ba20b3d2d159d$var$Ci(e - y - h + w, o + y - w, p, u, n, i, a),
            se: c.se ? void 0 : $e68ba20b3d2d159d$var$Ci(r + y - w, o + y - w, p, u, n, i, a),
            rotation: c.rotation ? void 0 : $e68ba20b3d2d159d$var$Ci(e + b / 2 - p / 2, t - y - g + w - $e68ba20b3d2d159d$var$Uk / s.value, p, u, n, i, a)
        }, M = 5 * $e68ba20b3d2d159d$var$k3.mouse / s.value;
        return Math.abs(b) > M && (c.n || (I.n = $e68ba20b3d2d159d$var$Ci(e + b / 2 - p / 2, t - y - g + w, p, u, n, i, a)), c.s || (I.s = $e68ba20b3d2d159d$var$Ci(e + b / 2 - p / 2, o + y - w, p, u, n, i, a))), Math.abs(v) > M && (c.w || (I.w = $e68ba20b3d2d159d$var$Ci(e - y - h + w, t + v / 2 - u / 2, p, u, n, i, a)), c.e || (I.e = $e68ba20b3d2d159d$var$Ci(r + y - w, t + v / 2 - u / 2, p, u, n, i, a))), I;
    }, $e68ba20b3d2d159d$var$Rd = (e, t, r, o = "mouse", n = $e68ba20b3d2d159d$var$L3)=>{
        if (e.locked || $e68ba20b3d2d159d$var$ce(e)) return {};
        if (e.type === "freedraw" || $e68ba20b3d2d159d$export$5df2ebb939539835(e)) {
            if (e.points.length === 2) {
                let [, a] = e.points;
                a[0] === 0 || a[1] === 0 ? n = $e68ba20b3d2d159d$var$rx : a[0] > 0 && a[1] < 0 ? n = $e68ba20b3d2d159d$var$P3 : a[0] > 0 && a[1] > 0 ? n = $e68ba20b3d2d159d$var$rx : a[0] < 0 && a[1] > 0 ? n = $e68ba20b3d2d159d$var$P3 : a[0] < 0 && a[1] < 0 && (n = $e68ba20b3d2d159d$var$rx);
            }
        } else $e68ba20b3d2d159d$var$re(e) && (n = {
            ...n,
            rotation: !0
        });
        let i = $e68ba20b3d2d159d$export$5df2ebb939539835(e) ? $e68ba20b3d2d159d$var$ai + 8 : $e68ba20b3d2d159d$var$ai;
        return $e68ba20b3d2d159d$var$Gl($e68ba20b3d2d159d$var$ae(e, r, !0), e.angle, t, o, n, i);
    }, $e68ba20b3d2d159d$var$Qu = (e, t)=>{
        if (t.editingLinearElement) return !1;
        if (e.length > 1) return !0;
        let r = e[0];
        return $e68ba20b3d2d159d$var$ce(r) ? !1 : $e68ba20b3d2d159d$export$5df2ebb939539835(r) ? r.points.length > 2 : !0;
    };
});
var $e68ba20b3d2d159d$var$nx, $e68ba20b3d2d159d$var$D3, $e68ba20b3d2d159d$var$eh, $e68ba20b3d2d159d$var$th, $e68ba20b3d2d159d$var$ox, $e68ba20b3d2d159d$var$Gk, $e68ba20b3d2d159d$var$rh, $e68ba20b3d2d159d$var$_3, $e68ba20b3d2d159d$var$R3 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Nd();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$ts();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$nx = (e, t, r)=>t >= e[0] && t <= e[0] + e[2] && r >= e[1] && r <= e[1] + e[3], $e68ba20b3d2d159d$var$D3 = (e, t, r, o, n, i, a, s)=>{
        if (!r.selectedElementIds[e.id]) return !1;
        let { rotation: l, ...c } = $e68ba20b3d2d159d$var$Rd(e, i, t, a, $e68ba20b3d2d159d$var$ws(s));
        if (l && $e68ba20b3d2d159d$var$nx(l, o, n)) return "rotation";
        let d = Object.keys(c).filter((m)=>{
            let p = c[m];
            return p ? $e68ba20b3d2d159d$var$nx(p, o, n) : !1;
        });
        if (d.length > 0) return d[0];
        if ($e68ba20b3d2d159d$var$Ju(s)) {
            let [m, p, u, h, g, b] = $e68ba20b3d2d159d$var$ae(e, t);
            if (!($e68ba20b3d2d159d$export$5df2ebb939539835(e) && e.points.length <= 2)) {
                let v = $e68ba20b3d2d159d$var$_m / i.value, y = $e68ba20b3d2d159d$var$_3([
                    m - v,
                    p - v
                ], [
                    u + v,
                    h + v
                ], [
                    g,
                    b
                ], $e68ba20b3d2d159d$var$an(e.angle));
                for (let [w, I] of Object.entries(y))if ($e68ba20b3d2d159d$var$es([
                    o,
                    n
                ], I, v)) return w;
            }
        }
        return !1;
    }, $e68ba20b3d2d159d$var$eh = (e, t, r, o, n, i, a, s)=>e.reduce((l, c)=>{
            if (l) return l;
            let d = $e68ba20b3d2d159d$var$D3(c, a, t, r, o, n, i, s);
            return d ? {
                element: c,
                transformHandleType: d
            } : null;
        }, null), $e68ba20b3d2d159d$var$th = ([e, t, r, o], n, i, a, s, l)=>{
        let c = $e68ba20b3d2d159d$var$Gl([
            e,
            t,
            r,
            o,
            (e + r) / 2,
            (t + o) / 2
        ], 0, a, s, $e68ba20b3d2d159d$var$ws(l)), d = Object.keys(c).find((m)=>{
            let p = c[m];
            return p && $e68ba20b3d2d159d$var$nx(p, n, i);
        });
        if (d) return d;
        if ($e68ba20b3d2d159d$var$Ju(l)) {
            let m = (e + r) / 2, p = (t + o) / 2, u = $e68ba20b3d2d159d$var$_m / a.value, h = $e68ba20b3d2d159d$var$_3([
                e - u,
                t - u
            ], [
                r + u,
                o + u
            ], [
                m,
                p
            ], $e68ba20b3d2d159d$var$an(0));
            for (let [g, b] of Object.entries(h))if ($e68ba20b3d2d159d$var$es([
                n,
                i
            ], b, u)) return g;
        }
        return !1;
    }, $e68ba20b3d2d159d$var$ox = [
        "ns",
        "nesw",
        "ew",
        "nwse"
    ], $e68ba20b3d2d159d$var$Gk = (e, t)=>{
        let r = $e68ba20b3d2d159d$var$ox.indexOf(e);
        if (r >= 0) {
            let o = Math.round(t / (Math.PI / 4));
            e = $e68ba20b3d2d159d$var$ox[(r + o) % $e68ba20b3d2d159d$var$ox.length];
        }
        return e;
    }, $e68ba20b3d2d159d$var$rh = (e)=>{
        let { element: t, transformHandleType: r } = e, o = t && Math.sign(t.height) * Math.sign(t.width) === -1, n = null;
        switch(r){
            case "n":
            case "s":
                n = "ns";
                break;
            case "w":
            case "e":
                n = "ew";
                break;
            case "nw":
            case "se":
                o ? n = "nesw" : n = "nwse";
                break;
            case "ne":
            case "sw":
                o ? n = "nwse" : n = "nesw";
                break;
            case "rotation":
                return "grab";
        }
        return n && t && (n = $e68ba20b3d2d159d$var$Gk(n, t.angle)), n ? `${n}-resize` : "";
    }, $e68ba20b3d2d159d$var$_3 = ([e, t], [r, o], n, i)=>{
        let a = $e68ba20b3d2d159d$var$Ct([
            e,
            t
        ], i, n), s = $e68ba20b3d2d159d$var$Ct([
            r,
            t
        ], i, n), l = $e68ba20b3d2d159d$var$Ct([
            e,
            o
        ], i, n), c = $e68ba20b3d2d159d$var$Ct([
            r,
            o
        ], i, n);
        return {
            n: [
                a,
                s
            ],
            e: [
                s,
                c
            ],
            s: [
                c,
                l
            ],
            w: [
                l,
                a
            ]
        };
    };
});
var $e68ba20b3d2d159d$var$oh, $e68ba20b3d2d159d$var$ix, $e68ba20b3d2d159d$var$Wk, $e68ba20b3d2d159d$var$Od, $e68ba20b3d2d159d$var$Fd, $e68ba20b3d2d159d$var$Vk, $e68ba20b3d2d159d$var$Yk, $e68ba20b3d2d159d$var$ax, $e68ba20b3d2d159d$var$Xk, $e68ba20b3d2d159d$var$sx, $e68ba20b3d2d159d$var$lx, $e68ba20b3d2d159d$var$Bd = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$$a();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$xs();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$Nt();
    $e68ba20b3d2d159d$var$Yt();
    $e68ba20b3d2d159d$var$Ol();
    $e68ba20b3d2d159d$var$oh = (e)=>e < 0 ? e + 2 * Math.PI : e >= 2 * Math.PI ? e - 2 * Math.PI : e, $e68ba20b3d2d159d$var$ix = (e, t, r, o, n, i, a, s, l, c, d)=>{
        if (r.length === 1) {
            let [m] = r;
            return t === "rotation" ? $e68ba20b3d2d159d$var$ce(m) || ($e68ba20b3d2d159d$var$Wk(m, o, s, l, n), $e68ba20b3d2d159d$var$Jt(m, o)) : $e68ba20b3d2d159d$var$G(m) && t ? ($e68ba20b3d2d159d$var$Vk(e, m, o, t, i, s, l), $e68ba20b3d2d159d$var$Jt(m, o)) : t && $e68ba20b3d2d159d$var$Yk(e, a, m, o, t, i, s, l), !0;
        } else if (r.length > 1) {
            if (t === "rotation") return $e68ba20b3d2d159d$var$Xk(e, r, o, s, l, n, c, d), !0;
            if (t) return $e68ba20b3d2d159d$var$ax(e, r, o, t, i, a, s, l), !0;
        }
        return !1;
    }, $e68ba20b3d2d159d$var$Wk = (e, t, r, o, n)=>{
        let [i, a, s, l] = $e68ba20b3d2d159d$var$ae(e, t), c = (i + s) / 2, d = (a + l) / 2, m;
        $e68ba20b3d2d159d$var$re(e) ? m = 0 : (m = 5 * Math.PI / 2 + Math.atan2(o - d, r - c), n && (m += $e68ba20b3d2d159d$var$In / 2, m -= m % $e68ba20b3d2d159d$var$In), m = $e68ba20b3d2d159d$var$oh(m));
        let p = $e68ba20b3d2d159d$var$fn(e);
        if ($e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            angle: m
        }), p) {
            let u = $e68ba20b3d2d159d$var$fr.getScene(e)?.getElement(p);
            u && !$e68ba20b3d2d159d$var$ie(e) && $e68ba20b3d2d159d$export$55655e96a21bba2e(u, {
                angle: m
            });
        }
    }, $e68ba20b3d2d159d$var$Od = (e, t, r, o)=>$e68ba20b3d2d159d$export$5df2ebb939539835(e) || $e68ba20b3d2d159d$var$qt(e) ? {
            points: $e68ba20b3d2d159d$var$Ki(0, t, $e68ba20b3d2d159d$var$Ki(1, r, e.points, o), o)
        } : {}, $e68ba20b3d2d159d$var$Fd = (e, t, r)=>{
        let o = e.width;
        if ($e68ba20b3d2d159d$var$Ge(e)) {
            let a = $e68ba20b3d2d159d$var$bt(e, t);
            a && (o = $e68ba20b3d2d159d$var$Mr(a, e));
        }
        let i = e.fontSize * (r / o);
        return i < $e68ba20b3d2d159d$var$Dm ? null : {
            size: i
        };
    }, $e68ba20b3d2d159d$var$Vk = (e, t, r, o, n, i, a)=>{
        let [s, l, c, d, m, p] = $e68ba20b3d2d159d$var$ae(t, r), [u, h] = $e68ba20b3d2d159d$var$Ee(i, a, m, p, -t.angle), g = 0, b = 0;
        o !== "e" && o !== "w" && (o.includes("e") && (g = (u - s) / (c - s)), o.includes("w") && (g = (c - u) / (c - s)), o.includes("n") && (b = (d - h) / (d - l)), o.includes("s") && (b = (h - l) / (d - l)));
        let v = Math.max(g, b);
        if (v > 0) {
            let y = t.width * v, w = t.height * v, I = $e68ba20b3d2d159d$var$Fd(t, r, y);
            if (I === null) return;
            let M = [
                s,
                l
            ], C = [
                c,
                d
            ], P = [
                m,
                p
            ], k = [
                s,
                l
            ];
            if ([
                "n",
                "w",
                "nw"
            ].includes(o) && (k = [
                C[0] - Math.abs(y),
                C[1] - Math.abs(w)
            ]), o === "ne") {
                let N = [
                    M[0],
                    C[1]
                ];
                k = [
                    N[0],
                    N[1] - Math.abs(w)
                ];
            }
            if (o === "sw") {
                let N = [
                    C[0],
                    M[1]
                ];
                k = [
                    N[0] - Math.abs(y),
                    N[1]
                ];
            }
            [
                "s",
                "n"
            ].includes(o) && (k[0] = P[0] - y / 2), [
                "e",
                "w"
            ].includes(o) && (k[1] = P[1] - w / 2), n && (k[0] = P[0] - Math.abs(y) / 2, k[1] = P[1] - Math.abs(w) / 2);
            let _ = t.angle, A = $e68ba20b3d2d159d$var$J(k, [
                m,
                p
            ], _), R = [
                k[0] + Math.abs(y) / 2,
                k[1] + Math.abs(w) / 2
            ], B = $e68ba20b3d2d159d$var$J(R, [
                m,
                p
            ], _);
            k = $e68ba20b3d2d159d$var$J(A, B, -_);
            let [V, ee] = k;
            $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                fontSize: I.size,
                width: y,
                height: w,
                x: V,
                y: ee
            });
        }
        if (o === "e" || o === "w") {
            let y = e.get(t.id), [w, I, M, C] = $e68ba20b3d2d159d$var$Ei(y, y.width, y.height, !0), P = [
                w,
                I
            ], k = [
                M,
                C
            ], _ = $e68ba20b3d2d159d$var$_l(P, k), A = $e68ba20b3d2d159d$var$J([
                i,
                a
            ], _, -y.angle), [R, , B] = $e68ba20b3d2d159d$var$Ei(t, t.width, t.height, !0), V = B - R, ee = k[0] - P[0], N = $e68ba20b3d2d159d$var$Ul($e68ba20b3d2d159d$var$ke({
                fontSize: t.fontSize,
                fontFamily: t.fontFamily
            }), t.lineHeight), H = ee / V;
            o.includes("e") && (H = (A[0] - P[0]) / V), o.includes("w") && (H = (k[0] - A[0]) / V);
            let xe = t.width * H < N ? N : t.width * H, X = $e68ba20b3d2d159d$var$Ro(t.originalText, $e68ba20b3d2d159d$var$ke(t), Math.abs(xe)), ne = $e68ba20b3d2d159d$var$Xt(X, $e68ba20b3d2d159d$var$ke(t), t.lineHeight), ve = ne.height, [Ce, Te, Le, Gt] = $e68ba20b3d2d159d$var$Ei(y, xe, ve, !0), co = Le - Ce, Xr = Gt - Te, xr = [
                ...P
            ];
            [
                "n",
                "w",
                "nw"
            ].includes(o) && (xr = [
                k[0] - Math.abs(co),
                P[1]
            ]);
            let So = y.angle, Pa = $e68ba20b3d2d159d$var$J(xr, _, So), Io = [
                xr[0] + Math.abs(co) / 2,
                xr[1] + Math.abs(Xr) / 2
            ], Co = $e68ba20b3d2d159d$var$J(Io, _, So);
            xr = $e68ba20b3d2d159d$var$J(Pa, Co, -So);
            let oi = {
                width: Math.abs(xe),
                height: Math.abs(ne.height),
                x: xr[0],
                y: xr[1],
                text: X,
                autoResize: !1
            };
            $e68ba20b3d2d159d$export$55655e96a21bba2e(t, oi);
        }
    }, $e68ba20b3d2d159d$var$Yk = (e, t, r, o, n, i, a, s)=>{
        let l = e.get(r.id), [c, d, m, p] = $e68ba20b3d2d159d$var$Ei(l, l.width, l.height, !0), u = [
            c,
            d
        ], h = [
            m,
            p
        ], g = $e68ba20b3d2d159d$var$_l(u, h), b = $e68ba20b3d2d159d$var$J([
            a,
            s
        ], g, -l.angle), [v, y, w, I] = $e68ba20b3d2d159d$var$Ei(r, r.width, r.height, !0), M = w - v, C = I - y, P = h[0] - u[0], k = h[1] - u[1], _ = P / M, A = k / C, R = {}, B = $e68ba20b3d2d159d$var$te(r, o);
        n.includes("e") && (_ = (b[0] - u[0]) / M), n.includes("s") && (A = (b[1] - u[1]) / C), n.includes("w") && (_ = (h[0] - b[0]) / M), n.includes("n") && (A = (h[1] - b[1]) / C);
        let V = l.width, ee = l.height, N = r.width * _, H = r.height * A;
        if (i && (N = 2 * N - V, H = 2 * H - ee), t) {
            let Kr = Math.abs(N) / V, Bs = Math.abs(H) / ee;
            if (n.length === 1 && (H *= Kr, N *= Bs), n.length === 2) {
                let Da = Math.max(Kr, Bs);
                N = V * Da * Math.sign(N), H = ee * Da * Math.sign(H);
            }
        }
        if (B) {
            let Kr = e.get(B.id);
            if (Kr && (R = {
                fontSize: Kr.fontSize
            }), t) {
                let Bs = {
                    ...r,
                    width: N,
                    height: H
                }, Da = $e68ba20b3d2d159d$var$Fd(B, o, $e68ba20b3d2d159d$var$Mr(Bs, B));
                if (Da === null) return;
                R = {
                    fontSize: Da.size
                };
            } else {
                let Bs = $e68ba20b3d2d159d$var$Hl($e68ba20b3d2d159d$var$ke(B), B.lineHeight), Da = $e68ba20b3d2d159d$var$zl(B.fontSize, B.lineHeight);
                N = Math.max(N, Bs), H = Math.max(H, Da);
            }
        }
        let [xe, X, ne, ve] = $e68ba20b3d2d159d$var$Ei(l, N, H, !0), Ce = ne - xe, Te = ve - X, Le = [
            ...u
        ];
        if ([
            "n",
            "w",
            "nw"
        ].includes(n) && (Le = [
            h[0] - Math.abs(Ce),
            h[1] - Math.abs(Te)
        ]), n === "ne") {
            let Kr = [
                u[0],
                h[1]
            ];
            Le = [
                Kr[0],
                Kr[1] - Math.abs(Te)
            ];
        }
        if (n === "sw") {
            let Kr = [
                h[0],
                u[1]
            ];
            Le = [
                Kr[0] - Math.abs(Ce),
                Kr[1]
            ];
        }
        t && ([
            "s",
            "n"
        ].includes(n) && (Le[0] = g[0] - Ce / 2), [
            "e",
            "w"
        ].includes(n) && (Le[1] = g[1] - Te / 2));
        let Gt = N < 0, co = H < 0;
        Gt && (n.includes("e") && (Le[0] -= Math.abs(Ce)), n.includes("w") && (Le[0] += Math.abs(Ce))), co && (n.includes("s") && (Le[1] -= Math.abs(Te)), n.includes("n") && (Le[1] += Math.abs(Te))), i && (Le[0] = g[0] - Math.abs(Ce) / 2, Le[1] = g[1] - Math.abs(Te) / 2);
        let Xr = l.angle, xr = $e68ba20b3d2d159d$var$J(Le, g, Xr), So = [
            Le[0] + Math.abs(Ce) / 2,
            Le[1] + Math.abs(Te) / 2
        ], Pa = $e68ba20b3d2d159d$var$J(So, g, Xr);
        Le = $e68ba20b3d2d159d$var$J(xr, Pa, -Xr);
        let Io = [
            ...Le
        ], Co = l.x - xe, oi = l.y - X;
        Io[0] += Co, Io[1] += oi;
        let vn = Io[0], Tm = Io[1], La, Ni;
        ($e68ba20b3d2d159d$export$5df2ebb939539835(r) || $e68ba20b3d2d159d$var$qt(r)) && (La = $e68ba20b3d2d159d$var$Ki(1, H, l.points, !0), Ni = $e68ba20b3d2d159d$var$Ki(0, N, La, !0));
        let Dr = {
            width: Math.abs(N),
            height: Math.abs(H),
            x: vn,
            y: Tm,
            points: Ni
        };
        if ("scale" in r && "scale" in l && $e68ba20b3d2d159d$export$55655e96a21bba2e(r, {
            scale: [
                (Math.sign(ne - l.x) || l.scale[0]) * l.scale[0],
                (Math.sign(ve - l.y) || l.scale[1]) * l.scale[1]
            ]
        }), $e68ba20b3d2d159d$var$ie(r) && B && t) {
            let Kr = Dr.width / r.width * B.fontSize;
            if (Kr < $e68ba20b3d2d159d$var$Dm) return;
            R.fontSize = Kr;
        }
        Dr.width !== 0 && Dr.height !== 0 && Number.isFinite(Dr.x) && Number.isFinite(Dr.y) && ($e68ba20b3d2d159d$export$55655e96a21bba2e(r, Dr), $e68ba20b3d2d159d$var$Jt(r, o, {
            oldSize: {
                width: l.width,
                height: l.height
            }
        }), B && R != null && $e68ba20b3d2d159d$export$55655e96a21bba2e(B, {
            fontSize: R.fontSize
        }), $e68ba20b3d2d159d$var$mn(r, o, n, t));
    }, $e68ba20b3d2d159d$var$ax = (e, t, r, o, n, i, a, s)=>{
        let l = t.reduce((X, ne)=>{
            let ve = e.get(ne.id);
            return ve && X.push({
                orig: ve,
                latest: ne
            }), X;
        }, []), c = l.reduce((X, { orig: ne })=>{
            if (!$e68ba20b3d2d159d$export$5df2ebb939539835(ne)) return X;
            let ve = $e68ba20b3d2d159d$var$fn(ne);
            if (!ve) return X;
            let Ce = e.get(ve) ?? null;
            if (!$e68ba20b3d2d159d$var$Ge(Ce)) return X;
            let Te = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(ne, Ce, r);
            return [
                ...X,
                {
                    ...Ce,
                    ...Te
                }
            ];
        }, []), { minX: d, minY: m, maxX: p, maxY: u, midX: h, midY: g } = $e68ba20b3d2d159d$var$oo(l.map(({ orig: X })=>X).concat(c)), b = p - d, v = u - m, y = o, w = {
            ne: [
                d,
                u
            ],
            se: [
                d,
                m
            ],
            sw: [
                p,
                m
            ],
            nw: [
                p,
                u
            ],
            e: [
                d,
                m + v / 2
            ],
            w: [
                p,
                m + v / 2
            ],
            n: [
                d + b / 2,
                u
            ],
            s: [
                d + b / 2,
                m
            ]
        }, [I, M] = n ? [
            h,
            g
        ] : w[y], C = n ? 2 : 1, P = Math.max(Math.abs(a - I) / b || 0, Math.abs(s - M) / v || 0) * C;
        if (P === 0) return;
        let k = y.includes("e") || y.includes("w") ? Math.abs(a - I) / b * C : 1, _ = y.includes("n") || y.includes("s") ? Math.abs(s - M) / v * C : 1, A = i || l.some((X)=>X.latest.angle !== 0 || $e68ba20b3d2d159d$var$G(X.latest) || $e68ba20b3d2d159d$var$Nn(X.latest));
        A && (k = P, _ = P);
        let R = {
            ne: [
                a < I,
                s > M
            ],
            se: [
                a < I,
                s < M
            ],
            sw: [
                a > I,
                s < M
            ],
            nw: [
                a > I,
                s > M
            ],
            e: [
                a < I,
                !1
            ],
            w: [
                a > I,
                !1
            ],
            n: [
                !1,
                s > M
            ],
            s: [
                !1,
                s < M
            ]
        }, [B, V] = R[y].map((X)=>X ? -1 : 1), ee = B < 0, N = V < 0, H = [];
        for (let { orig: X, latest: ne } of l){
            if ($e68ba20b3d2d159d$var$G(X) && $e68ba20b3d2d159d$var$Ge(X)) continue;
            let ve = X.width * k, Ce = X.height * _, Te = $e68ba20b3d2d159d$var$oh(X.angle * B * V), Le = $e68ba20b3d2d159d$export$5df2ebb939539835(X) || $e68ba20b3d2d159d$var$qt(X), Gt = X.x - I, co = X.y - M, Xr = ee && !Le ? ve : 0, xr = N && !Le ? Ce : 0, So = I + B * (Gt * k + Xr), Pa = M + V * (co * _ + xr), Io = $e68ba20b3d2d159d$var$Od(X, ve * B, Ce * V, !1), Co = {
                x: So,
                y: Pa,
                width: ve,
                height: Ce,
                angle: Te,
                ...Io
            };
            if ($e68ba20b3d2d159d$var$Ao(X) && (Co.scale = [
                X.scale[0] * B,
                X.scale[1] * V
            ]), $e68ba20b3d2d159d$var$G(X)) {
                let vn = $e68ba20b3d2d159d$var$Fd(X, r, ve);
                if (!vn) return;
                Co.fontSize = vn.size;
            }
            let oi = e.get($e68ba20b3d2d159d$var$fn(X) ?? "");
            if (oi) {
                if (A) {
                    let vn = oi.fontSize * P;
                    if (vn < $e68ba20b3d2d159d$var$Dm) return;
                    Co.boundTextFontSize = vn;
                } else Co.boundTextFontSize = oi.fontSize;
            }
            H.push({
                element: ne,
                update: Co
            });
        }
        let xe = H.map(({ element: X })=>X);
        for (let { element: X, update: { boundTextFontSize: ne, ...ve } } of H){
            let { angle: Ce } = ve, { width: Te, height: Le } = X;
            $e68ba20b3d2d159d$export$55655e96a21bba2e(X, ve, !1), $e68ba20b3d2d159d$var$ie(X) && $e68ba20b3d2d159d$var$ce(X) && $e68ba20b3d2d159d$var$Fo(X, r, X.points, void 0, void 0, {
                informMutation: !1
            }), $e68ba20b3d2d159d$var$Jt(X, r, {
                simultaneouslyUpdated: xe,
                oldSize: {
                    width: Te,
                    height: Le
                }
            });
            let Gt = $e68ba20b3d2d159d$var$te(X, r);
            Gt && ne && ($e68ba20b3d2d159d$export$55655e96a21bba2e(Gt, {
                fontSize: ne,
                angle: $e68ba20b3d2d159d$export$5df2ebb939539835(X) ? void 0 : Ce
            }, !1), $e68ba20b3d2d159d$var$mn(X, r, o, !0));
        }
        $e68ba20b3d2d159d$var$fr.getScene(H[0].element)?.triggerUpdate();
    }, $e68ba20b3d2d159d$var$Xk = (e, t, r, o, n, i, a, s)=>{
        let l = 5 * Math.PI / 2 + Math.atan2(n - s, o - a);
        i && (l += $e68ba20b3d2d159d$var$In / 2, l -= l % $e68ba20b3d2d159d$var$In), t.filter((c)=>!$e68ba20b3d2d159d$var$re(c)).forEach((c)=>{
            let [d, m, p, u] = $e68ba20b3d2d159d$var$ae(c, r), h = (d + p) / 2, g = (m + u) / 2, b = e.get(c.id)?.angle ?? c.angle, [v, y] = $e68ba20b3d2d159d$var$Ee(h, g, a, s, l + b - c.angle);
            if ($e68ba20b3d2d159d$var$ie(c) && $e68ba20b3d2d159d$var$ce(c)) {
                let I = $e68ba20b3d2d159d$var$mv(c, r);
                $e68ba20b3d2d159d$var$Fo(c, r, I);
            } else $e68ba20b3d2d159d$export$55655e96a21bba2e(c, {
                x: c.x + (v - h),
                y: c.y + (y - g),
                angle: $e68ba20b3d2d159d$var$oh(l + b)
            }, !1);
            $e68ba20b3d2d159d$var$Jt(c, r, {
                simultaneouslyUpdated: t
            });
            let w = $e68ba20b3d2d159d$var$te(c, r);
            w && !$e68ba20b3d2d159d$var$ie(c) && $e68ba20b3d2d159d$export$55655e96a21bba2e(w, {
                x: w.x + (v - h),
                y: w.y + (y - g),
                angle: $e68ba20b3d2d159d$var$oh(l + b)
            }, !1);
        }), $e68ba20b3d2d159d$var$fr.getScene(t[0])?.triggerUpdate();
    }, $e68ba20b3d2d159d$var$sx = (e, t, r, o, n)=>{
        let [i, a, s, l] = t.length === 1 ? $e68ba20b3d2d159d$var$ae(t[0], r) : $e68ba20b3d2d159d$export$3e54c0515ef60d1d(t), c = (i + s) / 2, d = (a + l) / 2, m = t.length === 1 ? t[0].angle : 0;
        switch([o, n] = $e68ba20b3d2d159d$var$Ee(o, n, c, d, -m), e){
            case "n":
                return $e68ba20b3d2d159d$var$Ee(o - (i + s) / 2, n - a, 0, 0, m);
            case "s":
                return $e68ba20b3d2d159d$var$Ee(o - (i + s) / 2, n - l, 0, 0, m);
            case "w":
                return $e68ba20b3d2d159d$var$Ee(o - i, n - (a + l) / 2, 0, 0, m);
            case "e":
                return $e68ba20b3d2d159d$var$Ee(o - s, n - (a + l) / 2, 0, 0, m);
            case "nw":
                return $e68ba20b3d2d159d$var$Ee(o - i, n - a, 0, 0, m);
            case "ne":
                return $e68ba20b3d2d159d$var$Ee(o - s, n - a, 0, 0, m);
            case "sw":
                return $e68ba20b3d2d159d$var$Ee(o - i, n - l, 0, 0, m);
            case "se":
                return $e68ba20b3d2d159d$var$Ee(o - s, n - l, 0, 0, m);
            default:
                return [
                    0,
                    0
                ];
        }
    }, $e68ba20b3d2d159d$var$lx = (e, t)=>{
        let [, [r, o]] = t.points;
        return e === "nw" && (r < 0 || o < 0) || e === "ne" && r >= 0 || e === "sw" && r <= 0 || e === "se" && (r > 0 || o > 0) ? "end" : "origin";
    };
});
var $e68ba20b3d2d159d$var$cx, $e68ba20b3d2d159d$var$Kk, $e68ba20b3d2d159d$var$N3, $e68ba20b3d2d159d$var$dx, $e68ba20b3d2d159d$var$nh, $e68ba20b3d2d159d$var$O3 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Qt();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Re();
    $e68ba20b3d2d159d$var$ys();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$cx = (e, t, r, o, n, i)=>{
        if (t.length === 1 && $e68ba20b3d2d159d$var$ie(t[0]) && $e68ba20b3d2d159d$var$ce(t[0]) && (t[0].startBinding || t[0].endBinding)) return;
        let a = t.filter((m)=>!($e68ba20b3d2d159d$var$ie(m) && $e68ba20b3d2d159d$var$ce(m) && m.startBinding && m.endBinding)), s = new Set(a), l = a.filter((m)=>$e68ba20b3d2d159d$var$re(m)).map((m)=>m.id);
        if (l.length > 0) for (let m of o.getNonDeletedElements())m.frameId !== null && l.includes(m.frameId) && s.add(m);
        let c = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(Array.from(s).map((m)=>e.originalElements.get(m.id) ?? m)), d = $e68ba20b3d2d159d$var$Kk(c, r, n, i);
        s.forEach((m)=>{
            if ($e68ba20b3d2d159d$var$N3(e, m, d), !$e68ba20b3d2d159d$var$ie(m)) {
                let p = $e68ba20b3d2d159d$var$te(m, o.getNonDeletedElementsMap());
                p && $e68ba20b3d2d159d$var$N3(e, p, d);
            }
            $e68ba20b3d2d159d$var$Jt(m, o.getElementsMapIncludingDeleted(), {
                simultaneouslyUpdated: Array.from(s)
            });
        });
    }, $e68ba20b3d2d159d$var$Kk = (e, t, r, o)=>{
        let [n, i] = e, a = n + t.x + r.x, s = i + t.y + r.y;
        if (r.x === 0 || r.y === 0) {
            let [l, c] = $e68ba20b3d2d159d$var$Ot(n + t.x, i + t.y, o);
            r.x === 0 && (a = l), r.y === 0 && (s = c);
        }
        return {
            x: a - n,
            y: s - i
        };
    }, $e68ba20b3d2d159d$var$N3 = (e, t, r)=>{
        let o = e.originalElements.get(t.id) ?? t, n = o.x + r.x, i = o.y + r.y;
        $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
            x: n,
            y: i
        });
    }, $e68ba20b3d2d159d$var$dx = (e, t, r)=>{
        let [o, n] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e);
        return [
            t - o,
            r - n
        ];
    }, $e68ba20b3d2d159d$var$nh = ({ newElement: e, elementType: t, originX: r, originY: o, x: n, y: i, width: a, height: s, shouldMaintainAspectRatio: l, shouldResizeFromCenter: c, zoom: d, widthAspectRatio: m = null, originOffset: p = null, informMutation: u = !0 })=>{
        l && e.type !== "selection" && (m ? s = a / m : (Math.abs(i - o) > Math.abs(n - r) ? { width: a, height: s } = $e68ba20b3d2d159d$var$qu(t, s, n < r ? -a : a) : { width: a, height: s } = $e68ba20b3d2d159d$var$qu(t, a, i < o ? -s : s), s < 0 && (s = -s)));
        let h = n < r ? r - a : r, g = i < o ? o - s : o;
        c && (a += a, s += s, h = r - a / 2, g = o - s / 2);
        let b = null;
        if ($e68ba20b3d2d159d$var$G(e)) {
            s = e.height;
            let v = $e68ba20b3d2d159d$var$Ul($e68ba20b3d2d159d$var$ke({
                fontSize: e.fontSize,
                fontFamily: e.fontFamily
            }), e.lineHeight);
            a = Math.max(a, v), Math.abs(n - r) > $e68ba20b3d2d159d$var$g0 / d && (b = {
                autoResize: !1
            }), g = o, c && (h = r - a / 2);
        }
        a !== 0 && s !== 0 && $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            x: h + (p?.x ?? 0),
            y: g + (p?.y ?? 0),
            width: a,
            height: s,
            ...b
        }, u);
    };
});
var $e68ba20b3d2d159d$var$vs, $e68ba20b3d2d159d$var$F3 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Xe();
    $e68ba20b3d2d159d$var$vs = (e, t)=>!!(!e.viewModeEnabled && (e.activeTool.type !== "custom" && (e.editingTextElement || e.activeTool.type !== "selection" && e.activeTool.type !== "eraser" && e.activeTool.type !== "hand" && e.activeTool.type !== "laser") || $e68ba20b3d2d159d$var$pe(t, e).length));
});
var $e68ba20b3d2d159d$export$b7313d603cab1db9, $e68ba20b3d2d159d$export$1859ad4f00516c7f, $e68ba20b3d2d159d$export$9169be2e06c9c165, $e68ba20b3d2d159d$var$B3, $e68ba20b3d2d159d$export$a9f9e75229944f66, $e68ba20b3d2d159d$var$_d, $e68ba20b3d2d159d$var$z3, $e68ba20b3d2d159d$var$m2, $e68ba20b3d2d159d$var$Dp, $e68ba20b3d2d159d$var$ye = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ys();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$gn();
    $e68ba20b3d2d159d$var$dt();
    $e68ba20b3d2d159d$var$Nd();
    $e68ba20b3d2d159d$var$R3();
    $e68ba20b3d2d159d$var$Bd();
    $e68ba20b3d2d159d$var$O3();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$We();
    $e68ba20b3d2d159d$var$ys();
    $e68ba20b3d2d159d$var$F3();
    $e68ba20b3d2d159d$export$b7313d603cab1db9 = (e)=>e.reduce((t, r)=>t + r.version, 0), $e68ba20b3d2d159d$export$1859ad4f00516c7f = (e)=>{
        let t = 5381;
        for(let r = 0; r < e.length; r++)t = (t << 5) + t + e[r].versionNonce;
        return t >>> 0;
    }, $e68ba20b3d2d159d$export$9169be2e06c9c165 = (e)=>{
        let t = 5381;
        for(let r = 0; r < e.length; r++){
            let o = e.charCodeAt(r);
            t = (t << 5) + t + o;
        }
        return t >>> 0;
    }, $e68ba20b3d2d159d$var$B3 = (e)=>e.filter((t)=>!t.isDeleted && !$e68ba20b3d2d159d$export$2cab0e754c9472e0(t)), $e68ba20b3d2d159d$export$a9f9e75229944f66 = (e)=>e.filter((t)=>!t.isDeleted), $e68ba20b3d2d159d$var$_d = (e)=>!e.isDeleted, $e68ba20b3d2d159d$var$z3 = (e)=>$e68ba20b3d2d159d$export$a9f9e75229944f66(e).map((t)=>$e68ba20b3d2d159d$var$_c(t.type) ? {
                ...t,
                lastCommittedPoint: null
            } : t), $e68ba20b3d2d159d$var$m2 = (e)=>$e68ba20b3d2d159d$var$z3(e), $e68ba20b3d2d159d$var$Dp = (e)=>$e68ba20b3d2d159d$var$z3(e);
});
var $e68ba20b3d2d159d$var$Ts, $e68ba20b3d2d159d$var$Ll, $e68ba20b3d2d159d$var$ux, $e68ba20b3d2d159d$var$Qe, $e68ba20b3d2d159d$var$hx, $e68ba20b3d2d159d$var$pe, $e68ba20b3d2d159d$var$zd, $e68ba20b3d2d159d$var$Fe, $e68ba20b3d2d159d$var$Wi = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$de();
    $e68ba20b3d2d159d$var$gr();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$ys();
    $e68ba20b3d2d159d$var$Ts = (e)=>{
        let t = new Set;
        return e.forEach((r)=>{
            $e68ba20b3d2d159d$var$re(r) && t.add(r.id);
        }), e.filter((r)=>!(r.frameId && t.has(r.frameId)));
    }, $e68ba20b3d2d159d$var$Ll = (e, t, r, o = !0)=>{
        let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(t, r), l = e.filter((c)=>{
            let [d, m, p, u] = $e68ba20b3d2d159d$var$go(c, r), h = $e68ba20b3d2d159d$var$rr(c, r);
            if (h) {
                let [g, b, v, y] = $e68ba20b3d2d159d$var$go(h, r);
                d = Math.max(g, d), m = Math.max(b, m), p = Math.min(v, p), u = Math.min(y, u);
            }
            return c.locked === !1 && c.type !== "selection" && !$e68ba20b3d2d159d$var$Ge(c) && n <= d && i <= m && a >= p && s >= u;
        });
        return l = o ? $e68ba20b3d2d159d$var$Ts(l) : l, l = l.filter((c)=>{
            let d = $e68ba20b3d2d159d$var$rr(c, r);
            return d ? $e68ba20b3d2d159d$var$No(c, d, r) : !0;
        }), l;
    }, $e68ba20b3d2d159d$var$ux = (e, t, r, o)=>{
        let n = new Set(t.map((i)=>i.id));
        return e.filter((i)=>{
            let a = $e68ba20b3d2d159d$var$bs(i, r.width, r.height, r, o);
            return !n.has(i.id) && a;
        });
    }, $e68ba20b3d2d159d$var$Qe = function() {
        let e = null, t = null, r = null, o = (n, i)=>(r != null && n === e && i.selectedElementIds === t || (r = n.some((a)=>i.selectedElementIds[a.id]), e = n, t = i.selectedElementIds), r);
        return o.clearCache = ()=>{
            e = null, t = null, r = null;
        }, o;
    }(), $e68ba20b3d2d159d$var$hx = (e, t, r)=>{
        let o = Array.from(new Set($e68ba20b3d2d159d$var$pe(e, t).map((n)=>r(n))));
        return o.length === 1 ? o[0] : null;
    }, $e68ba20b3d2d159d$var$pe = (e, t, r)=>{
        let o = [];
        for (let n of e.values()){
            if (t.selectedElementIds[n.id]) {
                o.push(n);
                continue;
            }
            if (r?.includeBoundTextElement && $e68ba20b3d2d159d$var$Ge(n) && t.selectedElementIds[n?.containerId]) {
                o.push(n);
                continue;
            }
        }
        if (r?.includeElementsInFrames) {
            let n = [];
            return o.forEach((i)=>{
                $e68ba20b3d2d159d$var$re(i) && $e68ba20b3d2d159d$var$bo(e, i.id).forEach((a)=>n.push(a)), n.push(i);
            }), n;
        }
        return o;
    }, $e68ba20b3d2d159d$var$zd = (e, t)=>t.editingTextElement ? [
            t.editingTextElement
        ] : t.newElement ? [
            t.newElement
        ] : $e68ba20b3d2d159d$var$pe(e, t, {
            includeBoundTextElement: !0
        }), $e68ba20b3d2d159d$var$Fe = (e, t)=>$e68ba20b3d2d159d$var$at(t.selectedElementIds, e) ? t.selectedElementIds : e;
});
var $e68ba20b3d2d159d$var$Zk, $e68ba20b3d2d159d$var$gx, $e68ba20b3d2d159d$var$Hn, $e68ba20b3d2d159d$var$fx = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$ye();
    $e68ba20b3d2d159d$var$W();
    $e68ba20b3d2d159d$var$Zk = (e, t)=>{
        let [r, o, n, i] = t, { x: a, y: s } = $e68ba20b3d2d159d$export$a4a3582487786f33({
            sceneX: r,
            sceneY: o
        }, e), { x: l, y: c } = $e68ba20b3d2d159d$export$a4a3582487786f33({
            sceneX: n,
            sceneY: i
        }, e);
        return l - a > e.width || c - s > e.height;
    }, $e68ba20b3d2d159d$var$gx = ({ scenePoint: e, viewportDimensions: t, zoom: r })=>({
            scrollX: t.width / 2 / r.value - e.x,
            scrollY: t.height / 2 / r.value - e.y
        }), $e68ba20b3d2d159d$var$Hn = (e, t)=>{
        if (e = $e68ba20b3d2d159d$var$B3(e), !e.length) return {
            scrollX: 0,
            scrollY: 0
        };
        let [r, o, n, i] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e);
        $e68ba20b3d2d159d$var$Zk(t, [
            r,
            o,
            n,
            i
        ]) && ([r, o, n, i] = $e68ba20b3d2d159d$var$XE(e, $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: t.scrollX,
            clientY: t.scrollY
        }, t)));
        let a = (r + n) / 2, s = (o + i) / 2;
        return $e68ba20b3d2d159d$var$gx({
            scenePoint: {
                x: a,
                y: s
            },
            viewportDimensions: {
                width: t.width,
                height: t.height
            },
            zoom: t.zoom
        });
    };
});
var $e68ba20b3d2d159d$var$to, $e68ba20b3d2d159d$var$lE, $e68ba20b3d2d159d$var$od, $e68ba20b3d2d159d$var$H3 = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Y();
    $e68ba20b3d2d159d$var$rt();
    $e68ba20b3d2d159d$var$to = (e)=>$e68ba20b3d2d159d$var$Bn($e68ba20b3d2d159d$var$c3(e, 6), $e68ba20b3d2d159d$var$Om, $e68ba20b3d2d159d$var$Fm), $e68ba20b3d2d159d$var$lE = (e)=>$e68ba20b3d2d159d$var$Bn(Math.round(e), 1, 100), $e68ba20b3d2d159d$var$od = (e)=>$e68ba20b3d2d159d$var$Bn(Math.round(e), 1, 100);
});
var $e68ba20b3d2d159d$var$Xe = $e68ba20b3d2d159d$var$K(()=>{
    "use strict";
    $e68ba20b3d2d159d$var$f();
    $e68ba20b3d2d159d$var$Wi();
    $e68ba20b3d2d159d$var$fx();
    $e68ba20b3d2d159d$var$Cd();
    $e68ba20b3d2d159d$var$H3();
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$$e = Symbol(), $e68ba20b3d2d159d$var$br = (0, $051474e5c5a9c9ad$export$239265d4179d81b3)();























































var $e68ba20b3d2d159d$var$S6 = $e68ba20b3d2d159d$var$e0({
    "./locales/ar-SA.json": ()=>(parcelRequire("wrIgO")),
    "./locales/az-AZ.json": ()=>(parcelRequire("8lIq9")),
    "./locales/bg-BG.json": ()=>(parcelRequire("57K7R")),
    "./locales/bn-BD.json": ()=>(parcelRequire("kfBeg")),
    "./locales/ca-ES.json": ()=>(parcelRequire("44kIP")),
    "./locales/cs-CZ.json": ()=>(parcelRequire("3m0Tx")),
    "./locales/da-DK.json": ()=>(parcelRequire("8rYzt")),
    "./locales/de-DE.json": ()=>(parcelRequire("8iCCj")),
    "./locales/el-GR.json": ()=>(parcelRequire("4ilWR")),
    "./locales/en.json": ()=>Promise.resolve((parcelRequire("2BVx3"))),
    "./locales/es-ES.json": ()=>(parcelRequire("fsgwp")),
    "./locales/eu-ES.json": ()=>(parcelRequire("15R1L")),
    "./locales/fa-IR.json": ()=>(parcelRequire("7o3SH")),
    "./locales/fi-FI.json": ()=>(parcelRequire("k4qN1")),
    "./locales/fr-FR.json": ()=>(parcelRequire("dlVEY")),
    "./locales/gl-ES.json": ()=>(parcelRequire("7IdwF")),
    "./locales/he-IL.json": ()=>(parcelRequire("iG5Bq")),
    "./locales/hi-IN.json": ()=>(parcelRequire("c2ybi")),
    "./locales/hu-HU.json": ()=>(parcelRequire("b5nR4")),
    "./locales/id-ID.json": ()=>(parcelRequire("6P2RI")),
    "./locales/it-IT.json": ()=>(parcelRequire("a1KRe")),
    "./locales/ja-JP.json": ()=>(parcelRequire("hGQ09")),
    "./locales/kaa.json": ()=>(parcelRequire("ghkPC")),
    "./locales/kab-KAB.json": ()=>(parcelRequire("eM4BI")),
    "./locales/kk-KZ.json": ()=>(parcelRequire("95UFN")),
    "./locales/km-KH.json": ()=>(parcelRequire("gNgTQ")),
    "./locales/ko-KR.json": ()=>(parcelRequire("k76pO")),
    "./locales/ku-TR.json": ()=>(parcelRequire("fohp3")),
    "./locales/lt-LT.json": ()=>(parcelRequire("7h0V3")),
    "./locales/lv-LV.json": ()=>(parcelRequire("bVMzX")),
    "./locales/mr-IN.json": ()=>(parcelRequire("6Zs38")),
    "./locales/my-MM.json": ()=>(parcelRequire("j458G")),
    "./locales/nb-NO.json": ()=>(parcelRequire("ecTVv")),
    "./locales/nl-NL.json": ()=>(parcelRequire("7bmgS")),
    "./locales/nn-NO.json": ()=>(parcelRequire("jsO5K")),
    "./locales/oc-FR.json": ()=>(parcelRequire("fPHNf")),
    "./locales/pa-IN.json": ()=>(parcelRequire("lRcpC")),
    "./locales/percentages.json": ()=>Promise.resolve((parcelRequire("3V2Z3"))),
    "./locales/pl-PL.json": ()=>(parcelRequire("g7AEJ")),
    "./locales/pt-BR.json": ()=>(parcelRequire("6HCdb")),
    "./locales/pt-PT.json": ()=>(parcelRequire("hSORx")),
    "./locales/ro-RO.json": ()=>(parcelRequire("8yN6k")),
    "./locales/ru-RU.json": ()=>(parcelRequire("7KoIq")),
    "./locales/si-LK.json": ()=>(parcelRequire("wOfp0")),
    "./locales/sk-SK.json": ()=>(parcelRequire("6sNyb")),
    "./locales/sl-SI.json": ()=>(parcelRequire("jkTe4")),
    "./locales/sv-SE.json": ()=>(parcelRequire("8eHj9")),
    "./locales/ta-IN.json": ()=>(parcelRequire("74729")),
    "./locales/th-TH.json": ()=>(parcelRequire("87mTV")),
    "./locales/tr-TR.json": ()=>(parcelRequire("j7RCH")),
    "./locales/uk-UA.json": ()=>(parcelRequire("qnPd3")),
    "./locales/vi-VN.json": ()=>(parcelRequire("bVo2w")),
    "./locales/zh-CN.json": ()=>(parcelRequire("kfL8w")),
    "./locales/zh-HK.json": ()=>(parcelRequire("aOo5T")),
    "./locales/zh-TW.json": ()=>(parcelRequire("7NDzr"))
});
var $e68ba20b3d2d159d$var$M6 = 85, $e68ba20b3d2d159d$export$811af2a4ddb5af35 = {
    code: "en",
    label: "English"
}, $e68ba20b3d2d159d$export$d0d68bb9ed2c643d = [
    $e68ba20b3d2d159d$export$811af2a4ddb5af35,
    ...[
        {
            code: "ar-SA",
            label: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
            rtl: !0
        },
        {
            code: "bg-BG",
            label: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"
        },
        {
            code: "ca-ES",
            label: "Catal\xe0"
        },
        {
            code: "cs-CZ",
            label: "\u010Cesky"
        },
        {
            code: "de-DE",
            label: "Deutsch"
        },
        {
            code: "el-GR",
            label: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
        },
        {
            code: "es-ES",
            label: "Espa\xf1ol"
        },
        {
            code: "eu-ES",
            label: "Euskara"
        },
        {
            code: "fa-IR",
            label: "\u0641\u0627\u0631\u0633\u06CC",
            rtl: !0
        },
        {
            code: "fi-FI",
            label: "Suomi"
        },
        {
            code: "fr-FR",
            label: "Fran\xe7ais"
        },
        {
            code: "gl-ES",
            label: "Galego"
        },
        {
            code: "he-IL",
            label: "\u05E2\u05D1\u05E8\u05D9\u05EA",
            rtl: !0
        },
        {
            code: "hi-IN",
            label: "\u0939\u093F\u0928\u094D\u0926\u0940"
        },
        {
            code: "hu-HU",
            label: "Magyar"
        },
        {
            code: "id-ID",
            label: "Bahasa Indonesia"
        },
        {
            code: "it-IT",
            label: "Italiano"
        },
        {
            code: "ja-JP",
            label: "\u65E5\u672C\u8A9E"
        },
        {
            code: "kab-KAB",
            label: "Taqbaylit"
        },
        {
            code: "kk-KZ",
            label: "\u049A\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456"
        },
        {
            code: "ko-KR",
            label: "\uD55C\uAD6D\uC5B4"
        },
        {
            code: "ku-TR",
            label: "Kurd\xee"
        },
        {
            code: "lt-LT",
            label: "Lietuvi\u0173"
        },
        {
            code: "lv-LV",
            label: "Latvie\u0161u"
        },
        {
            code: "my-MM",
            label: "Burmese"
        },
        {
            code: "nb-NO",
            label: "Norsk bokm\xe5l"
        },
        {
            code: "nl-NL",
            label: "Nederlands"
        },
        {
            code: "nn-NO",
            label: "Norsk nynorsk"
        },
        {
            code: "oc-FR",
            label: "Occitan"
        },
        {
            code: "pa-IN",
            label: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"
        },
        {
            code: "pl-PL",
            label: "Polski"
        },
        {
            code: "pt-BR",
            label: "Portugu\xeas Brasileiro"
        },
        {
            code: "pt-PT",
            label: "Portugu\xeas"
        },
        {
            code: "ro-RO",
            label: "Rom\xe2n\u0103"
        },
        {
            code: "ru-RU",
            label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
        },
        {
            code: "sk-SK",
            label: "Sloven\u010Dina"
        },
        {
            code: "sv-SE",
            label: "Svenska"
        },
        {
            code: "sl-SI",
            label: "Sloven\u0161\u010Dina"
        },
        {
            code: "tr-TR",
            label: "T\xfcrk\xe7e"
        },
        {
            code: "uk-UA",
            label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
        },
        {
            code: "zh-CN",
            label: "\u7B80\u4F53\u4E2D\u6587"
        },
        {
            code: "zh-TW",
            label: "\u7E41\u9AD4\u4E2D\u6587"
        },
        {
            code: "vi-VN",
            label: "Ti\u1EBFng Vi\u1EC7t"
        },
        {
            code: "mr-IN",
            label: "\u092E\u0930\u093E\u0920\u0940"
        }
    ].filter((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($3V2Z3)))[e.code] >= $e68ba20b3d2d159d$var$M6).sort((e, t)=>e.label > t.label ? 1 : -1)
], $e68ba20b3d2d159d$var$Im = "__test__";
$e68ba20b3d2d159d$var$T.DEV && $e68ba20b3d2d159d$export$d0d68bb9ed2c643d.unshift({
    code: $e68ba20b3d2d159d$var$Im,
    label: "test language"
}, {
    code: `${$e68ba20b3d2d159d$var$Im}.rtl`,
    label: "\u202Atest language (rtl)\u202C",
    rtl: !0
});
var $e68ba20b3d2d159d$var$zs = $e68ba20b3d2d159d$export$811af2a4ddb5af35, $e68ba20b3d2d159d$var$Sm = {}, $e68ba20b3d2d159d$var$Cm = async (e)=>{
    if ($e68ba20b3d2d159d$var$zs = e, document.documentElement.dir = $e68ba20b3d2d159d$var$zs.rtl ? "rtl" : "ltr", document.documentElement.lang = $e68ba20b3d2d159d$var$zs.code, e.code.startsWith($e68ba20b3d2d159d$var$Im)) $e68ba20b3d2d159d$var$Sm = {};
    else try {
        $e68ba20b3d2d159d$var$Sm = await $e68ba20b3d2d159d$var$S6(`./locales/${$e68ba20b3d2d159d$var$zs.code}.json`);
    } catch (t) {
        console.error(`Failed to load language ${e.code}:`, t.message), $e68ba20b3d2d159d$var$Sm = (0, (/*@__PURE__*/$parcel$interopDefault($2BVx3)));
    }
    $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$o0, e.code);
}, $e68ba20b3d2d159d$var$Sn = ()=>$e68ba20b3d2d159d$var$zs, $e68ba20b3d2d159d$var$t0 = (e, t)=>{
    for(let r = 0; r < t.length; ++r){
        let o = t[r];
        if (e[o] === void 0) return;
        e = e[o];
    }
    if (typeof e == "string") return e;
}, $e68ba20b3d2d159d$var$x = (e, t, r)=>{
    if ($e68ba20b3d2d159d$var$zs.code.startsWith($e68ba20b3d2d159d$var$Im)) return `\u202A[[${t ? `${e}(${JSON.stringify(t).slice(1, -1)})` : e}]]\u202C`;
    let o = e.split("."), n = $e68ba20b3d2d159d$var$t0($e68ba20b3d2d159d$var$Sm, o) || $e68ba20b3d2d159d$var$t0((0, (/*@__PURE__*/$parcel$interopDefault($2BVx3))), o) || r;
    if (n === void 0) {
        let i = `Can't find translation for ${e}`;
        if ($e68ba20b3d2d159d$var$T.PROD) return console.warn(i), "";
        throw new Error(i);
    }
    if (t) for(let i in t)n = n.replace(`{{${i}}}`, String(t[i]));
    return n;
}, $e68ba20b3d2d159d$var$o0 = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)($e68ba20b3d2d159d$export$811af2a4ddb5af35.code), $e68ba20b3d2d159d$export$3f3caade1c12f8c9 = ()=>{
    let e = (0, $051474e5c5a9c9ad$export$89a40582f8c436cc)($e68ba20b3d2d159d$var$o0, $e68ba20b3d2d159d$var$$e);
    return {
        t: $e68ba20b3d2d159d$var$x,
        langCode: e
    };
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$P6 = ({ size: e = "1em", circleWidth: t = 8, synchronized: r = !1, className: o = "" })=>{
    let i = -((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(Date.now()).current % 1600);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `Spinner ${o}`,
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            viewBox: "0 0 100 100",
            style: {
                width: e,
                height: e,
                "--spinner-delay": r ? `${i}ms` : 0
            },
            children: (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: 50 - t / 2,
                strokeWidth: t,
                fill: "none",
                strokeMiterlimit: "10"
            })
        })
    });
}, $e68ba20b3d2d159d$var$ar = $e68ba20b3d2d159d$var$P6;
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$Vm = ({ delay: e, theme: t })=>{
    let [r, o] = (0, $acw62.useState)(!!e);
    return (0, $acw62.useEffect)(()=>{
        if (!e) return;
        let n = setTimeout(()=>{
            o(!1);
        }, e);
        return ()=>clearTimeout(n);
    }, [
        e
    ]), r ? null : (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("LoadingMessage", {
            "LoadingMessage--dark": t === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK
        }),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "LoadingMessage-text",
                children: $e68ba20b3d2d159d$var$x("labels.loadingScene")
            })
        ]
    });
};
var $e68ba20b3d2d159d$var$F0 = (e)=>{
    let [t, r] = (0, $acw62.useState)(!0);
    return (0, $acw62.useEffect)(()=>{
        let o = async ()=>{
            await $e68ba20b3d2d159d$var$Cm(n), r(!1);
        }, n = $e68ba20b3d2d159d$export$d0d68bb9ed2c643d.find((i)=>i.code === e.langCode) || $e68ba20b3d2d159d$export$811af2a4ddb5af35;
        o();
    }, [
        e.langCode
    ]), t ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vm, {
        theme: e.theme
    }) : e.children;
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Gi();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$he = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((e, t)=>{
    let { id: r } = $e68ba20b3d2d159d$var$Ft(), o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(t, ()=>o.current);
    let n = `ToolIcon_size_${e.size}`, [i, a] = (0, $acw62.useState)(!1), s = (0, $acw62.useRef)(!0), l = async (d)=>{
        let m = "onClick" in e && e.onClick?.(d);
        if ($e68ba20b3d2d159d$var$Ln(m)) try {
            a(!0), await m;
        } catch (p) {
            if (p instanceof $e68ba20b3d2d159d$var$Rn) console.warn(p);
            else throw p;
        } finally{
            s.current && a(!1);
        }
    };
    (0, $acw62.useEffect)(()=>(s.current = !0, ()=>{
            s.current = !1;
        }), []);
    let c = (0, $acw62.useRef)(null);
    if (e.type === "button" || e.type === "icon" || e.type === "submit") {
        let d = e.type === "icon" ? "button" : e.type;
        return (0, $7b02d682eb115277$exports.jsxs)("button", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon_type_button", n, e.className, e.visible && !e.hidden ? "ToolIcon_type_button--show" : "ToolIcon_type_button--hide", {
                ToolIcon: !e.hidden,
                "ToolIcon--selected": e.selected,
                "ToolIcon--plain": e.type === "icon"
            }),
            style: e.style,
            "data-testid": e["data-testid"],
            hidden: e.hidden,
            title: e.title,
            "aria-label": e["aria-label"],
            type: d,
            onClick: l,
            ref: o,
            disabled: i || e.isLoading || !!e.disabled,
            children: [
                (e.icon || e.label) && (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ToolIcon__icon",
                    "aria-hidden": "true",
                    "aria-disabled": !!e.disabled,
                    children: [
                        e.icon || e.label,
                        e.keyBindingLabel && (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "ToolIcon__keybinding",
                            children: e.keyBindingLabel
                        }),
                        e.isLoading && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
                    ]
                }),
                e.showAriaLabel && (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "ToolIcon__label",
                    children: [
                        e["aria-label"],
                        " ",
                        i && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
                    ]
                }),
                e.children
            ]
        });
    }
    return (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon", e.className),
        title: e.title,
        onPointerDown: (d)=>{
            c.current = d.pointerType || null, e.onPointerDown?.({
                pointerType: d.pointerType || null
            });
        },
        onPointerUp: ()=>{
            requestAnimationFrame(()=>{
                c.current = null;
            });
        },
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: `ToolIcon_type_radio ${n}`,
                type: "radio",
                name: e.name,
                "aria-label": e["aria-label"],
                "aria-keyshortcuts": e["aria-keyshortcuts"],
                "data-testid": e["data-testid"],
                id: `${r}-${e.id}`,
                onChange: ()=>{
                    e.onChange?.({
                        pointerType: c.current
                    });
                },
                checked: e.checked,
                ref: o
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ToolIcon__icon",
                children: [
                    e.icon,
                    e.keyBindingLabel && (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "ToolIcon__keybinding",
                        children: e.keyBindingLabel
                    })
                ]
            })
        ]
    });
});
$e68ba20b3d2d159d$var$he.defaultProps = {
    visible: !0,
    className: "",
    size: "medium"
};
$e68ba20b3d2d159d$var$he.displayName = "ToolButton";
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$Ol();
var $e68ba20b3d2d159d$var$Jk = (e, t, r)=>{
    let o = r.scene.getNonDeletedElementsMap(), n = new Set($e68ba20b3d2d159d$var$pe(e.filter((i)=>$e68ba20b3d2d159d$var$re(i)), t).map((i)=>i.id));
    return {
        elements: e.map((i)=>t.selectedElementIds[i.id] ? (i.boundElements && i.boundElements.forEach((a)=>{
                let s = r.scene.getNonDeletedElementsMap().get(a.id);
                s && $e68ba20b3d2d159d$var$ce(s) && ($e68ba20b3d2d159d$export$55655e96a21bba2e(s, {
                    startBinding: i.id === s.startBinding?.elementId ? null : s.startBinding,
                    endBinding: i.id === s.endBinding?.elementId ? null : s.endBinding
                }), $e68ba20b3d2d159d$var$Fo(s, o, s.points));
            }), $e68ba20b3d2d159d$export$5390fab1c98104d7(i, {
                isDeleted: !0
            })) : i.frameId && n.has(i.frameId) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(i, {
                isDeleted: !0
            }) : $e68ba20b3d2d159d$var$Ge(i) && t.selectedElementIds[i.containerId] ? $e68ba20b3d2d159d$export$5390fab1c98104d7(i, {
                isDeleted: !0
            }) : i),
        appState: {
            ...t,
            selectedElementIds: {},
            selectedGroupIds: {}
        }
    };
}, $e68ba20b3d2d159d$var$W3 = (e, t)=>{
    if (e.editingGroupId) {
        let r = $e68ba20b3d2d159d$var$nt($e68ba20b3d2d159d$export$a9f9e75229944f66(t), e.editingGroupId);
        if (r.length) return {
            ...e,
            selectedElementIds: {
                [r[0].id]: !0
            }
        };
    }
    return e;
}, $e68ba20b3d2d159d$var$Gd = $e68ba20b3d2d159d$var$U({
    name: "deleteSelectedElements",
    label: "labels.delete",
    icon: $e68ba20b3d2d159d$var$rn,
    trackEvent: {
        category: "element",
        action: "delete"
    },
    perform: (e, t, r, o)=>{
        if (t.editingLinearElement) {
            let { elementId: a, selectedPointsIndices: s, startBindingElement: l, endBindingElement: c } = t.editingLinearElement, d = o.scene.getNonDeletedElementsMap(), m = $e68ba20b3d2d159d$var$$.getElement(a, d);
            if (!m || s == null) return !1;
            if (m.points.length < 2) {
                let u = e.map((g)=>g.id === m.id ? $e68ba20b3d2d159d$export$5390fab1c98104d7(g, {
                        isDeleted: !0
                    }) : g), h = $e68ba20b3d2d159d$var$W3(t, u);
                return {
                    elements: u,
                    appState: {
                        ...h,
                        editingLinearElement: null
                    },
                    storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                };
            }
            let p = {
                startBindingElement: s?.includes(0) ? null : l,
                endBindingElement: s?.includes(m.points.length - 1) ? null : c
            };
            return $e68ba20b3d2d159d$var$$.deletePoints(m, s, d), {
                elements: e,
                appState: {
                    ...t,
                    editingLinearElement: {
                        ...t.editingLinearElement,
                        ...p,
                        selectedPointsIndices: s?.[0] > 0 ? [
                            s[0] - 1
                        ] : [
                            0
                        ]
                    }
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            };
        }
        let { elements: n, appState: i } = $e68ba20b3d2d159d$var$Jk(e, t, o);
        return $e68ba20b3d2d159d$var$Jp(n, e.filter(({ id: a })=>t.selectedElementIds[a])), i = $e68ba20b3d2d159d$var$W3(i, n), {
            elements: n,
            appState: {
                ...i,
                activeTool: $e68ba20b3d2d159d$var$it(t, {
                    type: "selection"
                }),
                multiElement: null,
                activeEmbeddable: null
            },
            storeAction: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t) ? $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE : $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    keyTest: (e, t, r)=>(e.key === $e68ba20b3d2d159d$var$S.BACKSPACE || e.key === $e68ba20b3d2d159d$var$S.DELETE) && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD],
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$rn,
            title: $e68ba20b3d2d159d$var$x("labels.delete"),
            "aria-label": $e68ba20b3d2d159d$var$x("labels.delete"),
            onClick: ()=>r(null),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$xs();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$xx = (e, t)=>e.frameId === t || e.id === t, $e68ba20b3d2d159d$var$Y3 = (e, t, r)=>{
    let o = [], n = [], i = null, a = -1, s = $e68ba20b3d2d159d$var$j(r || $e68ba20b3d2d159d$var$pe(e, t, {
        includeBoundTextElement: !0,
        includeElementsInFrames: !0
    }));
    for(; ++a < e.length;){
        let l = e[a];
        s.get(l.id) ? (n.length && (o = o.concat(n), n = []), o.push(a), i = a + 1) : l.isDeleted && i === a ? (i = a + 1, n.push(a)) : n = [];
    }
    return o;
}, $e68ba20b3d2d159d$var$eP = (e)=>{
    let t = 0;
    return e.reduce((r, o, n)=>(n > 0 && e[n - 1] !== o - 1 && (t = ++t), (r[t] || (r[t] = [])).push(o), r), []);
}, $e68ba20b3d2d159d$var$V3 = (e, t, r)=>{
    if ("containerId" in e && e.containerId) {
        let o = $e68ba20b3d2d159d$var$fr.getScene(e).getElement(e.containerId);
        if (o) return r === "left" ? Math.min(t.indexOf(o), t.indexOf(e)) : Math.max(t.indexOf(o), t.indexOf(e));
    } else {
        let o = e.boundElements?.find((n)=>n.type !== "arrow")?.id;
        if (o) {
            let n = $e68ba20b3d2d159d$var$fr.getScene(e).getElement(o);
            if (n) return r === "left" ? Math.min(t.indexOf(n), t.indexOf(e)) : Math.max(t.indexOf(n), t.indexOf(e));
        }
    }
}, $e68ba20b3d2d159d$var$tP = (e, t)=>{
    let r = -1, o = -1;
    return e.forEach((n, i)=>{
        $e68ba20b3d2d159d$var$xx(n, t) && (r === -1 && (r = i), o = i);
    }), r === -1 ? [] : e.slice(r, o + 1);
}, $e68ba20b3d2d159d$var$rP = (e, t, r, o, n)=>{
    let i = t[r], a = (m)=>m.isDeleted ? !1 : n ? m.frameId === n : e.editingGroupId ? m.groupIds.includes(e.editingGroupId) : !0, s = o === "left" ? $e68ba20b3d2d159d$var$lf(t, (m)=>a(m), Math.max(0, r - 1)) : $e68ba20b3d2d159d$var$sf(t, (m)=>a(m), r + 1), l = t[s];
    if (!l) return -1;
    if (e.editingGroupId) {
        if (i?.groupIds.join("") === l?.groupIds.join("")) return $e68ba20b3d2d159d$var$V3(l, t, o) ?? s;
        if (!l?.groupIds.includes(e.editingGroupId)) return -1;
    }
    if (!n && (l.frameId || $e68ba20b3d2d159d$var$re(l))) {
        let m = $e68ba20b3d2d159d$var$tP(t, l.frameId || l.id);
        return o === "left" ? t.indexOf(m[0]) : t.indexOf(m[m.length - 1]);
    }
    if (!l.groupIds.length) return $e68ba20b3d2d159d$var$V3(l, t, o) ?? s;
    let c = e.editingGroupId ? l.groupIds[l.groupIds.indexOf(e.editingGroupId) - 1] : l.groupIds[l.groupIds.length - 1], d = $e68ba20b3d2d159d$var$nt(t, c);
    return d.length ? o === "left" ? t.indexOf(d[0]) : t.indexOf(d[d.length - 1]) : s;
}, $e68ba20b3d2d159d$var$X3 = (e, t)=>t.reduce((r, o)=>{
        let n = e[o];
        return r.set(n.id, n), r;
    }, new Map), $e68ba20b3d2d159d$var$K3 = (e, t, r)=>{
    let o = $e68ba20b3d2d159d$var$Y3(e, t), n = $e68ba20b3d2d159d$var$X3(e, o), i = $e68ba20b3d2d159d$var$eP(o);
    r === "right" && (i = i.reverse());
    let a = new Set(o.filter((s)=>$e68ba20b3d2d159d$var$re(e[s])).map((s)=>e[s].id));
    return i.forEach((s, l)=>{
        let c = s[0], d = s[s.length - 1], m = r === "left" ? c : d, p = s.some((y)=>{
            let w = e[y];
            return w.frameId && a.has(w.frameId);
        }) ? null : e[m]?.frameId, u = $e68ba20b3d2d159d$var$rP(t, e, m, r, p);
        if (u === -1 || m === u) return;
        let h = r === "left" ? e.slice(0, u) : e.slice(0, c), g = e.slice(c, d + 1), b = r === "left" ? e.slice(u, c) : e.slice(d + 1, u + 1), v = r === "left" ? e.slice(d + 1) : e.slice(u + 1);
        e = r === "left" ? [
            ...h,
            ...g,
            ...b,
            ...v
        ] : [
            ...h,
            ...b,
            ...g,
            ...v
        ];
    }), $e68ba20b3d2d159d$var$tr(e, n), e;
}, $e68ba20b3d2d159d$var$$3 = (e, t, r, o, n)=>{
    let i = $e68ba20b3d2d159d$var$Y3(e, t, n), a = $e68ba20b3d2d159d$var$X3(e, i), s = [], l, c;
    if (r === "left") {
        if (o) l = $e68ba20b3d2d159d$var$sf(e, (h)=>$e68ba20b3d2d159d$var$xx(h, o));
        else if (t.editingGroupId) {
            let h = $e68ba20b3d2d159d$var$nt(e, t.editingGroupId);
            if (!h.length) return e;
            l = e.indexOf(h[0]);
        } else l = 0;
        c = i[i.length - 1];
    } else {
        if (o) c = $e68ba20b3d2d159d$var$lf(e, (h)=>$e68ba20b3d2d159d$var$xx(h, o));
        else if (t.editingGroupId) {
            let h = $e68ba20b3d2d159d$var$nt(e, t.editingGroupId);
            if (!h.length) return e;
            c = e.indexOf(h[h.length - 1]);
        } else c = e.length - 1;
        l = i[0];
    }
    l === -1 && (l = 0);
    for(let h = l; h < c + 1; h++)i.includes(h) || s.push(e[h]);
    let d = Array.from(a.values()), m = e.slice(0, l), p = e.slice(c + 1), u = r === "left" ? [
        ...m,
        ...d,
        ...s,
        ...p
    ] : [
        ...m,
        ...s,
        ...d,
        ...p
    ];
    return $e68ba20b3d2d159d$var$tr(u, a), u;
};
function $e68ba20b3d2d159d$var$Z3(e, t, r, o) {
    let n = $e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$pe(e, t, {
        includeBoundTextElement: !0,
        includeElementsInFrames: !0
    })), i = {
        regularElements: [],
        frameChildren: new Map
    }, a = new Set;
    for (let c of e)n.has(c.id) && $e68ba20b3d2d159d$var$re(c) && a.add(c.id);
    for (let c of e)if (n.has(c.id)) {
        if ($e68ba20b3d2d159d$var$re(c) || c.frameId && a.has(c.frameId)) i.regularElements.push(c);
        else if (!c.frameId) i.regularElements.push(c);
        else {
            let d = i.frameChildren.get(c.frameId) || [];
            d.push(c), i.frameChildren.set(c.frameId, d);
        }
    }
    let s = e, l = Array.from(i.frameChildren.entries());
    for (let [c, d] of l)s = o(e, t, r, c, d);
    return o(s, t, r, null, i.regularElements);
}
var $e68ba20b3d2d159d$var$j3 = (e, t)=>$e68ba20b3d2d159d$var$K3(e, t, "left"), $e68ba20b3d2d159d$var$q3 = (e, t)=>$e68ba20b3d2d159d$var$K3(e, t, "right"), $e68ba20b3d2d159d$var$J3 = (e, t)=>$e68ba20b3d2d159d$var$Z3(e, t, "left", $e68ba20b3d2d159d$var$$3), $e68ba20b3d2d159d$var$Q3 = (e, t)=>$e68ba20b3d2d159d$var$Z3(e, t, "right", $e68ba20b3d2d159d$var$$3);
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$bx = $e68ba20b3d2d159d$var$U({
    name: "sendBackward",
    label: "labels.sendBackward",
    keywords: [
        "move down",
        "zindex",
        "layer"
    ],
    icon: $e68ba20b3d2d159d$var$wf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t)=>({
            elements: $e68ba20b3d2d159d$var$j3(e, t),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyPriority: 40,
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_LEFT,
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "zIndexButton",
            onClick: ()=>e(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.sendBackward")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+[")}`,
            children: $e68ba20b3d2d159d$var$wf
        })
}), $e68ba20b3d2d159d$var$yx = $e68ba20b3d2d159d$var$U({
    name: "bringForward",
    label: "labels.bringForward",
    keywords: [
        "move up",
        "zindex",
        "layer"
    ],
    icon: $e68ba20b3d2d159d$var$yf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t)=>({
            elements: $e68ba20b3d2d159d$var$q3(e, t),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyPriority: 40,
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_RIGHT,
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "zIndexButton",
            onClick: ()=>e(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.bringForward")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+]")}`,
            children: $e68ba20b3d2d159d$var$yf
        })
}), $e68ba20b3d2d159d$var$wx = $e68ba20b3d2d159d$var$U({
    name: "sendToBack",
    label: "labels.sendToBack",
    keywords: [
        "move down",
        "zindex",
        "layer"
    ],
    icon: $e68ba20b3d2d159d$var$Tf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t)=>({
            elements: $e68ba20b3d2d159d$var$J3(e, t),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>$e68ba20b3d2d159d$var$_r ? e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_LEFT : e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_LEFT,
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "zIndexButton",
            onClick: ()=>e(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.sendToBack")} \u2014 ${$e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+[") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+[")}`,
            children: $e68ba20b3d2d159d$var$Tf
        })
}), $e68ba20b3d2d159d$var$vx = $e68ba20b3d2d159d$var$U({
    name: "bringToFront",
    label: "labels.bringToFront",
    keywords: [
        "move up",
        "zindex",
        "layer"
    ],
    icon: $e68ba20b3d2d159d$var$vf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t)=>({
            elements: $e68ba20b3d2d159d$var$Q3(e, t),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>$e68ba20b3d2d159d$var$_r ? e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_RIGHT : e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.BRACKET_RIGHT,
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "zIndexButton",
            onClick: (r)=>e(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.bringToFront")} \u2014 ${$e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+]") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+]")}`,
            children: $e68ba20b3d2d159d$var$vf
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$Wi();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$Tx = $e68ba20b3d2d159d$var$U({
    name: "selectAll",
    label: "labels.selectAll",
    icon: $e68ba20b3d2d159d$var$Yw,
    trackEvent: {
        category: "canvas"
    },
    viewMode: !1,
    perform: (e, t, r, o)=>{
        if (t.editingLinearElement) return !1;
        let n = $e68ba20b3d2d159d$var$Ts(e.filter((i)=>!i.isDeleted && !($e68ba20b3d2d159d$var$G(i) && i.containerId) && !i.locked)).reduce((i, a)=>(i[a.id] = !0, i), {});
        return {
            appState: {
                ...t,
                ...$e68ba20b3d2d159d$var$mr({
                    editingGroupId: null,
                    selectedElementIds: n
                }, $e68ba20b3d2d159d$export$a9f9e75229944f66(e), t, o),
                selectedLinearElement: Object.keys(n).length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(e[0]) ? new $e68ba20b3d2d159d$var$$(e[0]) : null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.A
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$oP = (e)=>{
    let t = e.slice(), r = new Set, o = (i)=>{
        let a = i[0]?.groupIds?.join(""), s = [
            i[0]
        ], l = [];
        for (let c of i.slice(1))c.groupIds?.join("") === a ? s.push(c) : l.push(c);
        return l.length ? [
            ...s,
            ...o(l)
        ] : s;
    }, n = new Map;
    return t.forEach((i, a)=>{
        if (!n.has(i.id)) {
            if (i.groupIds?.length) {
                let s = i.groupIds[i.groupIds.length - 1], l = t.slice(a).filter((c)=>{
                    let d = c?.groupIds?.some((m)=>m === s);
                    return d && n.set(c.id, !0), d;
                });
                for (let c of o(l))r.add(c);
            } else r.add(i);
        }
    }), r.size !== e.length ? (console.error("normalizeGroupElementOrder: lost some elements... bailing!"), e) : [
        ...r
    ];
}, $e68ba20b3d2d159d$var$nP = (e)=>{
    let t = $e68ba20b3d2d159d$var$Z0(e), r = e.slice(), o = new Set;
    return r.forEach((n, i)=>{
        n && (n.boundElements?.length ? (o.add(n), r[i] = null, n.boundElements.forEach((a)=>{
            let s = t.get(a.id);
            s && a.type === "text" && (o.add(s[0]), r[s[1]] = null);
        })) : n.type === "text" && n.containerId && t.get(n.containerId)?.[0].boundElements?.find((s)=>s.id === n.id) || (o.add(n), r[i] = null));
    }), o.size !== e.length ? (console.error("normalizeBoundElementsOrder: lost some elements... bailing!"), e) : [
        ...o
    ];
}, $e68ba20b3d2d159d$var$eS = (e)=>$e68ba20b3d2d159d$var$nP($e68ba20b3d2d159d$var$oP(e));
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$Wi();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$Sx = $e68ba20b3d2d159d$var$U({
    name: "duplicateSelection",
    label: "labels.duplicateSelection",
    icon: $e68ba20b3d2d159d$var$Nc,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        if (t.editingLinearElement) {
            let n = $e68ba20b3d2d159d$var$$.duplicateSelectedPoints(t, o.scene.getNonDeletedElementsMap());
            return n ? {
                elements: e,
                appState: n.appState,
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            } : !1;
        }
        return {
            ...$e68ba20b3d2d159d$var$iP(e, t),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.D,
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$Nc,
            title: `${$e68ba20b3d2d159d$var$x("labels.duplicateSelection")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+D")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.duplicateSelection"),
            onClick: ()=>r(null),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$iP = (e, t)=>{
    let r = $e68ba20b3d2d159d$var$eS(e), o = new Map, n = [], i = [], a = new Map, s = new Map, l = (y)=>{
        let w = $e68ba20b3d2d159d$var$cd(t.editingGroupId, o, y, {
            x: y.x + $e68ba20b3d2d159d$var$Fa / 2,
            y: y.y + $e68ba20b3d2d159d$var$Fa / 2
        });
        return s.set(w.id, w), a.set(y.id, w.id), i.push(y), n.push(w), w;
    }, c = $e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$pe(r, t, {
        includeBoundTextElement: !0,
        includeElementsInFrames: !0
    })), d = new Map, m = (y)=>{
        for (let w of y)d.set(w.id, !0);
        return y;
    }, p = [], u = -1;
    for(; ++u < r.length;){
        let y = r[u];
        if (d.get(y.id)) continue;
        let w = $e68ba20b3d2d159d$var$te(y, $e68ba20b3d2d159d$var$j(e)), I = $e68ba20b3d2d159d$var$re(y);
        if (c.get(y.id)) {
            if (y.groupIds.length || w || I) {
                let M = $e68ba20b3d2d159d$var$pf(t, y);
                if (M) {
                    let C = $e68ba20b3d2d159d$var$nt(r, M).flatMap((P)=>$e68ba20b3d2d159d$var$re(P) ? [
                            ...$e68ba20b3d2d159d$var$bo(e, P.id),
                            P
                        ] : [
                            P
                        ]);
                    p.push(...m([
                        ...C,
                        ...C.map((P)=>l(P))
                    ]));
                    continue;
                }
                if (w) {
                    p.push(...m([
                        y,
                        w,
                        l(y),
                        l(w)
                    ]));
                    continue;
                }
                if (I) {
                    let C = $e68ba20b3d2d159d$var$bo(r, y.id);
                    p.push(...m([
                        ...C,
                        y,
                        ...C.map((P)=>l(P)),
                        l(y)
                    ]));
                    continue;
                }
            }
            (!y.frameId || !c.has(y.frameId)) && p.push(...m([
                y,
                l(y)
            ]));
        } else p.push(...m([
            y
        ]));
    }
    let h = [], g = new Map;
    for(u = p.length; --u >= 0;){
        let y = p[u];
        g.get(y.id) || (g.set(y.id, !0), h.push(y));
    }
    let b = $e68ba20b3d2d159d$var$tr(h.reverse(), $e68ba20b3d2d159d$var$j(n));
    $e68ba20b3d2d159d$var$Xu(p, i, a), $e68ba20b3d2d159d$var$qp(p, i, a), $e68ba20b3d2d159d$var$_u(b, i, a);
    let v = $e68ba20b3d2d159d$var$Ts(n);
    return {
        elements: b,
        appState: {
            ...t,
            ...$e68ba20b3d2d159d$var$mr({
                editingGroupId: t.editingGroupId,
                selectedElementIds: v.reduce((y, w)=>($e68ba20b3d2d159d$var$Ge(w) || (y[w.id] = !0), y), {})
            }, $e68ba20b3d2d159d$export$a9f9e75229944f66(b), t, null)
        }
    };
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$sP = new Set([
    "command_palette"
]), $e68ba20b3d2d159d$var$Pe = (e, t, r, o)=>{
    try {
        if (typeof window > "u" || $e68ba20b3d2d159d$var$T.VITE_WORKER_ID || $e68ba20b3d2d159d$var$T.VITE_APP_ENABLE_TRACKING !== "true" || !$e68ba20b3d2d159d$var$sP.has(e) || $e68ba20b3d2d159d$var$T.DEV) return;
        $e68ba20b3d2d159d$var$T.PROD || console.info("trackEvent", {
            category: e,
            action: t,
            label: r,
            value: o
        }), window.sa_event && window.sa_event(t, {
            category: e,
            label: r,
            value: o
        });
    } catch (n) {
        console.error("error during analytics", n);
    }
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$ah = (0, $acw62.forwardRef)((e, t)=>{
    let { title: r, className: o, testId: n, active: i, standalone: a, icon: s, onClick: l } = e;
    return (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        ref: t,
        title: r,
        "data-testid": n,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(o, {
            standalone: a,
            active: i
        }),
        onClick: l,
        children: s
    }, r);
});
var $e68ba20b3d2d159d$var$Bo = (e)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "buttonList",
        children: e.options.map((t)=>e.type === "button" ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ah, {
                icon: t.icon,
                title: t.text,
                testId: t.testId,
                active: t.active ?? e.value === t.value,
                onClick: (r)=>e.onClick(t.value, r)
            }, t.text) : (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                    active: e.value === t.value
                }),
                title: t.text,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "radio",
                        name: e.group,
                        onChange: ()=>e.onChange(t.value),
                        checked: e.value === t.value,
                        "data-testid": t.testId
                    }),
                    t.icon
                ]
            }, t.text))
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$yr();
var $e68ba20b3d2d159d$var$tS = ({ onChange: e, type: t, activeColor: r, topPicks: o })=>{
    let n;
    return t === "elementStroke" && (n = $e68ba20b3d2d159d$var$Am), t === "elementBackground" && (n = $e68ba20b3d2d159d$var$Mm), t === "canvasBackground" && (n = $e68ba20b3d2d159d$var$km), o && (n = o), n ? (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "color-picker__top-picks",
        children: n.map((i)=>(0, $7b02d682eb115277$exports.jsx)("button", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("color-picker__button", {
                    active: i === r,
                    "is-transparent": i === "transparent" || !i
                }),
                style: {
                    "--swatch-color": i
                },
                type: "button",
                title: i,
                onClick: ()=>e(i),
                "data-testid": `color-top-pick-${i}`,
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "color-picker__button-outline"
                })
            }, i))
    }) : (console.error("Invalid type for TopPicks"), null);
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$sh = ()=>(0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            width: 1,
            height: "1rem",
            backgroundColor: "var(--default-border-color)",
            margin: "0 auto"
        }
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$yr();
var $e68ba20b3d2d159d$var$ca = ({ palette: e, color: t })=>{
    for (let [r, o] of Object.entries(e))if (Array.isArray(o)) {
        let n = o.indexOf(t);
        if (n > -1) return {
            colorName: r,
            shade: n
        };
    } else if (o === t) return {
        colorName: r,
        shade: null
    };
    return null;
}, $e68ba20b3d2d159d$var$Wd = [
    [
        "q",
        "w",
        "e",
        "r",
        "t"
    ],
    [
        "a",
        "s",
        "d",
        "f",
        "g"
    ],
    [
        "z",
        "x",
        "c",
        "v",
        "b"
    ]
].flat(), $e68ba20b3d2d159d$var$Ax = ({ color: e, palette: t })=>!Object.values(t).flat().includes(e), $e68ba20b3d2d159d$var$oS = (e, t, r)=>{
    let o = {
        elementBackground: "backgroundColor",
        elementStroke: "strokeColor"
    }, n = e.filter((a)=>{
        if (a.isDeleted) return !1;
        let s = a[o[t]];
        return $e68ba20b3d2d159d$var$Ax({
            color: s,
            palette: r
        });
    }), i = new Map;
    return n.forEach((a)=>{
        let s = a[o[t]];
        i.has(s) ? i.set(s, i.get(s) + 1) : i.set(s, 1);
    }), [
        ...i.entries()
    ].sort((a, s)=>s[1] - a[1]).map((a)=>a[0]).slice(0, $e68ba20b3d2d159d$var$i0);
}, $e68ba20b3d2d159d$var$zo = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$var$rS = (e, t, r)=>(e * 299 + t * 587 + r * 114) / 1e3 >= 160 ? "black" : "white", $e68ba20b3d2d159d$var$nS = (e, t)=>{
    if (t) {
        let i = new Option().style;
        if (i.color = e, i.color) {
            let a = i.color.replace(/^(rgb|rgba)\(/, "").replace(/\)$/, "").replace(/\s/g, "").split(","), s = parseInt(a[0]), l = parseInt(a[1]), c = parseInt(a[2]);
            return $e68ba20b3d2d159d$var$rS(s, l, c);
        }
    }
    if (e === "transparent") return "black";
    let r = parseInt(e.substring(1, 3), 16), o = parseInt(e.substring(3, 5), 16), n = parseInt(e.substring(5, 7), 16);
    return $e68ba20b3d2d159d$var$rS(r, o, n);
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$fP = ({ color: e, keyLabel: t, isCustomColor: r = !1, isShade: o = !1 })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "color-picker__button__hotkey-label",
        style: {
            color: $e68ba20b3d2d159d$var$nS(e, r)
        },
        children: [
            o && "\u21E7",
            t
        ]
    }), $e68ba20b3d2d159d$var$Wl = $e68ba20b3d2d159d$var$fP;
var $e68ba20b3d2d159d$var$aS = ({ hex: e, onChange: t, palette: r })=>{
    let o = $e68ba20b3d2d159d$var$ca({
        color: e || "transparent",
        palette: r
    }), [n, i] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo), a = (0, $acw62.useRef)(null);
    if ((0, $acw62.useEffect)(()=>{
        a.current && n === "shades" && a.current.focus();
    }, [
        o,
        n
    ]), o) {
        let { colorName: s, shade: l } = o, c = r[s];
        if (Array.isArray(c)) return (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "color-picker-content--default shades",
            children: c.map((d, m)=>(0, $7b02d682eb115277$exports.jsxs)("button", {
                    ref: m === l && n === "shades" ? a : void 0,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("color-picker__button color-picker__button--large", {
                        active: m === l
                    }),
                    "aria-label": "Shade",
                    title: `${s} - ${m + 1}`,
                    style: d ? {
                        "--swatch-color": d
                    } : void 0,
                    onClick: ()=>{
                        t(d), i("shades");
                    },
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "color-picker__button-outline"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Wl, {
                            color: d,
                            keyLabel: m + 1,
                            isShade: !0
                        })
                    ]
                }, m))
        });
    }
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "color-picker-content--default",
        style: {
            position: "relative"
        },
        tabIndex: -1,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                tabIndex: -1,
                className: "color-picker__button color-picker__button--large color-picker__button--no-focus-visible"
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                tabIndex: -1,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontSize: "0.75rem"
                },
                children: $e68ba20b3d2d159d$var$x("colorPicker.noShades")
            })
        ]
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$CP = ({ palette: e, color: t, onChange: r, label: o, activeShade: n })=>{
    let i = $e68ba20b3d2d159d$var$ca({
        color: t || "transparent",
        palette: e
    }), [a, s] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo), l = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        l.current && a === "baseColors" && l.current.focus();
    }, [
        i?.colorName,
        a
    ]), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "color-picker-content--default",
        children: Object.entries(e).map(([c, d], m)=>{
            let p = (Array.isArray(d) ? d[n] : d) || "transparent", u = $e68ba20b3d2d159d$var$Wd[m], h = $e68ba20b3d2d159d$var$x(`colors.${c.replace(/\d+/, "")}`, null, "");
            return (0, $7b02d682eb115277$exports.jsxs)("button", {
                ref: i?.colorName === c ? l : void 0,
                tabIndex: -1,
                type: "button",
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("color-picker__button color-picker__button--large", {
                    active: i?.colorName === c,
                    "is-transparent": p === "transparent" || !p
                }),
                onClick: ()=>{
                    r(p), s("baseColors");
                },
                title: `${h}${p.startsWith("#") ? ` ${p}` : ""} \u2014 ${u}`,
                "aria-label": `${h} \u2014 ${u}`,
                style: p ? {
                    "--swatch-color": p
                } : void 0,
                "data-testid": `color-${c}`,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "color-picker__button-outline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Wl, {
                        color: p,
                        keyLabel: u
                    })
                ]
            }, c);
        })
    });
}, $e68ba20b3d2d159d$var$sS = $e68ba20b3d2d159d$var$CP;
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$lS = ({ colors: e, color: t, onChange: r, label: o })=>{
    let [n, i] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo), a = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        a.current && a.current.focus();
    }, [
        t,
        n
    ]), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "color-picker-content--default",
        children: e.map((s, l)=>(0, $7b02d682eb115277$exports.jsxs)("button", {
                ref: t === s ? a : void 0,
                tabIndex: -1,
                type: "button",
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("color-picker__button color-picker__button--large", {
                    active: t === s,
                    "is-transparent": s === "transparent" || !s
                }),
                onClick: ()=>{
                    r(s), i("custom");
                },
                title: s,
                "aria-label": o,
                style: {
                    "--swatch-color": s
                },
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "color-picker__button-outline"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Wl, {
                        color: s,
                        keyLabel: l + 1,
                        isCustomColor: !0
                    })
                ]
            }, l))
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$yr();
var $e68ba20b3d2d159d$var$Px = (e, t, r)=>{
    let o = Math.ceil(r / $e68ba20b3d2d159d$var$_a);
    switch(t = t ?? -1, e){
        case "ArrowLeft":
            {
                let n = t - 1;
                return n < 0 ? r - 1 : n;
            }
        case "ArrowRight":
            return (t + 1) % r;
        case "ArrowDown":
            {
                let n = t + $e68ba20b3d2d159d$var$_a;
                return n >= r ? t % $e68ba20b3d2d159d$var$_a : n;
            }
        case "ArrowUp":
            {
                let n = t - $e68ba20b3d2d159d$var$_a, i = n < 0 ? $e68ba20b3d2d159d$var$_a * o + n : n;
                return i >= r ? void 0 : i;
            }
    }
}, $e68ba20b3d2d159d$var$_P = ({ e: e, colorObj: t, onChange: r, palette: o, customColors: n, setActiveColorPickerSection: i, activeShade: a })=>{
    if (t?.shade != null && [
        "Digit1",
        "Digit2",
        "Digit3",
        "Digit4",
        "Digit5"
    ].includes(e.code) && e.shiftKey) {
        let s = Number(e.code.slice(-1)) - 1;
        return r(o[t.colorName][s]), i("shades"), !0;
    }
    if ([
        "1",
        "2",
        "3",
        "4",
        "5"
    ].includes(e.key) && n[Number(e.key) - 1]) return r(n[Number(e.key) - 1]), i("custom"), !0;
    if ($e68ba20b3d2d159d$var$Wd.includes(e.key)) {
        let s = $e68ba20b3d2d159d$var$Wd.indexOf(e.key), l = Object.keys(o)[s], c = o[l], d = Array.isArray(c) ? c[a] : c;
        return r(d), i("baseColors"), !0;
    }
    return !1;
}, $e68ba20b3d2d159d$var$cS = ({ event: e, activeColorPickerSection: t, palette: r, color: o, onChange: n, customColors: i, setActiveColorPickerSection: a, updateData: s, activeShade: l, onEyeDropperToggle: c, onEscape: d })=>{
    if (e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) return !1;
    if (e.key === $e68ba20b3d2d159d$var$S.ESCAPE) return d(e), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.ALT) return c(!0), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.I) return c(), !0;
    let m = $e68ba20b3d2d159d$var$ca({
        color: o,
        palette: r
    });
    if (e.key === $e68ba20b3d2d159d$var$S.TAB) {
        let p = {
            custom: !!i.length,
            baseColors: !0,
            shades: m?.shade != null,
            hex: !0
        }, u = Object.entries(p).reduce((y, [w, I])=>(I && y.push(w), y), []), h = u.indexOf(t), g = e.shiftKey ? -1 : 1, b = h + g > u.length - 1 ? 0 : h + g < 0 ? u.length - 1 : h + g, v = u[b];
        return v && a(v), v === "custom" ? n(i[0]) : v === "baseColors" && (Object.entries(r).find(([w, I])=>Array.isArray(I) ? I.includes(o) : I === o ? w : null) || n($e68ba20b3d2d159d$var$fe.black)), e.preventDefault(), e.stopPropagation(), !0;
    }
    if ($e68ba20b3d2d159d$var$_P({
        e: e,
        colorObj: m,
        onChange: n,
        palette: r,
        customColors: i,
        setActiveColorPickerSection: a,
        activeShade: l
    })) return !0;
    if (t === "shades" && m) {
        let { shade: p } = m, u = $e68ba20b3d2d159d$var$Px(e.key, p, $e68ba20b3d2d159d$var$_a);
        if (u !== void 0) return n(r[m.colorName][u]), !0;
    }
    if (t === "baseColors" && m) {
        let { colorName: p } = m, u = Object.keys(r), h = u.indexOf(p), g = $e68ba20b3d2d159d$var$Px(e.key, h, u.length);
        if (g !== void 0) {
            let b = u[g], v = r[b];
            return n(Array.isArray(v) ? v[l] : v), !0;
        }
    }
    if (t === "custom") {
        let p = i.indexOf(o), u = $e68ba20b3d2d159d$var$Px(e.key, p, i.length);
        if (u !== void 0) {
            let h = i[u];
            return n(h), !0;
        }
    }
    return !1;
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$RP = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "color-picker__heading",
        children: e
    }), $e68ba20b3d2d159d$var$Vl = $e68ba20b3d2d159d$var$RP;
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$pS = ({ color: e, onChange: t, label: r, type: o, elements: n, palette: i, updateData: a, children: s, onEyeDropperToggle: l, onEscape: c })=>{
    let [d] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>o === "canvasBackground" ? [] : $e68ba20b3d2d159d$var$oS(n, o, i)), [m, p] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo), u = $e68ba20b3d2d159d$var$ca({
        color: e,
        palette: i
    });
    (0, $acw62.useEffect)(()=>{
        if (!m) {
            let v = $e68ba20b3d2d159d$var$Ax({
                color: e,
                palette: i
            }), y = v && !d.includes(e);
            p(y ? "hex" : v ? "custom" : u?.shade != null ? "shades" : "baseColors");
        }
    }, [
        m,
        e,
        i,
        p,
        u,
        d
    ]);
    let [h, g] = (0, $acw62.useState)(u?.shade ?? (o === "elementBackground" ? $e68ba20b3d2d159d$var$Gs : $e68ba20b3d2d159d$var$Us));
    (0, $acw62.useEffect)(()=>{
        u?.shade != null && g(u.shade);
        let v = (y)=>{
            y.key === $e68ba20b3d2d159d$var$S.ALT && l(!1);
        };
        return document.addEventListener("keyup", v, {
            capture: !0
        }), ()=>{
            document.removeEventListener("keyup", v, {
                capture: !0
            });
        };
    }, [
        u,
        l
    ]);
    let b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": $e68ba20b3d2d159d$var$x("labels.colorPicker"),
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            ref: b,
            onKeyDown: (v)=>{
                $e68ba20b3d2d159d$var$cS({
                    event: v,
                    activeColorPickerSection: m,
                    palette: i,
                    color: e,
                    onChange: t,
                    onEyeDropperToggle: l,
                    customColors: d,
                    setActiveColorPickerSection: p,
                    updateData: a,
                    activeShade: h,
                    onEscape: c
                }) && (v.preventDefault(), v.stopPropagation());
            },
            className: "color-picker-content properties-content",
            tabIndex: -1,
            children: [
                !!d.length && (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vl, {
                            children: $e68ba20b3d2d159d$var$x("colorPicker.mostUsedCustomColors")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$lS, {
                            colors: d,
                            color: e,
                            label: $e68ba20b3d2d159d$var$x("colorPicker.mostUsedCustomColors"),
                            onChange: t
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vl, {
                            children: $e68ba20b3d2d159d$var$x("colorPicker.colors")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$sS, {
                            color: e,
                            label: r,
                            palette: i,
                            onChange: t,
                            activeShade: h
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vl, {
                            children: $e68ba20b3d2d159d$var$x("colorPicker.shades")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$aS, {
                            hex: e,
                            onChange: t,
                            palette: i
                        })
                    ]
                }),
                s
            ]
        })
    });
};
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Lx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null), $e68ba20b3d2d159d$var$Ke = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($e68ba20b3d2d159d$var$Lx);
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$ch = (e)=>{
    let [t, r] = (0, $acw62.useState)(null), o = $e68ba20b3d2d159d$export$aa949327762d0f40(), { theme: n } = $e68ba20b3d2d159d$var$Ke(), { container: i } = $e68ba20b3d2d159d$var$Ft();
    return (0, $acw62.useLayoutEffect)(()=>{
        t && (t.className = "", t.classList.add("excalidraw", ...e?.className?.split(/\s+/) || []), t.classList.toggle("excalidraw--mobile", o.editor.isMobile), t.classList.toggle("theme--dark", n === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK));
    }, [
        t,
        n,
        o.editor.isMobile,
        e?.className
    ]), (0, $acw62.useLayoutEffect)(()=>{
        let a = e?.parentSelector ? i?.querySelector(e.parentSelector) : document.body;
        if (!a) return;
        let s = document.createElement("div");
        return a.appendChild(s), r(s), ()=>{
            a.removeChild(s);
        };
    }, [
        i,
        e?.parentSelector
    ]), t;
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
function $e68ba20b3d2d159d$var$Yl(e, t, r) {
    (0, $acw62.useEffect)(()=>{
        function o(n) {
            let i = n;
            if (!e.current) return;
            let a = r?.(i, e.current);
            if (a === !0) return;
            if (a === !1) return t(i);
            e.current.contains(i.target) || !document.documentElement.contains(i.target) || i.target.closest("[data-radix-portal]") || i.target === document.documentElement && document.body.style.pointerEvents === "none" || i.target.closest("[data-prevent-outside-click]") || t(i);
        }
        return document.addEventListener("pointerdown", o), document.addEventListener("touchstart", o), ()=>{
            document.removeEventListener("pointerdown", o), document.removeEventListener("touchstart", o);
        };
    }, [
        e,
        t,
        r
    ]);
}
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Xl = (e)=>{
    let t = (0, $acw62.useRef)(e);
    return Object.assign(t.current, e), t.current;
};
var $e68ba20b3d2d159d$var$da = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$var$gS = ({ onCancel: e, onChange: t, onSelect: r, colorPickerType: o })=>{
    let n = $e68ba20b3d2d159d$var$ch({
        className: "excalidraw-eye-dropper-backdrop",
        parentSelector: ".excalidraw-eye-dropper-container"
    }), i = $e68ba20b3d2d159d$var$Ke(), a = $e68ba20b3d2d159d$var$ma(), s = $e68ba20b3d2d159d$var$Bt(), l = $e68ba20b3d2d159d$var$pe(a, i), c = $e68ba20b3d2d159d$var$Xl({
        app: s,
        onCancel: e,
        onChange: t,
        onSelect: r,
        selectedElements: l
    }), { container: d } = $e68ba20b3d2d159d$var$Ft();
    (0, $acw62.useEffect)(()=>{
        let p = m.current;
        if (!p || !s.canvas || !n) return;
        let u = !1, h = s.canvas.getContext("2d"), g = ({ clientX: C, clientY: P })=>{
            let k = h.getImageData((C - i.offsetLeft) * window.devicePixelRatio, (P - i.offsetTop) * window.devicePixelRatio, 1, 1).data;
            return $e68ba20b3d2d159d$var$m0(k[0], k[1], k[2]);
        }, b = ({ clientX: C, clientY: P, altKey: k })=>{
            p.style.top = `${P + 20}px`, p.style.left = `${C + 20}px`;
            let _ = g({
                clientX: C,
                clientY: P
            });
            u && c.onChange(o, _, c.selectedElements, {
                altKey: k
            }), p.style.background = _;
        }, v = ()=>{
            c.onCancel();
        }, y = (C, P)=>{
            c.onSelect(C, P);
        }, w = (C)=>{
            u = !0, C.stopImmediatePropagation();
        }, I = (C)=>{
            u = !1, d?.focus(), C.stopImmediatePropagation(), C.preventDefault(), y(g(C), C);
        }, M = (C)=>{
            C.key === $e68ba20b3d2d159d$var$S.ESCAPE && (C.preventDefault(), C.stopImmediatePropagation(), v());
        };
        return n.tabIndex = -1, n.focus(), b({
            clientX: c.app.lastViewportPosition.x,
            clientY: c.app.lastViewportPosition.y,
            altKey: !1
        }), n.addEventListener("keydown", M), n.addEventListener("pointerdown", w), n.addEventListener("pointerup", I), window.addEventListener("pointermove", b, {
            passive: !0
        }), window.addEventListener("blur", v), ()=>{
            u = !1, n.removeEventListener("keydown", M), n.removeEventListener("pointerdown", w), n.removeEventListener("pointerup", I), window.removeEventListener("pointermove", b), window.removeEventListener("blur", v);
        };
    }, [
        c,
        s.canvas,
        n,
        o,
        d,
        i.offsetLeft,
        i.offsetTop
    ]);
    let m = (0, $acw62.useRef)(null);
    return $e68ba20b3d2d159d$var$Yl(m, ()=>{
        e();
    }, (p)=>!!p.target.closest(".excalidraw-eye-dropper-trigger, .excalidraw-eye-dropper-backdrop")), n ? (0, $11492dca620dcaa5$exports.createPortal)((0, $7b02d682eb115277$exports.jsx)("div", {
        ref: m,
        className: "excalidraw-eye-dropper-preview"
    }), n) : null;
};
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$bS = ({ color: e, onChange: t, label: r, colorPickerType: o })=>{
    let n = $e68ba20b3d2d159d$export$aa949327762d0f40(), [i, a] = (0, $acw62.useState)(e), [s, l] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo);
    (0, $acw62.useEffect)(()=>{
        a(e);
    }, [
        e
    ]);
    let c = (0, $acw62.useCallback)((h)=>{
        let g = h.toLowerCase(), b = $e68ba20b3d2d159d$var$yS(g);
        b && t(b), a(g);
    }, [
        t
    ]), d = (0, $acw62.useRef)(null), m = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        d.current && d.current.focus();
    }, [
        s
    ]);
    let [p, u] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$da, $e68ba20b3d2d159d$var$$e);
    return (0, $acw62.useEffect)(()=>()=>{
            u(null);
        }, [
        u
    ]), (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "color-picker__input-label",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "color-picker__input-hash",
                children: "#"
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: s === "hex" ? d : void 0,
                style: {
                    border: 0,
                    padding: 0
                },
                spellCheck: !1,
                className: "color-picker-input",
                "aria-label": r,
                onChange: (h)=>{
                    c(h.target.value);
                },
                value: (i || "").replace(/^#/, ""),
                onBlur: ()=>{
                    a(e);
                },
                tabIndex: -1,
                onFocus: ()=>l("hex"),
                onKeyDown: (h)=>{
                    h.key !== $e68ba20b3d2d159d$var$S.TAB && (h.key === $e68ba20b3d2d159d$var$S.ESCAPE && m.current?.focus(), h.stopPropagation());
                }
            }),
            !n.editor.isMobile && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            width: "1px",
                            height: "1.25rem",
                            backgroundColor: "var(--default-border-color)"
                        }
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        ref: m,
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("excalidraw-eye-dropper-trigger", {
                            selected: p
                        }),
                        onClick: ()=>u((h)=>h ? null : {
                                    keepOpenOnAlt: !1,
                                    onSelect: (g)=>t(g),
                                    colorPickerType: o
                                }),
                        title: `${$e68ba20b3d2d159d$var$x("labels.eyeDropper")} \u2014 ${$e68ba20b3d2d159d$var$S.I.toLocaleUpperCase()} or ${$e68ba20b3d2d159d$var$O("Alt")} `,
                        children: $e68ba20b3d2d159d$var$Ow
                    })
                ]
            })
        ]
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Kt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ children: e, padding: t, className: r, style: o }, n)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Island", r),
        style: {
            "--padding": t,
            ...o
        },
        ref: n,
        children: e
    }));
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$mh = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: e, container: t, children: r, style: o, onClose: n, onKeyDown: i, onFocusOutside: a, onPointerLeave: s, onPointerDownOutside: l }, c)=>{
    let d = $e68ba20b3d2d159d$export$aa949327762d0f40();
    return (0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$602eac185826482c, {
        container: t,
        children: (0, $7b02d682eb115277$exports.jsxs)($8a88ecc38cbd867b$export$7c6e2c02157bb7d2, {
            ref: c,
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("focus-visible-none", e),
            "data-prevent-outside-click": !0,
            side: d.editor.isMobile && !d.viewport.isLandscape ? "bottom" : "right",
            align: d.editor.isMobile && !d.viewport.isLandscape ? "center" : "start",
            alignOffset: -16,
            sideOffset: 20,
            style: {
                zIndex: "var(--zIndex-popup)"
            },
            onPointerLeave: s,
            onKeyDown: i,
            onFocusOutside: a,
            onPointerDownOutside: l,
            onCloseAutoFocus: (m)=>{
                m.stopPropagation(), m.preventDefault(), t && !$e68ba20b3d2d159d$var$G0(document.activeElement) && t.focus(), n();
            },
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kt, {
                    padding: 3,
                    style: o,
                    children: r
                }),
                (0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$21b07c8f274aebd5, {
                    width: 20,
                    height: 10,
                    style: {
                        fill: "var(--popup-bg-color)",
                        filter: "drop-shadow(rgba(0, 0, 0, 0.05) 0px 3px 2px)"
                    }
                })
            ]
        })
    });
});
var $e68ba20b3d2d159d$var$vS = (e)=>{
    let t = new Option().style;
    return t.color = e, !!t.color;
}, $e68ba20b3d2d159d$var$yS = (e)=>$e68ba20b3d2d159d$var$Rr(e) ? e : $e68ba20b3d2d159d$var$vS(`#${e}`) ? `#${e}` : $e68ba20b3d2d159d$var$vS(e) ? e : null, $e68ba20b3d2d159d$var$nL = ({ type: e, color: t, onChange: r, label: o, elements: n, palette: i = $e68ba20b3d2d159d$var$fe, updateData: a })=>{
    let { container: s } = $e68ba20b3d2d159d$var$Ft(), [, l] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$zo), [c, d] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$da, $e68ba20b3d2d159d$var$$e), m = (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vl, {
                children: $e68ba20b3d2d159d$var$x("colorPicker.hexCode")
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$bS, {
                color: t,
                label: o,
                onChange: (h)=>{
                    r(h);
                },
                colorPickerType: e
            })
        ]
    }), p = (0, $acw62.useRef)(null), u = ()=>{
        p.current?.querySelector(".color-picker-content")?.focus();
    };
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$mh, {
        container: s,
        style: {
            maxWidth: "208px"
        },
        onFocusOutside: (h)=>{
            u(), h.preventDefault();
        },
        onPointerDownOutside: (h)=>{
            c && h.preventDefault();
        },
        onClose: ()=>{
            a({
                openPopup: null
            }), l(null);
        },
        children: i ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pS, {
            palette: i,
            color: t,
            onChange: (h)=>{
                r(h);
            },
            onEyeDropperToggle: (h)=>{
                d((g)=>h ? (g = g || {
                        keepOpenOnAlt: !0,
                        onSelect: r,
                        colorPickerType: e
                    }, g.keepOpenOnAlt = !0, g) : h === !1 || g ? null : {
                        keepOpenOnAlt: !1,
                        onSelect: r,
                        colorPickerType: e
                    });
            },
            onEscape: (h)=>{
                c ? d(null) : a({
                    openPopup: null
                });
            },
            label: o,
            type: e,
            elements: n,
            updateData: a,
            children: m
        }) : m
    });
}, $e68ba20b3d2d159d$var$iL = ({ label: e, color: t, type: r })=>(0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$41fb9f06171c75f4, {
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("color-picker__button active-color properties-trigger", {
            "is-transparent": t === "transparent" || !t
        }),
        "aria-label": e,
        style: t ? {
            "--swatch-color": t
        } : void 0,
        title: r === "elementStroke" ? $e68ba20b3d2d159d$var$x("labels.showStroke") : $e68ba20b3d2d159d$var$x("labels.showBackground"),
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "color-picker__button-outline"
        })
    }), $e68ba20b3d2d159d$var$Yd = ({ type: e, color: t, onChange: r, label: o, elements: n, palette: i = $e68ba20b3d2d159d$var$fe, topPicks: a, updateData: s, appState: l })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            role: "dialog",
            "aria-modal": "true",
            className: "color-picker-container",
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tS, {
                    activeColor: t,
                    onChange: r,
                    type: e,
                    topPicks: a
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$sh, {}),
                (0, $7b02d682eb115277$exports.jsxs)($8a88ecc38cbd867b$export$be92b6f5f03c0fe9, {
                    open: l.openPopup === e,
                    onOpenChange: (c)=>{
                        s({
                            openPopup: c ? e : null
                        });
                    },
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$iL, {
                            color: t,
                            label: o,
                            type: e
                        }),
                        l.openPopup === e && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nL, {
                            type: e,
                            color: t,
                            onChange: r,
                            label: o,
                            elements: n,
                            palette: i,
                            updateData: s
                        })
                    ]
                })
            ]
        })
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$uh = ({ children: e, left: t, top: r, onCloseRequest: o, fitInViewport: n = !1, offsetLeft: i = 0, offsetTop: a = 0, viewportWidth: s = window.innerWidth, viewportHeight: l = window.innerHeight })=>{
    let c = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        let m = c.current;
        if (!m) return;
        m.contains(document.activeElement) || m.focus();
        let p = (u)=>{
            if (u.key === $e68ba20b3d2d159d$var$S.TAB) {
                let h = $e68ba20b3d2d159d$var$Pc(m), { activeElement: g } = document, b = h.findIndex((v)=>v === g);
                g === m ? (u.shiftKey ? h[h.length - 1]?.focus() : h[0].focus(), u.preventDefault(), u.stopImmediatePropagation()) : b === 0 && u.shiftKey ? (h[h.length - 1]?.focus(), u.preventDefault(), u.stopImmediatePropagation()) : b === h.length - 1 && !u.shiftKey && (h[0]?.focus(), u.preventDefault(), u.stopImmediatePropagation());
            }
        };
        return m.addEventListener("keydown", p), ()=>m.removeEventListener("keydown", p);
    }, []);
    let d = (0, $acw62.useRef)(null);
    return (0, $acw62.useLayoutEffect)(()=>{
        if (n && c.current && r != null && t != null) {
            let m = c.current, { width: p, height: u } = m.getBoundingClientRect();
            if (d.current?.top === r && d.current?.left === t) return;
            d.current = {
                top: r,
                left: t
            }, p >= s ? (m.style.width = `${s}px`, m.style.left = "0px", m.style.overflowX = "scroll") : t + p - i > s ? m.style.left = `${s - p - 10}px` : m.style.left = `${t}px`, u >= l ? (m.style.height = `${l - 20}px`, m.style.top = "10px", m.style.overflowY = "scroll") : r + u - a > l ? m.style.top = `${l - u}px` : m.style.top = `${r}px`;
        }
    }, [
        r,
        t,
        n,
        s,
        l,
        i,
        a
    ]), (0, $acw62.useEffect)(()=>{
        if (o) {
            let m = (p)=>{
                c.current?.contains(p.target) || (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(()=>o(p));
            };
            return document.addEventListener("pointerdown", m, !1), ()=>document.removeEventListener("pointerdown", m, !1);
        }
    }, [
        o
    ]), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "popover",
        ref: c,
        tabIndex: -1,
        children: e
    });
};
$e68ba20b3d2d159d$var$be();
function $e68ba20b3d2d159d$var$dL({ options: e, value: t, label: r, onChange: o, onClose: n }) {
    let i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(), a = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(), s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        a.current ? a.current.focus() : s.current && s.current.focus();
    }, []), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "picker",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": r,
        onKeyDown: (c)=>{
            let d = e.find((m)=>m.keyBinding === c.key.toLowerCase());
            if (!(c.metaKey || c.altKey || c.ctrlKey) && d) {
                let m = e.indexOf(d);
                s.current.children[m].focus(), c.preventDefault();
            } else if (c.key === $e68ba20b3d2d159d$var$S.TAB) setTimeout(()=>{
                let m = a.current, p = document.activeElement;
                m !== p && n();
            }, 0);
            else if ($e68ba20b3d2d159d$var$rs(c.key)) {
                let { activeElement: m } = document, p = $e68ba20b3d2d159d$var$Sn().rtl, u = Array.prototype.indexOf.call(s.current.children, m);
                if (u !== -1) {
                    let h = e.length, g = u;
                    switch(c.key){
                        case p ? $e68ba20b3d2d159d$var$S.ARROW_LEFT : $e68ba20b3d2d159d$var$S.ARROW_RIGHT:
                        case $e68ba20b3d2d159d$var$S.ARROW_DOWN:
                            g = (u + 1) % h;
                            break;
                        case p ? $e68ba20b3d2d159d$var$S.ARROW_RIGHT : $e68ba20b3d2d159d$var$S.ARROW_LEFT:
                        case $e68ba20b3d2d159d$var$S.ARROW_UP:
                            g = (h + u - 1) % h;
                            break;
                    }
                    s.current.children[g].focus();
                }
                c.preventDefault();
            } else (c.key === $e68ba20b3d2d159d$var$S.ESCAPE || c.key === $e68ba20b3d2d159d$var$S.ENTER) && (c.preventDefault(), n());
            c.nativeEvent.stopImmediatePropagation(), c.stopPropagation();
        },
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "picker-content",
            ref: s,
            children: e.map((c, d)=>(0, $7b02d682eb115277$exports.jsxs)("button", {
                    type: "button",
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("picker-option", {
                        active: t === c.value
                    }),
                    onClick: (m)=>{
                        m.currentTarget.focus(), o(c.value);
                    },
                    title: `${c.text} ${c.keyBinding && `\u2014 ${c.keyBinding.toUpperCase()}`}`,
                    "aria-label": c.text || "none",
                    "aria-keyshortcuts": c.keyBinding || void 0,
                    ref: (m)=>{
                        m && d === 0 && (i.current = m), m && c.value === t && (a.current = m);
                    },
                    onFocus: ()=>{
                        o(c.value);
                    },
                    children: [
                        c.icon,
                        c.keyBinding && (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "picker-keybinding",
                            children: c.keyBinding
                        })
                    ]
                }, c.text))
        })
    });
}
function $e68ba20b3d2d159d$var$Ox({ value: e, label: t, options: r, onChange: o, group: n = "" }) {
    let [i, a] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(!1), s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null), l = $e68ba20b3d2d159d$var$Sn().rtl;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("button", {
                name: n,
                type: "button",
                className: i ? "active" : "",
                "aria-label": t,
                onClick: ()=>a(!i),
                ref: s,
                children: r.find((c)=>c.value === e)?.icon
            }),
            (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
                fallback: "",
                children: i ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$uh, {
                            onCloseRequest: (c)=>c.target !== s.current && a(!1),
                            ...l ? {
                                right: 5.5
                            } : {
                                left: -5.5
                            },
                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$dL, {
                                options: r.filter((c)=>c.showInPicker !== !1),
                                value: e,
                                label: t,
                                onChange: o,
                                onClose: ()=>{
                                    a(!1), s.current?.focus();
                                }
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "picker-triangle"
                        })
                    ]
                }) : null
            })
        ]
    });
}
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$hh = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: e, placeholder: t, onChange: r }, o)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("QuickSearch__wrapper", e),
        children: [
            $e68ba20b3d2d159d$var$Cp,
            (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: o,
                className: "QuickSearch__input",
                type: "text",
                placeholder: t,
                onChange: (n)=>r(n.target.value.trim().toLowerCase())
            })
        ]
    }));
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$gh = ({ className: e, placeholder: t, children: r })=>{
    let o = !(0, $acw62.Children).count(r);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ScrollableList__wrapper", e),
        role: "menu",
        children: o ? (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "empty",
            children: t
        }) : r
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$CS = ({ children: e, className: t = "", style: r, title: o })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `dropdown-menu-group ${t}`,
        style: r,
        children: [
            o && (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "dropdown-menu-group-title",
                children: o
            }),
            e
        ]
    }), $e68ba20b3d2d159d$var$Xd = $e68ba20b3d2d159d$var$CS;
$e68ba20b3d2d159d$var$CS.displayName = "DropdownMenuGroup";
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$Fx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({}), $e68ba20b3d2d159d$var$fh = (e = "", t = !1, r = !1)=>`dropdown-menu-item dropdown-menu-item-base ${e}
  ${t ? "dropdown-menu-item--selected" : ""} ${r ? "dropdown-menu-item--hovered" : ""}`.trim(), $e68ba20b3d2d159d$var$Eh = (e, t)=>{
    let r = (0, $acw62.useContext)($e68ba20b3d2d159d$var$Fx);
    return $e68ba20b3d2d159d$var$Ui(e, (o)=>{
        let n = new CustomEvent("menu.itemSelect", {
            bubbles: !0,
            cancelable: !0
        });
        t?.(n), n.defaultPrevented || r.onSelect?.(n);
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$vL = ({ textStyle: e, icon: t, shortcut: r, children: o })=>{
    let n = $e68ba20b3d2d159d$export$aa949327762d0f40();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            t && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dropdown-menu-item__icon",
                children: t
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: e,
                className: "dropdown-menu-item__text",
                children: o
            }),
            r && !n.editor.isMobile && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dropdown-menu-item__shortcut",
                children: r
            })
        ]
    });
}, $e68ba20b3d2d159d$var$xh = $e68ba20b3d2d159d$var$vL;
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$Hx = ({ icon: e, value: t, order: r, children: o, shortcut: n, className: i, hovered: a, selected: s, textStyle: l, onSelect: c, onClick: d, ...m })=>{
    let p = $e68ba20b3d2d159d$var$Eh(d, c), u = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        a && (r === 0 ? u.current?.scrollIntoView({
            block: "end"
        }) : u.current?.scrollIntoView({
            block: "nearest"
        }));
    }, [
        a,
        r
    ]), (0, $7b02d682eb115277$exports.jsx)("button", {
        ...m,
        ref: u,
        value: t,
        onClick: p,
        className: $e68ba20b3d2d159d$var$fh(i, s, a),
        title: m.title ?? m["aria-label"],
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$xh, {
            textStyle: l,
            icon: e,
            shortcut: n,
            children: o
        })
    });
};
$e68ba20b3d2d159d$var$Hx.displayName = "DropdownMenuItem";
var $e68ba20b3d2d159d$var$$l = {
    GREEN: "green",
    RED: "red",
    BLUE: "blue"
}, $e68ba20b3d2d159d$var$bh = ({ type: e = $e68ba20b3d2d159d$var$$l.BLUE, children: t })=>{
    let { theme: r } = $e68ba20b3d2d159d$var$Yn(), o = {
        display: "inline-flex",
        marginLeft: "auto",
        padding: "2px 4px",
        borderRadius: 6,
        fontSize: 9,
        fontFamily: "Cascadia, monospace",
        border: r === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? "1.5px solid white" : "none"
    };
    switch(e){
        case $e68ba20b3d2d159d$var$$l.GREEN:
            Object.assign(o, {
                backgroundColor: "var(--background-color-badge)",
                color: "var(--color-badge)"
            });
            break;
        case $e68ba20b3d2d159d$var$$l.RED:
            Object.assign(o, {
                backgroundColor: "pink",
                color: "darkred"
            });
            break;
        case $e68ba20b3d2d159d$var$$l.BLUE:
        default:
            Object.assign(o, {
                background: "var(--color-promo)",
                color: "var(--color-surface-lowest)"
            });
    }
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "DropDownMenuItemBadge",
        style: o,
        children: t
    });
};
$e68ba20b3d2d159d$var$bh.displayName = "DropdownMenuItemBadge";
$e68ba20b3d2d159d$var$Hx.Badge = $e68ba20b3d2d159d$var$bh;
var $e68ba20b3d2d159d$var$no = $e68ba20b3d2d159d$var$Hx;
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$AS = ({ event: e, inputRef: t, hoveredFont: r, filteredFonts: o, onClose: n, onSelect: i, onHover: a })=>{
    if (!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.key.toLowerCase() === $e68ba20b3d2d159d$var$S.F) return t.current?.focus(), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.ESCAPE) return n(), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.ENTER) return r?.value && i(r.value), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.ARROW_DOWN) return r?.next ? a(r.next.value) : o[0]?.value && a(o[0].value), !0;
    if (e.key === $e68ba20b3d2d159d$var$S.ARROW_UP) return r?.prev ? a(r.prev.value) : o[o.length - 1]?.value && a(o[o.length - 1].value), !0;
};
$e68ba20b3d2d159d$var$pn();
var $e68ba20b3d2d159d$var$kS = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ selectedFontFamily: e, hoveredFontFamily: t, onSelect: r, onHover: o, onLeave: n, onOpen: i, onClose: a })=>{
    let { container: s } = $e68ba20b3d2d159d$var$Ft(), { fonts: l } = $e68ba20b3d2d159d$var$Bt(), { showDeprecatedFonts: c } = $e68ba20b3d2d159d$var$Xn(), [d, m] = (0, $acw62.useState)(""), p = (0, $acw62.useRef)(null), u = (0, $acw62.useMemo)(()=>Array.from($e68ba20b3d2d159d$var$zr.registered.entries()).filter(([k, { metadata: _ }])=>!_.serverSide).map(([k, { metadata: _, fonts: A }])=>{
            let R = {
                value: k,
                icon: _.icon,
                text: A[0].fontFace.family
            };
            return _.deprecated && Object.assign(R, {
                deprecated: _.deprecated,
                badge: {
                    type: $e68ba20b3d2d159d$var$$l.RED,
                    placeholder: $e68ba20b3d2d159d$var$x("fontList.badge.old")
                }
            }), R;
        }).sort((k, _)=>k.text.toLowerCase() > _.text.toLowerCase() ? 1 : -1), []), h = (0, $acw62.useMemo)(()=>new Set(l.getSceneFontFamilies()), [
        e
    ]), g = (0, $acw62.useMemo)(()=>u.filter((k)=>h.has(k.value)), [
        u,
        h
    ]), b = (0, $acw62.useMemo)(()=>u.filter((k)=>!h.has(k.value) && (c || !k.deprecated)), [
        u,
        h,
        c
    ]), v = (0, $acw62.useMemo)(()=>$e68ba20b3d2d159d$var$j0([
            ...g,
            ...b
        ].filter((k)=>k.text?.toLowerCase().includes(d))), [
        g,
        b,
        d
    ]), y = (0, $acw62.useMemo)(()=>{
        let k;
        return t ? k = v.find((_)=>_.value === t) : e && (k = v.find((_)=>_.value === e)), !k && d && (v[0]?.value ? o(v[0].value) : n()), k;
    }, [
        t,
        e,
        d,
        v,
        o,
        n
    ]), w = (0, $acw62.useCallback)((k)=>{
        $e68ba20b3d2d159d$var$AS({
            event: k,
            inputRef: p,
            hoveredFont: y,
            filteredFonts: v,
            onSelect: r,
            onHover: o,
            onClose: a
        }) && (k.preventDefault(), k.stopPropagation());
    }, [
        y,
        v,
        r,
        o,
        a
    ]);
    (0, $acw62.useEffect)(()=>(i(), ()=>{
            a();
        }), []);
    let I = (0, $acw62.useMemo)(()=>v.filter((k)=>h.has(k.value)), [
        v,
        h
    ]), M = (0, $acw62.useMemo)(()=>v.filter((k)=>!h.has(k.value)), [
        v,
        h
    ]), C = (k, _)=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$no, {
            icon: k.icon,
            value: k.value,
            order: _,
            textStyle: {
                fontFamily: $e68ba20b3d2d159d$var$kn({
                    fontFamily: k.value
                })
            },
            hovered: k.value === y?.value,
            selected: k.value === e,
            tabIndex: k.value === e ? 0 : -1,
            onClick: (A)=>{
                r(Number(A.currentTarget.value));
            },
            onMouseMove: ()=>{
                y?.value !== k.value && o(k.value);
            },
            children: [
                k.text,
                k.badge && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$bh, {
                    type: k.badge.type,
                    children: k.badge.placeholder
                })
            ]
        }, k.value), P = [];
    return I.length && P.push((0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Xd, {
        title: $e68ba20b3d2d159d$var$x("fontList.sceneFonts"),
        children: I.map(C)
    }, "group_1")), M.length && P.push((0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Xd, {
        title: $e68ba20b3d2d159d$var$x("fontList.availableFonts"),
        children: M.map((k, _)=>C(k, _ + I.length))
    }, "group_2")), (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$mh, {
        className: "properties-content",
        container: s,
        style: {
            width: "15rem"
        },
        onClose: a,
        onPointerLeave: n,
        onKeyDown: w,
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hh, {
                ref: p,
                placeholder: $e68ba20b3d2d159d$var$x("quickSearch.placeholder"),
                onChange: $e68ba20b3d2d159d$var$si(m, 20)
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gh, {
                className: "dropdown-menu fonts manual-hover",
                placeholder: $e68ba20b3d2d159d$var$x("fontList.empty"),
                children: P.length ? P : null
            })
        ]
    });
}, (e, t)=>e.selectedFontFamily === t.selectedFontFamily && e.hoveredFontFamily === t.hoveredFontFamily);
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$LS = ({ selectedFontFamily: e })=>{
    let t = (0, $acw62.useMemo)(()=>!!(e && !$e68ba20b3d2d159d$var$DS(e)), [
        e
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$41fb9f06171c75f4, {
        asChild: !0,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ah, {
                standalone: !0,
                icon: $e68ba20b3d2d159d$var$up,
                title: $e68ba20b3d2d159d$var$x("labels.showFonts"),
                className: "properties-trigger",
                testId: "font-family-show-fonts",
                active: t,
                onClick: ()=>{}
            })
        })
    });
};
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$NS = [
    {
        value: $e68ba20b3d2d159d$export$530097e879f93363.Excalifont,
        icon: $e68ba20b3d2d159d$var$di,
        text: $e68ba20b3d2d159d$var$x("labels.handDrawn"),
        testId: "font-family-handrawn"
    },
    {
        value: $e68ba20b3d2d159d$export$530097e879f93363.Nunito,
        icon: $e68ba20b3d2d159d$var$Qs,
        text: $e68ba20b3d2d159d$var$x("labels.normal"),
        testId: "font-family-normal"
    },
    {
        value: $e68ba20b3d2d159d$export$530097e879f93363["Comic Shanns"],
        icon: $e68ba20b3d2d159d$var$zc,
        text: $e68ba20b3d2d159d$var$x("labels.code"),
        testId: "font-family-code"
    }
], $e68ba20b3d2d159d$var$OL = new Set($e68ba20b3d2d159d$var$NS.map((e)=>e.value)), $e68ba20b3d2d159d$var$DS = (e)=>e ? $e68ba20b3d2d159d$var$OL.has(e) : !1, $e68ba20b3d2d159d$var$OS = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ isOpened: e, selectedFontFamily: t, hoveredFontFamily: r, onSelect: o, onHover: n, onLeave: i, onPopupChange: a })=>{
    let s = (0, $acw62.useMemo)(()=>$e68ba20b3d2d159d$var$NS, []), l = (0, $acw62.useCallback)((c)=>{
        c && o(c);
    }, [
        o
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "dialog",
        "aria-modal": "true",
        className: "FontPicker__container",
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                type: "button",
                options: s,
                value: t,
                onClick: l
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$sh, {}),
            (0, $7b02d682eb115277$exports.jsxs)($8a88ecc38cbd867b$export$be92b6f5f03c0fe9, {
                open: e,
                onOpenChange: a,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$LS, {
                        selectedFontFamily: t
                    }),
                    e && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$kS, {
                        selectedFontFamily: t,
                        hoveredFontFamily: r,
                        onSelect: l,
                        onHover: n,
                        onLeave: i,
                        onOpen: ()=>a(!0),
                        onClose: ()=>a(!1)
                    })
                ]
            })
        ]
    });
}, (e, t)=>e.isOpened === t.isOpened && e.selectedFontFamily === t.selectedFontFamily && e.hoveredFontFamily === t.hoveredFontFamily);
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$jo();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Cd();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$pn();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Ol();
$e68ba20b3d2d159d$var$Nt();
var $e68ba20b3d2d159d$var$BS = .1, $e68ba20b3d2d159d$var$Hr = (e, t, r, o = !1)=>{
    let n = $e68ba20b3d2d159d$var$j($e68ba20b3d2d159d$var$pe(e, t, {
        includeBoundTextElement: o
    }));
    return e.map((i)=>n.get(i.id) || i.id === t.editingTextElement?.id ? r(i) : i);
}, $e68ba20b3d2d159d$var$Ur = function(e, t, r, o, n) {
    let i = t.editingTextElement, a = $e68ba20b3d2d159d$export$a9f9e75229944f66(e), s = null;
    return i && (s = r(i)), s || ($e68ba20b3d2d159d$var$Qe(a, t) ? s = $e68ba20b3d2d159d$var$hx(o === !0 ? a : a.filter((c)=>o(c)), t, r) ?? (typeof n == "function" ? n(!0) : n) : s = typeof n == "function" ? n(!1) : n), s;
}, $e68ba20b3d2d159d$var$zL = (e, t)=>$e68ba20b3d2d159d$var$Ge(t) || !t.autoResize ? t : $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
        x: e.textAlign === "left" ? e.x : e.x + (e.width - t.width) / (e.textAlign === "center" ? 2 : 1),
        y: e.y + (e.height - t.height) / 2
    }, !1), $e68ba20b3d2d159d$var$Vx = (e, t, r, o, n)=>{
    let i = new Set;
    return {
        elements: $e68ba20b3d2d159d$var$Hr(e, t, (a)=>{
            if ($e68ba20b3d2d159d$var$G(a)) {
                let s = o(a);
                i.add(s);
                let l = $e68ba20b3d2d159d$export$5390fab1c98104d7(a, {
                    fontSize: s
                });
                return $e68ba20b3d2d159d$var$gt(l, r.scene.getContainerElement(a), r.scene.getNonDeletedElementsMap()), l = $e68ba20b3d2d159d$var$zL(a, l), l;
            }
            return a;
        }, !0),
        appState: {
            ...t,
            currentItemFontSize: i.size === 1 ? [
                ...i
            ][0] : n ?? t.currentItemFontSize
        },
        storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
    };
}, $e68ba20b3d2d159d$var$HL = $e68ba20b3d2d159d$var$U({
    name: "changeStrokeColor",
    label: "labels.stroke",
    trackEvent: !1,
    perform: (e, t, r)=>({
            ...r.currentItemStrokeColor && {
                elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$var$Id(o.type) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                        strokeColor: r.currentItemStrokeColor
                    }) : o, !0)
            },
            appState: {
                ...t,
                ...r
            },
            storeAction: r.currentItemStrokeColor ? $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE : $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, appProps: o })=>(0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("h3", {
                    "aria-hidden": "true",
                    children: $e68ba20b3d2d159d$var$x("labels.stroke")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Yd, {
                    topPicks: $e68ba20b3d2d159d$var$Am,
                    palette: $e68ba20b3d2d159d$var$l0,
                    type: "elementStroke",
                    label: $e68ba20b3d2d159d$var$x("labels.stroke"),
                    color: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>n.strokeColor, !0, t.currentItemStrokeColor),
                    onChange: (n)=>r({
                            currentItemStrokeColor: n
                        }),
                    elements: e,
                    appState: t,
                    updateData: r
                })
            ]
        })
}), $e68ba20b3d2d159d$var$UL = $e68ba20b3d2d159d$var$U({
    name: "changeBackgroundColor",
    label: "labels.changeBackground",
    trackEvent: !1,
    perform: (e, t, r)=>({
            ...r.currentItemBackgroundColor && {
                elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                        backgroundColor: r.currentItemBackgroundColor
                    }))
            },
            appState: {
                ...t,
                ...r
            },
            storeAction: r.currentItemBackgroundColor ? $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE : $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, appProps: o })=>(0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("h3", {
                    "aria-hidden": "true",
                    children: $e68ba20b3d2d159d$var$x("labels.background")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Yd, {
                    topPicks: $e68ba20b3d2d159d$var$Mm,
                    palette: $e68ba20b3d2d159d$var$c0,
                    type: "elementBackground",
                    label: $e68ba20b3d2d159d$var$x("labels.background"),
                    color: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>n.backgroundColor, !0, t.currentItemBackgroundColor),
                    onChange: (n)=>r({
                            currentItemBackgroundColor: n
                        }),
                    elements: e,
                    appState: t,
                    updateData: r
                })
            ]
        })
}), $e68ba20b3d2d159d$var$GL = $e68ba20b3d2d159d$var$U({
    name: "changeFillStyle",
    label: "labels.fill",
    trackEvent: !1,
    perform: (e, t, r, o)=>($e68ba20b3d2d159d$var$Pe("element", "changeFillStyle", `${r} (${o.device.editor.isMobile ? "mobile" : "desktop"})`), {
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (n)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                    fillStyle: r
                })),
            appState: {
                ...t,
                currentItemFillStyle: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>{
        let o = $e68ba20b3d2d159d$var$pe(e, t), n = o.length > 0 && o.every((i)=>i.fillStyle === "zigzag");
        return (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.fill")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    type: "button",
                    options: [
                        {
                            value: "hachure",
                            text: `${n ? $e68ba20b3d2d159d$var$x("labels.zigzag") : $e68ba20b3d2d159d$var$x("labels.hachure")} (${$e68ba20b3d2d159d$var$O("Alt-Click")})`,
                            icon: n ? $e68ba20b3d2d159d$var$Qy : $e68ba20b3d2d159d$var$ew,
                            active: n ? !0 : void 0,
                            testId: "fill-hachure"
                        },
                        {
                            value: "cross-hatch",
                            text: $e68ba20b3d2d159d$var$x("labels.crossHatch"),
                            icon: $e68ba20b3d2d159d$var$tw,
                            testId: "fill-cross-hatch"
                        },
                        {
                            value: "solid",
                            text: $e68ba20b3d2d159d$var$x("labels.solid"),
                            icon: $e68ba20b3d2d159d$var$rw,
                            testId: "fill-solid"
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (i)=>i.fillStyle, (i)=>i.hasOwnProperty("fillStyle"), (i)=>i ? null : t.currentItemFillStyle),
                    onClick: (i, a)=>{
                        let s = a.altKey && i === "hachure" && o.every((l)=>l.fillStyle === "hachure") ? "zigzag" : i;
                        r(s);
                    }
                })
            ]
        });
    }
}), $e68ba20b3d2d159d$var$WL = $e68ba20b3d2d159d$var$U({
    name: "changeStrokeWidth",
    label: "labels.strokeWidth",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    strokeWidth: r
                })),
            appState: {
                ...t,
                currentItemStrokeWidth: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.strokeWidth")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "stroke-width",
                    options: [
                        {
                            value: $e68ba20b3d2d159d$var$Um.thin,
                            text: $e68ba20b3d2d159d$var$x("labels.thin"),
                            icon: $e68ba20b3d2d159d$var$Df,
                            testId: "strokeWidth-thin"
                        },
                        {
                            value: $e68ba20b3d2d159d$var$Um.bold,
                            text: $e68ba20b3d2d159d$var$x("labels.bold"),
                            icon: $e68ba20b3d2d159d$var$ow,
                            testId: "strokeWidth-bold"
                        },
                        {
                            value: $e68ba20b3d2d159d$var$Um.extraBold,
                            text: $e68ba20b3d2d159d$var$x("labels.extraBold"),
                            icon: $e68ba20b3d2d159d$var$nw,
                            testId: "strokeWidth-extraBold"
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (o)=>o.strokeWidth, (o)=>o.hasOwnProperty("strokeWidth"), (o)=>o ? null : t.currentItemStrokeWidth),
                    onChange: (o)=>r(o)
                })
            ]
        })
}), $e68ba20b3d2d159d$var$VL = $e68ba20b3d2d159d$var$U({
    name: "changeSloppiness",
    label: "labels.sloppiness",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    seed: $e68ba20b3d2d159d$var$ko(),
                    roughness: r
                })),
            appState: {
                ...t,
                currentItemRoughness: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.sloppiness")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "sloppiness",
                    options: [
                        {
                            value: 0,
                            text: $e68ba20b3d2d159d$var$x("labels.architect"),
                            icon: $e68ba20b3d2d159d$var$sw
                        },
                        {
                            value: 1,
                            text: $e68ba20b3d2d159d$var$x("labels.artist"),
                            icon: $e68ba20b3d2d159d$var$lw
                        },
                        {
                            value: 2,
                            text: $e68ba20b3d2d159d$var$x("labels.cartoonist"),
                            icon: $e68ba20b3d2d159d$var$cw
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (o)=>o.roughness, (o)=>o.hasOwnProperty("roughness"), (o)=>o ? null : t.currentItemRoughness),
                    onChange: (o)=>r(o)
                })
            ]
        })
}), $e68ba20b3d2d159d$var$Tte = $e68ba20b3d2d159d$var$U({
    name: "changeStrokeStyle",
    label: "labels.strokeStyle",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    strokeStyle: r
                })),
            appState: {
                ...t,
                currentItemStrokeStyle: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.strokeStyle")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "strokeStyle",
                    options: [
                        {
                            value: "solid",
                            text: $e68ba20b3d2d159d$var$x("labels.strokeStyle_solid"),
                            icon: $e68ba20b3d2d159d$var$Df
                        },
                        {
                            value: "dashed",
                            text: $e68ba20b3d2d159d$var$x("labels.strokeStyle_dashed"),
                            icon: $e68ba20b3d2d159d$var$iw
                        },
                        {
                            value: "dotted",
                            text: $e68ba20b3d2d159d$var$x("labels.strokeStyle_dotted"),
                            icon: $e68ba20b3d2d159d$var$aw
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (o)=>o.strokeStyle, (o)=>o.hasOwnProperty("strokeStyle"), (o)=>o ? null : t.currentItemStrokeStyle),
                    onChange: (o)=>r(o)
                })
            ]
        })
}), $e68ba20b3d2d159d$var$YL = $e68ba20b3d2d159d$var$U({
    name: "changeOpacity",
    label: "labels.opacity",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    opacity: r
                }), !0),
            appState: {
                ...t,
                currentItemOpacity: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsxs)("label", {
            className: "control-label",
            children: [
                $e68ba20b3d2d159d$var$x("labels.opacity"),
                (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "range",
                    min: "0",
                    max: "100",
                    step: "10",
                    onChange: (o)=>r(+o.target.value),
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (o)=>o.opacity, !0, t.currentItemOpacity) ?? void 0
                })
            ]
        })
}), $e68ba20b3d2d159d$var$XL = $e68ba20b3d2d159d$var$U({
    name: "changeFontSize",
    label: "labels.fontSize",
    trackEvent: !1,
    perform: (e, t, r, o)=>$e68ba20b3d2d159d$var$Vx(e, t, o, ()=>r, r),
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.fontSize")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "font-size",
                    options: [
                        {
                            value: 16,
                            text: $e68ba20b3d2d159d$var$x("labels.small"),
                            icon: $e68ba20b3d2d159d$var$yw,
                            testId: "fontSize-small"
                        },
                        {
                            value: 20,
                            text: $e68ba20b3d2d159d$var$x("labels.medium"),
                            icon: $e68ba20b3d2d159d$var$ww,
                            testId: "fontSize-medium"
                        },
                        {
                            value: 28,
                            text: $e68ba20b3d2d159d$var$x("labels.large"),
                            icon: $e68ba20b3d2d159d$var$vw,
                            testId: "fontSize-large"
                        },
                        {
                            value: 36,
                            text: $e68ba20b3d2d159d$var$x("labels.veryLarge"),
                            icon: $e68ba20b3d2d159d$var$Tw,
                            testId: "fontSize-veryLarge"
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>{
                        if ($e68ba20b3d2d159d$var$G(n)) return n.fontSize;
                        let i = $e68ba20b3d2d159d$var$te(n, o.scene.getNonDeletedElementsMap());
                        return i ? i.fontSize : null;
                    }, (n)=>$e68ba20b3d2d159d$var$G(n) || $e68ba20b3d2d159d$var$te(n, o.scene.getNonDeletedElementsMap()) !== null, (n)=>n ? null : t.currentItemFontSize || $e68ba20b3d2d159d$var$wr),
                    onChange: (n)=>r(n)
                })
            ]
        })
}), $e68ba20b3d2d159d$var$Yx = $e68ba20b3d2d159d$var$U({
    name: "decreaseFontSize",
    label: "labels.decreaseFontSize",
    icon: $e68ba20b3d2d159d$var$Ka,
    trackEvent: !1,
    perform: (e, t, r, o)=>$e68ba20b3d2d159d$var$Vx(e, t, o, (n)=>Math.round(1 / (1 + $e68ba20b3d2d159d$var$BS) * n.fontSize)),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && (e.key === $e68ba20b3d2d159d$var$S.CHEVRON_LEFT || e.key === $e68ba20b3d2d159d$var$S.COMMA)
}), $e68ba20b3d2d159d$var$Xx = $e68ba20b3d2d159d$var$U({
    name: "increaseFontSize",
    label: "labels.increaseFontSize",
    icon: $e68ba20b3d2d159d$var$Ka,
    trackEvent: !1,
    perform: (e, t, r, o)=>$e68ba20b3d2d159d$var$Vx(e, t, o, (n)=>Math.round(n.fontSize * (1 + $e68ba20b3d2d159d$var$BS))),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && (e.key === $e68ba20b3d2d159d$var$S.CHEVRON_RIGHT || e.key === $e68ba20b3d2d159d$var$S.PERIOD)
}), $e68ba20b3d2d159d$var$KL = $e68ba20b3d2d159d$var$U({
    name: "changeFontFamily",
    label: "labels.fontFamily",
    trackEvent: !1,
    perform: (e, t, r, o)=>{
        let { cachedElements: n, resetAll: i, resetContainers: a, ...s } = r;
        if (i) return {
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (g)=>{
                let b = n?.get(g.id);
                return b ? $e68ba20b3d2d159d$export$5390fab1c98104d7(g, {
                    ...b
                }) : g;
            }, !0),
            appState: {
                ...t,
                ...s
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
        };
        let { currentItemFontFamily: l, currentHoveredFontFamily: c } = r, d = $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE, m, p = !1;
        if (l) m = l, d = $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE;
        else if (c) {
            m = c, d = $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE;
            let h = $e68ba20b3d2d159d$var$pe(e, t, {
                includeBoundTextElement: !0
            }).filter((g)=>$e68ba20b3d2d159d$var$G(g));
            if (h.length > 200) p = !0;
            else {
                let g = 0, b = 0;
                for(; g < h.length && b < 5e3;){
                    let v = h[g];
                    b += v?.originalText.length || 0, g++;
                }
                b > 5e3 && (p = !0);
            }
        }
        let u = {
            appState: {
                ...t,
                ...s
            },
            storeAction: d
        };
        if (m && !p) {
            let h = new Map, g = new Set, b = !1, v = Array.from($e68ba20b3d2d159d$var$zr.loadedFontsCache.values()), y = Object.entries($e68ba20b3d2d159d$export$530097e879f93363).find(([M, C])=>C === m)?.[0];
            c && y && v.some((M)=>M.startsWith(y)) && (b = !0), Object.assign(u, {
                elements: $e68ba20b3d2d159d$var$Hr(e, t, (M)=>{
                    if ($e68ba20b3d2d159d$var$G(M) && (M.fontFamily !== m || l)) {
                        let C = $e68ba20b3d2d159d$export$5390fab1c98104d7(M, {
                            fontFamily: m,
                            lineHeight: $e68ba20b3d2d159d$var$Eo(m)
                        }), P = n?.get(M.containerId || "") || {}, k = o.scene.getContainerElement(M);
                        return a && k && P && $e68ba20b3d2d159d$export$55655e96a21bba2e(k, {
                            ...P
                        }, !1), b || (g = new Set([
                            ...g,
                            ...Array.from(C.originalText)
                        ])), h.set(C, k), C;
                    }
                    return M;
                }, !0)
            });
            let w = `10px ${$e68ba20b3d2d159d$var$kn({
                fontFamily: m
            })}`, I = Array.from(g.values()).join();
            if (b || window.document.fonts.check(w, I)) for (let [M, C] of h)$e68ba20b3d2d159d$var$gt(M, C, o.scene.getNonDeletedElementsMap(), !1);
            else window.document.fonts.load(w, I).then((M)=>{
                for (let [C, P] of h){
                    let k = o.scene.getElement(C.id), _ = P ? o.scene.getElement(P.id) : null;
                    k && $e68ba20b3d2d159d$var$gt(k, _, o.scene.getNonDeletedElementsMap(), !1);
                }
                o.fonts.onLoaded(M);
            });
        }
        return u;
    },
    PanelComponent: ({ elements: e, appState: t, app: r, updateData: o })=>{
        let n = (0, $acw62.useRef)(new Map), i = (0, $acw62.useRef)(null), [a, s] = (0, $acw62.useState)({}), l = (0, $acw62.useRef)(!0), c = (0, $acw62.useMemo)(()=>{
            let d = (m, p)=>$e68ba20b3d2d159d$var$Ur(m, t, (u)=>{
                    if ($e68ba20b3d2d159d$var$G(u)) return u.fontFamily;
                    let h = $e68ba20b3d2d159d$var$te(u, p);
                    return h ? h.fontFamily : null;
                }, (u)=>$e68ba20b3d2d159d$var$G(u) || $e68ba20b3d2d159d$var$te(u, p) !== null, (u)=>u ? null : t.currentItemFontFamily || $e68ba20b3d2d159d$var$vr);
            return a.openPopup === "fontFamily" && t.openPopup === "fontFamily" ? d(Array.from(n.current?.values() ?? []), n.current) : !a.openPopup && t.openPopup !== "fontFamily" ? d(e, r.scene.getNonDeletedElementsMap()) : i.current;
        }, [
            a.openPopup,
            t,
            e,
            r.scene
        ]);
        return (0, $acw62.useEffect)(()=>{
            i.current = c;
        }, [
            c
        ]), (0, $acw62.useEffect)(()=>{
            Object.keys(a).length && (o(a), s({}));
        }, [
            a
        ]), (0, $acw62.useEffect)(()=>(l.current = !1, ()=>{
                l.current = !0;
            }), []), (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.fontFamily")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$OS, {
                    isOpened: t.openPopup === "fontFamily",
                    selectedFontFamily: c,
                    hoveredFontFamily: t.currentHoveredFontFamily,
                    onSelect: (d)=>{
                        s({
                            openPopup: null,
                            currentHoveredFontFamily: null,
                            currentItemFontFamily: d
                        }), n.current.clear();
                    },
                    onHover: (d)=>{
                        s({
                            currentHoveredFontFamily: d,
                            cachedElements: new Map(n.current),
                            resetContainers: !0
                        });
                    },
                    onLeave: ()=>{
                        s({
                            currentHoveredFontFamily: null,
                            cachedElements: new Map(n.current),
                            resetAll: !0
                        });
                    },
                    onPopupChange: (d)=>{
                        if (d) {
                            n.current.clear();
                            let { editingTextElement: m } = t;
                            if (m?.type === "text") {
                                let p = r.scene.getElement(m.id);
                                n.current.set(m.id, $e68ba20b3d2d159d$export$5390fab1c98104d7(p || m, {}, !0));
                            } else {
                                let p = $e68ba20b3d2d159d$var$pe(e, t, {
                                    includeBoundTextElement: !0
                                });
                                for (let u of p)n.current.set(u.id, $e68ba20b3d2d159d$export$5390fab1c98104d7(u, {}, !0));
                            }
                            s({
                                openPopup: "fontFamily"
                            });
                        } else {
                            let m = {
                                openPopup: null,
                                currentHoveredFontFamily: null,
                                cachedElements: new Map(n.current),
                                resetAll: !0
                            };
                            l.current ? o({
                                ...a,
                                ...m
                            }) : s(m), n.current.clear();
                        }
                    }
                })
            ]
        });
    }
}), $e68ba20b3d2d159d$var$$L = $e68ba20b3d2d159d$var$U({
    name: "changeTextAlign",
    label: "Change text alignment",
    trackEvent: !1,
    perform: (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (n)=>{
                if ($e68ba20b3d2d159d$var$G(n)) {
                    let i = $e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                        textAlign: r
                    });
                    return $e68ba20b3d2d159d$var$gt(i, o.scene.getContainerElement(n), o.scene.getNonDeletedElementsMap()), i;
                }
                return n;
            }, !0),
            appState: {
                ...t,
                currentItemTextAlign: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>{
        let n = o.scene.getNonDeletedElementsMap();
        return (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.textAlign")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "text-align",
                    options: [
                        {
                            value: "left",
                            text: $e68ba20b3d2d159d$var$x("labels.left"),
                            icon: $e68ba20b3d2d159d$var$Iw,
                            testId: "align-left"
                        },
                        {
                            value: "center",
                            text: $e68ba20b3d2d159d$var$x("labels.center"),
                            icon: $e68ba20b3d2d159d$var$Cw,
                            testId: "align-horizontal-center"
                        },
                        {
                            value: "right",
                            text: $e68ba20b3d2d159d$var$x("labels.right"),
                            icon: $e68ba20b3d2d159d$var$Aw,
                            testId: "align-right"
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (i)=>{
                        if ($e68ba20b3d2d159d$var$G(i)) return i.textAlign;
                        let a = $e68ba20b3d2d159d$var$te(i, n);
                        return a ? a.textAlign : null;
                    }, (i)=>$e68ba20b3d2d159d$var$G(i) || $e68ba20b3d2d159d$var$te(i, n) !== null, (i)=>i ? null : t.currentItemTextAlign),
                    onChange: (i)=>r(i)
                })
            ]
        });
    }
}), $e68ba20b3d2d159d$var$ZL = $e68ba20b3d2d159d$var$U({
    name: "changeVerticalAlign",
    label: "Change vertical alignment",
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (n)=>{
                if ($e68ba20b3d2d159d$var$G(n)) {
                    let i = $e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                        verticalAlign: r
                    });
                    return $e68ba20b3d2d159d$var$gt(i, o.scene.getContainerElement(n), o.scene.getNonDeletedElementsMap()), i;
                }
                return n;
            }, !0),
            appState: {
                ...t
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)("fieldset", {
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                group: "text-align",
                options: [
                    {
                        value: $e68ba20b3d2d159d$var$Pt.TOP,
                        text: $e68ba20b3d2d159d$var$x("labels.alignTop"),
                        icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mw, {
                            theme: t.theme
                        }),
                        testId: "align-top"
                    },
                    {
                        value: $e68ba20b3d2d159d$var$Pt.MIDDLE,
                        text: $e68ba20b3d2d159d$var$x("labels.centerVertically"),
                        icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pw, {
                            theme: t.theme
                        }),
                        testId: "align-middle"
                    },
                    {
                        value: $e68ba20b3d2d159d$var$Pt.BOTTOM,
                        text: $e68ba20b3d2d159d$var$x("labels.alignBottom"),
                        icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$kw, {
                            theme: t.theme
                        }),
                        testId: "align-bottom"
                    }
                ],
                value: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>{
                    if ($e68ba20b3d2d159d$var$G(n) && n.containerId) return n.verticalAlign;
                    let i = $e68ba20b3d2d159d$var$te(n, o.scene.getNonDeletedElementsMap());
                    return i ? i.verticalAlign : null;
                }, (n)=>$e68ba20b3d2d159d$var$G(n) || $e68ba20b3d2d159d$var$te(n, o.scene.getNonDeletedElementsMap()) !== null, (n)=>n ? null : $e68ba20b3d2d159d$var$Pt.MIDDLE),
                onChange: (n)=>r(n)
            })
        })
}), $e68ba20b3d2d159d$var$Ste = $e68ba20b3d2d159d$var$U({
    name: "changeRoundness",
    label: "Change edge roundness",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>$e68ba20b3d2d159d$var$ce(o) ? o : $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    roundness: r === "round" ? {
                        type: $e68ba20b3d2d159d$var$_n(o.type) ? $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS : $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
                    } : null
                })),
            appState: {
                ...t,
                currentItemRoundness: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>{
        let n = $e68ba20b3d2d159d$var$zd($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t).some((i)=>i.roundness?.type === $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.LEGACY);
        return (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.edges")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "edges",
                    options: [
                        {
                            value: "sharp",
                            text: $e68ba20b3d2d159d$var$x("labels.sharp"),
                            icon: $e68ba20b3d2d159d$var$dw
                        },
                        {
                            value: "round",
                            text: $e68ba20b3d2d159d$var$x("labels.round"),
                            icon: $e68ba20b3d2d159d$var$mw
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (i)=>n ? null : i.roundness ? "round" : "sharp", (i)=>!$e68ba20b3d2d159d$var$ie(i) && i.hasOwnProperty("roundness"), (i)=>i ? null : t.currentItemRoundness),
                    onChange: (i)=>r(i)
                })
            ]
        });
    }
}), $e68ba20b3d2d159d$var$FS = (e)=>[
        {
            value: null,
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_none"),
            keyBinding: "q",
            icon: $e68ba20b3d2d159d$var$pw
        },
        {
            value: "arrow",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_arrow"),
            keyBinding: "w",
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$uw, {
                flip: e
            })
        },
        {
            value: "bar",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_bar"),
            keyBinding: "e",
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gw, {
                flip: e
            })
        },
        {
            value: "dot",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_circle"),
            keyBinding: null,
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$_f, {
                flip: e
            }),
            showInPicker: !1
        },
        {
            value: "circle",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_circle"),
            keyBinding: "r",
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$_f, {
                flip: e
            }),
            showInPicker: !1
        },
        {
            value: "circle_outline",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_circle_outline"),
            keyBinding: null,
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hw, {
                flip: e
            }),
            showInPicker: !1
        },
        {
            value: "triangle",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_triangle"),
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fw, {
                flip: e
            }),
            keyBinding: "t"
        },
        {
            value: "triangle_outline",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_triangle_outline"),
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Ew, {
                flip: e
            }),
            keyBinding: null,
            showInPicker: !1
        },
        {
            value: "diamond",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_diamond"),
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$xw, {
                flip: e
            }),
            keyBinding: null,
            showInPicker: !1
        },
        {
            value: "diamond_outline",
            text: $e68ba20b3d2d159d$var$x("labels.arrowhead_diamond_outline"),
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$bw, {
                flip: e
            }),
            keyBinding: null,
            showInPicker: !1
        }
    ], $e68ba20b3d2d159d$var$Ite = $e68ba20b3d2d159d$var$U({
    name: "changeArrowhead",
    label: "Change arrowheads",
    trackEvent: !1,
    perform: (e, t, r)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (o)=>{
                if ($e68ba20b3d2d159d$export$5df2ebb939539835(o)) {
                    let { position: n, type: i } = r;
                    if (n === "start") return $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                        startArrowhead: i
                    });
                    if (n === "end") return $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                        endArrowhead: i
                    });
                }
                return o;
            }),
            appState: {
                ...t,
                [r.position === "start" ? "currentItemStartArrowhead" : "currentItemEndArrowhead"]: r.type
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>{
        let o = $e68ba20b3d2d159d$var$Sn().rtl;
        return (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.arrowheads")
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "iconSelectList buttonList",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Ox, {
                            label: "arrowhead_start",
                            options: $e68ba20b3d2d159d$var$FS(!o),
                            value: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>$e68ba20b3d2d159d$export$5df2ebb939539835(n) && $e68ba20b3d2d159d$var$hs(n.type) ? n.startArrowhead : t.currentItemStartArrowhead, !0, t.currentItemStartArrowhead),
                            onChange: (n)=>r({
                                    position: "start",
                                    type: n
                                })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Ox, {
                            label: "arrowhead_end",
                            group: "arrowheads",
                            options: $e68ba20b3d2d159d$var$FS(!!o),
                            value: $e68ba20b3d2d159d$var$Ur(e, t, (n)=>$e68ba20b3d2d159d$export$5df2ebb939539835(n) && $e68ba20b3d2d159d$var$hs(n.type) ? n.endArrowhead : t.currentItemEndArrowhead, !0, t.currentItemEndArrowhead),
                            onChange: (n)=>r({
                                    position: "end",
                                    type: n
                                })
                        })
                    ]
                })
            ]
        });
    }
}), $e68ba20b3d2d159d$var$Cte = $e68ba20b3d2d159d$var$U({
    name: "changeArrowType",
    label: "Change arrow types",
    trackEvent: !1,
    perform: (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$var$Hr(e, t, (n)=>{
                if (!$e68ba20b3d2d159d$var$ie(n)) return n;
                let i = $e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                    roundness: r === $e68ba20b3d2d159d$var$_t.round ? {
                        type: $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
                    } : null,
                    elbowed: r === $e68ba20b3d2d159d$var$_t.elbow,
                    points: r === $e68ba20b3d2d159d$var$_t.elbow || n.elbowed ? [
                        n.points[0],
                        n.points[n.points.length - 1]
                    ] : n.points
                });
                if ($e68ba20b3d2d159d$var$ce(i)) {
                    let a = o.scene.getNonDeletedElementsMap();
                    o.dismissLinearEditor();
                    let s = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(i, 0, a), l = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(i, -1, a), c = !i.startBinding && $e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sr(s), e, a, !0), d = !i.endBinding && $e68ba20b3d2d159d$var$Ir($e68ba20b3d2d159d$var$sr(l), e, a, !0), m = c || i.startBinding && a.get(i.startBinding.elementId), p = d || i.endBinding && a.get(i.endBinding.elementId), u = c ? $e68ba20b3d2d159d$var$fl(s, l, c, a) : s, h = d ? $e68ba20b3d2d159d$var$fl(l, s, d, a) : l;
                    c && $e68ba20b3d2d159d$var$fo(i, c, "start", a), d && $e68ba20b3d2d159d$var$fo(i, d, "end", a), $e68ba20b3d2d159d$var$Fo(i, a, [
                        u,
                        h
                    ].map((g)=>[
                            g[0] - i.x,
                            g[1] - i.y
                        ]), [
                        0,
                        0
                    ], {
                        ...m && i.startBinding ? {
                            startBinding: {
                                ...i.startBinding,
                                ...$e68ba20b3d2d159d$var$qc(i, m, "start", a)
                            }
                        } : {},
                        ...p && i.endBinding ? {
                            endBinding: {
                                ...i.endBinding,
                                ...$e68ba20b3d2d159d$var$qc(i, p, "end", a)
                            }
                        } : {}
                    });
                } else $e68ba20b3d2d159d$export$55655e96a21bba2e(i, {
                    startBinding: i.startBinding ? {
                        ...i.startBinding,
                        fixedPoint: null
                    } : null,
                    endBinding: i.endBinding ? {
                        ...i.endBinding,
                        fixedPoint: null
                    } : null
                }, !1);
                return i;
            }),
            appState: {
                ...t,
                currentItemArrowType: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: $e68ba20b3d2d159d$var$x("labels.arrowtypes")
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Bo, {
                    group: "arrowtypes",
                    options: [
                        {
                            value: $e68ba20b3d2d159d$var$_t.sharp,
                            text: $e68ba20b3d2d159d$var$x("labels.arrowtype_sharp"),
                            icon: $e68ba20b3d2d159d$var$o2,
                            testId: "sharp-arrow"
                        },
                        {
                            value: $e68ba20b3d2d159d$var$_t.round,
                            text: $e68ba20b3d2d159d$var$x("labels.arrowtype_round"),
                            icon: $e68ba20b3d2d159d$var$i2,
                            testId: "round-arrow"
                        },
                        {
                            value: $e68ba20b3d2d159d$var$_t.elbow,
                            text: $e68ba20b3d2d159d$var$x("labels.arrowtype_elbowed"),
                            icon: $e68ba20b3d2d159d$var$n2,
                            testId: "elbow-arrow"
                        }
                    ],
                    value: $e68ba20b3d2d159d$var$Ur(e, t, (o)=>$e68ba20b3d2d159d$var$ie(o) ? o.elbowed ? $e68ba20b3d2d159d$var$_t.elbow : o.roundness ? $e68ba20b3d2d159d$var$_t.round : $e68ba20b3d2d159d$var$_t.sharp : null, (o)=>$e68ba20b3d2d159d$var$ie(o), (o)=>o ? null : t.currentItemArrowType),
                    onChange: (o)=>r(o)
                })
            ]
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$fx();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Ai = ({ viewportX: e, viewportY: t, nextZoom: r }, o)=>{
    let n = e - o.offsetLeft, i = t - o.offsetTop, a = o.zoom.value, s = o.scrollX + (n - n / a), l = o.scrollY + (i - i / a), c = -(n - n / r), d = -(i - i / r);
    return {
        scrollX: s + c,
        scrollY: l + d,
        zoom: {
            value: r
        }
    };
};
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Zl = ()=>{
    let e = document.querySelector(".excalidraw-tooltip");
    if (e) return e;
    let t = document.createElement("div");
    return document.body.appendChild(t), t.classList.add("excalidraw-tooltip"), t;
}, $e68ba20b3d2d159d$var$Kx = (e, t, r = "bottom")=>{
    let o = e.getBoundingClientRect(), n = window.innerWidth, i = window.innerHeight, a = 5, s = t.left + t.width / 2 - o.width / 2;
    s < 0 ? s = a : s + o.width >= n && (s = n - o.width - a);
    let l;
    r === "bottom" ? (l = t.top + t.height + a, l + o.height >= i && (l = t.top - o.height - a)) : (l = t.top - o.height - a, l < 0 && (l = t.top + t.height + a)), Object.assign(e.style, {
        top: `${l}px`,
        left: `${s}px`
    });
}, $e68ba20b3d2d159d$var$qL = (e, t, r, o)=>{
    t.classList.add("excalidraw-tooltip--visible"), t.style.minWidth = o ? "50ch" : "10ch", t.style.maxWidth = o ? "50ch" : "15ch", t.textContent = r;
    let n = e.getBoundingClientRect();
    $e68ba20b3d2d159d$var$Kx(t, n);
}, $e68ba20b3d2d159d$var$yo = ({ children: e, label: t, long: r = !1, style: o, disabled: n })=>((0, $acw62.useEffect)(()=>()=>$e68ba20b3d2d159d$var$Zl().classList.remove("excalidraw-tooltip--visible"), []), n ? null : (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "excalidraw-tooltip-wrapper",
        onPointerEnter: (i)=>$e68ba20b3d2d159d$var$qL(i.currentTarget, $e68ba20b3d2d159d$var$Zl(), t, r),
        onPointerLeave: ()=>$e68ba20b3d2d159d$var$Zl().classList.remove("excalidraw-tooltip--visible"),
        style: o,
        children: e
    }));
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Qr();
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$Zs();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$rt();
var $e68ba20b3d2d159d$var$QL = $e68ba20b3d2d159d$var$U({
    name: "changeViewBackgroundColor",
    label: "labels.canvasBackground",
    paletteName: "Change canvas background color",
    trackEvent: !1,
    predicate: (e, t, r, o)=>!!o.props.UIOptions.canvasActions.changeViewBackgroundColor && !t.viewModeEnabled,
    perform: (e, t, r)=>({
            appState: {
                ...t,
                ...r
            },
            storeAction: r.viewBackgroundColor ? $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE : $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, appProps: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Yd, {
            palette: null,
            topPicks: $e68ba20b3d2d159d$var$km,
            label: $e68ba20b3d2d159d$var$x("labels.canvasBackground"),
            type: "canvasBackground",
            color: t.viewBackgroundColor,
            onChange: (n)=>r({
                    viewBackgroundColor: n
                }),
            "data-testid": "canvas-background-picker",
            elements: e,
            appState: t,
            updateData: r
        })
}), $e68ba20b3d2d159d$var$Mi = $e68ba20b3d2d159d$var$U({
    name: "clearCanvas",
    label: "labels.clearCanvas",
    paletteName: "Clear canvas",
    icon: $e68ba20b3d2d159d$var$rn,
    trackEvent: {
        category: "canvas"
    },
    predicate: (e, t, r, o)=>!!o.props.UIOptions.canvasActions.clearCanvas && !t.viewModeEnabled,
    perform: (e, t, r, o)=>(o.imageCache.clear(), {
            elements: e.map((n)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(n, {
                    isDeleted: !0
                })),
            appState: {
                ...$e68ba20b3d2d159d$var$dr(),
                files: {},
                theme: t.theme,
                penMode: t.penMode,
                penDetected: t.penDetected,
                exportBackground: t.exportBackground,
                exportEmbedScene: t.exportEmbedScene,
                gridSize: t.gridSize,
                gridStep: t.gridStep,
                gridModeEnabled: t.gridModeEnabled,
                stats: t.stats,
                pasteDialog: t.pasteDialog,
                activeTool: t.activeTool.type === "image" ? {
                    ...t.activeTool,
                    type: "selection"
                } : t.activeTool
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        })
}), $e68ba20b3d2d159d$var$wh = $e68ba20b3d2d159d$var$U({
    name: "zoomIn",
    label: "buttons.zoomIn",
    viewMode: !0,
    icon: $e68ba20b3d2d159d$var$gf,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>({
            appState: {
                ...t,
                ...$e68ba20b3d2d159d$var$Ai({
                    viewportX: t.width / 2 + t.offsetLeft,
                    viewportY: t.height / 2 + t.offsetTop,
                    nextZoom: $e68ba20b3d2d159d$var$to(t.zoom.value + $e68ba20b3d2d159d$var$Ba)
                }, t),
                userToFollow: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            className: "zoom-in-button zoom-button",
            icon: $e68ba20b3d2d159d$var$gf,
            title: `${$e68ba20b3d2d159d$var$x("buttons.zoomIn")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd++")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.zoomIn"),
            disabled: t.zoom.value >= $e68ba20b3d2d159d$var$Fm,
            onClick: ()=>{
                e(null);
            }
        }),
    keyTest: (e)=>(e.code === $e68ba20b3d2d159d$var$Ae.EQUAL || e.code === $e68ba20b3d2d159d$var$Ae.NUM_ADD) && (e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || e.shiftKey)
}), $e68ba20b3d2d159d$var$vh = $e68ba20b3d2d159d$var$U({
    name: "zoomOut",
    label: "buttons.zoomOut",
    icon: $e68ba20b3d2d159d$var$ff,
    viewMode: !0,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>({
            appState: {
                ...t,
                ...$e68ba20b3d2d159d$var$Ai({
                    viewportX: t.width / 2 + t.offsetLeft,
                    viewportY: t.height / 2 + t.offsetTop,
                    nextZoom: $e68ba20b3d2d159d$var$to(t.zoom.value - $e68ba20b3d2d159d$var$Ba)
                }, t),
                userToFollow: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            className: "zoom-out-button zoom-button",
            icon: $e68ba20b3d2d159d$var$ff,
            title: `${$e68ba20b3d2d159d$var$x("buttons.zoomOut")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+-")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.zoomOut"),
            disabled: t.zoom.value <= $e68ba20b3d2d159d$var$Om,
            onClick: ()=>{
                e(null);
            }
        }),
    keyTest: (e)=>(e.code === $e68ba20b3d2d159d$var$Ae.MINUS || e.code === $e68ba20b3d2d159d$var$Ae.NUM_SUBTRACT) && (e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || e.shiftKey)
}), $e68ba20b3d2d159d$var$Th = $e68ba20b3d2d159d$var$U({
    name: "resetZoom",
    label: "buttons.resetZoom",
    icon: $e68ba20b3d2d159d$var$Oy,
    viewMode: !0,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>({
            appState: {
                ...t,
                ...$e68ba20b3d2d159d$var$Ai({
                    viewportX: t.width / 2 + t.offsetLeft,
                    viewportY: t.height / 2 + t.offsetTop,
                    nextZoom: $e68ba20b3d2d159d$var$to(1)
                }, t),
                userToFollow: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ updateData: e, appState: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
            label: $e68ba20b3d2d159d$var$x("buttons.resetZoom"),
            style: {
                height: "100%"
            },
            children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$he, {
                type: "button",
                className: "reset-zoom-button zoom-button",
                title: $e68ba20b3d2d159d$var$x("buttons.resetZoom"),
                "aria-label": $e68ba20b3d2d159d$var$x("buttons.resetZoom"),
                onClick: ()=>{
                    e(null);
                },
                children: [
                    (t.zoom.value * 100).toFixed(0),
                    "%"
                ]
            })
        }),
    keyTest: (e)=>(e.code === $e68ba20b3d2d159d$var$Ae.ZERO || e.code === $e68ba20b3d2d159d$var$Ae.NUM_ZERO) && (e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || e.shiftKey)
}), $e68ba20b3d2d159d$var$eD = (e, t, r = 1)=>{
    let [o, n, i, a] = e, s = i - o, l = t.width / s, c = a - n, d = t.height / c, p = Math.min(l, d) * $e68ba20b3d2d159d$var$Bn(r, .1, 1), u = Math.floor(p / $e68ba20b3d2d159d$var$Ba) * $e68ba20b3d2d159d$var$Ba;
    return $e68ba20b3d2d159d$var$to(Math.min(u, 1));
}, $e68ba20b3d2d159d$export$a6d6ae0cd5b44fe = ({ bounds: e, appState: t, fitToViewport: r = !1, viewportZoomFactor: o = 1 })=>{
    let [n, i, a, s] = e, l = (n + a) / 2, c = (i + s) / 2, d, m, p;
    if (r) {
        let u = a - n, h = s - i;
        d = Math.min(t.width / u, t.height / h) * $e68ba20b3d2d159d$var$Bn(o, .1, 1), d = $e68ba20b3d2d159d$var$to(d);
        let g = t.width;
        if (t.openSidebar) {
            let v = document.querySelector(".sidebar")?.offsetWidth ?? 0;
            g = document.documentElement.getAttribute("dir") === "rtl" ? t.width + v : t.width - v;
        }
        m = g / 2 * (1 / d) - l, p = t.height / 2 * (1 / d) - c;
    } else {
        d = $e68ba20b3d2d159d$var$eD(e, {
            width: t.width,
            height: t.height
        }, o);
        let u = $e68ba20b3d2d159d$var$gx({
            scenePoint: {
                x: l,
                y: c
            },
            viewportDimensions: {
                width: t.width,
                height: t.height
            },
            zoom: {
                value: d
            }
        });
        m = u.scrollX, p = u.scrollY;
    }
    return {
        appState: {
            ...t,
            scrollX: m,
            scrollY: p,
            zoom: {
                value: d
            }
        },
        storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
    };
}, $e68ba20b3d2d159d$var$$d = ({ targetElements: e, appState: t, fitToViewport: r, viewportZoomFactor: o })=>{
    let n = $e68ba20b3d2d159d$export$3e54c0515ef60d1d($e68ba20b3d2d159d$export$a9f9e75229944f66(e));
    return $e68ba20b3d2d159d$export$a6d6ae0cd5b44fe({
        bounds: n,
        appState: t,
        fitToViewport: r,
        viewportZoomFactor: o
    });
}, $e68ba20b3d2d159d$var$ire = $e68ba20b3d2d159d$var$U({
    name: "zoomToFitSelectionInViewport",
    label: "labels.zoomToFitViewport",
    icon: $e68ba20b3d2d159d$var$Mp,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t);
        return $e68ba20b3d2d159d$var$$d({
            targetElements: n.length ? n : e,
            appState: {
                ...t,
                userToFollow: null
            },
            fitToViewport: !1
        });
    },
    keyTest: (e)=>e.code === $e68ba20b3d2d159d$var$Ae.TWO && e.shiftKey && !e.altKey && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]
}), $e68ba20b3d2d159d$var$are = $e68ba20b3d2d159d$var$U({
    name: "zoomToFitSelection",
    label: "helpDialog.zoomToSelection",
    icon: $e68ba20b3d2d159d$var$Mp,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t);
        return $e68ba20b3d2d159d$var$$d({
            targetElements: n.length ? n : e,
            appState: {
                ...t,
                userToFollow: null
            },
            fitToViewport: !0,
            viewportZoomFactor: .7
        });
    },
    keyTest: (e)=>e.code === $e68ba20b3d2d159d$var$Ae.THREE && e.shiftKey && !e.altKey && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]
}), $e68ba20b3d2d159d$var$tD = $e68ba20b3d2d159d$var$U({
    name: "zoomToFit",
    label: "helpDialog.zoomToFit",
    icon: $e68ba20b3d2d159d$var$Mp,
    viewMode: !0,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t)=>$e68ba20b3d2d159d$var$$d({
            targetElements: e,
            appState: {
                ...t,
                userToFollow: null
            },
            fitToViewport: !1
        }),
    keyTest: (e)=>e.code === $e68ba20b3d2d159d$var$Ae.ONE && e.shiftKey && !e.altKey && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]
}), $e68ba20b3d2d159d$var$Cs = $e68ba20b3d2d159d$var$U({
    name: "toggleTheme",
    label: (e, t)=>t.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? "buttons.lightMode" : "buttons.darkMode",
    keywords: [
        "toggle",
        "dark",
        "light",
        "mode",
        "theme"
    ],
    icon: (e)=>e.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? $e68ba20b3d2d159d$var$Oc : $e68ba20b3d2d159d$var$Fc,
    viewMode: !0,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r)=>({
            appState: {
                ...t,
                theme: r || (t.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK : $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT)
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    keyTest: (e)=>e.altKey && e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.D,
    predicate: (e, t, r, o)=>!!o.props.UIOptions.canvasActions.toggleTheme
}), $e68ba20b3d2d159d$var$sre = $e68ba20b3d2d159d$var$U({
    name: "toggleEraserTool",
    label: "toolBar.eraser",
    trackEvent: {
        category: "toolbar"
    },
    perform: (e, t)=>{
        let r;
        return $e68ba20b3d2d159d$var$Jr(t) ? r = $e68ba20b3d2d159d$var$it(t, {
            ...t.activeTool.lastActiveTool || {
                type: "selection"
            },
            lastActiveToolBeforeEraser: null
        }) : r = $e68ba20b3d2d159d$var$it(t, {
            type: "eraser",
            lastActiveToolBeforeEraser: t.activeTool
        }), {
            appState: {
                ...t,
                selectedElementIds: {},
                selectedGroupIds: {},
                activeEmbeddable: null,
                activeTool: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>e.key === $e68ba20b3d2d159d$var$S.E
}), $e68ba20b3d2d159d$var$US = $e68ba20b3d2d159d$var$U({
    name: "toggleHandTool",
    label: "toolBar.hand",
    paletteName: "Toggle hand tool",
    trackEvent: {
        category: "toolbar"
    },
    icon: $e68ba20b3d2d159d$var$yp,
    viewMode: !1,
    perform: (e, t, r, o)=>{
        let n;
        return $e68ba20b3d2d159d$var$Jo(t) ? n = $e68ba20b3d2d159d$var$it(t, {
            ...t.activeTool.lastActiveTool || {
                type: "selection"
            },
            lastActiveToolBeforeEraser: null
        }) : (n = $e68ba20b3d2d159d$var$it(t, {
            type: "hand",
            lastActiveToolBeforeEraser: t.activeTool
        }), $e68ba20b3d2d159d$var$qe(o.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB)), {
            appState: {
                ...t,
                selectedElementIds: {},
                selectedGroupIds: {},
                activeEmbeddable: null,
                activeTool: n
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>!e.altKey && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.H
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Zs();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$wo = $e68ba20b3d2d159d$var$U({
    name: "finalize",
    label: "",
    trackEvent: !1,
    perform: (e, t, r, o)=>{
        let { interactiveCanvas: n, focusContainer: i, scene: a } = o, s = a.getNonDeletedElementsMap();
        if (t.editingLinearElement) {
            let { elementId: p, startBindingElement: u, endBindingElement: h } = t.editingLinearElement, g = $e68ba20b3d2d159d$var$$.getElement(p, s);
            if (g) return $e68ba20b3d2d159d$var$qr(g) && $e68ba20b3d2d159d$var$as(g, u, h, s, a), {
                elements: g.points.length < 2 || $e68ba20b3d2d159d$export$2cab0e754c9472e0(g) ? e.filter((b)=>b.id !== g.id) : void 0,
                appState: {
                    ...t,
                    cursorButton: "up",
                    editingLinearElement: null
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            };
        }
        let l = e, c = t.pendingImageElementId && a.getElement(t.pendingImageElementId);
        c && $e68ba20b3d2d159d$export$55655e96a21bba2e(c, {
            isDeleted: !0
        }, !1), window.document.activeElement instanceof HTMLElement && i();
        let d = t.multiElement ? t.multiElement : t.newElement?.type === "freedraw" ? t.newElement : null;
        if (d) {
            if (d.type !== "freedraw" && t.lastPointerDownWith !== "touch") {
                let { points: u, lastCommittedPoint: h } = d;
                (!h || u[u.length - 1] !== h) && $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                    points: d.points.slice(0, -1)
                });
            }
            $e68ba20b3d2d159d$export$2cab0e754c9472e0(d) && (l = l.filter((u)=>u.id !== d.id));
            let p = $e68ba20b3d2d159d$var$Br(d.points, t.zoom.value);
            if ((d.type === "line" || d.type === "freedraw") && p) {
                let u = d.points, h = u[0];
                $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                    points: u.map((g, b)=>b === u.length - 1 ? [
                            h[0],
                            h[1]
                        ] : g)
                });
            }
            if ($e68ba20b3d2d159d$var$qr(d) && !p && d.points.length > 1) {
                let [u, h] = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(d, -1, $e68ba20b3d2d159d$var$j(e));
                $e68ba20b3d2d159d$var$jc(d, t, {
                    x: u,
                    y: h
                }, s, e);
            }
        }
        (!t.activeTool.locked && t.activeTool.type !== "freedraw" || !d) && $e68ba20b3d2d159d$var$uo(n);
        let m;
        return t.activeTool.type === "eraser" ? m = $e68ba20b3d2d159d$var$it(t, {
            ...t.activeTool.lastActiveTool || {
                type: "selection"
            },
            lastActiveToolBeforeEraser: null
        }) : m = $e68ba20b3d2d159d$var$it(t, {
            type: "selection"
        }), {
            elements: l,
            appState: {
                ...t,
                cursorButton: "up",
                activeTool: (t.activeTool.locked || t.activeTool.type === "freedraw") && d ? t.activeTool : m,
                activeEmbeddable: null,
                newElement: null,
                selectionElement: null,
                multiElement: null,
                editingTextElement: null,
                startBoundElement: null,
                suggestedBindings: [],
                selectedElementIds: d && !t.activeTool.locked && t.activeTool.type !== "freedraw" ? {
                    ...t.selectedElementIds,
                    [d.id]: !0
                } : t.selectedElementIds,
                selectedLinearElement: d && $e68ba20b3d2d159d$export$5df2ebb939539835(d) ? new $e68ba20b3d2d159d$var$$(d) : t.selectedLinearElement,
                pendingImageElementId: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e, t)=>e.key === $e68ba20b3d2d159d$var$S.ESCAPE && (t.editingLinearElement !== null || !t.newElement && t.multiElement === null) || (e.key === $e68ba20b3d2d159d$var$S.ESCAPE || e.key === $e68ba20b3d2d159d$var$S.ENTER) && t.multiElement !== null,
    PanelComponent: ({ appState: e, updateData: t, data: r })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$Xy,
            title: $e68ba20b3d2d159d$var$x("buttons.done"),
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.done"),
            onClick: t,
            visible: e.multiElement != null,
            size: r?.size || "medium"
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$WS = (e)=>{
    let { id: t } = $e68ba20b3d2d159d$var$Ft(), [r, o] = (0, $acw62.useState)(e.value), n = (a)=>{
        e.ignoreFocus || $e68ba20b3d2d159d$var$X0(a.target);
        let s = a.target.value;
        s !== e.value && e.onChange(s);
    }, i = (a)=>{
        if (a.key === $e68ba20b3d2d159d$var$S.ENTER) {
            if (a.preventDefault(), a.nativeEvent.isComposing || a.keyCode === 229) return;
            a.currentTarget.blur();
        }
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ProjectName",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("label", {
                className: "ProjectName-label",
                htmlFor: "filename",
                children: `${e.label}:`
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "text",
                className: "TextInput",
                onBlur: n,
                onKeyDown: i,
                id: `${t}-filename`,
                value: r,
                onChange: (a)=>o(a.target.value)
            })
        ]
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$YS = (e)=>{
    let t = e.title || (e.value === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? $e68ba20b3d2d159d$var$x("buttons.lightMode") : $e68ba20b3d2d159d$var$x("buttons.darkMode"));
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
        type: "icon",
        icon: e.value === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? $e68ba20b3d2d159d$var$VS.MOON : $e68ba20b3d2d159d$var$VS.SUN,
        title: t,
        "aria-label": t,
        onClick: ()=>e.onChange(e.value === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT : $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK),
        "data-testid": "toggle-dark-mode"
    });
}, $e68ba20b3d2d159d$var$VS = {
    SUN: (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "512",
        height: "512",
        className: "rtl-mirror",
        viewBox: "0 0 512 512",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
        })
    }),
    MOON: (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "512",
        height: "512",
        className: "rtl-mirror",
        viewBox: "0 0 512 512",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
        })
    })
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$yd();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$pi();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$pi();
var $e68ba20b3d2d159d$var$As = (e, { selectedElementIds: t }, r)=>{
    e = $e68ba20b3d2d159d$export$a9f9e75229944f66(e);
    let o = r && $e68ba20b3d2d159d$var$Qe(e, {
        selectedElementIds: t
    }), n = null, i = o ? $e68ba20b3d2d159d$var$pe(e, {
        selectedElementIds: t
    }, {
        includeBoundTextElement: !0
    }) : e;
    return o && (i.length === 1 && $e68ba20b3d2d159d$var$re(i[0]) ? (n = i[0], i = $e68ba20b3d2d159d$var$Sl(e, n)) : i.length > 1 && (i = $e68ba20b3d2d159d$var$pe(e, {
        selectedElementIds: t
    }, {
        includeBoundTextElement: !0,
        includeElementsInFrames: !0
    }))), {
        exportingFrame: n,
        exportedElements: $e68ba20b3d2d159d$var$jr(i)
    };
};

var $e68ba20b3d2d159d$var$Ms = async (e, t, r, o, { exportBackground: n, exportPadding: i = $e68ba20b3d2d159d$var$$o, viewBackgroundColor: a, name: s = r.name || $e68ba20b3d2d159d$var$Wm, fileHandle: l = null, exportingFrame: c = null })=>{
    if (t.length === 0) throw new Error($e68ba20b3d2d159d$var$x("alerts.cannotExportEmptyCanvas"));
    if (e === "svg" || e === "clipboard-svg") {
        let m = $e68ba20b3d2d159d$var$Tl(t, {
            exportBackground: n,
            exportWithDarkMode: r.exportWithDarkMode,
            viewBackgroundColor: a,
            exportPadding: i,
            exportScale: r.exportScale,
            exportEmbedScene: r.exportEmbedScene && e === "svg"
        }, o, {
            exportingFrame: c
        });
        if (e === "svg") return $e68ba20b3d2d159d$var$ol(m.then((p)=>new Blob([
                p.outerHTML
            ], {
                type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg
            })), {
            description: "Export to SVG",
            name: s,
            extension: r.exportEmbedScene ? "excalidraw.svg" : "svg",
            fileHandle: l
        });
        if (e === "clipboard-svg") {
            let p = await m.then((u)=>u.outerHTML);
            try {
                await $e68ba20b3d2d159d$var$vi(p);
            } catch  {
                throw new Error($e68ba20b3d2d159d$var$x("errors.copyToSystemClipboardFailed"));
            }
            return;
        }
    }
    let d = $e68ba20b3d2d159d$var$Cu(t, r, o, {
        exportBackground: n,
        viewBackgroundColor: a,
        exportPadding: i,
        exportingFrame: c
    });
    if (e === "png") {
        let m = $e68ba20b3d2d159d$var$fi(d);
        return r.exportEmbedScene && (m = m.then((p)=>Promise.resolve().then(function() {
                return (parcelRequire("7NDzr"));
            }).then((res)=>($e68ba20b3d2d159d$var$bl(), $e68ba20b3d2d159d$var$nd)).then(({ encodePngMetadata: u })=>u({
                    blob: p,
                    metadata: $e68ba20b3d2d159d$export$b502122c5be20fdd(t, r, o, "local")
                })))), $e68ba20b3d2d159d$var$ol(m, {
            description: "Export to PNG",
            name: s,
            extension: "png",
            fileHandle: l
        });
    } else if (e === "clipboard") try {
        let m = $e68ba20b3d2d159d$var$fi(d);
        await $e68ba20b3d2d159d$var$Du(m);
    } catch (m) {
        throw console.warn(m), m.name === "CANVAS_POSSIBLY_TOO_BIG" ? new Error($e68ba20b3d2d159d$var$x("canvasError.canvasTooBig")) : $e68ba20b3d2d159d$var$ni && m.name === "TypeError" ? new Error(`${$e68ba20b3d2d159d$var$x("alerts.couldNotCopyToClipboard")}

${$e68ba20b3d2d159d$var$x("hints.firefox_clipboard_write")}`) : new Error($e68ba20b3d2d159d$var$x("alerts.couldNotCopyToClipboard"));
    }
    else throw new Error("Unsupported export type");
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Fr();
var $e68ba20b3d2d159d$var$XS = async (e, t, r, o)=>{
    let { exportBackground: n, viewBackgroundColor: i, fileHandle: a } = t, s = $e68ba20b3d2d159d$var$uE(a);
    if (!a || !$e68ba20b3d2d159d$var$vv(s)) throw new Error("fileHandle should exist and should be of type svg or png when resaving");
    t = {
        ...t,
        exportEmbedScene: !0
    };
    let { exportedElements: l, exportingFrame: c } = $e68ba20b3d2d159d$var$As(e, t, !1);
    return await $e68ba20b3d2d159d$var$Ms(s, l, t, r, {
        exportBackground: n,
        viewBackgroundColor: i,
        name: o,
        fileHandle: a,
        exportingFrame: c
    }), {
        fileHandle: a
    };
};
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$jd = ({ children: e, checked: t, onChange: r, className: o })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Checkbox", o, {
            "is-checked": t
        }),
        onClick: (n)=>{
            r(!t, n), n.currentTarget.querySelector(".Checkbox-box").focus();
        },
        children: [
            (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "Checkbox-box",
                role: "checkbox",
                "aria-checked": t,
                children: $e68ba20b3d2d159d$var$Uy
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Checkbox-label",
                children: e
            })
        ]
    });
$e68ba20b3d2d159d$var$yd();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$$x = $e68ba20b3d2d159d$var$U({
    name: "changeProjectName",
    label: "labels.fileTitle",
    trackEvent: !1,
    perform: (e, t, r)=>({
            appState: {
                ...t,
                name: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ appState: e, updateData: t, appProps: r, data: o, app: n })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$WS, {
            label: $e68ba20b3d2d159d$var$x("labels.fileTitle"),
            value: n.getName(),
            onChange: (i)=>t(i),
            ignoreFocus: o?.ignoreFocus ?? !1
        })
}), $e68ba20b3d2d159d$var$$S = $e68ba20b3d2d159d$var$U({
    name: "changeExportScale",
    label: "imageExportDialog.scale",
    trackEvent: {
        category: "export",
        action: "scale"
    },
    perform: (e, t, r)=>({
            appState: {
                ...t,
                exportScale: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>{
        let o = $e68ba20b3d2d159d$export$a9f9e75229944f66(e), i = $e68ba20b3d2d159d$var$Qe(o, t) ? $e68ba20b3d2d159d$var$pe(o, t) : o;
        return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: $e68ba20b3d2d159d$var$Xs.map((a)=>{
                let [s, l] = $e68ba20b3d2d159d$var$vT(i, $e68ba20b3d2d159d$var$$o, a), c = `${$e68ba20b3d2d159d$var$x("imageExportDialog.label.scale")} ${a}x (${s}x${l})`;
                return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                    size: "small",
                    type: "radio",
                    icon: `${a}x`,
                    name: "export-canvas-scale",
                    title: c,
                    "aria-label": c,
                    id: "export-canvas-scale",
                    checked: a === t.exportScale,
                    onChange: ()=>r(a)
                }, a);
            })
        });
    }
}), $e68ba20b3d2d159d$var$Zx = $e68ba20b3d2d159d$var$U({
    name: "changeExportBackground",
    label: "imageExportDialog.label.withBackground",
    trackEvent: {
        category: "export",
        action: "toggleBackground"
    },
    perform: (e, t, r)=>({
            appState: {
                ...t,
                exportBackground: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ appState: e, updateData: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jd, {
            checked: e.exportBackground,
            onChange: (r)=>t(r),
            children: $e68ba20b3d2d159d$var$x("imageExportDialog.label.withBackground")
        })
}), $e68ba20b3d2d159d$var$Ih = $e68ba20b3d2d159d$var$U({
    name: "changeExportEmbedScene",
    label: "imageExportDialog.tooltip.embedScene",
    trackEvent: {
        category: "export",
        action: "embedScene"
    },
    perform: (e, t, r)=>({
            appState: {
                ...t,
                exportEmbedScene: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ appState: e, updateData: t })=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$jd, {
            checked: e.exportEmbedScene,
            onChange: (r)=>t(r),
            children: [
                $e68ba20b3d2d159d$var$x("imageExportDialog.label.embedScene"),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
                    label: $e68ba20b3d2d159d$var$x("imageExportDialog.tooltip.embedScene"),
                    long: !0,
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "excalidraw-tooltip-icon",
                        children: $e68ba20b3d2d159d$var$Ky
                    })
                })
            ]
        })
}), $e68ba20b3d2d159d$var$Ch = $e68ba20b3d2d159d$var$U({
    name: "saveToActiveFile",
    label: "buttons.save",
    icon: $e68ba20b3d2d159d$var$Xa,
    trackEvent: {
        category: "export"
    },
    predicate: (e, t, r, o)=>!!o.props.UIOptions.canvasActions.saveToActiveFile && !!t.fileHandle && !t.viewModeEnabled,
    perform: async (e, t, r, o)=>{
        let n = !!t.fileHandle;
        try {
            let { fileHandle: i } = $e68ba20b3d2d159d$var$nl(t.fileHandle) ? await $e68ba20b3d2d159d$var$XS(e, t, o.files, o.getName()) : await $e68ba20b3d2d159d$var$Pp(e, t, o.files, o.getName());
            return {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    fileHandle: i,
                    toast: n ? {
                        message: i?.name ? $e68ba20b3d2d159d$var$x("toast.fileSavedToFilename").replace("{filename}", `"${i.name}"`) : $e68ba20b3d2d159d$var$x("toast.fileSaved")
                    } : null
                }
            };
        } catch (i) {
            return i?.name !== "AbortError" ? console.error(i) : console.warn(i), {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    },
    keyTest: (e)=>e.key === $e68ba20b3d2d159d$var$S.S && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !e.shiftKey
}), $e68ba20b3d2d159d$var$qd = $e68ba20b3d2d159d$var$U({
    name: "saveFileToDisk",
    label: "exportDialog.disk_title",
    icon: $e68ba20b3d2d159d$var$Xa,
    viewMode: !0,
    trackEvent: {
        category: "export"
    },
    perform: async (e, t, r, o)=>{
        try {
            let { fileHandle: n } = await $e68ba20b3d2d159d$var$Pp(e, {
                ...t,
                fileHandle: null
            }, o.files, o.getName());
            return {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    openDialog: null,
                    fileHandle: n,
                    toast: {
                        message: $e68ba20b3d2d159d$var$x("toast.fileSaved")
                    }
                }
            };
        } catch (n) {
            return n?.name !== "AbortError" ? console.error(n) : console.warn(n), {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    },
    keyTest: (e)=>e.key === $e68ba20b3d2d159d$var$S.S && e.shiftKey && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD],
    PanelComponent: ({ updateData: e })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$Wy,
            title: $e68ba20b3d2d159d$var$x("buttons.saveAs"),
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.saveAs"),
            showAriaLabel: $e68ba20b3d2d159d$export$aa949327762d0f40().editor.isMobile,
            hidden: !(0, $11b096c57ac70a88$export$5f747a46dc0eb6ee),
            onClick: ()=>e(null),
            "data-testid": "save-as-button"
        })
}), $e68ba20b3d2d159d$var$jl = $e68ba20b3d2d159d$var$U({
    name: "loadScene",
    label: "buttons.load",
    trackEvent: {
        category: "export"
    },
    predicate: (e, t, r, o)=>!!o.props.UIOptions.canvasActions.loadScene && !t.viewModeEnabled,
    perform: async (e, t, r, o)=>{
        try {
            let { elements: n, appState: i, files: a } = await $e68ba20b3d2d159d$var$Ff(t, e);
            return {
                elements: n,
                appState: i,
                files: a,
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            };
        } catch (n) {
            return n?.name === "AbortError" ? (console.warn(n), !1) : {
                elements: e,
                appState: {
                    ...t,
                    errorMessage: n.message
                },
                files: o.files,
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.O
}), $e68ba20b3d2d159d$var$ZS = $e68ba20b3d2d159d$var$U({
    name: "exportWithDarkMode",
    label: "imageExportDialog.label.darkMode",
    trackEvent: {
        category: "export",
        action: "toggleTheme"
    },
    perform: (e, t, r)=>({
            appState: {
                ...t,
                exportWithDarkMode: r
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ appState: e, updateData: t })=>(0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-45px",
                marginBottom: "10px"
            },
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$YS, {
                value: e.exportWithDarkMode ? $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK : $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT,
                onChange: (r)=>{
                    t(r === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK);
                },
                title: $e68ba20b3d2d159d$var$x("imageExportDialog.label.darkMode")
            })
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$pn();
var $e68ba20b3d2d159d$var$jS = "{}", $e68ba20b3d2d159d$var$jx = $e68ba20b3d2d159d$var$U({
    name: "copyStyles",
    label: "labels.copyStyles",
    icon: $e68ba20b3d2d159d$var$Nf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = [], i = e.find((a)=>t.selectedElementIds[a.id]);
        if (n.push(i), i && $e68ba20b3d2d159d$var$It(i)) {
            let a = $e68ba20b3d2d159d$var$te(i, o.scene.getNonDeletedElementsMap());
            n.push(a);
        }
        return i && ($e68ba20b3d2d159d$var$jS = JSON.stringify(n)), {
            appState: {
                ...t,
                toast: {
                    message: $e68ba20b3d2d159d$var$x("toast.copyStyles")
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.C
}), $e68ba20b3d2d159d$var$qx = $e68ba20b3d2d159d$var$U({
    name: "pasteStyles",
    label: "labels.pasteStyles",
    icon: $e68ba20b3d2d159d$var$Nf,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = JSON.parse($e68ba20b3d2d159d$var$jS), i = n[0], a = n[1];
        if (!$e68ba20b3d2d159d$var$Rc(i)) return {
            elements: e,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let s = $e68ba20b3d2d159d$var$pe(e, t, {
            includeBoundTextElement: !0
        }), l = s.map((c)=>c.id);
        return {
            elements: e.map((c)=>{
                if (l.includes(c.id)) {
                    let d = i;
                    if ($e68ba20b3d2d159d$var$G(c) && c.containerId && (d = a), !d) return c;
                    let m = $e68ba20b3d2d159d$export$5390fab1c98104d7(c, {
                        backgroundColor: d?.backgroundColor,
                        strokeWidth: d?.strokeWidth,
                        strokeColor: d?.strokeColor,
                        strokeStyle: d?.strokeStyle,
                        fillStyle: d?.fillStyle,
                        opacity: d?.opacity,
                        roughness: d?.roughness,
                        roundness: d.roundness ? $e68ba20b3d2d159d$var$iy(d.roundness.type, c) ? d.roundness : $e68ba20b3d2d159d$var$ay(c) : null
                    });
                    if ($e68ba20b3d2d159d$var$G(m)) {
                        let p = d.fontSize || $e68ba20b3d2d159d$var$wr, u = d.fontFamily || $e68ba20b3d2d159d$var$vr;
                        m = $e68ba20b3d2d159d$export$5390fab1c98104d7(m, {
                            fontSize: p,
                            fontFamily: u,
                            textAlign: d.textAlign || $e68ba20b3d2d159d$var$An,
                            lineHeight: d.lineHeight || $e68ba20b3d2d159d$var$Eo(u)
                        });
                        let h = null;
                        m.containerId && (h = s.find((g)=>$e68ba20b3d2d159d$var$G(m) && g.id === m.containerId) || null), $e68ba20b3d2d159d$var$gt(m, h, o.scene.getNonDeletedElementsMap());
                    }
                    return m.type === "arrow" && $e68ba20b3d2d159d$var$ie(d) && (m = $e68ba20b3d2d159d$export$5390fab1c98104d7(m, {
                        startArrowhead: d.startArrowhead,
                        endArrowhead: d.endArrowhead
                    })), $e68ba20b3d2d159d$var$re(c) && (m = $e68ba20b3d2d159d$export$5390fab1c98104d7(m, {
                        roundness: null,
                        backgroundColor: "transparent"
                    })), m;
                }
                return c;
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.V
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$dD = $e68ba20b3d2d159d$var$U({
    name: "toggleCanvasMenu",
    label: "buttons.menu",
    trackEvent: {
        category: "menu"
    },
    perform: (e, t)=>({
            appState: {
                ...t,
                openMenu: t.openMenu === "canvas" ? null : "canvas"
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ appState: e, updateData: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$hp,
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.menu"),
            onClick: t,
            selected: e.openMenu === "canvas"
        })
}), $e68ba20b3d2d159d$var$mD = $e68ba20b3d2d159d$var$U({
    name: "toggleEditMenu",
    label: "buttons.edit",
    trackEvent: {
        category: "menu"
    },
    perform: (e, t)=>({
            appState: {
                ...t,
                openMenu: t.openMenu === "shape" ? null : "shape"
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            visible: $e68ba20b3d2d159d$var$vs(t, $e68ba20b3d2d159d$export$a9f9e75229944f66(e)),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Vy,
            "aria-label": $e68ba20b3d2d159d$var$x("buttons.edit"),
            onClick: r,
            selected: t.openMenu === "shape"
        })
}), $e68ba20b3d2d159d$var$ks = $e68ba20b3d2d159d$var$U({
    name: "toggleShortcuts",
    label: "welcomeScreen.defaults.helpHint",
    icon: $e68ba20b3d2d159d$var$By,
    viewMode: !0,
    trackEvent: {
        category: "menu",
        action: "toggleHelpDialog"
    },
    perform: (e, t, r, { focusContainer: o })=>(t.openDialog?.name === "help" && o(), {
            appState: {
                ...t,
                openDialog: t.openDialog?.name === "help" ? null : {
                    name: "help"
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    keyTest: (e)=>e.key === $e68ba20b3d2d159d$var$S.QUESTION_MARK
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$jo();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$pD = (e)=>{
    if (e.length >= 2) {
        let t = e[0].groupIds;
        for (let r of t)if (e.reduce((o, n)=>o && $e68ba20b3d2d159d$var$Ga(n, r), !0)) return !0;
    }
    return !1;
}, $e68ba20b3d2d159d$var$JS = (e, t, r)=>{
    let o = r.scene.getSelectedElements({
        selectedElementIds: t.selectedElementIds,
        includeBoundTextElement: !0
    });
    return o.length >= 2 && !$e68ba20b3d2d159d$var$pD(o);
}, $e68ba20b3d2d159d$var$Jx = $e68ba20b3d2d159d$var$U({
    name: "group",
    label: "labels.group",
    icon: (e)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pf, {
            theme: e.theme
        }),
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0
        });
        if (n.length < 2) return {
            appState: t,
            elements: e,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let i = $e68ba20b3d2d159d$var$Qo(t);
        if (i.length === 1) {
            let b = i[0], v = new Set($e68ba20b3d2d159d$var$nt(e, b).map((I)=>I.id)), y = new Set(n.map((I)=>I.id));
            if (new Set([
                ...Array.from(v),
                ...Array.from(y)
            ]).size === v.size) return {
                appState: t,
                elements: e,
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
        let a = [
            ...e
        ];
        new Set(n.map((b)=>b.frameId)).size > 1 && $e68ba20b3d2d159d$var$HT(n).forEach((v, y)=>{
            $e68ba20b3d2d159d$var$Pl(v, o.scene.getNonDeletedElementsMap());
        });
        let l = $e68ba20b3d2d159d$var$Vt(), c = $e68ba20b3d2d159d$var$j(n);
        a = a.map((b)=>c.get(b.id) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(b, {
                groupIds: $e68ba20b3d2d159d$var$py(b.groupIds, l, t.editingGroupId)
            }) : b);
        let d = $e68ba20b3d2d159d$var$nt(a, l), m = d[d.length - 1], p = a.lastIndexOf(m), u = a.slice(p + 1), h = a.slice(0, p).filter((b)=>!$e68ba20b3d2d159d$var$Ga(b, l)), g = $e68ba20b3d2d159d$var$tr([
            ...h,
            ...d,
            ...u
        ], $e68ba20b3d2d159d$var$j(d));
        return {
            appState: {
                ...t,
                ...$e68ba20b3d2d159d$var$mf(l, {
                    ...t,
                    selectedGroupIds: {}
                }, $e68ba20b3d2d159d$export$a9f9e75229944f66(a))
            },
            elements: g,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    predicate: (e, t, r, o)=>$e68ba20b3d2d159d$var$JS(e, t, o),
    keyTest: (e)=>!e.shiftKey && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.G,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$JS(e, t, o),
            type: "button",
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pf, {
                theme: t.theme
            }),
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.group")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+G")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.group"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$Qx = $e68ba20b3d2d159d$var$U({
    name: "ungroup",
    label: "labels.ungroup",
    icon: (e)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Lf, {
            theme: e.theme
        }),
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$Qo(t), i = $e68ba20b3d2d159d$var$j(e);
        if (n.length === 0) return {
            appState: t,
            elements: e,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let a = [
            ...e
        ], s = [];
        a = a.map((p)=>{
            $e68ba20b3d2d159d$var$Ge(p) && s.push(p.id);
            let u = $e68ba20b3d2d159d$var$uy(p.groupIds, t.selectedGroupIds);
            return u.length === p.groupIds.length ? p : $e68ba20b3d2d159d$export$5390fab1c98104d7(p, {
                groupIds: u
            });
        });
        let l = $e68ba20b3d2d159d$var$mr(t, $e68ba20b3d2d159d$export$a9f9e75229944f66(a), t, null), c = o.scene.getSelectedElements(t), d = new Set(c.filter((p)=>p.frameId).map((p)=>p.frameId));
        return $e68ba20b3d2d159d$var$wd(e).filter((p)=>d.has(p.id)).forEach((p)=>{
            p && (a = $e68ba20b3d2d159d$var$Nu(a, $e68ba20b3d2d159d$var$kl(a, p, t, i), p, o));
        }), l.selectedElementIds = Object.entries(l.selectedElementIds).reduce((p, [u, h])=>(h && !s.includes(u) && (p[u] = !0), p), {}), {
            appState: {
                ...t,
                ...l
            },
            elements: a,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e)=>e.shiftKey && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.G.toUpperCase(),
    predicate: (e, t)=>$e68ba20b3d2d159d$var$Qo(t).length > 0,
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            hidden: $e68ba20b3d2d159d$var$Qo(t).length === 0,
            icon: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Lf, {
                theme: t.theme
            }),
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.ungroup")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+G")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.ungroup"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Ah = (e, t, r, o, n, i, a)=>{
    e.beginPath(), e.moveTo(t + i, r), e.lineTo(t + o - i, r), e.quadraticCurveTo(t + o, r, t + o, r + i), e.lineTo(t + o, r + n - i), e.quadraticCurveTo(t + o, r + n, t + o - i, r + n), e.lineTo(t + i, r + n), e.quadraticCurveTo(t, r + n, t, r + n - i), e.lineTo(t, r + i), e.quadraticCurveTo(t, r, t + i, r), e.closePath(), e.fill(), a && (e.strokeStyle = a), e.stroke();
};
$e68ba20b3d2d159d$var$f();
function $e68ba20b3d2d159d$var$uD(e) {
    let t = 0;
    if (e.length === 0) return t;
    for(let r = 0; r < e.length; r++){
        let o = e.charCodeAt(r);
        t = (t << 5) - t + o;
    }
    return t;
}
var $e68ba20b3d2d159d$var$Ps = (e, t)=>`hsl(${Math.abs($e68ba20b3d2d159d$var$uD(t?.id || e)) % 37 * 10}, 100%, 83%)`, $e68ba20b3d2d159d$var$QS = (e)=>{
    let t = e?.trim()?.codePointAt(0);
    return (t ? String.fromCodePoint(t) : "?").toUpperCase();
}, $e68ba20b3d2d159d$var$eI = ({ context: e, renderConfig: t, appState: r, normalizedWidth: o, normalizedHeight: n })=>{
    for (let [i, a] of t.remotePointerViewportCoords){
        let { x: s, y: l } = a, c = r.collaborators.get(i);
        s -= r.offsetLeft, l -= r.offsetTop;
        let d = 11, m = 14, p = s < 0 || s > o - d || l < 0 || l > n - m;
        s = Math.max(s, 0), s = Math.min(s, o - d), l = Math.max(l, 0), l = Math.min(l, n - m);
        let u = $e68ba20b3d2d159d$var$Ps(i, c);
        e.save(), e.strokeStyle = u, e.fillStyle = u;
        let h = t.remotePointerUserStates.get(i), g = p || h === "idle" || h === "away";
        g && (e.globalAlpha = .3), t.remotePointerButton.get(i) === "down" && (e.beginPath(), e.arc(s, l, 15, 0, 2 * Math.PI, !1), e.lineWidth = 3, e.strokeStyle = "#ffffff88", e.stroke(), e.closePath(), e.beginPath(), e.arc(s, l, 15, 0, 2 * Math.PI, !1), e.lineWidth = 1, e.strokeStyle = u, e.stroke(), e.closePath());
        let b = r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? "#2f6330" : $e68ba20b3d2d159d$var$y0, v = c?.isSpeaking;
        v && (e.fillStyle = b, e.strokeStyle = b, e.lineWidth = 10, e.lineJoin = "round", e.beginPath(), e.moveTo(s, l), e.lineTo(s + 0, l + 14), e.lineTo(s + 4, l + 9), e.lineTo(s + 11, l + 8), e.closePath(), e.stroke(), e.fill()), e.fillStyle = $e68ba20b3d2d159d$var$Ic, e.strokeStyle = $e68ba20b3d2d159d$var$Ic, e.lineWidth = 6, e.lineJoin = "round", e.beginPath(), e.moveTo(s, l), e.lineTo(s + 0, l + 14), e.lineTo(s + 4, l + 9), e.lineTo(s + 11, l + 8), e.closePath(), e.stroke(), e.fill(), e.fillStyle = u, e.strokeStyle = u, e.lineWidth = 2, e.lineJoin = "round", e.beginPath(), g ? (e.moveTo(s - 1, l - 1), e.lineTo(s - 1, l + 15), e.lineTo(s + 5, l + 10), e.lineTo(s + 12, l + 9), e.closePath(), e.fill()) : (e.moveTo(s, l), e.lineTo(s + 0, l + 14), e.lineTo(s + 4, l + 9), e.lineTo(s + 11, l + 8), e.closePath(), e.fill(), e.stroke());
        let y = t.remotePointerUsernames.get(i) || "";
        if (!p && y) {
            e.font = "600 12px sans-serif";
            let w = (v ? s + 0 : s) + d / 2, I = (v ? l + 0 : l) + m + 2, M = 5, C = 3, P = e.measureText(y), k = P.actualBoundingBoxDescent + P.actualBoundingBoxAscent, _ = Math.max(k, 12), A = w - 1, R = I - 1, B = P.width + 2 + M * 2 + 2, V = _ + 2 + C * 2 + 2;
            if (e.roundRect ? (e.beginPath(), e.roundRect(A, R, B, V, 8), e.fillStyle = u, e.fill(), e.strokeStyle = $e68ba20b3d2d159d$var$Ic, e.stroke(), v && (e.beginPath(), e.roundRect(A - 2, R - 2, B + 4, V + 4, 8), e.strokeStyle = b, e.stroke())) : $e68ba20b3d2d159d$var$Ah(e, A, R, B, V, 8, $e68ba20b3d2d159d$var$Ic), e.fillStyle = $e68ba20b3d2d159d$var$b0, e.fillText(y, w + M + 1, I + C + P.actualBoundingBoxAscent + Math.floor((_ - k) / 2) + 2), v) {
                e.fillStyle = b;
                let ee = 8, N = 8, H = 5;
                e.fillRect(A + B + N, R + (V / 2 - ee / 2), 2, ee), e.fillRect(A + B + N + H, R + (V / 2 - ee * 2 / 2), 2, ee * 2), e.fillRect(A + B + N + H * 2, R + (V / 2 - ee / 2), 2, ee);
            }
        }
        e.restore(), e.closePath();
    }
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$eb = ({ color: e, onClick: t, name: r, src: o, className: n })=>{
    let i = $e68ba20b3d2d159d$var$QS(r), [a, s] = (0, $acw62.useState)(!1), l = !a && o, c = l ? void 0 : {
        background: e
    };
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Avatar", n),
        style: c,
        onClick: t,
        children: l ? (0, $7b02d682eb115277$exports.jsx)("img", {
            className: "Avatar-img",
            src: o,
            alt: i,
            referrerPolicy: "no-referrer",
            onError: ()=>s(!0)
        }) : i
    });
};
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$ED = $e68ba20b3d2d159d$var$U({
    name: "goToCollaborator",
    label: "Go to a collaborator",
    viewMode: !0,
    trackEvent: {
        category: "collab"
    },
    perform: (e, t, r)=>!r.socketId || t.userToFollow?.socketId === r.socketId || r.isCurrentUser ? {
            appState: {
                ...t,
                userToFollow: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        } : {
            appState: {
                ...t,
                userToFollow: {
                    socketId: r.socketId,
                    username: r.username || ""
                },
                openMenu: t.openMenu === "canvas" ? null : t.openMenu
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        },
    PanelComponent: ({ updateData: e, data: t, appState: r })=>{
        let { socketId: o, collaborator: n, withName: i, isBeingFollowed: a } = t, s = $e68ba20b3d2d159d$var$Ps(o, n), l = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            "is-followed": a,
            "is-current-user": n.isCurrentUser === !0,
            "is-speaking": n.isSpeaking,
            "is-in-call": n.isInCall,
            "is-muted": n.isMuted
        }), c = n.isInCall ? n.isSpeaking ? (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "UserList__collaborator-status-icon-speaking-indicator",
            title: $e68ba20b3d2d159d$var$x("userList.hint.isSpeaking"),
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {}),
                (0, $7b02d682eb115277$exports.jsx)("div", {}),
                (0, $7b02d682eb115277$exports.jsx)("div", {})
            ]
        }) : n.isMuted ? (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "UserList__collaborator-status-icon-microphone-muted",
            title: $e68ba20b3d2d159d$var$x("userList.hint.micMuted"),
            children: $e68ba20b3d2d159d$var$Vw
        }) : (0, $7b02d682eb115277$exports.jsx)("div", {
            title: $e68ba20b3d2d159d$var$x("userList.hint.inCall"),
            children: $e68ba20b3d2d159d$var$Ww
        }) : null;
        return i ? (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `dropdown-menu-item dropdown-menu-item-base UserList__collaborator ${l}`,
            style: {
                "--avatar-size": "1.5rem"
            },
            onClick: ()=>e(n),
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$eb, {
                    color: s,
                    onClick: ()=>{},
                    name: n.username || "",
                    src: n.avatarUrl,
                    className: l
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "UserList__collaborator-name",
                    children: n.username
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "UserList__collaborator-status-icons",
                    "aria-hidden": !0,
                    children: [
                        a && (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "UserList__collaborator-status-icon-is-followed",
                            title: $e68ba20b3d2d159d$var$x("userList.hint.followStatus"),
                            children: $e68ba20b3d2d159d$var$tl
                        }),
                        c
                    ]
                })
            ]
        }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: `UserList__collaborator UserList__collaborator--avatar-only ${l}`,
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$eb, {
                    color: s,
                    onClick: ()=>{
                        e(n);
                    },
                    name: n.username || "",
                    src: n.avatarUrl,
                    className: l
                }),
                c && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "UserList__collaborator-status-icon",
                    children: c
                })
            ]
        });
    }
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$jo();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$tb = $e68ba20b3d2d159d$var$U({
    name: "addToLibrary",
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0,
            includeElementsInFrames: !0
        });
        for (let i of $e68ba20b3d2d159d$var$Gm)if (n.some((a)=>a.type === i)) return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
            appState: {
                ...t,
                errorMessage: $e68ba20b3d2d159d$var$x(`errors.libraryElementTypeError.${i}`)
            }
        };
        return o.library.getLatestLibrary().then((i)=>o.library.setLibrary([
                {
                    id: $e68ba20b3d2d159d$var$Vt(),
                    status: "unpublished",
                    elements: n.map($e68ba20b3d2d159d$var$hn),
                    created: Date.now()
                },
                ...i
            ])).then(()=>({
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    toast: {
                        message: $e68ba20b3d2d159d$var$x("toast.addedToLibrary")
                    }
                }
            })).catch((i)=>({
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    errorMessage: i.message
                }
            }));
    },
    label: "labels.addToLibrary"
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$Yt();
var $e68ba20b3d2d159d$var$rI = (e, t, r)=>{
    let o = $e68ba20b3d2d159d$var$Wa(e, t), n = $e68ba20b3d2d159d$var$oo(e);
    return o.flatMap((i)=>{
        let a = $e68ba20b3d2d159d$var$xD(i, n, r);
        return i.map((s)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(s, {
                x: s.x + a.x,
                y: s.y + a.y
            }));
    });
}, $e68ba20b3d2d159d$var$xD = (e, t, { axis: r, position: o })=>{
    let n = $e68ba20b3d2d159d$var$oo(e), [i, a] = r === "x" ? [
        "minX",
        "maxX"
    ] : [
        "minY",
        "maxY"
    ], s = {
        x: 0,
        y: 0
    };
    return o === "start" ? {
        ...s,
        [r]: t[i] - n[i]
    } : o === "end" ? {
        ...s,
        [r]: t[a] - n[a]
    } : {
        ...s,
        [r]: (t[i] + t[a]) / 2 - (n[i] + n[a]) / 2
    };
};
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$Ho = (e, t, r, o)=>{
    let n = o.scene.getSelectedElements(t);
    return n.length > 1 && !n.some((i)=>$e68ba20b3d2d159d$var$re(i));
}, $e68ba20b3d2d159d$var$Jl = (e, t, r, o)=>{
    let n = r.scene.getSelectedElements(t), i = $e68ba20b3d2d159d$var$j(e), a = $e68ba20b3d2d159d$var$rI(n, i, o), s = $e68ba20b3d2d159d$var$j(a);
    return $e68ba20b3d2d159d$var$Wn(e.map((l)=>s.get(l.id) || l), t, r);
}, $e68ba20b3d2d159d$var$bD = $e68ba20b3d2d159d$var$U({
    name: "alignTop",
    label: "labels.alignTop",
    icon: $e68ba20b3d2d159d$var$Sf,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "start",
                axis: "y"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.key === $e68ba20b3d2d159d$var$S.ARROW_UP,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Sf,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.alignTop")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Up")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.alignTop"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$yD = $e68ba20b3d2d159d$var$U({
    name: "alignBottom",
    label: "labels.alignBottom",
    icon: $e68ba20b3d2d159d$var$If,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "end",
                axis: "y"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.key === $e68ba20b3d2d159d$var$S.ARROW_DOWN,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$If,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.alignBottom")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Down")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.alignBottom"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$wD = $e68ba20b3d2d159d$var$U({
    name: "alignLeft",
    label: "labels.alignLeft",
    icon: $e68ba20b3d2d159d$var$Cf,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "start",
                axis: "x"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.key === $e68ba20b3d2d159d$var$S.ARROW_LEFT,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Cf,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.alignLeft")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Left")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.alignLeft"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$vD = $e68ba20b3d2d159d$var$U({
    name: "alignRight",
    label: "labels.alignRight",
    icon: $e68ba20b3d2d159d$var$Af,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "end",
                axis: "x"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && e.key === $e68ba20b3d2d159d$var$S.ARROW_RIGHT,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Af,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.alignRight")} \u2014 ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Right")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.alignRight"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$TD = $e68ba20b3d2d159d$var$U({
    name: "alignVerticallyCentered",
    label: "labels.centerVertically",
    icon: $e68ba20b3d2d159d$var$Mf,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "center",
                axis: "y"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Mf,
            onClick: ()=>r(null),
            title: $e68ba20b3d2d159d$var$x("labels.centerVertically"),
            "aria-label": $e68ba20b3d2d159d$var$x("labels.centerVertically"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$SD = $e68ba20b3d2d159d$var$U({
    name: "alignHorizontallyCentered",
    label: "labels.centerHorizontally",
    icon: $e68ba20b3d2d159d$var$kf,
    trackEvent: {
        category: "element"
    },
    predicate: $e68ba20b3d2d159d$var$Ho,
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$Jl(e, t, o, {
                position: "center",
                axis: "x"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$Ho(e, t, null, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$kf,
            onClick: ()=>r(null),
            title: $e68ba20b3d2d159d$var$x("labels.centerHorizontally"),
            "aria-label": $e68ba20b3d2d159d$var$x("labels.centerHorizontally"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$dt();
var $e68ba20b3d2d159d$var$oI = (e, t, r)=>{
    let [o, n, i, a] = r.axis === "x" ? [
        "minX",
        "midX",
        "maxX",
        "width"
    ] : [
        "minY",
        "midY",
        "maxY",
        "height"
    ], s = $e68ba20b3d2d159d$var$oo(e), l = $e68ba20b3d2d159d$var$Wa(e, t).map((p)=>[
            p,
            $e68ba20b3d2d159d$var$oo(p)
        ]).sort((p, u)=>p[1][n] - u[1][n]), c = 0;
    for (let p of l)c += p[1][a];
    let d = (s[a] - c) / (l.length - 1);
    if (d < 0) {
        let p = l.findIndex((b)=>b[1][o] === s[o]), u = l.findIndex((b)=>b[1][i] === s[i]), h = (l[u][1][n] - l[p][1][n]) / (l.length - 1), g = l[p][1][n];
        return l.flatMap(([b, v], y)=>{
            let w = {
                x: 0,
                y: 0
            };
            return y !== p && y !== u && (g += h, w[r.axis] = g - v[n]), b.map((I)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(I, {
                    x: I.x + w.x,
                    y: I.y + w.y
                }));
        });
    }
    let m = s[o];
    return l.flatMap(([p, u])=>{
        let h = {
            x: 0,
            y: 0
        };
        return h[r.axis] = m - u[o], m += d, m += u[a], p.map((g)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(g, {
                x: g.x + h.x,
                y: g.y + h.y
            }));
    });
};
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$nI = (e, t)=>{
    let r = t.scene.getSelectedElements(e);
    return r.length > 1 && !r.some((o)=>$e68ba20b3d2d159d$var$re(o));
}, $e68ba20b3d2d159d$var$iI = (e, t, r, o)=>{
    let n = r.scene.getSelectedElements(t), i = $e68ba20b3d2d159d$var$oI(n, r.scene.getNonDeletedElementsMap(), o), a = $e68ba20b3d2d159d$var$j(i);
    return $e68ba20b3d2d159d$var$Wn(e.map((s)=>a.get(s.id) || s), t, r);
}, $e68ba20b3d2d159d$var$ID = $e68ba20b3d2d159d$var$U({
    name: "distributeHorizontally",
    label: "labels.distributeHorizontally",
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$iI(e, t, o, {
                space: "between",
                axis: "x"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.H,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$nI(t, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$qy,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.distributeHorizontally")} \u2014 ${$e68ba20b3d2d159d$var$O("Alt+H")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.distributeHorizontally"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
}), $e68ba20b3d2d159d$var$CD = $e68ba20b3d2d159d$var$U({
    name: "distributeVertically",
    label: "labels.distributeVertically",
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>({
            appState: t,
            elements: $e68ba20b3d2d159d$var$iI(e, t, o, {
                space: "between",
                axis: "y"
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.V,
    PanelComponent: ({ elements: e, appState: t, updateData: r, app: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            hidden: !$e68ba20b3d2d159d$var$nI(t, o),
            type: "button",
            icon: $e68ba20b3d2d159d$var$Jy,
            onClick: ()=>r(null),
            title: `${$e68ba20b3d2d159d$var$x("labels.distributeVertically")} \u2014 ${$e68ba20b3d2d159d$var$O("Alt+V")}`,
            "aria-label": $e68ba20b3d2d159d$var$x("labels.distributeVertically"),
            visible: $e68ba20b3d2d159d$var$Qe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), t)
        })
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Bd();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$de();
var $e68ba20b3d2d159d$var$rb = $e68ba20b3d2d159d$var$U({
    name: "flipHorizontal",
    label: "labels.flipHorizontal",
    icon: $e68ba20b3d2d159d$var$$w,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$var$Wn($e68ba20b3d2d159d$var$sI(e, o.scene.getNonDeletedElementsMap(), t, "horizontal", o), t, o),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.H
}), $e68ba20b3d2d159d$var$ob = $e68ba20b3d2d159d$var$U({
    name: "flipVertical",
    label: "labels.flipVertical",
    icon: $e68ba20b3d2d159d$var$Kw,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>({
            elements: $e68ba20b3d2d159d$var$Wn($e68ba20b3d2d159d$var$sI(e, o.scene.getNonDeletedElementsMap(), t, "vertical", o), t, o),
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }),
    keyTest: (e)=>e.shiftKey && e.code === $e68ba20b3d2d159d$var$Ae.V && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]
}), $e68ba20b3d2d159d$var$sI = (e, t, r, o, n)=>{
    let i = $e68ba20b3d2d159d$var$pe($e68ba20b3d2d159d$export$a9f9e75229944f66(e), r, {
        includeBoundTextElement: !0,
        includeElementsInFrames: !0
    }), a = $e68ba20b3d2d159d$var$AD(i, t, r, o, n), s = $e68ba20b3d2d159d$var$j(a);
    return e.map((l)=>s.get(l.id) || l);
}, $e68ba20b3d2d159d$var$AD = (e, t, r, o, n)=>{
    let { minX: i, minY: a, maxX: s, maxY: l } = $e68ba20b3d2d159d$var$oo(e);
    return $e68ba20b3d2d159d$var$ax(t, e, t, "nw", !0, !0, o === "horizontal" ? s : i, o === "horizontal" ? a : l), $e68ba20b3d2d159d$var$ss(e.filter($e68ba20b3d2d159d$export$5df2ebb939539835), t, n.scene.getNonDeletedElements(), n.scene, $e68ba20b3d2d159d$var$zn(r), []), e;
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$ec = $e68ba20b3d2d159d$var$U({
    name: "copy",
    label: "labels.copy",
    icon: $e68ba20b3d2d159d$var$Nc,
    trackEvent: {
        category: "element"
    },
    perform: async (e, t, r, o)=>{
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0,
            includeElementsInFrames: !0
        });
        try {
            await $e68ba20b3d2d159d$var$Pu(n, o.files, r);
        } catch (i) {
            return {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    errorMessage: i.message
                }
            };
        }
        return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    keyTest: void 0
}), $e68ba20b3d2d159d$var$nb = $e68ba20b3d2d159d$var$U({
    name: "paste",
    label: "labels.paste",
    trackEvent: {
        category: "element"
    },
    perform: async (e, t, r, o)=>{
        let n;
        try {
            n = await $e68ba20b3d2d159d$var$LT();
        } catch (i) {
            return i.name === "AbortError" || i.name === "NotAllowedError" ? !1 : (console.error(`actionPaste ${i.name}: ${i.message}`), $e68ba20b3d2d159d$var$ni ? {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    errorMessage: $e68ba20b3d2d159d$var$x("hints.firefox_clipboard_write")
                }
            } : {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    errorMessage: $e68ba20b3d2d159d$var$x("errors.asyncPasteFailedOnRead")
                }
            });
        }
        try {
            o.pasteFromClipboard($e68ba20b3d2d159d$var$kT({
                types: n
            }));
        } catch (i) {
            return console.error(i), {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE,
                appState: {
                    ...t,
                    errorMessage: $e68ba20b3d2d159d$var$x("errors.asyncPasteFailedOnParse")
                }
            };
        }
        return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    keyTest: void 0
}), $e68ba20b3d2d159d$var$kh = $e68ba20b3d2d159d$var$U({
    name: "cut",
    label: "labels.cut",
    icon: $e68ba20b3d2d159d$var$Dw,
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>($e68ba20b3d2d159d$var$ec.perform(e, t, r, o), $e68ba20b3d2d159d$var$Gd.perform(e, t, null, o)),
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.X
}), $e68ba20b3d2d159d$var$Ph = $e68ba20b3d2d159d$var$U({
    name: "copyAsSvg",
    label: "labels.copyAsSvg",
    icon: $e68ba20b3d2d159d$var$Zw,
    trackEvent: {
        category: "element"
    },
    perform: async (e, t, r, o)=>{
        if (!o.canvas) return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let { exportedElements: n, exportingFrame: i } = $e68ba20b3d2d159d$var$As(e, t, !0);
        try {
            return await $e68ba20b3d2d159d$var$Ms("clipboard-svg", n, t, o.files, {
                ...t,
                exportingFrame: i,
                name: o.getName()
            }), {
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        } catch (a) {
            return console.error(a), {
                appState: {
                    ...t,
                    errorMessage: a.message
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    },
    predicate: (e)=>$e68ba20b3d2d159d$var$ku && e.length > 0,
    keywords: [
        "svg",
        "clipboard",
        "copy"
    ]
}), $e68ba20b3d2d159d$var$Lh = $e68ba20b3d2d159d$var$U({
    name: "copyAsPng",
    label: "labels.copyAsPng",
    icon: $e68ba20b3d2d159d$var$jw,
    trackEvent: {
        category: "element"
    },
    perform: async (e, t, r, o)=>{
        if (!o.canvas) return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0,
            includeElementsInFrames: !0
        }), { exportedElements: i, exportingFrame: a } = $e68ba20b3d2d159d$var$As(e, t, !0);
        try {
            return await $e68ba20b3d2d159d$var$Ms("clipboard", i, t, o.files, {
                ...t,
                exportingFrame: a,
                name: o.getName()
            }), {
                appState: {
                    ...t,
                    toast: {
                        message: $e68ba20b3d2d159d$var$x("toast.copyToClipboardAsPng", {
                            exportSelection: n.length ? $e68ba20b3d2d159d$var$x("toast.selection") : $e68ba20b3d2d159d$var$x("toast.canvas"),
                            exportColorScheme: t.exportWithDarkMode ? $e68ba20b3d2d159d$var$x("buttons.darkMode") : $e68ba20b3d2d159d$var$x("buttons.lightMode")
                        })
                    }
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        } catch (s) {
            return console.error(s), {
                appState: {
                    ...t,
                    errorMessage: s.message
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
            };
        }
    },
    predicate: (e)=>$e68ba20b3d2d159d$var$Cl && e.length > 0,
    keyTest: (e)=>e.code === $e68ba20b3d2d159d$var$Ae.C && e.altKey && e.shiftKey,
    keywords: [
        "png",
        "clipboard",
        "copy"
    ]
}), $e68ba20b3d2d159d$var$Dh = $e68ba20b3d2d159d$var$U({
    name: "copyText",
    label: "labels.copyText",
    trackEvent: {
        category: "element"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0
        });
        try {
            $e68ba20b3d2d159d$var$vi($e68ba20b3d2d159d$export$490cca97d34091f8(n));
        } catch  {
            throw new Error($e68ba20b3d2d159d$var$x("errors.copyToSystemClipboardFailed"));
        }
        return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    predicate: (e, t, r, o)=>$e68ba20b3d2d159d$var$ku && o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0
        }).some($e68ba20b3d2d159d$var$G),
    keywords: [
        "text",
        "clipboard",
        "copy"
    ]
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$_h = $e68ba20b3d2d159d$var$U({
    name: "gridMode",
    icon: $e68ba20b3d2d159d$var$t2,
    keywords: [
        "snap"
    ],
    label: "labels.toggleGrid",
    viewMode: !0,
    trackEvent: {
        category: "canvas",
        predicate: (e)=>e.gridModeEnabled
    },
    perform (e, t) {
        return {
            appState: {
                ...t,
                gridModeEnabled: !this.checked(t),
                objectsSnapModeEnabled: !1
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    checked: (e)=>e.gridModeEnabled,
    predicate: (e, t, r)=>r.gridModeEnabled === void 0,
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.code === $e68ba20b3d2d159d$var$Ae.QUOTE
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$tc = $e68ba20b3d2d159d$var$U({
    name: "zenMode",
    label: "buttons.zenMode",
    icon: $e68ba20b3d2d159d$var$Jw,
    paletteName: "Toggle zen mode",
    viewMode: !0,
    trackEvent: {
        category: "canvas",
        predicate: (e)=>!e.zenModeEnabled
    },
    perform (e, t) {
        return {
            appState: {
                ...t,
                zenModeEnabled: !this.checked(t)
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    checked: (e)=>e.zenModeEnabled,
    predicate: (e, t, r)=>typeof r.zenModeEnabled > "u",
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.Z
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$ib = $e68ba20b3d2d159d$var$U({
    name: "objectsSnapMode",
    label: "buttons.objectsSnapMode",
    icon: $e68ba20b3d2d159d$var$qw,
    viewMode: !1,
    trackEvent: {
        category: "canvas",
        predicate: (e)=>!e.objectsSnapModeEnabled
    },
    perform (e, t) {
        return {
            appState: {
                ...t,
                objectsSnapModeEnabled: !this.checked(t),
                gridModeEnabled: !1
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    checked: (e)=>e.objectsSnapModeEnabled,
    predicate: (e, t, r)=>typeof r.objectsSnapModeEnabled > "u",
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.S
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$rc = $e68ba20b3d2d159d$var$U({
    name: "stats",
    label: "stats.fullTitle",
    icon: $e68ba20b3d2d159d$var$Xw,
    paletteName: "Toggle stats",
    viewMode: !0,
    trackEvent: {
        category: "menu"
    },
    keywords: [
        "edit",
        "attributes",
        "customize"
    ],
    perform (e, t) {
        return {
            appState: {
                ...t,
                stats: {
                    ...t.stats,
                    open: !this.checked(t)
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    checked: (e)=>e.stats.open,
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.SLASH
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$Yu();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$ab = $e68ba20b3d2d159d$var$U({
    name: "unbindText",
    label: "labels.unbindText",
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>o.scene.getSelectedElements(t).some((i)=>$e68ba20b3d2d159d$var$It(i)),
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t), i = o.scene.getNonDeletedElementsMap();
        return n.forEach((a)=>{
            let s = $e68ba20b3d2d159d$var$te(a, i);
            if (s) {
                let { width: l, height: c } = $e68ba20b3d2d159d$var$Xt(s.originalText, $e68ba20b3d2d159d$var$ke(s), s.lineHeight), d = $e68ba20b3d2d159d$var$E3(a.id);
                $e68ba20b3d2d159d$var$Vu(a.id);
                let { x: m, y: p } = $e68ba20b3d2d159d$var$Bl(a, s, i);
                $e68ba20b3d2d159d$export$55655e96a21bba2e(s, {
                    containerId: null,
                    width: l,
                    height: c,
                    text: s.originalText,
                    x: m,
                    y: p
                }), $e68ba20b3d2d159d$export$55655e96a21bba2e(a, {
                    boundElements: a.boundElements?.filter((u)=>u.id !== s.id),
                    height: d || a.height
                });
            }
        }), {
            elements: e,
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    }
}), $e68ba20b3d2d159d$var$sb = $e68ba20b3d2d159d$var$U({
    name: "bindText",
    label: "labels.bindText",
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t);
        if (n.length === 2) {
            let i = $e68ba20b3d2d159d$var$G(n[0]) || $e68ba20b3d2d159d$var$G(n[1]), a;
            if ($e68ba20b3d2d159d$var$Dn(n[0]) ? a = n[0] : $e68ba20b3d2d159d$var$Dn(n[1]) && (a = n[1]), i && a && $e68ba20b3d2d159d$var$te(a, o.scene.getNonDeletedElementsMap()) === null) return !0;
        }
        return !1;
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t), i, a;
        $e68ba20b3d2d159d$var$G(n[0]) && $e68ba20b3d2d159d$var$Dn(n[1]) ? (i = n[0], a = n[1]) : (i = n[1], a = n[0]), $e68ba20b3d2d159d$export$55655e96a21bba2e(i, {
            containerId: a.id,
            verticalAlign: $e68ba20b3d2d159d$var$Pt.MIDDLE,
            textAlign: $e68ba20b3d2d159d$var$Oi.CENTER,
            autoResize: !0
        }), $e68ba20b3d2d159d$export$55655e96a21bba2e(a, {
            boundElements: (a.boundElements || []).concat({
                type: "text",
                id: i.id
            })
        });
        let s = a.height;
        return $e68ba20b3d2d159d$var$gt(i, a, o.scene.getNonDeletedElementsMap()), $e68ba20b3d2d159d$var$fs(a.id, s), {
            elements: $e68ba20b3d2d159d$var$MD(e, a, i),
            appState: {
                ...t,
                selectedElementIds: {
                    [a.id]: !0
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    }
}), $e68ba20b3d2d159d$var$MD = (e, t, r)=>{
    let o = e.slice(), n = o.findIndex((a)=>a.id === r.id);
    o.splice(n, 1);
    let i = o.findIndex((a)=>a.id === t.id);
    return o.splice(i + 1, 0, r), $e68ba20b3d2d159d$var$tr(o, $e68ba20b3d2d159d$var$j([
        t,
        r
    ])), o;
}, $e68ba20b3d2d159d$var$kD = (e, t, r)=>{
    let o = e.slice(), n = o.findIndex((a)=>a.id === t.id);
    o.splice(n, 1);
    let i = o.findIndex((a)=>a.id === r.id);
    return o.splice(i, 0, t), $e68ba20b3d2d159d$var$tr(o, $e68ba20b3d2d159d$var$j([
        t,
        r
    ])), o;
}, $e68ba20b3d2d159d$var$lI = $e68ba20b3d2d159d$var$U({
    name: "wrapTextInContainer",
    label: "labels.createContainerFromText",
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t), i = n.every((a)=>$e68ba20b3d2d159d$var$G(a));
        return n.length > 0 && i;
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t), i = e.slice(), a = {};
        for (let s of n)if ($e68ba20b3d2d159d$var$G(s)) {
            let l = $e68ba20b3d2d159d$var$Ar({
                type: "rectangle",
                backgroundColor: t.currentItemBackgroundColor,
                boundElements: [
                    ...s.boundElements || [],
                    {
                        id: s.id,
                        type: "text"
                    }
                ],
                angle: s.angle,
                fillStyle: t.currentItemFillStyle,
                strokeColor: t.currentItemStrokeColor,
                roughness: t.currentItemRoughness,
                strokeWidth: t.currentItemStrokeWidth,
                strokeStyle: t.currentItemStrokeStyle,
                roundness: t.currentItemRoundness === "round" ? {
                    type: $e68ba20b3d2d159d$var$_n("rectangle") ? $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS : $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
                } : null,
                opacity: 100,
                locked: !1,
                x: s.x - $e68ba20b3d2d159d$var$wt,
                y: s.y - $e68ba20b3d2d159d$var$wt,
                width: $e68ba20b3d2d159d$var$Ii(s.width, "rectangle"),
                height: $e68ba20b3d2d159d$var$Ii(s.height, "rectangle"),
                groupIds: s.groupIds,
                frameId: s.frameId
            });
            if (s.boundElements?.length) {
                let c = s.boundElements.filter((m)=>m.type === "arrow").map((m)=>m.id);
                i.filter((m)=>c.includes(m.id)).forEach((m)=>{
                    let p = m.startBinding, u = m.endBinding;
                    p?.elementId === s.id && (p = {
                        ...p,
                        elementId: l.id
                    }), u?.elementId === s.id && (u = {
                        ...u,
                        elementId: l.id
                    }), (p || u) && $e68ba20b3d2d159d$export$55655e96a21bba2e(m, {
                        startBinding: p,
                        endBinding: u
                    }, !1);
                });
            }
            $e68ba20b3d2d159d$export$55655e96a21bba2e(s, {
                containerId: l.id,
                verticalAlign: $e68ba20b3d2d159d$var$Pt.MIDDLE,
                boundElements: null,
                textAlign: $e68ba20b3d2d159d$var$Oi.CENTER,
                autoResize: !0
            }, !1), $e68ba20b3d2d159d$var$gt(s, l, o.scene.getNonDeletedElementsMap()), i = $e68ba20b3d2d159d$var$kD([
                ...i,
                l
            ], l, s), a[l.id] = !0;
        }
        return {
            elements: i,
            appState: {
                ...t,
                selectedElementIds: a
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    }
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$gd();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Xc();
$e68ba20b3d2d159d$var$Va();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$yu();
var $e68ba20b3d2d159d$var$db = 320, $e68ba20b3d2d159d$var$mI = 85, $e68ba20b3d2d159d$var$lb = 5, $e68ba20b3d2d159d$var$ND = 42, $e68ba20b3d2d159d$var$OD = 500, $e68ba20b3d2d159d$var$cb = !1, $e68ba20b3d2d159d$var$Rh = new Map, $e68ba20b3d2d159d$var$pI = ({ element: e, elementsMap: t, setAppState: r, onLinkOpen: o, setToast: n, updateEmbedValidationStatus: i })=>{
    let a = $e68ba20b3d2d159d$var$Yn(), s = $e68ba20b3d2d159d$var$Xn(), l = e.link || "", [c, d] = (0, $acw62.useState)(l), m = (0, $acw62.useRef)(null), p = a.showHyperlinkPopup === "editor", u = (0, $acw62.useCallback)(()=>{
        if (!m.current) return;
        let y = $e68ba20b3d2d159d$export$fc49cccc588ff0d4(m.current.value) || null;
        if (!e.link && y && $e68ba20b3d2d159d$var$Pe("hyperlink", "create"), $e68ba20b3d2d159d$var$Rt(e)) {
            if (a.activeEmbeddable?.element === e && r({
                activeEmbeddable: null
            }), !y) {
                $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
                    link: null
                }), i(e, !1);
                return;
            }
            if (!$e68ba20b3d2d159d$var$yl(y, s.validateEmbeddable)) y && n({
                message: $e68ba20b3d2d159d$var$x("toast.unableToEmbed"),
                closable: !0
            }), e.link && $e68ba20b3d2d159d$var$Rh.set(e.id, e.link), $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
                link: y
            }), i(e, !1);
            else {
                let { width: w, height: I } = e, M = $e68ba20b3d2d159d$var$bi(y);
                M?.error instanceof URIError && n({
                    message: $e68ba20b3d2d159d$var$x("toast.unrecognizedLinkFormat"),
                    closable: !0
                });
                let C = M ? M.intrinsicSize.w / M.intrinsicSize.h : 1, P = $e68ba20b3d2d159d$var$Rh.get(e.id) !== e.link;
                $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
                    ...P ? {
                        width: M?.type === "video" ? w > I ? w : I * C : w,
                        height: M?.type === "video" && w > I ? w / C : I
                    } : {},
                    link: y
                }), i(e, !0), $e68ba20b3d2d159d$var$Rh.has(e.id) && $e68ba20b3d2d159d$var$Rh.delete(e.id);
            }
        } else $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            link: y
        });
    }, [
        e,
        n,
        s.validateEmbeddable,
        a.activeEmbeddable,
        r,
        i
    ]);
    (0, $acw62.useLayoutEffect)(()=>()=>{
            u();
        }, [
        u
    ]), (0, $acw62.useEffect)(()=>{
        let y = null, w = (I)=>{
            if (p) return;
            y && clearTimeout(y), $e68ba20b3d2d159d$var$BD(e, t, a, [
                I.clientX,
                I.clientY
            ]) && (y = window.setTimeout(()=>{
                r({
                    showHyperlinkPopup: !1
                });
            }, $e68ba20b3d2d159d$var$OD));
        };
        return window.addEventListener("pointermove", w, !1), ()=>{
            window.removeEventListener("pointermove", w, !1), y && clearTimeout(y);
        };
    }, [
        a,
        e,
        p,
        r,
        t
    ]);
    let h = (0, $acw62.useCallback)(()=>{
        $e68ba20b3d2d159d$var$Pe("hyperlink", "delete"), $e68ba20b3d2d159d$export$55655e96a21bba2e(e, {
            link: null
        }), p && (m.current.value = ""), r({
            showHyperlinkPopup: !1
        });
    }, [
        r,
        e,
        p
    ]), g = ()=>{
        $e68ba20b3d2d159d$var$Pe("hyperlink", "edit", "popup-ui"), r({
            showHyperlinkPopup: "editor"
        });
    }, { x: b, y: v } = $e68ba20b3d2d159d$var$uI(e, a, t);
    return a.contextMenu || a.selectedElementsAreBeingDragged || a.resizingElement || a.isRotating || a.openMenu || a.viewModeEnabled ? null : (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "excalidraw-hyperlinkContainer",
        style: {
            top: `${v}px`,
            left: `${b}px`,
            width: $e68ba20b3d2d159d$var$db,
            padding: $e68ba20b3d2d159d$var$lb
        },
        onClick: ()=>{
            !e.link && !p && r({
                showHyperlinkPopup: "editor"
            });
        },
        children: [
            p ? (0, $7b02d682eb115277$exports.jsx)("input", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("excalidraw-hyperlinkContainer-input"),
                placeholder: "Type or paste your link here",
                ref: m,
                value: c,
                onChange: (y)=>d(y.target.value),
                autoFocus: !0,
                onKeyDown: (y)=>{
                    y.stopPropagation(), y[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && y.key === $e68ba20b3d2d159d$var$S.K && y.preventDefault(), (y.key === $e68ba20b3d2d159d$var$S.ENTER || y.key === $e68ba20b3d2d159d$var$S.ESCAPE) && (u(), r({
                        showHyperlinkPopup: "info"
                    }));
                }
            }) : e.link ? (0, $7b02d682eb115277$exports.jsx)("a", {
                href: $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e.link || ""),
                className: "excalidraw-hyperlinkContainer-link",
                target: $e68ba20b3d2d159d$var$sp(e.link) ? "_self" : "_blank",
                onClick: (y)=>{
                    if (e.link && o) {
                        let w = $e68ba20b3d2d159d$var$jm("excalidraw-link", y.nativeEvent);
                        o({
                            ...e,
                            link: $e68ba20b3d2d159d$export$fc49cccc588ff0d4(e.link)
                        }, w), w.defaultPrevented && y.preventDefault();
                    }
                },
                rel: "noopener noreferrer",
                children: e.link
            }) : (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "excalidraw-hyperlinkContainer-link",
                children: $e68ba20b3d2d159d$var$x("labels.link.empty")
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "excalidraw-hyperlinkContainer__buttons",
                children: [
                    !p && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                        type: "button",
                        title: $e68ba20b3d2d159d$var$x("buttons.edit"),
                        "aria-label": $e68ba20b3d2d159d$var$x("buttons.edit"),
                        label: $e68ba20b3d2d159d$var$x("buttons.edit"),
                        onClick: g,
                        className: "excalidraw-hyperlinkContainer--edit",
                        icon: $e68ba20b3d2d159d$var$di
                    }),
                    l && !$e68ba20b3d2d159d$var$Rt(e) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                        type: "button",
                        title: $e68ba20b3d2d159d$var$x("buttons.remove"),
                        "aria-label": $e68ba20b3d2d159d$var$x("buttons.remove"),
                        label: $e68ba20b3d2d159d$var$x("buttons.remove"),
                        onClick: h,
                        className: "excalidraw-hyperlinkContainer--remove",
                        icon: $e68ba20b3d2d159d$var$rn
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$uI = (e, t, r)=>{
    let [o, n] = $e68ba20b3d2d159d$var$ae(e, r), { x: i, y: a } = $e68ba20b3d2d159d$export$a4a3582487786f33({
        sceneX: o + e.width / 2,
        sceneY: n
    }, t), s = i - t.offsetLeft - $e68ba20b3d2d159d$var$db / 2, l = a - t.offsetTop - $e68ba20b3d2d159d$var$mI;
    return {
        x: s,
        y: l
    };
}, $e68ba20b3d2d159d$var$mb = (e, t)=>{
    let r = $e68ba20b3d2d159d$var$pe(e, t);
    return r[0]?.link ? $e68ba20b3d2d159d$var$Rt(r[0]) ? "labels.link.editEmbed" : "labels.link.edit" : $e68ba20b3d2d159d$var$Rt(r[0]) ? "labels.link.createEmbed" : "labels.link.create";
}, $e68ba20b3d2d159d$var$Qd = null, $e68ba20b3d2d159d$var$hI = (e, t, r)=>{
    $e68ba20b3d2d159d$var$Qd && clearTimeout($e68ba20b3d2d159d$var$Qd), $e68ba20b3d2d159d$var$Qd = window.setTimeout(()=>$e68ba20b3d2d159d$var$FD(e, t, r), $e68ba20b3d2d159d$var$C0);
}, $e68ba20b3d2d159d$var$FD = (e, t, r)=>{
    if (!e.link) return;
    let o = $e68ba20b3d2d159d$var$Zl();
    o.classList.add("excalidraw-tooltip--visible"), o.style.maxWidth = "20rem", o.textContent = e.link;
    let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(e, r), [l, c, d, m] = $e68ba20b3d2d159d$var$xd([
        n,
        i,
        a,
        s
    ], e.angle, t), p = $e68ba20b3d2d159d$export$a4a3582487786f33({
        sceneX: l,
        sceneY: c
    }, t);
    $e68ba20b3d2d159d$var$Kx(o, {
        left: p.x,
        top: p.y,
        width: d,
        height: m
    }, "top"), $e68ba20b3d2d159d$var$Pe("hyperlink", "tooltip", "link-icon"), $e68ba20b3d2d159d$var$cb = !0;
}, $e68ba20b3d2d159d$var$gI = ()=>{
    $e68ba20b3d2d159d$var$Qd && clearTimeout($e68ba20b3d2d159d$var$Qd), $e68ba20b3d2d159d$var$cb && ($e68ba20b3d2d159d$var$cb = !1, $e68ba20b3d2d159d$var$Zl().classList.remove("excalidraw-tooltip--visible"));
}, $e68ba20b3d2d159d$var$BD = (e, t, r, [o, n])=>{
    let { x: i, y: a } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
        clientX: o,
        clientY: n
    }, r), s = 15 / r.zoom.value;
    if ($e68ba20b3d2d159d$var$Yc(i, a, e, t)) return !1;
    let [l, c, d] = $e68ba20b3d2d159d$var$ae(e, t);
    if (i >= l && i <= d && a >= c - $e68ba20b3d2d159d$var$mI && a <= c) return !1;
    let { x: m, y: p } = $e68ba20b3d2d159d$var$uI(e, r, t);
    return !(o >= m - s && o <= m + $e68ba20b3d2d159d$var$db + $e68ba20b3d2d159d$var$lb * 2 + s && n >= p - s && n <= p + s + $e68ba20b3d2d159d$var$lb * 2 + $e68ba20b3d2d159d$var$ND);
};
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$em = $e68ba20b3d2d159d$var$U({
    name: "hyperlink",
    label: (e, t)=>$e68ba20b3d2d159d$var$mb(e, t),
    icon: $e68ba20b3d2d159d$var$Bc,
    perform: (e, t)=>t.showHyperlinkPopup === "editor" ? !1 : {
            elements: e,
            appState: {
                ...t,
                showHyperlinkPopup: "editor",
                openMenu: null
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        },
    trackEvent: {
        category: "hyperlink",
        action: "click"
    },
    keyTest: (e)=>e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.key === $e68ba20b3d2d159d$var$S.K,
    predicate: (e, t)=>$e68ba20b3d2d159d$var$pe(e, t).length === 1,
    PanelComponent: ({ elements: e, appState: t, updateData: r })=>{
        let o = $e68ba20b3d2d159d$var$pe(e, t);
        return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$Bc,
            "aria-label": $e68ba20b3d2d159d$var$x($e68ba20b3d2d159d$var$mb(e, t)),
            title: `${$e68ba20b3d2d159d$var$Rt(e[0]) ? $e68ba20b3d2d159d$var$x("labels.link.labelEmbed") : $e68ba20b3d2d159d$var$x("labels.link.label")} - ${$e68ba20b3d2d159d$var$O("CtrlOrCmd+K")}`,
            onClick: ()=>r(null),
            selected: o.length === 1 && !!o[0].link
        });
    }
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$pb = (e)=>e.every((t)=>!t.locked), $e68ba20b3d2d159d$var$ub = $e68ba20b3d2d159d$var$U({
    name: "toggleElementLock",
    label: (e, t, r)=>{
        let o = r.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !1
        });
        return o.length === 1 && !$e68ba20b3d2d159d$var$re(o[0]) ? o[0].locked ? "labels.elementLock.unlock" : "labels.elementLock.lock" : $e68ba20b3d2d159d$var$pb(o) ? "labels.elementLock.lockAll" : "labels.elementLock.unlockAll";
    },
    icon: (e, t)=>{
        let r = $e68ba20b3d2d159d$var$pe(t, e);
        return $e68ba20b3d2d159d$var$pb(r) ? $e68ba20b3d2d159d$var$js : $e68ba20b3d2d159d$var$Ya;
    },
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t);
        return n.length > 0 && !n.some((i)=>i.locked && i.frameId);
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0,
            includeElementsInFrames: !0
        });
        if (!n.length) return !1;
        let i = $e68ba20b3d2d159d$var$pb(n), a = $e68ba20b3d2d159d$var$j(n);
        return {
            elements: e.map((s)=>a.has(s.id) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(s, {
                    locked: i
                }) : s),
            appState: {
                ...t,
                selectedLinearElement: i ? null : t.selectedLinearElement
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    keyTest: (e, t, r, o)=>e.key.toLocaleLowerCase() === $e68ba20b3d2d159d$var$S.L && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.shiftKey && o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !1
        }).length > 0
}), $e68ba20b3d2d159d$var$fI = $e68ba20b3d2d159d$var$U({
    name: "unlockAllElements",
    paletteName: "Unlock all elements",
    trackEvent: {
        category: "canvas"
    },
    viewMode: !1,
    icon: $e68ba20b3d2d159d$var$Ya,
    predicate: (e, t)=>$e68ba20b3d2d159d$var$pe(e, t).length === 0 && e.some((o)=>o.locked),
    perform: (e, t)=>{
        let r = e.filter((o)=>o.locked);
        return {
            elements: e.map((o)=>o.locked ? $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                    locked: !1
                }) : o),
            appState: {
                ...t,
                selectedElementIds: Object.fromEntries(r.map((o)=>[
                        o.id,
                        !0
                    ]))
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    label: "labels.elementLock.unlockAll"
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$EI = ()=>{
    let [e, t] = (0, $acw62.useState)(null), r = (0, $acw62.useCallback)((o)=>t(o), []);
    return [
        e,
        r
    ];
};
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$bI = (e)=>{
    let { closeOnClickOutside: t = !0 } = e, r = $e68ba20b3d2d159d$var$ch({
        className: "excalidraw-modal-container"
    }), o = (0, $acw62.useRef)(document.body.classList.contains("excalidraw-animations-disabled"));
    if (!r) return null;
    let n = (i)=>{
        i.key === $e68ba20b3d2d159d$var$S.ESCAPE && (i.nativeEvent.stopImmediatePropagation(), i.stopPropagation(), e.onCloseRequest());
    };
    return (0, $11492dca620dcaa5$exports.createPortal)((0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Modal", e.className, {
            "animations-disabled": o.current
        }),
        role: "dialog",
        "aria-modal": "true",
        onKeyDown: n,
        "aria-labelledby": e.labelledBy,
        "data-prevent-outside-click": !0,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Modal__background",
                onClick: t ? e.onCloseRequest : void 0
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "Modal__content",
                style: {
                    "--max-width": `${e.maxWidth}px`
                },
                tabIndex: 0,
                children: e.children
            })
        ]
    }), r);
};
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$xl();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$Gi();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$Ml();
var $e68ba20b3d2d159d$var$hb = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(new Map), $e68ba20b3d2d159d$var$yI = async (e)=>await $e68ba20b3d2d159d$export$369dce80fa4b3d47({
        elements: e,
        appState: {
            exportBackground: !1,
            viewBackgroundColor: $e68ba20b3d2d159d$var$fe.white
        },
        files: null,
        renderEmbeddables: !1
    }), $e68ba20b3d2d159d$var$wI = (e, t, r)=>{
    let [o, n] = (0, $acw62.useState)();
    return (0, $acw62.useEffect)(()=>{
        if (t) {
            if (e) {
                let i = r.get(e);
                i ? n(i) : (async ()=>{
                    let a = await $e68ba20b3d2d159d$var$yI(t);
                    a.querySelector(".style-fonts")?.remove(), a && (r.set(e, a), n(a));
                })();
            } else (async ()=>{
                let i = await $e68ba20b3d2d159d$var$yI(t);
                n(i);
            })();
        }
    }, [
        e,
        t,
        r,
        n
    ]), o;
}, $e68ba20b3d2d159d$var$Nh = ()=>{
    let [e] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$hb, $e68ba20b3d2d159d$var$$e);
    return {
        clearLibraryCache: ()=>e.clear(),
        deleteItemsFromLibraryCache: (o)=>{
            o.forEach((n)=>e.delete(n));
        },
        svgCache: e
    };
};
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$ud();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$Oh = class {
    jobs = [];
    running = !1;
    tick() {
        if (this.running) return;
        let t = this.jobs.shift();
        t ? (this.running = !0, t.promise.resolve($e68ba20b3d2d159d$var$Dc(t.jobFactory, ...t.args).finally(()=>{
            this.running = !1, this.tick();
        }))) : this.running = !1;
    }
    push(t, ...r) {
        let o = $e68ba20b3d2d159d$var$Zm();
        return this.jobs.push({
            jobFactory: t,
            promise: o,
            args: r
        }), this.tick(), o;
    }
};
$e68ba20b3d2d159d$var$ye();
var $e68ba20b3d2d159d$var$II = new $e68ba20b3d2d159d$var$kr, $e68ba20b3d2d159d$var$Ls = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)({
    status: "loaded",
    isInitialized: !1,
    libraryItems: []
}), $e68ba20b3d2d159d$var$tm = (e)=>$e68ba20b3d2d159d$var$jr(e), $e68ba20b3d2d159d$var$qD = (e, t)=>!e.find((r)=>r.elements.length !== t.elements.length ? !1 : r.elements.every((o, n)=>o.id === t.elements[n].id && o.versionNonce === t.elements[n].versionNonce)), $e68ba20b3d2d159d$export$64e3c61fac15736f = (e, t)=>{
    let r = [];
    for (let o of t)$e68ba20b3d2d159d$var$qD(e, o) && r.push(o);
    return [
        ...r,
        ...e
    ];
}, $e68ba20b3d2d159d$var$AI = (e, t)=>{
    let r = $e68ba20b3d2d159d$var$j(t), o = {
        deletedItems: new Map,
        addedItems: new Map
    };
    for (let i of e)r.has(i.id) || o.deletedItems.set(i.id, i);
    let n = $e68ba20b3d2d159d$var$j(e);
    for (let i of t)n.has(i.id) || o.addedItems.set(i.id, i);
    return o;
}, $e68ba20b3d2d159d$var$gb = class {
    currLibraryItems = [];
    prevLibraryItems = $e68ba20b3d2d159d$var$tm(this.currLibraryItems);
    app;
    constructor(t){
        this.app = t;
    }
    updateQueue = [];
    getLastUpdateTask = ()=>this.updateQueue[this.updateQueue.length - 1];
    notifyListeners = ()=>{
        if (this.updateQueue.length > 0) $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$Ls, (t)=>({
                status: "loading",
                libraryItems: this.currLibraryItems,
                isInitialized: t.isInitialized
            }));
        else {
            $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$Ls, {
                status: "loaded",
                libraryItems: this.currLibraryItems,
                isInitialized: !0
            });
            try {
                let t = this.prevLibraryItems;
                this.prevLibraryItems = $e68ba20b3d2d159d$var$tm(this.currLibraryItems);
                let r = $e68ba20b3d2d159d$var$tm(this.currLibraryItems);
                this.app.props.onLibraryChange?.(r), $e68ba20b3d2d159d$var$II.trigger($e68ba20b3d2d159d$var$AI(t, r), r);
            } catch (t) {
                console.error(t);
            }
        }
    };
    destroy = ()=>{
        this.updateQueue = [], this.currLibraryItems = [], $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$hb, new Map);
    };
    resetLibrary = ()=>this.setLibrary([]);
    getLatestLibrary = ()=>new Promise(async (t)=>{
            try {
                let r = await (this.getLastUpdateTask() || this.currLibraryItems);
                this.updateQueue.length > 0 ? t(this.getLatestLibrary()) : t($e68ba20b3d2d159d$var$tm(r));
            } catch  {
                return t(this.currLibraryItems);
            }
        });
    updateLibrary = async ({ libraryItems: t, prompt: r = !1, merge: o = !1, openLibraryMenu: n = !1, defaultStatus: i = "unpublished" })=>(n && this.app.setState({
            openSidebar: {
                name: $e68ba20b3d2d159d$var$mo.name,
                tab: $e68ba20b3d2d159d$var$Mc
            }
        }), this.setLibrary(()=>new Promise(async (a, s)=>{
                try {
                    let l = await (typeof t == "function" && !(t instanceof Blob) ? t(this.currLibraryItems) : t), c;
                    l instanceof Blob ? c = await $e68ba20b3d2d159d$export$2f1669626eca00b4(l, i) : c = $e68ba20b3d2d159d$export$f65496d0049b5d9e(l, i), !r || window.confirm($e68ba20b3d2d159d$var$x("alerts.confirmAddLibrary", {
                        numShapes: c.length
                    })) ? (r && this.app.focusContainer(), a(o ? $e68ba20b3d2d159d$export$64e3c61fac15736f(this.currLibraryItems, c) : c)) : s(new $e68ba20b3d2d159d$var$Rn);
                } catch (l) {
                    s(l);
                }
            })));
    setLibrary = (t)=>{
        let r = new Promise(async (o, n)=>{
            try {
                await this.getLastUpdateTask(), typeof t == "function" && (t = t(this.currLibraryItems)), this.currLibraryItems = $e68ba20b3d2d159d$var$tm(await t), o(this.currLibraryItems);
            } catch (i) {
                n(i);
            }
        }).catch((o)=>{
            if (o.name === "AbortError") return console.warn("Library update aborted by user"), this.currLibraryItems;
            throw o;
        }).finally(()=>{
            this.updateQueue = this.updateQueue.filter((o)=>o !== r), this.notifyListeners();
        });
        return this.updateQueue.push(r), this.notifyListeners(), r;
    };
}, $e68ba20b3d2d159d$var$MI = $e68ba20b3d2d159d$var$gb, $e68ba20b3d2d159d$var$zh = (e)=>{
    let r = Math.ceil(Math.sqrt(e.length)), o = [], n = (u)=>e.slice(u * r, u * r + r).reduce((g, b)=>{
            let { height: v } = $e68ba20b3d2d159d$var$oo(b.elements);
            return Math.max(g, v);
        }, 0), i = (u)=>{
        let h = 0, g = 0, b = 0;
        for (let v of e){
            if (h % r === 0 && (g = 0), g === u) {
                let { width: y } = $e68ba20b3d2d159d$var$oo(v.elements);
                b = Math.max(b, y);
            }
            h++, g++;
        }
        return b;
    }, a = 0, s = 0, l = 0, c = 0, d = 0, m = 0, p = 0;
    for (let u of e){
        d && d % r === 0 && (s += l + 50, a = 0, m = 0, p++), m === 0 && (l = n(p)), c = i(m);
        let { minX: h, minY: g, width: b, height: v } = $e68ba20b3d2d159d$var$oo(u.elements), y = (c - b) / 2, w = (l - v) / 2;
        o.push(...u.elements.map((I)=>({
                ...I,
                x: I.x + a + y - h,
                y: I.y + s + w - g
            }))), a += c + 50, d++, m++;
    }
    return o;
}, $e68ba20b3d2d159d$export$6a5cb08d44c786bc = ()=>{
    let e = new URLSearchParams(window.location.hash.slice(1)).get($e68ba20b3d2d159d$var$zm.addLibrary) || new URLSearchParams(window.location.search).get($e68ba20b3d2d159d$var$Bm.addLibrary), t = e ? new URLSearchParams(window.location.hash.slice(1)).get("token") : null;
    return e ? {
        libraryUrl: e,
        idToken: t
    } : null;
}, $e68ba20b3d2d159d$var$oc = class e {
    static queue = new $e68ba20b3d2d159d$var$Oh;
    static async getLibraryItems(t, r, o = !0) {
        let n = ()=>new Promise(async (i, a)=>{
                try {
                    let s = await t.load({
                        source: r
                    });
                    i($e68ba20b3d2d159d$export$f65496d0049b5d9e(s?.libraryItems || [], "published"));
                } catch (s) {
                    a(s);
                }
            });
        return o ? e.queue.push(n) : n();
    }
    static run = async (t, r)=>{
        let o = new e(t);
        return e.queue.push(()=>r(o));
    };
    adapter;
    constructor(t){
        this.adapter = t;
    }
    getLibraryItems(t) {
        return e.getLibraryItems(this.adapter, t, !1);
    }
}, $e68ba20b3d2d159d$var$rm = 0, $e68ba20b3d2d159d$var$Fh = 0, $e68ba20b3d2d159d$export$7cf5688904053497 = (e)=>$e68ba20b3d2d159d$export$9169be2e06c9c165(e.map((t)=>`${t.id}:${$e68ba20b3d2d159d$export$1859ad4f00516c7f(t.elements)}`).sort().join()), $e68ba20b3d2d159d$var$SI = async (e, t)=>{
    try {
        return $e68ba20b3d2d159d$var$Fh++, await $e68ba20b3d2d159d$var$oc.run(e, async (r)=>{
            let o = $e68ba20b3d2d159d$var$j(await r.getLibraryItems("save"));
            for (let [s] of t.deletedItems)o.delete(s);
            let n = [];
            for (let [s, l] of t.addedItems)o.has(s) ? o.set(s, l) : n.push(l);
            let i = n.concat(Array.from(o.values())), a = $e68ba20b3d2d159d$export$7cf5688904053497(i);
            return a !== $e68ba20b3d2d159d$var$rm && await e.save({
                libraryItems: i
            }), $e68ba20b3d2d159d$var$rm = a, i;
        });
    } finally{
        $e68ba20b3d2d159d$var$Fh--;
    }
}, $e68ba20b3d2d159d$export$b3a938844c56ab6a = (e)=>{
    let { excalidrawAPI: t } = e, r = (0, $acw62.useRef)(e);
    r.current = e;
    let o = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        o.current = !1;
        let n = async ({ libraryUrl: s, idToken: l })=>{
            let c = new Promise(async (m, p)=>{
                try {
                    let h = await (await fetch(decodeURIComponent(s))).blob();
                    m(h);
                } catch (u) {
                    p(u);
                }
            }), d = l !== t.id;
            await (d && document.hidden ? new Promise((m)=>{
                window.addEventListener("focus", ()=>m(), {
                    once: !0
                });
            }) : null);
            try {
                await t.updateLibrary({
                    libraryItems: c,
                    prompt: d,
                    merge: !0,
                    defaultStatus: "published",
                    openLibraryMenu: !0
                });
            } catch (m) {
                throw m;
            } finally{
                if (window.location.hash.includes($e68ba20b3d2d159d$var$zm.addLibrary)) {
                    let m = new URLSearchParams(window.location.hash.slice(1));
                    m.delete($e68ba20b3d2d159d$var$zm.addLibrary), window.history.replaceState({}, $e68ba20b3d2d159d$var$Tc, `#${m.toString()}`);
                } else if (window.location.search.includes($e68ba20b3d2d159d$var$Bm.addLibrary)) {
                    let m = new URLSearchParams(window.location.search);
                    m.delete($e68ba20b3d2d159d$var$Bm.addLibrary), window.history.replaceState({}, $e68ba20b3d2d159d$var$Tc, `?${m.toString()}`);
                }
            }
        }, i = (s)=>{
            s.preventDefault();
            let l = $e68ba20b3d2d159d$export$6a5cb08d44c786bc();
            l && (s.stopImmediatePropagation(), window.history.replaceState({}, "", s.oldURL), n(l));
        }, a = $e68ba20b3d2d159d$export$6a5cb08d44c786bc();
        if (a && n(a), "getInitialLibraryItems" in r.current && r.current.getInitialLibraryItems && (console.warn("useHandleLibrar `opts.getInitialLibraryItems` is deprecated. Use `opts.adapter` instead."), Promise.resolve(r.current.getInitialLibraryItems()).then((s)=>{
            t.updateLibrary({
                libraryItems: s,
                merge: !0
            });
        }).catch((s)=>{
            console.error(`UseHandeLibrary getInitialLibraryItems failed: ${s?.message}`);
        })), "adapter" in r.current && r.current.adapter) {
            let s = r.current.adapter, l = r.current.migrationAdapter, c = $e68ba20b3d2d159d$var$Zm();
            l ? c.resolve($e68ba20b3d2d159d$var$Dc(l.load).then(async (d)=>{
                let m = null;
                try {
                    if (!d) return $e68ba20b3d2d159d$var$oc.getLibraryItems(s, "load");
                    m = $e68ba20b3d2d159d$export$f65496d0049b5d9e(d.libraryItems || [], "published");
                    let p = await $e68ba20b3d2d159d$var$SI(s, $e68ba20b3d2d159d$var$AI([], m));
                    try {
                        await l.clear();
                    } catch (u) {
                        console.error(`couldn't delete legacy library data: ${u.message}`);
                    }
                    return p;
                } catch (p) {
                    return console.error(`couldn't migrate legacy library data: ${p.message}`), m;
                }
            }).catch((d)=>(console.error(`error during library migration: ${d.message}`), $e68ba20b3d2d159d$var$oc.getLibraryItems(s, "load")))) : c.resolve($e68ba20b3d2d159d$var$Dc($e68ba20b3d2d159d$var$oc.getLibraryItems, s, "load")), t.updateLibrary({
                libraryItems: c.then((d)=>{
                    let m = d || [];
                    return $e68ba20b3d2d159d$var$rm = $e68ba20b3d2d159d$export$7cf5688904053497(m), m;
                }),
                merge: !0
            }).finally(()=>{
                o.current = !0;
            });
        }
        return window.addEventListener("hashchange", i), ()=>{
            window.removeEventListener("hashchange", i);
        };
    }, [
        t
    ]), (0, $acw62.useEffect)(()=>{
        let n = $e68ba20b3d2d159d$var$II.on(async (a, s)=>{
            let l = o.current, c = "adapter" in r.current && r.current.adapter || null;
            try {
                c && $e68ba20b3d2d159d$var$rm !== $e68ba20b3d2d159d$export$7cf5688904053497(s) && await $e68ba20b3d2d159d$var$SI(c, a);
            } catch (d) {
                console.error(`couldn't persist library update: ${d.message}`, a), l && r.current.excalidrawAPI && r.current.excalidrawAPI.updateScene({
                    appState: {
                        errorMessage: $e68ba20b3d2d159d$var$x("errors.saveLibraryError")
                    }
                });
            }
        }), i = (a)=>{
            $e68ba20b3d2d159d$var$Fh && $e68ba20b3d2d159d$var$K0(a);
        };
        return window.addEventListener("beforeunload", i), ()=>{
            window.removeEventListener("beforeunload", i), n(), $e68ba20b3d2d159d$var$rm = 0, $e68ba20b3d2d159d$var$Fh = 0;
        };
    }, []);
};
$e68ba20b3d2d159d$var$jo();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$pi();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$QD = (0, $acw62.forwardRef)(({ children: e, gap: t, align: r, justifyContent: o, className: n, style: i }, a)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Stack Stack_horizontal", n),
        style: {
            "--gap": t,
            alignItems: r,
            justifyContent: o,
            ...i
        },
        ref: a,
        children: e
    })), $e68ba20b3d2d159d$var$e8 = (0, $acw62.forwardRef)(({ children: e, gap: t, align: r, justifyContent: o, className: n, style: i }, a)=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Stack Stack_vertical", n),
        style: {
            "--gap": t,
            justifyItems: r,
            justifyContent: o,
            ...i
        },
        ref: a,
        children: e
    })), $e68ba20b3d2d159d$var$or = {
    Row: $e68ba20b3d2d159d$var$QD,
    Col: $e68ba20b3d2d159d$var$e8
};
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$t8 = ({ theme: e, id: t, libraryReturnUrl: r })=>{
    let o = r || window.location.origin + window.location.pathname;
    return (0, $7b02d682eb115277$exports.jsx)("a", {
        className: "library-menu-browse-button",
        href: `${$e68ba20b3d2d159d$var$T.VITE_APP_LIBRARY_URL}?target=${window.name || "_blank"}&referrer=${o}&useHash=true&token=${t}&theme=${e}&version=${$e68ba20b3d2d159d$var$za.excalidrawLibrary}`,
        target: "_excalidraw_libraries",
        children: $e68ba20b3d2d159d$var$x("labels.libraries")
    });
}, $e68ba20b3d2d159d$var$DI = $e68ba20b3d2d159d$var$t8;
var $e68ba20b3d2d159d$var$Hh = ({ libraryReturnUrl: e, theme: t, id: r, style: o, children: n, className: i })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("library-menu-control-buttons", i),
        style: o,
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$DI, {
                id: r,
                libraryReturnUrl: e,
                theme: t
            }),
            n
        ]
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$a8 = /({{[\w-]+}})|(<[\w-]+>)|(<\/[\w-]+>)/g, $e68ba20b3d2d159d$var$s8 = /{{([\w-]+)}}/, $e68ba20b3d2d159d$var$l8 = /<([\w-]+)>/, $e68ba20b3d2d159d$var$c8 = /<\/([\w-]+)>/, $e68ba20b3d2d159d$var$d8 = (e, t)=>{
    let r = [
        {
            name: "",
            children: []
        }
    ];
    return e.split($e68ba20b3d2d159d$var$a8).filter(Boolean).forEach((o)=>{
        let n = o.match($e68ba20b3d2d159d$var$l8), i = o.match($e68ba20b3d2d159d$var$c8), a = o.match($e68ba20b3d2d159d$var$s8);
        if (n !== null) {
            let s = n[1];
            t.hasOwnProperty(s) ? r.push({
                name: s,
                children: []
            }) : console.warn(`Trans: missed to pass in prop ${s} for interpolating ${e}`);
        } else if (i !== null) {
            if (i[1] === r[r.length - 1].name) {
                let l = r.pop(), c = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...l.children), d = t[l.name];
                typeof d == "function" && r[r.length - 1].children.push(d(c));
            } else console.warn(`Trans: unexpected end tag ${o} for interpolating ${e}`);
        } else if (a !== null) {
            let s = a[1];
            t.hasOwnProperty(s) ? r[r.length - 1].children.push(t[s]) : console.warn(`Trans: key ${s} not in props for interpolating ${e}`);
        } else r[r.length - 1].children.push(o);
    }), r.length !== 1 && console.warn(`Trans: stack not empty for interpolating ${e}`), r[0].children;
}, $e68ba20b3d2d159d$var$m8 = ({ i18nKey: e, children: t, ...r })=>{
    let { t: o } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, ...$e68ba20b3d2d159d$var$d8(o(e), r));
}, $e68ba20b3d2d159d$var$Gr = $e68ba20b3d2d159d$var$m8;
$e68ba20b3d2d159d$var$pi();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$u8 = ({ label: e, onClick: t, className: r, children: o, actionType: n, type: i = "button", isLoading: a, ...s })=>{
    let l = n ? `Dialog__action-button--${n}` : "";
    return (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Dialog__action-button", l, r),
        type: i,
        "aria-label": e,
        onClick: t,
        ...s,
        children: [
            o && (0, $7b02d682eb115277$exports.jsx)("div", {
                style: a ? {
                    visibility: "hidden"
                } : {},
                children: o
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: a ? {
                    visibility: "hidden"
                } : {},
                children: e
            }),
            a && (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    inset: 0
                },
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
            })
        ]
    });
}, $e68ba20b3d2d159d$var$nc = $e68ba20b3d2d159d$var$u8;
var $e68ba20b3d2d159d$var$f8 = (e)=>{
    let { onConfirm: t, onCancel: r, children: o, confirmText: n = $e68ba20b3d2d159d$var$x("buttons.confirm"), cancelText: i = $e68ba20b3d2d159d$var$x("buttons.cancel"), className: a = "", ...s } = e, l = $e68ba20b3d2d159d$var$He(), c = (0, $051474e5c5a9c9ad$export$a247c952d39ea7ea)($e68ba20b3d2d159d$var$ic, $e68ba20b3d2d159d$var$$e), { container: d } = $e68ba20b3d2d159d$var$Ft();
    return (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Mt, {
        onCloseRequest: r,
        size: "small",
        ...s,
        className: `confirm-dialog ${a}`,
        children: [
            o,
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "confirm-dialog-buttons",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nc, {
                        label: i,
                        onClick: ()=>{
                            l({
                                openMenu: null
                            }), c(!1), r(), d?.focus();
                        }
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nc, {
                        label: n,
                        onClick: ()=>{
                            l({
                                openMenu: null
                            }), c(!1), t(), d?.focus();
                        },
                        actionType: "danger"
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$Wh = $e68ba20b3d2d159d$var$f8;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Ml();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$$n = class {
    static has(t) {
        try {
            return !!window.localStorage.getItem(t);
        } catch (r) {
            return console.warn(`localStorage.getItem error: ${r.message}`), !1;
        }
    }
    static get(t) {
        try {
            let r = window.localStorage.getItem(t);
            return r ? JSON.parse(r) : null;
        } catch (r) {
            return console.warn(`localStorage.getItem error: ${r.message}`), null;
        }
    }
    static set = (t, r)=>{
        try {
            return window.localStorage.setItem(t, JSON.stringify(r)), !0;
        } catch (o) {
            return console.warn(`localStorage.setItem error: ${o.message}`), !1;
        }
    };
    static delete = (t)=>{
        try {
            window.localStorage.removeItem(t);
        } catch (r) {
            console.warn(`localStorage.removeItem error: ${r.message}`);
        }
    };
};
var $e68ba20b3d2d159d$var$x8 = async (e)=>{
    let o = Math.round(8), n = Math.max(Math.round(2), 2), i = $e68ba20b3d2d159d$var$V0(e, 6), a = document.createElement("canvas");
    a.width = i[0].length * 128 + (i[0].length + 1) * (o * 2) - o * 2, a.height = i.length * 128 + (i.length + 1) * (o * 2) - o * 2;
    let s = a.getContext("2d");
    s.fillStyle = (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white, s.fillRect(0, 0, a.width, a.height);
    for (let [l, c] of e.entries()){
        let d = await $e68ba20b3d2d159d$export$7e83d8bd8a3024f4({
            elements: c.elements,
            files: null,
            maxWidthOrHeight: 128
        }), { width: m, height: p } = d, u = Math.floor(l / 6) * (128 + o * 2), h = l % 6 * (128 + o * 2);
        s.drawImage(d, h + (128 - m) / 2 + o, u + (128 - p) / 2 + o), s.lineWidth = n, s.strokeStyle = (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).gray[4], s.strokeRect(h + o / 2, u + o / 2, 128 + o, 128 + o);
    }
    return await $e68ba20b3d2d159d$var$id(new File([
        await $e68ba20b3d2d159d$var$fi(a)
    ], "preview", {
        type: $e68ba20b3d2d159d$export$edfb5d7e4280f611.png
    }), {
        outputType: $e68ba20b3d2d159d$export$edfb5d7e4280f611.jpg,
        maxWidthOrHeight: 5e3
    });
}, $e68ba20b3d2d159d$var$b8 = ({ libItem: e, appState: t, index: r, onChange: o, onRemove: n })=>{
    let i = (0, $acw62.useRef)(null), a = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        let s = i.current;
        s && (async ()=>{
            let l = await $e68ba20b3d2d159d$export$369dce80fa4b3d47({
                elements: e.elements,
                appState: {
                    ...t,
                    viewBackgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white,
                    exportBackground: !0
                },
                files: null
            });
            s.innerHTML = l.outerHTML;
        })();
    }, [
        e.elements,
        t
    ]), (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "single-library-item",
        children: [
            e.status === "published" && (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "single-library-item-status",
                children: $e68ba20b3d2d159d$var$x("labels.statusPublished")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: i,
                className: "single-library-item__svg"
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                "aria-label": $e68ba20b3d2d159d$var$x("buttons.remove"),
                type: "button",
                icon: $e68ba20b3d2d159d$var$Po,
                className: "single-library-item--remove",
                onClick: n.bind(null, e.id),
                title: $e68ba20b3d2d159d$var$x("buttons.remove")
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    margin: "0.8rem 0",
                    width: "100%",
                    fontSize: "14px",
                    fontWeight: 500,
                    flexDirection: "column"
                },
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("label", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column"
                        },
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    padding: "0.5em 0"
                                },
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontWeight: 500,
                                            color: (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).gray[6]
                                        },
                                        children: $e68ba20b3d2d159d$var$x("publishDialog.itemName")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "aria-hidden": "true",
                                        className: "required",
                                        children: "*"
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                ref: a,
                                style: {
                                    width: "80%",
                                    padding: "0.2rem"
                                },
                                defaultValue: e.name,
                                placeholder: "Item name",
                                onChange: (s)=>{
                                    o(s.target.value, r);
                                }
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "error",
                        children: e.error
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$y8 = ({ onClose: e, libraryItems: t, appState: r, onSuccess: o, onError: n, updateItemsInStorage: i, onRemove: a })=>{
    let [s, l] = (0, $acw62.useState)({
        authorName: "",
        githubHandle: "",
        name: "",
        description: "",
        twitterHandle: "",
        website: ""
    }), [c, d] = (0, $acw62.useState)(!1);
    (0, $acw62.useEffect)(()=>{
        let w = $e68ba20b3d2d159d$var$$n.get($e68ba20b3d2d159d$var$Fi.PUBLISH_LIBRARY);
        w && l(w);
    }, []);
    let [m, p] = (0, $acw62.useState)(t.slice());
    (0, $acw62.useEffect)(()=>{
        p(t.slice());
    }, [
        t
    ]);
    let u = (w)=>{
        l({
            ...s,
            [w.target.name]: w.target.value
        });
    }, h = async (w)=>{
        w.preventDefault(), d(!0);
        let I = [], M = !1;
        if (m.forEach((R)=>{
            let B = "";
            R.name || (B = $e68ba20b3d2d159d$var$x("publishDialog.errors.required"), M = !0), I.push({
                ...R,
                error: B
            });
        }), M) {
            p(I), d(!1);
            return;
        }
        let C = await $e68ba20b3d2d159d$var$x8(m), P = {
            type: $e68ba20b3d2d159d$var$Tr.excalidrawLibrary,
            version: $e68ba20b3d2d159d$var$za.excalidrawLibrary,
            source: $e68ba20b3d2d159d$var$Ac,
            libraryItems: m
        }, k = JSON.stringify(P, null, 2), _ = new Blob([
            k
        ], {
            type: "application/json"
        }), A = new FormData;
        A.append("excalidrawLib", _), A.append("previewImage", C), A.append("previewImageType", C.type), A.append("title", s.name), A.append("authorName", s.authorName), A.append("githubHandle", s.githubHandle), A.append("name", s.name), A.append("description", s.description), A.append("twitterHandle", s.twitterHandle), A.append("website", s.website), fetch(`${$e68ba20b3d2d159d$var$T.VITE_APP_LIBRARY_BACKEND}/submit`, {
            method: "post",
            body: A
        }).then((R)=>R.ok ? R.json().then(({ url: B })=>{
                $e68ba20b3d2d159d$var$$n.delete($e68ba20b3d2d159d$var$Fi.PUBLISH_LIBRARY), o({
                    url: B,
                    authorName: s.authorName,
                    items: m
                });
            }) : R.json().catch(()=>{
                throw new Error(R.statusText || "something went wrong");
            }).then((B)=>{
                throw new Error(B.message || R.statusText || "something went wrong");
            }), (R)=>{
            console.error(R), n(R), d(!1);
        }).catch((R)=>{
            console.error(R), n(R), d(!1);
        });
    }, g = ()=>{
        let w = [];
        return m.forEach((I, M)=>{
            w.push((0, $7b02d682eb115277$exports.jsx)("div", {
                className: "single-library-item-wrapper",
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$b8, {
                    libItem: I,
                    appState: r,
                    index: M,
                    onChange: (C, P)=>{
                        let k = m.slice();
                        k[P].name = C, p(k);
                    },
                    onRemove: a
                })
            }, M));
        }), (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "selected-library-items",
            children: w
        });
    }, b = (0, $acw62.useCallback)(()=>{
        i(m), $e68ba20b3d2d159d$var$$n.set($e68ba20b3d2d159d$var$Fi.PUBLISH_LIBRARY, s), e();
    }, [
        m,
        e,
        i,
        s
    ]), v = !!t.length, y = t.some((w)=>w.status === "published");
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
        onCloseRequest: b,
        title: $e68ba20b3d2d159d$var$x("publishDialog.title"),
        className: "publish-library",
        children: v ? (0, $7b02d682eb115277$exports.jsxs)("form", {
            onSubmit: h,
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "publish-library-note",
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                        i18nKey: "publishDialog.noteDescription",
                        link: (w)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://libraries.excalidraw.com",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: w
                            })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "publish-library-note",
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                        i18nKey: "publishDialog.noteGuidelines",
                        link: (w)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                                href: "https://github.com/excalidraw/excalidraw-libraries#guidelines",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: w
                            })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "publish-library-note",
                    children: $e68ba20b3d2d159d$var$x("publishDialog.noteItems")
                }),
                y && (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "publish-library-note publish-library-warning",
                    children: $e68ba20b3d2d159d$var$x("publishDialog.republishWarning")
                }),
                g(),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "publish-library__fields",
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: $e68ba20b3d2d159d$var$x("publishDialog.libraryName")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "required",
                                            children: "*"
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    name: "name",
                                    required: !0,
                                    value: s.name,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.libraryName")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            style: {
                                alignItems: "flex-start"
                            },
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: $e68ba20b3d2d159d$var$x("publishDialog.libraryDesc")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "required",
                                            children: "*"
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    name: "description",
                                    rows: 4,
                                    required: !0,
                                    value: s.description,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.libraryDesc")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: $e68ba20b3d2d159d$var$x("publishDialog.authorName")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "required",
                                            children: "*"
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    name: "authorName",
                                    required: !0,
                                    value: s.authorName,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.authorName")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: $e68ba20b3d2d159d$var$x("publishDialog.githubUsername")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    name: "githubHandle",
                                    value: s.githubHandle,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.githubHandle")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: $e68ba20b3d2d159d$var$x("publishDialog.twitterUsername")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    name: "twitterHandle",
                                    value: s.twitterHandle,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.twitterHandle")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("label", {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: $e68ba20b3d2d159d$var$x("publishDialog.website")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    name: "website",
                                    pattern: "https?://.+",
                                    title: $e68ba20b3d2d159d$var$x("publishDialog.errors.website"),
                                    value: s.website,
                                    onChange: u,
                                    placeholder: $e68ba20b3d2d159d$var$x("publishDialog.placeholder.website")
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "publish-library-note",
                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                                i18nKey: "publishDialog.noteLicense",
                                link: (w)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://github.com/excalidraw/excalidraw-libraries/blob/main/LICENSE",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: w
                                    })
                            })
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "publish-library__buttons",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nc, {
                            label: $e68ba20b3d2d159d$var$x("buttons.cancel"),
                            onClick: b,
                            "data-testid": "cancel-clear-canvas-button"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nc, {
                            type: "submit",
                            label: $e68ba20b3d2d159d$var$x("buttons.submit"),
                            actionType: "primary",
                            isLoading: c
                        })
                    ]
                })
            ]
        }) : (0, $7b02d682eb115277$exports.jsx)("p", {
            style: {
                padding: "1em",
                textAlign: "center",
                fontWeight: 500
            },
            children: $e68ba20b3d2d159d$var$x("publishDialog.atleastOneLibItem")
        })
    });
}, $e68ba20b3d2d159d$var$OI = $e68ba20b3d2d159d$var$y8;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$FI = ({ className: e = "", children: t, onToggle: r, title: o, ...n })=>{
    let i = $e68ba20b3d2d159d$export$aa949327762d0f40(), a = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(`dropdown-menu-button ${e}`, "zen-mode-transition", {
        "dropdown-menu-button--mobile": i.editor.isMobile
    }).trim();
    return (0, $7b02d682eb115277$exports.jsx)("button", {
        "data-prevent-outside-click": !0,
        className: a,
        onClick: r,
        type: "button",
        "data-testid": "dropdown-menu-button",
        title: o,
        ...n,
        children: t
    });
}, $e68ba20b3d2d159d$var$BI = $e68ba20b3d2d159d$var$FI;
$e68ba20b3d2d159d$var$FI.displayName = "DropdownMenuTrigger";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$zI = ()=>(0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: "1px",
            backgroundColor: "var(--default-border-color)",
            margin: ".5rem 0"
        }
    }), $e68ba20b3d2d159d$var$HI = $e68ba20b3d2d159d$var$zI;
$e68ba20b3d2d159d$var$zI.displayName = "DropdownMenuSeparator";
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$UI = ({ children: e, onClickOutside: t, className: r = "", onSelect: o, style: n })=>{
    let i = $e68ba20b3d2d159d$export$aa949327762d0f40(), a = (0, $acw62.useRef)(null), s = $e68ba20b3d2d159d$var$Xl({
        onClickOutside: t
    });
    $e68ba20b3d2d159d$var$Yl(a, ()=>{
        s.onClickOutside?.();
    }), (0, $acw62.useEffect)(()=>{
        let c = (m)=>{
            m.key === $e68ba20b3d2d159d$var$S.ESCAPE && (m.stopImmediatePropagation(), s.onClickOutside?.());
        }, d = {
            capture: !0
        };
        return document.addEventListener("keydown", c, d), ()=>{
            document.removeEventListener("keydown", c, d);
        };
    }, [
        s
    ]);
    let l = (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)(`dropdown-menu ${r}`, {
        "dropdown-menu--mobile": i.editor.isMobile
    }).trim();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Fx.Provider, {
        value: {
            onSelect: o
        },
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: a,
            className: l,
            style: n,
            "data-testid": "dropdown-menu",
            children: i.editor.isMobile ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Col, {
                className: "dropdown-menu-container",
                children: e
            }) : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kt, {
                className: "dropdown-menu-container",
                padding: 2,
                style: {
                    zIndex: 2
                },
                children: e
            })
        })
    });
};
$e68ba20b3d2d159d$var$UI.displayName = "DropdownMenuContent";
var $e68ba20b3d2d159d$var$GI = $e68ba20b3d2d159d$var$UI;
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$VI = ({ icon: e, shortcut: t, href: r, children: o, onSelect: n, className: i = "", selected: a, rel: s = "noreferrer", ...l })=>{
    let c = $e68ba20b3d2d159d$var$Eh(l.onClick, n);
    return (0, $7b02d682eb115277$exports.jsx)("a", {
        ...l,
        href: r,
        target: "_blank",
        rel: "noreferrer",
        className: $e68ba20b3d2d159d$var$fh(i, a),
        title: l.title ?? l["aria-label"],
        onClick: c,
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$xh, {
            icon: e,
            shortcut: t,
            children: o
        })
    });
}, $e68ba20b3d2d159d$var$ac = $e68ba20b3d2d159d$var$VI;
$e68ba20b3d2d159d$var$VI.displayName = "DropdownMenuItemLink";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$A8 = ({ children: e, className: t = "", selected: r, ...o })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        ...o,
        className: `dropdown-menu-item-base dropdown-menu-item-custom ${t} ${r ? "dropdown-menu-item--selected" : ""}`.trim(),
        children: e
    }), $e68ba20b3d2d159d$var$YI = $e68ba20b3d2d159d$var$A8;
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$XI = (e)=>{
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(e).find((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(r) && typeof r.type != "string" && r?.type.displayName && r.type.displayName === "DropdownMenuTrigger");
    return t || null;
}, $e68ba20b3d2d159d$var$KI = (e)=>{
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(e).find((r)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(r) && typeof r.type != "string" && r?.type.displayName && r.type.displayName === "DropdownMenuContent");
    return t || null;
};
var $e68ba20b3d2d159d$var$Pi = ({ children: e, open: t })=>{
    let r = $e68ba20b3d2d159d$var$XI(e), o = $e68ba20b3d2d159d$var$KI(e);
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            r,
            t && o
        ]
    });
};
$e68ba20b3d2d159d$var$Pi.Trigger = $e68ba20b3d2d159d$var$BI;
$e68ba20b3d2d159d$var$Pi.Content = $e68ba20b3d2d159d$var$GI;
$e68ba20b3d2d159d$var$Pi.Item = $e68ba20b3d2d159d$var$no;
$e68ba20b3d2d159d$var$Pi.ItemLink = $e68ba20b3d2d159d$var$ac;
$e68ba20b3d2d159d$var$Pi.ItemCustom = $e68ba20b3d2d159d$var$YI;
$e68ba20b3d2d159d$var$Pi.Group = $e68ba20b3d2d159d$var$Xd;
$e68ba20b3d2d159d$var$Pi.Separator = $e68ba20b3d2d159d$var$HI;
var $e68ba20b3d2d159d$var$et = $e68ba20b3d2d159d$var$Pi;
$e68ba20b3d2d159d$var$Pi.displayName = "DropdownMenu";
var $e68ba20b3d2d159d$var$_8 = (e, t)=>e.filter((r)=>t.includes(r.id)), $e68ba20b3d2d159d$var$R8 = ({ setAppState: e, selectedItems: t, library: r, onRemoveFromLibrary: o, resetLibrary: n, onSelectItems: i, appState: a, className: s })=>{
    let [l] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$Ls, $e68ba20b3d2d159d$var$$e), [c, d] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$ic, $e68ba20b3d2d159d$var$$e), m = ()=>{
        let A = t.length ? $e68ba20b3d2d159d$var$x("alerts.removeItemsFromsLibrary", {
            count: t.length
        }) : $e68ba20b3d2d159d$var$x("alerts.resetLibrary"), R = t.length ? $e68ba20b3d2d159d$var$x("confirmDialog.removeItemsFromLib") : $e68ba20b3d2d159d$var$x("confirmDialog.resetLibrary");
        return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Wh, {
            onConfirm: ()=>{
                t.length ? o() : n(), u(!1);
            },
            onCancel: ()=>{
                u(!1);
            },
            title: R,
            children: (0, $7b02d682eb115277$exports.jsx)("p", {
                children: A
            })
        });
    }, [p, u] = (0, $acw62.useState)(!1), h = !!t.length, g = h ? l.libraryItems.filter((A)=>t.includes(A.id)) : l.libraryItems, b = h ? $e68ba20b3d2d159d$var$x("buttons.remove") : $e68ba20b3d2d159d$var$x("buttons.resetLibrary"), [v, y] = (0, $acw62.useState)(!1), [w, I] = (0, $acw62.useState)(null), M = (0, $acw62.useCallback)(()=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Mt, {
            onCloseRequest: ()=>I(null),
            title: $e68ba20b3d2d159d$var$x("publishSuccessDialog.title"),
            className: "publish-library-success",
            size: "small",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                        i18nKey: "publishSuccessDialog.content",
                        authorName: w.authorName,
                        link: (A)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                                href: w?.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: A
                            })
                    })
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                    type: "button",
                    title: $e68ba20b3d2d159d$var$x("buttons.close"),
                    "aria-label": $e68ba20b3d2d159d$var$x("buttons.close"),
                    label: $e68ba20b3d2d159d$var$x("buttons.close"),
                    onClick: ()=>I(null),
                    "data-testid": "publish-library-success-close",
                    className: "publish-library-success-close"
                })
            ]
        }), [
        I,
        w
    ]), C = (A, R)=>{
        y(!1), I({
            url: A.url,
            authorName: A.authorName
        });
        let B = R.slice();
        B.forEach((V)=>{
            t.includes(V.id) && (V.status = "published");
        }), r.setLibrary(B);
    }, P = async ()=>{
        try {
            await r.updateLibrary({
                libraryItems: $e68ba20b3d2d159d$var$rl({
                    description: "Excalidraw library files"
                }),
                merge: !0,
                openLibraryMenu: !0
            });
        } catch (A) {
            if (A?.name === "AbortError") {
                console.warn(A);
                return;
            }
            e({
                errorMessage: $e68ba20b3d2d159d$var$x("errors.importLibraryError")
            });
        }
    }, k = async ()=>{
        let A = h ? g : await r.getLatestLibrary();
        $e68ba20b3d2d159d$var$d2(A).catch($e68ba20b3d2d159d$var$$m).catch((R)=>{
            e({
                errorMessage: R.message
            });
        });
    }, _ = ()=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et, {
            open: c,
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Trigger, {
                    onToggle: ()=>d(!c),
                    children: $e68ba20b3d2d159d$var$vy
                }),
                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Content, {
                    onClickOutside: ()=>d(!1),
                    onSelect: ()=>d(!1),
                    className: "library-menu",
                    children: [
                        !h && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                            onSelect: P,
                            icon: $e68ba20b3d2d159d$var$Js,
                            "data-testid": "lib-dropdown--load",
                            children: $e68ba20b3d2d159d$var$x("buttons.load")
                        }),
                        !!g.length && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                            onSelect: k,
                            icon: $e68ba20b3d2d159d$var$Xa,
                            "data-testid": "lib-dropdown--export",
                            children: $e68ba20b3d2d159d$var$x("buttons.export")
                        }),
                        !!g.length && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                            onSelect: ()=>u(!0),
                            icon: $e68ba20b3d2d159d$var$rn,
                            children: b
                        }),
                        h && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                            icon: $e68ba20b3d2d159d$var$Lw,
                            onSelect: ()=>y(!0),
                            "data-testid": "lib-dropdown--remove",
                            children: $e68ba20b3d2d159d$var$x("buttons.publishLibrary")
                        })
                    ]
                })
            ]
        });
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("library-menu-dropdown-container", s),
        children: [
            _(),
            t.length > 0 && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "library-actions-counter",
                children: t.length
            }),
            p && m(),
            v && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$OI, {
                onClose: ()=>y(!1),
                libraryItems: $e68ba20b3d2d159d$var$_8(l.libraryItems, t),
                appState: a,
                onSuccess: (A)=>C(A, l.libraryItems),
                onError: (A)=>window.alert(A),
                updateItemsInStorage: ()=>r.setLibrary(l.libraryItems),
                onRemove: (A)=>i(t.filter((R)=>R !== A))
            }),
            w && M()
        ]
    });
}, $e68ba20b3d2d159d$var$wb = ({ selectedItems: e, onSelectItems: t, className: r })=>{
    let { library: o } = $e68ba20b3d2d159d$var$Bt(), { clearLibraryCache: n, deleteItemsFromLibraryCache: i } = $e68ba20b3d2d159d$var$Nh(), a = $e68ba20b3d2d159d$var$Ke(), s = $e68ba20b3d2d159d$var$He(), [l] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$Ls, $e68ba20b3d2d159d$var$$e), c = async (m)=>{
        let p = m.filter((u)=>!e.includes(u.id));
        o.setLibrary(p).catch(()=>{
            s({
                errorMessage: $e68ba20b3d2d159d$var$x("alerts.errorRemovingFromLibrary")
            });
        }), i(e), t([]);
    };
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$R8, {
        appState: a,
        setAppState: s,
        selectedItems: e,
        onSelectItems: t,
        library: o,
        onRemoveFromLibrary: ()=>c(l.libraryItems),
        resetLibrary: ()=>{
            o.resetLibrary(), n();
        },
        className: r
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$ZI = (0, $acw62.memo)(({ id: e, elements: t, isPending: r, onClick: o, selected: n, onToggle: i, onDrag: a, svgCache: s })=>{
    let l = (0, $acw62.useRef)(null), c = $e68ba20b3d2d159d$var$wI(e, t, s);
    (0, $acw62.useEffect)(()=>{
        let h = l.current;
        if (h) return c && (h.innerHTML = c.outerHTML), ()=>{
            h.innerHTML = "";
        };
    }, [
        c
    ]);
    let [d, m] = (0, $acw62.useState)(!1), p = $e68ba20b3d2d159d$export$aa949327762d0f40().editor.isMobile, u = r && (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "library-unit__adder",
        children: $e68ba20b3d2d159d$var$wy
    });
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("library-unit", {
            "library-unit__active": t,
            "library-unit--hover": t && d,
            "library-unit--selected": n,
            "library-unit--skeleton": !c
        }),
        onMouseEnter: ()=>m(!0),
        onMouseLeave: ()=>m(!1),
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("library-unit__dragger", {
                    "library-unit__pulse": !!r
                }),
                ref: l,
                draggable: !!t,
                onClick: t || r ? (h)=>{
                    e && h.shiftKey ? i(e, h) : o(e);
                } : void 0,
                onDragStart: (h)=>{
                    if (!e) {
                        h.preventDefault();
                        return;
                    }
                    m(!1), a(e, h);
                }
            }),
            u,
            e && t && (d || p || n) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jd, {
                checked: n,
                onChange: (h, g)=>i(e, g),
                className: "library-unit__checkbox"
            })
        ]
    });
}), $e68ba20b3d2d159d$var$jI = ()=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "library-unit library-unit--skeleton"
    });
$e68ba20b3d2d159d$var$f();
function $e68ba20b3d2d159d$var$G8() {
    return [
        !1,
        (0, $acw62.useCallback)((t)=>t(), [])
    ];
}
var $e68ba20b3d2d159d$var$qI = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useTransition || $e68ba20b3d2d159d$var$G8;
var $e68ba20b3d2d159d$var$vb = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "library-menu-items-container__grid",
        children: e
    }), $e68ba20b3d2d159d$var$jh = (0, $acw62.memo)(({ items: e, onItemSelectToggle: t, onItemDrag: r, isItemSelected: o, onClick: n, svgCache: i, itemsRenderedPerBatch: a })=>{
    let [, s] = $e68ba20b3d2d159d$var$qI(), [l, c] = (0, $acw62.useState)(0);
    return (0, $acw62.useEffect)(()=>{
        l < e.length && s(()=>{
            c(l + a);
        });
    }, [
        l,
        e.length,
        s,
        a
    ]), (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: e.map((d, m)=>m < l ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ZI, {
                elements: d?.elements,
                isPending: !d?.id && !!d?.elements,
                onClick: n,
                svgCache: i,
                id: d?.id,
                selected: o(d.id),
                onToggle: t,
                onDrag: r
            }, d?.id ?? m) : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jI, {}, m))
    });
});
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$q8 = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(0), $e68ba20b3d2d159d$var$JI = (e)=>{
    let [t, r] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$q8);
    return (0, $acw62.useEffect)(()=>{
        let { current: o } = e;
        if (!o) return;
        let n = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))(()=>{
            let { scrollTop: i } = o;
            r(i);
        }, 200);
        return o.addEventListener("scroll", n), ()=>{
            n.cancel(), o.removeEventListener("scroll", n);
        };
    }, [
        e,
        r
    ]), t;
};
var $e68ba20b3d2d159d$var$t7 = 17, $e68ba20b3d2d159d$var$r7 = 64;
function $e68ba20b3d2d159d$var$Tb({ isLoading: e, libraryItems: t, onAddToLibrary: r, onInsertLibraryItems: o, pendingElements: n, theme: i, id: a, libraryReturnUrl: s, onSelectItems: l, selectedItems: c }) {
    let d = (0, $acw62.useRef)(null), m = $e68ba20b3d2d159d$var$JI(d);
    (0, $acw62.useEffect)(()=>{
        m > 0 && d.current?.scrollTo(0, m);
    }, []);
    let { svgCache: p } = $e68ba20b3d2d159d$var$Nh(), u = (0, $acw62.useMemo)(()=>t.filter((A)=>A.status !== "published"), [
        t
    ]), h = (0, $acw62.useMemo)(()=>t.filter((A)=>A.status === "published"), [
        t
    ]), g = !t.length && !n.length, b = !n.length && !u.length && !h.length, [v, y] = (0, $acw62.useState)(null), w = (0, $acw62.useCallback)((A, R)=>{
        let B = !c.includes(A), V = [
            ...u,
            ...h
        ];
        if (B) {
            if (R.shiftKey && v) {
                let ee = V.findIndex((X)=>X.id === v), N = V.findIndex((X)=>X.id === A);
                if (ee === -1 || N === -1) {
                    l([
                        ...c,
                        A
                    ]);
                    return;
                }
                let H = $e68ba20b3d2d159d$var$j(c), xe = V.reduce((X, ne, ve)=>((ve >= ee && ve <= N || H.has(ne.id)) && X.push(ne.id), X), []);
                l(xe);
            } else l([
                ...c,
                A
            ]);
            y(A);
        } else y(null), l(c.filter((ee)=>ee !== A));
    }, [
        v,
        l,
        h,
        c,
        u
    ]), I = (0, $acw62.useCallback)((A)=>{
        let R;
        return c.includes(A) ? R = t.filter((B)=>c.includes(B.id)) : R = t.filter((B)=>B.id === A), R.map((B)=>({
                ...B,
                elements: $e68ba20b3d2d159d$var$du(B.elements, {
                    randomizeSeed: !0
                })
            }));
    }, [
        t,
        c
    ]), M = (0, $acw62.useCallback)((A, R)=>{
        R.dataTransfer.setData($e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib, $e68ba20b3d2d159d$export$dd44df3f856016a2(I(A)));
    }, [
        I
    ]), C = (0, $acw62.useCallback)((A)=>A ? c.includes(A) : !1, [
        c
    ]), P = (0, $acw62.useCallback)(()=>{
        r(n);
    }, [
        n,
        r
    ]), k = (0, $acw62.useCallback)((A)=>{
        A && o(I(A));
    }, [
        I,
        o
    ]), _ = p.size >= t.length ? $e68ba20b3d2d159d$var$r7 : $e68ba20b3d2d159d$var$t7;
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "library-menu-items-container",
        style: n.length || u.length || h.length ? {
            justifyContent: "flex-start"
        } : {
            borderBottom: 0
        },
        children: [
            !b && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wb, {
                selectedItems: c,
                onSelectItems: l,
                className: "library-menu-dropdown-container--in-heading"
            }),
            (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Col, {
                className: "library-menu-items-container__items",
                align: "start",
                gap: 1,
                style: {
                    flex: h.length > 0 ? 1 : "0 1 auto",
                    marginBottom: 0
                },
                ref: d,
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            !b && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "library-menu-items-container__header",
                                children: $e68ba20b3d2d159d$var$x("labels.personalLib")
                            }),
                            e && (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: "var(--container-padding-y)",
                                    right: "var(--container-padding-x)",
                                    transform: "translateY(50%)"
                                },
                                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
                            }),
                            !n.length && !u.length ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "library-menu-items__no-items",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "library-menu-items__no-items__label",
                                        children: $e68ba20b3d2d159d$var$x("library.noItems")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "library-menu-items__no-items__hint",
                                        children: h.length > 0 ? $e68ba20b3d2d159d$var$x("library.hint_emptyPrivateLibrary") : $e68ba20b3d2d159d$var$x("library.hint_emptyLibrary")
                                    })
                                ]
                            }) : (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$vb, {
                                children: [
                                    n.length > 0 && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jh, {
                                        itemsRenderedPerBatch: _,
                                        items: [
                                            {
                                                id: null,
                                                elements: n
                                            }
                                        ],
                                        onItemSelectToggle: w,
                                        onItemDrag: M,
                                        onClick: P,
                                        isItemSelected: C,
                                        svgCache: p
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jh, {
                                        itemsRenderedPerBatch: _,
                                        items: u,
                                        onItemSelectToggle: w,
                                        onItemDrag: M,
                                        onClick: k,
                                        isItemSelected: C,
                                        svgCache: p
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            (h.length > 0 || n.length > 0 || u.length > 0) && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "library-menu-items-container__header library-menu-items-container__header--excal",
                                children: $e68ba20b3d2d159d$var$x("labels.excalidrawLib")
                            }),
                            h.length > 0 ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$vb, {
                                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jh, {
                                    itemsRenderedPerBatch: _,
                                    items: h,
                                    onItemSelectToggle: w,
                                    onItemDrag: M,
                                    onClick: k,
                                    isItemSelected: C,
                                    svgCache: p
                                })
                            }) : u.length > 0 ? (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    margin: "1rem 0",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    fontSize: ".9rem"
                                },
                                children: $e68ba20b3d2d159d$var$x("library.noItems")
                            }) : null
                        ]
                    }),
                    g && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Hh, {
                        style: {
                            padding: "16px 0",
                            width: "100%"
                        },
                        id: a,
                        libraryReturnUrl: s,
                        theme: i,
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wb, {
                            selectedItems: c,
                            onSelectItems: l
                        })
                    })
                ]
            })
        ]
    });
}
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$ic = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(!1), $e68ba20b3d2d159d$var$tC = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "layer-ui__library",
        children: e
    }), $e68ba20b3d2d159d$var$a7 = ({ onInsertLibraryItems: e, pendingElements: t, onAddToLibrary: r, setAppState: o, libraryReturnUrl: n, library: i, id: a, theme: s, selectedItems: l, onSelectItems: c })=>{
    let [d] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$Ls, $e68ba20b3d2d159d$var$$e), m = (0, $acw62.useCallback)((h)=>{
        (async (b, v)=>{
            $e68ba20b3d2d159d$var$Pe("element", "addToLibrary", "ui");
            for (let w of $e68ba20b3d2d159d$var$Gm)if (b.some((I)=>I.type === w)) return o({
                errorMessage: $e68ba20b3d2d159d$var$x(`errors.libraryElementTypeError.${w}`)
            });
            let y = [
                {
                    status: "unpublished",
                    elements: b,
                    id: $e68ba20b3d2d159d$var$Vt(),
                    created: Date.now()
                },
                ...v
            ];
            r(), i.setLibrary(y).catch(()=>{
                o({
                    errorMessage: $e68ba20b3d2d159d$var$x("alerts.errorAddingToLibrary")
                });
            });
        })(h, d.libraryItems);
    }, [
        r,
        i,
        o,
        d.libraryItems
    ]), p = (0, $acw62.useMemo)(()=>d.libraryItems, [
        d
    ]);
    if (d.status === "loading" && !d.isInitialized) return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tC, {
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "layer-ui__library-message",
            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {
                        size: "2em"
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: $e68ba20b3d2d159d$var$x("labels.libraryLoadingMessage")
                    })
                ]
            })
        })
    });
    let u = d.libraryItems.length > 0 || t.length > 0;
    return (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$tC, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tb, {
                isLoading: d.status === "loading",
                libraryItems: p,
                onAddToLibrary: m,
                onInsertLibraryItems: e,
                pendingElements: t,
                id: a,
                libraryReturnUrl: n,
                theme: s,
                onSelectItems: c,
                selectedItems: l
            }),
            u && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Hh, {
                className: "library-menu-control-buttons--at-bottom",
                style: {
                    padding: "16px 12px 0 12px"
                },
                id: a,
                libraryReturnUrl: n,
                theme: s
            })
        ]
    });
}, $e68ba20b3d2d159d$var$s7 = (e, t)=>{
    let r = ()=>$e68ba20b3d2d159d$var$pe(t, e, {
            includeBoundTextElement: !0,
            includeElementsInFrames: !0
        }), o = (0, $acw62.useRef)(r()), n = (0, $acw62.useRef)(e), i = (0, $acw62.useRef)(t);
    return (!$e68ba20b3d2d159d$var$at(e.selectedElementIds, n.current.selectedElementIds) || !$e68ba20b3d2d159d$var$at(t, i.current)) && (o.current = r(), n.current = e, i.current = t), o.current;
}, $e68ba20b3d2d159d$var$nC = ()=>{
    let { library: e, id: t, onInsertElements: r } = $e68ba20b3d2d159d$var$Bt(), o = $e68ba20b3d2d159d$var$Xn(), n = $e68ba20b3d2d159d$var$Ke(), i = $e68ba20b3d2d159d$var$He(), a = $e68ba20b3d2d159d$var$ma(), [s, l] = (0, $acw62.useState)([]), c = (0, $acw62.useMemo)(()=>e, [
        e
    ]), d = $e68ba20b3d2d159d$var$s7(n, a), m = (0, $acw62.useCallback)((u)=>{
        r($e68ba20b3d2d159d$var$zh(u));
    }, [
        r
    ]), p = (0, $acw62.useCallback)(()=>{
        i({
            selectedElementIds: {},
            selectedGroupIds: {},
            activeEmbeddable: null
        });
    }, [
        i
    ]);
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$a7, {
        pendingElements: d,
        onInsertLibraryItems: m,
        onAddToLibrary: p,
        setAppState: i,
        libraryReturnUrl: o.libraryReturnUrl,
        library: c,
        id: t,
        theme: n.theme,
        selectedItems: s,
        onSelectItems: l
    });
};
$e68ba20b3d2d159d$var$oe();
function $e68ba20b3d2d159d$var$p7(e) {
    if (e && typeof e == "number") return e;
    switch(e){
        case "small":
            return 550;
        case "wide":
            return 1024;
        case "regular":
        default:
            return 800;
    }
}
var $e68ba20b3d2d159d$var$Mt = (e)=>{
    let [t, r] = $e68ba20b3d2d159d$var$EI(), [o] = (0, $acw62.useState)(document.activeElement), { id: n } = $e68ba20b3d2d159d$var$Ft(), i = $e68ba20b3d2d159d$export$aa949327762d0f40().viewport.isMobile;
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        let c = $e68ba20b3d2d159d$var$Pc(t);
        setTimeout(()=>{
            c.length > 0 && e.autofocus !== !1 && (c[1] || c[0]).focus();
        });
        let d = (m)=>{
            if (m.key === $e68ba20b3d2d159d$var$S.TAB) {
                let p = $e68ba20b3d2d159d$var$Pc(t), { activeElement: u } = document, h = p.findIndex((g)=>g === u);
                h === 0 && m.shiftKey ? (p[p.length - 1].focus(), m.preventDefault()) : h === p.length - 1 && !m.shiftKey && (p[0].focus(), m.preventDefault());
            }
        };
        return t.addEventListener("keydown", d), ()=>t.removeEventListener("keydown", d);
    }, [
        t,
        e.autofocus
    ]);
    let a = $e68ba20b3d2d159d$var$He(), s = (0, $051474e5c5a9c9ad$export$a247c952d39ea7ea)($e68ba20b3d2d159d$var$ic, $e68ba20b3d2d159d$var$$e), l = ()=>{
        a({
            openMenu: null
        }), s(!1), o.focus(), e.onCloseRequest();
    };
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$bI, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Dialog", e.className, {
            "Dialog--fullscreen": i
        }),
        labelledBy: "dialog-title",
        maxWidth: $e68ba20b3d2d159d$var$p7(e.size),
        onCloseRequest: l,
        closeOnClickOutside: e.closeOnClickOutside,
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
            ref: r,
            children: [
                e.title && (0, $7b02d682eb115277$exports.jsx)("h2", {
                    id: `${n}-dialog-title`,
                    className: "Dialog__title",
                    children: (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "Dialog__titleContent",
                        children: e.title
                    })
                }),
                i && (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "Dialog__close",
                    onClick: l,
                    title: $e68ba20b3d2d159d$var$x("buttons.close"),
                    "aria-label": $e68ba20b3d2d159d$var$x("buttons.close"),
                    type: "button",
                    children: $e68ba20b3d2d159d$var$Po
                }),
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "Dialog__content",
                    children: e.children
                })
            ]
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$export$353f5b6fc5456de1 = ({ type: e = "button", onSelect: t, selected: r, children: o, className: n = "", ...i })=>(0, $7b02d682eb115277$exports.jsx)("button", {
        onClick: $e68ba20b3d2d159d$var$Ui(i.onClick, (a)=>{
            t();
        }),
        type: e,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("excalidraw-button", n, {
            selected: r
        }),
        ...i,
        children: o
    });
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$aC = (0, $acw62.forwardRef)(({ onChange: e, label: t, fullWidth: r, placeholder: o, readonly: n, selectOnRender: i, onKeyDown: a, isRedacted: s = !1, ...l }, c)=>{
    let d = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(c, ()=>d.current), (0, $acw62.useLayoutEffect)(()=>{
        i && d.current?.select();
    }, [
        i
    ]);
    let [m, p] = (0, $acw62.useState)(!1);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ExcTextField", {
            "ExcTextField--fullWidth": r
        }),
        onClick: ()=>{
            d.current?.focus();
        },
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ExcTextField__label",
                children: t
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ExcTextField__input", {
                    "ExcTextField__input--readonly": n
                }),
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                            "is-redacted": "value" in l && l.value && s && !m
                        }),
                        readOnly: n,
                        value: "value" in l ? l.value : void 0,
                        defaultValue: "defaultValue" in l ? l.defaultValue : void 0,
                        placeholder: o,
                        ref: d,
                        onChange: (u)=>e?.(u.target.value),
                        onKeyDown: a
                    }),
                    s && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$353f5b6fc5456de1, {
                        onSelect: ()=>p(!m),
                        style: {
                            border: 0,
                            userSelect: "none"
                        },
                        children: m ? $e68ba20b3d2d159d$var$zw : $e68ba20b3d2d159d$var$tl
                    })
                ]
            })
        ]
    });
});
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$w7 = {
    toggleTheme: [
        $e68ba20b3d2d159d$var$O("Shift+Alt+D")
    ],
    saveScene: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+S")
    ],
    loadScene: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+O")
    ],
    clearCanvas: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Delete")
    ],
    imageExport: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+E")
    ],
    commandPalette: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+/"),
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+P")
    ],
    cut: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+X")
    ],
    copy: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+C")
    ],
    paste: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+V")
    ],
    copyStyles: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+C")
    ],
    pasteStyles: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+V")
    ],
    selectAll: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+A")
    ],
    deleteSelectedElements: [
        $e68ba20b3d2d159d$var$O("Delete")
    ],
    duplicateSelection: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+D"),
        $e68ba20b3d2d159d$var$O(`Alt+${$e68ba20b3d2d159d$var$x("helpDialog.drag")}`)
    ],
    sendBackward: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+[")
    ],
    bringForward: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+]")
    ],
    sendToBack: [
        $e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+[") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+[")
    ],
    bringToFront: [
        $e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+]") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+]")
    ],
    copyAsPng: [
        $e68ba20b3d2d159d$var$O("Shift+Alt+C")
    ],
    copyAsSvg: [],
    group: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+G")
    ],
    ungroup: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+G")
    ],
    gridMode: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+'")
    ],
    zenMode: [
        $e68ba20b3d2d159d$var$O("Alt+Z")
    ],
    objectsSnapMode: [
        $e68ba20b3d2d159d$var$O("Alt+S")
    ],
    stats: [
        $e68ba20b3d2d159d$var$O("Alt+/")
    ],
    addToLibrary: [],
    flipHorizontal: [
        $e68ba20b3d2d159d$var$O("Shift+H")
    ],
    flipVertical: [
        $e68ba20b3d2d159d$var$O("Shift+V")
    ],
    viewMode: [
        $e68ba20b3d2d159d$var$O("Alt+R")
    ],
    hyperlink: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+K")
    ],
    toggleElementLock: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+L")
    ],
    resetZoom: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+0")
    ],
    zoomOut: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+-")
    ],
    zoomIn: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd++")
    ],
    zoomToFitSelection: [
        $e68ba20b3d2d159d$var$O("Shift+3")
    ],
    zoomToFit: [
        $e68ba20b3d2d159d$var$O("Shift+1")
    ],
    zoomToFitSelectionInViewport: [
        $e68ba20b3d2d159d$var$O("Shift+2")
    ],
    toggleEraserTool: [
        $e68ba20b3d2d159d$var$O("E")
    ],
    toggleHandTool: [
        $e68ba20b3d2d159d$var$O("H")
    ],
    setFrameAsActiveTool: [
        $e68ba20b3d2d159d$var$O("F")
    ],
    saveFileToDisk: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+S")
    ],
    saveToActiveFile: [
        $e68ba20b3d2d159d$var$O("CtrlOrCmd+S")
    ],
    toggleShortcuts: [
        $e68ba20b3d2d159d$var$O("?")
    ]
}, $e68ba20b3d2d159d$var$zt = (e, t = 0)=>{
    let r = $e68ba20b3d2d159d$var$w7[e];
    return r && r.length > 0 ? r[t] || r[0] : "";
};
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$v7 = "\\u0300-\\u036f", $e68ba20b3d2d159d$var$T7 = "\\ufe20-\\ufe2f", $e68ba20b3d2d159d$var$S7 = "\\u20d0-\\u20ff", $e68ba20b3d2d159d$var$I7 = $e68ba20b3d2d159d$var$v7 + $e68ba20b3d2d159d$var$T7 + $e68ba20b3d2d159d$var$S7, $e68ba20b3d2d159d$var$C7 = `[${$e68ba20b3d2d159d$var$I7}]`, $e68ba20b3d2d159d$var$A7 = RegExp($e68ba20b3d2d159d$var$C7, "g"), $e68ba20b3d2d159d$var$M7 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $e68ba20b3d2d159d$var$k7 = {
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "E",
    "\xe6": "e",
    "\xde": "T",
    "\xfe": "t",
    "\xdf": "s",
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "I",
    "\u0133": "i",
    "\u0152": "E",
    "\u0153": "e",
    "\u0149": "n",
    "\u017F": "s"
}, $e68ba20b3d2d159d$var$Mb = (e)=>e.replace($e68ba20b3d2d159d$var$M7, (t)=>$e68ba20b3d2d159d$var$k7[t] || t).replace($e68ba20b3d2d159d$var$A7, "");
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$ga = ({ icon: e })=>(0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            width: "1em",
            margin: "0 0.5ex 0 0.5ex",
            display: "inline-block",
            lineHeight: 0,
            verticalAlign: "middle"
        },
        children: e
    });
$e68ba20b3d2d159d$var$ul();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$ul();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Cd();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Pb = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null), $e68ba20b3d2d159d$var$pt = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($e68ba20b3d2d159d$var$Pb), $e68ba20b3d2d159d$var$sC = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            MainMenuTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            WelcomeScreenMenuHintTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            WelcomeScreenToolbarHintTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            WelcomeScreenHelpHintTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            WelcomeScreenCenterTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            FooterCenterTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            DefaultSidebarTriggerTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            DefaultSidebarTabTriggersTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            OverwriteConfirmDialogTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            TTDDialogTriggerTunnel: (0, $6d4d33fbf8eac225$export$2e2bcd8739ae039)(),
            jotaiScope: Symbol()
        }), []);
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$Db = (e, t)=>{
    let r = t[0]?.type || null;
    for (let o of t)if (o.type !== r) {
        r = null;
        break;
    }
    return $e68ba20b3d2d159d$var$Id(e.activeTool.type) && e.activeTool.type !== "image" && r !== "image" && r !== "frame" && r !== "magicframe" || t.some((o)=>$e68ba20b3d2d159d$var$Id(o.type));
}, $e68ba20b3d2d159d$var$_b = (e, t)=>$e68ba20b3d2d159d$var$Ti(e.activeTool.type) || t.some((r)=>$e68ba20b3d2d159d$var$Ti(r.type)), $e68ba20b3d2d159d$var$qh = ({ appState: e, elementsMap: t, renderAction: r })=>{
    let o = $e68ba20b3d2d159d$var$zd(t, e), n = !1;
    o.length === 2 && ($e68ba20b3d2d159d$var$It(o[0]) || $e68ba20b3d2d159d$var$It(o[1])) && (n = !0);
    let i = !!(e.editingTextElement || e.newElement), a = $e68ba20b3d2d159d$export$aa949327762d0f40(), s = document.documentElement.getAttribute("dir") === "rtl", l = $e68ba20b3d2d159d$var$Ti(e.activeTool.type) && !$e68ba20b3d2d159d$var$Rr(e.currentItemBackgroundColor) || o.some((m)=>$e68ba20b3d2d159d$var$Ti(m.type) && !$e68ba20b3d2d159d$var$Rr(m.backgroundColor)), c = o.length === 1 || n, d = !e.editingLinearElement && o.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(o[0]) && !$e68ba20b3d2d159d$var$ce(o[0]);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "panelColumn",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                children: $e68ba20b3d2d159d$var$Db(e, o) && r("changeStrokeColor")
            }),
            $e68ba20b3d2d159d$var$_b(e, o) && (0, $7b02d682eb115277$exports.jsx)("div", {
                children: r("changeBackgroundColor")
            }),
            l && r("changeFillStyle"),
            ($e68ba20b3d2d159d$var$zu(e.activeTool.type) || o.some((m)=>$e68ba20b3d2d159d$var$zu(m.type))) && r("changeStrokeWidth"),
            (e.activeTool.type === "freedraw" || o.some((m)=>m.type === "freedraw")) && r("changeStrokeShape"),
            ($e68ba20b3d2d159d$var$Hu(e.activeTool.type) || o.some((m)=>$e68ba20b3d2d159d$var$Hu(m.type))) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    r("changeStrokeStyle"),
                    r("changeSloppiness")
                ]
            }),
            ($e68ba20b3d2d159d$var$Dl(e.activeTool.type) || o.some((m)=>$e68ba20b3d2d159d$var$Dl(m.type))) && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: r("changeRoundness")
            }),
            ($e68ba20b3d2d159d$var$zE(e.activeTool.type) || o.some((m)=>$e68ba20b3d2d159d$var$zE(m.type))) && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: r("changeArrowType")
            }),
            (e.activeTool.type === "text" || o.some($e68ba20b3d2d159d$var$G)) && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    r("changeFontFamily"),
                    r("changeFontSize"),
                    (e.activeTool.type === "text" || $e68ba20b3d2d159d$var$v3(o, t)) && r("changeTextAlign")
                ]
            }),
            $e68ba20b3d2d159d$var$w3(o, t) && r("changeVerticalAlign"),
            ($e68ba20b3d2d159d$var$hs(e.activeTool.type) || o.some((m)=>$e68ba20b3d2d159d$var$hs(m.type))) && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: r("changeArrowhead")
            }),
            r("changeOpacity"),
            (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("legend", {
                        children: $e68ba20b3d2d159d$var$x("labels.layers")
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "buttonList",
                        children: [
                            r("sendToBack"),
                            r("sendBackward"),
                            r("bringForward"),
                            r("bringToFront")
                        ]
                    })
                ]
            }),
            o.length > 1 && !n && (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("legend", {
                        children: $e68ba20b3d2d159d$var$x("labels.align")
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "buttonList",
                        children: [
                            s ? (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    r("alignRight"),
                                    r("alignHorizontallyCentered"),
                                    r("alignLeft")
                                ]
                            }) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    r("alignLeft"),
                                    r("alignHorizontallyCentered"),
                                    r("alignRight")
                                ]
                            }),
                            o.length > 2 && r("distributeHorizontally"),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    flexBasis: "100%",
                                    height: 0
                                }
                            }),
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: ".5rem",
                                    marginTop: "-0.5rem"
                                },
                                children: [
                                    r("alignTop"),
                                    r("alignVerticallyCentered"),
                                    r("alignBottom"),
                                    o.length > 2 && r("distributeVertically")
                                ]
                            })
                        ]
                    })
                ]
            }),
            !i && o.length > 0 && (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("legend", {
                        children: $e68ba20b3d2d159d$var$x("labels.actions")
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "buttonList",
                        children: [
                            !a.editor.isMobile && r("duplicateSelection"),
                            !a.editor.isMobile && r("deleteSelectedElements"),
                            r("group"),
                            r("ungroup"),
                            c && r("hyperlink"),
                            d && r("toggleLinearEditor")
                        ]
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$Jh = ({ activeTool: e, appState: t, app: r, UIOptions: o })=>{
    let [n, i] = (0, $acw62.useState)(!1), a = e.type === "frame", s = e.type === "laser", l = e.type === "embeddable", { TTDDialogTriggerTunnel: c } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            $e68ba20b3d2d159d$var$Kc.map(({ value: d, icon: m, key: p, numericKey: u, fillable: h }, g)=>{
                if (o.tools?.[d] === !1) return null;
                let b = $e68ba20b3d2d159d$var$x(`toolBar.${d}`), v = p && $e68ba20b3d2d159d$var$zi(typeof p == "string" ? p : p[0]), y = v ? `${v} ${$e68ba20b3d2d159d$var$x("helpDialog.or")} ${u}` : `${u}`;
                return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Shape", {
                        fillable: h
                    }),
                    type: "radio",
                    icon: m,
                    checked: e.type === d,
                    name: "editor-current-shape",
                    title: `${$e68ba20b3d2d159d$var$zi(b)} \u2014 ${y}`,
                    keyBindingLabel: u || v,
                    "aria-label": $e68ba20b3d2d159d$var$zi(b),
                    "aria-keyshortcuts": y,
                    "data-testid": `toolbar-${d}`,
                    onPointerDown: ({ pointerType: w })=>{
                        !t.penDetected && w === "pen" && r.togglePenMode(!0);
                    },
                    onChange: ({ pointerType: w })=>{
                        t.activeTool.type !== d && $e68ba20b3d2d159d$var$Pe("toolbar", d, "ui"), d === "image" ? r.setActiveTool({
                            type: d,
                            insertOnCanvasDirectly: w !== "mouse"
                        }) : r.setActiveTool({
                            type: d
                        });
                    }
                }, d);
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "App-toolbar__divider"
            }),
            (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et, {
                open: n,
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Trigger, {
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("App-toolbar__extra-tools-trigger", {
                            "App-toolbar__extra-tools-trigger--selected": a || l || s && !r.props.isCollaborating
                        }),
                        onToggle: ()=>i(!n),
                        title: $e68ba20b3d2d159d$var$x("toolBar.extraTools"),
                        children: [
                            $e68ba20b3d2d159d$var$Fw,
                            r.props.aiEnabled !== !1 && (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: "inline-flex",
                                    marginLeft: "auto",
                                    padding: "2px 4px",
                                    borderRadius: 6,
                                    fontSize: 8,
                                    fontFamily: "Cascadia, monospace",
                                    position: "absolute",
                                    background: "var(--color-promo)",
                                    color: "var(--color-surface-lowest)",
                                    bottom: 3,
                                    right: 4
                                },
                                children: "AI"
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Content, {
                        onClickOutside: ()=>i(!1),
                        onSelect: ()=>i(!1),
                        className: "App-toolbar__extra-tools-dropdown",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                                onSelect: ()=>r.setActiveTool({
                                        type: "frame"
                                    }),
                                icon: $e68ba20b3d2d159d$var$vp,
                                shortcut: $e68ba20b3d2d159d$var$S.F.toLocaleUpperCase(),
                                "data-testid": "toolbar-frame",
                                selected: a,
                                children: $e68ba20b3d2d159d$var$x("toolBar.frame")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                                onSelect: ()=>r.setActiveTool({
                                        type: "embeddable"
                                    }),
                                icon: $e68ba20b3d2d159d$var$Fy,
                                "data-testid": "toolbar-embeddable",
                                selected: l,
                                children: $e68ba20b3d2d159d$var$x("toolBar.embeddable")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                                onSelect: ()=>r.setActiveTool({
                                        type: "laser"
                                    }),
                                icon: $e68ba20b3d2d159d$var$Sp,
                                "data-testid": "toolbar-laser",
                                selected: s,
                                shortcut: $e68ba20b3d2d159d$var$S.K.toLocaleUpperCase(),
                                children: $e68ba20b3d2d159d$var$x("toolBar.laser")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    margin: "6px 0",
                                    fontSize: 14,
                                    fontWeight: 600
                                },
                                children: "Generate"
                            }),
                            r.props.aiEnabled !== !1 && (0, $7b02d682eb115277$exports.jsx)(c.Out, {}),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item, {
                                onSelect: ()=>r.setOpenDialog({
                                        name: "ttd",
                                        tab: "mermaid"
                                    }),
                                icon: $e68ba20b3d2d159d$var$Tp,
                                "data-testid": "toolbar-embeddable",
                                children: $e68ba20b3d2d159d$var$x("toolBar.mermaidToExcalidraw")
                            }),
                            r.props.aiEnabled !== !1 && r.plugins.diagramToCode && (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Item, {
                                    onSelect: ()=>r.onMagicframeToolSelect(),
                                    icon: $e68ba20b3d2d159d$var$Ip,
                                    "data-testid": "toolbar-magicframe",
                                    children: [
                                        $e68ba20b3d2d159d$var$x("toolBar.magicframe"),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item.Badge, {
                                            children: "AI"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$lC = ({ renderAction: e, zoom: t })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Col, {
        gap: 1,
        className: $e68ba20b3d2d159d$var$Na.ZOOM_ACTIONS,
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Row, {
            align: "center",
            children: [
                e("zoomOut"),
                e("resetZoom"),
                e("zoomIn")
            ]
        })
    }), $e68ba20b3d2d159d$var$cC = ({ renderAction: e, className: t })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `undo-redo-buttons ${t}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "undo-button-container",
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
                    label: $e68ba20b3d2d159d$var$x("buttons.undo"),
                    children: e("undo")
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "redo-button-container",
                children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$yo, {
                    label: $e68ba20b3d2d159d$var$x("buttons.redo"),
                    children: [
                        " ",
                        e("redo")
                    ]
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$dC = ({ actionManager: e, showExitZenModeBtn: t })=>(0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("disable-zen-mode", {
            "disable-zen-mode--visible": t
        }),
        onClick: ()=>e.executeAction($e68ba20b3d2d159d$var$tc),
        children: $e68ba20b3d2d159d$var$x("buttons.exitZenMode")
    }), $e68ba20b3d2d159d$var$mC = ({ renderAction: e, className: t })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: `finalize-button ${t}`,
        children: e("finalize", {
            size: "small"
        })
    });
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Rb = (e)=>{
    let t = (0, $acw62.useRef)({
        userFn: e
    });
    return t.current.userFn = e, t.current.stableFn || (t.current.stableFn = (...r)=>t.current.userFn(...r)), t.current.stableFn;
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Ds = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$var$pC = ()=>{
    let [e, t] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$Ds, $e68ba20b3d2d159d$var$$e), r = $e68ba20b3d2d159d$var$$t();
    return e && e === "clearCanvas" ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Wh, {
        onConfirm: ()=>{
            r.executeAction($e68ba20b3d2d159d$var$Mi), t(null);
        },
        onCancel: ()=>t(null),
        title: $e68ba20b3d2d159d$var$x("clearCanvasDialog.title"),
        children: (0, $7b02d682eb115277$exports.jsxs)("p", {
            className: "clear-canvas__content",
            children: [
                " ",
                $e68ba20b3d2d159d$var$x("alerts.clearReset")
            ]
        })
    }) : null;
};
var $e68ba20b3d2d159d$var$Nb = {};
$e68ba20b3d2d159d$var$Zg($e68ba20b3d2d159d$var$Nb, {
    toggleTheme: ()=>$e68ba20b3d2d159d$var$F7
});
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$F7 = {
    ...$e68ba20b3d2d159d$var$Cs,
    category: "App",
    label: "Toggle theme",
    perform: ({ actionManager: e })=>{
        e.executeAction($e68ba20b3d2d159d$var$Cs, "commandPalette");
    }
};
var $e68ba20b3d2d159d$var$G7 = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$var$kt = {
    app: "App",
    export: "Export",
    tools: "Tools",
    editor: "Editor",
    elements: "Elements",
    links: "Links"
}, $e68ba20b3d2d159d$var$W7 = (e)=>{
    switch(e){
        case $e68ba20b3d2d159d$var$kt.app:
            return 1;
        case $e68ba20b3d2d159d$var$kt.export:
            return 2;
        case $e68ba20b3d2d159d$var$kt.editor:
            return 3;
        case $e68ba20b3d2d159d$var$kt.tools:
            return 4;
        case $e68ba20b3d2d159d$var$kt.elements:
            return 5;
        case $e68ba20b3d2d159d$var$kt.links:
            return 6;
        default:
            return 10;
    }
}, $e68ba20b3d2d159d$var$tg = ({ shortcut: e, className: t, children: r })=>{
    let o = e.replace("++", "+$").split("+");
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("shortcut", t),
        children: [
            o.map((n, i)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "shortcut-wrapper",
                    children: (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "shortcut-key",
                        children: n === "$" ? "+" : n
                    })
                }, n)),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "shortcut-desc",
                children: r
            })
        ]
    });
}, $e68ba20b3d2d159d$var$gC = (e)=>!e.altKey && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && (e.shiftKey && e.key.toLowerCase() === $e68ba20b3d2d159d$var$S.P || e.key === $e68ba20b3d2d159d$var$S.SLASH), $e68ba20b3d2d159d$var$Xhe = Object.assign((e)=>{
    let t = $e68ba20b3d2d159d$var$Ke(), r = $e68ba20b3d2d159d$var$He();
    return (0, $acw62.useEffect)(()=>{
        let o = (n)=>{
            $e68ba20b3d2d159d$var$gC(n) && (n.preventDefault(), n.stopPropagation(), r((i)=>{
                let a = i.openDialog?.name === "commandPalette" ? null : {
                    name: "commandPalette"
                };
                return a && $e68ba20b3d2d159d$var$Pe("command_palette", "open", "shortcut"), {
                    openDialog: a
                };
            }));
        };
        return window.addEventListener("keydown", o, {
            capture: !0
        }), ()=>window.removeEventListener("keydown", o, {
                capture: !0
            });
    }, [
        r
    ]), t.openDialog?.name !== "commandPalette" ? null : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$V7, {
        ...e
    });
}, {
    defaultItems: $e68ba20b3d2d159d$var$Nb
});
function $e68ba20b3d2d159d$var$V7({ customCommandPaletteItems: e }) {
    let t = $e68ba20b3d2d159d$var$Bt(), r = $e68ba20b3d2d159d$var$Ke(), o = $e68ba20b3d2d159d$var$He(), n = $e68ba20b3d2d159d$var$Xn(), i = $e68ba20b3d2d159d$var$$t(), [a, s] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$G7), [l, c] = (0, $acw62.useState)(null), d = (0, $acw62.useRef)(null), m = $e68ba20b3d2d159d$var$Xl({
        uiAppState: r,
        customCommandPaletteItems: e,
        appProps: n
    });
    (0, $acw62.useEffect)(()=>{
        let { uiAppState: C, customCommandPaletteItems: P, appProps: k } = m, _ = (V)=>{
            let ee = "";
            return V.label && (typeof V.label == "function" ? ee = $e68ba20b3d2d159d$var$x(V.label(t.scene.getNonDeletedElements(), C, t)) : ee = $e68ba20b3d2d159d$var$x(V.label)), ee;
        }, A = (V)=>typeof V.icon == "function" ? V.icon(C, t.scene.getNonDeletedElements()) : V.icon, R = [], B = (V, ee, N)=>{
            let H = {
                label: _(V),
                icon: A(V),
                category: ee,
                shortcut: $e68ba20b3d2d159d$var$zt(V.name),
                keywords: V.keywords,
                predicate: V.predicate,
                viewMode: V.viewMode,
                perform: ()=>{
                    i.executeAction(V, "commandPalette");
                }
            };
            return N ? N(H, V) : H;
        };
        if (C && t.scene && i) {
            let V = [
                i.actions.group,
                i.actions.ungroup,
                i.actions.cut,
                i.actions.copy,
                i.actions.deleteSelectedElements,
                i.actions.copyStyles,
                i.actions.pasteStyles,
                i.actions.bringToFront,
                i.actions.bringForward,
                i.actions.sendBackward,
                i.actions.sendToBack,
                i.actions.alignTop,
                i.actions.alignBottom,
                i.actions.alignLeft,
                i.actions.alignRight,
                i.actions.alignVerticallyCentered,
                i.actions.alignHorizontallyCentered,
                i.actions.duplicateSelection,
                i.actions.flipHorizontal,
                i.actions.flipVertical,
                i.actions.zoomToFitSelection,
                i.actions.zoomToFitSelectionInViewport,
                i.actions.increaseFontSize,
                i.actions.decreaseFontSize,
                i.actions.toggleLinearEditor,
                $e68ba20b3d2d159d$var$em
            ].map((ne)=>B(ne, $e68ba20b3d2d159d$var$kt.elements, (ve, Ce)=>({
                        ...ve,
                        predicate: Ce.predicate ? Ce.predicate : (Te, Le, Gt, co)=>$e68ba20b3d2d159d$var$pe(Te, Le).length > 0
                    }))), ee = [
                i.actions.toggleHandTool,
                i.actions.setFrameAsActiveTool
            ].map((ne)=>B(ne, $e68ba20b3d2d159d$var$kt.tools)), N = [
                i.actions.undo,
                i.actions.redo,
                i.actions.zoomIn,
                i.actions.zoomOut,
                i.actions.resetZoom,
                i.actions.zoomToFit,
                i.actions.zenMode,
                i.actions.viewMode,
                i.actions.gridMode,
                i.actions.objectsSnapMode,
                i.actions.toggleShortcuts,
                i.actions.selectAll,
                i.actions.toggleElementLock,
                i.actions.unlockAllElements,
                i.actions.stats
            ].map((ne)=>B(ne, $e68ba20b3d2d159d$var$kt.editor)), H = [
                i.actions.saveToActiveFile,
                i.actions.saveFileToDisk,
                i.actions.copyAsPng,
                i.actions.copyAsSvg
            ].map((ne)=>B(ne, $e68ba20b3d2d159d$var$kt.export));
            R = [
                ...V,
                ...N,
                {
                    label: _($e68ba20b3d2d159d$var$Mi),
                    icon: A($e68ba20b3d2d159d$var$Mi),
                    shortcut: $e68ba20b3d2d159d$var$zt($e68ba20b3d2d159d$var$Mi.name),
                    category: $e68ba20b3d2d159d$var$kt.editor,
                    keywords: [
                        "delete",
                        "destroy"
                    ],
                    viewMode: !1,
                    perform: ()=>{
                        $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$Ds, "clearCanvas");
                    }
                },
                {
                    label: $e68ba20b3d2d159d$var$x("buttons.exportImage"),
                    category: $e68ba20b3d2d159d$var$kt.export,
                    icon: $e68ba20b3d2d159d$var$Ep,
                    shortcut: $e68ba20b3d2d159d$var$zt("imageExport"),
                    keywords: [
                        "export",
                        "image",
                        "png",
                        "jpeg",
                        "svg",
                        "clipboard",
                        "picture"
                    ],
                    perform: ()=>{
                        o({
                            openDialog: {
                                name: "imageExport"
                            }
                        });
                    }
                },
                ...H
            ];
            let xe = [
                {
                    label: $e68ba20b3d2d159d$var$x("toolBar.library"),
                    category: $e68ba20b3d2d159d$var$kt.app,
                    icon: $e68ba20b3d2d159d$var$pp,
                    viewMode: !1,
                    perform: ()=>{
                        C.openSidebar ? o({
                            openSidebar: null
                        }) : o({
                            openSidebar: {
                                name: $e68ba20b3d2d159d$var$mo.name,
                                tab: $e68ba20b3d2d159d$var$mo.defaultTab
                            }
                        });
                    }
                },
                {
                    label: $e68ba20b3d2d159d$var$x("labels.changeStroke"),
                    keywords: [
                        "color",
                        "outline"
                    ],
                    category: $e68ba20b3d2d159d$var$kt.elements,
                    icon: $e68ba20b3d2d159d$var$fp,
                    viewMode: !1,
                    predicate: (ne, ve)=>{
                        let Ce = $e68ba20b3d2d159d$var$pe(ne, ve);
                        return Ce.length > 0 && $e68ba20b3d2d159d$var$Db(ve, Ce);
                    },
                    perform: ()=>{
                        o((ne)=>({
                                openMenu: ne.openMenu === "shape" ? null : "shape",
                                openPopup: "elementStroke"
                            }));
                    }
                },
                {
                    label: $e68ba20b3d2d159d$var$x("labels.changeBackground"),
                    keywords: [
                        "color",
                        "fill"
                    ],
                    icon: $e68ba20b3d2d159d$var$fp,
                    category: $e68ba20b3d2d159d$var$kt.elements,
                    viewMode: !1,
                    predicate: (ne, ve)=>{
                        let Ce = $e68ba20b3d2d159d$var$pe(ne, ve);
                        return Ce.length > 0 && $e68ba20b3d2d159d$var$_b(ve, Ce);
                    },
                    perform: ()=>{
                        o((ne)=>({
                                openMenu: ne.openMenu === "shape" ? null : "shape",
                                openPopup: "elementBackground"
                            }));
                    }
                },
                {
                    label: $e68ba20b3d2d159d$var$x("labels.canvasBackground"),
                    keywords: [
                        "color"
                    ],
                    icon: $e68ba20b3d2d159d$var$fp,
                    category: $e68ba20b3d2d159d$var$kt.editor,
                    viewMode: !1,
                    perform: ()=>{
                        o((ne)=>({
                                openMenu: ne.openMenu === "canvas" ? null : "canvas",
                                openPopup: "canvasBackground"
                            }));
                    }
                },
                ...$e68ba20b3d2d159d$var$Kc.reduce((ne, ve)=>{
                    let { value: Ce, icon: Te, key: Le, numericKey: Gt } = ve;
                    if (k.UIOptions.tools?.[Ce] === !1) return ne;
                    let Xr = Le && $e68ba20b3d2d159d$var$zi(typeof Le == "string" ? Le : Le[0]) || Gt, xr = {
                        label: $e68ba20b3d2d159d$var$x(`toolBar.${Ce}`),
                        category: $e68ba20b3d2d159d$var$kt.tools,
                        shortcut: Xr,
                        icon: Te,
                        keywords: [
                            "toolbar"
                        ],
                        viewMode: !1,
                        perform: ({ event: So })=>{
                            Ce === "image" ? t.setActiveTool({
                                type: Ce,
                                insertOnCanvasDirectly: So.type === "keydown"
                            }) : t.setActiveTool({
                                type: Ce
                            });
                        }
                    };
                    return ne.push(xr), ne;
                }, []),
                ...ee,
                {
                    label: $e68ba20b3d2d159d$var$x("toolBar.lock"),
                    category: $e68ba20b3d2d159d$var$kt.tools,
                    icon: C.activeTool.locked ? $e68ba20b3d2d159d$var$js : $e68ba20b3d2d159d$var$Ya,
                    shortcut: $e68ba20b3d2d159d$var$S.Q.toLocaleUpperCase(),
                    viewMode: !1,
                    perform: ()=>{
                        t.toggleLock();
                    }
                },
                {
                    label: `${$e68ba20b3d2d159d$var$x("labels.textToDiagram")}...`,
                    category: $e68ba20b3d2d159d$var$kt.tools,
                    icon: $e68ba20b3d2d159d$var$Uw,
                    viewMode: !1,
                    predicate: k.aiEnabled,
                    perform: ()=>{
                        o((ne)=>({
                                ...ne,
                                openDialog: {
                                    name: "ttd",
                                    tab: "text-to-diagram"
                                }
                            }));
                    }
                },
                {
                    label: `${$e68ba20b3d2d159d$var$x("toolBar.mermaidToExcalidraw")}...`,
                    category: $e68ba20b3d2d159d$var$kt.tools,
                    icon: $e68ba20b3d2d159d$var$Tp,
                    viewMode: !1,
                    predicate: k.aiEnabled,
                    perform: ()=>{
                        o((ne)=>({
                                ...ne,
                                openDialog: {
                                    name: "ttd",
                                    tab: "mermaid"
                                }
                            }));
                    }
                }
            ], X = [
                ...R,
                ...xe,
                ...P || []
            ].map((ne)=>({
                    ...ne,
                    icon: ne.icon || $e68ba20b3d2d159d$var$Ap,
                    order: ne.order ?? $e68ba20b3d2d159d$var$W7(ne.category),
                    haystack: `${$e68ba20b3d2d159d$var$Mb(ne.label.toLocaleLowerCase())} ${ne.keywords?.join(" ") || ""}`
                }));
            c(X), s(X.find((ne)=>ne.label === a?.label) ?? null);
        }
    }, [
        m,
        t,
        i,
        c,
        a?.label,
        s,
        o
    ]);
    let [p, u] = (0, $acw62.useState)(""), [h, g] = (0, $acw62.useState)(null), [b, v] = (0, $acw62.useState)({}), y = (C)=>{
        o({
            openDialog: null
        }, C), u("");
    }, w = (C, P)=>{
        r.openDialog?.name === "commandPalette" && (P.stopPropagation(), P.preventDefault(), document.body.classList.add("excalidraw-animations-disabled"), y(()=>{
            C.perform({
                actionManager: i,
                event: P
            }), s(C), requestAnimationFrame(()=>{
                document.body.classList.remove("excalidraw-animations-disabled");
            });
        }));
    }, I = $e68ba20b3d2d159d$var$Rb((C)=>C.viewMode === !1 && r.viewModeEnabled ? !1 : typeof C.predicate == "function" ? C.predicate(t.scene.getNonDeletedElements(), r, n, t) : C.predicate === void 0 || C.predicate), M = $e68ba20b3d2d159d$var$Rb((C)=>{
        let P = $e68ba20b3d2d159d$var$Mn(C.target) || $e68ba20b3d2d159d$var$gC(C) || C.key === $e68ba20b3d2d159d$var$S.ESCAPE;
        if (P && C.key !== $e68ba20b3d2d159d$var$S.ARROW_UP && C.key !== $e68ba20b3d2d159d$var$S.ARROW_DOWN && C.key !== $e68ba20b3d2d159d$var$S.ENTER) return;
        let k = Object.values(b).flat(), _ = a && !p && I(a);
        if (C.key === $e68ba20b3d2d159d$var$S.ARROW_UP) {
            C.preventDefault();
            let A = k.findIndex((V)=>V.label === h?.label);
            if (_) {
                if (A === 0) {
                    g(a);
                    return;
                }
                if (h === a) {
                    let V = k[k.length - 1];
                    V && g(V);
                    return;
                }
            }
            let R;
            A === -1 ? R = k.length - 1 : R = A === 0 ? k.length - 1 : (A - 1) % k.length;
            let B = k[R];
            B && g(B);
            return;
        }
        if (C.key === $e68ba20b3d2d159d$var$S.ARROW_DOWN) {
            C.preventDefault();
            let A = k.findIndex((V)=>V.label === h?.label);
            if (_) {
                if (!h || A === k.length - 1) {
                    g(a);
                    return;
                }
                if (h === a) {
                    let V = k[0];
                    V && g(V);
                    return;
                }
            }
            let R = (A + 1) % k.length, B = k[R];
            B && g(B);
            return;
        }
        if (C.key === $e68ba20b3d2d159d$var$S.ENTER && h && setTimeout(()=>{
            w(h, C);
        }), !P) {
            if (C.stopPropagation(), /^[a-zA-Z0-9]$/.test(C.key)) {
                d?.current?.focus();
                return;
            }
            C.preventDefault();
        }
    });
    return (0, $acw62.useEffect)(()=>(window.addEventListener("keydown", M, {
            capture: !0
        }), ()=>window.removeEventListener("keydown", M, {
                capture: !0
            })), [
        M
    ]), (0, $acw62.useEffect)(()=>{
        if (!l) return;
        let C = (A)=>{
            let R = {};
            for (let B of A)R[B.category] ? R[B.category].push(B) : R[B.category] = [
                B
            ];
            return R;
        }, P = l.filter(I).sort((A, R)=>A.order - R.order), k = !p && a && I(a);
        if (!p) {
            v(C(k ? P.filter((A)=>A.label !== a?.label) : P)), g(k ? a : P[0] || null);
            return;
        }
        let _ = $e68ba20b3d2d159d$var$Mb(p.toLocaleLowerCase().replace(/[<>_| -]/g, ""));
        P = (0, (/*@__PURE__*/$parcel$interopDefault($ca0b4b54599ec457$exports))).filter(_, P, {
            extract: (A)=>A.haystack
        }).sort((A, R)=>R.score - A.score).map((A)=>A.original), v(C(P)), g(P[0] ?? null);
    }, [
        p,
        l,
        I,
        a
    ]), (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Mt, {
        onCloseRequest: ()=>y(),
        closeOnClickOutside: !0,
        title: !1,
        size: 720,
        autofocus: !0,
        className: "command-palette-dialog",
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$aC, {
                value: p,
                placeholder: $e68ba20b3d2d159d$var$x("commandPalette.search.placeholder"),
                onChange: (C)=>{
                    u(C);
                },
                selectOnRender: !0,
                ref: d
            }),
            !t.device.viewport.isMobile && (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "shortcuts-wrapper",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tg, {
                        shortcut: "\u2191\u2193",
                        children: $e68ba20b3d2d159d$var$x("commandPalette.shortcuts.select")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tg, {
                        shortcut: "\u21B5",
                        children: $e68ba20b3d2d159d$var$x("commandPalette.shortcuts.confirm")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tg, {
                        shortcut: $e68ba20b3d2d159d$var$O("Esc"),
                        children: $e68ba20b3d2d159d$var$x("commandPalette.shortcuts.close")
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "commands",
                children: [
                    a && !p && (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "command-category",
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "command-category-title",
                                children: [
                                    $e68ba20b3d2d159d$var$x("commandPalette.recents"),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "icon",
                                        style: {
                                            marginLeft: "6px"
                                        },
                                        children: $e68ba20b3d2d159d$var$Gw
                                    })
                                ]
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$uC, {
                                command: a,
                                isSelected: a.label === h?.label,
                                onClick: (C)=>w(a, C),
                                disabled: !I(a),
                                onMouseMove: ()=>g(a),
                                showShortcut: !t.device.viewport.isMobile,
                                appState: r
                            })
                        ]
                    }),
                    Object.keys(b).length > 0 ? Object.keys(b).map((C, P)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "command-category",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "command-category-title",
                                    children: C
                                }),
                                b[C].map((k)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$uC, {
                                        command: k,
                                        isSelected: k.label === h?.label,
                                        onClick: (_)=>w(k, _),
                                        onMouseMove: ()=>g(k),
                                        showShortcut: !t.device.viewport.isMobile,
                                        appState: r
                                    }, k.label))
                            ]
                        }, C)) : l ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "no-match",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "icon",
                                children: $e68ba20b3d2d159d$var$Cp
                            }),
                            " ",
                            $e68ba20b3d2d159d$var$x("commandPalette.search.noMatch")
                        ]
                    }) : null
                ]
            })
        ]
    });
}
var $e68ba20b3d2d159d$var$uC = ({ command: e, isSelected: t, disabled: r, onMouseMove: o, onClick: n, showShortcut: i, appState: a })=>{
    let s = ()=>{};
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("command-item", {
            "item-selected": t,
            "item-disabled": r
        }),
        ref: (l)=>{
            t && !r && l?.scrollIntoView?.({
                block: "nearest"
            });
        },
        onClick: r ? s : n,
        onMouseMove: r ? s : o,
        title: r ? $e68ba20b3d2d159d$var$x("commandPalette.itemNotAvailable") : "",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "name",
                children: [
                    e.icon && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ga, {
                        icon: typeof e.icon == "function" ? e.icon(a) : e.icon
                    }),
                    e.label
                ]
            }),
            i && e.shortcut && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tg, {
                shortcut: e.shortcut
            })
        ]
    });
};
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$Ob = $e68ba20b3d2d159d$var$U({
    name: "toggleLinearEditor",
    category: $e68ba20b3d2d159d$var$kt.elements,
    label: (e, t, r)=>r.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds
        })[0]?.type === "arrow" ? "labels.lineEditor.editArrow" : "labels.lineEditor.edit",
    keywords: [
        "line"
    ],
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t);
        return !!(!t.editingLinearElement && n.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(n[0]) && !$e68ba20b3d2d159d$var$ce(n[0]));
    },
    perform (e, t, r, o) {
        let n = o.scene.getSelectedElements({
            selectedElementIds: t.selectedElementIds,
            includeBoundTextElement: !0
        })[0], i = t.editingLinearElement?.elementId === n.id ? null : new $e68ba20b3d2d159d$var$$(n);
        return {
            appState: {
                ...t,
                editingLinearElement: i
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    },
    PanelComponent: ({ appState: e, updateData: t, app: r })=>{
        let o = r.scene.getSelectedElements({
            selectedElementIds: e.selectedElementIds
        })[0], n = $e68ba20b3d2d159d$var$x(o.type === "arrow" ? "labels.lineEditor.editArrow" : "labels.lineEditor.edit");
        return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
            type: "button",
            icon: $e68ba20b3d2d159d$var$r2,
            title: n,
            "aria-label": n,
            onClick: ()=>t(null)
        });
    }
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ud();
var $e68ba20b3d2d159d$var$_s = class {
    constructor(t = !0, r = !0){
        this.isUndoStackEmpty = t;
        this.isRedoStackEmpty = r;
    }
}, $e68ba20b3d2d159d$var$nm = class e {
    onHistoryChangedEmitter = new $e68ba20b3d2d159d$var$kr;
    undoStack = [];
    redoStack = [];
    get isUndoStackEmpty() {
        return this.undoStack.length === 0;
    }
    get isRedoStackEmpty() {
        return this.redoStack.length === 0;
    }
    clear() {
        this.undoStack.length = 0, this.redoStack.length = 0;
    }
    record(t, r) {
        let o = $e68ba20b3d2d159d$var$Fb.create(r, t);
        o.isEmpty() || (this.undoStack.push(o.inverse()), o.elementsChange.isEmpty() || (this.redoStack.length = 0), this.onHistoryChangedEmitter.trigger(new $e68ba20b3d2d159d$var$_s(this.isUndoStackEmpty, this.isRedoStackEmpty)));
    }
    undo(t, r, o) {
        return this.perform(t, r, o, ()=>e.pop(this.undoStack), (n)=>e.push(this.redoStack, n, t));
    }
    redo(t, r, o) {
        return this.perform(t, r, o, ()=>e.pop(this.redoStack), (n)=>e.push(this.undoStack, n, t));
    }
    perform(t, r, o, n, i) {
        try {
            let a = n();
            if (a === null) return;
            let s = t, l = r, c = !1;
            for(; a;){
                try {
                    [s, l, c] = a.applyTo(s, l, o);
                } finally{
                    i(a);
                }
                if (c) break;
                a = n();
            }
            return [
                s,
                l
            ];
        } finally{
            this.onHistoryChangedEmitter.trigger(new $e68ba20b3d2d159d$var$_s(this.isUndoStackEmpty, this.isRedoStackEmpty));
        }
    }
    static pop(t) {
        if (!t.length) return null;
        let r = t.pop();
        return r !== void 0 ? r : null;
    }
    static push(t, r, o) {
        let n = r.inverse().applyLatestChanges(o);
        return t.push(n);
    }
}, $e68ba20b3d2d159d$var$Fb = class e {
    constructor(t, r){
        this.appStateChange = t;
        this.elementsChange = r;
    }
    static create(t, r) {
        return new e(t, r);
    }
    inverse() {
        return new e(this.appStateChange.inverse(), this.elementsChange.inverse());
    }
    applyTo(t, r, o) {
        let [n, i] = this.elementsChange.applyTo(t, o.elements), [a, s] = this.appStateChange.applyTo(r, n);
        return [
            n,
            a,
            i || s
        ];
    }
    applyLatestChanges(t) {
        let r = this.elementsChange.applyLatestChanges(t);
        return e.create(this.appStateChange, r);
    }
    isEmpty() {
        return this.appStateChange.isEmpty() && this.elementsChange.isEmpty();
    }
};
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Bb = (e, t)=>{
    let [r, o] = (0, $acw62.useState)(t);
    return (0, $acw62.useEffect)(()=>{
        let n = e.on((i)=>{
            o(i);
        });
        return ()=>{
            n();
        };
    }, [
        e
    ]), r;
};
var $e68ba20b3d2d159d$var$fC = (e, t, r)=>{
    if (!t.multiElement && !t.resizingElement && !t.editingTextElement && !t.newElement && !t.selectedElementsAreBeingDragged && !t.selectionElement && !e.flowChartCreator.isCreatingChart) {
        let o = r();
        if (!o) return {
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
        let [n, i] = o, a = Array.from(n.values());
        return {
            appState: i,
            elements: a,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
        };
    }
    return {
        storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
    };
}, $e68ba20b3d2d159d$var$EC = (e, t)=>({
        name: "undo",
        label: "buttons.undo",
        icon: $e68ba20b3d2d159d$var$xf,
        trackEvent: {
            category: "history"
        },
        viewMode: !1,
        perform: (r, o, n, i)=>$e68ba20b3d2d159d$var$fC(i, o, ()=>e.undo($e68ba20b3d2d159d$var$j(r), o, t.snapshot)),
        keyTest: (r)=>r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && r.key.toLowerCase() === $e68ba20b3d2d159d$var$S.Z && !r.shiftKey,
        PanelComponent: ({ updateData: r, data: o })=>{
            let { isUndoStackEmpty: n } = $e68ba20b3d2d159d$var$Bb(e.onHistoryChangedEmitter, new $e68ba20b3d2d159d$var$_s(e.isUndoStackEmpty, e.isRedoStackEmpty));
            return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                type: "button",
                icon: $e68ba20b3d2d159d$var$xf,
                "aria-label": $e68ba20b3d2d159d$var$x("buttons.undo"),
                onClick: r,
                size: o?.size || "medium",
                disabled: n,
                "data-testid": "button-undo"
            });
        }
    }), $e68ba20b3d2d159d$var$xC = (e, t)=>({
        name: "redo",
        label: "buttons.redo",
        icon: $e68ba20b3d2d159d$var$bf,
        trackEvent: {
            category: "history"
        },
        viewMode: !1,
        perform: (r, o, n, i)=>$e68ba20b3d2d159d$var$fC(i, o, ()=>e.redo($e68ba20b3d2d159d$var$j(r), o, t.snapshot)),
        keyTest: (r)=>r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && r.shiftKey && r.key.toLowerCase() === $e68ba20b3d2d159d$var$S.Z || $e68ba20b3d2d159d$var$Pm && r.ctrlKey && !r.shiftKey && r.key === $e68ba20b3d2d159d$var$S.Y,
        PanelComponent: ({ updateData: r, data: o })=>{
            let { isRedoStackEmpty: n } = $e68ba20b3d2d159d$var$Bb(e.onHistoryChangedEmitter, new $e68ba20b3d2d159d$var$_s(e.isUndoStackEmpty, e.isRedoStackEmpty));
            return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                type: "button",
                icon: $e68ba20b3d2d159d$var$bf,
                "aria-label": $e68ba20b3d2d159d$var$x("buttons.redo"),
                onClick: r,
                size: o?.size || "medium",
                disabled: n,
                "data-testid": "button-redo"
            });
        }
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$zb = (e, t, r, o, n, i)=>{
    if (e.trackEvent) try {
        typeof e.trackEvent == "object" && (!e.trackEvent.predicate || e.trackEvent.predicate(r, o, i)) && $e68ba20b3d2d159d$var$Pe(e.trackEvent.category, e.trackEvent.action || e.name, `${t} (${n.device.editor.isMobile ? "mobile" : "desktop"})`);
    } catch (a) {
        console.error("error while logging action:", a);
    }
}, $e68ba20b3d2d159d$var$rg = class {
    actions = {};
    updater;
    getAppState;
    getElementsIncludingDeleted;
    app;
    constructor(t, r, o, n){
        this.updater = (i)=>{
            if ($e68ba20b3d2d159d$var$Ln(i)) i.then((a)=>t(a));
            else return t(i);
        }, this.getAppState = r, this.getElementsIncludingDeleted = o, this.app = n;
    }
    registerAction(t) {
        this.actions[t.name] = t;
    }
    registerAll(t) {
        t.forEach((r)=>this.registerAction(r));
    }
    handleKeyDown(t) {
        let r = this.app.props.UIOptions.canvasActions, o = Object.values(this.actions).sort((l, c)=>(c.keyPriority || 0) - (l.keyPriority || 0)).filter((l)=>(l.name in r ? r[l.name] : !0) && l.keyTest && l.keyTest(t, this.getAppState(), this.getElementsIncludingDeleted(), this.app));
        if (o.length !== 1) return o.length > 1 && console.warn("Canceling as multiple actions match this shortcut", o), !1;
        let n = o[0];
        if (this.getAppState().viewModeEnabled && n.viewMode !== !0) return !1;
        let i = this.getElementsIncludingDeleted(), a = this.getAppState(), s = null;
        return $e68ba20b3d2d159d$var$zb(n, "keyboard", a, i, this.app, null), t.preventDefault(), t.stopPropagation(), this.updater(o[0].perform(i, a, s, this.app)), !0;
    }
    executeAction(t, r = "api", o = null) {
        let n = this.getElementsIncludingDeleted(), i = this.getAppState();
        $e68ba20b3d2d159d$var$zb(t, r, i, n, this.app, o), this.updater(t.perform(n, i, o, this.app));
    }
    renderAction = (t, r)=>{
        let o = this.app.props.UIOptions.canvasActions;
        if (this.actions[t] && "PanelComponent" in this.actions[t] && (!(t in o) || o[t])) {
            let n = this.actions[t], i = n.PanelComponent;
            i.displayName = "PanelComponent";
            let a = this.getElementsIncludingDeleted(), s = this.getAppState(), l = (c)=>{
                $e68ba20b3d2d159d$var$zb(n, "ui", s, a, this.app, c), this.updater(n.perform(this.getElementsIncludingDeleted(), this.getAppState(), c, this.app));
            };
            return (0, $7b02d682eb115277$exports.jsx)(i, {
                elements: this.getElementsIncludingDeleted(),
                appState: this.getAppState(),
                updateData: l,
                appProps: this.app.props,
                app: this.app,
                data: r
            });
        }
        return null;
    };
    isActionEnabled = (t)=>{
        let r = this.getElementsIncludingDeleted(), o = this.getAppState();
        return !t.predicate || t.predicate(r, o, this.app.props, this.app);
    };
};
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$Qr();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$xl();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Hb = (e)=>{
    let t = Array.from(e.values());
    return {
        x: $e68ba20b3d2d159d$var$yC(t, (r)=>r.x) / t.length,
        y: $e68ba20b3d2d159d$var$yC(t, (r)=>r.y) / t.length
    };
}, $e68ba20b3d2d159d$var$Ub = ([e, t])=>Math.hypot(e.x - t.x, e.y - t.y), $e68ba20b3d2d159d$var$yC = (e, t)=>e.reduce((r, o)=>r + t(o), 0);
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$ys();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$xs();
$e68ba20b3d2d159d$var$ul();
$e68ba20b3d2d159d$var$Hp();
$e68ba20b3d2d159d$var$Fp();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$gd();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Lr = "separator", $e68ba20b3d2d159d$var$wC = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ actionManager: e, items: t, top: r, left: o, onClose: n })=>{
    let i = $e68ba20b3d2d159d$var$Yn(), a = $e68ba20b3d2d159d$var$ma(), s = t.reduce((l, c)=>(c && (c === $e68ba20b3d2d159d$var$Lr || !c.predicate || c.predicate(a, i, e.app.props, e.app)) && l.push(c), l), []);
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$uh, {
        onCloseRequest: ()=>{
            n();
        },
        top: r,
        left: o,
        fitInViewport: !0,
        offsetLeft: i.offsetLeft,
        offsetTop: i.offsetTop,
        viewportWidth: i.width,
        viewportHeight: i.height,
        children: (0, $7b02d682eb115277$exports.jsx)("ul", {
            className: "context-menu",
            onContextMenu: (l)=>l.preventDefault(),
            children: s.map((l, c)=>{
                if (l === $e68ba20b3d2d159d$var$Lr) return !s[c - 1] || s[c - 1] === $e68ba20b3d2d159d$var$Lr ? null : (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "context-menu-item-separator"
                }, c);
                let d = l.name, m = "";
                return l.label && (typeof l.label == "function" ? m = $e68ba20b3d2d159d$var$x(l.label(a, i, e.app)) : m = $e68ba20b3d2d159d$var$x(l.label)), (0, $7b02d682eb115277$exports.jsx)("li", {
                    "data-testid": d,
                    onClick: ()=>{
                        n(()=>{
                            e.executeAction(l, "contextMenu");
                        });
                    },
                    children: (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("context-menu-item", {
                            dangerous: d === "deleteSelectedElements",
                            checkmark: l.checked?.(i)
                        }),
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "context-menu-item__label",
                                children: m
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                className: "context-menu-item__shortcut",
                                children: d ? $e68ba20b3d2d159d$var$zt(d) : ""
                            })
                        ]
                    })
                }, c);
            })
        })
    });
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$vC = ({ children: e, onClose: t })=>{
    let [r, o] = (0, $acw62.useState)(!!e), { container: n } = $e68ba20b3d2d159d$var$Ft(), i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        o(!1), t && t(), n?.focus();
    }, [
        t,
        n
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: r && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
            size: "small",
            onCloseRequest: i,
            title: $e68ba20b3d2d159d$var$x("errorDialog.title"),
            children: (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    whiteSpace: "pre-wrap"
                },
                children: e
            })
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Ml();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$og = function({ onChange: e, value: t, choices: r, name: o }) {
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "RadioGroup",
        children: r.map((n)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("RadioGroup__choice", {
                    active: n.value === t
                }),
                title: n.ariaLabel,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        name: o,
                        type: "radio",
                        checked: n.value === t,
                        onChange: ()=>e(n.value),
                        "aria-label": n.ariaLabel
                    }),
                    n.label
                ]
            }, String(n.value)))
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$im = ({ title: e, name: t, checked: r, onChange: o, disabled: n = !1 })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Switch", {
            toggled: r,
            disabled: n
        }),
        children: (0, $7b02d682eb115277$exports.jsx)("input", {
            name: t,
            id: t,
            title: e,
            type: "checkbox",
            checked: r,
            disabled: n,
            onChange: ()=>o(!r),
            onKeyDown: (i)=>{
                i.key === " " && o(!r);
            }
        })
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Gi();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$fa = (0, $acw62.forwardRef)(({ children: e, icon: t, onClick: r, label: o, variant: n = "filled", color: i = "primary", size: a = "medium", fullWidth: s, className: l, status: c }, d)=>{
    let [m, p] = (0, $acw62.useState)(!1), u = async (g)=>{
        let b = r?.(g);
        if ($e68ba20b3d2d159d$var$Ln(b)) {
            let v = window.setTimeout(()=>{
                p(!0);
            }, 50);
            try {
                await b;
            } catch (y) {
                if (y instanceof $e68ba20b3d2d159d$var$Rn) console.warn(y);
                else throw y;
            } finally{
                clearTimeout(v), p(!1);
            }
        }
    }, h = m ? "loading" : c;
    return i = h === "success" ? "success" : i, (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ExcButton", `ExcButton--color-${i}`, `ExcButton--variant-${n}`, `ExcButton--size-${a}`, `ExcButton--status-${h}`, {
            "ExcButton--fullWidth": s
        }, l),
        onClick: u,
        type: "button",
        "aria-label": o,
        ref: d,
        disabled: h === "loading" || h === "success",
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ExcButton__contents",
            children: [
                h === "loading" ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {
                    className: "ExcButton__statusIcon"
                }) : h === "success" && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ExcButton__statusIcon",
                    children: $e68ba20b3d2d159d$var$Rw
                }),
                t && (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "ExcButton__icon",
                    "aria-hidden": !0,
                    children: t
                }),
                n !== "icon" && (e ?? o)
            ]
        })
    });
});
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$d_ = 2e3, $e68ba20b3d2d159d$var$IC = ()=>{
    let [e, t] = (0, $acw62.useState)(null), r = (0, $acw62.useRef)(0);
    return {
        copyStatus: e,
        onCopy: ()=>{
            clearTimeout(r.current), t("success"), r.current = window.setTimeout(()=>{
                t(null);
            }, $e68ba20b3d2d159d$var$d_);
        }
    };
};
var $e68ba20b3d2d159d$var$u_ = "filter" in document.createElement("canvas").getContext("2d"), $e68ba20b3d2d159d$var$h_ = ()=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: $e68ba20b3d2d159d$var$x("canvasError.cannotShowPreview")
            }),
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: $e68ba20b3d2d159d$var$x("canvasError.canvasTooBig")
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)("em", {
                children: [
                    "(",
                    $e68ba20b3d2d159d$var$x("canvasError.canvasTooBigTip"),
                    ")"
                ]
            })
        ]
    }), $e68ba20b3d2d159d$var$g_ = ({ appStateSnapshot: e, elementsSnapshot: t, files: r, actionManager: o, onExportImage: n, name: i })=>{
    let a = $e68ba20b3d2d159d$var$Qe(t, e), [s, l] = (0, $acw62.useState)(i), [c, d] = (0, $acw62.useState)(a), [m, p] = (0, $acw62.useState)(e.exportBackground), [u, h] = (0, $acw62.useState)(e.exportWithDarkMode), [g, b] = (0, $acw62.useState)(e.exportEmbedScene), [v, y] = (0, $acw62.useState)(e.exportScale), w = (0, $acw62.useRef)(null), [I, M] = (0, $acw62.useState)(null), { onCopy: C, copyStatus: P } = $e68ba20b3d2d159d$var$IC(), { exportedElements: k, exportingFrame: _ } = $e68ba20b3d2d159d$var$As(t, e, c);
    return (0, $acw62.useEffect)(()=>{
        let A = w.current;
        if (!A) return;
        let R = A.offsetWidth, B = A.offsetHeight;
        R && $e68ba20b3d2d159d$export$7e83d8bd8a3024f4({
            elements: k,
            appState: {
                ...e,
                name: s,
                exportBackground: m,
                exportWithDarkMode: u,
                exportScale: v,
                exportEmbedScene: g
            },
            files: r,
            exportPadding: $e68ba20b3d2d159d$var$$o,
            maxWidthOrHeight: Math.max(R, B),
            exportingFrame: _
        }).then((V)=>(M(null), $e68ba20b3d2d159d$var$fi(V).then(()=>{
                A.replaceChildren(V);
            }).catch((ee)=>{
                throw ee.name === "CANVAS_POSSIBLY_TOO_BIG" ? new Error($e68ba20b3d2d159d$var$x("canvasError.canvasTooBig")) : ee;
            }))).catch((V)=>{
            console.error(V), M(V);
        });
    }, [
        e,
        r,
        k,
        _,
        s,
        m,
        u,
        v,
        g
    ]), (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ImageExportModal",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: $e68ba20b3d2d159d$var$x("imageExportDialog.header")
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ImageExportModal__preview",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ImageExportModal__preview__canvas",
                        ref: w,
                        children: I && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$h_, {})
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "ImageExportModal__preview__filename",
                        children: !(0, $11b096c57ac70a88$export$5f747a46dc0eb6ee) && (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            className: "TextInput",
                            value: s,
                            style: {
                                width: "30ch"
                            },
                            onChange: (A)=>{
                                l(A.target.value), o.executeAction($e68ba20b3d2d159d$var$$x, "ui", A.target.value);
                            }
                        })
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ImageExportModal__settings",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: $e68ba20b3d2d159d$var$x("imageExportDialog.header")
                    }),
                    a && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$am, {
                        label: $e68ba20b3d2d159d$var$x("imageExportDialog.label.onlySelected"),
                        name: "exportOnlySelected",
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$im, {
                            name: "exportOnlySelected",
                            checked: c,
                            onChange: (A)=>{
                                d(A);
                            }
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$am, {
                        label: $e68ba20b3d2d159d$var$x("imageExportDialog.label.withBackground"),
                        name: "exportBackgroundSwitch",
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$im, {
                            name: "exportBackgroundSwitch",
                            checked: m,
                            onChange: (A)=>{
                                p(A), o.executeAction($e68ba20b3d2d159d$var$Zx, "ui", A);
                            }
                        })
                    }),
                    $e68ba20b3d2d159d$var$u_ && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$am, {
                        label: $e68ba20b3d2d159d$var$x("imageExportDialog.label.darkMode"),
                        name: "exportDarkModeSwitch",
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$im, {
                            name: "exportDarkModeSwitch",
                            checked: u,
                            onChange: (A)=>{
                                h(A), o.executeAction($e68ba20b3d2d159d$var$ZS, "ui", A);
                            }
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$am, {
                        label: $e68ba20b3d2d159d$var$x("imageExportDialog.label.embedScene"),
                        tooltip: $e68ba20b3d2d159d$var$x("imageExportDialog.tooltip.embedScene"),
                        name: "exportEmbedSwitch",
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$im, {
                            name: "exportEmbedSwitch",
                            checked: g,
                            onChange: (A)=>{
                                b(A), o.executeAction($e68ba20b3d2d159d$var$Ih, "ui", A);
                            }
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$am, {
                        label: $e68ba20b3d2d159d$var$x("imageExportDialog.label.scale"),
                        name: "exportScale",
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$og, {
                            name: "exportScale",
                            value: v,
                            onChange: (A)=>{
                                y(A), o.executeAction($e68ba20b3d2d159d$var$$S, "ui", A);
                            },
                            choices: $e68ba20b3d2d159d$var$Xs.map((A)=>({
                                    value: A,
                                    label: `${A}\xD7`
                                }))
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "ImageExportModal__settings__buttons",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fa, {
                                className: "ImageExportModal__settings__buttons__button",
                                label: $e68ba20b3d2d159d$var$x("imageExportDialog.title.exportToPng"),
                                onClick: ()=>n($e68ba20b3d2d159d$var$Nm.png, k, {
                                        exportingFrame: _
                                    }),
                                icon: $e68ba20b3d2d159d$var$Rf,
                                children: $e68ba20b3d2d159d$var$x("imageExportDialog.button.exportToPng")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fa, {
                                className: "ImageExportModal__settings__buttons__button",
                                label: $e68ba20b3d2d159d$var$x("imageExportDialog.title.exportToSvg"),
                                onClick: ()=>n($e68ba20b3d2d159d$var$Nm.svg, k, {
                                        exportingFrame: _
                                    }),
                                icon: $e68ba20b3d2d159d$var$Rf,
                                children: $e68ba20b3d2d159d$var$x("imageExportDialog.button.exportToSvg")
                            }),
                            ($e68ba20b3d2d159d$var$Cl || $e68ba20b3d2d159d$var$ni) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fa, {
                                className: "ImageExportModal__settings__buttons__button",
                                label: $e68ba20b3d2d159d$var$x("imageExportDialog.title.copyPngToClipboard"),
                                status: P,
                                onClick: async ()=>{
                                    await n($e68ba20b3d2d159d$var$Nm.clipboard, k, {
                                        exportingFrame: _
                                    }), C();
                                },
                                icon: $e68ba20b3d2d159d$var$wp,
                                children: $e68ba20b3d2d159d$var$x("imageExportDialog.button.copyPngToClipboard")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$am = ({ label: e, children: t, tooltip: r, name: o })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ImageExportModal__settings__setting",
        title: e,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("label", {
                htmlFor: o,
                className: "ImageExportModal__settings__setting__label",
                children: [
                    e,
                    r && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
                        label: r,
                        long: !0,
                        children: $e68ba20b3d2d159d$var$_w
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ImageExportModal__settings__setting__content",
                children: t
            })
        ]
    }), $e68ba20b3d2d159d$var$CC = ({ elements: e, appState: t, files: r, actionManager: o, onExportImage: n, onCloseRequest: i, name: a })=>{
    let [{ appStateSnapshot: s, elementsSnapshot: l }] = (0, $acw62.useState)(()=>({
            appStateSnapshot: $e68ba20b3d2d159d$var$jr(t),
            elementsSnapshot: $e68ba20b3d2d159d$var$jr(e)
        }));
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
        onCloseRequest: i,
        size: "wide",
        title: !1,
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$g_, {
            elementsSnapshot: l,
            appStateSnapshot: s,
            files: r,
            actionManager: o,
            onExportImage: n,
            name: a
        })
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$ig = ({ children: e, side: t, className: r })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("FixedSideContainer", `FixedSideContainer_side_${t}`, r),
        children: e
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Qr();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Yp();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$dc = 100, $e68ba20b3d2d159d$var$Rs = 100, $e68ba20b3d2d159d$var$Yb = (e)=>{
    switch(e){
        case $e68ba20b3d2d159d$var$S.ARROW_UP:
            return "up";
        case $e68ba20b3d2d159d$var$S.ARROW_DOWN:
            return "down";
        case $e68ba20b3d2d159d$var$S.ARROW_RIGHT:
            return "right";
        case $e68ba20b3d2d159d$var$S.ARROW_LEFT:
            return "left";
        default:
            return "right";
    }
}, $e68ba20b3d2d159d$var$AC = (e, t, r, o)=>{
    let n = [
        ...r.values()
    ].reduce((i, a)=>{
        let s;
        if ($e68ba20b3d2d159d$var$ce(a) && (s = a[e === "predecessors" ? "startBinding" : "endBinding"]) && a[e === "predecessors" ? "endBinding" : "startBinding"]?.elementId === t.id) {
            let l = r.get(s.elementId);
            if (!l) return i;
            $e68ba20b3d2d159d$var$Lc($e68ba20b3d2d159d$var$po(l), "not an ExcalidrawBindableElement");
            let c = e === "predecessors" ? a.points[a.points.length - 1] : [
                0,
                0
            ], d = $e68ba20b3d2d159d$var$$c(t, $e68ba20b3d2d159d$var$dn(t), [
                c[0] + a.x,
                c[1] + a.y
            ]);
            i.push({
                relative: l,
                heading: d
            });
        }
        return i;
    }, []);
    switch(o){
        case "up":
            return n.filter((i)=>$e68ba20b3d2d159d$var$cn(i.heading, $e68ba20b3d2d159d$var$hr)).map((i)=>i.relative);
        case "down":
            return n.filter((i)=>$e68ba20b3d2d159d$var$cn(i.heading, $e68ba20b3d2d159d$var$pr)).map((i)=>i.relative);
        case "right":
            return n.filter((i)=>$e68ba20b3d2d159d$var$cn(i.heading, $e68ba20b3d2d159d$var$At)).map((i)=>i.relative);
        case "left":
            return n.filter((i)=>$e68ba20b3d2d159d$var$cn(i.heading, $e68ba20b3d2d159d$var$ur)).map((i)=>i.relative);
    }
}, $e68ba20b3d2d159d$var$Wb = (e, t, r)=>$e68ba20b3d2d159d$var$AC("successors", e, t, r), $e68ba20b3d2d159d$var$Vb = (e, t, r)=>$e68ba20b3d2d159d$var$AC("predecessors", e, t, r), $e68ba20b3d2d159d$var$x_ = (e, t, r)=>{
    let o = $e68ba20b3d2d159d$var$Rs + e.width;
    if (r === "up" || r === "down") {
        let s = $e68ba20b3d2d159d$var$dc + e.height, l = e.x, c = e.x + e.width;
        if (t.every((d)=>d.x + d.width < l || d.x > c)) return {
            x: 0,
            y: s * (r === "up" ? -1 : 1)
        };
    } else if (r === "right" || r === "left") {
        let s = e.y, l = e.y + e.height;
        if (t.every((c)=>c.y + c.height < s || c.y > l)) return {
            x: ($e68ba20b3d2d159d$var$Rs + e.width) * (r === "left" ? -1 : 1),
            y: 0
        };
    }
    if (r === "up" || r === "down") {
        let s = $e68ba20b3d2d159d$var$dc + e.height, l = (t.length, s), c = t.length === 0 ? 0 : (t.length + 1) % 2 === 0 ? (t.length + 1) / 2 * o : t.length / 2 * o * -1;
        return r === "up" ? {
            x: c,
            y: l * -1
        } : {
            x: c,
            y: l
        };
    }
    let n = $e68ba20b3d2d159d$var$dc + e.height, i = (t.length, $e68ba20b3d2d159d$var$Rs + e.width), a = t.length === 0 ? 0 : (t.length + 1) % 2 === 0 ? (t.length + 1) / 2 * n : t.length / 2 * n * -1;
    return r === "left" ? {
        x: i * -1,
        y: a
    } : {
        x: i,
        y: a
    };
}, $e68ba20b3d2d159d$var$b_ = (e, t, r, o)=>{
    let n = $e68ba20b3d2d159d$var$Wb(e, t, o), i = $e68ba20b3d2d159d$var$Vb(e, t, o), a = $e68ba20b3d2d159d$var$x_(e, [
        ...n,
        ...i
    ], o), s = $e68ba20b3d2d159d$var$Ar({
        type: e.type,
        x: e.x + a.x,
        y: e.y + a.y,
        width: e.width,
        height: e.height,
        roundness: e.roundness,
        roughness: e.roughness,
        backgroundColor: e.backgroundColor,
        strokeColor: e.strokeColor,
        strokeWidth: e.strokeWidth
    });
    $e68ba20b3d2d159d$var$Lc($e68ba20b3d2d159d$var$Ua(s), "not an ExcalidrawFlowchartNodeElement");
    let l = $e68ba20b3d2d159d$var$MC(e, s, t, o, r);
    return {
        nextNode: s,
        bindingArrow: l
    };
}, $e68ba20b3d2d159d$var$y_ = (e, t, r, o, n)=>{
    let i = [];
    for(let a = 0; a < n; a++){
        let s, l;
        if (o === "left" || o === "right") {
            let m = $e68ba20b3d2d159d$var$dc * (n - 1) + n * e.height, p = e.y + e.height / 2 - m / 2, u = $e68ba20b3d2d159d$var$Rs + e.width;
            o === "left" && (u *= -1), s = e.x + u;
            let h = ($e68ba20b3d2d159d$var$dc + e.height) * a;
            l = p + h;
        } else {
            let m = $e68ba20b3d2d159d$var$Rs * (n - 1) + n * e.width, p = e.x + e.width / 2 - m / 2, u = $e68ba20b3d2d159d$var$dc + e.height;
            o === "up" && (u *= -1), l = e.y + u;
            let h = ($e68ba20b3d2d159d$var$Rs + e.width) * a;
            s = p + h;
        }
        let c = $e68ba20b3d2d159d$var$Ar({
            type: e.type,
            x: s,
            y: l,
            width: e.width,
            height: e.height,
            roundness: e.roundness,
            roughness: e.roughness,
            backgroundColor: e.backgroundColor,
            strokeColor: e.strokeColor,
            strokeWidth: e.strokeWidth
        });
        $e68ba20b3d2d159d$var$Lc($e68ba20b3d2d159d$var$Ua(c), "not an ExcalidrawFlowchartNodeElement");
        let d = $e68ba20b3d2d159d$var$MC(e, c, t, o, r);
        i.push(c), i.push(d);
    }
    return i;
}, $e68ba20b3d2d159d$var$MC = (e, t, r, o, n)=>{
    let i, a;
    switch(o){
        case "up":
            i = e.x + e.width / 2, a = e.y - 6;
            break;
        case "down":
            i = e.x + e.width / 2, a = e.y + e.height + 6;
            break;
        case "right":
            i = e.x + e.width + 6, a = e.y + e.height / 2;
            break;
        case "left":
            i = e.x - 6, a = e.y + e.height / 2;
            break;
    }
    let l, c;
    switch(o){
        case "up":
            l = t.x + t.width / 2 - i, c = t.y + t.height - a + 6;
            break;
        case "down":
            l = t.x + t.width / 2 - i, c = t.y - a - 6;
            break;
        case "right":
            l = t.x - i - 6, c = t.y - a + t.height / 2;
            break;
        case "left":
            l = t.x + t.width - i + 6, c = t.y - a + t.height / 2;
            break;
    }
    let d = $e68ba20b3d2d159d$var$ds({
        type: "arrow",
        x: i,
        y: a,
        startArrowhead: n.currentItemStartArrowhead,
        endArrowhead: n.currentItemEndArrowhead,
        strokeColor: n.currentItemStrokeColor,
        strokeStyle: n.currentItemStrokeStyle,
        strokeWidth: n.currentItemStrokeWidth,
        points: [
            [
                0,
                0
            ],
            [
                l,
                c
            ]
        ],
        elbowed: !0
    });
    $e68ba20b3d2d159d$var$fo(d, e, "start", r), $e68ba20b3d2d159d$var$fo(d, t, "end", r);
    let m = new Map;
    return m.set(e.id, e), m.set(t.id, t), m.set(d.id, d), $e68ba20b3d2d159d$var$$.movePoints(d, [
        {
            index: 1,
            point: d.points[1]
        }
    ], r, void 0, {
        changedElements: m
    }), d;
}, $e68ba20b3d2d159d$var$ag = class {
    isExploring = !1;
    sameLevelNodes = [];
    sameLevelIndex = 0;
    direction = null;
    visitedNodes = new Set;
    clear() {
        this.isExploring = !1, this.sameLevelNodes = [], this.sameLevelIndex = 0, this.direction = null, this.visitedNodes.clear();
    }
    exploreByDirection(t, r, o) {
        if (!$e68ba20b3d2d159d$var$po(t)) return null;
        if (o !== this.direction && this.clear(), this.visitedNodes.has(t.id) || this.visitedNodes.add(t.id), this.isExploring && o === this.direction && this.sameLevelNodes.length > 1) return this.sameLevelIndex = (this.sameLevelIndex + 1) % this.sameLevelNodes.length, this.sameLevelNodes[this.sameLevelIndex].id;
        let n = [
            ...$e68ba20b3d2d159d$var$Wb(t, r, o),
            ...$e68ba20b3d2d159d$var$Vb(t, r, o)
        ];
        if (n.length > 0) return this.sameLevelIndex = 0, this.isExploring = !0, this.sameLevelNodes = n, this.direction = o, this.visitedNodes.add(n[0].id), n[0].id;
        if (o === this.direction || !this.isExploring) {
            this.isExploring || this.visitedNodes.add(t.id);
            let a = [
                "up",
                "right",
                "down",
                "left"
            ].filter((s)=>s !== o).map((s)=>[
                    ...$e68ba20b3d2d159d$var$Wb(t, r, s),
                    ...$e68ba20b3d2d159d$var$Vb(t, r, s)
                ]).flat().filter((s)=>!this.visitedNodes.has(s.id));
            for (let s of a)if (!this.visitedNodes.has(s.id)) return this.visitedNodes.add(s.id), this.isExploring = !0, this.direction = o, s.id;
        }
        return null;
    }
}, $e68ba20b3d2d159d$var$sg = class {
    isCreatingChart = !1;
    numberOfNodes = 0;
    direction = "right";
    pendingNodes = null;
    createNodes(t, r, o, n) {
        if (n !== this.direction) {
            let { nextNode: i, bindingArrow: a } = $e68ba20b3d2d159d$var$b_(t, r, o, n);
            this.numberOfNodes = 1, this.isCreatingChart = !0, this.direction = n, this.pendingNodes = [
                i,
                a
            ];
        } else {
            this.numberOfNodes += 1;
            let i = $e68ba20b3d2d159d$var$y_(t, r, o, n, this.numberOfNodes);
            this.isCreatingChart = !0, this.direction = n, this.pendingNodes = i;
        }
        if (t.frameId) {
            let i = r.get(t.frameId);
            $e68ba20b3d2d159d$var$Lc(i && $e68ba20b3d2d159d$var$ep(i), "not an ExcalidrawFrameElement"), i && this.pendingNodes.every((a)=>$e68ba20b3d2d159d$var$Ru([
                    a
                ], i, r) || $e68ba20b3d2d159d$var$No(a, i, r)) && (this.pendingNodes = this.pendingNodes.map((a)=>$e68ba20b3d2d159d$export$55655e96a21bba2e(a, {
                    frameId: t.frameId
                }, !1)));
        }
    }
    clear() {
        this.isCreatingChart = !1, this.pendingNodes = null, this.direction = null, this.numberOfNodes = 0;
    }
}, $e68ba20b3d2d159d$var$kC = (e, t)=>{
    for (let [, r] of t)if (r.type === "arrow" && (r.startBinding?.elementId === e.id || r.endBinding?.elementId === e.id)) return !0;
    return !1;
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$Wi();
var $e68ba20b3d2d159d$var$w_ = 8, $e68ba20b3d2d159d$var$PC = 99999, $e68ba20b3d2d159d$var$lg = (e)=>$e68ba20b3d2d159d$var$w_ / e, $e68ba20b3d2d159d$var$Uo = class e {
    static referenceSnapPoints = null;
    static visibleGaps = null;
    static setReferenceSnapPoints = (t)=>{
        e.referenceSnapPoints = t;
    };
    static getReferenceSnapPoints = ()=>e.referenceSnapPoints;
    static setVisibleGaps = (t)=>{
        e.visibleGaps = t;
    };
    static getVisibleGaps = ()=>e.visibleGaps;
    static destroy = ()=>{
        e.referenceSnapPoints = null, e.visibleGaps = null;
    };
}, $e68ba20b3d2d159d$var$ba = (e)=>e.props.gridModeEnabled ?? e.state.gridModeEnabled, $e68ba20b3d2d159d$var$Di = ({ event: e, app: t, selectedElements: r })=>e ? t.state.objectsSnapModeEnabled && !e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || !t.state.objectsSnapModeEnabled && e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !$e68ba20b3d2d159d$var$ba(t) : r.length === 1 && r[0].type === "arrow" ? !1 : t.state.objectsSnapModeEnabled, $e68ba20b3d2d159d$var$v_ = (e, t, r = .01)=>Math.abs(e - t) <= r, $e68ba20b3d2d159d$var$sm = (e, t, { omitCenter: r, boundingBoxCorners: o, dragOffset: n } = {
    omitCenter: !1,
    boundingBoxCorners: !1
})=>{
    let i = [];
    if (e.length === 1) {
        let a = e[0], [s, l, c, d, m, p] = $e68ba20b3d2d159d$var$ae(a, t);
        n && (s += n.x, c += n.x, m += n.x, l += n.y, d += n.y, p += n.y);
        let u = (c - s) / 2, h = (d - l) / 2;
        if ((a.type === "diamond" || a.type === "ellipse") && !o) {
            let g = $e68ba20b3d2d159d$var$J([
                s,
                l + h
            ], [
                m,
                p
            ], a.angle), b = $e68ba20b3d2d159d$var$J([
                s + u,
                l
            ], [
                m,
                p
            ], a.angle), v = $e68ba20b3d2d159d$var$J([
                c,
                l + h
            ], [
                m,
                p
            ], a.angle), y = $e68ba20b3d2d159d$var$J([
                s + u,
                d
            ], [
                m,
                p
            ], a.angle);
            i = r ? [
                g,
                b,
                v,
                y
            ] : [
                g,
                b,
                v,
                y,
                [
                    m,
                    p
                ]
            ];
        } else {
            let g = $e68ba20b3d2d159d$var$J([
                s,
                l
            ], [
                m,
                p
            ], a.angle), b = $e68ba20b3d2d159d$var$J([
                c,
                l
            ], [
                m,
                p
            ], a.angle), v = $e68ba20b3d2d159d$var$J([
                s,
                d
            ], [
                m,
                p
            ], a.angle), y = $e68ba20b3d2d159d$var$J([
                c,
                d
            ], [
                m,
                p
            ], a.angle);
            i = r ? [
                g,
                b,
                v,
                y
            ] : [
                g,
                b,
                v,
                y,
                [
                    m,
                    p
                ]
            ];
        }
    } else if (e.length > 1) {
        let [a, s, l, c] = $e68ba20b3d2d159d$var$Uu(e, n ?? {
            x: 0,
            y: 0
        }), d = l - a, m = c - s, p = [
            a,
            s
        ], u = [
            l,
            s
        ], h = [
            a,
            c
        ], g = [
            l,
            c
        ], b = [
            a + d / 2,
            s + m / 2
        ];
        i = r ? [
            p,
            u,
            h,
            g
        ] : [
            p,
            u,
            h,
            g,
            b
        ];
    }
    return i.map((a)=>[
            $e68ba20b3d2d159d$var$yt(a[0]),
            $e68ba20b3d2d159d$var$yt(a[1])
        ]);
}, $e68ba20b3d2d159d$var$_C = (e, t, r, o)=>{
    let n = t.filter((i)=>$e68ba20b3d2d159d$var$re(i)).map((i)=>i.id);
    return $e68ba20b3d2d159d$var$ux(e, t, r, o).filter((i)=>!(i.frameId && n.includes(i.frameId)));
}, $e68ba20b3d2d159d$var$RC = (e, t, r, o)=>{
    let n = $e68ba20b3d2d159d$var$_C(e, t, r, o), i = $e68ba20b3d2d159d$var$Wa(n, o).filter((m)=>!(m.length === 1 && $e68ba20b3d2d159d$var$Ge(m[0]))).map((m)=>$e68ba20b3d2d159d$export$3e54c0515ef60d1d(m).map((p)=>$e68ba20b3d2d159d$var$yt(p))), a = i.sort((m, p)=>m[0] - p[0]), s = [], l = 0;
    e: for(let m = 0; m < a.length; m++){
        let p = a[m];
        for(let u = m + 1; u < a.length; u++){
            if (++l > $e68ba20b3d2d159d$var$PC) break e;
            let h = a[u], [, g, b, v] = p, [y, w, , I] = h;
            b < y && $e68ba20b3d2d159d$var$Md([
                g,
                v
            ], [
                w,
                I
            ]) && s.push({
                startBounds: p,
                endBounds: h,
                startSide: [
                    [
                        b,
                        g
                    ],
                    [
                        b,
                        v
                    ]
                ],
                endSide: [
                    [
                        y,
                        w
                    ],
                    [
                        y,
                        I
                    ]
                ],
                length: y - b,
                overlap: $e68ba20b3d2d159d$var$kd([
                    g,
                    v
                ], [
                    w,
                    I
                ])
            });
        }
    }
    let c = i.sort((m, p)=>m[1] - p[1]), d = [];
    l = 0;
    e: for(let m = 0; m < c.length; m++){
        let p = c[m];
        for(let u = m + 1; u < c.length; u++){
            if (++l > $e68ba20b3d2d159d$var$PC) break e;
            let h = c[u], [g, , b, v] = p, [y, w, I] = h;
            v < w && $e68ba20b3d2d159d$var$Md([
                g,
                b
            ], [
                y,
                I
            ]) && d.push({
                startBounds: p,
                endBounds: h,
                startSide: [
                    [
                        g,
                        v
                    ],
                    [
                        b,
                        v
                    ]
                ],
                endSide: [
                    [
                        y,
                        w
                    ],
                    [
                        I,
                        w
                    ]
                ],
                length: w - v,
                overlap: $e68ba20b3d2d159d$var$kd([
                    g,
                    b
                ], [
                    y,
                    I
                ])
            });
        }
    }
    return {
        horizontalGaps: s,
        verticalGaps: d
    };
}, $e68ba20b3d2d159d$var$LC = (e, t, r, o, n, i, a)=>{
    if (!$e68ba20b3d2d159d$var$Di({
        app: r,
        event: o,
        selectedElements: e
    })) return [];
    if (e.length === 0) return [];
    let s = $e68ba20b3d2d159d$var$Uo.getVisibleGaps();
    if (s) {
        let { horizontalGaps: l, verticalGaps: c } = s, [d, m, p, u] = $e68ba20b3d2d159d$var$Uu(e, t).map((b)=>$e68ba20b3d2d159d$var$yt(b)), h = (d + p) / 2, g = (m + u) / 2;
        for (let b of l){
            if (!$e68ba20b3d2d159d$var$Md([
                m,
                u
            ], b.overlap)) continue;
            let v = b.startSide[0][0] + b.length / 2, y = $e68ba20b3d2d159d$var$yt(v - h);
            if (b.length > p - d && Math.abs(y) <= a.x) {
                Math.abs(y) < a.x && (n.length = 0), a.x = Math.abs(y);
                let A = {
                    type: "gap",
                    direction: "center_horizontal",
                    gap: b,
                    offset: y
                };
                n.push(A);
                continue;
            }
            let [, , I] = b.endBounds, M = d - I, C = $e68ba20b3d2d159d$var$yt(b.length - M);
            if (Math.abs(C) <= a.x) {
                Math.abs(C) < a.x && (n.length = 0), a.x = Math.abs(C);
                let A = {
                    type: "gap",
                    direction: "side_right",
                    gap: b,
                    offset: C
                };
                n.push(A);
                continue;
            }
            let [P] = b.startBounds, k = P - p, _ = $e68ba20b3d2d159d$var$yt(k - b.length);
            if (Math.abs(_) <= a.x) {
                Math.abs(_) < a.x && (n.length = 0), a.x = Math.abs(_);
                let A = {
                    type: "gap",
                    direction: "side_left",
                    gap: b,
                    offset: _
                };
                n.push(A);
                continue;
            }
        }
        for (let b of c){
            if (!$e68ba20b3d2d159d$var$Md([
                d,
                p
            ], b.overlap)) continue;
            let v = b.startSide[0][1] + b.length / 2, y = $e68ba20b3d2d159d$var$yt(v - g);
            if (b.length > u - m && Math.abs(y) <= a.y) {
                Math.abs(y) < a.y && (i.length = 0), a.y = Math.abs(y);
                let A = {
                    type: "gap",
                    direction: "center_vertical",
                    gap: b,
                    offset: y
                };
                i.push(A);
                continue;
            }
            let [, I] = b.startBounds, M = I - u, C = $e68ba20b3d2d159d$var$yt(M - b.length);
            if (Math.abs(C) <= a.y) {
                Math.abs(C) < a.y && (i.length = 0), a.y = Math.abs(C);
                let A = {
                    type: "gap",
                    direction: "side_top",
                    gap: b,
                    offset: C
                };
                i.push(A);
                continue;
            }
            let [, , , P] = b.endBounds, k = $e68ba20b3d2d159d$var$yt(m - P), _ = b.length - k;
            if (Math.abs(_) <= a.y) {
                Math.abs(_) < a.y && (i.length = 0), a.y = Math.abs(_);
                let A = {
                    type: "gap",
                    direction: "side_bottom",
                    gap: b,
                    offset: _
                };
                i.push(A);
                continue;
            }
        }
    }
}, $e68ba20b3d2d159d$var$NC = (e, t, r, o)=>{
    let n = $e68ba20b3d2d159d$var$_C(e, t, r, o);
    return $e68ba20b3d2d159d$var$Wa(n, o).filter((i)=>!(i.length === 1 && $e68ba20b3d2d159d$var$Ge(i[0]))).flatMap((i)=>$e68ba20b3d2d159d$var$sm(i, o));
}, $e68ba20b3d2d159d$var$mc = (e, t, r, o, n, i, a)=>{
    if (!$e68ba20b3d2d159d$var$Di({
        app: r,
        event: o,
        selectedElements: e
    }) || e.length === 0 && t.length === 0) return [];
    let s = $e68ba20b3d2d159d$var$Uo.getReferenceSnapPoints();
    if (s) for (let l of t)for (let c of s){
        let d = c[0] - l[0], m = c[1] - l[1];
        Math.abs(d) <= a.x && (Math.abs(d) < a.x && (n.length = 0), n.push({
            type: "point",
            points: [
                l,
                c
            ],
            offset: d
        }), a.x = Math.abs(d)), Math.abs(m) <= a.y && (Math.abs(m) < a.y && (i.length = 0), i.push({
            type: "point",
            points: [
                l,
                c
            ],
            offset: m
        }), a.y = Math.abs(m));
    }
}, $e68ba20b3d2d159d$var$OC = (e, t, r, o, n)=>{
    let i = r.state, a = $e68ba20b3d2d159d$var$pe(e, i);
    if (!$e68ba20b3d2d159d$var$Di({
        app: r,
        event: o,
        selectedElements: a
    }) || a.length === 0) return {
        snapOffset: {
            x: 0,
            y: 0
        },
        snapLines: []
    };
    t.x = $e68ba20b3d2d159d$var$yt(t.x), t.y = $e68ba20b3d2d159d$var$yt(t.y);
    let s = [], l = [], c = $e68ba20b3d2d159d$var$lg(i.zoom.value), d = {
        x: c,
        y: c
    }, m = $e68ba20b3d2d159d$var$sm(a, n, {
        dragOffset: t
    });
    $e68ba20b3d2d159d$var$mc(a, m, r, o, s, l, d), $e68ba20b3d2d159d$var$LC(a, t, r, o, s, l, d);
    let p = {
        x: s[0]?.offset ?? 0,
        y: l[0]?.offset ?? 0
    };
    d.x = 0, d.y = 0, s.length = 0, l.length = 0;
    let u = {
        x: $e68ba20b3d2d159d$var$yt(t.x + p.x),
        y: $e68ba20b3d2d159d$var$yt(t.y + p.y)
    };
    $e68ba20b3d2d159d$var$mc(a, $e68ba20b3d2d159d$var$sm(a, n, {
        dragOffset: u
    }), r, o, s, l, d), $e68ba20b3d2d159d$var$LC(a, u, r, o, s, l, d);
    let h = $e68ba20b3d2d159d$var$Xb(s, l), g = $e68ba20b3d2d159d$var$S_(a, u, [
        ...s,
        ...l
    ].filter((b)=>b.type === "gap"));
    return {
        snapOffset: p,
        snapLines: [
            ...h,
            ...g
        ]
    };
}, $e68ba20b3d2d159d$var$yt = (e)=>Math.round(e * 10 ** 6) / 10 ** 6, $e68ba20b3d2d159d$var$DC = (e)=>{
    let t = new Map;
    for (let r of e){
        let o = r.join(",");
        t.has(o) || t.set(o, r);
    }
    return Array.from(t.values());
}, $e68ba20b3d2d159d$var$Xb = (e, t)=>{
    let r = {}, o = {};
    if (e.length > 0) {
        for (let n of e)if (n.type === "point") {
            let i = $e68ba20b3d2d159d$var$yt(n.points[0][0]);
            r[i] || (r[i] = []), r[i].push(...n.points.map((a)=>[
                    $e68ba20b3d2d159d$var$yt(a[0]),
                    $e68ba20b3d2d159d$var$yt(a[1])
                ]));
        }
    }
    if (t.length > 0) {
        for (let n of t)if (n.type === "point") {
            let i = $e68ba20b3d2d159d$var$yt(n.points[0][1]);
            o[i] || (o[i] = []), o[i].push(...n.points.map((a)=>[
                    $e68ba20b3d2d159d$var$yt(a[0]),
                    $e68ba20b3d2d159d$var$yt(a[1])
                ]));
        }
    }
    return Object.entries(r).map(([n, i])=>({
            type: "points",
            points: $e68ba20b3d2d159d$var$DC(i.map((a)=>[
                    Number(n),
                    a[1]
                ]).sort((a, s)=>a[1] - s[1]))
        })).concat(Object.entries(o).map(([n, i])=>({
            type: "points",
            points: $e68ba20b3d2d159d$var$DC(i.map((a)=>[
                    a[0],
                    Number(n)
                ]).sort((a, s)=>a[0] - s[0]))
        })));
}, $e68ba20b3d2d159d$var$T_ = (e)=>{
    let t = new Map;
    for (let r of e){
        let o = r.points.flat().map((n)=>[
                $e68ba20b3d2d159d$var$yt(n)
            ]).join(",");
        t.has(o) || t.set(o, r);
    }
    return Array.from(t.values());
}, $e68ba20b3d2d159d$var$S_ = (e, t, r)=>{
    let [o, n, i, a] = $e68ba20b3d2d159d$var$Uu(e, t), s = [];
    for (let l of r){
        let [c, d, m, p] = l.gap.startBounds, [u, h, g, b] = l.gap.endBounds, v = $e68ba20b3d2d159d$var$kd([
            n,
            a
        ], l.gap.overlap), y = $e68ba20b3d2d159d$var$kd([
            o,
            i
        ], l.gap.overlap);
        switch(l.direction){
            case "center_horizontal":
                if (v) {
                    let w = (v[0] + v[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                l.gap.startSide[0][0],
                                w
                            ],
                            [
                                o,
                                w
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                i,
                                w
                            ],
                            [
                                l.gap.endSide[0][0],
                                w
                            ]
                        ]
                    });
                }
                break;
            case "center_vertical":
                if (y) {
                    let w = (y[0] + y[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                l.gap.startSide[0][1]
                            ],
                            [
                                w,
                                n
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                a
                            ],
                            [
                                w,
                                l.gap.endSide[0][1]
                            ]
                        ]
                    });
                }
                break;
            case "side_right":
                if (v) {
                    let w = (v[0] + v[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                m,
                                w
                            ],
                            [
                                u,
                                w
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                g,
                                w
                            ],
                            [
                                o,
                                w
                            ]
                        ]
                    });
                }
                break;
            case "side_left":
                if (v) {
                    let w = (v[0] + v[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                i,
                                w
                            ],
                            [
                                c,
                                w
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "horizontal",
                        points: [
                            [
                                m,
                                w
                            ],
                            [
                                u,
                                w
                            ]
                        ]
                    });
                }
                break;
            case "side_top":
                if (y) {
                    let w = (y[0] + y[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                a
                            ],
                            [
                                w,
                                d
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                p
                            ],
                            [
                                w,
                                h
                            ]
                        ]
                    });
                }
                break;
            case "side_bottom":
                if (y) {
                    let w = (y[0] + y[1]) / 2;
                    s.push({
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                p
                            ],
                            [
                                w,
                                h
                            ]
                        ]
                    }, {
                        type: "gap",
                        direction: "vertical",
                        points: [
                            [
                                w,
                                b
                            ],
                            [
                                w,
                                n
                            ]
                        ]
                    });
                }
                break;
        }
    }
    return $e68ba20b3d2d159d$var$T_(s.map((l)=>({
            ...l,
            points: l.points.map((c)=>[
                    $e68ba20b3d2d159d$var$yt(c[0]),
                    $e68ba20b3d2d159d$var$yt(c[1])
                ])
        })));
}, $e68ba20b3d2d159d$var$FC = (e, t, r, o, n, i)=>{
    if (!$e68ba20b3d2d159d$var$Di({
        event: o,
        selectedElements: e,
        app: r
    }) || e.length === 0 || e.length === 1 && !$e68ba20b3d2d159d$var$v_(e[0].angle, 0)) return {
        snapOffset: {
            x: 0,
            y: 0
        },
        snapLines: []
    };
    let [a, s, l, c] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(t);
    i && (i.includes("e") ? l += n.x : i.includes("w") && (a += n.x), i.includes("n") ? s += n.y : i.includes("s") && (c += n.y));
    let d = [];
    if (i) switch(i){
        case "e":
            d.push([
                l,
                s
            ], [
                l,
                c
            ]);
            break;
        case "w":
            d.push([
                a,
                s
            ], [
                a,
                c
            ]);
            break;
        case "n":
            d.push([
                a,
                s
            ], [
                l,
                s
            ]);
            break;
        case "s":
            d.push([
                a,
                c
            ], [
                l,
                c
            ]);
            break;
        case "ne":
            d.push([
                l,
                s
            ]);
            break;
        case "nw":
            d.push([
                a,
                s
            ]);
            break;
        case "se":
            d.push([
                l,
                c
            ]);
            break;
        case "sw":
            d.push([
                a,
                c
            ]);
            break;
    }
    let m = $e68ba20b3d2d159d$var$lg(r.state.zoom.value), p = {
        x: m,
        y: m
    }, u = [], h = [];
    $e68ba20b3d2d159d$var$mc(t, d, r, o, u, h, p);
    let g = {
        x: u[0]?.offset ?? 0,
        y: h[0]?.offset ?? 0
    };
    p.x = 0, p.y = 0, u.length = 0, h.length = 0;
    let [b, v, y, w] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e).map((C)=>$e68ba20b3d2d159d$var$yt(C));
    $e68ba20b3d2d159d$var$mc(e, [
        [
            b,
            v
        ],
        [
            b,
            w
        ],
        [
            y,
            v
        ],
        [
            y,
            w
        ]
    ], r, o, u, h, p);
    let M = $e68ba20b3d2d159d$var$Xb(u, h);
    return {
        snapOffset: g,
        snapLines: M
    };
}, $e68ba20b3d2d159d$var$BC = (e, t, r, o, n, i)=>{
    if (!$e68ba20b3d2d159d$var$Di({
        event: r,
        selectedElements: [
            e
        ],
        app: t
    })) return {
        snapOffset: {
            x: 0,
            y: 0
        },
        snapLines: []
    };
    let a = [
        [
            o.x + n.x,
            o.y + n.y
        ]
    ], s = $e68ba20b3d2d159d$var$lg(t.state.zoom.value), l = {
        x: s,
        y: s
    }, c = [], d = [];
    $e68ba20b3d2d159d$var$mc([
        e
    ], a, t, r, c, d, l);
    let m = {
        x: c[0]?.offset ?? 0,
        y: d[0]?.offset ?? 0
    };
    l.x = 0, l.y = 0, c.length = 0, d.length = 0;
    let p = $e68ba20b3d2d159d$var$sm([
        e
    ], i, {
        boundingBoxCorners: !0,
        omitCenter: !0
    });
    $e68ba20b3d2d159d$var$mc([
        e
    ], p, t, r, c, d, l);
    let u = $e68ba20b3d2d159d$var$Xb(c, d);
    return {
        snapOffset: m,
        snapLines: u
    };
}, $e68ba20b3d2d159d$var$zC = (e, t, r, o, n)=>{
    if (!$e68ba20b3d2d159d$var$Di({
        event: o,
        selectedElements: [],
        app: t
    })) return {
        originOffset: {
            x: 0,
            y: 0
        },
        snapLines: []
    };
    let i = $e68ba20b3d2d159d$var$ux(e, [], t.state, n), a = $e68ba20b3d2d159d$var$lg(t.state.zoom.value), s = {
        x: a,
        y: a
    }, l = [], c = [];
    for (let d of i){
        let m = $e68ba20b3d2d159d$var$sm([
            d
        ], n);
        for (let p of m){
            let u = p[0] - r.x;
            Math.abs(u) <= Math.abs(s.x) && (Math.abs(u) < Math.abs(s.x) && (c.length = 0), c.push({
                type: "pointer",
                points: [
                    p,
                    [
                        p[0],
                        r.y
                    ]
                ],
                direction: "vertical"
            }), s.x = u);
            let h = p[1] - r.y;
            Math.abs(h) <= Math.abs(s.y) && (Math.abs(h) < Math.abs(s.y) && (l.length = 0), l.push({
                type: "pointer",
                points: [
                    p,
                    [
                        r.x,
                        p[1]
                    ]
                ],
                direction: "horizontal"
            }), s.y = h);
        }
    }
    return {
        originOffset: {
            x: c.length > 0 ? c[0].points[0][0] - r.x : 0,
            y: l.length > 0 ? l[0].points[0][1] - r.y : 0
        },
        snapLines: [
            ...c,
            ...l
        ]
    };
}, $e68ba20b3d2d159d$var$HC = (e)=>e === $e68ba20b3d2d159d$var$St.rectangle || e === $e68ba20b3d2d159d$var$St.ellipse || e === $e68ba20b3d2d159d$var$St.diamond || e === $e68ba20b3d2d159d$var$St.frame || e === $e68ba20b3d2d159d$var$St.magicframe || e === $e68ba20b3d2d159d$var$St.image || e === $e68ba20b3d2d159d$var$St.text;
var $e68ba20b3d2d159d$var$I_ = ({ appState: e, isMobile: t, device: r, app: o })=>{
    let { activeTool: n, isResizing: i, isRotating: a, lastPointerDownWith: s } = e, l = e.multiElement !== null;
    if (e.openSidebar && !r.editor.canFitSidebar) return null;
    if ($e68ba20b3d2d159d$var$Jr(e)) return $e68ba20b3d2d159d$var$x("hints.eraserRevert");
    if (n.type === "arrow" || n.type === "line") return l ? $e68ba20b3d2d159d$var$x("hints.linearElementMulti") : n.type === "arrow" ? $e68ba20b3d2d159d$var$x("hints.arrowTool", {
        arrowShortcut: $e68ba20b3d2d159d$var$O("A")
    }) : $e68ba20b3d2d159d$var$x("hints.linearElement");
    if (n.type === "freedraw") return $e68ba20b3d2d159d$var$x("hints.freeDraw");
    if (n.type === "text") return $e68ba20b3d2d159d$var$x("hints.text");
    if (n.type === "embeddable") return $e68ba20b3d2d159d$var$x("hints.embeddable");
    if (e.activeTool.type === "image" && e.pendingImageElementId) return $e68ba20b3d2d159d$var$x("hints.placeImage");
    let c = o.scene.getSelectedElements(e);
    if (i && s === "mouse" && c.length === 1) {
        let d = c[0];
        return $e68ba20b3d2d159d$export$5df2ebb939539835(d) && d.points.length === 2 ? $e68ba20b3d2d159d$var$x("hints.lockAngle") : $e68ba20b3d2d159d$var$Ao(d) ? $e68ba20b3d2d159d$var$x("hints.resizeImage") : $e68ba20b3d2d159d$var$x("hints.resize");
    }
    if (a && s === "mouse") return $e68ba20b3d2d159d$var$x("hints.rotate");
    if (c.length === 1 && $e68ba20b3d2d159d$var$G(c[0])) return $e68ba20b3d2d159d$var$x("hints.text_selected");
    if (e.editingTextElement) return $e68ba20b3d2d159d$var$x("hints.text_editing");
    if (n.type === "selection") {
        if (e.selectionElement && !c.length && !e.editingTextElement && !e.editingLinearElement) return $e68ba20b3d2d159d$var$x("hints.deepBoxSelect");
        if ($e68ba20b3d2d159d$var$ba(o) && e.selectedElementsAreBeingDragged) return $e68ba20b3d2d159d$var$x("hints.disableSnapping");
        if (!c.length && !t) return $e68ba20b3d2d159d$var$x("hints.canvasPanning");
        if (c.length === 1) {
            if ($e68ba20b3d2d159d$export$5df2ebb939539835(c[0])) return e.editingLinearElement ? e.editingLinearElement.selectedPointsIndices ? $e68ba20b3d2d159d$var$x("hints.lineEditor_pointSelected") : $e68ba20b3d2d159d$var$x("hints.lineEditor_nothingSelected") : $e68ba20b3d2d159d$var$x("hints.lineEditor_info");
            if (!e.newElement && !e.selectedElementsAreBeingDragged && $e68ba20b3d2d159d$var$Dn(c[0])) return $e68ba20b3d2d159d$var$Ua(c[0]) ? $e68ba20b3d2d159d$var$kC(c[0], o.scene.getNonDeletedElementsMap()) ? [
                $e68ba20b3d2d159d$var$x("hints.bindTextToElement"),
                $e68ba20b3d2d159d$var$x("hints.createFlowchart")
            ] : [
                $e68ba20b3d2d159d$var$x("hints.bindTextToElement"),
                $e68ba20b3d2d159d$var$x("hints.createFlowchart")
            ] : $e68ba20b3d2d159d$var$x("hints.bindTextToElement");
        }
    }
    return null;
}, $e68ba20b3d2d159d$var$cg = ({ appState: e, isMobile: t, device: r, app: o })=>{
    let n = $e68ba20b3d2d159d$var$I_({
        appState: e,
        isMobile: t,
        device: r,
        app: o
    });
    if (!n) return null;
    let i = Array.isArray(n) ? n.map((a)=>$e68ba20b3d2d159d$var$O(a).replace(/\. ?$/, "")).join(". ") : $e68ba20b3d2d159d$var$O(n);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "HintViewer",
        children: (0, $7b02d682eb115277$exports.jsx)("span", {
            children: i
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$A_ = "medium", $e68ba20b3d2d159d$var$GC = {
    CHECKED: $e68ba20b3d2d159d$var$js,
    UNCHECKED: $e68ba20b3d2d159d$var$Ya
}, $e68ba20b3d2d159d$var$dg = (e)=>(0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon ToolIcon__lock", `ToolIcon_size_${$e68ba20b3d2d159d$var$A_}`, {
            "is-mobile": e.isMobile
        }),
        title: `${e.title} \u2014 Q`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "ToolIcon_type_checkbox",
                type: "checkbox",
                name: e.name,
                onChange: e.onChange,
                checked: e.checked,
                "aria-label": e.title,
                "data-testid": "toolbar-lock"
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ToolIcon__icon",
                children: e.checked ? $e68ba20b3d2d159d$var$GC.CHECKED : $e68ba20b3d2d159d$var$GC.UNCHECKED
            })
        ]
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$ya = ({ heading: e, children: t, ...r })=>{
    let { id: o } = $e68ba20b3d2d159d$var$Ft(), n = (0, $7b02d682eb115277$exports.jsx)("h2", {
        className: "visually-hidden",
        id: `${o}-${e}-title`,
        children: $e68ba20b3d2d159d$var$x(`headings.${e}`)
    });
    return (0, $7b02d682eb115277$exports.jsx)("section", {
        ...r,
        "aria-labelledby": `${o}-${e}-title`,
        children: typeof t == "function" ? t(n) : (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                n,
                t
            ]
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$yn = 4, $e68ba20b3d2d159d$var$Jn = 6, $e68ba20b3d2d159d$var$YC = "rgba(0,0,0,0.3)", $e68ba20b3d2d159d$var$XC = (e, t, r, o)=>{
    if (!e.length) return {
        horizontal: null,
        vertical: null
    };
    let [n, i, a, s] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(e), l = t / o.zoom.value, c = r / o.zoom.value, d = t - l, m = r - c, p = {
        top: parseInt($e68ba20b3d2d159d$var$kc("sat")) || 0,
        bottom: parseInt($e68ba20b3d2d159d$var$kc("sab")) || 0,
        left: parseInt($e68ba20b3d2d159d$var$kc("sal")) || 0,
        right: parseInt($e68ba20b3d2d159d$var$kc("sar")) || 0
    }, u = $e68ba20b3d2d159d$var$Sn().rtl, h = -o.scrollX + d / 2 + p.left, g = -o.scrollY + m / 2 + p.top, b = h + l - p.right, v = g + c - p.bottom, y = Math.min(n, h), w = Math.min(i, g), I = Math.max(a, b), M = Math.max(s, v);
    return {
        horizontal: h === y && b === I ? null : {
            x: Math.max(p.left, $e68ba20b3d2d159d$var$yn) + (h - y) / (I - y) * t,
            y: r - $e68ba20b3d2d159d$var$Jn - Math.max($e68ba20b3d2d159d$var$yn, p.bottom),
            width: (b - h) / (I - y) * t - Math.max($e68ba20b3d2d159d$var$yn * 2, p.left + p.right),
            height: $e68ba20b3d2d159d$var$Jn
        },
        vertical: g === w && v === M ? null : {
            x: u ? Math.max(p.left, $e68ba20b3d2d159d$var$yn) : t - $e68ba20b3d2d159d$var$Jn - Math.max(p.right, $e68ba20b3d2d159d$var$yn),
            y: (g - w) / (M - w) * r + Math.max(p.top, $e68ba20b3d2d159d$var$yn),
            width: $e68ba20b3d2d159d$var$Jn,
            height: (v - g) / (M - w) * r - Math.max($e68ba20b3d2d159d$var$yn * 2, p.top + p.bottom)
        }
    };
}, $e68ba20b3d2d159d$var$Kb = (e, t, r)=>{
    let [o, n] = [
        e.horizontal,
        e.vertical
    ].map((a)=>a != null && a.x <= t && t <= a.x + a.width && a.y <= r && r <= a.y + a.height);
    return {
        isOverEither: o || n,
        isOverHorizontal: o,
        isOverVertical: n
    };
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$D_ = "medium", $e68ba20b3d2d159d$var$mg = (e)=>e.penDetected ? (0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon ToolIcon__penMode", `ToolIcon_size_${$e68ba20b3d2d159d$var$D_}`, {
            "is-mobile": e.isMobile
        }),
        title: `${e.title}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "ToolIcon_type_checkbox",
                type: "checkbox",
                name: e.name,
                onChange: e.onChange,
                checked: e.checked,
                "aria-label": e.title
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ToolIcon__icon",
                children: $e68ba20b3d2d159d$var$_y
            })
        ]
    }) : null;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$pg = (e)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("Shape", {
            fillable: !1
        }),
        type: "radio",
        icon: $e68ba20b3d2d159d$var$yp,
        name: "editor-current-shape",
        checked: e.checked,
        title: `${e.title} \u2014 H`,
        keyBindingLabel: e.isMobile ? void 0 : $e68ba20b3d2d159d$var$S.H.toLocaleUpperCase(),
        "aria-label": `${e.title} \u2014 H`,
        "aria-keyshortcuts": $e68ba20b3d2d159d$var$S.H,
        "data-testid": "toolbar-hand",
        onChange: ()=>e.onChange?.()
    });
$e68ba20b3d2d159d$var$Qr();
var $e68ba20b3d2d159d$var$$C = ({ appState: e, elements: t, actionManager: r, setAppState: o, onLockToggle: n, onHandToolToggle: i, onPenModeToggle: a, renderTopRightUI: s, renderCustomStats: l, renderSidebars: c, device: d, renderWelcomeScreen: m, UIOptions: p, app: u })=>{
    let { WelcomeScreenCenterTunnel: h, MainMenuTunnel: g, DefaultSidebarTriggerTunnel: b } = $e68ba20b3d2d159d$var$pt(), v = ()=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$ig, {
            side: "top",
            className: "App-top-bar",
            children: [
                m && (0, $7b02d682eb115277$exports.jsx)(h.Out, {}),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ya, {
                    heading: "shapes",
                    children: (w)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Col, {
                            gap: 4,
                            align: "center",
                            children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Row, {
                                gap: 1,
                                className: "App-toolbar-container",
                                children: [
                                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
                                        padding: 1,
                                        className: "App-toolbar App-toolbar--mobile",
                                        children: [
                                            w,
                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Row, {
                                                gap: 1,
                                                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Jh, {
                                                    appState: e,
                                                    activeTool: e.activeTool,
                                                    UIOptions: p,
                                                    app: u
                                                })
                                            })
                                        ]
                                    }),
                                    s && s(!0, e),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mobile-misc-tools-container",
                                        children: [
                                            !e.viewModeEnabled && (0, $7b02d682eb115277$exports.jsx)(b.Out, {}),
                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$mg, {
                                                checked: e.penMode,
                                                onChange: ()=>a(null),
                                                title: $e68ba20b3d2d159d$var$x("toolBar.penMode"),
                                                isMobile: !0,
                                                penDetected: e.penDetected
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$dg, {
                                                checked: e.activeTool.locked,
                                                onChange: n,
                                                title: $e68ba20b3d2d159d$var$x("toolBar.lock"),
                                                isMobile: !0
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pg, {
                                                checked: $e68ba20b3d2d159d$var$Jo(e),
                                                onChange: ()=>i(),
                                                title: $e68ba20b3d2d159d$var$x("toolBar.hand"),
                                                isMobile: !0
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$cg, {
                    appState: e,
                    isMobile: !0,
                    device: d,
                    app: u
                })
            ]
        }), y = ()=>e.viewModeEnabled ? (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "App-toolbar-content",
            children: (0, $7b02d682eb115277$exports.jsx)(g.Out, {})
        }) : (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "App-toolbar-content",
            children: [
                (0, $7b02d682eb115277$exports.jsx)(g.Out, {}),
                r.renderAction("toggleEditMenu"),
                r.renderAction("undo"),
                r.renderAction("redo"),
                r.renderAction(e.multiElement ? "finalize" : "duplicateSelection"),
                r.renderAction("deleteSelectedElements")
            ]
        });
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            c(),
            !e.viewModeEnabled && v(),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "App-bottom-bar",
                style: {
                    marginBottom: $e68ba20b3d2d159d$var$Jn + $e68ba20b3d2d159d$var$yn * 2,
                    marginLeft: $e68ba20b3d2d159d$var$Jn + $e68ba20b3d2d159d$var$yn * 2,
                    marginRight: $e68ba20b3d2d159d$var$Jn + $e68ba20b3d2d159d$var$yn * 2
                },
                children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
                    padding: 0,
                    children: [
                        e.openMenu === "shape" && !e.viewModeEnabled && $e68ba20b3d2d159d$var$vs(e, t) ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ya, {
                            className: "App-mobile-menu",
                            heading: "selectedShapeActions",
                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$qh, {
                                appState: e,
                                elementsMap: u.scene.getNonDeletedElementsMap(),
                                renderAction: r.renderAction
                            })
                        }) : null,
                        (0, $7b02d682eb115277$exports.jsxs)("footer", {
                            className: "App-toolbar",
                            children: [
                                y(),
                                e.scrolledOutside && !e.openMenu && !e.openSidebar && (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "scroll-back-to-content",
                                    onClick: ()=>{
                                        o((w)=>({
                                                ...$e68ba20b3d2d159d$var$Hn(t, w)
                                            }));
                                    },
                                    children: $e68ba20b3d2d159d$var$x("buttons.scrollBackToContent")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$PE();
$e68ba20b3d2d159d$var$yd();
var $e68ba20b3d2d159d$var$ZC = (e)=>{
    let t = (0, $acw62.useRef)(null), [r, o] = (0, $acw62.useState)(null);
    return (0, $acw62.useLayoutEffect)(()=>{
        if (!e.spreadsheet) return;
        let n = $e68ba20b3d2d159d$var$MT(e.chartType, e.spreadsheet, 0, 0);
        o(n);
        let i, a = t.current;
        return (async ()=>(i = await $e68ba20b3d2d159d$var$Tl(n, {
                exportBackground: !1,
                viewBackgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white
            }, null), i.querySelector(".style-fonts")?.remove(), a.replaceChildren(), a.appendChild(i), e.selected && a.parentNode.focus()))(), ()=>{
            a.replaceChildren();
        };
    }, [
        e.spreadsheet,
        e.chartType,
        e.selected
    ]), (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        className: "ChartPreview",
        onClick: ()=>{
            r && e.onClick(e.chartType, r);
        },
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: t
        })
    });
}, $e68ba20b3d2d159d$var$jC = ({ setAppState: e, appState: t, onClose: r })=>{
    let { onInsertElements: o } = $e68ba20b3d2d159d$var$Bt(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        r && r();
    }, [
        r
    ]), i = (a, s)=>{
        o(s), $e68ba20b3d2d159d$var$Pe("paste", "chart", a), e({
            currentChartType: a,
            pasteDialog: {
                shown: !1,
                data: null
            }
        });
    };
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
        size: "small",
        onCloseRequest: n,
        title: $e68ba20b3d2d159d$var$x("labels.pasteCharts"),
        className: "PasteChartDialog",
        autofocus: !1,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "container",
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ZC, {
                    chartType: "bar",
                    spreadsheet: t.pasteDialog.data,
                    selected: t.currentChartType === "bar",
                    onClick: i
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ZC, {
                    chartType: "line",
                    spreadsheet: t.pasteDialog.data,
                    selected: t.currentChartType === "line",
                    onClick: i
                })
            ]
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$V_ = ()=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "HelpDialog__header",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "HelpDialog__btn",
                href: "https://docs.excalidraw.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "HelpDialog__link-icon",
                        children: $e68ba20b3d2d159d$var$Ef
                    }),
                    $e68ba20b3d2d159d$var$x("helpDialog.documentation")
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "HelpDialog__btn",
                href: "https://blog.excalidraw.com",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "HelpDialog__link-icon",
                        children: $e68ba20b3d2d159d$var$Ef
                    }),
                    $e68ba20b3d2d159d$var$x("helpDialog.blog")
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "HelpDialog__btn",
                href: "https://github.com/excalidraw/excalidraw/issues",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "HelpDialog__link-icon",
                        children: $e68ba20b3d2d159d$var$gp
                    }),
                    $e68ba20b3d2d159d$var$x("helpDialog.github")
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "HelpDialog__btn",
                href: "https://youtube.com/@excalidraw",
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "HelpDialog__link-icon",
                        children: $e68ba20b3d2d159d$var$e2
                    }),
                    "YouTube"
                ]
            })
        ]
    }), $e68ba20b3d2d159d$var$Y_ = (e)=>(0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: e.title
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "HelpDialog__islands-container",
                children: e.children
            })
        ]
    }), $e68ba20b3d2d159d$var$$b = (e)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `HelpDialog__island ${e.className}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "HelpDialog__island-title",
                children: e.caption
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "HelpDialog__island-content",
                children: e.children
            })
        ]
    });
function* $e68ba20b3d2d159d$var$X_(e, t) {
    let r = !0;
    for (let o of e)r || (yield t), r = !1, yield o;
}
var $e68ba20b3d2d159d$var$K_ = (e)=>e.replace(/\b[a-z]\b/, (t)=>t.toUpperCase()), $e68ba20b3d2d159d$var$Q = ({ label: e, shortcuts: t, isOr: r = !0 })=>{
    let o = t.map((n)=>(n.endsWith("++") ? [
            ...n.slice(0, -2).split("+"),
            "+"
        ] : n.split("+")).map((a)=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$$_, {
                children: $e68ba20b3d2d159d$var$K_(a)
            }, a)));
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "HelpDialog__shortcut",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                children: e
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "HelpDialog__key-container",
                children: [
                    ...$e68ba20b3d2d159d$var$X_(o, r ? $e68ba20b3d2d159d$var$x("helpDialog.or") : null)
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$$_ = (e)=>(0, $7b02d682eb115277$exports.jsx)("kbd", {
        className: "HelpDialog__key",
        ...e
    }), $e68ba20b3d2d159d$var$qC = ({ onClose: e })=>{
    let t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        e && e();
    }, [
        e
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Mt, {
            onCloseRequest: t,
            title: $e68ba20b3d2d159d$var$x("helpDialog.title"),
            className: "HelpDialog",
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$V_, {}),
                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Y_, {
                    title: $e68ba20b3d2d159d$var$x("helpDialog.shortcuts"),
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$$b, {
                            className: "HelpDialog__island--tools",
                            caption: $e68ba20b3d2d159d$var$x("helpDialog.tools"),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.hand"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.H
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.selection"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.V,
                                        $e68ba20b3d2d159d$var$S[1]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.rectangle"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.R,
                                        $e68ba20b3d2d159d$var$S[2]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.diamond"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.D,
                                        $e68ba20b3d2d159d$var$S[3]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.ellipse"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.O,
                                        $e68ba20b3d2d159d$var$S[4]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.arrow"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.A,
                                        $e68ba20b3d2d159d$var$S[5]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.line"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.L,
                                        $e68ba20b3d2d159d$var$S[6]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.freedraw"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.P,
                                        $e68ba20b3d2d159d$var$S[7]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.text"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.T,
                                        $e68ba20b3d2d159d$var$S[8]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.image"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S[9]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.eraser"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.E,
                                        $e68ba20b3d2d159d$var$S[0]
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.frame"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.F
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.laser"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.K
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.eyeDropper"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.I,
                                        "Shift+S",
                                        "Shift+G"
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.editLineArrowPoints"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Enter")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.editText"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Enter")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.textNewLine"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Enter"),
                                        $e68ba20b3d2d159d$var$O("Shift+Enter")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.textFinish"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Esc"),
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Enter")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.curvedArrow"),
                                    shortcuts: [
                                        "A",
                                        $e68ba20b3d2d159d$var$x("helpDialog.click"),
                                        $e68ba20b3d2d159d$var$x("helpDialog.click"),
                                        $e68ba20b3d2d159d$var$x("helpDialog.click")
                                    ],
                                    isOr: !1
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.curvedLine"),
                                    shortcuts: [
                                        "L",
                                        $e68ba20b3d2d159d$var$x("helpDialog.click"),
                                        $e68ba20b3d2d159d$var$x("helpDialog.click"),
                                        $e68ba20b3d2d159d$var$x("helpDialog.click")
                                    ],
                                    isOr: !1
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.lock"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$S.Q
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.preventBinding"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("toolBar.link"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+K")
                                    ]
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$$b, {
                            className: "HelpDialog__island--view",
                            caption: $e68ba20b3d2d159d$var$x("helpDialog.view"),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.zoomIn"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd++")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.zoomOut"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+-")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.resetZoom"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+0")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.zoomToFit"),
                                    shortcuts: [
                                        "Shift+1"
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.zoomToSelection"),
                                    shortcuts: [
                                        "Shift+2"
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.movePageUpDown"),
                                    shortcuts: [
                                        "PgUp/PgDn"
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.movePageLeftRight"),
                                    shortcuts: [
                                        "Shift+PgUp/PgDn"
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.zenMode"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+Z")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.objectsSnapMode"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+S")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.toggleGrid"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+'")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.viewMode"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+R")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.toggleTheme"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+Shift+D")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("stats.fullTitle"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+/")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("commandPalette.title"),
                                    shortcuts: $e68ba20b3d2d159d$var$ni ? [
                                        $e68ba20b3d2d159d$var$zt("commandPalette")
                                    ] : [
                                        $e68ba20b3d2d159d$var$zt("commandPalette"),
                                        $e68ba20b3d2d159d$var$zt("commandPalette", 1)
                                    ]
                                })
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$$b, {
                            className: "HelpDialog__island--editor",
                            caption: $e68ba20b3d2d159d$var$x("helpDialog.editor"),
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.createFlowchart"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Arrow Key")
                                    ],
                                    isOr: !0
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.navigateFlowchart"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Alt+Arrow Key")
                                    ],
                                    isOr: !0
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.moveCanvas"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O(`Space+${$e68ba20b3d2d159d$var$x("helpDialog.drag")}`),
                                        $e68ba20b3d2d159d$var$O(`Wheel+${$e68ba20b3d2d159d$var$x("helpDialog.drag")}`)
                                    ],
                                    isOr: !0
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.clearReset"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Delete")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.delete"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Delete")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.cut"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+X")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.copy"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+C")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.paste"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+V")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.pasteAsPlaintext"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+V")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.selectAll"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+A")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.multiSelect"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O(`Shift+${$e68ba20b3d2d159d$var$x("helpDialog.click")}`)
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.deepSelect"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O(`CtrlOrCmd+${$e68ba20b3d2d159d$var$x("helpDialog.click")}`)
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.deepBoxSelect"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O(`CtrlOrCmd+${$e68ba20b3d2d159d$var$x("helpDialog.drag")}`)
                                    ]
                                }),
                                ($e68ba20b3d2d159d$var$Cl || $e68ba20b3d2d159d$var$ni) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.copyAsPng"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Shift+Alt+C")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.copyStyles"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+C")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.pasteStyles"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+V")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.sendToBack"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+[") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+[")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.bringToFront"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$_r ? $e68ba20b3d2d159d$var$O("CtrlOrCmd+Alt+]") : $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+]")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.sendBackward"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+[")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.bringForward"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+]")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.alignTop"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Up")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.alignBottom"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Down")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.alignLeft"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Left")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.alignRight"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Right")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.duplicateSelection"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+D"),
                                        $e68ba20b3d2d159d$var$O(`Alt+${$e68ba20b3d2d159d$var$x("helpDialog.drag")}`)
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("helpDialog.toggleElementLock"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+L")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.undo"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Z")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("buttons.redo"),
                                    shortcuts: $e68ba20b3d2d159d$var$Pm ? [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Y"),
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Z")
                                    ] : [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+Z")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.group"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+G")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.ungroup"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+G")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.flipHorizontal"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Shift+H")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.flipVertical"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Shift+V")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.showStroke"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("S")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.showBackground"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("G")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.showFonts"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("Shift+F")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.decreaseFontSize"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+<")
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Q, {
                                    label: $e68ba20b3d2d159d$var$x("labels.increaseFontSize"),
                                    shortcuts: [
                                        $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+>")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$j_ = 4, $e68ba20b3d2d159d$var$q_ = 8, $e68ba20b3d2d159d$var$J_ = ({ shouldWrap: e, children: t, username: r })=>e ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
        label: r || "Unknown user",
        children: t
    }) : (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: t
    }), $e68ba20b3d2d159d$var$Zb = ({ actionManager: e, collaborator: t, socketId: r, withName: o = !1, shouldWrapWithTooltip: n = !1, isBeingFollowed: i })=>{
    let a = {
        socketId: r,
        collaborator: t,
        withName: o,
        isBeingFollowed: i
    }, s = e.renderAction("goToCollaborator", a);
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$J_, {
        username: t.username,
        shouldWrap: n,
        children: s
    }, r);
}, $e68ba20b3d2d159d$var$Q_ = [
    "avatarUrl",
    "id",
    "socketId",
    "username",
    "isInCall",
    "isSpeaking",
    "isMuted"
], $e68ba20b3d2d159d$var$gg = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ className: e, mobile: t, collaborators: r, userToFollow: o })=>{
    let n = $e68ba20b3d2d159d$var$$t(), i = new Map;
    r.forEach((g, b)=>{
        let v = g.id || b;
        i.set(v, {
            ...g,
            socketId: b
        });
    });
    let a = Array.from(i.values()).filter((g)=>g.username?.trim()), [s, l] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(""), c = a.filter((g)=>g.username?.toLowerCase().includes(s)), d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (d.current) {
            let g = (v)=>{
                let y = Math.max(1, Math.min(8, Math.floor(v / 38)));
                p(y);
            };
            if (g(d.current.clientWidth), !$e68ba20b3d2d159d$var$vc) return;
            let b = new ResizeObserver((v)=>{
                for (let y of v){
                    let { width: w } = y.contentRect;
                    g(w);
                }
            });
            return b.observe(d.current), ()=>{
                b.disconnect();
            };
        }
    }, []);
    let [m, p] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($e68ba20b3d2d159d$var$j_), h = a.slice(0, m - 1).map((g)=>$e68ba20b3d2d159d$var$Zb({
            actionManager: n,
            collaborator: g,
            socketId: g.socketId,
            shouldWrapWithTooltip: !0,
            isBeingFollowed: g.socketId === o
        }));
    return t ? (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("UserList UserList_mobile", e),
        children: a.map((g)=>$e68ba20b3d2d159d$var$Zb({
                actionManager: n,
                collaborator: g,
                socketId: g.socketId,
                shouldWrapWithTooltip: !0,
                isBeingFollowed: g.socketId === o
            }))
    }) : (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "UserList__wrapper",
        ref: d,
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("UserList", e),
            style: {
                "--max-avatars": m
            },
            children: [
                h,
                a.length > m - 1 && (0, $7b02d682eb115277$exports.jsxs)($8a88ecc38cbd867b$export$be92b6f5f03c0fe9, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)($8a88ecc38cbd867b$export$41fb9f06171c75f4, {
                            className: "UserList__more",
                            children: [
                                "+",
                                a.length - m + 1
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$7c6e2c02157bb7d2, {
                            style: {
                                zIndex: 2,
                                width: "15rem",
                                textAlign: "left"
                            },
                            align: "end",
                            sideOffset: 10,
                            children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
                                padding: 2,
                                children: [
                                    a.length >= $e68ba20b3d2d159d$var$q_ && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hh, {
                                        placeholder: $e68ba20b3d2d159d$var$x("quickSearch.placeholder"),
                                        onChange: l
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gh, {
                                        className: "dropdown-menu UserList__collaborators",
                                        placeholder: $e68ba20b3d2d159d$var$x("userList.empty"),
                                        children: c.length > 0 ? [
                                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "hint",
                                                children: $e68ba20b3d2d159d$var$x("userList.hint.text")
                                            }),
                                            c.map((g)=>$e68ba20b3d2d159d$var$Zb({
                                                    actionManager: n,
                                                    collaborator: g,
                                                    socketId: g.socketId,
                                                    withName: !0,
                                                    isBeingFollowed: g.socketId === o
                                                }))
                                        ] : []
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)($8a88ecc38cbd867b$export$21b07c8f274aebd5, {
                                        width: 20,
                                        height: 10,
                                        style: {
                                            fill: "var(--popup-bg-color)",
                                            filter: "drop-shadow(rgba(0, 0, 0, 0.05) 0px 3px 2px)"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}, (e, t)=>{
    if (e.collaborators.size !== t.collaborators.size || e.mobile !== t.mobile || e.className !== t.className || e.userToFollow !== t.userToFollow) return !1;
    let r = t.collaborators.keys();
    for (let [o, n] of e.collaborators){
        let i = t.collaborators.get(o);
        if (!i || o !== r.next().value || !$e68ba20b3d2d159d$var$at(n, i, $e68ba20b3d2d159d$var$Q_)) return !1;
    }
    return !0;
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$qb = ({ children: e, color: t })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "Card",
        style: {
            "--card-color": t === "primary" ? "var(--color-primary)" : (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports)))[t][7],
            "--card-color-darker": t === "primary" ? "var(--color-primary-darker)" : (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports)))[t][8],
            "--card-color-darkest": t === "primary" ? "var(--color-primary-darkest)" : (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports)))[t][9]
        },
        children: e
    });
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$oR = ({ elements: e, appState: t, setAppState: r, files: o, actionManager: n, exportOpts: i, canvas: a, onCloseRequest: s })=>{
    let { onExportToBackend: l } = i;
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ExportDialog ExportDialog--json",
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "ExportDialog-cards",
            children: [
                i.saveFileToDisk && (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$qb, {
                    color: "lime",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Card-icon",
                            children: $e68ba20b3d2d159d$var$Yy
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: $e68ba20b3d2d159d$var$x("exportDialog.disk_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "Card-details",
                            children: [
                                $e68ba20b3d2d159d$var$x("exportDialog.disk_details"),
                                !(0, $11b096c57ac70a88$export$5f747a46dc0eb6ee) && n.renderAction("changeProjectName")
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                            className: "Card-button",
                            type: "button",
                            title: $e68ba20b3d2d159d$var$x("exportDialog.disk_button"),
                            "aria-label": $e68ba20b3d2d159d$var$x("exportDialog.disk_button"),
                            showAriaLabel: !0,
                            onClick: ()=>{
                                n.executeAction($e68ba20b3d2d159d$var$qd, "ui");
                            }
                        })
                    ]
                }),
                l && (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$qb, {
                    color: "pink",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Card-icon",
                            children: $e68ba20b3d2d159d$var$Bc
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: $e68ba20b3d2d159d$var$x("exportDialog.link_title")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "Card-details",
                            children: $e68ba20b3d2d159d$var$x("exportDialog.link_details")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                            className: "Card-button",
                            type: "button",
                            title: $e68ba20b3d2d159d$var$x("exportDialog.link_button"),
                            "aria-label": $e68ba20b3d2d159d$var$x("exportDialog.link_button"),
                            showAriaLabel: !0,
                            onClick: async ()=>{
                                try {
                                    $e68ba20b3d2d159d$var$Pe("export", "link", `ui (${$e68ba20b3d2d159d$var$J0()})`), await l(e, t, o), s();
                                } catch (c) {
                                    r({
                                        errorMessage: c.message
                                    });
                                }
                            }
                        })
                    ]
                }),
                i.renderCustomUI && i.renderCustomUI(e, t, o, a)
            ]
        })
    });
}, $e68ba20b3d2d159d$var$e5 = ({ elements: e, appState: t, files: r, actionManager: o, exportOpts: n, canvas: i, setAppState: a })=>{
    let s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        a({
            openDialog: null
        });
    }, [
        a
    ]);
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: t.openDialog?.name === "jsonExport" && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
            onCloseRequest: s,
            title: $e68ba20b3d2d159d$var$x("buttons.export"),
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$oR, {
                elements: e,
                appState: t,
                setAppState: a,
                files: r,
                actionManager: o,
                onCloseRequest: s,
                exportOpts: n,
                canvas: i
            })
        })
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$t5 = (e)=>(0, $7b02d682eb115277$exports.jsx)("button", {
        className: "help-icon",
        onClick: e.onClick,
        type: "button",
        title: `${$e68ba20b3d2d159d$var$x("helpDialog.title")} \u2014 ?`,
        "aria-label": $e68ba20b3d2d159d$var$x("helpDialog.title"),
        children: $e68ba20b3d2d159d$var$qs
    });
var $e68ba20b3d2d159d$var$r5 = ({ appState: e, actionManager: t, showExitZenModeBtn: r, renderWelcomeScreen: o })=>{
    let { FooterCenterTunnel: n, WelcomeScreenHelpHintTunnel: i } = $e68ba20b3d2d159d$var$pt(), a = $e68ba20b3d2d159d$export$aa949327762d0f40(), s = !e.viewModeEnabled && e.multiElement && a.isTouchScreen;
    return (0, $7b02d682eb115277$exports.jsxs)("footer", {
        role: "contentinfo",
        className: "layer-ui__wrapper__footer App-menu App-menu_bottom",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("layer-ui__wrapper__footer-left zen-mode-transition", {
                    "layer-ui__wrapper__footer-left--transition-left": e.zenModeEnabled
                }),
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Col, {
                    gap: 2,
                    children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$ya, {
                        heading: "canvasActions",
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$lC, {
                                renderAction: t.renderAction,
                                zoom: e.zoom
                            }),
                            !e.viewModeEnabled && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$cC, {
                                renderAction: t.renderAction,
                                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("zen-mode-transition", {
                                    "layer-ui__wrapper__footer-left--transition-bottom": e.zenModeEnabled
                                })
                            }),
                            s && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$mC, {
                                renderAction: t.renderAction,
                                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("zen-mode-transition", {
                                    "layer-ui__wrapper__footer-left--transition-left": e.zenModeEnabled
                                })
                            })
                        ]
                    })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)(n.Out, {}),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("layer-ui__wrapper__footer-right zen-mode-transition", {
                    "transition-right": e.zenModeEnabled
                }),
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    children: [
                        o && (0, $7b02d682eb115277$exports.jsx)(i.Out, {}),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$t5, {
                            onClick: ()=>t.executeAction($e68ba20b3d2d159d$var$ks)
                        })
                    ]
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$dC, {
                actionManager: t,
                showExitZenModeBtn: r
            })
        ]
    });
}, $e68ba20b3d2d159d$var$o5 = $e68ba20b3d2d159d$var$r5;
$e68ba20b3d2d159d$var$r5.displayName = "Footer";
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$xg = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$e1 = ({ children: e, className: t })=>{
    let r = $e68ba20b3d2d159d$export$aa949327762d0f40(), o = (0, $acw62.useContext)($e68ba20b3d2d159d$var$xg), n = !!(r.editor.canFitSidebar && o.shouldRenderDockButton);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("sidebar__header", t),
        "data-testid": "sidebar-header",
        children: [
            e,
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sidebar__header__buttons",
                children: [
                    n && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yo, {
                        label: $e68ba20b3d2d159d$var$x("labels.sidebarLock"),
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$353f5b6fc5456de1, {
                            onSelect: ()=>o.onDock?.(!o.docked),
                            selected: !!o.docked,
                            className: "sidebar__dock",
                            "data-testid": "sidebar-dock",
                            "aria-label": $e68ba20b3d2d159d$var$x("labels.sidebarLock"),
                            children: $e68ba20b3d2d159d$var$Ty
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$353f5b6fc5456de1, {
                        "data-testid": "sidebar-close",
                        className: "sidebar__close",
                        onSelect: o.onCloseRequest,
                        "aria-label": $e68ba20b3d2d159d$var$x("buttons.close"),
                        children: $e68ba20b3d2d159d$var$Po
                    })
                ]
            })
        ]
    });
};
$e68ba20b3d2d159d$var$e1.displayName = "SidebarHeader";
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$r1 = ({ name: e, tab: t, icon: r, title: o, children: n, onToggle: i, className: a, style: s })=>{
    let l = $e68ba20b3d2d159d$var$He(), c = $e68ba20b3d2d159d$var$Ke();
    return (0, $7b02d682eb115277$exports.jsxs)("label", {
        title: o,
        className: "sidebar-trigger__label-element",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "ToolIcon_type_checkbox",
                type: "checkbox",
                onChange: (d)=>{
                    document.querySelector(".layer-ui__wrapper")?.classList.remove("animate");
                    let m = d.target.checked;
                    l({
                        openSidebar: m ? {
                            name: e,
                            tab: t
                        } : null
                    }), i?.(m);
                },
                checked: c.openSidebar?.name === e,
                "aria-label": o,
                "aria-keyshortcuts": "0"
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("sidebar-trigger", a),
                style: s,
                children: [
                    r && (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: r
                    }),
                    n && (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "sidebar-trigger__label",
                        children: n
                    })
                ]
            })
        ]
    });
};
$e68ba20b3d2d159d$var$r1.displayName = "SidebarTrigger";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$o1 = ({ children: e, ...t })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$54c2e3dc7acea9f5, {
        className: "sidebar-triggers",
        ...t,
        children: e
    });
$e68ba20b3d2d159d$var$o1.displayName = "SidebarTabTriggers";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$n1 = ({ children: e, tab: t, onSelect: r, ...o })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$41fb9f06171c75f4, {
        value: t,
        asChild: !0,
        onSelect: r,
        children: (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "excalidraw-button sidebar-tab-trigger",
            ...o,
            children: e
        })
    });
$e68ba20b3d2d159d$var$n1.displayName = "SidebarTabTrigger";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$i1 = ({ children: e, ...t })=>{
    let r = $e68ba20b3d2d159d$var$Ke(), o = $e68ba20b3d2d159d$var$He();
    if (!r.openSidebar) return null;
    let { name: n } = r.openSidebar;
    return (0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$be92b6f5f03c0fe9, {
        className: "sidebar-tabs-root",
        value: r.openSidebar.tab,
        onValueChange: (i)=>o((a)=>({
                    ...a,
                    openSidebar: {
                        ...a.openSidebar,
                        name: n,
                        tab: i
                    }
                })),
        ...t,
        children: e
    });
};
$e68ba20b3d2d159d$var$i1.displayName = "SidebarTabs";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$a1 = ({ tab: e, children: t, ...r })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$7c6e2c02157bb7d2, {
        ...r,
        value: e,
        "data-testid": e,
        children: t
    });
$e68ba20b3d2d159d$var$a1.displayName = "SidebarTab";
var $e68ba20b3d2d159d$var$cm = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(!1), $e68ba20b3d2d159d$var$f5 = (0, $acw62.forwardRef)(({ name: e, children: t, onDock: r, docked: o, className: n, ...i }, a)=>{
    $e68ba20b3d2d159d$var$T.DEV && r && o == null && console.warn("Sidebar: `docked` must be set when `onDock` is supplied for the sidebar to be user-dockable. To hide this message, either pass `docked` or remove `onDock`");
    let s = $e68ba20b3d2d159d$var$He(), l = (0, $051474e5c5a9c9ad$export$a247c952d39ea7ea)($e68ba20b3d2d159d$var$cm, $e68ba20b3d2d159d$var$$e);
    (0, $acw62.useLayoutEffect)(()=>(l(!!o), ()=>{
            l(!1);
        }), [
        l,
        o
    ]);
    let c = (0, $acw62.useRef)({});
    c.current.onCloseRequest = ()=>{
        s({
            openSidebar: null
        });
    }, c.current.onDock = (u)=>r?.(u), c.current = $e68ba20b3d2d159d$var$Ks(c.current, {
        docked: o,
        shouldRenderDockButton: !!r && o != null
    });
    let d = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(a, ()=>d.current);
    let m = $e68ba20b3d2d159d$export$aa949327762d0f40(), p = (0, $acw62.useCallback)(()=>{
        document.querySelector(".Dialog") || s({
            openSidebar: null
        });
    }, [
        s
    ]);
    return $e68ba20b3d2d159d$var$Yl(d, (0, $acw62.useCallback)((u)=>{
        u.target.closest(".sidebar-trigger") || (!o || !m.editor.canFitSidebar) && p();
    }, [
        p,
        o,
        m.editor.canFitSidebar
    ])), (0, $acw62.useEffect)(()=>{
        let u = (h)=>{
            h.key === $e68ba20b3d2d159d$var$S.ESCAPE && (!o || !m.editor.canFitSidebar) && p();
        };
        return document.addEventListener("keydown", u), ()=>{
            document.removeEventListener("keydown", u);
        };
    }, [
        p,
        o,
        m.editor.canFitSidebar
    ]), (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kt, {
        ...i,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("sidebar", {
            "sidebar--docked": o
        }, n),
        ref: d,
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$xg.Provider, {
            value: c.current,
            children: t
        })
    });
});
$e68ba20b3d2d159d$var$f5.displayName = "SidebarInner";
var $e68ba20b3d2d159d$export$1ba59dacbcbf90fe = Object.assign((0, $acw62.forwardRef)((e, t)=>{
    let r = $e68ba20b3d2d159d$var$Ke(), { onStateChange: o } = e, n = (0, $acw62.useRef)(r.openSidebar);
    (0, $acw62.useEffect)(()=>{
        (!r.openSidebar && n?.current?.name === e.name || r.openSidebar?.name === e.name && n?.current?.name !== e.name || n.current?.name === e.name) && r.openSidebar !== n.current && o?.(r.openSidebar?.name !== e.name ? null : r.openSidebar), n.current = r.openSidebar;
    }, [
        r.openSidebar,
        o,
        e.name
    ]);
    let [i, a] = (0, $acw62.useState)(!1);
    return (0, $acw62.useLayoutEffect)(()=>(a(!0), ()=>a(!1)), []), i && r.openSidebar?.name === e.name ? (0, $acw62.createElement)($e68ba20b3d2d159d$var$f5, {
        ...e,
        ref: t,
        key: e.name
    }) : null;
}), {
    Header: $e68ba20b3d2d159d$var$e1,
    TabTriggers: $e68ba20b3d2d159d$var$o1,
    TabTrigger: $e68ba20b3d2d159d$var$n1,
    Tabs: $e68ba20b3d2d159d$var$i1,
    Tab: $e68ba20b3d2d159d$var$a1,
    Trigger: $e68ba20b3d2d159d$var$r1
});
$e68ba20b3d2d159d$export$1ba59dacbcbf90fe.displayName = "Sidebar";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$d1 = {};
$e68ba20b3d2d159d$var$Zg($e68ba20b3d2d159d$var$d1, {
    ChangeCanvasBackground: ()=>$e68ba20b3d2d159d$var$M5,
    ClearCanvas: ()=>$e68ba20b3d2d159d$var$C5,
    CommandPalette: ()=>$e68ba20b3d2d159d$var$S5,
    Export: ()=>$e68ba20b3d2d159d$var$k5,
    Help: ()=>$e68ba20b3d2d159d$var$I5,
    LiveCollaborationTrigger: ()=>$e68ba20b3d2d159d$var$L5,
    LoadScene: ()=>$e68ba20b3d2d159d$var$w5,
    SaveAsImage: ()=>$e68ba20b3d2d159d$var$T5,
    SaveToActiveFile: ()=>$e68ba20b3d2d159d$var$v5,
    Socials: ()=>$e68ba20b3d2d159d$var$P5,
    ToggleTheme: ()=>$e68ba20b3d2d159d$var$A5
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$l1 = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)({
    active: !1
});
async function $e68ba20b3d2d159d$var$E5({ title: e, description: t, actionLabel: r, color: o }) {
    return new Promise((n)=>{
        $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$l1, {
            active: !0,
            onConfirm: ()=>n(!0),
            onClose: ()=>n(!1),
            onReject: ()=>n(!1),
            title: e,
            description: t,
            actionLabel: r,
            color: o
        });
    });
}
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$b5 = ({ value: e, shortcut: t, onChange: r, choices: o, children: n, name: i })=>{
    let a = $e68ba20b3d2d159d$export$aa949327762d0f40();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dropdown-menu-item-base dropdown-menu-item-bare",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "dropdown-menu-item__text",
                        htmlFor: i,
                        children: n
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$og, {
                        name: i,
                        value: e,
                        onChange: r,
                        choices: o
                    })
                ]
            }),
            t && !a.editor.isMobile && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dropdown-menu-item__shortcut dropdown-menu-item__shortcut--orphaned",
                children: t
            })
        ]
    });
};
$e68ba20b3d2d159d$var$b5.displayName = "DropdownMenuItemContentRadio";
var $e68ba20b3d2d159d$var$y5 = $e68ba20b3d2d159d$var$b5;
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$w5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$$t(), r = $e68ba20b3d2d159d$var$ma();
    return t.isActionEnabled($e68ba20b3d2d159d$var$jl) ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        icon: $e68ba20b3d2d159d$var$Js,
        onSelect: async ()=>{
            (!r.length || await $e68ba20b3d2d159d$var$E5({
                title: e("overwriteConfirm.modal.loadFromFile.title"),
                actionLabel: e("overwriteConfirm.modal.loadFromFile.button"),
                color: "warning",
                description: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "overwriteConfirm.modal.loadFromFile.description",
                    bold: (n)=>(0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: n
                        }),
                    br: ()=>(0, $7b02d682eb115277$exports.jsx)("br", {})
                })
            })) && t.executeAction($e68ba20b3d2d159d$var$jl);
        },
        "data-testid": "load-button",
        shortcut: $e68ba20b3d2d159d$var$zt("loadScene"),
        "aria-label": e("buttons.load"),
        children: e("buttons.load")
    }) : null;
};
$e68ba20b3d2d159d$var$w5.displayName = "LoadScene";
var $e68ba20b3d2d159d$var$v5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$$t();
    return t.isActionEnabled($e68ba20b3d2d159d$var$Ch) ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        shortcut: $e68ba20b3d2d159d$var$zt("saveScene"),
        "data-testid": "save-button",
        onSelect: ()=>t.executeAction($e68ba20b3d2d159d$var$Ch),
        icon: $e68ba20b3d2d159d$var$Gy,
        "aria-label": `${e("buttons.save")}`,
        children: `${e("buttons.save")}`
    }) : null;
};
$e68ba20b3d2d159d$var$v5.displayName = "SaveToActiveFile";
var $e68ba20b3d2d159d$var$T5 = ()=>{
    let e = $e68ba20b3d2d159d$var$He(), { t: t } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        icon: $e68ba20b3d2d159d$var$Ep,
        "data-testid": "image-export-button",
        onSelect: ()=>e({
                openDialog: {
                    name: "imageExport"
                }
            }),
        shortcut: $e68ba20b3d2d159d$var$zt("imageExport"),
        "aria-label": t("buttons.exportImage"),
        children: t("buttons.exportImage")
    });
};
$e68ba20b3d2d159d$var$T5.displayName = "SaveAsImage";
var $e68ba20b3d2d159d$var$S5 = (e)=>{
    let t = $e68ba20b3d2d159d$var$He(), { t: r } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        icon: $e68ba20b3d2d159d$var$Ap,
        "data-testid": "command-palette-button",
        onSelect: ()=>{
            $e68ba20b3d2d159d$var$Pe("command_palette", "open", "menu"), t({
                openDialog: {
                    name: "commandPalette"
                }
            });
        },
        shortcut: $e68ba20b3d2d159d$var$zt("commandPalette"),
        "aria-label": r("commandPalette.title"),
        className: e?.className,
        children: r("commandPalette.title")
    });
};
$e68ba20b3d2d159d$var$S5.displayName = "CommandPalette";
var $e68ba20b3d2d159d$var$I5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$$t();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        "data-testid": "help-menu-item",
        icon: $e68ba20b3d2d159d$var$qs,
        onSelect: ()=>t.executeAction($e68ba20b3d2d159d$var$ks),
        shortcut: "?",
        "aria-label": e("helpDialog.title"),
        children: e("helpDialog.title")
    });
};
$e68ba20b3d2d159d$var$I5.displayName = "Help";
var $e68ba20b3d2d159d$var$C5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = (0, $051474e5c5a9c9ad$export$a247c952d39ea7ea)($e68ba20b3d2d159d$var$Ds, $e68ba20b3d2d159d$var$$e);
    return $e68ba20b3d2d159d$var$$t().isActionEnabled($e68ba20b3d2d159d$var$Mi) ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        icon: $e68ba20b3d2d159d$var$rn,
        onSelect: ()=>t("clearCanvas"),
        "data-testid": "clear-canvas-button",
        "aria-label": e("buttons.clearReset"),
        children: e("buttons.clearReset")
    }) : null;
};
$e68ba20b3d2d159d$var$C5.displayName = "ClearCanvas";
var $e68ba20b3d2d159d$var$A5 = (e)=>{
    let { t: t } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), r = $e68ba20b3d2d159d$var$Ke(), o = $e68ba20b3d2d159d$var$$t(), n = $e68ba20b3d2d159d$var$zt("toggleTheme");
    return o.isActionEnabled($e68ba20b3d2d159d$var$Cs) ? e?.allowSystemTheme ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$y5, {
        name: "theme",
        value: e.theme,
        onChange: (i)=>e.onSelect(i),
        choices: [
            {
                value: $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT,
                label: $e68ba20b3d2d159d$var$Fc,
                ariaLabel: `${t("buttons.lightMode")} - ${n}`
            },
            {
                value: $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK,
                label: $e68ba20b3d2d159d$var$Oc,
                ariaLabel: `${t("buttons.darkMode")} - ${n}`
            },
            {
                value: "system",
                label: $e68ba20b3d2d159d$var$Qw,
                ariaLabel: t("buttons.systemMode")
            }
        ],
        children: t("labels.theme")
    }) : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        onSelect: (i)=>{
            if (i.preventDefault(), e?.onSelect) e.onSelect(r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT : $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK);
            else return o.executeAction($e68ba20b3d2d159d$var$Cs);
        },
        icon: r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? $e68ba20b3d2d159d$var$Fc : $e68ba20b3d2d159d$var$Oc,
        "data-testid": "toggle-dark-mode",
        shortcut: n,
        "aria-label": r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? t("buttons.lightMode") : t("buttons.darkMode"),
        children: r.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? t("buttons.lightMode") : t("buttons.darkMode")
    }) : null;
};
$e68ba20b3d2d159d$var$A5.displayName = "ToggleTheme";
var $e68ba20b3d2d159d$var$M5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$Ke(), r = $e68ba20b3d2d159d$var$$t(), o = $e68ba20b3d2d159d$var$Xn();
    return t.viewModeEnabled || !o.UIOptions.canvasActions.changeViewBackgroundColor ? null : (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginTop: "0.5rem"
        },
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "canvas-background-label",
                style: {
                    fontSize: ".75rem",
                    marginBottom: ".5rem"
                },
                children: e("labels.canvasBackground")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: "0 0.625rem"
                },
                children: r.renderAction("changeViewBackgroundColor")
            })
        ]
    });
};
$e68ba20b3d2d159d$var$M5.displayName = "ChangeCanvasBackground";
var $e68ba20b3d2d159d$var$k5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$He();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        icon: $e68ba20b3d2d159d$var$Xa,
        onSelect: ()=>{
            t({
                openDialog: {
                    name: "jsonExport"
                }
            });
        },
        "data-testid": "json-export-button",
        "aria-label": e("buttons.export"),
        children: e("buttons.export")
    });
};
$e68ba20b3d2d159d$var$k5.displayName = "Export";
var $e68ba20b3d2d159d$var$P5 = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ac, {
                icon: $e68ba20b3d2d159d$var$gp,
                href: "https://github.com/excalidraw/excalidraw",
                "aria-label": "GitHub",
                children: "GitHub"
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ac, {
                icon: $e68ba20b3d2d159d$var$Hy,
                href: "https://x.com/excalidraw",
                "aria-label": "X",
                children: e("labels.followUs")
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ac, {
                icon: $e68ba20b3d2d159d$var$zy,
                href: "https://discord.gg/UexuTaE",
                "aria-label": "Discord",
                children: e("labels.discordChat")
            })
        ]
    });
};
$e68ba20b3d2d159d$var$P5.displayName = "Socials";
var $e68ba20b3d2d159d$var$L5 = ({ onSelect: e, isCollaborating: t })=>{
    let { t: r } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$no, {
        "data-testid": "collab-button",
        icon: $e68ba20b3d2d159d$var$xp,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
            "active-collab": t
        }),
        onSelect: e,
        children: r("labels.liveCollaboration")
    });
};
$e68ba20b3d2d159d$var$L5.displayName = "LiveCollaborationTrigger";
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Ri = (e, t)=>{
    let r = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(0), o = (n)=>{
        let { jotaiScope: i } = $e68ba20b3d2d159d$var$pt(), [, a] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)(r, i), s = (0, $acw62.useRef)({
            preferHost: !1,
            counter: 0
        });
        return (0, $acw62.useLayoutEffect)(()=>{
            let l = s.current;
            return a((c)=>{
                let d = c + 1;
                return l.counter = d, d;
            }), ()=>{
                a((c)=>{
                    let d = c - 1;
                    return l.counter = d, d || (l.preferHost = !1), d;
                });
            };
        }, [
            a
        ]), n.__fallback || (s.current.preferHost = !0), !s.current.counter && n.__fallback && s.current.preferHost || s.current.counter > 1 && n.__fallback ? null : (0, $7b02d682eb115277$exports.jsx)(t, {
            ...n
        });
    };
    return o.displayName = e, o;
};
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$kR = Object.assign($e68ba20b3d2d159d$var$Ri("MainMenu", ({ children: e, onSelect: t })=>{
    let { MainMenuTunnel: r } = $e68ba20b3d2d159d$var$pt(), o = $e68ba20b3d2d159d$export$aa949327762d0f40(), n = $e68ba20b3d2d159d$var$Ke(), i = $e68ba20b3d2d159d$var$He(), a = o.editor.isMobile ? void 0 : ()=>i({
            openMenu: null
        });
    return (0, $7b02d682eb115277$exports.jsx)(r.In, {
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et, {
            open: n.openMenu === "canvas",
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Trigger, {
                    onToggle: ()=>{
                        i({
                            openMenu: n.openMenu === "canvas" ? null : "canvas"
                        });
                    },
                    "data-testid": "main-menu-trigger",
                    className: "main-menu-trigger",
                    children: $e68ba20b3d2d159d$var$hp
                }),
                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Content, {
                    onClickOutside: a,
                    onSelect: $e68ba20b3d2d159d$var$Ui(t, ()=>{
                        i({
                            openMenu: null
                        });
                    }),
                    children: [
                        e,
                        o.editor.isMobile && n.collaborators.size > 0 && (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                            className: "UserList-Wrapper",
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("legend", {
                                    children: $e68ba20b3d2d159d$var$x("labels.collaborators")
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gg, {
                                    mobile: !0,
                                    collaborators: n.collaborators,
                                    userToFollow: n.userToFollow?.socketId || null
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}), {
    Trigger: $e68ba20b3d2d159d$var$et.Trigger,
    Item: $e68ba20b3d2d159d$var$et.Item,
    ItemLink: $e68ba20b3d2d159d$var$et.ItemLink,
    ItemCustom: $e68ba20b3d2d159d$var$et.ItemCustom,
    Group: $e68ba20b3d2d159d$var$et.Group,
    Separator: $e68ba20b3d2d159d$var$et.Separator,
    DefaultItems: $e68ba20b3d2d159d$var$d1
}), $e68ba20b3d2d159d$export$4e08dcf990b776c0 = $e68ba20b3d2d159d$var$kR;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$yg = ({ title: e, children: t, actionLabel: r, onClick: o })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "OverwriteConfirm__Actions__Action",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: e
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "OverwriteConfirm__Actions__Action__content",
                children: t
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fa, {
                variant: "outlined",
                color: "muted",
                label: r,
                size: "large",
                fullWidth: !0,
                onClick: o
            })
        ]
    }), $e68ba20b3d2d159d$var$PR = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$$t(), r = $e68ba20b3d2d159d$var$He();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yg, {
        title: e("overwriteConfirm.action.exportToImage.title"),
        actionLabel: e("overwriteConfirm.action.exportToImage.button"),
        onClick: ()=>{
            t.executeAction($e68ba20b3d2d159d$var$Ih, "ui", !0), r({
                openDialog: {
                    name: "imageExport"
                }
            });
        },
        children: e("overwriteConfirm.action.exportToImage.description")
    });
}, $e68ba20b3d2d159d$var$LR = ()=>{
    let { t: e } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9(), t = $e68ba20b3d2d159d$var$$t();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$yg, {
        title: e("overwriteConfirm.action.saveToDisk.title"),
        actionLabel: e("overwriteConfirm.action.saveToDisk.button"),
        onClick: ()=>{
            t.executeAction($e68ba20b3d2d159d$var$qd, "ui");
        },
        children: e("overwriteConfirm.action.saveToDisk.description")
    });
}, $e68ba20b3d2d159d$var$p1 = Object.assign(({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "OverwriteConfirm__Actions",
        children: e
    }), {
    ExportToImage: $e68ba20b3d2d159d$var$PR,
    SaveToDisk: $e68ba20b3d2d159d$var$LR
});
var $e68ba20b3d2d159d$var$wg = Object.assign($e68ba20b3d2d159d$var$Ri("OverwriteConfirmDialog", ({ children: e })=>{
    let { OverwriteConfirmDialogTunnel: t } = $e68ba20b3d2d159d$var$pt(), [r, o] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$l1, $e68ba20b3d2d159d$var$$e);
    if (!r.active) return null;
    let n = ()=>{
        r.onClose(), o((a)=>({
                ...a,
                active: !1
            }));
    }, i = ()=>{
        r.onConfirm(), o((a)=>({
                ...a,
                active: !1
            }));
    };
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
            onCloseRequest: n,
            title: !1,
            size: 916,
            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "OverwriteConfirm",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: r.title
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `OverwriteConfirm__Description OverwriteConfirm__Description--color-${r.color}`,
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "OverwriteConfirm__Description__icon",
                                children: $e68ba20b3d2d159d$var$Nw
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: r.description
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "OverwriteConfirm__Description__spacer"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$fa, {
                                color: r.color,
                                size: "large",
                                label: r.actionLabel,
                                onClick: i
                            })
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$p1, {
                        children: e
                    })
                ]
            })
        })
    });
}), {
    Actions: $e68ba20b3d2d159d$var$p1,
    Action: $e68ba20b3d2d159d$var$yg
});
$e68ba20b3d2d159d$var$Qr();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$N5 = $e68ba20b3d2d159d$var$Ri("DefaultSidebarTrigger", (e)=>{
    let { DefaultSidebarTriggerTunnel: t } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe.Trigger, {
            ...e,
            className: "default-sidebar-trigger",
            name: $e68ba20b3d2d159d$var$mo.name
        })
    });
});
$e68ba20b3d2d159d$var$N5.displayName = "DefaultSidebarTrigger";
var $e68ba20b3d2d159d$var$O5 = ({ children: e, ...t })=>{
    let { DefaultSidebarTabTriggersTunnel: r } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(r.In, {
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe.TabTriggers, {
            ...t,
            children: e
        })
    });
};
$e68ba20b3d2d159d$var$O5.displayName = "DefaultTabTriggers";
var $e68ba20b3d2d159d$export$2c2622abfb448137 = Object.assign($e68ba20b3d2d159d$var$Ri("DefaultSidebar", ({ children: e, className: t, onDock: r, docked: o, ...n })=>{
    let i = $e68ba20b3d2d159d$var$Ke(), a = $e68ba20b3d2d159d$var$He(), { DefaultSidebarTabTriggersTunnel: s } = $e68ba20b3d2d159d$var$pt();
    return (0, $acw62.createElement)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe, {
        ...n,
        name: "default",
        key: "default",
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("default-sidebar", t),
        docked: o ?? i.defaultSidebarDockedPreference,
        onDock: r === !1 || !r && o != null ? void 0 : $e68ba20b3d2d159d$var$Ui(r, (l)=>{
            a({
                defaultSidebarDockedPreference: l
            });
        })
    }, (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe.Tabs, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe.Header, {
                children: [
                    n.__fallback && (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            color: "var(--color-primary)",
                            fontSize: "1.2em",
                            fontWeight: "bold",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            paddingRight: "1em"
                        },
                        children: $e68ba20b3d2d159d$var$x("toolBar.library")
                    }),
                    (0, $7b02d682eb115277$exports.jsx)(s.Out, {})
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$1ba59dacbcbf90fe.Tab, {
                tab: $e68ba20b3d2d159d$var$Mc,
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$nC, {})
            }),
            e
        ]
    }));
}), {
    Trigger: $e68ba20b3d2d159d$var$N5,
    TabTriggers: $e68ba20b3d2d159d$var$O5
});
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$en();
$e68ba20b3d2d159d$var$xs();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$FR = "small", $e68ba20b3d2d159d$var$B5 = (e)=>(0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon ToolIcon__LaserPointer", `ToolIcon_size_${$e68ba20b3d2d159d$var$FR}`, {
            "is-mobile": e.isMobile
        }),
        title: `${e.title}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "ToolIcon_type_checkbox",
                type: "checkbox",
                name: e.name,
                onChange: e.onChange,
                checked: e.checked,
                "aria-label": e.title,
                "data-testid": "toolbar-LaserPointer"
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ToolIcon__icon",
                children: $e68ba20b3d2d159d$var$Sp
            })
        ]
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Fr();
var $e68ba20b3d2d159d$var$zR = ({ canvasRef: e, setError: t })=>{
    let r = e.current;
    if (!r) return;
    let o = r.parentElement;
    o && (o.style.background = "", t(null), r.replaceChildren());
}, $e68ba20b3d2d159d$var$Tg = async ({ canvasRef: e, mermaidToExcalidrawLib: t, mermaidDefinition: r, setError: o, data: n })=>{
    let i = e.current, a = i?.parentElement;
    if (!(!i || !a)) {
        if (!r) {
            $e68ba20b3d2d159d$var$zR({
                canvasRef: e,
                setError: o
            });
            return;
        }
        try {
            let s = await t.api, l;
            try {
                l = await s.parseMermaidToExcalidraw(r);
            } catch  {
                l = await s.parseMermaidToExcalidraw(r.replace(/"/g, "'"));
            }
            let { elements: c, files: d } = l;
            o(null), n.current = {
                elements: $e68ba20b3d2d159d$export$586f70b13f801aaf(c, {
                    regenerateIds: !0
                }),
                files: d
            };
            let m = await $e68ba20b3d2d159d$export$7e83d8bd8a3024f4({
                elements: n.current.elements,
                files: n.current.files,
                exportPadding: $e68ba20b3d2d159d$var$$o,
                maxWidthOrHeight: Math.max(a.offsetWidth, a.offsetHeight) * window.devicePixelRatio
            });
            try {
                await $e68ba20b3d2d159d$var$fi(m);
            } catch (p) {
                throw p.name === "CANVAS_POSSIBLY_TOO_BIG" ? new Error($e68ba20b3d2d159d$var$x("canvasError.canvasTooBig")) : p;
            }
            a.style.background = "var(--default-bg-color)", i.replaceChildren(m);
        } catch (s) {
            throw a.style.background = "var(--default-bg-color)", r && o(s), s;
        }
    }
}, $e68ba20b3d2d159d$var$dm = (e)=>{
    $e68ba20b3d2d159d$var$$n.set($e68ba20b3d2d159d$var$Fi.MERMAID_TO_EXCALIDRAW, e);
}, $e68ba20b3d2d159d$var$Sg = ({ app: e, data: t, text: r, shouldSaveMermaidDataToStorage: o })=>{
    let { elements: n, files: i } = t.current;
    n.length && (e.addElementsFromPasteOrLibrary({
        elements: n,
        files: i,
        position: "center",
        fitToContent: !0
    }), e.setOpenDialog(null), o && r && $e68ba20b3d2d159d$var$dm(r));
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Ig = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "ttd-dialog-panels",
        children: e
    });
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$hc = ({ label: e, children: t, panelAction: r, panelActionDisabled: o = !1, onTextSubmitInProgess: n, renderTopRight: i, renderSubmitShortcut: a, renderBottomRight: s })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ttd-dialog-panel",
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "ttd-dialog-panel__header",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("label", {
                        children: e
                    }),
                    i?.()
                ]
            }),
            t,
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ttd-dialog-panel-button-container", {
                    invisible: !r
                }),
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$export$353f5b6fc5456de1, {
                        className: "ttd-dialog-panel-button",
                        onSelect: r ? r.action : ()=>{},
                        disabled: o || n,
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)({
                                    invisible: n
                                }),
                                children: [
                                    r?.label,
                                    r?.icon && (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: r.icon
                                    })
                                ]
                            }),
                            n && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {})
                        ]
                    }),
                    !o && !n && a?.(),
                    s?.()
                ]
            })
        ]
    });
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$be();
var $e68ba20b3d2d159d$var$Cg = ({ input: e, placeholder: t, onChange: r, onKeyboardSubmit: o })=>{
    let n = (0, $acw62.useRef)(null), i = (0, $acw62.useRef)(o);
    return i.current = o, (0, $acw62.useEffect)(()=>{
        if (!i.current) return;
        let a = n.current;
        if (a) {
            let s = (l)=>{
                l[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && l.key === $e68ba20b3d2d159d$var$S.ENTER && (l.preventDefault(), i.current?.());
            };
            return a.addEventListener("keydown", s), ()=>{
                a.removeEventListener("keydown", s);
            };
        }
    }, []), (0, $7b02d682eb115277$exports.jsx)("textarea", {
        className: "ttd-dialog-input",
        onChange: r,
        value: e,
        placeholder: t,
        autoFocus: !0,
        ref: n
    });
};
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$WR = ({ error: e })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "ttd-dialog-output-error",
        className: "ttd-dialog-output-error",
        children: [
            "Error! ",
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: e
            })
        ]
    }), $e68ba20b3d2d159d$var$Mg = ({ error: e, canvasRef: t, loaded: r })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ttd-dialog-output-wrapper",
        children: [
            e && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$WR, {
                error: e.message
            }),
            r ? (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: t,
                style: {
                    opacity: e ? "0.15" : 1
                },
                className: "ttd-dialog-output-canvas-container"
            }) : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ar, {
                size: "2rem"
            })
        ]
    });
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$kg = ()=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "ttd-dialog-submit-shortcut",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ttd-dialog-submit-shortcut__key",
                children: $e68ba20b3d2d159d$var$O("CtrlOrCmd")
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ttd-dialog-submit-shortcut__key",
                children: $e68ba20b3d2d159d$var$O("Enter")
            })
        ]
    });
var $e68ba20b3d2d159d$var$XR = `flowchart TD
 A[Christmas] -->|Get money| B(Go shopping)
 B --> C{Let me think}
 C -->|One| D[Laptop]
 C -->|Two| E[iPhone]
 C -->|Three| F[Car]`, $e68ba20b3d2d159d$var$X5 = $e68ba20b3d2d159d$var$si($e68ba20b3d2d159d$var$dm, 300), $e68ba20b3d2d159d$var$KR = ({ mermaidToExcalidrawLib: e })=>{
    let [t, r] = (0, $acw62.useState)(()=>$e68ba20b3d2d159d$var$$n.get($e68ba20b3d2d159d$var$Fi.MERMAID_TO_EXCALIDRAW) || $e68ba20b3d2d159d$var$XR), o = (0, $acw62.useDeferredValue)(t.trim()), [n, i] = (0, $acw62.useState)(null), a = (0, $acw62.useRef)(null), s = (0, $acw62.useRef)({
        elements: [],
        files: null
    }), l = $e68ba20b3d2d159d$var$Bt();
    (0, $acw62.useEffect)(()=>{
        $e68ba20b3d2d159d$var$Tg({
            canvasRef: a,
            data: s,
            mermaidToExcalidrawLib: e,
            setError: i,
            mermaidDefinition: o
        }).catch((d)=>{
            $e68ba20b3d2d159d$var$q0() && console.error("Failed to parse mermaid definition", d);
        }), $e68ba20b3d2d159d$var$X5(o);
    }, [
        o,
        e
    ]), (0, $acw62.useEffect)(()=>()=>{
            $e68ba20b3d2d159d$var$X5.flush();
        }, []);
    let c = ()=>{
        $e68ba20b3d2d159d$var$Sg({
            app: l,
            data: s,
            text: t,
            shouldSaveMermaidDataToStorage: !0
        });
    };
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ttd-dialog-desc",
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "mermaid.description",
                    flowchartLink: (d)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://mermaid.js.org/syntax/flowchart.html",
                            children: d
                        }),
                    sequenceLink: (d)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://mermaid.js.org/syntax/sequenceDiagram.html",
                            children: d
                        }),
                    classLink: (d)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://mermaid.js.org/syntax/classDiagram.html",
                            children: d
                        })
                })
            }),
            (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Ig, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hc, {
                        label: $e68ba20b3d2d159d$var$x("mermaid.syntax"),
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Cg, {
                            input: t,
                            placeholder: "Write Mermaid diagram defintion here...",
                            onChange: (d)=>r(d.target.value),
                            onKeyboardSubmit: ()=>{
                                c();
                            }
                        })
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hc, {
                        label: $e68ba20b3d2d159d$var$x("mermaid.preview"),
                        panelAction: {
                            action: ()=>{
                                c();
                            },
                            label: $e68ba20b3d2d159d$var$x("mermaid.button"),
                            icon: $e68ba20b3d2d159d$var$el
                        },
                        renderSubmitShortcut: ()=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$kg, {}),
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mg, {
                            canvasRef: a,
                            loaded: e.loaded,
                            error: n
                        })
                    })
                ]
            })
        ]
    });
}, $e68ba20b3d2d159d$var$$5 = $e68ba20b3d2d159d$var$KR;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$q5 = (e)=>{
    let t = $e68ba20b3d2d159d$var$He(), r = (0, $acw62.useRef)(null), o = (0, $acw62.useRef)(0);
    return (0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$be92b6f5f03c0fe9, {
        ref: r,
        className: "ttd-dialog-tabs-root",
        value: e.tab,
        onValueChange: (n)=>{
            if (!n) return;
            let i = r.current?.closest(".Modal__content");
            if (i) {
                let a = i.offsetHeight || 0;
                a > o.current && (o.current = a, i.style.minHeight = `min(${o.current}px, 100%)`);
            }
            e.dialog === "ttd" && $e68ba20b3d2d159d$var$qm([
                "text-to-diagram",
                "mermaid"
            ], n) && t({
                openDialog: {
                    name: e.dialog,
                    tab: n
                }
            });
        },
        children: e.children
    });
};
$e68ba20b3d2d159d$var$q5.displayName = "TTDDialogTabs";
var $e68ba20b3d2d159d$var$J5 = $e68ba20b3d2d159d$var$q5;
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$h1 = ({ children: e, ...t })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$54c2e3dc7acea9f5, {
        className: "ttd-dialog-triggers",
        ...t,
        children: e
    });
$e68ba20b3d2d159d$var$h1.displayName = "TTDDialogTabTriggers";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Pg = ({ children: e, tab: t, onSelect: r, ...o })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$41fb9f06171c75f4, {
        value: t,
        asChild: !0,
        onSelect: r,
        children: (0, $7b02d682eb115277$exports.jsx)("button", {
            type: "button",
            className: "ttd-dialog-tab-trigger",
            ...o,
            children: e
        })
    });
$e68ba20b3d2d159d$var$Pg.displayName = "TTDDialogTabTrigger";
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Lg = ({ tab: e, children: t, ...r })=>(0, $7b02d682eb115277$exports.jsx)($1e222a1434bedc9c$export$7c6e2c02157bb7d2, {
        ...r,
        value: e,
        children: t
    });
$e68ba20b3d2d159d$var$Lg.displayName = "TTDDialogTab";
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$f1 = 3, $e68ba20b3d2d159d$var$gc = 1e3, $e68ba20b3d2d159d$var$QR = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$var$eN = (0, $051474e5c5a9c9ad$export$5fb5cc0d078610b)(null), $e68ba20b3d2d159d$export$a14571c7e5344c80 = (e)=>{
    let t = $e68ba20b3d2d159d$var$Ke();
    return t.openDialog?.name !== "ttd" ? null : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$tN, {
        ...e,
        tab: t.openDialog.tab
    });
};

var $e68ba20b3d2d159d$var$tN = $e68ba20b3d2d159d$var$Ri("TTDDialogBase", ({ tab: e, ...t })=>{
    let r = $e68ba20b3d2d159d$var$Bt(), o = $e68ba20b3d2d159d$var$He(), n = (0, $acw62.useRef)(null), [i, a] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$eN), [s, l] = (0, $acw62.useState)(i?.prompt ?? ""), c = s.trim(), d = (C)=>{
        l(C.target.value), a((P)=>({
                generatedResponse: P?.generatedResponse ?? null,
                prompt: C.target.value
            }));
    }, [m, p] = (0, $acw62.useState)(!1), [u, h] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$QR), g = async ()=>{
        if (c.length > $e68ba20b3d2d159d$var$gc || c.length < $e68ba20b3d2d159d$var$f1 || m || u?.rateLimitRemaining === 0 || "__fallback" in t) {
            c.length < $e68ba20b3d2d159d$var$f1 && M(new Error(`Prompt is too short (min ${$e68ba20b3d2d159d$var$f1} characters)`)), c.length > $e68ba20b3d2d159d$var$gc && M(new Error(`Prompt is too long (max ${$e68ba20b3d2d159d$var$gc} characters)`));
            return;
        }
        try {
            p(!0), $e68ba20b3d2d159d$var$Pe("ai", "generate", "ttd");
            let { generatedResponse: C, error: P, rateLimit: k, rateLimitRemaining: _ } = await t.onTextSubmit(c);
            if (typeof C == "string" && a((A)=>({
                    generatedResponse: C,
                    prompt: A?.prompt ?? null
                })), $e68ba20b3d2d159d$var$Ha(k) && $e68ba20b3d2d159d$var$Ha(_) && h({
                rateLimit: k,
                rateLimitRemaining: _
            }), P) {
                M(P);
                return;
            }
            if (!C) {
                M(new Error("Generation failed"));
                return;
            }
            try {
                await $e68ba20b3d2d159d$var$Tg({
                    canvasRef: n,
                    data: w,
                    mermaidToExcalidrawLib: v,
                    setError: M,
                    mermaidDefinition: C
                }), $e68ba20b3d2d159d$var$Pe("ai", "mermaid parse success", "ttd");
            } catch (A) {
                console.info(`%cTTD mermaid render errror: ${A.message}`, "color: red"), console.info(`>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
TTD mermaid definition render errror: ${A.message}`, "color: yellow"), $e68ba20b3d2d159d$var$Pe("ai", "mermaid parse failed", "ttd"), M(new Error("Generated an invalid diagram :(. You may also try a different prompt."));
            }
        } catch (C) {
            let P = C.message;
            (!P || P === "Failed to fetch") && (P = "Request failed"), M(new Error(P));
        } finally{
            p(!1);
        }
    }, b = (0, $acw62.useRef)(g);
    b.current = g;
    let [v, y] = (0, $acw62.useState)({
        loaded: !1,
        api: (parcelRequire("f3nFz"))
    });
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            await v.api, y((P)=>({
                    ...P,
                    loaded: !0
                }));
        })();
    }, [
        v.api
    ]);
    let w = (0, $acw62.useRef)({
        elements: [],
        files: null
    }), [I, M] = (0, $acw62.useState)(null);
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mt, {
        className: "ttd-dialog",
        onCloseRequest: ()=>{
            r.setOpenDialog(null);
        },
        size: 1200,
        title: !1,
        ...t,
        autofocus: !1,
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$J5, {
            dialog: "ttd",
            tab: e,
            children: [
                "__fallback" in t && t.__fallback ? (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "dialog-mermaid-title",
                    children: $e68ba20b3d2d159d$var$x("mermaid.title")
                }) : (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$h1, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pg, {
                            tab: "text-to-diagram",
                            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    $e68ba20b3d2d159d$var$x("labels.textToDiagram"),
                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "1px 6px",
                                            marginLeft: "10px",
                                            fontSize: 10,
                                            borderRadius: "12px",
                                            background: "var(--color-promo)",
                                            color: "var(--color-surface-lowest)"
                                        },
                                        children: "AI Beta"
                                    })
                                ]
                            })
                        }),
                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pg, {
                            tab: "mermaid",
                            children: "Mermaid"
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Lg, {
                    className: "ttd-dialog-content",
                    tab: "mermaid",
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$$5, {
                        mermaidToExcalidrawLib: v
                    })
                }),
                !("__fallback" in t) && (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Lg, {
                    className: "ttd-dialog-content",
                    tab: "text-to-diagram",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "ttd-dialog-desc",
                            children: "Currently we use Mermaid as a middle step, so you'll get best results if you describe a diagram, workflow, flow chart, and similar."
                        }),
                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Ig, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hc, {
                                    label: $e68ba20b3d2d159d$var$x("labels.prompt"),
                                    panelAction: {
                                        action: g,
                                        label: "Generate",
                                        icon: $e68ba20b3d2d159d$var$el
                                    },
                                    onTextSubmitInProgess: m,
                                    panelActionDisabled: c.length > $e68ba20b3d2d159d$var$gc || u?.rateLimitRemaining === 0,
                                    renderTopRight: ()=>u ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ttd-dialog-rate-limit",
                                            style: {
                                                fontSize: 12,
                                                marginLeft: "auto",
                                                color: u.rateLimitRemaining === 0 ? "var(--color-danger)" : void 0
                                            },
                                            children: [
                                                u.rateLimitRemaining,
                                                " requests left today"
                                            ]
                                        }) : null,
                                    renderSubmitShortcut: ()=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$kg, {}),
                                    renderBottomRight: ()=>{
                                        if (typeof i?.generatedResponse == "string") return (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "excalidraw-link",
                                            style: {
                                                marginLeft: "auto",
                                                fontSize: 14
                                            },
                                            onClick: ()=>{
                                                typeof i?.generatedResponse == "string" && ($e68ba20b3d2d159d$var$dm(i.generatedResponse), o({
                                                    openDialog: {
                                                        name: "ttd",
                                                        tab: "mermaid"
                                                    }
                                                }));
                                            },
                                            children: [
                                                "View as Mermaid",
                                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ga, {
                                                    icon: $e68ba20b3d2d159d$var$el
                                                })
                                            ]
                                        });
                                        let C = c.length / $e68ba20b3d2d159d$var$gc;
                                        return C > .8 ? (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginLeft: "auto",
                                                fontSize: 12,
                                                fontFamily: "monospace",
                                                color: C > 1 ? "var(--color-danger)" : void 0
                                            },
                                            children: [
                                                "Length: ",
                                                c.length,
                                                "/",
                                                $e68ba20b3d2d159d$var$gc
                                            ]
                                        }) : null;
                                    },
                                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Cg, {
                                        onChange: d,
                                        input: s,
                                        placeholder: "Describe what you want to see...",
                                        onKeyboardSubmit: ()=>{
                                            b.current();
                                        }
                                    })
                                }),
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hc, {
                                    label: "Preview",
                                    panelAction: {
                                        action: ()=>{
                                            console.info("Panel action clicked"), $e68ba20b3d2d159d$var$Sg({
                                                app: r,
                                                data: w
                                            });
                                        },
                                        label: "Insert",
                                        icon: $e68ba20b3d2d159d$var$el
                                    },
                                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Mg, {
                                        canvasRef: n,
                                        error: I,
                                        loaded: v.loaded
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
});
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Bd();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$iA = .01, $e68ba20b3d2d159d$var$lo = (e, t)=>!(t === "height" && $e68ba20b3d2d159d$var$G(e) || t === "width" && $e68ba20b3d2d159d$var$G(e) || t === "angle" && $e68ba20b3d2d159d$var$re(e)), $e68ba20b3d2d159d$var$ft = (e, t)=>{
    let r = e + t / 2;
    return r - r % t;
}, $e68ba20b3d2d159d$var$fc = (e, t, r)=>Object.keys(e).map((o)=>({
            original: (r ?? t).get(o),
            latest: t.get(o)
        })).filter((o)=>o.original !== void 0 && o.latest !== void 0), $e68ba20b3d2d159d$var$rN = (e, t, r, o, n, i, a)=>({
        x: e + (r - n) / 2 + (n - r) / 2 * Math.cos(a) + (o - i) / 2 * Math.sin(a),
        y: t + (o - i) / 2 + (n - r) / 2 * Math.sin(a) + (i - o) / 2 * Math.cos(a)
    }), $e68ba20b3d2d159d$var$Ec = (e, t, r, o, n, i, a, s = !0)=>{
    let l = n.get(o.id);
    if (!l) return;
    let c = {}, d = $e68ba20b3d2d159d$var$te(l, n);
    if (d) {
        let u = $e68ba20b3d2d159d$var$Hl($e68ba20b3d2d159d$var$ke(d), d.lineHeight), h = $e68ba20b3d2d159d$var$zl(d.fontSize, d.lineHeight);
        e = Math.max(e, u), t = Math.max(t, h);
    }
    let { width: m, height: p } = l;
    if ($e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
        ...$e68ba20b3d2d159d$var$rN(l.x, l.y, l.width, l.height, e, t, l.angle),
        width: e,
        height: t,
        ...$e68ba20b3d2d159d$var$Od(o, e, t, !0)
    }, s), $e68ba20b3d2d159d$var$pm(l, n, i, a, {
        newSize: {
            width: e,
            height: t
        }
    }), d && (c = {
        fontSize: d.fontSize
    }, r)) {
        let u = {
            ...l,
            width: e,
            height: t
        };
        c = {
            fontSize: $e68ba20b3d2d159d$var$Fd(d, n, $e68ba20b3d2d159d$var$Mr(u, d))?.size ?? d.fontSize
        };
    }
    $e68ba20b3d2d159d$var$Jt(l, n, {
        oldSize: {
            width: m,
            height: p
        }
    }), d && c && $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
        fontSize: c.fontSize
    }), $e68ba20b3d2d159d$var$mn(l, n, "e", r);
}, $e68ba20b3d2d159d$var$Ns = (e, t, r, o, n, i, a, s = !0)=>{
    let l = o.get(r.id);
    if (!l) return;
    let [c, d] = [
        r.x + r.width / 2,
        r.y + r.height / 2
    ], [m, p] = $e68ba20b3d2d159d$var$Ee(r.x, r.y, c, d, r.angle), u = e - m, h = t - p, [g, b] = $e68ba20b3d2d159d$var$Ee(e, t, c + u, d + h, -r.angle);
    $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
        x: g,
        y: b
    }, s), $e68ba20b3d2d159d$var$pm(l, o, n, i);
    let v = $e68ba20b3d2d159d$var$te(r, a);
    if (v) {
        let y = o.get(v.id);
        y && $e68ba20b3d2d159d$export$55655e96a21bba2e(y, {
            x: v.x + u,
            y: v.y + h
        }, s);
    }
}, $e68ba20b3d2d159d$var$xc = (e, t)=>{
    let o = $e68ba20b3d2d159d$var$Qo(t).map((n)=>$e68ba20b3d2d159d$var$nt(e, n).reduce((i, a)=>(i[a.id] = !0, i), {}));
    return e.filter((n)=>!$e68ba20b3d2d159d$var$Nn(n)).forEach((n)=>{
        o.push({
            [n.id]: !0
        });
    }), o;
}, $e68ba20b3d2d159d$var$pm = (e, t, r, o, n)=>{
    $e68ba20b3d2d159d$export$5df2ebb939539835(e) ? $e68ba20b3d2d159d$var$ss([
        e
    ], t, r, o, !0, []) : $e68ba20b3d2d159d$var$Jt(e, t, n);
};
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$iN = ({ label: e, icon: t, dragInputCallback: r, value: o, elements: n, editable: i = !0, shouldKeepAspectRatio: a, property: s, scene: l, appState: c, sensitivity: d = 1 })=>{
    let m = $e68ba20b3d2d159d$var$Bt(), p = (0, $acw62.useRef)(null), u = (0, $acw62.useRef)(null), [h, g] = (0, $acw62.useState)(o.toString()), b = (0, $acw62.useRef)(null);
    b.current || (b.current = {
        originalAppState: $e68ba20b3d2d159d$var$jr(c),
        originalElements: n,
        lastUpdatedValue: h,
        updatePending: !1
    }), (0, $acw62.useEffect)(()=>{
        let w = o.toString();
        g(w), b.current.lastUpdatedValue = w;
    }, [
        o
    ]);
    let v = (w, I, M)=>{
        if (!b.current.updatePending) return !1;
        b.current.updatePending = !1;
        let C = Number(w);
        if (isNaN(C)) {
            g(o.toString());
            return;
        }
        let P = Number(C.toFixed(2)), k = Number(o);
        (isNaN(k) || Math.abs(P - k) >= $e68ba20b3d2d159d$var$iA) && (b.current.lastUpdatedValue = w, r({
            accumulatedChange: 0,
            instantChange: 0,
            originalElements: I,
            originalElementsMap: m.scene.getNonDeletedElementsMap(),
            shouldKeepAspectRatio: a,
            shouldChangeByStepSize: !1,
            scene: l,
            nextValue: P,
            property: s,
            originalAppState: M,
            setInputValue: (_)=>g(String(_))
        }), m.syncActionResult({
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        }));
    }, y = (0, $acw62.useRef)({});
    return y.current.handleInputValue = v, (0, $acw62.useEffect)(()=>{
        let w = p.current, I = y.current;
        return ()=>{
            let M = w?.value;
            M && I.handleInputValue?.(M, b.current.originalElements, b.current.originalAppState), window.removeEventListener("pointermove", I.onPointerMove, !1), window.removeEventListener("pointerup", I.onPointerUp, !1);
        };
    }, [
        i
    ]), i ? (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("drag-input-container", !i && "disabled"),
        "data-testid": e,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "drag-input-label",
                ref: u,
                onPointerDown: (w)=>{
                    if (p.current && i) {
                        document.body.classList.add("excalidraw-cursor-resize");
                        let I = Number(p.current.value);
                        isNaN(I) && (I = 0);
                        let M = null, C = m.scene.getNonDeletedElements().reduce((V, ee)=>(V.set(ee.id, $e68ba20b3d2d159d$var$hn(ee)), V), new Map), P = n.map((V)=>C.get(V.id)), k = $e68ba20b3d2d159d$var$jr(c), _ = 0, A = 0, R = (V)=>{
                            if (M && C !== null && P !== null) {
                                let ee = V.clientX - M.x;
                                ee !== 0 && (A += ee, Math.abs(A) >= d && (A = Math.sign(A) * Math.floor(Math.abs(A) / d), _ += A, r({
                                    accumulatedChange: _,
                                    instantChange: A,
                                    originalElements: P,
                                    originalElementsMap: C,
                                    shouldKeepAspectRatio: a,
                                    shouldChangeByStepSize: V.shiftKey,
                                    property: s,
                                    scene: l,
                                    originalAppState: k,
                                    setInputValue: (N)=>g(String(N))
                                }), A = 0));
                            }
                            M = {
                                x: V.clientX,
                                y: V.clientY
                            };
                        }, B = ()=>{
                            window.removeEventListener("pointermove", R, !1), m.syncActionResult({
                                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                            }), M = null, _ = 0, A = 0, P = null, C = null, document.body.classList.remove("excalidraw-cursor-resize"), window.removeEventListener("pointerup", B, !1);
                        };
                        y.current.onPointerMove = R, y.current.onPointerUp = B, window.addEventListener("pointermove", R, !1), window.addEventListener("pointerup", B, !1);
                    }
                },
                onPointerEnter: ()=>{
                    u.current && (u.current.style.cursor = "ew-resize");
                },
                children: t ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ga, {
                    icon: t
                }) : e
            }),
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "drag-input",
                autoComplete: "off",
                spellCheck: "false",
                onKeyDown: (w)=>{
                    if (i) {
                        let I = w.target;
                        I instanceof HTMLInputElement && w.key === $e68ba20b3d2d159d$var$S.ENTER && (v(I.value, n, c), m.focusContainer());
                    }
                },
                ref: p,
                value: h,
                onChange: (w)=>{
                    b.current.updatePending = !0, g(w.target.value);
                },
                onFocus: (w)=>{
                    w.target.select(), b.current.originalElements = n, b.current.originalAppState = $e68ba20b3d2d159d$var$jr(c);
                },
                onBlur: (w)=>{
                    h ? i && v(w.target.value, b.current.originalElements, b.current.originalAppState) : g(o.toString());
                },
                disabled: !i
            })
        ]
    }) : null;
}, $e68ba20b3d2d159d$var$ir = $e68ba20b3d2d159d$var$iN;
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$sA = 10, $e68ba20b3d2d159d$var$sN = (e)=>e.type === "image", $e68ba20b3d2d159d$var$lN = ({ accumulatedChange: e, originalElements: t, shouldKeepAspectRatio: r, shouldChangeByStepSize: o, nextValue: n, property: i, scene: a })=>{
    let s = a.getNonDeletedElementsMap(), l = a.getNonDeletedElements(), c = t[0];
    if (c) {
        let d = r || $e68ba20b3d2d159d$var$sN(c), m = c.width / c.height;
        if (n !== void 0) {
            let b = Math.max(i === "width" ? n : d ? n * m : c.width, $e68ba20b3d2d159d$var$$r), v = Math.max(i === "height" ? n : d ? n / m : c.height, $e68ba20b3d2d159d$var$$r);
            $e68ba20b3d2d159d$var$Ec(b, v, d, c, s, l, a);
            return;
        }
        let p = i === "width" ? e : 0, u = i === "height" ? e : 0, h = Math.max(0, c.width + p);
        i === "width" && (o ? h = $e68ba20b3d2d159d$var$ft(h, $e68ba20b3d2d159d$var$sA) : h = Math.round(h));
        let g = Math.max(0, c.height + u);
        i === "height" && (o ? g = $e68ba20b3d2d159d$var$ft(g, $e68ba20b3d2d159d$var$sA) : g = Math.round(g)), d && (i === "width" ? g = Math.round(h / m * 100) / 100 : h = Math.round(g * m * 100) / 100), g = Math.max($e68ba20b3d2d159d$var$$r, g), h = Math.max($e68ba20b3d2d159d$var$$r, h), $e68ba20b3d2d159d$var$Ec(h, g, d, c, s, l, a);
    }
}, $e68ba20b3d2d159d$var$cN = ({ property: e, element: t, scene: r, appState: o })=>{
    let n = Math.round((e === "width" ? t.width : t.height) * 100) / 100;
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: e === "width" ? "W" : "H",
        elements: [
            t
        ],
        dragInputCallback: $e68ba20b3d2d159d$var$lN,
        value: n,
        editable: $e68ba20b3d2d159d$var$lo(t, e),
        scene: r,
        appState: o,
        property: e
    });
}, $e68ba20b3d2d159d$var$b1 = $e68ba20b3d2d159d$var$cN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$mN = 15, $e68ba20b3d2d159d$var$pN = ({ accumulatedChange: e, originalElements: t, shouldChangeByStepSize: r, nextValue: o, scene: n })=>{
    let i = n.getNonDeletedElementsMap(), a = n.getNonDeletedElements(), s = t[0];
    if (s && !$e68ba20b3d2d159d$var$ce(s)) {
        let l = i.get(s.id);
        if (!l) return;
        if (o !== void 0) {
            let h = $e68ba20b3d2d159d$var$Nl(o);
            $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
                angle: h
            }), $e68ba20b3d2d159d$var$pm(l, i, a, n);
            let g = $e68ba20b3d2d159d$var$te(l, i);
            g && !$e68ba20b3d2d159d$var$ie(l) && $e68ba20b3d2d159d$export$55655e96a21bba2e(g, {
                angle: h
            });
            return;
        }
        let c = Math.round($e68ba20b3d2d159d$var$Rl(s.angle) * 100) / 100, d = Math.round(e), m = (c + d) % 360;
        r && (m = $e68ba20b3d2d159d$var$ft(m, $e68ba20b3d2d159d$var$mN)), m = m < 0 ? m + 360 : m;
        let p = $e68ba20b3d2d159d$var$Nl(m);
        $e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
            angle: p
        }), $e68ba20b3d2d159d$var$pm(l, i, a, n);
        let u = $e68ba20b3d2d159d$var$te(l, i);
        u && !$e68ba20b3d2d159d$var$ie(l) && $e68ba20b3d2d159d$export$55655e96a21bba2e(u, {
            angle: p
        });
    }
}, $e68ba20b3d2d159d$var$uN = ({ element: e, scene: t, appState: r, property: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: "A",
        icon: $e68ba20b3d2d159d$var$bp,
        value: Math.round($e68ba20b3d2d159d$var$Rl(e.angle) % 360 * 100) / 100,
        elements: [
            e
        ],
        dragInputCallback: $e68ba20b3d2d159d$var$pN,
        editable: $e68ba20b3d2d159d$var$lo(e, "angle"),
        scene: t,
        appState: r,
        property: o
    }), $e68ba20b3d2d159d$var$lA = $e68ba20b3d2d159d$var$uN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$We();
var $e68ba20b3d2d159d$var$cA = 4, $e68ba20b3d2d159d$var$gN = 4, $e68ba20b3d2d159d$var$fN = ({ accumulatedChange: e, originalElements: t, shouldChangeByStepSize: r, nextValue: o, scene: n })=>{
    let i = n.getNonDeletedElementsMap(), a = t[0];
    if (a) {
        let s = i.get(a.id);
        if (!s || !$e68ba20b3d2d159d$var$G(s)) return;
        let l;
        if (o !== void 0) l = Math.max(Math.round(o), $e68ba20b3d2d159d$var$cA);
        else if (a.type === "text") {
            let c = Math.round(a.fontSize), d = Math.round(e);
            l = Math.max(c + d, $e68ba20b3d2d159d$var$cA), r && (l = $e68ba20b3d2d159d$var$ft(l, $e68ba20b3d2d159d$var$gN));
        }
        l && ($e68ba20b3d2d159d$export$55655e96a21bba2e(s, {
            fontSize: l
        }), $e68ba20b3d2d159d$var$gt(s, n.getContainerElement(s), n.getNonDeletedElementsMap()));
    }
}, $e68ba20b3d2d159d$var$EN = ({ element: e, scene: t, appState: r, property: o })=>{
    let n = $e68ba20b3d2d159d$var$G(e) ? e : $e68ba20b3d2d159d$var$It(e) ? $e68ba20b3d2d159d$var$te(e, t.getNonDeletedElementsMap()) : null;
    return n ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: "F",
        value: Math.round(n.fontSize * 10) / 10,
        elements: [
            n
        ],
        dragInputCallback: $e68ba20b3d2d159d$var$fN,
        icon: $e68ba20b3d2d159d$var$Ka,
        appState: r,
        scene: t,
        property: o
    }) : null;
}, $e68ba20b3d2d159d$var$dA = $e68ba20b3d2d159d$var$EN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Bd();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$bc = 10, $e68ba20b3d2d159d$var$yN = (e, t, r, o)=>{
    let n = o.x - e, i = o.y - t, a = o.width * r, s = o.height * r, l = e + n * r, c = t + i * r;
    return {
        width: a,
        height: s,
        x: l,
        y: c,
        ...$e68ba20b3d2d159d$var$Od(o, a, s, !1),
        ...$e68ba20b3d2d159d$var$G(o) ? {
            fontSize: o.fontSize * r
        } : {}
    };
}, $e68ba20b3d2d159d$var$wN = (e, t, r, o, n, i, a, s)=>{
    let l = $e68ba20b3d2d159d$var$yN(e, t, o, i), { width: c, height: d } = n;
    $e68ba20b3d2d159d$export$55655e96a21bba2e(n, l, !1);
    let m = $e68ba20b3d2d159d$var$te(i, s);
    if (m) {
        let p = m.fontSize * o;
        $e68ba20b3d2d159d$var$Jt(n, a, {
            oldSize: {
                width: c,
                height: d
            }
        });
        let u = a.get(m.id);
        u && $e68ba20b3d2d159d$var$G(u) && ($e68ba20b3d2d159d$export$55655e96a21bba2e(u, {
            fontSize: p
        }, !1), $e68ba20b3d2d159d$var$mn(n, a, r === "width" ? "e" : "s", !0));
    }
}, $e68ba20b3d2d159d$var$mA = (e, t, r, o, n, i, a, s, l, c)=>{
    i === "width" ? t = Math.round(e / o * 100) / 100 : e = Math.round(t * o * 100) / 100;
    let d = t / r;
    for(let m = 0; m < s.length; m++){
        let p = s[m], u = a[m];
        $e68ba20b3d2d159d$var$wN(n[0], n[1], i, d, u, p, l, c);
    }
}, $e68ba20b3d2d159d$var$vN = ({ accumulatedChange: e, originalElements: t, originalElementsMap: r, originalAppState: o, shouldChangeByStepSize: n, nextValue: i, scene: a, property: s })=>{
    let l = a.getNonDeletedElementsMap(), c = a.getNonDeletedElements(), d = $e68ba20b3d2d159d$var$xc(t, o);
    if (i !== void 0) {
        for (let u of d){
            let h = $e68ba20b3d2d159d$var$fc(u, l, r);
            if (h.length > 1) {
                let g = h.map((A)=>A.latest), b = h.map((A)=>A.original), [v, y, w, I] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(b), M = w - v, C = I - y, P = M / C, k = Math.max($e68ba20b3d2d159d$var$$r, s === "width" ? Math.max(0, i) : M), _ = Math.max($e68ba20b3d2d159d$var$$r, s === "height" ? Math.max(0, i) : C);
                $e68ba20b3d2d159d$var$mA(k, _, C, P, [
                    v,
                    y
                ], s, g, b, l, r);
            } else {
                let [g] = h, b = g?.latest, v = g?.original;
                if (b && v && $e68ba20b3d2d159d$var$lo(b, s)) {
                    let y = s === "width" ? Math.max(0, i) : b.width;
                    s === "width" && (n ? y = $e68ba20b3d2d159d$var$ft(y, $e68ba20b3d2d159d$var$bc) : y = Math.round(y));
                    let w = s === "height" ? Math.max(0, i) : b.height;
                    s === "height" && (n ? w = $e68ba20b3d2d159d$var$ft(w, $e68ba20b3d2d159d$var$bc) : w = Math.round(w)), y = Math.max($e68ba20b3d2d159d$var$$r, y), w = Math.max($e68ba20b3d2d159d$var$$r, w), $e68ba20b3d2d159d$var$Ec(y, w, !1, v, l, c, a, !1);
                }
            }
        }
        a.triggerUpdate();
        return;
    }
    let m = s === "width" ? e : 0, p = s === "height" ? e : 0;
    for (let u of d){
        let h = $e68ba20b3d2d159d$var$fc(u, l, r);
        if (h.length > 1) {
            let g = h.map((A)=>A.latest), b = h.map((A)=>A.original), [v, y, w, I] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(b), M = w - v, C = I - y, P = M / C, k = Math.max(0, M + m);
            s === "width" && (n ? k = $e68ba20b3d2d159d$var$ft(k, $e68ba20b3d2d159d$var$bc) : k = Math.round(k));
            let _ = Math.max(0, C + p);
            s === "height" && (n ? _ = $e68ba20b3d2d159d$var$ft(_, $e68ba20b3d2d159d$var$bc) : _ = Math.round(_)), k = Math.max($e68ba20b3d2d159d$var$$r, k), _ = Math.max($e68ba20b3d2d159d$var$$r, _), $e68ba20b3d2d159d$var$mA(k, _, C, P, [
                v,
                y
            ], s, g, b, l, r);
        } else {
            let [g] = h, b = g?.latest, v = g?.original;
            if (b && v && $e68ba20b3d2d159d$var$lo(b, s)) {
                let y = Math.max(0, v.width + m);
                s === "width" && (n ? y = $e68ba20b3d2d159d$var$ft(y, $e68ba20b3d2d159d$var$bc) : y = Math.round(y));
                let w = Math.max(0, v.height + p);
                s === "height" && (n ? w = $e68ba20b3d2d159d$var$ft(w, $e68ba20b3d2d159d$var$bc) : w = Math.round(w)), y = Math.max($e68ba20b3d2d159d$var$$r, y), w = Math.max($e68ba20b3d2d159d$var$$r, w), $e68ba20b3d2d159d$var$Ec(y, w, !1, v, l, c, a);
            }
        }
    }
    a.triggerUpdate();
}, $e68ba20b3d2d159d$var$TN = ({ property: e, elements: t, elementsMap: r, atomicUnits: o, scene: n, appState: i })=>{
    let a = (0, $acw62.useMemo)(()=>o.map((c)=>{
            let d = $e68ba20b3d2d159d$var$fc(c, r);
            if (d.length > 1) {
                let [p, u, h, g] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(d.map((b)=>b.latest));
                return Math.round((e === "width" ? h - p : g - u) * 100) / 100;
            }
            let [m] = d;
            return Math.round((e === "width" ? m.latest.width : m.latest.height) * 100) / 100;
        }), [
        r,
        o,
        e
    ]), s = new Set(a).size === 1 ? Math.round(a[0] * 100) / 100 : "Mixed", l = a.length > 0;
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: e === "width" ? "W" : "H",
        elements: t,
        dragInputCallback: $e68ba20b3d2d159d$var$vN,
        value: s,
        editable: l,
        appState: i,
        property: e,
        scene: n
    });
}, $e68ba20b3d2d159d$var$y1 = $e68ba20b3d2d159d$var$TN;
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$IN = 15, $e68ba20b3d2d159d$var$CN = ({ accumulatedChange: e, originalElements: t, shouldChangeByStepSize: r, nextValue: o, property: n, scene: i })=>{
    let a = i.getNonDeletedElementsMap(), s = t.map((c)=>a.get(c.id)).filter((c)=>c && !$e68ba20b3d2d159d$var$Nn(c) && $e68ba20b3d2d159d$var$lo(c, n)), l = t.filter((c)=>!$e68ba20b3d2d159d$var$Nn(c) && $e68ba20b3d2d159d$var$lo(c, n));
    if (o !== void 0) {
        let c = $e68ba20b3d2d159d$var$Nl(o);
        for (let d of s){
            if (!d) continue;
            $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                angle: c
            }, !1);
            let m = $e68ba20b3d2d159d$var$te(d, a);
            m && !$e68ba20b3d2d159d$var$ie(d) && $e68ba20b3d2d159d$export$55655e96a21bba2e(m, {
                angle: c
            }, !1);
        }
        i.triggerUpdate();
        return;
    }
    for(let c = 0; c < s.length; c++){
        let d = s[c];
        if (!d) continue;
        let m = l[c], p = Math.round($e68ba20b3d2d159d$var$Rl(m.angle) * 100) / 100, u = Math.round(e), h = (p + u) % 360;
        r && (h = $e68ba20b3d2d159d$var$ft(h, $e68ba20b3d2d159d$var$IN)), h = h < 0 ? h + 360 : h;
        let g = $e68ba20b3d2d159d$var$Nl(h);
        $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
            angle: g
        }, !1);
        let b = $e68ba20b3d2d159d$var$te(d, a);
        b && !$e68ba20b3d2d159d$var$ie(d) && $e68ba20b3d2d159d$export$55655e96a21bba2e(b, {
            angle: g
        }, !1);
    }
    i.triggerUpdate();
}, $e68ba20b3d2d159d$var$AN = ({ elements: e, scene: t, appState: r, property: o })=>{
    let n = e.filter((l)=>!$e68ba20b3d2d159d$var$Nn(l) && $e68ba20b3d2d159d$var$lo(l, "angle")), i = n.map((l)=>Math.round($e68ba20b3d2d159d$var$Rl(l.angle) % 360 * 100) / 100), a = new Set(i).size === 1 ? i[0] : "Mixed", s = n.some((l)=>$e68ba20b3d2d159d$var$lo(l, "angle"));
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: "A",
        icon: $e68ba20b3d2d159d$var$bp,
        value: a,
        elements: e,
        dragInputCallback: $e68ba20b3d2d159d$var$CN,
        editable: s,
        appState: r,
        scene: t,
        property: o
    });
}, $e68ba20b3d2d159d$var$pA = $e68ba20b3d2d159d$var$AN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$We();
var $e68ba20b3d2d159d$var$uA = 4, $e68ba20b3d2d159d$var$kN = 4, $e68ba20b3d2d159d$var$PN = (e, t)=>e.reduce((r, o)=>{
        if (!o || $e68ba20b3d2d159d$var$Nn(o)) return r;
        if ($e68ba20b3d2d159d$var$G(o)) return r.push(o), r;
        if ($e68ba20b3d2d159d$var$It(o)) {
            let n = $e68ba20b3d2d159d$var$te(o, t);
            if (n) return r.push(n), r;
        }
        return r;
    }, []), $e68ba20b3d2d159d$var$LN = ({ accumulatedChange: e, originalElements: t, shouldChangeByStepSize: r, nextValue: o, scene: n })=>{
    let i = n.getNonDeletedElementsMap(), a = t.map((l)=>i.get(l.id)), s;
    if (o) {
        s = Math.max(Math.round(o), $e68ba20b3d2d159d$var$uA);
        for (let l of a)$e68ba20b3d2d159d$export$55655e96a21bba2e(l, {
            fontSize: s
        }, !1), $e68ba20b3d2d159d$var$gt(l, n.getContainerElement(l), i, !1);
        n.triggerUpdate();
    } else {
        let l = t;
        for(let c = 0; c < a.length; c++){
            let d = a[c], m = l[c], p = Math.round(m.fontSize), u = Math.round(e), h = Math.max(p + u, $e68ba20b3d2d159d$var$uA);
            r && (h = $e68ba20b3d2d159d$var$ft(h, $e68ba20b3d2d159d$var$kN)), $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                fontSize: h
            }, !1), $e68ba20b3d2d159d$var$gt(d, n.getContainerElement(d), i, !1);
        }
        n.triggerUpdate();
    }
}, $e68ba20b3d2d159d$var$DN = ({ elements: e, scene: t, appState: r, property: o, elementsMap: n })=>{
    let i = $e68ba20b3d2d159d$var$PN(e, n);
    if (!i.length) return null;
    let a = i.map((c)=>Math.round(c.fontSize * 10) / 10), s = new Set(a).size === 1 ? a[0] : "Mixed", l = a.length > 0;
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: "F",
        icon: $e68ba20b3d2d159d$var$Ka,
        elements: i,
        dragInputCallback: $e68ba20b3d2d159d$var$LN,
        value: s,
        editable: l,
        scene: t,
        property: o,
        appState: r
    });
}, $e68ba20b3d2d159d$var$hA = $e68ba20b3d2d159d$var$DN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$rt();
var $e68ba20b3d2d159d$var$gA = 10, $e68ba20b3d2d159d$var$RN = ({ accumulatedChange: e, originalElements: t, originalElementsMap: r, shouldChangeByStepSize: o, nextValue: n, property: i, scene: a })=>{
    let s = a.getNonDeletedElementsMap(), l = a.getNonDeletedElements(), c = t[0], [d, m] = [
        c.x + c.width / 2,
        c.y + c.height / 2
    ], [p, u] = $e68ba20b3d2d159d$var$Ee(c.x, c.y, d, m, c.angle);
    if (n !== void 0) {
        $e68ba20b3d2d159d$var$Ns(i === "x" ? n : p, i === "y" ? n : u, c, s, l, a, r);
        return;
    }
    let h = i === "x" ? e : 0, g = i === "y" ? e : 0, b = i === "x" ? Math.round(o ? $e68ba20b3d2d159d$var$ft(c.x + h, $e68ba20b3d2d159d$var$gA) : p + h) : p, v = i === "y" ? Math.round(o ? $e68ba20b3d2d159d$var$ft(c.y + g, $e68ba20b3d2d159d$var$gA) : u + g) : u;
    $e68ba20b3d2d159d$var$Ns(b, v, c, s, l, a, r);
}, $e68ba20b3d2d159d$var$NN = ({ property: e, element: t, elementsMap: r, scene: o, appState: n })=>{
    let [i, a] = $e68ba20b3d2d159d$var$Ee(t.x, t.y, t.x + t.width / 2, t.y + t.height / 2, t.angle), s = Math.round((e === "x" ? i : a) * 100) / 100;
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: e === "x" ? "X" : "Y",
        elements: [
            t
        ],
        dragInputCallback: $e68ba20b3d2d159d$var$RN,
        scene: o,
        value: s,
        property: e,
        appState: n
    });
}, $e68ba20b3d2d159d$var$w1 = $e68ba20b3d2d159d$var$NN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$rt();
$e68ba20b3d2d159d$var$ye();
var $e68ba20b3d2d159d$var$BN = 10, $e68ba20b3d2d159d$var$zN = (e, t, r, o, n, i, a, s)=>{
    for(let l = 0; l < o.length; l++){
        let c = n[l], [d, m] = [
            c.x + c.width / 2,
            c.y + c.height / 2
        ], [p, u] = $e68ba20b3d2d159d$var$Ee(c.x, c.y, d, m, c.angle), h = e === "x" ? Math.round(p + t) : p, g = e === "y" ? Math.round(u + r) : u;
        $e68ba20b3d2d159d$var$Ns(h, g, c, i, o, s, a, !1);
    }
}, $e68ba20b3d2d159d$var$HN = (e, t, r, o, n, i, a)=>{
    let [s, l] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(r), c = e - s, d = t - l;
    for(let m = 0; m < r.length; m++){
        let p = r[m], u = o.get(p.id);
        if (u && (!$e68ba20b3d2d159d$var$G(u) || !u.containerId)) {
            let [h, g] = [
                u.x + u.width / 2,
                u.y + u.height / 2
            ], [b, v] = $e68ba20b3d2d159d$var$Ee(u.x, u.y, h, g, u.angle);
            $e68ba20b3d2d159d$var$Ns(b + c, v + d, p, o, n, a, i, !1);
        }
    }
}, $e68ba20b3d2d159d$var$UN = ({ accumulatedChange: e, originalElements: t, originalElementsMap: r, shouldChangeByStepSize: o, nextValue: n, property: i, scene: a, originalAppState: s })=>{
    let l = a.getNonDeletedElementsMap(), c = a.getNonDeletedElements();
    if (n !== void 0) {
        for (let u of $e68ba20b3d2d159d$var$xc(t, s)){
            let h = $e68ba20b3d2d159d$var$fc(u, l, r);
            if (h.length > 1) {
                let [g, b] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(h.map((w)=>w.latest));
                $e68ba20b3d2d159d$var$HN(i === "x" ? n : g, i === "y" ? n : b, h.map((w)=>w.original), l, c, r, a);
            } else {
                let g = h[0]?.original, b = h[0]?.latest;
                if (g && b && $e68ba20b3d2d159d$var$lo(b, i)) {
                    let [v, y] = [
                        g.x + g.width / 2,
                        g.y + g.height / 2
                    ], [w, I] = $e68ba20b3d2d159d$var$Ee(g.x, g.y, v, y, g.angle);
                    $e68ba20b3d2d159d$var$Ns(i === "x" ? n : w, i === "y" ? n : I, g, l, c, a, r, !1);
                }
            }
        }
        a.triggerUpdate();
        return;
    }
    let d = o ? $e68ba20b3d2d159d$var$ft(e, $e68ba20b3d2d159d$var$BN) : e;
    $e68ba20b3d2d159d$var$zN(i, i === "x" ? d : 0, i === "y" ? d : 0, t, t, l, r, a), a.triggerUpdate();
}, $e68ba20b3d2d159d$var$GN = ({ property: e, elements: t, elementsMap: r, atomicUnits: o, scene: n, appState: i })=>{
    let a = (0, $acw62.useMemo)(()=>o.map((l)=>{
            let c = Object.keys(l).map((g)=>r.get(g)).filter((g)=>g !== void 0);
            if (c.length > 1) {
                let [g, b] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(c);
                return Math.round((e === "x" ? g : b) * 100) / 100;
            }
            let [d] = c, [m, p] = [
                d.x + d.width / 2,
                d.y + d.height / 2
            ], [u, h] = $e68ba20b3d2d159d$var$Ee(d.x, d.y, m, p, d.angle);
            return Math.round((e === "x" ? u : h) * 100) / 100;
        }), [
        o,
        r,
        e
    ]), s = new Set(a).size === 1 ? a[0] : "Mixed";
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: e === "x" ? "X" : "Y",
        elements: t,
        dragInputCallback: $e68ba20b3d2d159d$var$UN,
        value: s,
        property: e,
        scene: n,
        appState: i
    });
}, $e68ba20b3d2d159d$var$v1 = $e68ba20b3d2d159d$var$GN;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$VN = ({ label: e, open: t, openTrigger: r, children: o })=>(0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                onClick: r,
                children: [
                    e,
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ga, {
                        icon: t ? $e68ba20b3d2d159d$var$s2 : $e68ba20b3d2d159d$var$a2
                    })
                ]
            }),
            t && (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: o
            })
        ]
    }), $e68ba20b3d2d159d$var$T1 = $e68ba20b3d2d159d$var$VN;
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Xe();
var $e68ba20b3d2d159d$var$xA = 5, $e68ba20b3d2d159d$var$XN = ({ property: e, scene: t, appState: r, setAppState: o })=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ir, {
        label: "Grid step",
        sensitivity: 8,
        elements: [],
        dragInputCallback: ({ nextValue: n, instantChange: i, shouldChangeByStepSize: a, setInputValue: s })=>{
            o((l)=>{
                let c;
                return n ? c = n : i && (c = a ? $e68ba20b3d2d159d$var$ft(l.gridStep + $e68ba20b3d2d159d$var$xA * Math.sign(i), $e68ba20b3d2d159d$var$xA) : l.gridStep + i), c ? (c = $e68ba20b3d2d159d$var$od(c), s(c), {
                    gridStep: c
                }) : (s(l.gridStep), null);
            });
        },
        scene: t,
        value: r.gridStep,
        property: e,
        appState: r
    }), $e68ba20b3d2d159d$var$bA = $e68ba20b3d2d159d$var$XN;
var $e68ba20b3d2d159d$var$JN = 50, $e68ba20b3d2d159d$export$3cdec2bba15e3523 = (e)=>{
    let t = $e68ba20b3d2d159d$var$Yn(), r = e.app.scene.getSceneNonce() || 1, o = e.app.scene.getSelectedElements({
        selectedElementIds: t.selectedElementIds,
        includeBoundTextElement: !1
    }), n = $e68ba20b3d2d159d$var$ba(e.app);
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$QN, {
        ...e,
        appState: t,
        sceneNonce: r,
        selectedElements: o,
        gridModeEnabled: n
    });
}, $e68ba20b3d2d159d$var$Tt = ({ children: e, columns: t = 1, heading: r, style: o, ...n })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("exc-stats__row", {
            "exc-stats__row--heading": r
        }),
        style: {
            gridTemplateColumns: `repeat(${t}, 1fr)`,
            ...o
        },
        ...n,
        children: e
    });
$e68ba20b3d2d159d$var$Tt.displayName = "StatsRow";
var $e68ba20b3d2d159d$var$Rg = ({ children: e, order: t, style: r, ...o })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "exc-stats__rows",
        style: {
            order: t,
            ...r
        },
        ...o,
        children: e
    });
$e68ba20b3d2d159d$var$Rg.displayName = "StatsRows";
$e68ba20b3d2d159d$export$3cdec2bba15e3523.StatsRow = $e68ba20b3d2d159d$var$Tt;
$e68ba20b3d2d159d$export$3cdec2bba15e3523.StatsRows = $e68ba20b3d2d159d$var$Rg;
var $e68ba20b3d2d159d$var$QN = (0, $acw62.memo)(({ app: e, onClose: t, renderCustomStats: r, selectedElements: o, appState: n, sceneNonce: i, gridModeEnabled: a })=>{
    let s = e.scene, l = s.getNonDeletedElements(), c = s.getNonDeletedElementsMap(), d = $e68ba20b3d2d159d$var$He(), m = o.length === 1 ? o[0] : null, p = o.length > 1 ? o : null, [u, h] = (0, $acw62.useState)({
        width: 0,
        height: 0
    }), g = (0, $acw62.useMemo)(()=>(0, $f1q41.throttle)((v)=>{
            let y = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(v);
            h({
                width: Math.round(y[2]) - Math.round(y[0]),
                height: Math.round(y[3]) - Math.round(y[1])
            });
        }, $e68ba20b3d2d159d$var$JN), []);
    (0, $acw62.useEffect)(()=>{
        g(l);
    }, [
        i,
        l,
        g
    ]), (0, $acw62.useEffect)(()=>()=>g.cancel(), [
        g
    ]);
    let b = (0, $acw62.useMemo)(()=>$e68ba20b3d2d159d$var$xc(o, n), [
        o,
        n
    ]);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "exc-stats",
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
            padding: 3,
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "title",
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("h2", {
                            children: $e68ba20b3d2d159d$var$x("stats.title")
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "close",
                            onClick: t,
                            children: $e68ba20b3d2d159d$var$Po
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$T1, {
                    label: (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: $e68ba20b3d2d159d$var$x("stats.generalStats")
                    }),
                    open: !!(n.stats.panels & $e68ba20b3d2d159d$var$Bi.generalStats),
                    openTrigger: ()=>d((v)=>({
                                stats: {
                                    open: !0,
                                    panels: v.stats.panels ^ $e68ba20b3d2d159d$var$Bi.generalStats
                                }
                            })),
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Rg, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                    heading: !0,
                                    children: $e68ba20b3d2d159d$var$x("stats.scene")
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Tt, {
                                    columns: 2,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: $e68ba20b3d2d159d$var$x("stats.shapes")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: l.length
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Tt, {
                                    columns: 2,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: $e68ba20b3d2d159d$var$x("stats.width")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: u.width
                                        })
                                    ]
                                }),
                                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Tt, {
                                    columns: 2,
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: $e68ba20b3d2d159d$var$x("stats.height")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: u.height
                                        })
                                    ]
                                }),
                                a && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            heading: !0,
                                            children: "Canvas"
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$bA, {
                                                property: "gridStep",
                                                scene: s,
                                                appState: n,
                                                setAppState: d
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        r?.(l, n)
                    ]
                }),
                o.length > 0 && (0, $7b02d682eb115277$exports.jsx)("div", {
                    id: "elementStats",
                    style: {
                        marginTop: 12
                    },
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$T1, {
                        label: (0, $7b02d682eb115277$exports.jsx)("h3", {
                            children: $e68ba20b3d2d159d$var$x("stats.elementProperties")
                        }),
                        open: !!(n.stats.panels & $e68ba20b3d2d159d$var$Bi.elementProperties),
                        openTrigger: ()=>d((v)=>({
                                    stats: {
                                        open: !0,
                                        panels: v.stats.panels ^ $e68ba20b3d2d159d$var$Bi.elementProperties
                                    }
                                })),
                        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Rg, {
                            children: [
                                m && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            heading: !0,
                                            "data-testid": "stats-element-type",
                                            children: $e68ba20b3d2d159d$var$x(`element.${m.type}`)
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$w1, {
                                                element: m,
                                                property: "x",
                                                elementsMap: c,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$w1, {
                                                element: m,
                                                property: "y",
                                                elementsMap: c,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$b1, {
                                                property: "width",
                                                element: m,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$b1, {
                                                property: "height",
                                                element: m,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        !$e68ba20b3d2d159d$var$ce(m) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$lA, {
                                                property: "angle",
                                                element: m,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$dA, {
                                                property: "fontSize",
                                                element: m,
                                                scene: s,
                                                appState: n
                                            })
                                        })
                                    ]
                                }),
                                p && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        $e68ba20b3d2d159d$var$gy(p) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            heading: !0,
                                            children: $e68ba20b3d2d159d$var$x("element.group")
                                        }),
                                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Tt, {
                                            columns: 2,
                                            style: {
                                                margin: "0.3125rem 0"
                                            },
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: $e68ba20b3d2d159d$var$x("stats.shapes")
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: o.length
                                                })
                                            ]
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$v1, {
                                                property: "x",
                                                elements: p,
                                                elementsMap: c,
                                                atomicUnits: b,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$v1, {
                                                property: "y",
                                                elements: p,
                                                elementsMap: c,
                                                atomicUnits: b,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$y1, {
                                                property: "width",
                                                elements: p,
                                                elementsMap: c,
                                                atomicUnits: b,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$y1, {
                                                property: "height",
                                                elements: p,
                                                elementsMap: c,
                                                atomicUnits: b,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pA, {
                                                property: "angle",
                                                elements: p,
                                                scene: s,
                                                appState: n
                                            })
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Tt, {
                                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$hA, {
                                                property: "fontSize",
                                                elements: p,
                                                scene: s,
                                                appState: n,
                                                elementsMap: c
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}, (e, t)=>e.sceneNonce === t.sceneNonce && e.selectedElements === t.selectedElements && e.appState.stats.panels === t.appState.stats.panels && e.gridModeEnabled === t.gridModeEnabled && e.appState.gridStep === t.appState.gridStep);
var $e68ba20b3d2d159d$var$n9 = ({ UIOptions: e })=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$export$4e08dcf990b776c0, {
        __fallback: !0,
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.LoadScene, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.SaveToActiveFile, {}),
            e.canvasActions.export && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.Export, {}),
            e.canvasActions.saveAsImage && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.SaveAsImage, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.Help, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.ClearCanvas, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.Separator, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.Group, {
                title: "Excalidraw links",
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.Socials, {})
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.Separator, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.ToggleTheme, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$4e08dcf990b776c0.DefaultItems.ChangeCanvasBackground, {})
        ]
    }), $e68ba20b3d2d159d$var$i9 = ()=>(0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$wg, {
        __fallback: !0,
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wg.Actions.SaveToDisk, {}),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wg.Actions.ExportToImage, {})
        ]
    }), $e68ba20b3d2d159d$var$a9 = ({ actionManager: e, appState: t, files: r, setAppState: o, elements: n, canvas: i, onLockToggle: a, onHandToolToggle: s, onPenModeToggle: l, showExitZenModeBtn: c, renderTopRightUI: d, renderCustomStats: m, UIOptions: p, onExportImage: u, renderWelcomeScreen: h, children: g, app: b, isCollaborating: v })=>{
    let y = $e68ba20b3d2d159d$export$aa949327762d0f40(), w = $e68ba20b3d2d159d$var$sC(), [I, M] = (0, $051474e5c5a9c9ad$export$83cf7ae8bb57e7ed)($e68ba20b3d2d159d$var$da, $e68ba20b3d2d159d$var$$e), C = ()=>p.canvasActions.export ? (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$e5, {
            elements: n,
            appState: t,
            files: r,
            actionManager: e,
            exportOpts: p.canvasActions.export,
            canvas: i,
            setAppState: o
        }) : null, P = ()=>!p.canvasActions.saveAsImage || t.openDialog?.name !== "imageExport" ? null : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$CC, {
            elements: n,
            appState: t,
            files: r,
            actionManager: e,
            onExportImage: u,
            onCloseRequest: ()=>o({
                    openDialog: null
                }),
            name: b.getName()
        }), k = ()=>(0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                position: "relative"
            },
            children: [
                (0, $7b02d682eb115277$exports.jsx)(w.MainMenuTunnel.Out, {}),
                h && (0, $7b02d682eb115277$exports.jsx)(w.WelcomeScreenMenuHintTunnel.Out, {})
            ]
        }), _ = ()=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ya, {
            heading: "selectedShapeActions",
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("selected-shape-actions zen-mode-transition", {
                "transition-left": t.zenModeEnabled
            }),
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kt, {
                className: $e68ba20b3d2d159d$var$Na.SHAPE_ACTIONS_MENU,
                padding: 2,
                style: {
                    maxHeight: `${t.height - 166}px`
                },
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$qh, {
                    appState: t,
                    elementsMap: b.scene.getNonDeletedElementsMap(),
                    renderAction: e.renderAction
                })
            })
        }), A = ()=>{
        let ee = $e68ba20b3d2d159d$var$vs(t, n), N = t.stats.open && !t.zenModeEnabled && !t.viewModeEnabled;
        return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ig, {
            side: "top",
            children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "App-menu App-menu_top",
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Col, {
                        gap: 6,
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("App-menu_top__left"),
                        children: [
                            k(),
                            ee && _()
                        ]
                    }),
                    !t.viewModeEnabled && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ya, {
                        heading: "shapes",
                        className: "shapes-section",
                        children: (H)=>(0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    h && (0, $7b02d682eb115277$exports.jsx)(w.WelcomeScreenToolbarHintTunnel.Out, {}),
                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$or.Col, {
                                        gap: 4,
                                        align: "start",
                                        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Row, {
                                            gap: 1,
                                            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("App-toolbar-container", {
                                                "zen-mode": t.zenModeEnabled
                                            }),
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Kt, {
                                                    padding: 1,
                                                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("App-toolbar", {
                                                        "zen-mode": t.zenModeEnabled
                                                    }),
                                                    children: [
                                                        (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$cg, {
                                                            appState: t,
                                                            isMobile: y.editor.isMobile,
                                                            device: y,
                                                            app: b
                                                        }),
                                                        H,
                                                        (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$or.Row, {
                                                            gap: 1,
                                                            children: [
                                                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$mg, {
                                                                    zenModeEnabled: t.zenModeEnabled,
                                                                    checked: t.penMode,
                                                                    onChange: ()=>l(null),
                                                                    title: $e68ba20b3d2d159d$var$x("toolBar.penMode"),
                                                                    penDetected: t.penDetected
                                                                }),
                                                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$dg, {
                                                                    checked: t.activeTool.locked,
                                                                    onChange: a,
                                                                    title: $e68ba20b3d2d159d$var$x("toolBar.lock")
                                                                }),
                                                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "App-toolbar__divider"
                                                                }),
                                                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pg, {
                                                                    checked: $e68ba20b3d2d159d$var$Jo(t),
                                                                    onChange: ()=>s(),
                                                                    title: $e68ba20b3d2d159d$var$x("toolBar.hand"),
                                                                    isMobile: !0
                                                                }),
                                                                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Jh, {
                                                                    appState: t,
                                                                    activeTool: t.activeTool,
                                                                    UIOptions: p,
                                                                    app: b
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                v && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kt, {
                                                    style: {
                                                        marginLeft: 8,
                                                        alignSelf: "center",
                                                        height: "fit-content"
                                                    },
                                                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$B5, {
                                                        title: $e68ba20b3d2d159d$var$x("toolBar.laser"),
                                                        checked: t.activeTool.type === $e68ba20b3d2d159d$var$St.laser,
                                                        onChange: ()=>b.setActiveTool({
                                                                type: $e68ba20b3d2d159d$var$St.laser
                                                            }),
                                                        isMobile: !0
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("layer-ui__wrapper__top-right zen-mode-transition", {
                            "transition-right": t.zenModeEnabled
                        }),
                        children: [
                            t.collaborators.size > 0 && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gg, {
                                collaborators: t.collaborators,
                                userToFollow: t.userToFollow?.socketId || null
                            }),
                            d?.(y.editor.isMobile, t),
                            !t.viewModeEnabled && (!B || t.openSidebar?.name !== $e68ba20b3d2d159d$var$mo.name) && (0, $7b02d682eb115277$exports.jsx)(w.DefaultSidebarTriggerTunnel.Out, {}),
                            N && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$3cdec2bba15e3523, {
                                app: b,
                                onClose: ()=>{
                                    e.executeAction($e68ba20b3d2d159d$var$rc);
                                },
                                renderCustomStats: m
                            })
                        ]
                    })
                ]
            })
        });
    }, R = ()=>(0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$2c2622abfb448137, {
            __fallback: !0,
            onDock: (ee)=>{
                $e68ba20b3d2d159d$var$Pe("sidebar", `toggleDock (${ee ? "dock" : "undock"})`, `(${y.editor.isMobile ? "mobile" : "desktop"})`);
            }
        }), B = (0, $051474e5c5a9c9ad$export$89a40582f8c436cc)($e68ba20b3d2d159d$var$cm, $e68ba20b3d2d159d$var$$e), V = (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            g,
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$n9, {
                UIOptions: p
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$2c2622abfb448137.Trigger, {
                __fallback: !0,
                icon: $e68ba20b3d2d159d$var$pp,
                title: $e68ba20b3d2d159d$var$zi($e68ba20b3d2d159d$var$x("toolBar.library")),
                onToggle: (ee)=>{
                    ee && $e68ba20b3d2d159d$var$Pe("sidebar", `${$e68ba20b3d2d159d$var$mo.name} (open)`, `button (${y.editor.isMobile ? "mobile" : "desktop"})`);
                },
                tab: $e68ba20b3d2d159d$var$mo.defaultTab,
                children: $e68ba20b3d2d159d$var$x("toolBar.library")
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$i9, {}),
            t.openDialog?.name === "ttd" && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$export$a14571c7e5344c80, {
                __fallback: !0
            }),
            t.isLoading && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Vm, {
                delay: 250
            }),
            t.errorMessage && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$vC, {
                onClose: ()=>o({
                        errorMessage: null
                    }),
                children: t.errorMessage
            }),
            I && !y.editor.isMobile && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$gS, {
                colorPickerType: I.colorPickerType,
                onCancel: ()=>{
                    M(null);
                },
                onChange: (ee, N, H, { altKey: xe })=>{
                    if (!(ee !== "elementBackground" && ee !== "elementStroke")) {
                        if (H.length) {
                            for (let X of H)$e68ba20b3d2d159d$export$55655e96a21bba2e(X, {
                                [xe && I.swapPreviewOnAlt ? ee === "elementBackground" ? "strokeColor" : "backgroundColor" : ee === "elementBackground" ? "backgroundColor" : "strokeColor"]: N
                            }, !1), $e68ba20b3d2d159d$var$Oe.delete(X);
                            $e68ba20b3d2d159d$var$fr.getScene(H[0])?.triggerUpdate();
                        } else o(ee === "elementBackground" ? {
                            currentItemBackgroundColor: N
                        } : {
                            currentItemStrokeColor: N
                        });
                    }
                },
                onSelect: (ee, N)=>{
                    M((H)=>H?.keepOpenOnAlt && N.altKey ? H : null), I?.onSelect?.(ee, N);
                }
            }),
            t.openDialog?.name === "help" && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$qC, {
                onClose: ()=>{
                    o({
                        openDialog: null
                    });
                }
            }),
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pC, {}),
            (0, $7b02d682eb115277$exports.jsx)(w.OverwriteConfirmDialogTunnel.Out, {}),
            P(),
            C(),
            t.pasteDialog.shown && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$jC, {
                setAppState: o,
                appState: t,
                onClose: ()=>o({
                        pasteDialog: {
                            shown: !1,
                            data: null
                        }
                    })
            }),
            y.editor.isMobile && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$$C, {
                app: b,
                appState: t,
                elements: n,
                actionManager: e,
                renderJSONExportDialog: C,
                renderImageExportDialog: P,
                setAppState: o,
                onLockToggle: a,
                onHandToolToggle: s,
                onPenModeToggle: l,
                renderTopRightUI: d,
                renderCustomStats: m,
                renderSidebars: R,
                device: y,
                renderWelcomeScreen: h,
                UIOptions: p
            }),
            !y.editor.isMobile && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "layer-ui__wrapper",
                        style: t.openSidebar && B && y.editor.canFitSidebar ? {
                            width: `calc(100% - ${$e68ba20b3d2d159d$var$L0}px)`
                        } : {},
                        children: [
                            h && (0, $7b02d682eb115277$exports.jsx)(w.WelcomeScreenCenterTunnel.Out, {}),
                            A(),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$o5, {
                                appState: t,
                                actionManager: e,
                                showExitZenModeBtn: c,
                                renderWelcomeScreen: h
                            }),
                            t.scrolledOutside && (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "scroll-back-to-content",
                                onClick: ()=>{
                                    o((ee)=>({
                                            ...$e68ba20b3d2d159d$var$Hn(n, ee)
                                        }));
                                },
                                children: $e68ba20b3d2d159d$var$x("buttons.scrollBackToContent")
                            })
                        ]
                    }),
                    R()
                ]
            })
        ]
    });
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Lx.Provider, {
        value: t,
        children: (0, $7b02d682eb115277$exports.jsx)((0, $051474e5c5a9c9ad$export$2881499e37b75b9a), {
            scope: w.jotaiScope,
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Pb.Provider, {
                value: w,
                children: V
            })
        })
    });
}, $e68ba20b3d2d159d$var$vA = (e)=>{
    let { suggestedBindings: t, startBoundElement: r, cursorButton: o, scrollX: n, scrollY: i, ...a } = e;
    return a;
}, $e68ba20b3d2d159d$var$s9 = (e, t)=>{
    if (e.children !== t.children) return !1;
    let { canvas: r, appState: o, ...n } = e, { canvas: i, appState: a, ...s } = t;
    return $e68ba20b3d2d159d$var$at($e68ba20b3d2d159d$var$vA(o), $e68ba20b3d2d159d$var$vA(a), {
        selectedElementIds: $e68ba20b3d2d159d$var$at,
        selectedGroupIds: $e68ba20b3d2d159d$var$at
    }) && $e68ba20b3d2d159d$var$at(n, s);
}, $e68ba20b3d2d159d$var$SA = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($e68ba20b3d2d159d$var$a9, $e68ba20b3d2d159d$var$s9);
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$m9 = 5e3, $e68ba20b3d2d159d$var$CA = ({ message: e, onClose: t, closable: r = !1, duration: o = $e68ba20b3d2d159d$var$m9, style: n })=>{
    let i = (0, $acw62.useRef)(0), a = o !== 1 / 0, s = (0, $acw62.useCallback)(()=>{
        a && (i.current = window.setTimeout(()=>t(), o));
    }, [
        t,
        o,
        a
    ]);
    return (0, $acw62.useEffect)(()=>{
        if (a) return s(), ()=>clearTimeout(i.current);
    }, [
        s,
        e,
        o,
        a
    ]), (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "Toast",
        onMouseEnter: a ? ()=>clearTimeout(i?.current) : void 0,
        onMouseLeave: a ? s : void 0,
        style: n,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "Toast__message",
                children: e
            }),
            r && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$he, {
                icon: $e68ba20b3d2d159d$var$Po,
                "aria-label": "close",
                type: "icon",
                onClick: t,
                className: "close"
            })
        ]
    });
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$I1 = $e68ba20b3d2d159d$var$U({
    name: "viewMode",
    label: "labels.viewMode",
    paletteName: "Toggle view mode",
    icon: $e68ba20b3d2d159d$var$tl,
    viewMode: !0,
    trackEvent: {
        category: "canvas",
        predicate: (e)=>!e.viewModeEnabled
    },
    perform (e, t) {
        return {
            appState: {
                ...t,
                viewModeEnabled: !this.checked(t)
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    checked: (e)=>e.viewModeEnabled,
    predicate: (e, t, r)=>typeof r.viewModeEnabled > "u",
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && e.altKey && e.code === $e68ba20b3d2d159d$var$Ae.R
});
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$TE();
$e68ba20b3d2d159d$var$mi();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$Va();
$e68ba20b3d2d159d$var$Nd();
$e68ba20b3d2d159d$var$pn();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$Wi();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$gr();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Zs();
$e68ba20b3d2d159d$var$je();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$Be();
var $e68ba20b3d2d159d$var$AA = (e, t)=>{
    let r = t.scene.getSelectedElements(e);
    return r.length === 1 && $e68ba20b3d2d159d$var$re(r[0]);
}, $e68ba20b3d2d159d$var$MA = $e68ba20b3d2d159d$var$U({
    name: "selectAllElementsInFrame",
    label: "labels.selectAllElementsInFrame",
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t).at(0) || null;
        if ($e68ba20b3d2d159d$var$re(n)) {
            let i = $e68ba20b3d2d159d$var$bo($e68ba20b3d2d159d$export$a9f9e75229944f66(e), n.id).filter((a)=>!(a.type === "text" && a.containerId));
            return {
                elements: e,
                appState: {
                    ...t,
                    selectedElementIds: i.reduce((a, s)=>(a[s.id] = !0, a), {})
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            };
        }
        return {
            elements: e,
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    predicate: (e, t, r, o)=>$e68ba20b3d2d159d$var$AA(t, o)
}), $e68ba20b3d2d159d$var$kA = $e68ba20b3d2d159d$var$U({
    name: "removeAllElementsFromFrame",
    label: "labels.removeAllElementsFromFrame",
    trackEvent: {
        category: "history"
    },
    perform: (e, t, r, o)=>{
        let n = o.scene.getSelectedElements(t).at(0) || null;
        return $e68ba20b3d2d159d$var$re(n) ? {
            elements: $e68ba20b3d2d159d$var$OE(e, n),
            appState: {
                ...t,
                selectedElementIds: {
                    [n.id]: !0
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        } : {
            elements: e,
            appState: t,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    predicate: (e, t, r, o)=>$e68ba20b3d2d159d$var$AA(t, o)
}), $e68ba20b3d2d159d$var$wIe = $e68ba20b3d2d159d$var$U({
    name: "updateFrameRendering",
    label: "labels.updateFrameRendering",
    viewMode: !0,
    trackEvent: {
        category: "canvas"
    },
    perform: (e, t)=>({
            elements: e,
            appState: {
                ...t,
                frameRendering: {
                    ...t.frameRendering,
                    enabled: !t.frameRendering.enabled
                }
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        }),
    checked: (e)=>e.frameRendering.enabled
}), $e68ba20b3d2d159d$var$vIe = $e68ba20b3d2d159d$var$U({
    name: "setFrameAsActiveTool",
    label: "toolBar.frame",
    trackEvent: {
        category: "toolbar"
    },
    icon: $e68ba20b3d2d159d$var$vp,
    viewMode: !1,
    perform: (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$it(t, {
            type: "frame"
        });
        return $e68ba20b3d2d159d$var$ho(o.interactiveCanvas, {
            ...t,
            activeTool: n
        }), {
            elements: e,
            appState: {
                ...t,
                activeTool: $e68ba20b3d2d159d$var$it(t, {
                    type: "frame"
                })
            },
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE
        };
    },
    keyTest: (e)=>!e[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !e.shiftKey && !e.altKey && e.key.toLocaleLowerCase() === $e68ba20b3d2d159d$var$S.F
});
$e68ba20b3d2d159d$var$Gi();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$u9 = ()=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "brave-measure-text-error",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "errors.brave_measure_text_error.line1",
                    bold: (e)=>(0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontWeight: 600
                            },
                            children: e
                        })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "errors.brave_measure_text_error.line2",
                    bold: (e)=>(0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontWeight: 600
                            },
                            children: e
                        })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "errors.brave_measure_text_error.line3",
                    link: (e)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "http://docs.excalidraw.com/docs/@excalidraw/excalidraw/faq#turning-off-aggresive-block-fingerprinting-in-brave-browser",
                            children: e
                        })
                })
            }),
            (0, $7b02d682eb115277$exports.jsx)("p", {
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Gr, {
                    i18nKey: "errors.brave_measure_text_error.line4",
                    issueLink: (e)=>(0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://github.com/excalidraw/excalidraw/issues/new",
                            children: e
                        }),
                    discordLink: (e)=>(0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: "https://discord.gg/UexuTaE",
                            children: [
                                e,
                                "."
                            ]
                        })
                })
            })
        ]
    }), $e68ba20b3d2d159d$var$LA = $e68ba20b3d2d159d$var$u9;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$gn();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$$a();
$e68ba20b3d2d159d$var$jo();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$pn();
$e68ba20b3d2d159d$var$de();
var $e68ba20b3d2d159d$var$Ng = {
    width: 100,
    height: 0
}, $e68ba20b3d2d159d$var$Ca = 100, $e68ba20b3d2d159d$var$h9 = (e, t, r)=>{
    let o = $e68ba20b3d2d159d$var$er({
        x: 0,
        y: 0,
        textAlign: $e68ba20b3d2d159d$var$Oi.CENTER,
        verticalAlign: $e68ba20b3d2d159d$var$Pt.MIDDLE,
        ...t,
        containerId: e.id,
        strokeColor: t.strokeColor || e.strokeColor
    });
    return Object.assign(e, {
        boundElements: (e.boundElements || []).concat({
            type: "text",
            id: o.id
        })
    }), $e68ba20b3d2d159d$var$gt(o, e, r), [
        e,
        o
    ];
}, $e68ba20b3d2d159d$var$DA = (e, t, r, o, n)=>{
    let i, a;
    if (Object.assign(e, {
        startBinding: e?.startBinding || null,
        endBinding: e.endBinding || null
    }), t) {
        let d = t?.width ?? $e68ba20b3d2d159d$var$Ca, m = t?.height ?? $e68ba20b3d2d159d$var$Ca, p;
        t.id && (p = o.getElement(t.id), p || console.error(`No element for start binding with id ${t.id} found`));
        let u = t.x || e.x - d, h = t.y || e.y - m / 2, g = p ? p.type : t.type;
        if (g) {
            if (g === "text") {
                let b = "";
                p && p.type === "text" ? b = p.text : t.type === "text" && (b = t.text), b || console.error(`No text found for start binding text element for ${e.id}`), i = $e68ba20b3d2d159d$var$er({
                    x: u,
                    y: h,
                    type: "text",
                    ...p,
                    ...t,
                    text: b
                }), Object.assign(i, {
                    x: t.x || e.x - i.width,
                    y: t.y || e.y - i.height / 2
                });
            } else switch(g){
                case "rectangle":
                case "ellipse":
                case "diamond":
                    i = $e68ba20b3d2d159d$var$Ar({
                        x: u,
                        y: h,
                        width: d,
                        height: m,
                        ...p,
                        ...t,
                        type: g
                    });
                    break;
                default:
                    $e68ba20b3d2d159d$var$Zo(e, `Unhandled element start type "${t.type}"`, !0);
            }
            $e68ba20b3d2d159d$var$fo(e, i, "start", n);
        }
    }
    if (r) {
        let d = r?.height ?? $e68ba20b3d2d159d$var$Ca, m = r?.width ?? $e68ba20b3d2d159d$var$Ca, p;
        r.id && (p = o.getElement(r.id), p || console.error(`No element for end binding with id ${r.id} found`));
        let u = r.x || e.x + e.width, h = r.y || e.y - d / 2, g = p ? p.type : r.type;
        if (g) {
            if (g === "text") {
                let b = "";
                p && p.type === "text" ? b = p.text : r.type === "text" && (b = r.text), b || console.error(`No text found for end binding text element for ${e.id}`), a = $e68ba20b3d2d159d$var$er({
                    x: u,
                    y: h,
                    type: "text",
                    ...p,
                    ...r,
                    text: b
                }), Object.assign(a, {
                    y: r.y || e.y - a.height / 2
                });
            } else switch(g){
                case "rectangle":
                case "ellipse":
                case "diamond":
                    a = $e68ba20b3d2d159d$var$Ar({
                        x: u,
                        y: h,
                        width: m,
                        height: d,
                        ...p,
                        ...r,
                        type: g
                    });
                    break;
                default:
                    $e68ba20b3d2d159d$var$Zo(e, `Unhandled element end type "${g}"`, !0);
            }
            $e68ba20b3d2d159d$var$fo(e, a, "end", n);
        }
    }
    if (e.points.length < 2) return {
        linearElement: e,
        startBoundElement: i,
        endBoundElement: a
    };
    let s = e.points.length - 1, l = .5, c = $e68ba20b3d2d159d$var$jr(e.points);
    return e.points[s][0] > e.points[s - 1][0] && (c[0][0] = l, c[s][0] -= l), e.points[s][0] < e.points[s - 1][0] && (c[0][0] = -l, c[s][0] += l), e.points[s][1] > e.points[s - 1][1] && (c[0][1] = l, c[s][1] -= l), e.points[s][1] < e.points[s - 1][1] && (c[0][1] = -l, c[s][1] += l), Object.assign(e, {
        points: c
    }), {
        linearElement: e,
        startBoundElement: i,
        endBoundElement: a
    };
}, $e68ba20b3d2d159d$var$C1 = class {
    excalidrawElements = new Map;
    add = (t)=>{
        t && this.excalidrawElements.set(t.id, t);
    };
    getElements = ()=>$e68ba20b3d2d159d$var$Cr(Array.from(this.excalidrawElements.values()));
    getElementsMap = ()=>$e68ba20b3d2d159d$var$lr($e68ba20b3d2d159d$var$j(this.getElements()));
    getElement = (t)=>this.excalidrawElements.get(t);
}, $e68ba20b3d2d159d$export$586f70b13f801aaf = (e, t)=>{
    if (!e) return [];
    let r = $e68ba20b3d2d159d$var$jr(e), o = new $e68ba20b3d2d159d$var$C1, n = new Map, i = new Map;
    for (let s of r){
        let l, c = s.id;
        switch(t?.regenerateIds !== !1 && Object.assign(s, {
            id: $e68ba20b3d2d159d$var$Vt()
        }), s.type){
            case "rectangle":
            case "ellipse":
            case "diamond":
                {
                    let m = s?.label?.text && s.width === void 0 ? 0 : s?.width || $e68ba20b3d2d159d$var$Ca, p = s?.label?.text && s.height === void 0 ? 0 : s?.height || $e68ba20b3d2d159d$var$Ca;
                    l = $e68ba20b3d2d159d$var$Ar({
                        ...s,
                        width: m,
                        height: p
                    });
                    break;
                }
            case "line":
                {
                    let m = s.width || $e68ba20b3d2d159d$var$Ng.width, p = s.height || $e68ba20b3d2d159d$var$Ng.height;
                    l = $e68ba20b3d2d159d$var$un({
                        width: m,
                        height: p,
                        points: [
                            [
                                0,
                                0
                            ],
                            [
                                m,
                                p
                            ]
                        ],
                        ...s
                    });
                    break;
                }
            case "arrow":
                {
                    let m = s.width || $e68ba20b3d2d159d$var$Ng.width, p = s.height || $e68ba20b3d2d159d$var$Ng.height;
                    l = $e68ba20b3d2d159d$var$ds({
                        width: m,
                        height: p,
                        endArrowhead: "arrow",
                        points: [
                            [
                                0,
                                0
                            ],
                            [
                                m,
                                p
                            ]
                        ],
                        ...s,
                        type: "arrow"
                    }), Object.assign(l, $e68ba20b3d2d159d$var$ui(l.points));
                    break;
                }
            case "text":
                {
                    let m = s?.fontFamily || $e68ba20b3d2d159d$var$vr, p = s?.fontSize || $e68ba20b3d2d159d$var$wr, u = s?.lineHeight || $e68ba20b3d2d159d$var$Eo(m), h = s.text ?? "", g = $e68ba20b3d2d159d$var$Gn(h), b = $e68ba20b3d2d159d$var$Xt(g, $e68ba20b3d2d159d$var$ke({
                        fontFamily: m,
                        fontSize: p
                    }), u);
                    l = $e68ba20b3d2d159d$var$er({
                        width: b.width,
                        height: b.height,
                        fontFamily: m,
                        fontSize: p,
                        ...s
                    });
                    break;
                }
            case "image":
                l = $e68ba20b3d2d159d$var$ld({
                    width: s?.width || $e68ba20b3d2d159d$var$Ca,
                    height: s?.height || $e68ba20b3d2d159d$var$Ca,
                    ...s
                });
                break;
            case "frame":
                l = $e68ba20b3d2d159d$var$cu({
                    x: 0,
                    y: 0,
                    ...s
                });
                break;
            case "magicframe":
                l = $e68ba20b3d2d159d$var$sd({
                    x: 0,
                    y: 0,
                    ...s
                });
                break;
            case "freedraw":
            case "iframe":
            case "embeddable":
                l = s;
                break;
            default:
                l = s, $e68ba20b3d2d159d$var$Zo(s, `Unhandled element type "${s.type}"`, !0);
        }
        o.getElement(l.id) ? console.error(`Duplicate id found for ${l.id}`) : (o.add(l), n.set(l.id, s), c && i.set(c, l.id));
    }
    let a = o.getElementsMap();
    for (let [s, l] of n){
        let c = o.getElement(s);
        switch(l.type){
            case "rectangle":
            case "ellipse":
            case "diamond":
            case "arrow":
                if (l.label?.text) {
                    let [d, m] = $e68ba20b3d2d159d$var$h9(c, l?.label, a);
                    if (o.add(d), o.add(m), $e68ba20b3d2d159d$var$ie(d)) {
                        let p = l.type === "arrow" ? l?.start : void 0, u = l.type === "arrow" ? l?.end : void 0;
                        if (p && p.id) {
                            let v = i.get(p.id);
                            v && Object.assign(p, {
                                id: v
                            });
                        }
                        if (u && u.id) {
                            let v = i.get(u.id);
                            v && Object.assign(u, {
                                id: v
                            });
                        }
                        let { linearElement: h, startBoundElement: g, endBoundElement: b } = $e68ba20b3d2d159d$var$DA(d, p, u, o, a);
                        d = h, o.add(h), o.add(g), o.add(b);
                    }
                } else switch(l.type){
                    case "arrow":
                        {
                            let { start: d, end: m } = l;
                            if (d && d.id) {
                                let g = i.get(d.id);
                                Object.assign(d, {
                                    id: g
                                });
                            }
                            if (m && m.id) {
                                let g = i.get(m.id);
                                Object.assign(m, {
                                    id: g
                                });
                            }
                            let { linearElement: p, startBoundElement: u, endBoundElement: h } = $e68ba20b3d2d159d$var$DA(c, d, m, o, a);
                            o.add(p), o.add(u), o.add(h);
                            break;
                        }
                }
                break;
        }
    }
    for (let [s, l] of n){
        if (l.type !== "frame" && l.type !== "magicframe") continue;
        let c = o.getElement(s);
        if (!c) throw new Error(`Excalidraw element with id ${s} doesn't exist`);
        let d = [];
        l.children.forEach((y)=>{
            let w = i.get(y);
            if (!w) throw new Error(`Element with ${y} wasn't mapped correctly`);
            let I = o.getElement(w);
            if (!I) throw new Error(`Frame element with id ${w} doesn't exist`);
            Object.assign(I, {
                frameId: c.id
            }), I?.boundElements?.forEach((M)=>{
                let C = o.getElement(M.id);
                if (!C) throw new Error(`Bound element with id ${M.id} doesn't exist`);
                Object.assign(C, {
                    frameId: c.id
                }), d.push(C);
            }), d.push(I);
        });
        let [m, p, u, h] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(d), g = 10;
        m = m - g, p = p - g, u = u + g, h = h + g;
        let b = Math.max(c?.width, u - m), v = Math.max(c?.height, h - p);
        Object.assign(c, {
            x: m,
            y: p,
            width: b,
            height: v
        });
    }
    return o.getElements();
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$Et = (e)=>(t)=>{
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(e, t);
    }, $e68ba20b3d2d159d$var$Og = (e)=>$e68ba20b3d2d159d$var$Hi((t)=>{
        (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(e, t);
    }), $e68ba20b3d2d159d$var$yc = (()=>{
    let e;
    try {
        let r = (0, $acw62.version).split(".");
        e = Number(r[0]) > 17;
    } catch  {
        e = !1;
    }
    let t = !1;
    return ()=>window.EXCALIDRAW_THROTTLE_RENDER === !0 ? e ? !0 : (t || (t = !0, console.warn("Excalidraw: render throttling is disabled on React versions < 18.")), !1) : !1;
})();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Fn();
$e68ba20b3d2d159d$var$Yt();
$e68ba20b3d2d159d$var$Nd();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$f9 = "#ff6b6b", $e68ba20b3d2d159d$var$E9 = "#ff0000", $e68ba20b3d2d159d$var$RA = 1, $e68ba20b3d2d159d$var$NA = 2, $e68ba20b3d2d159d$var$OA = (e, t)=>{
    if (!t.snapLines.length) return;
    let r = t.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT || t.zenModeEnabled ? $e68ba20b3d2d159d$var$f9 : $e68ba20b3d2d159d$var$E9, o = (t.zenModeEnabled ? $e68ba20b3d2d159d$var$RA * 1.5 : $e68ba20b3d2d159d$var$RA) / t.zoom.value;
    e.save(), e.translate(t.scrollX, t.scrollY);
    for (let n of t.snapLines)n.type === "pointer" ? (e.lineWidth = o, e.strokeStyle = r, $e68ba20b3d2d159d$var$b9(n, e, t)) : n.type === "gap" ? (e.lineWidth = o, e.strokeStyle = r, $e68ba20b3d2d159d$var$y9(n.points[0], n.points[1], n.direction, t, e)) : n.type === "points" && (e.lineWidth = o, e.strokeStyle = r, $e68ba20b3d2d159d$var$x9(n, e, t));
    e.restore();
}, $e68ba20b3d2d159d$var$x9 = (e, t, r)=>{
    if (!r.zenModeEnabled) {
        let o = e.points[0], n = e.points[e.points.length - 1];
        $e68ba20b3d2d159d$var$Vo(o, n, t);
    }
    for (let o of e.points)$e68ba20b3d2d159d$var$FA(o, r, t);
}, $e68ba20b3d2d159d$var$b9 = (e, t, r)=>{
    $e68ba20b3d2d159d$var$FA(e.points[0], r, t), r.zenModeEnabled || $e68ba20b3d2d159d$var$Vo(e.points[0], e.points[1], t);
}, $e68ba20b3d2d159d$var$FA = ([e, t], r, o)=>{
    o.save();
    let n = (r.zenModeEnabled ? $e68ba20b3d2d159d$var$NA * 1.5 : $e68ba20b3d2d159d$var$NA) / r.zoom.value;
    o.beginPath(), o.moveTo(e - n, t - n), o.lineTo(e + n, t + n), o.moveTo(e + n, t - n), o.lineTo(e - n, t + n), o.stroke(), o.restore();
}, $e68ba20b3d2d159d$var$Vo = (e, t, r)=>{
    r.beginPath(), r.lineTo(...e), r.lineTo(...t), r.stroke();
}, $e68ba20b3d2d159d$var$y9 = (e, t, r, o, n)=>{
    let i = 8 / o.zoom.value, a = i / 2, s = i / 4;
    if (r === "horizontal") {
        let l = [
            (e[0] + t[0]) / 2,
            e[1]
        ];
        o.zenModeEnabled || $e68ba20b3d2d159d$var$Vo([
            e[0],
            e[1] - i
        ], [
            e[0],
            e[1] + i
        ], n), $e68ba20b3d2d159d$var$Vo([
            l[0] - s,
            l[1] - a
        ], [
            l[0] - s,
            l[1] + a
        ], n), $e68ba20b3d2d159d$var$Vo([
            l[0] + s,
            l[1] - a
        ], [
            l[0] + s,
            l[1] + a
        ], n), o.zenModeEnabled || ($e68ba20b3d2d159d$var$Vo([
            t[0],
            t[1] - i
        ], [
            t[0],
            t[1] + i
        ], n), $e68ba20b3d2d159d$var$Vo(e, t, n));
    } else {
        let l = [
            e[0],
            (e[1] + t[1]) / 2
        ];
        o.zenModeEnabled || $e68ba20b3d2d159d$var$Vo([
            e[0] - i,
            e[1]
        ], [
            e[0] + i,
            e[1]
        ], n), $e68ba20b3d2d159d$var$Vo([
            l[0] - a,
            l[1] - s
        ], [
            l[0] + a,
            l[1] - s
        ], n), $e68ba20b3d2d159d$var$Vo([
            l[0] - a,
            l[1] + s
        ], [
            l[0] + a,
            l[1] + s
        ], n), o.zenModeEnabled || ($e68ba20b3d2d159d$var$Vo([
            t[0] - i,
            t[1]
        ], [
            t[0] + i,
            t[1]
        ], n), $e68ba20b3d2d159d$var$Vo(e, t, n));
    }
};
$e68ba20b3d2d159d$var$Qt();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$wu();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$rt();
var $e68ba20b3d2d159d$var$w9 = (e, t, r)=>{
    let { elementId: o, hoverPointIndex: n } = t.selectedLinearElement;
    if (t.editingLinearElement?.selectedPointsIndices?.includes(n)) return;
    let i = $e68ba20b3d2d159d$var$$.getElement(o, r);
    if (!i) return;
    let a = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(i, n, r);
    e.save(), e.translate(t.scrollX, t.scrollY), $e68ba20b3d2d159d$var$M1(a, e, t), e.restore();
}, $e68ba20b3d2d159d$var$M1 = (e, t, r)=>{
    t.fillStyle = "rgba(105, 101, 219, 0.4)", $e68ba20b3d2d159d$var$bd(t, e[0], e[1], $e68ba20b3d2d159d$var$$.POINT_HANDLE_SIZE / r.zoom.value, !1);
}, $e68ba20b3d2d159d$var$gm = (e, t, r, o, n, i, a, s, l = !1, c = 0)=>{
    e.save(), e.translate(i, a), e.rotate(s), l && e.fillRect(t - i, r - a, o, n), c && e.roundRect ? (e.beginPath(), e.roundRect(t - i, r - a, o, n, c), e.stroke(), e.closePath()) : e.strokeRect(t - i, r - a, o, n), e.restore();
}, $e68ba20b3d2d159d$var$v9 = (e, t, r, o, n, i)=>{
    e.save(), e.translate(o, n), e.rotate(i), e.beginPath(), e.moveTo(0, r / 2), e.lineTo(t / 2, 0), e.lineTo(0, -r / 2), e.lineTo(-t / 2, 0), e.closePath(), e.stroke(), e.restore();
}, $e68ba20b3d2d159d$var$Bg = (e, t, r, o, n, i = !1)=>{
    e.strokeStyle = "#5e5ad8", e.setLineDash([]), e.fillStyle = "rgba(255, 255, 255, 0.9)", n ? e.fillStyle = "rgba(134, 131, 226, 0.9)" : i && (e.fillStyle = "rgba(177, 151, 252, 0.7)"), $e68ba20b3d2d159d$var$bd(e, r[0], r[1], o / t.zoom.value, !i);
}, $e68ba20b3d2d159d$var$T9 = (e, t, r, o, n, i)=>{
    e.beginPath(), e.ellipse(o, n, t / 2, r / 2, i, 0, Math.PI * 2), e.stroke();
}, $e68ba20b3d2d159d$var$S9 = (e, t, r)=>{
    let [o, n, i, a] = $e68ba20b3d2d159d$var$ae(t, r), s = i - o, l = a - n, c = 10, d = 4;
    e.strokeStyle = "rgba(0,0,0,.05)", e.lineWidth = c - d;
    let m = d / 2 + c / 2, p = $e68ba20b3d2d159d$var$xo(Math.min(t.width, t.height), t);
    switch(t.type){
        case "rectangle":
        case "text":
        case "image":
        case "iframe":
        case "embeddable":
        case "frame":
        case "magicframe":
            $e68ba20b3d2d159d$var$gm(e, o - m, n - m, s + m * 2, l + m * 2, o + s / 2, n + l / 2, t.angle, void 0, p);
            break;
        case "diamond":
            let u = Math.hypot(s, l), h = m * u / l, g = m * u / s;
            $e68ba20b3d2d159d$var$v9(e, s + h * 2, l + g * 2, o + s / 2, n + l / 2, t.angle);
            break;
        case "ellipse":
            $e68ba20b3d2d159d$var$T9(e, s + m * 2, l + m * 2, o + s / 2, n + l / 2, t.angle);
            break;
    }
}, $e68ba20b3d2d159d$var$I9 = (e, t, r)=>{
    let [o, n, i] = t, a = $e68ba20b3d2d159d$var$Jc(i, i.width, i.height);
    e.strokeStyle = "rgba(0,0,0,0)", e.fillStyle = "rgba(0,0,0,.05)", (n === "both" ? [
        0,
        -1
    ] : n === "start" ? [
        0
    ] : [
        -1
    ]).forEach((l)=>{
        let [c, d] = $e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(o, l, r);
        $e68ba20b3d2d159d$var$bd(e, c, d, a);
    });
}, $e68ba20b3d2d159d$var$zA = (e, t, r)=>{
    let { angle: o, elementX1: n, elementY1: i, elementX2: a, elementY2: s, selectionColors: l, cx: c, cy: d, dashed: m, activeEmbeddable: p } = r, u = a - n, h = s - i, b = $e68ba20b3d2d159d$var$ai * 2 / t.zoom.value, v = 8 / t.zoom.value, y = 4 / t.zoom.value;
    e.save(), e.translate(t.scrollX, t.scrollY), e.lineWidth = (p ? 4 : 1) / t.zoom.value;
    let w = l.length;
    for(let I = 0; I < w; ++I)e.strokeStyle = l[I], m && e.setLineDash([
        v,
        y + (v + y) * (w - 1)
    ]), e.lineDashOffset = (v + y) * I, $e68ba20b3d2d159d$var$gm(e, n - b, i - b, u + b * 2, h + b * 2, c, d, o);
    e.restore();
}, $e68ba20b3d2d159d$var$C9 = (e, t, r, o)=>{
    let n = Array.isArray(r) ? $e68ba20b3d2d159d$var$I9 : $e68ba20b3d2d159d$var$S9;
    e.save(), e.translate(t.scrollX, t.scrollY), n(e, r, o), e.restore();
}, $e68ba20b3d2d159d$var$A9 = (e, t, r, o)=>{
    let [n, i, a, s] = $e68ba20b3d2d159d$var$ae(r, o), l = a - n, c = s - i;
    e.strokeStyle = "rgb(0,118,255)", e.lineWidth = $e68ba20b3d2d159d$var$ot.strokeWidth / t.zoom.value, e.save(), e.translate(t.scrollX, t.scrollY), $e68ba20b3d2d159d$var$gm(e, n, i, l, c, n + l / 2, i + c / 2, r.angle, !1, $e68ba20b3d2d159d$var$ot.radius / t.zoom.value), e.restore();
}, $e68ba20b3d2d159d$var$M9 = (e, t, r)=>{
    let o = r.filter((s)=>s.groupIds.length === 0), n = r.filter((s)=>s.groupIds.length > 0), i = (s)=>{
        let [l, c, d, m] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(s);
        return {
            angle: 0,
            elementX1: l,
            elementX2: d,
            elementY1: c,
            elementY2: m,
            selectionColors: [
                "rgb(0,118,255)"
            ],
            dashed: !1,
            cx: l + (d - l) / 2,
            cy: c + (m - c) / 2,
            activeEmbeddable: !1
        };
    }, a = (s)=>{
        let l = $e68ba20b3d2d159d$var$nt(r, s);
        return i(l);
    };
    Object.entries($e68ba20b3d2d159d$var$ip(n, t)).filter(([s, l])=>l).map(([s, l])=>s).map((s)=>a(s)).concat(o.map((s)=>i([
            s
        ]))).forEach((s)=>$e68ba20b3d2d159d$var$zA(e, t, s));
}, $e68ba20b3d2d159d$var$A1 = (e, t, r, o)=>{
    if (!t.selectedLinearElement) return;
    e.save(), e.translate(t.scrollX, t.scrollY), e.lineWidth = 1 / t.zoom.value;
    let n = $e68ba20b3d2d159d$var$$.getPointsGlobalCoordinates(r, o), { POINT_HANDLE_SIZE: i } = $e68ba20b3d2d159d$var$$, a = t.editingLinearElement ? i : i / 2;
    n.forEach((l, c)=>{
        if ($e68ba20b3d2d159d$var$ce(r) && c !== 0 && c !== n.length - 1) return;
        let d = !!t.editingLinearElement?.selectedPointsIndices?.includes(c);
        $e68ba20b3d2d159d$var$Bg(e, t, l, a, d);
    }), $e68ba20b3d2d159d$var$$.getEditorMidPoints(r, o, t).filter((l)=>l !== null).forEach((l)=>{
        t?.selectedLinearElement?.segmentMidPointHoveredCoords && $e68ba20b3d2d159d$var$$.arePointsEqual(l, t.selectedLinearElement.segmentMidPointHoveredCoords) ? t.editingLinearElement ? ($e68ba20b3d2d159d$var$Bg(e, t, l, a, !1), $e68ba20b3d2d159d$var$M1(l, e, t)) : ($e68ba20b3d2d159d$var$M1(l, e, t), $e68ba20b3d2d159d$var$Bg(e, t, l, a, !1)) : (t.editingLinearElement || n.length === 2) && $e68ba20b3d2d159d$var$Bg(e, t, l, i / 2, !1, !0);
    }), e.restore();
}, $e68ba20b3d2d159d$var$BA = (e, t, r, o, n)=>{
    Object.keys(o).forEach((i)=>{
        let a = o[i];
        if (a !== void 0) {
            let [s, l, c, d] = a;
            e.save(), e.lineWidth = 1 / r.zoom.value, t.selectionColor && (e.strokeStyle = t.selectionColor), i === "rotation" ? $e68ba20b3d2d159d$var$bd(e, s + c / 2, l + d / 2, c / 2) : e.roundRect ? (e.beginPath(), e.roundRect(s, l, c, d, 2 / r.zoom.value), e.fill(), e.stroke()) : $e68ba20b3d2d159d$var$gm(e, s, l, c, d, s + c / 2, l + d / 2, n, !0), e.restore();
        }
    });
}, $e68ba20b3d2d159d$var$k9 = (e, t, r, o)=>{
    t.save();
    let n = $e68ba20b3d2d159d$var$ai * 2 / r.zoom.value, i = e.width + n * 2, a = e.height + n * 2, s = e.x + i / 2, l = e.y + a / 2, c = -(i / 2 + n), d = -(a / 2 + n);
    t.translate(s + r.scrollX, l + r.scrollY), t.rotate(e.angle), t.lineWidth = 1 / r.zoom.value, t.strokeStyle = o, t.strokeRect(c, d, i, a), t.restore();
}, $e68ba20b3d2d159d$var$HA = ({ canvas: e, elementsMap: t, visibleElements: r, selectedElements: o, allElementsMap: n, scale: i, appState: a, renderConfig: s, device: l })=>{
    if (e === null) return {
        atLeastOneVisibleElement: !1,
        elementsMap: t
    };
    let [c, d] = $e68ba20b3d2d159d$var$wl(e, i), m = $e68ba20b3d2d159d$var$vl({
        canvas: e,
        scale: i,
        normalizedWidth: c,
        normalizedHeight: d
    });
    m.save(), m.scale(a.zoom.value, a.zoom.value);
    let p;
    if (r.forEach((g)=>{
        a.editingLinearElement?.elementId === g.id && g && (p = g);
    }), p && $e68ba20b3d2d159d$var$A1(m, a, p, t), a.selectionElement) try {
        $e68ba20b3d2d159d$var$qT(a.selectionElement, m, a, s.selectionColor);
    } catch (g) {
        console.error(g);
    }
    if (a.editingTextElement && $e68ba20b3d2d159d$var$G(a.editingTextElement)) {
        let g = n.get(a.editingTextElement.id);
        g && !g.autoResize && $e68ba20b3d2d159d$var$k9(g, m, a, s.selectionColor);
    }
    a.isBindingEnabled && a.suggestedBindings.filter((g)=>g != null).forEach((g)=>{
        $e68ba20b3d2d159d$var$C9(m, a, g, t);
    }), a.frameToHighlight && $e68ba20b3d2d159d$var$A9(m, a, a.frameToHighlight, t), a.elementsToHighlight && $e68ba20b3d2d159d$var$M9(m, a, a.elementsToHighlight);
    let u = o.some((g)=>$e68ba20b3d2d159d$var$re(g));
    if (o.length === 1 && a.editingLinearElement?.elementId === o[0].id && $e68ba20b3d2d159d$var$A1(m, a, o[0], t), a.selectedLinearElement && a.selectedLinearElement.hoverPointIndex >= 0 && !($e68ba20b3d2d159d$var$ce(o[0]) && a.selectedLinearElement.hoverPointIndex > 0 && a.selectedLinearElement.hoverPointIndex < o[0].points.length - 1) && $e68ba20b3d2d159d$var$w9(m, a, t), !a.multiElement && !a.editingLinearElement) {
        let g = $e68ba20b3d2d159d$var$Qu(o, a), b = o.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(o[0]);
        b && a.selectedLinearElement?.elementId === o[0].id && !o[0].locked && $e68ba20b3d2d159d$var$A1(m, a, o[0], t);
        let v = s.selectionColor || (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).black;
        if (g) {
            let y = $e68ba20b3d2d159d$var$j(o), w = [];
            for (let M of t.values()){
                let C = [], P = s.remoteSelectedElementIds.get(M.id);
                if (b && $e68ba20b3d2d159d$var$ie(M) && $e68ba20b3d2d159d$var$ce(M) && (M.startBinding || M.endBinding) || (y.has(M.id) && !$e68ba20b3d2d159d$var$np(a, M) && C.push(v), P && C.push(...P.map((k)=>$e68ba20b3d2d159d$var$Ps(k, a.collaborators.get(k))))), C.length) {
                    let [k, _, A, R, B, V] = $e68ba20b3d2d159d$var$ae(M, t, !0);
                    w.push({
                        angle: M.angle,
                        elementX1: k,
                        elementY1: _,
                        elementX2: A,
                        elementY2: R,
                        selectionColors: C,
                        dashed: !!P,
                        cx: B,
                        cy: V,
                        activeEmbeddable: a.activeEmbeddable?.element === M && a.activeEmbeddable.state === "active"
                    });
                }
            }
            let I = (M)=>{
                let C = $e68ba20b3d2d159d$var$nt(t, M), [P, k, _, A] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(C);
                w.push({
                    angle: 0,
                    elementX1: P,
                    elementX2: _,
                    elementY1: k,
                    elementY2: A,
                    selectionColors: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).black
                    ],
                    dashed: !0,
                    cx: P + (_ - P) / 2,
                    cy: k + (A - k) / 2,
                    activeEmbeddable: !1
                });
            };
            for (let M of $e68ba20b3d2d159d$var$Qo(a))I(M);
            a.editingGroupId && I(a.editingGroupId), w.forEach((M)=>$e68ba20b3d2d159d$var$zA(m, a, M));
        }
        if (m.save(), m.translate(a.scrollX, a.scrollY), o.length === 1) {
            m.fillStyle = (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white;
            let y = $e68ba20b3d2d159d$var$Rd(o[0], a.zoom, t, "mouse", $e68ba20b3d2d159d$var$ws(l));
            !a.viewModeEnabled && g && !$e68ba20b3d2d159d$var$G(a.editingTextElement) && $e68ba20b3d2d159d$var$BA(m, s, a, y, o[0].angle);
        } else if (o.length > 1 && !a.isRotating) {
            let y = $e68ba20b3d2d159d$var$ai * 2 / a.zoom.value;
            m.fillStyle = (0, (/*@__PURE__*/$parcel$interopDefault($e1b69108328f9d49$exports))).white;
            let [w, I, M, C] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(o), P = m.getLineDash();
            m.setLineDash([
                2 / a.zoom.value
            ]);
            let k = m.lineWidth;
            m.lineWidth = 1 / a.zoom.value, m.strokeStyle = v, $e68ba20b3d2d159d$var$gm(m, w - y, I - y, M - w + y * 2, C - I + y * 2, (w + M) / 2, (I + C) / 2, 0), m.lineWidth = k, m.setLineDash(P);
            let _ = $e68ba20b3d2d159d$var$Gl([
                w,
                I,
                M,
                C,
                (w + M) / 2,
                (I + C) / 2
            ], 0, a.zoom, "mouse", u ? {
                ...$e68ba20b3d2d159d$var$ws(l),
                rotation: !0
            } : $e68ba20b3d2d159d$var$ws(l));
            o.some((A)=>!A.locked) && $e68ba20b3d2d159d$var$BA(m, s, a, _, 0);
        }
        m.restore();
    }
    $e68ba20b3d2d159d$var$OA(m, a), m.restore(), $e68ba20b3d2d159d$var$eI({
        context: m,
        renderConfig: s,
        appState: a,
        normalizedWidth: c,
        normalizedHeight: d
    });
    let h;
    return s.renderScrollbars && (h = $e68ba20b3d2d159d$var$XC(r, c, d, a), m.save(), m.fillStyle = $e68ba20b3d2d159d$var$YC, m.strokeStyle = "rgba(255,255,255,0.8)", [
        h.horizontal,
        h.vertical
    ].forEach((g)=>{
        g && $e68ba20b3d2d159d$var$Ah(m, g.x, g.y, g.width, g.height, $e68ba20b3d2d159d$var$Jn / 2);
    }), m.restore()), {
        scrollBars: h,
        atLeastOneVisibleElement: r.length > 0,
        elementsMap: t
    };
}, $e68ba20b3d2d159d$var$k1 = $e68ba20b3d2d159d$var$Hi((e)=>{
    let t = $e68ba20b3d2d159d$var$HA(e);
    e.callback?.(t);
}, {
    trailing: !0
}), $e68ba20b3d2d159d$var$UA = (e, t)=>{
    if (t) {
        $e68ba20b3d2d159d$var$k1(e);
        return;
    }
    let r = $e68ba20b3d2d159d$var$HA(e);
    return e.callback(r), r;
};
var $e68ba20b3d2d159d$var$_9 = (e)=>{
    let t = (0, $acw62.useRef)(!1);
    return (0, $acw62.useEffect)(()=>{
        if (!t.current) {
            t.current = !0;
            return;
        }
        let r = new Map, o = new Map, n = new Map, i = new Map, a = new Map;
        e.appState.collaborators.forEach((l, c)=>{
            if (l.selectedElementIds) for (let d of Object.keys(l.selectedElementIds))n.has(d) || n.set(d, []), n.get(d).push(c);
            !l.pointer || l.pointer.renderCursor === !1 || (l.username && i.set(c, l.username), l.userState && a.set(c, l.userState), o.set(c, $e68ba20b3d2d159d$export$a4a3582487786f33({
                sceneX: l.pointer.x,
                sceneY: l.pointer.y
            }, e.appState)), r.set(c, l.button));
        });
        let s = e.containerRef?.current && getComputedStyle(e.containerRef.current).getPropertyValue("--color-selection") || "#6965db";
        $e68ba20b3d2d159d$var$UA({
            canvas: e.canvas,
            elementsMap: e.elementsMap,
            visibleElements: e.visibleElements,
            selectedElements: e.selectedElements,
            allElementsMap: e.allElementsMap,
            scale: window.devicePixelRatio,
            appState: e.appState,
            renderConfig: {
                remotePointerViewportCoords: o,
                remotePointerButton: r,
                remoteSelectedElementIds: n,
                remotePointerUsernames: i,
                remotePointerUserStates: a,
                selectionColor: s,
                renderScrollbars: !1
            },
            device: e.device,
            callback: e.renderInteractiveSceneCallback
        }, $e68ba20b3d2d159d$var$yc());
    }), (0, $7b02d682eb115277$exports.jsx)("canvas", {
        className: "excalidraw__canvas interactive",
        style: {
            width: e.appState.width,
            height: e.appState.height,
            cursor: e.appState.viewModeEnabled ? $e68ba20b3d2d159d$var$Ue.GRAB : $e68ba20b3d2d159d$var$Ue.AUTO
        },
        width: e.appState.width * e.scale,
        height: e.appState.height * e.scale,
        ref: e.handleCanvasRef,
        onContextMenu: e.onContextMenu,
        onPointerMove: e.onPointerMove,
        onPointerUp: e.onPointerUp,
        onPointerCancel: e.onPointerCancel,
        onTouchMove: e.onTouchMove,
        onPointerDown: e.onPointerDown,
        onDoubleClick: e.appState.viewModeEnabled ? void 0 : e.onDoubleClick,
        children: $e68ba20b3d2d159d$var$x("labels.drawingCanvas")
    });
}, $e68ba20b3d2d159d$var$GA = (e)=>({
        zoom: e.zoom,
        scrollX: e.scrollX,
        scrollY: e.scrollY,
        width: e.width,
        height: e.height,
        viewModeEnabled: e.viewModeEnabled,
        editingGroupId: e.editingGroupId,
        editingLinearElement: e.editingLinearElement,
        selectedElementIds: e.selectedElementIds,
        frameToHighlight: e.frameToHighlight,
        offsetLeft: e.offsetLeft,
        offsetTop: e.offsetTop,
        theme: e.theme,
        pendingImageElementId: e.pendingImageElementId,
        selectionElement: e.selectionElement,
        selectedGroupIds: e.selectedGroupIds,
        selectedLinearElement: e.selectedLinearElement,
        multiElement: e.multiElement,
        isBindingEnabled: e.isBindingEnabled,
        suggestedBindings: e.suggestedBindings,
        isRotating: e.isRotating,
        elementsToHighlight: e.elementsToHighlight,
        collaborators: e.collaborators,
        activeEmbeddable: e.activeEmbeddable,
        snapLines: e.snapLines,
        zenModeEnabled: e.zenModeEnabled,
        editingTextElement: e.editingTextElement
    }), $e68ba20b3d2d159d$var$R9 = (e, t)=>e.selectionNonce !== t.selectionNonce || e.sceneNonce !== t.sceneNonce || e.scale !== t.scale || e.elementsMap !== t.elementsMap || e.visibleElements !== t.visibleElements || e.selectedElements !== t.selectedElements ? !1 : $e68ba20b3d2d159d$var$at($e68ba20b3d2d159d$var$GA(e.appState), $e68ba20b3d2d159d$var$GA(t.appState)), $e68ba20b3d2d159d$var$P1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($e68ba20b3d2d159d$var$_9, $e68ba20b3d2d159d$var$R9);
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Iu();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$B9 = (e)=>{
    let t = (0, $acw62.useRef)(null), r = (0, $acw62.useRef)(!1);
    return (0, $acw62.useEffect)(()=>{
        let o = t.current;
        if (!o) return;
        let n = e.canvas;
        r.current || (r.current = !0, o.replaceChildren(n), n.classList.add("excalidraw__canvas", "static"));
        let i = `${e.appState.width}px`, a = `${e.appState.height}px`;
        n.style.width !== i && (n.style.width = i), n.style.height !== a && (n.style.height = a);
        let s = e.appState.width * e.scale, l = e.appState.height * e.scale;
        n.width !== s && (n.width = s), n.height !== l && (n.height = l), $e68ba20b3d2d159d$var$Su({
            canvas: n,
            rc: e.rc,
            scale: e.scale,
            elementsMap: e.elementsMap,
            allElementsMap: e.allElementsMap,
            visibleElements: e.visibleElements,
            appState: e.appState,
            renderConfig: e.renderConfig
        }, $e68ba20b3d2d159d$var$yc());
    }), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "excalidraw__canvas-wrapper",
        ref: t
    });
}, $e68ba20b3d2d159d$var$VA = (e)=>({
        zoom: e.zoom,
        scrollX: e.scrollX,
        scrollY: e.scrollY,
        width: e.width,
        height: e.height,
        viewModeEnabled: e.viewModeEnabled,
        offsetLeft: e.offsetLeft,
        offsetTop: e.offsetTop,
        theme: e.theme,
        pendingImageElementId: e.pendingImageElementId,
        shouldCacheIgnoreZoom: e.shouldCacheIgnoreZoom,
        viewBackgroundColor: e.viewBackgroundColor,
        exportScale: e.exportScale,
        selectedElementsAreBeingDragged: e.selectedElementsAreBeingDragged,
        gridSize: e.gridSize,
        gridStep: e.gridStep,
        frameRendering: e.frameRendering,
        selectedElementIds: e.selectedElementIds,
        frameToHighlight: e.frameToHighlight,
        editingGroupId: e.editingGroupId,
        currentHoveredFontFamily: e.currentHoveredFontFamily
    }), $e68ba20b3d2d159d$var$z9 = (e, t)=>e.sceneNonce !== t.sceneNonce || e.scale !== t.scale || e.elementsMap !== t.elementsMap || e.visibleElements !== t.visibleElements ? !1 : $e68ba20b3d2d159d$var$at($e68ba20b3d2d159d$var$VA(e.appState), $e68ba20b3d2d159d$var$VA(t.appState)) && $e68ba20b3d2d159d$var$at(e.renderConfig, t.renderConfig), $e68ba20b3d2d159d$var$L1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($e68ba20b3d2d159d$var$B9, $e68ba20b3d2d159d$var$z9);
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ys();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Iu();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$fm = class {
    scene;
    constructor(t){
        this.scene = t;
    }
    getRenderableElements = (()=>{
        let t = ({ elementsMap: o, zoom: n, offsetLeft: i, offsetTop: a, scrollX: s, scrollY: l, height: c, width: d })=>{
            let m = [];
            for (let p of o.values())$e68ba20b3d2d159d$var$bs(p, d, c, {
                zoom: n,
                offsetLeft: i,
                offsetTop: a,
                scrollX: s,
                scrollY: l
            }, o) && m.push(p);
            return m;
        }, r = ({ elements: o, editingTextElement: n, newElementId: i, pendingImageElementId: a })=>{
            let s = $e68ba20b3d2d159d$var$lr(new Map);
            for (let l of o)$e68ba20b3d2d159d$var$Ao(l) && a === l.id || i !== l.id && (!n || n.type !== "text" || l.id !== n.id) && s.set(l.id, l);
            return s;
        };
        return $e68ba20b3d2d159d$var$Q0(({ zoom: o, offsetLeft: n, offsetTop: i, scrollX: a, scrollY: s, height: l, width: c, editingTextElement: d, newElementId: m, pendingImageElementId: p, sceneNonce: u })=>{
            let h = this.scene.getNonDeletedElements(), g = r({
                elements: h,
                editingTextElement: d,
                newElementId: m,
                pendingImageElementId: p
            }), b = t({
                elementsMap: g,
                zoom: o,
                offsetLeft: n,
                offsetTop: i,
                scrollX: a,
                scrollY: s,
                height: l,
                width: c
            });
            return {
                elementsMap: g,
                visibleElements: b
            };
        });
    })();
    destroy() {
        $e68ba20b3d2d159d$var$k1.cancel(), $e68ba20b3d2d159d$var$CE.cancel(), this.getRenderableElements.clear();
    }
};
$e68ba20b3d2d159d$var$en();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$XA = ({ trails: e })=>{
    let t = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        if (t.current) for (let r of e)r.start(t.current);
        return ()=>{
            for (let r of e)r.stop();
        };
    }, e), (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "SVGLayer",
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            ref: t
        })
    });
};
$e68ba20b3d2d159d$var$Zs();
$e68ba20b3d2d159d$var$ud();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$ye();
var $e68ba20b3d2d159d$var$W9 = 5, $e68ba20b3d2d159d$var$V9 = (e, t, r)=>{
    let [o, n] = $e68ba20b3d2d159d$var$ae(e, r), { x: i, y: a } = $e68ba20b3d2d159d$export$a4a3582487786f33({
        sceneX: o + e.width,
        sceneY: n
    }, t), s = i - t.offsetLeft + 10, l = a - t.offsetTop;
    return {
        x: s,
        y: l
    };
}, $e68ba20b3d2d159d$var$D1 = ({ children: e, element: t, elementsMap: r })=>{
    let o = $e68ba20b3d2d159d$var$Yn();
    if (o.contextMenu || o.newElement || o.resizingElement || o.isRotating || o.openMenu || o.viewModeEnabled) return null;
    let { x: n, y: i } = $e68ba20b3d2d159d$var$V9(t, o, r);
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "excalidraw-canvas-buttons",
        style: {
            top: `${i}px`,
            left: `${n}px`,
            padding: $e68ba20b3d2d159d$var$W9
        },
        children: e
    });
};
$e68ba20b3d2d159d$var$yr();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$K9 = "small", $e68ba20b3d2d159d$var$zg = (e)=>(0, $7b02d682eb115277$exports.jsxs)("label", {
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("ToolIcon ToolIcon__MagicButton", `ToolIcon_size_${$e68ba20b3d2d159d$var$K9}`, {
            "is-mobile": e.isMobile
        }),
        title: `${e.title}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "ToolIcon_type_checkbox",
                type: "checkbox",
                name: e.name,
                onChange: e.onChange,
                checked: e.checked,
                "aria-label": e.title
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "ToolIcon__icon",
                children: e.icon
            })
        ]
    });
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$Z9 = ({ height: e, width: t, userToFollow: r, onDisconnect: o })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "follow-mode",
        style: {
            width: t,
            height: e
        },
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "follow-mode__badge",
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "follow-mode__badge__label",
                    children: [
                        "Following",
                        " ",
                        (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "follow-mode__badge__username",
                            title: r.username,
                            children: r.username
                        })
                    ]
                }),
                (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    onClick: o,
                    className: "follow-mode__disconnect-btn",
                    children: $e68ba20b3d2d159d$var$Po
                })
            ]
        })
    }), $e68ba20b3d2d159d$var$ZA = $e68ba20b3d2d159d$var$Z9;
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$Hg = class {
    targets = new WeakMap;
    rafIds = new WeakMap;
    register(t, r) {
        this.targets.set(t, {
            callback: r,
            stopped: !0
        });
    }
    start(t) {
        let r = this.targets.get(t);
        r && (this.rafIds.has(t) || (this.targets.set(t, {
            ...r,
            stopped: !1
        }), this.scheduleFrame(t)));
    }
    stop(t) {
        let r = this.targets.get(t);
        r && !r.stopped && this.targets.set(t, {
            ...r,
            stopped: !0
        }), this.cancelFrame(t);
    }
    constructFrame(t) {
        return (r)=>{
            let o = this.targets.get(t);
            if (!o) return;
            let n = this.onFrame(o, r);
            !o.stopped && !n ? this.scheduleFrame(t) : this.cancelFrame(t);
        };
    }
    scheduleFrame(t) {
        let r = requestAnimationFrame(this.constructFrame(t));
        this.rafIds.set(t, r);
    }
    cancelFrame(t) {
        if (this.rafIds.has(t)) {
            let r = this.rafIds.get(t);
            cancelAnimationFrame(r);
        }
        this.rafIds.delete(t);
    }
    onFrame(t, r) {
        return t.callback(r) ?? !1;
    }
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$Os = class {
    constructor(t, r, o){
        this.animationFrameHandler = t;
        this.app = r;
        this.options = o;
        this.animationFrameHandler.register(this, this.onFrame.bind(this)), this.trailElement = document.createElementNS($e68ba20b3d2d159d$var$Ze, "path");
    }
    currentTrail;
    pastTrails = [];
    container;
    trailElement;
    get hasCurrentTrail() {
        return !!this.currentTrail;
    }
    hasLastPoint(t, r) {
        if (this.currentTrail) {
            let o = this.currentTrail.originalPoints.length;
            return this.currentTrail.originalPoints[o - 1][0] === t && this.currentTrail.originalPoints[o - 1][1] === r;
        }
        return !1;
    }
    start(t) {
        t && (this.container = t), this.trailElement.parentNode !== this.container && this.container && this.container.appendChild(this.trailElement), this.animationFrameHandler.start(this);
    }
    stop() {
        this.animationFrameHandler.stop(this), this.trailElement.parentNode === this.container && this.container?.removeChild(this.trailElement);
    }
    startPath(t, r) {
        this.currentTrail = new (0, $30b0e781a03fc496$export$6531021b3bf36eae)(this.options), this.currentTrail.addPoint([
            t,
            r,
            performance.now()
        ]), this.update();
    }
    addPointToPath(t, r) {
        this.currentTrail && (this.currentTrail.addPoint([
            t,
            r,
            performance.now()
        ]), this.update());
    }
    endPath() {
        this.currentTrail && (this.currentTrail.close(), this.currentTrail.options.keepHead = !1, this.pastTrails.push(this.currentTrail), this.currentTrail = void 0, this.update());
    }
    update() {
        this.start();
    }
    onFrame() {
        let t = [];
        for (let o of this.pastTrails)t.push(this.drawTrail(o, this.app.state));
        if (this.currentTrail) {
            let o = this.drawTrail(this.currentTrail, this.app.state);
            t.push(o);
        }
        this.pastTrails = this.pastTrails.filter((o)=>o.getStrokeOutline().length !== 0), t.length === 0 && this.stop();
        let r = t.join(" ").trim();
        this.trailElement.setAttribute("d", r), this.trailElement.setAttribute("fill", (this.options.fill ?? (()=>"black"))(this));
    }
    drawTrail(t, r) {
        let o = t.getStrokeOutline(t.options.size / r.zoom.value).map(([n, i])=>{
            let a = $e68ba20b3d2d159d$export$a4a3582487786f33({
                sceneX: n,
                sceneY: i
            }, r);
            return [
                a.x,
                a.y
            ];
        });
        return $e68ba20b3d2d159d$var$ey(o, !0);
    }
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$Y();
var $e68ba20b3d2d159d$var$Ug = class {
    constructor(t, r){
        this.animationFrameHandler = t;
        this.app = r;
        this.animationFrameHandler.register(this, this.onFrame.bind(this)), this.localTrail = new $e68ba20b3d2d159d$var$Os(t, r, {
            ...this.getTrailOptions(),
            fill: ()=>$e68ba20b3d2d159d$export$b42ada940915b9f1
        });
    }
    localTrail;
    collabTrails = new Map;
    container;
    getTrailOptions() {
        return {
            simplify: 0,
            streamline: .4,
            sizeMapping: (t)=>{
                let n = Math.max(0, 1 - (performance.now() - t.pressure) / 1e3), i = (50 - Math.min(50, t.totalLength - t.currentIndex)) / 50;
                return Math.min($e68ba20b3d2d159d$var$li(i), $e68ba20b3d2d159d$var$li(n));
            }
        };
    }
    startPath(t, r) {
        this.localTrail.startPath(t, r);
    }
    addPointToPath(t, r) {
        this.localTrail.addPointToPath(t, r);
    }
    endPath() {
        this.localTrail.endPath();
    }
    start(t) {
        this.container = t, this.animationFrameHandler.start(this), this.localTrail.start(t);
    }
    stop() {
        this.animationFrameHandler.stop(this), this.localTrail.stop();
    }
    onFrame() {
        this.updateCollabTrails();
    }
    updateCollabTrails() {
        if (!(!this.container || this.app.state.collaborators.size === 0)) {
            for (let [t, r] of this.app.state.collaborators.entries()){
                let o;
                this.collabTrails.has(t) ? o = this.collabTrails.get(t) : (o = new $e68ba20b3d2d159d$var$Os(this.animationFrameHandler, this.app, {
                    ...this.getTrailOptions(),
                    fill: ()=>r.pointer?.laserColor || $e68ba20b3d2d159d$var$Ps(t, r)
                }), o.start(this.container), this.collabTrails.set(t, o)), r.pointer && r.pointer.tool === "laser" && (r.button === "down" && !o.hasCurrentTrail && o.startPath(r.pointer.x, r.pointer.y), r.button === "down" && o.hasCurrentTrail && !o.hasLastPoint(r.pointer.x, r.pointer.y) && o.addPointToPath(r.pointer.x, r.pointer.y), r.button === "up" && o.hasCurrentTrail && (o.addPointToPath(r.pointer.x, r.pointer.y), o.endPath()));
            }
            for (let t of this.collabTrails.keys())this.app.state.collaborators.has(t) || (this.collabTrails.get(t).stop(), this.collabTrails.delete(t));
        }
    }
};
$e68ba20b3d2d159d$var$Fn();
$e68ba20b3d2d159d$var$Xc();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$xs();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$Nt();
$e68ba20b3d2d159d$var$ia();
$e68ba20b3d2d159d$var$Yu();
var $e68ba20b3d2d159d$var$q9 = (e, t, r, o, n, i)=>{
    let { zoom: a } = o, s = 180 * r / Math.PI, l = e * (a.value - 1) / 2, c = t * (a.value - 1) / 2;
    return e > n && a.value !== 1 && (l = n * (a.value - 1) / 2), t > i && a.value !== 1 && (c = i * (a.value - 1) / 2), `translate(${l}px, ${c}px) scale(${a.value}) rotate(${s}deg)`;
}, $e68ba20b3d2d159d$var$jA = ({ id: e, onChange: t, onSubmit: r, getViewportCoords: o, element: n, canvas: i, excalidrawContainer: a, app: s, autoSelect: l = !0 })=>{
    let c = (N, H)=>{
        if (!H.style.fontFamily || !H.style.fontSize) return !1;
        let xe = H.style.fontFamily.replace(/"/g, "");
        return $e68ba20b3d2d159d$var$kn({
            fontFamily: N.fontFamily
        }) !== xe || `${N.fontSize}px` !== H.style.fontSize;
    }, d = ()=>{
        let N = s.state, H = $e68ba20b3d2d159d$var$fr.getScene(n)?.getElement(e);
        if (!H) return;
        let { textAlign: xe, verticalAlign: X } = H, ne = s.scene.getNonDeletedElementsMap();
        if (H && $e68ba20b3d2d159d$var$G(H)) {
            let ve = H.x, Ce = H.y, Te = $e68ba20b3d2d159d$var$bt(H, s.scene.getNonDeletedElementsMap()), Le = H.width, Gt = H.height, co = H.width, Xr = H.height;
            if (Te && H.containerId) {
                if ($e68ba20b3d2d159d$var$ie(Te)) {
                    let Dr = $e68ba20b3d2d159d$var$$.getBoundTextElementPosition(Te, H, ne);
                    ve = Dr.x, Ce = Dr.y;
                }
                let La = c(H, m), Ni;
                if (La ? Ni = $e68ba20b3d2d159d$var$fs(Te.id, Te.height) : (Ni = $e68ba20b3d2d159d$var$gs[Te.id], Ni || (Ni = $e68ba20b3d2d159d$var$fs(Te.id, Te.height))), co = $e68ba20b3d2d159d$var$Mr(Te, H), Xr = $e68ba20b3d2d159d$var$us(Te, H), !$e68ba20b3d2d159d$var$ie(Te) && Gt > Xr) {
                    let Dr = $e68ba20b3d2d159d$var$Ii(Gt, Te.type);
                    $e68ba20b3d2d159d$export$55655e96a21bba2e(Te, {
                        height: Dr
                    });
                    return;
                } else if (!$e68ba20b3d2d159d$var$ie(Te) && Te.height > Ni.height && Gt < Xr) {
                    let Dr = $e68ba20b3d2d159d$var$Ii(Gt, Te.type);
                    $e68ba20b3d2d159d$export$55655e96a21bba2e(Te, {
                        height: Dr
                    });
                } else {
                    let { y: Dr } = $e68ba20b3d2d159d$var$Bl(Te, H, ne);
                    Ce = Dr;
                }
            }
            let [xr, So] = o(ve, Ce), Pa = m.selectionStart, Io = m.selectionEnd, Co = m.value.length;
            if (Pa === Io && Io !== Co) {
                let La = Co - Io;
                m.selectionStart = m.value.length - La, m.selectionEnd = m.value.length - La;
            }
            Te ? Le += .5 : (co = (N.width - 8 - xr) / N.zoom.value, Le = Math.min(Le, co)), Gt *= 1.05;
            let oi = $e68ba20b3d2d159d$var$ke(H), vn = $e68ba20b3d2d159d$var$u0 ? 0 : Math.ceil(H.fontSize / 2), Tm = (N.height - So) / N.zoom.value;
            Object.assign(m.style, {
                font: oi,
                lineHeight: H.lineHeight,
                width: `${Le}px`,
                height: `${Gt}px`,
                left: `${xr - vn}px`,
                top: `${So}px`,
                transform: $e68ba20b3d2d159d$var$q9(Le, Gt, $e68ba20b3d2d159d$var$y3(H, Te), N, co, Tm),
                padding: `0 ${vn}px`,
                textAlign: xe,
                verticalAlign: X,
                color: H.strokeColor,
                opacity: H.opacity / 100,
                filter: "var(--theme-filter)",
                maxHeight: `${Tm}px`
            }), m.scrollTop = 0, $e68ba20b3d2d159d$var$Zr() && (m.style.fontFamily = $e68ba20b3d2d159d$var$kn(H)), $e68ba20b3d2d159d$export$55655e96a21bba2e(H, {
                x: ve,
                y: Ce
            });
        }
    }, m = document.createElement("textarea");
    m.dir = "auto", m.tabIndex = 0, m.dataset.type = "wysiwyg", m.wrap = "off", m.classList.add("excalidraw-wysiwyg");
    let p = "pre", u = "normal";
    ($e68ba20b3d2d159d$var$Ge(n) || !n.autoResize) && (p = "pre-wrap", u = "break-word"), Object.assign(m.style, {
        position: "absolute",
        display: "inline-block",
        minHeight: "1em",
        backfaceVisibility: "hidden",
        margin: 0,
        border: 0,
        outline: 0,
        resize: "none",
        background: "transparent",
        overflow: "hidden",
        zIndex: "var(--zIndex-wysiwyg)",
        wordBreak: u,
        whiteSpace: p,
        overflowWrap: "break-word",
        boxSizing: "content-box"
    }), m.value = n.originalText, d(), t && (m.onpaste = async (N)=>{
        let H = await $e68ba20b3d2d159d$var$Lu(N, !0);
        if (!H.text) return;
        let xe = $e68ba20b3d2d159d$var$Gn(H.text);
        if (!xe) return;
        let X = $e68ba20b3d2d159d$var$bt(n, s.scene.getNonDeletedElementsMap()), ne = $e68ba20b3d2d159d$var$ke({
            fontSize: s.state.currentItemFontSize,
            fontFamily: s.state.currentItemFontFamily
        });
        if (X) {
            let ve = $e68ba20b3d2d159d$var$te(X, s.scene.getNonDeletedElementsMap()), Ce = $e68ba20b3d2d159d$var$Ro(`${m.value}${xe}`, ne, $e68ba20b3d2d159d$var$Mr(X, ve)), Te = $e68ba20b3d2d159d$var$Ku(Ce, ne, !0);
            m.style.width = `${Te}px`;
        }
    }, m.oninput = ()=>{
        let N = $e68ba20b3d2d159d$var$Gn(m.value);
        if (m.value !== N) {
            let H = m.selectionStart;
            m.value = N, m.selectionStart = H, m.selectionEnd = H;
        }
        t(m.value);
    }), m.onkeydown = (N)=>{
        if (!N.shiftKey && $e68ba20b3d2d159d$var$wh.keyTest(N)) N.preventDefault(), s.actionManager.executeAction($e68ba20b3d2d159d$var$wh), d();
        else if (!N.shiftKey && $e68ba20b3d2d159d$var$vh.keyTest(N)) N.preventDefault(), s.actionManager.executeAction($e68ba20b3d2d159d$var$vh), d();
        else if (!N.shiftKey && $e68ba20b3d2d159d$var$Th.keyTest(N)) N.preventDefault(), s.actionManager.executeAction($e68ba20b3d2d159d$var$Th), d();
        else if ($e68ba20b3d2d159d$var$Yx.keyTest(N)) s.actionManager.executeAction($e68ba20b3d2d159d$var$Yx);
        else if ($e68ba20b3d2d159d$var$Xx.keyTest(N)) s.actionManager.executeAction($e68ba20b3d2d159d$var$Xx);
        else if (N.key === $e68ba20b3d2d159d$var$S.ESCAPE) N.preventDefault(), M = !0, C();
        else if (N.key === $e68ba20b3d2d159d$var$S.ENTER && N[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) {
            if (N.preventDefault(), N.isComposing || N.keyCode === 229) return;
            M = !0, C();
        } else if (N.key === $e68ba20b3d2d159d$var$S.TAB || N[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && (N.code === $e68ba20b3d2d159d$var$Ae.BRACKET_LEFT || N.code === $e68ba20b3d2d159d$var$Ae.BRACKET_RIGHT)) {
            if (N.preventDefault(), N.isComposing) return;
            N.shiftKey || N.code === $e68ba20b3d2d159d$var$Ae.BRACKET_LEFT ? y() : v(), m.dispatchEvent(new Event("input"));
        }
    };
    let h = 4, g = " ".repeat(h), b = new RegExp(`^ {1,${h}}`), v = ()=>{
        let { selectionStart: N, selectionEnd: H } = m, xe = w(), X = m.value;
        xe.forEach((ne)=>{
            let ve = X.slice(0, ne), Ce = X.slice(ne);
            X = `${ve}${g}${Ce}`;
        }), m.value = X, m.selectionStart = N + h, m.selectionEnd = H + h * xe.length;
    }, y = ()=>{
        let { selectionStart: N, selectionEnd: H } = m, xe = w(), X = [], ne = m.value;
        xe.forEach((ve)=>{
            let Ce = ne.slice(ve, ve + h).match(b);
            if (Ce) {
                let Te = ne.slice(0, ve), Le = ne.slice(ve + Ce[0].length);
                ne = `${Te}${Le}`, X.push(ve);
            }
        }), m.value = ne, X.length && (N > X[X.length - 1] ? m.selectionStart = Math.max(N - h, X[X.length - 1]) : m.selectionStart = N, m.selectionEnd = Math.max(m.selectionStart, H - h * X.length));
    }, w = ()=>{
        let { selectionStart: N, selectionEnd: H, value: xe } = m, X = xe.slice(0, N).match(/[^\n]*$/)[0].length;
        return N = N - X, xe.slice(N, H).split(`
`).reduce((ve, Ce, Te, Le)=>ve.concat(Te ? ve[Te - 1] + Le[Te - 1].length + 1 : N), []).reverse();
    }, I = (N)=>{
        N.target instanceof HTMLCanvasElement && (N.preventDefault(), N.stopPropagation());
    }, M = !1, C = ()=>{
        if (V) return;
        V = !0, P();
        let N = $e68ba20b3d2d159d$var$fr.getScene(n)?.getElement(n.id);
        if (!N) return;
        let H = $e68ba20b3d2d159d$var$bt(N, s.scene.getNonDeletedElementsMap());
        if (H) {
            if (m.value.trim()) {
                let xe = $e68ba20b3d2d159d$var$fn(H);
                !xe || xe !== n.id ? $e68ba20b3d2d159d$export$55655e96a21bba2e(H, {
                    boundElements: (H.boundElements || []).concat({
                        type: "text",
                        id: n.id
                    })
                }) : $e68ba20b3d2d159d$var$ie(H) && $e68ba20b3d2d159d$export$52f84dc7de3cd4b8(H);
            } else $e68ba20b3d2d159d$export$55655e96a21bba2e(H, {
                boundElements: H.boundElements?.filter((xe)=>!$e68ba20b3d2d159d$var$G(xe))
            });
            $e68ba20b3d2d159d$var$gt(N, H, s.scene.getNonDeletedElementsMap());
        }
        r({
            viaKeyboard: M,
            nextOriginalText: m.value
        });
    }, P = ()=>{
        m.onblur = null, m.oninput = null, m.onkeydown = null, ee && ee.disconnect(), window.removeEventListener("resize", d), window.removeEventListener("wheel", I, !0), window.removeEventListener("pointerdown", A), window.removeEventListener("pointerup", k), window.removeEventListener("blur", C), window.removeEventListener("beforeunload", C), R(), B(), m.remove();
    }, k = (N)=>{
        window.removeEventListener("pointerup", k);
        let H = N?.target, xe = H instanceof HTMLElement && H.classList.contains("properties-trigger");
        setTimeout(()=>{
            m.onblur = C, xe || m.focus();
        });
    }, _ = ()=>{
        m.onblur = null, window.addEventListener("pointerup", k), window.addEventListener("blur", C);
    }, A = (N)=>{
        let H = N?.target;
        if (N.button === $e68ba20b3d2d159d$var$Cn.WHEEL) {
            H instanceof HTMLTextAreaElement && (N.preventDefault(), s.handleCanvasPanUsingWheelOrSpaceDrag(N)), _();
            return;
        }
        let xe = H instanceof HTMLElement && H.classList.contains("properties-trigger");
        (N.target instanceof HTMLElement || N.target instanceof SVGElement) && N.target.closest(`.${$e68ba20b3d2d159d$var$Na.SHAPE_ACTIONS_MENU}, .${$e68ba20b3d2d159d$var$Na.ZOOM_ACTIONS}`) && !$e68ba20b3d2d159d$var$Mn(N.target) || xe ? _() : N.target instanceof HTMLCanvasElement && !$e68ba20b3d2d159d$var$Zr() && requestAnimationFrame(()=>{
            C();
        });
    }, R = s.scene.onUpdate(()=>{
        d(), !!document.activeElement?.closest(".properties-content") || m.focus();
    }), B = s.onScrollChangeEmitter.on(()=>{
        d();
    }), V = !1;
    l && m.select(), k();
    let ee = null;
    i && "ResizeObserver" in window ? (ee = new window.ResizeObserver(()=>{
        d();
    }), ee.observe(i)) : window.addEventListener("resize", d), m.onpointerdown = (N)=>N.stopPropagation(), requestAnimationFrame(()=>{
        window.addEventListener("pointerdown", A, {
            capture: !0
        });
    }), window.addEventListener("beforeunload", C), a?.querySelector(".excalidraw-textEditorContainer").appendChild(m);
};
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$yu();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$We();
$e68ba20b3d2d159d$var$Xe();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$je();
var $e68ba20b3d2d159d$var$qA = $e68ba20b3d2d159d$var$U({
    name: "autoResize",
    label: "labels.autoResize",
    icon: null,
    trackEvent: {
        category: "element"
    },
    predicate: (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$pe(e, t);
        return n.length === 1 && $e68ba20b3d2d159d$var$G(n[0]) && !n[0].autoResize;
    },
    perform: (e, t, r, o)=>{
        let n = $e68ba20b3d2d159d$var$pe(e, t);
        return {
            appState: t,
            elements: e.map((i)=>{
                if (i.id === n[0].id && $e68ba20b3d2d159d$var$G(i)) {
                    let a = $e68ba20b3d2d159d$var$Xt(i.originalText, $e68ba20b3d2d159d$var$ke(i), i.lineHeight);
                    return $e68ba20b3d2d159d$export$5390fab1c98104d7(i, {
                        autoResize: !0,
                        width: a.width,
                        height: a.height,
                        text: i.originalText
                    });
                }
                return i;
            }),
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        };
    }
});
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$JA = (e)=>{
    let t = [
        "flowchart",
        "graph",
        "sequenceDiagram",
        "classDiagram",
        "stateDiagram",
        "stateDiagram-v2",
        "erDiagram",
        "journey",
        "gantt",
        "pie",
        "quadrantChart",
        "requirementDiagram",
        "gitGraph",
        "C4Context",
        "mindmap",
        "timeline",
        "zenuml",
        "sankey",
        "xychart",
        "block"
    ];
    return new RegExp(`^(?:%%{.*?}%%[\\s\\n]*)?\\b(?:${t.map((o)=>`\\s*${o}(-beta)?`).join("|")})\\b`).test(e.trim());
};
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$wu();
$e68ba20b3d2d159d$var$Fn();
var $e68ba20b3d2d159d$var$QA = ({ canvas: e, rc: t, newElement: r, elementsMap: o, allElementsMap: n, scale: i, appState: a, renderConfig: s })=>{
    if (e) {
        let [l, c] = $e68ba20b3d2d159d$var$wl(e, i), d = $e68ba20b3d2d159d$var$vl({
            canvas: e,
            scale: i,
            normalizedWidth: l,
            normalizedHeight: c
        });
        d.save(), d.scale(a.zoom.value, a.zoom.value), r && r.type !== "selection" ? $e68ba20b3d2d159d$var$wi(r, o, n, t, d, s, a) : d.clearRect(0, 0, l, c);
    }
}, $e68ba20b3d2d159d$var$J9 = $e68ba20b3d2d159d$var$Hi((e)=>{
    $e68ba20b3d2d159d$var$QA(e);
}, {
    trailing: !0
}), $e68ba20b3d2d159d$var$e6 = (e, t)=>{
    if (t) {
        $e68ba20b3d2d159d$var$J9(e);
        return;
    }
    $e68ba20b3d2d159d$var$QA(e);
};
var $e68ba20b3d2d159d$var$tO = (e)=>{
    let t = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        t.current && $e68ba20b3d2d159d$var$e6({
            canvas: t.current,
            scale: e.scale,
            newElement: e.appState.newElement,
            elementsMap: e.elementsMap,
            allElementsMap: e.allElementsMap,
            rc: e.rc,
            renderConfig: e.renderConfig,
            appState: e.appState
        }, $e68ba20b3d2d159d$var$yc());
    }), (0, $7b02d682eb115277$exports.jsx)("canvas", {
        className: "excalidraw__canvas",
        style: {
            width: e.appState.width,
            height: e.appState.height
        },
        width: e.appState.width * e.scale,
        height: e.appState.height * e.scale,
        ref: t
    });
}, $e68ba20b3d2d159d$var$t6 = $e68ba20b3d2d159d$var$tO;
$e68ba20b3d2d159d$var$Ol();
var $e68ba20b3d2d159d$var$i6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null), $e68ba20b3d2d159d$var$a6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null), $e68ba20b3d2d159d$var$s6 = {
    viewport: {
        isMobile: !1,
        isLandscape: !1
    },
    editor: {
        isMobile: !1,
        canFitSidebar: !1
    },
    isTouchScreen: !1
}, $e68ba20b3d2d159d$var$z1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($e68ba20b3d2d159d$var$s6);
$e68ba20b3d2d159d$var$z1.displayName = "DeviceContext";
var $e68ba20b3d2d159d$var$H1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    container: null,
    id: null
});
$e68ba20b3d2d159d$var$H1.displayName = "ExcalidrawContainerContext";
var $e68ba20b3d2d159d$var$U1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext([]);
$e68ba20b3d2d159d$var$U1.displayName = "ExcalidrawElementsContext";
var $e68ba20b3d2d159d$var$G1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    ...$e68ba20b3d2d159d$var$dr(),
    width: 0,
    height: 0,
    offsetLeft: 0,
    offsetTop: 0
});
$e68ba20b3d2d159d$var$G1.displayName = "ExcalidrawAppStateContext";
var $e68ba20b3d2d159d$var$W1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(()=>{
    console.warn("Uninitialized ExcalidrawSetAppStateContext context!");
});
$e68ba20b3d2d159d$var$W1.displayName = "ExcalidrawSetAppStateContext";
var $e68ba20b3d2d159d$var$V1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$e68ba20b3d2d159d$var$V1.displayName = "ExcalidrawActionManagerContext";
var $e68ba20b3d2d159d$var$Bt = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$i6), $e68ba20b3d2d159d$var$Xn = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$a6), $e68ba20b3d2d159d$export$aa949327762d0f40 = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$z1), $e68ba20b3d2d159d$var$Ft = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$H1), $e68ba20b3d2d159d$var$ma = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$U1), $e68ba20b3d2d159d$var$Yn = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$G1), $e68ba20b3d2d159d$var$He = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$W1), $e68ba20b3d2d159d$var$$t = ()=>(0, $acw62.useContext)($e68ba20b3d2d159d$var$V1), $e68ba20b3d2d159d$var$Em = !1, $e68ba20b3d2d159d$var$R1 = 0, $e68ba20b3d2d159d$var$Fs = !1, $e68ba20b3d2d159d$var$xm = !1, $e68ba20b3d2d159d$var$N1 = !1, $e68ba20b3d2d159d$var$O1 = {
    horizontal: null,
    vertical: null
}, $e68ba20b3d2d159d$var$Aa = 0, $e68ba20b3d2d159d$var$bm = !1, $e68ba20b3d2d159d$var$F1 = new Map, $e68ba20b3d2d159d$var$Wg = !1, $e68ba20b3d2d159d$var$o6 = 0, $e68ba20b3d2d159d$var$n6 = !1, $e68ba20b3d2d159d$var$ym = null, $e68ba20b3d2d159d$var$Ve = {
    pointers: new Map,
    lastCenter: null,
    initialDistance: null,
    initialScale: null
};

var $e68ba20b3d2d159d$var$B1 = class e extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    canvas;
    interactiveCanvas = null;
    rc;
    unmounted = !1;
    actionManager;
    device = $e68ba20b3d2d159d$var$s6;
    excalidrawContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
    scene;
    fonts;
    renderer;
    resizeObserver;
    nearestScrollableContainer;
    library;
    libraryItemsFromStorage;
    id;
    store;
    history;
    excalidrawContainerValue;
    files = {};
    imageCache = new Map;
    iFrameRefs = new Map;
    embedsValidationStatus = new Map;
    initializedEmbeds = new Set;
    elementsPendingErasure = new Set;
    flowChartCreator = new $e68ba20b3d2d159d$var$sg;
    flowChartNavigator = new $e68ba20b3d2d159d$var$ag;
    hitLinkElement;
    lastPointerDownEvent = null;
    lastPointerUpEvent = null;
    lastPointerMoveEvent = null;
    lastViewportPosition = {
        x: 0,
        y: 0
    };
    animationFrameHandler = new $e68ba20b3d2d159d$var$Hg;
    laserTrails = new $e68ba20b3d2d159d$var$Ug(this.animationFrameHandler, this);
    eraserTrail = new $e68ba20b3d2d159d$var$Os(this.animationFrameHandler, this, {
        streamline: .2,
        size: 5,
        keepHead: !0,
        sizeMapping: (t)=>{
            let n = Math.max(0, 1 - (performance.now() - t.pressure) / 200), i = (10 - Math.min(10, t.totalLength - t.currentIndex)) / 10;
            return Math.min($e68ba20b3d2d159d$var$li(i), $e68ba20b3d2d159d$var$li(n));
        },
        fill: ()=>this.state.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT ? "rgba(0, 0, 0, 0.2)" : "rgba(255, 255, 255, 0.2)"
    });
    onChangeEmitter = new $e68ba20b3d2d159d$var$kr;
    onPointerDownEmitter = new $e68ba20b3d2d159d$var$kr;
    onPointerUpEmitter = new $e68ba20b3d2d159d$var$kr;
    onUserFollowEmitter = new $e68ba20b3d2d159d$var$kr;
    onScrollChangeEmitter = new $e68ba20b3d2d159d$var$kr;
    missingPointerEventCleanupEmitter = new $e68ba20b3d2d159d$var$kr;
    onRemoveEventListenersEmitter = new $e68ba20b3d2d159d$var$kr;
    constructor(t){
        super(t);
        let r = $e68ba20b3d2d159d$var$dr(), { excalidrawAPI: o, viewModeEnabled: n = !1, zenModeEnabled: i = !1, gridModeEnabled: a = !1, objectsSnapModeEnabled: s = !1, theme: l = r.theme, name: c = `${$e68ba20b3d2d159d$var$x("labels.untitled")}-${$e68ba20b3d2d159d$var$af()}` } = t;
        if (this.state = {
            ...r,
            theme: l,
            isLoading: !0,
            ...this.getCanvasOffsets(),
            viewModeEnabled: n,
            zenModeEnabled: i,
            objectsSnapModeEnabled: s,
            gridModeEnabled: a ?? r.gridModeEnabled,
            name: c,
            width: window.innerWidth,
            height: window.innerHeight
        }, this.id = (0, $363a23d82a2fc856$export$ac4959f4f1338dfc)(), this.library = new $e68ba20b3d2d159d$var$MI(this), this.actionManager = new $e68ba20b3d2d159d$var$rg(this.syncActionResult, ()=>this.state, ()=>this.scene.getElementsIncludingDeleted(), this), this.scene = new $e68ba20b3d2d159d$var$fr, this.canvas = document.createElement("canvas"), this.rc = (0, $c82ad6b659cbfd26$export$2e2bcd8739ae039).canvas(this.canvas), this.renderer = new $e68ba20b3d2d159d$var$fm(this.scene), this.store = new $e68ba20b3d2d159d$var$pu, this.history = new $e68ba20b3d2d159d$var$nm, o) {
            let d = {
                updateScene: this.updateScene,
                updateLibrary: this.library.updateLibrary,
                addFiles: this.addFiles,
                resetScene: this.resetScene,
                getSceneElementsIncludingDeleted: this.getSceneElementsIncludingDeleted,
                history: {
                    clear: this.resetHistory
                },
                scrollToContent: this.scrollToContent,
                getSceneElements: this.getSceneElements,
                getAppState: ()=>this.state,
                getFiles: ()=>this.files,
                getName: this.getName,
                registerAction: (m)=>{
                    this.actionManager.registerAction(m);
                },
                refresh: this.refresh,
                setToast: this.setToast,
                id: this.id,
                setActiveTool: this.setActiveTool,
                setCursor: this.setCursor,
                resetCursor: this.resetCursor,
                updateFrameRendering: this.updateFrameRendering,
                toggleSidebar: this.toggleSidebar,
                onChange: (m)=>this.onChangeEmitter.on(m),
                onPointerDown: (m)=>this.onPointerDownEmitter.on(m),
                onPointerUp: (m)=>this.onPointerUpEmitter.on(m),
                onScrollChange: (m)=>this.onScrollChangeEmitter.on(m),
                onUserFollow: (m)=>this.onUserFollowEmitter.on(m)
            };
            typeof o == "function" ? o(d) : console.error("excalidrawAPI should be a function!");
        }
        this.excalidrawContainerValue = {
            container: this.excalidrawContainerRef.current,
            id: this.id
        }, this.fonts = new $e68ba20b3d2d159d$var$zr({
            scene: this.scene
        }), this.history = new $e68ba20b3d2d159d$var$nm, this.actionManager.registerAll($e68ba20b3d2d159d$var$cp), this.actionManager.registerAction($e68ba20b3d2d159d$var$EC(this.history, this.store)), this.actionManager.registerAction($e68ba20b3d2d159d$var$xC(this.history, this.store));
    }
    onWindowMessage(t) {
        if (t.origin !== "https://player.vimeo.com" && t.origin !== "https://www.youtube.com") return;
        let r = null;
        try {
            r = JSON.parse(t.data);
        } catch  {}
        if (r) switch(t.origin){
            case "https://player.vimeo.com":
                if (r.method === "paused") {
                    let o = null, n = document.body.querySelectorAll("iframe.excalidraw__embeddable");
                    if (!n) break;
                    for (let i of n)i.contentWindow === t.source && (o = i.contentWindow);
                    o?.postMessage(JSON.stringify({
                        method: r.value ? "play" : "pause",
                        value: !0
                    }), "*");
                }
                break;
            case "https://www.youtube.com":
                if (r.event === "infoDelivery" && r.info && r.id && typeof r.info.playerState == "number") {
                    let o = r.id, n = r.info.playerState;
                    Object.values($e68ba20b3d2d159d$var$Sc).includes(n) && $e68ba20b3d2d159d$var$F1.set(o, n);
                }
                break;
        }
    }
    cacheEmbeddableRef(t, r) {
        r && this.iFrameRefs.set(t.id, r);
    }
    getEffectiveGridSize = ()=>$e68ba20b3d2d159d$var$ba(this) ? this.state.gridSize : null;
    getHTMLIFrameElement(t) {
        return this.iFrameRefs.get(t.id);
    }
    handleEmbeddableCenterClick(t) {
        if (this.state.activeEmbeddable?.element === t && this.state.activeEmbeddable?.state === "active" || (setTimeout(()=>{
            this.setState({
                activeEmbeddable: {
                    element: t,
                    state: "active"
                },
                selectedElementIds: {
                    [t.id]: !0
                },
                newElement: null,
                selectionElement: null
            });
        }, 100), $e68ba20b3d2d159d$var$Mo(t))) return;
        let r = this.getHTMLIFrameElement(t);
        if (r?.contentWindow) {
            if (r.src.includes("youtube")) {
                let o = $e68ba20b3d2d159d$var$F1.get(t.id);
                switch(o || ($e68ba20b3d2d159d$var$F1.set(t.id, $e68ba20b3d2d159d$var$Sc.UNSTARTED), r.contentWindow.postMessage(JSON.stringify({
                    event: "listening",
                    id: t.id
                }), "*")), o){
                    case $e68ba20b3d2d159d$var$Sc.PLAYING:
                    case $e68ba20b3d2d159d$var$Sc.BUFFERING:
                        r.contentWindow?.postMessage(JSON.stringify({
                            event: "command",
                            func: "pauseVideo",
                            args: ""
                        }), "*");
                        break;
                    default:
                        r.contentWindow?.postMessage(JSON.stringify({
                            event: "command",
                            func: "playVideo",
                            args: ""
                        }), "*");
                }
            }
            r.src.includes("player.vimeo.com") && r.contentWindow.postMessage(JSON.stringify({
                method: "paused"
            }), "*");
        }
    }
    isIframeLikeElementCenter(t, r, o, n) {
        return t && !r.altKey && !r.shiftKey && !r.metaKey && !r.ctrlKey && (this.state.activeEmbeddable?.element !== t || this.state.activeEmbeddable?.state === "hover" || !this.state.activeEmbeddable) && o >= t.x + t.width / 3 && o <= t.x + 2 * t.width / 3 && n >= t.y + t.height / 3 && n <= t.y + 2 * t.height / 3;
    }
    updateEmbedValidationStatus = (t, r)=>{
        this.embedsValidationStatus.set(t.id, r), $e68ba20b3d2d159d$var$Oe.delete(t);
    };
    updateEmbeddables = ()=>{
        let t = new Set, r = !1;
        this.scene.getNonDeletedElements().filter((o)=>{
            if ($e68ba20b3d2d159d$var$Rt(o)) {
                if (t.add(o.id), !this.embedsValidationStatus.has(o.id)) {
                    r = !0;
                    let n = $e68ba20b3d2d159d$var$yl(o.link, this.props.validateEmbeddable);
                    this.updateEmbedValidationStatus(o, n);
                }
            } else $e68ba20b3d2d159d$var$Mo(o) && t.add(o.id);
            return !1;
        }), r && this.scene.triggerUpdate(), this.iFrameRefs.forEach((o, n)=>{
            t.has(n) || this.iFrameRefs.delete(n);
        });
    };
    renderEmbeddables() {
        let t = this.state.zoom.value, r = this.state.width, o = this.state.height, n = this.scene.getNonDeletedElements().filter((i)=>$e68ba20b3d2d159d$var$Rt(i) && this.embedsValidationStatus.get(i.id) === !0 || $e68ba20b3d2d159d$var$Mo(i));
        return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: n.map((i)=>{
                let { x: a, y: s } = $e68ba20b3d2d159d$export$a4a3582487786f33({
                    sceneX: i.x,
                    sceneY: i.y
                }, this.state), l = $e68ba20b3d2d159d$var$bs(i, r, o, this.state, this.scene.getNonDeletedElementsMap()), c = this.initializedEmbeds.has(i.id);
                if (l && !c && this.initializedEmbeds.add(i.id), !(l || c)) return null;
                let m;
                if ($e68ba20b3d2d159d$var$Mo(i)) {
                    m = null;
                    let h = (i.customData?.generationData ?? this.magicGenerations.get(i.id)) || {
                        status: "error",
                        message: "No generation data",
                        code: "ERR_NO_GENERATION_DATA"
                    };
                    if (h.status === "done") {
                        let g = h.html;
                        m = {
                            intrinsicSize: {
                                w: i.width,
                                h: i.height
                            },
                            type: "document",
                            srcdoc: ()=>g
                        };
                    } else if (h.status === "pending") m = {
                        intrinsicSize: {
                            w: i.width,
                            h: i.height
                        },
                        type: "document",
                        srcdoc: ()=>$e68ba20b3d2d159d$var$hd(`
                    <style>
                      html, body {
                        width: 100%;
                        height: 100%;
                        color: ${this.state.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK ? "white" : "black"};
                      }
                      body {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        gap: 1rem;
                      }

                      .Spinner {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: auto;
                        margin-right: auto;
                      }

                      .Spinner svg {
                        animation: rotate 1.6s linear infinite;
                        transform-origin: center center;
                        width: 40px;
                        height: 40px;
                      }

                      .Spinner circle {
                        stroke: currentColor;
                        animation: dash 1.6s linear 0s infinite;
                        stroke-linecap: round;
                      }

                      @keyframes rotate {
                        100% {
                          transform: rotate(360deg);
                        }
                      }

                      @keyframes dash {
                        0% {
                          stroke-dasharray: 1, 300;
                          stroke-dashoffset: 0;
                        }
                        50% {
                          stroke-dasharray: 150, 300;
                          stroke-dashoffset: -200;
                        }
                        100% {
                          stroke-dasharray: 1, 300;
                          stroke-dashoffset: -280;
                        }
                      }
                    </style>
                    <div class="Spinner">
                      <svg
                        viewBox="0 0 100 100"
                      >
                        <circle
                          cx="50"
                          cy="50"
                          r="46"
                          stroke-width="8"
                          fill="none"
                          stroke-miter-limit="10"
                        />
                      </svg>
                    </div>
                    <div>Generating...</div>
                  `)
                    };
                    else {
                        let g;
                        h.code === "ERR_GENERATION_INTERRUPTED" ? g = "Generation was interrupted..." : g = h.message || "Generation failed", m = {
                            intrinsicSize: {
                                w: i.width,
                                h: i.height
                            },
                            type: "document",
                            srcdoc: ()=>$e68ba20b3d2d159d$var$hd(`
                    <style>
                    html, body {
                      height: 100%;
                    }
                      body {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: ${$e68ba20b3d2d159d$var$fe.red[3]};
                      }
                      h1, h3 {
                        margin-top: 0;
                        margin-bottom: 0.5rem;
                      }
                    </style>
                    <h1>Error!</h1>
                    <h3>${g}</h3>
                  `)
                        };
                    }
                } else m = $e68ba20b3d2d159d$var$bi($e68ba20b3d2d159d$var$lp(i.link || ""));
                let p = this.state.activeEmbeddable?.element === i && this.state.activeEmbeddable?.state === "active", u = this.state.activeEmbeddable?.element === i && this.state.activeEmbeddable?.state === "hover";
                return (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("excalidraw__embeddable-container", {
                        "is-hovered": u
                    }),
                    style: {
                        transform: l ? `translate(${a - this.state.offsetLeft}px, ${s - this.state.offsetTop}px) scale(${t})` : "none",
                        display: l ? "block" : "none",
                        opacity: $e68ba20b3d2d159d$var$FE(i, $e68ba20b3d2d159d$var$rr(i, this.scene.getNonDeletedElementsMap()), this.elementsPendingErasure, null),
                        "--embeddable-radius": `${$e68ba20b3d2d159d$var$xo(Math.min(i.width, i.height), i)}px`
                    },
                    children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "excalidraw__embeddable-container__inner",
                        style: {
                            width: l ? `${i.width}px` : 0,
                            height: l ? `${i.height}px` : 0,
                            transform: l ? `rotate(${i.angle}rad)` : "none",
                            pointerEvents: p ? $e68ba20b3d2d159d$var$Ra.enabled : $e68ba20b3d2d159d$var$Ra.disabled
                        },
                        children: [
                            u && (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "excalidraw__embeddable-hint",
                                children: $e68ba20b3d2d159d$var$x("buttons.embeddableInteractionButton")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "excalidraw__embeddable__outer",
                                style: {
                                    padding: `${i.strokeWidth}px`
                                },
                                children: ($e68ba20b3d2d159d$var$Rt(i) ? this.props.renderEmbeddable?.(i, this.state) : null) ?? (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                    ref: (h)=>this.cacheEmbeddableRef(i, h),
                                    className: "excalidraw__embeddable",
                                    srcDoc: m?.type === "document" ? m.srcdoc(this.state.theme) : void 0,
                                    src: m?.type !== "document" ? m?.link ?? "" : void 0,
                                    scrolling: "no",
                                    referrerPolicy: "no-referrer-when-downgrade",
                                    title: "Excalidraw Embedded Content",
                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                    allowFullScreen: !0,
                                    sandbox: `${m?.sandbox?.allowSameOrigin ? "allow-same-origin" : ""} allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-downloads`
                                })
                            })
                        ]
                    })
                }, i.id);
            })
        });
    }
    getFrameNameDOMId = (t)=>`${this.id}-frame-name-${t.id}`;
    frameNameBoundsCache = {
        get: (t)=>{
            let r = this.frameNameBoundsCache._cache.get(t.id);
            if (!r || r.zoom !== this.state.zoom.value || r.versionNonce !== t.versionNonce) {
                let o = document.getElementById(this.getFrameNameDOMId(t));
                if (o) {
                    let n = o.getBoundingClientRect(), i = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
                        clientX: n.x,
                        clientY: n.y
                    }, this.state), a = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
                        clientX: n.right,
                        clientY: n.bottom
                    }, this.state);
                    return r = {
                        x: i.x,
                        y: i.y,
                        width: a.x - i.x,
                        height: a.y - i.y,
                        angle: 0,
                        zoom: this.state.zoom.value,
                        versionNonce: t.versionNonce
                    }, this.frameNameBoundsCache._cache.set(t.id, r), r;
                }
                return null;
            }
            return r;
        },
        _cache: new Map
    };
    renderFrameNames = ()=>{
        if (!this.state.frameRendering.enabled || !this.state.frameRendering.name) return null;
        let t = this.state.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK;
        return this.scene.getNonDeletedFramesLikes().map((r)=>{
            if (!$e68ba20b3d2d159d$var$bs(r, this.canvas.width / window.devicePixelRatio, this.canvas.height / window.devicePixelRatio, {
                offsetLeft: this.state.offsetLeft,
                offsetTop: this.state.offsetTop,
                scrollX: this.state.scrollX,
                scrollY: this.state.scrollY,
                zoom: this.state.zoom
            }, this.scene.getNonDeletedElementsMap())) return null;
            let { x: o, y: n } = $e68ba20b3d2d159d$export$a4a3582487786f33({
                sceneX: r.x,
                sceneY: r.y
            }, this.state), i = 6, a = ()=>{
                $e68ba20b3d2d159d$export$55655e96a21bba2e(r, {
                    name: r.name?.trim() || null
                }), this.setState({
                    editingFrame: null
                });
            }, s, l = $e68ba20b3d2d159d$var$Au(r);
            if (r.id === this.state.editingFrame) {
                let c = l;
                s = (0, $7b02d682eb115277$exports.jsx)("input", {
                    autoFocus: !0,
                    value: c,
                    onChange: (d)=>{
                        $e68ba20b3d2d159d$export$55655e96a21bba2e(r, {
                            name: d.target.value
                        });
                    },
                    onFocus: (d)=>d.target.select(),
                    onBlur: ()=>a(),
                    onKeyDown: (d)=>{
                        (d.key === $e68ba20b3d2d159d$var$S.ESCAPE || d.key === $e68ba20b3d2d159d$var$S.ENTER) && a();
                    },
                    style: {
                        background: this.state.viewBackgroundColor,
                        filter: t ? $e68ba20b3d2d159d$var$Vs : "none",
                        zIndex: 2,
                        border: "none",
                        display: "block",
                        padding: `${i}px`,
                        borderRadius: 4,
                        boxShadow: "inset 0 0 0 1px var(--color-primary)",
                        fontFamily: "Assistant",
                        fontSize: "14px",
                        transform: `translate(-${i}px, ${i}px)`,
                        color: "var(--color-gray-80)",
                        overflow: "hidden",
                        maxWidth: `${document.body.clientWidth - o - i}px`
                    },
                    size: c.length + 1 || 1,
                    dir: "auto",
                    autoComplete: "off",
                    autoCapitalize: "off",
                    autoCorrect: "off"
                });
            } else s = l;
            return (0, $7b02d682eb115277$exports.jsx)("div", {
                id: this.getFrameNameDOMId(r),
                style: {
                    position: "absolute",
                    bottom: `${this.state.height + $e68ba20b3d2d159d$var$ot.nameOffsetY - n + this.state.offsetTop}px`,
                    left: `${o - this.state.offsetLeft}px`,
                    zIndex: 2,
                    fontSize: $e68ba20b3d2d159d$var$ot.nameFontSize,
                    color: t ? $e68ba20b3d2d159d$var$ot.nameColorDarkTheme : $e68ba20b3d2d159d$var$ot.nameColorLightTheme,
                    lineHeight: $e68ba20b3d2d159d$var$ot.nameLineHeight,
                    width: "max-content",
                    maxWidth: `${r.width}px`,
                    overflow: r.id === this.state.editingFrame ? "visible" : "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    cursor: $e68ba20b3d2d159d$var$Ue.MOVE,
                    pointerEvents: this.state.viewModeEnabled ? $e68ba20b3d2d159d$var$Ra.disabled : $e68ba20b3d2d159d$var$Ra.enabled
                },
                onPointerDown: (c)=>this.handleCanvasPointerDown(c),
                onWheel: (c)=>this.handleWheel(c),
                onContextMenu: this.handleCanvasContextMenu,
                onDoubleClick: ()=>{
                    this.setState({
                        editingFrame: r.id
                    });
                },
                children: s
            }, r.id);
        });
    };
    toggleOverscrollBehavior(t) {
        document.documentElement.style.overscrollBehaviorX = t.type === "pointerenter" ? "none" : "auto";
    }
    render() {
        let t = this.scene.getSelectedElements(this.state), { renderTopRightUI: r, renderCustomStats: o } = this.props, n = this.scene.getSceneNonce(), { elementsMap: i, visibleElements: a } = this.renderer.getRenderableElements({
            sceneNonce: n,
            zoom: this.state.zoom,
            offsetLeft: this.state.offsetLeft,
            offsetTop: this.state.offsetTop,
            scrollX: this.state.scrollX,
            scrollY: this.state.scrollY,
            height: this.state.height,
            width: this.state.width,
            editingTextElement: this.state.editingTextElement,
            newElementId: this.state.newElement?.id,
            pendingImageElementId: this.state.pendingImageElementId
        }), s = this.scene.getNonDeletedElementsMap(), l = this.state.selectionElement || this.state.newElement || this.state.selectedElementsAreBeingDragged || this.state.resizingElement || this.state.activeTool.type === "laser" && this.state.cursorButton === "down", c = t[0];
        return (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("excalidraw excalidraw-container", {
                "excalidraw--view-mode": this.state.viewModeEnabled,
                "excalidraw--mobile": this.device.editor.isMobile
            }),
            style: {
                "--ui-pointerEvents": l ? $e68ba20b3d2d159d$var$Ra.disabled : $e68ba20b3d2d159d$var$Ra.enabled
            },
            ref: this.excalidrawContainerRef,
            onDrop: this.handleAppOnDrop,
            tabIndex: 0,
            onKeyDown: this.props.handleKeyboardGlobally ? void 0 : this.onKeyDown,
            onPointerEnter: this.toggleOverscrollBehavior,
            onPointerLeave: this.toggleOverscrollBehavior,
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$i6.Provider, {
                value: this,
                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$a6.Provider, {
                    value: this.props,
                    children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$H1.Provider, {
                        value: this.excalidrawContainerValue,
                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$z1.Provider, {
                            value: this.device,
                            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$W1.Provider, {
                                value: this.setAppState,
                                children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$G1.Provider, {
                                    value: this.state,
                                    children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$U1.Provider, {
                                        value: this.scene.getNonDeletedElements(),
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$V1.Provider, {
                                                value: this.actionManager,
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$SA, {
                                                        canvas: this.canvas,
                                                        appState: this.state,
                                                        files: this.files,
                                                        setAppState: this.setAppState,
                                                        actionManager: this.actionManager,
                                                        elements: this.scene.getNonDeletedElements(),
                                                        onLockToggle: this.toggleLock,
                                                        onPenModeToggle: this.togglePenMode,
                                                        onHandToolToggle: this.onHandToolToggle,
                                                        langCode: $e68ba20b3d2d159d$var$Sn().code,
                                                        renderTopRightUI: r,
                                                        renderCustomStats: o,
                                                        showExitZenModeBtn: typeof this.props?.zenModeEnabled > "u" && this.state.zenModeEnabled,
                                                        UIOptions: this.props.UIOptions,
                                                        onExportImage: this.onExportImage,
                                                        renderWelcomeScreen: !this.state.isLoading && this.state.showWelcomeScreen && this.state.activeTool.type === "selection" && !this.state.zenModeEnabled && !this.scene.getElementsIncludingDeleted().length,
                                                        app: this,
                                                        isCollaborating: this.props.isCollaborating,
                                                        children: this.props.children
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "excalidraw-textEditorContainer"
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "excalidraw-contextMenuContainer"
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "excalidraw-eye-dropper-container"
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$XA, {
                                                        trails: [
                                                            this.laserTrails,
                                                            this.eraserTrail
                                                        ]
                                                    }),
                                                    t.length === 1 && this.state.showHyperlinkPopup && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pI, {
                                                        element: c,
                                                        elementsMap: s,
                                                        setAppState: this.setAppState,
                                                        onLinkOpen: this.props.onLinkOpen,
                                                        setToast: this.setToast,
                                                        updateEmbedValidationStatus: this.updateEmbedValidationStatus
                                                    }, c.id),
                                                    this.props.aiEnabled !== !1 && t.length === 1 && $e68ba20b3d2d159d$var$$s(c) && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$D1, {
                                                        element: c,
                                                        elementsMap: i,
                                                        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$zg, {
                                                            title: $e68ba20b3d2d159d$var$x("labels.convertToCode"),
                                                            icon: $e68ba20b3d2d159d$var$Ip,
                                                            checked: !1,
                                                            onChange: ()=>this.onMagicFrameGenerate(c, "button")
                                                        })
                                                    }),
                                                    t.length === 1 && $e68ba20b3d2d159d$var$Mo(c) && c.customData?.generationData?.status === "done" && (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$D1, {
                                                        element: c,
                                                        elementsMap: i,
                                                        children: [
                                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$zg, {
                                                                title: $e68ba20b3d2d159d$var$x("labels.copySource"),
                                                                icon: $e68ba20b3d2d159d$var$wp,
                                                                checked: !1,
                                                                onChange: ()=>this.onIframeSrcCopy(c)
                                                            }),
                                                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$zg, {
                                                                title: "Enter fullscreen",
                                                                icon: $e68ba20b3d2d159d$var$Bw,
                                                                checked: !1,
                                                                onChange: ()=>{
                                                                    let d = this.getHTMLIFrameElement(c);
                                                                    if (d) try {
                                                                        d.requestFullscreen(), this.setState({
                                                                            activeEmbeddable: {
                                                                                element: c,
                                                                                state: "active"
                                                                            },
                                                                            selectedElementIds: {
                                                                                [c.id]: !0
                                                                            },
                                                                            newElement: null,
                                                                            selectionElement: null
                                                                        });
                                                                    } catch (m) {
                                                                        console.warn(m), this.setState({
                                                                            errorMessage: "Couldn't enter fullscreen"
                                                                        });
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    this.state.toast !== null && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$CA, {
                                                        message: this.state.toast.message,
                                                        onClose: ()=>this.setToast(null),
                                                        duration: this.state.toast.duration,
                                                        closable: this.state.toast.closable
                                                    }),
                                                    this.state.contextMenu && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wC, {
                                                        items: this.state.contextMenu.items,
                                                        top: this.state.contextMenu.top,
                                                        left: this.state.contextMenu.left,
                                                        actionManager: this.actionManager,
                                                        onClose: (d)=>{
                                                            this.setState({
                                                                contextMenu: null
                                                            }, ()=>{
                                                                this.focusContainer(), d?.();
                                                            });
                                                        }
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$L1, {
                                                        canvas: this.canvas,
                                                        rc: this.rc,
                                                        elementsMap: i,
                                                        allElementsMap: s,
                                                        visibleElements: a,
                                                        sceneNonce: n,
                                                        selectionNonce: this.state.selectionElement?.versionNonce,
                                                        scale: window.devicePixelRatio,
                                                        appState: this.state,
                                                        renderConfig: {
                                                            imageCache: this.imageCache,
                                                            isExporting: !1,
                                                            renderGrid: $e68ba20b3d2d159d$var$ba(this),
                                                            canvasBackgroundColor: this.state.viewBackgroundColor,
                                                            embedsValidationStatus: this.embedsValidationStatus,
                                                            elementsPendingErasure: this.elementsPendingErasure,
                                                            pendingFlowchartNodes: this.flowChartCreator.pendingNodes
                                                        }
                                                    }),
                                                    this.state.newElement && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$t6, {
                                                        appState: this.state,
                                                        scale: window.devicePixelRatio,
                                                        rc: this.rc,
                                                        elementsMap: i,
                                                        allElementsMap: s,
                                                        renderConfig: {
                                                            imageCache: this.imageCache,
                                                            isExporting: !1,
                                                            renderGrid: !1,
                                                            canvasBackgroundColor: this.state.viewBackgroundColor,
                                                            embedsValidationStatus: this.embedsValidationStatus,
                                                            elementsPendingErasure: this.elementsPendingErasure,
                                                            pendingFlowchartNodes: null
                                                        }
                                                    }),
                                                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$P1, {
                                                        containerRef: this.excalidrawContainerRef,
                                                        canvas: this.interactiveCanvas,
                                                        elementsMap: i,
                                                        visibleElements: a,
                                                        allElementsMap: s,
                                                        selectedElements: t,
                                                        sceneNonce: n,
                                                        selectionNonce: this.state.selectionElement?.versionNonce,
                                                        scale: window.devicePixelRatio,
                                                        appState: this.state,
                                                        device: this.device,
                                                        renderInteractiveSceneCallback: this.renderInteractiveSceneCallback,
                                                        handleCanvasRef: this.handleInteractiveCanvasRef,
                                                        onContextMenu: this.handleCanvasContextMenu,
                                                        onPointerMove: this.handleCanvasPointerMove,
                                                        onPointerUp: this.handleCanvasPointerUp,
                                                        onPointerCancel: this.removePointer,
                                                        onTouchMove: this.handleTouchMove,
                                                        onPointerDown: this.handleCanvasPointerDown,
                                                        onDoubleClick: this.handleCanvasDoubleClick
                                                    }),
                                                    this.state.userToFollow && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$ZA, {
                                                        width: this.state.width,
                                                        height: this.state.height,
                                                        userToFollow: this.state.userToFollow,
                                                        onDisconnect: this.maybeUnfollowRemoteUser
                                                    }),
                                                    this.renderFrameNames()
                                                ]
                                            }),
                                            this.renderEmbeddables()
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    }
    focusContainer = ()=>{
        this.excalidrawContainerRef.current?.focus();
    };
    getSceneElementsIncludingDeleted = ()=>this.scene.getElementsIncludingDeleted();
    getSceneElements = ()=>this.scene.getNonDeletedElements();
    onInsertElements = (t)=>{
        this.addElementsFromPasteOrLibrary({
            elements: t,
            position: "center",
            files: null
        });
    };
    onExportImage = async (t, r, o)=>{
        $e68ba20b3d2d159d$var$Pe("export", t, "ui");
        let n = await $e68ba20b3d2d159d$var$Ms(t, r, this.state, this.files, {
            exportBackground: this.state.exportBackground,
            name: this.getName(),
            viewBackgroundColor: this.state.viewBackgroundColor,
            exportingFrame: o.exportingFrame
        }).catch($e68ba20b3d2d159d$var$$m).catch((i)=>{
            console.error(i), this.setState({
                errorMessage: i.message
            });
        });
        this.state.exportEmbedScene && n && $e68ba20b3d2d159d$var$nl(n) && this.setState({
            fileHandle: n
        });
    };
    magicGenerations = new Map;
    updateMagicGeneration = ({ frameElement: t, data: r })=>{
        r.status === "pending" ? $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
            customData: {
                generationData: void 0
            }
        }, !1) : $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
            customData: {
                generationData: r
            }
        }, !1), this.magicGenerations.set(t.id, r), this.triggerRender();
    };
    plugins = {};
    setPlugins(t) {
        Object.assign(this.plugins, t);
    }
    async onMagicFrameGenerate(t, r) {
        let o = this.plugins.diagramToCode?.generate;
        if (!o) {
            this.setState({
                errorMessage: "No diagram to code plugin found"
            });
            return;
        }
        let n = $e68ba20b3d2d159d$var$Sl(this.scene.getNonDeletedElements(), t).filter((a)=>!$e68ba20b3d2d159d$var$$s(a));
        if (!n.length) {
            r === "button" ? (this.setState({
                errorMessage: "Cannot generate from an empty frame"
            }), $e68ba20b3d2d159d$var$Pe("ai", "generate (no-children)", "d2c")) : this.setActiveTool({
                type: "magicframe"
            });
            return;
        }
        let i = this.insertIframeElement({
            sceneX: t.x + t.width + 30,
            sceneY: t.y,
            width: t.width,
            height: t.height
        });
        if (i) {
            this.updateMagicGeneration({
                frameElement: i,
                data: {
                    status: "pending"
                }
            }), this.setState({
                selectedElementIds: {
                    [i.id]: !0
                }
            }), $e68ba20b3d2d159d$var$Pe("ai", "generate (start)", "d2c");
            try {
                let { html: a } = await o({
                    frame: t,
                    children: n
                });
                if ($e68ba20b3d2d159d$var$Pe("ai", "generate (success)", "d2c"), !a.trim()) {
                    this.updateMagicGeneration({
                        frameElement: i,
                        data: {
                            status: "error",
                            code: "ERR_OAI",
                            message: "Nothing genereated :("
                        }
                    });
                    return;
                }
                let s = a.includes("<!DOCTYPE html>") && a.includes("</html>") ? a.slice(a.indexOf("<!DOCTYPE html>"), a.indexOf("</html>") + 7) : a;
                this.updateMagicGeneration({
                    frameElement: i,
                    data: {
                        status: "done",
                        html: s
                    }
                });
            } catch (a) {
                $e68ba20b3d2d159d$var$Pe("ai", "generate (failed)", "d2c"), this.updateMagicGeneration({
                    frameElement: i,
                    data: {
                        status: "error",
                        code: "ERR_OAI",
                        message: a.message || "Unknown error during generation"
                    }
                });
            }
        }
    }
    onIframeSrcCopy(t) {
        t.customData?.generationData?.status === "done" && ($e68ba20b3d2d159d$var$vi(t.customData.generationData.html), this.setToast({
            message: "copied to clipboard",
            closable: !1,
            duration: 1500
        }));
    }
    onMagicframeToolSelect = ()=>{
        let t = this.scene.getSelectedElements({
            selectedElementIds: this.state.selectedElementIds
        });
        if (t.length === 0) this.setActiveTool({
            type: $e68ba20b3d2d159d$var$St.magicframe
        }), $e68ba20b3d2d159d$var$Pe("ai", "tool-select (empty-selection)", "d2c");
        else {
            let r = t.length === 1 && $e68ba20b3d2d159d$var$$s(t[0]) && t[0];
            if (!r && t.some((n)=>$e68ba20b3d2d159d$var$re(n) || n.frameId)) {
                this.setActiveTool({
                    type: $e68ba20b3d2d159d$var$St.magicframe
                });
                return;
            }
            $e68ba20b3d2d159d$var$Pe("ai", "tool-select (existing selection)", "d2c");
            let o;
            if (r) o = r;
            else {
                let [n, i, a, s] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(t), l = 50;
                o = $e68ba20b3d2d159d$var$sd({
                    ...$e68ba20b3d2d159d$var$ot,
                    x: n - l,
                    y: i - l,
                    width: a - n + l * 2,
                    height: s - i + l * 2,
                    opacity: 100,
                    locked: !1
                }), this.scene.insertElement(o);
                for (let c of t)$e68ba20b3d2d159d$export$55655e96a21bba2e(c, {
                    frameId: o.id
                });
                this.setState({
                    selectedElementIds: {
                        [o.id]: !0
                    }
                });
            }
            this.onMagicFrameGenerate(o, "upstream");
        }
    };
    openEyeDropper = ({ type: t })=>{
        $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$da, {
            swapPreviewOnAlt: !0,
            colorPickerType: t === "stroke" ? "elementStroke" : "elementBackground",
            onSelect: (r, o)=>{
                let n = t === "background" && o.altKey || t === "stroke" && !o.altKey;
                !this.scene.getSelectedElements(this.state).length || this.state.activeTool.type !== "selection" ? n ? this.syncActionResult({
                    appState: {
                        ...this.state,
                        currentItemStrokeColor: r
                    },
                    storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                }) : this.syncActionResult({
                    appState: {
                        ...this.state,
                        currentItemBackgroundColor: r
                    },
                    storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                }) : this.updateScene({
                    elements: this.scene.getElementsIncludingDeleted().map((a)=>this.state.selectedElementIds[a.id] ? $e68ba20b3d2d159d$export$5390fab1c98104d7(a, {
                            [n ? "strokeColor" : "backgroundColor"]: r
                        }) : a),
                    storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                });
            },
            keepOpenOnAlt: !1
        });
    };
    dismissLinearEditor = ()=>{
        setTimeout(()=>{
            this.setState({
                editingLinearElement: null
            });
        });
    };
    syncActionResult = $e68ba20b3d2d159d$var$Et((t)=>{
        if (this.unmounted || t === !1) return;
        t.storeAction === $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE ? this.store.shouldUpdateSnapshot() : t.storeAction === $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE && this.store.shouldCaptureIncrement();
        let r = !1, o = null;
        if (t.elements && (this.scene.replaceAllElements(t.elements), r = !0), t.files && (this.files = t.replaceFiles ? t.files : {
            ...this.files,
            ...t.files
        }, this.addNewImagesToImageCache()), t.appState || o || this.state.contextMenu) {
            let n = t?.appState?.viewModeEnabled || !1, i = t?.appState?.zenModeEnabled || !1, a = t?.appState?.theme || this.props.theme || $e68ba20b3d2d159d$export$5714e40777c1bcc2.LIGHT, s = t?.appState?.name ?? this.state.name, l = t?.appState?.errorMessage ?? this.state.errorMessage;
            typeof this.props.viewModeEnabled < "u" && (n = this.props.viewModeEnabled), typeof this.props.zenModeEnabled < "u" && (i = this.props.zenModeEnabled), o = t.appState?.editingTextElement || null, t.elements && o && t.elements.forEach((c)=>{
                o?.id === c.id && o !== c && $e68ba20b3d2d159d$var$_d(c) && $e68ba20b3d2d159d$var$G(c) && (o = c);
            }), o?.isDeleted && (o = null), this.setState((c)=>Object.assign(t.appState || {}, {
                    contextMenu: null,
                    editingTextElement: o,
                    viewModeEnabled: n,
                    zenModeEnabled: i,
                    theme: a,
                    name: s,
                    errorMessage: l
                })), r = !0;
        }
        !r && t.storeAction !== $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE && this.scene.triggerUpdate();
    });
    onBlur = $e68ba20b3d2d159d$var$Et(()=>{
        $e68ba20b3d2d159d$var$Fs = !1, this.setState({
            isBindingEnabled: !0
        });
    });
    onUnload = ()=>{
        this.onBlur();
    };
    disableEvent = (t)=>{
        t.preventDefault();
    };
    resetHistory = ()=>{
        this.history.clear();
    };
    resetStore = ()=>{
        this.store.clear();
    };
    resetScene = $e68ba20b3d2d159d$var$Et((t)=>{
        this.scene.replaceAllElements([]), this.setState((r)=>({
                ...$e68ba20b3d2d159d$var$dr(),
                isLoading: t?.resetLoadingState ? !1 : r.isLoading,
                theme: this.state.theme
            })), this.resetStore(), this.resetHistory();
    });
    initializeScene = async ()=>{
        "launchQueue" in window && "LaunchParams" in window && window.launchQueue.setConsumer(async (o)=>{
            if (!o.files.length) return;
            let n = o.files[0], i = await n.getFile();
            this.loadFileToCanvas(new File([
                i
            ], i.name || "", {
                type: i.type
            }), n);
        }), this.props.theme && this.setState({
            theme: this.props.theme
        }), this.state.isLoading || this.setState({
            isLoading: !0
        });
        let t = null;
        try {
            typeof this.props.initialData == "function" ? t = await this.props.initialData() || null : t = await this.props.initialData || null, t?.libraryItems && this.library.updateLibrary({
                libraryItems: t.libraryItems,
                merge: !0
            }).catch((o)=>{
                console.error(o);
            });
        } catch (o) {
            console.error(o), t = {
                appState: {
                    errorMessage: o.message || "Encountered an error during importing or restoring scene data"
                }
            };
        }
        let r = $e68ba20b3d2d159d$export$db239ef39aadc7fe(t, null, null, {
            repairBindings: !0
        });
        r.appState = {
            ...r.appState,
            theme: this.props.theme || r.appState.theme,
            openSidebar: r.appState?.openSidebar || this.state.openSidebar,
            activeTool: r.appState.activeTool.type === "image" ? {
                ...r.appState.activeTool,
                type: "selection"
            } : r.appState.activeTool,
            isLoading: !1,
            toast: this.state.toast
        }, t?.scrollToContent && (r.appState = {
            ...r.appState,
            ...$e68ba20b3d2d159d$var$Hn(r.elements, {
                ...r.appState,
                width: this.state.width,
                height: this.state.height,
                offsetTop: this.state.offsetTop,
                offsetLeft: this.state.offsetLeft
            })
        }), this.resetStore(), this.resetHistory(), this.syncActionResult({
            ...r,
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
        }), this.fonts.loadSceneFonts();
    };
    isMobileBreakpoint = (t, r)=>t < $e68ba20b3d2d159d$var$A0 || r < $e68ba20b3d2d159d$var$k0 && t < $e68ba20b3d2d159d$var$M0;
    refreshViewportBreakpoints = ()=>{
        if (!this.excalidrawContainerRef.current) return;
        let { clientWidth: r, clientHeight: o } = document.body, n = this.device.viewport, i = $e68ba20b3d2d159d$var$Ks(n, {
            isLandscape: r > o,
            isMobile: this.isMobileBreakpoint(r, o)
        });
        return n !== i ? (this.device = {
            ...this.device,
            viewport: i
        }, !0) : !1;
    };
    refreshEditorBreakpoints = ()=>{
        let t = this.excalidrawContainerRef.current;
        if (!t) return;
        let { width: r, height: o } = t.getBoundingClientRect(), n = this.props.UIOptions.dockedSidebarBreakpoint != null ? this.props.UIOptions.dockedSidebarBreakpoint : $e68ba20b3d2d159d$var$P0, i = this.device.editor, a = $e68ba20b3d2d159d$var$Ks(i, {
            isMobile: this.isMobileBreakpoint(r, o),
            canFitSidebar: r > n
        });
        return i !== a ? (this.device = {
            ...this.device,
            editor: a
        }, !0) : !1;
    };
    async componentDidMount() {
        if (this.unmounted = !1, this.excalidrawContainerValue.container = this.excalidrawContainerRef.current, $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST || $e68ba20b3d2d159d$var$T.DEV) {
            let r = this.setState.bind(this);
            Object.defineProperties(window.h, {
                state: {
                    configurable: !0,
                    get: ()=>this.state
                },
                setState: {
                    configurable: !0,
                    value: (...o)=>this.setState(...o)
                },
                app: {
                    configurable: !0,
                    value: this
                },
                history: {
                    configurable: !0,
                    value: this.history
                },
                store: {
                    configurable: !0,
                    value: this.store
                },
                fonts: {
                    configurable: !0,
                    value: this.fonts
                }
            });
        }
        this.store.onStoreIncrementEmitter.on((r)=>{
            this.history.record(r.elementsChange, r.appStateChange);
        }), this.scene.onUpdate(this.triggerRender), this.addEventListeners(), this.props.autoFocus && this.excalidrawContainerRef.current && this.focusContainer(), $e68ba20b3d2d159d$var$Zr() || (this.refreshViewportBreakpoints(), this.refreshEditorBreakpoints()), $e68ba20b3d2d159d$var$vc && this.excalidrawContainerRef.current && (this.resizeObserver = new ResizeObserver(()=>{
            this.refreshEditorBreakpoints(), this.updateDOMRect();
        }), this.resizeObserver?.observe(this.excalidrawContainerRef.current)), new URLSearchParams(window.location.search.slice(1)).has("web-share-target") ? this.restoreFileFromShare() : this.updateDOMRect(this.initializeScene), $e68ba20b3d2d159d$var$h0() && !$e68ba20b3d2d159d$var$S3() && this.setState({
            errorMessage: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$LA, {})
        });
    }
    componentWillUnmount() {
        window.launchQueue?.setConsumer(()=>{}), this.renderer.destroy(), this.scene.destroy(), this.scene = new $e68ba20b3d2d159d$var$fr, this.fonts = new $e68ba20b3d2d159d$var$zr({
            scene: this.scene
        }), this.renderer = new $e68ba20b3d2d159d$var$fm(this.scene), this.files = {}, this.imageCache.clear(), this.resizeObserver?.disconnect(), this.unmounted = !0, this.removeEventListeners(), this.library.destroy(), this.laserTrails.stop(), this.eraserTrail.stop(), this.onChangeEmitter.clear(), this.store.onStoreIncrementEmitter.clear(), $e68ba20b3d2d159d$var$Oe.destroy(), $e68ba20b3d2d159d$var$Uo.destroy(), clearTimeout($e68ba20b3d2d159d$var$Aa), $e68ba20b3d2d159d$var$Qe.clearCache(), $e68ba20b3d2d159d$var$mr.clearCache(), $e68ba20b3d2d159d$var$Aa = 0, document.documentElement.style.overscrollBehaviorX = "";
    }
    onResize = $e68ba20b3d2d159d$var$Et(()=>{
        this.scene.getElementsIncludingDeleted().forEach((t)=>$e68ba20b3d2d159d$var$Oe.delete(t)), this.refreshViewportBreakpoints(), this.updateDOMRect(), $e68ba20b3d2d159d$var$vc || this.refreshEditorBreakpoints(), this.setState({});
    });
    onFullscreenChange = ()=>{
        !document.fullscreenElement && this.state.activeEmbeddable?.state === "active" && this.setState({
            activeEmbeddable: null
        });
    };
    removeEventListeners() {
        this.onRemoveEventListenersEmitter.trigger();
    }
    addEventListeners() {
        this.removeEventListeners(), this.props.handleKeyboardGlobally && this.onRemoveEventListenersEmitter.once($e68ba20b3d2d159d$var$xt(document, "keydown", this.onKeyDown, !1)), this.onRemoveEventListenersEmitter.once($e68ba20b3d2d159d$var$xt(this.excalidrawContainerRef.current, "wheel", this.onWheel, {
            passive: !1
        }), $e68ba20b3d2d159d$var$xt(window, "message", this.onWindowMessage, !1), $e68ba20b3d2d159d$var$xt(document, "pointerup", this.removePointer), $e68ba20b3d2d159d$var$xt(document, "copy", this.onCopy), $e68ba20b3d2d159d$var$xt(document, "keyup", this.onKeyUp, {
            passive: !0
        }), $e68ba20b3d2d159d$var$xt(document, "pointermove", this.updateCurrentCursorPosition), $e68ba20b3d2d159d$var$xt(document.fonts, "loadingdone", (t)=>{
            let r = t.fontfaces;
            this.fonts.onLoaded(r);
        }), $e68ba20b3d2d159d$var$xt(document, "gesturestart", this.onGestureStart, !1), $e68ba20b3d2d159d$var$xt(document, "gesturechange", this.onGestureChange, !1), $e68ba20b3d2d159d$var$xt(document, "gestureend", this.onGestureEnd, !1), $e68ba20b3d2d159d$var$xt(window, "focus", ()=>{
            this.maybeCleanupAfterMissingPointerUp(null), this.triggerRender(!0);
        })), !this.state.viewModeEnabled && (this.onRemoveEventListenersEmitter.once($e68ba20b3d2d159d$var$xt(document, "fullscreenchange", this.onFullscreenChange), $e68ba20b3d2d159d$var$xt(document, "paste", this.pasteFromClipboard), $e68ba20b3d2d159d$var$xt(document, "cut", this.onCut), $e68ba20b3d2d159d$var$xt(window, "resize", this.onResize, !1), $e68ba20b3d2d159d$var$xt(window, "unload", this.onUnload, !1), $e68ba20b3d2d159d$var$xt(window, "blur", this.onBlur, !1), $e68ba20b3d2d159d$var$xt(this.excalidrawContainerRef.current, "wheel", this.handleWheel), $e68ba20b3d2d159d$var$xt(this.excalidrawContainerRef.current, "dragover", this.disableEvent, !1), $e68ba20b3d2d159d$var$xt(this.excalidrawContainerRef.current, "drop", this.disableEvent, !1)), this.props.detectScroll && this.onRemoveEventListenersEmitter.once($e68ba20b3d2d159d$var$xt($e68ba20b3d2d159d$var$Y0(this.excalidrawContainerRef.current), "scroll", this.onScroll)));
    }
    componentDidUpdate(t, r) {
        this.updateEmbeddables();
        let o = this.scene.getElementsIncludingDeleted(), n = this.scene.getElementsMapIncludingDeleted(), i = this.scene.getNonDeletedElementsMap();
        !this.state.showWelcomeScreen && !o.length && this.setState({
            showWelcomeScreen: !0
        }), t.UIOptions.dockedSidebarBreakpoint !== this.props.UIOptions.dockedSidebarBreakpoint && this.refreshEditorBreakpoints(), r.userToFollow && !this.state.collaborators.has(r.userToFollow.socketId) && this.maybeUnfollowRemoteUser(), (r.zoom.value !== this.state.zoom.value || r.scrollX !== this.state.scrollX || r.scrollY !== this.state.scrollY) && (this.props?.onScrollChange?.(this.state.scrollX, this.state.scrollY, this.state.zoom), this.onScrollChangeEmitter.trigger(this.state.scrollX, this.state.scrollY, this.state.zoom)), r.userToFollow !== this.state.userToFollow && (r.userToFollow && this.onUserFollowEmitter.trigger({
            userToFollow: r.userToFollow,
            action: "UNFOLLOW"
        }), this.state.userToFollow && this.onUserFollowEmitter.trigger({
            userToFollow: this.state.userToFollow,
            action: "FOLLOW"
        })), Object.keys(this.state.selectedElementIds).length && $e68ba20b3d2d159d$var$Jr(this.state) && this.setState({
            activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                type: "selection"
            })
        }), this.state.activeTool.type === "eraser" && r.theme !== this.state.theme && $e68ba20b3d2d159d$var$uf(this.interactiveCanvas, this.state.theme), r.activeTool.type === "selection" && this.state.activeTool.type !== "selection" && this.state.showHyperlinkPopup && this.setState({
            showHyperlinkPopup: !1
        }), t.langCode !== this.props.langCode && this.updateLanguage(), $e68ba20b3d2d159d$var$Jr(r) && !$e68ba20b3d2d159d$var$Jr(this.state) && this.eraserTrail.endPath(), t.viewModeEnabled !== this.props.viewModeEnabled && this.setState({
            viewModeEnabled: !!this.props.viewModeEnabled
        }), r.viewModeEnabled !== this.state.viewModeEnabled && (this.addEventListeners(), this.deselectElements()), t.zenModeEnabled !== this.props.zenModeEnabled && this.setState({
            zenModeEnabled: !!this.props.zenModeEnabled
        }), t.theme !== this.props.theme && this.props.theme && this.setState({
            theme: this.props.theme
        }), this.excalidrawContainerRef.current?.classList.toggle("theme--dark", this.state.theme === $e68ba20b3d2d159d$export$5714e40777c1bcc2.DARK), this.state.editingLinearElement && !this.state.selectedElementIds[this.state.editingLinearElement.elementId] && setTimeout(()=>{
            this.state.editingLinearElement && this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
        }), this.state.editingTextElement?.isDeleted && this.setState({
            editingTextElement: null
        }), this.state.selectedLinearElement && !this.state.selectedElementIds[this.state.selectedLinearElement.elementId] && this.setState({
            selectedLinearElement: null
        });
        let { multiElement: s } = r;
        r.activeTool !== this.state.activeTool && s != null && $e68ba20b3d2d159d$var$zn(this.state) && $e68ba20b3d2d159d$var$qr(s, !1) && $e68ba20b3d2d159d$var$jc(s, this.state, $e68ba20b3d2d159d$var$sr($e68ba20b3d2d159d$var$$.getPointAtIndexGlobalCoordinates(s, -1, i)), this.scene.getNonDeletedElementsMap(), this.scene.getNonDeletedElements()), this.store.commit(n, this.state), this.state.isLoading || (this.props.onChange?.(o, this.state, this.files), this.onChangeEmitter.trigger(o, this.state, this.files));
    }
    renderInteractiveSceneCallback = ({ atLeastOneVisibleElement: t, scrollBars: r, elementsMap: o })=>{
        r && ($e68ba20b3d2d159d$var$O1 = r);
        let n = this.state.editingTextElement ? !1 : !t && o.size > 0;
        this.state.scrolledOutside !== n && this.setState({
            scrolledOutside: n
        }), this.scheduleImageRefresh();
    };
    onScroll = $e68ba20b3d2d159d$var$si(()=>{
        let { offsetTop: t, offsetLeft: r } = this.getCanvasOffsets();
        this.setState((o)=>o.offsetLeft === r && o.offsetTop === t ? null : {
                offsetTop: t,
                offsetLeft: r
            });
    }, $e68ba20b3d2d159d$var$I0);
    onCut = $e68ba20b3d2d159d$var$Et((t)=>{
        !this.excalidrawContainerRef.current?.contains(document.activeElement) || $e68ba20b3d2d159d$var$Mn(t.target) || (this.actionManager.executeAction($e68ba20b3d2d159d$var$kh, "keyboard", t), t.preventDefault(), t.stopPropagation());
    });
    onCopy = $e68ba20b3d2d159d$var$Et((t)=>{
        !this.excalidrawContainerRef.current?.contains(document.activeElement) || $e68ba20b3d2d159d$var$Mn(t.target) || (this.actionManager.executeAction($e68ba20b3d2d159d$var$ec, "keyboard", t), t.preventDefault(), t.stopPropagation());
    });
    static resetTapTwice() {
        $e68ba20b3d2d159d$var$Em = !1;
    }
    onTouchStart = (t)=>{
        if ($e68ba20b3d2d159d$var$Lm && t.preventDefault(), !$e68ba20b3d2d159d$var$Em) {
            $e68ba20b3d2d159d$var$Em = !0, clearTimeout($e68ba20b3d2d159d$var$R1), $e68ba20b3d2d159d$var$R1 = window.setTimeout(e.resetTapTwice, $e68ba20b3d2d159d$var$T0);
            return;
        }
        if ($e68ba20b3d2d159d$var$Em && t.touches.length === 1) {
            let r = t.touches[0];
            this.handleCanvasDoubleClick({
                clientX: r.clientX,
                clientY: r.clientY
            }), $e68ba20b3d2d159d$var$Em = !1, clearTimeout($e68ba20b3d2d159d$var$R1);
        }
        t.touches.length === 2 && this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            activeEmbeddable: null
        });
    };
    onTouchEnd = (t)=>{
        this.resetContextMenuTimer(), t.touches.length > 0 ? this.setState({
            previousSelectedElementIds: {},
            selectedElementIds: $e68ba20b3d2d159d$var$Fe(this.state.previousSelectedElementIds, this.state)
        }) : $e68ba20b3d2d159d$var$Ve.pointers.clear();
    };
    pasteFromClipboard = $e68ba20b3d2d159d$var$Et(async (t)=>{
        let r = !!$e68ba20b3d2d159d$var$Wg, o = document.activeElement, n = this.excalidrawContainerRef.current?.contains(o);
        if (t && !n) return;
        let i = document.elementFromPoint(this.lastViewportPosition.x, this.lastViewportPosition.y);
        if (t && (!(i instanceof HTMLCanvasElement) || $e68ba20b3d2d159d$var$Mn(o))) return;
        let { x: a, y: s } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: this.lastViewportPosition.x,
            clientY: this.lastViewportPosition.y
        }, this.state), l = t?.clipboardData?.files[0], c = await $e68ba20b3d2d159d$var$Lu(t, r);
        if (!l && !r) {
            if (c.mixedContent) return this.addElementsFromMixedContentPaste(c.mixedContent, {
                isPlainPaste: r,
                sceneX: a,
                sceneY: s
            });
            if (c.text) {
                let d = c.text.trim();
                d.startsWith("<svg") && d.endsWith("</svg>") && (l = $e68ba20b3d2d159d$var$fE(d));
            }
        }
        if ($e68ba20b3d2d159d$var$ra(l) && !c.spreadsheet) {
            if (!this.isToolSupported("image")) {
                this.setState({
                    errorMessage: $e68ba20b3d2d159d$var$x("errors.imageToolNotSupported")
                });
                return;
            }
            let d = this.createImageElement({
                sceneX: a,
                sceneY: s
            });
            this.insertImageElement(d, l), this.initializeImageDimensions(d), this.setState({
                selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                    [d.id]: !0
                }, this.state)
            });
            return;
        }
        if (this.props.onPaste) try {
            if (await this.props.onPaste(c, t) === !1) return;
        } catch (d) {
            console.error(d);
        }
        if (c.errorMessage) this.setState({
            errorMessage: c.errorMessage
        });
        else if (c.spreadsheet && !r) this.setState({
            pasteDialog: {
                data: c.spreadsheet,
                shown: !0
            }
        });
        else if (c.elements) {
            let d = c.programmaticAPI ? $e68ba20b3d2d159d$export$586f70b13f801aaf(c.elements) : c.elements;
            this.addElementsFromPasteOrLibrary({
                elements: d,
                files: c.files || null,
                position: "cursor",
                retainSeed: r
            });
        } else if (c.text) {
            if (c.text && $e68ba20b3d2d159d$var$JA(c.text)) {
                let p = await (parcelRequire("f3nFz"));
                try {
                    let { elements: u, files: h } = await p.parseMermaidToExcalidraw(c.text), g = $e68ba20b3d2d159d$export$586f70b13f801aaf(u, {
                        regenerateIds: !0
                    });
                    this.addElementsFromPasteOrLibrary({
                        elements: g,
                        files: h,
                        position: "cursor"
                    });
                    return;
                } catch (u) {
                    console.warn(`parsing pasted text as mermaid definition failed: ${u.message}`);
                }
            }
            let d = $e68ba20b3d2d159d$var$Qm(c.text).split(/\n+/).map((p)=>p.trim()).filter(Boolean), m = d.map((p)=>$e68ba20b3d2d159d$var$mT(p)).filter((p)=>$e68ba20b3d2d159d$var$yl(p, this.props.validateEmbeddable) && (/^(http|https):\/\/[^\s/$.?#].[^\s]*$/.test(p) || $e68ba20b3d2d159d$var$bi(p)?.type === "video"));
            if (!$e68ba20b3d2d159d$var$Wg && m.length > 0 && m.length === d.length) {
                let p = [];
                for (let u of m){
                    let h = p[p.length - 1], g = this.insertEmbeddableElement({
                        sceneX: h ? h.x + h.width + 20 : a,
                        sceneY: s,
                        link: $e68ba20b3d2d159d$export$fc49cccc588ff0d4(u)
                    });
                    g && p.push(g);
                }
                p.length && this.setState({
                    selectedElementIds: Object.fromEntries(p.map((u)=>[
                            u.id,
                            !0
                        ]))
                });
                return;
            }
            this.addTextFromPaste(c.text, r);
        }
        this.setActiveTool({
            type: "selection"
        }), t?.preventDefault();
    });
    addElementsFromPasteOrLibrary = (t)=>{
        let r = $e68ba20b3d2d159d$export$bf29272de9e9a11(t.elements, null, void 0), [o, n, i, a] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(r), s = $e68ba20b3d2d159d$var$Wt(o, i) / 2, l = $e68ba20b3d2d159d$var$Wt(n, a) / 2, c = typeof t.position == "object" ? t.position.clientX : t.position === "cursor" ? this.lastViewportPosition.x : this.state.width / 2 + this.state.offsetLeft, d = typeof t.position == "object" ? t.position.clientY : t.position === "cursor" ? this.lastViewportPosition.y : this.state.height / 2 + this.state.offsetTop, { x: m, y: p } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: c,
            clientY: d
        }, this.state), u = m - s, h = p - l, [g, b] = $e68ba20b3d2d159d$var$Ot(u, h, this.getEffectiveGridSize()), v = $e68ba20b3d2d159d$var$du(r.map((C)=>$e68ba20b3d2d159d$export$5390fab1c98104d7(C, {
                x: C.x + g - o,
                y: C.y + b - n
            })), {
            randomizeSeed: !t.retainSeed
        }), w = [
            ...this.scene.getElementsIncludingDeleted(),
            ...v
        ];
        $e68ba20b3d2d159d$var$tr(w, $e68ba20b3d2d159d$var$j(v));
        let I = this.getTopLayerFrameAtSceneCoords({
            x: m,
            y: p
        });
        if (I) {
            let C = $e68ba20b3d2d159d$var$GT(v, I);
            $e68ba20b3d2d159d$var$Sd(w, C, I);
        }
        this.scene.replaceAllElements(w), v.forEach((C)=>{
            if ($e68ba20b3d2d159d$var$G(C) && $e68ba20b3d2d159d$var$Ge(C)) {
                let P = $e68ba20b3d2d159d$var$bt(C, this.scene.getElementsMapIncludingDeleted());
                $e68ba20b3d2d159d$var$gt(C, P, this.scene.getElementsMapIncludingDeleted());
            }
        }), t.files && (this.files = {
            ...this.files,
            ...t.files
        }), this.store.shouldCaptureIncrement();
        let M = $e68ba20b3d2d159d$var$Ts(v);
        this.setState({
            ...this.state,
            openSidebar: this.state.openSidebar && this.device.editor.canFitSidebar && $e68ba20b3d2d159d$var$br.get($e68ba20b3d2d159d$var$cm) ? this.state.openSidebar : null,
            ...$e68ba20b3d2d159d$var$mr({
                editingGroupId: null,
                selectedElementIds: M.reduce((C, P)=>($e68ba20b3d2d159d$var$Ge(P) || (C[P.id] = !0), C), {})
            }, this.scene.getNonDeletedElements(), this.state, this)
        }, ()=>{
            t.files && this.addNewImagesToImageCache();
        }), this.setActiveTool({
            type: "selection"
        }), t.fitToContent && this.scrollToContent(v, {
            fitToContent: !0
        });
    };
    async addElementsFromMixedContentPaste(t, { isPlainPaste: r, sceneX: o, sceneY: n }) {
        if (!r && t.some((i)=>i.type === "imageUrl") && this.isToolSupported("image")) {
            let i = t.filter((m)=>m.type === "imageUrl").map((m)=>m.value), a = await Promise.all(i.map(async (m)=>{
                try {
                    return {
                        file: await $e68ba20b3d2d159d$var$Iv(m)
                    };
                } catch (p) {
                    let u = p.message;
                    return p.cause === "FETCH_ERROR" ? u = $e68ba20b3d2d159d$var$x("errors.failedToFetchImage") : p.cause === "UNSUPPORTED" && (u = $e68ba20b3d2d159d$var$x("errors.unsupportedFileType")), {
                        errorMessage: u
                    };
                }
            })), s = n, l = !1, c = {};
            for (let m of a)if (m.file) {
                let p = this.createImageElement({
                    sceneX: o,
                    sceneY: s
                }), u = await this.insertImageElement(p, m.file);
                u && (l || (l = !0, s -= u.height / 2), $e68ba20b3d2d159d$export$55655e96a21bba2e(u, {
                    y: s
                }, !1), s = p.y + p.height + 25, c[p.id] = !0);
            }
            this.setState({
                selectedElementIds: $e68ba20b3d2d159d$var$Fe(c, this.state)
            });
            let d = a.find((m)=>!!m.errorMessage);
            d && d.errorMessage && this.setState({
                errorMessage: d.errorMessage
            });
        } else {
            let i = t.filter((a)=>a.type === "text");
            i.length && this.addTextFromPaste(i.map((a)=>a.value).join(`

`), r);
        }
    }
    addTextFromPaste(t, r = !1) {
        let { x: o, y: n } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: this.lastViewportPosition.x,
            clientY: this.lastViewportPosition.y
        }, this.state), i = {
            x: o,
            y: n,
            strokeColor: this.state.currentItemStrokeColor,
            backgroundColor: this.state.currentItemBackgroundColor,
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roundness: null,
            roughness: this.state.currentItemRoughness,
            opacity: this.state.currentItemOpacity,
            text: t,
            fontSize: this.state.currentItemFontSize,
            fontFamily: this.state.currentItemFontFamily,
            textAlign: $e68ba20b3d2d159d$var$An,
            verticalAlign: $e68ba20b3d2d159d$var$Oa,
            locked: !1
        }, a = $e68ba20b3d2d159d$var$ke({
            fontSize: i.fontSize,
            fontFamily: i.fontFamily
        }), s = $e68ba20b3d2d159d$var$Eo(i.fontFamily), [l, , c] = $e68ba20b3d2d159d$export$88b92c9ed786194d(this.state), d = Math.max(Math.min((c - l) * .5, 800), 200), m = 10, p = n, u = r ? [
            t
        ] : t.split(`
`), h = u.reduce((g, b, v)=>{
            let y = $e68ba20b3d2d159d$var$Gn(b).trim();
            if (y.length) {
                let w = this.getTopLayerFrameAtSceneCoords({
                    x: o,
                    y: p
                }), I = $e68ba20b3d2d159d$var$Xt(y, a, s), M = I.width > d, C = M ? $e68ba20b3d2d159d$var$Ro(y, a, d) : y;
                I = M ? $e68ba20b3d2d159d$var$Xt(C, a, s) : I;
                let P = o - I.width / 2, k = p - I.height / 2, _ = $e68ba20b3d2d159d$var$er({
                    ...i,
                    x: P,
                    y: k,
                    text: C,
                    originalText: y,
                    lineHeight: s,
                    autoResize: !M,
                    frameId: w ? w.id : null
                });
                g.push(_), p += _.height + m;
            } else u[v - 1]?.trim() && (p += $e68ba20b3d2d159d$var$oa(i.fontSize, s) + m);
            return g;
        }, []);
        h.length !== 0 && (this.scene.insertElements(h), this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe(Object.fromEntries(h.map((g)=>[
                    g.id,
                    !0
                ])), this.state)
        }), !r && h.length > 1 && $e68ba20b3d2d159d$var$n6 === !1 && !this.device.editor.isMobile && (this.setToast({
            message: $e68ba20b3d2d159d$var$x("toast.pasteAsSingleElement", {
                shortcut: $e68ba20b3d2d159d$var$O("CtrlOrCmd+Shift+V")
            }),
            duration: 5e3
        }), $e68ba20b3d2d159d$var$n6 = !0), this.store.shouldCaptureIncrement());
    }
    setAppState = (t, r)=>{
        this.setState(t, r);
    };
    removePointer = (t)=>{
        $e68ba20b3d2d159d$var$Aa && this.resetContextMenuTimer(), $e68ba20b3d2d159d$var$Ve.pointers.delete(t.pointerId);
    };
    toggleLock = (t = "ui")=>{
        this.state.activeTool.locked || $e68ba20b3d2d159d$var$Pe("toolbar", "toggleLock", `${t} (${this.device.editor.isMobile ? "mobile" : "desktop"})`), this.setState((r)=>({
                activeTool: {
                    ...r.activeTool,
                    ...$e68ba20b3d2d159d$var$it(this.state, r.activeTool.locked ? {
                        type: "selection"
                    } : r.activeTool),
                    locked: !r.activeTool.locked
                }
            }));
    };
    updateFrameRendering = (t)=>{
        this.setState((r)=>{
            let o = typeof t == "function" ? t(r.frameRendering) : t;
            return {
                frameRendering: {
                    enabled: o?.enabled ?? r.frameRendering.enabled,
                    clip: o?.clip ?? r.frameRendering.clip,
                    name: o?.name ?? r.frameRendering.name,
                    outline: o?.outline ?? r.frameRendering.outline
                }
            };
        });
    };
    togglePenMode = (t)=>{
        this.setState((r)=>({
                penMode: t ?? !r.penMode,
                penDetected: !0
            }));
    };
    onHandToolToggle = ()=>{
        this.actionManager.executeAction($e68ba20b3d2d159d$var$US);
    };
    zoomCanvas = (t)=>{
        this.setState({
            ...$e68ba20b3d2d159d$var$Ai({
                viewportX: this.state.width / 2 + this.state.offsetLeft,
                viewportY: this.state.height / 2 + this.state.offsetTop,
                nextZoom: $e68ba20b3d2d159d$var$to(t)
            }, this.state)
        });
    };
    cancelInProgressAnimation = null;
    scrollToContent = (t = this.scene.getNonDeletedElements(), r)=>{
        this.cancelInProgressAnimation?.();
        let o = Array.isArray(t) ? t : [
            t
        ], n = this.state.zoom, i = this.state.scrollX, a = this.state.scrollY;
        if (r?.fitToContent || r?.fitToViewport) {
            let { appState: s } = $e68ba20b3d2d159d$var$$d({
                targetElements: o,
                appState: this.state,
                fitToViewport: !!r?.fitToViewport,
                viewportZoomFactor: r?.viewportZoomFactor
            });
            n = s.zoom, i = s.scrollX, a = s.scrollY;
        } else {
            let s = $e68ba20b3d2d159d$var$Hn(o, this.state);
            i = s.scrollX, a = s.scrollY;
        }
        if (r?.animate) {
            let s = this.state.scrollX, l = this.state.scrollY, c = this.state.zoom.value, d = $e68ba20b3d2d159d$var$W0({
                fromValues: {
                    scrollX: s,
                    scrollY: l,
                    zoom: c
                },
                toValues: {
                    scrollX: i,
                    scrollY: a,
                    zoom: n.value
                },
                interpolateValue: (m, p, u, h)=>{
                    if (h === "zoom") return m * Math.pow(p / m, $e68ba20b3d2d159d$var$li(u));
                },
                onStep: ({ scrollX: m, scrollY: p, zoom: u })=>{
                    this.setState({
                        scrollX: m,
                        scrollY: p,
                        zoom: {
                            value: u
                        }
                    });
                },
                onStart: ()=>{
                    this.setState({
                        shouldCacheIgnoreZoom: !0
                    });
                },
                onEnd: ()=>{
                    this.setState({
                        shouldCacheIgnoreZoom: !1
                    });
                },
                onCancel: ()=>{
                    this.setState({
                        shouldCacheIgnoreZoom: !1
                    });
                },
                duration: r?.duration ?? 500
            });
            this.cancelInProgressAnimation = ()=>{
                d(), this.cancelInProgressAnimation = null;
            };
        } else this.setState({
            scrollX: i,
            scrollY: a,
            zoom: n
        });
    };
    maybeUnfollowRemoteUser = ()=>{
        this.state.userToFollow && this.setState({
            userToFollow: null
        });
    };
    translateCanvas = (t)=>{
        this.cancelInProgressAnimation?.(), this.maybeUnfollowRemoteUser(), this.setState(t);
    };
    setToast = (t)=>{
        this.setState({
            toast: t
        });
    };
    restoreFileFromShare = async ()=>{
        try {
            let t = await caches.open("web-share-target"), r = await t.match("shared-file");
            if (r) {
                let o = await r.blob(), n = new File([
                    o
                ], o.name || "", {
                    type: o.type
                });
                this.loadFileToCanvas(n, null), await t.delete("shared-file"), window.history.replaceState(null, $e68ba20b3d2d159d$var$Tc, window.location.pathname);
            }
        } catch (t) {
            this.setState({
                errorMessage: t.message
            });
        }
    };
    addFiles = $e68ba20b3d2d159d$var$Et((t)=>{
        let r = t.reduce((o, n)=>(o.set(n.id, n), o), new Map);
        this.files = {
            ...this.files,
            ...Object.fromEntries(r)
        }, this.scene.getNonDeletedElements().forEach((o)=>{
            $e68ba20b3d2d159d$var$Nr(o) && r.has(o.fileId) && (this.imageCache.delete(o.fileId), $e68ba20b3d2d159d$var$Oe.delete(o));
        }), this.scene.triggerUpdate(), this.addNewImagesToImageCache();
    });
    updateScene = $e68ba20b3d2d159d$var$Et((t)=>{
        let r = $e68ba20b3d2d159d$var$Cr(t.elements ?? []);
        if (t.storeAction && t.storeAction !== $e68ba20b3d2d159d$export$85f9bb8d5701581c.NONE) {
            let o = this.store.snapshot.appState, n = this.store.snapshot.elements, i = t.appState ? Object.assign({}, o, t.appState) : o, a = t.elements ? this.store.filterUncomittedElements(this.scene.getElementsMapIncludingDeleted(), $e68ba20b3d2d159d$var$j(r)) : n;
            t.storeAction === $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE ? this.store.captureIncrement(a, i) : t.storeAction === $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE && this.store.updateSnapshot(a, i);
        }
        t.appState && this.setState(t.appState), t.elements && this.scene.replaceAllElements(r), t.collaborators && this.setState({
            collaborators: t.collaborators
        });
    });
    triggerRender = (t)=>{
        t === !0 ? this.scene.triggerUpdate() : this.setState({});
    };
    toggleSidebar = ({ name: t, tab: r, force: o })=>{
        let n;
        o === void 0 ? n = this.state.openSidebar?.name === t && this.state.openSidebar?.tab === r ? null : t : n = o ? t : null;
        let i = n ? {
            name: n
        } : null;
        return i && r && (i.tab = r), this.setState({
            openSidebar: i
        }), !!n;
    };
    updateCurrentCursorPosition = $e68ba20b3d2d159d$var$Et((t)=>{
        this.lastViewportPosition.x = t.clientX, this.lastViewportPosition.y = t.clientY;
    });
    getEditorUIOffsets = ()=>{
        let t = this.excalidrawContainerRef?.current?.querySelector(".App-toolbar")?.getBoundingClientRect()?.bottom ?? 0, r = Math.max(this.excalidrawContainerRef?.current?.querySelector(".default-sidebar")?.getBoundingClientRect()?.width ?? 0), o = Math.max(this.excalidrawContainerRef?.current?.querySelector(".App-menu__left")?.getBoundingClientRect()?.width ?? 0, 0);
        return $e68ba20b3d2d159d$var$Sn().rtl ? {
            top: t,
            right: o,
            bottom: 0,
            left: r
        } : {
            top: t,
            right: r,
            bottom: 0,
            left: o
        };
    };
    onKeyDown = $e68ba20b3d2d159d$var$Et((t)=>{
        if ("Proxy" in window && (!t.shiftKey && /^[A-Z]$/.test(t.key) || t.shiftKey && /^[a-z]$/.test(t.key)) && (t = new Proxy(t, {
            get (i, a) {
                let s = i[a];
                return typeof s == "function" ? s.bind(i) : a === "key" ? t.shiftKey ? i.key.toUpperCase() : i.key.toLowerCase() : s;
            }
        })), !$e68ba20b3d2d159d$var$Xm(t.target)) {
            if (t.key === $e68ba20b3d2d159d$var$S.ESCAPE && this.flowChartCreator.isCreatingChart) {
                this.flowChartCreator.clear(), this.triggerRender(!0);
                return;
            }
            let i = $e68ba20b3d2d159d$var$rs(t.key);
            if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && i && !t.shiftKey) {
                t.preventDefault();
                let a = $e68ba20b3d2d159d$var$pe(this.scene.getNonDeletedElementsMap(), this.state);
                a.length === 1 && $e68ba20b3d2d159d$var$Ua(a[0]) && this.flowChartCreator.createNodes(a[0], this.scene.getNonDeletedElementsMap(), this.state, $e68ba20b3d2d159d$var$Yb(t.key)), this.flowChartCreator.pendingNodes?.length && !$e68ba20b3d2d159d$var$ju(this.flowChartCreator.pendingNodes, this.canvas.width / window.devicePixelRatio, this.canvas.height / window.devicePixelRatio, {
                    offsetLeft: this.state.offsetLeft,
                    offsetTop: this.state.offsetTop,
                    scrollX: this.state.scrollX,
                    scrollY: this.state.scrollY,
                    zoom: this.state.zoom
                }, this.scene.getNonDeletedElementsMap(), this.getEditorUIOffsets()) && this.scrollToContent(this.flowChartCreator.pendingNodes, {
                    animate: !0,
                    duration: 300,
                    fitToContent: !0,
                    viewportZoomFactor: .8
                });
                return;
            }
            if (t.altKey) {
                let a = $e68ba20b3d2d159d$var$pe(this.scene.getNonDeletedElementsMap(), this.state);
                if (a.length === 1 && i) {
                    t.preventDefault();
                    let s = this.flowChartNavigator.exploreByDirection(a[0], this.scene.getNonDeletedElementsMap(), $e68ba20b3d2d159d$var$Yb(t.key));
                    if (s) {
                        this.setState((c)=>({
                                selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                                    [s]: !0
                                }, c)
                            }));
                        let l = this.scene.getNonDeletedElementsMap().get(s);
                        l && !$e68ba20b3d2d159d$var$ju([
                            l
                        ], this.canvas.width / window.devicePixelRatio, this.canvas.height / window.devicePixelRatio, {
                            offsetLeft: this.state.offsetLeft,
                            offsetTop: this.state.offsetTop,
                            scrollX: this.state.scrollX,
                            scrollY: this.state.scrollY,
                            zoom: this.state.zoom
                        }, this.scene.getNonDeletedElementsMap(), this.getEditorUIOffsets()) && this.scrollToContent(l, {
                            animate: !0,
                            duration: 300
                        });
                    }
                    return;
                }
            }
        }
        if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && t.key === $e68ba20b3d2d159d$var$S.P && !t.shiftKey && !t.altKey) {
            this.setToast({
                message: $e68ba20b3d2d159d$var$x("commandPalette.shortcutHint", {
                    shortcut: $e68ba20b3d2d159d$var$zt("commandPalette")
                })
            }), t.preventDefault();
            return;
        }
        if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && t.key.toLowerCase() === $e68ba20b3d2d159d$var$S.V && ($e68ba20b3d2d159d$var$Wg = t.shiftKey, clearTimeout($e68ba20b3d2d159d$var$o6), $e68ba20b3d2d159d$var$o6 = window.setTimeout(()=>{
            $e68ba20b3d2d159d$var$Wg = !1;
        }, 100)), t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && $e68ba20b3d2d159d$var$Mn(t.target) && (t.code === $e68ba20b3d2d159d$var$Ae.MINUS || t.code === $e68ba20b3d2d159d$var$Ae.EQUAL)) {
            t.preventDefault();
            return;
        }
        if ($e68ba20b3d2d159d$var$Mn(t.target) && t.key !== $e68ba20b3d2d159d$var$S.ESCAPE || $e68ba20b3d2d159d$var$rs(t.key) && $e68ba20b3d2d159d$var$Xm(t.target)) return;
        if (t.key === $e68ba20b3d2d159d$var$S.QUESTION_MARK) {
            this.setState({
                openDialog: {
                    name: "help"
                }
            });
            return;
        } else if (t.key.toLowerCase() === $e68ba20b3d2d159d$var$S.E && t.shiftKey && t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) {
            t.preventDefault(), this.setState({
                openDialog: {
                    name: "imageExport"
                }
            });
            return;
        }
        if (t.key === $e68ba20b3d2d159d$var$S.PAGE_UP || t.key === $e68ba20b3d2d159d$var$S.PAGE_DOWN) {
            let i = (t.shiftKey ? this.state.width : this.state.height) / this.state.zoom.value;
            t.key === $e68ba20b3d2d159d$var$S.PAGE_DOWN && (i = -i), t.shiftKey ? this.translateCanvas((a)=>({
                    scrollX: a.scrollX + i
                })) : this.translateCanvas((a)=>({
                    scrollY: a.scrollY + i
                }));
        }
        if (this.actionManager.handleKeyDown(t) || this.state.viewModeEnabled) return;
        if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && this.state.isBindingEnabled && this.setState({
            isBindingEnabled: !1
        }), $e68ba20b3d2d159d$var$rs(t.key)) {
            let i = this.scene.getSelectedElements({
                selectedElementIds: this.state.selectedElementIds,
                includeBoundTextElement: !0,
                includeElementsInFrames: !0
            }), a = i.find($e68ba20b3d2d159d$var$ce), s = new Set;
            i.filter($e68ba20b3d2d159d$var$ce).filter((m)=>{
                let p = m.startBinding && !i.some((h)=>h.id === m.startBinding?.elementId), u = m.endBinding && !i.some((h)=>h.id === m.endBinding?.elementId);
                return p || u;
            }).forEach((m)=>s.add(m.id)), i = i.filter((m)=>!s.has(m.id));
            let l = this.getEffectiveGridSize() && (t.shiftKey ? $e68ba20b3d2d159d$var$Jg : this.getEffectiveGridSize()) || (t.shiftKey ? $e68ba20b3d2d159d$var$f0 : $e68ba20b3d2d159d$var$Jg), c = 0, d = 0;
            t.key === $e68ba20b3d2d159d$var$S.ARROW_LEFT ? c = -l : t.key === $e68ba20b3d2d159d$var$S.ARROW_RIGHT ? c = l : t.key === $e68ba20b3d2d159d$var$S.ARROW_UP ? d = -l : t.key === $e68ba20b3d2d159d$var$S.ARROW_DOWN && (d = l), i.forEach((m)=>{
                $e68ba20b3d2d159d$export$55655e96a21bba2e(m, {
                    x: m.x + c,
                    y: m.y + d
                }), $e68ba20b3d2d159d$var$Jt(m, this.scene.getNonDeletedElementsMap(), {
                    simultaneouslyUpdated: i
                });
            }), this.setState({
                suggestedBindings: $e68ba20b3d2d159d$var$jp(i.filter((m)=>m.id !== a?.id || l !== 0), this.scene.getNonDeletedElementsMap())
            }), t.preventDefault();
        } else if (t.key === $e68ba20b3d2d159d$var$S.ENTER) {
            let i = this.scene.getSelectedElements(this.state);
            if (i.length === 1) {
                let a = i[0];
                if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) $e68ba20b3d2d159d$export$5df2ebb939539835(a) && (!this.state.editingLinearElement || this.state.editingLinearElement.elementId !== i[0].id) && (this.store.shouldCaptureIncrement(), $e68ba20b3d2d159d$var$ce(a) || this.setState({
                    editingLinearElement: new $e68ba20b3d2d159d$var$$(a)
                }));
                else if ($e68ba20b3d2d159d$var$G(a) || $e68ba20b3d2d159d$var$T3(a)) {
                    let s;
                    $e68ba20b3d2d159d$var$G(a) || (s = a);
                    let l = $e68ba20b3d2d159d$var$$u(a, this.state, this.scene.getNonDeletedElementsMap()), c = l.x, d = l.y;
                    this.startTextEditing({
                        sceneX: c,
                        sceneY: d,
                        container: s
                    }), t.preventDefault();
                    return;
                } else $e68ba20b3d2d159d$var$re(a) && this.setState({
                    editingFrame: a.id
                });
            }
        } else if (!t.ctrlKey && !t.altKey && !t.metaKey && !this.state.newElement && !this.state.selectionElement && !this.state.selectedElementsAreBeingDragged) {
            let i = $e68ba20b3d2d159d$var$j2(t.key);
            i ? (this.state.activeTool.type !== i && $e68ba20b3d2d159d$var$Pe("toolbar", i, `keyboard (${this.device.editor.isMobile ? "mobile" : "desktop"})`), i === "arrow" && this.state.activeTool.type === "arrow" && this.setState((a)=>({
                    currentItemArrowType: a.currentItemArrowType === $e68ba20b3d2d159d$var$_t.sharp ? $e68ba20b3d2d159d$var$_t.round : a.currentItemArrowType === $e68ba20b3d2d159d$var$_t.round ? $e68ba20b3d2d159d$var$_t.elbow : $e68ba20b3d2d159d$var$_t.sharp
                })), this.setActiveTool({
                type: i
            }), t.stopPropagation()) : t.key === $e68ba20b3d2d159d$var$S.Q && (this.toggleLock("keyboard"), t.stopPropagation());
        }
        if (t.key === $e68ba20b3d2d159d$var$S.SPACE && $e68ba20b3d2d159d$var$Ve.pointers.size === 0 && ($e68ba20b3d2d159d$var$Fs = !0, $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB), t.preventDefault()), (t.key === $e68ba20b3d2d159d$var$S.G || t.key === $e68ba20b3d2d159d$var$S.S) && !t.altKey && !t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) {
            let i = this.scene.getSelectedElements(this.state);
            if (this.state.activeTool.type === "selection" && !i.length) return;
            t.key === $e68ba20b3d2d159d$var$S.G && ($e68ba20b3d2d159d$var$Ti(this.state.activeTool.type) || i.some((a)=>$e68ba20b3d2d159d$var$Ti(a.type))) && (this.setState({
                openPopup: "elementBackground"
            }), t.stopPropagation()), t.key === $e68ba20b3d2d159d$var$S.S && (this.setState({
                openPopup: "elementStroke"
            }), t.stopPropagation());
        }
        if (!t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && t.shiftKey && t.key.toLowerCase() === $e68ba20b3d2d159d$var$S.F) {
            let i = this.scene.getSelectedElements(this.state);
            if (this.state.activeTool.type === "selection" && !i.length) return;
            (this.state.activeTool.type === "text" || i.find((a)=>$e68ba20b3d2d159d$var$G(a) || $e68ba20b3d2d159d$var$te(a, this.scene.getNonDeletedElementsMap()))) && (t.preventDefault(), this.setState({
                openPopup: "fontFamily"
            }));
        }
        if (t.key === $e68ba20b3d2d159d$var$S.K && !t.altKey && !t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) {
            this.state.activeTool.type === "laser" ? this.setActiveTool({
                type: "selection"
            }) : this.setActiveTool({
                type: "laser"
            });
            return;
        }
        t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && (t.key === $e68ba20b3d2d159d$var$S.BACKSPACE || t.key === $e68ba20b3d2d159d$var$S.DELETE) && $e68ba20b3d2d159d$var$br.set($e68ba20b3d2d159d$var$Ds, "clearCanvas");
        let r = t.key.toLocaleLowerCase(), o = r === $e68ba20b3d2d159d$var$S.S && t.shiftKey, n = t.key === $e68ba20b3d2d159d$var$S.I || r === $e68ba20b3d2d159d$var$S.G && t.shiftKey;
        (o || n) && this.openEyeDropper({
            type: o ? "stroke" : "background"
        });
    });
    onWheel = $e68ba20b3d2d159d$var$Et((t)=>{
        !(t.target instanceof HTMLCanvasElement) && t.ctrlKey && t.preventDefault();
    });
    onKeyUp = $e68ba20b3d2d159d$var$Et((t)=>{
        if (t.key === $e68ba20b3d2d159d$var$S.SPACE && (this.state.viewModeEnabled ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB) : this.state.activeTool.type === "selection" ? $e68ba20b3d2d159d$var$uo(this.interactiveCanvas) : ($e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state), this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            selectedGroupIds: {},
            editingGroupId: null,
            activeEmbeddable: null
        })), $e68ba20b3d2d159d$var$Fs = !1), !t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !this.state.isBindingEnabled && this.setState({
            isBindingEnabled: !0
        }), $e68ba20b3d2d159d$var$rs(t.key) && ($e68ba20b3d2d159d$var$ss(this.scene.getSelectedElements(this.state).filter($e68ba20b3d2d159d$export$5df2ebb939539835), this.scene.getNonDeletedElementsMap(), this.scene.getNonDeletedElements(), this.scene, $e68ba20b3d2d159d$var$zn(this.state), this.state.selectedLinearElement?.selectedPointsIndices ?? []), this.setState({
            suggestedBindings: []
        })), t.altKey || this.flowChartNavigator.isExploring && (this.flowChartNavigator.clear(), this.syncActionResult({
            storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
        })), !t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && this.flowChartCreator.isCreatingChart) {
            this.flowChartCreator.pendingNodes?.length && this.scene.insertElements(this.flowChartCreator.pendingNodes);
            let r = this.flowChartCreator.pendingNodes?.[0];
            r && (this.setState((o)=>({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        [r.id]: !0
                    }, o)
                })), $e68ba20b3d2d159d$var$ju([
                r
            ], this.canvas.width / window.devicePixelRatio, this.canvas.height / window.devicePixelRatio, {
                offsetLeft: this.state.offsetLeft,
                offsetTop: this.state.offsetTop,
                scrollX: this.state.scrollX,
                scrollY: this.state.scrollY,
                zoom: this.state.zoom
            }, this.scene.getNonDeletedElementsMap(), this.getEditorUIOffsets()) || this.scrollToContent(r, {
                animate: !0,
                duration: 300
            })), this.flowChartCreator.clear(), this.syncActionResult({
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            });
        }
    });
    isToolSupported = (t)=>this.props.UIOptions.tools?.[t] !== !1;
    setActiveTool = (t)=>{
        if (!this.isToolSupported(t.type)) {
            console.warn(`"${t.type}" tool is disabled via "UIOptions.canvasActions.tools.${t.type}"`);
            return;
        }
        let r = $e68ba20b3d2d159d$var$it(this.state, t);
        r.type === "hand" ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB) : $e68ba20b3d2d159d$var$Fs || $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state), $e68ba20b3d2d159d$var$U0(document.activeElement) && this.focusContainer(), $e68ba20b3d2d159d$var$_c(r.type) || this.setState({
            suggestedBindings: []
        }), r.type === "image" && this.onImageAction({
            insertOnCanvasDirectly: (t.type === "image" && t.insertOnCanvasDirectly) ?? !1
        }), this.setState((o)=>{
            let n = {
                snapLines: o.snapLines.length ? [] : o.snapLines,
                originSnapOffset: null,
                activeEmbeddable: null
            };
            return r.type === "freedraw" && this.store.shouldCaptureIncrement(), r.type !== "selection" ? {
                ...o,
                activeTool: r,
                selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, o),
                selectedGroupIds: $e68ba20b3d2d159d$var$Fe({}, o),
                editingGroupId: null,
                multiElement: null,
                ...n
            } : {
                ...o,
                activeTool: r,
                ...n
            };
        });
    };
    setOpenDialog = (t)=>{
        this.setState({
            openDialog: t
        });
    };
    setCursor = (t)=>{
        $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, t);
    };
    resetCursor = ()=>{
        $e68ba20b3d2d159d$var$uo(this.interactiveCanvas);
    };
    isTouchScreenMultiTouchGesture = ()=>$e68ba20b3d2d159d$var$Ve.pointers.size >= 2;
    getName = ()=>this.state.name || this.props.name || `${$e68ba20b3d2d159d$var$x("labels.untitled")}-${$e68ba20b3d2d159d$var$af()}`;
    onGestureStart = $e68ba20b3d2d159d$var$Et((t)=>{
        t.preventDefault(), this.isTouchScreenMultiTouchGesture() && this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            activeEmbeddable: null
        }), $e68ba20b3d2d159d$var$Ve.initialScale = this.state.zoom.value;
    });
    onGestureChange = $e68ba20b3d2d159d$var$Et((t)=>{
        if (t.preventDefault(), this.isTouchScreenMultiTouchGesture()) return;
        let r = $e68ba20b3d2d159d$var$Ve.initialScale;
        r && this.setState((o)=>({
                ...$e68ba20b3d2d159d$var$Ai({
                    viewportX: this.lastViewportPosition.x,
                    viewportY: this.lastViewportPosition.y,
                    nextZoom: $e68ba20b3d2d159d$var$to(r * t.scale)
                }, o)
            }));
    });
    onGestureEnd = $e68ba20b3d2d159d$var$Et((t)=>{
        t.preventDefault(), this.isTouchScreenMultiTouchGesture() && this.setState({
            previousSelectedElementIds: {},
            selectedElementIds: $e68ba20b3d2d159d$var$Fe(this.state.previousSelectedElementIds, this.state)
        }), $e68ba20b3d2d159d$var$Ve.initialScale = null;
    });
    handleTextWysiwyg(t, { isExistingElement: r = !1 }) {
        let o = this.scene.getElementsMapIncludingDeleted(), n = (i, a)=>{
            this.scene.replaceAllElements([
                ...this.scene.getElementsIncludingDeleted().map((s)=>s.id === t.id && $e68ba20b3d2d159d$var$G(s) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(s, {
                        originalText: i,
                        isDeleted: a ?? s.isDeleted,
                        ...$e68ba20b3d2d159d$var$td(s, $e68ba20b3d2d159d$var$bt(s, o), o, i)
                    }) : s)
            ]);
        };
        $e68ba20b3d2d159d$var$jA({
            id: t.id,
            canvas: this.canvas,
            getViewportCoords: (i, a)=>{
                let { x: s, y: l } = $e68ba20b3d2d159d$export$a4a3582487786f33({
                    sceneX: i,
                    sceneY: a
                }, this.state);
                return [
                    s - this.state.offsetLeft,
                    l - this.state.offsetTop
                ];
            },
            onChange: $e68ba20b3d2d159d$var$Et((i)=>{
                n(i, !1), $e68ba20b3d2d159d$var$_d(t) && $e68ba20b3d2d159d$var$Jt(t, this.scene.getNonDeletedElementsMap());
            }),
            onSubmit: $e68ba20b3d2d159d$var$Et(({ viaKeyboard: i, nextOriginalText: a })=>{
                let s = !a.trim();
                if (n(a, s), !s && i) {
                    let l = t.containerId ? t.containerId : t.id;
                    (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                        this.setState((c)=>({
                                selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                                    ...c.selectedElementIds,
                                    [l]: !0
                                }, c)
                            }));
                    });
                }
                s && $e68ba20b3d2d159d$var$Jp(this.scene.getNonDeletedElements(), [
                    t
                ]), (!s || r) && this.store.shouldCaptureIncrement(), this.setState({
                    newElement: null,
                    editingTextElement: null
                }), this.state.activeTool.locked && $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state), this.focusContainer();
            }),
            element: t,
            excalidrawContainer: this.excalidrawContainerRef.current,
            app: this,
            autoSelect: !this.device.isTouchScreen
        }), this.deselectElements(), n(t.originalText, !1);
    }
    deselectElements() {
        this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            selectedGroupIds: {},
            editingGroupId: null,
            activeEmbeddable: null
        });
    }
    getTextElementAtPosition(t, r) {
        let o = this.getElementAtPosition(t, r, {
            includeBoundTextElement: !0
        });
        return o && $e68ba20b3d2d159d$var$G(o) && !o.isDeleted ? o : null;
    }
    getElementAtPosition(t, r, o) {
        let n = this.getElementsAtPosition(t, r, o?.includeBoundTextElement, o?.includeLockedElements);
        if (n.length > 1) {
            if (o?.preferSelected) {
                for(let a = n.length - 1; a > -1; a--)if (this.state.selectedElementIds[n[a].id]) return n[a];
            }
            let i = n[n.length - 1];
            return $e68ba20b3d2d159d$var$ns({
                x: t,
                y: r,
                element: i,
                shape: $e68ba20b3d2d159d$var$sn(i, this.scene.getNonDeletedElementsMap()),
                threshold: this.getElementHitThreshold() / 2,
                frameNameBound: $e68ba20b3d2d159d$var$re(i) ? this.frameNameBoundsCache.get(i) : null
            }) ? i : n[n.length - 2];
        }
        return n.length === 1 ? n[0] : null;
    }
    getElementsAtPosition(t, r, o = !1, n = !1) {
        let i = [], a = this.scene.getNonDeletedElementsMap();
        return (o && n ? this.scene.getNonDeletedElements() : this.scene.getNonDeletedElements().filter((l)=>(n || !l.locked) && (o || !($e68ba20b3d2d159d$var$G(l) && l.containerId)))).filter((l)=>this.hitElement(t, r, l)).filter((l)=>{
            let c = $e68ba20b3d2d159d$var$rr(l, a);
            return c && this.state.frameRendering.enabled && this.state.frameRendering.clip ? $e68ba20b3d2d159d$var$NE({
                x: t,
                y: r
            }, c, a) : !0;
        }).filter((l)=>$e68ba20b3d2d159d$var$Mo(l) ? (i.push(l), !1) : !0).concat(i);
    }
    getElementHitThreshold() {
        return $e68ba20b3d2d159d$var$x0 / this.state.zoom.value;
    }
    hitElement(t, r, o, n = !0) {
        if (n && this.state.selectedElementIds[o.id] && $e68ba20b3d2d159d$var$Qu([
            o
        ], this.state)) {
            let a = $e68ba20b3d2d159d$var$W2(o, this.scene.getNonDeletedElementsMap(), this.getElementHitThreshold());
            return $e68ba20b3d2d159d$var$ml([
                t,
                r
            ], a);
        }
        return $e68ba20b3d2d159d$var$tE(t, r, $e68ba20b3d2d159d$var$Gp(o, this.scene.getNonDeletedElementsMap())) ? !0 : $e68ba20b3d2d159d$var$ns({
            x: t,
            y: r,
            element: o,
            shape: $e68ba20b3d2d159d$var$sn(o, this.scene.getNonDeletedElementsMap()),
            threshold: this.getElementHitThreshold(),
            frameNameBound: $e68ba20b3d2d159d$var$re(o) ? this.frameNameBoundsCache.get(o) : null
        });
    }
    getTextBindableContainerAtPosition(t, r) {
        let o = this.scene.getNonDeletedElements(), n = this.scene.getSelectedElements(this.state);
        if (n.length === 1) return $e68ba20b3d2d159d$var$Dn(n[0], !1) ? n[0] : null;
        let i = null;
        for(let a = o.length - 1; a >= 0; --a){
            if (o[a].isDeleted) continue;
            let [s, l, c, d] = $e68ba20b3d2d159d$var$ae(o[a], this.scene.getNonDeletedElementsMap());
            if ($e68ba20b3d2d159d$var$ie(o[a]) && $e68ba20b3d2d159d$var$ns({
                x: t,
                y: r,
                element: o[a],
                shape: $e68ba20b3d2d159d$var$sn(o[a], this.scene.getNonDeletedElementsMap()),
                threshold: this.getElementHitThreshold()
            })) {
                i = o[a];
                break;
            } else if (s < t && t < c && l < r && r < d) {
                i = o[a];
                break;
            }
        }
        return $e68ba20b3d2d159d$var$Dn(i, !1) ? i : null;
    }
    startTextEditing = ({ sceneX: t, sceneY: r, insertAtParentCenter: o = !0, container: n, autoEdit: i = !0 })=>{
        let a = !1, s = o && this.getTextWysiwygSnappedToCenterPosition(t, r, this.state, n);
        n && s && ($e68ba20b3d2d159d$var$te(n, this.scene.getNonDeletedElementsMap()) || (a = !0));
        let l = null, c = this.scene.getSelectedElements(this.state);
        c.length === 1 ? $e68ba20b3d2d159d$var$G(c[0]) ? l = c[0] : n ? l = $e68ba20b3d2d159d$var$te(c[0], this.scene.getNonDeletedElementsMap()) : l = this.getTextElementAtPosition(t, r) : l = this.getTextElementAtPosition(t, r);
        let d = l?.fontFamily || this.state.currentItemFontFamily, m = l?.lineHeight || $e68ba20b3d2d159d$var$Eo(d), p = this.state.currentItemFontSize;
        if (!l && a && n && !$e68ba20b3d2d159d$var$ie(n)) {
            let b = $e68ba20b3d2d159d$var$Hl($e68ba20b3d2d159d$var$ke({
                fontSize: p,
                fontFamily: d
            }), m), v = $e68ba20b3d2d159d$var$zl(p, m), y = Math.max(n.height, v), w = Math.max(n.width, b);
            $e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
                height: y,
                width: w
            }), t = n.x + w / 2, r = n.y + y / 2, s && (s = this.getTextWysiwygSnappedToCenterPosition(t, r, this.state, n));
        }
        let u = this.getTopLayerFrameAtSceneCoords({
            x: t,
            y: r
        }), h = l || $e68ba20b3d2d159d$var$er({
            x: s ? s.elementCenterX : t,
            y: s ? s.elementCenterY : r,
            strokeColor: this.state.currentItemStrokeColor,
            backgroundColor: this.state.currentItemBackgroundColor,
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            opacity: this.state.currentItemOpacity,
            text: "",
            fontSize: p,
            fontFamily: d,
            textAlign: s ? "center" : this.state.currentItemTextAlign,
            verticalAlign: s ? $e68ba20b3d2d159d$var$Pt.MIDDLE : $e68ba20b3d2d159d$var$Oa,
            containerId: a ? n?.id : void 0,
            groupIds: n?.groupIds ?? [],
            lineHeight: m,
            angle: n?.angle ?? 0,
            frameId: u ? u.id : null
        });
        if (!l && a && n && $e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
            boundElements: (n.boundElements || []).concat({
                type: "text",
                id: h.id
            })
        }), this.setState({
            editingTextElement: h
        }), !l) {
            if (n && a) {
                let g = this.scene.getElementIndex(n.id);
                this.scene.insertElementAtIndex(h, g + 1);
            } else this.scene.insertElement(h);
        }
        i || l || n ? this.handleTextWysiwyg(h, {
            isExistingElement: !!l
        }) : this.setState({
            newElement: h,
            multiElement: null
        });
    };
    handleCanvasDoubleClick = (t)=>{
        if (this.state.multiElement || this.state.activeTool.type !== "selection") return;
        let r = this.scene.getSelectedElements(this.state);
        if (r.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(r[0]) && t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && (!this.state.editingLinearElement || this.state.editingLinearElement.elementId !== r[0].id) && !$e68ba20b3d2d159d$var$ce(r[0])) {
            this.store.shouldCaptureIncrement(), this.setState({
                editingLinearElement: new $e68ba20b3d2d159d$var$$(r[0])
            });
            return;
        }
        $e68ba20b3d2d159d$var$uo(this.interactiveCanvas);
        let { x: o, y: n } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state);
        if ($e68ba20b3d2d159d$var$Qo(this.state).length > 0) {
            let a = this.getElementAtPosition(o, n), s = a && $e68ba20b3d2d159d$var$dy(a, this.state.selectedGroupIds);
            if (s) {
                this.store.shouldCaptureIncrement(), this.setState((l)=>({
                        ...l,
                        ...$e68ba20b3d2d159d$var$mr({
                            editingGroupId: s,
                            selectedElementIds: {
                                [a.id]: !0
                            }
                        }, this.scene.getNonDeletedElements(), l, this)
                    }));
                return;
            }
        }
        if ($e68ba20b3d2d159d$var$uo(this.interactiveCanvas), !t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] && !this.state.viewModeEnabled) {
            let a = this.getElementAtPosition(o, n);
            if ($e68ba20b3d2d159d$var$cr(a)) {
                this.setState({
                    activeEmbeddable: {
                        element: a,
                        state: "active"
                    }
                });
                return;
            }
            let s = this.getTextBindableContainerAtPosition(o, n);
            if (s && ($e68ba20b3d2d159d$var$It(s) || !$e68ba20b3d2d159d$var$Rr(s.backgroundColor) || $e68ba20b3d2d159d$var$ns({
                x: o,
                y: n,
                element: s,
                shape: $e68ba20b3d2d159d$var$sn(s, this.scene.getNonDeletedElementsMap()),
                threshold: this.getElementHitThreshold()
            }))) {
                let l = $e68ba20b3d2d159d$var$$u(s, this.state, this.scene.getNonDeletedElementsMap());
                o = l.x, n = l.y;
            }
            this.startTextEditing({
                sceneX: o,
                sceneY: n,
                insertAtParentCenter: !t.altKey,
                container: s
            });
        }
    };
    getElementLinkAtPosition = (t, r)=>{
        let o = this.scene.getNonDeletedElements().slice().reverse(), n = 1 / 0;
        return o.find((i, a)=>(r && i.id === r.id && (n = a), i.link && a <= n && $e68ba20b3d2d159d$var$bu(i, this.scene.getNonDeletedElementsMap(), this.state, [
                t.x,
                t.y
            ], this.device.editor.isMobile)));
    };
    redirectToLink = (t, r)=>{
        let o = $e68ba20b3d2d159d$var$Lt(this.lastPointerDownEvent.clientX, this.lastPointerDownEvent.clientY, this.lastPointerUpEvent.clientX, this.lastPointerUpEvent.clientY);
        if (!this.hitLinkElement || r && o > $e68ba20b3d2d159d$var$ii || !r && o !== 0) return;
        let n = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(this.lastPointerDownEvent, this.state), i = this.scene.getNonDeletedElementsMap(), a = $e68ba20b3d2d159d$var$bu(this.hitLinkElement, i, this.state, [
            n.x,
            n.y
        ], this.device.editor.isMobile), s = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(this.lastPointerUpEvent, this.state), l = $e68ba20b3d2d159d$var$bu(this.hitLinkElement, i, this.state, [
            s.x,
            s.y
        ], this.device.editor.isMobile);
        if (a && l) {
            let c = this.hitLinkElement.link;
            if (c) {
                c = $e68ba20b3d2d159d$export$fc49cccc588ff0d4(c);
                let d;
                if (this.props.onLinkOpen && (d = $e68ba20b3d2d159d$var$jm("excalidraw-link", t.nativeEvent), this.props.onLinkOpen({
                    ...this.hitLinkElement,
                    link: c
                }, d)), !d?.defaultPrevented) {
                    let m = $e68ba20b3d2d159d$var$sp(c) ? "_self" : "_blank", p = window.open(void 0, m);
                    p && (p.opener = null, p.location = c);
                }
            }
        }
    };
    getTopLayerFrameAtSceneCoords = (t)=>{
        let r = this.scene.getNonDeletedElementsMap(), o = this.scene.getNonDeletedFramesLikes().filter((n)=>$e68ba20b3d2d159d$var$NE(t, n, r));
        return o.length ? o[o.length - 1] : null;
    };
    handleCanvasPointerMove = (t)=>{
        this.savePointer(t.clientX, t.clientY, this.state.cursorButton), this.lastPointerMoveEvent = t.nativeEvent, $e68ba20b3d2d159d$var$Ve.pointers.has(t.pointerId) && $e68ba20b3d2d159d$var$Ve.pointers.set(t.pointerId, {
            x: t.clientX,
            y: t.clientY
        });
        let r = $e68ba20b3d2d159d$var$Ve.initialScale;
        if ($e68ba20b3d2d159d$var$Ve.pointers.size === 2 && $e68ba20b3d2d159d$var$Ve.lastCenter && r && $e68ba20b3d2d159d$var$Ve.initialDistance) {
            let p = $e68ba20b3d2d159d$var$Hb($e68ba20b3d2d159d$var$Ve.pointers), u = p.x - $e68ba20b3d2d159d$var$Ve.lastCenter.x, h = p.y - $e68ba20b3d2d159d$var$Ve.lastCenter.y;
            $e68ba20b3d2d159d$var$Ve.lastCenter = p;
            let g = $e68ba20b3d2d159d$var$Ub(Array.from($e68ba20b3d2d159d$var$Ve.pointers.values())), b = this.state.activeTool.type === "freedraw" && this.state.penMode ? 1 : g / $e68ba20b3d2d159d$var$Ve.initialDistance, v = b ? $e68ba20b3d2d159d$var$to(r * b) : this.state.zoom.value;
            this.setState((y)=>{
                let w = $e68ba20b3d2d159d$var$Ai({
                    viewportX: p.x,
                    viewportY: p.y,
                    nextZoom: v
                }, y);
                this.translateCanvas({
                    zoom: w.zoom,
                    scrollX: w.scrollX + 2 * (u / v),
                    scrollY: w.scrollY + 2 * (h / v),
                    shouldCacheIgnoreZoom: !0
                });
            }), this.resetShouldCacheIgnoreZoomDebounced();
        } else $e68ba20b3d2d159d$var$Ve.lastCenter = $e68ba20b3d2d159d$var$Ve.initialDistance = $e68ba20b3d2d159d$var$Ve.initialScale = null;
        if ($e68ba20b3d2d159d$var$Fs || $e68ba20b3d2d159d$var$xm || $e68ba20b3d2d159d$var$N1 || $e68ba20b3d2d159d$var$Jo(this.state)) return;
        let n = $e68ba20b3d2d159d$var$Kb($e68ba20b3d2d159d$var$O1, t.clientX - this.state.offsetLeft, t.clientY - this.state.offsetTop).isOverEither;
        !this.state.newElement && !this.state.selectionElement && !this.state.selectedElementsAreBeingDragged && !this.state.multiElement && (n ? $e68ba20b3d2d159d$var$uo(this.interactiveCanvas) : $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state));
        let i = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state), { x: a, y: s } = i;
        if (!this.state.newElement && $e68ba20b3d2d159d$var$HC(this.state.activeTool.type)) {
            let { originOffset: p, snapLines: u } = $e68ba20b3d2d159d$var$zC(this.scene.getNonDeletedElements(), this, {
                x: a,
                y: s
            }, t, this.scene.getNonDeletedElementsMap());
            this.setState((h)=>{
                let g = $e68ba20b3d2d159d$var$Jm(h.snapLines, u), b = h.originSnapOffset ? $e68ba20b3d2d159d$var$Jm(h.originSnapOffset, p) : p;
                return h.snapLines === g && h.originSnapOffset === b ? null : {
                    snapLines: g,
                    originSnapOffset: b
                };
            });
        } else !this.state.newElement && !this.state.selectedElementsAreBeingDragged && !this.state.selectionElement && this.setState((p)=>p.snapLines.length ? {
                snapLines: []
            } : null);
        if (this.state.editingLinearElement && !this.state.editingLinearElement.isDragging) {
            let p = $e68ba20b3d2d159d$var$$.handlePointerMove(t, a, s, this, this.scene.getNonDeletedElementsMap());
            p && p !== this.state.editingLinearElement && (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                this.setState({
                    editingLinearElement: p
                });
            }), p?.lastUncommittedPoint != null ? this.maybeSuggestBindingAtCursor(i) : (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                this.setState({
                    suggestedBindings: []
                });
            });
        }
        if ($e68ba20b3d2d159d$var$cf(this.state.activeTool.type)) {
            let { newElement: p } = this.state;
            $e68ba20b3d2d159d$var$qr(p, !1) ? this.maybeSuggestBindingsForLinearElementAtCoords(p, [
                i
            ], this.state.startBoundElement) : this.maybeSuggestBindingAtCursor(i);
        }
        if (this.state.multiElement) {
            let { multiElement: p } = this.state, { x: u, y: h } = p, { points: g, lastCommittedPoint: b } = p, v = g[g.length - 1];
            if ($e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state), v === b) $e68ba20b3d2d159d$var$Lt(a - u, s - h, v[0], v[1]) >= $e68ba20b3d2d159d$var$Ws ? $e68ba20b3d2d159d$export$55655e96a21bba2e(p, {
                points: [
                    ...g,
                    [
                        a - u,
                        s - h
                    ]
                ]
            }, !1) : $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER);
            else if (g.length > 2 && b && $e68ba20b3d2d159d$var$Lt(a - u, s - h, b[0], b[1]) < $e68ba20b3d2d159d$var$Ws) $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER), $e68ba20b3d2d159d$export$55655e96a21bba2e(p, {
                points: g.slice(0, -1)
            }, !1);
            else {
                let [y, w] = $e68ba20b3d2d159d$var$Ot(a, s, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || $e68ba20b3d2d159d$var$ce(p) ? null : this.getEffectiveGridSize()), [I, M] = p?.lastCommittedPoint ?? [
                    0,
                    0
                ], C = y - u - I, P = w - h - M;
                $e68ba20b3d2d159d$var$os(t) && ({ width: C, height: P } = $e68ba20b3d2d159d$var$Fl(I + u, M + h, y, w)), $e68ba20b3d2d159d$var$Br(g, this.state.zoom.value) && $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER), $e68ba20b3d2d159d$var$ce(p) ? $e68ba20b3d2d159d$var$Fo(p, this.scene.getNonDeletedElementsMap(), [
                    ...g.slice(0, -1),
                    [
                        I + C,
                        M + P
                    ]
                ], void 0, void 0, {
                    isDragging: !0,
                    informMutation: !1
                }) : $e68ba20b3d2d159d$export$55655e96a21bba2e(p, {
                    points: [
                        ...g.slice(0, -1),
                        [
                            I + C,
                            M + P
                        ]
                    ]
                }, !1), this.triggerRender(!1);
            }
            return;
        }
        if (!!t.buttons || this.state.activeTool.type !== "selection" && this.state.activeTool.type !== "text" && this.state.activeTool.type !== "eraser") return;
        let c = this.scene.getNonDeletedElements(), d = this.scene.getSelectedElements(this.state);
        if (d.length === 1 && !n && !this.state.editingLinearElement) {
            if (this.state.selectedLinearElement && this.handleHoverSelectedLinearElement(this.state.selectedLinearElement, a, s), (!this.state.selectedLinearElement || this.state.selectedLinearElement.hoverPointIndex === -1) && !(d.length === 1 && $e68ba20b3d2d159d$var$ce(d[0]))) {
                let p = $e68ba20b3d2d159d$var$eh(c, this.state, a, s, this.state.zoom, t.pointerType, this.scene.getNonDeletedElementsMap(), this.device);
                if (p && p.transformHandleType) {
                    $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$rh(p));
                    return;
                }
            }
        } else if (d.length > 1 && !n) {
            let p = $e68ba20b3d2d159d$var$th($e68ba20b3d2d159d$export$3e54c0515ef60d1d(d), a, s, this.state.zoom, t.pointerType, this.device);
            if (p) {
                $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$rh({
                    transformHandleType: p
                }));
                return;
            }
        }
        let m = this.getElementAtPosition(i.x, i.y);
        this.hitLinkElement = this.getElementLinkAtPosition(i, m), !$e68ba20b3d2d159d$var$Jr(this.state) && (this.hitLinkElement && !this.state.selectedElementIds[this.hitLinkElement.id] ? ($e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER), $e68ba20b3d2d159d$var$hI(this.hitLinkElement, this.state, this.scene.getNonDeletedElementsMap())) : ($e68ba20b3d2d159d$var$gI(), m && (m.link || $e68ba20b3d2d159d$var$Rt(m)) && this.state.selectedElementIds[m.id] && !this.state.contextMenu && !this.state.showHyperlinkPopup ? this.setState({
            showHyperlinkPopup: "info"
        }) : this.state.activeTool.type === "text" ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$G(m) ? $e68ba20b3d2d159d$var$Ue.TEXT : $e68ba20b3d2d159d$var$Ue.CROSSHAIR) : this.state.viewModeEnabled ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB) : n ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.AUTO) : this.state.selectedLinearElement ? this.handleHoverSelectedLinearElement(this.state.selectedLinearElement, a, s) : t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.AUTO) : (m || this.isHittingCommonBoundingBoxOfSelectedElements(i, d)) && !m?.locked && (m && $e68ba20b3d2d159d$var$cr(m) && this.isIframeLikeElementCenter(m, t, a, s) ? ($e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER), this.setState({
            activeEmbeddable: {
                element: m,
                state: "hover"
            }
        })) : ($e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.MOVE), this.state.activeEmbeddable?.state === "hover" && this.setState({
            activeEmbeddable: null
        })))));
    };
    handleEraser = (t, r, o)=>{
        this.eraserTrail.addPointToPath(o.x, o.y);
        let n = !1, i = new Set, a = this.scene.getNonDeletedElements(), s = (p)=>{
            for (let u of p){
                if (u.locked) return;
                if (t.altKey ? this.elementsPendingErasure.delete(u.id) && (n = !0) : this.elementsPendingErasure.has(u.id) || (n = !0, this.elementsPendingErasure.add(u.id)), n && u.groupIds?.length) {
                    let h = u.groupIds.at(-1);
                    if (!i.has(h)) {
                        i.add(h);
                        let g = $e68ba20b3d2d159d$var$nt(a, h);
                        for (let b of g)t.altKey ? this.elementsPendingErasure.delete(b.id) : this.elementsPendingErasure.add(b.id);
                    }
                }
            }
        }, l = $e68ba20b3d2d159d$var$Lt(r.lastCoords.x, r.lastCoords.y, o.x, o.y), c = this.getElementHitThreshold(), d = {
            ...r.lastCoords
        }, m = 0;
        for(; m <= l;){
            let p = this.getElementsAtPosition(d.x, d.y);
            if (s(p), m === l) break;
            m = Math.min(m + c, l);
            let u = m / l, h = (1 - u) * d.x + u * o.x, g = (1 - u) * d.y + u * o.y;
            d.x = h, d.y = g;
        }
        if (r.lastCoords.x = o.x, r.lastCoords.y = o.y, n) {
            for (let p of this.scene.getNonDeletedElements())$e68ba20b3d2d159d$var$Ge(p) && (this.elementsPendingErasure.has(p.id) || this.elementsPendingErasure.has(p.containerId)) && (t.altKey ? (this.elementsPendingErasure.delete(p.id), this.elementsPendingErasure.delete(p.containerId)) : (this.elementsPendingErasure.add(p.id), this.elementsPendingErasure.add(p.containerId)));
            this.elementsPendingErasure = new Set(this.elementsPendingErasure), this.triggerRender();
        }
    };
    handleTouchMove = (t)=>{
        $e68ba20b3d2d159d$var$bm = !0;
    };
    handleHoverSelectedLinearElement(t, r, o) {
        let n = this.scene.getNonDeletedElementsMap(), i = $e68ba20b3d2d159d$var$$.getElement(t.elementId, n);
        if (i) {
            if (this.state.selectedLinearElement) {
                let a = -1, s = null;
                $e68ba20b3d2d159d$var$ns({
                    x: r,
                    y: o,
                    element: i,
                    shape: $e68ba20b3d2d159d$var$sn(i, this.scene.getNonDeletedElementsMap())
                }) ? (a = $e68ba20b3d2d159d$var$$.getPointIndexUnderCursor(i, n, this.state.zoom, r, o), s = $e68ba20b3d2d159d$var$$.getSegmentMidpointHitCoords(t, {
                    x: r,
                    y: o
                }, this.state, this.scene.getNonDeletedElementsMap()), a >= 0 || s ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER) : this.hitElement(r, o, i) && $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.MOVE)) : this.hitElement(r, o, i) && (!$e68ba20b3d2d159d$var$ce(i) || !(i.startBinding || i.endBinding)) && $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.MOVE), this.state.selectedLinearElement.hoverPointIndex !== a && this.setState({
                    selectedLinearElement: {
                        ...this.state.selectedLinearElement,
                        hoverPointIndex: a
                    }
                }), $e68ba20b3d2d159d$var$$.arePointsEqual(this.state.selectedLinearElement.segmentMidPointHoveredCoords, s) || this.setState({
                    selectedLinearElement: {
                        ...this.state.selectedLinearElement,
                        segmentMidPointHoveredCoords: s
                    }
                });
            } else $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.AUTO);
        }
    }
    handleCanvasPointerDown = (t)=>{
        if (this.maybeCleanupAfterMissingPointerUp(t.nativeEvent), this.maybeUnfollowRemoteUser(), this.state.contextMenu && this.setState({
            contextMenu: null
        }), this.state.snapLines && this.setAppState({
            snapLines: []
        }), this.updateGestureOnPointerDown(t), t.pointerType === "touch" && this.state.newElement && this.state.newElement.type === "freedraw") {
            let c = this.state.newElement;
            this.updateScene({
                ...c.points.length < 10 ? {
                    elements: this.scene.getElementsIncludingDeleted().filter((d)=>d.id !== c.id)
                } : {},
                appState: {
                    newElement: null,
                    editingTextElement: null,
                    startBoundElement: null,
                    suggestedBindings: [],
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe(Object.keys(this.state.selectedElementIds).filter((d)=>d !== c.id).reduce((d, m)=>(d[m] = this.state.selectedElementIds[m], d), {}), this.state)
                },
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
            });
            return;
        }
        let r = document.getSelection();
        if (r?.anchorNode && r.removeAllRanges(), this.maybeOpenContextMenuAfterPointerDownOnTouchDevices(t), !this.state.penDetected && t.pointerType === "pen" && this.setState((c)=>({
                penMode: !0,
                penDetected: !0
            })), !this.device.isTouchScreen && [
            "pen",
            "touch"
        ].includes(t.pointerType) && (this.device = $e68ba20b3d2d159d$var$Ks(this.device, {
            isTouchScreen: !0
        })), $e68ba20b3d2d159d$var$xm || (this.lastPointerDownEvent = t, this.handleCanvasPanUsingWheelOrSpaceDrag(t))) return;
        if (this.setState({
            lastPointerDownWith: t.pointerType,
            cursorButton: "down"
        }), this.savePointer(t.clientX, t.clientY, "down"), t.button === $e68ba20b3d2d159d$var$Cn.ERASER && this.state.activeTool.type !== $e68ba20b3d2d159d$var$St.eraser) {
            this.setState({
                activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                    type: $e68ba20b3d2d159d$var$St.eraser,
                    lastActiveToolBeforeEraser: this.state.activeTool
                })
            }, ()=>{
                this.handleCanvasPointerDown(t);
                let c = ()=>{
                    d(), m?.(), $e68ba20b3d2d159d$var$Jr(this.state) && this.setState({
                        activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                            ...this.state.activeTool.lastActiveTool || {
                                type: $e68ba20b3d2d159d$var$St.selection
                            },
                            lastActiveToolBeforeEraser: null
                        })
                    });
                }, d = $e68ba20b3d2d159d$var$xt(window, "pointerup", c, {
                    once: !0
                }), m;
                requestAnimationFrame(()=>{
                    m = this.missingPointerEventCleanupEmitter.once(c);
                });
            });
            return;
        }
        if (t.button !== $e68ba20b3d2d159d$var$Cn.MAIN && t.button !== $e68ba20b3d2d159d$var$Cn.TOUCH && t.button !== $e68ba20b3d2d159d$var$Cn.ERASER || $e68ba20b3d2d159d$var$Ve.pointers.size > 1) return;
        let o = this.initialPointerDownState(t);
        if (this.setState({
            selectedElementsAreBeingDragged: !1
        }), this.handleDraggingScrollBar(t, o) || (this.clearSelectionIfNotUsingSelection(), this.updateBindingEnabledOnPointerMove(t), this.handleSelectionOnPointerDown(t, o)) || !(!this.state.penMode || t.pointerType !== "touch" || this.state.activeTool.type === "selection" || this.state.activeTool.type === "text" || this.state.activeTool.type === "image")) return;
        if (this.state.activeTool.type === "text") this.handleTextOnPointerDown(t, o);
        else if (this.state.activeTool.type === "arrow" || this.state.activeTool.type === "line") this.handleLinearElementOnPointerDown(t, this.state.activeTool.type, o);
        else if (this.state.activeTool.type === "image") {
            $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.CROSSHAIR);
            let c = this.state.pendingImageElementId && this.scene.getElement(this.state.pendingImageElementId);
            if (!c) return;
            this.setState({
                newElement: c,
                pendingImageElementId: null,
                multiElement: null
            });
            let { x: d, y: m } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state), p = this.getTopLayerFrameAtSceneCoords({
                x: d,
                y: m
            });
            $e68ba20b3d2d159d$export$55655e96a21bba2e(c, {
                x: d,
                y: m,
                frameId: p ? p.id : null
            });
        } else this.state.activeTool.type === "freedraw" ? this.handleFreeDrawElementOnPointerDown(t, this.state.activeTool.type, o) : this.state.activeTool.type === "custom" ? $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state) : this.state.activeTool.type === $e68ba20b3d2d159d$var$St.frame || this.state.activeTool.type === $e68ba20b3d2d159d$var$St.magicframe ? this.createFrameElementOnPointerDown(o, this.state.activeTool.type) : this.state.activeTool.type === "laser" ? this.laserTrails.startPath(o.lastCoords.x, o.lastCoords.y) : this.state.activeTool.type !== "eraser" && this.state.activeTool.type !== "hand" && this.createGenericElementOnPointerDown(this.state.activeTool.type, o);
        this.props?.onPointerDown?.(this.state.activeTool, o), this.onPointerDownEmitter.trigger(this.state.activeTool, o, t), this.state.activeTool.type === "eraser" && this.eraserTrail.startPath(o.lastCoords.x, o.lastCoords.y);
        let i = this.onPointerMoveFromPointerDownHandler(o), a = this.onPointerUpFromPointerDownHandler(o), s = this.onKeyDownFromPointerDownHandler(o), l = this.onKeyUpFromPointerDownHandler(o);
        this.missingPointerEventCleanupEmitter.once((c)=>a(c || t.nativeEvent)), (!this.state.viewModeEnabled || this.state.activeTool.type === "laser") && (window.addEventListener("pointermove", i), window.addEventListener("pointerup", a), window.addEventListener("keydown", s), window.addEventListener("keyup", l), o.eventListeners.onMove = i, o.eventListeners.onUp = a, o.eventListeners.onKeyUp = l, o.eventListeners.onKeyDown = s);
    };
    handleCanvasPointerUp = (t)=>{
        this.removePointer(t), this.lastPointerUpEvent = t;
        let r = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: t.clientX,
            clientY: t.clientY
        }, this.state), o = t.timeStamp - (this.lastPointerDownEvent?.timeStamp ?? 0);
        if (this.device.editor.isMobile && o < 300) {
            let n = this.getElementAtPosition(r.x, r.y);
            if ($e68ba20b3d2d159d$var$cr(n) && this.isIframeLikeElementCenter(n, t, r.x, r.y)) {
                this.handleEmbeddableCenterClick(n);
                return;
            }
        }
        if (this.device.isTouchScreen) {
            let n = this.getElementAtPosition(r.x, r.y);
            this.hitLinkElement = this.getElementLinkAtPosition(r, n);
        }
        this.hitLinkElement && !this.state.selectedElementIds[this.hitLinkElement.id] ? o < 300 && $e68ba20b3d2d159d$var$cr(this.hitLinkElement) && !$e68ba20b3d2d159d$var$IE(this.hitLinkElement, this.scene.getNonDeletedElementsMap(), this.state, [
            r.x,
            r.y
        ]) ? this.handleEmbeddableCenterClick(this.hitLinkElement) : this.redirectToLink(t, this.device.isTouchScreen) : this.state.viewModeEnabled && this.setState({
            activeEmbeddable: null,
            selectedElementIds: {}
        });
    };
    maybeOpenContextMenuAfterPointerDownOnTouchDevices = (t)=>{
        t.pointerType === "touch" && ($e68ba20b3d2d159d$var$bm = !1, $e68ba20b3d2d159d$var$Aa ? $e68ba20b3d2d159d$var$bm = !0 : $e68ba20b3d2d159d$var$Aa = window.setTimeout(()=>{
            $e68ba20b3d2d159d$var$Aa = 0, $e68ba20b3d2d159d$var$bm || this.handleCanvasContextMenu(t);
        }, $e68ba20b3d2d159d$var$S0));
    };
    resetContextMenuTimer = ()=>{
        clearTimeout($e68ba20b3d2d159d$var$Aa), $e68ba20b3d2d159d$var$Aa = 0, $e68ba20b3d2d159d$var$bm = !1;
    };
    maybeCleanupAfterMissingPointerUp = (t)=>{
        $e68ba20b3d2d159d$var$ym?.(), this.missingPointerEventCleanupEmitter.trigger(t).clear();
    };
    handleCanvasPanUsingWheelOrSpaceDrag = (t)=>{
        if (!($e68ba20b3d2d159d$var$Ve.pointers.size <= 1 && (t.button === $e68ba20b3d2d159d$var$Cn.WHEEL || t.button === $e68ba20b3d2d159d$var$Cn.MAIN && $e68ba20b3d2d159d$var$Fs || $e68ba20b3d2d159d$var$Jo(this.state) || this.state.viewModeEnabled))) return !1;
        $e68ba20b3d2d159d$var$xm = !0, this.state.editingTextElement || t.preventDefault();
        let r = !1, o = /Linux/.test(window.navigator.platform);
        $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRABBING);
        let { clientX: n, clientY: i } = t, a = $e68ba20b3d2d159d$var$Og((l)=>{
            let c = n - l.clientX, d = i - l.clientY;
            if (n = l.clientX, i = l.clientY, o && !r && (Math.abs(c) > 1 || Math.abs(d) > 1)) {
                r = !0;
                let m = (u)=>{
                    document.body.removeEventListener("paste", m), u.stopPropagation();
                }, p = ()=>{
                    setTimeout(()=>{
                        document.body.removeEventListener("paste", m), window.removeEventListener("pointerup", p);
                    }, 100);
                };
                document.body.addEventListener("paste", m), window.addEventListener("pointerup", p);
            }
            this.translateCanvas({
                scrollX: this.state.scrollX - c / this.state.zoom.value,
                scrollY: this.state.scrollY - d / this.state.zoom.value
            });
        }), s = $e68ba20b3d2d159d$var$Et($e68ba20b3d2d159d$var$ym = ()=>{
            $e68ba20b3d2d159d$var$ym = null, $e68ba20b3d2d159d$var$xm = !1, $e68ba20b3d2d159d$var$Fs || (this.state.viewModeEnabled ? $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.GRAB) : $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state)), this.setState({
                cursorButton: "up"
            }), this.savePointer(t.clientX, t.clientY, "up"), window.removeEventListener("pointermove", a), window.removeEventListener("pointerup", s), window.removeEventListener("blur", s), a.flush();
        });
        return window.addEventListener("blur", s), window.addEventListener("pointermove", a, {
            passive: !0
        }), window.addEventListener("pointerup", s), !0;
    };
    updateGestureOnPointerDown(t) {
        $e68ba20b3d2d159d$var$Ve.pointers.set(t.pointerId, {
            x: t.clientX,
            y: t.clientY
        }), $e68ba20b3d2d159d$var$Ve.pointers.size === 2 && ($e68ba20b3d2d159d$var$Ve.lastCenter = $e68ba20b3d2d159d$var$Hb($e68ba20b3d2d159d$var$Ve.pointers), $e68ba20b3d2d159d$var$Ve.initialScale = this.state.zoom.value, $e68ba20b3d2d159d$var$Ve.initialDistance = $e68ba20b3d2d159d$var$Ub(Array.from($e68ba20b3d2d159d$var$Ve.pointers.values())));
    }
    initialPointerDownState(t) {
        let r = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state), o = this.scene.getSelectedElements(this.state), [n, i, a, s] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(o), l = o.findIndex($e68ba20b3d2d159d$var$ce) === 0;
        return {
            origin: r,
            withCmdOrCtrl: t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD],
            originInGrid: $e68ba20b3d2d159d$var$sr($e68ba20b3d2d159d$var$Ot(r.x, r.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] || l ? null : this.getEffectiveGridSize())),
            scrollbars: $e68ba20b3d2d159d$var$Kb($e68ba20b3d2d159d$var$O1, t.clientX - this.state.offsetLeft, t.clientY - this.state.offsetTop),
            lastCoords: {
                ...r
            },
            originalElements: this.scene.getNonDeletedElements().reduce((c, d)=>(c.set(d.id, $e68ba20b3d2d159d$var$hn(d)), c), new Map),
            resize: {
                handleType: !1,
                isResizing: !1,
                offset: {
                    x: 0,
                    y: 0
                },
                arrowDirection: "origin",
                center: {
                    x: (a + n) / 2,
                    y: (s + i) / 2
                }
            },
            hit: {
                element: null,
                allHitElements: [],
                wasAddedToSelection: !1,
                hasBeenDuplicated: !1,
                hasHitCommonBoundingBoxOfSelectedElements: this.isHittingCommonBoundingBoxOfSelectedElements(r, o)
            },
            drag: {
                hasOccurred: !1,
                offset: null
            },
            eventListeners: {
                onMove: null,
                onUp: null,
                onKeyUp: null,
                onKeyDown: null
            },
            boxSelection: {
                hasOccurred: !1
            }
        };
    }
    handleDraggingScrollBar(t, r) {
        if (!(r.scrollbars.isOverEither && !this.state.multiElement)) return !1;
        $e68ba20b3d2d159d$var$N1 = !0, r.lastCoords.x = t.clientX, r.lastCoords.y = t.clientY;
        let o = $e68ba20b3d2d159d$var$Og((i)=>{
            i.target instanceof HTMLElement && this.handlePointerMoveOverScrollbars(i, r);
        }), n = $e68ba20b3d2d159d$var$Et(()=>{
            $e68ba20b3d2d159d$var$ym = null, $e68ba20b3d2d159d$var$N1 = !1, $e68ba20b3d2d159d$var$ho(this.interactiveCanvas, this.state), this.setState({
                cursorButton: "up"
            }), this.savePointer(t.clientX, t.clientY, "up"), window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", n), o.flush();
        });
        return $e68ba20b3d2d159d$var$ym = n, window.addEventListener("pointermove", o), window.addEventListener("pointerup", n), !0;
    }
    clearSelectionIfNotUsingSelection = ()=>{
        this.state.activeTool.type !== "selection" && this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            selectedGroupIds: {},
            editingGroupId: null,
            activeEmbeddable: null
        });
    };
    handleSelectionOnPointerDown = (t, r)=>{
        if (this.state.activeTool.type === "selection") {
            let o = this.scene.getNonDeletedElements(), n = this.scene.getNonDeletedElementsMap(), i = this.scene.getSelectedElements(this.state);
            if (i.length === 1 && !this.state.editingLinearElement && !(this.state.selectedLinearElement && this.state.selectedLinearElement.hoverPointIndex !== -1)) {
                let a = $e68ba20b3d2d159d$var$eh(o, this.state, r.origin.x, r.origin.y, this.state.zoom, t.pointerType, this.scene.getNonDeletedElementsMap(), this.device);
                a != null && (this.setState({
                    resizingElement: a.element
                }), r.resize.handleType = a.transformHandleType);
            } else i.length > 1 && (r.resize.handleType = $e68ba20b3d2d159d$var$th($e68ba20b3d2d159d$export$3e54c0515ef60d1d(i), r.origin.x, r.origin.y, this.state.zoom, t.pointerType, this.device));
            if (r.resize.handleType) r.resize.isResizing = !0, r.resize.offset = $e68ba20b3d2d159d$var$sr($e68ba20b3d2d159d$var$sx(r.resize.handleType, i, n, r.origin.x, r.origin.y)), i.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(i[0]) && i[0].points.length === 2 && (r.resize.arrowDirection = $e68ba20b3d2d159d$var$lx(r.resize.handleType, i[0]));
            else {
                if (this.state.selectedLinearElement) {
                    let l = this.state.editingLinearElement || this.state.selectedLinearElement, c = $e68ba20b3d2d159d$var$$.handlePointerDown(t, this, this.store, r.origin, l, this.scene);
                    if (c.hitElement && (r.hit.element = c.hitElement), c.linearElementEditor && (this.setState({
                        selectedLinearElement: c.linearElementEditor
                    }), this.state.editingLinearElement && this.setState({
                        editingLinearElement: c.linearElementEditor
                    })), c.didAddPoint) return !0;
                }
                if (r.hit.element = r.hit.element ?? this.getElementAtPosition(r.origin.x, r.origin.y), r.hit.element && this.getElementLinkAtPosition({
                    x: r.origin.x,
                    y: r.origin.y
                }, r.hit.element)) return !1;
                r.hit.allHitElements = this.getElementsAtPosition(r.origin.x, r.origin.y);
                let a = r.hit.element, s = r.hit.allHitElements.some((l)=>this.isASelectedElement(l));
                if ((a === null || !s) && !t.shiftKey && !r.hit.hasHitCommonBoundingBoxOfSelectedElements && this.clearSelection(a), this.state.editingLinearElement) this.setState({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        [this.state.editingLinearElement.elementId]: !0
                    }, this.state)
                });
                else if (a != null) {
                    if (t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD]) return this.state.selectedElementIds[a.id] || (r.hit.wasAddedToSelection = !0), this.setState((l)=>({
                            ...$e68ba20b3d2d159d$var$cy(l, a),
                            previousSelectedElementIds: this.state.selectedElementIds
                        })), !1;
                    this.state.selectedElementIds[a.id] || (this.state.editingGroupId && !$e68ba20b3d2d159d$var$Ga(a, this.state.editingGroupId) && this.setState({
                        selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
                        selectedGroupIds: {},
                        editingGroupId: null,
                        activeEmbeddable: null
                    }), !s && !r.hit.hasHitCommonBoundingBoxOfSelectedElements && (this.setState((l)=>{
                        let c = {
                            ...l.selectedElementIds,
                            [a.id]: !0
                        }, d = [];
                        if (Object.keys(l.selectedElementIds).forEach((m)=>{
                            let p = this.scene.getElement(m);
                            p && d.push(p);
                        }), $e68ba20b3d2d159d$var$re(a)) $e68ba20b3d2d159d$var$bo(d, a.id).forEach((m)=>{
                            delete c[m.id];
                        });
                        else if (a.frameId) c[a.frameId] && delete c[a.id];
                        else {
                            let m = a.groupIds, p = new Set(m.flatMap((u)=>$e68ba20b3d2d159d$var$nt(this.scene.getNonDeletedElements(), u)).filter((u)=>$e68ba20b3d2d159d$var$re(u)).map((u)=>u.id));
                            p.size > 0 && d.forEach((u)=>{
                                u.frameId && p.has(u.frameId) && (delete c[u.id], u.groupIds.flatMap((h)=>$e68ba20b3d2d159d$var$nt(this.scene.getNonDeletedElements(), h)).forEach((h)=>{
                                    delete c[h.id];
                                }));
                            });
                        }
                        return {
                            ...$e68ba20b3d2d159d$var$mr({
                                editingGroupId: l.editingGroupId,
                                selectedElementIds: c
                            }, this.scene.getNonDeletedElements(), l, this),
                            showHyperlinkPopup: a.link || $e68ba20b3d2d159d$var$Rt(a) ? "info" : !1
                        };
                    }), r.hit.wasAddedToSelection = !0));
                }
                this.setState({
                    previousSelectedElementIds: this.state.selectedElementIds
                });
            }
        }
        return !1;
    };
    isASelectedElement(t) {
        return t != null && this.state.selectedElementIds[t.id];
    }
    isHittingCommonBoundingBoxOfSelectedElements(t, r) {
        if (r.length < 2) return !1;
        let o = this.getElementHitThreshold(), [n, i, a, s] = $e68ba20b3d2d159d$export$3e54c0515ef60d1d(r);
        return t.x > n - o && t.x < a + o && t.y > i - o && t.y < s + o;
    }
    handleTextOnPointerDown = (t, r)=>{
        if (this.state.editingTextElement) return;
        let o = r.origin.x, n = r.origin.y, i = this.getElementAtPosition(o, n, {
            includeBoundTextElement: !0
        }), a = this.getTextBindableContainerAtPosition(o, n);
        $e68ba20b3d2d159d$var$It(i) && (a = i, o = i.x + i.width / 2, n = i.y + i.height / 2), this.startTextEditing({
            sceneX: o,
            sceneY: n,
            insertAtParentCenter: !t.altKey,
            container: a,
            autoEdit: !1
        }), $e68ba20b3d2d159d$var$uo(this.interactiveCanvas), this.state.activeTool.locked || this.setState({
            activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                type: "selection"
            })
        });
    };
    handleFreeDrawElementOnPointerDown = (t, r, o)=>{
        let [n, i] = $e68ba20b3d2d159d$var$Ot(o.origin.x, o.origin.y, null), a = this.getTopLayerFrameAtSceneCoords({
            x: n,
            y: i
        }), s = t.pressure === .5, l = $e68ba20b3d2d159d$var$oT({
            type: r,
            x: n,
            y: i,
            strokeColor: this.state.currentItemStrokeColor,
            backgroundColor: this.state.currentItemBackgroundColor,
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            opacity: this.state.currentItemOpacity,
            roundness: null,
            simulatePressure: s,
            locked: !1,
            frameId: a ? a.id : null,
            points: [
                [
                    0,
                    0
                ]
            ],
            pressures: s ? [] : [
                t.pressure
            ]
        });
        this.scene.insertElement(l), this.setState((d)=>{
            let m = {
                ...d.selectedElementIds
            };
            return delete m[l.id], {
                selectedElementIds: $e68ba20b3d2d159d$var$Fe(m, d)
            };
        });
        let c = $e68ba20b3d2d159d$var$Ir(o.origin, this.scene.getNonDeletedElements(), this.scene.getNonDeletedElementsMap());
        this.setState({
            newElement: l,
            startBoundElement: c,
            suggestedBindings: []
        });
    };
    insertIframeElement = ({ sceneX: t, sceneY: r, width: o, height: n })=>{
        let [i, a] = $e68ba20b3d2d159d$var$Ot(t, r, this.lastPointerDownEvent?.[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), s = $e68ba20b3d2d159d$var$tT({
            type: "iframe",
            x: i,
            y: a,
            strokeColor: "transparent",
            backgroundColor: "transparent",
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            roundness: this.getCurrentItemRoundness("iframe"),
            opacity: this.state.currentItemOpacity,
            locked: !1,
            width: o,
            height: n
        });
        return this.scene.insertElement(s), s;
    };
    insertEmbeddableElement = ({ sceneX: t, sceneY: r, link: o })=>{
        let [n, i] = $e68ba20b3d2d159d$var$Ot(t, r, this.lastPointerDownEvent?.[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), a = $e68ba20b3d2d159d$var$bi(o);
        if (!a) return;
        a.error instanceof URIError && this.setToast({
            message: $e68ba20b3d2d159d$var$x("toast.unrecognizedLinkFormat"),
            closable: !0
        });
        let s = $e68ba20b3d2d159d$var$EE({
            type: "embeddable",
            x: n,
            y: i,
            strokeColor: "transparent",
            backgroundColor: "transparent",
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            roundness: this.getCurrentItemRoundness("embeddable"),
            opacity: this.state.currentItemOpacity,
            locked: !1,
            width: a.intrinsicSize.w,
            height: a.intrinsicSize.h,
            link: o
        });
        return this.scene.insertElement(s), s;
    };
    createImageElement = ({ sceneX: t, sceneY: r, addToFrameUnderCursor: o = !0 })=>{
        let [n, i] = $e68ba20b3d2d159d$var$Ot(t, r, this.lastPointerDownEvent?.[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), a = o ? this.getTopLayerFrameAtSceneCoords({
            x: n,
            y: i
        }) : null;
        return $e68ba20b3d2d159d$var$ld({
            type: "image",
            x: n,
            y: i,
            strokeColor: this.state.currentItemStrokeColor,
            backgroundColor: this.state.currentItemBackgroundColor,
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            roundness: null,
            opacity: this.state.currentItemOpacity,
            locked: !1,
            frameId: a ? a.id : null
        });
    };
    handleLinearElementOnPointerDown = (t, r, o)=>{
        if (this.state.multiElement) {
            let { multiElement: n } = this.state;
            if (n.type === "line" && $e68ba20b3d2d159d$var$Br(n.points, this.state.zoom.value)) {
                $e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
                    lastCommittedPoint: n.points[n.points.length - 1]
                }), this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                return;
            }
            if ($e68ba20b3d2d159d$var$ce(n) && n.points.length > 1) {
                $e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
                    lastCommittedPoint: n.points[n.points.length - 1]
                }), this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                return;
            }
            let { x: i, y: a, lastCommittedPoint: s } = n;
            if (n.points.length > 1 && s && $e68ba20b3d2d159d$var$Lt(o.origin.x - i, o.origin.y - a, s[0], s[1]) < $e68ba20b3d2d159d$var$Ws) {
                this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                return;
            }
            this.setState((l)=>({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        ...l.selectedElementIds,
                        [n.id]: !0
                    }, l)
                })), $e68ba20b3d2d159d$export$55655e96a21bba2e(n, {
                lastCommittedPoint: n.points[n.points.length - 1]
            }), $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.POINTER);
        } else {
            let [n, i] = $e68ba20b3d2d159d$var$Ot(o.origin.x, o.origin.y, t[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), a = this.getTopLayerFrameAtSceneCoords({
                x: n,
                y: i
            }), { currentItemStartArrowhead: s, currentItemEndArrowhead: l } = this.state, [c, d] = r === "arrow" ? [
                s,
                l
            ] : [
                null,
                null
            ], m = r === "arrow" ? $e68ba20b3d2d159d$var$ds({
                type: r,
                x: n,
                y: i,
                strokeColor: this.state.currentItemStrokeColor,
                backgroundColor: this.state.currentItemBackgroundColor,
                fillStyle: this.state.currentItemFillStyle,
                strokeWidth: this.state.currentItemStrokeWidth,
                strokeStyle: this.state.currentItemStrokeStyle,
                roughness: this.state.currentItemRoughness,
                opacity: this.state.currentItemOpacity,
                roundness: this.state.currentItemArrowType === $e68ba20b3d2d159d$var$_t.round ? {
                    type: $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
                } : null,
                startArrowhead: c,
                endArrowhead: d,
                locked: !1,
                frameId: a ? a.id : null,
                elbowed: this.state.currentItemArrowType === $e68ba20b3d2d159d$var$_t.elbow
            }) : $e68ba20b3d2d159d$var$un({
                type: r,
                x: n,
                y: i,
                strokeColor: this.state.currentItemStrokeColor,
                backgroundColor: this.state.currentItemBackgroundColor,
                fillStyle: this.state.currentItemFillStyle,
                strokeWidth: this.state.currentItemStrokeWidth,
                strokeStyle: this.state.currentItemStrokeStyle,
                roughness: this.state.currentItemRoughness,
                opacity: this.state.currentItemOpacity,
                roundness: this.state.currentItemRoundness === "round" ? {
                    type: $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
                } : null,
                locked: !1,
                frameId: a ? a.id : null
            });
            this.setState((u)=>{
                let h = {
                    ...u.selectedElementIds
                };
                return delete h[m.id], {
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe(h, u)
                };
            }), $e68ba20b3d2d159d$export$55655e96a21bba2e(m, {
                points: [
                    ...m.points,
                    [
                        0,
                        0
                    ]
                ]
            });
            let p = $e68ba20b3d2d159d$var$Ir(o.origin, this.scene.getNonDeletedElements(), this.scene.getNonDeletedElementsMap(), $e68ba20b3d2d159d$var$ce(m));
            this.scene.insertElement(m), this.setState({
                newElement: m,
                startBoundElement: p,
                suggestedBindings: []
            });
        }
    };
    getCurrentItemRoundness(t) {
        return this.state.currentItemRoundness === "round" ? {
            type: $e68ba20b3d2d159d$var$_n(t) ? $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.ADAPTIVE_RADIUS : $e68ba20b3d2d159d$export$93eaedb7efc8b9fa.PROPORTIONAL_RADIUS
        } : null;
    }
    createGenericElementOnPointerDown = (t, r)=>{
        let [o, n] = $e68ba20b3d2d159d$var$Ot(r.origin.x, r.origin.y, this.lastPointerDownEvent?.[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), i = this.getTopLayerFrameAtSceneCoords({
            x: o,
            y: n
        }), a = {
            x: o,
            y: n,
            strokeColor: this.state.currentItemStrokeColor,
            backgroundColor: this.state.currentItemBackgroundColor,
            fillStyle: this.state.currentItemFillStyle,
            strokeWidth: this.state.currentItemStrokeWidth,
            strokeStyle: this.state.currentItemStrokeStyle,
            roughness: this.state.currentItemRoughness,
            opacity: this.state.currentItemOpacity,
            roundness: this.getCurrentItemRoundness(t),
            locked: !1,
            frameId: i ? i.id : null
        }, s;
        t === "embeddable" ? s = $e68ba20b3d2d159d$var$EE({
            type: "embeddable",
            ...a
        }) : s = $e68ba20b3d2d159d$var$Ar({
            type: t,
            ...a
        }), s.type === "selection" ? this.setState({
            selectionElement: s
        }) : (this.scene.insertElement(s), this.setState({
            multiElement: null,
            newElement: s
        }));
    };
    createFrameElementOnPointerDown = (t, r)=>{
        let [o, n] = $e68ba20b3d2d159d$var$Ot(t.origin.x, t.origin.y, this.lastPointerDownEvent?.[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), i = {
            x: o,
            y: n,
            opacity: this.state.currentItemOpacity,
            locked: !1,
            ...$e68ba20b3d2d159d$var$ot
        }, a = r === $e68ba20b3d2d159d$var$St.magicframe ? $e68ba20b3d2d159d$var$sd(i) : $e68ba20b3d2d159d$var$cu(i);
        this.scene.insertElement(a), this.setState({
            multiElement: null,
            newElement: a
        });
    };
    maybeCacheReferenceSnapPoints(t, r, o = !1) {
        $e68ba20b3d2d159d$var$Di({
            event: t,
            app: this,
            selectedElements: r
        }) && (o || !$e68ba20b3d2d159d$var$Uo.getReferenceSnapPoints()) && $e68ba20b3d2d159d$var$Uo.setReferenceSnapPoints($e68ba20b3d2d159d$var$NC(this.scene.getNonDeletedElements(), r, this.state, this.scene.getNonDeletedElementsMap()));
    }
    maybeCacheVisibleGaps(t, r, o = !1) {
        $e68ba20b3d2d159d$var$Di({
            event: t,
            app: this,
            selectedElements: r
        }) && (o || !$e68ba20b3d2d159d$var$Uo.getVisibleGaps()) && $e68ba20b3d2d159d$var$Uo.setVisibleGaps($e68ba20b3d2d159d$var$RC(this.scene.getNonDeletedElements(), r, this.state, this.scene.getNonDeletedElementsMap()));
    }
    onKeyDownFromPointerDownHandler(t) {
        return $e68ba20b3d2d159d$var$Et((r)=>{
            this.maybeHandleResize(t, r) || this.maybeDragNewGenericElement(t, r);
        });
    }
    onKeyUpFromPointerDownHandler(t) {
        return $e68ba20b3d2d159d$var$Et((r)=>{
            r.key === $e68ba20b3d2d159d$var$S.ALT && r.preventDefault(), !this.maybeHandleResize(t, r) && this.maybeDragNewGenericElement(t, r);
        });
    }
    onPointerMoveFromPointerDownHandler(t) {
        return $e68ba20b3d2d159d$var$Og((r)=>{
            if (t.drag.offset === null && (t.drag.offset = $e68ba20b3d2d159d$var$sr($e68ba20b3d2d159d$var$dx(this.scene.getSelectedElements(this.state), t.origin.x, t.origin.y))), !(r.target instanceof HTMLElement) || this.handlePointerMoveOverScrollbars(r, t)) return;
            let n = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(r, this.state);
            if ($e68ba20b3d2d159d$var$Jr(this.state)) {
                this.handleEraser(r, t, n);
                return;
            }
            this.state.activeTool.type === "laser" && this.laserTrails.addPointToPath(n.x, n.y);
            let [i, a] = $e68ba20b3d2d159d$var$Ot(n.x, n.y, r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize());
            if (!t.drag.hasOccurred && (this.state.activeTool.type === "arrow" || this.state.activeTool.type === "line") && $e68ba20b3d2d159d$var$Lt(n.x, n.y, t.origin.x, t.origin.y) < $e68ba20b3d2d159d$var$ii) return;
            if (t.resize.isResizing && (t.lastCoords.x = n.x, t.lastCoords.y = n.y, this.maybeHandleResize(t, r))) return !0;
            let s = this.scene.getNonDeletedElementsMap();
            if (this.state.selectedLinearElement) {
                let d = this.state.editingLinearElement || this.state.selectedLinearElement;
                if ($e68ba20b3d2d159d$var$$.shouldAddMidpoint(this.state.selectedLinearElement, n, this.state, s)) {
                    let p = $e68ba20b3d2d159d$var$$.addMidpoint(this.state.selectedLinearElement, n, this, !r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD], s);
                    if (!p) return;
                    (0, $11492dca620dcaa5$exports.flushSync)(()=>{
                        this.state.selectedLinearElement && this.setState({
                            selectedLinearElement: {
                                ...this.state.selectedLinearElement,
                                pointerDownState: p.pointerDownState,
                                selectedPointsIndices: p.selectedPointsIndices
                            }
                        }), this.state.editingLinearElement && this.setState({
                            editingLinearElement: {
                                ...this.state.editingLinearElement,
                                pointerDownState: p.pointerDownState,
                                selectedPointsIndices: p.selectedPointsIndices
                            }
                        });
                    });
                    return;
                } else if (d.pointerDownState.segmentMidpoint.value !== null && !d.pointerDownState.segmentMidpoint.added) return;
                if ($e68ba20b3d2d159d$var$$.handlePointDragging(r, this, n.x, n.y, (p, u)=>{
                    this.maybeSuggestBindingsForLinearElementAtCoords(p, u);
                }, d, this.scene)) {
                    t.lastCoords.x = n.x, t.lastCoords.y = n.y, t.drag.hasOccurred = !0, this.state.editingLinearElement && !this.state.editingLinearElement.isDragging && this.setState({
                        editingLinearElement: {
                            ...this.state.editingLinearElement,
                            isDragging: !0
                        }
                    }), this.state.selectedLinearElement.isDragging || this.setState({
                        selectedLinearElement: {
                            ...this.state.selectedLinearElement,
                            isDragging: !0
                        }
                    });
                    return;
                }
            }
            let l = t.hit.allHitElements.some((d)=>this.isASelectedElement(d)), c = this.state.editingLinearElement && r.shiftKey && this.state.editingLinearElement.elementId === t.hit.element?.id;
            if ((l || t.hit.hasHitCommonBoundingBoxOfSelectedElements) && !c) {
                let d = this.scene.getSelectedElements(this.state);
                if (d.every((u)=>u.locked)) return;
                let m = d.find((u)=>$e68ba20b3d2d159d$var$re(u)), p = this.getTopLayerFrameAtSceneCoords(n);
                if (this.setState({
                    frameToHighlight: p && !m ? p : null
                }), t.drag.hasOccurred = !0, d.length > 0 && !t.withCmdOrCtrl && !this.state.editingTextElement && this.state.activeEmbeddable?.state !== "active") {
                    let u = {
                        x: n.x - t.origin.x,
                        y: n.y - t.origin.y
                    }, h = [
                        ...t.originalElements.values()
                    ], g = r.shiftKey;
                    if (g) {
                        let y = Math.abs(u.x), w = Math.abs(u.y), I = g && y < w, M = g && y > w;
                        I && (u.x = 0), M && (u.y = 0);
                    }
                    this.maybeCacheVisibleGaps(r, d), this.maybeCacheReferenceSnapPoints(r, d);
                    let { snapOffset: b, snapLines: v } = $e68ba20b3d2d159d$var$OC(h, u, this, r, this.scene.getNonDeletedElementsMap());
                    if (this.setState({
                        snapLines: v
                    }), !this.state.editingFrame && $e68ba20b3d2d159d$var$cx(t, d, u, this.scene, b, r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), this.setState({
                        selectedElementsAreBeingDragged: !0,
                        selectionElement: null
                    }), (d.length !== 1 || !$e68ba20b3d2d159d$var$ce(d[0])) && this.setState({
                        suggestedBindings: $e68ba20b3d2d159d$var$jp(d, this.scene.getNonDeletedElementsMap())
                    }), r.altKey && !t.hit.hasBeenDuplicated) {
                        t.hit.hasBeenDuplicated = !0;
                        let y = [], w = [], I = new Map, M = new Map, C = t.hit.element, P = new Set(this.scene.getSelectedElements({
                            selectedElementIds: this.state.selectedElementIds,
                            includeBoundTextElement: !0,
                            includeElementsInFrames: !0
                        }).map((A)=>A.id)), k = this.scene.getElementsIncludingDeleted();
                        for (let A of k)if (P.has(A.id) || A.id === C?.id && t.hit.wasAddedToSelection) {
                            let R = $e68ba20b3d2d159d$var$cd(this.state.editingGroupId, I, A), B = t.originalElements.get(A.id);
                            $e68ba20b3d2d159d$export$55655e96a21bba2e(R, {
                                x: B.x,
                                y: B.y
                            }), t.originalElements.set(R.id, R), y.push(R), w.push(A), M.set(A.id, R.id);
                        } else y.push(A);
                        let _ = [
                            ...y,
                            ...w
                        ];
                        $e68ba20b3d2d159d$var$tr(_, $e68ba20b3d2d159d$var$j(w)), $e68ba20b3d2d159d$var$Xu(y, w, M), $e68ba20b3d2d159d$var$qp(_, w, M, "duplicatesServeAsOld"), $e68ba20b3d2d159d$var$_u(_, w, M), this.scene.replaceAllElements(_), this.maybeCacheVisibleGaps(r, d, !0), this.maybeCacheReferenceSnapPoints(r, d, !0);
                    }
                    return;
                }
            }
            if (this.state.selectionElement) t.lastCoords.x = n.x, t.lastCoords.y = n.y, this.maybeDragNewGenericElement(t, r);
            else {
                let d = this.state.newElement;
                if (!d) return;
                if (d.type === "freedraw") {
                    let m = d.points, p = n.x - d.x, u = n.y - d.y, h = m.length > 0 && m[m.length - 1];
                    if (!(h && h[0] === p && h[1] === u)) {
                        let b = d.simulatePressure ? d.pressures : [
                            ...d.pressures,
                            r.pressure
                        ];
                        $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                            points: [
                                ...m,
                                [
                                    p,
                                    u
                                ]
                            ],
                            pressures: b
                        }, !1), this.setState({
                            newElement: d
                        });
                    }
                } else if ($e68ba20b3d2d159d$export$5df2ebb939539835(d)) {
                    t.drag.hasOccurred = !0;
                    let m = d.points, p = i - d.x, u = a - d.y;
                    $e68ba20b3d2d159d$var$os(r) && m.length === 2 && ({ width: p, height: u } = $e68ba20b3d2d159d$var$Fl(d.x, d.y, n.x, n.y)), m.length === 1 ? $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                        points: [
                            ...m,
                            [
                                p,
                                u
                            ]
                        ]
                    }, !1) : m.length > 1 && $e68ba20b3d2d159d$var$ce(d) ? $e68ba20b3d2d159d$var$Fo(d, s, [
                        ...m.slice(0, -1),
                        [
                            p,
                            u
                        ]
                    ], [
                        0,
                        0
                    ], void 0, {
                        isDragging: !0,
                        informMutation: !1
                    }) : m.length === 2 && $e68ba20b3d2d159d$export$55655e96a21bba2e(d, {
                        points: [
                            ...m.slice(0, -1),
                            [
                                p,
                                u
                            ]
                        ]
                    }, !1), this.setState({
                        newElement: d
                    }), $e68ba20b3d2d159d$var$qr(d, !1) && this.maybeSuggestBindingsForLinearElementAtCoords(d, [
                        n
                    ], this.state.startBoundElement);
                } else t.lastCoords.x = n.x, t.lastCoords.y = n.y, this.maybeDragNewGenericElement(t, r, !1);
            }
            if (this.state.activeTool.type === "selection") {
                t.boxSelection.hasOccurred = !0;
                let d = this.scene.getNonDeletedElements();
                if (this.state.editingLinearElement) $e68ba20b3d2d159d$var$$.handleBoxSelection(r, this.state, this.setState.bind(this), this.scene.getNonDeletedElementsMap());
                else {
                    let m = !0;
                    !r.shiftKey && $e68ba20b3d2d159d$var$Qe(d, this.state) && (t.withCmdOrCtrl && t.hit.element ? this.setState((u)=>$e68ba20b3d2d159d$var$mr({
                            ...u,
                            selectedElementIds: {
                                [t.hit.element.id]: !0
                            }
                        }, this.scene.getNonDeletedElements(), u, this)) : m = !1);
                    let p = this.state.selectionElement ? $e68ba20b3d2d159d$var$Ll(d, this.state.selectionElement, this.scene.getNonDeletedElementsMap()) : [];
                    this.setState((u)=>{
                        let h = {
                            ...m && u.selectedElementIds,
                            ...p.reduce((g, b)=>(g[b.id] = !0, g), {})
                        };
                        return t.hit.element && (p.length ? delete h[t.hit.element.id] : h[t.hit.element.id] = !0), u = m ? u : {
                            ...u,
                            selectedGroupIds: {},
                            editingGroupId: null
                        }, {
                            ...$e68ba20b3d2d159d$var$mr({
                                editingGroupId: u.editingGroupId,
                                selectedElementIds: h
                            }, this.scene.getNonDeletedElements(), u, this),
                            selectedLinearElement: p.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(p[0]) ? new $e68ba20b3d2d159d$var$$(p[0]) : null,
                            showHyperlinkPopup: p.length === 1 && (p[0].link || $e68ba20b3d2d159d$var$Rt(p[0])) ? "info" : !1
                        };
                    });
                }
            }
        });
    }
    handlePointerMoveOverScrollbars(t, r) {
        if (r.scrollbars.isOverHorizontal) {
            let o = t.clientX, n = o - r.lastCoords.x;
            return this.translateCanvas({
                scrollX: this.state.scrollX - n / this.state.zoom.value
            }), r.lastCoords.x = o, !0;
        }
        if (r.scrollbars.isOverVertical) {
            let o = t.clientY, n = o - r.lastCoords.y;
            return this.translateCanvas({
                scrollY: this.state.scrollY - n / this.state.zoom.value
            }), r.lastCoords.y = o, !0;
        }
        return !1;
    }
    onPointerUpFromPointerDownHandler(t) {
        return $e68ba20b3d2d159d$var$Et((r)=>{
            this.removePointer(r), t.eventListeners.onMove && t.eventListeners.onMove.flush();
            let { newElement: o, resizingElement: n, multiElement: i, activeTool: a, isResizing: s, isRotating: l } = this.state;
            this.setState((u)=>({
                    isResizing: !1,
                    isRotating: !1,
                    resizingElement: null,
                    selectionElement: null,
                    frameToHighlight: null,
                    elementsToHighlight: null,
                    cursorButton: "up",
                    snapLines: $e68ba20b3d2d159d$var$Jm(u.snapLines, []),
                    originSnapOffset: null
                })), $e68ba20b3d2d159d$var$Uo.setReferenceSnapPoints(null), $e68ba20b3d2d159d$var$Uo.setVisibleGaps(null), this.savePointer(r.clientX, r.clientY, "up"), this.setState({
                selectedElementsAreBeingDragged: !1
            });
            let c = this.scene.getNonDeletedElementsMap();
            if (this.state.editingLinearElement) {
                if (!t.boxSelection.hasOccurred && t.hit?.element?.id !== this.state.editingLinearElement.elementId) this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                else {
                    let u = $e68ba20b3d2d159d$var$$.handlePointerUp(r, this.state.editingLinearElement, this.state, this.scene);
                    u !== this.state.editingLinearElement && this.setState({
                        editingLinearElement: u,
                        suggestedBindings: []
                    });
                }
            } else if (this.state.selectedLinearElement) {
                if (t.hit?.element?.id !== this.state.selectedLinearElement.elementId) this.scene.getSelectedElements(this.state).length > 1 && this.setState({
                    selectedLinearElement: null
                });
                else {
                    let u = $e68ba20b3d2d159d$var$$.handlePointerUp(r, this.state.selectedLinearElement, this.state, this.scene), { startBindingElement: h, endBindingElement: g } = u, b = this.scene.getElement(u.elementId);
                    $e68ba20b3d2d159d$var$qr(b) && $e68ba20b3d2d159d$var$as(b, h, g, c, this.scene), u !== this.state.selectedLinearElement && this.setState({
                        selectedLinearElement: {
                            ...u,
                            selectedPointsIndices: null
                        },
                        suggestedBindings: []
                    });
                }
            }
            if (this.missingPointerEventCleanupEmitter.clear(), window.removeEventListener("pointermove", t.eventListeners.onMove), window.removeEventListener("pointerup", t.eventListeners.onUp), window.removeEventListener("keydown", t.eventListeners.onKeyDown), window.removeEventListener("keyup", t.eventListeners.onKeyUp), this.state.pendingImageElementId && this.setState({
                pendingImageElementId: null
            }), this.props?.onPointerUp?.(a, t), this.onPointerUpEmitter.trigger(this.state.activeTool, t, r), o?.type === "freedraw") {
                let u = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(r, this.state), h = o.points, g = u.x - o.x, b = u.y - o.y;
                g === h[0][0] && b === h[0][1] && (b += 1e-4, g += 1e-4);
                let v = o.simulatePressure ? [] : [
                    ...o.pressures,
                    r.pressure
                ];
                $e68ba20b3d2d159d$export$55655e96a21bba2e(o, {
                    points: [
                        ...h,
                        [
                            g,
                            b
                        ]
                    ],
                    pressures: v,
                    lastCommittedPoint: [
                        g,
                        b
                    ]
                }), this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                return;
            }
            if ($e68ba20b3d2d159d$var$Ao(o)) {
                let u = o;
                try {
                    this.initializeImageDimensions(u), this.setState({
                        selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                            [u.id]: !0
                        }, this.state)
                    }, ()=>{
                        this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                    });
                } catch (h) {
                    console.error(h), this.scene.replaceAllElements(this.scene.getElementsIncludingDeleted().filter((g)=>g.id !== u.id)), this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
                }
                return;
            }
            if ($e68ba20b3d2d159d$export$5df2ebb939539835(o)) {
                o.points.length > 1 && this.store.shouldCaptureIncrement();
                let u = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(r, this.state);
                !t.drag.hasOccurred && o && !i ? ($e68ba20b3d2d159d$export$55655e96a21bba2e(o, {
                    points: [
                        ...o.points,
                        [
                            u.x - o.x,
                            u.y - o.y
                        ]
                    ]
                }), this.setState({
                    multiElement: o,
                    newElement: o
                })) : t.drag.hasOccurred && !i && ($e68ba20b3d2d159d$var$zn(this.state) && $e68ba20b3d2d159d$var$qr(o, !1) && $e68ba20b3d2d159d$var$jc(o, this.state, u, this.scene.getNonDeletedElementsMap(), this.scene.getNonDeletedElements()), this.setState({
                    suggestedBindings: [],
                    startBoundElement: null
                }), a.locked ? this.setState((h)=>({
                        newElement: null
                    })) : ($e68ba20b3d2d159d$var$uo(this.interactiveCanvas), this.setState((h)=>({
                        newElement: null,
                        activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                            type: "selection"
                        }),
                        selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                            ...h.selectedElementIds,
                            [o.id]: !0
                        }, h),
                        selectedLinearElement: new $e68ba20b3d2d159d$var$$(o)
                    }))), this.scene.triggerUpdate());
                return;
            }
            if ($e68ba20b3d2d159d$var$G(o)) {
                let u = $e68ba20b3d2d159d$var$Ul($e68ba20b3d2d159d$var$ke({
                    fontSize: o.fontSize,
                    fontFamily: o.fontFamily
                }), o.lineHeight);
                o.width < u && $e68ba20b3d2d159d$export$55655e96a21bba2e(o, {
                    autoResize: !0
                }), this.resetCursor(), this.handleTextWysiwyg(o, {
                    isExistingElement: !0
                });
            }
            if (a.type !== "selection" && o && $e68ba20b3d2d159d$export$2cab0e754c9472e0(o)) {
                this.updateScene({
                    elements: this.scene.getElementsIncludingDeleted().filter((u)=>u.id !== o.id),
                    appState: {
                        newElement: null
                    },
                    storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
                });
                return;
            }
            if ($e68ba20b3d2d159d$var$re(o)) {
                let u = $e68ba20b3d2d159d$var$UT(this.scene.getElementsIncludingDeleted(), o, this.scene.getNonDeletedElementsMap());
                this.scene.replaceAllElements($e68ba20b3d2d159d$var$Sd(this.scene.getElementsMapIncludingDeleted(), u, o));
            }
            if (o && ($e68ba20b3d2d159d$export$55655e96a21bba2e(o, $e68ba20b3d2d159d$var$rd(o)), this.scene.triggerUpdate()), t.drag.hasOccurred) {
                let u = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(r, this.state);
                if (this.state.selectedLinearElement && this.state.selectedLinearElement.isDragging) {
                    let h = this.scene.getElement(this.state.selectedLinearElement.elementId);
                    if (h?.frameId) {
                        let g = $e68ba20b3d2d159d$var$rr(h, c);
                        g && h && ($e68ba20b3d2d159d$var$No(h, g, this.scene.getNonDeletedElementsMap()) || ($e68ba20b3d2d159d$export$55655e96a21bba2e(h, {
                            groupIds: []
                        }), $e68ba20b3d2d159d$var$Pl([
                            h
                        ], this.scene.getNonDeletedElementsMap()), this.scene.triggerUpdate()));
                    }
                } else {
                    let h = this.getTopLayerFrameAtSceneCoords(u), g = this.scene.getSelectedElements(this.state), b = this.scene.getElementsMapIncludingDeleted(), v = (y)=>{
                        if (y.length > 0) {
                            for (let w of y){
                                let I = w.groupIds.indexOf(this.state.editingGroupId);
                                $e68ba20b3d2d159d$export$55655e96a21bba2e(w, {
                                    groupIds: w.groupIds.slice(0, I)
                                }, !1);
                            }
                            b.forEach((w)=>{
                                w.groupIds.length && $e68ba20b3d2d159d$var$nt(b, w.groupIds[w.groupIds.length - 1]).length < 2 && $e68ba20b3d2d159d$export$55655e96a21bba2e(w, {
                                    groupIds: []
                                }, !1);
                            }), this.setState({
                                editingGroupId: null
                            });
                        }
                    };
                    if (h && !this.state.selectedElementIds[h.id]) {
                        let y = g.filter((w)=>w.frameId !== h.id && $e68ba20b3d2d159d$var$ms(w, b, this.state));
                        this.state.editingGroupId && v(y), b = $e68ba20b3d2d159d$var$Sd(b, y, h);
                    } else if (!h && this.state.editingGroupId) {
                        let y = g.filter((w)=>w.frameId && !$e68ba20b3d2d159d$var$ms(w, b, this.state));
                        v(y);
                    }
                    b = $e68ba20b3d2d159d$var$Wn(b, this.state, this), this.scene.replaceAllElements(b);
                }
            }
            if (n && this.store.shouldCaptureIncrement(), n && $e68ba20b3d2d159d$export$2cab0e754c9472e0(n) && this.updateScene({
                elements: this.scene.getElementsIncludingDeleted().filter((u)=>u.id !== n.id),
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.UPDATE
            }), t.resize.isResizing) {
                let u = $e68ba20b3d2d159d$var$Wn(this.scene.getElementsIncludingDeleted(), this.state, this), h = this.scene.getSelectedElements(this.state).filter((g)=>$e68ba20b3d2d159d$var$re(g));
                for (let g of h)u = $e68ba20b3d2d159d$var$Nu(u, $e68ba20b3d2d159d$var$kl(this.scene.getElementsIncludingDeleted(), g, this.state, c), g, this);
                this.scene.replaceAllElements(u);
            }
            let d = t.hit.element;
            this.state.selectedLinearElement?.elementId !== d?.id && $e68ba20b3d2d159d$export$5df2ebb939539835(d) && this.scene.getSelectedElements(this.state).length === 1 && this.setState({
                selectedLinearElement: new $e68ba20b3d2d159d$var$$(d)
            });
            let m = this.lastPointerDownEvent, p = this.lastPointerUpEvent || this.lastPointerMoveEvent;
            if ($e68ba20b3d2d159d$var$Jr(this.state) && m && p) {
                if (this.eraserTrail.endPath(), $e68ba20b3d2d159d$var$Lt(m.clientX, m.clientY, p.clientX, p.clientY) === 0) {
                    let h = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
                        clientX: p.clientX,
                        clientY: p.clientY
                    }, this.state);
                    this.getElementsAtPosition(h.x, h.y).forEach((b)=>this.elementsPendingErasure.add(b.id));
                }
                this.eraseElements();
                return;
            } else this.elementsPendingErasure.size && this.restoreReadyToEraseElements();
            if (d && !t.drag.hasOccurred && !t.hit.wasAddedToSelection && (!this.state.editingLinearElement || !t.boxSelection.hasOccurred) && (r.shiftKey && !this.state.editingLinearElement ? this.state.selectedElementIds[d.id] ? $e68ba20b3d2d159d$var$np(this.state, d) ? this.setState((u)=>{
                let h = {
                    ...u.selectedElementIds
                };
                for (let g of d.groupIds.flatMap((b)=>$e68ba20b3d2d159d$var$nt(this.scene.getNonDeletedElements(), b)))delete h[g.id];
                return {
                    selectedGroupIds: {
                        ...u.selectedElementIds,
                        ...d.groupIds.map((g)=>({
                                [g]: !1
                            })).reduce((g, b)=>({
                                ...g,
                                ...b
                            }), {})
                    },
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe(h, u)
                };
            }) : this.state.selectedLinearElement?.isDragging || this.setState((u)=>{
                let h = {
                    ...u.selectedElementIds
                };
                delete h[d.id];
                let g = $e68ba20b3d2d159d$var$pe(this.scene.getNonDeletedElements(), {
                    selectedElementIds: h
                });
                return {
                    ...$e68ba20b3d2d159d$var$mr({
                        editingGroupId: u.editingGroupId,
                        selectedElementIds: h
                    }, this.scene.getNonDeletedElements(), u, this),
                    selectedLinearElement: g.length === 1 && $e68ba20b3d2d159d$export$5df2ebb939539835(g[0]) ? new $e68ba20b3d2d159d$var$$(g[0]) : u.selectedLinearElement
                };
            }) : d.frameId && this.state.selectedElementIds[d.frameId] ? this.setState((u)=>{
                let h = {
                    ...u.selectedElementIds,
                    [d.id]: !0
                };
                return delete h[d.frameId], (this.scene.getElement(d.frameId)?.groupIds ?? []).flatMap((g)=>$e68ba20b3d2d159d$var$nt(this.scene.getNonDeletedElements(), g)).forEach((g)=>{
                    delete h[g.id];
                }), {
                    ...$e68ba20b3d2d159d$var$mr({
                        editingGroupId: u.editingGroupId,
                        selectedElementIds: h
                    }, this.scene.getNonDeletedElements(), u, this),
                    showHyperlinkPopup: d.link || $e68ba20b3d2d159d$var$Rt(d) ? "info" : !1
                };
            }) : this.setState((u)=>({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        ...u.selectedElementIds,
                        [d.id]: !0
                    }, u)
                })) : this.setState((u)=>({
                    ...$e68ba20b3d2d159d$var$mr({
                        editingGroupId: u.editingGroupId,
                        selectedElementIds: {
                            [d.id]: !0
                        }
                    }, this.scene.getNonDeletedElements(), u, this),
                    selectedLinearElement: $e68ba20b3d2d159d$export$5df2ebb939539835(d) && u.selectedLinearElement?.elementId !== d.id ? new $e68ba20b3d2d159d$var$$(d) : u.selectedLinearElement
                }))), !t.drag.hasOccurred && !this.state.isResizing && (d && $e68ba20b3d2d159d$var$Z2({
                x: t.origin.x,
                y: t.origin.y,
                element: d,
                shape: $e68ba20b3d2d159d$var$sn(d, this.scene.getNonDeletedElementsMap()),
                threshold: this.getElementHitThreshold(),
                frameNameBound: $e68ba20b3d2d159d$var$re(d) ? this.frameNameBoundsCache.get(d) : null
            }, c) || !d && t.hit.hasHitCommonBoundingBoxOfSelectedElements)) {
                this.state.editingLinearElement ? this.setState({
                    editingLinearElement: null
                }) : this.setState({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
                    selectedGroupIds: {},
                    editingGroupId: null,
                    activeEmbeddable: null
                }), $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, $e68ba20b3d2d159d$var$Ue.AUTO);
                return;
            }
            if (!a.locked && a.type !== "freedraw" && o && this.setState((u)=>({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        ...u.selectedElementIds,
                        [o.id]: !0
                    }, u),
                    showHyperlinkPopup: $e68ba20b3d2d159d$var$Rt(o) && !o.link ? "editor" : u.showHyperlinkPopup
                })), (a.type !== "selection" || $e68ba20b3d2d159d$var$Qe(this.scene.getNonDeletedElements(), this.state) || !$e68ba20b3d2d159d$var$at(this.state.previousSelectedElementIds, this.state.selectedElementIds)) && this.store.shouldCaptureIncrement(), t.drag.hasOccurred || s || l) {
                let u = this.scene.getSelectedElements(this.state).filter($e68ba20b3d2d159d$export$5df2ebb939539835);
                $e68ba20b3d2d159d$var$ss(u, this.scene.getNonDeletedElementsMap(), this.scene.getNonDeletedElements(), this.scene, $e68ba20b3d2d159d$var$zn(this.state), this.state.selectedLinearElement?.selectedPointsIndices ?? []);
            }
            if (a.type === "laser") {
                this.laserTrails.endPath();
                return;
            }
            !a.locked && a.type !== "freedraw" ? ($e68ba20b3d2d159d$var$uo(this.interactiveCanvas), this.setState({
                newElement: null,
                suggestedBindings: [],
                activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                    type: "selection"
                })
            })) : this.setState({
                newElement: null,
                suggestedBindings: []
            }), d && this.lastPointerUpEvent && this.lastPointerDownEvent && this.lastPointerUpEvent.timeStamp - this.lastPointerDownEvent.timeStamp < 300 && $e68ba20b3d2d159d$var$Ve.pointers.size <= 1 && $e68ba20b3d2d159d$var$cr(d) && this.isIframeLikeElementCenter(d, this.lastPointerUpEvent, t.origin.x, t.origin.y) && this.handleEmbeddableCenterClick(d);
        });
    }
    restoreReadyToEraseElements = ()=>{
        this.elementsPendingErasure = new Set, this.triggerRender();
    };
    eraseElements = ()=>{
        let t = !1, r = this.scene.getElementsIncludingDeleted().map((o)=>this.elementsPendingErasure.has(o.id) || o.frameId && this.elementsPendingErasure.has(o.frameId) || $e68ba20b3d2d159d$var$Ge(o) && this.elementsPendingErasure.has(o.containerId) ? (t = !0, $e68ba20b3d2d159d$export$5390fab1c98104d7(o, {
                isDeleted: !0
            })) : o);
        this.elementsPendingErasure = new Set, t && (this.store.shouldCaptureIncrement(), this.scene.replaceAllElements(r));
    };
    initializeImage = async ({ imageFile: t, imageElement: r, showCursorImagePreview: o = !1 })=>{
        if (!$e68ba20b3d2d159d$var$ra(t)) throw new Error($e68ba20b3d2d159d$var$x("errors.unsupportedFileType"));
        let n = t.type;
        if ($e68ba20b3d2d159d$var$qe(this.interactiveCanvas, "wait"), n === $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg) try {
            t = $e68ba20b3d2d159d$var$fE(await $e68ba20b3d2d159d$var$hT(await t.text()), t.name);
        } catch (c) {
            throw console.warn(c), new Error($e68ba20b3d2d159d$var$x("errors.svgImageInsertError"));
        }
        let i = await (this.props.generateIdForFile?.(t) || $e68ba20b3d2d159d$var$Tv(t));
        if (!i) throw console.warn("Couldn't generate file id or the supplied `generateIdForFile` didn't resolve to one."), new Error($e68ba20b3d2d159d$var$x("errors.imageInsertError"));
        if (!this.files[i]?.dataURL) {
            try {
                t = await $e68ba20b3d2d159d$var$id(t, {
                    maxWidthOrHeight: $e68ba20b3d2d159d$var$D0
                });
            } catch (c) {
                console.error("Error trying to resizing image file on insertion", c);
            }
            if (t.size > $e68ba20b3d2d159d$var$rf) throw new Error($e68ba20b3d2d159d$var$x("errors.fileTooBig", {
                maxSize: `${Math.trunc($e68ba20b3d2d159d$var$rf / 1024 / 1024)}MB`
            }));
        }
        if (o) {
            let c = this.files[i]?.dataURL, d = c && $e68ba20b3d2d159d$var$Sv(c);
            this.setImagePreviewCursor(d || t);
        }
        let s = this.files[i]?.dataURL || await $e68ba20b3d2d159d$export$7a55ad1e8bd07594(t), l = $e68ba20b3d2d159d$export$55655e96a21bba2e(r, {
            fileId: i
        }, !1);
        return new Promise(async (c, d)=>{
            try {
                this.files = {
                    ...this.files,
                    [i]: {
                        mimeType: n,
                        id: i,
                        dataURL: s,
                        created: Date.now(),
                        lastRetrieved: Date.now()
                    }
                };
                let m = this.imageCache.get(i);
                m || (this.addNewImagesToImageCache(), await this.updateImageCache([
                    l
                ])), m?.image instanceof Promise && await m.image, this.state.pendingImageElementId !== l.id && this.state.newElement?.id !== l.id && this.initializeImageDimensions(l, !0), c(l);
            } catch (m) {
                console.error(m), d(new Error($e68ba20b3d2d159d$var$x("errors.imageInsertError")));
            } finally{
                o || $e68ba20b3d2d159d$var$uo(this.interactiveCanvas);
            }
        });
    };
    insertImageElement = async (t, r, o)=>{
        if (!this.isToolSupported("image")) {
            this.setState({
                errorMessage: $e68ba20b3d2d159d$var$x("errors.imageToolNotSupported")
            });
            return;
        }
        this.scene.insertElement(t);
        try {
            return await this.initializeImage({
                imageFile: r,
                imageElement: t,
                showCursorImagePreview: o
            });
        } catch (n) {
            return $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                isDeleted: !0
            }), this.actionManager.executeAction($e68ba20b3d2d159d$var$wo), this.setState({
                errorMessage: n.message || $e68ba20b3d2d159d$var$x("errors.imageInsertError")
            }), null;
        }
    };
    setImagePreviewCursor = async (t)=>{
        let o;
        try {
            o = await $e68ba20b3d2d159d$var$id(t, {
                maxWidthOrHeight: 96
            });
        } catch (i) {
            throw i.cause === "UNSUPPORTED" ? new Error($e68ba20b3d2d159d$var$x("errors.unsupportedFileType")) : i;
        }
        let n = await $e68ba20b3d2d159d$export$7a55ad1e8bd07594(o);
        if (t.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg) {
            let i = await $e68ba20b3d2d159d$var$vE(n), a = Math.min(i.height, 96), s = a * (i.width / i.height);
            s > 96 && (s = 96, a = s * (i.height / i.width));
            let l = document.createElement("canvas");
            l.height = a, l.width = s, l.getContext("2d").drawImage(i, 0, 0, s, a), n = l.toDataURL($e68ba20b3d2d159d$export$edfb5d7e4280f611.svg);
        }
        this.state.pendingImageElementId && $e68ba20b3d2d159d$var$qe(this.interactiveCanvas, `url(${n}) 4 4, auto`);
    };
    onImageAction = async ({ insertOnCanvasDirectly: t })=>{
        try {
            let r = this.state.width / 2 + this.state.offsetLeft, o = this.state.height / 2 + this.state.offsetTop, { x: n, y: i } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
                clientX: r,
                clientY: o
            }, this.state), a = await $e68ba20b3d2d159d$var$rl({
                description: "Image",
                extensions: Object.keys($e68ba20b3d2d159d$var$Cc)
            }), s = this.createImageElement({
                sceneX: n,
                sceneY: i,
                addToFrameUnderCursor: !1
            });
            t ? (this.insertImageElement(s, a), this.initializeImageDimensions(s), this.setState({
                selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                    [s.id]: !0
                }, this.state)
            }, ()=>{
                this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
            })) : this.setState({
                pendingImageElementId: s.id
            }, ()=>{
                this.insertImageElement(s, a, !0);
            });
        } catch (r) {
            r.name !== "AbortError" ? console.error(r) : console.warn(r), this.setState({
                pendingImageElementId: null,
                newElement: null,
                activeTool: $e68ba20b3d2d159d$var$it(this.state, {
                    type: "selection"
                })
            }, ()=>{
                this.actionManager.executeAction($e68ba20b3d2d159d$var$wo);
            });
        }
    };
    initializeImageDimensions = (t, r = !1)=>{
        let o = $e68ba20b3d2d159d$var$Nr(t) && this.imageCache.get(t.fileId)?.image;
        if (!o || o instanceof Promise) {
            if (t.width < $e68ba20b3d2d159d$var$ii / this.state.zoom.value && t.height < $e68ba20b3d2d159d$var$ii / this.state.zoom.value) {
                let n = 100 / this.state.zoom.value;
                $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                    x: t.x - n / 2,
                    y: t.y - n / 2,
                    width: n,
                    height: n
                });
            }
            return;
        }
        if (r || t.width < $e68ba20b3d2d159d$var$ii / this.state.zoom.value && t.height < $e68ba20b3d2d159d$var$ii / this.state.zoom.value) {
            let n = Math.max(this.state.height - 120, 160), i = Math.min(n, Math.floor(this.state.height * .5) / this.state.zoom.value), a = Math.min(o.naturalHeight, i), s = a * (o.naturalWidth / o.naturalHeight), l = t.x + t.width / 2 - s / 2, c = t.y + t.height / 2 - a / 2;
            $e68ba20b3d2d159d$export$55655e96a21bba2e(t, {
                x: l,
                y: c,
                width: s,
                height: a
            });
        }
    };
    updateImageCache = async (t, r = this.files)=>{
        let { updatedFiles: o, erroredFiles: n } = await $e68ba20b3d2d159d$var$Eu({
            imageCache: this.imageCache,
            fileIds: t.map((i)=>i.fileId),
            files: r
        });
        if (o.size || n.size) for (let i of t)o.has(i.fileId) && $e68ba20b3d2d159d$var$Oe.delete(i);
        return n.size && this.scene.replaceAllElements(this.scene.getElementsIncludingDeleted().map((i)=>$e68ba20b3d2d159d$var$Nr(i) && n.has(i.fileId) ? $e68ba20b3d2d159d$export$5390fab1c98104d7(i, {
                status: "error"
            }) : i)), {
            updatedFiles: o,
            erroredFiles: n
        };
    };
    addNewImagesToImageCache = async (t = $e68ba20b3d2d159d$var$xu(this.scene.getNonDeletedElements()), r = this.files)=>{
        let o = t.filter((n)=>!n.isDeleted && !this.imageCache.has(n.fileId));
        if (o.length) {
            let { updatedFiles: n } = await this.updateImageCache(o, r);
            n.size && this.scene.triggerUpdate();
        }
    };
    scheduleImageRefresh = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))(()=>{
        this.addNewImagesToImageCache();
    }, $e68ba20b3d2d159d$var$v0);
    updateBindingEnabledOnPointerMove = (t)=>{
        let r = $e68ba20b3d2d159d$var$ev(t);
        this.state.isBindingEnabled !== r && this.setState({
            isBindingEnabled: r
        });
    };
    maybeSuggestBindingAtCursor = (t)=>{
        let r = $e68ba20b3d2d159d$var$Ir(t, this.scene.getNonDeletedElements(), this.scene.getNonDeletedElementsMap());
        this.setState({
            suggestedBindings: r != null ? [
                r
            ] : []
        });
    };
    maybeSuggestBindingsForLinearElementAtCoords = (t, r, o)=>{
        if (!r.length) return;
        let n = r.reduce((i, a)=>{
            let s = $e68ba20b3d2d159d$var$Ir(a, this.scene.getNonDeletedElements(), this.scene.getNonDeletedElementsMap(), $e68ba20b3d2d159d$var$ie(t) && $e68ba20b3d2d159d$var$ce(t));
            return s != null && !$e68ba20b3d2d159d$var$oE(t, o?.id, s) && i.push(s), i;
        }, []);
        this.setState({
            suggestedBindings: n
        });
    };
    clearSelection(t) {
        this.setState((r)=>({
                selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, r),
                activeEmbeddable: null,
                selectedGroupIds: {},
                editingGroupId: r.editingGroupId && t != null && $e68ba20b3d2d159d$var$Ga(t, r.editingGroupId) ? r.editingGroupId : null
            })), this.setState({
            selectedElementIds: $e68ba20b3d2d159d$var$Fe({}, this.state),
            activeEmbeddable: null,
            previousSelectedElementIds: this.state.selectedElementIds
        });
    }
    handleInteractiveCanvasRef = (t)=>{
        t !== null ? (this.interactiveCanvas = t, this.interactiveCanvas.addEventListener("touchstart", this.onTouchStart), this.interactiveCanvas.addEventListener("touchend", this.onTouchEnd)) : (this.interactiveCanvas?.removeEventListener("touchstart", this.onTouchStart), this.interactiveCanvas?.removeEventListener("touchend", this.onTouchEnd));
    };
    handleAppOnDrop = async (t)=>{
        let { file: r, fileHandle: o } = await $e68ba20b3d2d159d$var$Cv(t), { x: n, y: i } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state);
        try {
            if ($e68ba20b3d2d159d$var$ra(r) && this.isToolSupported("image")) {
                if (r?.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.png || r?.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.svg) try {
                    let l = await $e68ba20b3d2d159d$export$d8a4a83cfacbdff0(r, this.state, this.scene.getElementsIncludingDeleted(), o);
                    this.syncActionResult({
                        ...l,
                        appState: {
                            ...l.appState || this.state,
                            isLoading: !1
                        },
                        replaceFiles: !0,
                        storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
                    });
                    return;
                } catch (l) {
                    if (l.name !== "EncodingError") throw new Error($e68ba20b3d2d159d$var$x("alerts.couldNotLoadInvalidFile"));
                }
                let s = this.createImageElement({
                    sceneX: n,
                    sceneY: i
                });
                this.insertImageElement(s, r), this.initializeImageDimensions(s), this.setState({
                    selectedElementIds: $e68ba20b3d2d159d$var$Fe({
                        [s.id]: !0
                    }, this.state)
                });
                return;
            }
        } catch (s) {
            return this.setState({
                isLoading: !1,
                errorMessage: s.message
            });
        }
        let a = t.dataTransfer.getData($e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib);
        if (a && typeof a == "string") {
            try {
                let s = $e68ba20b3d2d159d$var$hE(a);
                this.addElementsFromPasteOrLibrary({
                    elements: $e68ba20b3d2d159d$var$zh(s),
                    position: t,
                    files: null
                });
            } catch (s) {
                this.setState({
                    errorMessage: s.message
                });
            }
            return;
        }
        if (r && await this.loadFileToCanvas(r, o), t.dataTransfer?.types?.includes("text/plain")) {
            let s = t.dataTransfer?.getData("text");
            if (s && $e68ba20b3d2d159d$var$yl(s, this.props.validateEmbeddable) && (/^(http|https):\/\/[^\s/$.?#].[^\s]*$/.test(s) || $e68ba20b3d2d159d$var$bi(s)?.type === "video")) {
                let l = this.insertEmbeddableElement({
                    sceneX: n,
                    sceneY: i,
                    link: $e68ba20b3d2d159d$export$fc49cccc588ff0d4(s)
                });
                l && this.setState({
                    selectedElementIds: {
                        [l.id]: !0
                    }
                });
            }
        }
    };
    loadFileToCanvas = async (t, r)=>{
        t = await $e68ba20b3d2d159d$var$Hc(t);
        try {
            let o = this.scene.getElementsIncludingDeleted(), n;
            try {
                n = await $e68ba20b3d2d159d$export$d9e5f6de300e0e24(t, this.state, o, r);
            } catch (i) {
                let a = i instanceof $e68ba20b3d2d159d$var$qo;
                if (a && i.code === "IMAGE_NOT_CONTAINS_SCENE_DATA" && !this.isToolSupported("image")) {
                    this.setState({
                        isLoading: !1,
                        errorMessage: $e68ba20b3d2d159d$var$x("errors.imageToolNotSupported")
                    });
                    return;
                }
                let s = a ? $e68ba20b3d2d159d$var$x("alerts.cannotRestoreFromImage") : $e68ba20b3d2d159d$var$x("alerts.couldNotLoadInvalidFile");
                this.setState({
                    isLoading: !1,
                    errorMessage: s
                });
            }
            if (!n) return;
            n.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidraw ? ($e68ba20b3d2d159d$var$Cr(o.concat(n.data.elements)), this.store.updateSnapshot($e68ba20b3d2d159d$var$j(o), this.state), this.setState({
                isLoading: !0
            }), this.syncActionResult({
                ...n.data,
                appState: {
                    ...n.data.appState || this.state,
                    isLoading: !1
                },
                replaceFiles: !0,
                storeAction: $e68ba20b3d2d159d$export$85f9bb8d5701581c.CAPTURE
            })) : n.type === $e68ba20b3d2d159d$export$edfb5d7e4280f611.excalidrawlib && await this.library.updateLibrary({
                libraryItems: t,
                merge: !0,
                openLibraryMenu: !0
            }).catch((i)=>{
                console.error(i), this.setState({
                    errorMessage: $e68ba20b3d2d159d$var$x("errors.importLibraryError")
                });
            });
        } catch (o) {
            this.setState({
                isLoading: !1,
                errorMessage: o.message
            });
        }
    };
    handleCanvasContextMenu = (t)=>{
        if (t.preventDefault(), ("pointerType" in t.nativeEvent && t.nativeEvent.pointerType === "touch" || "pointerType" in t.nativeEvent && t.nativeEvent.pointerType === "pen" && t.button !== $e68ba20b3d2d159d$var$Cn.SECONDARY) && this.state.activeTool.type !== "selection") return;
        let { x: r, y: o } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d(t, this.state), n = this.getElementAtPosition(r, o, {
            preferSelected: !0,
            includeLockedElements: !0
        }), i = this.scene.getSelectedElements(this.state), a = this.isHittingCommonBoundingBoxOfSelectedElements({
            x: r,
            y: o
        }, i), s = n || a ? "element" : "canvas", l = this.excalidrawContainerRef.current, { top: c, left: d } = l.getBoundingClientRect(), m = t.clientX - d, p = t.clientY - c;
        $e68ba20b3d2d159d$var$Pe("contextMenu", "openContextMenu", s), this.setState({
            ...n && !this.state.selectedElementIds[n.id] ? {
                ...this.state,
                ...$e68ba20b3d2d159d$var$mr({
                    editingGroupId: this.state.editingGroupId,
                    selectedElementIds: {
                        [n.id]: !0
                    }
                }, this.scene.getNonDeletedElements(), this.state, this),
                selectedLinearElement: $e68ba20b3d2d159d$export$5df2ebb939539835(n) ? new $e68ba20b3d2d159d$var$$(n) : null
            } : this.state,
            showHyperlinkPopup: !1
        }, ()=>{
            this.setState({
                contextMenu: {
                    top: p,
                    left: m,
                    items: this.getContextMenuItems(s)
                }
            });
        });
    };
    maybeDragNewGenericElement = (t, r, o = !0)=>{
        let n = this.state.selectionElement, i = t.lastCoords;
        if (n && this.state.activeTool.type !== "eraser") {
            $e68ba20b3d2d159d$var$nh({
                newElement: n,
                elementType: this.state.activeTool.type,
                originX: t.origin.x,
                originY: t.origin.y,
                x: i.x,
                y: i.y,
                width: $e68ba20b3d2d159d$var$Wt(t.origin.x, i.x),
                height: $e68ba20b3d2d159d$var$Wt(t.origin.y, i.y),
                shouldMaintainAspectRatio: $e68ba20b3d2d159d$var$pl(r),
                shouldResizeFromCenter: $e68ba20b3d2d159d$var$Bp(r),
                zoom: this.state.zoom.value,
                informMutation: o
            });
            return;
        }
        let a = this.state.newElement;
        if (!a) return;
        let [s, l] = $e68ba20b3d2d159d$var$Ot(i.x, i.y, r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), c = $e68ba20b3d2d159d$var$Nr(a) && this.imageCache.get(a.fileId)?.image, d = c && !(c instanceof Promise) ? c.width / c.height : null;
        this.maybeCacheReferenceSnapPoints(r, [
            a
        ]);
        let { snapOffset: m, snapLines: p } = $e68ba20b3d2d159d$var$BC(a, this, r, {
            x: t.originInGrid.x + (this.state.originSnapOffset?.x ?? 0),
            y: t.originInGrid.y + (this.state.originSnapOffset?.y ?? 0)
        }, {
            x: s - t.originInGrid.x,
            y: l - t.originInGrid.y
        }, this.scene.getNonDeletedElementsMap());
        s += m.x, l += m.y, this.setState({
            snapLines: p
        }), $e68ba20b3d2d159d$var$nh({
            newElement: a,
            elementType: this.state.activeTool.type,
            originX: t.originInGrid.x,
            originY: t.originInGrid.y,
            x: s,
            y: l,
            width: $e68ba20b3d2d159d$var$Wt(t.originInGrid.x, s),
            height: $e68ba20b3d2d159d$var$Wt(t.originInGrid.y, l),
            shouldMaintainAspectRatio: $e68ba20b3d2d159d$var$Ao(a) ? !$e68ba20b3d2d159d$var$pl(r) : $e68ba20b3d2d159d$var$pl(r),
            shouldResizeFromCenter: $e68ba20b3d2d159d$var$Bp(r),
            zoom: this.state.zoom.value,
            widthAspectRatio: d,
            originOffset: this.state.originSnapOffset,
            informMutation: o
        }), this.setState({
            newElement: a
        }), (this.state.activeTool.type === $e68ba20b3d2d159d$var$St.frame || this.state.activeTool.type === $e68ba20b3d2d159d$var$St.magicframe) && this.setState({
            elementsToHighlight: $e68ba20b3d2d159d$var$kl(this.scene.getNonDeletedElements(), a, this.state, this.scene.getNonDeletedElementsMap())
        });
    };
    maybeHandleResize = (t, r)=>{
        let o = this.scene.getSelectedElements(this.state), n = o.filter((d)=>$e68ba20b3d2d159d$var$re(d)), i = t.resize.handleType;
        if (n.length > 0 && i === "rotation" || o.length === 1 && $e68ba20b3d2d159d$var$ce(o[0])) return !1;
        this.setState({
            isResizing: i && i !== "rotation",
            isRotating: i === "rotation",
            activeEmbeddable: null
        });
        let a = t.lastCoords, [s, l] = $e68ba20b3d2d159d$var$Ot(a.x - t.resize.offset.x, a.y - t.resize.offset.y, r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), c = new Map;
        if (n.forEach((d)=>{
            $e68ba20b3d2d159d$var$bo(this.scene.getNonDeletedElements(), d.id).forEach((p)=>{
                c.set(d.id + p.id, {
                    x: p.x - d.x,
                    y: p.y - d.y
                });
            });
        }), !this.state.selectedElementsAreBeingDragged) {
            let [d, m] = $e68ba20b3d2d159d$var$Ot(a.x, a.y, r[$e68ba20b3d2d159d$var$S.CTRL_OR_CMD] ? null : this.getEffectiveGridSize()), p = {
                x: d - t.originInGrid.x,
                y: m - t.originInGrid.y
            }, u = [
                ...t.originalElements.values()
            ];
            this.maybeCacheReferenceSnapPoints(r, o);
            let { snapOffset: h, snapLines: g } = $e68ba20b3d2d159d$var$FC(o, $e68ba20b3d2d159d$var$pe(u, this.state), this, r, p, i);
            s += h.x, l += h.y, this.setState({
                snapLines: g
            });
        }
        if ($e68ba20b3d2d159d$var$ix(t.originalElements, i, o, this.scene.getElementsMapIncludingDeleted(), $e68ba20b3d2d159d$var$os(r), $e68ba20b3d2d159d$var$Bp(r), o.some((d)=>$e68ba20b3d2d159d$var$Ao(d)) ? !$e68ba20b3d2d159d$var$pl(r) : $e68ba20b3d2d159d$var$pl(r), s, l, t.resize.center.x, t.resize.center.y)) {
            let d = $e68ba20b3d2d159d$var$jp(o, this.scene.getNonDeletedElementsMap()), m = new Set;
            return n.forEach((p)=>{
                $e68ba20b3d2d159d$var$kl(this.scene.getNonDeletedElements(), p, this.state, this.scene.getNonDeletedElementsMap()).forEach((u)=>m.add(u));
            }), this.setState({
                elementsToHighlight: [
                    ...m
                ],
                suggestedBindings: d
            }), !0;
        }
        return !1;
    };
    getContextMenuItems = (t)=>{
        let r = [];
        return r.push($e68ba20b3d2d159d$var$Lh, $e68ba20b3d2d159d$var$Ph), t === "canvas" ? this.state.viewModeEnabled ? [
            ...r,
            $e68ba20b3d2d159d$var$_h,
            $e68ba20b3d2d159d$var$tc,
            $e68ba20b3d2d159d$var$I1,
            $e68ba20b3d2d159d$var$rc
        ] : [
            $e68ba20b3d2d159d$var$nb,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$Lh,
            $e68ba20b3d2d159d$var$Ph,
            $e68ba20b3d2d159d$var$Dh,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$Tx,
            $e68ba20b3d2d159d$var$fI,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$_h,
            $e68ba20b3d2d159d$var$ib,
            $e68ba20b3d2d159d$var$tc,
            $e68ba20b3d2d159d$var$I1,
            $e68ba20b3d2d159d$var$rc
        ] : (r.push($e68ba20b3d2d159d$var$Dh), this.state.viewModeEnabled ? [
            $e68ba20b3d2d159d$var$ec,
            ...r
        ] : [
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$kh,
            $e68ba20b3d2d159d$var$ec,
            $e68ba20b3d2d159d$var$nb,
            $e68ba20b3d2d159d$var$MA,
            $e68ba20b3d2d159d$var$kA,
            $e68ba20b3d2d159d$var$Lr,
            ...r,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$jx,
            $e68ba20b3d2d159d$var$qx,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$Jx,
            $e68ba20b3d2d159d$var$qA,
            $e68ba20b3d2d159d$var$ab,
            $e68ba20b3d2d159d$var$sb,
            $e68ba20b3d2d159d$var$lI,
            $e68ba20b3d2d159d$var$Qx,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$tb,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$bx,
            $e68ba20b3d2d159d$var$yx,
            $e68ba20b3d2d159d$var$wx,
            $e68ba20b3d2d159d$var$vx,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$rb,
            $e68ba20b3d2d159d$var$ob,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$Ob,
            $e68ba20b3d2d159d$var$em,
            $e68ba20b3d2d159d$var$Sx,
            $e68ba20b3d2d159d$var$ub,
            $e68ba20b3d2d159d$var$Lr,
            $e68ba20b3d2d159d$var$Gd
        ]);
    };
    handleWheel = $e68ba20b3d2d159d$var$Et((t)=>{
        if (!(t.target instanceof HTMLCanvasElement || t.target instanceof HTMLTextAreaElement || t.target instanceof HTMLIFrameElement) || (t.preventDefault(), $e68ba20b3d2d159d$var$xm)) return;
        let { deltaX: r, deltaY: o } = t;
        if (t.metaKey || t.ctrlKey) {
            let n = Math.sign(o), i = $e68ba20b3d2d159d$var$Ba * 100, a = Math.abs(o), s = o;
            a > i && (s = i * n);
            let l = this.state.zoom.value - s / 100;
            l += Math.log10(Math.max(1, this.state.zoom.value)) * -n * Math.min(1, a / 20), this.translateCanvas((c)=>({
                    ...$e68ba20b3d2d159d$var$Ai({
                        viewportX: this.lastViewportPosition.x,
                        viewportY: this.lastViewportPosition.y,
                        nextZoom: $e68ba20b3d2d159d$var$to(l)
                    }, c),
                    shouldCacheIgnoreZoom: !0
                })), this.resetShouldCacheIgnoreZoomDebounced();
            return;
        }
        if (t.shiftKey) {
            this.translateCanvas(({ zoom: n, scrollX: i })=>({
                    scrollX: i - (o || r) / n.value
                }));
            return;
        }
        this.translateCanvas(({ zoom: n, scrollX: i, scrollY: a })=>({
                scrollX: i - r / n.value,
                scrollY: a - o / n.value
            }));
    });
    getTextWysiwygSnappedToCenterPosition(t, r, o, n) {
        if (n) {
            let i = n.x + n.width / 2, a = n.y + n.height / 2, s = $e68ba20b3d2d159d$var$$u(n, o, this.scene.getNonDeletedElementsMap());
            if (s && (i = s.x, a = s.y), Math.hypot(t - i, r - a) < $e68ba20b3d2d159d$var$E0) {
                let { x: d, y: m } = $e68ba20b3d2d159d$export$a4a3582487786f33({
                    sceneX: i,
                    sceneY: a
                }, o);
                return {
                    viewportX: d,
                    viewportY: m,
                    elementCenterX: i,
                    elementCenterY: a
                };
            }
        }
    }
    savePointer = (t, r, o)=>{
        if (!t || !r) return;
        let { x: n, y: i } = $e68ba20b3d2d159d$export$ae5c444d4333ce2d({
            clientX: t,
            clientY: r
        }, this.state);
        isNaN(n) || isNaN(i);
        let a = {
            x: n,
            y: i,
            tool: this.state.activeTool.type === "laser" ? "laser" : "pointer"
        };
        this.props.onPointerUpdate?.({
            pointer: a,
            button: o,
            pointersMap: $e68ba20b3d2d159d$var$Ve.pointers
        });
    };
    resetShouldCacheIgnoreZoomDebounced = $e68ba20b3d2d159d$var$si(()=>{
        this.unmounted || this.setState({
            shouldCacheIgnoreZoom: !1
        });
    }, 300);
    updateDOMRect = (t)=>{
        if (this.excalidrawContainerRef?.current) {
            let r = this.excalidrawContainerRef.current, { width: o, height: n, left: i, top: a } = r.getBoundingClientRect(), { width: s, height: l, offsetTop: c, offsetLeft: d } = this.state;
            if (o === s && n === l && i === d && a === c) {
                t && t();
                return;
            }
            this.setState({
                width: o,
                height: n,
                offsetLeft: i,
                offsetTop: a
            }, ()=>{
                t && t();
            });
        }
    };
    refresh = ()=>{
        this.setState({
            ...this.getCanvasOffsets()
        });
    };
    getCanvasOffsets() {
        if (this.excalidrawContainerRef?.current) {
            let t = this.excalidrawContainerRef.current, { left: r, top: o } = t.getBoundingClientRect();
            return {
                offsetLeft: r,
                offsetTop: o
            };
        }
        return {
            offsetLeft: 0,
            offsetTop: 0
        };
    }
    async updateLanguage() {
        let t = $e68ba20b3d2d159d$export$d0d68bb9ed2c643d.find((r)=>r.code === this.props.langCode) || $e68ba20b3d2d159d$export$811af2a4ddb5af35;
        await $e68ba20b3d2d159d$var$Cm(t), this.setAppState({});
    }
}, $e68ba20b3d2d159d$var$aO = ()=>{
    ($e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST || $e68ba20b3d2d159d$var$T.DEV) && (window.h = window.h || {}, Object.defineProperties(window.h, {
        elements: {
            configurable: !0,
            get () {
                return this.app?.scene.getElementsIncludingDeleted();
            },
            set (e) {
                return this.app?.scene.replaceAllElements($e68ba20b3d2d159d$var$Cr(e));
            }
        },
        scene: {
            configurable: !0,
            get () {
                return this.app?.scene;
            }
        }
    }));
};
$e68ba20b3d2d159d$var$aO();
var $e68ba20b3d2d159d$var$l6 = $e68ba20b3d2d159d$var$B1;
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$lO = ()=>{
    Array.prototype.at || Object.defineProperty(Array.prototype, "at", {
        value: function(e) {
            if (e = Math.trunc(e) || 0, e < 0 && (e += this.length), !(e < 0 || e >= this.length)) return this[e];
        },
        writable: !0,
        enumerable: !1,
        configurable: !0
    }), Element.prototype.replaceChildren || (Element.prototype.replaceChildren = function(...e) {
        this.innerHTML = "", this.append(...e);
    });
}, $e68ba20b3d2d159d$var$c6 = $e68ba20b3d2d159d$var$lO;
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$m6 = ({ children: e })=>{
    let { FooterCenterTunnel: t } = $e68ba20b3d2d159d$var$pt(), r = $e68ba20b3d2d159d$var$Ke();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("footer-center zen-mode-transition", {
                "layer-ui__wrapper__footer-left--transition-bottom": r.zenModeEnabled
            }),
            children: e
        })
    });
}, $e68ba20b3d2d159d$export$a06f1c675e846f6f = $e68ba20b3d2d159d$var$m6;
$e68ba20b3d2d159d$var$m6.displayName = "FooterCenter";
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$var$mO = ()=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "ExcalidrawLogo-icon",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M39.9 32.889a.326.326 0 0 0-.279-.056c-2.094-3.083-4.774-6-7.343-8.833l-.419-.472a.212.212 0 0 0-.056-.139.586.586 0 0 0-.167-.111l-.084-.083-.056-.056c-.084-.167-.28-.278-.475-.167-.782.39-1.507.973-2.206 1.528-.92.722-1.842 1.445-2.708 2.25a8.405 8.405 0 0 0-.977 1.028c-.14.194-.028.361.14.444-.615.611-1.23 1.223-1.843 1.861a.315.315 0 0 0-.084.223c0 .083.056.166.111.194l1.09.833v.028c1.535 1.528 4.244 3.611 7.12 5.861.418.334.865.667 1.284 1 .195.223.39.473.558.695.084.11.28.139.391.055.056.056.14.111.196.167a.398.398 0 0 0 .167.056.255.255 0 0 0 .224-.111.394.394 0 0 0 .055-.167c.029 0 .028.028.056.028a.318.318 0 0 0 .224-.084l5.082-5.528a.309.309 0 0 0 0-.444Zm-14.63-1.917a.485.485 0 0 0 .111.14c.586.5 1.2 1 1.843 1.555l-2.569-1.945-.251-.166c-.056-.028-.112-.084-.168-.111l-.195-.167.056-.056.055-.055.112-.111c.866-.861 2.346-2.306 3.1-3.028-.81.805-2.43 3.167-2.095 3.944Zm8.767 6.89-2.122-1.612a44.713 44.713 0 0 0-2.625-2.5c1.145.861 2.122 1.611 2.262 1.75 1.117.972 1.06.806 1.815 1.445l.921.666a1.06 1.06 0 0 1-.251.25Zm.558.416-.056-.028c.084-.055.168-.111.252-.194l-.196.222ZM1.089 5.75c.055.361.14.722.195 1.056.335 1.833.67 3.5 1.284 4.75l.252.944c.084.361.223.806.363.917 1.424 1.25 3.602 3.11 5.947 4.889a.295.295 0 0 0 .363 0s0 .027.028.027a.254.254 0 0 0 .196.084.318.318 0 0 0 .223-.084c2.988-3.305 5.221-6.027 6.813-8.305.112-.111.14-.278.14-.417.111-.111.195-.25.307-.333.111-.111.111-.306 0-.39l-.028-.027c0-.055-.028-.139-.084-.167-.698-.666-1.2-1.138-1.731-1.638-.922-.862-1.871-1.75-3.881-3.75l-.028-.028c-.028-.028-.056-.056-.112-.056-.558-.194-1.703-.389-3.127-.639C6.087 2.223 3.21 1.723.614.944c0 0-.168 0-.196.028l-.083.084c-.028.027-.056.055-.224.11h.056-.056c.028.167.028.278.084.473 0 .055.112.5.112.555l.782 3.556Zm15.496 3.278-.335-.334c.084.112.196.195.335.334Zm-3.546 4.666-.056.056c0-.028.028-.056.056-.056Zm-2.038-10c.168.167.866.834 1.033.973-.726-.334-2.54-1.167-3.379-1.445.838.167 1.983.334 2.346.472ZM1.424 2.306c.419.722.754 3.222 1.089 5.666-.196-.778-.335-1.555-.503-2.278-.251-1.277-.503-2.416-.838-3.416.056 0 .14 0 .252.028Zm-.168-.584c-.112 0-.223-.028-.307-.028 0-.027 0-.055-.028-.055.14 0 .223.028.335.083Zm-1.089.222c0-.027 0-.027 0 0ZM39.453 1.333c.028-.11-.558-.61-.363-.639.42-.027.42-.666 0-.666-.558.028-1.144.166-1.675.25-.977.194-1.982.389-2.96.61-2.205.473-4.383.973-6.561 1.557-.67.194-1.424.333-2.066.666-.224.111-.196.333-.084.472-.056.028-.084.028-.14.056-.195.028-.363.056-.558.083-.168.028-.252.167-.224.334 0 .027.028.083.028.11-1.173 1.556-2.485 3.195-3.909 4.945-1.396 1.611-2.876 3.306-4.356 5.056-4.719 5.5-10.052 11.75-15.943 17.25a.268.268 0 0 0 0 .389c.028.027.056.055.084.055-.084.084-.168.14-.252.222-.056.056-.084.111-.084.167a.605.605 0 0 0-.111.139c-.112.111-.112.305.028.389.111.11.307.11.39-.028.029-.028.029-.056.056-.056a.44.44 0 0 1 .615 0c.335.362.67.723.977 1.028l-.698-.583c-.112-.111-.307-.083-.39.028-.113.11-.085.305.027.389l7.427 6.194c.056.056.112.056.196.056s.14-.028.195-.084l.168-.166c.028.027.083.027.111.027.084 0 .14-.027.196-.083 10.052-10.055 18.15-17.639 27.42-24.417.083-.055.111-.166.111-.25.112 0 .196-.083.251-.194 1.704-5.194 2.039-9.806 2.15-12.083v-.028c0-.028.028-.056.028-.083.028-.056.028-.084.028-.084a1.626 1.626 0 0 0-.111-1.028ZM21.472 9.5c.446-.5.893-1.028 1.34-1.5-2.876 3.778-7.65 9.583-14.408 16.5 4.607-5.083 9.242-10.333 13.068-15ZM5.193 35.778h.084-.084Zm3.462 3.194c-.027-.028-.027-.028 0-.028v.028Zm4.16-3.583c.224-.25.448-.472.699-.722 0 0 0 .027.028.027-.252.223-.475.445-.726.695Zm1.146-1.111c.14-.14.279-.334.446-.5l.028-.028c1.648-1.694 3.351-3.389 5.082-5.111l.028-.028c.419-.333.921-.694 1.368-1.028a379.003 379.003 0 0 0-6.952 6.695ZM24.794 6.472c-.921 1.195-1.954 2.778-2.82 4.028-2.736 3.944-11.532 13.583-11.727 13.75a1976.983 1976.983 0 0 1-8.042 7.639l-.167.167c-.14-.167-.14-.417.028-.556C14.49 19.861 22.03 10.167 25.074 5.917c-.084.194-.14.36-.28.555Zm4.83 5.695c-1.116-.64-1.646-1.64-1.34-2.611l.084-.334c.028-.083.084-.194.14-.277.307-.5.754-.917 1.257-1.167.027 0 .055 0 .083-.028-.028-.056-.028-.139-.028-.222.028-.167.14-.278.335-.278.335 0 1.369.306 1.76.639.111.083.223.194.335.305.14.167.363.445.474.667.056.028.112.306.196.445.056.222.111.472.084.694-.028.028 0 .194-.028.194a2.668 2.668 0 0 1-.363 1.028c-.028.028-.028.056-.056.084l-.028.027c-.14.223-.335.417-.53.556-.643.444-1.369.583-2.095.389 0 0-.195-.084-.28-.111Zm8.154-.834a39.098 39.098 0 0 1-.893 3.167c0 .028-.028.083 0 .111-.056 0-.084.028-.14.056-2.206 1.61-4.356 3.305-6.506 5.028 1.843-1.64 3.686-3.306 5.613-4.945.558-.5.949-1.139 1.06-1.861l.28-1.667v-.055c.14-.334.67-.195.586.166Z",
            fill: "currentColor"
        })
    }), $e68ba20b3d2d159d$var$pO = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 450 55",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        className: "ExcalidrawLogo-text",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M429.27 96.74c2.47-1.39 4.78-3.02 6.83-4.95 1.43-1.35 2.73-2.86 3.81-4.51-.66.9-1.4 1.77-2.23 2.59-2.91 2.84-5.72 5.09-8.42 6.87h.01ZM343.6 69.36c.33 3.13.58 6.27.79 9.4.09 1.37.18 2.75.25 4.12-.12-4.46-.27-8.93-.5-13.39-.11-2.08-.24-4.16-.4-6.24-.06 1.79-.11 3.85-.13 6.11h-.01ZM378.47 98.34c.01-.37.07-1.13.01-6.51-.11 1.9-.22 3.81-.31 5.71-.07 1.42-.22 2.91-.16 4.35.39.03.78.07 1.17.1-.92-.85-.76-2.01-.72-3.66l.01.01ZM344.09 86.12c-.09-2.41-.22-4.83-.39-7.24v12.21c.15-.05.32-.09.47-.14.05-1.61-.03-3.23-.09-4.83h.01ZM440.69 66.79c-.22-.34-.45-.67-.69-.99-3.71-4.87-9.91-7.14-15.65-8.55-1.05-.26-2.12-.49-3.18-.71 2.29.59 4.48 1.26 6.64 2.02 7.19 2.54 10.57 5.41 12.88 8.23ZM305.09 72.46l1.2 3.6c.84 2.53 1.67 5.06 2.46 7.61.24.78.5 1.57.73 2.36.22-.04.44-.08.67-.12a776.9 776.9 0 0 1-5.01-13.57c-.02.04-.03.09-.05.13v-.01ZM345.49 90.25v.31c1.48-.42 3.05-.83 4.66-1.2-1.56.25-3.12.52-4.66.89ZM371.02 90.22c0-.57-.04-1.14-.11-1.71-.06-.02-.12-.04-.19-.05-.21-.05-.43-.08-.65-.11.42.16.74.88.95 1.87ZM398.93 54.23c-.13 0-.27-.01-.4-.02l.03.4c.11-.15.23-.27.37-.38ZM401.57 62.28v-.15c-1.22-.24-2.86-.61-3.23-1.25-.09-.15-.18-.51-.27-.98-.09.37-.2.73-.33 1.09 1.24.56 2.52.98 3.83 1.29ZM421.73 88.68c-2.97 1.65-6.28 3.12-9.69 3.68v.18c4.72-.14 11.63-3.85 16.33-8.38-2.04 1.75-4.33 3.24-6.63 4.53l-.01-.01ZM411.28 80.92c-.05-1.2-.09-2.4-.15-3.6-.21 5.66-.46 11.38-.47 14.51.24-.02.48-.04.71-.07.15-3.61.05-7.23-.09-10.83v-.01Z",
                transform: "translate(-144.023 -51.76)"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M425.38 67.41c-3.5-1.45-7.19-2.57-14.06-3.62.09 1.97.06 4.88-.03 8.12.03.04.06.09.06.15.19 1.36.28 2.73.37 4.1.25 3.77.39 7.55.41 11.33 0 1.38-.01 2.76-.07 4.13 1.4-.25 2.78-.65 4.12-1.15 4.07-1.5 7.94-3.78 11.28-6.54 2.33-1.92 5.13-4.49 5.88-7.58.63-3.53-2.45-6.68-7.97-8.96l.01.02ZM411.35 92.53v-.06l-.34.03c.11.01.22.03.34.03ZM314.26 64.06c-.23-.59-.47-1.17-.7-1.75.57 1.62 1.11 3.25 1.6 4.9l.15.54 2.35 6.05c.32.82.66 1.64.98 2.46-1.38-4.1-2.83-8.17-4.39-12.2h.01ZM156.82 103.07c-.18.13-.38.23-.58.33 1.32-.03 2.66-.2 3.93-.34.86-.09 1.72-.22 2.58-.33-2.12.1-4.12.17-5.94.34h.01ZM210.14 68.88s.03.04.05.07c.18-.31.39-.64.58-.96-.21.3-.42.6-.64.89h.01ZM201.65 82.8c-.5.77-1.02 1.56-1.49 2.37 1.11-1.55 2.21-3.1 3.2-4.59-.23.23-.49.51-.75.79-.32.47-.65.95-.96 1.43ZM194.03 98.66c-.33-.4-.65-.84-1.05-1.17-.24-.2-.07-.49.17-.56-.23-.26-.42-.5-.63-.75 1.51-2.55 3.93-5.87 6.4-9.28-.17-.08-.29-.28-.2-.49.04-.09.09-.17.13-.26-1.21 1.78-2.42 3.55-3.61 5.33-.87 1.31-1.74 2.64-2.54 4-.29.5-.63 1.04-.87 1.61.81.65 1.63 1.27 2.47 1.88-.09-.11-.18-.21-.27-.32v.01ZM307.79 82.93c-1-3.17-2.05-6.32-3.1-9.48-1.62 4.08-3.69 9.17-6.16 15.19 3.32-1.04 6.77-1.87 10.27-2.5-.32-1.08-.67-2.15-1.01-3.21ZM149.5 80.7c.05-1.71.04-3.43 0-5.14-.1 2.26-.16 4.51-.22 6.77-.02.73-.03 1.46-.04 2.19.14-1.27.2-2.55.24-3.82h.02ZM228.98 98.3c.39 1.25.91 3.03.94 3.91.06-.03.12-.07.17-.1.08-1.29-.55-2.65-1.11-3.81ZM307.72 53.36c.81.5 1.53 1.04 2.07 1.49-.38-.8-.78-1.58-1.21-2.35-.17.03-.34.06-.51.11-.43.12-.86.26-1.29.41.35-.01.53.1.94.34ZM283.69 96.14c3.91-7.25 6.89-13.35 8.88-18.15l1.1-2.66c-1.27 2.64-2.56 5.27-3.83 7.9-1.53 3.15-3.06 6.31-4.58 9.47-.87 1.81-1.76 3.62-2.54 5.47.04.02.07.04.11.07.05.05.1.09.15.14.05-.73.27-1.48.71-2.24ZM289.92 103.23s-.04.01-.05.03c0-.02.04-.03.05-.04.05-.05.11-.1.16-.15l.21-.21c-.55 0-1.5-.27-2.55-.72.4.26.8.51 1.22.74.24.13.48.26.73.37.05.02.1.03.14.05a.27.27 0 0 1 .08-.07h.01ZM269.23 68.49c-.39-.19-.82-.48-1.33-.87-3.06-1.56-6.31-2.78-9.36-2.35-3.5.49-5.7 1.11-7.74 2.44 5.71-2.6 12.82-2.07 18.44.79l-.01-.01ZM177.87 53.69l1.06.03c-.96-.22-2-.25-2.89-.3-4.95-.26-9.99.33-14.86 1.19-2.44.43-4.88.95-7.28 1.59 9.09-1.76 15.69-2.77 23.97-2.51ZM219.85 55.51c-.18.12-.36.27-.56.45-.45.53-.86 1.11-1.26 1.66-1.91 2.61-3.71 5.31-5.57 7.95l-.12.18 8.05-10.11c-.18-.05-.36-.1-.55-.13h.01ZM510.71 54.1c.12-.15.29-.3.53-.45.69-.4 3.72-.63 5.87-.74-.36-.02-.73-.04-1.09-.05-1.84-.03-3.67.09-5.49.35.05.3.12.59.18.88v.01ZM510.76 86.02c1.37-3.07 2.49-6.27 3.57-9.46.55-1.64 1.12-3.3 1.6-4.97-1.59 4.01-3.67 9.14-6.2 15.3.24-.08.5-.14.74-.22.1-.22.19-.44.29-.65ZM566.95 75.76c.11-.02.23.03.31.11-.05-.13-.09-.26-.14-.39-.05.09-.11.18-.17.28ZM511.33 86.41c3.08-.89 6.24-1.62 9.46-2.14-1.51-3.98-2.98-7.96-4.39-11.87-.05.15-.09.31-.14.46-1.02 3.32-2.15 6.61-3.39 9.85-.48 1.25-.98 2.49-1.53 3.7h-.01ZM578.24 74.45c.11-.44.23-.87.35-1.31-.31.7-.64 1.39-.97 2.08.09.21.19.4.28.61.12-.46.23-.92.35-1.38h-.01ZM520.62 53.11c-.09 0-.18-.01-.28-.02.38.34.29 1.08.93 2.53l6.65 17.15c2.2 5.68 4.69 11.36 7.41 16.87l1.06 2.17c-2.95-7.05-5.92-14.08-8.87-21.13-1.58-3.79-3.16-7.59-4.7-11.4-.78-1.92-1.73-3.89-2.25-5.91-.03-.1 0-.19.04-.26h.01ZM578.78 77.87c1.45-5.77 3.07-10.43 3.58-13.36.05-.34.16-.88.31-1.55-.67 1.79-1.37 3.56-2.08 5.33-.12.43-.23.86-.35 1.29-.65 2.43-1.29 4.86-1.9 7.3.14.33.29.65.43 1l.01-.01ZM545.3 94.66c.02-.44.03-.83.05-1.12.02-1.01.05-2.02.11-3.02.03-6.66-.46-14.33-1.46-22.8-.13-.42-.27-1.24-.56-2.89 0-.02 0-.04-.01-.06.62 6.61.95 13.25 1.32 19.87.17 3.08.33 6.16.52 9.23.02.25.03.52.04.78l-.01.01ZM580.77 102.81c.13.2.27.38.37.49.27-.11.53-.22.8-.32-.43.09-.82.05-1.17-.16v-.01ZM530.48 104.07h.33c-.36-.13-.71-.32-1.04-.56.14.24.3.47.45.7.06-.08.14-.13.26-.13v-.01ZM542.63 58.82c.06.23.11.47.15.71.14-.33.36-.62.7-.86-.28.05-.57.11-.85.15ZM583.81 57.87c.15-.7.29-1.41.42-2.11-.14.45-.28.9-.42 1.34-.46 1.44-.89 2.89-1.31 4.34.44-1.19.88-2.37 1.31-3.57ZM523.62 91.48c-4.66 1.17-9.05 2.89-14.02 5.27 4.65-1.84 9.48-3.29 14.28-4.63-.09-.22-.17-.41-.26-.64ZM460.64 78.3c-.04-2.9-.11-5.81-.28-8.71-.1-1.68-.17-3.43-.5-5.09-.07.02-.14.03-.2.05.3 6.54.45 12.17.51 17.12.17-.07.34-.14.51-.2 0-1.06-.01-2.11-.03-3.17h-.01ZM470.63 63.24c-3.38-.26-6.81.32-10.1 1.1.41 2.01.47 4.14.57 6.18.18 3.55.25 7.11.27 10.67 3.31-1.38 6.5-3.12 9.3-5.35 1.96-1.56 3.86-3.41 5.02-5.66.73-1.41 1.19-3.22.26-4.65-1.09-1.7-3.46-2.14-5.32-2.29ZM460.29 63.68c1-.24 2.01-.46 3.04-.65-1.15.16-2.37.38-3.71.69v.13c.07-.02.15-.04.22-.05.11-.13.3-.18.45-.11v-.01ZM457.24 100.96c.43-.03.86-.07 1.29-.11.14-.49.27-.99.38-1.49-.44.7-1 1.23-1.67 1.6ZM482.88 104.98c-.18.23-.36.38-.55.47.14.09.27.19.4.28a70.76 70.76 0 0 0 4.37-4.63c.76-.89 1.52-1.81 2.19-2.77-.3-.27-.61-.53-.92-.79-.07 1.94-4.62 6.32-5.49 7.45v-.01Z",
                transform: "translate(-144.023 -51.76)"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M474.36 63.31c-.4-.16-.84-.27-1.29-.37 1.56.42 3.08 1.22 3.76 2.74.62 1.4.32 2.95-.28 4.32.7-1.22.94-2.34.74-3.47-.24-1.33-1.19-2.54-2.93-3.21v-.01ZM477.34 89.18c-1.2-.81-2.4-1.62-3.6-2.42-.14.1-.26.19-.4.29 1.4.67 2.73 1.39 4 2.13ZM465.88 93.85c.37.25.74.5 1.1.75.46.32.92.65 1.38.97-1.57-1.2-2.01-1.61-2.49-1.72h.01ZM574.92 90.06c-2.28-5.21-4.93-11.13-5.67-12.26-.1-.15-1.57-3.01-1.63-3.08 0 0-.01.02-.02.02.4 1.37 1.09 2.69 1.65 3.99 2.14 4.95 4.36 9.86 6.67 14.73.6 1.26 1.21 2.52 1.83 3.78-.75-2.01-1.64-4.45-2.83-7.18ZM448.73 65.29c.1.2.22.38.34.57.22-.02.43-.06.65-.08v-.08c-.14-.05-.25 0-.99-.41ZM460.16 94.81c-.02.31-.06.59-.1.89-.03 1.71-.33 3.43-.79 5.07.15-.02.3-.03.45-.05.01-.04.02-.08.03-.11.09-.34.15-.69.2-1.03.17-1.07.25-2.16.33-3.24.05-.69.08-1.39.12-2.08-.27.1-.27.26-.24.57v-.02Z",
                transform: "translate(-144.023 -51.76)"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m328.67 98.12-3.22-6.58c-1.29-2.63-2.53-5.29-3.72-7.97-.25-.85-.52-1.69-.79-2.53-.81-2.57-1.67-5.12-2.55-7.67-1.92-5.53-3.9-11.08-6.32-16.41-.72-1.58-1.46-3.44-2.63-4.79-.03-.17-.16-.29-.34-.36a.282.282 0 0 0-.23-.04c-.06-.01-.12 0-.18.01-.74.06-1.5.38-2.19.61-2.22.77-4.4 1.64-6.63 2.38-.03-.08-.06-.16-.09-.25-.15-.42-.82-.24-.67.19.03.09.07.19.1.28l-.18.06c-.36.11-.28.6 0 .68.18 1.18.63 2.36.98 3.49.03.09.06.17.08.26-.08.23-.17.46-.24.64-.37.98-.79 1.94-1.21 2.9-1.27 2.89-2.62 5.75-3.98 8.6-3.18 6.67-6.44 13.31-9.64 19.97-1.08 2.25-2.2 4.5-3.15 6.81-.13.32.24.5.5.37 1.34 1.33 2.84 2.5 4.4 3.57.65.44 1.31.87 2.01 1.24.4.22.86.48 1.33.5.24.01.35-.19.33-.37.11-.1.21-.21.28-.28.41-.41.81-.84 1.2-1.26.85-.92 1.69-1.87 2.5-2.84 6.31-2.34 12.6-4.31 18.71-5.84 2.14 5.3 3.43 8.43 3.97 9.58.55 1.05 1.15 1.88 1.82 2.52 1.32.56 6.96-.03 9.23-1.96.87-1.28 1.19-2.67.93-4.15-.09-.5-.22-.95-.4-1.33l-.01-.03Zm-20.09-45.61c.43.77.83 1.56 1.21 2.35-.54-.45-1.27-.99-2.07-1.49-.42-.24-.6-.35-.94-.34.43-.15.85-.29 1.29-.41.17-.05.34-.08.51-.11Zm-25.86 45.66c.78-1.85 1.67-3.66 2.54-5.47 1.51-3.16 3.05-6.31 4.58-9.47 1.28-2.63 2.56-5.26 3.83-7.9l-1.1 2.66c-1.99 4.79-4.97 10.9-8.88 18.15-.43.76-.66 1.51-.71 2.24-.05-.05-.1-.09-.15-.14a.259.259 0 0 0-.11-.07Zm6.24 4.71c-.42-.23-.82-.48-1.22-.74 1.05.45 2 .72 2.55.72l-.21.21c-.05.05-.11.1-.16.15-.01.01-.04.03-.05.04 0-.02.03-.02.05-.03a.27.27 0 0 0-.08.07c-.05-.02-.1-.03-.14-.05-.25-.1-.49-.24-.73-.37h-.01Zm15.73-29.43c1.05 3.15 2.1 6.31 3.1 9.48.34 1.06.69 2.13 1.01 3.21-3.5.63-6.95 1.46-10.27 2.5 2.48-6.03 4.54-11.11 6.16-15.19Zm4.79 12.57c-.23-.79-.49-1.58-.73-2.36-.79-2.54-1.63-5.08-2.46-7.61l-1.2-3.6c.02-.04.04-.09.05-.13 1.6 4.45 3.28 9 5.01 13.57l-.67.12v.01Zm5.83-18.27-.15-.54c-.49-1.64-1.03-3.28-1.6-4.9.23.58.47 1.17.7 1.75 1.56 4.03 3.01 8.1 4.39 12.2-.33-.82-.67-1.64-.98-2.46l-2.35-6.05h-.01ZM390.43 79.37c-.13-10.43-.22-17.5-.24-19.97-.24-1.6.21-2.88-.65-3.65-.14-.13-.32-.23-.52-.32h.03c.45 0 .45-.69 0-.7-1.75-.03-3.5-.04-5.25-.14-1.38-.08-2.76-.21-4.15-.31-.07 0-.12.01-.17.04-.21-.07-.47.03-.45.31l.03.45c-.11.14-.19.3-.22.5-.21 1.26-.32 13.67-.36 23.59-.32 5.79-.67 11.57-.97 17.36-.09 1.73-.29 3.54-.21 5.3-.39.02-.38.64.04.69v.12c.05.44.74.45.7 0v-.06c1.1.09 2.2.21 3.3.3 1.14.19 2.44.2 3.29.17 1.73-.05 2.92-.05 3.8-.37.45-.05.9-.11 1.35-.17.44-.06.25-.73-.19-.67h-.01c.24-.32.45-.72.62-1.25.66-1.84.41-6.36.34-11.33l-.13-9.9.02.01Zm-12.26 18.17c.09-1.91.2-3.81.31-5.71.06 5.38 0 6.14-.01 6.51-.05 1.65-.21 2.81.72 3.66-.39-.04-.78-.07-1.17-.1-.06-1.44.09-2.93.16-4.35l-.01-.01ZM588.97 53.85c-2.06-.25-3.17-.51-3.76-.6a.3.3 0 0 1 .04-.08c.22-.39-.39-.75-.6-.35-.56 1.02-.9 2.19-1.26 3.29-.61 1.88-1.17 3.78-1.72 5.68-.63 2.19-1.24 4.39-1.83 6.59-.81 2.03-1.67 4.05-2.61 6.03-1.7-3.64-3.11-6.04-4.03-7.57-2.26-3.74-2.85-5.48-3.57-6.08l.31-.09c.43-.12.25-.8-.19-.67-1.06.3-2.12.6-3.17.95-.93.32-1.85.69-2.76 1.07-.13.05-.19.16-.22.27-.04.02-.08.05-.11.07-.04-.06-.07-.12-.11-.18a.354.354 0 0 0-.48-.12c-.16.09-.22.32-.13.48l.33.54c0 .09.02.18.06.28.51 1.16.78 1.38.72 1.47-2.42 3.44-5.41 7.86-6.2 9.1-1.27 1.97-2.01 3.14-2.45 3.84l-.91-6.56-.43-4.1c-.19-1.85-.37-3.23-.53-4.13-.19-1.1-.3-2.15-.45-3.16-.2-1.36-.29-2.06-.47-2.42h.04c.45.02.45-.68 0-.7-3.43-.16-6.81.94-10.17 1.48-.24-.22-.73-.04-.58.32.24.59.33 1.25.43 1.87.17 1.06.29 2.13.4 3.2.32 3.09.53 6.2.74 9.3.44 6.75.77 13.51 1.17 20.26.11 1.95.13 3.96.46 5.89.05.3.37.31.55.14.74 1.71 2.87 1.27 6.13 1.27 1.34 0 2.39.04 2.99-.11.02.32.48.53.63.18 3.61-8.26 7.41-16.46 12.05-24.2.03-.05.04-.1.05-.15.3.73.64 1.45.94 2.16.97 2.26 1.97 4.52 2.98 6.76 2.26 5.03 4.54 10.07 7.09 14.96.47.9.94 1.79 1.47 2.65.2.32.4.67.66.96-.18.25 0 .68.34.54.91-.38 1.82-.75 2.76-1.07 1.04-.35 2.11-.65 3.17-.95.39-.11.28-.66-.07-.68.62-.4.95-.96.87-1.91-.3-3.34.72-7.47.86-8.52l2.14-11.43c1.75-10.74 3.13-17.51 3.23-20.86.02-.49.08-2.84.13-3.24.17-1.25.48-1-4.96-1.65l.03-.02Zm-46.19 5.67c-.04-.24-.09-.48-.15-.71l.85-.15c-.34.24-.56.53-.7.86Zm1.95 25.12c-.36-6.63-.7-13.26-1.32-19.87 0 .02 0 .04.01.06.29 1.65.44 2.47.56 2.89 1 8.46 1.5 16.14 1.46 22.8-.06.99-.1 2-.11 3.02-.01.29-.03.68-.05 1.12-.01-.26-.03-.53-.04-.78-.19-3.08-.35-6.16-.52-9.23l.01-.01Zm36.4 18.66c-.11-.11-.24-.29-.37-.49.35.21.74.26 1.17.16-.27.11-.53.22-.8.32v.01Zm-.89-33.72c.12-.43.23-.86.35-1.29.71-1.77 1.41-3.55 2.08-5.33-.15.68-.26 1.22-.31 1.55-.5 2.94-2.13 7.59-3.58 13.36-.15-.35-.29-.66-.43-1 .61-2.44 1.25-4.87 1.9-7.3l-.01.01Zm3.56-12.48c.14-.44.28-.89.42-1.34-.13.7-.27 1.41-.42 2.11-.43 1.19-.86 2.38-1.31 3.57.42-1.45.85-2.9 1.31-4.34Zm-5.22 16.05c-.11.44-.23.87-.35 1.31-.12.46-.23.92-.35 1.38-.1-.22-.19-.4-.28-.61.34-.69.66-1.38.97-2.08h.01Zm-11.64 2.62c.06-.1.12-.19.17-.28.05.13.09.26.14.39a.398.398 0 0 0-.31-.11Zm2.3 2.98c-.56-1.3-1.25-2.63-1.65-3.99 0 0 .01-.02.02-.02.06.08 1.52 2.93 1.63 3.08.73 1.13 3.38 7.04 5.67 12.26 1.2 2.73 2.08 5.17 2.83 7.18-.62-1.25-1.23-2.51-1.83-3.78-2.31-4.87-4.53-9.78-6.67-14.73ZM275.92 87.03c-1.06-2.18-1.13-3.45-2.44-2.93-1.52.57-2.94 1.3-4.5 2.1-1.4.72-2.68 1.44-3.92 2.12.01-.25-.24-.5-.51-.34-4.8 2.93-12.41 4.7-17.28 1.31-1.98-1.77-3.32-4.15-3.97-5.78-.29-.95-.49-1.94-.63-2.93-.14-3.34 1.58-6.53 3.9-9.12.8-.79 1.68-1.51 2.66-2.12 3.7-2.3 8.22-3.07 12.51-2.51 2.71.35 5.32 1.24 7.71 2.55.39.22.75-.39.35-.6-.18-.1-.37-.18-.55-.27.56.27 1.03.33 1.51.19l-.48.39c-.15.11-.23.3-.13.48.09.15.33.24.48.13 1.3-.97 2.46-2.09 3.45-3.37.37-.29.64-.6.65-.97v-.02c.08-.33-.03-.7-.21-1.08-.31-.87-.98-2.01-2.19-3.26-2.43-2.52-3.79-3.45-5.68-4.26-1.14-.49-3.12-1.06-4.42-1.23-3.28-.42-10.64-1.21-18.18 4.11-7.74 5.46-11.94 12.3-12.23 20.61-.08 2.06.04 3.98.34 5.71.74 4.18 2.57 8 5.44 11.34 4.26 4.99 9.76 7.52 16.34 7.52 4.85 0 9.69-1.77 14.89-4.62.23-.12.45-.23.68-.35 2.19-1.1 4.37-2.23 6.46-3.5.49-.3 1.03-.61 1.5-.98 1.47-.87 1.11-1.12.49-2.95-.39-1.14-.76-2.7-2.06-5.36l.02-.01Zm-17.38-21.76c3.05-.42 6.31.79 9.36 2.35.51.39.94.68 1.33.87-5.61-2.86-12.72-3.39-18.44-.79 2.05-1.33 4.24-1.95 7.74-2.44l.01.01ZM443.67 72.67c-.4-2.2-1.15-4.33-2.37-6.22-1.49-2.32-3.58-4.19-5.91-5.64-6.17-3.81-13.75-5.11-20.83-6.01-3.23-.41-6.47-.69-9.72-.92l-1.39-.12c-.85-.07-1.52-.1-2.05-.1-1.08-.06-2.17-.12-3.25-.17-.08 0-.14.02-.19.05-.1.05-.18.14-.16.3.27 2.55-.01 5.12-.92 7.52-.15.38.4.56.62.28 1.32.59 2.68 1.05 4.08 1.37 0 2.78-.14 7.58-.33 12.91 0 0 0 .02-.01.03-.61 3.66-.79 7.42-1 11.12-.23 4.01-.43 8.03-.44 12.05 0 .64 0 1.28.03 1.93.02.31 0 .68.15.96.06.11.14.16.24.17-.2.17-.21.54.11.59 3.83.67 7.78.71 11.68.25 2.3-.19 4.87-.65 7.65-1.56 1.85-.54 3.67-1.18 5.43-1.91 7.2-3.02 14.31-8.07 17.35-15.53.76-1.86 1.17-3.8 1.31-5.75.3-1.93.28-3.82-.09-5.58l.01-.02Zm-19.32-15.42c5.74 1.41 11.94 3.68 15.65 8.55.25.32.47.65.69.99-2.3-2.82-5.68-5.69-12.88-8.23-2.16-.76-4.35-1.43-6.64-2.02 1.06.21 2.13.45 3.18.71Zm-25.82-3.04c.13 0 .27.01.4.02-.14.1-.26.23-.37.38 0-.13-.02-.26-.03-.4Zm34.82 22.17c-.75 3.09-3.55 5.66-5.88 7.58-3.35 2.76-7.21 5.03-11.28 6.54-1.33.49-2.71.9-4.12 1.15.06-1.38.08-2.76.07-4.13-.02-3.78-.16-7.56-.41-11.33-.09-1.37-.18-2.74-.37-4.1 0-.06-.03-.11-.06-.15.09-3.25.12-6.16.03-8.12 6.86 1.05 10.56 2.17 14.06 3.62 5.52 2.28 8.59 5.44 7.97 8.96l-.01-.02Zm-22 16.15c-.12 0-.23-.02-.34-.03l.34-.03v.06Zm-.69-.7c0-3.13.26-8.84.47-14.51.06 1.2.11 2.41.15 3.6.15 3.6.25 7.23.09 10.83-.24.03-.48.05-.71.07v.01Zm-12.33-30.94c.37.63 2.01 1.01 3.23 1.25v.15c-1.31-.31-2.59-.73-3.83-1.29.12-.36.23-.72.33-1.09.08.48.18.84.27.98Zm13.7 31.65v-.18c3.41-.56 6.71-2.02 9.69-3.68 2.31-1.28 4.59-2.78 6.63-4.53-4.69 4.53-11.61 8.24-16.33 8.38l.01.01Zm24.07-.75c-2.05 1.93-4.37 3.56-6.83 4.95 2.7-1.78 5.52-4.03 8.42-6.87.82-.82 1.56-1.69 2.23-2.59-1.08 1.65-2.38 3.16-3.81 4.51h-.01ZM187.16 92.14c-.79-2.47-2.1-7.12-3.1-6.87-.19-.01-2.09.77-4.08 1.54-3.06 1.18-5.91 2.13-10.09 2.82-2.74.42-5.87 1.01-10.61 1.06.04-3.34.05-6.01.05-7.99 7.97-.65 12.33-2.11 16.37-3.55 1.11-.39 2.69-1.01 2.63-1.8-.08-.35-.55-1.39-1.17-2.61-.47-1.16-.98-2.31-1.61-3.38-.42-.71-1.04-1.69-1.86-2.06-.11-.08-.22-.13-.29-.12-.02 0-.04 0-.07.01-.19-.04-.39-.05-.6-.01-.17.03-.24.15-.25.28-.04.02-.09.04-.14.05-4.33 1.48-8.85 2.33-13.24 3.61a499.1 499.1 0 0 0-.31-8.19c4.51-.99 8.88-1.38 13.11-1.82 3.68-.38 6.28.12 7.47.34.59.11.9.16 1.16.18h.1c-.1.37.44.66.62.28.02-.04.03-.08.05-.13.15.2.53.22.62-.1.17-.58.19-1.21.21-1.81v-.36c.03-.15.05-.3.07-.45.52-2.47.33-5.09-.64-7.44-.11-.27-.44-.28-.6-.14-.08-.21-.15-.42-.24-.62-.19-.41-.79-.05-.6.35.03.07.05.15.09.22-.98-.42-2.15-.54-3.17-.63-2.17-.19-4.37-.14-6.54 0-5.7.35-11.4 1.3-16.91 2.79-2.08.56-4.13 1.22-6.14 2-4.54 1.05-3.79 1.51-2.17 6.07.18.51.46 1.68.54 1.94.82 2.47 1.08 2.13 3.1 2.13s0 .05 0 .08h.52c-.48 2.66-.51 5.45-.62 8.13-.15 3.48-.22 6.96-.28 10.45 0 .41-.01.82-.02 1.23-.16.29-.33.57-.51.85-.05.38-.09.77-.14 1.18-.42 3.52-.59 6.48-.52 8.8v.34c.02.47.05.76.06.87.16 1.57-.26 3.47 1.35 3.79 1.61.32 3.5.55 4.85.55.11 0 .22-.02.33-.02 1.79.24 3.67.05 5.45-.12 2.85-.28 5.69-.7 8.51-1.19 3.03-.53 6.05-1.14 9.04-1.86 2.4-.58 4.82-1.19 7.13-2.06.51-.19 1.73-.57 2.46-1.14 1.81-.68 2.18-1 1.57-2.67-.23-.62-.48-1.49-.91-2.78l-.03-.02Zm-11.12-38.71c.89.05 1.93.08 2.89.3-.33 0-.68-.02-1.06-.03-8.28-.26-14.88.75-23.97 2.51 2.41-.64 4.85-1.16 7.28-1.59 4.87-.86 9.91-1.45 14.86-1.19Zm-26.53 22.13c.03 1.71.04 3.43 0 5.14-.04 1.27-.11 2.55-.24 3.82 0-.73.02-1.46.04-2.19.05-2.26.12-4.51.22-6.77h-.02Zm6.73 27.85c.2-.1.4-.21.58-.33 1.82-.17 3.82-.24 5.94-.34-.86.11-1.72.24-2.58.33-1.27.14-2.61.31-3.93.34h-.01ZM534.48 85.44c-3.52-8.38-7.07-16.75-10.5-25.17-.63-1.54-1.25-3.09-1.86-4.65-.31-.8-.65-1.6-.87-2.43-.04-.17-.17-.24-.31-.25.1-.2 0-.51-.29-.53-1.59-.08-3.18-.22-4.78-.25-1.96-.03-3.91.13-5.84.42-.31.05-.31.38-.13.56-.03.06-.05.14-.04.22.23 1.54.63 3.06 1.16 4.53.13.35.27.7.41 1.06l-2.68 6.18c-.11.03-.2.09-.25.22-.67 1.9-1.52 3.73-2.34 5.56a536.85 536.85 0 0 1-3.9 8.45c-2.64 5.64-5.34 11.25-7.91 16.93-.44.97-.88 1.94-1.29 2.93-.2.48-.47 1-.55 1.52v.05c-.02.12.02.26.16.34 1.19.73 2.41 1.41 3.66 2.05 1.2.62 2.45 1.25 3.76 1.61.43.12.62-.55.19-.67-1.13-.31-2.2-.83-3.24-1.36 1.09.36 2.1.69 2.75.93 2.82 1.01 2.38 1.1 4.3-3.75 2.1-1.09 4.34-1.96 6.53-2.79 4.35-1.64 8.8-3.03 13.27-4.29.82 2.01 1.77 3.97 2.72 5.92.35.83.62 1.45.79 1.82.22.42.45.8.69 1.15.17.33.33.67.5 1 .42.8.84 1.63 1.4 2.35.23.29.6 0 .55-.31 1.53-.02 3.06-.07 4.58-.27.92-.12 1.82-.32 2.71-.54 1.39-.27 3.85-1.11 3.74-1.42-.67-1.96-1.55-3.87-2.34-5.78-1.57-3.78-3.16-7.56-4.75-11.33v-.01Zm-11.65-26.16c1.54 3.81 3.12 7.6 4.7 11.4 2.94 7.05 5.91 14.09 8.87 21.13l-1.06-2.17c-2.71-5.51-5.2-11.19-7.41-16.87l-6.65-17.15c-.65-1.45-.55-2.19-.93-2.53.09 0 .18.01.28.02a.29.29 0 0 0-.04.26c.52 2.02 1.47 3.98 2.25 5.91h-.01Zm-6.58 13.58c.05-.15.09-.31.14-.46 1.41 3.92 2.88 7.9 4.39 11.87-3.22.52-6.38 1.25-9.46 2.14.55-1.22 1.05-2.46 1.53-3.7 1.24-3.24 2.37-6.53 3.39-9.85h.01Zm-.23-20c.36 0 .73.03 1.09.05-2.15.1-5.18.33-5.87.74-.24.15-.41.3-.53.45-.06-.29-.13-.58-.18-.88 1.82-.26 3.65-.39 5.49-.35v-.01Zm-.09 18.72c-.49 1.67-1.05 3.33-1.6 4.97-1.07 3.19-2.19 6.38-3.57 9.46-.09.21-.19.43-.29.65-.25.07-.5.14-.74.22 2.53-6.16 4.61-11.29 6.2-15.3Zm-6.34 25.16c4.97-2.38 9.37-4.1 14.02-5.27l.26.64c-4.8 1.35-9.63 2.8-14.28 4.63Zm20.17 6.76c.33.23.68.42 1.04.56h-.33c-.12 0-.21.06-.26.13-.15-.23-.31-.45-.45-.7v.01ZM226.57 91.75c-3.55-4.74-6.68-9.11-9.31-12.99 9.2-15.25 10.05-17.81 10.35-18.38.17-.34 1.09-2.27.64-2.53-1.13-.65-1.03-.65-2.97-1.71-1.19-.65-3.04-1.61-4.53-2.12-1.71-.59-1.24-.36-3 2.77-.06.1-.11.2-.17.3-.75 1.02-1.48 2.05-2.2 3.09-1.88 2.71-3.73 5.45-5.69 8.1-3.68-4.91-6.88-8.76-9.51-11.43-.15-.15-.3-.29-.46-.42-1.27-1.28-7.24 3.53-7.93 5.58-.09.09-.19.16-.28.25-.27.26.03.64.33.58.19.65.5 1.29.94 1.91 3.85 5.06 7.19 9.76 9.94 14-1.23 2.61-3.06 5-4.67 7.38l-2.28 3.33c-.5.66-.93 1.23-1.29 1.69-.67.93-2.09 2.61-2.3 3.87-.51.85-1.16 1.84-1.29 2.83-.06.44.61.63.67.19.01-.08.04-.15.06-.22 1.36 1.08 2.76 2.11 4.19 3.11 1.3.91 2.62 1.85 4.04 2.56.21.1.4 0 .48-.17.24.07.48.14.72.2.44.1.62-.57.19-.67-2.02-.48-3.77-1.57-5.23-3.02-.47-.46-.9-.96-1.32-1.46 1.74 1.35 4.2 2.89 5.89 4.14 1.39 1.03 2.85-2.27 4.22-4.2 1.86-2.64 3.96-5.86 5.52-8.29l10.39 14.51c.67.81 1.14 1.21 1.57 1.36-.05.24.12.51.41.4 1.53-.58 3.05-1.19 4.54-1.87 1.52-.69 3.06-1.45 4.36-2.5a.28.28 0 0 0 .12-.23c1.66-1.1.81-1.74-1.41-4.91-1.13-1.58-1.71-2.36-3.7-5.01l-.03-.02Zm2.41 6.54c.56 1.15 1.19 2.52 1.11 3.81-.06.04-.12.07-.17.1-.03-.88-.55-2.66-.94-3.91Zm-16.51-32.73c1.86-2.65 3.65-5.35 5.57-7.95.4-.55.81-1.13 1.26-1.66.19-.18.38-.33.56-.45.18.03.36.08.55.13l-8.05 10.11.12-.18h-.01ZM192.7 95.48c.79-1.37 1.66-2.69 2.54-4 1.19-1.79 2.4-3.56 3.61-5.33-.04.09-.09.17-.13.26-.1.22.03.41.2.49-2.47 3.42-4.89 6.73-6.4 9.28.21.24.4.48.63.75-.24.07-.4.36-.17.56.4.33.72.77 1.05 1.17.09.11.18.21.27.32-.84-.61-1.66-1.24-2.47-1.88.24-.57.58-1.11.87-1.61v-.01Zm7.46-10.32c.47-.81.98-1.59 1.49-2.37.31-.48.64-.95.96-1.43.26-.29.52-.56.75-.79-.99 1.48-2.09 3.03-3.2 4.59Zm10.03-16.22s-.03-.05-.05-.07c.22-.29.43-.59.64-.89-.2.32-.4.65-.58.96h-.01ZM371.54 87.96c-.01-.08-.01-.16-.03-.23-.06-.38-.58-.29-.66.03-.3-.05-.6-.08-.81-.11-1.14-.15-2.29-.19-3.44-.2 1.04-.09 2.09-.18 3.14-.23.45-.02.45-.72 0-.7-6.57.35-13.14 1.23-19.65 2.11-1.53.21-3.05.42-4.57.68-.01 0-.02.01-.04.01-.04-3.33-.13-6.66-.24-9.99-.19-5.7-.4-11.41-.88-17.1-.13-1.51-.23-3.07-.49-4.58 0-.25 0-.48-.02-.68-.06-1.19-.04-2.61-.68-2.78-.16-.07-.72-.16-1.5-.24.22-.17.16-.62-.2-.63-1.19-.04-2.39.09-3.57.23-1.2.14-2.41.32-3.59.6-.16-.1-.41-.06-.5.12-.06.02-.13.03-.19.05-.35.1-.29.55-.03.66-.26.6-.19 2.27-.21 3-.02.66-.66 33.73-.9 40.3-.03.65.06 1.12.04 1.45-.16 3.05.87 4.96 6.34 3.93 1.09-.08 2.75-.77 5.36-1.43 4.13-1.04 5.78-1.52 6.2-1.65 6.43-1.69 6.78-1.97 11.72-2.43.55-.05 4.8-.38 6.03-.3.64.04 1.19.07 1.65.1.09 0 .16-.03.24-.05.1.27.56.33.66-.02.39-1.32.61-2.71.78-4.08.2-1.61.29-3.24.15-4.86.24.03.52-.23.38-.53-.09-.2-.27-.33-.49-.43v-.02Zm-.63.56c.07.57.11 1.14.11 1.71-.21-.99-.53-1.71-.95-1.87.22.03.44.06.65.11.06.01.12.04.19.05Zm-25.41 1.73c1.54-.36 3.1-.64 4.66-.89-1.61.37-3.18.77-4.66 1.2v-.31Zm-.86-7.37c-.07-1.37-.16-2.75-.25-4.12-.21-3.13-.45-6.27-.79-9.4.02-2.25.08-4.31.13-6.11.16 2.08.29 4.16.4 6.24.23 4.46.38 8.93.5 13.39h.01Zm-.94-4c.16 2.41.29 4.83.39 7.24.06 1.6.14 3.22.09 4.83-.15.05-.32.09-.47.14V78.88h-.01ZM483.72 92.83c-3.05-2.28-6.22-4.4-9.38-6.51 8.86-6.49 13.49-12.95 13.73-19.23.04-.76 0-1.5-.13-2.2-.67-3.82-3.5-6.68-8.39-8.48.13.04.27.08.4.13 3.92 1.39 7.74 4.23 8.5 8.56.34 1.95-.05 3.96-.98 5.69-.21.4.39.75.6.35 1.86-3.46 1.46-7.55-.97-10.63-3.53-4.47-9.76-5.88-15.16-6.16-2.32-.12-4.64-.04-6.95.19-6 .32-12.71 1.68-17.63 3.21-.37.11-.67.23-.92.35-.2-.17-.62.02-.57.37v.03c-.64.68-.18 1.64.48 3.21.38.91.67 1.89 1.15 2.58.32.76.68 1.51 1.13 2.19.14.21.38.19.53.07.19-.02.38-.05.57-.08v1.57c-.06.06-.1.13-.11.23-.27 4.18-.34 8.38-.48 12.57l-.3 9.03c-.24 3.91-.44 6.77-.46 7.26-.05.88-.11 1.95.07 2.81-.01.22-.02.43-.04.65 0 .11-.02.23-.03.35 0 .05-.03.27-.01.16-.05.4.5.59.64.28.05.04.12.08.2.08 1.75.13 3.5.28 5.25.3 1.69.02 3.38-.12 5.06-.32.08.23.36.39.55.15.06-.08.11-.17.16-.26.18-.09.24-.32.18-.48.05-.2.1-.4.13-.6.16-.86.25-1.74.33-2.62.11-1.17.17-2.34.23-3.51.15-.01.32-.03.52-.04.36-.03 1.73-.15 2.06-.15.39 0 .7-.02.95-.04 1.76 1.11 3.45 2.35 5.14 3.55 2.83 2.01 5.64 4.04 8.47 6.04 1.42 1 2.85 2 4.29 2.97.1.06.19.07.27.04.08 0 .17-.02.25-.1 1.61-1.56 3.15-3.18 4.6-4.88.75-.88 1.49-1.78 2.15-2.73.01.01.03.02.04.03.34.3.83-.2.49-.49-2.16-1.9-4.34-3.76-6.64-5.48l.03-.01Zm-6.38-3.65a55.72 55.72 0 0 0-4-2.13c.14-.1.26-.19.4-.29 1.2.81 2.4 1.61 3.6 2.42Zm-20.1 11.78c.67-.37 1.23-.91 1.67-1.6-.11.5-.24 1-.38 1.49-.43.04-.86.08-1.29.11Zm2.38-37.24c1.34-.31 2.56-.52 3.71-.69-1.03.19-2.04.41-3.04.65-.14-.07-.34-.02-.45.11-.07.02-.15.04-.22.05v-.13.01Zm.04.84c.07-.02.14-.03.2-.05.34 1.66.41 3.41.5 5.09.17 2.9.24 5.81.28 8.71l.03 3.17c-.17.07-.34.14-.51.2-.06-4.96-.21-10.58-.51-17.12h.01Zm16.04 5.62c-1.16 2.25-3.06 4.1-5.02 5.66-2.8 2.23-5.99 3.97-9.3 5.35-.01-3.56-.09-7.12-.27-10.67-.1-2.04-.16-4.16-.57-6.18 3.3-.78 6.72-1.36 10.1-1.1 1.85.14 4.23.59 5.32 2.29.92 1.43.46 3.24-.26 4.65Zm.85-.18c.6-1.37.9-2.92.28-4.32-.67-1.52-2.2-2.32-3.76-2.74.46.1.89.21 1.29.37 1.74.67 2.69 1.88 2.93 3.21.2 1.13-.05 2.25-.74 3.47V70Zm-27.47-4.14c-.12-.19-.23-.38-.34-.57.74.42.85.36.99.41v.08c-.22.03-.43.06-.65.08Zm11.21 30.46c-.08 1.08-.16 2.17-.33 3.24-.05.35-.11.69-.2 1.03 0 .04-.02.07-.03.11-.15.02-.3.04-.45.05.45-1.64.76-3.36.79-5.07.03-.29.08-.57.1-.89-.03-.31-.03-.47.24-.57-.04.69-.07 1.39-.12 2.08v.02Zm5.6-2.47c.48.11.92.52 2.49 1.72-.46-.32-.92-.65-1.38-.97-.37-.25-.73-.5-1.1-.75h-.01Zm21.23 7.24a70.76 70.76 0 0 1-4.37 4.63c-.14-.09-.27-.19-.4-.28.19-.09.37-.24.55-.47.87-1.14 5.43-5.51 5.49-7.45.31.26.62.53.92.79-.67.97-1.42 1.88-2.19 2.77v.01Z",
                fill: "currentColor",
                transform: "translate(-144.023 -51.76)"
            })
        ]
    }), $e68ba20b3d2d159d$var$p6 = ({ style: e, size: t = "small", withText: r })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `ExcalidrawLogo is-${t}`,
        style: e,
        children: [
            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$mO, {}),
            r && (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$pO, {})
        ]
    });
var $e68ba20b3d2d159d$var$X1 = ({ icon: e, shortcut: t, children: r })=>{
    let o = $e68ba20b3d2d159d$export$aa949327762d0f40();
    return (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "welcome-screen-menu-item__icon",
                children: e
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "welcome-screen-menu-item__text",
                children: r
            }),
            t && !o.editor.isMobile && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "welcome-screen-menu-item__shortcut",
                children: t
            })
        ]
    });
};
$e68ba20b3d2d159d$var$X1.displayName = "WelcomeScreenMenuItemContent";
var $e68ba20b3d2d159d$var$wm = ({ onSelect: e, children: t, icon: r, shortcut: o, className: n = "", ...i })=>(0, $7b02d682eb115277$exports.jsx)("button", {
        ...i,
        type: "button",
        className: `welcome-screen-menu-item ${n}`,
        onClick: e,
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$X1, {
            icon: r,
            shortcut: o,
            children: t
        })
    });
$e68ba20b3d2d159d$var$wm.displayName = "WelcomeScreenMenuItem";
var $e68ba20b3d2d159d$var$h6 = ({ children: e, href: t, icon: r, shortcut: o, className: n = "", ...i })=>(0, $7b02d682eb115277$exports.jsx)("a", {
        ...i,
        className: `welcome-screen-menu-item ${n}`,
        href: t,
        target: "_blank",
        rel: "noreferrer",
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$X1, {
            icon: r,
            shortcut: o,
            children: e
        })
    });
$e68ba20b3d2d159d$var$h6.displayName = "WelcomeScreenMenuItemLink";
var $e68ba20b3d2d159d$var$Yo = ({ children: e })=>{
    let { WelcomeScreenCenterTunnel: t } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "welcome-screen-center",
            children: e || (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$K1, {}),
                    (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$$1, {
                        children: $e68ba20b3d2d159d$var$x("welcomeScreen.defaults.center_heading")
                    }),
                    (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$Z1, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$q1, {}),
                            (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$j1, {})
                        ]
                    })
                ]
            })
        })
    });
};
$e68ba20b3d2d159d$var$Yo.displayName = "Center";
var $e68ba20b3d2d159d$var$K1 = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "welcome-screen-center__logo excalifont welcome-screen-decor",
        children: e || (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$p6, {
            withText: !0
        })
    });
$e68ba20b3d2d159d$var$K1.displayName = "Logo";
var $e68ba20b3d2d159d$var$$1 = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "welcome-screen-center__heading welcome-screen-decor excalifont",
        children: e
    });
$e68ba20b3d2d159d$var$$1.displayName = "Heading";
var $e68ba20b3d2d159d$var$Z1 = ({ children: e })=>(0, $7b02d682eb115277$exports.jsx)("div", {
        className: "welcome-screen-menu",
        children: e
    });
$e68ba20b3d2d159d$var$Z1.displayName = "Menu";
var $e68ba20b3d2d159d$var$j1 = ()=>{
    let e = $e68ba20b3d2d159d$var$$t();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wm, {
        onSelect: ()=>e.executeAction($e68ba20b3d2d159d$var$ks),
        shortcut: "?",
        icon: $e68ba20b3d2d159d$var$qs,
        children: $e68ba20b3d2d159d$var$x("helpDialog.title")
    });
};
$e68ba20b3d2d159d$var$j1.displayName = "MenuItemHelp";
var $e68ba20b3d2d159d$var$q1 = ()=>{
    let e = $e68ba20b3d2d159d$var$Ke(), t = $e68ba20b3d2d159d$var$$t();
    return e.viewModeEnabled ? null : (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wm, {
        onSelect: ()=>t.executeAction($e68ba20b3d2d159d$var$jl),
        shortcut: $e68ba20b3d2d159d$var$zt("loadScene"),
        icon: $e68ba20b3d2d159d$var$Js,
        children: $e68ba20b3d2d159d$var$x("buttons.load")
    });
};
$e68ba20b3d2d159d$var$q1.displayName = "MenuItemLoadScene";
var $e68ba20b3d2d159d$var$g6 = ({ onSelect: e })=>{
    let { t: t } = $e68ba20b3d2d159d$export$3f3caade1c12f8c9();
    return (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$wm, {
        shortcut: null,
        onSelect: e,
        icon: $e68ba20b3d2d159d$var$xp,
        children: t("labels.liveCollaboration")
    });
};
$e68ba20b3d2d159d$var$g6.displayName = "MenuItemLiveCollaborationTrigger";
$e68ba20b3d2d159d$var$Yo.Logo = $e68ba20b3d2d159d$var$K1;
$e68ba20b3d2d159d$var$Yo.Heading = $e68ba20b3d2d159d$var$$1;
$e68ba20b3d2d159d$var$Yo.Menu = $e68ba20b3d2d159d$var$Z1;
$e68ba20b3d2d159d$var$Yo.MenuItem = $e68ba20b3d2d159d$var$wm;
$e68ba20b3d2d159d$var$Yo.MenuItemLink = $e68ba20b3d2d159d$var$h6;
$e68ba20b3d2d159d$var$Yo.MenuItemHelp = $e68ba20b3d2d159d$var$j1;
$e68ba20b3d2d159d$var$Yo.MenuItemLoadScene = $e68ba20b3d2d159d$var$q1;
$e68ba20b3d2d159d$var$Yo.MenuItemLiveCollaborationTrigger = $e68ba20b3d2d159d$var$g6;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$Yg = ({ children: e })=>{
    let { WelcomeScreenMenuHintTunnel: t } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "excalifont welcome-screen-decor welcome-screen-decor-hint welcome-screen-decor-hint--menu",
            children: [
                $e68ba20b3d2d159d$var$Sy,
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "welcome-screen-decor-hint__label",
                    children: e || $e68ba20b3d2d159d$var$x("welcomeScreen.defaults.menuHint")
                })
            ]
        })
    });
};
$e68ba20b3d2d159d$var$Yg.displayName = "MenuHint";
var $e68ba20b3d2d159d$var$Xg = ({ children: e })=>{
    let { WelcomeScreenToolbarHintTunnel: t } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "excalifont welcome-screen-decor welcome-screen-decor-hint welcome-screen-decor-hint--toolbar",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "welcome-screen-decor-hint__label",
                    children: e || $e68ba20b3d2d159d$var$x("welcomeScreen.defaults.toolbarHint")
                }),
                $e68ba20b3d2d159d$var$Cy
            ]
        })
    });
};
$e68ba20b3d2d159d$var$Xg.displayName = "ToolbarHint";
var $e68ba20b3d2d159d$var$Kg = ({ children: e })=>{
    let { WelcomeScreenHelpHintTunnel: t } = $e68ba20b3d2d159d$var$pt();
    return (0, $7b02d682eb115277$exports.jsx)(t.In, {
        children: (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "excalifont welcome-screen-decor welcome-screen-decor-hint welcome-screen-decor-hint--help",
            children: [
                (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: e || $e68ba20b3d2d159d$var$x("welcomeScreen.defaults.helpHint")
                }),
                $e68ba20b3d2d159d$var$Iy
            ]
        })
    });
};
$e68ba20b3d2d159d$var$Kg.displayName = "HelpHint";
var $e68ba20b3d2d159d$var$$g = (e)=>(0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: e.children || (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Yo, {}),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Yg, {}),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Xg, {}),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$Kg, {})
            ]
        })
    });
$e68ba20b3d2d159d$var$$g.displayName = "WelcomeScreen";
$e68ba20b3d2d159d$var$$g.Center = $e68ba20b3d2d159d$var$Yo;
$e68ba20b3d2d159d$var$$g.Hints = {
    MenuHint: $e68ba20b3d2d159d$var$Yg,
    ToolbarHint: $e68ba20b3d2d159d$var$Xg,
    HelpHint: $e68ba20b3d2d159d$var$Kg
};
var $e68ba20b3d2d159d$export$8995dcca99dcdafc = $e68ba20b3d2d159d$var$$g;
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$var$x6 = ({ isCollaborating: e, onSelect: t, ...r })=>{
    let o = $e68ba20b3d2d159d$var$Ke(), n = o.width < 830;
    return (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$export$353f5b6fc5456de1, {
        ...r,
        className: (0, $15e6d94060e5d8b6$export$2e2bcd8739ae039)("collab-button", {
            active: e
        }),
        type: "button",
        onSelect: t,
        style: {
            position: "relative",
            width: n ? void 0 : "auto"
        },
        title: $e68ba20b3d2d159d$var$x("labels.liveCollaboration"),
        children: [
            n ? $e68ba20b3d2d159d$var$$y : $e68ba20b3d2d159d$var$x("labels.share"),
            o.collaborators.size > 0 && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "CollabButton-collaborators",
                children: o.collaborators.size
            })
        ]
    });
}, $e68ba20b3d2d159d$export$a21052be051df15f = $e68ba20b3d2d159d$var$x6;
$e68ba20b3d2d159d$var$x6.displayName = "LiveCollaborationTrigger";
$e68ba20b3d2d159d$var$ye();
$e68ba20b3d2d159d$var$xl();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Do();
$e68ba20b3d2d159d$var$W();
var $e68ba20b3d2d159d$var$yO = (e, t, r)=>!!(t && (t.id === e.editingTextElement?.id || t.id === e.resizingElement?.id || t.id === e.newElement?.id || t.version > r.version || t.version === r.version && t.versionNonce < r.versionNonce)), $e68ba20b3d2d159d$var$wO = (0, (/*@__PURE__*/$parcel$interopDefault($ac43bb23aa0a60e2$exports)))((e, t, r)=>{
    if ($e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST || window?.DEBUG_FRACTIONAL_INDICES) {
        let o = $e68ba20b3d2d159d$var$Cr(e.map((n)=>({
                ...n
            })));
        $e68ba20b3d2d159d$var$Dd(o, {
            shouldThrow: $e68ba20b3d2d159d$var$T.DEV || $e68ba20b3d2d159d$var$T.MODE === $e68ba20b3d2d159d$var$Zt.TEST,
            includeBoundTextValidation: !0,
            reconciliationContext: {
                localElements: t,
                remoteElements: r
            }
        });
    }
}, 60000, {
    leading: !0,
    trailing: !1
}), $e68ba20b3d2d159d$export$24265510fb3189bb = (e, t, r)=>{
    let o = $e68ba20b3d2d159d$var$j(e), n = [], i = new Set;
    for (let s of t)if (!i.has(s.id)) {
        let l = o.get(s.id), c = $e68ba20b3d2d159d$var$yO(r, l, s);
        l && c ? (n.push(l), i.add(l.id)) : (n.push(s), i.add(s.id));
    }
    for (let s of e)i.has(s.id) || (n.push(s), i.add(s.id));
    let a = $e68ba20b3d2d159d$var$mu(n);
    return $e68ba20b3d2d159d$var$wO(a, e, t), $e68ba20b3d2d159d$var$Cr(a), a;
};
$e68ba20b3d2d159d$var$Ml();
$e68ba20b3d2d159d$var$pi();
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$Fn();
$e68ba20b3d2d159d$var$de();
$e68ba20b3d2d159d$var$Y();
$e68ba20b3d2d159d$var$Re();
$e68ba20b3d2d159d$var$Be();
$e68ba20b3d2d159d$var$W();
$e68ba20b3d2d159d$var$f();
$e68ba20b3d2d159d$var$oe();
var $e68ba20b3d2d159d$export$3e7fbeb7078e3eaa = ({ children: e, icon: t })=>{
    let { TTDDialogTriggerTunnel: r } = $e68ba20b3d2d159d$var$pt(), o = $e68ba20b3d2d159d$var$He();
    return (0, $7b02d682eb115277$exports.jsx)(r.In, {
        children: (0, $7b02d682eb115277$exports.jsxs)($e68ba20b3d2d159d$var$et.Item, {
            onSelect: ()=>{
                $e68ba20b3d2d159d$var$Pe("ai", "dialog open", "ttd"), o({
                    openDialog: {
                        name: "ttd",
                        tab: "text-to-diagram"
                    }
                });
            },
            icon: t ?? $e68ba20b3d2d159d$var$Hw,
            children: [
                e ?? $e68ba20b3d2d159d$var$x("labels.textToDiagram"),
                (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$et.Item.Badge, {
                    children: "AI"
                })
            ]
        })
    });
};
$e68ba20b3d2d159d$export$3e7fbeb7078e3eaa.displayName = "TTDDialogTrigger";
$e68ba20b3d2d159d$var$Va();
$e68ba20b3d2d159d$var$dt();
$e68ba20b3d2d159d$var$_E();
$e68ba20b3d2d159d$var$f();
var $e68ba20b3d2d159d$export$e6ec20b6439293fa = (e)=>{
    let t = $e68ba20b3d2d159d$var$Bt();
    return (0, $acw62.useLayoutEffect)(()=>{
        t.setPlugins({
            diagramToCode: {
                generate: e.generate
            }
        });
    }, [
        t,
        e.generate
    ]), null;
};
$e68ba20b3d2d159d$var$Fr();
$e68ba20b3d2d159d$var$c6();

var $e68ba20b3d2d159d$var$kO = (e)=>{
    let { onChange: t, initialData: r, excalidrawAPI: o, isCollaborating: n = !1, onPointerUpdate: i, renderTopRightUI: a, langCode: s = $e68ba20b3d2d159d$export$811af2a4ddb5af35.code, viewModeEnabled: l, zenModeEnabled: c, gridModeEnabled: d, libraryReturnUrl: m, theme: p, name: u, renderCustomStats: h, onPaste: g, detectScroll: b = !0, handleKeyboardGlobally: v = !1, onLibraryChange: y, autoFocus: w = !1, generateIdForFile: I, onLinkOpen: M, onPointerDown: C, onPointerUp: P, onScrollChange: k, children: _, validateEmbeddable: A, renderEmbeddable: R, aiEnabled: B, showDeprecatedFonts: V } = e, ee = e.UIOptions?.canvasActions, N = {
        ...e.UIOptions,
        canvasActions: {
            ...$e68ba20b3d2d159d$var$tf.canvasActions,
            ...ee
        },
        tools: {
            image: e.UIOptions?.tools?.image ?? !0
        }
    };
    return ee?.export && (N.canvasActions.export.saveFileToDisk = ee.export?.saveFileToDisk ?? $e68ba20b3d2d159d$var$tf.canvasActions.export.saveFileToDisk), N.canvasActions.toggleTheme === null && typeof p > "u" && (N.canvasActions.toggleTheme = !0), (0, $acw62.useEffect)(()=>{
        (async ()=>{
            await (parcelRequire("891Eb"));
        })();
        let xe = (X)=>{
            typeof X.scale == "number" && X.scale !== 1 && X.preventDefault();
        };
        return document.addEventListener("touchmove", xe, {
            passive: !1
        }), ()=>{
            document.removeEventListener("touchmove", xe);
        };
    }, []), (0, $7b02d682eb115277$exports.jsx)((0, $051474e5c5a9c9ad$export$2881499e37b75b9a), {
        unstable_createStore: ()=>$e68ba20b3d2d159d$var$br,
        scope: $e68ba20b3d2d159d$var$$e,
        children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$F0, {
            langCode: s,
            theme: p,
            children: (0, $7b02d682eb115277$exports.jsx)($e68ba20b3d2d159d$var$l6, {
                onChange: t,
                initialData: r,
                excalidrawAPI: o,
                isCollaborating: n,
                onPointerUpdate: i,
                renderTopRightUI: a,
                langCode: s,
                viewModeEnabled: l,
                zenModeEnabled: c,
                gridModeEnabled: d,
                libraryReturnUrl: m,
                theme: p,
                name: u,
                renderCustomStats: h,
                UIOptions: N,
                onPaste: g,
                detectScroll: b,
                handleKeyboardGlobally: v,
                onLibraryChange: y,
                autoFocus: w,
                generateIdForFile: I,
                onLinkOpen: M,
                onPointerDown: C,
                onPointerUp: P,
                onScrollChange: k,
                validateEmbeddable: A,
                renderEmbeddable: R,
                aiEnabled: B !== !1,
                showDeprecatedFonts: V,
                children: _
            })
        })
    });
}, $e68ba20b3d2d159d$var$PO = (e, t)=>{
    if (e.children !== t.children) return !1;
    let { initialData: r, UIOptions: o = {}, ...n } = e, { initialData: i, UIOptions: a = {}, ...s } = t, l = Object.keys(o), c = Object.keys(a);
    return l.length !== c.length ? !1 : l.every((m)=>m === "canvasActions" ? Object.keys(o.canvasActions).every((u)=>u === "export" && o?.canvasActions?.export && a?.canvasActions?.export ? o.canvasActions.export.saveFileToDisk === a.canvasActions.export.saveFileToDisk : o?.canvasActions?.[u] === a?.canvasActions?.[u]) : o[m] === a[m]) && $e68ba20b3d2d159d$var$at(n, s);
}, $e68ba20b3d2d159d$export$c8d59565b9e4e564 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($e68ba20b3d2d159d$var$kO, $e68ba20b3d2d159d$var$PO);
$e68ba20b3d2d159d$export$c8d59565b9e4e564.displayName = "Excalidraw";



var $acw62 = parcelRequire("acw62");
"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $2f71637df772b183$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $2f71637df772b183$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $2f71637df772b183$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $2f71637df772b183$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
const $843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge($843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE);
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders.prototype);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $2f71637df772b183$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $e8c8c7960873e9ee$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($e8c8c7960873e9ee$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.4.0";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

function $0a8a304ccadc5598$var$V(e, { insertAt: n } = {}) {
    if (!e || typeof document > "u") return;
    let t = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
$0a8a304ccadc5598$var$V(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var $0a8a304ccadc5598$var$Me = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: "Select...",
    create: "Create"
}, $0a8a304ccadc5598$var$De = {
    value: [],
    hasSelectAll: !0,
    className: "multi-select",
    debounceDuration: 200,
    options: []
}, $0a8a304ccadc5598$var$re = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({}), $0a8a304ccadc5598$var$ne = ({ props: e, children: n })=>{
    let [t, r] = (0, $acw62.useState)(e.options), a = (c)=>{
        var u;
        return ((u = e.overrideStrings) == null ? void 0 : u[c]) || $0a8a304ccadc5598$var$Me[c];
    };
    return (0, $acw62.useEffect)(()=>{
        r(e.options);
    }, [
        e.options
    ]), (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$re.Provider, {
        value: {
            t: a,
            ...$0a8a304ccadc5598$var$De,
            ...e,
            options: t,
            setOptions: r
        },
        children: n
    });
}, $0a8a304ccadc5598$var$w = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0a8a304ccadc5598$var$re);
function $0a8a304ccadc5598$var$se(e, n) {
    let t = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>{
        t.current ? e() : t.current = !0;
    }, n);
}
var $0a8a304ccadc5598$var$He = {
    when: !0,
    eventTypes: [
        "keydown"
    ]
};
function $0a8a304ccadc5598$var$R(e, n, t) {
    let r = (0, $acw62.useMemo)(()=>Array.isArray(e) ? e : [
            e
        ], [
        e
    ]), a = Object.assign({}, $0a8a304ccadc5598$var$He, t), { when: c, eventTypes: u } = a, b = (0, $acw62.useRef)(n), { target: s } = a;
    (0, $acw62.useEffect)(()=>{
        b.current = n;
    });
    let p = (0, $acw62.useCallback)((i)=>{
        r.some((l)=>i.key === l || i.code === l) && b.current(i);
    }, [
        r
    ]);
    (0, $acw62.useEffect)(()=>{
        if (c && typeof window < "u") {
            let i = s ? s.current : window;
            return u.forEach((l)=>{
                i && i.addEventListener(l, p);
            }), ()=>{
                u.forEach((l)=>{
                    i && i.removeEventListener(l, p);
                });
            };
        }
    }, [
        c,
        u,
        r,
        s,
        n
    ]);
}
var $0a8a304ccadc5598$var$f = {
    ARROW_DOWN: "ArrowDown",
    ARROW_UP: "ArrowUp",
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: "Space"
};
var $0a8a304ccadc5598$var$le = (e, n)=>{
    let t;
    return function(...r) {
        clearTimeout(t), t = setTimeout(()=>{
            e.apply(null, r);
        }, n);
    };
};
function $0a8a304ccadc5598$var$ie(e, n) {
    return n ? e.filter(({ label: t, value: r })=>t != null && r != null && t.toLowerCase().includes(n.toLowerCase())) : e;
}
var $0a8a304ccadc5598$var$T = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-search-clear-icon gray",
        children: [
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
var $0a8a304ccadc5598$var$Ue = ({ checked: e, option: n, onClick: t, disabled: r })=>(0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `item-renderer ${r ? "disabled" : ""}`,
        children: [
            (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                onChange: t,
                checked: e,
                tabIndex: -1,
                disabled: r
            }),
            (0, $7b02d682eb115277$exports.jsx)("span", {
                children: n.label
            })
        ]
    }), $0a8a304ccadc5598$var$pe = $0a8a304ccadc5598$var$Ue;
var $0a8a304ccadc5598$var$Ye = ({ itemRenderer: e = $0a8a304ccadc5598$var$pe, option: n, checked: t, tabIndex: r, disabled: a, onSelectionChanged: c, onClick: u })=>{
    let b = (0, $acw62.useRef)(), s = (l)=>{
        p(), l.preventDefault();
    }, p = ()=>{
        a || c(!t);
    }, i = (l)=>{
        p(), u(l);
    };
    return $0a8a304ccadc5598$var$R([
        $0a8a304ccadc5598$var$f.ENTER,
        $0a8a304ccadc5598$var$f.SPACE
    ], s, {
        target: b
    }), (0, $7b02d682eb115277$exports.jsx)("label", {
        className: `select-item ${t ? "selected" : ""}`,
        role: "option",
        "aria-selected": t,
        tabIndex: r,
        ref: b,
        children: (0, $7b02d682eb115277$exports.jsx)(e, {
            option: n,
            checked: t,
            onClick: i,
            disabled: a
        })
    });
}, $0a8a304ccadc5598$export$13ef48a934230896 = $0a8a304ccadc5598$var$Ye;
var $0a8a304ccadc5598$var$ze = ({ options: e, onClick: n, skipIndex: t })=>{
    let { disabled: r, value: a, onChange: c, ItemRenderer: u } = $0a8a304ccadc5598$var$w(), b = (s, p)=>{
        r || c(p ? [
            ...a,
            s
        ] : a.filter((i)=>i.value !== s.value));
    };
    return (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: e.map((s, p)=>{
            let i = p + t;
            return (0, $7b02d682eb115277$exports.jsx)("li", {
                children: (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$export$13ef48a934230896, {
                    tabIndex: i,
                    option: s,
                    onSelectionChanged: (l)=>b(s, l),
                    checked: !!a.find((l)=>l.value === s.value),
                    onClick: (l)=>n(l, i),
                    itemRenderer: u,
                    disabled: s.disabled || r
                })
            }, (s == null ? void 0 : s.key) || p);
        })
    });
}, $0a8a304ccadc5598$var$ue = $0a8a304ccadc5598$var$ze;
var $0a8a304ccadc5598$var$Je = ()=>{
    let { t: e, onChange: n, options: t, setOptions: r, value: a, filterOptions: c, ItemRenderer: u, disabled: b, disableSearch: s, hasSelectAll: p, ClearIcon: i, debounceDuration: l, isCreatable: L, onCreateOption: y } = $0a8a304ccadc5598$var$w(), O = (0, $acw62.useRef)(), g = (0, $acw62.useRef)(), [m, M] = (0, $acw62.useState)(""), [v, K] = (0, $acw62.useState)(t), [x, D] = (0, $acw62.useState)(""), [E, I] = (0, $acw62.useState)(0), W = (0, $acw62.useCallback)($0a8a304ccadc5598$var$le((o)=>D(o), l), []), A = (0, $acw62.useMemo)(()=>{
        let o = 0;
        return s || (o += 1), p && (o += 1), o;
    }, [
        s,
        p
    ]), _ = {
        label: e(m ? "selectAllFiltered" : "selectAll"),
        value: ""
    }, H = (o)=>{
        let d = v.filter((C)=>!C.disabled).map((C)=>C.value);
        if (o) {
            let Ae = [
                ...a.map((U)=>U.value),
                ...d
            ];
            return (c ? v : t).filter((U)=>Ae.includes(U.value));
        }
        return a.filter((C)=>!d.includes(C.value));
    }, B = (o)=>{
        let d = H(o);
        n(d);
    }, h = (o)=>{
        W(o.target.value), M(o.target.value), I(0);
    }, P = ()=>{
        var o;
        D(""), M(""), (o = g == null ? void 0 : g.current) == null || o.focus();
    }, Z = (o)=>I(o), we = (o)=>{
        switch(o.code){
            case $0a8a304ccadc5598$var$f.ARROW_UP:
                ee(-1);
                break;
            case $0a8a304ccadc5598$var$f.ARROW_DOWN:
                ee(1);
                break;
            default:
                return;
        }
        o.stopPropagation(), o.preventDefault();
    };
    $0a8a304ccadc5598$var$R([
        $0a8a304ccadc5598$var$f.ARROW_DOWN,
        $0a8a304ccadc5598$var$f.ARROW_UP
    ], we, {
        target: O
    });
    let Oe = ()=>{
        I(0);
    }, j = async ()=>{
        let o = {
            label: m,
            value: m,
            __isNew__: !0
        };
        y && (o = await y(m)), r([
            o,
            ...t
        ]), P(), n([
            ...a,
            o
        ]);
    }, Re = async ()=>c ? await c(t, x) : $0a8a304ccadc5598$var$ie(t, x), ee = (o)=>{
        let d = E + o;
        d = Math.max(0, d), d = Math.min(d, t.length + Math.max(A - 1, 0)), I(d);
    };
    (0, $acw62.useEffect)(()=>{
        var o, d;
        (d = (o = O == null ? void 0 : O.current) == null ? void 0 : o.querySelector(`[tabIndex='${E}']`)) == null || d.focus();
    }, [
        E
    ]);
    let [ke, Ee] = (0, $acw62.useMemo)(()=>{
        let o = v.filter((d)=>!d.disabled);
        return [
            o.every((d)=>a.findIndex((C)=>C.value === d.value) !== -1),
            o.length !== 0
        ];
    }, [
        v,
        a
    ]);
    (0, $acw62.useEffect)(()=>{
        Re().then(K);
    }, [
        x,
        t
    ]);
    let te = (0, $acw62.useRef)();
    $0a8a304ccadc5598$var$R([
        $0a8a304ccadc5598$var$f.ENTER
    ], j, {
        target: te
    });
    let Ie = L && m && !v.some((o)=>(o == null ? void 0 : o.value) === m);
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "select-panel",
        role: "listbox",
        ref: O,
        children: [
            !s && (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "search",
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("input", {
                        placeholder: e("search"),
                        type: "text",
                        "aria-describedby": e("search"),
                        onChange: h,
                        onFocus: Oe,
                        value: m,
                        ref: g,
                        tabIndex: 0
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "search-clear-button",
                        hidden: !m,
                        onClick: P,
                        "aria-label": e("clearSearch"),
                        children: i || (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$T, {})
                    })
                ]
            }),
            (0, $7b02d682eb115277$exports.jsxs)("ul", {
                className: "options",
                children: [
                    p && Ee && (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$export$13ef48a934230896, {
                        tabIndex: A === 1 ? 0 : 1,
                        checked: ke,
                        option: _,
                        onSelectionChanged: B,
                        onClick: ()=>Z(1),
                        itemRenderer: u,
                        disabled: b
                    }),
                    v.length ? (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$ue, {
                        skipIndex: A,
                        options: v,
                        onClick: (o, d)=>Z(d)
                    }) : Ie ? (0, $7b02d682eb115277$exports.jsx)("li", {
                        onClick: j,
                        className: "select-item creatable",
                        tabIndex: 1,
                        ref: te,
                        children: `${e("create")} "${m}"`
                    }) : (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: "no-options",
                        children: e("noOptions")
                    })
                ]
            })
        ]
    });
}, $0a8a304ccadc5598$export$9640093ec8451560 = $0a8a304ccadc5598$var$Je;
var $0a8a304ccadc5598$var$ge = ({ expanded: e })=>(0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        className: "dropdown-heading-dropdown-arrow gray",
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
        })
    });
var $0a8a304ccadc5598$var$xe = ()=>{
    let { t: e, value: n, options: t, valueRenderer: r } = $0a8a304ccadc5598$var$w(), a = n.length === 0, c = n.length === t.length, u = r && r(n, t);
    return a ? (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "gray",
        children: u || e("selectSomeItems")
    }) : (0, $7b02d682eb115277$exports.jsx)("span", {
        children: u || (c ? e("allItemsAreSelected") : (()=>n.map((s)=>s.label).join(", "))())
    });
};
var $0a8a304ccadc5598$var$Se = ({ size: e = 24 })=>(0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            width: e,
            marginRight: "0.2rem"
        },
        children: (0, $7b02d682eb115277$exports.jsx)("svg", {
            width: e,
            height: e,
            className: "spinner",
            viewBox: "0 0 50 50",
            style: {
                display: "inline",
                verticalAlign: "middle"
            },
            children: (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "25",
                cy: "25",
                r: "20",
                fill: "none",
                className: "path"
            })
        })
    });
var $0a8a304ccadc5598$var$Xe = ()=>{
    let { t: e, onMenuToggle: n, ArrowRenderer: t, shouldToggleOnHover: r, isLoading: a, disabled: c, onChange: u, labelledBy: b, value: s, isOpen: p, defaultIsOpen: i, ClearSelectedIcon: l, closeOnChangedValue: L } = $0a8a304ccadc5598$var$w();
    (0, $acw62.useEffect)(()=>{
        L && m(!1);
    }, [
        s
    ]);
    let [y, O] = (0, $acw62.useState)(!0), [g, m] = (0, $acw62.useState)(i), [M, v] = (0, $acw62.useState)(!1), K = t || $0a8a304ccadc5598$var$ge, x = (0, $acw62.useRef)();
    $0a8a304ccadc5598$var$se(()=>{
        n && n(g);
    }, [
        g
    ]), (0, $acw62.useEffect)(()=>{
        i === void 0 && typeof p == "boolean" && (O(!1), m(p));
    }, [
        p
    ]);
    let D = (h)=>{
        var P;
        [
            "text",
            "button"
        ].includes(h.target.type) && [
            $0a8a304ccadc5598$var$f.SPACE,
            $0a8a304ccadc5598$var$f.ENTER
        ].includes(h.code) || (y && (h.code === $0a8a304ccadc5598$var$f.ESCAPE ? (m(!1), (P = x == null ? void 0 : x.current) == null || P.focus()) : m(!0)), h.preventDefault());
    };
    $0a8a304ccadc5598$var$R([
        $0a8a304ccadc5598$var$f.ENTER,
        $0a8a304ccadc5598$var$f.ARROW_DOWN,
        $0a8a304ccadc5598$var$f.SPACE,
        $0a8a304ccadc5598$var$f.ESCAPE
    ], D, {
        target: x
    });
    let E = (h)=>{
        y && r && m(h);
    }, I = ()=>!M && v(!0), W = (h)=>{
        !h.currentTarget.contains(h.relatedTarget) && y && (v(!1), m(!1));
    }, A = ()=>E(!0), _ = ()=>E(!1), H = ()=>{
        y && m(a || c ? !1 : !g);
    }, B = (h)=>{
        h.stopPropagation(), u([]), y && m(!1);
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", {
        tabIndex: 0,
        className: "dropdown-container",
        "aria-labelledby": b,
        "aria-expanded": g,
        "aria-readonly": !0,
        "aria-disabled": c,
        ref: x,
        onFocus: I,
        onBlur: W,
        onMouseEnter: A,
        onMouseLeave: _,
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dropdown-heading",
                onClick: H,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "dropdown-heading-value",
                        children: (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$xe, {})
                    }),
                    a && (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$Se, {}),
                    s.length > 0 && l !== null && (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        className: "clear-selected-button",
                        onClick: B,
                        disabled: c,
                        "aria-label": e("clearSelected"),
                        children: l || (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$T, {})
                    }),
                    (0, $7b02d682eb115277$exports.jsx)(K, {
                        expanded: g
                    })
                ]
            }),
            g && (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "dropdown-content",
                children: (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "panel-content",
                    children: (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$export$9640093ec8451560, {})
                })
            })
        ]
    });
}, $0a8a304ccadc5598$export$931cbfb6bfb85fc = $0a8a304ccadc5598$var$Xe;
var $0a8a304ccadc5598$var$Ze = (e)=>(0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$var$ne, {
        props: e,
        children: (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `rmsc ${e.className || "multi-select"}`,
            children: (0, $7b02d682eb115277$exports.jsx)($0a8a304ccadc5598$export$931cbfb6bfb85fc, {})
        })
    }), $0a8a304ccadc5598$export$1e7dfd31545b5809 = $0a8a304ccadc5598$var$Ze;


function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $983350b7b3960a26$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $983350b7b3960a26$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();



var $fm8kz = parcelRequire("fm8kz");
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($fc182b1f84212d3f$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + "box-$1$2" + (0, $fm8kz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-item-" + (0, $fm8kz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + "flex-line-pack" + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + "box-" + (0, $fm8kz.replace)(value, "-grow", "") + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, "$1" + (0, $fm8kz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + "$1"), /(image-set)/, (0, $fm8kz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + "box-pack:$3" + (0, $fm8kz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $fm8kz.WEBKIT) + "$2-$3" + "$1" + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $fm8kz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ":", ":" + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $fm8kz.WEBKIT) + "$2$3" + "$1" + (0, $fm8kz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, "@", "@" + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ":" + (0, $fm8kz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $fm8kz.stringify),
        (0, $fm8kz.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;





var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $0fe24a6591b39473$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $0fe24a6591b39473$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $0fe24a6591b39473$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7)));
    if (!(0, $0fe24a6591b39473$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(arr, i) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr, i) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

function $973e4da43f2a375d$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $973e4da43f2a375d$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $973e4da43f2a375d$var$getSide(placement) {
    return placement.split("-")[0];
}
function $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($973e4da43f2a375d$var$getSide(placement)) ? "x" : "y";
}
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $973e4da43f2a375d$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($973e4da43f2a375d$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $973e4da43f2a375d$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $973e4da43f2a375d$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $973e4da43f2a375d$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $973e4da43f2a375d$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = options;
    const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $973e4da43f2a375d$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const $973e4da43f2a375d$var$min = Math.min;
const $973e4da43f2a375d$var$max = Math.max;
function $973e4da43f2a375d$var$within(min$1, value, max$1) {
    return $973e4da43f2a375d$var$max(min$1, $973e4da43f2a375d$var$min(value, max$1));
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = options || {};
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements } = state;
            if (element == null) return {};
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const length = $973e4da43f2a375d$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $973e4da43f2a375d$var$within(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $973e4da43f2a375d$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $973e4da43f2a375d$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $973e4da43f2a375d$var$allPlacements = /*#__PURE__*/ $973e4da43f2a375d$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
const $973e4da43f2a375d$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $973e4da43f2a375d$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$973e4da43f2a375d$var$oppositeSideMap[side]);
}
function $973e4da43f2a375d$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
    const length = $973e4da43f2a375d$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $973e4da43f2a375d$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $973e4da43f2a375d$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$973e4da43f2a375d$var$oppositeAlignmentMap[alignment]);
}
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$973e4da43f2a375d$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $973e4da43f2a375d$var$getAlignment(placement) === alignment || (autoAlignment ? $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = $973e4da43f2a375d$var$allPlacements, autoAlignment: autoAlignment = true, ...detectOverflowOptions } = options;
            const placements = alignment !== undefined || allowedPlacements === $973e4da43f2a375d$var$allPlacements ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main, cross: cross } = $973e4da43f2a375d$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$973e4da43f2a375d$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = $973e4da43f2a375d$var$getAlignment(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                $973e4da43f2a375d$var$getAlignment(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getExpandedPlacements(placement) {
    const oppositePlacement = $973e4da43f2a375d$var$getOppositePlacement(placement);
    return [
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $973e4da43f2a375d$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $973e4da43f2a375d$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $973e4da43f2a375d$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    let list = $973e4da43f2a375d$var$getSideList($973e4da43f2a375d$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($973e4da43f2a375d$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = options;
            const side = $973e4da43f2a375d$var$getSide(placement);
            const isBasePlacement = $973e4da43f2a375d$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $973e4da43f2a375d$var$getOppositePlacement(initialPlacement)
            ] : $973e4da43f2a375d$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$973e4da43f2a375d$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main, cross: cross } = $973e4da43f2a375d$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return $973e4da43f2a375d$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = options;
            const { rects: rects } = state;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = $973e4da43f2a375d$var$min(...rects.map((rect)=>rect.left));
    const minY = $973e4da43f2a375d$var$min(...rects.map((rect)=>rect.top));
    const maxX = $973e4da43f2a375d$var$max(...rects.map((rect)=>rect.right));
    const maxY = $973e4da43f2a375d$var$max(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>$973e4da43f2a375d$export$ee05aea0aeecbad4($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = options;
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = $973e4da43f2a375d$export$ee05aea0aeecbad4($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = $973e4da43f2a375d$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ($973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $973e4da43f2a375d$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $973e4da43f2a375d$var$getSide(placement) === "left";
                    const maxRight = $973e4da43f2a375d$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $973e4da43f2a375d$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
async function $973e4da43f2a375d$var$convertValueToCoords(state, value) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $973e4da43f2a375d$var$getSide(placement);
    const alignment = $973e4da43f2a375d$var$getAlignment(placement);
    const isVertical = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(state) : value;
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $973e4da43f2a375d$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement($973e4da43f2a375d$var$getSide(placement));
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $973e4da43f2a375d$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $973e4da43f2a375d$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const crossAxis = $973e4da43f2a375d$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset(state) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($973e4da43f2a375d$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = options;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = $973e4da43f2a375d$var$getSide(placement);
            const alignment = $973e4da43f2a375d$var$getAlignment(placement);
            const axis = $973e4da43f2a375d$var$getMainAxisFromPlacement(placement);
            const isXAxis = axis === "x";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isXAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? $973e4da43f2a375d$var$min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? $973e4da43f2a375d$var$min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = $973e4da43f2a375d$var$max(overflow.left, 0);
                const xMax = $973e4da43f2a375d$var$max(overflow.right, 0);
                const yMin = $973e4da43f2a375d$var$max(overflow.top, 0);
                const yMax = $973e4da43f2a375d$var$max(overflow.bottom, 0);
                if (isXAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $973e4da43f2a375d$var$max(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $973e4da43f2a375d$var$max(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};


function $461947879dcdbcd4$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $461947879dcdbcd4$var$getComputedStyle$1(element) {
    return $461947879dcdbcd4$var$getWindow(element).getComputedStyle(element);
}
function $461947879dcdbcd4$var$isNode(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Node;
}
function $461947879dcdbcd4$var$getNodeName(node) {
    return $461947879dcdbcd4$var$isNode(node) ? (node.nodeName || "").toLowerCase() : "";
}
function $461947879dcdbcd4$var$isHTMLElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).HTMLElement;
}
function $461947879dcdbcd4$var$isElement(value) {
    return value instanceof $461947879dcdbcd4$var$getWindow(value).Element;
}
function $461947879dcdbcd4$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $461947879dcdbcd4$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $461947879dcdbcd4$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $461947879dcdbcd4$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $461947879dcdbcd4$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($461947879dcdbcd4$var$getNodeName(element));
}
function $461947879dcdbcd4$var$isContainingBlock(element) {
    const safari = $461947879dcdbcd4$var$isSafari();
    const css = $461947879dcdbcd4$var$getComputedStyle$1(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || !safari && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !safari && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $461947879dcdbcd4$var$isSafari() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $461947879dcdbcd4$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($461947879dcdbcd4$var$getNodeName(node));
}
const $461947879dcdbcd4$var$min = Math.min;
const $461947879dcdbcd4$var$max = Math.max;
const $461947879dcdbcd4$var$round = Math.round;
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = $461947879dcdbcd4$var$getComputedStyle$1(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = $461947879dcdbcd4$var$isHTMLElement(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = $461947879dcdbcd4$var$round(width) !== offsetWidth || $461947879dcdbcd4$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        fallback: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !$461947879dcdbcd4$var$isElement(element) ? element.contextElement : element;
}
const $461947879dcdbcd4$var$FALLBACK_SCALE = {
    x: 1,
    y: 1
};
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!$461947879dcdbcd4$var$isHTMLElement(domElement)) return $461947879dcdbcd4$var$FALLBACK_SCALE;
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, fallback: fallback } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = (fallback ? $461947879dcdbcd4$var$round(rect.width) : rect.width) / width;
    let y = (fallback ? $461947879dcdbcd4$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = {
    x: 0,
    y: 0
};
function $461947879dcdbcd4$var$getVisualOffsets(element, isFixed, floatingOffsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (isFixed === void 0) isFixed = true;
    if (!$461947879dcdbcd4$var$isSafari()) return $461947879dcdbcd4$var$noOffsets;
    const win = element ? $461947879dcdbcd4$var$getWindow(element) : window;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== win) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0,
        y: ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0
    };
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = $461947879dcdbcd4$var$FALLBACK_SCALE;
    if (includeScale) {
        if (offsetParent) {
            if ($461947879dcdbcd4$var$isElement(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(domElement, isFixedStrategy, offsetParent);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $461947879dcdbcd4$var$getWindow(domElement);
        const offsetWin = offsetParent && $461947879dcdbcd4$var$isElement(offsetParent) ? $461947879dcdbcd4$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle(currentIFrame);
            iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += iframeRect.x;
            y += iframeRect.y;
            currentIFrame = $461947879dcdbcd4$var$getWindow(currentIFrame).frameElement;
        }
    }
    return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$getDocumentElement(node) {
    return (($461947879dcdbcd4$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $461947879dcdbcd4$var$getNodeScroll(element) {
    if ($461947879dcdbcd4$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = {
        x: 1,
        y: 1
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== "body" || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect($461947879dcdbcd4$var$getDocumentElement(element)).left + $461947879dcdbcd4$var$getNodeScroll(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const scroll = $461947879dcdbcd4$var$getNodeScroll(element);
    const body = element.ownerDocument.body;
    const width = $461947879dcdbcd4$var$max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = $461947879dcdbcd4$var$max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($461947879dcdbcd4$var$getComputedStyle$1(body).direction === "rtl") x += $461947879dcdbcd4$var$max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getParentNode(node) {
    if ($461947879dcdbcd4$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $461947879dcdbcd4$var$isShadowRoot(node) && node.host || // Fallback.
    $461947879dcdbcd4$var$getDocumentElement(node);
    return $461947879dcdbcd4$var$isShadowRoot(result) ? result.host : result;
}
function $461947879dcdbcd4$var$getNearestOverflowAncestor(node) {
    const parentNode = $461947879dcdbcd4$var$getParentNode(node);
    if ($461947879dcdbcd4$var$isLastTraversableNode(parentNode)) // `getParentNode` will never return a `Document` due to the fallback
    // check, so it's either the <html> or <body> element.
    return parentNode.ownerDocument.body;
    if ($461947879dcdbcd4$var$isHTMLElement(parentNode) && $461947879dcdbcd4$var$isOverflowElement(parentNode)) return parentNode;
    return $461947879dcdbcd4$var$getNearestOverflowAncestor(parentNode);
}
function $461947879dcdbcd4$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $461947879dcdbcd4$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $461947879dcdbcd4$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $461947879dcdbcd4$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $461947879dcdbcd4$export$3b57c1601291186b(scrollableAncestor));
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = $461947879dcdbcd4$var$getWindow(element);
    const html = $461947879dcdbcd4$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = $461947879dcdbcd4$var$isSafari();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $461947879dcdbcd4$var$isHTMLElement(element) ? $461947879dcdbcd4$var$getScale(element) : {
        x: 1,
        y: 1
    };
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect($461947879dcdbcd4$var$getDocumentElement(element));
    else if ($461947879dcdbcd4$var$isElement(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $973e4da43f2a375d$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = $461947879dcdbcd4$var$getParentNode(element);
    if (parentNode === stopNode || !$461947879dcdbcd4$var$isElement(parentNode) || $461947879dcdbcd4$var$isLastTraversableNode(parentNode)) return false;
    return $461947879dcdbcd4$var$getComputedStyle$1(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $461947879dcdbcd4$export$3b57c1601291186b(element).filter((el)=>$461947879dcdbcd4$var$isElement(el) && $461947879dcdbcd4$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $461947879dcdbcd4$var$getComputedStyle$1(element).position === "fixed";
    let currentNode = elementIsFixed ? $461947879dcdbcd4$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($461947879dcdbcd4$var$isElement(currentNode) && !$461947879dcdbcd4$var$isLastTraversableNode(currentNode)){
        const computedStyle = $461947879dcdbcd4$var$getComputedStyle$1(currentNode);
        const currentNodeIsContaining = $461947879dcdbcd4$var$isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || $461947879dcdbcd4$var$isOverflowElement(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $461947879dcdbcd4$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $461947879dcdbcd4$var$max(rect.top, accRect.top);
        accRect.right = $461947879dcdbcd4$var$min(rect.right, accRect.right);
        accRect.bottom = $461947879dcdbcd4$var$min(rect.bottom, accRect.bottom);
        accRect.left = $461947879dcdbcd4$var$max(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    return $461947879dcdbcd4$var$getCssDimensions(element);
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!$461947879dcdbcd4$var$isHTMLElement(element) || $461947879dcdbcd4$var$getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
function $461947879dcdbcd4$var$getContainingBlock(element) {
    let currentNode = $461947879dcdbcd4$var$getParentNode(element);
    while($461947879dcdbcd4$var$isHTMLElement(currentNode) && !$461947879dcdbcd4$var$isLastTraversableNode(currentNode)){
        if ($461947879dcdbcd4$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $461947879dcdbcd4$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window1 = $461947879dcdbcd4$var$getWindow(element);
    if (!$461947879dcdbcd4$var$isHTMLElement(element)) return window1;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && $461947879dcdbcd4$var$isTableElement(offsetParent) && $461947879dcdbcd4$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ($461947879dcdbcd4$var$getNodeName(offsetParent) === "html" || $461947879dcdbcd4$var$getNodeName(offsetParent) === "body" && $461947879dcdbcd4$var$getComputedStyle$1(offsetParent).position === "static" && !$461947879dcdbcd4$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $461947879dcdbcd4$var$getContainingBlock(element) || window1;
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $461947879dcdbcd4$var$isHTMLElement(offsetParent);
    const documentElement = $461947879dcdbcd4$var$getDocumentElement(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($461947879dcdbcd4$var$getNodeName(offsetParent) !== "body" || $461947879dcdbcd4$var$isOverflowElement(documentElement)) scroll = $461947879dcdbcd4$var$getNodeScroll(offsetParent);
        if ($461947879dcdbcd4$var$isHTMLElement(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $461947879dcdbcd4$var$isElement,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getDocumentElement: $461947879dcdbcd4$var$getDocumentElement,
    getScale: $461947879dcdbcd4$var$getScale,
    async getElementRects (_ref) {
        let { reference: reference, floating: floating, strategy: strategy } = _ref;
        const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
            floating: {
                x: 0,
                y: 0,
                ...await getDimensionsFn(floating)
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$461947879dcdbcd4$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = true, animationFrame: animationFrame = false } = options;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$461947879dcdbcd4$var$isElement(reference) ? $461947879dcdbcd4$export$3b57c1601291186b(reference) : reference.contextElement ? $461947879dcdbcd4$export$3b57c1601291186b(reference.contextElement) : [],
        ...$461947879dcdbcd4$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        // ignores Window, checks for [object VisualViewport]
        const isVisualViewport = !$461947879dcdbcd4$var$isElement(ancestor) && ancestor.toString().includes("V");
        if (ancestorScroll && (animationFrame ? isVisualViewport : true)) ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        observer = new ResizeObserver(()=>{
            update();
        });
        $461947879dcdbcd4$var$isElement(reference) && !animationFrame && observer.observe(reference);
        if (!$461947879dcdbcd4$var$isElement(reference) && reference.contextElement && !animationFrame) observer.observe(reference.contextElement);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $986c40371255b7c2$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $986c40371255b7c2$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $986c40371255b7c2$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $986c40371255b7c2$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($986c40371255b7c2$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $986c40371255b7c2$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($986c40371255b7c2$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $986c40371255b7c2$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $986c40371255b7c2$var$_excluded$3);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $986c40371255b7c2$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $986c40371255b7c2$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $986c40371255b7c2$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $986c40371255b7c2$var$normalizedHeight(el) {
    if ($986c40371255b7c2$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $986c40371255b7c2$var$getScrollTop(el) {
    if ($986c40371255b7c2$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $986c40371255b7c2$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($986c40371255b7c2$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $986c40371255b7c2$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $986c40371255b7c2$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $986c40371255b7c2$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $986c40371255b7c2$export$b4171a6734a65d42;
    var start = $986c40371255b7c2$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $986c40371255b7c2$var$easeOutCubic(currentTime, start, change, duration);
        $986c40371255b7c2$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $986c40371255b7c2$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $986c40371255b7c2$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $986c40371255b7c2$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $986c40371255b7c2$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $986c40371255b7c2$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $986c40371255b7c2$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $986c40371255b7c2$var$passiveOptionAccessed = false;
var $986c40371255b7c2$var$options = {
    get passive () {
        return $986c40371255b7c2$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $986c40371255b7c2$var$w = typeof window !== "undefined" ? window : {};
if ($986c40371255b7c2$var$w.addEventListener && $986c40371255b7c2$var$w.removeEventListener) {
    $986c40371255b7c2$var$w.addEventListener("p", $986c40371255b7c2$export$b4171a6734a65d42, $986c40371255b7c2$var$options);
    $986c40371255b7c2$var$w.removeEventListener("p", $986c40371255b7c2$export$b4171a6734a65d42, false);
}
var $986c40371255b7c2$export$2408f22a0fab9ae5 = $986c40371255b7c2$var$passiveOptionAccessed;
function $986c40371255b7c2$export$3466f893ebf79586(item) {
    return item != null;
}
function $986c40371255b7c2$var$isArray(arg) {
    return Array.isArray(arg);
}
function $986c40371255b7c2$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $986c40371255b7c2$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $986c40371255b7c2$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $986c40371255b7c2$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $986c40371255b7c2$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $986c40371255b7c2$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $986c40371255b7c2$var$normalizedHeight(scrollParent);
    var scrollTop = $986c40371255b7c2$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $986c40371255b7c2$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $986c40371255b7c2$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $986c40371255b7c2$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $986c40371255b7c2$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $986c40371255b7c2$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $986c40371255b7c2$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $986c40371255b7c2$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $986c40371255b7c2$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $986c40371255b7c2$var$alignToControl(placement), "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $986c40371255b7c2$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $986c40371255b7c2$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($986c40371255b7c2$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $986c40371255b7c2$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $986c40371255b7c2$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $986c40371255b7c2$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $986c40371255b7c2$var$Menu$1 = $986c40371255b7c2$var$Menu;
// ==============================
// Menu List
// ==============================
var $986c40371255b7c2$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $986c40371255b7c2$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $986c40371255b7c2$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $986c40371255b7c2$export$3b14a55fb2447963 = $986c40371255b7c2$var$noticeCSS;
var $986c40371255b7c2$export$342063e11d6c3cad = $986c40371255b7c2$var$noticeCSS;
var $986c40371255b7c2$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
$986c40371255b7c2$var$NoOptionsMessage.defaultProps = {
    children: "No options"
};
var $986c40371255b7c2$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
$986c40371255b7c2$var$LoadingMessage.defaultProps = {
    children: "Loading..."
};
// ==============================
// Menu Portal
// ==============================
var $986c40371255b7c2$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $986c40371255b7c2$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($986c40371255b7c2$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $986c40371255b7c2$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $986c40371255b7c2$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $986c40371255b7c2$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $986c40371255b7c2$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $986c40371255b7c2$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $986c40371255b7c2$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $986c40371255b7c2$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $986c40371255b7c2$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $986c40371255b7c2$var$_templateObject;
var $986c40371255b7c2$var$_excluded$2 = [
    "size"
];
function $986c40371255b7c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $986c40371255b7c2$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $986c40371255b7c2$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $986c40371255b7c2$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $986c40371255b7c2$var$_ref2
    }, props));
};
var $986c40371255b7c2$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $986c40371255b7c2$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $986c40371255b7c2$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $986c40371255b7c2$export$f1e1789686576879 = $986c40371255b7c2$var$baseCSS;
var $986c40371255b7c2$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$DownChevron, null));
};
var $986c40371255b7c2$export$407448d2b89b1813 = $986c40371255b7c2$var$baseCSS;
var $986c40371255b7c2$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $986c40371255b7c2$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $986c40371255b7c2$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $986c40371255b7c2$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $986c40371255b7c2$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($986c40371255b7c2$var$_templateObject || ($986c40371255b7c2$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $986c40371255b7c2$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $986c40371255b7c2$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($986c40371255b7c2$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $986c40371255b7c2$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$986c40371255b7c2$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $986c40371255b7c2$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $986c40371255b7c2$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $986c40371255b7c2$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps), children);
};
var $986c40371255b7c2$var$Control$1 = $986c40371255b7c2$var$Control;
var $986c40371255b7c2$var$_excluded$1 = [
    "data"
];
var $986c40371255b7c2$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $986c40371255b7c2$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $986c40371255b7c2$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $986c40371255b7c2$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $986c40371255b7c2$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $986c40371255b7c2$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $986c40371255b7c2$var$Group$1 = $986c40371255b7c2$var$Group;
var $986c40371255b7c2$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $986c40371255b7c2$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $986c40371255b7c2$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $986c40371255b7c2$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $986c40371255b7c2$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $986c40371255b7c2$var$spacingStyle)
};
var $986c40371255b7c2$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $986c40371255b7c2$var$spacingStyle);
};
var $986c40371255b7c2$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $986c40371255b7c2$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $986c40371255b7c2$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $986c40371255b7c2$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $986c40371255b7c2$var$Input$1 = $986c40371255b7c2$var$Input;
var $986c40371255b7c2$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $986c40371255b7c2$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $986c40371255b7c2$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $986c40371255b7c2$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $986c40371255b7c2$var$MultiValueContainer = $986c40371255b7c2$var$MultiValueGeneric;
var $986c40371255b7c2$var$MultiValueLabel = $986c40371255b7c2$var$MultiValueGeneric;
function $986c40371255b7c2$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($986c40371255b7c2$var$CrossIcon, {
        size: 14
    }));
}
var $986c40371255b7c2$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $986c40371255b7c2$var$MultiValue$1 = $986c40371255b7c2$var$MultiValue;
var $986c40371255b7c2$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $986c40371255b7c2$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $986c40371255b7c2$var$Option$1 = $986c40371255b7c2$var$Option;
var $986c40371255b7c2$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $986c40371255b7c2$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $986c40371255b7c2$var$Placeholder$1 = $986c40371255b7c2$var$Placeholder;
var $986c40371255b7c2$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $986c40371255b7c2$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $986c40371255b7c2$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $986c40371255b7c2$var$SingleValue$1 = $986c40371255b7c2$var$SingleValue;
var $986c40371255b7c2$export$db3b6bfb95261072 = {
    ClearIndicator: $986c40371255b7c2$var$ClearIndicator,
    Control: $986c40371255b7c2$var$Control$1,
    DropdownIndicator: $986c40371255b7c2$var$DropdownIndicator,
    DownChevron: $986c40371255b7c2$var$DownChevron,
    CrossIcon: $986c40371255b7c2$var$CrossIcon,
    Group: $986c40371255b7c2$var$Group$1,
    GroupHeading: $986c40371255b7c2$var$GroupHeading,
    IndicatorsContainer: $986c40371255b7c2$var$IndicatorsContainer,
    IndicatorSeparator: $986c40371255b7c2$var$IndicatorSeparator,
    Input: $986c40371255b7c2$var$Input$1,
    LoadingIndicator: $986c40371255b7c2$var$LoadingIndicator,
    Menu: $986c40371255b7c2$var$Menu$1,
    MenuList: $986c40371255b7c2$var$MenuList,
    MenuPortal: $986c40371255b7c2$var$MenuPortal,
    LoadingMessage: $986c40371255b7c2$var$LoadingMessage,
    NoOptionsMessage: $986c40371255b7c2$var$NoOptionsMessage,
    MultiValue: $986c40371255b7c2$var$MultiValue$1,
    MultiValueContainer: $986c40371255b7c2$var$MultiValueContainer,
    MultiValueLabel: $986c40371255b7c2$var$MultiValueLabel,
    MultiValueRemove: $986c40371255b7c2$var$MultiValueRemove,
    Option: $986c40371255b7c2$var$Option$1,
    Placeholder: $986c40371255b7c2$var$Placeholder$1,
    SelectContainer: $986c40371255b7c2$var$SelectContainer,
    SingleValue: $986c40371255b7c2$var$SingleValue$1,
    ValueContainer: $986c40371255b7c2$var$ValueContainer
};
var $986c40371255b7c2$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $986c40371255b7c2$export$db3b6bfb95261072), props.components);
};





var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");


var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $d5b559d5750ae890$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $d5b559d5750ae890$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $d5b559d5750ae890$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $d5b559d5750ae890$var$_ref
    }, props));
};
var $d5b559d5750ae890$var$A11yText$1 = $d5b559d5750ae890$var$A11yText;
var $d5b559d5750ae890$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $d5b559d5750ae890$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $d5b559d5750ae890$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($d5b559d5750ae890$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($d5b559d5750ae890$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $d5b559d5750ae890$var$LiveRegion$1 = $d5b559d5750ae890$var$LiveRegion;
var $d5b559d5750ae890$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $d5b559d5750ae890$var$anyDiacritic = new RegExp("[" + $d5b559d5750ae890$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $d5b559d5750ae890$var$diacriticToBase = {};
for(var $d5b559d5750ae890$var$i = 0; $d5b559d5750ae890$var$i < $d5b559d5750ae890$var$diacritics.length; $d5b559d5750ae890$var$i++){
    var $d5b559d5750ae890$var$diacritic = $d5b559d5750ae890$var$diacritics[$d5b559d5750ae890$var$i];
    for(var $d5b559d5750ae890$var$j = 0; $d5b559d5750ae890$var$j < $d5b559d5750ae890$var$diacritic.letters.length; $d5b559d5750ae890$var$j++)$d5b559d5750ae890$var$diacriticToBase[$d5b559d5750ae890$var$diacritic.letters[$d5b559d5750ae890$var$j]] = $d5b559d5750ae890$var$diacritic.base;
}
var $d5b559d5750ae890$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($d5b559d5750ae890$var$anyDiacritic, function(match) {
        return $d5b559d5750ae890$var$diacriticToBase[match];
    });
};
var $d5b559d5750ae890$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($d5b559d5750ae890$var$stripDiacritics);
var $d5b559d5750ae890$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $d5b559d5750ae890$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $d5b559d5750ae890$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $d5b559d5750ae890$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $d5b559d5750ae890$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $d5b559d5750ae890$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $d5b559d5750ae890$var$memoizedStripDiacriticsForInput(input);
            candidate = $d5b559d5750ae890$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $d5b559d5750ae890$var$_excluded = [
    "innerRef"
];
function $d5b559d5750ae890$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $d5b559d5750ae890$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $986c40371255b7c2$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $d5b559d5750ae890$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $d5b559d5750ae890$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $d5b559d5750ae890$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $986c40371255b7c2$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $d5b559d5750ae890$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $d5b559d5750ae890$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $d5b559d5750ae890$var$preventTouchMove(e) {
    e.preventDefault();
}
function $d5b559d5750ae890$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $d5b559d5750ae890$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $d5b559d5750ae890$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $d5b559d5750ae890$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $d5b559d5750ae890$var$activeScrollLocks = 0;
var $d5b559d5750ae890$var$listenerOptions = {
    capture: false,
    passive: false
};
function $d5b559d5750ae890$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$d5b559d5750ae890$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $d5b559d5750ae890$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $d5b559d5750ae890$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($d5b559d5750ae890$var$LOCK_STYLES).forEach(function(key) {
                var val = $d5b559d5750ae890$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $d5b559d5750ae890$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $d5b559d5750ae890$var$preventTouchMove, $d5b559d5750ae890$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $d5b559d5750ae890$var$preventInertiaScroll, $d5b559d5750ae890$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $d5b559d5750ae890$var$allowTouchMove, $d5b559d5750ae890$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $d5b559d5750ae890$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$d5b559d5750ae890$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $d5b559d5750ae890$var$activeScrollLocks = Math.max($d5b559d5750ae890$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $d5b559d5750ae890$var$activeScrollLocks < 1) $d5b559d5750ae890$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $d5b559d5750ae890$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $d5b559d5750ae890$var$preventTouchMove, $d5b559d5750ae890$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $d5b559d5750ae890$var$preventInertiaScroll, $d5b559d5750ae890$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $d5b559d5750ae890$var$allowTouchMove, $d5b559d5750ae890$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $d5b559d5750ae890$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d5b559d5750ae890$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $d5b559d5750ae890$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $d5b559d5750ae890$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $d5b559d5750ae890$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $d5b559d5750ae890$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $d5b559d5750ae890$var$blurSelectInput,
        css: $d5b559d5750ae890$var$_ref2$1
    }), children(targetRef));
}
function $d5b559d5750ae890$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d5b559d5750ae890$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $d5b559d5750ae890$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $d5b559d5750ae890$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $d5b559d5750ae890$var$RequiredInput$1 = $d5b559d5750ae890$var$RequiredInput;
var $d5b559d5750ae890$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $d5b559d5750ae890$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $d5b559d5750ae890$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $d5b559d5750ae890$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $d5b559d5750ae890$var$defaultStyles = {
    clearIndicator: (0, $986c40371255b7c2$export$407448d2b89b1813),
    container: (0, $986c40371255b7c2$export$8b22cf2602fb60ce),
    control: (0, $986c40371255b7c2$export$4368d992c4eafac0),
    dropdownIndicator: (0, $986c40371255b7c2$export$f1e1789686576879),
    group: (0, $986c40371255b7c2$export$39b482c5e57630a8),
    groupHeading: (0, $986c40371255b7c2$export$2d1720544b23b823),
    indicatorsContainer: (0, $986c40371255b7c2$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $986c40371255b7c2$export$dda1d9f60106f0e9),
    input: (0, $986c40371255b7c2$export$35e795649ee09318),
    loadingIndicator: (0, $986c40371255b7c2$export$882b5998b3b9117c),
    loadingMessage: (0, $986c40371255b7c2$export$342063e11d6c3cad),
    menu: (0, $986c40371255b7c2$export$953cecd6e717a553),
    menuList: (0, $986c40371255b7c2$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $986c40371255b7c2$export$ae1af26003f05816),
    multiValue: (0, $986c40371255b7c2$export$ffb5f4729a158638),
    multiValueLabel: (0, $986c40371255b7c2$export$9e5f44173e64f162),
    multiValueRemove: (0, $986c40371255b7c2$export$625550452a3fa3ec),
    noOptionsMessage: (0, $986c40371255b7c2$export$3b14a55fb2447963),
    option: (0, $986c40371255b7c2$export$90a7f3efeed30595),
    placeholder: (0, $986c40371255b7c2$export$efccba1c4a2ef57b),
    singleValue: (0, $986c40371255b7c2$export$d141bba7fdc215a3),
    valueContainer: (0, $986c40371255b7c2$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $d5b559d5750ae890$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $d5b559d5750ae890$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $d5b559d5750ae890$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $d5b559d5750ae890$var$baseUnit = 4;
// The minimum height of the control
var $d5b559d5750ae890$var$controlHeight = 38;
// The amount of space between the control and menu */
var $d5b559d5750ae890$var$menuGutter = $d5b559d5750ae890$var$baseUnit * 2;
var $d5b559d5750ae890$var$spacing = {
    baseUnit: $d5b559d5750ae890$var$baseUnit,
    controlHeight: $d5b559d5750ae890$var$controlHeight,
    menuGutter: $d5b559d5750ae890$var$menuGutter
};
var $d5b559d5750ae890$export$4368d992c4eafac0 = {
    borderRadius: $d5b559d5750ae890$var$borderRadius,
    colors: $d5b559d5750ae890$var$colors,
    spacing: $d5b559d5750ae890$var$spacing
};
var $d5b559d5750ae890$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $986c40371255b7c2$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $986c40371255b7c2$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $d5b559d5750ae890$export$db3b6bfb95261072(),
    formatGroupLabel: $d5b559d5750ae890$var$formatGroupLabel,
    getOptionLabel: $d5b559d5750ae890$export$8b22cf2602fb60ce,
    getOptionValue: $d5b559d5750ae890$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $d5b559d5750ae890$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $986c40371255b7c2$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $d5b559d5750ae890$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $d5b559d5750ae890$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $d5b559d5750ae890$var$_isOptionSelected(props, option, selectValue);
    var label = $d5b559d5750ae890$var$getOptionLabel(props, option);
    var value = $d5b559d5750ae890$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d5b559d5750ae890$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $d5b559d5750ae890$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $d5b559d5750ae890$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $d5b559d5750ae890$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d5b559d5750ae890$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $986c40371255b7c2$export$3466f893ebf79586));
}
function $d5b559d5750ae890$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d5b559d5750ae890$var$buildFocusableOptions(props, selectValue) {
    return $d5b559d5750ae890$var$buildFocusableOptionsFromCategorizedOptions($d5b559d5750ae890$var$buildCategorizedOptions(props, selectValue));
}
function $d5b559d5750ae890$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$d5b559d5750ae890$var$shouldHideSelectedOptions(props) || !isSelected) && $d5b559d5750ae890$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d5b559d5750ae890$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d5b559d5750ae890$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $d5b559d5750ae890$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $d5b559d5750ae890$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $d5b559d5750ae890$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $d5b559d5750ae890$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $d5b559d5750ae890$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $d5b559d5750ae890$var$getOptionValue(props, i) === candidate;
    });
}
function $d5b559d5750ae890$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $d5b559d5750ae890$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $d5b559d5750ae890$var$instanceId = 1;
var $d5b559d5750ae890$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $986c40371255b7c2$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $986c40371255b7c2$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $986c40371255b7c2$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $986c40371255b7c2$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $986c40371255b7c2$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $986c40371255b7c2$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $986c40371255b7c2$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $986c40371255b7c2$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $d5b559d5750ae890$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $d5b559d5750ae890$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $d5b559d5750ae890$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $986c40371255b7c2$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $d5b559d5750ae890$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $d5b559d5750ae890$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $986c40371255b7c2$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $d5b559d5750ae890$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$d5b559d5750ae890$var$instanceId);
        _this.state.selectValue = (0, $986c40371255b7c2$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $986c40371255b7c2$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $986c40371255b7c2$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $d5b559d5750ae890$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($d5b559d5750ae890$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $d5b559d5750ae890$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $d5b559d5750ae890$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $d5b559d5750ae890$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $d5b559d5750ae890$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($d5b559d5750ae890$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $986c40371255b7c2$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $986c40371255b7c2$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($d5b559d5750ae890$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($d5b559d5750ae890$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($d5b559d5750ae890$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $986c40371255b7c2$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $d5b559d5750ae890$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $d5b559d5750ae890$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $d5b559d5750ae890$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $986c40371255b7c2$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$d5b559d5750ae890$export$25ce5a424b770e84.defaultProps = $d5b559d5750ae890$export$407448d2b89b1813;





var $8de12fa6a893dcd1$exports = {};
var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


function $8de12fa6a893dcd1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8de12fa6a893dcd1$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bb7ca61ce45563c4$exports(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8de12fa6a893dcd1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
$8de12fa6a893dcd1$exports = $8de12fa6a893dcd1$var$_objectSpread2, $8de12fa6a893dcd1$exports.__esModule = true, $8de12fa6a893dcd1$exports["default"] = $8de12fa6a893dcd1$exports;


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7b4ac2338b8e8f97$exports(subClass, superClass);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $6c89cb228f797fa5$exports = {};
var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;


var $ac4cd79166dac6e4$exports = {};

var $ac4cd79166dac6e4$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(self);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


function $6c89cb228f797fa5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $426f299ee58329c3$exports();
    return function _createSuperInternal() {
        var Super = $93d4339c80153a6a$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $93d4339c80153a6a$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ac4cd79166dac6e4$exports(this, result);
    };
}
$6c89cb228f797fa5$exports = $6c89cb228f797fa5$var$_createSuper, $6c89cb228f797fa5$exports.__esModule = true, $6c89cb228f797fa5$exports["default"] = $6c89cb228f797fa5$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;




var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;






var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $d5b559d5750ae890$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0fe24a6591b39473$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};



const $6acfd7cb01a49a02$var$libOptions = [
    {
        "label": "Software Architecture",
        "value": "software-architecture"
    },
    {
        "label": "System Design Components",
        "value": "system-design"
    },
    {
        "label": "Architecture diagram components",
        "value": "architecture-diagram-components"
    },
    {
        "label": "Software Logos",
        "value": "drwnio"
    },
    {
        "label": "Stick Figures",
        "value": "stick-figures"
    },
    {
        "label": "Forms",
        "value": "forms"
    },
    {
        "label": "AWS Architecture Icons",
        "value": "aws-architecture-icons"
    },
    {
        "label": "Data Viz",
        "value": "data-viz"
    },
    {
        "label": "Awesome Icons",
        "value": "awesome-icons"
    },
    {
        "label": "Cloud",
        "value": "cloud"
    },
    {
        "label": "Decision flow control",
        "value": "decision-flow-control"
    },
    {
        "label": "Basic UX/wireframing elements",
        "value": "basic-ux-wireframing-elements"
    },
    {
        "label": "System Design Template",
        "value": "system-design-template"
    },
    {
        "label": "Google Icons",
        "value": "google-icons"
    },
    {
        "label": "Icons",
        "value": "icons"
    },
    {
        "label": "Systems Design Components",
        "value": "systems-design-components"
    },
    {
        "label": "Dev Ops Icons",
        "value": "dev_ops"
    },
    {
        "label": "Network topology icons",
        "value": "network-topology-icons"
    },
    {
        "label": "Database",
        "value": "db-eng"
    },
    {
        "label": "Algorithms and Data Structures (Arrays, Matrices, Trees ...)",
        "value": "algorithms-and-data-structures-arrays-matrices-trees"
    },
    {
        "label": "Lo-Fi Wireframing Kit",
        "value": "lo-fi-wireframing-kit"
    },
    {
        "label": "Technology Logos",
        "value": "technology-logos"
    },
    {
        "label": "Sticky Notes",
        "value": "post-it"
    },
    {
        "label": "Cloud Design Patterns",
        "value": "cloud-design-patterns"
    },
    {
        "label": "Basic shapes",
        "value": "basic-shapes"
    },
    {
        "label": "Bubbles",
        "value": "bubbles"
    },
    {
        "label": "Web Kit",
        "value": "web-kit"
    },
    {
        "label": "Information Architecture",
        "value": "information-architecture"
    },
    {
        "label": "Storytelling",
        "value": "storytelling"
    },
    {
        "label": "Computers",
        "value": "computers"
    },
    {
        "label": "IT Logos",
        "value": "it-logos"
    },
    {
        "label": "AWS Serverless Icons",
        "value": "aws-serverless"
    },
    {
        "label": "Gantt Diagram",
        "value": "gantt"
    },
    {
        "label": "Microsoft Azure cloud icons",
        "value": "microsoft-azure-cloud-icons"
    },
    {
        "label": "Azure cloud services icons",
        "value": "azure-cloud-services"
    },
    {
        "label": "Artem's icons",
        "value": "artem-s-icons"
    },
    {
        "label": "Data Platform",
        "value": "data-platform"
    },
    {
        "label": "some-handdrawn-signs",
        "value": "some-handdrawn-signs"
    },
    {
        "label": "Emojis",
        "value": "emojis"
    },
    {
        "label": "Data sources",
        "value": "data-sources"
    },
    {
        "label": "Universal UI kit",
        "value": "universal-ui-kit"
    },
    {
        "label": "Robots",
        "value": "robots"
    },
    {
        "label": "AWS Simple Icons",
        "value": "aws-simple-icons"
    },
    {
        "label": "System Icons",
        "value": "system-icons"
    },
    {
        "label": "Math Teacher Library",
        "value": "math-teacher-library"
    },
    {
        "label": "Hexagonal Architecture",
        "value": "hexagonal-architecture"
    },
    {
        "label": "Webpage frames",
        "value": "webpage-frames"
    },
    {
        "label": "Dropdowns",
        "value": "dropdowns"
    },
    {
        "label": "Charts",
        "value": "charts"
    },
    {
        "label": "GCP Icons",
        "value": "gcp-icons"
    },
    {
        "label": "Azure Network",
        "value": "azure-network"
    },
    {
        "label": "Apple Devices Frames",
        "value": "apple-devices-frames"
    },
    {
        "label": "Graphs",
        "value": "graphs"
    },
    {
        "label": "Stick people",
        "value": "stick-people"
    },
    {
        "label": "Gadgets",
        "value": "gadgets"
    },
    {
        "label": "System Design Icons",
        "value": "systemdesignicons"
    },
    {
        "label": "Mobile Kit",
        "value": "mobile-kit"
    },
    {
        "label": "Wardley Maps Symbols",
        "value": "wardley-maps-symbols"
    },
    {
        "label": "Original Google Architecture Icons",
        "value": "original-google-architecture-icons"
    },
    {
        "label": "Deep learning",
        "value": "deep-learning"
    },
    {
        "label": "Scrum board",
        "value": "scrum-board"
    },
    {
        "label": "Network elements",
        "value": "network-elements"
    },
    {
        "label": "Some more logos",
        "value": "logos"
    },
    {
        "label": "Polygons",
        "value": "polygons"
    },
    {
        "label": "AWS Architecture Icons",
        "value": "aws-architecture-icons"
    },
    {
        "label": "Schematic Symbols",
        "value": "schematic-symbols"
    },
    {
        "label": "IT Logos",
        "value": "it-logos"
    },
    {
        "label": "Medias",
        "value": "medias"
    },
    {
        "label": "Mathematical Symbols",
        "value": "mathematical-symbols"
    },
    {
        "label": "Awesome Slides",
        "value": "awesome-slides"
    },
    {
        "label": "Data processing",
        "value": "data-processing"
    },
    {
        "label": "HTML input elements",
        "value": "html-input-elements"
    },
    {
        "label": "Business Model Templates",
        "value": "canvases"
    },
    {
        "label": "Veeam",
        "value": "veeam"
    },
    {
        "label": "Wardley Mapping Canvas",
        "value": "wardley-mapping-canvas"
    },
    {
        "label": "UML Library: Activity Diagram",
        "value": "uml-library-activity-diagram"
    },
    {
        "label": "Data Science logos",
        "value": "data-science"
    },
    {
        "label": "VMware Architecture Design",
        "value": "vmware-architecture-design"
    },
    {
        "label": "GitHub Git Icons",
        "value": "github-icons"
    },
    {
        "label": "Message Queue components",
        "value": "mq"
    },
    {
        "label": "Presentation Templates",
        "value": "presentation-templates"
    },
    {
        "label": "Redis Grafana",
        "value": "redis-grafana"
    },
    {
        "label": "Office Items",
        "value": "office-items"
    },
    {
        "label": "Azure Compute",
        "value": "azure-compute"
    },
    {
        "label": "bpmn",
        "value": "bpmn"
    },
    {
        "label": "Microsoft 365 icons",
        "value": "microsoft-365-icons"
    },
    {
        "label": "Some common cloud apps",
        "value": "some-common-cloud-apps"
    },
    {
        "label": "Network locations",
        "value": "network-locations"
    },
    {
        "label": "Snowflake Iconography",
        "value": "snowflake-iconography"
    },
    {
        "label": "Azure General",
        "value": "azure-general"
    },
    {
        "label": "Simple Sticky Notes",
        "value": "simple-sticky-notes"
    },
    {
        "label": "Hearts",
        "value": "hearts"
    },
    {
        "label": "C4 Architecture",
        "value": "c4-architecture"
    },
    {
        "label": "Common Home Network Basics",
        "value": "common-home-network-basics"
    },
    {
        "label": "Kubernetes Icons Set",
        "value": "kubernetes-icons-set"
    },
    {
        "label": "Stars",
        "value": "stars"
    },
    {
        "label": "Veeam unofficial",
        "value": "veeam_unofficial"
    },
    {
        "label": "Customer Journey Map",
        "value": "customer-journey-map"
    },
    {
        "label": "2022 - GANTT",
        "value": "2022-gantt"
    },
    {
        "label": "Clouds",
        "value": "clouds"
    },
    {
        "label": "Data Flow",
        "value": "data-flow"
    },
    {
        "label": "Android",
        "value": "android"
    },
    {
        "label": "Misc Azure Icons",
        "value": "misc-azure-icons"
    },
    {
        "label": "Cryptocurrencies",
        "value": "cryptocurrencies"
    },
    {
        "label": "Microsoft Apps",
        "value": "microsoft-apps"
    },
    {
        "label": "Maps",
        "value": "maps"
    },
    {
        "label": "Make your calendar",
        "value": "make-your-calendar"
    },
    {
        "label": "Clocks",
        "value": "clocks"
    },
    {
        "label": "3D Shapes",
        "value": "3d-shapes"
    },
    {
        "label": "AWS Serverless Icons v2",
        "value": "aws-serverless-icons-v2"
    },
    {
        "label": "Snowflake datawarehousing Icons",
        "value": "snowflake"
    },
    {
        "label": "DnD 5e planning",
        "value": "dnd-writing-icons-for-dm"
    },
    {
        "label": "Medicine",
        "value": "medicine"
    },
    {
        "label": "Azure Storage",
        "value": "azure-storage"
    },
    {
        "label": "Front End Tools & Technologies",
        "value": "front-end-tech-and-tools"
    },
    {
        "label": "Baby Characters",
        "value": "baby-characters"
    },
    {
        "label": "Enterprise Integration Patterns",
        "value": "enterprise-integration-patterns"
    },
    {
        "label": "Wireframing placeholders",
        "value": "wireframing-placeholders"
    },
    {
        "label": "Team Topologies",
        "value": "team-topologies"
    },
    {
        "label": "Coordinates",
        "value": "coordinates"
    },
    {
        "label": "Comms Platform Icons",
        "value": "comms-platform-icons"
    },
    {
        "label": "Desktop Resolutions",
        "value": "desktop-resolutions"
    },
    {
        "label": "Biology",
        "value": "biology"
    },
    {
        "label": "NSX-T VMware",
        "value": "nsx-t-vmware"
    },
    {
        "label": "Computer parts",
        "value": "computer-parts"
    },
    {
        "label": "Despair",
        "value": "despair"
    },
    {
        "label": "Banners",
        "value": "banners"
    },
    {
        "label": "Arduino Boards",
        "value": "arduino-boards"
    },
    {
        "label": "HTML, CSS and JS logos",
        "value": "html-css-js-icons"
    },
    {
        "label": "Kubernetes icons",
        "value": "kubernetes-icons"
    },
    {
        "label": "Azure Containers",
        "value": "azure-containers"
    },
    {
        "label": "Circuit Components",
        "value": "circuit-components"
    },
    {
        "label": "science chemistry gcse",
        "value": "science-chemistry-gcse"
    },
    {
        "label": "Data Vault",
        "value": "data-vault"
    },
    {
        "label": "Electrical Engineering",
        "value": "electrical-engineering"
    },
    {
        "label": "Raspberry Pi 3",
        "value": "raspberrypi3"
    },
    {
        "label": "Stick Figures Collaboration",
        "value": "stick-figures-collaboration"
    },
    {
        "label": "Organization Chart",
        "value": "organization-chart"
    },
    {
        "label": "Domain-Driven Design",
        "value": "domain-driven-design"
    },
    {
        "label": "Periodic Table",
        "value": "periodic-table"
    },
    {
        "label": "Chess set",
        "value": "chess-set"
    },
    {
        "label": "Retail peripherals",
        "value": "retail-peripherals"
    },
    {
        "label": "ELK Stack",
        "value": "elk-stack"
    },
    {
        "label": "Raspberry Pi Zero",
        "value": "raspberrypi-zero"
    },
    {
        "label": "Golang gophers",
        "value": "golang-gophers"
    },
    {
        "label": "Halloween elements",
        "value": "halloween-elements"
    },
    {
        "label": "Digital Signal Processing",
        "value": "digital-signal-processing"
    },
    {
        "label": "Web3 Crypto Solution Design v1",
        "value": "web3-crypto-solution-design-v1"
    },
    {
        "label": "code-essentials",
        "value": "code-essentials"
    },
    {
        "label": "Event Storming",
        "value": "event-storming"
    },
    {
        "label": "secure_shell",
        "value": "secure_shell"
    },
    {
        "label": "Racks and Servers / Components",
        "value": "racks-and-servers-components"
    },
    {
        "label": "Music notation",
        "value": "music-notation"
    },
    {
        "label": "Football Icons",
        "value": "football-icons"
    },
    {
        "label": "DS visualizations",
        "value": "ds-visualizations"
    },
    {
        "label": "Valentine's Day",
        "value": "valentine-s-day"
    },
    {
        "label": "IT Tools Logos",
        "value": "it-tools-logos"
    },
    {
        "label": "Playing cards",
        "value": "playing-cards"
    },
    {
        "label": "Organic Chemistry Basics",
        "value": "organic-chemistry-basics"
    },
    {
        "label": "Red Hat",
        "value": "red-hat"
    },
    {
        "label": "3d coordinate systems + graphs",
        "value": "3d-coordinate-systems-graphs"
    },
    {
        "label": "Boardgame",
        "value": "boardgame"
    },
    {
        "label": "Barotrauma",
        "value": "barotrauma"
    },
    {
        "label": "Music Instruments",
        "value": "music-instruments"
    },
    {
        "label": "Go Icons",
        "value": "go-icons"
    },
    {
        "label": "Internet Service providers",
        "value": "internet-service-providers"
    },
    {
        "label": "Common Screen Resolutions",
        "value": "common-screen-resolutions"
    },
    {
        "label": "PRINTERS",
        "value": "printers"
    },
    {
        "label": "Arduino Micro",
        "value": "arduino-micro"
    },
    {
        "label": "Risk based Test Strategy",
        "value": "risk-based-test-strategy"
    },
    {
        "label": "Male Heads Diverse 1",
        "value": "male-heads-diverse-1"
    },
    {
        "label": "Dart and Flutter icons",
        "value": "dart-and-flutter-icons"
    },
    {
        "label": "Head Builder Kit 1",
        "value": "head-builder-kit-1"
    },
    {
        "label": "R Icons",
        "value": "r"
    },
    {
        "label": "Tools",
        "value": "tools"
    },
    {
        "label": "Macroeconomics",
        "value": "macroeconomics"
    },
    {
        "label": "Fibre Network",
        "value": "fibre-network"
    },
    {
        "label": "Traffic signs \u26D4\uD83D\uDED1",
        "value": "traffic-signs"
    },
    {
        "label": "Picasso's Line Drawings",
        "value": "picasso-s-line-drawings"
    },
    {
        "label": "Genealogy Essentials",
        "value": "genealogy-essentials"
    },
    {
        "label": "TTRPG Clocks",
        "value": "ttrpg-clocks"
    },
    {
        "label": "Synths and FX",
        "value": "synths-and-fx"
    },
    {
        "label": "micro",
        "value": "micro"
    },
    {
        "label": "logic gates",
        "value": "logic-gates"
    },
    {
        "label": "Body Builder Kit 1",
        "value": "body-builder-kit-1"
    },
    {
        "label": "Types and Values in JavaScript",
        "value": "types-and-values-in-javascript"
    },
    {
        "label": "Montessori Basic Grammar Symbols",
        "value": "montessori-basic-grammar-symbols"
    },
    {
        "label": "Character Kit 1",
        "value": "character-kit-1"
    },
    {
        "label": "Ultimate Frisbee",
        "value": "ultimate-frisbee"
    },
    {
        "label": "Female Heads Diverse",
        "value": "female-heads-diverse"
    },
    {
        "label": "Architecture floor plan symbols",
        "value": "architecture"
    },
    {
        "label": "Random figure drawings",
        "value": "random-figure-drawings"
    },
    {
        "label": "Shapes for UML & ER Diagrams",
        "value": "UML-ER-library"
    },
    {
        "label": "Yellow box",
        "value": "yellow-box"
    },
    {
        "label": "Logic Gates",
        "value": "Logic-Gates"
    }
];
var $6acfd7cb01a49a02$export$2e2bcd8739ae039 = $6acfd7cb01a49a02$var$libOptions;




var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};



var $fm8kz = parcelRequire("fm8kz");

var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $f8dbcd8598db1f0b$var$h = ("undefined" != typeof $cfae44f0dfdf62c0$exports && void 0 !== $cfae44f0dfdf62c0$exports.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.0.0-rc.3", $f8dbcd8598db1f0b$var$m = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$y = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, false)), $f8dbcd8598db1f0b$var$v = {}, $f8dbcd8598db1f0b$var$g = /invalid hook call/i, $f8dbcd8598db1f0b$var$S = new Set, $f8dbcd8598db1f0b$var$w = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$b = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$N(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$P = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$_ = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$C = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$I(e) {
    return e.replace($f8dbcd8598db1f0b$var$_, "-").replace($f8dbcd8598db1f0b$var$C, "");
}
var $f8dbcd8598db1f0b$var$A = /(a)(d)/gi, $f8dbcd8598db1f0b$var$O = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$O(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$O(t % 52) + n).replace($f8dbcd8598db1f0b$var$A, "$1-$2");
}
var $f8dbcd8598db1f0b$var$D, $f8dbcd8598db1f0b$var$T = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$j = function(e) {
    return $f8dbcd8598db1f0b$var$T(5381, e);
};
function $f8dbcd8598db1f0b$var$x(e) {
    return $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$j(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$k(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$V(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$M = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$F = $f8dbcd8598db1f0b$var$M ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$z = $f8dbcd8598db1f0b$var$M ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$$ = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$L = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$G = (($f8dbcd8598db1f0b$var$D = {})[$f8dbcd8598db1f0b$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$D[$f8dbcd8598db1f0b$var$F] = $f8dbcd8598db1f0b$var$L, $f8dbcd8598db1f0b$var$D);
function $f8dbcd8598db1f0b$var$Y(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$F ? $f8dbcd8598db1f0b$var$L : "$$typeof" in e ? $f8dbcd8598db1f0b$var$G[e.$$typeof] : $f8dbcd8598db1f0b$var$B;
}
var $f8dbcd8598db1f0b$var$W = Object.defineProperty, $f8dbcd8598db1f0b$var$q = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$H = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$U = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$J = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$X = Object.prototype;
function $f8dbcd8598db1f0b$var$Z(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$X) {
            var r = $f8dbcd8598db1f0b$var$J(t);
            r && r !== $f8dbcd8598db1f0b$var$X && $f8dbcd8598db1f0b$var$Z(e, r, n);
        }
        var o = $f8dbcd8598db1f0b$var$q(t);
        $f8dbcd8598db1f0b$var$H && (o = o.concat($f8dbcd8598db1f0b$var$H(t)));
        for(var s = $f8dbcd8598db1f0b$var$Y(e), i = $f8dbcd8598db1f0b$var$Y(t), a = 0; a < o.length; ++a){
            var c = o[a];
            if (!(c in $f8dbcd8598db1f0b$var$$ || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$U(t, c);
                try {
                    $f8dbcd8598db1f0b$var$W(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$K(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ee(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$te(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], r = 1; r < e.length; r++)n += t ? t + e[r] : e[r];
    return n;
}
function $f8dbcd8598db1f0b$var$ne(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ne(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var r = 0; r < t.length; r++)e[r] = $f8dbcd8598db1f0b$var$re(e[r], t[r]);
    else if ($f8dbcd8598db1f0b$var$ne(t)) for(var r in t)e[r] = $f8dbcd8598db1f0b$var$re(e[r], t[r]);
    return e;
}
var $f8dbcd8598db1f0b$var$oe = {};
function $f8dbcd8598db1f0b$var$se() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], r = [], o = 1, s = e.length; o < s; o += 1)r.push(e[o]);
    return r.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$ie(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$ae = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)if ((o <<= 1) < 0) throw $f8dbcd8598db1f0b$var$ie(16, "".concat(e));
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$ce = new Map, $f8dbcd8598db1f0b$var$le = new Map, $f8dbcd8598db1f0b$var$ue = 1, $f8dbcd8598db1f0b$var$pe = function(e) {
    if ($f8dbcd8598db1f0b$var$ce.has(e)) return $f8dbcd8598db1f0b$var$ce.get(e);
    for(; $f8dbcd8598db1f0b$var$le.has($f8dbcd8598db1f0b$var$ue);)$f8dbcd8598db1f0b$var$ue++;
    var t = $f8dbcd8598db1f0b$var$ue++;
    return $f8dbcd8598db1f0b$var$ce.set(e, t), $f8dbcd8598db1f0b$var$le.set(t, e), t;
}, $f8dbcd8598db1f0b$var$de = function(e, t) {
    $f8dbcd8598db1f0b$var$ce.set(e, t), $f8dbcd8598db1f0b$var$le.set(t, e);
}, $f8dbcd8598db1f0b$var$he = "style[".concat($f8dbcd8598db1f0b$var$h, "][").concat("data-styled-version", '="').concat("6.0.0-rc.3", '"]'), $f8dbcd8598db1f0b$var$fe = new RegExp("^".concat($f8dbcd8598db1f0b$var$h, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$me = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$ye = function(e, t) {
    for(var n, r = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), o = [], s = 0, i = r.length; s < i; s++){
        var a = r[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$fe);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$de(u, l), $f8dbcd8598db1f0b$var$me(e, u, c[3]), e.getTag().insertRules(l, o)), o.length = 0;
            } else o.push(a);
        }
    }
};
function $f8dbcd8598db1f0b$var$ve() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$ge = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$h)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$h, "active"), r.setAttribute("data-styled-version", "6.0.0-rc.3");
    var i = $f8dbcd8598db1f0b$var$ve();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$Se = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$ge(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            throw $f8dbcd8598db1f0b$var$ie(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$we = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$ge(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$be = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ee = $f8dbcd8598db1f0b$var$m, $f8dbcd8598db1f0b$var$Ne = {
    isServer: !$f8dbcd8598db1f0b$var$m,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$y
}, $f8dbcd8598db1f0b$var$Pe = function() {
    function e(e, n, r) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === n && (n = {}), this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Ne), e), this.gs = n, this.names = new Map(r), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$m && $f8dbcd8598db1f0b$var$Ee && ($f8dbcd8598db1f0b$var$Ee = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$he), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$h) && ($f8dbcd8598db1f0b$var$ye(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$pe(e);
    }, e.prototype.reconstructWithOptions = function(n, r) {
        return void 0 === r && (r = !0), new e((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), n), this.gs, r && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$be(n) : t ? new $f8dbcd8598db1f0b$var$Se(n) : new $f8dbcd8598db1f0b$var$we(n);
        }(this.options), new $f8dbcd8598db1f0b$var$ae(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$pe(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$pe(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$pe(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e.prototype.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = function(n) {
                var o = function(e) {
                    return $f8dbcd8598db1f0b$var$le.get(e);
                }(n);
                if (void 0 === o) return "continue";
                var s = e.names.get(o), i = t.getGroup(n);
                if (void 0 === s || 0 === i.length) return "continue";
                var a = "".concat($f8dbcd8598db1f0b$var$h, ".g").concat(n, '[id="').concat(o, '"]'), c = "";
                void 0 !== s && s.forEach(function(e) {
                    e.length > 0 && (c += "".concat(e, ","));
                }), r += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
            }, s = 0; s < n; s++)o(s);
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$_e = /&/g, $f8dbcd8598db1f0b$var$Ce = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Ie(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Ie(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Ae(e) {
    var t, n, r, o = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, s = o.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$E : s, a = o.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$b : a, l = function(e, r, o) {
        return o === n || o.startsWith(n) && o.endsWith(n) && o.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $fm8kz.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$_e, n).replace(r, l));
    }), i.prefix && u.push($fm8kz.prefixer), u.push($fm8kz.stringify);
    var d = function(e, o, s, a) {
        void 0 === o && (o = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = o, r = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$Ce, ""), l = $fm8kz.compile(s || o ? "".concat(s, " ").concat(o, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Ie(l, i.namespace));
        var d = [];
        return $fm8kz.serialize(l, $fm8kz.middleware(u.concat($fm8kz.rulesheet(function(e) {
            return d.push(e);
        })))), d;
    };
    return d.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$ie(15), $f8dbcd8598db1f0b$var$T(e, t.name);
    }, 5381).toString() : "", d;
}
var $f8dbcd8598db1f0b$var$Oe = new $f8dbcd8598db1f0b$var$Pe, $f8dbcd8598db1f0b$var$Re = $f8dbcd8598db1f0b$var$Ae(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Oe,
    stylis: $f8dbcd8598db1f0b$var$Re
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$je = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$xe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), r = t[0], a = t[1], c = $f8dbcd8598db1f0b$var$xe().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), p = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$Ae({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: r
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        r
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(r, e.stylisPlugins) || a(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: p
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$je.Provider, {
        value: p
    }, e.children));
}
var $f8dbcd8598db1f0b$var$Ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$Re);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            throw $f8dbcd8598db1f0b$var$ie(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$Re), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$Me = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$Fe(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var r = e[n];
        if (1 === n && "-" === r && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$Me(r) ? t += "-" + r.toLowerCase() : t += r;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$ze = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Be = function(t) {
    var n, r, o = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$ze(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$K(i) ? o.push("".concat($f8dbcd8598db1f0b$var$Fe(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$ne(i) ? o.push.apply(o, (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Be(i), !1), [
            "}"
        ], !1)) : o.push("".concat($f8dbcd8598db1f0b$var$Fe(s), ": ").concat((n = s, null == (r = i) || "boolean" == typeof r || "" === r ? "" : "number" != typeof r || 0 === r || n in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || n.startsWith("--") ? String(r).trim() : "".concat(r, "px")), ";")));
    }
    return o;
};
function $f8dbcd8598db1f0b$var$$e(e, t, n, r) {
    if ($f8dbcd8598db1f0b$var$ze(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$K(e)) {
        if (!$f8dbcd8598db1f0b$var$K(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var o = e(t);
        return $f8dbcd8598db1f0b$var$$e(o, t, n, r);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$Ve ? n ? (e.inject(n, r), [
        e.getName(r)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$ne(e) ? $f8dbcd8598db1f0b$var$Be(e) : Array.isArray(e) ? e.flatMap(function(e) {
        return $f8dbcd8598db1f0b$var$$e(e, t, n, r);
    }) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Le(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$K(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ge = $f8dbcd8598db1f0b$var$j("6.0.0-rc.3"), $f8dbcd8598db1f0b$var$Ye = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Le(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$T($f8dbcd8598db1f0b$var$Ge, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Pe.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) r = $f8dbcd8598db1f0b$var$ee(r, this.staticRulesId);
            else {
                var o = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$$e(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$R($f8dbcd8598db1f0b$var$T(this.baseHash, o) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(o, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                r = $f8dbcd8598db1f0b$var$ee(r, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$T(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$$e(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$T(a, p), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), r = $f8dbcd8598db1f0b$var$ee(r, d);
            }
        }
        return r;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var r = $f8dbcd8598db1f0b$export$93d4e7f90805808f(), o = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$ie(14);
            if ($f8dbcd8598db1f0b$var$K(e)) {
                var r = e(n);
                return r;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$ie(8);
            return n ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, r);
    }, [
        e.theme,
        r
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Je = {};
function $f8dbcd8598db1f0b$var$Xe(e, r, o) {
    var s, i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, u = !$f8dbcd8598db1f0b$var$V(e), p = r.componentId, d = void 0 === p ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$I(e);
        $f8dbcd8598db1f0b$var$Je[n] = ($f8dbcd8598db1f0b$var$Je[n] || 0) + 1;
        var r = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$x("6.0.0-rc.3" + n + $f8dbcd8598db1f0b$var$Je[n]));
        return t ? "".concat(t, "-").concat(r) : r;
    }(r.displayName, r.parentComponentId) : p, h = r.displayName, f = void 0 === h ? function(e) {
        return $f8dbcd8598db1f0b$var$V(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$k(e), ")");
    }(e) : h, m = null !== (s = r.attrs) && void 0 !== s ? s : [], y = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$I(r.displayName), "-").concat(r.componentId) : r.componentId || d, v = i && a.attrs ? a.attrs.concat(m).filter(Boolean) : m, g = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var S = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var b = r.shouldForwardProp;
            g = function(e, t) {
                return S(e, t) && b(e, t);
            };
        } else g = S;
    }
    var _ = new $f8dbcd8598db1f0b$var$Ye(o, y, i ? a.componentStyle : void 0), C = _.isStatic && 0 === m.length;
    function A(e, n) {
        return function(e, n, r, o) {
            var s = e.attrs, i = e.componentStyle, a = e.defaultProps, u = e.foldedComponentIds, p = e.styledComponentId, d = e.target, h = $f8dbcd8598db1f0b$export$93d4e7f90805808f(), f = $f8dbcd8598db1f0b$var$xe(), m = e.shouldForwardProp || f.shouldForwardProp;
            var y = function(e, n, r) {
                for(var o, s = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: r
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$K(o = e[i]) ? o(s) : o;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$ee(s[c], a[c]) : "style" === c ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$ee(s.className, n.className)), s;
            }(s, n, $f8dbcd8598db1f0b$var$N(n, h, a) || $f8dbcd8598db1f0b$var$E), v = y.as || d, g = {};
            for(var S in y)void 0 === y[S] || "$" === S[0] || "as" === S || "theme" === S || ("forwardedAs" === S ? g.as = y.forwardedAs : m && !m(S, v) || (g[S] = y[S]));
            var w = function(e, t, n) {
                var r = $f8dbcd8598db1f0b$var$xe(), o = e.generateAndInjectStyles(t ? $f8dbcd8598db1f0b$var$E : n, r.styleSheet, r.stylis);
                return o;
            }(i, o, y);
            var b = $f8dbcd8598db1f0b$var$ee(u, p);
            return w && (b += " " + w), y.className && (b += " " + y.className), g[$f8dbcd8598db1f0b$var$V(v) && !$f8dbcd8598db1f0b$var$P.has(v) ? "class" : "className"] = b, g.ref = r, (0, $acw62.createElement)(v, g);
        }(O, e, n, C);
    }
    A.displayName = f;
    var O = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(A);
    return O.attrs = v, O.componentStyle = _, O.displayName = f, O.shouldForwardProp = g, O.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ee(a.foldedComponentIds, a.styledComponentId) : "", O.styledComponentId = y, O.target = i ? a.target : e, Object.defineProperty(O, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var r = 0, o = t; r < o.length; r++)$f8dbcd8598db1f0b$var$re(e, o[r], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), Object.defineProperty(O, "toString", {
        value: function() {
            return ".".concat(O.styledComponentId);
        }
    }), u && $f8dbcd8598db1f0b$var$Z(O, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), O;
}
function $f8dbcd8598db1f0b$var$Ze(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$Ke = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    if ($f8dbcd8598db1f0b$var$K(t) || $f8dbcd8598db1f0b$var$ne(t)) {
        var o = t;
        return $f8dbcd8598db1f0b$var$Ke($f8dbcd8598db1f0b$var$$e($f8dbcd8598db1f0b$var$Ze($f8dbcd8598db1f0b$var$b, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            o
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $f8dbcd8598db1f0b$var$$e(s) : $f8dbcd8598db1f0b$var$Ke($f8dbcd8598db1f0b$var$$e($f8dbcd8598db1f0b$var$Ze(s, n)));
}
function $f8dbcd8598db1f0b$var$et(n, r, o) {
    if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !r) throw $f8dbcd8598db1f0b$var$ie(1, r);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$et(n, r, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, o), {
            attrs: Array.prototype.concat(o.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$et(n, r, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, o), e));
    }, s;
}
function $f8dbcd8598db1f0b$var$tt(e) {
    return $f8dbcd8598db1f0b$var$et($f8dbcd8598db1f0b$var$Xe, e);
}
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$tt;
$f8dbcd8598db1f0b$var$P.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$tt(e);
});
var $f8dbcd8598db1f0b$var$rt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Le(e), $f8dbcd8598db1f0b$var$Pe.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$$e(this.rules, t, n, r)), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Pe.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(r) {
    for(var o = [], s = 1; s < arguments.length; s++)o[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        r
    ], o, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$x(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$rt(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$xe(), r = $f8dbcd8598db1f0b$export$93d4e7f90805808f(), o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(o, e, t.styleSheet, r, t.stylis), ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useInsertionEffect || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect)(function() {
            if (!t.styleSheet.server) return u(o, e, t.styleSheet, r, t.stylis), function() {
                return c.removeStyles(o, t.styleSheet);
            };
        }, [
            o,
            e,
            t.styleSheet,
            r,
            t.stylis
        ]), null;
    };
    function u(e, n, r, o, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$v, r, s);
        else {
            var i = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$N(n, o, l.defaultProps)
            });
            c.renderStyles(e, i, r, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$x(o);
    return new $f8dbcd8598db1f0b$var$Ve(s, o);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(r, o) {
        var s = $f8dbcd8598db1f0b$var$N(r, $f8dbcd8598db1f0b$export$93d4e7f90805808f(), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r, {
            theme: s,
            ref: o
        }));
    });
    return r.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$k(e), ")"), $f8dbcd8598db1f0b$var$Z(r, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $f8dbcd8598db1f0b$var$ve(), r = $f8dbcd8598db1f0b$var$te([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$h, '="true"'),
                "".concat("data-styled-version", '="').concat("6.0.0-rc.3", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(r, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ie(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var r;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$ie(2);
            var o = ((r = {})[$f8dbcd8598db1f0b$var$h] = "", r["data-styled-version"] = "6.0.0-rc.3", r.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, r), s = $f8dbcd8598db1f0b$var$ve();
            return s && (o.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, o, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Pe({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$ie(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$ie(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Pe,
    mainSheet: $f8dbcd8598db1f0b$var$Oe
};
var $f8dbcd8598db1f0b$var$lt = "__sc-".concat($f8dbcd8598db1f0b$var$h, "__");


// const libPrefix = "https://libraries.excalidraw.com/libraries"
const $1b8e0994176c9ade$var$libExtension = "excalidrawlib";
// initial data: dockered sidebar, no elements
const $1b8e0994176c9ade$var$initialData = {
    appState: {
        defaultSidebarDockedPreference: true,
        isSidebarDocked: true
    },
    scrollToContent: true
};
const $1b8e0994176c9ade$var$UIOptions = {
    canvasActions: {
        toggleTheme: true
    }
};
const $1b8e0994176c9ade$var$queryParameters = new URLSearchParams(window.location.search);
const $1b8e0994176c9ade$var$libBaseUrl = $1b8e0994176c9ade$var$queryParameters.get("libUrl");
const $1b8e0994176c9ade$var$userLang = $1b8e0994176c9ade$var$queryParameters.get("lang");
const $1b8e0994176c9ade$var$theme = {
    blue: {
        bg: "#0d6efd",
        hover: "#0b5ed7"
    },
    grey: {
        bg: "#6c757d",
        hover: "#5c636a"
    }
};
const $1b8e0994176c9ade$var$Button = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: "flex";
  background-color: ${(props)=>$1b8e0994176c9ade$var$theme[props.theme].bg};
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  outline: 0;
  margin: 0px 0px;
  border: 0px;
  cursor: pointer;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props)=>$1b8e0994176c9ade$var$theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;
const $1b8e0994176c9ade$var$PublishButton = ({ excalidrawAPI: excalidrawAPI })=>{
    const [disabled, setDisabled] = (0, $acw62.useState)(false);
    const publishHandler = async (event)=>{
        setDisabled(true);
        // console.log("React App ----> publishHandler");
        if (!excalidrawAPI) return;
        // get elements && appState && files  from excalidrawAPI
        const elements = excalidrawAPI.getSceneElements();
        if (!elements || !elements.length) return;
        const appState = excalidrawAPI.getAppState();
        const files = excalidrawAPI.getFiles();
        // generate drawData, svg file, png file
        const drawData = (0, $e68ba20b3d2d159d$export$b502122c5be20fdd)(elements, excalidrawAPI.getAppState(), files, "local");
        // console.log('React App ----> drawData:', drawData);
        const svgData = await (0, $e68ba20b3d2d159d$export$369dce80fa4b3d47)({
            elements: elements,
            appState: appState,
            files: files
        });
        //console.log('React App ----> svgData:', svgData);
        const pngBlob = await (0, $e68ba20b3d2d159d$export$64d5110a38cde8)({
            elements: elements,
            appState: appState,
            files: files,
            maxWidthOrHeight: 1000,
            mimeType: "image/png"
        });
        // get width and height of
        const width = svgData.getAttribute("width");
        const height = svgData.getAttribute("height");
        //console.log('React App ----> width and height:', width, height);
        // post message "PUBLISH" to parent window
        window.parent.postMessage({
            type: "PUBLISH",
            data: {
                drawData: drawData,
                svgData: svgData.outerHTML,
                svgRect: {
                    width: width,
                    height: height
                },
                pngBlob: pngBlob
            }
        }, "*");
    };
    const { t: t } = (0, $e68ba20b3d2d159d$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$Button, {
        theme: "blue",
        disabled: disabled,
        onClick: publishHandler,
        children: t("buttons.submit")
    });
};
const $1b8e0994176c9ade$var$CancelButton = ()=>{
    const { t: t } = (0, $e68ba20b3d2d159d$export$3f3caade1c12f8c9)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$Button, {
        theme: "grey",
        onClick: ()=>{
            window.parent.postMessage({
                type: "CANCEL"
            }, "*");
        },
        children: t("buttons.cancel")
    });
};
const $1b8e0994176c9ade$var$DebugButton = ({ excalidrawAPI: excalidrawAPI })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$Button, {
        theme: "blue",
        disabled: false,
        onClick: ()=>{
            console.log("App state----> :", excalidrawAPI.getAppState());
            excalidrawAPI.toggleMenu("customSidebar");
        },
        children: "Debug"
    });
};
const $1b8e0994176c9ade$var$LibrarySelectorAnother = ({ excalidrawAPI: excalidrawAPI, libBaseUrl: libBaseUrl })=>{
    const [selectedLibs, setSelectedLibs] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        //console.log("React App ----> selectedLibs:", selectedLibs);
        if (!excalidrawAPI) return;
        let libs = [];
        if (selectedLibs && selectedLibs.length !== 0) libs = selectedLibs.map((lib)=>lib.value);
        //console.log("React App ----> selected libs:", libs)
        updateLibraries(excalidrawAPI, libBaseUrl, libs);
    }, [
        selectedLibs
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a8a304ccadc5598$export$1e7dfd31545b5809), {
        options: (0, $6acfd7cb01a49a02$export$2e2bcd8739ae039),
        value: selectedLibs,
        onChange: setSelectedLibs,
        labelledBy: "Select"
    });
};
const $1b8e0994176c9ade$var$Option = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $986c40371255b7c2$export$db3b6bfb95261072).Option, {
            ...props,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "checkbox",
                    checked: props.isSelected,
                    onChange: ()=>null
                }),
                " ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    children: props.label
                })
            ]
        })
    });
};
const $1b8e0994176c9ade$var$ValueContainer = ({ children: children, ...props })=>{
    const { getValue: getValue } = props;
    const selectedOptions = getValue();
    const maxOptions = 3;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $986c40371255b7c2$export$db3b6bfb95261072).ValueContainer, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "inline-block",
                    marginLeft: "auto"
                },
                children: [
                    selectedOptions.length,
                    "/",
                    maxOptions
                ]
            })
        ]
    });
};
const $1b8e0994176c9ade$var$Spacer = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            flexGrow: "1"
        }
    });
};
const $1b8e0994176c9ade$var$libSelectorStyle = {
    minWidth: "300px"
};
const $1b8e0994176c9ade$var$indicatorStyle = {
    margin: "0 auto",
    marginInlineStart: "0.6em",
    alignItems: "center",
    display: "flex",
    color: "#ff8c00",
    fontWeight: "bold",
    flexGrow: "0"
};
const $1b8e0994176c9ade$var$customStyles = {
    container: (base)=>({
            ...base,
            display: "flex",
            minWidth: "300px",
            // marginInlineStart: "0.6em",
            margin: "0 auto"
        }),
    control: (base)=>({
            ...base,
            display: "flex",
            minWidth: "300px"
        }),
    valueContainer: (provided, state)=>({
            ...provided,
            display: "flex"
        }),
    placeholder: (base)=>({
            ...base,
            fontStyle: "italic",
            display: "flex"
        })
};
const $1b8e0994176c9ade$var$LibrarySelector = ({ excalidrawAPI: excalidrawAPI, libBaseUrl: libBaseUrl })=>{
    const [selectedLibs, setSelectedLibs] = (0, $acw62.useState)([]);
    const libsRef = (0, $acw62.useRef)({});
    const updateLibraries1 = async (excalidrawAPI, libBaseUrl, libraries = [])=>{
        const updateLibs = async (isClear = false)=>{
            //console.log("isClear:", isClear);
            let merge, libs;
            if (isClear) {
                merge = false;
                libs = [
                    "null"
                ];
            //console.log("React App ----> clear libraries")
            } else {
                merge = true;
                libs = libraries;
            //console.log("React App ----> update libraries:", libs)
            }
            for (const lib of libs){
                let libraryItems;
                if (!libsRef.current.hasOwnProperty(lib)) {
                    // if libsRef does not have the lib, then download it
                    const resp = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039)({
                        url: `${libBaseUrl}/${lib}.${$1b8e0994176c9ade$var$libExtension}`,
                        method: "GET",
                        responseType: "blob"
                    });
                    libraryItems = await (0, $e68ba20b3d2d159d$export$2f1669626eca00b4)(resp.data);
                    // save the lib to libsRef
                    libsRef.current[lib] = libraryItems;
                } else // if libsRef has the lib, then use it
                libraryItems = libsRef.current[lib];
                await excalidrawAPI.updateLibrary({
                    libraryItems: libraryItems,
                    merge: merge,
                    openLibraryMenu: true,
                    defaultStatus: "published"
                });
            // console.log("all libsRef:", libsRef.current);
            }
        };
        // clear libs first
        await updateLibs(true);
        // then update the with selected libs
        if (libraries.length === 0) return;
        else await updateLibs(false);
    };
    (0, $acw62.useEffect)(()=>{
        //console.log("React App ----> selectedLibs:", selectedLibs);
        if (!excalidrawAPI) return;
        let libs = [];
        if (selectedLibs && selectedLibs.length !== 0) libs = selectedLibs.map((lib)=>lib.value);
        //console.log("React App ----> selected libs:", libs)
        updateLibraries1(excalidrawAPI, libBaseUrl, libs);
    }, [
        selectedLibs
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
        isMulti: true,
        menuPlacement: "top",
        options: (0, $6acfd7cb01a49a02$export$2e2bcd8739ae039),
        components: {
            Option: $1b8e0994176c9ade$var$Option,
            ValueContainer: $1b8e0994176c9ade$var$ValueContainer
        },
        isOptionDisabled: (option)=>!selectedLibs.includes(option) && selectedLibs.length >= 3,
        value: selectedLibs,
        onChange: setSelectedLibs,
        allowSelectAll: false,
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        className: "react-basic-multi-select",
        classNamePrefix: "react-select",
        styles: $1b8e0994176c9ade$var$customStyles,
        placeholder: "Add libraries",
        maxMenuHeight: 500
    });
};
function $1b8e0994176c9ade$export$86fbec116b87613f() {
    // const queryParameters = new URLSearchParams(window.location.search)
    // const pageId = queryParameters.get('pageId')
    const [excalidrawAPI, setExcalidrawAPI] = (0, $acw62.useState)(null);
    const { t: t } = (0, $e68ba20b3d2d159d$export$3f3caade1c12f8c9)();
    (0, $acw62.useEffect)(()=>{
        //console.log("React App ----> excalidrawAPI:", excalidrawAPI);
        if (!excalidrawAPI) return;
        const handler = (event)=>{
            // console.log('React App ----> received event from react:', event.data.type, event);
            if (event.data.type === "LOAD") {
                // console.log('React App ----> to update scene with data from parent window');
                const rawData = event.data.data;
                const files = rawData.files;
                // console.log("---> files: ", files);
                excalidrawAPI.updateScene(rawData);
                if (files) {
                    const fileDataList = Object.values(files);
                    fileDataList.length > 0 && excalidrawAPI.addFiles(fileDataList);
                }
            }
        };
        window.addEventListener("message", handler);
        return ()=>{
            window.removeEventListener("message", handler);
        };
    }, [
        excalidrawAPI
    ]);
    (0, $acw62.useEffect)(()=>{
        // post message "INIT" to parent window, only run once
        //console.log ('React App ----> post message "INIT" to parent window');
        window.parent.postMessage({
            type: "INIT"
        }, "*");
    }, []);
    //console.log('React App ----> to render react app');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                height: "100vh"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e68ba20b3d2d159d$export$c8d59565b9e4e564), {
                initialData: $1b8e0994176c9ade$var$initialData,
                UIOptions: $1b8e0994176c9ade$var$UIOptions,
                excalidrawAPI: (api)=>setExcalidrawAPI(api),
                langCode: $1b8e0994176c9ade$var$userLang,
                renderTopRightUI: ()=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$PublishButton, {
                                excalidrawAPI: excalidrawAPI
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$CancelButton, {})
                        ]
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.LoadScene, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.SaveToActiveFile, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.Export, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.SaveAsImage, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).Separator, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.ClearCanvas, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).Separator, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.ToggleTheme, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$4e08dcf990b776c0).DefaultItems.ChangeCanvasBackground, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$8995dcca99dcdafc), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e68ba20b3d2d159d$export$a06f1c675e846f6f), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$Spacer, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$LibrarySelector, {
                                excalidrawAPI: excalidrawAPI,
                                libBaseUrl: $1b8e0994176c9ade$var$libBaseUrl
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: $1b8e0994176c9ade$var$indicatorStyle,
                                children: " \uD83D\uDC48 Add Libraries \uD83D\uDE80"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$Spacer, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$a14571c7e5344c80), {
                        onTextSubmit: async (input)=>{
                            try {
                                const response = await fetch("https://ai.xdevpod.com/gmc", {
                                    method: "POST",
                                    headers: {
                                        Accept: "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        prompt: input
                                    })
                                });
                                const rateLimit = response.headers.has("X-Ratelimit-Limit") ? parseInt(response.headers.get("X-Ratelimit-Limit") || "0", 10) : undefined;
                                const rateLimitRemaining = response.headers.has("X-Ratelimit-Remaining") ? parseInt(response.headers.get("X-Ratelimit-Remaining") || "0", 10) : undefined;
                                const json = await response.json();
                                if (!response.ok) {
                                    if (response.status === 429) return {
                                        rateLimit: rateLimit,
                                        rateLimitRemaining: rateLimitRemaining,
                                        error: new Error("Too many requests today, please try again tomorrow!")
                                    };
                                    throw new Error(json.message || "Generation failed...");
                                }
                                const generatedResponse = json.code;
                                if (!generatedResponse) throw new Error("Generation failed...");
                                console.log("Generated response", generatedResponse);
                                return {
                                    generatedResponse: generatedResponse,
                                    rateLimit: rateLimit,
                                    rateLimitRemaining: rateLimitRemaining
                                };
                            } catch (err) {
                                throw new Error("Request failed");
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e68ba20b3d2d159d$export$3e7fbeb7078e3eaa), {})
                ]
            })
        })
    });
}


const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.fa582aaf.js.map
